(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["wangEditor"] = factory();
	else
		root["wangEditor"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 127);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(128);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 封装 DOM 操作
 * @wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _bind = _interopRequireDefault(__webpack_require__(86));

var _includes = _interopRequireDefault(__webpack_require__(111));

var _filter = _interopRequireDefault(__webpack_require__(87));

var _splice = _interopRequireDefault(__webpack_require__(88));

var _indexOf = _interopRequireDefault(__webpack_require__(53));

var _map = _interopRequireDefault(__webpack_require__(112));

var _trim = _interopRequireDefault(__webpack_require__(21));

var _map2 = _interopRequireDefault(__webpack_require__(42));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _isArray = _interopRequireDefault(__webpack_require__(116));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_igv09dk30() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/dom-core.ts";
  var hash = "aacd11e22e4f7ac14df85bfe165adbfb4e6a794f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/dom-core.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 88
        }
      },
      "2": {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 7,
          column: 18
        }
      },
      "3": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 25
        }
      },
      "4": {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 7,
          column: 48
        }
      },
      "5": {
        start: {
          line: 7,
          column: 63
        },
        end: {
          line: 7,
          column: 88
        }
      },
      "6": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "7": {
        start: {
          line: 8,
          column: 17
        },
        end: {
          line: 8,
          column: 25
        }
      },
      "8": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 8,
          column: 32
        }
      },
      "9": {
        start: {
          line: 8,
          column: 38
        },
        end: {
          line: 8,
          column: 39
        }
      },
      "10": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "11": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 9,
          column: 33
        }
      },
      "12": {
        start: {
          line: 9,
          column: 39
        },
        end: {
          line: 9,
          column: 40
        }
      },
      "13": {
        start: {
          line: 9,
          column: 47
        },
        end: {
          line: 9,
          column: 55
        }
      },
      "14": {
        start: {
          line: 10,
          column: 12
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "15": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 13
        }
      },
      "16": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 62
        }
      },
      "17": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "18": {
        start: {
          line: 15,
          column: 13
        },
        end: {
          line: 15,
          column: 30
        }
      },
      "19": {
        start: {
          line: 16,
          column: 19
        },
        end: {
          line: 16,
          column: 21
        }
      },
      "20": {
        start: {
          line: 22,
          column: 14
        },
        end: {
          line: 22,
          column: 43
        }
      },
      "21": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 25
        }
      },
      "22": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 28
        }
      },
      "23": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 33
        }
      },
      "24": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "25": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 21
        }
      },
      "26": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "27": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 20
        }
      },
      "28": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 17
        }
      },
      "29": {
        start: {
          line: 45,
          column: 16
        },
        end: {
          line: 45,
          column: 51
        }
      },
      "30": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 33
        }
      },
      "31": {
        start: {
          line: 53,
          column: 19
        },
        end: {
          line: 53,
          column: 21
        }
      },
      "32": {
        start: {
          line: 54,
          column: 20
        },
        end: {
          line: 54,
          column: 22
        }
      },
      "33": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "34": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 36
        }
      },
      "35": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 25
        }
      },
      "36": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 70,
          column: 7
        }
      },
      "37": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 66,
          column: 10
        }
      },
      "38": {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 28
        }
      },
      "39": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "40": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 50
        }
      },
      "41": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 21
        }
      },
      "42": {
        start: {
          line: 74,
          column: 32
        },
        end: {
          line: 701,
          column: 3
        }
      },
      "43": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 24
        }
      },
      "44": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 40
        }
      },
      "45": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 36
        }
      },
      "46": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      "47": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 85,
          column: 19
        }
      },
      "48": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 90,
          column: 9
        }
      },
      "49": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 89,
          column: 28
        }
      },
      "50": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 91,
          column: 31
        }
      },
      "51": {
        start: {
          line: 92,
          column: 23
        },
        end: {
          line: 92,
          column: 72
        }
      },
      "52": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 33
        }
      },
      "53": {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 116,
          column: 9
        }
      },
      "54": {
        start: {
          line: 95,
          column: 12
        },
        end: {
          line: 95,
          column: 40
        }
      },
      "55": {
        start: {
          line: 97,
          column: 13
        },
        end: {
          line: 116,
          column: 9
        }
      },
      "56": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 54
        }
      },
      "57": {
        start: {
          line: 101,
          column: 13
        },
        end: {
          line: 116,
          column: 9
        }
      },
      "58": {
        start: {
          line: 103,
          column: 12
        },
        end: {
          line: 103,
          column: 38
        }
      },
      "59": {
        start: {
          line: 105,
          column: 13
        },
        end: {
          line: 116,
          column: 9
        }
      },
      "60": {
        start: {
          line: 107,
          column: 30
        },
        end: {
          line: 107,
          column: 67
        }
      },
      "61": {
        start: {
          line: 108,
          column: 12
        },
        end: {
          line: 115,
          column: 13
        }
      },
      "62": {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 64
        }
      },
      "63": {
        start: {
          line: 114,
          column: 16
        },
        end: {
          line: 114,
          column: 64
        }
      },
      "64": {
        start: {
          line: 117,
          column: 21
        },
        end: {
          line: 117,
          column: 42
        }
      },
      "65": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 121,
          column: 9
        }
      },
      "66": {
        start: {
          line: 120,
          column: 12
        },
        end: {
          line: 120,
          column: 24
        }
      },
      "67": {
        start: {
          line: 123,
          column: 16
        },
        end: {
          line: 123,
          column: 17
        }
      },
      "68": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 126,
          column: 9
        }
      },
      "69": {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 125,
          column: 47
        }
      },
      "70": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 29
        }
      },
      "71": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 138,
          column: 7
        }
      },
      "72": {
        start: {
          line: 134,
          column: 12
        },
        end: {
          line: 134,
          column: 36
        }
      },
      "73": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 152,
          column: 6
        }
      },
      "74": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 150,
          column: 9
        }
      },
      "75": {
        start: {
          line: 144,
          column: 21
        },
        end: {
          line: 144,
          column: 22
        }
      },
      "76": {
        start: {
          line: 145,
          column: 23
        },
        end: {
          line: 145,
          column: 36
        }
      },
      "77": {
        start: {
          line: 146,
          column: 25
        },
        end: {
          line: 146,
          column: 47
        }
      },
      "78": {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 149,
          column: 13
        }
      },
      "79": {
        start: {
          line: 148,
          column: 16
        },
        end: {
          line: 148,
          column: 22
        }
      },
      "80": {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 151,
          column: 20
        }
      },
      "81": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 164,
          column: 6
        }
      },
      "82": {
        start: {
          line: 158,
          column: 8
        },
        end: {
          line: 158,
          column: 46
        }
      },
      "83": {
        start: {
          line: 158,
          column: 31
        },
        end: {
          line: 158,
          column: 44
        }
      },
      "84": {
        start: {
          line: 159,
          column: 24
        },
        end: {
          line: 159,
          column: 26
        }
      },
      "85": {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 162,
          column: 11
        }
      },
      "86": {
        start: {
          line: 161,
          column: 12
        },
        end: {
          line: 161,
          column: 51
        }
      },
      "87": {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 28
        }
      },
      "88": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 176,
          column: 6
        }
      },
      "89": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 44
        }
      },
      "90": {
        start: {
          line: 170,
          column: 32
        },
        end: {
          line: 170,
          column: 42
        }
      },
      "91": {
        start: {
          line: 171,
          column: 21
        },
        end: {
          line: 171,
          column: 32
        }
      },
      "92": {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 174,
          column: 9
        }
      },
      "93": {
        start: {
          line: 173,
          column: 12
        },
        end: {
          line: 173,
          column: 35
        }
      },
      "94": {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 36
        }
      },
      "95": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 182,
          column: 6
        }
      },
      "96": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 27
        }
      },
      "97": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 189,
          column: 6
        }
      },
      "98": {
        start: {
          line: 187,
          column: 21
        },
        end: {
          line: 187,
          column: 32
        }
      },
      "99": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 36
        }
      },
      "100": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 222,
          column: 6
        }
      },
      "101": {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 192,
          column: 24
        }
      },
      "102": {
        start: {
          line: 192,
          column: 12
        },
        end: {
          line: 192,
          column: 24
        }
      },
      "103": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 197,
          column: 9
        }
      },
      "104": {
        start: {
          line: 195,
          column: 12
        },
        end: {
          line: 195,
          column: 26
        }
      },
      "105": {
        start: {
          line: 196,
          column: 12
        },
        end: {
          line: 196,
          column: 26
        }
      },
      "106": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 221,
          column: 11
        }
      },
      "107": {
        start: {
          line: 200,
          column: 12
        },
        end: {
          line: 204,
          column: 13
        }
      },
      "108": {
        start: {
          line: 202,
          column: 16
        },
        end: {
          line: 202,
          column: 48
        }
      },
      "109": {
        start: {
          line: 203,
          column: 16
        },
        end: {
          line: 203,
          column: 23
        }
      },
      "110": {
        start: {
          line: 206,
          column: 26
        },
        end: {
          line: 212,
          column: 13
        }
      },
      "111": {
        start: {
          line: 207,
          column: 29
        },
        end: {
          line: 207,
          column: 37
        }
      },
      "112": {
        start: {
          line: 208,
          column: 16
        },
        end: {
          line: 211,
          column: 17
        }
      },
      "113": {
        start: {
          line: 210,
          column: 20
        },
        end: {
          line: 210,
          column: 39
        }
      },
      "114": {
        start: {
          line: 213,
          column: 12
        },
        end: {
          line: 213,
          column: 49
        }
      },
      "115": {
        start: {
          line: 215,
          column: 12
        },
        end: {
          line: 220,
          column: 15
        }
      },
      "116": {
        start: {
          line: 223,
          column: 4
        },
        end: {
          line: 252,
          column: 6
        }
      },
      "117": {
        start: {
          line: 224,
          column: 8
        },
        end: {
          line: 225,
          column: 24
        }
      },
      "118": {
        start: {
          line: 225,
          column: 12
        },
        end: {
          line: 225,
          column: 24
        }
      },
      "119": {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 230,
          column: 9
        }
      },
      "120": {
        start: {
          line: 228,
          column: 12
        },
        end: {
          line: 228,
          column: 26
        }
      },
      "121": {
        start: {
          line: 229,
          column: 12
        },
        end: {
          line: 229,
          column: 26
        }
      },
      "122": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 251,
          column: 11
        }
      },
      "123": {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 250,
          column: 13
        }
      },
      "124": {
        start: {
          line: 234,
          column: 26
        },
        end: {
          line: 234,
          column: 28
        }
      },
      "125": {
        start: {
          line: 235,
          column: 16
        },
        end: {
          line: 241,
          column: 17
        }
      },
      "126": {
        start: {
          line: 235,
          column: 29
        },
        end: {
          line: 235,
          column: 30
        }
      },
      "127": {
        start: {
          line: 236,
          column: 31
        },
        end: {
          line: 236,
          column: 46
        }
      },
      "128": {
        start: {
          line: 237,
          column: 20
        },
        end: {
          line: 240,
          column: 21
        }
      },
      "129": {
        start: {
          line: 238,
          column: 24
        },
        end: {
          line: 238,
          column: 32
        }
      },
      "130": {
        start: {
          line: 239,
          column: 24
        },
        end: {
          line: 239,
          column: 30
        }
      },
      "131": {
        start: {
          line: 242,
          column: 16
        },
        end: {
          line: 245,
          column: 17
        }
      },
      "132": {
        start: {
          line: 243,
          column: 34
        },
        end: {
          line: 243,
          column: 72
        }
      },
      "133": {
        start: {
          line: 244,
          column: 20
        },
        end: {
          line: 244,
          column: 60
        }
      },
      "134": {
        start: {
          line: 249,
          column: 16
        },
        end: {
          line: 249,
          column: 51
        }
      },
      "135": {
        start: {
          line: 253,
          column: 4
        },
        end: {
          line: 262,
          column: 6
        }
      },
      "136": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 257,
          column: 9
        }
      },
      "137": {
        start: {
          line: 256,
          column: 12
        },
        end: {
          line: 256,
          column: 57
        }
      },
      "138": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 261,
          column: 11
        }
      },
      "139": {
        start: {
          line: 260,
          column: 12
        },
        end: {
          line: 260,
          column: 40
        }
      },
      "140": {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 271,
          column: 6
        }
      },
      "141": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 270,
          column: 11
        }
      },
      "142": {
        start: {
          line: 269,
          column: 12
        },
        end: {
          line: 269,
          column: 38
        }
      },
      "143": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 299,
          column: 6
        }
      },
      "144": {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 279,
          column: 9
        }
      },
      "145": {
        start: {
          line: 278,
          column: 12
        },
        end: {
          line: 278,
          column: 24
        }
      },
      "146": {
        start: {
          line: 280,
          column: 8
        },
        end: {
          line: 298,
          column: 11
        }
      },
      "147": {
        start: {
          line: 281,
          column: 12
        },
        end: {
          line: 297,
          column: 13
        }
      },
      "148": {
        start: {
          line: 283,
          column: 26
        },
        end: {
          line: 283,
          column: 52
        }
      },
      "149": {
        start: {
          line: 284,
          column: 16
        },
        end: {
          line: 286,
          column: 19
        }
      },
      "150": {
        start: {
          line: 285,
          column: 20
        },
        end: {
          line: 285,
          column: 41
        }
      },
      "151": {
        start: {
          line: 288,
          column: 16
        },
        end: {
          line: 290,
          column: 17
        }
      },
      "152": {
        start: {
          line: 289,
          column: 20
        },
        end: {
          line: 289,
          column: 40
        }
      },
      "153": {
        start: {
          line: 292,
          column: 16
        },
        end: {
          line: 292,
          column: 47
        }
      },
      "154": {
        start: {
          line: 296,
          column: 16
        },
        end: {
          line: 296,
          column: 43
        }
      },
      "155": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 325,
          column: 6
        }
      },
      "156": {
        start: {
          line: 305,
          column: 8
        },
        end: {
          line: 307,
          column: 9
        }
      },
      "157": {
        start: {
          line: 306,
          column: 12
        },
        end: {
          line: 306,
          column: 24
        }
      },
      "158": {
        start: {
          line: 308,
          column: 8
        },
        end: {
          line: 324,
          column: 11
        }
      },
      "159": {
        start: {
          line: 309,
          column: 12
        },
        end: {
          line: 312,
          column: 13
        }
      },
      "160": {
        start: {
          line: 311,
          column: 16
        },
        end: {
          line: 311,
          column: 23
        }
      },
      "161": {
        start: {
          line: 313,
          column: 22
        },
        end: {
          line: 313,
          column: 48
        }
      },
      "162": {
        start: {
          line: 314,
          column: 12
        },
        end: {
          line: 321,
          column: 15
        }
      },
      "163": {
        start: {
          line: 315,
          column: 16
        },
        end: {
          line: 315,
          column: 35
        }
      },
      "164": {
        start: {
          line: 317,
          column: 16
        },
        end: {
          line: 319,
          column: 17
        }
      },
      "165": {
        start: {
          line: 318,
          column: 20
        },
        end: {
          line: 318,
          column: 33
        }
      },
      "166": {
        start: {
          line: 320,
          column: 16
        },
        end: {
          line: 320,
          column: 28
        }
      },
      "167": {
        start: {
          line: 323,
          column: 12
        },
        end: {
          line: 323,
          column: 43
        }
      },
      "168": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 341,
          column: 6
        }
      },
      "169": {
        start: {
          line: 331,
          column: 8
        },
        end: {
          line: 333,
          column: 9
        }
      },
      "170": {
        start: {
          line: 332,
          column: 12
        },
        end: {
          line: 332,
          column: 25
        }
      },
      "171": {
        start: {
          line: 334,
          column: 19
        },
        end: {
          line: 334,
          column: 32
        }
      },
      "172": {
        start: {
          line: 335,
          column: 8
        },
        end: {
          line: 338,
          column: 9
        }
      },
      "173": {
        start: {
          line: 337,
          column: 12
        },
        end: {
          line: 337,
          column: 25
        }
      },
      "174": {
        start: {
          line: 339,
          column: 18
        },
        end: {
          line: 339,
          column: 44
        }
      },
      "175": {
        start: {
          line: 340,
          column: 8
        },
        end: {
          line: 340,
          column: 39
        }
      },
      "176": {
        start: {
          line: 348,
          column: 4
        },
        end: {
          line: 386,
          column: 6
        }
      },
      "177": {
        start: {
          line: 350,
          column: 8
        },
        end: {
          line: 355,
          column: 9
        }
      },
      "178": {
        start: {
          line: 351,
          column: 12
        },
        end: {
          line: 351,
          column: 30
        }
      },
      "179": {
        start: {
          line: 354,
          column: 12
        },
        end: {
          line: 354,
          column: 49
        }
      },
      "180": {
        start: {
          line: 356,
          column: 8
        },
        end: {
          line: 385,
          column: 11
        }
      },
      "181": {
        start: {
          line: 357,
          column: 24
        },
        end: {
          line: 357,
          column: 65
        }
      },
      "182": {
        start: {
          line: 358,
          column: 12
        },
        end: {
          line: 384,
          column: 13
        }
      },
      "183": {
        start: {
          line: 360,
          column: 32
        },
        end: {
          line: 360,
          column: 52
        }
      },
      "184": {
        start: {
          line: 362,
          column: 16
        },
        end: {
          line: 369,
          column: 19
        }
      },
      "185": {
        start: {
          line: 363,
          column: 20
        },
        end: {
          line: 368,
          column: 21
        }
      },
      "186": {
        start: {
          line: 364,
          column: 24
        },
        end: {
          line: 364,
          column: 44
        }
      },
      "187": {
        start: {
          line: 367,
          column: 24
        },
        end: {
          line: 367,
          column: 36
        }
      },
      "188": {
        start: {
          line: 371,
          column: 16
        },
        end: {
          line: 373,
          column: 17
        }
      },
      "189": {
        start: {
          line: 372,
          column: 20
        },
        end: {
          line: 372,
          column: 49
        }
      },
      "190": {
        start: {
          line: 375,
          column: 16
        },
        end: {
          line: 377,
          column: 17
        }
      },
      "191": {
        start: {
          line: 376,
          column: 20
        },
        end: {
          line: 376,
          column: 57
        }
      },
      "192": {
        start: {
          line: 379,
          column: 16
        },
        end: {
          line: 379,
          column: 65
        }
      },
      "193": {
        start: {
          line: 383,
          column: 16
        },
        end: {
          line: 383,
          column: 57
        }
      },
      "194": {
        start: {
          line: 390,
          column: 4
        },
        end: {
          line: 393,
          column: 6
        }
      },
      "195": {
        start: {
          line: 391,
          column: 19
        },
        end: {
          line: 391,
          column: 32
        }
      },
      "196": {
        start: {
          line: 392,
          column: 8
        },
        end: {
          line: 392,
          column: 44
        }
      },
      "197": {
        start: {
          line: 397,
          column: 4
        },
        end: {
          line: 399,
          column: 6
        }
      },
      "198": {
        start: {
          line: 398,
          column: 8
        },
        end: {
          line: 398,
          column: 44
        }
      },
      "199": {
        start: {
          line: 403,
          column: 4
        },
        end: {
          line: 405,
          column: 6
        }
      },
      "200": {
        start: {
          line: 404,
          column: 8
        },
        end: {
          line: 404,
          column: 43
        }
      },
      "201": {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 415,
          column: 6
        }
      },
      "202": {
        start: {
          line: 410,
          column: 19
        },
        end: {
          line: 410,
          column: 32
        }
      },
      "203": {
        start: {
          line: 411,
          column: 8
        },
        end: {
          line: 413,
          column: 9
        }
      },
      "204": {
        start: {
          line: 412,
          column: 12
        },
        end: {
          line: 412,
          column: 24
        }
      },
      "205": {
        start: {
          line: 414,
          column: 8
        },
        end: {
          line: 414,
          column: 32
        }
      },
      "206": {
        start: {
          line: 419,
          column: 4
        },
        end: {
          line: 425,
          column: 6
        }
      },
      "207": {
        start: {
          line: 420,
          column: 19
        },
        end: {
          line: 420,
          column: 32
        }
      },
      "208": {
        start: {
          line: 421,
          column: 8
        },
        end: {
          line: 423,
          column: 9
        }
      },
      "209": {
        start: {
          line: 422,
          column: 12
        },
        end: {
          line: 422,
          column: 24
        }
      },
      "210": {
        start: {
          line: 424,
          column: 8
        },
        end: {
          line: 424,
          column: 34
        }
      },
      "211": {
        start: {
          line: 430,
          column: 4
        },
        end: {
          line: 437,
          column: 6
        }
      },
      "212": {
        start: {
          line: 431,
          column: 21
        },
        end: {
          line: 431,
          column: 35
        }
      },
      "213": {
        start: {
          line: 432,
          column: 19
        },
        end: {
          line: 432,
          column: 32
        }
      },
      "214": {
        start: {
          line: 433,
          column: 8
        },
        end: {
          line: 435,
          column: 9
        }
      },
      "215": {
        start: {
          line: 434,
          column: 12
        },
        end: {
          line: 434,
          column: 69
        }
      },
      "216": {
        start: {
          line: 436,
          column: 8
        },
        end: {
          line: 436,
          column: 31
        }
      },
      "217": {
        start: {
          line: 442,
          column: 4
        },
        end: {
          line: 448,
          column: 6
        }
      },
      "218": {
        start: {
          line: 443,
          column: 8
        },
        end: {
          line: 447,
          column: 11
        }
      },
      "219": {
        start: {
          line: 444,
          column: 12
        },
        end: {
          line: 446,
          column: 15
        }
      },
      "220": {
        start: {
          line: 445,
          column: 16
        },
        end: {
          line: 445,
          column: 40
        }
      },
      "221": {
        start: {
          line: 452,
          column: 4
        },
        end: {
          line: 462,
          column: 6
        }
      },
      "222": {
        start: {
          line: 453,
          column: 8
        },
        end: {
          line: 461,
          column: 11
        }
      },
      "223": {
        start: {
          line: 454,
          column: 12
        },
        end: {
          line: 460,
          column: 13
        }
      },
      "224": {
        start: {
          line: 455,
          column: 16
        },
        end: {
          line: 455,
          column: 30
        }
      },
      "225": {
        start: {
          line: 458,
          column: 31
        },
        end: {
          line: 458,
          column: 49
        }
      },
      "226": {
        start: {
          line: 459,
          column: 16
        },
        end: {
          line: 459,
          column: 55
        }
      },
      "227": {
        start: {
          line: 467,
          column: 4
        },
        end: {
          line: 471,
          column: 6
        }
      },
      "228": {
        start: {
          line: 468,
          column: 19
        },
        end: {
          line: 468,
          column: 32
        }
      },
      "229": {
        start: {
          line: 469,
          column: 20
        },
        end: {
          line: 469,
          column: 35
        }
      },
      "230": {
        start: {
          line: 470,
          column: 8
        },
        end: {
          line: 470,
          column: 36
        }
      },
      "231": {
        start: {
          line: 475,
          column: 4
        },
        end: {
          line: 479,
          column: 6
        }
      },
      "232": {
        start: {
          line: 476,
          column: 19
        },
        end: {
          line: 476,
          column: 32
        }
      },
      "233": {
        start: {
          line: 478,
          column: 8
        },
        end: {
          line: 478,
          column: 44
        }
      },
      "234": {
        start: {
          line: 483,
          column: 4
        },
        end: {
          line: 486,
          column: 6
        }
      },
      "235": {
        start: {
          line: 484,
          column: 19
        },
        end: {
          line: 484,
          column: 32
        }
      },
      "236": {
        start: {
          line: 485,
          column: 8
        },
        end: {
          line: 485,
          column: 29
        }
      },
      "237": {
        start: {
          line: 490,
          column: 4
        },
        end: {
          line: 493,
          column: 6
        }
      },
      "238": {
        start: {
          line: 491,
          column: 19
        },
        end: {
          line: 491,
          column: 32
        }
      },
      "239": {
        start: {
          line: 492,
          column: 8
        },
        end: {
          line: 492,
          column: 20
        }
      },
      "240": {
        start: {
          line: 497,
          column: 4
        },
        end: {
          line: 500,
          column: 6
        }
      },
      "241": {
        start: {
          line: 498,
          column: 19
        },
        end: {
          line: 498,
          column: 32
        }
      },
      "242": {
        start: {
          line: 499,
          column: 8
        },
        end: {
          line: 499,
          column: 33
        }
      },
      "243": {
        start: {
          line: 512,
          column: 4
        },
        end: {
          line: 515,
          column: 6
        }
      },
      "244": {
        start: {
          line: 513,
          column: 19
        },
        end: {
          line: 513,
          column: 32
        }
      },
      "245": {
        start: {
          line: 514,
          column: 8
        },
        end: {
          line: 514,
          column: 50
        }
      },
      "246": {
        start: {
          line: 516,
          column: 4
        },
        end: {
          line: 528,
          column: 6
        }
      },
      "247": {
        start: {
          line: 517,
          column: 8
        },
        end: {
          line: 527,
          column: 9
        }
      },
      "248": {
        start: {
          line: 519,
          column: 23
        },
        end: {
          line: 519,
          column: 36
        }
      },
      "249": {
        start: {
          line: 520,
          column: 12
        },
        end: {
          line: 520,
          column: 82
        }
      },
      "250": {
        start: {
          line: 520,
          column: 68
        },
        end: {
          line: 520,
          column: 78
        }
      },
      "251": {
        start: {
          line: 524,
          column: 12
        },
        end: {
          line: 526,
          column: 15
        }
      },
      "252": {
        start: {
          line: 525,
          column: 16
        },
        end: {
          line: 525,
          column: 37
        }
      },
      "253": {
        start: {
          line: 529,
          column: 4
        },
        end: {
          line: 540,
          column: 6
        }
      },
      "254": {
        start: {
          line: 530,
          column: 19
        },
        end: {
          line: 530,
          column: 32
        }
      },
      "255": {
        start: {
          line: 531,
          column: 8
        },
        end: {
          line: 539,
          column: 9
        }
      },
      "256": {
        start: {
          line: 533,
          column: 12
        },
        end: {
          line: 533,
          column: 34
        }
      },
      "257": {
        start: {
          line: 537,
          column: 12
        },
        end: {
          line: 537,
          column: 33
        }
      },
      "258": {
        start: {
          line: 538,
          column: 12
        },
        end: {
          line: 538,
          column: 24
        }
      },
      "259": {
        start: {
          line: 544,
          column: 4
        },
        end: {
          line: 547,
          column: 6
        }
      },
      "260": {
        start: {
          line: 545,
          column: 19
        },
        end: {
          line: 545,
          column: 32
        }
      },
      "261": {
        start: {
          line: 546,
          column: 8
        },
        end: {
          line: 546,
          column: 33
        }
      },
      "262": {
        start: {
          line: 551,
          column: 4
        },
        end: {
          line: 555,
          column: 6
        }
      },
      "263": {
        start: {
          line: 552,
          column: 8
        },
        end: {
          line: 554,
          column: 11
        }
      },
      "264": {
        start: {
          line: 553,
          column: 12
        },
        end: {
          line: 553,
          column: 25
        }
      },
      "265": {
        start: {
          line: 559,
          column: 4
        },
        end: {
          line: 562,
          column: 6
        }
      },
      "266": {
        start: {
          line: 560,
          column: 19
        },
        end: {
          line: 560,
          column: 32
        }
      },
      "267": {
        start: {
          line: 561,
          column: 8
        },
        end: {
          line: 561,
          column: 46
        }
      },
      "268": {
        start: {
          line: 566,
          column: 4
        },
        end: {
          line: 569,
          column: 6
        }
      },
      "269": {
        start: {
          line: 567,
          column: 19
        },
        end: {
          line: 567,
          column: 32
        }
      },
      "270": {
        start: {
          line: 568,
          column: 8
        },
        end: {
          line: 568,
          column: 42
        }
      },
      "271": {
        start: {
          line: 573,
          column: 4
        },
        end: {
          line: 576,
          column: 6
        }
      },
      "272": {
        start: {
          line: 574,
          column: 19
        },
        end: {
          line: 574,
          column: 32
        }
      },
      "273": {
        start: {
          line: 575,
          column: 8
        },
        end: {
          line: 575,
          column: 37
        }
      },
      "274": {
        start: {
          line: 582,
          column: 4
        },
        end: {
          line: 597,
          column: 6
        }
      },
      "275": {
        start: {
          line: 583,
          column: 19
        },
        end: {
          line: 583,
          column: 43
        }
      },
      "276": {
        start: {
          line: 584,
          column: 8
        },
        end: {
          line: 586,
          column: 9
        }
      },
      "277": {
        start: {
          line: 585,
          column: 12
        },
        end: {
          line: 585,
          column: 24
        }
      },
      "278": {
        start: {
          line: 587,
          column: 21
        },
        end: {
          line: 587,
          column: 39
        }
      },
      "279": {
        start: {
          line: 588,
          column: 8
        },
        end: {
          line: 590,
          column: 9
        }
      },
      "280": {
        start: {
          line: 589,
          column: 12
        },
        end: {
          line: 589,
          column: 24
        }
      },
      "281": {
        start: {
          line: 591,
          column: 8
        },
        end: {
          line: 594,
          column: 9
        }
      },
      "282": {
        start: {
          line: 593,
          column: 12
        },
        end: {
          line: 593,
          column: 29
        }
      },
      "283": {
        start: {
          line: 596,
          column: 8
        },
        end: {
          line: 596,
          column: 50
        }
      },
      "284": {
        start: {
          line: 602,
          column: 4
        },
        end: {
          line: 612,
          column: 6
        }
      },
      "285": {
        start: {
          line: 603,
          column: 8
        },
        end: {
          line: 611,
          column: 9
        }
      },
      "286": {
        start: {
          line: 604,
          column: 12
        },
        end: {
          line: 604,
          column: 52
        }
      },
      "287": {
        start: {
          line: 606,
          column: 13
        },
        end: {
          line: 611,
          column: 9
        }
      },
      "288": {
        start: {
          line: 607,
          column: 12
        },
        end: {
          line: 607,
          column: 43
        }
      },
      "289": {
        start: {
          line: 610,
          column: 12
        },
        end: {
          line: 610,
          column: 25
        }
      },
      "290": {
        start: {
          line: 617,
          column: 4
        },
        end: {
          line: 627,
          column: 6
        }
      },
      "291": {
        start: {
          line: 618,
          column: 29
        },
        end: {
          line: 618,
          column: 40
        }
      },
      "292": {
        start: {
          line: 619,
          column: 28
        },
        end: {
          line: 619,
          column: 51
        }
      },
      "293": {
        start: {
          line: 620,
          column: 8
        },
        end: {
          line: 622,
          column: 9
        }
      },
      "294": {
        start: {
          line: 621,
          column: 12
        },
        end: {
          line: 621,
          column: 24
        }
      },
      "295": {
        start: {
          line: 623,
          column: 8
        },
        end: {
          line: 626,
          column: 11
        }
      },
      "296": {
        start: {
          line: 624,
          column: 25
        },
        end: {
          line: 624,
          column: 49
        }
      },
      "297": {
        start: {
          line: 625,
          column: 12
        },
        end: {
          line: 625,
          column: 53
        }
      },
      "298": {
        start: {
          line: 632,
          column: 4
        },
        end: {
          line: 648,
          column: 6
        }
      },
      "299": {
        start: {
          line: 633,
          column: 29
        },
        end: {
          line: 633,
          column: 40
        }
      },
      "300": {
        start: {
          line: 634,
          column: 28
        },
        end: {
          line: 634,
          column: 51
        }
      },
      "301": {
        start: {
          line: 635,
          column: 25
        },
        end: {
          line: 635,
          column: 67
        }
      },
      "302": {
        start: {
          line: 636,
          column: 8
        },
        end: {
          line: 638,
          column: 9
        }
      },
      "303": {
        start: {
          line: 637,
          column: 12
        },
        end: {
          line: 637,
          column: 24
        }
      },
      "304": {
        start: {
          line: 639,
          column: 8
        },
        end: {
          line: 647,
          column: 11
        }
      },
      "305": {
        start: {
          line: 640,
          column: 25
        },
        end: {
          line: 640,
          column: 49
        }
      },
      "306": {
        start: {
          line: 641,
          column: 12
        },
        end: {
          line: 646,
          column: 13
        }
      },
      "307": {
        start: {
          line: 642,
          column: 16
        },
        end: {
          line: 642,
          column: 54
        }
      },
      "308": {
        start: {
          line: 645,
          column: 16
        },
        end: {
          line: 645,
          column: 41
        }
      },
      "309": {
        start: {
          line: 654,
          column: 4
        },
        end: {
          line: 663,
          column: 6
        }
      },
      "310": {
        start: {
          line: 655,
          column: 8
        },
        end: {
          line: 662,
          column: 9
        }
      },
      "311": {
        start: {
          line: 657,
          column: 12
        },
        end: {
          line: 657,
          column: 44
        }
      },
      "312": {
        start: {
          line: 661,
          column: 12
        },
        end: {
          line: 661,
          column: 44
        }
      },
      "313": {
        start: {
          line: 668,
          column: 4
        },
        end: {
          line: 677,
          column: 6
        }
      },
      "314": {
        start: {
          line: 669,
          column: 8
        },
        end: {
          line: 671,
          column: 9
        }
      },
      "315": {
        start: {
          line: 670,
          column: 12
        },
        end: {
          line: 670,
          column: 24
        }
      },
      "316": {
        start: {
          line: 672,
          column: 22
        },
        end: {
          line: 672,
          column: 35
        }
      },
      "317": {
        start: {
          line: 673,
          column: 8
        },
        end: {
          line: 675,
          column: 9
        }
      },
      "318": {
        start: {
          line: 674,
          column: 12
        },
        end: {
          line: 674,
          column: 24
        }
      },
      "319": {
        start: {
          line: 676,
          column: 8
        },
        end: {
          line: 676,
          column: 42
        }
      },
      "320": {
        start: {
          line: 682,
          column: 4
        },
        end: {
          line: 691,
          column: 6
        }
      },
      "321": {
        start: {
          line: 683,
          column: 20
        },
        end: {
          line: 683,
          column: 33
        }
      },
      "322": {
        start: {
          line: 684,
          column: 8
        },
        end: {
          line: 690,
          column: 10
        }
      },
      "323": {
        start: {
          line: 696,
          column: 4
        },
        end: {
          line: 699,
          column: 6
        }
      },
      "324": {
        start: {
          line: 697,
          column: 20
        },
        end: {
          line: 697,
          column: 33
        }
      },
      "325": {
        start: {
          line: 698,
          column: 8
        },
        end: {
          line: 698,
          column: 37
        }
      },
      "326": {
        start: {
          line: 700,
          column: 4
        },
        end: {
          line: 700,
          column: 22
        }
      },
      "327": {
        start: {
          line: 702,
          column: 0
        },
        end: {
          line: 702,
          column: 32
        }
      },
      "328": {
        start: {
          line: 705,
          column: 14
        },
        end: {
          line: 705,
          column: 16
        }
      },
      "329": {
        start: {
          line: 706,
          column: 4
        },
        end: {
          line: 708,
          column: 5
        }
      },
      "330": {
        start: {
          line: 706,
          column: 18
        },
        end: {
          line: 706,
          column: 19
        }
      },
      "331": {
        start: {
          line: 707,
          column: 8
        },
        end: {
          line: 707,
          column: 32
        }
      },
      "332": {
        start: {
          line: 709,
          column: 4
        },
        end: {
          line: 709,
          column: 84
        }
      },
      "333": {
        start: {
          line: 711,
          column: 0
        },
        end: {
          line: 711,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 54
          },
          end: {
            line: 6,
            column: 55
          }
        },
        loc: {
          start: {
            line: 6,
            column: 66
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "_createElemByHTML",
        decl: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 26
          }
        },
        loc: {
          start: {
            line: 21,
            column: 33
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 21
      },
      "2": {
        name: "_isDOMList",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 19
          }
        },
        loc: {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 31
      },
      "3": {
        name: "_querySelectorAll",
        decl: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 26
          }
        },
        loc: {
          start: {
            line: 44,
            column: 37
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 44
      },
      "4": {
        name: "_styleArrTrim",
        decl: {
          start: {
            line: 52,
            column: 9
          },
          end: {
            line: 52,
            column: 22
          }
        },
        loc: {
          start: {
            line: 52,
            column: 30
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 21
          },
          end: {
            line: 62,
            column: 22
          }
        },
        loc: {
          start: {
            line: 62,
            column: 37
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 64,
            column: 38
          },
          end: {
            line: 64,
            column: 39
          }
        },
        loc: {
          start: {
            line: 64,
            column: 51
          },
          end: {
            line: 66,
            column: 9
          }
        },
        line: 64
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 74,
            column: 33
          }
        },
        loc: {
          start: {
            line: 74,
            column: 44
          },
          end: {
            line: 701,
            column: 1
          }
        },
        line: 74
      },
      "8": {
        name: "DomElement",
        decl: {
          start: {
            line: 79,
            column: 13
          },
          end: {
            line: 79,
            column: 23
          }
        },
        loc: {
          start: {
            line: 79,
            column: 34
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 79
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 133,
            column: 13
          },
          end: {
            line: 133,
            column: 14
          }
        },
        loc: {
          start: {
            line: 133,
            column: 25
          },
          end: {
            line: 135,
            column: 9
          }
        },
        line: 133
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 143,
            column: 35
          },
          end: {
            line: 143,
            column: 36
          }
        },
        loc: {
          start: {
            line: 143,
            column: 49
          },
          end: {
            line: 152,
            column: 5
          }
        },
        line: 143
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 157,
            column: 33
          },
          end: {
            line: 157,
            column: 34
          }
        },
        loc: {
          start: {
            line: 157,
            column: 49
          },
          end: {
            line: 164,
            column: 5
          }
        },
        line: 157
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 160,
            column: 27
          },
          end: {
            line: 160,
            column: 28
          }
        },
        loc: {
          start: {
            line: 160,
            column: 43
          },
          end: {
            line: 162,
            column: 9
          }
        },
        line: 160
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 169,
            column: 31
          },
          end: {
            line: 169,
            column: 32
          }
        },
        loc: {
          start: {
            line: 169,
            column: 48
          },
          end: {
            line: 176,
            column: 5
          }
        },
        line: 169
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 180,
            column: 33
          },
          end: {
            line: 180,
            column: 34
          }
        },
        loc: {
          start: {
            line: 180,
            column: 45
          },
          end: {
            line: 182,
            column: 5
          }
        },
        line: 180
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 186,
            column: 32
          },
          end: {
            line: 186,
            column: 33
          }
        },
        loc: {
          start: {
            line: 186,
            column: 44
          },
          end: {
            line: 189,
            column: 5
          }
        },
        line: 186
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 190,
            column: 30
          },
          end: {
            line: 190,
            column: 31
          }
        },
        loc: {
          start: {
            line: 190,
            column: 60
          },
          end: {
            line: 222,
            column: 5
          }
        },
        line: 190
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 198,
            column: 28
          },
          end: {
            line: 198,
            column: 29
          }
        },
        loc: {
          start: {
            line: 198,
            column: 44
          },
          end: {
            line: 221,
            column: 9
          }
        },
        line: 198
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 206,
            column: 26
          },
          end: {
            line: 206,
            column: 27
          }
        },
        loc: {
          start: {
            line: 206,
            column: 39
          },
          end: {
            line: 212,
            column: 13
          }
        },
        line: 206
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 223,
            column: 31
          },
          end: {
            line: 223,
            column: 32
          }
        },
        loc: {
          start: {
            line: 223,
            column: 61
          },
          end: {
            line: 252,
            column: 5
          }
        },
        line: 223
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 231,
            column: 28
          },
          end: {
            line: 231,
            column: 29
          }
        },
        loc: {
          start: {
            line: 231,
            column: 44
          },
          end: {
            line: 251,
            column: 9
          }
        },
        line: 231
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 253,
            column: 32
          },
          end: {
            line: 253,
            column: 33
          }
        },
        loc: {
          start: {
            line: 253,
            column: 52
          },
          end: {
            line: 262,
            column: 5
          }
        },
        line: 253
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 259,
            column: 28
          },
          end: {
            line: 259,
            column: 29
          }
        },
        loc: {
          start: {
            line: 259,
            column: 44
          },
          end: {
            line: 261,
            column: 9
          }
        },
        line: 259
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 267,
            column: 38
          },
          end: {
            line: 267,
            column: 39
          }
        },
        loc: {
          start: {
            line: 267,
            column: 53
          },
          end: {
            line: 271,
            column: 5
          }
        },
        line: 267
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 268,
            column: 21
          },
          end: {
            line: 268,
            column: 22
          }
        },
        loc: {
          start: {
            line: 268,
            column: 37
          },
          end: {
            line: 270,
            column: 9
          }
        },
        line: 268
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 276,
            column: 36
          },
          end: {
            line: 276,
            column: 37
          }
        },
        loc: {
          start: {
            line: 276,
            column: 57
          },
          end: {
            line: 299,
            column: 5
          }
        },
        line: 276
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 280,
            column: 28
          },
          end: {
            line: 280,
            column: 29
          }
        },
        loc: {
          start: {
            line: 280,
            column: 44
          },
          end: {
            line: 298,
            column: 9
          }
        },
        line: 280
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 284,
            column: 33
          },
          end: {
            line: 284,
            column: 34
          }
        },
        loc: {
          start: {
            line: 284,
            column: 49
          },
          end: {
            line: 286,
            column: 17
          }
        },
        line: 284
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 304,
            column: 39
          },
          end: {
            line: 304,
            column: 40
          }
        },
        loc: {
          start: {
            line: 304,
            column: 60
          },
          end: {
            line: 325,
            column: 5
          }
        },
        line: 304
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 308,
            column: 28
          },
          end: {
            line: 308,
            column: 29
          }
        },
        loc: {
          start: {
            line: 308,
            column: 44
          },
          end: {
            line: 324,
            column: 9
          }
        },
        line: 308
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 314,
            column: 29
          },
          end: {
            line: 314,
            column: 30
          }
        },
        loc: {
          start: {
            line: 314,
            column: 45
          },
          end: {
            line: 321,
            column: 13
          }
        },
        line: 314
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 330,
            column: 36
          },
          end: {
            line: 330,
            column: 37
          }
        },
        loc: {
          start: {
            line: 330,
            column: 57
          },
          end: {
            line: 341,
            column: 5
          }
        },
        line: 330
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 348,
            column: 31
          },
          end: {
            line: 348,
            column: 32
          }
        },
        loc: {
          start: {
            line: 348,
            column: 51
          },
          end: {
            line: 386,
            column: 5
          }
        },
        line: 348
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 356,
            column: 28
          },
          end: {
            line: 356,
            column: 29
          }
        },
        loc: {
          start: {
            line: 356,
            column: 44
          },
          end: {
            line: 385,
            column: 9
          }
        },
        line: 356
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 362,
            column: 42
          },
          end: {
            line: 362,
            column: 43
          }
        },
        loc: {
          start: {
            line: 362,
            column: 58
          },
          end: {
            line: 369,
            column: 17
          }
        },
        line: 362
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 390,
            column: 49
          },
          end: {
            line: 390,
            column: 50
          }
        },
        loc: {
          start: {
            line: 390,
            column: 61
          },
          end: {
            line: 393,
            column: 5
          }
        },
        line: 390
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 397,
            column: 32
          },
          end: {
            line: 397,
            column: 33
          }
        },
        loc: {
          start: {
            line: 397,
            column: 44
          },
          end: {
            line: 399,
            column: 5
          }
        },
        line: 397
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 403,
            column: 32
          },
          end: {
            line: 403,
            column: 33
          }
        },
        loc: {
          start: {
            line: 403,
            column: 44
          },
          end: {
            line: 405,
            column: 5
          }
        },
        line: 403
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 409,
            column: 36
          },
          end: {
            line: 409,
            column: 37
          }
        },
        loc: {
          start: {
            line: 409,
            column: 48
          },
          end: {
            line: 415,
            column: 5
          }
        },
        line: 409
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 419,
            column: 38
          },
          end: {
            line: 419,
            column: 39
          }
        },
        loc: {
          start: {
            line: 419,
            column: 50
          },
          end: {
            line: 425,
            column: 5
          }
        },
        line: 419
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 430,
            column: 43
          },
          end: {
            line: 430,
            column: 44
          }
        },
        loc: {
          start: {
            line: 430,
            column: 64
          },
          end: {
            line: 437,
            column: 5
          }
        },
        line: 430
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 442,
            column: 34
          },
          end: {
            line: 442,
            column: 35
          }
        },
        loc: {
          start: {
            line: 442,
            column: 55
          },
          end: {
            line: 448,
            column: 5
          }
        },
        line: 442
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 443,
            column: 28
          },
          end: {
            line: 443,
            column: 29
          }
        },
        loc: {
          start: {
            line: 443,
            column: 44
          },
          end: {
            line: 447,
            column: 9
          }
        },
        line: 443
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 444,
            column: 30
          },
          end: {
            line: 444,
            column: 31
          }
        },
        loc: {
          start: {
            line: 444,
            column: 47
          },
          end: {
            line: 446,
            column: 13
          }
        },
        line: 444
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 452,
            column: 34
          },
          end: {
            line: 452,
            column: 35
          }
        },
        loc: {
          start: {
            line: 452,
            column: 46
          },
          end: {
            line: 462,
            column: 5
          }
        },
        line: 452
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 453,
            column: 28
          },
          end: {
            line: 453,
            column: 29
          }
        },
        loc: {
          start: {
            line: 453,
            column: 44
          },
          end: {
            line: 461,
            column: 9
          }
        },
        line: 453
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 467,
            column: 37
          },
          end: {
            line: 467,
            column: 38
          }
        },
        loc: {
          start: {
            line: 467,
            column: 55
          },
          end: {
            line: 471,
            column: 5
          }
        },
        line: 467
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 475,
            column: 39
          },
          end: {
            line: 475,
            column: 40
          }
        },
        loc: {
          start: {
            line: 475,
            column: 51
          },
          end: {
            line: 479,
            column: 5
          }
        },
        line: 475
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 483,
            column: 39
          },
          end: {
            line: 483,
            column: 40
          }
        },
        loc: {
          start: {
            line: 483,
            column: 51
          },
          end: {
            line: 486,
            column: 5
          }
        },
        line: 483
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 490,
            column: 35
          },
          end: {
            line: 490,
            column: 36
          }
        },
        loc: {
          start: {
            line: 490,
            column: 47
          },
          end: {
            line: 493,
            column: 5
          }
        },
        line: 490
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 497,
            column: 43
          },
          end: {
            line: 497,
            column: 44
          }
        },
        loc: {
          start: {
            line: 497,
            column: 55
          },
          end: {
            line: 500,
            column: 5
          }
        },
        line: 497
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 512,
            column: 32
          },
          end: {
            line: 512,
            column: 33
          }
        },
        loc: {
          start: {
            line: 512,
            column: 52
          },
          end: {
            line: 515,
            column: 5
          }
        },
        line: 512
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 516,
            column: 32
          },
          end: {
            line: 516,
            column: 33
          }
        },
        loc: {
          start: {
            line: 516,
            column: 47
          },
          end: {
            line: 528,
            column: 5
          }
        },
        line: 516
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 520,
            column: 54
          },
          end: {
            line: 520,
            column: 55
          }
        },
        loc: {
          start: {
            line: 520,
            column: 66
          },
          end: {
            line: 520,
            column: 80
          }
        },
        line: 520
      },
      "54": {
        name: "(anonymous_54)",
        decl: {
          start: {
            line: 524,
            column: 32
          },
          end: {
            line: 524,
            column: 33
          }
        },
        loc: {
          start: {
            line: 524,
            column: 48
          },
          end: {
            line: 526,
            column: 13
          }
        },
        line: 524
      },
      "55": {
        name: "(anonymous_55)",
        decl: {
          start: {
            line: 529,
            column: 32
          },
          end: {
            line: 529,
            column: 33
          }
        },
        loc: {
          start: {
            line: 529,
            column: 47
          },
          end: {
            line: 540,
            column: 5
          }
        },
        line: 529
      },
      "56": {
        name: "(anonymous_56)",
        decl: {
          start: {
            line: 544,
            column: 31
          },
          end: {
            line: 544,
            column: 32
          }
        },
        loc: {
          start: {
            line: 544,
            column: 43
          },
          end: {
            line: 547,
            column: 5
          }
        },
        line: 544
      },
      "57": {
        name: "(anonymous_57)",
        decl: {
          start: {
            line: 551,
            column: 33
          },
          end: {
            line: 551,
            column: 34
          }
        },
        loc: {
          start: {
            line: 551,
            column: 45
          },
          end: {
            line: 555,
            column: 5
          }
        },
        line: 551
      },
      "58": {
        name: "(anonymous_58)",
        decl: {
          start: {
            line: 552,
            column: 28
          },
          end: {
            line: 552,
            column: 29
          }
        },
        loc: {
          start: {
            line: 552,
            column: 44
          },
          end: {
            line: 554,
            column: 9
          }
        },
        line: 552
      },
      "59": {
        name: "(anonymous_59)",
        decl: {
          start: {
            line: 559,
            column: 32
          },
          end: {
            line: 559,
            column: 33
          }
        },
        loc: {
          start: {
            line: 559,
            column: 44
          },
          end: {
            line: 562,
            column: 5
          }
        },
        line: 559
      },
      "60": {
        name: "(anonymous_60)",
        decl: {
          start: {
            line: 566,
            column: 32
          },
          end: {
            line: 566,
            column: 33
          }
        },
        loc: {
          start: {
            line: 566,
            column: 44
          },
          end: {
            line: 569,
            column: 5
          }
        },
        line: 566
      },
      "61": {
        name: "(anonymous_61)",
        decl: {
          start: {
            line: 573,
            column: 34
          },
          end: {
            line: 573,
            column: 35
          }
        },
        loc: {
          start: {
            line: 573,
            column: 46
          },
          end: {
            line: 576,
            column: 5
          }
        },
        line: 573
      },
      "62": {
        name: "(anonymous_62)",
        decl: {
          start: {
            line: 582,
            column: 39
          },
          end: {
            line: 582,
            column: 40
          }
        },
        loc: {
          start: {
            line: 582,
            column: 68
          },
          end: {
            line: 597,
            column: 5
          }
        },
        line: 582
      },
      "63": {
        name: "(anonymous_63)",
        decl: {
          start: {
            line: 602,
            column: 33
          },
          end: {
            line: 602,
            column: 34
          }
        },
        loc: {
          start: {
            line: 602,
            column: 50
          },
          end: {
            line: 612,
            column: 5
          }
        },
        line: 602
      },
      "64": {
        name: "(anonymous_64)",
        decl: {
          start: {
            line: 617,
            column: 40
          },
          end: {
            line: 617,
            column: 41
          }
        },
        loc: {
          start: {
            line: 617,
            column: 60
          },
          end: {
            line: 627,
            column: 5
          }
        },
        line: 617
      },
      "65": {
        name: "(anonymous_65)",
        decl: {
          start: {
            line: 623,
            column: 28
          },
          end: {
            line: 623,
            column: 29
          }
        },
        loc: {
          start: {
            line: 623,
            column: 44
          },
          end: {
            line: 626,
            column: 9
          }
        },
        line: 623
      },
      "66": {
        name: "(anonymous_66)",
        decl: {
          start: {
            line: 632,
            column: 39
          },
          end: {
            line: 632,
            column: 40
          }
        },
        loc: {
          start: {
            line: 632,
            column: 59
          },
          end: {
            line: 648,
            column: 5
          }
        },
        line: 632
      },
      "67": {
        name: "(anonymous_67)",
        decl: {
          start: {
            line: 639,
            column: 28
          },
          end: {
            line: 639,
            column: 29
          }
        },
        loc: {
          start: {
            line: 639,
            column: 44
          },
          end: {
            line: 647,
            column: 9
          }
        },
        line: 639
      },
      "68": {
        name: "(anonymous_68)",
        decl: {
          start: {
            line: 654,
            column: 32
          },
          end: {
            line: 654,
            column: 33
          }
        },
        loc: {
          start: {
            line: 654,
            column: 54
          },
          end: {
            line: 663,
            column: 5
          }
        },
        line: 654
      },
      "69": {
        name: "(anonymous_69)",
        decl: {
          start: {
            line: 668,
            column: 38
          },
          end: {
            line: 668,
            column: 39
          }
        },
        loc: {
          start: {
            line: 668,
            column: 56
          },
          end: {
            line: 677,
            column: 5
          }
        },
        line: 668
      },
      "70": {
        name: "(anonymous_70)",
        decl: {
          start: {
            line: 682,
            column: 41
          },
          end: {
            line: 682,
            column: 42
          }
        },
        loc: {
          start: {
            line: 682,
            column: 53
          },
          end: {
            line: 691,
            column: 5
          }
        },
        line: 682
      },
      "71": {
        name: "(anonymous_71)",
        decl: {
          start: {
            line: 696,
            column: 37
          },
          end: {
            line: 696,
            column: 38
          }
        },
        loc: {
          start: {
            line: 696,
            column: 52
          },
          end: {
            line: 699,
            column: 5
          }
        },
        line: 696
      },
      "72": {
        name: "$",
        decl: {
          start: {
            line: 704,
            column: 9
          },
          end: {
            line: 704,
            column: 10
          }
        },
        loc: {
          start: {
            line: 704,
            column: 13
          },
          end: {
            line: 710,
            column: 1
          }
        },
        line: 704
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 21
          },
          end: {
            line: 12,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 6,
            column: 26
          }
        }, {
          start: {
            line: 6,
            column: 30
          },
          end: {
            line: 6,
            column: 49
          }
        }, {
          start: {
            line: 6,
            column: 54
          },
          end: {
            line: 12,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 42
          }
        }, {
          start: {
            line: 35,
            column: 46
          },
          end: {
            line: 35,
            column: 74
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 67
      },
      "6": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }],
        line: 84
      },
      "7": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        }, {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        }],
        line: 88
      },
      "8": {
        loc: {
          start: {
            line: 92,
            column: 23
          },
          end: {
            line: 92,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 50
          },
          end: {
            line: 92,
            column: 67
          }
        }, {
          start: {
            line: 92,
            column: 70
          },
          end: {
            line: 92,
            column: 72
          }
        }],
        line: 92
      },
      "9": {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        }, {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 116,
            column: 9
          }
        }],
        line: 94
      },
      "10": {
        loc: {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 94,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 94,
            column: 26
          }
        }, {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 94,
            column: 44
          }
        }],
        line: 94
      },
      "11": {
        loc: {
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }, {
          start: {
            line: 97,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }],
        line: 97
      },
      "12": {
        loc: {
          start: {
            line: 101,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }, {
          start: {
            line: 101,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }],
        line: 101
      },
      "13": {
        loc: {
          start: {
            line: 105,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }, {
          start: {
            line: 105,
            column: 13
          },
          end: {
            line: 116,
            column: 9
          }
        }],
        line: 105
      },
      "14": {
        loc: {
          start: {
            line: 108,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        }, {
          start: {
            line: 108,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        }],
        line: 108
      },
      "15": {
        loc: {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 121,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 121,
            column: 9
          }
        }, {
          start: {
            line: 118,
            column: 8
          },
          end: {
            line: 121,
            column: 9
          }
        }],
        line: 118
      },
      "16": {
        loc: {
          start: {
            line: 147,
            column: 12
          },
          end: {
            line: 149,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 12
          },
          end: {
            line: 149,
            column: 13
          }
        }, {
          start: {
            line: 147,
            column: 12
          },
          end: {
            line: 149,
            column: 13
          }
        }],
        line: 147
      },
      "17": {
        loc: {
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 46
          }
        }, {
          start: {
            line: 158,
            column: 8
          },
          end: {
            line: 158,
            column: 46
          }
        }],
        line: 158
      },
      "18": {
        loc: {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 44
          }
        }, {
          start: {
            line: 170,
            column: 8
          },
          end: {
            line: 170,
            column: 44
          }
        }],
        line: 170
      },
      "19": {
        loc: {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 174,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 174,
            column: 9
          }
        }, {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 174,
            column: 9
          }
        }],
        line: 172
      },
      "20": {
        loc: {
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 192,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 192,
            column: 24
          }
        }, {
          start: {
            line: 191,
            column: 8
          },
          end: {
            line: 192,
            column: 24
          }
        }],
        line: 191
      },
      "21": {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 197,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 197,
            column: 9
          }
        }, {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 197,
            column: 9
          }
        }],
        line: 194
      },
      "22": {
        loc: {
          start: {
            line: 200,
            column: 12
          },
          end: {
            line: 204,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 200,
            column: 12
          },
          end: {
            line: 204,
            column: 13
          }
        }, {
          start: {
            line: 200,
            column: 12
          },
          end: {
            line: 204,
            column: 13
          }
        }],
        line: 200
      },
      "23": {
        loc: {
          start: {
            line: 208,
            column: 16
          },
          end: {
            line: 211,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 16
          },
          end: {
            line: 211,
            column: 17
          }
        }, {
          start: {
            line: 208,
            column: 16
          },
          end: {
            line: 211,
            column: 17
          }
        }],
        line: 208
      },
      "24": {
        loc: {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 225,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 225,
            column: 24
          }
        }, {
          start: {
            line: 224,
            column: 8
          },
          end: {
            line: 225,
            column: 24
          }
        }],
        line: 224
      },
      "25": {
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        }, {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        }],
        line: 227
      },
      "26": {
        loc: {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 250,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 250,
            column: 13
          }
        }, {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 250,
            column: 13
          }
        }],
        line: 233
      },
      "27": {
        loc: {
          start: {
            line: 237,
            column: 20
          },
          end: {
            line: 240,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 20
          },
          end: {
            line: 240,
            column: 21
          }
        }, {
          start: {
            line: 237,
            column: 20
          },
          end: {
            line: 240,
            column: 21
          }
        }],
        line: 237
      },
      "28": {
        loc: {
          start: {
            line: 237,
            column: 24
          },
          end: {
            line: 237,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 237,
            column: 24
          },
          end: {
            line: 237,
            column: 50
          }
        }, {
          start: {
            line: 237,
            column: 54
          },
          end: {
            line: 237,
            column: 68
          }
        }, {
          start: {
            line: 237,
            column: 72
          },
          end: {
            line: 237,
            column: 90
          }
        }],
        line: 237
      },
      "29": {
        loc: {
          start: {
            line: 242,
            column: 16
          },
          end: {
            line: 245,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 242,
            column: 16
          },
          end: {
            line: 245,
            column: 17
          }
        }, {
          start: {
            line: 242,
            column: 16
          },
          end: {
            line: 245,
            column: 17
          }
        }],
        line: 242
      },
      "30": {
        loc: {
          start: {
            line: 254,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }, {
          start: {
            line: 254,
            column: 8
          },
          end: {
            line: 257,
            column: 9
          }
        }],
        line: 254
      },
      "31": {
        loc: {
          start: {
            line: 256,
            column: 19
          },
          end: {
            line: 256,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 19
          },
          end: {
            line: 256,
            column: 50
          }
        }, {
          start: {
            line: 256,
            column: 54
          },
          end: {
            line: 256,
            column: 56
          }
        }],
        line: 256
      },
      "32": {
        loc: {
          start: {
            line: 277,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        }, {
          start: {
            line: 277,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        }],
        line: 277
      },
      "33": {
        loc: {
          start: {
            line: 281,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }, {
          start: {
            line: 281,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }],
        line: 281
      },
      "34": {
        loc: {
          start: {
            line: 288,
            column: 16
          },
          end: {
            line: 290,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 288,
            column: 16
          },
          end: {
            line: 290,
            column: 17
          }
        }, {
          start: {
            line: 288,
            column: 16
          },
          end: {
            line: 290,
            column: 17
          }
        }],
        line: 288
      },
      "35": {
        loc: {
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        }, {
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 307,
            column: 9
          }
        }],
        line: 305
      },
      "36": {
        loc: {
          start: {
            line: 309,
            column: 12
          },
          end: {
            line: 312,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 12
          },
          end: {
            line: 312,
            column: 13
          }
        }, {
          start: {
            line: 309,
            column: 12
          },
          end: {
            line: 312,
            column: 13
          }
        }],
        line: 309
      },
      "37": {
        loc: {
          start: {
            line: 317,
            column: 16
          },
          end: {
            line: 319,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 16
          },
          end: {
            line: 319,
            column: 17
          }
        }, {
          start: {
            line: 317,
            column: 16
          },
          end: {
            line: 319,
            column: 17
          }
        }],
        line: 317
      },
      "38": {
        loc: {
          start: {
            line: 317,
            column: 20
          },
          end: {
            line: 317,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 20
          },
          end: {
            line: 317,
            column: 25
          }
        }, {
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 47
          }
        }],
        line: 317
      },
      "39": {
        loc: {
          start: {
            line: 331,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 331,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }, {
          start: {
            line: 331,
            column: 8
          },
          end: {
            line: 333,
            column: 9
          }
        }],
        line: 331
      },
      "40": {
        loc: {
          start: {
            line: 335,
            column: 8
          },
          end: {
            line: 338,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 335,
            column: 8
          },
          end: {
            line: 338,
            column: 9
          }
        }, {
          start: {
            line: 335,
            column: 8
          },
          end: {
            line: 338,
            column: 9
          }
        }],
        line: 335
      },
      "41": {
        loc: {
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 355,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 355,
            column: 9
          }
        }, {
          start: {
            line: 350,
            column: 8
          },
          end: {
            line: 355,
            column: 9
          }
        }],
        line: 350
      },
      "42": {
        loc: {
          start: {
            line: 357,
            column: 25
          },
          end: {
            line: 357,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 25
          },
          end: {
            line: 357,
            column: 51
          }
        }, {
          start: {
            line: 357,
            column: 55
          },
          end: {
            line: 357,
            column: 57
          }
        }],
        line: 357
      },
      "43": {
        loc: {
          start: {
            line: 358,
            column: 12
          },
          end: {
            line: 384,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 358,
            column: 12
          },
          end: {
            line: 384,
            column: 13
          }
        }, {
          start: {
            line: 358,
            column: 12
          },
          end: {
            line: 384,
            column: 13
          }
        }],
        line: 358
      },
      "44": {
        loc: {
          start: {
            line: 363,
            column: 20
          },
          end: {
            line: 368,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 363,
            column: 20
          },
          end: {
            line: 368,
            column: 21
          }
        }, {
          start: {
            line: 363,
            column: 20
          },
          end: {
            line: 368,
            column: 21
          }
        }],
        line: 363
      },
      "45": {
        loc: {
          start: {
            line: 371,
            column: 16
          },
          end: {
            line: 373,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 371,
            column: 16
          },
          end: {
            line: 373,
            column: 17
          }
        }, {
          start: {
            line: 371,
            column: 16
          },
          end: {
            line: 373,
            column: 17
          }
        }],
        line: 371
      },
      "46": {
        loc: {
          start: {
            line: 371,
            column: 20
          },
          end: {
            line: 371,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 371,
            column: 20
          },
          end: {
            line: 371,
            column: 38
          }
        }, {
          start: {
            line: 371,
            column: 42
          },
          end: {
            line: 371,
            column: 77
          }
        }],
        line: 371
      },
      "47": {
        loc: {
          start: {
            line: 375,
            column: 16
          },
          end: {
            line: 377,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 375,
            column: 16
          },
          end: {
            line: 377,
            column: 17
          }
        }, {
          start: {
            line: 375,
            column: 16
          },
          end: {
            line: 377,
            column: 17
          }
        }],
        line: 375
      },
      "48": {
        loc: {
          start: {
            line: 411,
            column: 8
          },
          end: {
            line: 413,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 411,
            column: 8
          },
          end: {
            line: 413,
            column: 9
          }
        }, {
          start: {
            line: 411,
            column: 8
          },
          end: {
            line: 413,
            column: 9
          }
        }],
        line: 411
      },
      "49": {
        loc: {
          start: {
            line: 421,
            column: 8
          },
          end: {
            line: 423,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 421,
            column: 8
          },
          end: {
            line: 423,
            column: 9
          }
        }, {
          start: {
            line: 421,
            column: 8
          },
          end: {
            line: 423,
            column: 9
          }
        }],
        line: 421
      },
      "50": {
        loc: {
          start: {
            line: 434,
            column: 12
          },
          end: {
            line: 434,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 434,
            column: 12
          },
          end: {
            line: 434,
            column: 29
          }
        }, {
          start: {
            line: 434,
            column: 33
          },
          end: {
            line: 434,
            column: 68
          }
        }],
        line: 434
      },
      "51": {
        loc: {
          start: {
            line: 454,
            column: 12
          },
          end: {
            line: 460,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 454,
            column: 12
          },
          end: {
            line: 460,
            column: 13
          }
        }, {
          start: {
            line: 454,
            column: 12
          },
          end: {
            line: 460,
            column: 13
          }
        }],
        line: 454
      },
      "52": {
        loc: {
          start: {
            line: 459,
            column: 16
          },
          end: {
            line: 459,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 459,
            column: 16
          },
          end: {
            line: 459,
            column: 24
          }
        }, {
          start: {
            line: 459,
            column: 28
          },
          end: {
            line: 459,
            column: 54
          }
        }],
        line: 459
      },
      "53": {
        loc: {
          start: {
            line: 517,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 517,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        }, {
          start: {
            line: 517,
            column: 8
          },
          end: {
            line: 527,
            column: 9
          }
        }],
        line: 517
      },
      "54": {
        loc: {
          start: {
            line: 531,
            column: 8
          },
          end: {
            line: 539,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 531,
            column: 8
          },
          end: {
            line: 539,
            column: 9
          }
        }, {
          start: {
            line: 531,
            column: 8
          },
          end: {
            line: 539,
            column: 9
          }
        }],
        line: 531
      },
      "55": {
        loc: {
          start: {
            line: 583,
            column: 19
          },
          end: {
            line: 583,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 583,
            column: 19
          },
          end: {
            line: 583,
            column: 26
          }
        }, {
          start: {
            line: 583,
            column: 30
          },
          end: {
            line: 583,
            column: 43
          }
        }],
        line: 583
      },
      "56": {
        loc: {
          start: {
            line: 584,
            column: 8
          },
          end: {
            line: 586,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 584,
            column: 8
          },
          end: {
            line: 586,
            column: 9
          }
        }, {
          start: {
            line: 584,
            column: 8
          },
          end: {
            line: 586,
            column: 9
          }
        }],
        line: 584
      },
      "57": {
        loc: {
          start: {
            line: 588,
            column: 8
          },
          end: {
            line: 590,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 588,
            column: 8
          },
          end: {
            line: 590,
            column: 9
          }
        }, {
          start: {
            line: 588,
            column: 8
          },
          end: {
            line: 590,
            column: 9
          }
        }],
        line: 588
      },
      "58": {
        loc: {
          start: {
            line: 591,
            column: 8
          },
          end: {
            line: 594,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 591,
            column: 8
          },
          end: {
            line: 594,
            column: 9
          }
        }, {
          start: {
            line: 591,
            column: 8
          },
          end: {
            line: 594,
            column: 9
          }
        }],
        line: 591
      },
      "59": {
        loc: {
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 611,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 611,
            column: 9
          }
        }, {
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 611,
            column: 9
          }
        }],
        line: 603
      },
      "60": {
        loc: {
          start: {
            line: 606,
            column: 13
          },
          end: {
            line: 611,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 606,
            column: 13
          },
          end: {
            line: 611,
            column: 9
          }
        }, {
          start: {
            line: 606,
            column: 13
          },
          end: {
            line: 611,
            column: 9
          }
        }],
        line: 606
      },
      "61": {
        loc: {
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 622,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 622,
            column: 9
          }
        }, {
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 622,
            column: 9
          }
        }],
        line: 620
      },
      "62": {
        loc: {
          start: {
            line: 635,
            column: 25
          },
          end: {
            line: 635,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 635,
            column: 25
          },
          end: {
            line: 635,
            column: 38
          }
        }, {
          start: {
            line: 635,
            column: 42
          },
          end: {
            line: 635,
            column: 67
          }
        }],
        line: 635
      },
      "63": {
        loc: {
          start: {
            line: 636,
            column: 8
          },
          end: {
            line: 638,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 636,
            column: 8
          },
          end: {
            line: 638,
            column: 9
          }
        }, {
          start: {
            line: 636,
            column: 8
          },
          end: {
            line: 638,
            column: 9
          }
        }],
        line: 636
      },
      "64": {
        loc: {
          start: {
            line: 641,
            column: 12
          },
          end: {
            line: 646,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 641,
            column: 12
          },
          end: {
            line: 646,
            column: 13
          }
        }, {
          start: {
            line: 641,
            column: 12
          },
          end: {
            line: 646,
            column: 13
          }
        }],
        line: 641
      },
      "65": {
        loc: {
          start: {
            line: 655,
            column: 8
          },
          end: {
            line: 662,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 655,
            column: 8
          },
          end: {
            line: 662,
            column: 9
          }
        }, {
          start: {
            line: 655,
            column: 8
          },
          end: {
            line: 662,
            column: 9
          }
        }],
        line: 655
      },
      "66": {
        loc: {
          start: {
            line: 669,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 669,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        }, {
          start: {
            line: 669,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        }],
        line: 669
      },
      "67": {
        loc: {
          start: {
            line: 673,
            column: 8
          },
          end: {
            line: 675,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 673,
            column: 8
          },
          end: {
            line: 675,
            column: 9
          }
        }, {
          start: {
            line: 673,
            column: 8
          },
          end: {
            line: 675,
            column: 9
          }
        }],
        line: 673
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0,
      "238": 0,
      "239": 0,
      "240": 0,
      "241": 0,
      "242": 0,
      "243": 0,
      "244": 0,
      "245": 0,
      "246": 0,
      "247": 0,
      "248": 0,
      "249": 0,
      "250": 0,
      "251": 0,
      "252": 0,
      "253": 0,
      "254": 0,
      "255": 0,
      "256": 0,
      "257": 0,
      "258": 0,
      "259": 0,
      "260": 0,
      "261": 0,
      "262": 0,
      "263": 0,
      "264": 0,
      "265": 0,
      "266": 0,
      "267": 0,
      "268": 0,
      "269": 0,
      "270": 0,
      "271": 0,
      "272": 0,
      "273": 0,
      "274": 0,
      "275": 0,
      "276": 0,
      "277": 0,
      "278": 0,
      "279": 0,
      "280": 0,
      "281": 0,
      "282": 0,
      "283": 0,
      "284": 0,
      "285": 0,
      "286": 0,
      "287": 0,
      "288": 0,
      "289": 0,
      "290": 0,
      "291": 0,
      "292": 0,
      "293": 0,
      "294": 0,
      "295": 0,
      "296": 0,
      "297": 0,
      "298": 0,
      "299": 0,
      "300": 0,
      "301": 0,
      "302": 0,
      "303": 0,
      "304": 0,
      "305": 0,
      "306": 0,
      "307": 0,
      "308": 0,
      "309": 0,
      "310": 0,
      "311": 0,
      "312": 0,
      "313": 0,
      "314": 0,
      "315": 0,
      "316": 0,
      "317": 0,
      "318": 0,
      "319": 0,
      "320": 0,
      "321": 0,
      "322": 0,
      "323": 0,
      "324": 0,
      "325": 0,
      "326": 0,
      "327": 0,
      "328": 0,
      "329": 0,
      "330": 0,
      "331": 0,
      "332": 0,
      "333": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/dom-core.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/dom-core.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;AAGH,+BAAgC;AAmBhC,IAAM,YAAY,GAAgB,EAAE,CAAA;AAEpC;;;GAGG;AACH,SAAS,iBAAiB,CAAC,IAAY;IACnC,IAAM,GAAG,GAAG,QAAQ,CAAC,aAAa,CAAC,KAAK,CAAC,CAAA;IACzC,GAAG,CAAC,SAAS,GAAG,IAAI,CAAA;IACpB,IAAM,KAAK,GAAG,GAAG,CAAC,QAAQ,CAAA;IAC1B,OAAO,cAAO,CAAC,KAAK,CAAC,CAAA;AACzB,CAAC;AAED;;;GAGG;AACH,SAAS,UAAU,CAAsC,QAAiB;IACtE,IAAI,CAAC,QAAQ,EAAE;QACX,OAAO,KAAK,CAAA;KACf;IACD,IAAI,QAAQ,YAAY,cAAc,IAAI,QAAQ,YAAY,QAAQ,EAAE;QACpE,OAAO,IAAI,CAAA;KACd;IACD,OAAO,KAAK,CAAA;AAChB,CAAC;AAED;;;GAGG;AACH,SAAS,iBAAiB,CAAC,QAAgB;IACvC,IAAM,KAAK,GAAG,QAAQ,CAAC,gBAAgB,CAAC,QAAQ,CAAC,CAAA;IACjD,OAAO,cAAO,CAAC,KAAK,CAAC,CAAA;AACzB,CAAC;AAED;;;GAGG;AACH,SAAS,aAAa,CAAC,KAAwB;IAC3C,IAAI,QAAQ,GAAa,EAAE,CAAA;IAC3B,IAAI,SAAS,GAAa,EAAE,CAAA;IAE5B,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,KAAK,CAAC,EAAE;QACvB,+BAA+B;QAC/B,QAAQ,GAAG,KAAK,CAAC,KAAK,CAAC,GAAG,CAAC,CAAA;KAC9B;SAAM;QACH,QAAQ,GAAG,KAAK,CAAA;KACnB;IAED,QAAQ,CAAC,OAAO,CAAC,UAAA,IAAI;QACjB,6BAA6B;QAC7B,IAAI,GAAG,GAAG,IAAI,CAAC,KAAK,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,UAAA,CAAC;YAC3B,OAAO,CAAC,CAAC,IAAI,EAAE,CAAA;QACnB,CAAC,CAAC,CAAA;QACF,IAAI,GAAG,CAAC,MAAM,KAAK,CAAC,EAAE;YAClB,SAAS,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC,CAAC,GAAG,GAAG,GAAG,GAAG,CAAC,CAAC,CAAC,CAAC,CAAA;SACxC;IACL,CAAC,CAAC,CAAA;IACF,OAAO,SAAS,CAAA;AACpB,CAAC;AAgBD,OAAO;AACP;IAOI;;;OAGG;IACH,oBAAY,QAAW;QACnB,QAAQ;QACR,IAAI,CAAC,KAAK,GAAG,EAAE,CAAA;QACf,IAAI,CAAC,MAAM,GAAG,IAAI,CAAC,KAAK,CAAC,MAAM,CAAA;QAC/B,IAAI,CAAC,UAAU,GAAG,IAAI,GAAG,EAAE,CAAA;QAE3B,IAAI,CAAC,QAAQ,EAAE;YACX,OAAM;SACT;QAED,2BAA2B;QAC3B,IAAI,QAAQ,YAAY,UAAU,EAAE;YAChC,OAAO,QAAQ,CAAA;SAClB;QAED,IAAI,cAAc,GAAkB,EAAE,CAAA,CAAC,SAAS;QAChD,IAAM,QAAQ,GAAG,QAAQ,YAAY,IAAI,CAAC,CAAC,CAAC,QAAQ,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAC,CAAA;QAClE,IAAI,CAAC,QAAQ,GAAG,QAAQ,CAAA;QAExB,IAAI,QAAQ,KAAK,CAAC,IAAI,QAAQ,KAAK,CAAC,EAAE;YAClC,cAAc,GAAG,CAAC,QAAuB,CAAC,CAAA;SAC7C;aAAM,IAAI,UAAU,CAAC,QAAQ,CAAC,EAAE;YAC7B,WAAW;YACX,cAAc,GAAG,cAAO,CAAC,QAAQ,CAAC,CAAA;SACrC;aAAM,IAAI,QAAQ,YAAY,KAAK,EAAE;YAClC,0BAA0B;YAC1B,cAAc,GAAG,QAAQ,CAAA;SAC5B;aAAM,IAAI,OAAO,QAAQ,KAAK,QAAQ,EAAE;YACrC,MAAM;YACN,IAAM,WAAW,GAAG,QAAQ,CAAC,OAAO,CAAC,QAAQ,EAAE,EAAE,CAAC,CAAC,IAAI,EAAE,CAAA;YACzD,IAAI,WAAW,CAAC,OAAO,CAAC,GAAG,CAAC,KAAK,CAAC,EAAE;gBAChC,UAAU;gBACV,cAAc,GAAG,iBAAiB,CAAC,WAAW,CAAC,CAAA;aAClD;iBAAM;gBACH,eAAe;gBACf,cAAc,GAAG,iBAAiB,CAAC,WAAW,CAAC,CAAA;aAClD;SACJ;QAED,IAAM,MAAM,GAAG,cAAc,CAAC,MAAM,CAAA;QACpC,IAAI,CAAC,MAAM,EAAE;YACT,MAAM;YACN,OAAO,IAAI,CAAA;SACd;QAED,YAAY;QACZ,IAAI,CAAC,GAAG,CAAC,CAAA;QACT,OAAO,CAAC,GAAG,MAAM,EAAE,CAAC,EAAE,EAAE;YACpB,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,cAAc,CAAC,CAAC,CAAC,CAAC,CAAA;SACrC;QACD,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAKD,sBAAI,0BAAE;QAHN;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;QAC3B,CAAC;;;OAAA;IAED;;;OAGG;IACH,4BAAO,GAAP,UAAQ,EAA2D;QAC/D,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,IAAI,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;YAClC,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;YAC1B,IAAM,MAAM,GAAG,EAAE,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,EAAE,CAAC,CAAC,CAAA;YACrC,IAAI,MAAM,KAAK,KAAK,EAAE;gBAClB,MAAK;aACR;SACJ;QACD,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;;OAGG;IACH,0BAAK,GAAL,UAAM,IAAqB;QAArB,qBAAA,EAAA,YAAqB;QACvB,IAAM,SAAS,GAAkB,EAAE,CAAA;QACnC,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,UAAA,IAAI;YACnB,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,CAAC,CAAC,IAAI,CAAgB,CAAC,CAAA;QACzD,CAAC,CAAC,CAAA;QACF,OAAO,CAAC,CAAC,SAAS,CAAC,CAAA;IACvB,CAAC;IAED;;;OAGG;IACH,wBAAG,GAAH,UAAI,KAAiB;QAAjB,sBAAA,EAAA,SAAiB;QACjB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,KAAK,IAAI,MAAM,EAAE;YACjB,KAAK,GAAG,KAAK,GAAG,MAAM,CAAA;SACzB;QACD,OAAO,CAAC,CAAC,IAAI,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAA;IAC/B,CAAC;IAED;;OAEG;IACH,0BAAK,GAAL;QACI,OAAO,IAAI,CAAC,GAAG,CAAC,CAAC,CAAC,CAAA;IACtB,CAAC;IAED;;OAEG;IACH,yBAAI,GAAJ;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,OAAO,IAAI,CAAC,GAAG,CAAC,MAAM,GAAG,CAAC,CAAC,CAAA;IAC/B,CAAC;IAUD,uBAAE,GAAF,UAAG,IAAY,EAAE,QAA2B,EAAE,EAAa;QACvD,IAAI,CAAC,IAAI;YAAE,OAAO,IAAI,CAAA;QAEtB,4BAA4B;QAC5B,IAAI,OAAO,QAAQ,KAAK,UAAU,EAAE;YAChC,EAAE,GAAG,QAAQ,CAAA;YACb,QAAQ,GAAG,EAAE,CAAA;SAChB;QAED,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,SAAS;YACT,IAAI,CAAC,QAAQ,EAAE;gBACX,MAAM;gBACN,IAAI,CAAC,gBAAgB,CAAC,IAAI,EAAE,EAAc,CAAC,CAAA;gBAC3C,OAAM;aACT;YAED,QAAQ;YACR,IAAM,OAAO,GAAa,UAAU,CAAC;gBACjC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;gBACtC,IAAI,MAAM,CAAC,OAAO,CAAC,QAAkB,CAAC,EAAE;oBACpC,CAAC;oBAAC,EAAe,CAAC,IAAI,CAAC,MAAM,EAAE,CAAC,CAAC,CAAA;iBACpC;YACL,CAAC,CAAA;YACD,IAAI,CAAC,gBAAgB,CAAC,IAAI,EAAE,OAAO,CAAC,CAAA;YAEpC,SAAS;YACT,YAAY,CAAC,IAAI,CAAC;gBACd,IAAI,EAAE,IAAI;gBACV,QAAQ,EAAE,QAAkB;gBAC5B,EAAE,EAAE,EAAc;gBAClB,OAAO,SAAA;aACV,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;IACN,CAAC;IAUD,wBAAG,GAAH,UAAI,IAAY,EAAE,QAA2B,EAAE,EAAa;QACxD,IAAI,CAAC,IAAI;YAAE,OAAO,IAAI,CAAA;QAEtB,4BAA4B;QAC5B,IAAI,OAAO,QAAQ,KAAK,UAAU,EAAE;YAChC,EAAE,GAAG,QAAQ,CAAA;YACb,QAAQ,GAAG,EAAE,CAAA;SAChB;QAED,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YAC3C,SAAS;YACT,IAAI,QAAQ,EAAE;gBACV,IAAI,GAAG,GAAG,CAAC,CAAC,CAAA;gBACZ,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,YAAY,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;oBAC1C,IAAI,IAAI,GAAG,YAAY,CAAC,CAAC,CAAC,CAAA;oBAC1B,IAAI,IAAI,CAAC,QAAQ,KAAK,QAAQ,IAAI,IAAI,CAAC,EAAE,KAAK,EAAE,IAAI,IAAI,CAAC,IAAI,KAAK,IAAI,EAAE;wBACpE,GAAG,GAAG,CAAC,CAAA;wBACP,MAAK;qBACR;iBACJ;gBACD,IAAI,GAAG,KAAK,CAAC,CAAC,EAAE;oBACJ,IAAA,OAAO,GAAK,YAAY,CAAC,MAAM,CAAC,GAAG,EAAE,CAAC,CAAC,CAAC,CAAC,CAAC,QAAnC,CAAmC;oBAClD,IAAI,CAAC,mBAAmB,CAAC,IAAI,EAAE,OAAO,CAAC,CAAA;iBAC1C;aACJ;iBAAM;gBACH,aAAa;gBACb,IAAI,CAAC,mBAAmB,CAAC,IAAI,EAAE,EAAE,CAAC,CAAA;aACrC;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IASD,yBAAI,GAAJ,UAAK,GAAW,EAAE,GAAY;QAC1B,IAAI,GAAG,IAAI,IAAI,EAAE;YACb,OAAO;YACP,OAAO,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,GAAG,CAAC,IAAI,EAAE,CAAA;SAC/C;QAED,UAAU;QACV,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YAC3C,IAAI,CAAC,YAAY,CAAC,GAAG,EAAE,GAAG,CAAC,CAAA;QAC/B,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,+BAAU,GAAV,UAAW,GAAW;QAClB,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YACpC,IAAI,CAAC,eAAe,CAAC,GAAG,CAAC,CAAA;QAC7B,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,6BAAQ,GAAR,UAAS,SAAkB;QACvB,IAAI,CAAC,SAAS,EAAE;YACZ,OAAO,IAAI,CAAA;SACd;QAED,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YAC3C,IAAI,IAAI,CAAC,SAAS,EAAE;gBAChB,YAAY;gBACZ,IAAI,GAAG,GAAa,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,IAAI,CAAC,CAAA;gBAC9C,GAAG,GAAG,GAAG,CAAC,MAAM,CAAC,UAAA,IAAI;oBACjB,OAAO,CAAC,CAAC,IAAI,CAAC,IAAI,EAAE,CAAA;gBACxB,CAAC,CAAC,CAAA;gBACF,WAAW;gBACX,IAAI,GAAG,CAAC,OAAO,CAAC,SAAS,CAAC,GAAG,CAAC,EAAE;oBAC5B,GAAG,CAAC,IAAI,CAAC,SAAS,CAAC,CAAA;iBACtB;gBACD,gBAAgB;gBAChB,IAAI,CAAC,SAAS,GAAG,GAAG,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;aACjC;iBAAM;gBACH,aAAa;gBACb,IAAI,CAAC,SAAS,GAAG,SAAS,CAAA;aAC7B;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,gCAAW,GAAX,UAAY,SAAkB;QAC1B,IAAI,CAAC,SAAS,EAAE;YACZ,OAAO,IAAI,CAAA;SACd;QACD,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YAC3C,IAAI,CAAC,IAAI,CAAC,SAAS,EAAE;gBACjB,YAAY;gBACZ,OAAM;aACT;YAED,IAAI,GAAG,GAAa,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,IAAI,CAAC,CAAA;YAC9C,GAAG,GAAG,GAAG,CAAC,MAAM,CAAC,UAAA,IAAI;gBACjB,IAAI,GAAG,IAAI,CAAC,IAAI,EAAE,CAAA;gBAClB,WAAW;gBACX,IAAI,CAAC,IAAI,IAAI,IAAI,KAAK,SAAS,EAAE;oBAC7B,OAAO,KAAK,CAAA;iBACf;gBACD,OAAO,IAAI,CAAA;YACf,CAAC,CAAC,CAAA;YACF,gBAAgB;YAChB,IAAI,CAAC,SAAS,GAAG,GAAG,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;QAClC,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,6BAAQ,GAAR,UAAS,SAAkB;QACvB,IAAI,CAAC,SAAS,EAAE;YACZ,OAAO,KAAK,CAAA;SACf;QACD,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,IAAI,CAAC,IAAI,CAAC,SAAS,EAAE;YACjB,YAAY;YACZ,OAAO,KAAK,CAAA;SACf;QACD,IAAI,GAAG,GAAa,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,IAAI,CAAC,CAAA;QAC9C,OAAO,GAAG,CAAC,QAAQ,CAAC,SAAS,CAAC,CAAA,CAAC,OAAO;IAC1C,CAAC;IAED;;;;OAIG;IACH,2BAA2B;IAC3B,wBAAG,GAAH,UAAI,GAAW,EAAE,GAAqB;QAClC,IAAI,YAAoB,CAAA;QACxB,IAAI,GAAG,IAAI,EAAE,EAAE;YACX,YAAY,GAAG,EAAE,CAAA;SACpB;aAAM;YACH,YAAY,GAAM,GAAG,SAAI,GAAG,MAAG,CAAA;SAClC;QACD,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,IAAM,KAAK,GAAG,CAAC,IAAI,CAAC,YAAY,CAAC,OAAO,CAAC,IAAI,EAAE,CAAC,CAAC,IAAI,EAAE,CAAA;YACvD,IAAI,KAAK,EAAE;gBACP,+BAA+B;gBAC/B,IAAI,SAAS,GAAa,aAAa,CAAC,KAAK,CAAC,CAAA;gBAE9C,cAAc;gBACd,SAAS,GAAG,SAAS,CAAC,GAAG,CAAC,UAAA,IAAI;oBAC1B,IAAI,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,KAAK,CAAC,EAAE;wBACzB,OAAO,YAAY,CAAA;qBACtB;yBAAM;wBACH,OAAO,IAAI,CAAA;qBACd;gBACL,CAAC,CAAC,CAAA;gBACF,WAAW;gBACX,IAAI,YAAY,IAAI,EAAE,IAAI,SAAS,CAAC,OAAO,CAAC,YAAY,CAAC,GAAG,CAAC,EAAE;oBAC3D,SAAS,CAAC,IAAI,CAAC,YAAY,CAAC,CAAA;iBAC/B;gBAED,QAAQ;gBACR,IAAI,YAAY,IAAI,EAAE,EAAE;oBACpB,SAAS,GAAG,aAAa,CAAC,SAAS,CAAC,CAAA;iBACvC;gBAED,aAAa;gBACb,IAAI,CAAC,YAAY,CAAC,OAAO,EAAE,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAA;aACnD;iBAAM;gBACH,aAAa;gBACb,IAAI,CAAC,YAAY,CAAC,OAAO,EAAE,YAAY,CAAC,CAAA;aAC3C;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACH,0CAAqB,GAArB;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAC,qBAAqB,EAAE,CAAA;IACvC,CAAC;IAED;;OAEG;IACH,yBAAI,GAAJ;QACI,OAAO,IAAI,CAAC,GAAG,CAAC,SAAS,EAAE,OAAO,CAAC,CAAA;IACvC,CAAC;IAED;;OAEG;IACH,yBAAI,GAAJ;QACI,OAAO,IAAI,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,CAAA;IACtC,CAAC;IAED;;OAEG;IACH,6BAAQ,GAAR;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,IAAI,CAAC,IAAI,EAAE;YACP,OAAO,IAAI,CAAA;SACd;QAED,OAAO,CAAC,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IAC3B,CAAC;IAED;;OAEG;IACH,+BAAU,GAAV;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,IAAI,CAAC,IAAI,EAAE;YACP,OAAO,IAAI,CAAA;SACd;QAED,OAAO,CAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;IAC7B,CAAC;IAED;;;OAGG;IACH,oCAAe,GAAf,UAAgB,SAAqB;QACjC,IAAM,MAAM,GAAG,IAAI,CAAC,OAAO,EAAE,CAAA;QAC7B,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAC,aAAa,EAAE,EAAE;YACzB,MAAM,CAAC,UAAU,IAAI,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,UAAU,CAAC,CAAA;SAC3D;QACD,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;IAC1B,CAAC;IAED;;;OAGG;IACH,2BAAM,GAAN,UAAO,SAAqB;QACxB,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,SAAS,CAAC,OAAO,CAAC,UAAU,KAAkB;gBAC1C,IAAI,CAAC,WAAW,CAAC,KAAK,CAAC,CAAA;YAC3B,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACH,2BAAM,GAAN;QACI,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,IAAI,IAAI,CAAC,MAAM,EAAE;gBACb,IAAI,CAAC,MAAM,EAAE,CAAA;aAChB;iBAAM;gBACH,IAAM,QAAM,GAAG,IAAI,CAAC,aAAa,CAAA;gBACjC,QAAM,IAAI,QAAM,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;aACrC;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,8BAAS,GAAT,UAAU,MAAkB;QACxB,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,IAAM,KAAK,GAAG,MAAM,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC7B,OAAO,IAAI,CAAC,QAAQ,CAAC,KAAK,CAAC,CAAA;IAC/B,CAAC;IAED;;OAEG;IACH,gCAAW,GAAX;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,6CAA6C;QAC7C,OAAO,IAAI,CAAC,qBAAqB,EAAE,CAAA;IACvC,CAAC;IAED;;OAEG;IACH,gCAAW,GAAX;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAC,QAAQ,CAAA;IACxB,CAAC;IAED;;OAEG;IACH,4BAAO,GAAP;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACH,oCAAe,GAAf;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAC,YAAY,CAAA;IAC5B,CAAC;IAED;;OAEG;IACH,6BAA6B;IAC7B,iCAAiC;IACjC,8BAA8B;IAC9B,IAAI;IAEJ;;;OAGG;IACH,yBAAI,GAAJ,UAAK,QAAgB;QACjB,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,CAAC,CAAC,IAAI,CAAC,gBAAgB,CAAC,QAAQ,CAAC,CAAC,CAAA;IAC7C,CAAC;IAQD,yBAAI,GAAJ,UAAK,GAAY;QACb,IAAI,CAAC,GAAG,EAAE;YACN,UAAU;YACV,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;YAE1B,OAAO,IAAI,CAAC,SAAS,CAAC,OAAO,CAAC,UAAU,EAAE,cAAM,OAAA,EAAE,EAAF,CAAE,CAAC,CAAA;SACtD;aAAM;YACH,UAAU;YACV,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;gBAC3C,IAAI,CAAC,SAAS,GAAG,GAAG,CAAA;YACxB,CAAC,CAAC,CAAA;SACL;IACL,CAAC;IAQD,yBAAI,GAAJ,UAAK,GAAY;QACb,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,IAAI,CAAC,GAAG,EAAE;YACN,UAAU;YACV,OAAO,IAAI,CAAC,SAAS,CAAA;SACxB;aAAM;YACH,UAAU;YACV,IAAI,CAAC,SAAS,GAAG,GAAG,CAAA;YACpB,OAAO,IAAI,CAAA;SACd;IACL,CAAC;IAED;;OAEG;IACH,wBAAG,GAAH;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAQ,IAAY,CAAC,KAAK,CAAC,IAAI,EAAE,CAAA,CAAC,SAAS;IAC/C,CAAC;IAED;;OAEG;IACH,0BAAK,GAAL;QACI,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,IAAI,CAAC,KAAK,EAAE,CAAA;QAChB,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACH,yBAAI,GAAJ;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,CAAC,CAAC,IAAI,CAAC,sBAAsB,CAAC,CAAA;IACzC,CAAC;IAED;;OAEG;IACH,yBAAI,GAAJ;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,CAAC,CAAC,IAAI,CAAC,kBAAkB,CAAC,CAAA;IACrC,CAAC;IAED;;OAEG;IACH,2BAAM,GAAN;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1B,OAAO,CAAC,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;IAChC,CAAC;IAED;;;;OAIG;IACH,gCAAW,GAAX,UAAY,QAAgB,EAAE,OAAqB;QAC/C,IAAM,IAAI,GAAG,OAAO,IAAI,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QACrC,IAAI,IAAI,CAAC,QAAQ,KAAK,MAAM,EAAE;YAC1B,OAAO,IAAI,CAAA;SACd;QAED,IAAM,MAAM,GAAG,IAAI,CAAC,aAAa,CAAA;QACjC,IAAI,MAAM,KAAK,IAAI,EAAE;YACjB,OAAO,IAAI,CAAA;SACd;QAED,IAAI,MAAM,CAAC,OAAO,CAAC,QAAQ,CAAC,EAAE;YAC1B,SAAS;YACT,OAAO,CAAC,CAAC,MAAM,CAAC,CAAA;SACnB;QAED,UAAU;QACV,OAAO,IAAI,CAAC,WAAW,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAA;IAC7C,CAAC;IAED;;;OAGG;IACH,0BAAK,GAAL,UAAM,KAA+B;QACjC,IAAI,KAAK,YAAY,UAAU,EAAE;YAC7B,OAAO,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,KAAK,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;SAC1C;aAAM,IAAI,KAAK,YAAY,WAAW,EAAE;YACrC,OAAO,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,KAAK,KAAK,CAAA;SACjC;aAAM;YACH,OAAO,KAAK,CAAA;SACf;IACL,CAAC;IAED;;;OAGG;IACH,iCAAY,GAAZ,UAAa,QAA6B;QACtC,IAAM,cAAc,GAAG,CAAC,CAAC,QAAQ,CAAC,CAAA;QAClC,IAAM,aAAa,GAAG,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC7C,IAAI,CAAC,aAAa,EAAE;YAChB,OAAO,IAAI,CAAA;SACd;QACD,OAAO,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACpB,IAAM,MAAM,GAAG,aAAa,CAAC,UAAkB,CAAA;YAC/C,MAAM,CAAC,YAAY,CAAC,IAAI,EAAE,aAAa,CAAC,CAAA;QAC5C,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACH,gCAAW,GAAX,UAAY,QAA6B;QACrC,IAAM,cAAc,GAAG,CAAC,CAAC,QAAQ,CAAC,CAAA;QAClC,IAAM,aAAa,GAAG,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC7C,IAAM,UAAU,GAAG,aAAa,IAAI,aAAa,CAAC,WAAW,CAAA;QAC7D,IAAI,CAAC,aAAa,EAAE;YAChB,OAAO,IAAI,CAAA;SACd;QACD,OAAO,IAAI,CAAC,OAAO,CAAC,UAAU,IAAiB;YAC3C,IAAM,MAAM,GAAG,aAAa,CAAC,UAAkB,CAAA;YAC/C,IAAI,UAAU,EAAE;gBACZ,MAAM,CAAC,YAAY,CAAC,IAAI,EAAE,UAAU,CAAC,CAAA;aACxC;iBAAM;gBACH,MAAM,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;aAC3B;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;;OAIG;IACH,yBAAI,GAAJ,UAAQ,GAAW,EAAE,KAAS;QAC1B,IAAI,KAAK,IAAI,IAAI,EAAE;YACf,OAAO;YACP,IAAI,CAAC,UAAU,CAAC,GAAG,CAAC,GAAG,EAAE,KAAK,CAAC,CAAA;SAClC;aAAM;YACH,OAAO;YACP,OAAO,IAAI,CAAC,UAAU,CAAC,GAAG,CAAC,GAAG,CAAC,CAAA;SAClC;IACL,CAAC;IAED;;;OAGG;IACH,+BAAU,GAAV,UAAW,MAAc;QACrB,IAAI,IAAI,CAAC,MAAM,GAAG,CAAC,EAAE;YACjB,OAAO,IAAI,CAAA;SACd;QAED,IAAM,OAAO,GAAG,IAAI,CAAC,MAAM,EAAE,CAAA;QAC7B,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,OAAO,CAAC,EAAE;YACjC,OAAO,IAAI,CAAA;SACd;QAED,OAAO,OAAO,CAAC,UAAU,CAAC,MAAM,CAAC,CAAA;IACrC,CAAC;IAED;;;OAGG;IACH,kCAAa,GAAb;QACI,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC3B,OAAO;YACH,GAAG,EAAE,KAAK,CAAC,SAAS;YACpB,IAAI,EAAE,KAAK,CAAC,UAAU;YACtB,KAAK,EAAE,KAAK,CAAC,WAAW;YACxB,MAAM,EAAE,KAAK,CAAC,YAAY;YAC1B,MAAM,EAAE,KAAK,CAAC,YAAY;SAC7B,CAAA;IACL,CAAC;IAED;;;OAGG;IACH,8BAAS,GAAT,UAAU,GAAW;QACjB,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC3B,KAAK,CAAC,QAAQ,CAAC,EAAE,GAAG,KAAA,EAAE,CAAC,CAAA;IAC3B,CAAC;IACL,iBAAC;AAAD,CAAC,AAxsBD,IAwsBC;AAxsBY,gCAAU;AA0sBvB,WAAW;AACX,SAAS,CAAC;IAAC,aAAgD;SAAhD,UAAgD,EAAhD,qBAAgD,EAAhD,IAAgD;QAAhD,wBAAgD;;IACvD,YAAW,UAAU,YAAV,UAAU,2BAAI,GAAG,MAAC;AACjC,CAAC;AAED,kBAAe,CAAC,CAAA",
      sourcesContent: ["/**\n * @description \u5C01\u88C5 DOM \u64CD\u4F5C\n * @wangfupeng\n */\n\nimport Editor from '../editor/index'\nimport { toArray } from './util'\n\n// \u8BB0\u5F55\u5143\u7D20\u57FA\u4E8E\u4E0A\u4E00\u4E2A\u76F8\u5BF9&\u7EDD\u5BF9\u5B9A\u4F4D\u7684\u4F4D\u7F6E\u4FE1\u606F\ntype OffsetDataType = {\n    top: number\n    left: number\n    width: number\n    height: number\n    parent: Element | null\n}\n\n// \u8BB0\u5F55\u4EE3\u7406\u4E8B\u4EF6\u7ED1\u5B9A\ntype listener = (e: Event) => void\ntype EventItem = {\n    elem: HTMLElement\n    selector: string\n    fn: listener\n    agentFn: listener\n}\nconst AGENT_EVENTS: EventItem[] = []\n\n/**\n * \u6839\u636E html \u5B57\u7B26\u4E32\u521B\u5EFA elem\n * @param {String} html html\n */\nfunction _createElemByHTML(html: string): HTMLElement[] {\n    const div = document.createElement('div')\n    div.innerHTML = html\n    const elems = div.children\n    return toArray(elems)\n}\n\n/**\n * \u5224\u65AD\u662F\u5426\u662F DOM List\n * @param selector DOM \u5143\u7D20\u6216\u5217\u8868\n */\nfunction _isDOMList<T extends HTMLCollection | NodeList>(selector: unknown): selector is T {\n    if (!selector) {\n        return false\n    }\n    if (selector instanceof HTMLCollection || selector instanceof NodeList) {\n        return true\n    }\n    return false\n}\n\n/**\n * \u5C01\u88C5 querySelectorAll\n * @param selector css \u9009\u62E9\u5668\n */\nfunction _querySelectorAll(selector: string): HTMLElement[] {\n    const elems = document.querySelectorAll(selector)\n    return toArray(elems)\n}\n\n/**\n * \u5C01\u88C5 _styleArrTrim\n * @param styleArr css\n */\nfunction _styleArrTrim(style: string | string[]): string[] {\n    let styleArr: string[] = []\n    let resultArr: string[] = []\n\n    if (!Array.isArray(style)) {\n        // \u6709 style\uFF0C\u5C06 style \u6309\u7167 `;` \u62C6\u5206\u4E3A\u6570\u7EC4\n        styleArr = style.split(';')\n    } else {\n        styleArr = style\n    }\n\n    styleArr.forEach(item => {\n        // \u5BF9\u6BCF\u9879\u6837\u5F0F\uFF0C\u6309\u7167 : \u62C6\u5206\u4E3A key \u548C value\n        let arr = item.split(':').map(i => {\n            return i.trim()\n        })\n        if (arr.length === 2) {\n            resultArr.push(arr[0] + ':' + arr[1])\n        }\n    })\n    return resultArr\n}\n\nexport type DomElementSelector =\n    | string\n    | DomElement\n    | HTMLElement\n    | Element\n    | Document\n    | HTMLCollection\n    | Node\n    | NodeList\n    | HTMLElement[]\n    | EventTarget\n    | null\n    | undefined\n\n// \u6784\u9020\u51FD\u6570\nexport class DomElement<T extends DomElementSelector = DomElementSelector> {\n    // \u5B9A\u4E49\u5C5E\u6027\n    selector!: T\n    length: number\n    elems: HTMLElement[]\n    dataSource: Map<string, any>\n\n    /**\n     * \u6784\u9020\u51FD\u6570\n     * @param selector \u4EFB\u4E00\u7C7B\u578B\u7684\u9009\u62E9\u5668\n     */\n    constructor(selector: T) {\n        // \u521D\u59CB\u5316\u5C5E\u6027\n        this.elems = []\n        this.length = this.elems.length\n        this.dataSource = new Map()\n\n        if (!selector) {\n            return\n        }\n\n        // \u539F\u672C\u5C31\u662F DomElement \u5B9E\u4F8B\uFF0C\u5219\u76F4\u63A5\u8FD4\u56DE\n        if (selector instanceof DomElement) {\n            return selector\n        }\n\n        let selectorResult: HTMLElement[] = [] // \u5B58\u50A8\u67E5\u8BE2\u7ED3\u679C\n        const nodeType = selector instanceof Node ? selector.nodeType : -1\n        this.selector = selector\n\n        if (nodeType === 1 || nodeType === 9) {\n            selectorResult = [selector as HTMLElement]\n        } else if (_isDOMList(selector)) {\n            // DOM List\n            selectorResult = toArray(selector)\n        } else if (selector instanceof Array) {\n            // Element \u6570\u7EC4\uFF08\u5176\u4ED6\u6570\u636E\u7C7B\u578B\uFF0C\u6682\u65F6\u5FFD\u7565\uFF09\n            selectorResult = selector\n        } else if (typeof selector === 'string') {\n            // \u5B57\u7B26\u4E32\n            const tmpSelector = selector.replace('/\\n/mg', '').trim()\n            if (tmpSelector.indexOf('<') === 0) {\n                // \u5982 <div>\n                selectorResult = _createElemByHTML(tmpSelector)\n            } else {\n                // \u5982 #id .class\n                selectorResult = _querySelectorAll(tmpSelector)\n            }\n        }\n\n        const length = selectorResult.length\n        if (!length) {\n            // \u7A7A\u6570\u7EC4\n            return this\n        }\n\n        // \u52A0\u5165 DOM \u8282\u70B9\n        let i = 0\n        for (; i < length; i++) {\n            this.elems.push(selectorResult[i])\n        }\n        this.length = length\n    }\n\n    /**\n     * \u83B7\u53D6\u5143\u7D20 id\n     */\n    get id(): string {\n        return this.elems[0].id\n    }\n\n    /**\n     * \u904D\u5386\u6240\u6709\u5143\u7D20\uFF0C\u6267\u884C\u56DE\u8C03\u51FD\u6570\n     * @param fn \u56DE\u8C03\u51FD\u6570\n     */\n    forEach(fn: (ele: HTMLElement, index?: number) => boolean | unknown): DomElement {\n        for (let i = 0; i < this.length; i++) {\n            const elem = this.elems[i]\n            const result = fn.call(elem, elem, i)\n            if (result === false) {\n                break\n            }\n        }\n        return this\n    }\n\n    /**\n     * \u514B\u9686\u5143\u7D20\n     * @param deep \u662F\u5426\u6DF1\u5EA6\u514B\u9686\n     */\n    clone(deep: boolean = false): DomElement {\n        const cloneList: HTMLElement[] = []\n        this.elems.forEach(elem => {\n            cloneList.push(elem.cloneNode(!!deep) as HTMLElement)\n        })\n        return $(cloneList)\n    }\n\n    /**\n     * \u83B7\u53D6\u7B2C\u51E0\u4E2A\u5143\u7D20\n     * @param index index\n     */\n    get(index: number = 0): DomElement {\n        const length = this.length\n        if (index >= length) {\n            index = index % length\n        }\n        return $(this.elems[index])\n    }\n\n    /**\n     * \u83B7\u53D6\u7B2C\u4E00\u4E2A\u5143\u7D20\n     */\n    first(): DomElement {\n        return this.get(0)\n    }\n\n    /**\n     * \u83B7\u53D6\u6700\u540E\u4E00\u4E2A\u5143\u7D20\n     */\n    last(): DomElement {\n        const length = this.length\n        return this.get(length - 1)\n    }\n\n    /**\n     * \u7ED1\u5B9A\u4E8B\u4EF6\n     * @param type \u4E8B\u4EF6\u7C7B\u578B\n     * @param selector DOM \u9009\u62E9\u5668\n     * @param fn \u4E8B\u4EF6\u51FD\u6570\n     */\n    on(type: string, fn: Function): DomElement\n    on(type: string, selector: string, fn: Function): DomElement\n    on(type: string, selector: string | Function, fn?: Function): DomElement {\n        if (!type) return this\n\n        // \u6CA1\u6709 selector \uFF0C\u53EA\u6709 type \u548C fn\n        if (typeof selector === 'function') {\n            fn = selector\n            selector = ''\n        }\n\n        return this.forEach(elem => {\n            // \u6CA1\u6709\u4E8B\u4EF6\u4EE3\u7406\n            if (!selector) {\n                // \u65E0\u4EE3\u7406\n                elem.addEventListener(type, fn as listener)\n                return\n            }\n\n            // \u6709\u4E8B\u4EF6\u4EE3\u7406\n            const agentFn: listener = function (e) {\n                const target = e.target as HTMLElement\n                if (target.matches(selector as string)) {\n                    ;(fn as listener).call(target, e)\n                }\n            }\n            elem.addEventListener(type, agentFn)\n\n            // \u7F13\u5B58\u4EE3\u7406\u4E8B\u4EF6\n            AGENT_EVENTS.push({\n                elem: elem,\n                selector: selector as string,\n                fn: fn as listener,\n                agentFn,\n            })\n        })\n    }\n\n    /**\n     * \u89E3\u7ED1\u4E8B\u4EF6\n     * @param type \u4E8B\u4EF6\u7C7B\u578B\n     * @param selector DOM \u9009\u62E9\u5668\n     * @param fn \u4E8B\u4EF6\u51FD\u6570\n     */\n    off(type: string, fn: Function): DomElement\n    off(type: string, selector: string, fn: Function): DomElement\n    off(type: string, selector: string | Function, fn?: Function): DomElement {\n        if (!type) return this\n\n        // \u6CA1\u6709 selector \uFF0C\u53EA\u6709 type \u548C fn\n        if (typeof selector === 'function') {\n            fn = selector\n            selector = ''\n        }\n\n        return this.forEach(function (elem: HTMLElement) {\n            // \u89E3\u7ED1\u4E8B\u4EF6\u4EE3\u7406\n            if (selector) {\n                let idx = -1\n                for (let i = 0; i < AGENT_EVENTS.length; i++) {\n                    let item = AGENT_EVENTS[i]\n                    if (item.selector === selector && item.fn === fn && item.elem === elem) {\n                        idx = i\n                        break\n                    }\n                }\n                if (idx !== -1) {\n                    const { agentFn } = AGENT_EVENTS.splice(idx, 1)[0]\n                    elem.removeEventListener(type, agentFn)\n                }\n            } else {\n                // @ts-ignore\n                elem.removeEventListener(type, fn)\n            }\n        })\n    }\n\n    /**\n     * \u8BBE\u7F6E/\u83B7\u53D6 \u5C5E\u6027\n     * @param key key\n     * @param val value\n     */\n    attr(key: string): string\n    attr(key: string, val: string): DomElement\n    attr(key: string, val?: string): DomElement | string {\n        if (val == null) {\n            // \u83B7\u53D6\u6570\u636E\n            return this.elems[0].getAttribute(key) || ''\n        }\n\n        // \u5426\u5219\uFF0C\u8BBE\u7F6E\u5C5E\u6027\n        return this.forEach(function (elem: HTMLElement) {\n            elem.setAttribute(key, val)\n        })\n    }\n\n    /**\n     * \u5220\u9664 \u5C5E\u6027\n     * @param key key\n     */\n    removeAttr(key: string): void {\n        this.forEach(function (elem: HTMLElement) {\n            elem.removeAttribute(key)\n        })\n    }\n\n    /**\n     * \u6DFB\u52A0 css class\n     * @param className css class\n     */\n    addClass(className?: string): DomElement {\n        if (!className) {\n            return this\n        }\n\n        return this.forEach(function (elem: HTMLElement) {\n            if (elem.className) {\n                // \u5F53\u524D\u6709 class\n                let arr: string[] = elem.className.split(/\\s/)\n                arr = arr.filter(item => {\n                    return !!item.trim()\n                })\n                // \u6DFB\u52A0 class\n                if (arr.indexOf(className) < 0) {\n                    arr.push(className)\n                }\n                // \u4FEE\u6539 elem.class\n                elem.className = arr.join(' ')\n            } else {\n                // \u5F53\u524D\u6CA1\u6709 class\n                elem.className = className\n            }\n        })\n    }\n\n    /**\n     * \u6DFB\u52A0 css class\n     * @param className css class\n     */\n    removeClass(className?: string): DomElement {\n        if (!className) {\n            return this\n        }\n        return this.forEach(function (elem: HTMLElement) {\n            if (!elem.className) {\n                // \u5F53\u524D\u65E0 class\n                return\n            }\n\n            let arr: string[] = elem.className.split(/\\s/)\n            arr = arr.filter(item => {\n                item = item.trim()\n                // \u5220\u9664 class\n                if (!item || item === className) {\n                    return false\n                }\n                return true\n            })\n            // \u4FEE\u6539 elem.class\n            elem.className = arr.join(' ')\n        })\n    }\n\n    /**\n     * \u662F\u5426\u6709\u4F20\u5165\u7684 css class\n     * @param className css class\n     */\n    hasClass(className?: string): boolean {\n        if (!className) {\n            return false\n        }\n        const elem = this.elems[0]\n        if (!elem.className) {\n            // \u5F53\u524D\u65E0 class\n            return false\n        }\n        let arr: string[] = elem.className.split(/\\s/)\n        return arr.includes(className) // \u662F\u5426\u5305\u542B\n    }\n\n    /**\n     * \u4FEE\u6539 css\n     * @param key css key\n     * @param val css value\n     */\n    // css(key: string): string\n    css(key: string, val?: string | number): DomElement {\n        let currentStyle: string\n        if (val == '') {\n            currentStyle = ''\n        } else {\n            currentStyle = `${key}:${val};`\n        }\n        return this.forEach(elem => {\n            const style = (elem.getAttribute('style') || '').trim()\n            if (style) {\n                // \u6709 style\uFF0C\u5C06 style \u6309\u7167 `;` \u62C6\u5206\u4E3A\u6570\u7EC4\n                let resultArr: string[] = _styleArrTrim(style)\n\n                // \u66FF\u6362\u73B0\u6709\u7684 style\n                resultArr = resultArr.map(item => {\n                    if (item.indexOf(key) === 0) {\n                        return currentStyle\n                    } else {\n                        return item\n                    }\n                })\n                // \u65B0\u589E style\n                if (currentStyle != '' && resultArr.indexOf(currentStyle) < 0) {\n                    resultArr.push(currentStyle)\n                }\n\n                // \u53BB\u6389 \u7A7A\u767D\n                if (currentStyle == '') {\n                    resultArr = _styleArrTrim(resultArr)\n                }\n\n                // \u91CD\u65B0\u8BBE\u7F6E style\n                elem.setAttribute('style', resultArr.join('; '))\n            } else {\n                // \u5F53\u524D\u6CA1\u6709 style\n                elem.setAttribute('style', currentStyle)\n            }\n        })\n    }\n\n    /**\n     * \u5C01\u88C5 getBoundingClientRect\n     */\n    getBoundingClientRect(): DOMRect {\n        const elem = this.elems[0]\n        return elem.getBoundingClientRect()\n    }\n\n    /**\n     * \u663E\u793A\n     */\n    show(): DomElement {\n        return this.css('display', 'block')\n    }\n\n    /**\n     * \u9690\u85CF\n     */\n    hide(): DomElement {\n        return this.css('display', 'none')\n    }\n\n    /**\n     * \u83B7\u53D6\u5B50\u8282\u70B9\uFF08\u53EA\u6709 DOM \u5143\u7D20\uFF09\n     */\n    children(): DomElement | null {\n        const elem = this.elems[0]\n        if (!elem) {\n            return null\n        }\n\n        return $(elem.children)\n    }\n\n    /**\n     * \u83B7\u53D6\u5B50\u8282\u70B9\uFF08\u5305\u62EC\u6587\u672C\u8282\u70B9\uFF09\n     */\n    childNodes(): DomElement | null {\n        const elem = this.elems[0]\n        if (!elem) {\n            return null\n        }\n\n        return $(elem.childNodes)\n    }\n\n    /**\n     * \u5C06\u5B50\u5143\u7D20\u5168\u90E8\u66FF\u6362\n     * @param $children \u65B0\u7684child\u8282\u70B9\n     */\n    replaceChildAll($children: DomElement): void {\n        const parent = this.getNode()\n        const elem = this.elems[0]\n        while (elem.hasChildNodes()) {\n            parent.firstChild && elem.removeChild(parent.firstChild)\n        }\n        this.append($children)\n    }\n\n    /**\n     * \u589E\u52A0\u5B50\u8282\u70B9\n     * @param $children \u5B50\u8282\u70B9\n     */\n    append($children: DomElement): DomElement {\n        return this.forEach(elem => {\n            $children.forEach(function (child: HTMLElement) {\n                elem.appendChild(child)\n            })\n        })\n    }\n\n    /**\n     * \u79FB\u9664\u5F53\u524D\u8282\u70B9\n     */\n    remove(): DomElement {\n        return this.forEach(elem => {\n            if (elem.remove) {\n                elem.remove()\n            } else {\n                const parent = elem.parentElement\n                parent && parent.removeChild(elem)\n            }\n        })\n    }\n\n    /**\n     * \u5F53\u524D\u5143\u7D20\uFF0C\u662F\u5426\u5305\u542B\u67D0\u4E2A\u5B50\u5143\u7D20\n     * @param $child \u5B50\u5143\u7D20\n     */\n    isContain($child: DomElement): boolean {\n        const elem = this.elems[0]\n        const child = $child.elems[0]\n        return elem.contains(child)\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5143\u7D20\u7684\u5C3A\u5BF8\u548C\u4F4D\u7F6E\u4FE1\u606F\n     */\n    getSizeData(): DOMRect {\n        const elem = this.elems[0]\n        // \u53EF\u5F97\u5230 bottom height left right top width \u7684\u6570\u636E\n        return elem.getBoundingClientRect()\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5143\u7D20 nodeName\n     */\n    getNodeName(): string {\n        const elem = this.elems[0]\n        return elem.nodeName\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5143\u7D20\u8282\u70B9\n     */\n    getNode(): Node {\n        const elem = this.elems[0]\n        return elem\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5143\u7D20\u53EF\u89C6\u9AD8\u5EA6\n     */\n    getClientHeight(): number {\n        const elem = this.elems[0]\n        return elem.clientHeight\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5143\u7D20\u53EF\u89C6\u5BBD\u5EA6\n     */\n    // getClientWidth(): number {\n    //     const elem = this.elems[0]\n    //     return elem.clientWidth\n    // }\n\n    /**\n     * \u67E5\u8BE2\n     * @param selector css \u9009\u62E9\u5668\n     */\n    find(selector: string): DomElement {\n        const elem = this.elems[0]\n        return $(elem.querySelectorAll(selector))\n    }\n\n    /**\n     * \u83B7\u53D6/\u8BBE\u7F6E \u5143\u7D20 text\n     * @param val text \u503C\n     */\n    text(): string\n    text(val: string): DomElement\n    text(val?: string): DomElement | string {\n        if (!val) {\n            // \u83B7\u53D6 text\n            const elem = this.elems[0]\n\n            return elem.innerHTML.replace(/<[^>]+>/g, () => '')\n        } else {\n            // \u8BBE\u7F6E text\n            return this.forEach(function (elem: HTMLElement) {\n                elem.innerHTML = val\n            })\n        }\n    }\n\n    /**\n     * \u8BBE\u7F6E/\u83B7\u53D6 \u5143\u7D20 html\n     * @param val html \u503C\n     */\n    html(): string\n    html(val: string): DomElement\n    html(val?: string): DomElement | string {\n        const elem = this.elems[0]\n        if (!val) {\n            // \u83B7\u53D6 html\n            return elem.innerHTML\n        } else {\n            // \u8BBE\u7F6E html\n            elem.innerHTML = val\n            return this\n        }\n    }\n\n    /**\n     * \u83B7\u53D6\u5143\u7D20 value\n     */\n    val(): string {\n        const elem = this.elems[0]\n        return (elem as any).value.trim() // \u6682\u7528 any\n    }\n\n    /**\n     * focus \u5230\u5F53\u524D\u5143\u7D20\n     */\n    focus(): DomElement {\n        return this.forEach(elem => {\n            elem.focus()\n        })\n    }\n\n    /**\n     * \u5F53\u524D\u5143\u7D20\u524D\u4E00\u4E2A\u5144\u5F1F\u8282\u70B9\n     */\n    prev(): DomElement {\n        const elem = this.elems[0]\n        return $(elem.previousElementSibling)\n    }\n\n    /**\n     * \u5F53\u524D\u5143\u7D20\u540E\u4E00\u4E2A\u5144\u5F1F\u8282\u70B9\n     */\n    next(): DomElement {\n        const elem = this.elems[0]\n        return $(elem.nextElementSibling)\n    }\n\n    /**\n     * \u83B7\u53D6\u7236\u5143\u7D20\n     */\n    parent(): DomElement {\n        const elem = this.elems[0]\n        return $(elem.parentElement)\n    }\n\n    /**\n     * \u67E5\u627E\u7236\u5143\u7D20\uFF0C\u77E5\u9053\u6EE1\u8DB3 selector \u6761\u4EF6\n     * @param selector css \u9009\u62E9\u5668\n     * @param curElem \u4ECE\u54EA\u4E2A\u5143\u7D20\u5F00\u59CB\u67E5\u627E\uFF0C\u9ED8\u8BA4\u4E3A\u5F53\u524D\u5143\u7D20\n     */\n    parentUntil(selector: string, curElem?: HTMLElement): DomElement | null {\n        const elem = curElem || this.elems[0]\n        if (elem.nodeName === 'BODY') {\n            return null\n        }\n\n        const parent = elem.parentElement\n        if (parent === null) {\n            return null\n        }\n\n        if (parent.matches(selector)) {\n            // \u627E\u5230\uFF0C\u5E76\u8FD4\u56DE\n            return $(parent)\n        }\n\n        // \u7EE7\u7EED\u67E5\u627E\uFF0C\u9012\u5F52\n        return this.parentUntil(selector, parent)\n    }\n\n    /**\n     * \u5224\u8BFB\u662F\u5426\u76F8\u7B49\n     * @param $elem \u5143\u7D20\n     */\n    equal($elem: DomElement | HTMLElement): boolean {\n        if ($elem instanceof DomElement) {\n            return this.elems[0] === $elem.elems[0]\n        } else if ($elem instanceof HTMLElement) {\n            return this.elems[0] === $elem\n        } else {\n            return false\n        }\n    }\n\n    /**\n     * \u5C06\u8BE5\u5143\u7D20\u63D2\u5165\u5230\u67D0\u4E2A\u5143\u7D20\u524D\u9762\n     * @param selector css \u9009\u62E9\u5668\n     */\n    insertBefore(selector: string | DomElement): DomElement {\n        const $referenceNode = $(selector)\n        const referenceNode = $referenceNode.elems[0]\n        if (!referenceNode) {\n            return this\n        }\n        return this.forEach(elem => {\n            const parent = referenceNode.parentNode as Node\n            parent.insertBefore(elem, referenceNode)\n        })\n    }\n\n    /**\n     * \u5C06\u8BE5\u5143\u7D20\u63D2\u5165\u5230\u67D0\u4E2A\u5143\u7D20\u540E\u9762\n     * @param selector css \u9009\u62E9\u5668\n     */\n    insertAfter(selector: string | DomElement): DomElement {\n        const $referenceNode = $(selector)\n        const referenceNode = $referenceNode.elems[0]\n        const anchorNode = referenceNode && referenceNode.nextSibling\n        if (!referenceNode) {\n            return this\n        }\n        return this.forEach(function (elem: HTMLElement) {\n            const parent = referenceNode.parentNode as Node\n            if (anchorNode) {\n                parent.insertBefore(elem, anchorNode)\n            } else {\n                parent.appendChild(elem)\n            }\n        })\n    }\n\n    /**\n     * \u8BBE\u7F6E/\u83B7\u53D6 \u6570\u636E\n     * @param key key\n     * @param value value\n     */\n    data<T>(key: string, value?: T): T | undefined {\n        if (value != null) {\n            // \u8BBE\u7F6E\u6570\u636E\n            this.dataSource.set(key, value)\n        } else {\n            // \u83B7\u53D6\u6570\u636E\n            return this.dataSource.get(key)\n        }\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u8282\u70B9\u7684\u9876\u7EA7(\u6BB5\u843D)\n     * @param editor \u5BCC\u6587\u672C\u5B9E\u4F8B\n     */\n    getNodeTop(editor: Editor): DomElement {\n        if (this.length < 1) {\n            return this\n        }\n\n        const $parent = this.parent()\n        if (editor.$textElem.equal($parent)) {\n            return this\n        }\n\n        return $parent.getNodeTop(editor)\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D \u8282\u70B9 \u57FA\u4E0E\u4E0A\u4E00\u4E2A\u62E5\u6709\u76F8\u5BF9\u6216\u8005\u89E3\u51B3\u5B9A\u4F4D\u7684\u7236\u5BB9\u5668\u7684\u4F4D\u7F6E\n     * @param editor \u5BCC\u6587\u672C\u5B9E\u4F8B\n     */\n    getOffsetData(): OffsetDataType {\n        const $node = this.elems[0]\n        return {\n            top: $node.offsetTop,\n            left: $node.offsetLeft,\n            width: $node.offsetWidth,\n            height: $node.offsetHeight,\n            parent: $node.offsetParent,\n        }\n    }\n\n    /**\n     * \u4ECE\u4E0A\u81F3\u4E0B\u8FDB\u884C\u6EDA\u52A8\n     * @param top \u6EDA\u52A8\u7684\u503C\n     */\n    scrollTop(top: number): void {\n        const $node = this.elems[0]\n        $node.scrollTo({ top })\n    }\n}\n\n// new \u4E00\u4E2A\u5BF9\u8C61\nfunction $(...arg: ConstructorParameters<typeof DomElement>): DomElement {\n    return new DomElement(...arg)\n}\n\nexport default $\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aacd11e22e4f7ac14df85bfe165adbfb4e6a794f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_igv09dk30 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_igv09dk30();

var __spreadArrays = (cov_igv09dk30().s[0]++, (cov_igv09dk30().b[0][0]++, void 0) && (cov_igv09dk30().b[0][1]++, (void 0).__spreadArrays) || (cov_igv09dk30().b[0][2]++, function () {
  cov_igv09dk30().f[0]++;
  cov_igv09dk30().s[1]++;

  for (var s = (cov_igv09dk30().s[2]++, 0), i = (cov_igv09dk30().s[3]++, 0), il = (cov_igv09dk30().s[4]++, arguments.length); i < il; i++) {
    cov_igv09dk30().s[5]++;
    s += arguments[i].length;
  }

  cov_igv09dk30().s[6]++;

  for (var r = (cov_igv09dk30().s[7]++, Array(s)), k = (cov_igv09dk30().s[8]++, 0), i = (cov_igv09dk30().s[9]++, 0); i < il; i++) {
    cov_igv09dk30().s[10]++;

    for (var a = (cov_igv09dk30().s[11]++, arguments[i]), j = (cov_igv09dk30().s[12]++, 0), jl = (cov_igv09dk30().s[13]++, a.length); j < jl; j++, k++) {
      cov_igv09dk30().s[14]++;
      r[k] = a[j];
    }
  }

  cov_igv09dk30().s[15]++;
  return r;
}));

cov_igv09dk30().s[16]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_igv09dk30().s[17]++;
exports.DomElement = void 0;
var util_1 = (cov_igv09dk30().s[18]++, __webpack_require__(7));
var AGENT_EVENTS = (cov_igv09dk30().s[19]++, []);
/**
 * 根据 html 字符串创建 elem
 * @param {String} html html
 */

function _createElemByHTML(html) {
  cov_igv09dk30().f[1]++;
  var div = (cov_igv09dk30().s[20]++, document.createElement('div'));
  cov_igv09dk30().s[21]++;
  div.innerHTML = html;
  var elems = (cov_igv09dk30().s[22]++, div.children);
  cov_igv09dk30().s[23]++;
  return util_1.toArray(elems);
}
/**
 * 判断是否是 DOM List
 * @param selector DOM 元素或列表
 */


function _isDOMList(selector) {
  cov_igv09dk30().f[2]++;
  cov_igv09dk30().s[24]++;

  if (!selector) {
    cov_igv09dk30().b[1][0]++;
    cov_igv09dk30().s[25]++;
    return false;
  } else {
    cov_igv09dk30().b[1][1]++;
  }

  cov_igv09dk30().s[26]++;

  if ((cov_igv09dk30().b[3][0]++, selector instanceof HTMLCollection) || (cov_igv09dk30().b[3][1]++, selector instanceof NodeList)) {
    cov_igv09dk30().b[2][0]++;
    cov_igv09dk30().s[27]++;
    return true;
  } else {
    cov_igv09dk30().b[2][1]++;
  }

  cov_igv09dk30().s[28]++;
  return false;
}
/**
 * 封装 querySelectorAll
 * @param selector css 选择器
 */


function _querySelectorAll(selector) {
  cov_igv09dk30().f[3]++;
  var elems = (cov_igv09dk30().s[29]++, document.querySelectorAll(selector));
  cov_igv09dk30().s[30]++;
  return util_1.toArray(elems);
}
/**
 * 封装 _styleArrTrim
 * @param styleArr css
 */


function _styleArrTrim(style) {
  cov_igv09dk30().f[4]++;
  var styleArr = (cov_igv09dk30().s[31]++, []);
  var resultArr = (cov_igv09dk30().s[32]++, []);
  cov_igv09dk30().s[33]++;

  if (!(0, _isArray["default"])(style)) {
    cov_igv09dk30().b[4][0]++;
    cov_igv09dk30().s[34]++;
    // 有 style，将 style 按照 `;` 拆分为数组
    styleArr = style.split(';');
  } else {
    cov_igv09dk30().b[4][1]++;
    cov_igv09dk30().s[35]++;
    styleArr = style;
  }

  cov_igv09dk30().s[36]++;
  (0, _forEach["default"])(styleArr).call(styleArr, function (item) {
    var _context;

    cov_igv09dk30().f[5]++;
    // 对每项样式，按照 : 拆分为 key 和 value
    var arr = (cov_igv09dk30().s[37]++, (0, _map2["default"])(_context = item.split(':')).call(_context, function (i) {
      cov_igv09dk30().f[6]++;
      cov_igv09dk30().s[38]++;
      return (0, _trim["default"])(i).call(i);
    }));
    cov_igv09dk30().s[39]++;

    if (arr.length === 2) {
      cov_igv09dk30().b[5][0]++;
      cov_igv09dk30().s[40]++;
      resultArr.push(arr[0] + ':' + arr[1]);
    } else {
      cov_igv09dk30().b[5][1]++;
    }
  });
  cov_igv09dk30().s[41]++;
  return resultArr;
} // 构造函数


var DomElement = (
/** @class */
cov_igv09dk30().s[42]++, function () {
  cov_igv09dk30().f[7]++;

  /**
   * 构造函数
   * @param selector 任一类型的选择器
   */
  function DomElement(selector) {
    cov_igv09dk30().f[8]++;
    cov_igv09dk30().s[43]++;
    // 初始化属性
    this.elems = [];
    cov_igv09dk30().s[44]++;
    this.length = this.elems.length;
    cov_igv09dk30().s[45]++;
    this.dataSource = new _map["default"]();
    cov_igv09dk30().s[46]++;

    if (!selector) {
      cov_igv09dk30().b[6][0]++;
      cov_igv09dk30().s[47]++;
      return;
    } else {
      cov_igv09dk30().b[6][1]++;
    } // 原本就是 DomElement 实例，则直接返回


    cov_igv09dk30().s[48]++;

    if (selector instanceof DomElement) {
      cov_igv09dk30().b[7][0]++;
      cov_igv09dk30().s[49]++;
      return selector;
    } else {
      cov_igv09dk30().b[7][1]++;
    }

    var selectorResult = (cov_igv09dk30().s[50]++, []); // 存储查询结果

    var nodeType = (cov_igv09dk30().s[51]++, selector instanceof Node ? (cov_igv09dk30().b[8][0]++, selector.nodeType) : (cov_igv09dk30().b[8][1]++, -1));
    cov_igv09dk30().s[52]++;
    this.selector = selector;
    cov_igv09dk30().s[53]++;

    if ((cov_igv09dk30().b[10][0]++, nodeType === 1) || (cov_igv09dk30().b[10][1]++, nodeType === 9)) {
      cov_igv09dk30().b[9][0]++;
      cov_igv09dk30().s[54]++;
      selectorResult = [selector];
    } else {
      cov_igv09dk30().b[9][1]++;
      cov_igv09dk30().s[55]++;

      if (_isDOMList(selector)) {
        cov_igv09dk30().b[11][0]++;
        cov_igv09dk30().s[56]++;
        // DOM List
        selectorResult = util_1.toArray(selector);
      } else {
        cov_igv09dk30().b[11][1]++;
        cov_igv09dk30().s[57]++;

        if (selector instanceof Array) {
          cov_igv09dk30().b[12][0]++;
          cov_igv09dk30().s[58]++;
          // Element 数组（其他数据类型，暂时忽略）
          selectorResult = selector;
        } else {
          cov_igv09dk30().b[12][1]++;
          cov_igv09dk30().s[59]++;

          if (typeof selector === 'string') {
            var _context2;

            cov_igv09dk30().b[13][0]++;
            // 字符串
            var tmpSelector = (cov_igv09dk30().s[60]++, (0, _trim["default"])(_context2 = selector.replace('/\n/mg', '')).call(_context2));
            cov_igv09dk30().s[61]++;

            if ((0, _indexOf["default"])(tmpSelector).call(tmpSelector, '<') === 0) {
              cov_igv09dk30().b[14][0]++;
              cov_igv09dk30().s[62]++;
              // 如 <div>
              selectorResult = _createElemByHTML(tmpSelector);
            } else {
              cov_igv09dk30().b[14][1]++;
              cov_igv09dk30().s[63]++;
              // 如 #id .class
              selectorResult = _querySelectorAll(tmpSelector);
            }
          } else {
            cov_igv09dk30().b[13][1]++;
          }
        }
      }
    }

    var length = (cov_igv09dk30().s[64]++, selectorResult.length);
    cov_igv09dk30().s[65]++;

    if (!length) {
      cov_igv09dk30().b[15][0]++;
      cov_igv09dk30().s[66]++;
      // 空数组
      return this;
    } else {
      cov_igv09dk30().b[15][1]++;
    } // 加入 DOM 节点


    var i = (cov_igv09dk30().s[67]++, 0);
    cov_igv09dk30().s[68]++;

    for (; i < length; i++) {
      cov_igv09dk30().s[69]++;
      this.elems.push(selectorResult[i]);
    }

    cov_igv09dk30().s[70]++;
    this.length = length;
  }

  cov_igv09dk30().s[71]++;
  (0, _defineProperty["default"])(DomElement.prototype, "id", {
    /**
     * 获取元素 id
     */
    get: function get() {
      cov_igv09dk30().f[9]++;
      cov_igv09dk30().s[72]++;
      return this.elems[0].id;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 遍历所有元素，执行回调函数
   * @param fn 回调函数
   */

  cov_igv09dk30().s[73]++;

  DomElement.prototype.forEach = function (fn) {
    cov_igv09dk30().f[10]++;
    cov_igv09dk30().s[74]++;

    for (var i = (cov_igv09dk30().s[75]++, 0); i < this.length; i++) {
      var elem = (cov_igv09dk30().s[76]++, this.elems[i]);
      var result = (cov_igv09dk30().s[77]++, fn.call(elem, elem, i));
      cov_igv09dk30().s[78]++;

      if (result === false) {
        cov_igv09dk30().b[16][0]++;
        cov_igv09dk30().s[79]++;
        break;
      } else {
        cov_igv09dk30().b[16][1]++;
      }
    }

    cov_igv09dk30().s[80]++;
    return this;
  };
  /**
   * 克隆元素
   * @param deep 是否深度克隆
   */


  cov_igv09dk30().s[81]++;

  DomElement.prototype.clone = function (deep) {
    var _context3;

    cov_igv09dk30().f[11]++;
    cov_igv09dk30().s[82]++;

    if (deep === void 0) {
      cov_igv09dk30().b[17][0]++;
      cov_igv09dk30().s[83]++;
      deep = false;
    } else {
      cov_igv09dk30().b[17][1]++;
    }

    var cloneList = (cov_igv09dk30().s[84]++, []);
    cov_igv09dk30().s[85]++;
    (0, _forEach["default"])(_context3 = this.elems).call(_context3, function (elem) {
      cov_igv09dk30().f[12]++;
      cov_igv09dk30().s[86]++;
      cloneList.push(elem.cloneNode(!!deep));
    });
    cov_igv09dk30().s[87]++;
    return $(cloneList);
  };
  /**
   * 获取第几个元素
   * @param index index
   */


  cov_igv09dk30().s[88]++;

  DomElement.prototype.get = function (index) {
    cov_igv09dk30().f[13]++;
    cov_igv09dk30().s[89]++;

    if (index === void 0) {
      cov_igv09dk30().b[18][0]++;
      cov_igv09dk30().s[90]++;
      index = 0;
    } else {
      cov_igv09dk30().b[18][1]++;
    }

    var length = (cov_igv09dk30().s[91]++, this.length);
    cov_igv09dk30().s[92]++;

    if (index >= length) {
      cov_igv09dk30().b[19][0]++;
      cov_igv09dk30().s[93]++;
      index = index % length;
    } else {
      cov_igv09dk30().b[19][1]++;
    }

    cov_igv09dk30().s[94]++;
    return $(this.elems[index]);
  };
  /**
   * 获取第一个元素
   */


  cov_igv09dk30().s[95]++;

  DomElement.prototype.first = function () {
    cov_igv09dk30().f[14]++;
    cov_igv09dk30().s[96]++;
    return this.get(0);
  };
  /**
   * 获取最后一个元素
   */


  cov_igv09dk30().s[97]++;

  DomElement.prototype.last = function () {
    cov_igv09dk30().f[15]++;
    var length = (cov_igv09dk30().s[98]++, this.length);
    cov_igv09dk30().s[99]++;
    return this.get(length - 1);
  };

  cov_igv09dk30().s[100]++;

  DomElement.prototype.on = function (type, selector, fn) {
    var _context4;

    cov_igv09dk30().f[16]++;
    cov_igv09dk30().s[101]++;

    if (!type) {
      cov_igv09dk30().b[20][0]++;
      cov_igv09dk30().s[102]++;
      return this;
    } else {
      cov_igv09dk30().b[20][1]++;
    } // 没有 selector ，只有 type 和 fn


    cov_igv09dk30().s[103]++;

    if (typeof selector === 'function') {
      cov_igv09dk30().b[21][0]++;
      cov_igv09dk30().s[104]++;
      fn = selector;
      cov_igv09dk30().s[105]++;
      selector = '';
    } else {
      cov_igv09dk30().b[21][1]++;
    }

    cov_igv09dk30().s[106]++;
    return (0, _forEach["default"])(_context4 = this).call(_context4, function (elem) {
      cov_igv09dk30().f[17]++;
      cov_igv09dk30().s[107]++;

      // 没有事件代理
      if (!selector) {
        cov_igv09dk30().b[22][0]++;
        cov_igv09dk30().s[108]++;
        // 无代理
        elem.addEventListener(type, fn);
        cov_igv09dk30().s[109]++;
        return;
      } else {
        cov_igv09dk30().b[22][1]++;
      } // 有事件代理


      cov_igv09dk30().s[110]++;

      var agentFn = function agentFn(e) {
        cov_igv09dk30().f[18]++;
        var target = (cov_igv09dk30().s[111]++, e.target);
        cov_igv09dk30().s[112]++;

        if (target.matches(selector)) {
          cov_igv09dk30().b[23][0]++;
          ;
          cov_igv09dk30().s[113]++;
          fn.call(target, e);
        } else {
          cov_igv09dk30().b[23][1]++;
        }
      };

      cov_igv09dk30().s[114]++;
      elem.addEventListener(type, agentFn); // 缓存代理事件

      cov_igv09dk30().s[115]++;
      AGENT_EVENTS.push({
        elem: elem,
        selector: selector,
        fn: fn,
        agentFn: agentFn
      });
    });
  };

  cov_igv09dk30().s[116]++;

  DomElement.prototype.off = function (type, selector, fn) {
    var _context5;

    cov_igv09dk30().f[19]++;
    cov_igv09dk30().s[117]++;

    if (!type) {
      cov_igv09dk30().b[24][0]++;
      cov_igv09dk30().s[118]++;
      return this;
    } else {
      cov_igv09dk30().b[24][1]++;
    } // 没有 selector ，只有 type 和 fn


    cov_igv09dk30().s[119]++;

    if (typeof selector === 'function') {
      cov_igv09dk30().b[25][0]++;
      cov_igv09dk30().s[120]++;
      fn = selector;
      cov_igv09dk30().s[121]++;
      selector = '';
    } else {
      cov_igv09dk30().b[25][1]++;
    }

    cov_igv09dk30().s[122]++;
    return (0, _forEach["default"])(_context5 = this).call(_context5, function (elem) {
      cov_igv09dk30().f[20]++;
      cov_igv09dk30().s[123]++;

      // 解绑事件代理
      if (selector) {
        cov_igv09dk30().b[26][0]++;
        var idx = (cov_igv09dk30().s[124]++, -1);
        cov_igv09dk30().s[125]++;

        for (var i = (cov_igv09dk30().s[126]++, 0); i < AGENT_EVENTS.length; i++) {
          var item = (cov_igv09dk30().s[127]++, AGENT_EVENTS[i]);
          cov_igv09dk30().s[128]++;

          if ((cov_igv09dk30().b[28][0]++, item.selector === selector) && (cov_igv09dk30().b[28][1]++, item.fn === fn) && (cov_igv09dk30().b[28][2]++, item.elem === elem)) {
            cov_igv09dk30().b[27][0]++;
            cov_igv09dk30().s[129]++;
            idx = i;
            cov_igv09dk30().s[130]++;
            break;
          } else {
            cov_igv09dk30().b[27][1]++;
          }
        }

        cov_igv09dk30().s[131]++;

        if (idx !== -1) {
          cov_igv09dk30().b[29][0]++;
          var agentFn = (cov_igv09dk30().s[132]++, (0, _splice["default"])(AGENT_EVENTS).call(AGENT_EVENTS, idx, 1)[0].agentFn);
          cov_igv09dk30().s[133]++;
          elem.removeEventListener(type, agentFn);
        } else {
          cov_igv09dk30().b[29][1]++;
        }
      } else {
        cov_igv09dk30().b[26][1]++;
        cov_igv09dk30().s[134]++;
        // @ts-ignore
        elem.removeEventListener(type, fn);
      }
    });
  };

  cov_igv09dk30().s[135]++;

  DomElement.prototype.attr = function (key, val) {
    var _context6;

    cov_igv09dk30().f[21]++;
    cov_igv09dk30().s[136]++;

    if (val == null) {
      cov_igv09dk30().b[30][0]++;
      cov_igv09dk30().s[137]++;
      // 获取数据
      return (cov_igv09dk30().b[31][0]++, this.elems[0].getAttribute(key)) || (cov_igv09dk30().b[31][1]++, '');
    } else {
      cov_igv09dk30().b[30][1]++;
    } // 否则，设置属性


    cov_igv09dk30().s[138]++;
    return (0, _forEach["default"])(_context6 = this).call(_context6, function (elem) {
      cov_igv09dk30().f[22]++;
      cov_igv09dk30().s[139]++;
      elem.setAttribute(key, val);
    });
  };
  /**
   * 删除 属性
   * @param key key
   */


  cov_igv09dk30().s[140]++;

  DomElement.prototype.removeAttr = function (key) {
    var _context7;

    cov_igv09dk30().f[23]++;
    cov_igv09dk30().s[141]++;
    (0, _forEach["default"])(_context7 = this).call(_context7, function (elem) {
      cov_igv09dk30().f[24]++;
      cov_igv09dk30().s[142]++;
      elem.removeAttribute(key);
    });
  };
  /**
   * 添加 css class
   * @param className css class
   */


  cov_igv09dk30().s[143]++;

  DomElement.prototype.addClass = function (className) {
    var _context8;

    cov_igv09dk30().f[25]++;
    cov_igv09dk30().s[144]++;

    if (!className) {
      cov_igv09dk30().b[32][0]++;
      cov_igv09dk30().s[145]++;
      return this;
    } else {
      cov_igv09dk30().b[32][1]++;
    }

    cov_igv09dk30().s[146]++;
    return (0, _forEach["default"])(_context8 = this).call(_context8, function (elem) {
      cov_igv09dk30().f[26]++;
      cov_igv09dk30().s[147]++;

      if (elem.className) {
        cov_igv09dk30().b[33][0]++;
        // 当前有 class
        var arr = (cov_igv09dk30().s[148]++, elem.className.split(/\s/));
        cov_igv09dk30().s[149]++;
        arr = (0, _filter["default"])(arr).call(arr, function (item) {
          cov_igv09dk30().f[27]++;
          cov_igv09dk30().s[150]++;
          return !!(0, _trim["default"])(item).call(item);
        }); // 添加 class

        cov_igv09dk30().s[151]++;

        if ((0, _indexOf["default"])(arr).call(arr, className) < 0) {
          cov_igv09dk30().b[34][0]++;
          cov_igv09dk30().s[152]++;
          arr.push(className);
        } else {
          cov_igv09dk30().b[34][1]++;
        } // 修改 elem.class


        cov_igv09dk30().s[153]++;
        elem.className = arr.join(' ');
      } else {
        cov_igv09dk30().b[33][1]++;
        cov_igv09dk30().s[154]++;
        // 当前没有 class
        elem.className = className;
      }
    });
  };
  /**
   * 添加 css class
   * @param className css class
   */


  cov_igv09dk30().s[155]++;

  DomElement.prototype.removeClass = function (className) {
    var _context9;

    cov_igv09dk30().f[28]++;
    cov_igv09dk30().s[156]++;

    if (!className) {
      cov_igv09dk30().b[35][0]++;
      cov_igv09dk30().s[157]++;
      return this;
    } else {
      cov_igv09dk30().b[35][1]++;
    }

    cov_igv09dk30().s[158]++;
    return (0, _forEach["default"])(_context9 = this).call(_context9, function (elem) {
      cov_igv09dk30().f[29]++;
      cov_igv09dk30().s[159]++;

      if (!elem.className) {
        cov_igv09dk30().b[36][0]++;
        cov_igv09dk30().s[160]++;
        // 当前无 class
        return;
      } else {
        cov_igv09dk30().b[36][1]++;
      }

      var arr = (cov_igv09dk30().s[161]++, elem.className.split(/\s/));
      cov_igv09dk30().s[162]++;
      arr = (0, _filter["default"])(arr).call(arr, function (item) {
        cov_igv09dk30().f[30]++;
        cov_igv09dk30().s[163]++;
        item = (0, _trim["default"])(item).call(item); // 删除 class

        cov_igv09dk30().s[164]++;

        if ((cov_igv09dk30().b[38][0]++, !item) || (cov_igv09dk30().b[38][1]++, item === className)) {
          cov_igv09dk30().b[37][0]++;
          cov_igv09dk30().s[165]++;
          return false;
        } else {
          cov_igv09dk30().b[37][1]++;
        }

        cov_igv09dk30().s[166]++;
        return true;
      }); // 修改 elem.class

      cov_igv09dk30().s[167]++;
      elem.className = arr.join(' ');
    });
  };
  /**
   * 是否有传入的 css class
   * @param className css class
   */


  cov_igv09dk30().s[168]++;

  DomElement.prototype.hasClass = function (className) {
    cov_igv09dk30().f[31]++;
    cov_igv09dk30().s[169]++;

    if (!className) {
      cov_igv09dk30().b[39][0]++;
      cov_igv09dk30().s[170]++;
      return false;
    } else {
      cov_igv09dk30().b[39][1]++;
    }

    var elem = (cov_igv09dk30().s[171]++, this.elems[0]);
    cov_igv09dk30().s[172]++;

    if (!elem.className) {
      cov_igv09dk30().b[40][0]++;
      cov_igv09dk30().s[173]++;
      // 当前无 class
      return false;
    } else {
      cov_igv09dk30().b[40][1]++;
    }

    var arr = (cov_igv09dk30().s[174]++, elem.className.split(/\s/));
    cov_igv09dk30().s[175]++;
    return (0, _includes["default"])(arr).call(arr, className); // 是否包含
  };
  /**
   * 修改 css
   * @param key css key
   * @param val css value
   */
  // css(key: string): string


  cov_igv09dk30().s[176]++;

  DomElement.prototype.css = function (key, val) {
    var _context10;

    cov_igv09dk30().f[32]++;
    var currentStyle;
    cov_igv09dk30().s[177]++;

    if (val == '') {
      cov_igv09dk30().b[41][0]++;
      cov_igv09dk30().s[178]++;
      currentStyle = '';
    } else {
      cov_igv09dk30().b[41][1]++;
      cov_igv09dk30().s[179]++;
      currentStyle = key + ":" + val + ";";
    }

    cov_igv09dk30().s[180]++;
    return (0, _forEach["default"])(_context10 = this).call(_context10, function (elem) {
      var _context11;

      cov_igv09dk30().f[33]++;
      var style = (cov_igv09dk30().s[181]++, (0, _trim["default"])(_context11 = (cov_igv09dk30().b[42][0]++, elem.getAttribute('style')) || (cov_igv09dk30().b[42][1]++, '')).call(_context11));
      cov_igv09dk30().s[182]++;

      if (style) {
        cov_igv09dk30().b[43][0]++;
        // 有 style，将 style 按照 `;` 拆分为数组
        var resultArr = (cov_igv09dk30().s[183]++, _styleArrTrim(style)); // 替换现有的 style

        cov_igv09dk30().s[184]++;
        resultArr = (0, _map2["default"])(resultArr).call(resultArr, function (item) {
          cov_igv09dk30().f[34]++;
          cov_igv09dk30().s[185]++;

          if ((0, _indexOf["default"])(item).call(item, key) === 0) {
            cov_igv09dk30().b[44][0]++;
            cov_igv09dk30().s[186]++;
            return currentStyle;
          } else {
            cov_igv09dk30().b[44][1]++;
            cov_igv09dk30().s[187]++;
            return item;
          }
        }); // 新增 style

        cov_igv09dk30().s[188]++;

        if ((cov_igv09dk30().b[46][0]++, currentStyle != '') && (cov_igv09dk30().b[46][1]++, (0, _indexOf["default"])(resultArr).call(resultArr, currentStyle) < 0)) {
          cov_igv09dk30().b[45][0]++;
          cov_igv09dk30().s[189]++;
          resultArr.push(currentStyle);
        } else {
          cov_igv09dk30().b[45][1]++;
        } // 去掉 空白


        cov_igv09dk30().s[190]++;

        if (currentStyle == '') {
          cov_igv09dk30().b[47][0]++;
          cov_igv09dk30().s[191]++;
          resultArr = _styleArrTrim(resultArr);
        } else {
          cov_igv09dk30().b[47][1]++;
        } // 重新设置 style


        cov_igv09dk30().s[192]++;
        elem.setAttribute('style', resultArr.join('; '));
      } else {
        cov_igv09dk30().b[43][1]++;
        cov_igv09dk30().s[193]++;
        // 当前没有 style
        elem.setAttribute('style', currentStyle);
      }
    });
  };
  /**
   * 封装 getBoundingClientRect
   */


  cov_igv09dk30().s[194]++;

  DomElement.prototype.getBoundingClientRect = function () {
    cov_igv09dk30().f[35]++;
    var elem = (cov_igv09dk30().s[195]++, this.elems[0]);
    cov_igv09dk30().s[196]++;
    return elem.getBoundingClientRect();
  };
  /**
   * 显示
   */


  cov_igv09dk30().s[197]++;

  DomElement.prototype.show = function () {
    cov_igv09dk30().f[36]++;
    cov_igv09dk30().s[198]++;
    return this.css('display', 'block');
  };
  /**
   * 隐藏
   */


  cov_igv09dk30().s[199]++;

  DomElement.prototype.hide = function () {
    cov_igv09dk30().f[37]++;
    cov_igv09dk30().s[200]++;
    return this.css('display', 'none');
  };
  /**
   * 获取子节点（只有 DOM 元素）
   */


  cov_igv09dk30().s[201]++;

  DomElement.prototype.children = function () {
    cov_igv09dk30().f[38]++;
    var elem = (cov_igv09dk30().s[202]++, this.elems[0]);
    cov_igv09dk30().s[203]++;

    if (!elem) {
      cov_igv09dk30().b[48][0]++;
      cov_igv09dk30().s[204]++;
      return null;
    } else {
      cov_igv09dk30().b[48][1]++;
    }

    cov_igv09dk30().s[205]++;
    return $(elem.children);
  };
  /**
   * 获取子节点（包括文本节点）
   */


  cov_igv09dk30().s[206]++;

  DomElement.prototype.childNodes = function () {
    cov_igv09dk30().f[39]++;
    var elem = (cov_igv09dk30().s[207]++, this.elems[0]);
    cov_igv09dk30().s[208]++;

    if (!elem) {
      cov_igv09dk30().b[49][0]++;
      cov_igv09dk30().s[209]++;
      return null;
    } else {
      cov_igv09dk30().b[49][1]++;
    }

    cov_igv09dk30().s[210]++;
    return $(elem.childNodes);
  };
  /**
   * 将子元素全部替换
   * @param $children 新的child节点
   */


  cov_igv09dk30().s[211]++;

  DomElement.prototype.replaceChildAll = function ($children) {
    cov_igv09dk30().f[40]++;
    var parent = (cov_igv09dk30().s[212]++, this.getNode());
    var elem = (cov_igv09dk30().s[213]++, this.elems[0]);
    cov_igv09dk30().s[214]++;

    while (elem.hasChildNodes()) {
      cov_igv09dk30().s[215]++;
      (cov_igv09dk30().b[50][0]++, parent.firstChild) && (cov_igv09dk30().b[50][1]++, elem.removeChild(parent.firstChild));
    }

    cov_igv09dk30().s[216]++;
    this.append($children);
  };
  /**
   * 增加子节点
   * @param $children 子节点
   */


  cov_igv09dk30().s[217]++;

  DomElement.prototype.append = function ($children) {
    var _context12;

    cov_igv09dk30().f[41]++;
    cov_igv09dk30().s[218]++;
    return (0, _forEach["default"])(_context12 = this).call(_context12, function (elem) {
      cov_igv09dk30().f[42]++;
      cov_igv09dk30().s[219]++;
      (0, _forEach["default"])($children).call($children, function (child) {
        cov_igv09dk30().f[43]++;
        cov_igv09dk30().s[220]++;
        elem.appendChild(child);
      });
    });
  };
  /**
   * 移除当前节点
   */


  cov_igv09dk30().s[221]++;

  DomElement.prototype.remove = function () {
    var _context13;

    cov_igv09dk30().f[44]++;
    cov_igv09dk30().s[222]++;
    return (0, _forEach["default"])(_context13 = this).call(_context13, function (elem) {
      cov_igv09dk30().f[45]++;
      cov_igv09dk30().s[223]++;

      if (elem.remove) {
        cov_igv09dk30().b[51][0]++;
        cov_igv09dk30().s[224]++;
        elem.remove();
      } else {
        cov_igv09dk30().b[51][1]++;
        var parent_1 = (cov_igv09dk30().s[225]++, elem.parentElement);
        cov_igv09dk30().s[226]++;
        (cov_igv09dk30().b[52][0]++, parent_1) && (cov_igv09dk30().b[52][1]++, parent_1.removeChild(elem));
      }
    });
  };
  /**
   * 当前元素，是否包含某个子元素
   * @param $child 子元素
   */


  cov_igv09dk30().s[227]++;

  DomElement.prototype.isContain = function ($child) {
    cov_igv09dk30().f[46]++;
    var elem = (cov_igv09dk30().s[228]++, this.elems[0]);
    var child = (cov_igv09dk30().s[229]++, $child.elems[0]);
    cov_igv09dk30().s[230]++;
    return elem.contains(child);
  };
  /**
   * 获取当前元素的尺寸和位置信息
   */


  cov_igv09dk30().s[231]++;

  DomElement.prototype.getSizeData = function () {
    cov_igv09dk30().f[47]++;
    var elem = (cov_igv09dk30().s[232]++, this.elems[0]); // 可得到 bottom height left right top width 的数据

    cov_igv09dk30().s[233]++;
    return elem.getBoundingClientRect();
  };
  /**
   * 获取当前元素 nodeName
   */


  cov_igv09dk30().s[234]++;

  DomElement.prototype.getNodeName = function () {
    cov_igv09dk30().f[48]++;
    var elem = (cov_igv09dk30().s[235]++, this.elems[0]);
    cov_igv09dk30().s[236]++;
    return elem.nodeName;
  };
  /**
   * 获取当前元素节点
   */


  cov_igv09dk30().s[237]++;

  DomElement.prototype.getNode = function () {
    cov_igv09dk30().f[49]++;
    var elem = (cov_igv09dk30().s[238]++, this.elems[0]);
    cov_igv09dk30().s[239]++;
    return elem;
  };
  /**
   * 获取当前元素可视高度
   */


  cov_igv09dk30().s[240]++;

  DomElement.prototype.getClientHeight = function () {
    cov_igv09dk30().f[50]++;
    var elem = (cov_igv09dk30().s[241]++, this.elems[0]);
    cov_igv09dk30().s[242]++;
    return elem.clientHeight;
  };
  /**
   * 获取当前元素可视宽度
   */
  // getClientWidth(): number {
  //     const elem = this.elems[0]
  //     return elem.clientWidth
  // }

  /**
   * 查询
   * @param selector css 选择器
   */


  cov_igv09dk30().s[243]++;

  DomElement.prototype.find = function (selector) {
    cov_igv09dk30().f[51]++;
    var elem = (cov_igv09dk30().s[244]++, this.elems[0]);
    cov_igv09dk30().s[245]++;
    return $(elem.querySelectorAll(selector));
  };

  cov_igv09dk30().s[246]++;

  DomElement.prototype.text = function (val) {
    cov_igv09dk30().f[52]++;
    cov_igv09dk30().s[247]++;

    if (!val) {
      cov_igv09dk30().b[53][0]++;
      // 获取 text
      var elem = (cov_igv09dk30().s[248]++, this.elems[0]);
      cov_igv09dk30().s[249]++;
      return elem.innerHTML.replace(/<[^>]+>/g, function () {
        cov_igv09dk30().f[53]++;
        cov_igv09dk30().s[250]++;
        return '';
      });
    } else {
      var _context14;

      cov_igv09dk30().b[53][1]++;
      cov_igv09dk30().s[251]++;
      // 设置 text
      return (0, _forEach["default"])(_context14 = this).call(_context14, function (elem) {
        cov_igv09dk30().f[54]++;
        cov_igv09dk30().s[252]++;
        elem.innerHTML = val;
      });
    }
  };

  cov_igv09dk30().s[253]++;

  DomElement.prototype.html = function (val) {
    cov_igv09dk30().f[55]++;
    var elem = (cov_igv09dk30().s[254]++, this.elems[0]);
    cov_igv09dk30().s[255]++;

    if (!val) {
      cov_igv09dk30().b[54][0]++;
      cov_igv09dk30().s[256]++;
      // 获取 html
      return elem.innerHTML;
    } else {
      cov_igv09dk30().b[54][1]++;
      cov_igv09dk30().s[257]++;
      // 设置 html
      elem.innerHTML = val;
      cov_igv09dk30().s[258]++;
      return this;
    }
  };
  /**
   * 获取元素 value
   */


  cov_igv09dk30().s[259]++;

  DomElement.prototype.val = function () {
    var _context15;

    cov_igv09dk30().f[56]++;
    var elem = (cov_igv09dk30().s[260]++, this.elems[0]);
    cov_igv09dk30().s[261]++;
    return (0, _trim["default"])(_context15 = elem.value).call(_context15); // 暂用 any
  };
  /**
   * focus 到当前元素
   */


  cov_igv09dk30().s[262]++;

  DomElement.prototype.focus = function () {
    var _context16;

    cov_igv09dk30().f[57]++;
    cov_igv09dk30().s[263]++;
    return (0, _forEach["default"])(_context16 = this).call(_context16, function (elem) {
      cov_igv09dk30().f[58]++;
      cov_igv09dk30().s[264]++;
      elem.focus();
    });
  };
  /**
   * 当前元素前一个兄弟节点
   */


  cov_igv09dk30().s[265]++;

  DomElement.prototype.prev = function () {
    cov_igv09dk30().f[59]++;
    var elem = (cov_igv09dk30().s[266]++, this.elems[0]);
    cov_igv09dk30().s[267]++;
    return $(elem.previousElementSibling);
  };
  /**
   * 当前元素后一个兄弟节点
   */


  cov_igv09dk30().s[268]++;

  DomElement.prototype.next = function () {
    cov_igv09dk30().f[60]++;
    var elem = (cov_igv09dk30().s[269]++, this.elems[0]);
    cov_igv09dk30().s[270]++;
    return $(elem.nextElementSibling);
  };
  /**
   * 获取父元素
   */


  cov_igv09dk30().s[271]++;

  DomElement.prototype.parent = function () {
    cov_igv09dk30().f[61]++;
    var elem = (cov_igv09dk30().s[272]++, this.elems[0]);
    cov_igv09dk30().s[273]++;
    return $(elem.parentElement);
  };
  /**
   * 查找父元素，知道满足 selector 条件
   * @param selector css 选择器
   * @param curElem 从哪个元素开始查找，默认为当前元素
   */


  cov_igv09dk30().s[274]++;

  DomElement.prototype.parentUntil = function (selector, curElem) {
    cov_igv09dk30().f[62]++;
    var elem = (cov_igv09dk30().s[275]++, (cov_igv09dk30().b[55][0]++, curElem) || (cov_igv09dk30().b[55][1]++, this.elems[0]));
    cov_igv09dk30().s[276]++;

    if (elem.nodeName === 'BODY') {
      cov_igv09dk30().b[56][0]++;
      cov_igv09dk30().s[277]++;
      return null;
    } else {
      cov_igv09dk30().b[56][1]++;
    }

    var parent = (cov_igv09dk30().s[278]++, elem.parentElement);
    cov_igv09dk30().s[279]++;

    if (parent === null) {
      cov_igv09dk30().b[57][0]++;
      cov_igv09dk30().s[280]++;
      return null;
    } else {
      cov_igv09dk30().b[57][1]++;
    }

    cov_igv09dk30().s[281]++;

    if (parent.matches(selector)) {
      cov_igv09dk30().b[58][0]++;
      cov_igv09dk30().s[282]++;
      // 找到，并返回
      return $(parent);
    } else {
      cov_igv09dk30().b[58][1]++;
    } // 继续查找，递归


    cov_igv09dk30().s[283]++;
    return this.parentUntil(selector, parent);
  };
  /**
   * 判读是否相等
   * @param $elem 元素
   */


  cov_igv09dk30().s[284]++;

  DomElement.prototype.equal = function ($elem) {
    cov_igv09dk30().f[63]++;
    cov_igv09dk30().s[285]++;

    if ($elem instanceof DomElement) {
      cov_igv09dk30().b[59][0]++;
      cov_igv09dk30().s[286]++;
      return this.elems[0] === $elem.elems[0];
    } else {
      cov_igv09dk30().b[59][1]++;
      cov_igv09dk30().s[287]++;

      if ($elem instanceof HTMLElement) {
        cov_igv09dk30().b[60][0]++;
        cov_igv09dk30().s[288]++;
        return this.elems[0] === $elem;
      } else {
        cov_igv09dk30().b[60][1]++;
        cov_igv09dk30().s[289]++;
        return false;
      }
    }
  };
  /**
   * 将该元素插入到某个元素前面
   * @param selector css 选择器
   */


  cov_igv09dk30().s[290]++;

  DomElement.prototype.insertBefore = function (selector) {
    var _context17;

    cov_igv09dk30().f[64]++;
    var $referenceNode = (cov_igv09dk30().s[291]++, $(selector));
    var referenceNode = (cov_igv09dk30().s[292]++, $referenceNode.elems[0]);
    cov_igv09dk30().s[293]++;

    if (!referenceNode) {
      cov_igv09dk30().b[61][0]++;
      cov_igv09dk30().s[294]++;
      return this;
    } else {
      cov_igv09dk30().b[61][1]++;
    }

    cov_igv09dk30().s[295]++;
    return (0, _forEach["default"])(_context17 = this).call(_context17, function (elem) {
      cov_igv09dk30().f[65]++;
      var parent = (cov_igv09dk30().s[296]++, referenceNode.parentNode);
      cov_igv09dk30().s[297]++;
      parent.insertBefore(elem, referenceNode);
    });
  };
  /**
   * 将该元素插入到某个元素后面
   * @param selector css 选择器
   */


  cov_igv09dk30().s[298]++;

  DomElement.prototype.insertAfter = function (selector) {
    var _context18;

    cov_igv09dk30().f[66]++;
    var $referenceNode = (cov_igv09dk30().s[299]++, $(selector));
    var referenceNode = (cov_igv09dk30().s[300]++, $referenceNode.elems[0]);
    var anchorNode = (cov_igv09dk30().s[301]++, (cov_igv09dk30().b[62][0]++, referenceNode) && (cov_igv09dk30().b[62][1]++, referenceNode.nextSibling));
    cov_igv09dk30().s[302]++;

    if (!referenceNode) {
      cov_igv09dk30().b[63][0]++;
      cov_igv09dk30().s[303]++;
      return this;
    } else {
      cov_igv09dk30().b[63][1]++;
    }

    cov_igv09dk30().s[304]++;
    return (0, _forEach["default"])(_context18 = this).call(_context18, function (elem) {
      cov_igv09dk30().f[67]++;
      var parent = (cov_igv09dk30().s[305]++, referenceNode.parentNode);
      cov_igv09dk30().s[306]++;

      if (anchorNode) {
        cov_igv09dk30().b[64][0]++;
        cov_igv09dk30().s[307]++;
        parent.insertBefore(elem, anchorNode);
      } else {
        cov_igv09dk30().b[64][1]++;
        cov_igv09dk30().s[308]++;
        parent.appendChild(elem);
      }
    });
  };
  /**
   * 设置/获取 数据
   * @param key key
   * @param value value
   */


  cov_igv09dk30().s[309]++;

  DomElement.prototype.data = function (key, value) {
    cov_igv09dk30().f[68]++;
    cov_igv09dk30().s[310]++;

    if (value != null) {
      cov_igv09dk30().b[65][0]++;
      cov_igv09dk30().s[311]++;
      // 设置数据
      this.dataSource.set(key, value);
    } else {
      cov_igv09dk30().b[65][1]++;
      cov_igv09dk30().s[312]++;
      // 获取数据
      return this.dataSource.get(key);
    }
  };
  /**
   * 获取当前节点的顶级(段落)
   * @param editor 富文本实例
   */


  cov_igv09dk30().s[313]++;

  DomElement.prototype.getNodeTop = function (editor) {
    cov_igv09dk30().f[69]++;
    cov_igv09dk30().s[314]++;

    if (this.length < 1) {
      cov_igv09dk30().b[66][0]++;
      cov_igv09dk30().s[315]++;
      return this;
    } else {
      cov_igv09dk30().b[66][1]++;
    }

    var $parent = (cov_igv09dk30().s[316]++, this.parent());
    cov_igv09dk30().s[317]++;

    if (editor.$textElem.equal($parent)) {
      cov_igv09dk30().b[67][0]++;
      cov_igv09dk30().s[318]++;
      return this;
    } else {
      cov_igv09dk30().b[67][1]++;
    }

    cov_igv09dk30().s[319]++;
    return $parent.getNodeTop(editor);
  };
  /**
   * 获取当前 节点 基与上一个拥有相对或者解决定位的父容器的位置
   * @param editor 富文本实例
   */


  cov_igv09dk30().s[320]++;

  DomElement.prototype.getOffsetData = function () {
    cov_igv09dk30().f[70]++;
    var $node = (cov_igv09dk30().s[321]++, this.elems[0]);
    cov_igv09dk30().s[322]++;
    return {
      top: $node.offsetTop,
      left: $node.offsetLeft,
      width: $node.offsetWidth,
      height: $node.offsetHeight,
      parent: $node.offsetParent
    };
  };
  /**
   * 从上至下进行滚动
   * @param top 滚动的值
   */


  cov_igv09dk30().s[323]++;

  DomElement.prototype.scrollTop = function (top) {
    cov_igv09dk30().f[71]++;
    var $node = (cov_igv09dk30().s[324]++, this.elems[0]);
    cov_igv09dk30().s[325]++;
    $node.scrollTo({
      top: top
    });
  };

  cov_igv09dk30().s[326]++;
  return DomElement;
}());
cov_igv09dk30().s[327]++;
exports.DomElement = DomElement; // new 一个对象

function $() {
  cov_igv09dk30().f[72]++;
  var arg = (cov_igv09dk30().s[328]++, []);
  cov_igv09dk30().s[329]++;

  for (var _i = (cov_igv09dk30().s[330]++, 0); _i < arguments.length; _i++) {
    cov_igv09dk30().s[331]++;
    arg[_i] = arguments[_i];
  }

  cov_igv09dk30().s[332]++;
  return new ((0, _bind["default"])(DomElement).apply(DomElement, __spreadArrays([void 0], arg)))();
}

cov_igv09dk30().s[333]++;
exports["default"] = $;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(132);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var getOwnPropertyDescriptor = __webpack_require__(66).f;
var isForced = __webpack_require__(97);
var path = __webpack_require__(10);
var bind = __webpack_require__(46);
var createNonEnumerableProperty = __webpack_require__(16);
var has = __webpack_require__(15);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof NativeConstructor) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return NativeConstructor.apply(this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    target[key] = resultProperty;

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!has(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(302);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 工具函数集合
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _isArray = _interopRequireDefault(__webpack_require__(116));

var _typeof2 = _interopRequireDefault(__webpack_require__(91));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(120));

var _slice = _interopRequireDefault(__webpack_require__(54));

var _parseInt2 = _interopRequireDefault(__webpack_require__(258));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_23rlp2sm0s() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/util.ts";
  var hash = "1f2ed621bcb96cc4496202c7b7bea714821f820d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/util.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 88
        }
      },
      "2": {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 7,
          column: 18
        }
      },
      "3": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 25
        }
      },
      "4": {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 7,
          column: 48
        }
      },
      "5": {
        start: {
          line: 7,
          column: 63
        },
        end: {
          line: 7,
          column: 88
        }
      },
      "6": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "7": {
        start: {
          line: 8,
          column: 17
        },
        end: {
          line: 8,
          column: 25
        }
      },
      "8": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 8,
          column: 32
        }
      },
      "9": {
        start: {
          line: 8,
          column: 38
        },
        end: {
          line: 8,
          column: 39
        }
      },
      "10": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "11": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 9,
          column: 33
        }
      },
      "12": {
        start: {
          line: 9,
          column: 39
        },
        end: {
          line: 9,
          column: 40
        }
      },
      "13": {
        start: {
          line: 9,
          column: 47
        },
        end: {
          line: 9,
          column: 55
        }
      },
      "14": {
        start: {
          line: 10,
          column: 12
        },
        end: {
          line: 10,
          column: 24
        }
      },
      "15": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 13
        }
      },
      "16": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 62
        }
      },
      "17": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 14,
          column: 259
        }
      },
      "18": {
        start: {
          line: 15,
          column: 27
        },
        end: {
          line: 32,
          column: 3
        }
      },
      "19": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 39
        }
      },
      "20": {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 18,
          column: 51
        }
      },
      "21": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 92
        }
      },
      "22": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 21,
          column: 93
        }
      },
      "23": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 26,
          column: 6
        }
      },
      "24": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 41
        }
      },
      "25": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 6
        }
      },
      "26": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 40
        }
      },
      "27": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 17
        }
      },
      "28": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 34,
          column: 25
        }
      },
      "29": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 43
        }
      },
      "30": {
        start: {
          line: 40,
          column: 29
        },
        end: {
          line: 40,
          column: 41
        }
      },
      "31": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 54
        }
      },
      "32": {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 43,
          column: 30
        }
      },
      "33": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 53,
          column: 43
        }
      },
      "34": {
        start: {
          line: 55,
          column: 0
        },
        end: {
          line: 55,
          column: 46
        }
      },
      "35": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 60,
          column: 34
        }
      },
      "36": {
        start: {
          line: 62,
          column: 0
        },
        end: {
          line: 62,
          column: 52
        }
      },
      "37": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "38": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 71,
          column: 9
        }
      },
      "39": {
        start: {
          line: 66,
          column: 25
        },
        end: {
          line: 66,
          column: 42
        }
      },
      "40": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 70,
          column: 13
        }
      },
      "41": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 22
        }
      },
      "42": {
        start: {
          line: 74,
          column: 0
        },
        end: {
          line: 74,
          column: 26
        }
      },
      "43": {
        start: {
          line: 82,
          column: 17
        },
        end: {
          line: 82,
          column: 36
        }
      },
      "44": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      },
      "45": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 26
        }
      },
      "46": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 43
        }
      },
      "47": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 88,
          column: 9
        }
      },
      "48": {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 87,
          column: 18
        }
      },
      "49": {
        start: {
          line: 91,
          column: 0
        },
        end: {
          line: 91,
          column: 32
        }
      },
      "50": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 48
        }
      },
      "51": {
        start: {
          line: 98,
          column: 31
        },
        end: {
          line: 98,
          column: 46
        }
      },
      "52": {
        start: {
          line: 99,
          column: 15
        },
        end: {
          line: 99,
          column: 20
        }
      },
      "53": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 113,
          column: 6
        }
      },
      "54": {
        start: {
          line: 101,
          column: 20
        },
        end: {
          line: 101,
          column: 24
        }
      },
      "55": {
        start: {
          line: 102,
          column: 19
        },
        end: {
          line: 102,
          column: 21
        }
      },
      "56": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 105,
          column: 9
        }
      },
      "57": {
        start: {
          line: 103,
          column: 22
        },
        end: {
          line: 103,
          column: 23
        }
      },
      "58": {
        start: {
          line: 104,
          column: 12
        },
        end: {
          line: 104,
          column: 37
        }
      },
      "59": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 112,
          column: 9
        }
      },
      "60": {
        start: {
          line: 107,
          column: 12
        },
        end: {
          line: 107,
          column: 24
        }
      },
      "61": {
        start: {
          line: 108,
          column: 12
        },
        end: {
          line: 111,
          column: 25
        }
      },
      "62": {
        start: {
          line: 109,
          column: 16
        },
        end: {
          line: 109,
          column: 29
        }
      },
      "63": {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 65
        }
      },
      "64": {
        start: {
          line: 115,
          column: 0
        },
        end: {
          line: 115,
          column: 28
        }
      },
      "65": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 42
        }
      },
      "66": {
        start: {
          line: 122,
          column: 28
        },
        end: {
          line: 122,
          column: 40
        }
      },
      "67": {
        start: {
          line: 123,
          column: 17
        },
        end: {
          line: 123,
          column: 18
        }
      },
      "68": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 137,
          column: 6
        }
      },
      "69": {
        start: {
          line: 125,
          column: 20
        },
        end: {
          line: 125,
          column: 24
        }
      },
      "70": {
        start: {
          line: 126,
          column: 19
        },
        end: {
          line: 126,
          column: 21
        }
      },
      "71": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 129,
          column: 9
        }
      },
      "72": {
        start: {
          line: 127,
          column: 22
        },
        end: {
          line: 127,
          column: 23
        }
      },
      "73": {
        start: {
          line: 128,
          column: 12
        },
        end: {
          line: 128,
          column: 37
        }
      },
      "74": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 132,
          column: 9
        }
      },
      "75": {
        start: {
          line: 131,
          column: 12
        },
        end: {
          line: 131,
          column: 40
        }
      },
      "76": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 136,
          column: 18
        }
      },
      "77": {
        start: {
          line: 134,
          column: 12
        },
        end: {
          line: 134,
          column: 23
        }
      },
      "78": {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 135,
          column: 61
        }
      },
      "79": {
        start: {
          line: 139,
          column: 0
        },
        end: {
          line: 139,
          column: 28
        }
      },
      "80": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 36
        }
      },
      "81": {
        start: {
          line: 147,
          column: 0
        },
        end: {
          line: 147,
          column: 32
        }
      },
      "82": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "83": {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 154,
          column: 20
        }
      },
      "84": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "85": {
        start: {
          line: 158,
          column: 8
        },
        end: {
          line: 158,
          column: 18
        }
      },
      "86": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 162,
          column: 5
        }
      },
      "87": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "88": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "89": {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 166,
          column: 9
        }
      },
      "90": {
        start: {
          line: 165,
          column: 12
        },
        end: {
          line: 165,
          column: 41
        }
      },
      "91": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 16
        }
      },
      "92": {
        start: {
          line: 170,
          column: 0
        },
        end: {
          line: 170,
          column: 30
        }
      },
      "93": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 44
        }
      },
      "94": {
        start: {
          line: 178,
          column: 0
        },
        end: {
          line: 178,
          column: 26
        }
      },
      "95": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 48
        }
      },
      "96": {
        start: {
          line: 186,
          column: 0
        },
        end: {
          line: 186,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 54
          },
          end: {
            line: 6,
            column: 55
          }
        },
        loc: {
          start: {
            line: 6,
            column: 66
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 15,
            column: 28
          }
        },
        loc: {
          start: {
            line: 15,
            column: 39
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "NavUA",
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 18
          }
        },
        loc: {
          start: {
            line: 16,
            column: 21
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 27
          },
          end: {
            line: 24,
            column: 28
          }
        },
        loc: {
          start: {
            line: 24,
            column: 39
          },
          end: {
            line: 26,
            column: 5
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 28,
            column: 32
          }
        },
        loc: {
          start: {
            line: 28,
            column: 43
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 28
      },
      "5": {
        name: "getRandom",
        decl: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 39,
            column: 18
          }
        },
        loc: {
          start: {
            line: 39,
            column: 27
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 39
      },
      "6": {
        name: "replaceHtmlSymbol",
        decl: {
          start: {
            line: 48,
            column: 9
          },
          end: {
            line: 48,
            column: 26
          }
        },
        loc: {
          start: {
            line: 48,
            column: 33
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 48
      },
      "7": {
        name: "replaceSpecialSymbol",
        decl: {
          start: {
            line: 56,
            column: 9
          },
          end: {
            line: 56,
            column: 29
          }
        },
        loc: {
          start: {
            line: 56,
            column: 37
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 56
      },
      "8": {
        name: "forEach",
        decl: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 16
          }
        },
        loc: {
          start: {
            line: 63,
            column: 26
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 63
      },
      "9": {
        name: "arrForEach",
        decl: {
          start: {
            line: 80,
            column: 9
          },
          end: {
            line: 80,
            column: 19
          }
        },
        loc: {
          start: {
            line: 80,
            column: 33
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 80
      },
      "10": {
        name: "throttle",
        decl: {
          start: {
            line: 97,
            column: 9
          },
          end: {
            line: 97,
            column: 17
          }
        },
        loc: {
          start: {
            line: 97,
            column: 32
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 97
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 100,
            column: 11
          },
          end: {
            line: 100,
            column: 12
          }
        },
        loc: {
          start: {
            line: 100,
            column: 23
          },
          end: {
            line: 113,
            column: 5
          }
        },
        line: 100
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 108,
            column: 23
          },
          end: {
            line: 108,
            column: 24
          }
        },
        loc: {
          start: {
            line: 108,
            column: 35
          },
          end: {
            line: 111,
            column: 13
          }
        },
        line: 108
      },
      "13": {
        name: "debounce",
        decl: {
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 121,
            column: 17
          }
        },
        loc: {
          start: {
            line: 121,
            column: 29
          },
          end: {
            line: 138,
            column: 1
          }
        },
        line: 121
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 124,
            column: 11
          },
          end: {
            line: 124,
            column: 12
          }
        },
        loc: {
          start: {
            line: 124,
            column: 23
          },
          end: {
            line: 137,
            column: 5
          }
        },
        line: 124
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 133,
            column: 35
          },
          end: {
            line: 133,
            column: 36
          }
        },
        loc: {
          start: {
            line: 133,
            column: 47
          },
          end: {
            line: 136,
            column: 9
          }
        },
        line: 133
      },
      "16": {
        name: "isFunction",
        decl: {
          start: {
            line: 144,
            column: 9
          },
          end: {
            line: 144,
            column: 19
          }
        },
        loc: {
          start: {
            line: 144,
            column: 24
          },
          end: {
            line: 146,
            column: 1
          }
        },
        line: 144
      },
      "17": {
        name: "deepClone",
        decl: {
          start: {
            line: 152,
            column: 9
          },
          end: {
            line: 152,
            column: 18
          }
        },
        loc: {
          start: {
            line: 152,
            column: 25
          },
          end: {
            line: 169,
            column: 1
          }
        },
        line: 152
      },
      "18": {
        name: "toArray",
        decl: {
          start: {
            line: 175,
            column: 9
          },
          end: {
            line: 175,
            column: 16
          }
        },
        loc: {
          start: {
            line: 175,
            column: 23
          },
          end: {
            line: 177,
            column: 1
          }
        },
        line: 175
      },
      "19": {
        name: "getRandomCode",
        decl: {
          start: {
            line: 183,
            column: 9
          },
          end: {
            line: 183,
            column: 22
          }
        },
        loc: {
          start: {
            line: 183,
            column: 25
          },
          end: {
            line: 185,
            column: 1
          }
        },
        line: 183
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 21
          },
          end: {
            line: 12,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 6,
            column: 26
          }
        }, {
          start: {
            line: 6,
            column: 30
          },
          end: {
            line: 6,
            column: 49
          }
        }, {
          start: {
            line: 6,
            column: 54
          },
          end: {
            line: 12,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 19,
            column: 79
          },
          end: {
            line: 19,
            column: 83
          }
        }, {
          start: {
            line: 19,
            column: 86
          },
          end: {
            line: 19,
            column: 91
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 29
          }
        }, {
          start: {
            line: 19,
            column: 33
          },
          end: {
            line: 19,
            column: 50
          }
        }, {
          start: {
            line: 19,
            column: 54
          },
          end: {
            line: 19,
            column: 76
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 80
          },
          end: {
            line: 21,
            column: 84
          }
        }, {
          start: {
            line: 21,
            column: 87
          },
          end: {
            line: 21,
            column: 92
          }
        }],
        line: 21
      },
      "4": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 41
          }
        }, {
          start: {
            line: 21,
            column: 45
          },
          end: {
            line: 21,
            column: 77
          }
        }],
        line: 21
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 43
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 43
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }, {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }],
        line: 65
      },
      "7": {
        loc: {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        }, {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 70,
            column: 13
          }
        }],
        line: 67
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 82,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 17
          },
          end: {
            line: 82,
            column: 31
          }
        }, {
          start: {
            line: 82,
            column: 35
          },
          end: {
            line: 82,
            column: 36
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }, {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }],
        line: 86
      },
      "10": {
        loc: {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 48
          }
        }, {
          start: {
            line: 98,
            column: 4
          },
          end: {
            line: 98,
            column: 48
          }
        }],
        line: 98
      },
      "11": {
        loc: {
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        }, {
          start: {
            line: 106,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        }],
        line: 106
      },
      "12": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 42
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 42
          }
        }],
        line: 122
      },
      "13": {
        loc: {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }, {
          start: {
            line: 130,
            column: 8
          },
          end: {
            line: 132,
            column: 9
          }
        }],
        line: 130
      },
      "14": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        }],
        line: 153
      },
      "15": {
        loc: {
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 153,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 153,
            column: 32
          }
        }, {
          start: {
            line: 153,
            column: 36
          },
          end: {
            line: 153,
            column: 61
          }
        }, {
          start: {
            line: 153,
            column: 65
          },
          end: {
            line: 153,
            column: 78
          }
        }],
        line: 153
      },
      "16": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }],
        line: 157
      },
      "17": {
        loc: {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }, {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 162,
            column: 5
          }
        }],
        line: 160
      },
      "18": {
        loc: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        }, {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        }],
        line: 164
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/util.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/util.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;AAEH;IASI;QACI,IAAI,CAAC,GAAG,GAAG,SAAS,CAAC,SAAS,CAAA;QAE9B,IAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,KAAK,CAAC,gBAAgB,CAAC,CAAA;QAC7C,IAAI,CAAC,SAAS,GAAG,IAAI,IAAI,IAAI,CAAC,CAAC,CAAC,IAAI,MAAM,IAAI,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,GAAG,EAAE,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,KAAK,CAAA;QAEnF,IAAI,CAAC,SAAS;YACV,cAAc,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,IAAI,CAAC,gBAAgB,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,KAAK,CAAA;IACxF,CAAC;IAED,SAAS;IACF,oBAAI,GAAX;QACI,OAAO,eAAe,IAAI,MAAM,CAAA;IACpC,CAAC;IAED,aAAa;IACN,wBAAQ,GAAf;QACI,OAAO,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;IACnC,CAAC;IACL,YAAC;AAAD,CAAC,AA5BD,IA4BC;AAED,aAAa;AACA,QAAA,EAAE,GAAG,IAAI,KAAK,EAAE,CAAA;AAE7B;;;GAGG;AACH,SAAgB,SAAS,CAAC,MAAmB;IAAnB,uBAAA,EAAA,WAAmB;IACzC,OAAO,MAAM,GAAG,IAAI,CAAC,MAAM,EAAE,CAAC,QAAQ,EAAE,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;AACrD,CAAC;AAFD,8BAEC;AAED;;;GAGG;AACH,SAAgB,iBAAiB,CAAC,IAAY;IAC1C,OAAO,IAAI;SACN,OAAO,CAAC,KAAK,EAAE,MAAM,CAAC;SACtB,OAAO,CAAC,KAAK,EAAE,MAAM,CAAC;SACtB,OAAO,CAAC,KAAK,EAAE,QAAQ,CAAC;SACxB,OAAO,CAAC,eAAe,EAAE,OAAO,CAAC,CAAA;AAC1C,CAAC;AAND,8CAMC;AAED,SAAgB,oBAAoB,CAAC,KAAa;IAC9C,OAAO,KAAK;SACP,OAAO,CAAC,QAAQ,EAAE,GAAG,CAAC;SACtB,OAAO,CAAC,QAAQ,EAAE,GAAG,CAAC;SACtB,OAAO,CAAC,UAAU,EAAE,GAAG,CAAC,CAAA;AACjC,CAAC;AALD,oDAKC;AA4BD,SAAgB,OAAO,CACnB,GAAM,EACN,EAGmB;IAEnB,KAAK,IAAI,GAAG,IAAI,GAAG,EAAE;QACjB,IAAI,MAAM,CAAC,SAAS,CAAC,cAAc,CAAC,IAAI,CAAC,GAAG,EAAE,GAAG,CAAC,EAAE;YAChD,IAAM,MAAM,GAAG,EAAE,CAAC,GAAG,EAAE,GAAG,CAAC,GAAG,CAAC,CAAC,CAAA;YAChC,IAAI,MAAM,KAAK,KAAK,EAAE;gBAClB,SAAS;gBACT,MAAK;aACR;SACJ;KACJ;AACL,CAAC;AAhBD,0BAgBC;AAED;;;;GAIG;AACH,SAAgB,UAAU,CACtB,OAAU,EACV,EAAkE;IAElE,IAAI,CAAC,EAAE,IAAI,EAAE,MAAM,CAAA;IACnB,IAAM,MAAM,GAAG,OAAO,CAAC,MAAM,IAAI,CAAC,CAAA;IAClC,KAAK,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,MAAM,EAAE,CAAC,EAAE,EAAE;QACzB,IAAI,GAAG,OAAO,CAAC,CAAC,CAAC,CAAA;QACjB,MAAM,GAAG,EAAE,CAAC,IAAI,CAAC,OAAO,EAAE,IAAI,EAAE,CAAC,CAAC,CAAA;QAClC,IAAI,MAAM,KAAK,KAAK,EAAE;YAClB,MAAK;SACR;KACJ;AACL,CAAC;AAbD,gCAaC;AAED;;;;GAIG;AAEH,SAAgB,QAAQ,CACpB,EAAoC,EACpC,QAAsB;IAAtB,yBAAA,EAAA,cAAsB;IAEtB,IAAI,IAAI,GAAG,KAAK,CAAA;IAChB,OAAO;QAAA,iBAQN;QARyB,cAAU;aAAV,UAAU,EAAV,qBAAU,EAAV,IAAU;YAAV,yBAAU;;QAChC,IAAI,CAAC,IAAI,EAAE;YACP,IAAI,GAAG,IAAI,CAAA;YACX,UAAU,CAAC;gBACP,IAAI,GAAG,KAAK,CAAA;gBACZ,EAAE,CAAC,IAAI,OAAP,EAAE,kBAAM,KAAI,GAAK,IAAI,GAAC,CAAC,qBAAqB;YAChD,CAAC,EAAE,QAAQ,CAAC,CAAA;SACf;IACL,CAAC,CAAA;AACL,CAAC;AAdD,4BAcC;AAED;;;;GAIG;AACH,SAAgB,QAAQ,CACpB,EAAiC,EACjC,KAAmB;IAAnB,sBAAA,EAAA,WAAmB;IAEnB,IAAI,MAAM,GAAG,CAAC,CAAA;IACd,OAAO;QAAA,iBAQN;QARgB,cAAU;aAAV,UAAU,EAAV,qBAAU,EAAV,IAAU;YAAV,yBAAU;;QACvB,IAAI,MAAM,EAAE;YACR,MAAM,CAAC,YAAY,CAAC,MAAM,CAAC,CAAA;SAC9B;QACD,MAAM,GAAG,MAAM,CAAC,UAAU,CAAC;YACvB,MAAM,GAAG,CAAC,CAAA;YACV,EAAE,CAAC,IAAI,OAAP,EAAE,kBAAM,KAAI,GAAK,IAAI,GAAC,CAAC,qBAAqB;QAChD,CAAC,EAAE,KAAK,CAAC,CAAA;IACb,CAAC,CAAA;AACL,CAAC;AAdD,4BAcC;AAED;;;GAGG;AACH,SAAgB,UAAU,CAAC,EAAO;IAC9B,OAAO,OAAO,EAAE,KAAK,UAAU,CAAA;AACnC,CAAC;AAFD,gCAEC;AAED;;;GAGG;AACH,SAAgB,SAAS,CAAI,IAAO;IAChC,IAAI,OAAO,IAAI,KAAK,QAAQ,IAAI,OAAO,IAAI,IAAI,UAAU,IAAI,IAAI,KAAK,IAAI,EAAE;QACxE,OAAO,IAAI,CAAA;KACd;IAED,IAAI,IAAS,CAAA;IACb,IAAI,KAAK,CAAC,OAAO,CAAC,IAAI,CAAC,EAAE;QACrB,IAAI,GAAG,EAAE,CAAA;KACZ;IAED,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,IAAI,CAAC,EAAE;QACtB,IAAI,GAAG,EAAE,CAAA;KACZ;IAED,KAAK,IAAI,CAAC,IAAI,IAAI,EAAE;QAChB,IAAI,MAAM,CAAC,SAAS,CAAC,cAAc,CAAC,IAAI,CAAC,IAAI,EAAE,CAAC,CAAC,EAAE;YAC/C,IAAI,CAAC,CAAC,CAAC,GAAG,SAAS,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAA;SAC/B;KACJ;IAED,OAAO,IAAI,CAAA;AACf,CAAC;AArBD,8BAqBC;AAED;;;GAGG;AACH,SAAgB,OAAO,CAAI,IAAO;IAC9B,OAAO,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;AAC3C,CAAC;AAFD,0BAEC;AAED;;;GAGG;AACH,SAAgB,aAAa;IACzB,OAAO,IAAI,CAAC,MAAM,EAAE,CAAC,QAAQ,CAAC,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;AAC/C,CAAC;AAFD,sCAEC",
      sourcesContent: ["/**\n * @description \u5DE5\u5177\u51FD\u6570\u96C6\u5408\n * @author wangfupeng\n */\n\nclass NavUA {\n    public _ua: string\n\n    // \u662F\u5426\u4E3A\u65E7\u7248 Edge\n    public isOldEdge: boolean\n\n    // \u662F\u5426\u4E3A Firefox\n    public isFirefox: boolean\n\n    constructor() {\n        this._ua = navigator.userAgent\n\n        const math = this._ua.match(/(Edge?)\\/(\\d+)/)\n        this.isOldEdge = math && math[1] == 'Edge' && parseInt(math[2]) < 19 ? true : false\n\n        this.isFirefox =\n            /Firefox\\/\\d+/.test(this._ua) && !/Seamonkey\\/\\d+/.test(this._ua) ? true : false\n    }\n\n    // \u662F\u5426\u4E3A IE\n    public isIE() {\n        return 'ActiveXObject' in window\n    }\n\n    // \u662F\u5426\u4E3A webkit\n    public isWebkit() {\n        return /webkit/i.test(this._ua)\n    }\n}\n\n// \u548C UA \u76F8\u5173\u7684\u5C5E\u6027\nexport const UA = new NavUA()\n\n/**\n * \u83B7\u53D6\u968F\u673A\u5B57\u7B26\n * @param prefix \u524D\u7F00\n */\nexport function getRandom(prefix: string = ''): string {\n    return prefix + Math.random().toString().slice(2)\n}\n\n/**\n * \u66FF\u6362 html \u7279\u6B8A\u5B57\u7B26\n * @param html html \u5B57\u7B26\u4E32\n */\nexport function replaceHtmlSymbol(html: string) {\n    return html\n        .replace(/</gm, '&lt;')\n        .replace(/>/gm, '&gt;')\n        .replace(/\"/gm, '&quot;')\n        .replace(/(\\r\\n|\\r|\\n)/g, '<br/>')\n}\n\nexport function replaceSpecialSymbol(value: string) {\n    return value\n        .replace(/&lt;/gm, '<')\n        .replace(/&gt;/gm, '>')\n        .replace(/&quot;/gm, '\"')\n}\n\ninterface Obj {\n    [key: string]: unknown\n    [key: number]: unknown\n}\ninterface ArrObj {\n    length: number\n    [key: number]: unknown\n}\n\n/**\n * \u904D\u5386\u5BF9\u8C61\u6216\u6570\u7EC4\uFF0C\u6267\u884C\u56DE\u8C03\u51FD\u6570\n * @param obj \u5BF9\u8C61\u6216\u6570\u7EC4\n * @param fn \u56DE\u8C03\u51FD\u6570 (key, val) => {...}\n */\nexport function forEach<T extends ArrObj, V = T[Extract<keyof T, number>]>(\n    obj: T,\n    fn: (key: string, value: V) => boolean | void\n): void\nexport function forEach<T extends Obj>(\n    obj: T,\n    fn: (key: string, value: T[Extract<keyof T, string | number>]) => boolean | void\n): void\nexport function forEach<T extends unknown[]>(\n    obj: T,\n    fn: (key: string, value: T[Extract<keyof T, number>]) => boolean | void\n): void\nexport function forEach<T extends unknown[] | Obj | ArrObj>(\n    obj: T,\n    fn: (\n        key: string,\n        value: T[Extract<keyof T, number>] | T[Extract<keyof T, string>]\n    ) => boolean | void\n): void {\n    for (let key in obj) {\n        if (Object.prototype.hasOwnProperty.call(obj, key)) {\n            const result = fn(key, obj[key])\n            if (result === false) {\n                // \u63D0\u524D\u7EC8\u6B62\u5FAA\u73AF\n                break\n            }\n        }\n    }\n}\n\n/**\n * \u904D\u5386\u7C7B\u6570\u7EC4\n * @param fakeArr \u7C7B\u6570\u7EC4\n * @param fn \u56DE\u8C03\u51FD\u6570\n */\nexport function arrForEach<T extends { length: number; [key: number]: unknown }>(\n    fakeArr: T,\n    fn: (this: T, item: T[number], index: number) => boolean | unknown\n): void {\n    let i, item, result\n    const length = fakeArr.length || 0\n    for (i = 0; i < length; i++) {\n        item = fakeArr[i]\n        result = fn.call(fakeArr, item, i)\n        if (result === false) {\n            break\n        }\n    }\n}\n\n/**\n * \u8282\u6D41\n * @param fn \u51FD\u6570\n * @param interval \u95F4\u9694\u65F6\u95F4\uFF0C\u6BEB\u79D2\n */\n\nexport function throttle<C, T extends unknown[]>(\n    fn: (this: C, ...args: T) => unknown,\n    interval: number = 200\n) {\n    let flag = false\n    return function (this: C, ...args: T): void {\n        if (!flag) {\n            flag = true\n            setTimeout(() => {\n                flag = false\n                fn.call(this, ...args) // this \u62A5\u8BED\u6CD5\u9519\u8BEF\uFF0C\u5148\u7528 null\n            }, interval)\n        }\n    }\n}\n\n/**\n * \u9632\u6296\n * @param fn \u51FD\u6570\n * @param delay \u95F4\u9694\u65F6\u95F4\uFF0C\u6BEB\u79D2\n */\nexport function debounce<C, T extends unknown[]>(\n    fn: (this: C, ...args: T) => void,\n    delay: number = 200\n): (this: C, ...args: T) => void {\n    let lastFn = 0\n    return function (...args: T) {\n        if (lastFn) {\n            window.clearTimeout(lastFn)\n        }\n        lastFn = window.setTimeout(() => {\n            lastFn = 0\n            fn.call(this, ...args) // this \u62A5\u8BED\u6CD5\u9519\u8BEF\uFF0C\u5148\u7528 null\n        }, delay)\n    }\n}\n\n/**\n * isFunction \u662F\u5426\u662F\u51FD\u6570\n * @param fn \u51FD\u6570\n */\nexport function isFunction(fn: any): fn is Function {\n    return typeof fn === 'function'\n}\n\n/**\n * \u5F15\u7528\u4E0E\u975E\u5F15\u7528\u503C \u6DF1\u62F7\u8D1D\u65B9\u6CD5\n * @param data\n */\nexport function deepClone<T>(data: T): T {\n    if (typeof data !== 'object' || typeof data == 'function' || data === null) {\n        return data\n    }\n\n    let item: any\n    if (Array.isArray(data)) {\n        item = []\n    }\n\n    if (!Array.isArray(data)) {\n        item = {}\n    }\n\n    for (let i in data) {\n        if (Object.prototype.hasOwnProperty.call(data, i)) {\n            item[i] = deepClone(data[i])\n        }\n    }\n\n    return item\n}\n\n/**\n * \u5C06\u53EF\u904D\u5386\u7684\u5BF9\u8C61\u8F6C\u6362\u4E3A\u6570\u7EC4\n * @param data \u53EF\u904D\u5386\u7684\u5BF9\u8C61\n */\nexport function toArray<T>(data: T) {\n    return Array.prototype.slice.call(data)\n}\n\n/**\n * \u552F\u4E00id\u751F\u6210\n * @param length \u968F\u673A\u6570\u957F\u5EA6\n */\nexport function getRandomCode() {\n    return Math.random().toString(36).slice(-5)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1f2ed621bcb96cc4496202c7b7bea714821f820d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23rlp2sm0s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_23rlp2sm0s();

var __spreadArrays = (cov_23rlp2sm0s().s[0]++, (cov_23rlp2sm0s().b[0][0]++, void 0) && (cov_23rlp2sm0s().b[0][1]++, (void 0).__spreadArrays) || (cov_23rlp2sm0s().b[0][2]++, function () {
  cov_23rlp2sm0s().f[0]++;
  cov_23rlp2sm0s().s[1]++;

  for (var s = (cov_23rlp2sm0s().s[2]++, 0), i = (cov_23rlp2sm0s().s[3]++, 0), il = (cov_23rlp2sm0s().s[4]++, arguments.length); i < il; i++) {
    cov_23rlp2sm0s().s[5]++;
    s += arguments[i].length;
  }

  cov_23rlp2sm0s().s[6]++;

  for (var r = (cov_23rlp2sm0s().s[7]++, Array(s)), k = (cov_23rlp2sm0s().s[8]++, 0), i = (cov_23rlp2sm0s().s[9]++, 0); i < il; i++) {
    cov_23rlp2sm0s().s[10]++;

    for (var a = (cov_23rlp2sm0s().s[11]++, arguments[i]), j = (cov_23rlp2sm0s().s[12]++, 0), jl = (cov_23rlp2sm0s().s[13]++, a.length); j < jl; j++, k++) {
      cov_23rlp2sm0s().s[14]++;
      r[k] = a[j];
    }
  }

  cov_23rlp2sm0s().s[15]++;
  return r;
}));

cov_23rlp2sm0s().s[16]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_23rlp2sm0s().s[17]++;
exports.getRandomCode = exports.toArray = exports.deepClone = exports.isFunction = exports.debounce = exports.throttle = exports.arrForEach = exports.forEach = exports.replaceSpecialSymbol = exports.replaceHtmlSymbol = exports.getRandom = exports.UA = void 0;
var NavUA = (
/** @class */
cov_23rlp2sm0s().s[18]++, function () {
  cov_23rlp2sm0s().f[1]++;

  function NavUA() {
    cov_23rlp2sm0s().f[2]++;
    cov_23rlp2sm0s().s[19]++;
    this._ua = navigator.userAgent;
    var math = (cov_23rlp2sm0s().s[20]++, this._ua.match(/(Edge?)\/(\d+)/));
    cov_23rlp2sm0s().s[21]++;
    this.isOldEdge = (cov_23rlp2sm0s().b[2][0]++, math) && (cov_23rlp2sm0s().b[2][1]++, math[1] == 'Edge') && (cov_23rlp2sm0s().b[2][2]++, (0, _parseInt2["default"])(math[2]) < 19) ? (cov_23rlp2sm0s().b[1][0]++, true) : (cov_23rlp2sm0s().b[1][1]++, false);
    cov_23rlp2sm0s().s[22]++;
    this.isFirefox = (cov_23rlp2sm0s().b[4][0]++, /Firefox\/\d+/.test(this._ua)) && (cov_23rlp2sm0s().b[4][1]++, !/Seamonkey\/\d+/.test(this._ua)) ? (cov_23rlp2sm0s().b[3][0]++, true) : (cov_23rlp2sm0s().b[3][1]++, false);
  } // 是否为 IE


  cov_23rlp2sm0s().s[23]++;

  NavUA.prototype.isIE = function () {
    cov_23rlp2sm0s().f[3]++;
    cov_23rlp2sm0s().s[24]++;
    return 'ActiveXObject' in window;
  }; // 是否为 webkit


  cov_23rlp2sm0s().s[25]++;

  NavUA.prototype.isWebkit = function () {
    cov_23rlp2sm0s().f[4]++;
    cov_23rlp2sm0s().s[26]++;
    return /webkit/i.test(this._ua);
  };

  cov_23rlp2sm0s().s[27]++;
  return NavUA;
}()); // 和 UA 相关的属性

cov_23rlp2sm0s().s[28]++;
exports.UA = new NavUA();
/**
 * 获取随机字符
 * @param prefix 前缀
 */

function getRandom(prefix) {
  var _context;

  cov_23rlp2sm0s().f[5]++;
  cov_23rlp2sm0s().s[29]++;

  if (prefix === void 0) {
    cov_23rlp2sm0s().b[5][0]++;
    cov_23rlp2sm0s().s[30]++;
    prefix = '';
  } else {
    cov_23rlp2sm0s().b[5][1]++;
  }

  cov_23rlp2sm0s().s[31]++;
  return prefix + (0, _slice["default"])(_context = Math.random().toString()).call(_context, 2);
}

cov_23rlp2sm0s().s[32]++;
exports.getRandom = getRandom;
/**
 * 替换 html 特殊字符
 * @param html html 字符串
 */

function replaceHtmlSymbol(html) {
  cov_23rlp2sm0s().f[6]++;
  cov_23rlp2sm0s().s[33]++;
  return html.replace(/</gm, '&lt;').replace(/>/gm, '&gt;').replace(/"/gm, '&quot;').replace(/(\r\n|\r|\n)/g, '<br/>');
}

cov_23rlp2sm0s().s[34]++;
exports.replaceHtmlSymbol = replaceHtmlSymbol;

function replaceSpecialSymbol(value) {
  cov_23rlp2sm0s().f[7]++;
  cov_23rlp2sm0s().s[35]++;
  return value.replace(/&lt;/gm, '<').replace(/&gt;/gm, '>').replace(/&quot;/gm, '"');
}

cov_23rlp2sm0s().s[36]++;
exports.replaceSpecialSymbol = replaceSpecialSymbol;

function forEach(obj, fn) {
  cov_23rlp2sm0s().f[8]++;
  cov_23rlp2sm0s().s[37]++;

  for (var key in obj) {
    cov_23rlp2sm0s().s[38]++;

    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      cov_23rlp2sm0s().b[6][0]++;
      var result = (cov_23rlp2sm0s().s[39]++, fn(key, obj[key]));
      cov_23rlp2sm0s().s[40]++;

      if (result === false) {
        cov_23rlp2sm0s().b[7][0]++;
        cov_23rlp2sm0s().s[41]++;
        // 提前终止循环
        break;
      } else {
        cov_23rlp2sm0s().b[7][1]++;
      }
    } else {
      cov_23rlp2sm0s().b[6][1]++;
    }
  }
}

cov_23rlp2sm0s().s[42]++;
exports.forEach = forEach;
/**
 * 遍历类数组
 * @param fakeArr 类数组
 * @param fn 回调函数
 */

function arrForEach(fakeArr, fn) {
  cov_23rlp2sm0s().f[9]++;
  var i, item, result;
  var length = (cov_23rlp2sm0s().s[43]++, (cov_23rlp2sm0s().b[8][0]++, fakeArr.length) || (cov_23rlp2sm0s().b[8][1]++, 0));
  cov_23rlp2sm0s().s[44]++;

  for (i = 0; i < length; i++) {
    cov_23rlp2sm0s().s[45]++;
    item = fakeArr[i];
    cov_23rlp2sm0s().s[46]++;
    result = fn.call(fakeArr, item, i);
    cov_23rlp2sm0s().s[47]++;

    if (result === false) {
      cov_23rlp2sm0s().b[9][0]++;
      cov_23rlp2sm0s().s[48]++;
      break;
    } else {
      cov_23rlp2sm0s().b[9][1]++;
    }
  }
}

cov_23rlp2sm0s().s[49]++;
exports.arrForEach = arrForEach;
/**
 * 节流
 * @param fn 函数
 * @param interval 间隔时间，毫秒
 */

function throttle(fn, interval) {
  cov_23rlp2sm0s().f[10]++;
  cov_23rlp2sm0s().s[50]++;

  if (interval === void 0) {
    cov_23rlp2sm0s().b[10][0]++;
    cov_23rlp2sm0s().s[51]++;
    interval = 200;
  } else {
    cov_23rlp2sm0s().b[10][1]++;
  }

  var flag = (cov_23rlp2sm0s().s[52]++, false);
  cov_23rlp2sm0s().s[53]++;
  return function () {
    cov_23rlp2sm0s().f[11]++;

    var _this = (cov_23rlp2sm0s().s[54]++, this);

    var args = (cov_23rlp2sm0s().s[55]++, []);
    cov_23rlp2sm0s().s[56]++;

    for (var _i = (cov_23rlp2sm0s().s[57]++, 0); _i < arguments.length; _i++) {
      cov_23rlp2sm0s().s[58]++;
      args[_i] = arguments[_i];
    }

    cov_23rlp2sm0s().s[59]++;

    if (!flag) {
      cov_23rlp2sm0s().b[11][0]++;
      cov_23rlp2sm0s().s[60]++;
      flag = true;
      cov_23rlp2sm0s().s[61]++;
      (0, _setTimeout2["default"])(function () {
        cov_23rlp2sm0s().f[12]++;
        cov_23rlp2sm0s().s[62]++;
        flag = false;
        cov_23rlp2sm0s().s[63]++;
        fn.call.apply(fn, __spreadArrays([_this], args)); // this 报语法错误，先用 null
      }, interval);
    } else {
      cov_23rlp2sm0s().b[11][1]++;
    }
  };
}

cov_23rlp2sm0s().s[64]++;
exports.throttle = throttle;
/**
 * 防抖
 * @param fn 函数
 * @param delay 间隔时间，毫秒
 */

function debounce(fn, delay) {
  cov_23rlp2sm0s().f[13]++;
  cov_23rlp2sm0s().s[65]++;

  if (delay === void 0) {
    cov_23rlp2sm0s().b[12][0]++;
    cov_23rlp2sm0s().s[66]++;
    delay = 200;
  } else {
    cov_23rlp2sm0s().b[12][1]++;
  }

  var lastFn = (cov_23rlp2sm0s().s[67]++, 0);
  cov_23rlp2sm0s().s[68]++;
  return function () {
    cov_23rlp2sm0s().f[14]++;

    var _this = (cov_23rlp2sm0s().s[69]++, this);

    var args = (cov_23rlp2sm0s().s[70]++, []);
    cov_23rlp2sm0s().s[71]++;

    for (var _i = (cov_23rlp2sm0s().s[72]++, 0); _i < arguments.length; _i++) {
      cov_23rlp2sm0s().s[73]++;
      args[_i] = arguments[_i];
    }

    cov_23rlp2sm0s().s[74]++;

    if (lastFn) {
      cov_23rlp2sm0s().b[13][0]++;
      cov_23rlp2sm0s().s[75]++;
      window.clearTimeout(lastFn);
    } else {
      cov_23rlp2sm0s().b[13][1]++;
    }

    cov_23rlp2sm0s().s[76]++;
    lastFn = window.setTimeout(function () {
      cov_23rlp2sm0s().f[15]++;
      cov_23rlp2sm0s().s[77]++;
      lastFn = 0;
      cov_23rlp2sm0s().s[78]++;
      fn.call.apply(fn, __spreadArrays([_this], args)); // this 报语法错误，先用 null
    }, delay);
  };
}

cov_23rlp2sm0s().s[79]++;
exports.debounce = debounce;
/**
 * isFunction 是否是函数
 * @param fn 函数
 */

function isFunction(fn) {
  cov_23rlp2sm0s().f[16]++;
  cov_23rlp2sm0s().s[80]++;
  return typeof fn === 'function';
}

cov_23rlp2sm0s().s[81]++;
exports.isFunction = isFunction;
/**
 * 引用与非引用值 深拷贝方法
 * @param data
 */

function deepClone(data) {
  cov_23rlp2sm0s().f[17]++;
  cov_23rlp2sm0s().s[82]++;

  if ((cov_23rlp2sm0s().b[15][0]++, (0, _typeof2["default"])(data) !== 'object') || (cov_23rlp2sm0s().b[15][1]++, typeof data == 'function') || (cov_23rlp2sm0s().b[15][2]++, data === null)) {
    cov_23rlp2sm0s().b[14][0]++;
    cov_23rlp2sm0s().s[83]++;
    return data;
  } else {
    cov_23rlp2sm0s().b[14][1]++;
  }

  var item;
  cov_23rlp2sm0s().s[84]++;

  if ((0, _isArray["default"])(data)) {
    cov_23rlp2sm0s().b[16][0]++;
    cov_23rlp2sm0s().s[85]++;
    item = [];
  } else {
    cov_23rlp2sm0s().b[16][1]++;
  }

  cov_23rlp2sm0s().s[86]++;

  if (!(0, _isArray["default"])(data)) {
    cov_23rlp2sm0s().b[17][0]++;
    cov_23rlp2sm0s().s[87]++;
    item = {};
  } else {
    cov_23rlp2sm0s().b[17][1]++;
  }

  cov_23rlp2sm0s().s[88]++;

  for (var i in data) {
    cov_23rlp2sm0s().s[89]++;

    if (Object.prototype.hasOwnProperty.call(data, i)) {
      cov_23rlp2sm0s().b[18][0]++;
      cov_23rlp2sm0s().s[90]++;
      item[i] = deepClone(data[i]);
    } else {
      cov_23rlp2sm0s().b[18][1]++;
    }
  }

  cov_23rlp2sm0s().s[91]++;
  return item;
}

cov_23rlp2sm0s().s[92]++;
exports.deepClone = deepClone;
/**
 * 将可遍历的对象转换为数组
 * @param data 可遍历的对象
 */

function toArray(data) {
  cov_23rlp2sm0s().f[18]++;
  cov_23rlp2sm0s().s[93]++;
  return (0, _slice["default"])(Array.prototype).call(data);
}

cov_23rlp2sm0s().s[94]++;
exports.toArray = toArray;
/**
 * 唯一id生成
 * @param length 随机数长度
 */

function getRandomCode() {
  var _context2;

  cov_23rlp2sm0s().f[19]++;
  cov_23rlp2sm0s().s[95]++;
  return (0, _slice["default"])(_context2 = Math.random().toString(36)).call(_context2, -5);
}

cov_23rlp2sm0s().s[96]++;
exports.getRandomCode = getRandomCode;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(131)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var shared = __webpack_require__(72);
var has = __webpack_require__(15);
var uid = __webpack_require__(60);
var NATIVE_SYMBOL = __webpack_require__(76);
var USE_SYMBOL_AS_UID = __webpack_require__(100);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(10);
var has = __webpack_require__(15);
var wrappedWellKnownSymbolModule = __webpack_require__(92);
var defineProperty = __webpack_require__(17).f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var definePropertyModule = __webpack_require__(17);
var createPropertyDescriptor = __webpack_require__(33);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(96);
var anObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(10);

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(210);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 下拉菜单 Class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_uf64jtqji() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropListMenu.ts";
  var hash = "95b678c35331f0786c30e0d5a8b39d8cadbc211e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropListMenu.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 24,
          column: 47
        }
      },
      "17": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 55
        }
      },
      "18": {
        start: {
          line: 26,
          column: 34
        },
        end: {
          line: 73,
          column: 17
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 36
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 60
        }
      },
      "21": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 74
        }
      },
      "22": {
        start: {
          line: 33,
          column: 24
        },
        end: {
          line: 33,
          column: 80
        }
      },
      "23": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 45,
          column: 9
        }
      },
      "24": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 44,
          column: 15
        }
      },
      "25": {
        start: {
          line: 36,
          column: 28
        },
        end: {
          line: 36,
          column: 38
        }
      },
      "26": {
        start: {
          line: 37,
          column: 32
        },
        end: {
          line: 37,
          column: 68
        }
      },
      "27": {
        start: {
          line: 38,
          column: 16
        },
        end: {
          line: 43,
          column: 17
        }
      },
      "28": {
        start: {
          line: 39,
          column: 35
        },
        end: {
          line: 39,
          column: 112
        }
      },
      "29": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 42,
          column: 21
        }
      },
      "30": {
        start: {
          line: 41,
          column: 24
        },
        end: {
          line: 41,
          column: 50
        }
      },
      "31": {
        start: {
          line: 47,
          column: 23
        },
        end: {
          line: 47,
          column: 58
        }
      },
      "32": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 34
        }
      },
      "33": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 69,
          column: 11
        }
      },
      "34": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 54,
          column: 13
        }
      },
      "35": {
        start: {
          line: 53,
          column: 16
        },
        end: {
          line: 53,
          column: 23
        }
      },
      "36": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 60
        }
      },
      "37": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 98
        }
      },
      "38": {
        start: {
          line: 57,
          column: 82
        },
        end: {
          line: 57,
          column: 94
        }
      },
      "39": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 61,
          column: 20
        }
      },
      "40": {
        start: {
          line: 60,
          column: 16
        },
        end: {
          line: 60,
          column: 32
        }
      },
      "41": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 41
        }
      },
      "42": {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 68,
          column: 15
        }
      },
      "43": {
        start: {
          line: 67,
          column: 16
        },
        end: {
          line: 67,
          column: 32
        }
      },
      "44": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 21
        }
      },
      "45": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 24
        }
      },
      "46": {
        start: {
          line: 74,
          column: 0
        },
        end: {
          line: 74,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 26,
            column: 35
          }
        },
        loc: {
          start: {
            line: 26,
            column: 52
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "DropListMenu",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 25
          }
        },
        loc: {
          start: {
            line: 28,
            column: 47
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 35,
            column: 30
          },
          end: {
            line: 35,
            column: 31
          }
        },
        loc: {
          start: {
            line: 35,
            column: 46
          },
          end: {
            line: 44,
            column: 13
          }
        },
        line: 35
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 51,
            column: 30
          },
          end: {
            line: 51,
            column: 31
          }
        },
        loc: {
          start: {
            line: 51,
            column: 42
          },
          end: {
            line: 62,
            column: 9
          }
        },
        line: 51
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 57,
            column: 66
          },
          end: {
            line: 57,
            column: 67
          }
        },
        loc: {
          start: {
            line: 57,
            column: 80
          },
          end: {
            line: 57,
            column: 96
          }
        },
        line: 57
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 59,
            column: 55
          },
          end: {
            line: 59,
            column: 56
          }
        },
        loc: {
          start: {
            line: 59,
            column: 67
          },
          end: {
            line: 61,
            column: 13
          }
        },
        line: 59
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 63,
            column: 30
          },
          end: {
            line: 63,
            column: 31
          }
        },
        loc: {
          start: {
            line: 63,
            column: 42
          },
          end: {
            line: 69,
            column: 9
          }
        },
        line: 63
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 66,
            column: 55
          },
          end: {
            line: 66,
            column: 56
          }
        },
        loc: {
          start: {
            line: 66,
            column: 67
          },
          end: {
            line: 68,
            column: 13
          }
        },
        line: 66
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 52
          }
        }, {
          start: {
            line: 29,
            column: 56
          },
          end: {
            line: 29,
            column: 60
          }
        }],
        line: 29
      },
      "8": {
        loc: {
          start: {
            line: 33,
            column: 24
          },
          end: {
            line: 33,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 57
          },
          end: {
            line: 33,
            column: 59
          }
        }, {
          start: {
            line: 33,
            column: 62
          },
          end: {
            line: 33,
            column: 80
          }
        }],
        line: 33
      },
      "9": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }],
        line: 34
      },
      "10": {
        loc: {
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 34,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 34,
            column: 28
          }
        }, {
          start: {
            line: 34,
            column: 32
          },
          end: {
            line: 34,
            column: 52
          }
        }],
        line: 34
      },
      "11": {
        loc: {
          start: {
            line: 38,
            column: 16
          },
          end: {
            line: 43,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 16
          },
          end: {
            line: 43,
            column: 17
          }
        }, {
          start: {
            line: 38,
            column: 16
          },
          end: {
            line: 43,
            column: 17
          }
        }],
        line: 38
      },
      "12": {
        loc: {
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 39,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 80
          },
          end: {
            line: 39,
            column: 86
          }
        }, {
          start: {
            line: 39,
            column: 89
          },
          end: {
            line: 39,
            column: 112
          }
        }],
        line: 39
      },
      "13": {
        loc: {
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 39,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 39,
            column: 53
          }
        }, {
          start: {
            line: 39,
            column: 57
          },
          end: {
            line: 39,
            column: 77
          }
        }],
        line: 39
      },
      "14": {
        loc: {
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 42,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 42,
            column: 21
          }
        }, {
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 42,
            column: 21
          }
        }],
        line: 40
      },
      "15": {
        loc: {
          start: {
            line: 40,
            column: 24
          },
          end: {
            line: 40,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 24
          },
          end: {
            line: 40,
            column: 32
          }
        }, {
          start: {
            line: 40,
            column: 36
          },
          end: {
            line: 40,
            column: 52
          }
        }],
        line: 40
      },
      "16": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 54,
            column: 13
          }
        }],
        line: 52
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropListMenu.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropListMenu.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoD;AAEpD,gDAAyB;AACzB,wDAAmD;AAEnD;IAA2B,gCAAI;IAG3B,sBAAY,KAAiB,EAAE,MAAc,EAAE,IAAkB;QAAjE,YACI,kBAAM,KAAK,EAAE,MAAM,CAAC,SA6CvB;QA3CG,MAAM;QACN,IAAI,CAAC,KAAK,GAAG,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,wBAAsB,IAAI,CAAC,KAAO,CAAC,CAAA;QAEjE,wBAAwB;QACxB,IAAM,SAAS,GAAW,MAAM,CAAC,MAAM,CAAC,IAAI,KAAK,OAAO,CAAC,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC,kBAAkB,CAAA;QAClF,IAAI,SAAS,KAAK,EAAE,IAAI,IAAI,CAAC,IAAI,KAAK,MAAM,EAAE;YAC1C,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;gBAClB,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAA;gBACxB,IAAM,SAAS,GAAG,kBAAC,CAAC,KAAK,CAAC,QAAQ,EAAE,CAAC,CAAA;gBACrC,IAAI,SAAS,CAAC,MAAM,GAAG,CAAC,EAAE;oBACtB,IAAM,QAAQ,GAAG,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,WAAW,EAAE,CAAA;oBACzC,IAAI,QAAQ,IAAI,QAAQ,KAAK,GAAG,EAAE;wBAC9B,KAAK,CAAC,QAAQ,CAAC,SAAS,CAAC,CAAA;qBAC5B;iBACJ;YACL,CAAC,CAAC,CAAA;SACL;QAED,eAAe;QACf,IAAM,QAAQ,GAAG,IAAI,kBAAQ,CAAC,KAAI,EAAE,IAAI,CAAC,CAAA;QACzC,KAAI,CAAC,QAAQ,GAAG,QAAQ,CAAA;QAExB,OAAO;QACP,KAAK;aACA,EAAE,CAAC,YAAY,EAAE;YACd,IAAI,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,IAAI,IAAI,EAAE;gBACrC,OAAM;aACT;YACD,KAAK,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,MAAM,CAAC,CAAC,CAAA;YAC/C,mBAAmB;YACnB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,uBAAuB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,EAAE,EAAJ,CAAI,CAAC,CAAA;YACjE,KAAK;YACL,QAAQ,CAAC,aAAa,GAAG,MAAM,CAAC,UAAU,CAAC;gBACvC,QAAQ,CAAC,IAAI,EAAE,CAAA;YACnB,CAAC,EAAE,GAAG,CAAC,CAAA;QACX,CAAC,CAAC;aACD,EAAE,CAAC,YAAY,EAAE;YACd,KAAK,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,CAAA;YAC5B,KAAK;YACL,QAAQ,CAAC,aAAa,GAAG,MAAM,CAAC,UAAU,CAAC;gBACvC,QAAQ,CAAC,IAAI,EAAE,CAAA;YACnB,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;;IACV,CAAC;IACL,mBAAC;AAAD,CAAC,AAlDD,CAA2B,cAAI,GAkD9B;AAED,kBAAe,YAAY,CAAA",
      sourcesContent: ["/**\n * @description \u4E0B\u62C9\u83DC\u5355 Class\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport Menu from './Menu'\nimport DropList, { DropListConf } from './DropList'\n\nclass DropListMenu extends Menu {\n    public dropList: DropList\n\n    constructor($elem: DomElement, editor: Editor, conf: DropListConf) {\n        super($elem, editor)\n\n        // \u56FD\u9645\u5316\n        conf.title = editor.i18next.t(`menus.dropListMenu.${conf.title}`)\n\n        // \u975E\u4E2D\u6587\u6A21\u5F0F\u4E0B \u5E26 icon \u7684\u4E0B\u62C9\u5217\u8868\u5C45\u5DE6\n        const className: string = editor.config.lang === 'zh-CN' ? '' : 'w-e-drop-list-tl'\n        if (className !== '' && conf.type === 'list') {\n            conf.list.forEach(item => {\n                const $elem = item.$elem\n                const $children = $($elem.children())\n                if ($children.length > 0) {\n                    const nodeName = $children?.getNodeName()\n                    if (nodeName && nodeName === 'I') {\n                        $elem.addClass(className)\n                    }\n                }\n            })\n        }\n\n        // \u521D\u59CB\u5316 dropList\n        const dropList = new DropList(this, conf)\n        this.dropList = dropList\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\n        $elem\n            .on('mouseenter', () => {\n                if (editor.selection.getRange() == null) {\n                    return\n                }\n                $elem.css('z-index', editor.zIndex.get('menu'))\n                // \u89E6\u53D1 droplist \u60AC\u6D6E\u4E8B\u4EF6\n                editor.txt.eventHooks.dropListMenuHoverEvents.forEach(fn => fn())\n                // \u663E\u793A\n                dropList.showTimeoutId = window.setTimeout(() => {\n                    dropList.show()\n                }, 200)\n            })\n            .on('mouseleave', () => {\n                $elem.css('z-index', 'auto')\n                // \u9690\u85CF\n                dropList.hideTimeoutId = window.setTimeout(() => {\n                    dropList.hide()\n                })\n            })\n    }\n}\n\nexport default DropListMenu\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "95b678c35331f0786c30e0d5a8b39d8cadbc211e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_uf64jtqji = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_uf64jtqji();

var __extends = (cov_uf64jtqji().s[0]++, (cov_uf64jtqji().b[0][0]++, void 0) && (cov_uf64jtqji().b[0][1]++, (void 0).__extends) || (cov_uf64jtqji().b[0][2]++, function () {
  cov_uf64jtqji().f[0]++;
  cov_uf64jtqji().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_uf64jtqji().f[1]++;
    cov_uf64jtqji().s[2]++;
    _extendStatics = (cov_uf64jtqji().b[1][0]++, _setPrototypeOf["default"]) || (cov_uf64jtqji().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_uf64jtqji().b[1][2]++, function (d, b) {
      cov_uf64jtqji().f[2]++;
      cov_uf64jtqji().s[3]++;
      d.__proto__ = b;
    }) || (cov_uf64jtqji().b[1][3]++, function (d, b) {
      cov_uf64jtqji().f[3]++;
      cov_uf64jtqji().s[4]++;

      for (var p in b) {
        cov_uf64jtqji().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_uf64jtqji().b[2][0]++;
          cov_uf64jtqji().s[6]++;
          d[p] = b[p];
        } else {
          cov_uf64jtqji().b[2][1]++;
        }
      }
    });
    cov_uf64jtqji().s[7]++;
    return _extendStatics(d, b);
  };

  cov_uf64jtqji().s[8]++;
  return function (d, b) {
    cov_uf64jtqji().f[4]++;
    cov_uf64jtqji().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_uf64jtqji().f[5]++;
      cov_uf64jtqji().s[10]++;
      this.constructor = d;
    }

    cov_uf64jtqji().s[11]++;
    d.prototype = b === null ? (cov_uf64jtqji().b[3][0]++, (0, _create["default"])(b)) : (cov_uf64jtqji().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_uf64jtqji().s[12]++, (cov_uf64jtqji().b[4][0]++, void 0) && (cov_uf64jtqji().b[4][1]++, (void 0).__importDefault) || (cov_uf64jtqji().b[4][2]++, function (mod) {
  cov_uf64jtqji().f[6]++;
  cov_uf64jtqji().s[13]++;
  return (cov_uf64jtqji().b[6][0]++, mod) && (cov_uf64jtqji().b[6][1]++, mod.__esModule) ? (cov_uf64jtqji().b[5][0]++, mod) : (cov_uf64jtqji().b[5][1]++, {
    "default": mod
  });
}));

cov_uf64jtqji().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_uf64jtqji().s[15]++, __importDefault(__webpack_require__(2)));
var Menu_1 = (cov_uf64jtqji().s[16]++, __importDefault(__webpack_require__(93)));
var DropList_1 = (cov_uf64jtqji().s[17]++, __importDefault(__webpack_require__(124)));
var DropListMenu = (
/** @class */
cov_uf64jtqji().s[18]++, function (_super) {
  cov_uf64jtqji().f[7]++;
  cov_uf64jtqji().s[19]++;

  __extends(DropListMenu, _super);

  function DropListMenu($elem, editor, conf) {
    cov_uf64jtqji().f[8]++;

    var _this = (cov_uf64jtqji().s[20]++, (cov_uf64jtqji().b[7][0]++, _super.call(this, $elem, editor)) || (cov_uf64jtqji().b[7][1]++, this)); // 国际化


    cov_uf64jtqji().s[21]++;
    conf.title = editor.i18next.t("menus.dropListMenu." + conf.title); // 非中文模式下 带 icon 的下拉列表居左

    var className = (cov_uf64jtqji().s[22]++, editor.config.lang === 'zh-CN' ? (cov_uf64jtqji().b[8][0]++, '') : (cov_uf64jtqji().b[8][1]++, 'w-e-drop-list-tl'));
    cov_uf64jtqji().s[23]++;

    if ((cov_uf64jtqji().b[10][0]++, className !== '') && (cov_uf64jtqji().b[10][1]++, conf.type === 'list')) {
      var _context;

      cov_uf64jtqji().b[9][0]++;
      cov_uf64jtqji().s[24]++;
      (0, _forEach["default"])(_context = conf.list).call(_context, function (item) {
        cov_uf64jtqji().f[9]++;
        var $elem = (cov_uf64jtqji().s[25]++, item.$elem);
        var $children = (cov_uf64jtqji().s[26]++, dom_core_1["default"]($elem.children()));
        cov_uf64jtqji().s[27]++;

        if ($children.length > 0) {
          cov_uf64jtqji().b[11][0]++;
          var nodeName = (cov_uf64jtqji().s[28]++, (cov_uf64jtqji().b[13][0]++, $children === null) || (cov_uf64jtqji().b[13][1]++, $children === void 0) ? (cov_uf64jtqji().b[12][0]++, void 0) : (cov_uf64jtqji().b[12][1]++, $children.getNodeName()));
          cov_uf64jtqji().s[29]++;

          if ((cov_uf64jtqji().b[15][0]++, nodeName) && (cov_uf64jtqji().b[15][1]++, nodeName === 'I')) {
            cov_uf64jtqji().b[14][0]++;
            cov_uf64jtqji().s[30]++;
            $elem.addClass(className);
          } else {
            cov_uf64jtqji().b[14][1]++;
          }
        } else {
          cov_uf64jtqji().b[11][1]++;
        }
      });
    } else {
      cov_uf64jtqji().b[9][1]++;
    } // 初始化 dropList


    var dropList = (cov_uf64jtqji().s[31]++, new DropList_1["default"](_this, conf));
    cov_uf64jtqji().s[32]++;
    _this.dropList = dropList; // 绑定事件

    cov_uf64jtqji().s[33]++;
    $elem.on('mouseenter', function () {
      var _context2;

      cov_uf64jtqji().f[10]++;
      cov_uf64jtqji().s[34]++;

      if (editor.selection.getRange() == null) {
        cov_uf64jtqji().b[16][0]++;
        cov_uf64jtqji().s[35]++;
        return;
      } else {
        cov_uf64jtqji().b[16][1]++;
      }

      cov_uf64jtqji().s[36]++;
      $elem.css('z-index', editor.zIndex.get('menu')); // 触发 droplist 悬浮事件

      cov_uf64jtqji().s[37]++;
      (0, _forEach["default"])(_context2 = editor.txt.eventHooks.dropListMenuHoverEvents).call(_context2, function (fn) {
        cov_uf64jtqji().f[11]++;
        cov_uf64jtqji().s[38]++;
        return fn();
      }); // 显示

      cov_uf64jtqji().s[39]++;
      dropList.showTimeoutId = window.setTimeout(function () {
        cov_uf64jtqji().f[12]++;
        cov_uf64jtqji().s[40]++;
        dropList.show();
      }, 200);
    }).on('mouseleave', function () {
      cov_uf64jtqji().f[13]++;
      cov_uf64jtqji().s[41]++;
      $elem.css('z-index', 'auto'); // 隐藏

      cov_uf64jtqji().s[42]++;
      dropList.hideTimeoutId = window.setTimeout(function () {
        cov_uf64jtqji().f[14]++;
        cov_uf64jtqji().s[43]++;
        dropList.hide();
      });
    });
    cov_uf64jtqji().s[44]++;
    return _this;
  }

  cov_uf64jtqji().s[45]++;
  return DropListMenu;
}(Menu_1["default"]));
cov_uf64jtqji().s[46]++;
exports["default"] = DropListMenu;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 按钮菜单 Class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_133juveve1() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/BtnMenu.ts";
  var hash = "7c228e2fadbadf411d2b3d4b59f769d607d12ddd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/BtnMenu.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 13
        },
        end: {
          line: 23,
          column: 47
        }
      },
      "16": {
        start: {
          line: 24,
          column: 29
        },
        end: {
          line: 30,
          column: 17
        }
      },
      "17": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 31
        }
      },
      "18": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 56
        }
      },
      "19": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 19
        }
      },
      "20": {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 31,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 24,
            column: 29
          },
          end: {
            line: 24,
            column: 30
          }
        },
        loc: {
          start: {
            line: 24,
            column: 47
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 24
      },
      "8": {
        name: "BtnMenu",
        decl: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 20
          }
        },
        loc: {
          start: {
            line: 26,
            column: 36
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 26
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 27,
            column: 15
          },
          end: {
            line: 27,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 15
          },
          end: {
            line: 27,
            column: 47
          }
        }, {
          start: {
            line: 27,
            column: 51
          },
          end: {
            line: 27,
            column: 55
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/BtnMenu.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/BtnMenu.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAIH,gDAAyB;AAEzB;IAAsB,2BAAI;IACtB,iBAAY,KAAiB,EAAE,MAAc;eACzC,kBAAM,KAAK,EAAE,MAAM,CAAC;IACxB,CAAC;IACL,cAAC;AAAD,CAAC,AAJD,CAAsB,cAAI,GAIzB;AAED,kBAAe,OAAO,CAAA",
      sourcesContent: ["/**\n * @description \u6309\u94AE\u83DC\u5355 Class\n * @author wangfupeng\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport Menu from './Menu'\n\nclass BtnMenu extends Menu {\n    constructor($elem: DomElement, editor: Editor) {\n        super($elem, editor)\n    }\n}\n\nexport default BtnMenu\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7c228e2fadbadf411d2b3d4b59f769d607d12ddd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_133juveve1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_133juveve1();

var __extends = (cov_133juveve1().s[0]++, (cov_133juveve1().b[0][0]++, void 0) && (cov_133juveve1().b[0][1]++, (void 0).__extends) || (cov_133juveve1().b[0][2]++, function () {
  cov_133juveve1().f[0]++;
  cov_133juveve1().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_133juveve1().f[1]++;
    cov_133juveve1().s[2]++;
    _extendStatics = (cov_133juveve1().b[1][0]++, _setPrototypeOf["default"]) || (cov_133juveve1().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_133juveve1().b[1][2]++, function (d, b) {
      cov_133juveve1().f[2]++;
      cov_133juveve1().s[3]++;
      d.__proto__ = b;
    }) || (cov_133juveve1().b[1][3]++, function (d, b) {
      cov_133juveve1().f[3]++;
      cov_133juveve1().s[4]++;

      for (var p in b) {
        cov_133juveve1().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_133juveve1().b[2][0]++;
          cov_133juveve1().s[6]++;
          d[p] = b[p];
        } else {
          cov_133juveve1().b[2][1]++;
        }
      }
    });
    cov_133juveve1().s[7]++;
    return _extendStatics(d, b);
  };

  cov_133juveve1().s[8]++;
  return function (d, b) {
    cov_133juveve1().f[4]++;
    cov_133juveve1().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_133juveve1().f[5]++;
      cov_133juveve1().s[10]++;
      this.constructor = d;
    }

    cov_133juveve1().s[11]++;
    d.prototype = b === null ? (cov_133juveve1().b[3][0]++, (0, _create["default"])(b)) : (cov_133juveve1().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_133juveve1().s[12]++, (cov_133juveve1().b[4][0]++, void 0) && (cov_133juveve1().b[4][1]++, (void 0).__importDefault) || (cov_133juveve1().b[4][2]++, function (mod) {
  cov_133juveve1().f[6]++;
  cov_133juveve1().s[13]++;
  return (cov_133juveve1().b[6][0]++, mod) && (cov_133juveve1().b[6][1]++, mod.__esModule) ? (cov_133juveve1().b[5][0]++, mod) : (cov_133juveve1().b[5][1]++, {
    "default": mod
  });
}));

cov_133juveve1().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var Menu_1 = (cov_133juveve1().s[15]++, __importDefault(__webpack_require__(93)));
var BtnMenu = (
/** @class */
cov_133juveve1().s[16]++, function (_super) {
  cov_133juveve1().f[7]++;
  cov_133juveve1().s[17]++;

  __extends(BtnMenu, _super);

  function BtnMenu($elem, editor) {
    cov_133juveve1().f[8]++;
    cov_133juveve1().s[18]++;
    return (cov_133juveve1().b[7][0]++, _super.call(this, $elem, editor)) || (cov_133juveve1().b[7][1]++, this);
  }

  cov_133juveve1().s[19]++;
  return BtnMenu;
}(Menu_1["default"]));
cov_133juveve1().s[20]++;
exports["default"] = BtnMenu;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(67);
var requireObjectCoercible = __webpack_require__(45);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(10);
var global = __webpack_require__(8);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var fails = __webpack_require__(12);
var has = __webpack_require__(15);

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description panel class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _set = _interopRequireDefault(__webpack_require__(123));

var _find = _interopRequireDefault(__webpack_require__(31));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2qz28d5iyj() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Panel.ts";
  var hash = "e8eb64404d7bde69065eb783ca0bf8ec6cf59700";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Panel.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 14
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "5": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 172,
          column: 3
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 25
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 25
        }
      },
      "8": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 88
        }
      },
      "9": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 18,
          column: 32
        }
      },
      "10": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 71
        }
      },
      "11": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 78
        }
      },
      "12": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 83
        }
      },
      "13": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 144,
          column: 6
        }
      },
      "14": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 24
        }
      },
      "15": {
        start: {
          line: 28,
          column: 19
        },
        end: {
          line: 28,
          column: 28
        }
      },
      "16": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "17": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 19
        }
      },
      "18": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 33,
          column: 28
        }
      },
      "19": {
        start: {
          line: 35,
          column: 25
        },
        end: {
          line: 35,
          column: 40
        }
      },
      "20": {
        start: {
          line: 36,
          column: 20
        },
        end: {
          line: 36,
          column: 37
        }
      },
      "21": {
        start: {
          line: 37,
          column: 19
        },
        end: {
          line: 37,
          column: 67
        }
      },
      "22": {
        start: {
          line: 38,
          column: 23
        },
        end: {
          line: 38,
          column: 57
        }
      },
      "23": {
        start: {
          line: 39,
          column: 18
        },
        end: {
          line: 39,
          column: 55
        }
      },
      "24": {
        start: {
          line: 40,
          column: 19
        },
        end: {
          line: 40,
          column: 71
        }
      },
      "25": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 45,
          column: 61
        }
      },
      "26": {
        start: {
          line: 47,
          column: 24
        },
        end: {
          line: 47,
          column: 92
        }
      },
      "27": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "28": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 51,
          column: 11
        }
      },
      "29": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 27
        }
      },
      "30": {
        start: {
          line: 53,
          column: 33
        },
        end: {
          line: 53,
          column: 92
        }
      },
      "31": {
        start: {
          line: 54,
          column: 35
        },
        end: {
          line: 54,
          column: 98
        }
      },
      "32": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 75
        }
      },
      "33": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 57,
          column: 32
        }
      },
      "34": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 60,
          column: 9
        }
      },
      "35": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 88
        }
      },
      "36": {
        start: {
          line: 62,
          column: 19
        },
        end: {
          line: 62,
          column: 34
        }
      },
      "37": {
        start: {
          line: 63,
          column: 26
        },
        end: {
          line: 63,
          column: 28
        }
      },
      "38": {
        start: {
          line: 64,
          column: 28
        },
        end: {
          line: 64,
          column: 30
        }
      },
      "39": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 105,
          column: 11
        }
      },
      "40": {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 68,
          column: 13
        }
      },
      "41": {
        start: {
          line: 67,
          column: 16
        },
        end: {
          line: 67,
          column: 23
        }
      },
      "42": {
        start: {
          line: 69,
          column: 24
        },
        end: {
          line: 69,
          column: 39
        }
      },
      "43": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 70,
          column: 35
        }
      },
      "44": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 88
        }
      },
      "45": {
        start: {
          line: 73,
          column: 12
        },
        end: {
          line: 73,
          column: 46
        }
      },
      "46": {
        start: {
          line: 74,
          column: 27
        },
        end: {
          line: 74,
          column: 50
        }
      },
      "47": {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 75,
          column: 50
        }
      },
      "48": {
        start: {
          line: 77,
          column: 12
        },
        end: {
          line: 77,
          column: 37
        }
      },
      "49": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 41
        }
      },
      "50": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 86,
          column: 13
        }
      },
      "51": {
        start: {
          line: 81,
          column: 16
        },
        end: {
          line: 81,
          column: 44
        }
      },
      "52": {
        start: {
          line: 82,
          column: 16
        },
        end: {
          line: 82,
          column: 46
        }
      },
      "53": {
        start: {
          line: 85,
          column: 16
        },
        end: {
          line: 85,
          column: 32
        }
      },
      "54": {
        start: {
          line: 88,
          column: 12
        },
        end: {
          line: 104,
          column: 15
        }
      },
      "55": {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 91,
          column: 17
        }
      },
      "56": {
        start: {
          line: 90,
          column: 20
        },
        end: {
          line: 90,
          column: 27
        }
      },
      "57": {
        start: {
          line: 93,
          column: 16
        },
        end: {
          line: 96,
          column: 19
        }
      },
      "58": {
        start: {
          line: 94,
          column: 20
        },
        end: {
          line: 94,
          column: 49
        }
      },
      "59": {
        start: {
          line: 95,
          column: 20
        },
        end: {
          line: 95,
          column: 53
        }
      },
      "60": {
        start: {
          line: 97,
          column: 16
        },
        end: {
          line: 99,
          column: 19
        }
      },
      "61": {
        start: {
          line: 98,
          column: 20
        },
        end: {
          line: 98,
          column: 36
        }
      },
      "62": {
        start: {
          line: 101,
          column: 16
        },
        end: {
          line: 101,
          column: 44
        }
      },
      "63": {
        start: {
          line: 102,
          column: 16
        },
        end: {
          line: 102,
          column: 46
        }
      },
      "64": {
        start: {
          line: 103,
          column: 16
        },
        end: {
          line: 103,
          column: 32
        }
      },
      "65": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 110,
          column: 11
        }
      },
      "66": {
        start: {
          line: 109,
          column: 12
        },
        end: {
          line: 109,
          column: 32
        }
      },
      "67": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 38
        }
      },
      "68": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 133,
          column: 11
        }
      },
      "69": {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 117,
          column: 13
        }
      },
      "70": {
        start: {
          line: 116,
          column: 16
        },
        end: {
          line: 116,
          column: 23
        }
      },
      "71": {
        start: {
          line: 118,
          column: 25
        },
        end: {
          line: 118,
          column: 41
        }
      },
      "72": {
        start: {
          line: 119,
          column: 12
        },
        end: {
          line: 132,
          column: 15
        }
      },
      "73": {
        start: {
          line: 120,
          column: 31
        },
        end: {
          line: 120,
          column: 45
        }
      },
      "74": {
        start: {
          line: 121,
          column: 27
        },
        end: {
          line: 121,
          column: 37
        }
      },
      "75": {
        start: {
          line: 122,
          column: 25
        },
        end: {
          line: 122,
          column: 53
        }
      },
      "76": {
        start: {
          line: 123,
          column: 31
        },
        end: {
          line: 123,
          column: 51
        }
      },
      "77": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 131,
          column: 19
        }
      },
      "78": {
        start: {
          line: 125,
          column: 20
        },
        end: {
          line: 125,
          column: 40
        }
      },
      "79": {
        start: {
          line: 126,
          column: 37
        },
        end: {
          line: 126,
          column: 42
        }
      },
      "80": {
        start: {
          line: 128,
          column: 20
        },
        end: {
          line: 130,
          column: 21
        }
      },
      "81": {
        start: {
          line: 129,
          column: 24
        },
        end: {
          line: 129,
          column: 39
        }
      },
      "82": {
        start: {
          line: 135,
          column: 22
        },
        end: {
          line: 135,
          column: 66
        }
      },
      "83": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 138,
          column: 9
        }
      },
      "84": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 35
        }
      },
      "85": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 33
        }
      },
      "86": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 28
        }
      },
      "87": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 37
        }
      },
      "88": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 156,
          column: 6
        }
      },
      "89": {
        start: {
          line: 149,
          column: 19
        },
        end: {
          line: 149,
          column: 28
        }
      },
      "90": {
        start: {
          line: 150,
          column: 25
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "91": {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 153,
          column: 9
        }
      },
      "92": {
        start: {
          line: 152,
          column: 12
        },
        end: {
          line: 152,
          column: 32
        }
      },
      "93": {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 40
        }
      },
      "94": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 168,
          column: 6
        }
      },
      "95": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 163,
          column: 9
        }
      },
      "96": {
        start: {
          line: 162,
          column: 12
        },
        end: {
          line: 162,
          column: 19
        }
      },
      "97": {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 167,
          column: 11
        }
      },
      "98": {
        start: {
          line: 165,
          column: 24
        },
        end: {
          line: 165,
          column: 34
        }
      },
      "99": {
        start: {
          line: 166,
          column: 12
        },
        end: {
          line: 166,
          column: 36
        }
      },
      "100": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 35
        }
      },
      "101": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 17
        }
      },
      "102": {
        start: {
          line: 173,
          column: 0
        },
        end: {
          line: 173,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 39
          },
          end: {
            line: 172,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "Panel",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 18
          }
        },
        loc: {
          start: {
            line: 13,
            column: 31
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 26,
            column: 29
          },
          end: {
            line: 26,
            column: 30
          }
        },
        loc: {
          start: {
            line: 26,
            column: 41
          },
          end: {
            line: 144,
            column: 5
          }
        },
        line: 26
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 49,
            column: 30
          },
          end: {
            line: 49,
            column: 31
          }
        },
        loc: {
          start: {
            line: 49,
            column: 42
          },
          end: {
            line: 51,
            column: 9
          }
        },
        line: 49
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 65,
            column: 21
          },
          end: {
            line: 65,
            column: 22
          }
        },
        loc: {
          start: {
            line: 65,
            column: 46
          },
          end: {
            line: 105,
            column: 9
          }
        },
        line: 65
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 88,
            column: 31
          },
          end: {
            line: 88,
            column: 32
          }
        },
        loc: {
          start: {
            line: 88,
            column: 43
          },
          end: {
            line: 104,
            column: 13
          }
        },
        line: 88
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 93,
            column: 36
          },
          end: {
            line: 93,
            column: 37
          }
        },
        loc: {
          start: {
            line: 93,
            column: 54
          },
          end: {
            line: 96,
            column: 17
          }
        },
        line: 93
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 97,
            column: 38
          },
          end: {
            line: 97,
            column: 39
          }
        },
        loc: {
          start: {
            line: 97,
            column: 58
          },
          end: {
            line: 99,
            column: 17
          }
        },
        line: 97
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 107,
            column: 31
          },
          end: {
            line: 107,
            column: 32
          }
        },
        loc: {
          start: {
            line: 107,
            column: 44
          },
          end: {
            line: 110,
            column: 9
          }
        },
        line: 107
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 114,
            column: 21
          },
          end: {
            line: 114,
            column: 22
          }
        },
        loc: {
          start: {
            line: 114,
            column: 43
          },
          end: {
            line: 133,
            column: 9
          }
        },
        line: 114
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 119,
            column: 27
          },
          end: {
            line: 119,
            column: 28
          }
        },
        loc: {
          start: {
            line: 119,
            column: 44
          },
          end: {
            line: 132,
            column: 13
          }
        },
        line: 119
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 124,
            column: 49
          },
          end: {
            line: 124,
            column: 50
          }
        },
        loc: {
          start: {
            line: 124,
            column: 62
          },
          end: {
            line: 131,
            column: 17
          }
        },
        line: 124
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 148,
            column: 29
          },
          end: {
            line: 148,
            column: 30
          }
        },
        loc: {
          start: {
            line: 148,
            column: 41
          },
          end: {
            line: 156,
            column: 5
          }
        },
        line: 148
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 160,
            column: 29
          },
          end: {
            line: 160,
            column: 30
          }
        },
        loc: {
          start: {
            line: 160,
            column: 41
          },
          end: {
            line: 168,
            column: 5
          }
        },
        line: 160
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 164,
            column: 35
          },
          end: {
            line: 164,
            column: 36
          }
        },
        loc: {
          start: {
            line: 164,
            column: 51
          },
          end: {
            line: 167,
            column: 9
          }
        },
        line: 164
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 29
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 20
          },
          end: {
            line: 36,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 20
          },
          end: {
            line: 36,
            column: 30
          }
        }, {
          start: {
            line: 36,
            column: 34
          },
          end: {
            line: 36,
            column: 37
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 62,
            column: 19
          },
          end: {
            line: 62,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 19
          },
          end: {
            line: 62,
            column: 28
          }
        }, {
          start: {
            line: 62,
            column: 32
          },
          end: {
            line: 62,
            column: 34
          }
        }],
        line: 62
      },
      "7": {
        loc: {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 68,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 68,
            column: 13
          }
        }, {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 68,
            column: 13
          }
        }],
        line: 66
      },
      "8": {
        loc: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 33
          }
        }, {
          start: {
            line: 69,
            column: 37
          },
          end: {
            line: 69,
            column: 39
          }
        }],
        line: 69
      },
      "9": {
        loc: {
          start: {
            line: 70,
            column: 22
          },
          end: {
            line: 70,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 70,
            column: 22
          },
          end: {
            line: 70,
            column: 29
          }
        }, {
          start: {
            line: 70,
            column: 33
          },
          end: {
            line: 70,
            column: 35
          }
        }],
        line: 70
      },
      "10": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        }, {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 86,
            column: 13
          }
        }],
        line: 80
      },
      "11": {
        loc: {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 91,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 91,
            column: 17
          }
        }, {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 91,
            column: 17
          }
        }],
        line: 89
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 117,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 117,
            column: 13
          }
        }, {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 117,
            column: 13
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 118,
            column: 25
          },
          end: {
            line: 118,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 25
          },
          end: {
            line: 118,
            column: 35
          }
        }, {
          start: {
            line: 118,
            column: 39
          },
          end: {
            line: 118,
            column: 41
          }
        }],
        line: 118
      },
      "14": {
        loc: {
          start: {
            line: 122,
            column: 25
          },
          end: {
            line: 122,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 25
          },
          end: {
            line: 122,
            column: 33
          }
        }, {
          start: {
            line: 122,
            column: 37
          },
          end: {
            line: 122,
            column: 53
          }
        }],
        line: 122
      },
      "15": {
        loc: {
          start: {
            line: 128,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        }, {
          start: {
            line: 128,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        }],
        line: 128
      },
      "16": {
        loc: {
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        }, {
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        }],
        line: 136
      },
      "17": {
        loc: {
          start: {
            line: 151,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        }, {
          start: {
            line: 151,
            column: 8
          },
          end: {
            line: 153,
            column: 9
          }
        }],
        line: 151
      },
      "18": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 163,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 163,
            column: 9
          }
        }, {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 163,
            column: 9
          }
        }],
        line: 161
      },
      "19": {
        loc: {
          start: {
            line: 166,
            column: 12
          },
          end: {
            line: 166,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 12
          },
          end: {
            line: 166,
            column: 17
          }
        }, {
          start: {
            line: 166,
            column: 21
          },
          end: {
            line: 166,
            column: 35
          }
        }],
        line: 166
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Panel.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Panel.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,kEAAoD;AAEpD,2CAA4C;AAmB5C;IAQI,eAAY,IAAe,EAAE,IAAe;QACxC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;QAChB,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;QAChB,IAAI,CAAC,UAAU,GAAG,kBAAC,CAAC,yCAAyC,CAAC,CAAA;QAE9D,WAAW;QACX,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,KAAK,CAAC,gBAAgB,CAAC,CAAA;QAC9D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,KAAK,CAAC,gBAAgB,CAAC,CAAA;QACrE,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,uBAAuB,CAAC,IAAI,CAAC,KAAK,CAAC,gBAAgB,CAAC,CAAA;IAC9E,CAAC;IAED;;OAEG;IACI,sBAAM,GAAb;QAAA,iBAuIC;QAtIG,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAI,KAAK,CAAC,YAAY,CAAC,GAAG,CAAC,IAAI,CAAC,EAAE;YAC9B,OAAO;YACP,OAAM;SACT;QAED,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QAEtB,YAAY;QACZ,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAClC,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,IAAI,GAAG,CAAA,CAAC,WAAW;QAC3C,IAAM,IAAI,GAAG,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,qBAAqB,EAAE,CAAA;QAC7D,IAAM,QAAQ,GAAG,IAAI,CAAC,KAAK,CAAC,qBAAqB,EAAE,CAAA;QACnD,IAAM,GAAG,GAAG,IAAI,CAAC,MAAM,GAAG,IAAI,CAAC,GAAG,GAAG,QAAQ,CAAC,GAAG,CAAA;QACjD,IAAM,IAAI,GAAG,CAAC,IAAI,CAAC,KAAK,GAAG,KAAK,CAAC,GAAG,CAAC,GAAG,IAAI,CAAC,IAAI,GAAG,QAAQ,CAAC,IAAI,CAAA;QAEjE,UAAU;aACL,GAAG,CAAC,OAAO,EAAE,KAAK,GAAG,IAAI,CAAC;aAC1B,GAAG,CAAC,YAAY,EAAK,GAAG,OAAI,CAAC;aAC7B,GAAG,CAAC,aAAa,EAAK,IAAI,OAAI,CAAC;aAC/B,GAAG,CAAC,SAAS,EAAE,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,OAAO,CAAC,CAAC,CAAA;QAEpD,SAAS;QACT,IAAM,SAAS,GAAG,kBAAC,CAAC,gDAAgD,CAAC,CAAA;QACrE,UAAU,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;QAC5B,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE;YAClB,KAAI,CAAC,MAAM,EAAE,CAAA;QACjB,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,IAAM,kBAAkB,GAAG,kBAAC,CAAC,uCAAuC,CAAC,CAAA;QACrE,IAAM,oBAAoB,GAAG,kBAAC,CAAC,2CAA2C,CAAC,CAAA;QAC3E,UAAU,CAAC,MAAM,CAAC,kBAAkB,CAAC,CAAC,MAAM,CAAC,oBAAoB,CAAC,CAAA;QAElE,OAAO;QACP,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA,CAAC,kBAAkB;QAC7C,IAAI,MAAM,EAAE;YACR,oBAAoB,CAAC,GAAG,CAAC,QAAQ,EAAE,MAAM,GAAG,IAAI,CAAC,CAAC,GAAG,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;SAC9E;QAED,OAAO;QACP,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,IAAI,EAAE,CAAA;QAC5B,IAAM,WAAW,GAAiB,EAAE,CAAA;QACpC,IAAM,aAAa,GAAiB,EAAE,CAAA;QAEtC,IAAI,CAAC,OAAO,CAAC,UAAC,GAAiB,EAAE,QAAgB;YAC7C,IAAI,CAAC,GAAG,EAAE;gBACN,OAAM;aACT;YACD,IAAM,KAAK,GAAG,GAAG,CAAC,KAAK,IAAI,EAAE,CAAA;YAC7B,IAAM,GAAG,GAAG,GAAG,CAAC,GAAG,IAAI,EAAE,CAAA;YAEzB,UAAU;YACV,IAAM,MAAM,GAAG,kBAAC,CAAC,4BAAwB,KAAK,UAAO,CAAC,CAAA;YACtD,kBAAkB,CAAC,MAAM,CAAC,MAAM,CAAC,CAAA;YACjC,IAAM,QAAQ,GAAG,kBAAC,CAAC,GAAG,CAAC,CAAA;YACvB,oBAAoB,CAAC,MAAM,CAAC,QAAQ,CAAC,CAAA;YAErC,QAAQ;YACR,WAAW,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;YACxB,aAAa,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;YAE5B,cAAc;YACd,IAAI,QAAQ,KAAK,CAAC,EAAE;gBAChB,MAAM,CAAC,IAAI,CAAC,QAAQ,EAAE,IAAI,CAAC,CAAA;gBAC3B,MAAM,CAAC,QAAQ,CAAC,YAAY,CAAC,CAAA;aAChC;iBAAM;gBACH,QAAQ,CAAC,IAAI,EAAE,CAAA;aAClB;YAED,aAAa;YACb,MAAM,CAAC,EAAE,CAAC,OAAO,EAAE;gBACf,IAAI,MAAM,CAAC,IAAI,CAAC,QAAQ,CAAC,EAAE;oBACvB,OAAM;iBACT;gBACD,YAAY;gBACZ,WAAW,CAAC,OAAO,CAAC,UAAA,MAAM;oBACtB,MAAM,CAAC,IAAI,CAAC,QAAQ,EAAE,KAAK,CAAC,CAAA;oBAC5B,MAAM,CAAC,WAAW,CAAC,YAAY,CAAC,CAAA;gBACpC,CAAC,CAAC,CAAA;gBACF,aAAa,CAAC,OAAO,CAAC,UAAA,QAAQ;oBAC1B,QAAQ,CAAC,IAAI,EAAE,CAAA;gBACnB,CAAC,CAAC,CAAA;gBAEF,YAAY;gBACZ,MAAM,CAAC,IAAI,CAAC,QAAQ,EAAE,IAAI,CAAC,CAAA;gBAC3B,MAAM,CAAC,QAAQ,CAAC,YAAY,CAAC,CAAA;gBAC7B,QAAQ,CAAC,IAAI,EAAE,CAAA;YACnB,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;QAEF,SAAS;QACT,UAAU,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC5B,UAAU;YACV,CAAC,CAAC,eAAe,EAAE,CAAA;QACvB,CAAC,CAAC,CAAA;QAEF,UAAU;QACV,IAAI,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU,CAAC,CAAA;QAE7B,wCAAwC;QACxC,IAAI,CAAC,OAAO,CAAC,UAAC,GAAiB,EAAE,KAAa;YAC1C,IAAI,CAAC,GAAG,EAAE;gBACN,OAAM;aACT;YACD,IAAM,MAAM,GAAG,GAAG,CAAC,MAAM,IAAI,EAAE,CAAA;YAC/B,MAAM,CAAC,OAAO,CAAC,UAAC,KAAoB;gBAChC,IAAM,QAAQ,GAAG,KAAK,CAAC,QAAQ,CAAA;gBAC/B,IAAM,IAAI,GAAG,KAAK,CAAC,IAAI,CAAA;gBACvB,IAAM,EAAE,GAAG,KAAK,CAAC,EAAE,IAAI,gBAAQ,CAAA;gBAC/B,IAAM,QAAQ,GAAG,aAAa,CAAC,KAAK,CAAC,CAAA;gBACrC,QAAQ,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,EAAE,CAAC,IAAI,EAAE,UAAC,CAAQ;oBACtC,CAAC,CAAC,eAAe,EAAE,CAAA;oBACnB,IAAM,UAAU,GAAG,EAAE,CAAC,CAAC,CAAC,CAAA;oBACxB,sBAAsB;oBACtB,IAAI,UAAU,EAAE;wBACZ,KAAI,CAAC,MAAM,EAAE,CAAA;qBAChB;gBACL,CAAC,CAAC,CAAA;YACN,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;QAEF,iBAAiB;QACjB,IAAI,OAAO,GAAG,UAAU,CAAC,IAAI,CAAC,2BAA2B,CAAC,CAAA;QAC1D,IAAI,OAAO,CAAC,MAAM,EAAE;YAChB,OAAO,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,KAAK,EAAE,CAAA;SACzB;QAED,aAAa;QACb,KAAK,CAAC,gBAAgB,EAAE,CAAA;QAExB,uBAAuB;QACvB,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAA;QACnB,KAAK,CAAC,YAAY,CAAC,GAAG,CAAC,IAAI,CAAC,CAAA;IAChC,CAAC;IAED;;OAEG;IACI,sBAAM,GAAb;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAClC,IAAI,UAAU,EAAE;YACZ,UAAU,CAAC,MAAM,EAAE,CAAA;SACtB;QAED,gBAAgB;QAChB,KAAK,CAAC,YAAY,CAAC,MAAM,CAAC,IAAI,CAAC,CAAA;IACnC,CAAC;IAED;;OAEG;IACI,sBAAgB,GAAvB;QACI,IAAI,KAAK,CAAC,YAAY,CAAC,IAAI,KAAK,CAAC,EAAE;YAC/B,OAAM;SACT;QACD,KAAK,CAAC,YAAY,CAAC,OAAO,CAAC,UAAA,IAAI;YAC3B,IAAM,KAAK,GAAI,IAAkB,CAAC,KAAK,CAAA;YACvC,KAAK,IAAI,KAAK,CAAC,MAAM,EAAE,CAAA;QAC3B,CAAC,CAAC,CAAA;IACN,CAAC;IAxLD,qBAAqB;IACd,kBAAY,GAAmB,IAAI,GAAG,EAAE,CAAA;IAwLnD,YAAC;CAAA,AA1LD,IA0LC;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description panel class\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport PanelMenu from './PanelMenu'\nimport { EMPTY_FN } from '../../utils/const'\n\n// Panel \u914D\u7F6E\u683C\u5F0F\ntype _TabEventConf = {\n    selector: string\n    type: string\n    fn: Function\n}\nexport type PanelTabConf = {\n    title: string\n    tpl: string\n    events: _TabEventConf[]\n}\nexport type PanelConf = {\n    width: number | 0\n    height: number | 0\n    tabs: PanelTabConf[]\n}\n\nclass Panel {\n    // \u8BB0\u5F55\u5DF2\u7ECF\u521B\u5EFA\u8FC7\u7684 panelMenu\n    static createdMenus: Set<PanelMenu> = new Set()\n\n    private menu: PanelMenu\n    private conf: PanelConf\n    public $container: DomElement\n\n    constructor(menu: PanelMenu, conf: PanelConf) {\n        this.menu = menu\n        this.conf = conf\n        this.$container = $('<div class=\"w-e-panel-container\"></div>')\n\n        // \u9690\u85CF panel\n        const editor = menu.editor\n        editor.txt.eventHooks.clickEvents.push(Panel.hideCurAllPanels)\n        editor.txt.eventHooks.toolbarClickEvents.push(Panel.hideCurAllPanels)\n        editor.txt.eventHooks.dropListMenuHoverEvents.push(Panel.hideCurAllPanels)\n    }\n\n    /**\n     * \u521B\u5EFA\u5E76\u5C55\u793A panel\n     */\n    public create(): void {\n        const menu = this.menu\n        if (Panel.createdMenus.has(menu)) {\n            // \u521B\u5EFA\u8FC7\u4E86\n            return\n        }\n\n        const conf = this.conf\n\n        // panel \u7684\u5BB9\u5668\n        const $container = this.$container\n        const width = conf.width || 300 // \u9ED8\u8BA4 300px\n        const rect = menu.editor.$toolbarElem.getBoundingClientRect()\n        const menuRect = menu.$elem.getBoundingClientRect()\n        const top = rect.height + rect.top - menuRect.top\n        const left = (rect.width - width) / 2 + rect.left - menuRect.left\n\n        $container\n            .css('width', width + 'px')\n            .css('margin-top', `${top}px`)\n            .css('margin-left', `${left}px`)\n            .css('z-index', menu.editor.zIndex.get('panel'))\n\n        // \u6DFB\u52A0\u5173\u95ED\u6309\u94AE\n        const $closeBtn = $('<i class=\"w-e-icon-close w-e-panel-close\"></i>')\n        $container.append($closeBtn)\n        $closeBtn.on('click', () => {\n            this.remove()\n        })\n\n        // \u51C6\u5907 tabs \u5BB9\u5668\n        const $tabTitleContainer = $('<ul class=\"w-e-panel-tab-title\"></ul>')\n        const $tabContentContainer = $('<div class=\"w-e-panel-tab-content\"></div>')\n        $container.append($tabTitleContainer).append($tabContentContainer)\n\n        // \u8BBE\u7F6E\u9AD8\u5EA6\n        const height = conf.height // height: 0 \u5373\u4E0D\u7528\u8BBE\u7F6E\n        if (height) {\n            $tabContentContainer.css('height', height + 'px').css('overflow-y', 'auto')\n        }\n\n        // tabs\n        const tabs = conf.tabs || []\n        const tabTitleArr: DomElement[] = []\n        const tabContentArr: DomElement[] = []\n\n        tabs.forEach((tab: PanelTabConf, tabIndex: number) => {\n            if (!tab) {\n                return\n            }\n            const title = tab.title || ''\n            const tpl = tab.tpl || ''\n\n            // \u6DFB\u52A0\u5230 DOM\n            const $title = $(`<li class=\"w-e-item\">${title}</li>`)\n            $tabTitleContainer.append($title)\n            const $content = $(tpl)\n            $tabContentContainer.append($content)\n\n            // \u8BB0\u5F55\u5230\u5185\u5B58\n            tabTitleArr.push($title)\n            tabContentArr.push($content)\n\n            // \u8BBE\u7F6E active \u9879\n            if (tabIndex === 0) {\n                $title.data('active', true)\n                $title.addClass('w-e-active')\n            } else {\n                $content.hide()\n            }\n\n            // \u7ED1\u5B9A tab \u7684\u4E8B\u4EF6\n            $title.on('click', () => {\n                if ($title.data('active')) {\n                    return\n                }\n                // \u9690\u85CF\u6240\u6709\u7684 tab\n                tabTitleArr.forEach($title => {\n                    $title.data('active', false)\n                    $title.removeClass('w-e-active')\n                })\n                tabContentArr.forEach($content => {\n                    $content.hide()\n                })\n\n                // \u663E\u793A\u5F53\u524D\u7684 tab\n                $title.data('active', true)\n                $title.addClass('w-e-active')\n                $content.show()\n            })\n        })\n\n        // \u7ED1\u5B9A\u5173\u95ED\u4E8B\u4EF6\n        $container.on('click', (e: Event) => {\n            // \u70B9\u51FB\u65F6\u963B\u6B62\u5192\u6CE1\n            e.stopPropagation()\n        })\n\n        // \u6DFB\u52A0\u5230 DOM\n        menu.$elem.append($container)\n\n        // \u7ED1\u5B9A conf events \u7684\u4E8B\u4EF6\uFF0C\u53EA\u6709\u6DFB\u52A0\u5230 DOM \u4E4B\u540E\u624D\u80FD\u7ED1\u5B9A\u6210\u529F\n        tabs.forEach((tab: PanelTabConf, index: number) => {\n            if (!tab) {\n                return\n            }\n            const events = tab.events || []\n            events.forEach((event: _TabEventConf) => {\n                const selector = event.selector\n                const type = event.type\n                const fn = event.fn || EMPTY_FN\n                const $content = tabContentArr[index]\n                $content.find(selector).on(type, (e: Event) => {\n                    e.stopPropagation()\n                    const needToHide = fn(e)\n                    // \u6267\u884C\u5B8C\u4E8B\u4EF6\u4E4B\u540E\uFF0C\u662F\u5426\u8981\u5173\u95ED panel\n                    if (needToHide) {\n                        this.remove()\n                    }\n                })\n            })\n        })\n\n        // focus \u7B2C\u4E00\u4E2A elem\n        let $inputs = $container.find('input[type=text],textarea')\n        if ($inputs.length) {\n            $inputs.get(0).focus()\n        }\n\n        // \u9690\u85CF\u5176\u4ED6 panel\n        Panel.hideCurAllPanels()\n\n        // \u8BB0\u5F55\u8BE5 menu \u5DF2\u7ECF\u521B\u5EFA\u4E86 panel\n        menu.setPanel(this)\n        Panel.createdMenus.add(menu)\n    }\n\n    /**\n     * \u79FB\u9664 penal\n     */\n    public remove(): void {\n        const menu = this.menu\n        const $container = this.$container\n        if ($container) {\n            $container.remove()\n        }\n\n        // \u5C06\u8BE5 menu \u8BB0\u5F55\u4E2D\u79FB\u9664\n        Panel.createdMenus.delete(menu)\n    }\n\n    /**\n     * \u9690\u85CF\u5F53\u524D\u6240\u6709\u7684 panel\n     */\n    static hideCurAllPanels(): void {\n        if (Panel.createdMenus.size === 0) {\n            return\n        }\n        Panel.createdMenus.forEach(menu => {\n            const panel = (menu as PanelMenu).panel\n            panel && panel.remove()\n        })\n    }\n}\n\nexport default Panel\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e8eb64404d7bde69065eb783ca0bf8ec6cf59700"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2qz28d5iyj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2qz28d5iyj();

var __importDefault = (cov_2qz28d5iyj().s[0]++, (cov_2qz28d5iyj().b[0][0]++, void 0) && (cov_2qz28d5iyj().b[0][1]++, (void 0).__importDefault) || (cov_2qz28d5iyj().b[0][2]++, function (mod) {
  cov_2qz28d5iyj().f[0]++;
  cov_2qz28d5iyj().s[1]++;
  return (cov_2qz28d5iyj().b[2][0]++, mod) && (cov_2qz28d5iyj().b[2][1]++, mod.__esModule) ? (cov_2qz28d5iyj().b[1][0]++, mod) : (cov_2qz28d5iyj().b[1][1]++, {
    "default": mod
  });
}));

cov_2qz28d5iyj().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_2qz28d5iyj().s[3]++, __importDefault(__webpack_require__(2)));
var const_1 = (cov_2qz28d5iyj().s[4]++, __webpack_require__(30));
var Panel = (
/** @class */
cov_2qz28d5iyj().s[5]++, function () {
  cov_2qz28d5iyj().f[1]++;

  function Panel(menu, conf) {
    cov_2qz28d5iyj().f[2]++;
    cov_2qz28d5iyj().s[6]++;
    this.menu = menu;
    cov_2qz28d5iyj().s[7]++;
    this.conf = conf;
    cov_2qz28d5iyj().s[8]++;
    this.$container = dom_core_1["default"]('<div class="w-e-panel-container"></div>'); // 隐藏 panel

    var editor = (cov_2qz28d5iyj().s[9]++, menu.editor);
    cov_2qz28d5iyj().s[10]++;
    editor.txt.eventHooks.clickEvents.push(Panel.hideCurAllPanels);
    cov_2qz28d5iyj().s[11]++;
    editor.txt.eventHooks.toolbarClickEvents.push(Panel.hideCurAllPanels);
    cov_2qz28d5iyj().s[12]++;
    editor.txt.eventHooks.dropListMenuHoverEvents.push(Panel.hideCurAllPanels);
  }
  /**
   * 创建并展示 panel
   */


  cov_2qz28d5iyj().s[13]++;

  Panel.prototype.create = function () {
    cov_2qz28d5iyj().f[3]++;

    var _this = (cov_2qz28d5iyj().s[14]++, this);

    var menu = (cov_2qz28d5iyj().s[15]++, this.menu);
    cov_2qz28d5iyj().s[16]++;

    if (Panel.createdMenus.has(menu)) {
      cov_2qz28d5iyj().b[3][0]++;
      cov_2qz28d5iyj().s[17]++;
      // 创建过了
      return;
    } else {
      cov_2qz28d5iyj().b[3][1]++;
    }

    var conf = (cov_2qz28d5iyj().s[18]++, this.conf); // panel 的容器

    var $container = (cov_2qz28d5iyj().s[19]++, this.$container);
    var width = (cov_2qz28d5iyj().s[20]++, (cov_2qz28d5iyj().b[4][0]++, conf.width) || (cov_2qz28d5iyj().b[4][1]++, 300)); // 默认 300px

    var rect = (cov_2qz28d5iyj().s[21]++, menu.editor.$toolbarElem.getBoundingClientRect());
    var menuRect = (cov_2qz28d5iyj().s[22]++, menu.$elem.getBoundingClientRect());
    var top = (cov_2qz28d5iyj().s[23]++, rect.height + rect.top - menuRect.top);
    var left = (cov_2qz28d5iyj().s[24]++, (rect.width - width) / 2 + rect.left - menuRect.left);
    cov_2qz28d5iyj().s[25]++;
    $container.css('width', width + 'px').css('margin-top', top + "px").css('margin-left', left + "px").css('z-index', menu.editor.zIndex.get('panel')); // 添加关闭按钮

    var $closeBtn = (cov_2qz28d5iyj().s[26]++, dom_core_1["default"]('<i class="w-e-icon-close w-e-panel-close"></i>'));
    cov_2qz28d5iyj().s[27]++;
    $container.append($closeBtn);
    cov_2qz28d5iyj().s[28]++;
    $closeBtn.on('click', function () {
      cov_2qz28d5iyj().f[4]++;
      cov_2qz28d5iyj().s[29]++;

      _this.remove();
    }); // 准备 tabs 容器

    var $tabTitleContainer = (cov_2qz28d5iyj().s[30]++, dom_core_1["default"]('<ul class="w-e-panel-tab-title"></ul>'));
    var $tabContentContainer = (cov_2qz28d5iyj().s[31]++, dom_core_1["default"]('<div class="w-e-panel-tab-content"></div>'));
    cov_2qz28d5iyj().s[32]++;
    $container.append($tabTitleContainer).append($tabContentContainer); // 设置高度

    var height = (cov_2qz28d5iyj().s[33]++, conf.height); // height: 0 即不用设置

    cov_2qz28d5iyj().s[34]++;

    if (height) {
      cov_2qz28d5iyj().b[5][0]++;
      cov_2qz28d5iyj().s[35]++;
      $tabContentContainer.css('height', height + 'px').css('overflow-y', 'auto');
    } else {
      cov_2qz28d5iyj().b[5][1]++;
    } // tabs


    var tabs = (cov_2qz28d5iyj().s[36]++, (cov_2qz28d5iyj().b[6][0]++, conf.tabs) || (cov_2qz28d5iyj().b[6][1]++, []));
    var tabTitleArr = (cov_2qz28d5iyj().s[37]++, []);
    var tabContentArr = (cov_2qz28d5iyj().s[38]++, []);
    cov_2qz28d5iyj().s[39]++;
    (0, _forEach["default"])(tabs).call(tabs, function (tab, tabIndex) {
      cov_2qz28d5iyj().f[5]++;
      cov_2qz28d5iyj().s[40]++;

      if (!tab) {
        cov_2qz28d5iyj().b[7][0]++;
        cov_2qz28d5iyj().s[41]++;
        return;
      } else {
        cov_2qz28d5iyj().b[7][1]++;
      }

      var title = (cov_2qz28d5iyj().s[42]++, (cov_2qz28d5iyj().b[8][0]++, tab.title) || (cov_2qz28d5iyj().b[8][1]++, ''));
      var tpl = (cov_2qz28d5iyj().s[43]++, (cov_2qz28d5iyj().b[9][0]++, tab.tpl) || (cov_2qz28d5iyj().b[9][1]++, '')); // 添加到 DOM

      var $title = (cov_2qz28d5iyj().s[44]++, dom_core_1["default"]("<li class=\"w-e-item\">" + title + "</li>"));
      cov_2qz28d5iyj().s[45]++;
      $tabTitleContainer.append($title);
      var $content = (cov_2qz28d5iyj().s[46]++, dom_core_1["default"](tpl));
      cov_2qz28d5iyj().s[47]++;
      $tabContentContainer.append($content); // 记录到内存

      cov_2qz28d5iyj().s[48]++;
      tabTitleArr.push($title);
      cov_2qz28d5iyj().s[49]++;
      tabContentArr.push($content); // 设置 active 项

      cov_2qz28d5iyj().s[50]++;

      if (tabIndex === 0) {
        cov_2qz28d5iyj().b[10][0]++;
        cov_2qz28d5iyj().s[51]++;
        $title.data('active', true);
        cov_2qz28d5iyj().s[52]++;
        $title.addClass('w-e-active');
      } else {
        cov_2qz28d5iyj().b[10][1]++;
        cov_2qz28d5iyj().s[53]++;
        $content.hide();
      } // 绑定 tab 的事件


      cov_2qz28d5iyj().s[54]++;
      $title.on('click', function () {
        cov_2qz28d5iyj().f[6]++;
        cov_2qz28d5iyj().s[55]++;

        if ($title.data('active')) {
          cov_2qz28d5iyj().b[11][0]++;
          cov_2qz28d5iyj().s[56]++;
          return;
        } else {
          cov_2qz28d5iyj().b[11][1]++;
        } // 隐藏所有的 tab


        cov_2qz28d5iyj().s[57]++;
        (0, _forEach["default"])(tabTitleArr).call(tabTitleArr, function ($title) {
          cov_2qz28d5iyj().f[7]++;
          cov_2qz28d5iyj().s[58]++;
          $title.data('active', false);
          cov_2qz28d5iyj().s[59]++;
          $title.removeClass('w-e-active');
        });
        cov_2qz28d5iyj().s[60]++;
        (0, _forEach["default"])(tabContentArr).call(tabContentArr, function ($content) {
          cov_2qz28d5iyj().f[8]++;
          cov_2qz28d5iyj().s[61]++;
          $content.hide();
        }); // 显示当前的 tab

        cov_2qz28d5iyj().s[62]++;
        $title.data('active', true);
        cov_2qz28d5iyj().s[63]++;
        $title.addClass('w-e-active');
        cov_2qz28d5iyj().s[64]++;
        $content.show();
      });
    }); // 绑定关闭事件

    cov_2qz28d5iyj().s[65]++;
    $container.on('click', function (e) {
      cov_2qz28d5iyj().f[9]++;
      cov_2qz28d5iyj().s[66]++;
      // 点击时阻止冒泡
      e.stopPropagation();
    }); // 添加到 DOM

    cov_2qz28d5iyj().s[67]++;
    menu.$elem.append($container); // 绑定 conf events 的事件，只有添加到 DOM 之后才能绑定成功

    cov_2qz28d5iyj().s[68]++;
    (0, _forEach["default"])(tabs).call(tabs, function (tab, index) {
      cov_2qz28d5iyj().f[10]++;
      cov_2qz28d5iyj().s[69]++;

      if (!tab) {
        cov_2qz28d5iyj().b[12][0]++;
        cov_2qz28d5iyj().s[70]++;
        return;
      } else {
        cov_2qz28d5iyj().b[12][1]++;
      }

      var events = (cov_2qz28d5iyj().s[71]++, (cov_2qz28d5iyj().b[13][0]++, tab.events) || (cov_2qz28d5iyj().b[13][1]++, []));
      cov_2qz28d5iyj().s[72]++;
      (0, _forEach["default"])(events).call(events, function (event) {
        cov_2qz28d5iyj().f[11]++;
        var selector = (cov_2qz28d5iyj().s[73]++, event.selector);
        var type = (cov_2qz28d5iyj().s[74]++, event.type);
        var fn = (cov_2qz28d5iyj().s[75]++, (cov_2qz28d5iyj().b[14][0]++, event.fn) || (cov_2qz28d5iyj().b[14][1]++, const_1.EMPTY_FN));
        var $content = (cov_2qz28d5iyj().s[76]++, tabContentArr[index]);
        cov_2qz28d5iyj().s[77]++;
        (0, _find["default"])($content).call($content, selector).on(type, function (e) {
          cov_2qz28d5iyj().f[12]++;
          cov_2qz28d5iyj().s[78]++;
          e.stopPropagation();
          var needToHide = (cov_2qz28d5iyj().s[79]++, fn(e)); // 执行完事件之后，是否要关闭 panel

          cov_2qz28d5iyj().s[80]++;

          if (needToHide) {
            cov_2qz28d5iyj().b[15][0]++;
            cov_2qz28d5iyj().s[81]++;

            _this.remove();
          } else {
            cov_2qz28d5iyj().b[15][1]++;
          }
        });
      });
    }); // focus 第一个 elem

    var $inputs = (cov_2qz28d5iyj().s[82]++, (0, _find["default"])($container).call($container, 'input[type=text],textarea'));
    cov_2qz28d5iyj().s[83]++;

    if ($inputs.length) {
      cov_2qz28d5iyj().b[16][0]++;
      cov_2qz28d5iyj().s[84]++;
      $inputs.get(0).focus();
    } else {
      cov_2qz28d5iyj().b[16][1]++;
    } // 隐藏其他 panel


    cov_2qz28d5iyj().s[85]++;
    Panel.hideCurAllPanels(); // 记录该 menu 已经创建了 panel

    cov_2qz28d5iyj().s[86]++;
    menu.setPanel(this);
    cov_2qz28d5iyj().s[87]++;
    Panel.createdMenus.add(menu);
  };
  /**
   * 移除 penal
   */


  cov_2qz28d5iyj().s[88]++;

  Panel.prototype.remove = function () {
    cov_2qz28d5iyj().f[13]++;
    var menu = (cov_2qz28d5iyj().s[89]++, this.menu);
    var $container = (cov_2qz28d5iyj().s[90]++, this.$container);
    cov_2qz28d5iyj().s[91]++;

    if ($container) {
      cov_2qz28d5iyj().b[17][0]++;
      cov_2qz28d5iyj().s[92]++;
      $container.remove();
    } else {
      cov_2qz28d5iyj().b[17][1]++;
    } // 将该 menu 记录中移除


    cov_2qz28d5iyj().s[93]++;
    Panel.createdMenus["delete"](menu);
  };
  /**
   * 隐藏当前所有的 panel
   */


  cov_2qz28d5iyj().s[94]++;

  Panel.hideCurAllPanels = function () {
    var _context;

    cov_2qz28d5iyj().f[14]++;
    cov_2qz28d5iyj().s[95]++;

    if (Panel.createdMenus.size === 0) {
      cov_2qz28d5iyj().b[18][0]++;
      cov_2qz28d5iyj().s[96]++;
      return;
    } else {
      cov_2qz28d5iyj().b[18][1]++;
    }

    cov_2qz28d5iyj().s[97]++;
    (0, _forEach["default"])(_context = Panel.createdMenus).call(_context, function (menu) {
      cov_2qz28d5iyj().f[15]++;
      var panel = (cov_2qz28d5iyj().s[98]++, menu.panel);
      cov_2qz28d5iyj().s[99]++;
      (cov_2qz28d5iyj().b[19][0]++, panel) && (cov_2qz28d5iyj().b[19][1]++, panel.remove());
    });
  }; // 记录已经创建过的 panelMenu


  cov_2qz28d5iyj().s[100]++;
  Panel.createdMenus = new _set["default"]();
  cov_2qz28d5iyj().s[101]++;
  return Panel;
}());
cov_2qz28d5iyj().s[102]++;
exports["default"] = Panel;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 常量
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_155ttqnk2r() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/const.ts";
  var hash = "6f9d38231f9ac9b8bdbacfe1f00e8bc647cdbf04";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/const.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 64
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 28
        }
      },
      "3": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 44
        }
      },
      "4": {
        start: {
          line: 13,
          column: 0
        },
        end: {
          line: 13,
          column: 112
        }
      }
    },
    fnMap: {
      "0": {
        name: "EMPTY_FN",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 17
          }
        },
        loc: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 23
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/const.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/const.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;AAEH,SAAgB,QAAQ,KAAI,CAAC;AAA7B,4BAA6B;AAC7B,gBAAgB;AACH,QAAA,QAAQ,GAAG,wBAAwB,CAAA;AAEhD,iBAAiB;AACJ,QAAA,QAAQ,GAAG,4FAA4F,CAAA",
      sourcesContent: ["/**\n * @description \u5E38\u91CF\n * @author wangfupeng\n */\n\nexport function EMPTY_FN() {}\n//\u7528\u4E8E\u6821\u9A8C\u56FE\u7247\u94FE\u63A5\u662F\u5426\u7B26\u5408\u89C4\u8303\nexport const imgRegex = /\\.(gif|jpg|jpeg|png)$/i\n\n//\u7528\u4E8E\u6821\u9A8C\u662F\u5426\u4E3Aurl\u683C\u5F0F\u5B57\u7B26\u4E32\nexport const urlRegex = /^(http|ftp|https):\\/\\/[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-.,@?^=%&amp;:/~+#]*[\\w\\-@?^=%&amp;/~+#])?/\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6f9d38231f9ac9b8bdbacfe1f00e8bc647cdbf04"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_155ttqnk2r = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_155ttqnk2r();
cov_155ttqnk2r().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_155ttqnk2r().s[1]++;
exports.urlRegex = exports.imgRegex = exports.EMPTY_FN = void 0;

function EMPTY_FN() {
  cov_155ttqnk2r().f[0]++;
}

cov_155ttqnk2r().s[2]++;
exports.EMPTY_FN = EMPTY_FN; //用于校验图片链接是否符合规范

cov_155ttqnk2r().s[3]++;
exports.imgRegex = /\.(gif|jpg|jpeg|png)$/i; //用于校验是否为url格式字符串

cov_155ttqnk2r().s[4]++;
exports.urlRegex = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(281);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description Modal 菜单 Class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_27gee1ql5n() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/PanelMenu.ts";
  var hash = "056e215e65f649bdb6f12c38c8d7145bb14699a8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/PanelMenu.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 13
        },
        end: {
          line: 23,
          column: 47
        }
      },
      "16": {
        start: {
          line: 24,
          column: 31
        },
        end: {
          line: 37,
          column: 17
        }
      },
      "17": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 33
        }
      },
      "18": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 56
        }
      },
      "19": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 35,
          column: 6
        }
      },
      "20": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 27
        }
      },
      "21": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 21
        }
      },
      "22": {
        start: {
          line: 38,
          column: 0
        },
        end: {
          line: 38,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 24,
            column: 31
          },
          end: {
            line: 24,
            column: 32
          }
        },
        loc: {
          start: {
            line: 24,
            column: 49
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 24
      },
      "8": {
        name: "PanelMenu",
        decl: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 22
          }
        },
        loc: {
          start: {
            line: 26,
            column: 38
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 26
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 33,
            column: 35
          },
          end: {
            line: 33,
            column: 36
          }
        },
        loc: {
          start: {
            line: 33,
            column: 52
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 27,
            column: 15
          },
          end: {
            line: 27,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 15
          },
          end: {
            line: 27,
            column: 47
          }
        }, {
          start: {
            line: 27,
            column: 51
          },
          end: {
            line: 27,
            column: 55
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/PanelMenu.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/PanelMenu.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAIH,gDAAyB;AAGzB;IAAwB,6BAAI;IAGxB,mBAAY,KAAiB,EAAE,MAAc;eACzC,kBAAM,KAAK,EAAE,MAAM,CAAC;IACxB,CAAC;IAED;;;OAGG;IACI,4BAAQ,GAAf,UAAgB,KAAY;QACxB,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;IACtB,CAAC;IACL,gBAAC;AAAD,CAAC,AAdD,CAAwB,cAAI,GAc3B;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description Modal \u83DC\u5355 Class\n * @author wangfupeng\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport Menu from './Menu'\nimport Panel from './Panel'\n\nclass PanelMenu extends Menu {\n    public panel: Panel | undefined\n\n    constructor($elem: DomElement, editor: Editor) {\n        super($elem, editor)\n    }\n\n    /**\n     * \u7ED9 menu \u8BBE\u7F6E panel\n     * @param panel panel \u5B9E\u4F8B\n     */\n    public setPanel(panel: Panel): void {\n        this.panel = panel\n    }\n}\n\nexport default PanelMenu\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "056e215e65f649bdb6f12c38c8d7145bb14699a8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27gee1ql5n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_27gee1ql5n();

var __extends = (cov_27gee1ql5n().s[0]++, (cov_27gee1ql5n().b[0][0]++, void 0) && (cov_27gee1ql5n().b[0][1]++, (void 0).__extends) || (cov_27gee1ql5n().b[0][2]++, function () {
  cov_27gee1ql5n().f[0]++;
  cov_27gee1ql5n().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_27gee1ql5n().f[1]++;
    cov_27gee1ql5n().s[2]++;
    _extendStatics = (cov_27gee1ql5n().b[1][0]++, _setPrototypeOf["default"]) || (cov_27gee1ql5n().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_27gee1ql5n().b[1][2]++, function (d, b) {
      cov_27gee1ql5n().f[2]++;
      cov_27gee1ql5n().s[3]++;
      d.__proto__ = b;
    }) || (cov_27gee1ql5n().b[1][3]++, function (d, b) {
      cov_27gee1ql5n().f[3]++;
      cov_27gee1ql5n().s[4]++;

      for (var p in b) {
        cov_27gee1ql5n().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_27gee1ql5n().b[2][0]++;
          cov_27gee1ql5n().s[6]++;
          d[p] = b[p];
        } else {
          cov_27gee1ql5n().b[2][1]++;
        }
      }
    });
    cov_27gee1ql5n().s[7]++;
    return _extendStatics(d, b);
  };

  cov_27gee1ql5n().s[8]++;
  return function (d, b) {
    cov_27gee1ql5n().f[4]++;
    cov_27gee1ql5n().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_27gee1ql5n().f[5]++;
      cov_27gee1ql5n().s[10]++;
      this.constructor = d;
    }

    cov_27gee1ql5n().s[11]++;
    d.prototype = b === null ? (cov_27gee1ql5n().b[3][0]++, (0, _create["default"])(b)) : (cov_27gee1ql5n().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_27gee1ql5n().s[12]++, (cov_27gee1ql5n().b[4][0]++, void 0) && (cov_27gee1ql5n().b[4][1]++, (void 0).__importDefault) || (cov_27gee1ql5n().b[4][2]++, function (mod) {
  cov_27gee1ql5n().f[6]++;
  cov_27gee1ql5n().s[13]++;
  return (cov_27gee1ql5n().b[6][0]++, mod) && (cov_27gee1ql5n().b[6][1]++, mod.__esModule) ? (cov_27gee1ql5n().b[5][0]++, mod) : (cov_27gee1ql5n().b[5][1]++, {
    "default": mod
  });
}));

cov_27gee1ql5n().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var Menu_1 = (cov_27gee1ql5n().s[15]++, __importDefault(__webpack_require__(93)));
var PanelMenu = (
/** @class */
cov_27gee1ql5n().s[16]++, function (_super) {
  cov_27gee1ql5n().f[7]++;
  cov_27gee1ql5n().s[17]++;

  __extends(PanelMenu, _super);

  function PanelMenu($elem, editor) {
    cov_27gee1ql5n().f[8]++;
    cov_27gee1ql5n().s[18]++;
    return (cov_27gee1ql5n().b[7][0]++, _super.call(this, $elem, editor)) || (cov_27gee1ql5n().b[7][1]++, this);
  }
  /**
   * 给 menu 设置 panel
   * @param panel panel 实例
   */


  cov_27gee1ql5n().s[19]++;

  PanelMenu.prototype.setPanel = function (panel) {
    cov_27gee1ql5n().f[9]++;
    cov_27gee1ql5n().s[20]++;
    this.panel = panel;
  };

  cov_27gee1ql5n().s[21]++;
  return PanelMenu;
}(Menu_1["default"]));
cov_27gee1ql5n().s[22]++;
exports["default"] = PanelMenu;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(45);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var isArrayIteratorMethod = __webpack_require__(158);
var toLength = __webpack_require__(34);
var bind = __webpack_require__(46);
var getIteratorMethod = __webpack_require__(159);
var iteratorClose = __webpack_require__(160);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(77);
var defineProperty = __webpack_require__(17).f;
var createNonEnumerableProperty = __webpack_require__(16);
var has = __webpack_require__(15);
var toString = __webpack_require__(162);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!has(target, TO_STRING_TAG)) {
      defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !TO_STRING_TAG_SUPPORT) {
      createNonEnumerableProperty(target, 'toString', toString);
    }
  }
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(166);
var global = __webpack_require__(8);
var isObject = __webpack_require__(13);
var createNonEnumerableProperty = __webpack_require__(16);
var objectHas = __webpack_require__(15);
var shared = __webpack_require__(73);
var sharedKey = __webpack_require__(59);
var hiddenKeys = __webpack_require__(48);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(46);
var IndexedObject = __webpack_require__(67);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(34);
var arraySpeciesCreate = __webpack_require__(85);

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description Tooltip class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1ig3psa2jh() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Tooltip.ts";
  var hash = "f75ed040021ffde1e5c6408c8b0da17f5646186a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Tooltip.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 168,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 33
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 25
        }
      },
      "8": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 27
        }
      },
      "9": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 44
        }
      },
      "10": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 58
        }
      },
      "11": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 43
        }
      },
      "12": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 37
        }
      },
      "13": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 101,
          column: 6
        }
      },
      "14": {
        start: {
          line: 27,
          column: 25
        },
        end: {
          line: 27,
          column: 40
        }
      },
      "15": {
        start: {
          line: 28,
          column: 18
        },
        end: {
          line: 28,
          column: 19
        }
      },
      "16": {
        start: {
          line: 29,
          column: 19
        },
        end: {
          line: 29,
          column: 20
        }
      },
      "17": {
        start: {
          line: 31,
          column: 28
        },
        end: {
          line: 31,
          column: 30
        }
      },
      "18": {
        start: {
          line: 33,
          column: 28
        },
        end: {
          line: 33,
          column: 62
        }
      },
      "19": {
        start: {
          line: 35,
          column: 29
        },
        end: {
          line: 35,
          column: 69
        }
      },
      "20": {
        start: {
          line: 37,
          column: 27
        },
        end: {
          line: 37,
          column: 72
        }
      },
      "21": {
        start: {
          line: 39,
          column: 27
        },
        end: {
          line: 39,
          column: 59
        }
      },
      "22": {
        start: {
          line: 40,
          column: 31
        },
        end: {
          line: 40,
          column: 70
        }
      },
      "23": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 64
        }
      },
      "24": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 93
        }
      },
      "25": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 98,
          column: 9
        }
      },
      "26": {
        start: {
          line: 47,
          column: 41
        },
        end: {
          line: 47,
          column: 75
        }
      },
      "27": {
        start: {
          line: 49,
          column: 28
        },
        end: {
          line: 49,
          column: 44
        }
      },
      "28": {
        start: {
          line: 49,
          column: 59
        },
        end: {
          line: 49,
          column: 76
        }
      },
      "29": {
        start: {
          line: 49,
          column: 93
        },
        end: {
          line: 49,
          column: 112
        }
      },
      "30": {
        start: {
          line: 51,
          column: 30
        },
        end: {
          line: 51,
          column: 51
        }
      },
      "31": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 66,
          column: 13
        }
      },
      "32": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 54,
          column: 55
        }
      },
      "33": {
        start: {
          line: 55,
          column: 16
        },
        end: {
          line: 55,
          column: 54
        }
      },
      "34": {
        start: {
          line: 57,
          column: 17
        },
        end: {
          line: 66,
          column: 13
        }
      },
      "35": {
        start: {
          line: 59,
          column: 16
        },
        end: {
          line: 59,
          column: 54
        }
      },
      "36": {
        start: {
          line: 60,
          column: 16
        },
        end: {
          line: 60,
          column: 56
        }
      },
      "37": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 79
        }
      },
      "38": {
        start: {
          line: 65,
          column: 16
        },
        end: {
          line: 65,
          column: 56
        }
      },
      "39": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 73,
          column: 13
        }
      },
      "40": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 25
        }
      },
      "41": {
        start: {
          line: 72,
          column: 16
        },
        end: {
          line: 72,
          column: 34
        }
      },
      "42": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 90,
          column: 13
        }
      },
      "43": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 78,
          column: 64
        }
      },
      "44": {
        start: {
          line: 79,
          column: 16
        },
        end: {
          line: 79,
          column: 56
        }
      },
      "45": {
        start: {
          line: 81,
          column: 17
        },
        end: {
          line: 90,
          column: 13
        }
      },
      "46": {
        start: {
          line: 83,
          column: 16
        },
        end: {
          line: 83,
          column: 64
        }
      },
      "47": {
        start: {
          line: 84,
          column: 16
        },
        end: {
          line: 84,
          column: 56
        }
      },
      "48": {
        start: {
          line: 88,
          column: 16
        },
        end: {
          line: 88,
          column: 78
        }
      },
      "49": {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 89,
          column: 54
        }
      },
      "50": {
        start: {
          line: 92,
          column: 12
        },
        end: {
          line: 97,
          column: 13
        }
      },
      "51": {
        start: {
          line: 93,
          column: 16
        },
        end: {
          line: 93,
          column: 25
        }
      },
      "52": {
        start: {
          line: 96,
          column: 16
        },
        end: {
          line: 96,
          column: 43
        }
      },
      "53": {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 40
        }
      },
      "54": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 126,
          column: 6
        }
      },
      "55": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 24
        }
      },
      "56": {
        start: {
          line: 107,
          column: 19
        },
        end: {
          line: 107,
          column: 28
        }
      },
      "57": {
        start: {
          line: 108,
          column: 21
        },
        end: {
          line: 108,
          column: 32
        }
      },
      "58": {
        start: {
          line: 109,
          column: 26
        },
        end: {
          line: 109,
          column: 42
        }
      },
      "59": {
        start: {
          line: 110,
          column: 25
        },
        end: {
          line: 110,
          column: 40
        }
      },
      "60": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 125,
          column: 11
        }
      },
      "61": {
        start: {
          line: 113,
          column: 24
        },
        end: {
          line: 113,
          column: 34
        }
      },
      "62": {
        start: {
          line: 114,
          column: 27
        },
        end: {
          line: 114,
          column: 60
        }
      },
      "63": {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 59
        }
      },
      "64": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 116,
          column: 35
        }
      },
      "65": {
        start: {
          line: 117,
          column: 12
        },
        end: {
          line: 117,
          column: 40
        }
      },
      "66": {
        start: {
          line: 119,
          column: 12
        },
        end: {
          line: 124,
          column: 15
        }
      },
      "67": {
        start: {
          line: 120,
          column: 16
        },
        end: {
          line: 120,
          column: 35
        }
      },
      "68": {
        start: {
          line: 121,
          column: 26
        },
        end: {
          line: 121,
          column: 59
        }
      },
      "69": {
        start: {
          line: 122,
          column: 16
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "70": {
        start: {
          line: 123,
          column: 20
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "71": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 149,
          column: 6
        }
      },
      "72": {
        start: {
          line: 131,
          column: 21
        },
        end: {
          line: 131,
          column: 32
        }
      },
      "73": {
        start: {
          line: 132,
          column: 25
        },
        end: {
          line: 132,
          column: 40
        }
      },
      "74": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 27
        }
      },
      "75": {
        start: {
          line: 136,
          column: 17
        },
        end: {
          line: 136,
          column: 39
        }
      },
      "76": {
        start: {
          line: 136,
          column: 47
        },
        end: {
          line: 136,
          column: 53
        }
      },
      "77": {
        start: {
          line: 136,
          column: 62
        },
        end: {
          line: 136,
          column: 69
        }
      },
      "78": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 137,
          column: 42
        }
      },
      "79": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 44
        }
      },
      "80": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 140,
          column: 64
        }
      },
      "81": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "82": {
        start: {
          line: 143,
          column: 12
        },
        end: {
          line: 143,
          column: 62
        }
      },
      "83": {
        start: {
          line: 146,
          column: 12
        },
        end: {
          line: 146,
          column: 58
        }
      },
      "84": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 26
        }
      },
      "85": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 156,
          column: 6
        }
      },
      "86": {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 154,
          column: 33
        }
      },
      "87": {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 27
        }
      },
      "88": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 166,
          column: 7
        }
      },
      "89": {
        start: {
          line: 162,
          column: 12
        },
        end: {
          line: 162,
          column: 30
        }
      },
      "90": {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 167,
          column: 19
        }
      },
      "91": {
        start: {
          line: 169,
          column: 0
        },
        end: {
          line: 169,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 29
          },
          end: {
            line: 11,
            column: 30
          }
        },
        loc: {
          start: {
            line: 11,
            column: 41
          },
          end: {
            line: 168,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "Tooltip",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 20
          }
        },
        loc: {
          start: {
            line: 12,
            column: 42
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 26,
            column: 40
          },
          end: {
            line: 26,
            column: 41
          }
        },
        loc: {
          start: {
            line: 26,
            column: 52
          },
          end: {
            line: 101,
            column: 5
          }
        },
        line: 26
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 105,
            column: 36
          },
          end: {
            line: 105,
            column: 37
          }
        },
        loc: {
          start: {
            line: 105,
            column: 48
          },
          end: {
            line: 126,
            column: 5
          }
        },
        line: 105
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 111,
            column: 21
          },
          end: {
            line: 111,
            column: 22
          }
        },
        loc: {
          start: {
            line: 111,
            column: 44
          },
          end: {
            line: 125,
            column: 9
          }
        },
        line: 111
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 119,
            column: 30
          },
          end: {
            line: 119,
            column: 31
          }
        },
        loc: {
          start: {
            line: 119,
            column: 43
          },
          end: {
            line: 124,
            column: 13
          }
        },
        line: 119
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 130,
            column: 31
          },
          end: {
            line: 130,
            column: 32
          }
        },
        loc: {
          start: {
            line: 130,
            column: 43
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 130
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 153,
            column: 31
          },
          end: {
            line: 153,
            column: 32
          }
        },
        loc: {
          start: {
            line: 153,
            column: 43
          },
          end: {
            line: 156,
            column: 5
          }
        },
        line: 153
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 161,
            column: 13
          },
          end: {
            line: 161,
            column: 14
          }
        },
        loc: {
          start: {
            line: 161,
            column: 25
          },
          end: {
            line: 163,
            column: 9
          }
        },
        line: 161
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }],
        line: 52
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 17
          },
          end: {
            line: 66,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 17
          },
          end: {
            line: 66,
            column: 13
          }
        }, {
          start: {
            line: 57,
            column: 17
          },
          end: {
            line: 66,
            column: 13
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 64,
            column: 23
          },
          end: {
            line: 64,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 41
          },
          end: {
            line: 64,
            column: 52
          }
        }, {
          start: {
            line: 64,
            column: 55
          },
          end: {
            line: 64,
            column: 56
          }
        }],
        line: 64
      },
      "7": {
        loc: {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        }, {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        }],
        line: 68
      },
      "8": {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 90,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 90,
            column: 13
          }
        }, {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 90,
            column: 13
          }
        }],
        line: 76
      },
      "9": {
        loc: {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 90,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 90,
            column: 13
          }
        }, {
          start: {
            line: 81,
            column: 17
          },
          end: {
            line: 90,
            column: 13
          }
        }],
        line: 81
      },
      "10": {
        loc: {
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        }, {
          start: {
            line: 92,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        }],
        line: 92
      },
      "11": {
        loc: {
          start: {
            line: 122,
            column: 16
          },
          end: {
            line: 123,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 16
          },
          end: {
            line: 123,
            column: 35
          }
        }, {
          start: {
            line: 122,
            column: 16
          },
          end: {
            line: 123,
            column: 35
          }
        }],
        line: 122
      },
      "12": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }],
        line: 142
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Tooltip.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Tooltip.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,kEAAoD;AAcpD;IAQI,iBAAY,MAAc,EAAE,KAAiB,EAAE,IAAqB;QAChE,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QACpB,IAAI,CAAC,WAAW,GAAG,KAAK,CAAA;QACxB,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;QAChB,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;QAClB,IAAI,CAAC,sBAAsB,GAAG,KAAK,CAAA;QAEnC,eAAe;QACf,IAAM,UAAU,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QACnC,UAAU,CAAC,QAAQ,CAAC,aAAa,CAAC,CAAA;QAClC,IAAI,CAAC,UAAU,GAAG,UAAU,CAAA;IAChC,CAAC;IAED;;OAEG;IACK,iCAAe,GAAvB;QACI,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAElC,IAAI,GAAG,GAAG,CAAC,CAAA;QACX,IAAI,IAAI,GAAG,CAAC,CAAA;QAEZ,cAAc;QACd,IAAM,aAAa,GAAG,EAAE,CAAA;QACxB,gBAAgB;QAChB,IAAM,aAAa,GAAG,QAAQ,CAAC,eAAe,CAAC,SAAS,CAAA;QACxD,aAAa;QACb,IAAM,cAAc,GAAG,IAAI,CAAC,WAAW,CAAC,qBAAqB,EAAE,CAAA;QAC/D,aAAa;QACb,IAAM,YAAY,GAAG,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAA;QAClE,gCAAgC;QAChC,IAAM,YAAY,GAAG,IAAI,CAAC,WAAW,CAAC,aAAa,EAAE,CAAA;QACrD,IAAM,gBAAgB,GAAG,kBAAC,CAAC,YAAY,CAAC,MAAM,CAAC,CAAA;QAC/C,gBAAgB;QAChB,IAAM,SAAS,GAAG,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,SAAS,CAAA;QAC1D,uBAAuB;QACvB,IAAI,CAAC,sBAAsB,GAAG,gBAAgB,CAAC,KAAK,CAAC,IAAI,CAAC,MAAM,CAAC,kBAAkB,CAAC,CAAA;QAEpF,IAAI,IAAI,CAAC,sBAAsB,EAAE;YAC7B,SAAS;YACT,IAAM,sBAAsB,GAAG,gBAAgB,CAAC,eAAe,EAAE,CAAA;YACjE,cAAc;YACN,IAAK,SAAS,GAA6C,YAAY,IAAzD,EAAQ,UAAU,GAA2B,YAAY,KAAvC,EAAU,YAAY,GAAK,YAAY,OAAjB,CAAiB;YAC/E,mBAAmB;YACnB,IAAM,WAAW,GAAG,SAAS,GAAG,SAAS,CAAA;YACzC,IAAI,WAAW,GAAG,aAAa,GAAG,CAAC,EAAE;gBACjC,gBAAgB;gBAChB,GAAG,GAAG,WAAW,GAAG,aAAa,GAAG,EAAE,CAAA;gBACtC,UAAU,CAAC,QAAQ,CAAC,gBAAgB,CAAC,CAAA;aACxC;iBAAM,IAAI,WAAW,GAAG,YAAY,GAAG,aAAa,GAAG,sBAAsB,EAAE;gBAC5E,gBAAgB;gBAChB,GAAG,GAAG,WAAW,GAAG,YAAY,GAAG,EAAE,CAAA;gBACrC,UAAU,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAA;aAC1C;iBAAM;gBACH,yBAAyB;gBACzB,GAAG,GAAG,CAAC,WAAW,GAAG,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,aAAa,GAAG,EAAE,CAAA;gBAC9D,UAAU,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAA;aAC1C;YACD,UAAU;YACV,IAAI,UAAU,GAAG,CAAC,EAAE;gBAChB,IAAI,GAAG,CAAC,CAAA;aACX;iBAAM;gBACH,IAAI,GAAG,UAAU,CAAA;aACpB;SACJ;aAAM;YACH,IAAI,cAAc,CAAC,GAAG,GAAG,aAAa,EAAE;gBACpC,0CAA0C;gBAC1C,GAAG,GAAG,cAAc,CAAC,MAAM,GAAG,aAAa,GAAG,CAAC,CAAA,CAAC,SAAS;gBACzD,UAAU,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAA;aAC1C;iBAAM,IAAI,cAAc,CAAC,GAAG,GAAG,YAAY,CAAC,GAAG,GAAG,aAAa,EAAE;gBAC9D,2CAA2C;gBAC3C,GAAG,GAAG,cAAc,CAAC,MAAM,GAAG,aAAa,GAAG,CAAC,CAAA,CAAC,SAAS;gBACzD,UAAU,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAA;aAC1C;iBAAM;gBACH,wBAAwB;gBACxB,GAAG,GAAG,cAAc,CAAC,GAAG,GAAG,aAAa,GAAG,aAAa,GAAG,EAAE,CAAA,CAAC,4BAA4B;gBAC1F,UAAU,CAAC,QAAQ,CAAC,gBAAgB,CAAC,CAAA;aACxC;YACD,UAAU;YACV,IAAI,cAAc,CAAC,IAAI,GAAG,CAAC,EAAE;gBACzB,IAAI,GAAG,CAAC,CAAA;aACX;iBAAM;gBACH,IAAI,GAAG,cAAc,CAAC,IAAI,CAAA;aAC7B;SACJ;QAED,OAAO;QACP,OAAO,EAAE,GAAG,KAAA,EAAE,IAAI,MAAA,EAAE,CAAA;IACxB,CAAC;IAED;;OAEG;IACK,6BAAW,GAAnB;QAAA,iBAqBC;QApBG,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,WAAW,GAAG,IAAI,CAAC,WAAW,CAAA;QACpC,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAElC,IAAI,CAAC,OAAO,CAAC,UAAC,IAAyB,EAAE,KAAa;YAClD,OAAO;YACP,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAA;YACxB,IAAM,QAAQ,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;YACjC,QAAQ,CAAC,QAAQ,CAAC,2BAA2B,CAAC,CAAA;YAC9C,QAAQ,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;YACtB,UAAU,CAAC,MAAM,CAAC,QAAQ,CAAC,CAAA;YAE3B,SAAS;YACT,KAAK,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;gBACvB,CAAC,CAAC,cAAc,EAAE,CAAA;gBAClB,IAAM,GAAG,GAAG,IAAI,CAAC,OAAO,CAAC,MAAM,EAAE,WAAW,CAAC,CAAA;gBAC7C,IAAI,GAAG;oBAAE,KAAI,CAAC,MAAM,EAAE,CAAA;YAC1B,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACI,wBAAM,GAAb;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAElC,mBAAmB;QACnB,IAAI,CAAC,WAAW,EAAE,CAAA;QAElB,OAAO;QACD,IAAA,KAAgB,IAAI,CAAC,eAAe,EAAE,EAApC,GAAG,SAAA,EAAE,IAAI,UAA2B,CAAA;QAC5C,UAAU,CAAC,GAAG,CAAC,KAAK,EAAK,GAAG,OAAI,CAAC,CAAA;QACjC,UAAU,CAAC,GAAG,CAAC,MAAM,EAAK,IAAI,OAAI,CAAC,CAAA;QAEnC,aAAa;QACb,UAAU,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,SAAS,CAAC,CAAC,CAAA;QAEvD,UAAU;QACV,IAAI,IAAI,CAAC,sBAAsB,EAAE;YAC7B,IAAI,CAAC,MAAM,CAAC,kBAAkB,CAAC,MAAM,CAAC,UAAU,CAAC,CAAA;SACpD;aAAM;YACH,kBAAC,CAAC,MAAM,CAAC,CAAC,MAAM,CAAC,UAAU,CAAC,CAAA;SAC/B;QAED,IAAI,CAAC,KAAK,GAAG,IAAI,CAAA;IACrB,CAAC;IAED;;OAEG;IACI,wBAAM,GAAb;QACI,IAAI,CAAC,UAAU,CAAC,MAAM,EAAE,CAAA;QACxB,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;IACtB,CAAC;IAKD,sBAAW,2BAAM;QAHjB;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,KAAK,CAAA;QACrB,CAAC;;;OAAA;IACL,cAAC;AAAD,CAAC,AAtKD,IAsKC;AAED,kBAAe,OAAO,CAAA",
      sourcesContent: ["/**\n * @description Tooltip class\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\n\ntype PositionDataType = {\n    top: number\n    left: number\n}\n\nexport type TooltipConfItemType = {\n    $elem: DomElement\n    onClick: Function\n}\nexport type TooltipConfType = Array<TooltipConfItemType>\n\nclass Tooltip {\n    private $container: DomElement\n    private $targetElem: DomElement\n    private editor: Editor\n    private conf: TooltipConfType\n    private _show: boolean\n    private _isInsertTextContainer: boolean\n\n    constructor(editor: Editor, $elem: DomElement, conf: TooltipConfType) {\n        this.editor = editor\n        this.$targetElem = $elem\n        this.conf = conf\n        this._show = false\n        this._isInsertTextContainer = false\n\n        // \u5B9A\u4E49 container\n        const $container = $('<div></div>')\n        $container.addClass('w-e-tooltip')\n        this.$container = $container\n    }\n\n    /**\n     * \u83B7\u53D6 tooltip \u5B9A\u4F4D\n     */\n    private getPositionData(): PositionDataType {\n        const $container = this.$container\n\n        let top = 0\n        let left = 0\n\n        // tooltip \u7684\u9AD8\u5EA6\n        const tooltipHeight = 20\n        // \u7F51\u9875\u7684 scrollTop\n        const pageScrollTop = document.documentElement.scrollTop\n        // \u76EE\u6807\u5143\u7D20\u7684 rect\n        const targetElemRect = this.$targetElem.getBoundingClientRect()\n        // \u7F16\u8F91\u533A\u57DF\u7684 rect\n        const textElemRect = this.editor.$textElem.getBoundingClientRect()\n        // \u83B7\u53D6\u57FA\u4E8E textContainerElem \u7684 \u4F4D\u7F6E\u4FE1\u606F\n        const targetOffset = this.$targetElem.getOffsetData()\n        const targetParentElem = $(targetOffset.parent)\n        // \u83B7\u53D6 \u7F16\u8F91\u533A\u57DF\u7684\u6EDA\u52A8\u6761\u4FE1\u606F\n        const scrollTop = this.editor.$textElem.elems[0].scrollTop\n        // \u662F\u5426\u63D2\u5165 textContainer \u4E2D\n        this._isInsertTextContainer = targetParentElem.equal(this.editor.$textContainerElem)\n\n        if (this._isInsertTextContainer) {\n            // \u7236\u5BB9\u5668\u7684\u9AD8\u5EA6\n            const targetParentElemHeight = targetParentElem.getClientHeight()\n            // \u76F8\u5BF9\u4E8E\u7236\u5BB9\u5668\u7684\u4F4D\u7F6E\u4FE1\u606F\n            const { top: offsetTop, left: offsetLeft, height: offsetHeight } = targetOffset\n            // \u5143\u7D20\u57FA\u4E8E\u7236\u5BB9\u5668\u7684 \u7EDD\u5BF9top\u4FE1\u606F\n            const absoluteTop = offsetTop - scrollTop\n            if (absoluteTop > tooltipHeight + 5) {\n                // \u8BF4\u660E\u6A21\u677F\u5143\u7D20\u7684\u9876\u90E8\u7A7A\u95F4\u8DB3\u591F\n                top = absoluteTop - tooltipHeight - 15\n                $container.addClass('w-e-tooltip-up')\n            } else if (absoluteTop + offsetHeight + tooltipHeight < targetParentElemHeight) {\n                // \u8BF4\u660E\u6A21\u677F\u5143\u7D20\u7684\u5E95\u90E8\u7A7A\u95F4\u8DB3\u591F\n                top = absoluteTop + offsetHeight + 10\n                $container.addClass('w-e-tooltip-down')\n            } else {\n                // \u5176\u4ED6\u60C5\u51B5\uFF0Ctooltip \u653E\u5728\u76EE\u6807\u5143\u7D20\u5DE6\u4E0A\u89D2\n                top = (absoluteTop > 0 ? absoluteTop : 0) + tooltipHeight + 10\n                $container.addClass('w-e-tooltip-down')\n            }\n            // \u8BA1\u7B97 left\n            if (offsetLeft < 0) {\n                left = 0\n            } else {\n                left = offsetLeft\n            }\n        } else {\n            if (targetElemRect.top < tooltipHeight) {\n                // \u8BF4\u660E\u76EE\u6807\u5143\u7D20\u7684\u9876\u90E8\uFF0C\u56E0\u6ED1\u52A8\u9690\u85CF\u5728\u6D4F\u89C8\u5668\u4E0A\u65B9\u3002tooltip \u8981\u653E\u5728\u76EE\u6807\u5143\u7D20\u4E0B\u9762\n                top = targetElemRect.bottom + pageScrollTop + 5 // 5px \u95F4\u8DDD\n                $container.addClass('w-e-tooltip-down')\n            } else if (targetElemRect.top - textElemRect.top < tooltipHeight) {\n                // \u8BF4\u660E\u76EE\u6807\u5143\u7D20\u7684\u9876\u90E8\uFF0C\u56E0\u6ED1\u52A8\u9690\u85CF\u5728\u7F16\u8F91\u533A\u57DF\u4E0A\u65B9\u3002tooltip \u8981\u653E\u5728\u76EE\u6807\u5143\u7D20\u4E0B\u9762\n                top = targetElemRect.bottom + pageScrollTop + 5 // 5px \u95F4\u8DDD\n                $container.addClass('w-e-tooltip-down')\n            } else {\n                // \u5176\u4ED6\u60C5\u51B5\uFF0Ctooltip \u653E\u5728\u76EE\u6807\u5143\u7D20\u4E0A\u65B9\n                top = targetElemRect.top + pageScrollTop - tooltipHeight - 15 // \u51CF\u53BB toolbar \u7684\u9AD8\u5EA6\uFF0C\u8FD8\u6709 15px \u95F4\u8DDD\n                $container.addClass('w-e-tooltip-up')\n            }\n            // \u8BA1\u7B97 left\n            if (targetElemRect.left < 0) {\n                left = 0\n            } else {\n                left = targetElemRect.left\n            }\n        }\n\n        // \u8FD4\u56DE\u7ED3\u679C\n        return { top, left }\n    }\n\n    /**\n     * \u6DFB\u52A0 tooltip \u83DC\u5355\n     */\n    private appendMenus(): void {\n        const conf = this.conf\n        const editor = this.editor\n        const $targetElem = this.$targetElem\n        const $container = this.$container\n\n        conf.forEach((item: TooltipConfItemType, index: number) => {\n            // \u6DFB\u52A0\u5143\u7D20\n            const $elem = item.$elem\n            const $wrapper = $('<div></div>')\n            $wrapper.addClass('w-e-tooltip-item-wrapper ')\n            $wrapper.append($elem)\n            $container.append($wrapper)\n\n            // \u7ED1\u5B9A\u70B9\u51FB\u4E8B\u4EF6\n            $elem.on('click', (e: Event) => {\n                e.preventDefault()\n                const res = item.onClick(editor, $targetElem)\n                if (res) this.remove()\n            })\n        })\n    }\n\n    /**\n     * \u521B\u5EFA tooltip\n     */\n    public create(): void {\n        const editor = this.editor\n        const $container = this.$container\n\n        // \u751F\u6210 container \u7684\u5185\u5BB9\n        this.appendMenus()\n\n        // \u8BBE\u7F6E\u5B9A\u4F4D\n        const { top, left } = this.getPositionData()\n        $container.css('top', `${top}px`)\n        $container.css('left', `${left}px`)\n\n        // \u8BBE\u7F6E z-index\n        $container.css('z-index', editor.zIndex.get('tooltip'))\n\n        // \u6DFB\u52A0\u5230 DOM\n        if (this._isInsertTextContainer) {\n            this.editor.$textContainerElem.append($container)\n        } else {\n            $('body').append($container)\n        }\n\n        this._show = true\n    }\n\n    /**\n     * \u79FB\u9664\u8BE5 tooltip\n     */\n    public remove(): void {\n        this.$container.remove()\n        this._show = false\n    }\n\n    /**\n     * \u662F\u5426\u663E\u793A\n     */\n    public get isShow(): boolean {\n        return this._show\n    }\n}\n\nexport default Tooltip\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f75ed040021ffde1e5c6408c8b0da17f5646186a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ig3psa2jh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ig3psa2jh();

var __importDefault = (cov_1ig3psa2jh().s[0]++, (cov_1ig3psa2jh().b[0][0]++, void 0) && (cov_1ig3psa2jh().b[0][1]++, (void 0).__importDefault) || (cov_1ig3psa2jh().b[0][2]++, function (mod) {
  cov_1ig3psa2jh().f[0]++;
  cov_1ig3psa2jh().s[1]++;
  return (cov_1ig3psa2jh().b[2][0]++, mod) && (cov_1ig3psa2jh().b[2][1]++, mod.__esModule) ? (cov_1ig3psa2jh().b[1][0]++, mod) : (cov_1ig3psa2jh().b[1][1]++, {
    "default": mod
  });
}));

cov_1ig3psa2jh().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1ig3psa2jh().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip = (
/** @class */
cov_1ig3psa2jh().s[4]++, function () {
  cov_1ig3psa2jh().f[1]++;

  function Tooltip(editor, $elem, conf) {
    cov_1ig3psa2jh().f[2]++;
    cov_1ig3psa2jh().s[5]++;
    this.editor = editor;
    cov_1ig3psa2jh().s[6]++;
    this.$targetElem = $elem;
    cov_1ig3psa2jh().s[7]++;
    this.conf = conf;
    cov_1ig3psa2jh().s[8]++;
    this._show = false;
    cov_1ig3psa2jh().s[9]++;
    this._isInsertTextContainer = false; // 定义 container

    var $container = (cov_1ig3psa2jh().s[10]++, dom_core_1["default"]('<div></div>'));
    cov_1ig3psa2jh().s[11]++;
    $container.addClass('w-e-tooltip');
    cov_1ig3psa2jh().s[12]++;
    this.$container = $container;
  }
  /**
   * 获取 tooltip 定位
   */


  cov_1ig3psa2jh().s[13]++;

  Tooltip.prototype.getPositionData = function () {
    cov_1ig3psa2jh().f[3]++;
    var $container = (cov_1ig3psa2jh().s[14]++, this.$container);
    var top = (cov_1ig3psa2jh().s[15]++, 0);
    var left = (cov_1ig3psa2jh().s[16]++, 0); // tooltip 的高度

    var tooltipHeight = (cov_1ig3psa2jh().s[17]++, 20); // 网页的 scrollTop

    var pageScrollTop = (cov_1ig3psa2jh().s[18]++, document.documentElement.scrollTop); // 目标元素的 rect

    var targetElemRect = (cov_1ig3psa2jh().s[19]++, this.$targetElem.getBoundingClientRect()); // 编辑区域的 rect

    var textElemRect = (cov_1ig3psa2jh().s[20]++, this.editor.$textElem.getBoundingClientRect()); // 获取基于 textContainerElem 的 位置信息

    var targetOffset = (cov_1ig3psa2jh().s[21]++, this.$targetElem.getOffsetData());
    var targetParentElem = (cov_1ig3psa2jh().s[22]++, dom_core_1["default"](targetOffset.parent)); // 获取 编辑区域的滚动条信息

    var scrollTop = (cov_1ig3psa2jh().s[23]++, this.editor.$textElem.elems[0].scrollTop); // 是否插入 textContainer 中

    cov_1ig3psa2jh().s[24]++;
    this._isInsertTextContainer = targetParentElem.equal(this.editor.$textContainerElem);
    cov_1ig3psa2jh().s[25]++;

    if (this._isInsertTextContainer) {
      cov_1ig3psa2jh().b[3][0]++;
      // 父容器的高度
      var targetParentElemHeight = (cov_1ig3psa2jh().s[26]++, targetParentElem.getClientHeight()); // 相对于父容器的位置信息

      var offsetTop = (cov_1ig3psa2jh().s[27]++, targetOffset.top),
          offsetLeft = (cov_1ig3psa2jh().s[28]++, targetOffset.left),
          offsetHeight = (cov_1ig3psa2jh().s[29]++, targetOffset.height); // 元素基于父容器的 绝对top信息

      var absoluteTop = (cov_1ig3psa2jh().s[30]++, offsetTop - scrollTop);
      cov_1ig3psa2jh().s[31]++;

      if (absoluteTop > tooltipHeight + 5) {
        cov_1ig3psa2jh().b[4][0]++;
        cov_1ig3psa2jh().s[32]++;
        // 说明模板元素的顶部空间足够
        top = absoluteTop - tooltipHeight - 15;
        cov_1ig3psa2jh().s[33]++;
        $container.addClass('w-e-tooltip-up');
      } else {
        cov_1ig3psa2jh().b[4][1]++;
        cov_1ig3psa2jh().s[34]++;

        if (absoluteTop + offsetHeight + tooltipHeight < targetParentElemHeight) {
          cov_1ig3psa2jh().b[5][0]++;
          cov_1ig3psa2jh().s[35]++;
          // 说明模板元素的底部空间足够
          top = absoluteTop + offsetHeight + 10;
          cov_1ig3psa2jh().s[36]++;
          $container.addClass('w-e-tooltip-down');
        } else {
          cov_1ig3psa2jh().b[5][1]++;
          cov_1ig3psa2jh().s[37]++;
          // 其他情况，tooltip 放在目标元素左上角
          top = (absoluteTop > 0 ? (cov_1ig3psa2jh().b[6][0]++, absoluteTop) : (cov_1ig3psa2jh().b[6][1]++, 0)) + tooltipHeight + 10;
          cov_1ig3psa2jh().s[38]++;
          $container.addClass('w-e-tooltip-down');
        }
      } // 计算 left


      cov_1ig3psa2jh().s[39]++;

      if (offsetLeft < 0) {
        cov_1ig3psa2jh().b[7][0]++;
        cov_1ig3psa2jh().s[40]++;
        left = 0;
      } else {
        cov_1ig3psa2jh().b[7][1]++;
        cov_1ig3psa2jh().s[41]++;
        left = offsetLeft;
      }
    } else {
      cov_1ig3psa2jh().b[3][1]++;
      cov_1ig3psa2jh().s[42]++;

      if (targetElemRect.top < tooltipHeight) {
        cov_1ig3psa2jh().b[8][0]++;
        cov_1ig3psa2jh().s[43]++;
        // 说明目标元素的顶部，因滑动隐藏在浏览器上方。tooltip 要放在目标元素下面
        top = targetElemRect.bottom + pageScrollTop + 5; // 5px 间距

        cov_1ig3psa2jh().s[44]++;
        $container.addClass('w-e-tooltip-down');
      } else {
        cov_1ig3psa2jh().b[8][1]++;
        cov_1ig3psa2jh().s[45]++;

        if (targetElemRect.top - textElemRect.top < tooltipHeight) {
          cov_1ig3psa2jh().b[9][0]++;
          cov_1ig3psa2jh().s[46]++;
          // 说明目标元素的顶部，因滑动隐藏在编辑区域上方。tooltip 要放在目标元素下面
          top = targetElemRect.bottom + pageScrollTop + 5; // 5px 间距

          cov_1ig3psa2jh().s[47]++;
          $container.addClass('w-e-tooltip-down');
        } else {
          cov_1ig3psa2jh().b[9][1]++;
          cov_1ig3psa2jh().s[48]++;
          // 其他情况，tooltip 放在目标元素上方
          top = targetElemRect.top + pageScrollTop - tooltipHeight - 15; // 减去 toolbar 的高度，还有 15px 间距

          cov_1ig3psa2jh().s[49]++;
          $container.addClass('w-e-tooltip-up');
        }
      } // 计算 left


      cov_1ig3psa2jh().s[50]++;

      if (targetElemRect.left < 0) {
        cov_1ig3psa2jh().b[10][0]++;
        cov_1ig3psa2jh().s[51]++;
        left = 0;
      } else {
        cov_1ig3psa2jh().b[10][1]++;
        cov_1ig3psa2jh().s[52]++;
        left = targetElemRect.left;
      }
    } // 返回结果


    cov_1ig3psa2jh().s[53]++;
    return {
      top: top,
      left: left
    };
  };
  /**
   * 添加 tooltip 菜单
   */


  cov_1ig3psa2jh().s[54]++;

  Tooltip.prototype.appendMenus = function () {
    cov_1ig3psa2jh().f[4]++;

    var _this = (cov_1ig3psa2jh().s[55]++, this);

    var conf = (cov_1ig3psa2jh().s[56]++, this.conf);
    var editor = (cov_1ig3psa2jh().s[57]++, this.editor);
    var $targetElem = (cov_1ig3psa2jh().s[58]++, this.$targetElem);
    var $container = (cov_1ig3psa2jh().s[59]++, this.$container);
    cov_1ig3psa2jh().s[60]++;
    (0, _forEach["default"])(conf).call(conf, function (item, index) {
      cov_1ig3psa2jh().f[5]++;
      // 添加元素
      var $elem = (cov_1ig3psa2jh().s[61]++, item.$elem);
      var $wrapper = (cov_1ig3psa2jh().s[62]++, dom_core_1["default"]('<div></div>'));
      cov_1ig3psa2jh().s[63]++;
      $wrapper.addClass('w-e-tooltip-item-wrapper ');
      cov_1ig3psa2jh().s[64]++;
      $wrapper.append($elem);
      cov_1ig3psa2jh().s[65]++;
      $container.append($wrapper); // 绑定点击事件

      cov_1ig3psa2jh().s[66]++;
      $elem.on('click', function (e) {
        cov_1ig3psa2jh().f[6]++;
        cov_1ig3psa2jh().s[67]++;
        e.preventDefault();
        var res = (cov_1ig3psa2jh().s[68]++, item.onClick(editor, $targetElem));
        cov_1ig3psa2jh().s[69]++;

        if (res) {
          cov_1ig3psa2jh().b[11][0]++;
          cov_1ig3psa2jh().s[70]++;

          _this.remove();
        } else {
          cov_1ig3psa2jh().b[11][1]++;
        }
      });
    });
  };
  /**
   * 创建 tooltip
   */


  cov_1ig3psa2jh().s[71]++;

  Tooltip.prototype.create = function () {
    cov_1ig3psa2jh().f[7]++;
    var editor = (cov_1ig3psa2jh().s[72]++, this.editor);
    var $container = (cov_1ig3psa2jh().s[73]++, this.$container); // 生成 container 的内容

    cov_1ig3psa2jh().s[74]++;
    this.appendMenus(); // 设置定位

    var _a = (cov_1ig3psa2jh().s[75]++, this.getPositionData()),
        top = (cov_1ig3psa2jh().s[76]++, _a.top),
        left = (cov_1ig3psa2jh().s[77]++, _a.left);

    cov_1ig3psa2jh().s[78]++;
    $container.css('top', top + "px");
    cov_1ig3psa2jh().s[79]++;
    $container.css('left', left + "px"); // 设置 z-index

    cov_1ig3psa2jh().s[80]++;
    $container.css('z-index', editor.zIndex.get('tooltip')); // 添加到 DOM

    cov_1ig3psa2jh().s[81]++;

    if (this._isInsertTextContainer) {
      cov_1ig3psa2jh().b[12][0]++;
      cov_1ig3psa2jh().s[82]++;
      this.editor.$textContainerElem.append($container);
    } else {
      cov_1ig3psa2jh().b[12][1]++;
      cov_1ig3psa2jh().s[83]++;
      dom_core_1["default"]('body').append($container);
    }

    cov_1ig3psa2jh().s[84]++;
    this._show = true;
  };
  /**
   * 移除该 tooltip
   */


  cov_1ig3psa2jh().s[85]++;

  Tooltip.prototype.remove = function () {
    cov_1ig3psa2jh().f[8]++;
    cov_1ig3psa2jh().s[86]++;
    this.$container.remove();
    cov_1ig3psa2jh().s[87]++;
    this._show = false;
  };

  cov_1ig3psa2jh().s[88]++;
  (0, _defineProperty["default"])(Tooltip.prototype, "isShow", {
    /**
     * 是否显示
     */
    get: function get() {
      cov_1ig3psa2jh().f[9]++;
      cov_1ig3psa2jh().s[89]++;
      return this._show;
    },
    enumerable: false,
    configurable: true
  });
  cov_1ig3psa2jh().s[90]++;
  return Tooltip;
}());
cov_1ig3psa2jh().s[91]++;
exports["default"] = Tooltip;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(29);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var defineProperties = __webpack_require__(135);
var enumBugKeys = __webpack_require__(71);
var hiddenKeys = __webpack_require__(48);
var html = __webpack_require__(99);
var documentCreateElement = __webpack_require__(68);
var sharedKey = __webpack_require__(59);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__(16);

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172);
var DOMIterables = __webpack_require__(173);
var global = __webpack_require__(8);
var classof = __webpack_require__(61);
var createNonEnumerableProperty = __webpack_require__(16);
var Iterators = __webpack_require__(38);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }
  Iterators[COLLECTION_NAME] = Iterators.Array;
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(44);

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var wellKnownSymbol = __webpack_require__(9);
var V8_VERSION = __webpack_require__(82);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(202);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(254);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(98);
var enumBugKeys = __webpack_require__(71);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(72);
var uid = __webpack_require__(60);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(77);
var classofRaw = __webpack_require__(44);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(29);

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(170).charAt;
var InternalStateModule = __webpack_require__(40);
var defineIterator = __webpack_require__(83);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var propertyIsEnumerableModule = __webpack_require__(55);
var createPropertyDescriptor = __webpack_require__(33);
var toIndexedObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(96);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var classof = __webpack_require__(44);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var isObject = __webpack_require__(13);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(25);
var toLength = __webpack_require__(34);
var toAbsoluteIndex = __webpack_require__(70);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(35);
var store = __webpack_require__(73);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.7.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var setGlobal = __webpack_require__(136);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(15);
var toObject = __webpack_require__(36);
var sharedKey = __webpack_require__(59);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(156);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var aPossiblePrototype = __webpack_require__(157);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(26);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(44);
var global = __webpack_require__(8);

module.exports = classof(global.process) == 'process';


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var userAgent = __webpack_require__(79);

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var createIteratorConstructor = __webpack_require__(171);
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(75);
var setToStringTag = __webpack_require__(39);
var createNonEnumerableProperty = __webpack_require__(16);
var redefine = __webpack_require__(49);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(35);
var Iterators = __webpack_require__(38);
var IteratorsCore = __webpack_require__(109);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var isArray = __webpack_require__(51);
var wellKnownSymbol = __webpack_require__(9);

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(194);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(198);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(56);
var definePropertyModule = __webpack_require__(17);
var createPropertyDescriptor = __webpack_require__(33);

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(45);
var whitespaces = __webpack_require__(65);

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var _Symbol$iterator = __webpack_require__(222);

var _Symbol = __webpack_require__(225);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof _Symbol === "function" && typeof _Symbol$iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof _Symbol === "function" && obj.constructor === _Symbol && obj !== _Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

exports.f = wellKnownSymbol;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description Menu class 父类
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2h49l1ffo3() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Menu.ts";
  var hash = "3f5a4169f58a63f6fac602e4a5ef008de16cdd77";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Menu.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 10,
          column: 49
        }
      },
      "4": {
        start: {
          line: 11,
          column: 26
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 24
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 27
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "8": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 29
        }
      },
      "9": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 27,
          column: 11
        }
      },
      "10": {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 47
        }
      },
      "11": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 90
        }
      },
      "12": {
        start: {
          line: 21,
          column: 74
        },
        end: {
          line: 21,
          column: 86
        }
      },
      "13": {
        start: {
          line: 22,
          column: 12
        },
        end: {
          line: 22,
          column: 32
        }
      },
      "14": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 25,
          column: 13
        }
      },
      "15": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 23
        }
      },
      "16": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 34
        }
      },
      "17": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 51
        }
      },
      "18": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 40,
          column: 6
        }
      },
      "19": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 28
        }
      },
      "20": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 42
        }
      },
      "21": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 47,
          column: 6
        }
      },
      "22": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 29
        }
      },
      "23": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 45
        }
      },
      "24": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "25": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 53,
          column: 32
        }
      },
      "26": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 16
        }
      },
      "27": {
        start: {
          line: 60,
          column: 0
        },
        end: {
          line: 60,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 26
          },
          end: {
            line: 11,
            column: 27
          }
        },
        loc: {
          start: {
            line: 11,
            column: 38
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "Menu",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 17
          }
        },
        loc: {
          start: {
            line: 12,
            column: 33
          },
          end: {
            line: 28,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 18,
            column: 26
          },
          end: {
            line: 18,
            column: 27
          }
        },
        loc: {
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 18
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 21,
            column: 58
          },
          end: {
            line: 21,
            column: 59
          }
        },
        loc: {
          start: {
            line: 21,
            column: 72
          },
          end: {
            line: 21,
            column: 88
          }
        },
        line: 21
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 33,
            column: 34
          },
          end: {
            line: 33,
            column: 35
          }
        },
        loc: {
          start: {
            line: 33,
            column: 47
          },
          end: {
            line: 33,
            column: 50
          }
        },
        line: 33
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 29
          }
        },
        loc: {
          start: {
            line: 37,
            column: 40
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 37
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 44,
            column: 30
          },
          end: {
            line: 44,
            column: 31
          }
        },
        loc: {
          start: {
            line: 44,
            column: 42
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 44
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 14
          }
        },
        loc: {
          start: {
            line: 52,
            column: 25
          },
          end: {
            line: 54,
            column: 9
          }
        },
        line: 52
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 25,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 25,
            column: 13
          }
        }, {
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 25,
            column: 13
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Menu.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/Menu.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,kDAA2B;AAS3B;IAMI,cAAY,KAAiB,EAAE,MAAc;QAA7C,iBAkBC;QAjBG,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;QAClB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QACpB,IAAI,CAAC,OAAO,GAAG,KAAK,CAAA;QAEpB,WAAW;QACX,KAAK,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YACvB,eAAK,CAAC,gBAAgB,EAAE,CAAA,CAAC,gBAAgB;YAEzC,YAAY;YACZ,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,EAAE,EAAJ,CAAI,CAAC,CAAA;YAEzD,CAAC,CAAC,eAAe,EAAE,CAAA;YACnB,IAAI,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,IAAI,IAAI,EAAE;gBACrC,OAAM;aACT;YACD,KAAI,CAAC,YAAY,CAAC,CAAC,CAAC,CAAA;QACxB,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;OAGG;IACO,2BAAY,GAAtB,UAAuB,CAAQ,IAAS,CAAC;IAEzC;;OAEG;IACO,qBAAM,GAAhB;QACI,IAAI,CAAC,OAAO,GAAG,IAAI,CAAA;QACnB,IAAI,CAAC,KAAK,CAAC,QAAQ,CAAC,YAAY,CAAC,CAAA;IACrC,CAAC;IAED;;OAEG;IACO,uBAAQ,GAAlB;QACI,IAAI,CAAC,OAAO,GAAG,KAAK,CAAA;QACpB,IAAI,CAAC,KAAK,CAAC,WAAW,CAAC,YAAY,CAAC,CAAA;IACxC,CAAC;IAKD,sBAAW,0BAAQ;QAHnB;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,OAAO,CAAA;QACvB,CAAC;;;OAAA;IACL,WAAC;AAAD,CAAC,AAtDD,IAsDC;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description Menu class \u7236\u7C7B\n * @author wangfupeng\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport Panel from './Panel'\n\nexport interface MenuActive {\n    /**\n     * \u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\uFF0C\u83DC\u5355\u662F\u5426\u9AD8\u4EAE\n     */\n    tryChangeActive(): void\n}\n\nclass Menu {\n    public key: string | undefined\n    public $elem: DomElement\n    public editor: Editor\n    private _active: boolean // \u83DC\u5355\u662F\u5426\u5904\u4E8E\u6FC0\u6D3B\u72B6\u6001\uFF0C\u5982\u9009\u4E2D\u4E00\u6BB5\u52A0\u7C97\u6587\u5B57\u65F6\uFF0Cbold \u83DC\u5355\u8981\u88AB\u6FC0\u6D3B\uFF08\u5373\u9AD8\u4EAE\u663E\u793A\uFF09\n\n    constructor($elem: DomElement, editor: Editor) {\n        this.$elem = $elem\n        this.editor = editor\n        this._active = false\n\n        // \u7ED1\u5B9A\u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n        $elem.on('click', (e: Event) => {\n            Panel.hideCurAllPanels() // \u9690\u85CF\u5F53\u524D\u7684\u6240\u6709 Panel\n\n            // \u89E6\u53D1\u83DC\u5355\u70B9\u51FB\u7684\u94A9\u5B50\n            editor.txt.eventHooks.menuClickEvents.forEach(fn => fn())\n\n            e.stopPropagation()\n            if (editor.selection.getRange() == null) {\n                return\n            }\n            this.clickHandler(e)\n        })\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\uFF0C\u5B50\u7C7B\u53EF\u91CD\u5199\n     * @param e event\n     */\n    protected clickHandler(e: Event): void {}\n\n    /**\n     * \u6FC0\u6D3B\u83DC\u5355\uFF0C\u9AD8\u4EAE\u663E\u793A\n     */\n    protected active(): void {\n        this._active = true\n        this.$elem.addClass('w-e-active')\n    }\n\n    /**\n     * \u53D6\u6D88\u6FC0\u6D3B\uFF0C\u4E0D\u518D\u9AD8\u4EAE\u663E\u793A\n     */\n    protected unActive(): void {\n        this._active = false\n        this.$elem.removeClass('w-e-active')\n    }\n\n    /**\n     * \u662F\u5426\u5904\u4E8E\u6FC0\u6D3B\u72B6\u6001\n     */\n    public get isActive() {\n        return this._active\n    }\n}\n\nexport default Menu\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3f5a4169f58a63f6fac602e4a5ef008de16cdd77"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2h49l1ffo3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2h49l1ffo3();

var __importDefault = (cov_2h49l1ffo3().s[0]++, (cov_2h49l1ffo3().b[0][0]++, void 0) && (cov_2h49l1ffo3().b[0][1]++, (void 0).__importDefault) || (cov_2h49l1ffo3().b[0][2]++, function (mod) {
  cov_2h49l1ffo3().f[0]++;
  cov_2h49l1ffo3().s[1]++;
  return (cov_2h49l1ffo3().b[2][0]++, mod) && (cov_2h49l1ffo3().b[2][1]++, mod.__esModule) ? (cov_2h49l1ffo3().b[1][0]++, mod) : (cov_2h49l1ffo3().b[1][1]++, {
    "default": mod
  });
}));

cov_2h49l1ffo3().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var Panel_1 = (cov_2h49l1ffo3().s[3]++, __importDefault(__webpack_require__(28)));
var Menu = (
/** @class */
cov_2h49l1ffo3().s[4]++, function () {
  cov_2h49l1ffo3().f[1]++;

  function Menu($elem, editor) {
    cov_2h49l1ffo3().f[2]++;

    var _this = (cov_2h49l1ffo3().s[5]++, this);

    cov_2h49l1ffo3().s[6]++;
    this.$elem = $elem;
    cov_2h49l1ffo3().s[7]++;
    this.editor = editor;
    cov_2h49l1ffo3().s[8]++;
    this._active = false; // 绑定菜单点击事件

    cov_2h49l1ffo3().s[9]++;
    $elem.on('click', function (e) {
      var _context;

      cov_2h49l1ffo3().f[3]++;
      cov_2h49l1ffo3().s[10]++;
      Panel_1["default"].hideCurAllPanels(); // 隐藏当前的所有 Panel
      // 触发菜单点击的钩子

      cov_2h49l1ffo3().s[11]++;
      (0, _forEach["default"])(_context = editor.txt.eventHooks.menuClickEvents).call(_context, function (fn) {
        cov_2h49l1ffo3().f[4]++;
        cov_2h49l1ffo3().s[12]++;
        return fn();
      });
      cov_2h49l1ffo3().s[13]++;
      e.stopPropagation();
      cov_2h49l1ffo3().s[14]++;

      if (editor.selection.getRange() == null) {
        cov_2h49l1ffo3().b[3][0]++;
        cov_2h49l1ffo3().s[15]++;
        return;
      } else {
        cov_2h49l1ffo3().b[3][1]++;
      }

      cov_2h49l1ffo3().s[16]++;

      _this.clickHandler(e);
    });
  }
  /**
   * 菜单点击事件，子类可重写
   * @param e event
   */


  cov_2h49l1ffo3().s[17]++;

  Menu.prototype.clickHandler = function (e) {
    cov_2h49l1ffo3().f[5]++;
  };
  /**
   * 激活菜单，高亮显示
   */


  cov_2h49l1ffo3().s[18]++;

  Menu.prototype.active = function () {
    cov_2h49l1ffo3().f[6]++;
    cov_2h49l1ffo3().s[19]++;
    this._active = true;
    cov_2h49l1ffo3().s[20]++;
    this.$elem.addClass('w-e-active');
  };
  /**
   * 取消激活，不再高亮显示
   */


  cov_2h49l1ffo3().s[21]++;

  Menu.prototype.unActive = function () {
    cov_2h49l1ffo3().f[7]++;
    cov_2h49l1ffo3().s[22]++;
    this._active = false;
    cov_2h49l1ffo3().s[23]++;
    this.$elem.removeClass('w-e-active');
  };

  cov_2h49l1ffo3().s[24]++;
  (0, _defineProperty["default"])(Menu.prototype, "isActive", {
    /**
     * 是否处于激活状态
     */
    get: function get() {
      cov_2h49l1ffo3().f[8]++;
      cov_2h49l1ffo3().s[25]++;
      return this._active;
    },
    enumerable: false,
    configurable: true
  });
  cov_2h49l1ffo3().s[26]++;
  return Menu;
}());
cov_2h49l1ffo3().s[27]++;
exports["default"] = Menu;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 上传图片
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _indexOf = _interopRequireDefault(__webpack_require__(53));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _bind = _interopRequireDefault(__webpack_require__(86));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_ahoy21ze1() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/upload-img.ts";
  var hash = "c3c4fb77e533c4cdcb5ba50534687bb97a368722";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/upload-img.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 20
        },
        end: {
          line: 11,
          column: 79
        }
      },
      "5": {
        start: {
          line: 12,
          column: 17
        },
        end: {
          line: 12,
          column: 73
        }
      },
      "6": {
        start: {
          line: 13,
          column: 31
        },
        end: {
          line: 261,
          column: 3
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "8": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      "9": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 56
        }
      },
      "10": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 29,
          column: 9
        }
      },
      "11": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 35
        }
      },
      "12": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 36
        }
      },
      "13": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "14": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 54
        }
      },
      "15": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "16": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 39,
          column: 26
        }
      },
      "17": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "18": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 41,
          column: 34
        }
      },
      "19": {
        start: {
          line: 42,
          column: 25
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "20": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "21": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 59
        }
      },
      "22": {
        start: {
          line: 44,
          column: 37
        },
        end: {
          line: 44,
          column: 57
        }
      },
      "23": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 51
        }
      },
      "24": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 92
        }
      },
      "25": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 36
        }
      },
      "26": {
        start: {
          line: 52,
          column: 18
        },
        end: {
          line: 52,
          column: 47
        }
      },
      "27": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 55,
          column: 10
        }
      },
      "28": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 23
        }
      },
      "29": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 59,
          column: 10
        }
      },
      "30": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 133
        }
      },
      "31": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 23
        }
      },
      "32": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 59
        }
      },
      "33": {
        start: {
          line: 60,
          column: 36
        },
        end: {
          line: 60,
          column: 56
        }
      },
      "34": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 22
        }
      },
      "35": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 259,
          column: 6
        }
      },
      "36": {
        start: {
          line: 68,
          column: 22
        },
        end: {
          line: 68,
          column: 26
        }
      },
      "37": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 71,
          column: 9
        }
      },
      "38": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 70,
          column: 19
        }
      },
      "39": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "40": {
        start: {
          line: 73,
          column: 21
        },
        end: {
          line: 73,
          column: 34
        }
      },
      "41": {
        start: {
          line: 75,
          column: 25
        },
        end: {
          line: 75,
          column: 36
        }
      },
      "42": {
        start: {
          line: 76,
          column: 16
        },
        end: {
          line: 78,
          column: 9
        }
      },
      "43": {
        start: {
          line: 77,
          column: 12
        },
        end: {
          line: 77,
          column: 55
        }
      },
      "44": {
        start: {
          line: 81,
          column: 30
        },
        end: {
          line: 81,
          column: 52
        }
      },
      "45": {
        start: {
          line: 83,
          column: 34
        },
        end: {
          line: 83,
          column: 60
        }
      },
      "46": {
        start: {
          line: 85,
          column: 22
        },
        end: {
          line: 85,
          column: 45
        }
      },
      "47": {
        start: {
          line: 86,
          column: 23
        },
        end: {
          line: 86,
          column: 44
        }
      },
      "48": {
        start: {
          line: 88,
          column: 24
        },
        end: {
          line: 88,
          column: 49
        }
      },
      "49": {
        start: {
          line: 90,
          column: 29
        },
        end: {
          line: 90,
          column: 50
        }
      },
      "50": {
        start: {
          line: 92,
          column: 30
        },
        end: {
          line: 92,
          column: 52
        }
      },
      "51": {
        start: {
          line: 94,
          column: 37
        },
        end: {
          line: 94,
          column: 66
        }
      },
      "52": {
        start: {
          line: 96,
          column: 31
        },
        end: {
          line: 96,
          column: 54
        }
      },
      "53": {
        start: {
          line: 98,
          column: 20
        },
        end: {
          line: 98,
          column: 41
        }
      },
      "54": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 45
        }
      },
      "55": {
        start: {
          line: 102,
          column: 30
        },
        end: {
          line: 102,
          column: 52
        }
      },
      "56": {
        start: {
          line: 104,
          column: 30
        },
        end: {
          line: 104,
          column: 52
        }
      },
      "57": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 110,
          column: 9
        }
      },
      "58": {
        start: {
          line: 107,
          column: 12
        },
        end: {
          line: 109,
          column: 13
        }
      },
      "59": {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 23
        }
      },
      "60": {
        start: {
          line: 112,
          column: 26
        },
        end: {
          line: 112,
          column: 28
        }
      },
      "61": {
        start: {
          line: 113,
          column: 23
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "62": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 133,
          column: 11
        }
      },
      "63": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 32
        }
      },
      "64": {
        start: {
          line: 116,
          column: 23
        },
        end: {
          line: 116,
          column: 32
        }
      },
      "65": {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 120,
          column: 13
        }
      },
      "66": {
        start: {
          line: 119,
          column: 16
        },
        end: {
          line: 119,
          column: 23
        }
      },
      "67": {
        start: {
          line: 121,
          column: 12
        },
        end: {
          line: 125,
          column: 13
        }
      },
      "68": {
        start: {
          line: 123,
          column: 16
        },
        end: {
          line: 123,
          column: 70
        }
      },
      "69": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 124,
          column: 23
        }
      },
      "70": {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 130,
          column: 13
        }
      },
      "71": {
        start: {
          line: 128,
          column: 16
        },
        end: {
          line: 128,
          column: 91
        }
      },
      "72": {
        start: {
          line: 129,
          column: 16
        },
        end: {
          line: 129,
          column: 23
        }
      },
      "73": {
        start: {
          line: 132,
          column: 12
        },
        end: {
          line: 132,
          column: 35
        }
      },
      "74": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 138,
          column: 9
        }
      },
      "75": {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 68
        }
      },
      "76": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 19
        }
      },
      "77": {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 142,
          column: 9
        }
      },
      "78": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 59
        }
      },
      "79": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 19
        }
      },
      "80": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 148,
          column: 9
        }
      },
      "81": {
        start: {
          line: 145,
          column: 12
        },
        end: {
          line: 145,
          column: 68
        }
      },
      "82": {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 147,
          column: 19
        }
      },
      "83": {
        start: {
          line: 151,
          column: 23
        },
        end: {
          line: 151,
          column: 37
        }
      },
      "84": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 159,
          column: 11
        }
      },
      "85": {
        start: {
          line: 153,
          column: 23
        },
        end: {
          line: 153,
          column: 50
        }
      },
      "86": {
        start: {
          line: 154,
          column: 12
        },
        end: {
          line: 157,
          column: 13
        }
      },
      "87": {
        start: {
          line: 156,
          column: 16
        },
        end: {
          line: 156,
          column: 42
        }
      },
      "88": {
        start: {
          line: 158,
          column: 12
        },
        end: {
          line: 158,
          column: 40
        }
      },
      "89": {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 245,
          column: 9
        }
      },
      "90": {
        start: {
          line: 162,
          column: 37
        },
        end: {
          line: 162,
          column: 63
        }
      },
      "91": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 163,
          column: 52
        }
      },
      "92": {
        start: {
          line: 164,
          column: 38
        },
        end: {
          line: 164,
          column: 65
        }
      },
      "93": {
        start: {
          line: 165,
          column: 12
        },
        end: {
          line: 180,
          column: 15
        }
      },
      "94": {
        start: {
          line: 169,
          column: 16
        },
        end: {
          line: 177,
          column: 17
        }
      },
      "95": {
        start: {
          line: 170,
          column: 20
        },
        end: {
          line: 175,
          column: 21
        }
      },
      "96": {
        start: {
          line: 171,
          column: 24
        },
        end: {
          line: 171,
          column: 47
        }
      },
      "97": {
        start: {
          line: 174,
          column: 24
        },
        end: {
          line: 174,
          column: 47
        }
      },
      "98": {
        start: {
          line: 176,
          column: 20
        },
        end: {
          line: 176,
          column: 72
        }
      },
      "99": {
        start: {
          line: 179,
          column: 16
        },
        end: {
          line: 179,
          column: 42
        }
      },
      "100": {
        start: {
          line: 181,
          column: 12
        },
        end: {
          line: 183,
          column: 13
        }
      },
      "101": {
        start: {
          line: 182,
          column: 16
        },
        end: {
          line: 182,
          column: 61
        }
      },
      "102": {
        start: {
          line: 185,
          column: 22
        },
        end: {
          line: 238,
          column: 14
        }
      },
      "103": {
        start: {
          line: 191,
          column: 20
        },
        end: {
          line: 192,
          column: 70
        }
      },
      "104": {
        start: {
          line: 192,
          column: 24
        },
        end: {
          line: 192,
          column: 70
        }
      },
      "105": {
        start: {
          line: 195,
          column: 20
        },
        end: {
          line: 195,
          column: 47
        }
      },
      "106": {
        start: {
          line: 196,
          column: 20
        },
        end: {
          line: 197,
          column: 51
        }
      },
      "107": {
        start: {
          line: 197,
          column: 24
        },
        end: {
          line: 197,
          column: 51
        }
      },
      "108": {
        start: {
          line: 200,
          column: 38
        },
        end: {
          line: 200,
          column: 68
        }
      },
      "109": {
        start: {
          line: 201,
          column: 20
        },
        end: {
          line: 204,
          column: 21
        }
      },
      "110": {
        start: {
          line: 202,
          column: 24
        },
        end: {
          line: 202,
          column: 53
        }
      },
      "111": {
        start: {
          line: 203,
          column: 24
        },
        end: {
          line: 203,
          column: 50
        }
      },
      "112": {
        start: {
          line: 207,
          column: 20
        },
        end: {
          line: 207,
          column: 106
        }
      },
      "113": {
        start: {
          line: 208,
          column: 20
        },
        end: {
          line: 209,
          column: 49
        }
      },
      "114": {
        start: {
          line: 209,
          column: 24
        },
        end: {
          line: 209,
          column: 49
        }
      },
      "115": {
        start: {
          line: 212,
          column: 20
        },
        end: {
          line: 212,
          column: 108
        }
      },
      "116": {
        start: {
          line: 213,
          column: 20
        },
        end: {
          line: 214,
          column: 59
        }
      },
      "117": {
        start: {
          line: 214,
          column: 24
        },
        end: {
          line: 214,
          column: 59
        }
      },
      "118": {
        start: {
          line: 217,
          column: 20
        },
        end: {
          line: 221,
          column: 21
        }
      },
      "119": {
        start: {
          line: 219,
          column: 24
        },
        end: {
          line: 219,
          column: 92
        }
      },
      "120": {
        start: {
          line: 220,
          column: 24
        },
        end: {
          line: 220,
          column: 31
        }
      },
      "121": {
        start: {
          line: 222,
          column: 20
        },
        end: {
          line: 228,
          column: 21
        }
      },
      "122": {
        start: {
          line: 224,
          column: 24
        },
        end: {
          line: 224,
          column: 118
        }
      },
      "123": {
        start: {
          line: 225,
          column: 24
        },
        end: {
          line: 226,
          column: 60
        }
      },
      "124": {
        start: {
          line: 226,
          column: 28
        },
        end: {
          line: 226,
          column: 60
        }
      },
      "125": {
        start: {
          line: 227,
          column: 24
        },
        end: {
          line: 227,
          column: 31
        }
      },
      "126": {
        start: {
          line: 230,
          column: 31
        },
        end: {
          line: 230,
          column: 42
        }
      },
      "127": {
        start: {
          line: 231,
          column: 20
        },
        end: {
          line: 233,
          column: 23
        }
      },
      "128": {
        start: {
          line: 232,
          column: 24
        },
        end: {
          line: 232,
          column: 48
        }
      },
      "129": {
        start: {
          line: 235,
          column: 20
        },
        end: {
          line: 236,
          column: 59
        }
      },
      "130": {
        start: {
          line: 236,
          column: 24
        },
        end: {
          line: 236,
          column: 59
        }
      },
      "131": {
        start: {
          line: 239,
          column: 12
        },
        end: {
          line: 242,
          column: 13
        }
      },
      "132": {
        start: {
          line: 241,
          column: 16
        },
        end: {
          line: 241,
          column: 32
        }
      },
      "133": {
        start: {
          line: 244,
          column: 12
        },
        end: {
          line: 244,
          column: 19
        }
      },
      "134": {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 258,
          column: 9
        }
      },
      "135": {
        start: {
          line: 248,
          column: 12
        },
        end: {
          line: 257,
          column: 15
        }
      },
      "136": {
        start: {
          line: 249,
          column: 28
        },
        end: {
          line: 249,
          column: 35
        }
      },
      "137": {
        start: {
          line: 250,
          column: 29
        },
        end: {
          line: 250,
          column: 45
        }
      },
      "138": {
        start: {
          line: 251,
          column: 16
        },
        end: {
          line: 251,
          column: 43
        }
      },
      "139": {
        start: {
          line: 252,
          column: 16
        },
        end: {
          line: 256,
          column: 18
        }
      },
      "140": {
        start: {
          line: 253,
          column: 20
        },
        end: {
          line: 254,
          column: 31
        }
      },
      "141": {
        start: {
          line: 254,
          column: 24
        },
        end: {
          line: 254,
          column: 31
        }
      },
      "142": {
        start: {
          line: 255,
          column: 20
        },
        end: {
          line: 255,
          column: 60
        }
      },
      "143": {
        start: {
          line: 260,
          column: 4
        },
        end: {
          line: 260,
          column: 21
        }
      },
      "144": {
        start: {
          line: 262,
          column: 0
        },
        end: {
          line: 262,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 31
          },
          end: {
            line: 13,
            column: 32
          }
        },
        loc: {
          start: {
            line: 13,
            column: 43
          },
          end: {
            line: 261,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "UploadImg",
        decl: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 22
          }
        },
        loc: {
          start: {
            line: 14,
            column: 31
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 32
          },
          end: {
            line: 22,
            column: 33
          }
        },
        loc: {
          start: {
            line: 22,
            column: 64
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 36
          },
          end: {
            line: 38,
            column: 37
          }
        },
        loc: {
          start: {
            line: 38,
            column: 51
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 17
          }
        },
        loc: {
          start: {
            line: 43,
            column: 40
          },
          end: {
            line: 46,
            column: 9
          }
        },
        line: 43
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 53,
            column: 21
          },
          end: {
            line: 53,
            column: 22
          }
        },
        loc: {
          start: {
            line: 53,
            column: 33
          },
          end: {
            line: 55,
            column: 9
          }
        },
        line: 53
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 56,
            column: 22
          },
          end: {
            line: 56,
            column: 23
          }
        },
        loc: {
          start: {
            line: 56,
            column: 34
          },
          end: {
            line: 59,
            column: 9
          }
        },
        line: 56
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 60,
            column: 22
          },
          end: {
            line: 60,
            column: 23
          }
        },
        loc: {
          start: {
            line: 60,
            column: 34
          },
          end: {
            line: 60,
            column: 58
          }
        },
        line: 60
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 67,
            column: 36
          },
          end: {
            line: 67,
            column: 37
          }
        },
        loc: {
          start: {
            line: 67,
            column: 53
          },
          end: {
            line: 259,
            column: 5
          }
        },
        line: 67
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 17
          }
        },
        loc: {
          start: {
            line: 76,
            column: 32
          },
          end: {
            line: 78,
            column: 9
          }
        },
        line: 76
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 114,
            column: 33
          },
          end: {
            line: 114,
            column: 34
          }
        },
        loc: {
          start: {
            line: 114,
            column: 49
          },
          end: {
            line: 133,
            column: 9
          }
        },
        line: 114
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 152,
            column: 28
          },
          end: {
            line: 152,
            column: 29
          }
        },
        loc: {
          start: {
            line: 152,
            column: 51
          },
          end: {
            line: 159,
            column: 9
          }
        },
        line: 152
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 165,
            column: 44
          },
          end: {
            line: 165,
            column: 45
          }
        },
        loc: {
          start: {
            line: 165,
            column: 64
          },
          end: {
            line: 180,
            column: 13
          }
        },
        line: 165
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 190,
            column: 28
          },
          end: {
            line: 190,
            column: 29
          }
        },
        loc: {
          start: {
            line: 190,
            column: 43
          },
          end: {
            line: 193,
            column: 17
          }
        },
        line: 190
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 194,
            column: 27
          },
          end: {
            line: 194,
            column: 28
          }
        },
        loc: {
          start: {
            line: 194,
            column: 42
          },
          end: {
            line: 198,
            column: 17
          }
        },
        line: 194
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 199,
            column: 28
          },
          end: {
            line: 199,
            column: 29
          }
        },
        loc: {
          start: {
            line: 199,
            column: 50
          },
          end: {
            line: 205,
            column: 17
          }
        },
        line: 199
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 206,
            column: 25
          },
          end: {
            line: 206,
            column: 26
          }
        },
        loc: {
          start: {
            line: 206,
            column: 40
          },
          end: {
            line: 210,
            column: 17
          }
        },
        line: 206
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 211,
            column: 24
          },
          end: {
            line: 211,
            column: 25
          }
        },
        loc: {
          start: {
            line: 211,
            column: 50
          },
          end: {
            line: 215,
            column: 17
          }
        },
        line: 211
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 216,
            column: 27
          },
          end: {
            line: 216,
            column: 28
          }
        },
        loc: {
          start: {
            line: 216,
            column: 50
          },
          end: {
            line: 237,
            column: 17
          }
        },
        line: 216
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 231,
            column: 33
          },
          end: {
            line: 231,
            column: 34
          }
        },
        loc: {
          start: {
            line: 231,
            column: 49
          },
          end: {
            line: 233,
            column: 21
          }
        },
        line: 231
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 248,
            column: 37
          },
          end: {
            line: 248,
            column: 38
          }
        },
        loc: {
          start: {
            line: 248,
            column: 53
          },
          end: {
            line: 257,
            column: 13
          }
        },
        line: 248
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 252,
            column: 32
          },
          end: {
            line: 252,
            column: 33
          }
        },
        loc: {
          start: {
            line: 252,
            column: 44
          },
          end: {
            line: 256,
            column: 17
          }
        },
        line: 252
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 59
          }
        }, {
          start: {
            line: 44,
            column: 12
          },
          end: {
            line: 44,
            column: 59
          }
        }],
        line: 44
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }, {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        }, {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        }],
        line: 105
      },
      "8": {
        loc: {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        }, {
          start: {
            line: 107,
            column: 12
          },
          end: {
            line: 109,
            column: 13
          }
        }],
        line: 107
      },
      "9": {
        loc: {
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 32
          }
        }, {
          start: {
            line: 107,
            column: 36
          },
          end: {
            line: 107,
            column: 56
          }
        }],
        line: 107
      },
      "10": {
        loc: {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 120,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 120,
            column: 13
          }
        }, {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 120,
            column: 13
          }
        }],
        line: 118
      },
      "11": {
        loc: {
          start: {
            line: 118,
            column: 16
          },
          end: {
            line: 118,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 16
          },
          end: {
            line: 118,
            column: 21
          }
        }, {
          start: {
            line: 118,
            column: 25
          },
          end: {
            line: 118,
            column: 30
          }
        }],
        line: 118
      },
      "12": {
        loc: {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        }, {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 125,
            column: 13
          }
        }],
        line: 121
      },
      "13": {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        }, {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        }],
        line: 126
      },
      "14": {
        loc: {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        }, {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 138,
            column: 9
          }
        }],
        line: 135
      },
      "15": {
        loc: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        }, {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 142,
            column: 9
          }
        }],
        line: 139
      },
      "16": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }, {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }],
        line: 144
      },
      "17": {
        loc: {
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 144,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 144,
            column: 27
          }
        }, {
          start: {
            line: 144,
            column: 31
          },
          end: {
            line: 144,
            column: 68
          }
        }],
        line: 144
      },
      "18": {
        loc: {
          start: {
            line: 153,
            column: 23
          },
          end: {
            line: 153,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 23
          },
          end: {
            line: 153,
            column: 37
          }
        }, {
          start: {
            line: 153,
            column: 41
          },
          end: {
            line: 153,
            column: 50
          }
        }],
        line: 153
      },
      "19": {
        loc: {
          start: {
            line: 154,
            column: 12
          },
          end: {
            line: 157,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 12
          },
          end: {
            line: 157,
            column: 13
          }
        }, {
          start: {
            line: 154,
            column: 12
          },
          end: {
            line: 157,
            column: 13
          }
        }],
        line: 154
      },
      "20": {
        loc: {
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        }, {
          start: {
            line: 160,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        }],
        line: 160
      },
      "21": {
        loc: {
          start: {
            line: 164,
            column: 38
          },
          end: {
            line: 164,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 38
          },
          end: {
            line: 164,
            column: 59
          }
        }, {
          start: {
            line: 164,
            column: 63
          },
          end: {
            line: 164,
            column: 65
          }
        }],
        line: 164
      },
      "22": {
        loc: {
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 177,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 177,
            column: 17
          }
        }, {
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 177,
            column: 17
          }
        }],
        line: 169
      },
      "23": {
        loc: {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 175,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 175,
            column: 21
          }
        }, {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 175,
            column: 21
          }
        }],
        line: 170
      },
      "24": {
        loc: {
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }, {
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }],
        line: 181
      },
      "25": {
        loc: {
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 192,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 192,
            column: 70
          }
        }, {
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 192,
            column: 70
          }
        }],
        line: 191
      },
      "26": {
        loc: {
          start: {
            line: 196,
            column: 20
          },
          end: {
            line: 197,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 20
          },
          end: {
            line: 197,
            column: 51
          }
        }, {
          start: {
            line: 196,
            column: 20
          },
          end: {
            line: 197,
            column: 51
          }
        }],
        line: 196
      },
      "27": {
        loc: {
          start: {
            line: 201,
            column: 20
          },
          end: {
            line: 204,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 20
          },
          end: {
            line: 204,
            column: 21
          }
        }, {
          start: {
            line: 201,
            column: 20
          },
          end: {
            line: 204,
            column: 21
          }
        }],
        line: 201
      },
      "28": {
        loc: {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 209,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 209,
            column: 49
          }
        }, {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 209,
            column: 49
          }
        }],
        line: 208
      },
      "29": {
        loc: {
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 214,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 214,
            column: 59
          }
        }, {
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 214,
            column: 59
          }
        }],
        line: 213
      },
      "30": {
        loc: {
          start: {
            line: 217,
            column: 20
          },
          end: {
            line: 221,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 20
          },
          end: {
            line: 221,
            column: 21
          }
        }, {
          start: {
            line: 217,
            column: 20
          },
          end: {
            line: 221,
            column: 21
          }
        }],
        line: 217
      },
      "31": {
        loc: {
          start: {
            line: 222,
            column: 20
          },
          end: {
            line: 228,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 222,
            column: 20
          },
          end: {
            line: 228,
            column: 21
          }
        }, {
          start: {
            line: 222,
            column: 20
          },
          end: {
            line: 228,
            column: 21
          }
        }],
        line: 222
      },
      "32": {
        loc: {
          start: {
            line: 225,
            column: 24
          },
          end: {
            line: 226,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 24
          },
          end: {
            line: 226,
            column: 60
          }
        }, {
          start: {
            line: 225,
            column: 24
          },
          end: {
            line: 226,
            column: 60
          }
        }],
        line: 225
      },
      "33": {
        loc: {
          start: {
            line: 235,
            column: 20
          },
          end: {
            line: 236,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 235,
            column: 20
          },
          end: {
            line: 236,
            column: 59
          }
        }, {
          start: {
            line: 235,
            column: 20
          },
          end: {
            line: 236,
            column: 59
          }
        }],
        line: 235
      },
      "34": {
        loc: {
          start: {
            line: 239,
            column: 12
          },
          end: {
            line: 242,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 239,
            column: 12
          },
          end: {
            line: 242,
            column: 13
          }
        }, {
          start: {
            line: 239,
            column: 12
          },
          end: {
            line: 242,
            column: 13
          }
        }],
        line: 239
      },
      "35": {
        loc: {
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        }, {
          start: {
            line: 247,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        }],
        line: 247
      },
      "36": {
        loc: {
          start: {
            line: 253,
            column: 20
          },
          end: {
            line: 254,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 253,
            column: 20
          },
          end: {
            line: 254,
            column: 31
          }
        }, {
          start: {
            line: 253,
            column: 20
          },
          end: {
            line: 254,
            column: 31
          }
        }],
        line: 253
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/upload-img.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/upload-img.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,yCAAsD;AACtD,gFAAkD;AAClD,0EAAmD;AAOnD;IAGI,mBAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;;;OAIG;IACK,yBAAK,GAAb,UAAc,SAAiB,EAAE,SAAkB;QAC/C,IAAM,WAAW,GAAG,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,WAAW,CAAA;QAClD,IAAI,WAAW,EAAE;YACb,WAAW,CAAC,SAAS,CAAC,CAAA;SACzB;aAAM;YACH,MAAM,CAAC,KAAK,CAAC,SAAS,CAAC,CAAA;SAC1B;QAED,IAAI,SAAS,EAAE;YACX,OAAO,CAAC,KAAK,CAAC,cAAc,GAAG,SAAS,CAAC,CAAA;SAC5C;IACL,CAAC;IAED;;;OAGG;IACI,6BAAS,GAAhB,UAAiB,GAAW;QAA5B,mBA4BC;QA3BG,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;QAE5B,IAAM,UAAU,GAAG,WAAW,CAAA;QAC9B,IAAM,CAAC,GAAG,UAAC,IAAY,EAAE,MAA2B;YAA3B,uBAAA,EAAA,mBAA2B;YAChD,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,MAAM,GAAG,IAAI,CAAC,CAAA;QAC1C,CAAC,CAAA;QAED,gBAAgB;QAChB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,gBAAa,GAAG,mCAA6B,CAAC,CAAA;QAC1E,SAAS;QACT,MAAM,CAAC,eAAe,CAAC,GAAG,CAAC,CAAA;QAE3B,OAAO;QACP,IAAI,GAAG,GAAQ,QAAQ,CAAC,aAAa,CAAC,KAAK,CAAC,CAAA;QAC5C,GAAG,CAAC,MAAM,GAAG;YACT,GAAG,GAAG,IAAI,CAAA;QACd,CAAC,CAAA;QACD,GAAG,CAAC,OAAO,GAAG;YACV,OAAI,CAAC,KAAK,CACN,CAAC,CAAC,QAAQ,CAAC,EACX,iBAAe,CAAC,CAAC,QAAQ,CAAC,cAAI,CAAC,CAAC,MAAM,CAAC,WAAK,GAAG,gBAAK,CAAC,CAAC,QAAQ,CAAG,CACpE,CAAA;YACD,GAAG,GAAG,IAAI,CAAA;QACd,CAAC,CAAA;QACD,GAAG,CAAC,OAAO,GAAG,cAAM,OAAA,CAAC,GAAG,GAAG,IAAI,CAAC,EAAZ,CAAY,CAAA;QAChC,GAAG,CAAC,GAAG,GAAG,GAAG,CAAA;IACjB,CAAC;IAED;;;OAGG;IACI,6BAAS,GAAhB,UAAiB,KAAwB;QAAzC,mBAsNC;QArNG,IAAI,CAAC,KAAK,CAAC,MAAM,EAAE;YACf,OAAM;SACT;QAED,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;QAE5B,wEAAwE;QAExE,IAAM,UAAU,GAAG,WAAW,CAAA;QAC9B,IAAM,CAAC,GAAG,UAAC,IAAY;YACnB,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,UAAU,GAAG,IAAI,CAAC,CAAA;QAC9C,CAAC,CAAA;QAED,uEAAuE;QAEvE,QAAQ;QACR,IAAI,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;QAC5C,YAAY;QACZ,IAAM,mBAAmB,GAAG,MAAM,CAAC,mBAAmB,CAAA;QACtD,SAAS;QACT,IAAM,OAAO,GAAG,MAAM,CAAC,gBAAgB,CAAA;QACvC,IAAM,QAAQ,GAAG,OAAO,GAAG,IAAI,GAAG,IAAI,CAAA;QACtC,aAAa;QACb,IAAM,SAAS,GAAG,MAAM,CAAC,kBAAkB,CAAA;QAC3C,eAAe;QACf,IAAM,cAAc,GAAG,MAAM,CAAC,cAAc,CAAA;QAC5C,QAAQ;QACR,IAAM,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;QAC9C,cAAc;QACd,IAAM,sBAAsB,GAAG,MAAM,CAAC,sBAAsB,CAAA;QAC5D,aAAa;QACb,IAAM,gBAAgB,GAAG,MAAM,CAAC,gBAAgB,CAAA;QAChD,OAAO;QACP,IAAM,KAAK,GAAG,MAAM,CAAC,cAAc,CAAA;QACnC,WAAW;QACX,IAAM,OAAO,GAAG,MAAM,CAAC,gBAAgB,CAAA;QACvC,aAAa;QACb,IAAM,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;QAC9C,UAAU;QACV,IAAM,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;QAE9C,IAAI,CAAC,eAAe,EAAE;YAClB,6CAA6C;YAC7C,IAAI,CAAC,eAAe,IAAI,CAAC,mBAAmB,EAAE;gBAC1C,OAAM;aACT;SACJ;QAED,uEAAuE;QACvE,IAAM,WAAW,GAAW,EAAE,CAAA;QAC9B,IAAM,QAAQ,GAAa,EAAE,CAAA;QAC7B,iBAAU,CAAC,KAAK,EAAE,UAAA,IAAI;YAClB,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;YACtB,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;YAEtB,gCAAgC;YAChC,IAAI,CAAC,IAAI,IAAI,CAAC,IAAI,EAAE;gBAChB,OAAM;aACT;YAED,IAAI,iCAAiC,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,KAAK,EAAE;gBACxD,cAAc;gBACd,QAAQ,CAAC,IAAI,CAAC,WAAI,IAAI,cAAI,CAAC,CAAC,MAAM,CAAG,CAAC,CAAA;gBACtC,OAAM;aACT;YAED,IAAI,OAAO,GAAG,IAAI,EAAE;gBAChB,SAAS;gBACT,QAAQ,CAAC,IAAI,CAAC,WAAI,IAAI,cAAI,CAAC,CAAC,IAAI,CAAC,SAAI,QAAQ,MAAG,CAAC,CAAA;gBACjD,OAAM;aACT;YAED,cAAc;YACd,WAAW,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QAC1B,CAAC,CAAC,CAAA;QACF,SAAS;QACT,IAAI,QAAQ,CAAC,MAAM,EAAE;YACjB,IAAI,CAAC,KAAK,CAAI,CAAC,CAAC,SAAS,CAAC,SAAM,GAAG,QAAQ,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAA;YACvD,OAAM;SACT;QACD,IAAI,WAAW,CAAC,MAAM,GAAG,SAAS,EAAE;YAChC,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,QAAQ,CAAC,GAAG,SAAS,GAAG,CAAC,CAAC,KAAK,CAAC,CAAC,CAAA;YAC9C,OAAM;SACT;QAED,sEAAsE;QACtE,IAAI,eAAe,IAAI,OAAO,eAAe,KAAK,UAAU,EAAE;YAC1D,eAAe,CAAC,WAAW,EAAE,IAAI,CAAC,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,CAAA;YAEvD,iBAAiB;YACjB,OAAM;SACT;QAED,qEAAqE;QAErE,SAAS;QACT,IAAM,QAAQ,GAAG,IAAI,QAAQ,EAAE,CAAA;QAC/B,WAAW,CAAC,OAAO,CAAC,UAAC,IAAU,EAAE,KAAa;YAC1C,IAAI,IAAI,GAAG,cAAc,IAAI,IAAI,CAAC,IAAI,CAAA;YACtC,IAAI,WAAW,CAAC,MAAM,GAAG,CAAC,EAAE;gBACxB,sBAAsB;gBACtB,IAAI,GAAG,IAAI,GAAG,CAAC,KAAK,GAAG,CAAC,CAAC,CAAA;aAC5B;YACD,QAAQ,CAAC,MAAM,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QAC/B,CAAC,CAAC,CAAA;QACF,IAAI,eAAe,EAAE;YACjB,UAAU;YACV,IAAM,kBAAkB,GAAG,eAAe,CAAC,KAAK,CAAC,GAAG,CAAC,CAAA;YACrD,eAAe,GAAG,kBAAkB,CAAC,CAAC,CAAC,CAAA;YACvC,IAAM,mBAAmB,GAAG,kBAAkB,CAAC,CAAC,CAAC,IAAI,EAAE,CAAA;YACvD,cAAO,CAAC,eAAe,EAAE,UAAC,GAAW,EAAE,GAAW;gBAC9C,4CAA4C;gBAC5C,gCAAgC;gBAEhC,kBAAkB;gBAClB,IAAI,sBAAsB,EAAE;oBACxB,IAAI,eAAe,CAAC,OAAO,CAAC,GAAG,CAAC,GAAG,CAAC,EAAE;wBAClC,eAAe,IAAI,GAAG,CAAA;qBACzB;yBAAM;wBACH,eAAe,IAAI,GAAG,CAAA;qBACzB;oBACD,eAAe,GAAG,eAAe,GAAG,GAAG,GAAG,GAAG,GAAG,GAAG,CAAA;iBACtD;gBAED,uBAAuB;gBACvB,QAAQ,CAAC,MAAM,CAAC,GAAG,EAAE,GAAG,CAAC,CAAA;YAC7B,CAAC,CAAC,CAAA;YACF,IAAI,mBAAmB,EAAE;gBACrB,eAAe,IAAI,GAAG,GAAG,mBAAmB,CAAA;aAC/C;YAED,OAAO;YACP,IAAM,GAAG,GAAG,qBAAI,CAAC,eAAe,EAAE;gBAC9B,OAAO,SAAA;gBACP,QAAQ,UAAA;gBACR,OAAO,EAAE,gBAAgB;gBACzB,eAAe,EAAE,CAAC,CAAC,eAAe;gBAClC,UAAU,EAAE,UAAA,GAAG;oBACX,IAAI,KAAK,CAAC,MAAM;wBAAE,OAAO,KAAK,CAAC,MAAM,CAAC,GAAG,EAAE,MAAM,EAAE,WAAW,CAAC,CAAA;gBACnE,CAAC;gBACD,SAAS,EAAE,UAAA,GAAG;oBACV,OAAI,CAAC,KAAK,CAAC,CAAC,CAAC,QAAQ,CAAC,CAAC,CAAA;oBACvB,IAAI,KAAK,CAAC,OAAO;wBAAE,KAAK,CAAC,OAAO,CAAC,GAAG,EAAE,MAAM,CAAC,CAAA;gBACjD,CAAC;gBACD,UAAU,EAAE,UAAC,OAAO,EAAE,CAAC;oBACnB,IAAM,WAAW,GAAG,IAAI,kBAAQ,CAAC,MAAM,CAAC,CAAA;oBACxC,IAAI,CAAC,CAAC,gBAAgB,EAAE;wBACpB,OAAO,GAAG,CAAC,CAAC,MAAM,GAAG,CAAC,CAAC,KAAK,CAAA;wBAC5B,WAAW,CAAC,IAAI,CAAC,OAAO,CAAC,CAAA;qBAC5B;gBACL,CAAC;gBACD,OAAO,EAAE,UAAA,GAAG;oBACR,OAAI,CAAC,KAAK,CACN,CAAC,CAAC,QAAQ,CAAC,EACR,CAAC,CAAC,QAAQ,CAAC,cAAI,CAAC,CAAC,SAAS,CAAC,UAAK,GAAG,CAAC,MAAQ,CAClD,CAAA;oBACD,IAAI,KAAK,CAAC,KAAK;wBAAE,KAAK,CAAC,KAAK,CAAC,GAAG,EAAE,MAAM,CAAC,CAAA;gBAC7C,CAAC;gBACD,MAAM,EAAE,UAAC,GAAG,EAAE,SAAS;oBACnB,OAAI,CAAC,KAAK,CACN,CAAC,CAAC,QAAQ,CAAC,EACX,CAAC,CAAC,YAAY,CAAC,IAAG,WAAI,CAAC,CAAC,MAAM,CAAC,OAAI,CAAA,GAAG,SAAS,CAClD,CAAA;oBACD,IAAI,KAAK,CAAC,IAAI;wBAAE,KAAK,CAAC,IAAI,CAAC,GAAG,EAAE,MAAM,EAAE,SAAS,CAAC,CAAA;gBACtD,CAAC;gBACD,SAAS,EAAE,UAAC,GAAG,EAAE,MAAe;oBAC5B,IAAI,KAAK,CAAC,YAAY,EAAE;wBACpB,UAAU;wBACV,KAAK,CAAC,YAAY,CAAC,OAAI,CAAC,SAAS,CAAC,IAAI,CAAC,OAAI,CAAC,EAAE,MAAM,EAAE,MAAM,CAAC,CAAA;wBAC7D,OAAM;qBACT;oBACD,IAAI,MAAM,CAAC,KAAK,IAAI,GAAG,EAAE;wBACrB,uCAAuC;wBACvC,OAAI,CAAC,KAAK,CACN,CAAC,CAAC,QAAQ,CAAC,EACR,CAAC,CAAC,YAAY,CAAC,cAAI,CAAC,CAAC,MAAM,CAAC,eAAU,MAAM,CAAC,KAAO,CAC1D,CAAA;wBACD,IAAI,KAAK,CAAC,IAAI;4BAAE,KAAK,CAAC,IAAI,CAAC,GAAG,EAAE,MAAM,EAAE,MAAM,CAAC,CAAA;wBAC/C,OAAM;qBACT;oBAED,UAAU;oBACV,IAAM,IAAI,GAAG,MAAM,CAAC,IAAI,CAAA;oBACxB,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;wBACb,OAAI,CAAC,SAAS,CAAC,IAAI,CAAC,CAAA;oBACxB,CAAC,CAAC,CAAA;oBAEF,OAAO;oBACP,IAAI,KAAK,CAAC,OAAO;wBAAE,KAAK,CAAC,OAAO,CAAC,GAAG,EAAE,MAAM,EAAE,MAAM,CAAC,CAAA;gBACzD,CAAC;aACJ,CAAC,CAAA;YACF,IAAI,OAAO,GAAG,KAAK,QAAQ,EAAE;gBACzB,QAAQ;gBACR,IAAI,CAAC,KAAK,CAAC,GAAG,CAAC,CAAA;aAClB;YAED,iBAAiB;YACjB,OAAM;SACT;QAED,6EAA6E;QAC7E,IAAI,mBAAmB,EAAE;YACrB,iBAAU,CAAC,KAAK,EAAE,UAAA,IAAI;gBAClB,IAAM,KAAK,GAAG,OAAI,CAAA;gBAClB,IAAM,MAAM,GAAG,IAAI,UAAU,EAAE,CAAA;gBAC/B,MAAM,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;gBAC1B,MAAM,CAAC,MAAM,GAAG;oBACZ,IAAI,CAAC,IAAI,CAAC,MAAM;wBAAE,OAAM;oBACxB,KAAK,CAAC,SAAS,CAAC,IAAI,CAAC,MAAM,CAAC,QAAQ,EAAE,CAAC,CAAA;gBAC3C,CAAC,CAAA;YACL,CAAC,CAAC,CAAA;SACL;IACL,CAAC;IACL,gBAAC;AAAD,CAAC,AAtRD,IAsRC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u4E0A\u4F20\u56FE\u7247\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport { arrForEach, forEach } from '../../utils/util'\nimport post from '../../editor/upload/upload-core'\nimport Progress from '../../editor/upload/progress'\n\nexport type ResType = {\n    errno: number | string\n    data: string[]\n}\n\nclass UploadImg {\n    private editor: Editor\n\n    constructor(editor: Editor) {\n        this.editor = editor\n    }\n\n    /**\n     * \u63D0\u793A\u4FE1\u606F\n     * @param alertInfo alert info\n     * @param debugInfo debug info\n     */\n    private alert(alertInfo: string, debugInfo?: string): void {\n        const customAlert = this.editor.config.customAlert\n        if (customAlert) {\n            customAlert(alertInfo)\n        } else {\n            window.alert(alertInfo)\n        }\n\n        if (debugInfo) {\n            console.error('wangEditor: ' + debugInfo)\n        }\n    }\n\n    /**\n     * \u5F80\u7F16\u8F91\u533A\u57DF\u63D2\u5165\u56FE\u7247\n     * @param src \u56FE\u7247\u5730\u5740\n     */\n    public insertImg(src: string): void {\n        const editor = this.editor\n        const config = editor.config\n\n        const i18nPrefix = 'validate.'\n        const t = (text: string, prefix: string = i18nPrefix): string => {\n            return editor.i18next.t(prefix + text)\n        }\n\n        // \u5148\u63D2\u5165\u56FE\u7247\uFF0C\u65E0\u8BBA\u662F\u5426\u80FD\u6210\u529F\n        editor.cmd.do('insertHTML', `<img src=\"${src}\" style=\"max-width:100%;\"/>`)\n        // \u6267\u884C\u56DE\u8C03\u51FD\u6570\n        config.linkImgCallback(src)\n\n        // \u52A0\u8F7D\u56FE\u7247\n        let img: any = document.createElement('img')\n        img.onload = () => {\n            img = null\n        }\n        img.onerror = () => {\n            this.alert(\n                t('\u63D2\u5165\u56FE\u7247\u9519\u8BEF'),\n                `wangEditor: ${t('\u63D2\u5165\u56FE\u7247\u9519\u8BEF')}\uFF0C${t('\u56FE\u7247\u94FE\u63A5')} \"${src}\"\uFF0C${t('\u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25')}`\n            )\n            img = null\n        }\n        img.onabort = () => (img = null)\n        img.src = src\n    }\n\n    /**\n     * \u4E0A\u4F20\u56FE\u7247\n     * @param files \u6587\u4EF6\u5217\u8868\n     */\n    public uploadImg(files: FileList | File[]): void {\n        if (!files.length) {\n            return\n        }\n\n        const editor = this.editor\n        const config = editor.config\n\n        // ------------------------------ i18next ------------------------------\n\n        const i18nPrefix = 'validate.'\n        const t = (text: string): string => {\n            return editor.i18next.t(i18nPrefix + text)\n        }\n\n        // ------------------------------ \u83B7\u53D6\u914D\u7F6E\u4FE1\u606F ------------------------------\n\n        // \u670D\u52A1\u7AEF\u5730\u5740\n        let uploadImgServer = config.uploadImgServer\n        // base64 \u683C\u5F0F\n        const uploadImgShowBase64 = config.uploadImgShowBase64\n        // \u56FE\u7247\u6700\u5927\u4F53\u79EF\n        const maxSize = config.uploadImgMaxSize\n        const maxSizeM = maxSize / 1024 / 1024\n        // \u4E00\u6B21\u6700\u591A\u4E0A\u4F20\u56FE\u7247\u6570\u91CF\n        const maxLength = config.uploadImgMaxLength\n        // \u81EA\u5B9A\u4E49 fileName\n        const uploadFileName = config.uploadFileName\n        // \u81EA\u5B9A\u4E49\u53C2\u6570\n        const uploadImgParams = config.uploadImgParams\n        // \u53C2\u6570\u62FC\u63A5\u5230 url \u4E2D\n        const uploadImgParamsWithUrl = config.uploadImgParamsWithUrl\n        // \u81EA\u5B9A\u4E49 header\n        const uploadImgHeaders = config.uploadImgHeaders\n        // \u94A9\u5B50\u51FD\u6570\n        const hooks = config.uploadImgHooks\n        // \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6\u65F6\u95F4\n        const timeout = config.uploadImgTimeout\n        // \u8DE8\u57DF\u5E26 cookie\n        const withCredentials = config.withCredentials\n        // \u81EA\u5B9A\u4E49\u4E0A\u4F20\u56FE\u7247\n        const customUploadImg = config.customUploadImg\n\n        if (!customUploadImg) {\n            // \u6CA1\u6709 customUploadImg \u7684\u60C5\u51B5\u4E0B\uFF0C\u9700\u8981\u5982\u4E0B\u4E24\u4E2A\u914D\u7F6E\u624D\u80FD\u7EE7\u7EED\u8FDB\u884C\u56FE\u7247\u4E0A\u4F20\n            if (!uploadImgServer && !uploadImgShowBase64) {\n                return\n            }\n        }\n\n        // ------------------------------ \u9A8C\u8BC1\u6587\u4EF6\u4FE1\u606F ------------------------------\n        const resultFiles: File[] = []\n        const errInfos: string[] = []\n        arrForEach(files, file => {\n            const name = file.name\n            const size = file.size\n\n            // chrome \u4F4E\u7248\u672C name === undefined\n            if (!name || !size) {\n                return\n            }\n\n            if (/\\.(jpg|jpeg|png|bmp|gif|webp)$/i.test(name) === false) {\n                // \u540E\u7F00\u540D\u4E0D\u5408\u6CD5\uFF0C\u4E0D\u662F\u56FE\u7247\n                errInfos.push(`\u3010${name}\u3011${t('\u4E0D\u662F\u56FE\u7247')}`)\n                return\n            }\n\n            if (maxSize < size) {\n                // \u4E0A\u4F20\u56FE\u7247\u8FC7\u5927\n                errInfos.push(`\u3010${name}\u3011${t('\u5927\u4E8E')} ${maxSizeM}M`)\n                return\n            }\n\n            // \u9A8C\u8BC1\u901A\u8FC7\u7684\u52A0\u5165\u7ED3\u679C\u5217\u8868\n            resultFiles.push(file)\n        })\n        // \u629B\u51FA\u9A8C\u8BC1\u4FE1\u606F\n        if (errInfos.length) {\n            this.alert(`${t('\u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7')}: \\n` + errInfos.join('\\n'))\n            return\n        }\n        if (resultFiles.length > maxLength) {\n            this.alert(t('\u4E00\u6B21\u6700\u591A\u4E0A\u4F20') + maxLength + t('\u5F20\u56FE\u7247'))\n            return\n        }\n\n        // ------------------------------ \u81EA\u5B9A\u4E49\u4E0A\u4F20 ------------------------------\n        if (customUploadImg && typeof customUploadImg === 'function') {\n            customUploadImg(resultFiles, this.insertImg.bind(this))\n\n            // \u963B\u6B62\u4EE5\u4E0B\u4EE3\u7801\u6267\u884C\uFF0C\u91CD\u8981\uFF01\uFF01\uFF01\n            return\n        }\n\n        // ------------------------------ \u4E0A\u4F20\u56FE\u7247 ------------------------------\n\n        // \u6DFB\u52A0\u56FE\u7247\u6570\u636E\n        const formData = new FormData()\n        resultFiles.forEach((file: File, index: number) => {\n            let name = uploadFileName || file.name\n            if (resultFiles.length > 1) {\n                // \u591A\u4E2A\u6587\u4EF6\u65F6\uFF0Cfilename \u4E0D\u80FD\u91CD\u590D\n                name = name + (index + 1)\n            }\n            formData.append(name, file)\n        })\n        if (uploadImgServer) {\n            // \u6DFB\u52A0\u81EA\u5B9A\u4E49\u53C2\u6570\n            const uploadImgServerArr = uploadImgServer.split('#')\n            uploadImgServer = uploadImgServerArr[0]\n            const uploadImgServerHash = uploadImgServerArr[1] || ''\n            forEach(uploadImgParams, (key: string, val: string) => {\n                // \u56E0\u4F7F\u7528\u8005\u53CD\u5E94\uFF0C\u81EA\u5B9A\u4E49\u53C2\u6570\u4E0D\u80FD\u9ED8\u8BA4 encode \uFF0C\u7531 v3.1.1 \u7248\u672C\u5F00\u59CB\u6CE8\u91CA\u6389\n                // val = encodeURIComponent(val)\n\n                // \u7B2C\u4E00\uFF0C\u5C06\u53C2\u6570\u62FC\u63A5\u5230 url \u4E2D\n                if (uploadImgParamsWithUrl) {\n                    if (uploadImgServer.indexOf('?') > 0) {\n                        uploadImgServer += '&'\n                    } else {\n                        uploadImgServer += '?'\n                    }\n                    uploadImgServer = uploadImgServer + key + '=' + val\n                }\n\n                // \u7B2C\u4E8C\uFF0C\u5C06\u53C2\u6570\u6DFB\u52A0\u5230 formData \u4E2D\n                formData.append(key, val)\n            })\n            if (uploadImgServerHash) {\n                uploadImgServer += '#' + uploadImgServerHash\n            }\n\n            // \u5F00\u59CB\u4E0A\u4F20\n            const xhr = post(uploadImgServer, {\n                timeout,\n                formData,\n                headers: uploadImgHeaders,\n                withCredentials: !!withCredentials,\n                beforeSend: xhr => {\n                    if (hooks.before) return hooks.before(xhr, editor, resultFiles)\n                },\n                onTimeout: xhr => {\n                    this.alert(t('\u4E0A\u4F20\u56FE\u7247\u8D85\u65F6'))\n                    if (hooks.timeout) hooks.timeout(xhr, editor)\n                },\n                onProgress: (percent, e) => {\n                    const progressBar = new Progress(editor)\n                    if (e.lengthComputable) {\n                        percent = e.loaded / e.total\n                        progressBar.show(percent)\n                    }\n                },\n                onError: xhr => {\n                    this.alert(\n                        t('\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF'),\n                        `${t('\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF')}\uFF0C${t('\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001')}: ${xhr.status}`\n                    )\n                    if (hooks.error) hooks.error(xhr, editor)\n                },\n                onFail: (xhr, resultStr) => {\n                    this.alert(\n                        t('\u4E0A\u4F20\u56FE\u7247\u5931\u8D25'),\n                        t('\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF') + `\uFF0C${t('\u8FD4\u56DE\u7ED3\u679C')}: ` + resultStr\n                    )\n                    if (hooks.fail) hooks.fail(xhr, editor, resultStr)\n                },\n                onSuccess: (xhr, result: ResType) => {\n                    if (hooks.customInsert) {\n                        // \u81EA\u5B9A\u4E49\u63D2\u5165\u56FE\u7247\n                        hooks.customInsert(this.insertImg.bind(this), result, editor)\n                        return\n                    }\n                    if (result.errno != '0') {\n                        // \u8FD4\u56DE\u683C\u5F0F\u4E0D\u5BF9\uFF0C\u5E94\u8BE5\u4E3A { errno: 0, data: [...] }\n                        this.alert(\n                            t('\u4E0A\u4F20\u56FE\u7247\u5931\u8D25'),\n                            `${t('\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF')}\uFF0C${t('\u8FD4\u56DE\u7ED3\u679C')} errno=${result.errno}`\n                        )\n                        if (hooks.fail) hooks.fail(xhr, editor, result)\n                        return\n                    }\n\n                    // \u6210\u529F\uFF0C\u63D2\u5165\u56FE\u7247\n                    const data = result.data\n                    data.forEach(link => {\n                        this.insertImg(link)\n                    })\n\n                    // \u94A9\u5B50\u51FD\u6570\n                    if (hooks.success) hooks.success(xhr, editor, result)\n                },\n            })\n            if (typeof xhr === 'string') {\n                // \u4E0A\u4F20\u88AB\u963B\u6B62\n                this.alert(xhr)\n            }\n\n            // \u963B\u6B62\u4EE5\u4E0B\u4EE3\u7801\u6267\u884C\uFF0C\u91CD\u8981\uFF01\uFF01\uFF01\n            return\n        }\n\n        // ------------------------------ \u663E\u793A base64 \u683C\u5F0F ------------------------------\n        if (uploadImgShowBase64) {\n            arrForEach(files, file => {\n                const _this = this\n                const reader = new FileReader()\n                reader.readAsDataURL(file)\n                reader.onload = function () {\n                    if (!this.result) return\n                    _this.insertImg(this.result.toString())\n                }\n            })\n        }\n    }\n}\n\nexport default UploadImg\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c3c4fb77e533c4cdcb5ba50534687bb97a368722"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ahoy21ze1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_ahoy21ze1();

var __importDefault = (cov_ahoy21ze1().s[0]++, (cov_ahoy21ze1().b[0][0]++, void 0) && (cov_ahoy21ze1().b[0][1]++, (void 0).__importDefault) || (cov_ahoy21ze1().b[0][2]++, function (mod) {
  cov_ahoy21ze1().f[0]++;
  cov_ahoy21ze1().s[1]++;
  return (cov_ahoy21ze1().b[2][0]++, mod) && (cov_ahoy21ze1().b[2][1]++, mod.__esModule) ? (cov_ahoy21ze1().b[1][0]++, mod) : (cov_ahoy21ze1().b[1][1]++, {
    "default": mod
  });
}));

cov_ahoy21ze1().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_ahoy21ze1().s[3]++, __webpack_require__(7));
var upload_core_1 = (cov_ahoy21ze1().s[4]++, __importDefault(__webpack_require__(331)));
var progress_1 = (cov_ahoy21ze1().s[5]++, __importDefault(__webpack_require__(332)));
var UploadImg = (
/** @class */
cov_ahoy21ze1().s[6]++, function () {
  cov_ahoy21ze1().f[1]++;

  function UploadImg(editor) {
    cov_ahoy21ze1().f[2]++;
    cov_ahoy21ze1().s[7]++;
    this.editor = editor;
  }
  /**
   * 提示信息
   * @param alertInfo alert info
   * @param debugInfo debug info
   */


  cov_ahoy21ze1().s[8]++;

  UploadImg.prototype.alert = function (alertInfo, debugInfo) {
    cov_ahoy21ze1().f[3]++;
    var customAlert = (cov_ahoy21ze1().s[9]++, this.editor.config.customAlert);
    cov_ahoy21ze1().s[10]++;

    if (customAlert) {
      cov_ahoy21ze1().b[3][0]++;
      cov_ahoy21ze1().s[11]++;
      customAlert(alertInfo);
    } else {
      cov_ahoy21ze1().b[3][1]++;
      cov_ahoy21ze1().s[12]++;
      window.alert(alertInfo);
    }

    cov_ahoy21ze1().s[13]++;

    if (debugInfo) {
      cov_ahoy21ze1().b[4][0]++;
      cov_ahoy21ze1().s[14]++;
      console.error('wangEditor: ' + debugInfo);
    } else {
      cov_ahoy21ze1().b[4][1]++;
    }
  };
  /**
   * 往编辑区域插入图片
   * @param src 图片地址
   */


  cov_ahoy21ze1().s[15]++;

  UploadImg.prototype.insertImg = function (src) {
    cov_ahoy21ze1().f[4]++;

    var _this_1 = (cov_ahoy21ze1().s[16]++, this);

    var editor = (cov_ahoy21ze1().s[17]++, this.editor);
    var config = (cov_ahoy21ze1().s[18]++, editor.config);
    var i18nPrefix = (cov_ahoy21ze1().s[19]++, 'validate.');
    cov_ahoy21ze1().s[20]++;

    var t = function t(text, prefix) {
      cov_ahoy21ze1().f[5]++;
      cov_ahoy21ze1().s[21]++;

      if (prefix === void 0) {
        cov_ahoy21ze1().b[5][0]++;
        cov_ahoy21ze1().s[22]++;
        prefix = i18nPrefix;
      } else {
        cov_ahoy21ze1().b[5][1]++;
      }

      cov_ahoy21ze1().s[23]++;
      return editor.i18next.t(prefix + text);
    }; // 先插入图片，无论是否能成功


    cov_ahoy21ze1().s[24]++;
    editor.cmd["do"]('insertHTML', "<img src=\"" + src + "\" style=\"max-width:100%;\"/>"); // 执行回调函数

    cov_ahoy21ze1().s[25]++;
    config.linkImgCallback(src); // 加载图片

    var img = (cov_ahoy21ze1().s[26]++, document.createElement('img'));
    cov_ahoy21ze1().s[27]++;

    img.onload = function () {
      cov_ahoy21ze1().f[6]++;
      cov_ahoy21ze1().s[28]++;
      img = null;
    };

    cov_ahoy21ze1().s[29]++;

    img.onerror = function () {
      cov_ahoy21ze1().f[7]++;
      cov_ahoy21ze1().s[30]++;

      _this_1.alert(t('插入图片错误'), "wangEditor: " + t('插入图片错误') + "\uFF0C" + t('图片链接') + " \"" + src + "\"\uFF0C" + t('下载链接失败'));

      cov_ahoy21ze1().s[31]++;
      img = null;
    };

    cov_ahoy21ze1().s[32]++;

    img.onabort = function () {
      cov_ahoy21ze1().f[8]++;
      cov_ahoy21ze1().s[33]++;
      return img = null;
    };

    cov_ahoy21ze1().s[34]++;
    img.src = src;
  };
  /**
   * 上传图片
   * @param files 文件列表
   */


  cov_ahoy21ze1().s[35]++;

  UploadImg.prototype.uploadImg = function (files) {
    cov_ahoy21ze1().f[9]++;

    var _this_1 = (cov_ahoy21ze1().s[36]++, this);

    cov_ahoy21ze1().s[37]++;

    if (!files.length) {
      cov_ahoy21ze1().b[6][0]++;
      cov_ahoy21ze1().s[38]++;
      return;
    } else {
      cov_ahoy21ze1().b[6][1]++;
    }

    var editor = (cov_ahoy21ze1().s[39]++, this.editor);
    var config = (cov_ahoy21ze1().s[40]++, editor.config); // ------------------------------ i18next ------------------------------

    var i18nPrefix = (cov_ahoy21ze1().s[41]++, 'validate.');
    cov_ahoy21ze1().s[42]++;

    var t = function t(text) {
      cov_ahoy21ze1().f[10]++;
      cov_ahoy21ze1().s[43]++;
      return editor.i18next.t(i18nPrefix + text);
    }; // ------------------------------ 获取配置信息 ------------------------------
    // 服务端地址


    var uploadImgServer = (cov_ahoy21ze1().s[44]++, config.uploadImgServer); // base64 格式

    var uploadImgShowBase64 = (cov_ahoy21ze1().s[45]++, config.uploadImgShowBase64); // 图片最大体积

    var maxSize = (cov_ahoy21ze1().s[46]++, config.uploadImgMaxSize);
    var maxSizeM = (cov_ahoy21ze1().s[47]++, maxSize / 1024 / 1024); // 一次最多上传图片数量

    var maxLength = (cov_ahoy21ze1().s[48]++, config.uploadImgMaxLength); // 自定义 fileName

    var uploadFileName = (cov_ahoy21ze1().s[49]++, config.uploadFileName); // 自定义参数

    var uploadImgParams = (cov_ahoy21ze1().s[50]++, config.uploadImgParams); // 参数拼接到 url 中

    var uploadImgParamsWithUrl = (cov_ahoy21ze1().s[51]++, config.uploadImgParamsWithUrl); // 自定义 header

    var uploadImgHeaders = (cov_ahoy21ze1().s[52]++, config.uploadImgHeaders); // 钩子函数

    var hooks = (cov_ahoy21ze1().s[53]++, config.uploadImgHooks); // 上传图片超时时间

    var timeout = (cov_ahoy21ze1().s[54]++, config.uploadImgTimeout); // 跨域带 cookie

    var withCredentials = (cov_ahoy21ze1().s[55]++, config.withCredentials); // 自定义上传图片

    var customUploadImg = (cov_ahoy21ze1().s[56]++, config.customUploadImg);
    cov_ahoy21ze1().s[57]++;

    if (!customUploadImg) {
      cov_ahoy21ze1().b[7][0]++;
      cov_ahoy21ze1().s[58]++;

      // 没有 customUploadImg 的情况下，需要如下两个配置才能继续进行图片上传
      if ((cov_ahoy21ze1().b[9][0]++, !uploadImgServer) && (cov_ahoy21ze1().b[9][1]++, !uploadImgShowBase64)) {
        cov_ahoy21ze1().b[8][0]++;
        cov_ahoy21ze1().s[59]++;
        return;
      } else {
        cov_ahoy21ze1().b[8][1]++;
      }
    } else {
      cov_ahoy21ze1().b[7][1]++;
    } // ------------------------------ 验证文件信息 ------------------------------


    var resultFiles = (cov_ahoy21ze1().s[60]++, []);
    var errInfos = (cov_ahoy21ze1().s[61]++, []);
    cov_ahoy21ze1().s[62]++;
    util_1.arrForEach(files, function (file) {
      cov_ahoy21ze1().f[11]++;
      var name = (cov_ahoy21ze1().s[63]++, file.name);
      var size = (cov_ahoy21ze1().s[64]++, file.size); // chrome 低版本 name === undefined

      cov_ahoy21ze1().s[65]++;

      if ((cov_ahoy21ze1().b[11][0]++, !name) || (cov_ahoy21ze1().b[11][1]++, !size)) {
        cov_ahoy21ze1().b[10][0]++;
        cov_ahoy21ze1().s[66]++;
        return;
      } else {
        cov_ahoy21ze1().b[10][1]++;
      }

      cov_ahoy21ze1().s[67]++;

      if (/\.(jpg|jpeg|png|bmp|gif|webp)$/i.test(name) === false) {
        cov_ahoy21ze1().b[12][0]++;
        cov_ahoy21ze1().s[68]++;
        // 后缀名不合法，不是图片
        errInfos.push("\u3010" + name + "\u3011" + t('不是图片'));
        cov_ahoy21ze1().s[69]++;
        return;
      } else {
        cov_ahoy21ze1().b[12][1]++;
      }

      cov_ahoy21ze1().s[70]++;

      if (maxSize < size) {
        cov_ahoy21ze1().b[13][0]++;
        cov_ahoy21ze1().s[71]++;
        // 上传图片过大
        errInfos.push("\u3010" + name + "\u3011" + t('大于') + " " + maxSizeM + "M");
        cov_ahoy21ze1().s[72]++;
        return;
      } else {
        cov_ahoy21ze1().b[13][1]++;
      } // 验证通过的加入结果列表


      cov_ahoy21ze1().s[73]++;
      resultFiles.push(file);
    }); // 抛出验证信息

    cov_ahoy21ze1().s[74]++;

    if (errInfos.length) {
      cov_ahoy21ze1().b[14][0]++;
      cov_ahoy21ze1().s[75]++;
      this.alert(t('图片验证未通过') + ": \n" + errInfos.join('\n'));
      cov_ahoy21ze1().s[76]++;
      return;
    } else {
      cov_ahoy21ze1().b[14][1]++;
    }

    cov_ahoy21ze1().s[77]++;

    if (resultFiles.length > maxLength) {
      cov_ahoy21ze1().b[15][0]++;
      cov_ahoy21ze1().s[78]++;
      this.alert(t('一次最多上传') + maxLength + t('张图片'));
      cov_ahoy21ze1().s[79]++;
      return;
    } else {
      cov_ahoy21ze1().b[15][1]++;
    } // ------------------------------ 自定义上传 ------------------------------


    cov_ahoy21ze1().s[80]++;

    if ((cov_ahoy21ze1().b[17][0]++, customUploadImg) && (cov_ahoy21ze1().b[17][1]++, typeof customUploadImg === 'function')) {
      var _context;

      cov_ahoy21ze1().b[16][0]++;
      cov_ahoy21ze1().s[81]++;
      customUploadImg(resultFiles, (0, _bind["default"])(_context = this.insertImg).call(_context, this)); // 阻止以下代码执行，重要！！！

      cov_ahoy21ze1().s[82]++;
      return;
    } else {
      cov_ahoy21ze1().b[16][1]++;
    } // ------------------------------ 上传图片 ------------------------------
    // 添加图片数据


    var formData = (cov_ahoy21ze1().s[83]++, new FormData());
    cov_ahoy21ze1().s[84]++;
    (0, _forEach["default"])(resultFiles).call(resultFiles, function (file, index) {
      cov_ahoy21ze1().f[12]++;
      var name = (cov_ahoy21ze1().s[85]++, (cov_ahoy21ze1().b[18][0]++, uploadFileName) || (cov_ahoy21ze1().b[18][1]++, file.name));
      cov_ahoy21ze1().s[86]++;

      if (resultFiles.length > 1) {
        cov_ahoy21ze1().b[19][0]++;
        cov_ahoy21ze1().s[87]++;
        // 多个文件时，filename 不能重复
        name = name + (index + 1);
      } else {
        cov_ahoy21ze1().b[19][1]++;
      }

      cov_ahoy21ze1().s[88]++;
      formData.append(name, file);
    });
    cov_ahoy21ze1().s[89]++;

    if (uploadImgServer) {
      cov_ahoy21ze1().b[20][0]++;
      // 添加自定义参数
      var uploadImgServerArr = (cov_ahoy21ze1().s[90]++, uploadImgServer.split('#'));
      cov_ahoy21ze1().s[91]++;
      uploadImgServer = uploadImgServerArr[0];
      var uploadImgServerHash = (cov_ahoy21ze1().s[92]++, (cov_ahoy21ze1().b[21][0]++, uploadImgServerArr[1]) || (cov_ahoy21ze1().b[21][1]++, ''));
      cov_ahoy21ze1().s[93]++;
      (0, _forEach["default"])(util_1).call(util_1, uploadImgParams, function (key, val) {
        cov_ahoy21ze1().f[13]++;
        cov_ahoy21ze1().s[94]++;

        // 因使用者反应，自定义参数不能默认 encode ，由 v3.1.1 版本开始注释掉
        // val = encodeURIComponent(val)
        // 第一，将参数拼接到 url 中
        if (uploadImgParamsWithUrl) {
          cov_ahoy21ze1().b[22][0]++;
          cov_ahoy21ze1().s[95]++;

          if ((0, _indexOf["default"])(uploadImgServer).call(uploadImgServer, '?') > 0) {
            cov_ahoy21ze1().b[23][0]++;
            cov_ahoy21ze1().s[96]++;
            uploadImgServer += '&';
          } else {
            cov_ahoy21ze1().b[23][1]++;
            cov_ahoy21ze1().s[97]++;
            uploadImgServer += '?';
          }

          cov_ahoy21ze1().s[98]++;
          uploadImgServer = uploadImgServer + key + '=' + val;
        } else {
          cov_ahoy21ze1().b[22][1]++;
        } // 第二，将参数添加到 formData 中


        cov_ahoy21ze1().s[99]++;
        formData.append(key, val);
      });
      cov_ahoy21ze1().s[100]++;

      if (uploadImgServerHash) {
        cov_ahoy21ze1().b[24][0]++;
        cov_ahoy21ze1().s[101]++;
        uploadImgServer += '#' + uploadImgServerHash;
      } else {
        cov_ahoy21ze1().b[24][1]++;
      } // 开始上传


      var xhr = (cov_ahoy21ze1().s[102]++, upload_core_1["default"](uploadImgServer, {
        timeout: timeout,
        formData: formData,
        headers: uploadImgHeaders,
        withCredentials: !!withCredentials,
        beforeSend: function beforeSend(xhr) {
          cov_ahoy21ze1().f[14]++;
          cov_ahoy21ze1().s[103]++;

          if (hooks.before) {
            cov_ahoy21ze1().b[25][0]++;
            cov_ahoy21ze1().s[104]++;
            return hooks.before(xhr, editor, resultFiles);
          } else {
            cov_ahoy21ze1().b[25][1]++;
          }
        },
        onTimeout: function onTimeout(xhr) {
          cov_ahoy21ze1().f[15]++;
          cov_ahoy21ze1().s[105]++;

          _this_1.alert(t('上传图片超时'));

          cov_ahoy21ze1().s[106]++;

          if (hooks.timeout) {
            cov_ahoy21ze1().b[26][0]++;
            cov_ahoy21ze1().s[107]++;
            hooks.timeout(xhr, editor);
          } else {
            cov_ahoy21ze1().b[26][1]++;
          }
        },
        onProgress: function onProgress(percent, e) {
          cov_ahoy21ze1().f[16]++;
          var progressBar = (cov_ahoy21ze1().s[108]++, new progress_1["default"](editor));
          cov_ahoy21ze1().s[109]++;

          if (e.lengthComputable) {
            cov_ahoy21ze1().b[27][0]++;
            cov_ahoy21ze1().s[110]++;
            percent = e.loaded / e.total;
            cov_ahoy21ze1().s[111]++;
            progressBar.show(percent);
          } else {
            cov_ahoy21ze1().b[27][1]++;
          }
        },
        onError: function onError(xhr) {
          cov_ahoy21ze1().f[17]++;
          cov_ahoy21ze1().s[112]++;

          _this_1.alert(t('上传图片错误'), t('上传图片错误') + "\uFF0C" + t('服务器返回状态') + ": " + xhr.status);

          cov_ahoy21ze1().s[113]++;

          if (hooks.error) {
            cov_ahoy21ze1().b[28][0]++;
            cov_ahoy21ze1().s[114]++;
            hooks.error(xhr, editor);
          } else {
            cov_ahoy21ze1().b[28][1]++;
          }
        },
        onFail: function onFail(xhr, resultStr) {
          cov_ahoy21ze1().f[18]++;
          cov_ahoy21ze1().s[115]++;

          _this_1.alert(t('上传图片失败'), t('上传图片返回结果错误') + ("\uFF0C" + t('返回结果') + ": ") + resultStr);

          cov_ahoy21ze1().s[116]++;

          if (hooks.fail) {
            cov_ahoy21ze1().b[29][0]++;
            cov_ahoy21ze1().s[117]++;
            hooks.fail(xhr, editor, resultStr);
          } else {
            cov_ahoy21ze1().b[29][1]++;
          }
        },
        onSuccess: function onSuccess(xhr, result) {
          cov_ahoy21ze1().f[19]++;
          cov_ahoy21ze1().s[118]++;

          if (hooks.customInsert) {
            var _context2;

            cov_ahoy21ze1().b[30][0]++;
            cov_ahoy21ze1().s[119]++;
            // 自定义插入图片
            hooks.customInsert((0, _bind["default"])(_context2 = _this_1.insertImg).call(_context2, _this_1), result, editor);
            cov_ahoy21ze1().s[120]++;
            return;
          } else {
            cov_ahoy21ze1().b[30][1]++;
          }

          cov_ahoy21ze1().s[121]++;

          if (result.errno != '0') {
            cov_ahoy21ze1().b[31][0]++;
            cov_ahoy21ze1().s[122]++;

            // 返回格式不对，应该为 { errno: 0, data: [...] }
            _this_1.alert(t('上传图片失败'), t('上传图片返回结果错误') + "\uFF0C" + t('返回结果') + " errno=" + result.errno);

            cov_ahoy21ze1().s[123]++;

            if (hooks.fail) {
              cov_ahoy21ze1().b[32][0]++;
              cov_ahoy21ze1().s[124]++;
              hooks.fail(xhr, editor, result);
            } else {
              cov_ahoy21ze1().b[32][1]++;
            }

            cov_ahoy21ze1().s[125]++;
            return;
          } else {
            cov_ahoy21ze1().b[31][1]++;
          } // 成功，插入图片


          var data = (cov_ahoy21ze1().s[126]++, result.data);
          cov_ahoy21ze1().s[127]++;
          (0, _forEach["default"])(data).call(data, function (link) {
            cov_ahoy21ze1().f[20]++;
            cov_ahoy21ze1().s[128]++;

            _this_1.insertImg(link);
          }); // 钩子函数

          cov_ahoy21ze1().s[129]++;

          if (hooks.success) {
            cov_ahoy21ze1().b[33][0]++;
            cov_ahoy21ze1().s[130]++;
            hooks.success(xhr, editor, result);
          } else {
            cov_ahoy21ze1().b[33][1]++;
          }
        }
      }));
      cov_ahoy21ze1().s[131]++;

      if (typeof xhr === 'string') {
        cov_ahoy21ze1().b[34][0]++;
        cov_ahoy21ze1().s[132]++;
        // 上传被阻止
        this.alert(xhr);
      } else {
        cov_ahoy21ze1().b[34][1]++;
      } // 阻止以下代码执行，重要！！！


      cov_ahoy21ze1().s[133]++;
      return;
    } else {
      cov_ahoy21ze1().b[20][1]++;
    } // ------------------------------ 显示 base64 格式 ------------------------------


    cov_ahoy21ze1().s[134]++;

    if (uploadImgShowBase64) {
      cov_ahoy21ze1().b[35][0]++;
      cov_ahoy21ze1().s[135]++;
      util_1.arrForEach(files, function (file) {
        cov_ahoy21ze1().f[21]++;

        var _this = (cov_ahoy21ze1().s[136]++, _this_1);

        var reader = (cov_ahoy21ze1().s[137]++, new FileReader());
        cov_ahoy21ze1().s[138]++;
        reader.readAsDataURL(file);
        cov_ahoy21ze1().s[139]++;

        reader.onload = function () {
          cov_ahoy21ze1().f[22]++;
          cov_ahoy21ze1().s[140]++;

          if (!this.result) {
            cov_ahoy21ze1().b[36][0]++;
            cov_ahoy21ze1().s[141]++;
            return;
          } else {
            cov_ahoy21ze1().b[36][1]++;
          }

          cov_ahoy21ze1().s[142]++;

          _this.insertImg(this.result.toString());
        };
      });
    } else {
      cov_ahoy21ze1().b[35][1]++;
    }
  };

  cov_ahoy21ze1().s[143]++;
  return UploadImg;
}());
cov_ahoy21ze1().s[144]++;
exports["default"] = UploadImg;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 双栈实现撤销恢复
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1y0uozuoe3() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/cache.ts";
  var hash = "e003a00ff22a3a15ccf6f157c5790b963017f6dd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/cache.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 14
        },
        end: {
          line: 7,
          column: 32
        }
      },
      "2": {
        start: {
          line: 8,
          column: 27
        },
        end: {
          line: 75,
          column: 3
        }
      },
      "3": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 31
        }
      },
      "4": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 26
        }
      },
      "5": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 51
        }
      },
      "6": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 57
        }
      },
      "7": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 27,
          column: 7
        }
      },
      "8": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 58
        }
      },
      "9": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      "10": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 36
        }
      },
      "11": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 42
        }
      },
      "12": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "13": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "14": {
        start: {
          line: 40,
          column: 12
        },
        end: {
          line: 40,
          column: 36
        }
      },
      "15": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 30
        }
      },
      "16": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 32
        }
      },
      "17": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 20
        }
      },
      "18": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 59,
          column: 6
        }
      },
      "19": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 41
        }
      },
      "20": {
        start: {
          line: 52,
          column: 19
        },
        end: {
          line: 52,
          column: 39
        }
      },
      "21": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 57,
          column: 9
        }
      },
      "22": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "23": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 21
        }
      },
      "24": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 24
        }
      },
      "25": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 21
        }
      },
      "26": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 73,
          column: 6
        }
      },
      "27": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 41
        }
      },
      "28": {
        start: {
          line: 66,
          column: 19
        },
        end: {
          line: 66,
          column: 45
        }
      },
      "29": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 71,
          column: 9
        }
      },
      "30": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 36
        }
      },
      "31": {
        start: {
          line: 69,
          column: 12
        },
        end: {
          line: 69,
          column: 21
        }
      },
      "32": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 70,
          column: 24
        }
      },
      "33": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 21
        }
      },
      "34": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 17
        }
      },
      "35": {
        start: {
          line: 76,
          column: 0
        },
        end: {
          line: 76,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 27
          },
          end: {
            line: 8,
            column: 28
          }
        },
        loc: {
          start: {
            line: 8,
            column: 39
          },
          end: {
            line: 75,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "Cache",
        decl: {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 18
          }
        },
        loc: {
          start: {
            line: 9,
            column: 28
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 9
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 13
          },
          end: {
            line: 22,
            column: 14
          }
        },
        loc: {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 24,
            column: 9
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 35
          },
          end: {
            line: 31,
            column: 36
          }
        },
        loc: {
          start: {
            line: 31,
            column: 54
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 27
          },
          end: {
            line: 38,
            column: 28
          }
        },
        loc: {
          start: {
            line: 38,
            column: 43
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 50,
            column: 29
          },
          end: {
            line: 50,
            column: 30
          }
        },
        loc: {
          start: {
            line: 50,
            column: 43
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 64,
            column: 30
          },
          end: {
            line: 64,
            column: 31
          }
        },
        loc: {
          start: {
            line: 64,
            column: 44
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 18
          }
        }, {
          start: {
            line: 51,
            column: 23
          },
          end: {
            line: 51,
            column: 39
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }, {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }],
        line: 53
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 18
          }
        }, {
          start: {
            line: 65,
            column: 23
          },
          end: {
            line: 65,
            column: 39
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 71,
            column: 9
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/cache.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/cache.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,iCAAmC;AAEnC;IAgBI,eAAsB,OAAe;QAAf,YAAO,GAAP,OAAO,CAAQ;QALrC;;WAEG;QACO,SAAI,GAAY,KAAK,CAAA;QAG3B,IAAI,CAAC,IAAI,GAAG,IAAI,iBAAS,CAAC,OAAO,CAAC,CAAA;QAClC,IAAI,CAAC,UAAU,GAAG,IAAI,iBAAS,CAAC,OAAO,CAAC,CAAA;IAC5C,CAAC;IAKD,sBAAW,uBAAI;QAHf;;WAEG;aACH;YACI,OAAO,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,CAAA;QACjD,CAAC;;;OAAA;IAED;;OAEG;IACI,4BAAY,GAAnB,UAAoB,OAAe;QAC/B,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAA;QAC3B,IAAI,CAAC,UAAU,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAA;IACrC,CAAC;IAED;;OAEG;IACI,oBAAI,GAAX,UAAY,IAAO;QACf,IAAI,IAAI,CAAC,IAAI,EAAE;YACX,IAAI,CAAC,UAAU,CAAC,KAAK,EAAE,CAAA;YACvB,IAAI,CAAC,IAAI,GAAG,KAAK,CAAA;SACpB;QACD,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,CAAA;QACvB,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;;OAGG;IACI,sBAAM,GAAb,UAAc,EAAqB;QAC/B,CAAC,IAAI,CAAC,IAAI,IAAI,CAAC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,CAAA;QAChC,IAAI,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,QAAQ,EAAE,CAAA;QAC/B,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,UAAU,CAAC,OAAO,CAAC,IAAI,CAAC,CAAA;YAC7B,EAAE,CAAC,IAAI,CAAC,CAAA;YACR,OAAO,IAAI,CAAA;SACd;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED;;;OAGG;IACI,uBAAO,GAAd,UAAe,EAAqB;QAChC,CAAC,IAAI,CAAC,IAAI,IAAI,CAAC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,CAAA;QAChC,IAAI,IAAI,GAAG,IAAI,CAAC,UAAU,CAAC,QAAQ,EAAE,CAAA;QACrC,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,CAAA;YACvB,EAAE,CAAC,IAAI,CAAC,CAAA;YACR,OAAO,IAAI,CAAA;SACd;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IACL,YAAC;AAAD,CAAC,AA7ED,IA6EC",
      sourcesContent: ["/**\n * @description \u53CC\u6808\u5B9E\u73B0\u64A4\u9500\u6062\u590D\n * @author fangzhicong\n */\n\nimport { CeilStack } from './stack'\n\nexport default class Cache<T> {\n    /**\n     * \u6B63\u5E38\u64CD\u4F5C\uFF08\u7528\u6237\u8F93\u5165\u3001js\u4EE3\u7801\u4FEE\u6539\u5185\u5BB9\u3001\u6062\u590D\u64CD\u4F5C\uFF09\u4EA7\u751F\u7684\u7F13\u5B58\n     */\n    protected data: CeilStack<T>\n\n    /**\n     * \u64A4\u9500\u64CD\u4F5C\u4EA7\u751F\u7684\u7F13\u5B58\uFF08\u6062\u590D\u64CD\u4F5C\u65F6\u9700\u8981\u8FD9\u4E9B\u6570\u636E\uFF09\n     */\n    protected revokeData: CeilStack<T>\n\n    /**\n     * \u4E0A\u4E00\u6B65\u64CD\u4F5C\u662F\u5426\u4E3A \u64A4\u9500/\u6062\u590D\n     */\n    protected isRe: boolean = false\n\n    constructor(protected maxSize: number) {\n        this.data = new CeilStack(maxSize)\n        this.revokeData = new CeilStack(maxSize)\n    }\n\n    /**\n     * \u8FD4\u56DE\u5F53\u524D\u6808\u4E2D\u7684\u6570\u636E\u957F\u5EA6\u3002\u683C\u5F0F\u4E3A\uFF1A[\u6B63\u5E38\u7684\u6570\u636E\u7684\u6761\u6570\uFF0C\u88AB\u64A4\u9500\u7684\u6570\u636E\u7684\u6761\u6570]\n     */\n    public get size() {\n        return [this.data.size, this.revokeData.size]\n    }\n\n    /**\n     * \u91CD\u8BBE\u6570\u636E\u7F13\u5B58\u5668\u7684\u7F13\u5B58\u957F\u5EA6\uFF08\u7B2C\u4E00\u6B21\u6709\u6548\uFF09\n     */\n    public resetMaxSize(maxSize: number) {\n        this.data.resetMax(maxSize)\n        this.revokeData.resetMax(maxSize)\n    }\n\n    /**\n     * \u4FDD\u5B58\u6570\u636E\n     */\n    public save(data: T) {\n        if (this.isRe) {\n            this.revokeData.clear()\n            this.isRe = false\n        }\n        this.data.instack(data)\n        return this\n    }\n\n    /**\n     * \u64A4\u9500\n     * @param fn \u64A4\u9500\u65F6\uFF0C\u5982\u679C\u6709\u6570\u636E\uFF0C\u6267\u884C\u7684\u56DE\u8C03\u51FD\u6570\n     */\n    public revoke(fn: (data: T) => void) {\n        !this.isRe && (this.isRe = true)\n        let data = this.data.outstack()\n        if (data) {\n            this.revokeData.instack(data)\n            fn(data)\n            return true\n        }\n        return false\n    }\n\n    /**\n     * \u6062\u590D\n     * @param fn \u6062\u590D\u65F6\uFF0C\u5982\u679C\u6709\u6570\u636E\uFF0C\u6267\u884C\u7684\u56DE\u8C03\u51FD\u6570\n     */\n    public restore(fn: (data: T) => void) {\n        !this.isRe && (this.isRe = true)\n        let data = this.revokeData.outstack()\n        if (data) {\n            this.data.instack(data)\n            fn(data)\n            return true\n        }\n        return false\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e003a00ff22a3a15ccf6f157c5790b963017f6dd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1y0uozuoe3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1y0uozuoe3();
cov_1y0uozuoe3().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var stack_1 = (cov_1y0uozuoe3().s[1]++, __webpack_require__(390));
var Cache = (
/** @class */
cov_1y0uozuoe3().s[2]++, function () {
  cov_1y0uozuoe3().f[0]++;

  function Cache(maxSize) {
    cov_1y0uozuoe3().f[1]++;
    cov_1y0uozuoe3().s[3]++;
    this.maxSize = maxSize;
    /**
     * 上一步操作是否为 撤销/恢复
     */

    cov_1y0uozuoe3().s[4]++;
    this.isRe = false;
    cov_1y0uozuoe3().s[5]++;
    this.data = new stack_1.CeilStack(maxSize);
    cov_1y0uozuoe3().s[6]++;
    this.revokeData = new stack_1.CeilStack(maxSize);
  }

  cov_1y0uozuoe3().s[7]++;
  (0, _defineProperty["default"])(Cache.prototype, "size", {
    /**
     * 返回当前栈中的数据长度。格式为：[正常的数据的条数，被撤销的数据的条数]
     */
    get: function get() {
      cov_1y0uozuoe3().f[2]++;
      cov_1y0uozuoe3().s[8]++;
      return [this.data.size, this.revokeData.size];
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 重设数据缓存器的缓存长度（第一次有效）
   */

  cov_1y0uozuoe3().s[9]++;

  Cache.prototype.resetMaxSize = function (maxSize) {
    cov_1y0uozuoe3().f[3]++;
    cov_1y0uozuoe3().s[10]++;
    this.data.resetMax(maxSize);
    cov_1y0uozuoe3().s[11]++;
    this.revokeData.resetMax(maxSize);
  };
  /**
   * 保存数据
   */


  cov_1y0uozuoe3().s[12]++;

  Cache.prototype.save = function (data) {
    cov_1y0uozuoe3().f[4]++;
    cov_1y0uozuoe3().s[13]++;

    if (this.isRe) {
      cov_1y0uozuoe3().b[0][0]++;
      cov_1y0uozuoe3().s[14]++;
      this.revokeData.clear();
      cov_1y0uozuoe3().s[15]++;
      this.isRe = false;
    } else {
      cov_1y0uozuoe3().b[0][1]++;
    }

    cov_1y0uozuoe3().s[16]++;
    this.data.instack(data);
    cov_1y0uozuoe3().s[17]++;
    return this;
  };
  /**
   * 撤销
   * @param fn 撤销时，如果有数据，执行的回调函数
   */


  cov_1y0uozuoe3().s[18]++;

  Cache.prototype.revoke = function (fn) {
    cov_1y0uozuoe3().f[5]++;
    cov_1y0uozuoe3().s[19]++;
    (cov_1y0uozuoe3().b[1][0]++, !this.isRe) && (cov_1y0uozuoe3().b[1][1]++, this.isRe = true);
    var data = (cov_1y0uozuoe3().s[20]++, this.data.outstack());
    cov_1y0uozuoe3().s[21]++;

    if (data) {
      cov_1y0uozuoe3().b[2][0]++;
      cov_1y0uozuoe3().s[22]++;
      this.revokeData.instack(data);
      cov_1y0uozuoe3().s[23]++;
      fn(data);
      cov_1y0uozuoe3().s[24]++;
      return true;
    } else {
      cov_1y0uozuoe3().b[2][1]++;
    }

    cov_1y0uozuoe3().s[25]++;
    return false;
  };
  /**
   * 恢复
   * @param fn 恢复时，如果有数据，执行的回调函数
   */


  cov_1y0uozuoe3().s[26]++;

  Cache.prototype.restore = function (fn) {
    cov_1y0uozuoe3().f[6]++;
    cov_1y0uozuoe3().s[27]++;
    (cov_1y0uozuoe3().b[3][0]++, !this.isRe) && (cov_1y0uozuoe3().b[3][1]++, this.isRe = true);
    var data = (cov_1y0uozuoe3().s[28]++, this.revokeData.outstack());
    cov_1y0uozuoe3().s[29]++;

    if (data) {
      cov_1y0uozuoe3().b[4][0]++;
      cov_1y0uozuoe3().s[30]++;
      this.data.instack(data);
      cov_1y0uozuoe3().s[31]++;
      fn(data);
      cov_1y0uozuoe3().s[32]++;
      return true;
    } else {
      cov_1y0uozuoe3().b[4][1]++;
    }

    cov_1y0uozuoe3().s[33]++;
    return false;
  };

  cov_1y0uozuoe3().s[34]++;
  return Cache;
}());
cov_1y0uozuoe3().s[35]++;
exports["default"] = Cache;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var fails = __webpack_require__(12);
var createElement = __webpack_require__(68);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(15);
var toIndexedObject = __webpack_require__(25);
var indexOf = __webpack_require__(69).indexOf;
var hiddenKeys = __webpack_require__(48);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(26);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(76);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);

module.exports = global.Promise;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(49);

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else redefine(target, key, src[key], options);
  } return target;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(26);
var definePropertyModule = __webpack_require__(17);
var wellKnownSymbol = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(14);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(73);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var aFunction = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(9);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var fails = __webpack_require__(12);
var bind = __webpack_require__(46);
var html = __webpack_require__(99);
var createElement = __webpack_require__(68);
var IS_IOS = __webpack_require__(107);
var IS_NODE = __webpack_require__(80);

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__(79);

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var isObject = __webpack_require__(13);
var newPromiseCapability = __webpack_require__(63);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(74);
var createNonEnumerableProperty = __webpack_require__(16);
var has = __webpack_require__(15);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(35);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(185);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(206);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var global = __webpack_require__(8);
var InternalMetadataModule = __webpack_require__(114);
var fails = __webpack_require__(12);
var createNonEnumerableProperty = __webpack_require__(16);
var iterate = __webpack_require__(37);
var anInstance = __webpack_require__(78);
var isObject = __webpack_require__(13);
var setToStringTag = __webpack_require__(39);
var defineProperty = __webpack_require__(17).f;
var forEach = __webpack_require__(41).forEach;
var DESCRIPTORS = __webpack_require__(14);
var InternalStateModule = __webpack_require__(40);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var exported = {};
  var Constructor;

  if (!DESCRIPTORS || typeof NativeConstructor != 'function'
    || !(IS_WEAK || NativePrototype.forEach && !fails(function () { new NativeConstructor().entries().next(); }))
  ) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else {
    Constructor = wrapper(function (target, iterable) {
      setInternalState(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
        type: CONSTRUCTOR_NAME,
        collection: new NativeConstructor()
      });
      if (iterable != undefined) iterate(iterable, target[ADDER], { that: target, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
        createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
          var collection = getInternalState(this).collection;
          if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
          var result = collection[KEY](a === 0 ? 0 : a, b);
          return IS_ADDER ? this : result;
        });
      }
    });

    IS_WEAK || defineProperty(Constructor.prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).collection.size;
      }
    });
  }

  setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: true }, exported);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(48);
var isObject = __webpack_require__(13);
var has = __webpack_require__(15);
var defineProperty = __webpack_require__(17).f;
var uid = __webpack_require__(60);
var FREEZING = __webpack_require__(209);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(17).f;
var create = __webpack_require__(47);
var redefineAll = __webpack_require__(102);
var bind = __webpack_require__(46);
var anInstance = __webpack_require__(78);
var iterate = __webpack_require__(37);
var defineIterator = __webpack_require__(83);
var setSpecies = __webpack_require__(103);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(114).fastKey;
var InternalStateModule = __webpack_require__(40);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(219);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(98);
var enumBugKeys = __webpack_require__(71);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(252);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 样式配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_19dzt3axbt() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/style.ts";
  var hash = "54f787ba909c10a95a4afafe460d0f0e5b7a0ace";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/style.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 9,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/style.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/style.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,kBAAe;IACX,MAAM,EAAE,KAAK;CAChB,CAAA",
      sourcesContent: ["/**\n * @description \u6837\u5F0F\u914D\u7F6E\n * @author wangfupeng\n */\n\nexport default {\n    zIndex: 10000,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "54f787ba909c10a95a4afafe460d0f0e5b7a0ace"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19dzt3axbt = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_19dzt3axbt();
cov_19dzt3axbt().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_19dzt3axbt().s[1]++;
exports["default"] = {
  zIndex: 10000
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 处理粘贴逻辑
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1wd4xq79qk() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/paste/paste-event.ts";
  var hash = "042c6ee91f720842c9ca3261e03e52bba665ecfd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/paste/paste-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 76
        }
      },
      "4": {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 11,
          column: 40
        }
      },
      "5": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 12,
          column: 59
        }
      },
      "6": {
        start: {
          line: 19,
          column: 24
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "7": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 22
        }
      },
      "8": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "9": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 81
        }
      },
      "10": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 56
        }
      },
      "11": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 47
        }
      },
      "12": {
        start: {
          line: 29,
          column: 0
        },
        end: {
          line: 29,
          column: 36
        }
      },
      "13": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 55
        }
      },
      "14": {
        start: {
          line: 37,
          column: 34
        },
        end: {
          line: 37,
          column: 53
        }
      },
      "15": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 52
        }
      },
      "16": {
        start: {
          line: 38,
          column: 32
        },
        end: {
          line: 38,
          column: 50
        }
      },
      "17": {
        start: {
          line: 39,
          column: 24
        },
        end: {
          line: 39,
          column: 39
        }
      },
      "18": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "19": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "20": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 55
        }
      },
      "21": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "22": {
        start: {
          line: 46,
          column: 19
        },
        end: {
          line: 46,
          column: 34
        }
      },
      "23": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "24": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 22
        }
      },
      "25": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 42
        }
      },
      "26": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 72
        }
      },
      "27": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 21
        }
      },
      "28": {
        start: {
          line: 56,
          column: 0
        },
        end: {
          line: 56,
          column: 36
        }
      },
      "29": {
        start: {
          line: 63,
          column: 17
        },
        end: {
          line: 63,
          column: 19
        }
      },
      "30": {
        start: {
          line: 64,
          column: 14
        },
        end: {
          line: 64,
          column: 29
        }
      },
      "31": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "32": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 22
        }
      },
      "33": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 69,
          column: 84
        }
      },
      "34": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 71,
          column: 22
        }
      },
      "35": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 22
        }
      },
      "36": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 77,
          column: 7
        }
      },
      "37": {
        start: {
          line: 73,
          column: 19
        },
        end: {
          line: 73,
          column: 29
        }
      },
      "38": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "39": {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 75,
          column: 43
        }
      },
      "40": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 18
        }
      },
      "41": {
        start: {
          line: 80,
          column: 0
        },
        end: {
          line: 80,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "getPasteText",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 21
          }
        },
        loc: {
          start: {
            line: 17,
            column: 25
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "getPasteHtml",
        decl: {
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 21
          }
        },
        loc: {
          start: {
            line: 36,
            column: 49
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 36
      },
      "3": {
        name: "getPasteImgs",
        decl: {
          start: {
            line: 61,
            column: 9
          },
          end: {
            line: 61,
            column: 21
          }
        },
        loc: {
          start: {
            line: 61,
            column: 25
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 61
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 72,
            column: 27
          }
        },
        loc: {
          start: {
            line: 72,
            column: 48
          },
          end: {
            line: 77,
            column: 5
          }
        },
        line: 72
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 26,
            column: 5
          }
        }],
        line: 21
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 20
          },
          end: {
            line: 22,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 20
          },
          end: {
            line: 22,
            column: 40
          }
        }, {
          start: {
            line: 22,
            column: 44
          },
          end: {
            line: 22,
            column: 80
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 55
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 55
          }
        }],
        line: 37
      },
      "6": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 52
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 38,
            column: 52
          }
        }],
        line: 38
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 45
      },
      "9": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 47
      },
      "10": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 65
      },
      "11": {
        loc: {
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 69,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 67
          },
          end: {
            line: 69,
            column: 73
          }
        }, {
          start: {
            line: 69,
            column: 76
          },
          end: {
            line: 69,
            column: 84
          }
        }],
        line: 69
      },
      "12": {
        loc: {
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 69,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 69,
            column: 47
          }
        }, {
          start: {
            line: 69,
            column: 51
          },
          end: {
            line: 69,
            column: 64
          }
        }],
        line: 69
      },
      "13": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 22
          }
        }, {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 71,
            column: 22
          }
        }],
        line: 70
      },
      "14": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }],
        line: 74
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/paste/paste-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/paste/paste-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;AAEH,yCAA6D;AAC7D,4DAAoC;AAEpC;;;GAGG;AACH,SAAgB,YAAY,CAAC,CAAiB;IAC1C,8FAA8F;IAC9F,IAAM,aAAa,GAAG,CAAC,CAAC,aAAa,CAAA,CAAC,yBAAyB;IAC/D,IAAI,SAAS,GAAG,EAAE,CAAA;IAClB,IAAI,aAAa,IAAI,IAAI,EAAE;QACvB,SAAS,GAAI,MAAc,CAAC,aAAa,IAAK,MAAc,CAAC,aAAa,CAAC,OAAO,CAAC,MAAM,CAAC,CAAA;KAC7F;SAAM;QACH,SAAS,GAAG,aAAa,CAAC,OAAO,CAAC,YAAY,CAAC,CAAA;KAClD;IACD,OAAO,wBAAiB,CAAC,SAAS,CAAC,CAAA;AACvC,CAAC;AAVD,oCAUC;AAED;;;;;GAKG;AACH,SAAgB,YAAY,CACxB,CAAiB,EACjB,WAA2B,EAC3B,SAA0B;IAD1B,4BAAA,EAAA,kBAA2B;IAC3B,0BAAA,EAAA,iBAA0B;IAE1B,IAAM,aAAa,GAAG,CAAC,CAAC,aAAa,CAAA,CAAC,yBAAyB;IAC/D,IAAI,SAAS,GAAG,EAAE,CAAA;IAClB,IAAI,aAAa,EAAE;QACf,SAAS,GAAG,aAAa,CAAC,OAAO,CAAC,WAAW,CAAC,CAAA;KACjD;IAED,wCAAwC;IACxC,IAAI,CAAC,SAAS,EAAE;QACZ,IAAM,IAAI,GAAG,YAAY,CAAC,CAAC,CAAC,CAAA;QAC5B,IAAI,CAAC,IAAI,EAAE;YACP,OAAO,EAAE,CAAA,CAAC,eAAe;SAC5B;QACD,SAAS,GAAG,QAAM,IAAI,SAAM,CAAA;KAC/B;IAED,aAAa;IACb,SAAS,GAAG,oBAAS,CAAC,SAAS,EAAE,WAAW,EAAE,SAAS,CAAC,CAAA;IAExD,OAAO,SAAS,CAAA;AACpB,CAAC;AAxBD,oCAwBC;AAED;;;GAGG;AACH,SAAgB,YAAY,CAAC,CAAiB;;IAC1C,IAAM,MAAM,GAAW,EAAE,CAAA;IACzB,IAAM,GAAG,GAAG,YAAY,CAAC,CAAC,CAAC,CAAA;IAC3B,IAAI,GAAG,EAAE;QACL,YAAY;QACZ,OAAO,MAAM,CAAA;KAChB;IAED,IAAM,KAAK,SAAG,CAAC,CAAC,aAAa,0CAAE,KAAK,CAAA;IAEpC,IAAI,CAAC,KAAK;QAAE,OAAO,MAAM,CAAA;IAEzB,cAAO,CAAC,KAAK,EAAE,UAAC,GAAG,EAAE,KAAK;QACtB,IAAM,IAAI,GAAG,KAAK,CAAC,IAAI,CAAA;QACvB,IAAI,QAAQ,CAAC,IAAI,CAAC,IAAI,CAAC,EAAE;YACrB,MAAM,CAAC,IAAI,CAAC,KAAK,CAAC,SAAS,EAAU,CAAC,CAAA;SACzC;IACL,CAAC,CAAC,CAAA;IAEF,OAAO,MAAM,CAAA;AACjB,CAAC;AApBD,oCAoBC",
      sourcesContent: ["/**\n * @description \u5904\u7406\u7C98\u8D34\u903B\u8F91\n * @author wangfupeng\n */\n\nimport { replaceHtmlSymbol, forEach } from '../../utils/util'\nimport parseHtml from './parse-html'\n\n/**\n * \u83B7\u53D6\u7C98\u8D34\u7684\u7EAF\u6587\u672C\n * @param e Event \u53C2\u6570\n */\nexport function getPasteText(e: ClipboardEvent): string {\n    // const clipboardData = e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)\n    const clipboardData = e.clipboardData // \u6682\u4E0D\u8003\u8651 originalEvent \u7684\u60C5\u51B5\n    let pasteText = ''\n    if (clipboardData == null) {\n        pasteText = (window as any).clipboardData && (window as any).clipboardData.getData('text')\n    } else {\n        pasteText = clipboardData.getData('text/plain')\n    }\n    return replaceHtmlSymbol(pasteText)\n}\n\n/**\n * \u83B7\u53D6\u7C98\u8D34\u7684 html \u5B57\u7B26\u4E32\n * @param e Event \u53C2\u6570\n * @param filterStyle \u662F\u5426\u8FC7\u6EE4 style \u6837\u5F0F\n * @param ignoreImg \u662F\u5426\u5FFD\u7565 img \u6807\u7B7E\n */\nexport function getPasteHtml(\n    e: ClipboardEvent,\n    filterStyle: boolean = true,\n    ignoreImg: boolean = false\n): string {\n    const clipboardData = e.clipboardData // \u6682\u4E0D\u8003\u8651 originalEvent \u7684\u60C5\u51B5\n    let pasteHtml = ''\n    if (clipboardData) {\n        pasteHtml = clipboardData.getData('text/html')\n    }\n\n    // \u65E0\u6CD5\u901A\u8FC7 'text/html' \u683C\u5F0F\u83B7\u53D6 html\uFF0C\u5219\u5C1D\u8BD5\u83B7\u53D6 text\n    if (!pasteHtml) {\n        const text = getPasteText(e)\n        if (!text) {\n            return '' // \u6CA1\u6709\u627E\u5230\u4EFB\u4F55\u6587\u5B57\uFF0C\u5219\u8FD4\u56DE\n        }\n        pasteHtml = `<p>${text}</p>`\n    }\n\n    // \u5254\u9664\u591A\u4F59\u7684\u6807\u7B7E\u3001\u5C5E\u6027\n    pasteHtml = parseHtml(pasteHtml, filterStyle, ignoreImg)\n\n    return pasteHtml\n}\n\n/**\n * \u83B7\u53D6\u7C98\u8D34\u7684\u56FE\u7247\u6587\u4EF6\n * @param e Event \u53C2\u6570\n */\nexport function getPasteImgs(e: ClipboardEvent): File[] {\n    const result: File[] = []\n    const txt = getPasteText(e)\n    if (txt) {\n        // \u6709\u6587\u5B57\uFF0C\u5C31\u5FFD\u7565\u56FE\u7247\n        return result\n    }\n\n    const items = e.clipboardData?.items\n\n    if (!items) return result\n\n    forEach(items, (key, value) => {\n        const type = value.type\n        if (/image/i.test(type)) {\n            result.push(value.getAsFile() as File)\n        }\n    })\n\n    return result\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "042c6ee91f720842c9ca3261e03e52bba665ecfd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1wd4xq79qk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1wd4xq79qk();

var __importDefault = (cov_1wd4xq79qk().s[0]++, (cov_1wd4xq79qk().b[0][0]++, void 0) && (cov_1wd4xq79qk().b[0][1]++, (void 0).__importDefault) || (cov_1wd4xq79qk().b[0][2]++, function (mod) {
  cov_1wd4xq79qk().f[0]++;
  cov_1wd4xq79qk().s[1]++;
  return (cov_1wd4xq79qk().b[2][0]++, mod) && (cov_1wd4xq79qk().b[2][1]++, mod.__esModule) ? (cov_1wd4xq79qk().b[1][0]++, mod) : (cov_1wd4xq79qk().b[1][1]++, {
    "default": mod
  });
}));

cov_1wd4xq79qk().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_1wd4xq79qk().s[3]++;
exports.getPasteImgs = exports.getPasteHtml = exports.getPasteText = void 0;
var util_1 = (cov_1wd4xq79qk().s[4]++, __webpack_require__(7));
var parse_html_1 = (cov_1wd4xq79qk().s[5]++, __importDefault(__webpack_require__(290)));
/**
 * 获取粘贴的纯文本
 * @param e Event 参数
 */

function getPasteText(e) {
  cov_1wd4xq79qk().f[1]++;
  // const clipboardData = e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData)
  var clipboardData = (cov_1wd4xq79qk().s[6]++, e.clipboardData); // 暂不考虑 originalEvent 的情况

  var pasteText = (cov_1wd4xq79qk().s[7]++, '');
  cov_1wd4xq79qk().s[8]++;

  if (clipboardData == null) {
    cov_1wd4xq79qk().b[3][0]++;
    cov_1wd4xq79qk().s[9]++;
    pasteText = (cov_1wd4xq79qk().b[4][0]++, window.clipboardData) && (cov_1wd4xq79qk().b[4][1]++, window.clipboardData.getData('text'));
  } else {
    cov_1wd4xq79qk().b[3][1]++;
    cov_1wd4xq79qk().s[10]++;
    pasteText = clipboardData.getData('text/plain');
  }

  cov_1wd4xq79qk().s[11]++;
  return util_1.replaceHtmlSymbol(pasteText);
}

cov_1wd4xq79qk().s[12]++;
exports.getPasteText = getPasteText;
/**
 * 获取粘贴的 html 字符串
 * @param e Event 参数
 * @param filterStyle 是否过滤 style 样式
 * @param ignoreImg 是否忽略 img 标签
 */

function getPasteHtml(e, filterStyle, ignoreImg) {
  cov_1wd4xq79qk().f[2]++;
  cov_1wd4xq79qk().s[13]++;

  if (filterStyle === void 0) {
    cov_1wd4xq79qk().b[5][0]++;
    cov_1wd4xq79qk().s[14]++;
    filterStyle = true;
  } else {
    cov_1wd4xq79qk().b[5][1]++;
  }

  cov_1wd4xq79qk().s[15]++;

  if (ignoreImg === void 0) {
    cov_1wd4xq79qk().b[6][0]++;
    cov_1wd4xq79qk().s[16]++;
    ignoreImg = false;
  } else {
    cov_1wd4xq79qk().b[6][1]++;
  }

  var clipboardData = (cov_1wd4xq79qk().s[17]++, e.clipboardData); // 暂不考虑 originalEvent 的情况

  var pasteHtml = (cov_1wd4xq79qk().s[18]++, '');
  cov_1wd4xq79qk().s[19]++;

  if (clipboardData) {
    cov_1wd4xq79qk().b[7][0]++;
    cov_1wd4xq79qk().s[20]++;
    pasteHtml = clipboardData.getData('text/html');
  } else {
    cov_1wd4xq79qk().b[7][1]++;
  } // 无法通过 'text/html' 格式获取 html，则尝试获取 text


  cov_1wd4xq79qk().s[21]++;

  if (!pasteHtml) {
    cov_1wd4xq79qk().b[8][0]++;
    var text = (cov_1wd4xq79qk().s[22]++, getPasteText(e));
    cov_1wd4xq79qk().s[23]++;

    if (!text) {
      cov_1wd4xq79qk().b[9][0]++;
      cov_1wd4xq79qk().s[24]++;
      return ''; // 没有找到任何文字，则返回
    } else {
      cov_1wd4xq79qk().b[9][1]++;
    }

    cov_1wd4xq79qk().s[25]++;
    pasteHtml = "<p>" + text + "</p>";
  } else {
    cov_1wd4xq79qk().b[8][1]++;
  } // 剔除多余的标签、属性


  cov_1wd4xq79qk().s[26]++;
  pasteHtml = parse_html_1["default"](pasteHtml, filterStyle, ignoreImg);
  cov_1wd4xq79qk().s[27]++;
  return pasteHtml;
}

cov_1wd4xq79qk().s[28]++;
exports.getPasteHtml = getPasteHtml;
/**
 * 获取粘贴的图片文件
 * @param e Event 参数
 */

function getPasteImgs(e) {
  cov_1wd4xq79qk().f[3]++;

  var _a;

  var result = (cov_1wd4xq79qk().s[29]++, []);
  var txt = (cov_1wd4xq79qk().s[30]++, getPasteText(e));
  cov_1wd4xq79qk().s[31]++;

  if (txt) {
    cov_1wd4xq79qk().b[10][0]++;
    cov_1wd4xq79qk().s[32]++;
    // 有文字，就忽略图片
    return result;
  } else {
    cov_1wd4xq79qk().b[10][1]++;
  }

  var items = (cov_1wd4xq79qk().s[33]++, (cov_1wd4xq79qk().b[12][0]++, (_a = e.clipboardData) === null) || (cov_1wd4xq79qk().b[12][1]++, _a === void 0) ? (cov_1wd4xq79qk().b[11][0]++, void 0) : (cov_1wd4xq79qk().b[11][1]++, _a.items));
  cov_1wd4xq79qk().s[34]++;

  if (!items) {
    cov_1wd4xq79qk().b[13][0]++;
    cov_1wd4xq79qk().s[35]++;
    return result;
  } else {
    cov_1wd4xq79qk().b[13][1]++;
  }

  cov_1wd4xq79qk().s[36]++;
  (0, _forEach["default"])(util_1).call(util_1, items, function (key, value) {
    cov_1wd4xq79qk().f[4]++;
    var type = (cov_1wd4xq79qk().s[37]++, value.type);
    cov_1wd4xq79qk().s[38]++;

    if (/image/i.test(type)) {
      cov_1wd4xq79qk().b[14][0]++;
      cov_1wd4xq79qk().s[39]++;
      result.push(value.getAsFile());
    } else {
      cov_1wd4xq79qk().b[14][1]++;
    }
  });
  cov_1wd4xq79qk().s[40]++;
  return result;
}

cov_1wd4xq79qk().s[41]++;
exports.getPasteImgs = getPasteImgs;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(292);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 下拉列表 class
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_y45wikuj2() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropList.ts";
  var hash = "5c96eb87ae8aac62644a7ee9369adc28f696614a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropList.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 22
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "2": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 62
        }
      },
      "3": {
        start: {
          line: 9,
          column: 17
        },
        end: {
          line: 9,
          column: 65
        }
      },
      "4": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 10,
          column: 42
        }
      },
      "5": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 113,
          column: 3
        }
      },
      "6": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 24
        }
      },
      "7": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 31
        }
      },
      "8": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 31
        }
      },
      "9": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 25
        }
      },
      "10": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 25
        }
      },
      "11": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 19,
          column: 79
        }
      },
      "12": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 68
        }
      },
      "13": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 40
        }
      },
      "14": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 34
        }
      },
      "15": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 25,
          column: 34
        }
      },
      "16": {
        start: {
          line: 26,
          column: 19
        },
        end: {
          line: 26,
          column: 38
        }
      },
      "17": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 28,
          column: 64
        }
      },
      "18": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 112
        }
      },
      "19": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 46,
          column: 11
        }
      },
      "20": {
        start: {
          line: 32,
          column: 24
        },
        end: {
          line: 32,
          column: 34
        }
      },
      "21": {
        start: {
          line: 33,
          column: 24
        },
        end: {
          line: 33,
          column: 34
        }
      },
      "22": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 70
        }
      },
      "23": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 45,
          column: 13
        }
      },
      "24": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 36,
          column: 34
        }
      },
      "25": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 37,
          column: 34
        }
      },
      "26": {
        start: {
          line: 38,
          column: 16
        },
        end: {
          line: 44,
          column: 19
        }
      },
      "27": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 40
        }
      },
      "28": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 43,
          column: 23
        }
      },
      "29": {
        start: {
          line: 42,
          column: 24
        },
        end: {
          line: 42,
          column: 37
        }
      },
      "30": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 33
        }
      },
      "31": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 53,
          column: 11
        }
      },
      "32": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 52,
          column: 15
        }
      },
      "33": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 51,
          column: 29
        }
      },
      "34": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 37
        }
      },
      "35": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 30
        }
      },
      "36": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 27
        }
      },
      "37": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "38": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 66,
          column: 9
        }
      },
      "39": {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 45
        }
      },
      "40": {
        start: {
          line: 67,
          column: 19
        },
        end: {
          line: 67,
          column: 28
        }
      },
      "41": {
        start: {
          line: 68,
          column: 24
        },
        end: {
          line: 68,
          column: 34
        }
      },
      "42": {
        start: {
          line: 69,
          column: 25
        },
        end: {
          line: 69,
          column: 40
        }
      },
      "43": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 72,
          column: 9
        }
      },
      "44": {
        start: {
          line: 71,
          column: 12
        },
        end: {
          line: 71,
          column: 19
        }
      },
      "45": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 85,
          column: 9
        }
      },
      "46": {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 75,
          column: 30
        }
      },
      "47": {
        start: {
          line: 79,
          column: 29
        },
        end: {
          line: 79,
          column: 64
        }
      },
      "48": {
        start: {
          line: 80,
          column: 24
        },
        end: {
          line: 80,
          column: 46
        }
      },
      "49": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 81,
          column: 87
        }
      },
      "50": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 83,
          column: 41
        }
      },
      "51": {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 84,
          column: 33
        }
      },
      "52": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 26
        }
      },
      "53": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 104,
          column: 6
        }
      },
      "54": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 96,
          column: 9
        }
      },
      "55": {
        start: {
          line: 95,
          column: 12
        },
        end: {
          line: 95,
          column: 45
        }
      },
      "56": {
        start: {
          line: 97,
          column: 25
        },
        end: {
          line: 97,
          column: 40
        }
      },
      "57": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 100,
          column: 9
        }
      },
      "58": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 19
        }
      },
      "59": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 26
        }
      },
      "60": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 103,
          column: 27
        }
      },
      "61": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 111,
          column: 7
        }
      },
      "62": {
        start: {
          line: 107,
          column: 12
        },
        end: {
          line: 107,
          column: 30
        }
      },
      "63": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 20
        }
      },
      "64": {
        start: {
          line: 114,
          column: 0
        },
        end: {
          line: 114,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 56
          },
          end: {
            line: 5,
            column: 57
          }
        },
        loc: {
          start: {
            line: 5,
            column: 71
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 5
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 11,
            column: 31
          }
        },
        loc: {
          start: {
            line: 11,
            column: 42
          },
          end: {
            line: 113,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "DropList",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 21
          }
        },
        loc: {
          start: {
            line: 12,
            column: 34
          },
          end: {
            line: 58,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 21
          },
          end: {
            line: 31,
            column: 22
          }
        },
        loc: {
          start: {
            line: 31,
            column: 37
          },
          end: {
            line: 46,
            column: 9
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 32
          },
          end: {
            line: 38,
            column: 33
          }
        },
        loc: {
          start: {
            line: 38,
            column: 44
          },
          end: {
            line: 44,
            column: 17
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 60
          },
          end: {
            line: 41,
            column: 61
          }
        },
        loc: {
          start: {
            line: 41,
            column: 72
          },
          end: {
            line: 43,
            column: 21
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 36
          },
          end: {
            line: 49,
            column: 37
          }
        },
        loc: {
          start: {
            line: 49,
            column: 48
          },
          end: {
            line: 53,
            column: 9
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 50,
            column: 52
          },
          end: {
            line: 50,
            column: 53
          }
        },
        loc: {
          start: {
            line: 50,
            column: 64
          },
          end: {
            line: 52,
            column: 13
          }
        },
        line: 50
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 62,
            column: 30
          },
          end: {
            line: 62,
            column: 31
          }
        },
        loc: {
          start: {
            line: 62,
            column: 42
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 62
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 92,
            column: 30
          },
          end: {
            line: 92,
            column: 31
          }
        },
        loc: {
          start: {
            line: 92,
            column: 42
          },
          end: {
            line: 104,
            column: 5
          }
        },
        line: 92
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 106,
            column: 13
          },
          end: {
            line: 106,
            column: 14
          }
        },
        loc: {
          start: {
            line: 106,
            column: 25
          },
          end: {
            line: 108,
            column: 9
          }
        },
        line: 106
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 22
          },
          end: {
            line: 7,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 5,
            column: 23
          },
          end: {
            line: 5,
            column: 27
          }
        }, {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 5,
            column: 51
          }
        }, {
          start: {
            line: 5,
            column: 56
          },
          end: {
            line: 7,
            column: 1
          }
        }],
        line: 5
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 6,
            column: 37
          },
          end: {
            line: 6,
            column: 40
          }
        }, {
          start: {
            line: 6,
            column: 43
          },
          end: {
            line: 6,
            column: 61
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 15
          }
        }, {
          start: {
            line: 6,
            column: 19
          },
          end: {
            line: 6,
            column: 33
          }
        }],
        line: 6
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 19
          },
          end: {
            line: 25,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 19
          },
          end: {
            line: 25,
            column: 28
          }
        }, {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 34
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 28
          }
        }, {
          start: {
            line: 26,
            column: 32
          },
          end: {
            line: 26,
            column: 38
          }
        }],
        line: 26
      },
      "5": {
        loc: {
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 44
          }
        }, {
          start: {
            line: 28,
            column: 48
          },
          end: {
            line: 28,
            column: 64
          }
        }],
        line: 28
      },
      "6": {
        loc: {
          start: {
            line: 30,
            column: 56
          },
          end: {
            line: 30,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 74
          },
          end: {
            line: 30,
            column: 84
          }
        }, {
          start: {
            line: 30,
            column: 87
          },
          end: {
            line: 30,
            column: 98
          }
        }],
        line: 30
      },
      "7": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 45,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 45,
            column: 13
          }
        }, {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 45,
            column: 13
          }
        }],
        line: 35
      },
      "8": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }, {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }],
        line: 63
      },
      "9": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        }],
        line: 70
      },
      "10": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }],
        line: 73
      },
      "11": {
        loc: {
          start: {
            line: 79,
            column: 29
          },
          end: {
            line: 79,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 29
          },
          end: {
            line: 79,
            column: 59
          }
        }, {
          start: {
            line: 79,
            column: 63
          },
          end: {
            line: 79,
            column: 64
          }
        }],
        line: 79
      },
      "12": {
        loc: {
          start: {
            line: 80,
            column: 24
          },
          end: {
            line: 80,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 24
          },
          end: {
            line: 80,
            column: 39
          }
        }, {
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 80,
            column: 46
          }
        }],
        line: 80
      },
      "13": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 96,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 96,
            column: 9
          }
        }, {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 96,
            column: 9
          }
        }],
        line: 93
      },
      "14": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }, {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }],
        line: 98
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropList.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/DropList.ts"],
      names: [],
      mappings: ";AAAA;;GAEG;;;;;AAEH,kEAAoD;AAEpD,2CAA4C;AAgB5C;IAUI,kBAAY,IAAkB,EAAE,IAAkB;QAAlD,iBAqDC;QApDG,IAAI,CAAC,aAAa,GAAG,CAAC,CAAA;QACtB,IAAI,CAAC,aAAa,GAAG,CAAC,CAAA;QACtB,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;QAChB,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;QAEhB,KAAK;QACL,IAAM,UAAU,GAAG,kBAAC,CAAC,kCAAkC,CAAC,CAAA;QAExD,KAAK;QACL,IAAM,MAAM,GAAG,kBAAC,CAAC,QAAM,IAAI,CAAC,KAAK,SAAM,CAAC,CAAA;QACxC,MAAM,CAAC,QAAQ,CAAC,cAAc,CAAC,CAAA;QAC/B,UAAU,CAAC,MAAM,CAAC,MAAM,CAAC,CAAA;QAEzB,QAAQ;QACR,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,IAAI,EAAE,CAAA;QAC5B,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,IAAI,MAAM,CAAA;QAChC,aAAa;QACb,IAAM,YAAY,GAAG,IAAI,CAAC,YAAY,IAAI,gBAAQ,CAAA;QAElD,eAAe;QACf,IAAM,KAAK,GAAG,kBAAC,CAAC,aAAa,GAAG,CAAC,IAAI,KAAK,MAAM,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,WAAW,CAAC,GAAG,SAAS,CAAC,CAAA;QACzF,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACb,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAA;YAExB,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAA;YACxB,IAAM,GAAG,GAAG,kBAAC,CAAC,4BAA4B,CAAC,CAAA;YAC3C,IAAI,KAAK,EAAE;gBACP,GAAG,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;gBACjB,KAAK,CAAC,MAAM,CAAC,GAAG,CAAC,CAAA;gBACjB,GAAG,CAAC,EAAE,CAAC,OAAO,EAAE;oBACZ,YAAY,CAAC,KAAK,CAAC,CAAA;oBAEnB,oBAAoB;oBACpB,KAAI,CAAC,aAAa,GAAG,MAAM,CAAC,UAAU,CAAC;wBACnC,KAAI,CAAC,IAAI,EAAE,CAAA;oBACf,CAAC,CAAC,CAAA;gBACN,CAAC,CAAC,CAAA;aACL;QACL,CAAC,CAAC,CAAA;QACF,UAAU,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;QAExB,SAAS;QACT,UAAU,CAAC,EAAE,CAAC,YAAY,EAAE;YACxB,KAAI,CAAC,aAAa,GAAG,MAAM,CAAC,UAAU,CAAC;gBACnC,KAAI,CAAC,IAAI,EAAE,CAAA;YACf,CAAC,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;QAEF,OAAO;QACP,IAAI,CAAC,UAAU,GAAG,UAAU,CAAA;QAC5B,IAAI,CAAC,QAAQ,GAAG,KAAK,CAAA;QACrB,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;IACtB,CAAC;IAED;;OAEG;IACI,uBAAI,GAAX;QACI,IAAI,IAAI,CAAC,aAAa,EAAE;YACpB,YAAY;YACZ,YAAY,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;SACnC;QAED,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAM,SAAS,GAAG,IAAI,CAAC,KAAK,CAAA;QAC5B,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAClC,IAAI,IAAI,CAAC,KAAK,EAAE;YACZ,OAAM;SACT;QACD,IAAI,IAAI,CAAC,QAAQ,EAAE;YACf,KAAK;YACL,UAAU,CAAC,IAAI,EAAE,CAAA;SACpB;aAAM;YACH,iBAAiB;YACjB,IAAM,UAAU,GAAG,SAAS,CAAC,WAAW,EAAE,CAAC,MAAM,IAAI,CAAC,CAAA;YACtD,IAAM,KAAK,GAAG,IAAI,CAAC,IAAI,CAAC,KAAK,IAAI,GAAG,CAAA,CAAC,UAAU;YAC/C,UAAU,CAAC,GAAG,CAAC,YAAY,EAAE,UAAU,GAAG,IAAI,CAAC,CAAC,GAAG,CAAC,OAAO,EAAE,KAAK,GAAG,IAAI,CAAC,CAAA;YAE1E,UAAU;YACV,SAAS,CAAC,MAAM,CAAC,UAAU,CAAC,CAAA;YAC5B,IAAI,CAAC,QAAQ,GAAG,IAAI,CAAA;SACvB;QAED,OAAO;QACP,IAAI,CAAC,KAAK,GAAG,IAAI,CAAA;IACrB,CAAC;IAED;;OAEG;IACI,uBAAI,GAAX;QACI,IAAI,IAAI,CAAC,aAAa,EAAE;YACpB,YAAY;YACZ,YAAY,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;SACnC;QAED,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAClC,IAAI,CAAC,IAAI,CAAC,KAAK,EAAE;YACb,OAAM;SACT;QACD,UAAU;QACV,UAAU,CAAC,IAAI,EAAE,CAAA;QACjB,IAAI,CAAC,KAAK,GAAG,KAAK,CAAA;IACtB,CAAC;IAED,sBAAW,4BAAM;aAAjB;YACI,OAAO,IAAI,CAAC,KAAK,CAAA;QACrB,CAAC;;;OAAA;IACL,eAAC;AAAD,CAAC,AAvHD,IAuHC;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u4E0B\u62C9\u5217\u8868 class\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport DropListMenu from './DropListMenu'\nimport { EMPTY_FN } from '../../utils/const'\n\nexport type DropListItem = {\n    $elem: DomElement\n    value: string\n}\n\n// droplist \u7684\u914D\u7F6E\u6570\u636E\nexport type DropListConf = {\n    title: string\n    list: DropListItem[]\n    type: string // 'list' \u5217\u8868\u5F62\u5F0F\uFF08\u5982\u201C\u6807\u9898\u201D\u83DC\u5355\uFF09\uFF1B 'inline-block' \u5757\u72B6\u5F62\u5F0F\uFF08\u5982\u201C\u989C\u8272\u201D\u83DC\u5355\uFF09\n    clickHandler: (value: DropListItem['value']) => void\n    width: number | 100\n}\n\nclass DropList {\n    private menu: DropListMenu\n    private conf: DropListConf\n    private $container: DomElement\n    private rendered: boolean\n    private _show: boolean\n\n    public hideTimeoutId: number\n    public showTimeoutId: number\n\n    constructor(menu: DropListMenu, conf: DropListConf) {\n        this.hideTimeoutId = 0\n        this.showTimeoutId = 0\n        this.menu = menu\n        this.conf = conf\n\n        // \u5BB9\u5668\n        const $container = $('<div class=\"w-e-droplist\"></div>')\n\n        // \u6807\u9898\n        const $title = $(`<p>${conf.title}</p>`)\n        $title.addClass('w-e-dp-title')\n        $container.append($title)\n\n        // \u5217\u8868\u548C\u7C7B\u578B\n        const list = conf.list || []\n        const type = conf.type || 'list'\n        // item \u7684\u70B9\u51FB\u4E8B\u4EF6\n        const clickHandler = conf.clickHandler || EMPTY_FN\n\n        // \u52A0\u5165 DOM \u5E76\u7ED1\u5B9A\u4E8B\u4EF6\n        const $list = $('<ul class=\"' + (type === 'list' ? 'w-e-list' : 'w-e-block') + '\"></ul>')\n        list.forEach(item => {\n            const $elem = item.$elem\n\n            const value = item.value\n            const $li = $('<li class=\"w-e-item\"></li>')\n            if ($elem) {\n                $li.append($elem)\n                $list.append($li)\n                $li.on('click', () => {\n                    clickHandler(value)\n\n                    // item \u70B9\u51FB\u4E4B\u540E\uFF0C\u9690\u85CF list\n                    this.hideTimeoutId = window.setTimeout(() => {\n                        this.hide()\n                    })\n                })\n            }\n        })\n        $container.append($list)\n\n        // \u7ED1\u5B9A\u9690\u85CF\u4E8B\u4EF6\n        $container.on('mouseleave', () => {\n            this.hideTimeoutId = window.setTimeout(() => {\n                this.hide()\n            })\n        })\n\n        // \u8BB0\u5F55\u5C5E\u6027\n        this.$container = $container\n        this.rendered = false\n        this._show = false\n    }\n\n    /**\n     * \u663E\u793A DropList\n     */\n    public show() {\n        if (this.hideTimeoutId) {\n            // \u6E05\u9664\u4E4B\u524D\u7684\u5B9A\u65F6\u9690\u85CF\n            clearTimeout(this.hideTimeoutId)\n        }\n\n        const menu = this.menu\n        const $menuELem = menu.$elem\n        const $container = this.$container\n        if (this._show) {\n            return\n        }\n        if (this.rendered) {\n            // \u663E\u793A\n            $container.show()\n        } else {\n            // \u52A0\u5165 DOM \u4E4B\u524D\u5148\u5B9A\u4F4D\u4F4D\u7F6E\n            const menuHeight = $menuELem.getSizeData().height || 0\n            const width = this.conf.width || 100 // \u9ED8\u8BA4\u4E3A 100\n            $container.css('margin-top', menuHeight + 'px').css('width', width + 'px')\n\n            // \u52A0\u5165\u5230 DOM\n            $menuELem.append($container)\n            this.rendered = true\n        }\n\n        // \u4FEE\u6539\u5C5E\u6027\n        this._show = true\n    }\n\n    /**\n     * \u9690\u85CF DropList\n     */\n    public hide() {\n        if (this.showTimeoutId) {\n            // \u6E05\u9664\u4E4B\u524D\u7684\u5B9A\u65F6\u663E\u793A\n            clearTimeout(this.showTimeoutId)\n        }\n\n        const $container = this.$container\n        if (!this._show) {\n            return\n        }\n        // \u9690\u85CF\u5E76\u9700\u6539\u5C5E\u6027\n        $container.hide()\n        this._show = false\n    }\n\n    public get isShow() {\n        return this._show\n    }\n}\n\nexport default DropList\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5c96eb87ae8aac62644a7ee9369adc28f696614a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_y45wikuj2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_y45wikuj2();

var __importDefault = (cov_y45wikuj2().s[0]++, (cov_y45wikuj2().b[0][0]++, void 0) && (cov_y45wikuj2().b[0][1]++, (void 0).__importDefault) || (cov_y45wikuj2().b[0][2]++, function (mod) {
  cov_y45wikuj2().f[0]++;
  cov_y45wikuj2().s[1]++;
  return (cov_y45wikuj2().b[2][0]++, mod) && (cov_y45wikuj2().b[2][1]++, mod.__esModule) ? (cov_y45wikuj2().b[1][0]++, mod) : (cov_y45wikuj2().b[1][1]++, {
    "default": mod
  });
}));

cov_y45wikuj2().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_y45wikuj2().s[3]++, __importDefault(__webpack_require__(2)));
var const_1 = (cov_y45wikuj2().s[4]++, __webpack_require__(30));
var DropList = (
/** @class */
cov_y45wikuj2().s[5]++, function () {
  cov_y45wikuj2().f[1]++;

  function DropList(menu, conf) {
    cov_y45wikuj2().f[2]++;

    var _this = (cov_y45wikuj2().s[6]++, this);

    cov_y45wikuj2().s[7]++;
    this.hideTimeoutId = 0;
    cov_y45wikuj2().s[8]++;
    this.showTimeoutId = 0;
    cov_y45wikuj2().s[9]++;
    this.menu = menu;
    cov_y45wikuj2().s[10]++;
    this.conf = conf; // 容器

    var $container = (cov_y45wikuj2().s[11]++, dom_core_1["default"]('<div class="w-e-droplist"></div>')); // 标题

    var $title = (cov_y45wikuj2().s[12]++, dom_core_1["default"]("<p>" + conf.title + "</p>"));
    cov_y45wikuj2().s[13]++;
    $title.addClass('w-e-dp-title');
    cov_y45wikuj2().s[14]++;
    $container.append($title); // 列表和类型

    var list = (cov_y45wikuj2().s[15]++, (cov_y45wikuj2().b[3][0]++, conf.list) || (cov_y45wikuj2().b[3][1]++, []));
    var type = (cov_y45wikuj2().s[16]++, (cov_y45wikuj2().b[4][0]++, conf.type) || (cov_y45wikuj2().b[4][1]++, 'list')); // item 的点击事件

    var clickHandler = (cov_y45wikuj2().s[17]++, (cov_y45wikuj2().b[5][0]++, conf.clickHandler) || (cov_y45wikuj2().b[5][1]++, const_1.EMPTY_FN)); // 加入 DOM 并绑定事件

    var $list = (cov_y45wikuj2().s[18]++, dom_core_1["default"]('<ul class="' + (type === 'list' ? (cov_y45wikuj2().b[6][0]++, 'w-e-list') : (cov_y45wikuj2().b[6][1]++, 'w-e-block')) + '"></ul>'));
    cov_y45wikuj2().s[19]++;
    (0, _forEach["default"])(list).call(list, function (item) {
      cov_y45wikuj2().f[3]++;
      var $elem = (cov_y45wikuj2().s[20]++, item.$elem);
      var value = (cov_y45wikuj2().s[21]++, item.value);
      var $li = (cov_y45wikuj2().s[22]++, dom_core_1["default"]('<li class="w-e-item"></li>'));
      cov_y45wikuj2().s[23]++;

      if ($elem) {
        cov_y45wikuj2().b[7][0]++;
        cov_y45wikuj2().s[24]++;
        $li.append($elem);
        cov_y45wikuj2().s[25]++;
        $list.append($li);
        cov_y45wikuj2().s[26]++;
        $li.on('click', function () {
          cov_y45wikuj2().f[4]++;
          cov_y45wikuj2().s[27]++;
          clickHandler(value); // item 点击之后，隐藏 list

          cov_y45wikuj2().s[28]++;
          _this.hideTimeoutId = window.setTimeout(function () {
            cov_y45wikuj2().f[5]++;
            cov_y45wikuj2().s[29]++;

            _this.hide();
          });
        });
      } else {
        cov_y45wikuj2().b[7][1]++;
      }
    });
    cov_y45wikuj2().s[30]++;
    $container.append($list); // 绑定隐藏事件

    cov_y45wikuj2().s[31]++;
    $container.on('mouseleave', function () {
      cov_y45wikuj2().f[6]++;
      cov_y45wikuj2().s[32]++;
      _this.hideTimeoutId = window.setTimeout(function () {
        cov_y45wikuj2().f[7]++;
        cov_y45wikuj2().s[33]++;

        _this.hide();
      });
    }); // 记录属性

    cov_y45wikuj2().s[34]++;
    this.$container = $container;
    cov_y45wikuj2().s[35]++;
    this.rendered = false;
    cov_y45wikuj2().s[36]++;
    this._show = false;
  }
  /**
   * 显示 DropList
   */


  cov_y45wikuj2().s[37]++;

  DropList.prototype.show = function () {
    cov_y45wikuj2().f[8]++;
    cov_y45wikuj2().s[38]++;

    if (this.hideTimeoutId) {
      cov_y45wikuj2().b[8][0]++;
      cov_y45wikuj2().s[39]++;
      // 清除之前的定时隐藏
      clearTimeout(this.hideTimeoutId);
    } else {
      cov_y45wikuj2().b[8][1]++;
    }

    var menu = (cov_y45wikuj2().s[40]++, this.menu);
    var $menuELem = (cov_y45wikuj2().s[41]++, menu.$elem);
    var $container = (cov_y45wikuj2().s[42]++, this.$container);
    cov_y45wikuj2().s[43]++;

    if (this._show) {
      cov_y45wikuj2().b[9][0]++;
      cov_y45wikuj2().s[44]++;
      return;
    } else {
      cov_y45wikuj2().b[9][1]++;
    }

    cov_y45wikuj2().s[45]++;

    if (this.rendered) {
      cov_y45wikuj2().b[10][0]++;
      cov_y45wikuj2().s[46]++;
      // 显示
      $container.show();
    } else {
      cov_y45wikuj2().b[10][1]++;
      // 加入 DOM 之前先定位位置
      var menuHeight = (cov_y45wikuj2().s[47]++, (cov_y45wikuj2().b[11][0]++, $menuELem.getSizeData().height) || (cov_y45wikuj2().b[11][1]++, 0));
      var width = (cov_y45wikuj2().s[48]++, (cov_y45wikuj2().b[12][0]++, this.conf.width) || (cov_y45wikuj2().b[12][1]++, 100)); // 默认为 100

      cov_y45wikuj2().s[49]++;
      $container.css('margin-top', menuHeight + 'px').css('width', width + 'px'); // 加入到 DOM

      cov_y45wikuj2().s[50]++;
      $menuELem.append($container);
      cov_y45wikuj2().s[51]++;
      this.rendered = true;
    } // 修改属性


    cov_y45wikuj2().s[52]++;
    this._show = true;
  };
  /**
   * 隐藏 DropList
   */


  cov_y45wikuj2().s[53]++;

  DropList.prototype.hide = function () {
    cov_y45wikuj2().f[9]++;
    cov_y45wikuj2().s[54]++;

    if (this.showTimeoutId) {
      cov_y45wikuj2().b[13][0]++;
      cov_y45wikuj2().s[55]++;
      // 清除之前的定时显示
      clearTimeout(this.showTimeoutId);
    } else {
      cov_y45wikuj2().b[13][1]++;
    }

    var $container = (cov_y45wikuj2().s[56]++, this.$container);
    cov_y45wikuj2().s[57]++;

    if (!this._show) {
      cov_y45wikuj2().b[14][0]++;
      cov_y45wikuj2().s[58]++;
      return;
    } else {
      cov_y45wikuj2().b[14][1]++;
    } // 隐藏并需改属性


    cov_y45wikuj2().s[59]++;
    $container.hide();
    cov_y45wikuj2().s[60]++;
    this._show = false;
  };

  cov_y45wikuj2().s[61]++;
  (0, _defineProperty["default"])(DropList.prototype, "isShow", {
    get: function get() {
      cov_y45wikuj2().f[10]++;
      cov_y45wikuj2().s[62]++;
      return this._show;
    },
    enumerable: false,
    configurable: true
  });
  cov_y45wikuj2().s[63]++;
  return DropList;
}());
cov_y45wikuj2().s[64]++;
exports["default"] = DropList;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 检查选区是否在链接中，即菜单是否应该 active
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_173ji2x400() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/link/is-active.ts";
  var hash = "8c1ddab4013adf0cb58d762cb807c5f275022bbc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/link/is-active.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 8,
          column: 69
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 11,
          column: 5
        }
      },
      "3": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 21
        }
      },
      "4": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 20
        }
      },
      "6": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 21
        }
      },
      "7": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "isActive",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 17
          }
        },
        loc: {
          start: {
            line: 7,
            column: 26
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/link/is-active.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/link/is-active.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAIH,SAAS,QAAQ,CAAC,MAAc;IAC5B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;IACnE,IAAI,CAAC,cAAc,EAAE;QACjB,OAAO,KAAK,CAAA;KACf;IACD,IAAI,cAAc,CAAC,WAAW,EAAE,KAAK,GAAG,EAAE;QACtC,OAAO,IAAI,CAAA;KACd;SAAM;QACH,OAAO,KAAK,CAAA;KACf;AACL,CAAC;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u68C0\u67E5\u9009\u533A\u662F\u5426\u5728\u94FE\u63A5\u4E2D\uFF0C\u5373\u83DC\u5355\u662F\u5426\u5E94\u8BE5 active\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\n\nfunction isActive(editor: Editor): boolean {\n    const $selectionELem = editor.selection.getSelectionContainerElem()\n    if (!$selectionELem) {\n        return false\n    }\n    if ($selectionELem.getNodeName() === 'A') {\n        return true\n    } else {\n        return false\n    }\n}\n\nexport default isActive\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8c1ddab4013adf0cb58d762cb807c5f275022bbc"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_173ji2x400 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_173ji2x400();
cov_173ji2x400().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

function isActive(editor) {
  cov_173ji2x400().f[0]++;
  var $selectionELem = (cov_173ji2x400().s[1]++, editor.selection.getSelectionContainerElem());
  cov_173ji2x400().s[2]++;

  if (!$selectionELem) {
    cov_173ji2x400().b[0][0]++;
    cov_173ji2x400().s[3]++;
    return false;
  } else {
    cov_173ji2x400().b[0][1]++;
  }

  cov_173ji2x400().s[4]++;

  if ($selectionELem.getNodeName() === 'A') {
    cov_173ji2x400().b[1][0]++;
    cov_173ji2x400().s[5]++;
    return true;
  } else {
    cov_173ji2x400().b[1][1]++;
    cov_173ji2x400().s[6]++;
    return false;
  }
}

cov_173ji2x400().s[7]++;
exports["default"] = isActive;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 检查选区是否在代码中，即菜单是否应该 active
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1rutrhqsnw() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/code/is-active.ts";
  var hash = "67af9426a2a6a57394a98407bfb73c3a6d0597cb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/code/is-active.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 8,
          column: 69
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 11,
          column: 5
        }
      },
      "3": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 21
        }
      },
      "4": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "5": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 20
        }
      },
      "6": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 21
        }
      },
      "7": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "isActive",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 17
          }
        },
        loc: {
          start: {
            line: 7,
            column: 26
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 16,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 46
          }
        }, {
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 13,
            column: 45
          }
        }, {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 14,
            column: 55
          }
        }, {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 15,
            column: 54
          }
        }, {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 58
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0, 0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/code/is-active.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/code/is-active.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAIH,SAAS,QAAQ,CAAC,MAAc;IAC5B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;IACnE,IAAI,CAAC,cAAc,EAAE;QACjB,OAAO,KAAK,CAAA;KACf;IACD,IACI,cAAc,CAAC,WAAW,EAAE,IAAI,MAAM;QACtC,cAAc,CAAC,WAAW,EAAE,IAAI,KAAK;QACrC,cAAc,CAAC,MAAM,EAAE,CAAC,WAAW,EAAE,IAAI,MAAM;QAC/C,cAAc,CAAC,MAAM,EAAE,CAAC,WAAW,EAAE,IAAI,KAAK;QAC9C,MAAM,CAAC,IAAI,CAAC,cAAc,CAAC,MAAM,EAAE,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,EACpD;QACE,OAAO,IAAI,CAAA;KACd;SAAM;QACH,OAAO,KAAK,CAAA;KACf;AACL,CAAC;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u68C0\u67E5\u9009\u533A\u662F\u5426\u5728\u4EE3\u7801\u4E2D\uFF0C\u5373\u83DC\u5355\u662F\u5426\u5E94\u8BE5 active\n * @author lkw\n */\n\nimport Editor from '../../editor/index'\n\nfunction isActive(editor: Editor): boolean {\n    const $selectionELem = editor.selection.getSelectionContainerElem()\n    if (!$selectionELem) {\n        return false\n    }\n    if (\n        $selectionELem.getNodeName() == 'CODE' ||\n        $selectionELem.getNodeName() == 'PRE' ||\n        $selectionELem.parent().getNodeName() == 'CODE' ||\n        $selectionELem.parent().getNodeName() == 'PRE' ||\n        /hljs/.test($selectionELem.parent().attr('class'))\n    ) {\n        return true\n    } else {\n        return false\n    }\n}\n\nexport default isActive\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "67af9426a2a6a57394a98407bfb73c3a6d0597cb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1rutrhqsnw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1rutrhqsnw();
cov_1rutrhqsnw().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

function isActive(editor) {
  cov_1rutrhqsnw().f[0]++;
  var $selectionELem = (cov_1rutrhqsnw().s[1]++, editor.selection.getSelectionContainerElem());
  cov_1rutrhqsnw().s[2]++;

  if (!$selectionELem) {
    cov_1rutrhqsnw().b[0][0]++;
    cov_1rutrhqsnw().s[3]++;
    return false;
  } else {
    cov_1rutrhqsnw().b[0][1]++;
  }

  cov_1rutrhqsnw().s[4]++;

  if ((cov_1rutrhqsnw().b[2][0]++, $selectionELem.getNodeName() == 'CODE') || (cov_1rutrhqsnw().b[2][1]++, $selectionELem.getNodeName() == 'PRE') || (cov_1rutrhqsnw().b[2][2]++, $selectionELem.parent().getNodeName() == 'CODE') || (cov_1rutrhqsnw().b[2][3]++, $selectionELem.parent().getNodeName() == 'PRE') || (cov_1rutrhqsnw().b[2][4]++, /hljs/.test($selectionELem.parent().attr('class')))) {
    cov_1rutrhqsnw().b[1][0]++;
    cov_1rutrhqsnw().s[5]++;
    return true;
  } else {
    cov_1rutrhqsnw().b[1][1]++;
    cov_1rutrhqsnw().s[6]++;
    return false;
  }
}

cov_1rutrhqsnw().s[7]++;
exports["default"] = isActive;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 入口文件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

function cov_1vmcr5xq74() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/wangEditor.ts";
  var hash = "c6080c934366b4d4f0ccff880e86a28be6e206be";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/wangEditor.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "2": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 89
        }
      },
      "4": {
        start: {
          line: 8,
          column: 71
        },
        end: {
          line: 8,
          column: 83
        }
      },
      "5": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 33
        }
      },
      "6": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 33
        }
      },
      "7": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 17
        }
      },
      "8": {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "9": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 126
        }
      },
      "10": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 14,
          column: 126
        }
      },
      "11": {
        start: {
          line: 14,
          column: 95
        },
        end: {
          line: 14,
          column: 126
        }
      },
      "12": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "13": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 62
        }
      },
      "14": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 62
        }
      },
      "15": {
        start: {
          line: 20,
          column: 0
        },
        end: {
          line: 20,
          column: 38
        }
      },
      "16": {
        start: {
          line: 21,
          column: 0
        },
        end: {
          line: 21,
          column: 36
        }
      },
      "17": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 37
        }
      },
      "18": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 36
        }
      },
      "19": {
        start: {
          line: 24,
          column: 0
        },
        end: {
          line: 24,
          column: 37
        }
      },
      "20": {
        start: {
          line: 25,
          column: 0
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "21": {
        start: {
          line: 26,
          column: 0
        },
        end: {
          line: 26,
          column: 28
        }
      },
      "22": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 56
        }
      },
      "23": {
        start: {
          line: 28,
          column: 0
        },
        end: {
          line: 28,
          column: 66
        }
      },
      "24": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "25": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 13
        }
      },
      "26": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "27": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 74
          },
          end: {
            line: 6,
            column: 75
          }
        },
        loc: {
          start: {
            line: 6,
            column: 96
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 58
          },
          end: {
            line: 8,
            column: 59
          }
        },
        loc: {
          start: {
            line: 8,
            column: 69
          },
          end: {
            line: 8,
            column: 85
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        loc: {
          start: {
            line: 9,
            column: 28
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 13,
            column: 50
          },
          end: {
            line: 13,
            column: 51
          }
        },
        loc: {
          start: {
            line: 13,
            column: 71
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 13
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 16,
            column: 56
          },
          end: {
            line: 16,
            column: 57
          }
        },
        loc: {
          start: {
            line: 16,
            column: 71
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 12,
            column: 2
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 12,
            column: 2
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 6,
            column: 74
          },
          end: {
            line: 9,
            column: 1
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 12,
            column: 1
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        }],
        line: 10
      },
      "4": {
        loc: {
          start: {
            line: 13,
            column: 19
          },
          end: {
            line: 15,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 13,
            column: 24
          }
        }, {
          start: {
            line: 13,
            column: 28
          },
          end: {
            line: 13,
            column: 45
          }
        }, {
          start: {
            line: 13,
            column: 50
          },
          end: {
            line: 15,
            column: 1
          }
        }],
        line: 13
      },
      "5": {
        loc: {
          start: {
            line: 14,
            column: 21
          },
          end: {
            line: 14,
            column: 126
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 21
          },
          end: {
            line: 14,
            column: 126
          }
        }, {
          start: {
            line: 14,
            column: 21
          },
          end: {
            line: 14,
            column: 126
          }
        }],
        line: 14
      },
      "6": {
        loc: {
          start: {
            line: 14,
            column: 25
          },
          end: {
            line: 14,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 25
          },
          end: {
            line: 14,
            column: 40
          }
        }, {
          start: {
            line: 14,
            column: 44
          },
          end: {
            line: 14,
            column: 93
          }
        }],
        line: 14
      },
      "7": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 18,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 23
          },
          end: {
            line: 16,
            column: 27
          }
        }, {
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 56
          },
          end: {
            line: 18,
            column: 1
          }
        }],
        line: 16
      },
      "8": {
        loc: {
          start: {
            line: 17,
            column: 11
          },
          end: {
            line: 17,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 37
          },
          end: {
            line: 17,
            column: 40
          }
        }, {
          start: {
            line: 17,
            column: 43
          },
          end: {
            line: 17,
            column: 61
          }
        }],
        line: 17
      },
      "9": {
        loc: {
          start: {
            line: 17,
            column: 12
          },
          end: {
            line: 17,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 12
          },
          end: {
            line: 17,
            column: 15
          }
        }, {
          start: {
            line: 17,
            column: 19
          },
          end: {
            line: 17,
            column: 33
          }
        }],
        line: 17
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/wangEditor.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/wangEditor.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;AAEH,sCAAmC;AACnC,oCAAiC;AACjC,qCAAkC;AAClC,oCAAiC;AACjC,qCAAkC;AAClC,wCAAqC;AAErC,4BAAyB;AACzB,yDAAmC;AAEnC,kEAA+C;AAE/C,YAAY;AACZ,IAAI;IACA,QAAQ,CAAA;CACX;AAAC,OAAO,EAAE,EAAE;IACT,MAAM,IAAI,KAAK,CAAC,YAAY,CAAC,CAAA;CAChC;AAED,kBAAe,eAAM,CAAA",
      sourcesContent: ["/**\n * @description \u5165\u53E3\u6587\u4EF6\n * @author wangfupeng\n */\n\nimport './assets/style/common.less'\nimport './assets/style/icon.less'\nimport './assets/style/menus.less'\nimport './assets/style/text.less'\nimport './assets/style/panel.less'\nimport './assets/style/droplist.less'\n\nimport './utils/polyfill'\nimport Editor from './editor/index'\n\nexport * from './menus/menu-constructors/index'\n\n// \u68C0\u9A8C\u662F\u5426\u6D4F\u89C8\u5668\u73AF\u5883\ntry {\n    document\n} catch (ex) {\n    throw new Error('\u8BF7\u5728\u6D4F\u89C8\u5668\u73AF\u5883\u4E0B\u8FD0\u884C')\n}\n\nexport default Editor\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c6080c934366b4d4f0ccff880e86a28be6e206be"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vmcr5xq74 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1vmcr5xq74();

var __createBinding = (cov_1vmcr5xq74().s[0]++, (cov_1vmcr5xq74().b[0][0]++, void 0) && (cov_1vmcr5xq74().b[0][1]++, (void 0).__createBinding) || (cov_1vmcr5xq74().b[0][2]++, _create["default"] ? (cov_1vmcr5xq74().b[1][0]++, function (o, m, k, k2) {
  cov_1vmcr5xq74().f[0]++;
  cov_1vmcr5xq74().s[1]++;

  if (k2 === undefined) {
    cov_1vmcr5xq74().b[2][0]++;
    cov_1vmcr5xq74().s[2]++;
    k2 = k;
  } else {
    cov_1vmcr5xq74().b[2][1]++;
  }

  cov_1vmcr5xq74().s[3]++;
  (0, _defineProperty["default"])(o, k2, {
    enumerable: true,
    get: function get() {
      cov_1vmcr5xq74().f[1]++;
      cov_1vmcr5xq74().s[4]++;
      return m[k];
    }
  });
}) : (cov_1vmcr5xq74().b[1][1]++, function (o, m, k, k2) {
  cov_1vmcr5xq74().f[2]++;
  cov_1vmcr5xq74().s[5]++;

  if (k2 === undefined) {
    cov_1vmcr5xq74().b[3][0]++;
    cov_1vmcr5xq74().s[6]++;
    k2 = k;
  } else {
    cov_1vmcr5xq74().b[3][1]++;
  }

  cov_1vmcr5xq74().s[7]++;
  o[k2] = m[k];
})));

var __exportStar = (cov_1vmcr5xq74().s[8]++, (cov_1vmcr5xq74().b[4][0]++, void 0) && (cov_1vmcr5xq74().b[4][1]++, (void 0).__exportStar) || (cov_1vmcr5xq74().b[4][2]++, function (m, exports) {
  cov_1vmcr5xq74().f[3]++;
  cov_1vmcr5xq74().s[9]++;

  for (var p in m) {
    cov_1vmcr5xq74().s[10]++;

    if ((cov_1vmcr5xq74().b[6][0]++, p !== "default") && (cov_1vmcr5xq74().b[6][1]++, !Object.prototype.hasOwnProperty.call(exports, p))) {
      cov_1vmcr5xq74().b[5][0]++;
      cov_1vmcr5xq74().s[11]++;

      __createBinding(exports, m, p);
    } else {
      cov_1vmcr5xq74().b[5][1]++;
    }
  }
}));

var __importDefault = (cov_1vmcr5xq74().s[12]++, (cov_1vmcr5xq74().b[7][0]++, void 0) && (cov_1vmcr5xq74().b[7][1]++, (void 0).__importDefault) || (cov_1vmcr5xq74().b[7][2]++, function (mod) {
  cov_1vmcr5xq74().f[4]++;
  cov_1vmcr5xq74().s[13]++;
  return (cov_1vmcr5xq74().b[9][0]++, mod) && (cov_1vmcr5xq74().b[9][1]++, mod.__esModule) ? (cov_1vmcr5xq74().b[8][0]++, mod) : (cov_1vmcr5xq74().b[8][1]++, {
    "default": mod
  });
}));

cov_1vmcr5xq74().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_1vmcr5xq74().s[15]++;

__webpack_require__(137);

cov_1vmcr5xq74().s[16]++;

__webpack_require__(139);

cov_1vmcr5xq74().s[17]++;

__webpack_require__(143);

cov_1vmcr5xq74().s[18]++;

__webpack_require__(145);

cov_1vmcr5xq74().s[19]++;

__webpack_require__(147);

cov_1vmcr5xq74().s[20]++;

__webpack_require__(149);

cov_1vmcr5xq74().s[21]++;

__webpack_require__(151);

var index_1 = (cov_1vmcr5xq74().s[22]++, __importDefault(__webpack_require__(174)));
cov_1vmcr5xq74().s[23]++;

__exportStar(__webpack_require__(405), exports); // 检验是否浏览器环境


cov_1vmcr5xq74().s[24]++;

try {
  cov_1vmcr5xq74().s[25]++;
  document;
} catch (ex) {
  cov_1vmcr5xq74().s[26]++;
  throw new Error('请在浏览器环境下运行');
}

cov_1vmcr5xq74().s[27]++;
exports["default"] = index_1["default"];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(129);

module.exports = parent;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130);
var path = __webpack_require__(10);

var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(14);
var objectDefinePropertyModile = __webpack_require__(17);

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),
/* 131 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(133);

module.exports = parent;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134);
var path = __webpack_require__(10);

var Object = path.Object;

module.exports = function create(P, D) {
  return Object.create(P, D);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var DESCRIPTORS = __webpack_require__(14);
var create = __webpack_require__(47);

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var definePropertyModule = __webpack_require__(17);
var anObject = __webpack_require__(23);
var objectKeys = __webpack_require__(57);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var createNonEnumerableProperty = __webpack_require__(16);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(138);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-toolbar,\n.w-e-text-container,\n.w-e-menu-panel {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  background-color: #fff;\n  /*表情菜单样式*/\n  /*分割线样式*/\n}\n.w-e-toolbar .eleImg,\n.w-e-text-container .eleImg,\n.w-e-menu-panel .eleImg {\n  cursor: pointer;\n  display: inline-block;\n  font-size: 18px;\n  padding: 0 3px;\n}\n.w-e-toolbar *,\n.w-e-text-container *,\n.w-e-menu-panel * {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n.w-e-toolbar hr,\n.w-e-text-container hr,\n.w-e-menu-panel hr {\n  cursor: pointer;\n  display: block;\n  height: 0px;\n  border: 0;\n  border-top: 3px solid #ccc;\n  margin: 20px 0;\n}\n.w-e-clear-fix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.w-e-drop-list-item {\n  position: relative;\n  top: 1px;\n  padding-right: 7px;\n  color: #333 !important;\n}\n.w-e-drop-list-tl {\n  padding-left: 10px;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(140);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__(141);
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__(142);
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, "@font-face {\n  font-family: 'w-e-icon';\n  src: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"w-e-icon-\"],\n[class*=\" w-e-icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'w-e-icon' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.w-e-icon-close:before {\n  content: \"\\f00d\";\n}\n.w-e-icon-upload2:before {\n  content: \"\\e9c6\";\n}\n.w-e-icon-trash-o:before {\n  content: \"\\f014\";\n}\n.w-e-icon-header:before {\n  content: \"\\f1dc\";\n}\n.w-e-icon-pencil2:before {\n  content: \"\\e906\";\n}\n.w-e-icon-paint-brush:before {\n  content: \"\\f1fc\";\n}\n.w-e-icon-image:before {\n  content: \"\\e90d\";\n}\n.w-e-icon-play:before {\n  content: \"\\e912\";\n}\n.w-e-icon-location:before {\n  content: \"\\e947\";\n}\n.w-e-icon-undo:before {\n  content: \"\\e965\";\n}\n.w-e-icon-redo:before {\n  content: \"\\e966\";\n}\n.w-e-icon-quotes-left:before {\n  content: \"\\e977\";\n}\n.w-e-icon-list-numbered:before {\n  content: \"\\e9b9\";\n}\n.w-e-icon-list2:before {\n  content: \"\\e9bb\";\n}\n.w-e-icon-link:before {\n  content: \"\\e9cb\";\n}\n.w-e-icon-happy:before {\n  content: \"\\e9df\";\n}\n.w-e-icon-bold:before {\n  content: \"\\ea62\";\n}\n.w-e-icon-underline:before {\n  content: \"\\ea63\";\n}\n.w-e-icon-italic:before {\n  content: \"\\ea64\";\n}\n.w-e-icon-strikethrough:before {\n  content: \"\\ea65\";\n}\n.w-e-icon-table2:before {\n  content: \"\\ea71\";\n}\n.w-e-icon-paragraph-left:before {\n  content: \"\\ea77\";\n}\n.w-e-icon-paragraph-center:before {\n  content: \"\\ea78\";\n}\n.w-e-icon-paragraph-right:before {\n  content: \"\\ea79\";\n}\n.w-e-icon-paragraph-justify:before {\n  content: \"\\ea7a\";\n}\n.w-e-icon-terminal:before {\n  content: \"\\f120\";\n}\n.w-e-icon-page-break:before {\n  content: \"\\ea68\";\n}\n.w-e-icon-cancel-circle:before {\n  content: \"\\ea0d\";\n}\n.w-e-icon-font:before {\n  content: \"\\ea5c\";\n}\n.w-e-icon-text-heigh:before {\n  content: \"\\ea5f\";\n}\n.w-e-icon-paint-format:before {\n  content: \"\\e90c\";\n}\n.w-e-icon-indent-increase:before {\n  content: \"\\ea7b\";\n}\n.w-e-icon-indent-decrease:before {\n  content: \"\\ea7c\";\n}\n.w-e-icon-row-height:before {\n  content: \"\\e9be\";\n}\n.w-e-icon-fullscreen_exit:before {\n  content: \"\\e900\";\n}\n.w-e-icon-fullscreen:before {\n  content: \"\\e901\";\n}\n.w-e-icon-split-line:before {\n  content: \"\\ea0b\";\n}\n.w-e-icon-checkbox-checked:before {\n  content: \"\\ea52\";\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), "\"");
  }

  return url;
};

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("data:font/woff;base64,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");

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(144);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-toolbar {\n  display: flex;\n  padding: 0 6px;\n  flex-wrap: wrap;\n  position: relative;\n  /* 单个菜单 */\n}\n.w-e-toolbar .w-e-menu {\n  position: relative;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n}\n.w-e-toolbar .w-e-menu i {\n  color: #999;\n}\n.w-e-toolbar .w-e-menu:hover {\n  background-color: #F6F6F6;\n}\n.w-e-toolbar .w-e-menu:hover i {\n  color: #333;\n}\n.w-e-toolbar .w-e-active i {\n  color: #1e88e5;\n}\n.w-e-toolbar .w-e-active:hover i {\n  color: #1e88e5;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(146);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-text-container {\n  position: relative;\n}\n.w-e-text-container .w-e-progress {\n  position: absolute;\n  background-color: #1e88e5;\n  top: 0;\n  left: 0;\n  height: 1px;\n}\n.w-e-text-container .placeholder {\n  color: #D4D4D4;\n  position: absolute;\n  font-size: 11pt;\n  line-height: 22px;\n  left: 10px;\n  top: 10px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  z-index: -1;\n}\n.w-e-text {\n  padding: 0 10px;\n  overflow-y: auto;\n}\n.w-e-text p,\n.w-e-text h1,\n.w-e-text h2,\n.w-e-text h3,\n.w-e-text h4,\n.w-e-text h5,\n.w-e-text table,\n.w-e-text pre {\n  margin: 10px 0;\n  line-height: 1.5;\n}\n.w-e-text ul,\n.w-e-text ol {\n  margin: 10px 0 10px 20px;\n}\n.w-e-text blockquote {\n  display: block;\n  border-left: 8px solid #d0e5f2;\n  padding: 5px 10px;\n  margin: 10px 0;\n  line-height: 1.4;\n  font-size: 100%;\n  background-color: #f1f1f1;\n}\n.w-e-text code {\n  display: inline-block;\n  background-color: #f1f1f1;\n  border-radius: 3px;\n  padding: 3px 5px;\n  margin: 0 3px;\n}\n.w-e-text pre code {\n  display: block;\n}\n.w-e-text table {\n  border-top: 1px solid #ccc;\n  border-left: 1px solid #ccc;\n}\n.w-e-text table td,\n.w-e-text table th {\n  border-bottom: 1px solid #ccc;\n  border-right: 1px solid #ccc;\n  padding: 3px 5px;\n  min-height: 30px;\n}\n.w-e-text table th {\n  border-bottom: 2px solid #ccc;\n  text-align: center;\n  background-color: #f1f1f1;\n}\n.w-e-text:focus {\n  outline: none;\n}\n.w-e-text img {\n  cursor: pointer;\n}\n.w-e-text img:hover {\n  box-shadow: 0 0 5px #333;\n}\n.w-e-tooltip {\n  display: flex;\n  color: #f1f1f1;\n  background-color: rgba(0, 0, 0, 0.75);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 4px 5px 6px;\n  position: absolute;\n}\n.w-e-tooltip-up::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-top-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-tooltip-down::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-bottom-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-tooltip-item-wrapper {\n  cursor: pointer;\n  font-size: 14px;\n  margin: 0 5px;\n}\n.w-e-tooltip-item-wrapper:hover {\n  color: #ccc;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(148);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-menu .w-e-panel-container {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border: 1px solid #ccc;\n  border-top: 0;\n  box-shadow: 1px 1px 2px #ccc;\n  color: #333;\n  background-color: #fff;\n  text-align: left;\n  /* 为 emotion panel 定制的样式 */\n  /* 上传图片的 panel 定制样式 */\n}\n.w-e-menu .w-e-panel-container .w-e-panel-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 5px;\n  margin: 2px 5px 0 0;\n  cursor: pointer;\n  color: #999;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-close:hover {\n  color: #333;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title {\n  list-style: none;\n  display: flex;\n  font-size: 14px;\n  margin: 2px 10px 0 10px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-item {\n  padding: 3px 5px;\n  color: #999;\n  cursor: pointer;\n  margin: 0 3px;\n  position: relative;\n  top: 1px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-active {\n  color: #333;\n  border-bottom: 1px solid #333;\n  cursor: default;\n  font-weight: 700;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content {\n  padding: 10px 15px 10px 15px;\n  font-size: 16px;\n  /* 输入框的样式 */\n  /* 按钮的样式 */\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input:focus,\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus,\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content button:focus {\n  outline: none;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea {\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 5px;\n  margin-top: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus {\n  border-color: #1e88e5;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text] {\n  border: none;\n  border-bottom: 1px solid #ccc;\n  font-size: 14px;\n  height: 20px;\n  color: #333;\n  text-align: left;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].small {\n  width: 30px;\n  text-align: center;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].block {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text]:focus {\n  border-bottom: 2px solid #1e88e5;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button {\n  font-size: 14px;\n  color: #1e88e5;\n  border: none;\n  padding: 5px 10px;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 3px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.left {\n  float: left;\n  margin-right: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {\n  float: right;\n  margin-left: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.gray {\n  color: #999;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.red {\n  color: #c24f4a;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button:hover {\n  background-color: #f1f1f1;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.w-e-menu .w-e-panel-container .w-e-emoticon-container .w-e-item {\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0 3px;\n  display: inline-block;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container {\n  text-align: center;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn {\n  display: inline-block;\n  color: #999;\n  cursor: pointer;\n  font-size: 60px;\n  line-height: 1;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn:hover {\n  color: #333;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(150);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-toolbar .w-e-droplist {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  border: 1px solid #f1f1f1;\n  border-right-color: #ccc;\n  border-bottom-color: #ccc;\n}\n.w-e-toolbar .w-e-droplist .w-e-dp-title {\n  text-align: center;\n  color: #999;\n  line-height: 2;\n  border-bottom: 1px solid #f1f1f1;\n  font-size: 13px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list {\n  list-style: none;\n  line-height: 1;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {\n  color: #333;\n  padding: 5px 0;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item:hover {\n  background-color: #f1f1f1;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block {\n  list-style: none;\n  text-align: left;\n  padding: 5px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item {\n  display: inline-block;\n  padding: 3px 5px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item:hover {\n  background-color: #f1f1f1;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description polyfill 【注意，js 语法的兼容，都通过 babel transform runtime 支持】
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _promise = _interopRequireDefault(__webpack_require__(152));

function cov_18xby68237() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/polyfill.ts";
  var hash = "489e117c209488e3ef6ac3ea81ffedc8a338f98a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/polyfill.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 15,
          column: 6
        }
      },
      "2": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 60
        }
      },
      "3": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 9,
          column: 30
        }
      },
      "4": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 13,
          column: 9
        }
      },
      "5": {
        start: {
          line: 11,
          column: 12
        },
        end: {
          line: 12,
          column: 22
        }
      },
      "6": {
        start: {
          line: 12,
          column: 16
        },
        end: {
          line: 12,
          column: 22
        }
      },
      "7": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 22
        }
      },
      "8": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "9": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 32
          },
          end: {
            line: 7,
            column: 33
          }
        },
        loc: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 0
          },
          end: {
            line: 16,
            column: 1
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 0
          },
          end: {
            line: 16,
            column: 1
          }
        }, {
          start: {
            line: 6,
            column: 0
          },
          end: {
            line: 16,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 12,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 12,
            column: 22
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 12,
            column: 22
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 18,
            column: 0
          },
          end: {
            line: 20,
            column: 1
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 0
          },
          end: {
            line: 20,
            column: 1
          }
        }, {
          start: {
            line: 18,
            column: 0
          },
          end: {
            line: 20,
            column: 1
          }
        }],
        line: 18
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/polyfill.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/polyfill.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;AAEH,IAAI,CAAC,OAAO,CAAC,SAAS,CAAC,OAAO,EAAE;IAC5B,OAAO,CAAC,SAAS,CAAC,OAAO,GAAG,UAAU,CAAC;QACnC,IAAI,OAAO,GAAwB,IAAI,CAAC,aAAa,CAAC,gBAAgB,CAAC,CAAC,CAAC,CAAA;QACzE,IAAI,CAAC,GAAW,OAAO,CAAC,MAAM,CAAA;QAC9B,KAAK,CAAC,EAAE,CAAC,IAAI,CAAC,EAAE,CAAC,EAAE,EAAE;YACjB,IAAI,OAAO,CAAC,IAAI,CAAC,CAAC,CAAC,KAAK,IAAI;gBAAE,MAAK;SACtC;QACD,OAAO,CAAC,GAAG,CAAC,CAAC,CAAA;IACjB,CAAC,CAAA;CACJ;AAED,gDAAgD;AAChD,IAAI,CAAC,MAAM,CAAC,OAAO,EAAE;IACjB,MAAM,CAAC,OAAO,GAAG,OAAO,CAAA;CAC3B",
      sourcesContent: ["/**\n * @description polyfill \u3010\u6CE8\u610F\uFF0Cjs \u8BED\u6CD5\u7684\u517C\u5BB9\uFF0C\u90FD\u901A\u8FC7 babel transform runtime \u652F\u6301\u3011\n * @author wangfupeng\n */\n\nif (!Element.prototype.matches) {\n    Element.prototype.matches = function (s) {\n        let matches: NodeListOf<Element> = this.ownerDocument.querySelectorAll(s)\n        let i: number = matches.length\n        for (i; i >= 0; i--) {\n            if (matches.item(i) === this) break\n        }\n        return i > -1\n    }\n}\n\n// \u6709\u7684\u7B2C\u4E09\u65B9\u5E93\u9700\u8981\u539F\u751F Promise \uFF0C\u800C IE11 \u53C8\u6CA1\u6709\u539F\u751F Promise \uFF0C\u5C31\u62A5\u9519\nif (!window.Promise) {\n    window.Promise = Promise\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "489e117c209488e3ef6ac3ea81ffedc8a338f98a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_18xby68237 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_18xby68237();
cov_18xby68237().s[0]++;

if (!Element.prototype.matches) {
  cov_18xby68237().b[0][0]++;
  cov_18xby68237().s[1]++;

  Element.prototype.matches = function (s) {
    cov_18xby68237().f[0]++;
    var matches = (cov_18xby68237().s[2]++, this.ownerDocument.querySelectorAll(s));
    var i = (cov_18xby68237().s[3]++, matches.length);
    cov_18xby68237().s[4]++;

    for (i; i >= 0; i--) {
      cov_18xby68237().s[5]++;

      if (matches.item(i) === this) {
        cov_18xby68237().b[1][0]++;
        cov_18xby68237().s[6]++;
        break;
      } else {
        cov_18xby68237().b[1][1]++;
      }
    }

    cov_18xby68237().s[7]++;
    return i > -1;
  };
} else {
  cov_18xby68237().b[0][1]++;
} // 有的第三方库需要原生 Promise ，而 IE11 又没有原生 Promise ，就报错


cov_18xby68237().s[8]++;

if (!window.Promise) {
  cov_18xby68237().b[2][0]++;
  cov_18xby68237().s[9]++;
  window.Promise = _promise["default"];
} else {
  cov_18xby68237().b[2][1]++;
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(153);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(154);

module.exports = parent;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
__webpack_require__(62);
__webpack_require__(161);
__webpack_require__(167);
__webpack_require__(168);
__webpack_require__(169);
__webpack_require__(64);
__webpack_require__(50);
var path = __webpack_require__(10);

module.exports = path.Promise;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(74);
var setPrototypeOf = __webpack_require__(75);
var create = __webpack_require__(47);
var createNonEnumerableProperty = __webpack_require__(16);
var createPropertyDescriptor = __webpack_require__(33);
var iterate = __webpack_require__(37);

var $AggregateError = function AggregateError(errors, message) {
  var that = this;
  if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
  if (setPrototypeOf) {
    that = setPrototypeOf(new Error(undefined), getPrototypeOf(that));
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', String(message));
  var errorsArray = [];
  iterate(errors, errorsArray.push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

$AggregateError.prototype = create(Error.prototype, {
  constructor: createPropertyDescriptor(5, $AggregateError),
  message: createPropertyDescriptor(5, ''),
  name: createPropertyDescriptor(5, 'AggregateError')
});

$({ global: true }, {
  AggregateError: $AggregateError
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);
var Iterators = __webpack_require__(38);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(61);
var Iterators = __webpack_require__(38);
var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var IS_PURE = __webpack_require__(35);
var global = __webpack_require__(8);
var getBuiltIn = __webpack_require__(26);
var NativePromise = __webpack_require__(101);
var redefine = __webpack_require__(49);
var redefineAll = __webpack_require__(102);
var setToStringTag = __webpack_require__(39);
var setSpecies = __webpack_require__(103);
var isObject = __webpack_require__(13);
var aFunction = __webpack_require__(29);
var anInstance = __webpack_require__(78);
var inspectSource = __webpack_require__(104);
var iterate = __webpack_require__(37);
var checkCorrectnessOfIteration = __webpack_require__(163);
var speciesConstructor = __webpack_require__(105);
var task = __webpack_require__(106).set;
var microtask = __webpack_require__(164);
var promiseResolve = __webpack_require__(108);
var hostReportErrors = __webpack_require__(165);
var newPromiseCapabilityModule = __webpack_require__(63);
var perform = __webpack_require__(81);
var InternalStateModule = __webpack_require__(40);
var isForced = __webpack_require__(97);
var wellKnownSymbol = __webpack_require__(9);
var IS_NODE = __webpack_require__(80);
var V8_VERSION = __webpack_require__(82);

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && !NATIVE_REJECTION_EVENT) return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(77);
var classof = __webpack_require__(61);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var getOwnPropertyDescriptor = __webpack_require__(66).f;
var macrotask = __webpack_require__(106).set;
var IS_IOS = __webpack_require__(107);
var IS_NODE = __webpack_require__(80);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  if (!IS_IOS && !IS_NODE && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inspectSource = __webpack_require__(104);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var aFunction = __webpack_require__(29);
var newPromiseCapabilityModule = __webpack_require__(63);
var perform = __webpack_require__(81);
var iterate = __webpack_require__(37);

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
$({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var aFunction = __webpack_require__(29);
var getBuiltIn = __webpack_require__(26);
var newPromiseCapabilityModule = __webpack_require__(63);
var perform = __webpack_require__(81);
var iterate = __webpack_require__(37);

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://github.com/tc39/proposal-promise-any
$({ target: 'Promise', stat: true }, {
  any: function any(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        errors.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var IS_PURE = __webpack_require__(35);
var NativePromise = __webpack_require__(101);
var fails = __webpack_require__(12);
var getBuiltIn = __webpack_require__(26);
var speciesConstructor = __webpack_require__(105);
var promiseResolve = __webpack_require__(108);
var redefine = __webpack_require__(49);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (!IS_PURE && typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var requireObjectCoercible = __webpack_require__(45);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(109).IteratorPrototype;
var create = __webpack_require__(47);
var createPropertyDescriptor = __webpack_require__(33);
var setToStringTag = __webpack_require__(39);
var Iterators = __webpack_require__(38);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(25);
var addToUnscopables = __webpack_require__(84);
var Iterators = __webpack_require__(38);
var InternalStateModule = __webpack_require__(40);
var defineIterator = __webpack_require__(83);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 编辑器 class
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

function cov_2443yu0eci() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/index.ts";
  var hash = "09adf260eefffb7aa1329ce4a93a1b57a9faec72";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "2": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 7,
          column: 33
        }
      },
      "3": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 89
        }
      },
      "4": {
        start: {
          line: 8,
          column: 71
        },
        end: {
          line: 8,
          column: 83
        }
      },
      "5": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 33
        }
      },
      "6": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 33
        }
      },
      "7": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 17
        }
      },
      "8": {
        start: {
          line: 13,
          column: 25
        },
        end: {
          line: 17,
          column: 2
        }
      },
      "9": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 72
        }
      },
      "10": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 21
        }
      },
      "11": {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "12": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 42
        }
      },
      "13": {
        start: {
          line: 19,
          column: 31
        },
        end: {
          line: 19,
          column: 42
        }
      },
      "14": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 20,
          column: 19
        }
      },
      "15": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 141
        }
      },
      "16": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 141
        }
      },
      "17": {
        start: {
          line: 21,
          column: 40
        },
        end: {
          line: 21,
          column: 141
        }
      },
      "18": {
        start: {
          line: 21,
          column: 109
        },
        end: {
          line: 21,
          column: 141
        }
      },
      "19": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 36
        }
      },
      "20": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 18
        }
      },
      "21": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "22": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 62
        }
      },
      "23": {
        start: {
          line: 28,
          column: 0
        },
        end: {
          line: 28,
          column: 62
        }
      },
      "24": {
        start: {
          line: 29,
          column: 17
        },
        end: {
          line: 29,
          column: 62
        }
      },
      "25": {
        start: {
          line: 30,
          column: 13
        },
        end: {
          line: 30,
          column: 37
        }
      },
      "26": {
        start: {
          line: 31,
          column: 15
        },
        end: {
          line: 31,
          column: 52
        }
      },
      "27": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 32,
          column: 57
        }
      },
      "28": {
        start: {
          line: 33,
          column: 16
        },
        end: {
          line: 33,
          column: 53
        }
      },
      "29": {
        start: {
          line: 34,
          column: 14
        },
        end: {
          line: 34,
          column: 55
        }
      },
      "30": {
        start: {
          line: 35,
          column: 14
        },
        end: {
          line: 35,
          column: 56
        }
      },
      "31": {
        start: {
          line: 36,
          column: 17
        },
        end: {
          line: 36,
          column: 64
        }
      },
      "32": {
        start: {
          line: 37,
          column: 23
        },
        end: {
          line: 37,
          column: 76
        }
      },
      "33": {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 68
        }
      },
      "34": {
        start: {
          line: 39,
          column: 21
        },
        end: {
          line: 39,
          column: 72
        }
      },
      "35": {
        start: {
          line: 40,
          column: 24
        },
        end: {
          line: 40,
          column: 75
        }
      },
      "36": {
        start: {
          line: 41,
          column: 23
        },
        end: {
          line: 41,
          column: 76
        }
      },
      "37": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 53
        }
      },
      "38": {
        start: {
          line: 43,
          column: 14
        },
        end: {
          line: 43,
          column: 56
        }
      },
      "39": {
        start: {
          line: 44,
          column: 14
        },
        end: {
          line: 44,
          column: 57
        }
      },
      "40": {
        start: {
          line: 45,
          column: 16
        },
        end: {
          line: 45,
          column: 53
        }
      },
      "41": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 47,
          column: 78
        }
      },
      "42": {
        start: {
          line: 48,
          column: 17
        },
        end: {
          line: 48,
          column: 80
        }
      },
      "43": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 88
        }
      },
      "44": {
        start: {
          line: 50,
          column: 14
        },
        end: {
          line: 50,
          column: 74
        }
      },
      "45": {
        start: {
          line: 51,
          column: 18
        },
        end: {
          line: 51,
          column: 82
        }
      },
      "46": {
        start: {
          line: 52,
          column: 16
        },
        end: {
          line: 52,
          column: 78
        }
      },
      "47": {
        start: {
          line: 53,
          column: 16
        },
        end: {
          line: 53,
          column: 17
        }
      },
      "48": {
        start: {
          line: 54,
          column: 28
        },
        end: {
          line: 176,
          column: 3
        }
      },
      "49": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 37
        }
      },
      "50": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 46
        }
      },
      "51": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 47
        }
      },
      "52": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 41
        }
      },
      "53": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "54": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 56
        }
      },
      "55": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 57
        }
      },
      "56": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 62
        }
      },
      "57": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 68
        }
      },
      "58": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 59
        }
      },
      "59": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 32
        }
      },
      "60": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 29
        }
      },
      "61": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 29
        }
      },
      "62": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 33
        }
      },
      "63": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 38
        }
      },
      "64": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 55
        }
      },
      "65": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 47
        }
      },
      "66": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 45
        }
      },
      "67": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 47
        }
      },
      "68": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 46
        }
      },
      "69": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "70": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 49
        }
      },
      "71": {
        start: {
          line: 88,
          column: 17
        },
        end: {
          line: 88,
          column: 40
        }
      },
      "72": {
        start: {
          line: 88,
          column: 52
        },
        end: {
          line: 88,
          column: 62
        }
      },
      "73": {
        start: {
          line: 88,
          column: 73
        },
        end: {
          line: 88,
          column: 82
        }
      },
      "74": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 31
        }
      },
      "75": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 29
        }
      },
      "76": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 98,
          column: 6
        }
      },
      "77": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 48
        }
      },
      "78": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 128,
          column: 6
        }
      },
      "79": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 31
        }
      },
      "80": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 61
        }
      },
      "81": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 110,
          column: 9
        }
      },
      "82": {
        start: {
          line: 109,
          column: 12
        },
        end: {
          line: 109,
          column: 45
        }
      },
      "83": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 37
        }
      },
      "84": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 33
        }
      },
      "85": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 24
        }
      },
      "86": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 26
        }
      },
      "87": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 120,
          column: 40
        }
      },
      "88": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 33
        }
      },
      "89": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 35
        }
      },
      "90": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 30
        }
      },
      "91": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 31
        }
      },
      "92": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 136,
          column: 6
        }
      },
      "93": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 41
        }
      },
      "94": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 20
        }
      },
      "95": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 147,
          column: 6
        }
      },
      "96": {
        start: {
          line: 141,
          column: 20
        },
        end: {
          line: 141,
          column: 24
        }
      },
      "97": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 82
        }
      },
      "98": {
        start: {
          line: 143,
          column: 56
        },
        end: {
          line: 143,
          column: 78
        }
      },
      "99": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 145,
          column: 35
        }
      },
      "100": {
        start: {
          line: 146,
          column: 8
        },
        end: {
          line: 146,
          column: 41
        }
      },
      "101": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 153,
          column: 6
        }
      },
      "102": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 152,
          column: 46
        }
      },
      "103": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 159,
          column: 6
        }
      },
      "104": {
        start: {
          line: 158,
          column: 8
        },
        end: {
          line: 158,
          column: 48
        }
      },
      "105": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 166,
          column: 6
        }
      },
      "106": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 43
        }
      },
      "107": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 34
        }
      },
      "108": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 169,
          column: 39
        }
      },
      "109": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 41
        }
      },
      "110": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 49
        }
      },
      "111": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 35
        }
      },
      "112": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 43
        }
      },
      "113": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 174,
          column: 39
        }
      },
      "114": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 18
        }
      },
      "115": {
        start: {
          line: 177,
          column: 0
        },
        end: {
          line: 177,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 74
          },
          end: {
            line: 6,
            column: 75
          }
        },
        loc: {
          start: {
            line: 6,
            column: 96
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 58
          },
          end: {
            line: 8,
            column: 59
          }
        },
        loc: {
          start: {
            line: 8,
            column: 69
          },
          end: {
            line: 8,
            column: 85
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        loc: {
          start: {
            line: 9,
            column: 28
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 13,
            column: 80
          },
          end: {
            line: 13,
            column: 81
          }
        },
        loc: {
          start: {
            line: 13,
            column: 95
          },
          end: {
            line: 15,
            column: 1
          }
        },
        line: 13
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 15,
            column: 5
          },
          end: {
            line: 15,
            column: 6
          }
        },
        loc: {
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 15
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 18,
            column: 50
          },
          end: {
            line: 18,
            column: 51
          }
        },
        loc: {
          start: {
            line: 18,
            column: 65
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 18
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 25,
            column: 57
          }
        },
        loc: {
          start: {
            line: 25,
            column: 71
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 25
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 54,
            column: 28
          },
          end: {
            line: 54,
            column: 29
          }
        },
        loc: {
          start: {
            line: 54,
            column: 40
          },
          end: {
            line: 176,
            column: 1
          }
        },
        line: 54
      },
      "8": {
        name: "Editor",
        decl: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 19
          }
        },
        loc: {
          start: {
            line: 60,
            column: 51
          },
          end: {
            line: 91,
            column: 5
          }
        },
        line: 60
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 96,
            column: 37
          },
          end: {
            line: 96,
            column: 38
          }
        },
        loc: {
          start: {
            line: 96,
            column: 56
          },
          end: {
            line: 98,
            column: 5
          }
        },
        line: 96
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 102,
            column: 30
          },
          end: {
            line: 102,
            column: 31
          }
        },
        loc: {
          start: {
            line: 102,
            column: 42
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 102
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 133,
            column: 37
          },
          end: {
            line: 133,
            column: 38
          }
        },
        loc: {
          start: {
            line: 133,
            column: 51
          },
          end: {
            line: 136,
            column: 5
          }
        },
        line: 133
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 140,
            column: 31
          },
          end: {
            line: 140,
            column: 32
          }
        },
        loc: {
          start: {
            line: 140,
            column: 43
          },
          end: {
            line: 147,
            column: 5
          }
        },
        line: 140
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 143,
            column: 40
          },
          end: {
            line: 143,
            column: 41
          }
        },
        loc: {
          start: {
            line: 143,
            column: 54
          },
          end: {
            line: 143,
            column: 80
          }
        },
        line: 143
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 151,
            column: 34
          },
          end: {
            line: 151,
            column: 35
          }
        },
        loc: {
          start: {
            line: 151,
            column: 46
          },
          end: {
            line: 153,
            column: 5
          }
        },
        line: 151
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 157,
            column: 36
          },
          end: {
            line: 157,
            column: 37
          }
        },
        loc: {
          start: {
            line: 157,
            column: 48
          },
          end: {
            line: 159,
            column: 5
          }
        },
        line: 157
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 164,
            column: 36
          },
          end: {
            line: 164,
            column: 37
          }
        },
        loc: {
          start: {
            line: 164,
            column: 50
          },
          end: {
            line: 166,
            column: 5
          }
        },
        line: 164
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 12,
            column: 2
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 12,
            column: 2
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 6,
            column: 74
          },
          end: {
            line: 9,
            column: 1
          }
        }, {
          start: {
            line: 9,
            column: 6
          },
          end: {
            line: 12,
            column: 1
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 33
          }
        }],
        line: 10
      },
      "4": {
        loc: {
          start: {
            line: 13,
            column: 25
          },
          end: {
            line: 17,
            column: 2
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 30
          }
        }, {
          start: {
            line: 13,
            column: 34
          },
          end: {
            line: 13,
            column: 57
          }
        }, {
          start: {
            line: 13,
            column: 63
          },
          end: {
            line: 17,
            column: 1
          }
        }],
        line: 13
      },
      "5": {
        loc: {
          start: {
            line: 13,
            column: 63
          },
          end: {
            line: 17,
            column: 1
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 13,
            column: 80
          },
          end: {
            line: 15,
            column: 1
          }
        }, {
          start: {
            line: 15,
            column: 5
          },
          end: {
            line: 17,
            column: 1
          }
        }],
        line: 13
      },
      "6": {
        loc: {
          start: {
            line: 18,
            column: 19
          },
          end: {
            line: 24,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 24
          }
        }, {
          start: {
            line: 18,
            column: 28
          },
          end: {
            line: 18,
            column: 45
          }
        }, {
          start: {
            line: 18,
            column: 50
          },
          end: {
            line: 24,
            column: 1
          }
        }],
        line: 18
      },
      "7": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 42
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 42
          }
        }],
        line: 19
      },
      "8": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 11
          }
        }, {
          start: {
            line: 19,
            column: 15
          },
          end: {
            line: 19,
            column: 29
          }
        }],
        line: 19
      },
      "9": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 141
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 141
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 141
          }
        }],
        line: 21
      },
      "10": {
        loc: {
          start: {
            line: 21,
            column: 40
          },
          end: {
            line: 21,
            column: 141
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 40
          },
          end: {
            line: 21,
            column: 141
          }
        }, {
          start: {
            line: 21,
            column: 40
          },
          end: {
            line: 21,
            column: 141
          }
        }],
        line: 21
      },
      "11": {
        loc: {
          start: {
            line: 21,
            column: 44
          },
          end: {
            line: 21,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 44
          },
          end: {
            line: 21,
            column: 59
          }
        }, {
          start: {
            line: 21,
            column: 63
          },
          end: {
            line: 21,
            column: 107
          }
        }],
        line: 21
      },
      "12": {
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 27,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 27
          }
        }, {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 51
          }
        }, {
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 27,
            column: 1
          }
        }],
        line: 25
      },
      "13": {
        loc: {
          start: {
            line: 26,
            column: 11
          },
          end: {
            line: 26,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 37
          },
          end: {
            line: 26,
            column: 40
          }
        }, {
          start: {
            line: 26,
            column: 43
          },
          end: {
            line: 26,
            column: 61
          }
        }],
        line: 26
      },
      "14": {
        loc: {
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 15
          }
        }, {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 33
          }
        }],
        line: 26
      },
      "15": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 67
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        }, {
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 110,
            column: 9
          }
        }],
        line: 108
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;;;;;;;AAEH,+DAAqE;AACrE,sCAAyC;AACzC,qDAAqD;AACrD,0DAA8C;AAC9C,sDAAkC;AAClC,wDAAgC;AAChC,yDAAkC;AAClC,iEAAyC;AACzC,6EAAqD;AACrD,qEAA6C;AAC7C,yEAAiD;AACjD,4EAA2F;AAC3F,6EAAoD;AACpD,sDAA8B;AAC9B,yDAAmC;AACnC,0DAAqC;AACrC,sDAAmC;AAEnC,cAAc;AACd,+EAAwD;AACxD,iFAA0D;AAC1D,yFAAkE;AAClE,2EAAoD;AACpD,mFAA4D;AAC5D,+EAAwD;AAExD,IAAI,SAAS,GAAG,CAAC,CAAA;AAEjB;IA0CI;;;;OAIG;IACH,gBAAY,eAAmC,EAAE,YAAiC;QAdlF,iBAAiB;QACT,uBAAkB,GAAe,EAAE,CAAA;QAcvC,sBAAsB;QACtB,IAAI,CAAC,EAAE,GAAG,gBAAc,SAAS,EAAI,CAAA;QAErC,IAAI,CAAC,eAAe,GAAG,eAAe,CAAA;QACtC,IAAI,CAAC,YAAY,GAAG,YAAY,CAAA;QAEhC,IAAI,eAAe,IAAI,IAAI,EAAE;YACzB,MAAM,IAAI,KAAK,CAAC,0BAA0B,CAAC,CAAA;SAC9C;QAED,kBAAkB;QAClB,8EAA8E;QAC9E,IAAI,CAAC,MAAM,GAAG,gBAAS,CAAC,gBAAa,CAAC,CAAA;QACtC,IAAI,CAAC,YAAY,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QACpC,IAAI,CAAC,kBAAkB,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QAC1C,IAAI,CAAC,SAAS,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QACjC,IAAI,CAAC,aAAa,GAAG,EAAE,CAAA;QACvB,IAAI,CAAC,UAAU,GAAG,EAAE,CAAA;QACpB,IAAI,CAAC,OAAO,GAAG,KAAK,CAAA;QACpB,IAAI,CAAC,WAAW,GAAG,KAAK,CAAA;QACxB,IAAI,CAAC,gBAAgB,GAAG,KAAK,CAAA;QAE7B,IAAI,CAAC,SAAS,GAAG,IAAI,mBAAoB,CAAC,IAAI,CAAC,CAAA;QAC/C,IAAI,CAAC,GAAG,GAAG,IAAI,iBAAU,CAAC,IAAI,CAAC,CAAA;QAC/B,IAAI,CAAC,GAAG,GAAG,IAAI,eAAI,CAAC,IAAI,CAAC,CAAA;QACzB,IAAI,CAAC,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,CAAC,CAAA;QAC5B,IAAI,CAAC,MAAM,GAAG,IAAI,iBAAM,EAAE,CAAA;QAC1B,IAAI,CAAC,MAAM,GAAG,IAAI,eAAM,CAAC,IAAI,CAAC,CAAA;QAC9B,IAAI,CAAC,OAAO,GAAG,IAAI,eAAO,CAAC,IAAI,CAAC,CAAA;QAE1B,IAAA,KAAsB,iBAAW,CAAC,IAAI,CAAC,EAArC,OAAO,aAAA,EAAE,MAAM,YAAsB,CAAA;QAC7C,IAAI,CAAC,OAAO,GAAG,OAAO,CAAA;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;;OAGG;IACI,8BAAa,GAApB,UAAqB,OAAiB;QAClC,wBAAa,CAAC,IAAI,EAAE,OAAO,CAAC,CAAA;IAChC,CAAC;IAED;;OAEG;IACI,uBAAM,GAAb;QACI,aAAa;QACb,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QAEtB,cAAc;QACd,IAAI,CAAC,gBAAgB,GAAG,IAAI,CAAC,MAAM,CAAC,cAAc,EAAE,CAAA;QAEpD,eAAe;QACf,IAAI,CAAC,IAAI,CAAC,gBAAgB,EAAE;YACxB,IAAI,CAAC,MAAM,CAAC,eAAe,GAAG,EAAE,CAAA;SACnC;QAED,4BAA4B;QAC5B,sBAAW,CAAC,IAAI,CAAC,CAAA;QAEjB,UAAU;QACV,kBAAO,CAAC,IAAI,CAAC,CAAA;QAEb,WAAW;QACX,IAAI,CAAC,GAAG,CAAC,IAAI,EAAE,CAAA;QAEf,QAAQ;QACR,IAAI,CAAC,KAAK,CAAC,IAAI,EAAE,CAAA;QAEjB,UAAU;QACV,yBAAc,CAAC,IAAI,CAAC,CAAA;QAEpB,mBAAmB;QACnB,IAAI,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;QAExB,OAAO;QACP,oBAAS,CAAC,IAAI,CAAC,CAAA;QAEf,YAAY;QACZ,IAAI,CAAC,MAAM,CAAC,OAAO,EAAE,CAAA;QAErB,IAAI,CAAC,OAAO,CAAC,OAAO,EAAE,CAAA;IAC1B,CAAC;IAED;;;OAGG;IACI,8BAAa,GAApB,UAAqB,EAAY;QAC7B,IAAI,CAAC,kBAAkB,CAAC,IAAI,CAAC,EAAE,CAAC,CAAA;QAChC,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,wBAAO,GAAd;QAAA,iBAOC;QANG,SAAS;QACT,IAAI,CAAC,kBAAkB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,IAAI,CAAC,KAAI,CAAC,EAAb,CAAa,CAAC,CAAA;QAEpD,YAAY;QACZ,IAAI,CAAC,YAAY,CAAC,MAAM,EAAE,CAAA;QAC1B,IAAI,CAAC,kBAAkB,CAAC,MAAM,EAAE,CAAA;IACpC,CAAC;IAED;;OAEG;IACI,2BAAU,GAAjB;QACI,+BAAa,CAAC,IAAI,CAAC,CAAA;IACvB,CAAC;IAED;;OAEG;IACI,6BAAY,GAAnB;QACI,iCAAe,CAAC,IAAI,CAAC,CAAA;IACzB,CAAC;IAED;;;OAGG;IACI,6BAAY,GAAnB,UAAoB,EAAU;QAC1B,wBAAY,CAAC,IAAI,EAAE,EAAE,CAAC,CAAA;IAC1B,CAAC;IA7KD,OAAO;IACA,QAAC,GAAG,kBAAC,CAAA;IAEL,cAAO,GAAG,iBAAO,CAAA;IACjB,eAAQ,GAAG,kBAAQ,CAAA;IACnB,mBAAY,GAAG,sBAAY,CAAA;IAC3B,YAAK,GAAG,eAAK,CAAA;IACb,gBAAS,GAAG,mBAAS,CAAA;IACrB,cAAO,GAAG,iBAAO,CAAA;IAsK5B,aAAC;CAAA,AA/KD,IA+KC;AAED,kBAAe,MAAM,CAAA",
      sourcesContent: ["/**\n * @description \u7F16\u8F91\u5668 class\n * @author wangfupeng\n */\n\nimport $, { DomElement, DomElementSelector } from '../utils/dom-core'\nimport { deepClone } from '../utils/util'\nimport defaultConfig, { ConfigType } from '../config'\nimport SelectionAndRangeAPI from './selection'\nimport CommandAPI from './command'\nimport Text from '../text/index'\nimport Menus from '../menus/index'\nimport initDom from './init-fns/init-dom'\nimport initSelection from './init-fns/init-selection'\nimport bindEvent from './init-fns/bind-event'\nimport i18nextInit from './init-fns/i18next-init'\nimport initFullScreen, { setUnFullScreen, setFullScreen } from './init-fns/set-full-screen'\nimport scrollToHead from './init-fns/scroll-to-head'\nimport ZIndex from './z-index'\nimport Change from './change/index'\nimport History from './history/index'\nimport disableInit from './disable'\n\n// \u521B\u5EFA\u83DC\u5355\u7684 class\nimport BtnMenu from '../menus/menu-constructors/BtnMenu'\nimport DropList from '../menus/menu-constructors/DropList'\nimport DropListMenu from '../menus/menu-constructors/DropListMenu'\nimport Panel from '../menus/menu-constructors/Panel'\nimport PanelMenu from '../menus/menu-constructors/PanelMenu'\nimport Tooltip from '../menus/menu-constructors/Tooltip'\n\nlet EDITOR_ID = 1\n\nclass Editor {\n    // \u66B4\u9732 $\n    static $ = $\n\n    static BtnMenu = BtnMenu\n    static DropList = DropList\n    static DropListMenu = DropListMenu\n    static Panel = Panel\n    static PanelMenu = PanelMenu\n    static Tooltip = Tooltip\n\n    public id: string\n    public toolbarSelector: DomElementSelector\n    public textSelector?: DomElementSelector\n    public config: ConfigType\n    public $toolbarElem: DomElement\n    public $textContainerElem: DomElement\n    public $textElem: DomElement\n    public toolbarElemId: string\n    public textElemId: string\n    public isFocus: boolean\n    public isComposing: boolean\n    public isCompatibleMode: boolean\n    public selection: SelectionAndRangeAPI\n    public cmd: CommandAPI\n    public txt: Text\n    public menus: Menus\n    public i18next: any\n    public highlight: any\n    public zIndex: ZIndex\n    public change: Change\n    public history: History\n\n    // \u5B9E\u4F8B\u9500\u6BC1\u524D\u9700\u8981\u6267\u884C\u7684\u94A9\u5B50\u96C6\u5408\n    private beforeDestroyHooks: Function[] = []\n\n    /** \u7981\u7528api */\n    public disable: Function\n\n    /** \u542F\u7528api */\n    public enable: Function\n\n    /**\n     * \u6784\u9020\u51FD\u6570\n     * @param toolbarSelector \u5DE5\u5177\u680F DOM selector\n     * @param textSelector \u6587\u672C\u533A\u57DF DOM selector\n     */\n    constructor(toolbarSelector: DomElementSelector, textSelector?: DomElementSelector) {\n        // id\uFF0C\u7528\u4EE5\u533A\u5206\u5355\u4E2A\u9875\u9762\u4E0D\u540C\u7684\u7F16\u8F91\u5668\u5BF9\u8C61\n        this.id = `wangEditor-${EDITOR_ID++}`\n\n        this.toolbarSelector = toolbarSelector\n        this.textSelector = textSelector\n\n        if (toolbarSelector == null) {\n            throw new Error('\u9519\u8BEF\uFF1A\u521D\u59CB\u5316\u7F16\u8F91\u5668\u65F6\u5019\u672A\u4F20\u5165\u4EFB\u4F55\u53C2\u6570\uFF0C\u8BF7\u67E5\u9605\u6587\u6863')\n        }\n\n        // \u5C5E\u6027\u7684\u9ED8\u8BA4\u503C\uFF0C\u540E\u9762\u53EF\u80FD\u4F1A\u518D\u4FEE\u6539\n        // \u9ED8\u8BA4\u914D\u7F6E - \u5F53\u4E00\u4E2A\u9875\u9762\u6709\u591A\u4E2A\u7F16\u8F91\u5668\u7684\u65F6\u5019\uFF0C\u56E0\u4E3A JS \u7684\u7279\u6027(\u5F15\u7528\u7C7B\u578B)\u4F1A\u5BFC\u81F4\u591A\u4E2A\u7F16\u8F91\u5668\u7684 config \u5F15\u7528\u662F\u540C\u4E00\u4E2A\uFF0C\u6240\u4EE5\u9700\u8981 \u6DF1\u5EA6\u514B\u9686 \u65AD\u6389\u5F15\u7528\n        this.config = deepClone(defaultConfig)\n        this.$toolbarElem = $('<div></div>')\n        this.$textContainerElem = $('<div></div>')\n        this.$textElem = $('<div></div>')\n        this.toolbarElemId = ''\n        this.textElemId = ''\n        this.isFocus = false\n        this.isComposing = false\n        this.isCompatibleMode = false\n\n        this.selection = new SelectionAndRangeAPI(this)\n        this.cmd = new CommandAPI(this)\n        this.txt = new Text(this)\n        this.menus = new Menus(this)\n        this.zIndex = new ZIndex()\n        this.change = new Change(this)\n        this.history = new History(this)\n\n        const { disable, enable } = disableInit(this)\n        this.disable = disable\n        this.enable = enable\n    }\n\n    /**\n     * \u521D\u59CB\u5316\u9009\u533A\n     * @param newLine \u65B0\u5EFA\u4E00\u884C\n     */\n    public initSelection(newLine?: boolean): void {\n        initSelection(this, newLine)\n    }\n\n    /**\n     * \u521B\u5EFA\u7F16\u8F91\u5668\u5B9E\u4F8B\n     */\n    public create(): void {\n        // \u521D\u59CB\u5316 ZIndex\n        this.zIndex.init(this)\n\n        // \u786E\u5B9A\u5F53\u524D\u7684\u5386\u53F2\u8BB0\u5F55\u6A21\u5F0F\n        this.isCompatibleMode = this.config.compatibleMode()\n\n        // \u6807\u51C6\u6A21\u5F0F\u4E0B\uFF0C\u91CD\u7F6E\u5EF6\u8FDF\u65F6\u95F4\n        if (!this.isCompatibleMode) {\n            this.config.onchangeTimeout = 30\n        }\n\n        // \u56FD\u9645\u5316 \u56E0\u4E3A\u8981\u5728\u521B\u5EFA\u83DC\u5355\u524D\u4F7F\u7528 \u6240\u4EE5\u8981\u6700\u5148 \u521D\u59CB\u5316\n        i18nextInit(this)\n\n        // \u521D\u59CB\u5316 DOM\n        initDom(this)\n\n        // \u521D\u59CB\u5316 text\n        this.txt.init()\n\n        // \u521D\u59CB\u5316\u83DC\u5355\n        this.menus.init()\n\n        // \u521D\u59CB\u5316\u5168\u5C4F\u529F\u80FD\n        initFullScreen(this)\n\n        // \u521D\u59CB\u5316\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u5185\u5BB9\u5C3E\u90E8\n        this.initSelection(true)\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\n        bindEvent(this)\n\n        // \u7ED1\u5B9A\u76D1\u542C\u7684\u76EE\u6807\u8282\u70B9\n        this.change.observe()\n\n        this.history.observe()\n    }\n\n    /**\n     * \u63D0\u4F9B\u7ED9\u7528\u6237\u6DFB\u52A0\u9500\u6BC1\u524D\u7684\u94A9\u5B50\u51FD\u6570\n     * @param fn \u94A9\u5B50\u51FD\u6570\n     */\n    public beforeDestroy(fn: Function): Editor {\n        this.beforeDestroyHooks.push(fn)\n        return this\n    }\n\n    /**\n     * \u9500\u6BC1\u5F53\u524D\u7F16\u8F91\u5668\u5B9E\u4F8B\n     */\n    public destroy(): void {\n        // \u8C03\u7528\u94A9\u5B50\u51FD\u6570\n        this.beforeDestroyHooks.forEach(fn => fn.call(this))\n\n        // \u9500\u6BC1 DOM \u8282\u70B9\n        this.$toolbarElem.remove()\n        this.$textContainerElem.remove()\n    }\n\n    /**\n     * \u5C06\u7F16\u8F91\u5668\u8BBE\u7F6E\u4E3A\u5168\u5C4F\n     */\n    public fullScreen(): void {\n        setFullScreen(this)\n    }\n\n    /**\n     * \u5C06\u7F16\u8F91\u5668\u9000\u51FA\u5168\u5C4F\n     */\n    public unFullScreen(): void {\n        setUnFullScreen(this)\n    }\n\n    /**\n     * \u6EDA\u52A8\u5230\u6307\u5B9A\u6807\u9898\u951A\u70B9\n     * @param id \u6807\u9898\u951A\u70B9id\n     */\n    public scrollToHead(id: string): void {\n        scrollToHead(this, id)\n    }\n}\n\nexport default Editor\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "09adf260eefffb7aa1329ce4a93a1b57a9faec72"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2443yu0eci = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2443yu0eci();

var __createBinding = (cov_2443yu0eci().s[0]++, (cov_2443yu0eci().b[0][0]++, void 0) && (cov_2443yu0eci().b[0][1]++, (void 0).__createBinding) || (cov_2443yu0eci().b[0][2]++, _create["default"] ? (cov_2443yu0eci().b[1][0]++, function (o, m, k, k2) {
  cov_2443yu0eci().f[0]++;
  cov_2443yu0eci().s[1]++;

  if (k2 === undefined) {
    cov_2443yu0eci().b[2][0]++;
    cov_2443yu0eci().s[2]++;
    k2 = k;
  } else {
    cov_2443yu0eci().b[2][1]++;
  }

  cov_2443yu0eci().s[3]++;
  (0, _defineProperty["default"])(o, k2, {
    enumerable: true,
    get: function get() {
      cov_2443yu0eci().f[1]++;
      cov_2443yu0eci().s[4]++;
      return m[k];
    }
  });
}) : (cov_2443yu0eci().b[1][1]++, function (o, m, k, k2) {
  cov_2443yu0eci().f[2]++;
  cov_2443yu0eci().s[5]++;

  if (k2 === undefined) {
    cov_2443yu0eci().b[3][0]++;
    cov_2443yu0eci().s[6]++;
    k2 = k;
  } else {
    cov_2443yu0eci().b[3][1]++;
  }

  cov_2443yu0eci().s[7]++;
  o[k2] = m[k];
})));

var __setModuleDefault = (cov_2443yu0eci().s[8]++, (cov_2443yu0eci().b[4][0]++, void 0) && (cov_2443yu0eci().b[4][1]++, (void 0).__setModuleDefault) || (cov_2443yu0eci().b[4][2]++, _create["default"] ? (cov_2443yu0eci().b[5][0]++, function (o, v) {
  cov_2443yu0eci().f[3]++;
  cov_2443yu0eci().s[9]++;
  (0, _defineProperty["default"])(o, "default", {
    enumerable: true,
    value: v
  });
}) : (cov_2443yu0eci().b[5][1]++, function (o, v) {
  cov_2443yu0eci().f[4]++;
  cov_2443yu0eci().s[10]++;
  o["default"] = v;
})));

var __importStar = (cov_2443yu0eci().s[11]++, (cov_2443yu0eci().b[6][0]++, void 0) && (cov_2443yu0eci().b[6][1]++, (void 0).__importStar) || (cov_2443yu0eci().b[6][2]++, function (mod) {
  cov_2443yu0eci().f[5]++;
  cov_2443yu0eci().s[12]++;

  if ((cov_2443yu0eci().b[8][0]++, mod) && (cov_2443yu0eci().b[8][1]++, mod.__esModule)) {
    cov_2443yu0eci().b[7][0]++;
    cov_2443yu0eci().s[13]++;
    return mod;
  } else {
    cov_2443yu0eci().b[7][1]++;
  }

  var result = (cov_2443yu0eci().s[14]++, {});
  cov_2443yu0eci().s[15]++;

  if (mod != null) {
    cov_2443yu0eci().b[9][0]++;
    cov_2443yu0eci().s[16]++;

    for (var k in mod) {
      cov_2443yu0eci().s[17]++;

      if ((cov_2443yu0eci().b[11][0]++, k !== "default") && (cov_2443yu0eci().b[11][1]++, Object.prototype.hasOwnProperty.call(mod, k))) {
        cov_2443yu0eci().b[10][0]++;
        cov_2443yu0eci().s[18]++;

        __createBinding(result, mod, k);
      } else {
        cov_2443yu0eci().b[10][1]++;
      }
    }
  } else {
    cov_2443yu0eci().b[9][1]++;
  }

  cov_2443yu0eci().s[19]++;

  __setModuleDefault(result, mod);

  cov_2443yu0eci().s[20]++;
  return result;
}));

var __importDefault = (cov_2443yu0eci().s[21]++, (cov_2443yu0eci().b[12][0]++, void 0) && (cov_2443yu0eci().b[12][1]++, (void 0).__importDefault) || (cov_2443yu0eci().b[12][2]++, function (mod) {
  cov_2443yu0eci().f[6]++;
  cov_2443yu0eci().s[22]++;
  return (cov_2443yu0eci().b[14][0]++, mod) && (cov_2443yu0eci().b[14][1]++, mod.__esModule) ? (cov_2443yu0eci().b[13][0]++, mod) : (cov_2443yu0eci().b[13][1]++, {
    "default": mod
  });
}));

cov_2443yu0eci().s[23]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_2443yu0eci().s[24]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_2443yu0eci().s[25]++, __webpack_require__(7));
var config_1 = (cov_2443yu0eci().s[26]++, __importDefault(__webpack_require__(263)));
var selection_1 = (cov_2443yu0eci().s[27]++, __importDefault(__webpack_require__(277)));
var command_1 = (cov_2443yu0eci().s[28]++, __importDefault(__webpack_require__(279)));
var index_1 = (cov_2443yu0eci().s[29]++, __importDefault(__webpack_require__(280)));
var index_2 = (cov_2443yu0eci().s[30]++, __importDefault(__webpack_require__(299)));
var init_dom_1 = (cov_2443yu0eci().s[31]++, __importDefault(__webpack_require__(376)));
var init_selection_1 = (cov_2443yu0eci().s[32]++, __importDefault(__webpack_require__(377)));
var bind_event_1 = (cov_2443yu0eci().s[33]++, __importDefault(__webpack_require__(378)));
var i18next_init_1 = (cov_2443yu0eci().s[34]++, __importDefault(__webpack_require__(379)));
var set_full_screen_1 = (cov_2443yu0eci().s[35]++, __importStar(__webpack_require__(380)));
var scroll_to_head_1 = (cov_2443yu0eci().s[36]++, __importDefault(__webpack_require__(383)));
var z_index_1 = (cov_2443yu0eci().s[37]++, __importDefault(__webpack_require__(384)));
var index_3 = (cov_2443yu0eci().s[38]++, __importDefault(__webpack_require__(385)));
var index_4 = (cov_2443yu0eci().s[39]++, __importDefault(__webpack_require__(387)));
var disable_1 = (cov_2443yu0eci().s[40]++, __importDefault(__webpack_require__(402))); // 创建菜单的 class

var BtnMenu_1 = (cov_2443yu0eci().s[41]++, __importDefault(__webpack_require__(24)));
var DropList_1 = (cov_2443yu0eci().s[42]++, __importDefault(__webpack_require__(124)));
var DropListMenu_1 = (cov_2443yu0eci().s[43]++, __importDefault(__webpack_require__(22)));
var Panel_1 = (cov_2443yu0eci().s[44]++, __importDefault(__webpack_require__(28)));
var PanelMenu_1 = (cov_2443yu0eci().s[45]++, __importDefault(__webpack_require__(32)));
var Tooltip_1 = (cov_2443yu0eci().s[46]++, __importDefault(__webpack_require__(43)));
var EDITOR_ID = (cov_2443yu0eci().s[47]++, 1);
var Editor = (
/** @class */
cov_2443yu0eci().s[48]++, function () {
  cov_2443yu0eci().f[7]++;

  /**
   * 构造函数
   * @param toolbarSelector 工具栏 DOM selector
   * @param textSelector 文本区域 DOM selector
   */
  function Editor(toolbarSelector, textSelector) {
    cov_2443yu0eci().f[8]++;
    cov_2443yu0eci().s[49]++;
    // 实例销毁前需要执行的钩子集合
    this.beforeDestroyHooks = []; // id，用以区分单个页面不同的编辑器对象

    cov_2443yu0eci().s[50]++;
    this.id = "wangEditor-" + EDITOR_ID++;
    cov_2443yu0eci().s[51]++;
    this.toolbarSelector = toolbarSelector;
    cov_2443yu0eci().s[52]++;
    this.textSelector = textSelector;
    cov_2443yu0eci().s[53]++;

    if (toolbarSelector == null) {
      cov_2443yu0eci().b[15][0]++;
      cov_2443yu0eci().s[54]++;
      throw new Error('错误：初始化编辑器时候未传入任何参数，请查阅文档');
    } else {
      cov_2443yu0eci().b[15][1]++;
    } // 属性的默认值，后面可能会再修改
    // 默认配置 - 当一个页面有多个编辑器的时候，因为 JS 的特性(引用类型)会导致多个编辑器的 config 引用是同一个，所以需要 深度克隆 断掉引用


    cov_2443yu0eci().s[55]++;
    this.config = util_1.deepClone(config_1["default"]);
    cov_2443yu0eci().s[56]++;
    this.$toolbarElem = dom_core_1["default"]('<div></div>');
    cov_2443yu0eci().s[57]++;
    this.$textContainerElem = dom_core_1["default"]('<div></div>');
    cov_2443yu0eci().s[58]++;
    this.$textElem = dom_core_1["default"]('<div></div>');
    cov_2443yu0eci().s[59]++;
    this.toolbarElemId = '';
    cov_2443yu0eci().s[60]++;
    this.textElemId = '';
    cov_2443yu0eci().s[61]++;
    this.isFocus = false;
    cov_2443yu0eci().s[62]++;
    this.isComposing = false;
    cov_2443yu0eci().s[63]++;
    this.isCompatibleMode = false;
    cov_2443yu0eci().s[64]++;
    this.selection = new selection_1["default"](this);
    cov_2443yu0eci().s[65]++;
    this.cmd = new command_1["default"](this);
    cov_2443yu0eci().s[66]++;
    this.txt = new index_1["default"](this);
    cov_2443yu0eci().s[67]++;
    this.menus = new index_2["default"](this);
    cov_2443yu0eci().s[68]++;
    this.zIndex = new z_index_1["default"]();
    cov_2443yu0eci().s[69]++;
    this.change = new index_3["default"](this);
    cov_2443yu0eci().s[70]++;
    this.history = new index_4["default"](this);

    var _a = (cov_2443yu0eci().s[71]++, disable_1["default"](this)),
        disable = (cov_2443yu0eci().s[72]++, _a.disable),
        enable = (cov_2443yu0eci().s[73]++, _a.enable);

    cov_2443yu0eci().s[74]++;
    this.disable = disable;
    cov_2443yu0eci().s[75]++;
    this.enable = enable;
  }
  /**
   * 初始化选区
   * @param newLine 新建一行
   */


  cov_2443yu0eci().s[76]++;

  Editor.prototype.initSelection = function (newLine) {
    cov_2443yu0eci().f[9]++;
    cov_2443yu0eci().s[77]++;
    init_selection_1["default"](this, newLine);
  };
  /**
   * 创建编辑器实例
   */


  cov_2443yu0eci().s[78]++;

  Editor.prototype.create = function () {
    cov_2443yu0eci().f[10]++;
    cov_2443yu0eci().s[79]++;
    // 初始化 ZIndex
    this.zIndex.init(this); // 确定当前的历史记录模式

    cov_2443yu0eci().s[80]++;
    this.isCompatibleMode = this.config.compatibleMode(); // 标准模式下，重置延迟时间

    cov_2443yu0eci().s[81]++;

    if (!this.isCompatibleMode) {
      cov_2443yu0eci().b[16][0]++;
      cov_2443yu0eci().s[82]++;
      this.config.onchangeTimeout = 30;
    } else {
      cov_2443yu0eci().b[16][1]++;
    } // 国际化 因为要在创建菜单前使用 所以要最先 初始化


    cov_2443yu0eci().s[83]++;
    i18next_init_1["default"](this); // 初始化 DOM

    cov_2443yu0eci().s[84]++;
    init_dom_1["default"](this); // 初始化 text

    cov_2443yu0eci().s[85]++;
    this.txt.init(); // 初始化菜单

    cov_2443yu0eci().s[86]++;
    this.menus.init(); // 初始化全屏功能

    cov_2443yu0eci().s[87]++;
    set_full_screen_1["default"](this); // 初始化选区，将光标定位到内容尾部

    cov_2443yu0eci().s[88]++;
    this.initSelection(true); // 绑定事件

    cov_2443yu0eci().s[89]++;
    bind_event_1["default"](this); // 绑定监听的目标节点

    cov_2443yu0eci().s[90]++;
    this.change.observe();
    cov_2443yu0eci().s[91]++;
    this.history.observe();
  };
  /**
   * 提供给用户添加销毁前的钩子函数
   * @param fn 钩子函数
   */


  cov_2443yu0eci().s[92]++;

  Editor.prototype.beforeDestroy = function (fn) {
    cov_2443yu0eci().f[11]++;
    cov_2443yu0eci().s[93]++;
    this.beforeDestroyHooks.push(fn);
    cov_2443yu0eci().s[94]++;
    return this;
  };
  /**
   * 销毁当前编辑器实例
   */


  cov_2443yu0eci().s[95]++;

  Editor.prototype.destroy = function () {
    var _context;

    cov_2443yu0eci().f[12]++;

    var _this = (cov_2443yu0eci().s[96]++, this); // 调用钩子函数


    cov_2443yu0eci().s[97]++;
    (0, _forEach["default"])(_context = this.beforeDestroyHooks).call(_context, function (fn) {
      cov_2443yu0eci().f[13]++;
      cov_2443yu0eci().s[98]++;
      return fn.call(_this);
    }); // 销毁 DOM 节点

    cov_2443yu0eci().s[99]++;
    this.$toolbarElem.remove();
    cov_2443yu0eci().s[100]++;
    this.$textContainerElem.remove();
  };
  /**
   * 将编辑器设置为全屏
   */


  cov_2443yu0eci().s[101]++;

  Editor.prototype.fullScreen = function () {
    cov_2443yu0eci().f[14]++;
    cov_2443yu0eci().s[102]++;
    set_full_screen_1.setFullScreen(this);
  };
  /**
   * 将编辑器退出全屏
   */


  cov_2443yu0eci().s[103]++;

  Editor.prototype.unFullScreen = function () {
    cov_2443yu0eci().f[15]++;
    cov_2443yu0eci().s[104]++;
    set_full_screen_1.setUnFullScreen(this);
  };
  /**
   * 滚动到指定标题锚点
   * @param id 标题锚点id
   */


  cov_2443yu0eci().s[105]++;

  Editor.prototype.scrollToHead = function (id) {
    cov_2443yu0eci().f[16]++;
    cov_2443yu0eci().s[106]++;
    scroll_to_head_1["default"](this, id);
  }; // 暴露 $


  cov_2443yu0eci().s[107]++;
  Editor.$ = dom_core_1["default"];
  cov_2443yu0eci().s[108]++;
  Editor.BtnMenu = BtnMenu_1["default"];
  cov_2443yu0eci().s[109]++;
  Editor.DropList = DropList_1["default"];
  cov_2443yu0eci().s[110]++;
  Editor.DropListMenu = DropListMenu_1["default"];
  cov_2443yu0eci().s[111]++;
  Editor.Panel = Panel_1["default"];
  cov_2443yu0eci().s[112]++;
  Editor.PanelMenu = PanelMenu_1["default"];
  cov_2443yu0eci().s[113]++;
  Editor.Tooltip = Tooltip_1["default"];
  cov_2443yu0eci().s[114]++;
  return Editor;
}());
cov_2443yu0eci().s[115]++;
exports["default"] = Editor;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
var forEach = __webpack_require__(176);
var classof = __webpack_require__(61);
var ArrayPrototype = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

module.exports = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.forEach)
    // eslint-disable-next-line no-prototype-builtins
    || DOMIterables.hasOwnProperty(classof(it)) ? forEach : own;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(177);

module.exports = parent;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').forEach;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var forEach = __webpack_require__(179);

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__(41).forEach;
var arrayMethodIsStrict = __webpack_require__(110);
var arrayMethodUsesToLength = __webpack_require__(27);

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(181);

module.exports = parent;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(182);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (it instanceof Function && own === FunctionPrototype.bind) ? bind : own;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Function').bind;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var bind = __webpack_require__(184);

// `Function.prototype.bind` method
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
$({ target: 'Function', proto: true }, {
  bind: bind
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(29);
var isObject = __webpack_require__(13);

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.github.io/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(186);

module.exports = parent;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var arrayIncludes = __webpack_require__(187);
var stringIncludes = __webpack_require__(189);

var ArrayPrototype = Array.prototype;
var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.includes)) return arrayIncludes;
  if (typeof it === 'string' || it === StringPrototype || (it instanceof String && own === StringPrototype.includes)) {
    return stringIncludes;
  } return own;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(188);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').includes;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $includes = __webpack_require__(69).includes;
var addToUnscopables = __webpack_require__(84);
var arrayMethodUsesToLength = __webpack_require__(27);

var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('String').includes;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var notARegExp = __webpack_require__(191);
var requireObjectCoercible = __webpack_require__(45);
var correctIsRegExpLogic = __webpack_require__(193);

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__(192);

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(13);
var classof = __webpack_require__(44);
var wellKnownSymbol = __webpack_require__(9);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(195);

module.exports = parent;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(196);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.filter) ? filter : own;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').filter;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $filter = __webpack_require__(41).filter;
var arrayMethodHasSpeciesSupport = __webpack_require__(52);
var arrayMethodUsesToLength = __webpack_require__(27);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(199);

module.exports = parent;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var splice = __webpack_require__(200);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.splice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.splice) ? splice : own;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').splice;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(70);
var toInteger = __webpack_require__(58);
var toLength = __webpack_require__(34);
var toObject = __webpack_require__(36);
var arraySpeciesCreate = __webpack_require__(85);
var createProperty = __webpack_require__(89);
var arrayMethodHasSpeciesSupport = __webpack_require__(52);
var arrayMethodUsesToLength = __webpack_require__(27);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(203);

module.exports = parent;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(204);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.indexOf) ? indexOf : own;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(205);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').indexOf;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $indexOf = __webpack_require__(69).indexOf;
var arrayMethodIsStrict = __webpack_require__(110);
var arrayMethodUsesToLength = __webpack_require__(27);

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(207);

module.exports = parent;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(208);
__webpack_require__(62);
__webpack_require__(64);
__webpack_require__(50);
var path = __webpack_require__(10);

module.exports = path.Map;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(113);
var collectionStrong = __webpack_require__(115);

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(211);

module.exports = parent;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(212);

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.trim;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.trim) ? trim : own;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('String').trim;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $trim = __webpack_require__(90).trim;
var forcedStringTrimMethod = __webpack_require__(214);

// `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(12);
var whitespaces = __webpack_require__(65);

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(216);

module.exports = parent;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(217);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.map;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.map) ? map : own;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').map;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $map = __webpack_require__(41).map;
var arrayMethodHasSpeciesSupport = __webpack_require__(52);
var arrayMethodUsesToLength = __webpack_require__(27);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(220);

module.exports = parent;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(221);
var path = __webpack_require__(10);

module.exports = path.Array.isArray;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var isArray = __webpack_require__(51);

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(223);

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(224);

module.exports = parent;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117);
__webpack_require__(64);
__webpack_require__(50);
var WrappedWellKnownSymbolModule = __webpack_require__(92);

module.exports = WrappedWellKnownSymbolModule.f('iterator');


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(226);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(227);
__webpack_require__(247);
__webpack_require__(248);
__webpack_require__(249);
__webpack_require__(250);
// TODO: Remove from `core-js@4`
__webpack_require__(251);

module.exports = parent;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(228);
__webpack_require__(62);
__webpack_require__(229);
__webpack_require__(231);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(234);
__webpack_require__(117);
__webpack_require__(235);
__webpack_require__(236);
__webpack_require__(237);
__webpack_require__(238);
__webpack_require__(239);
__webpack_require__(240);
__webpack_require__(241);
__webpack_require__(242);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
var path = __webpack_require__(10);

module.exports = path.Symbol;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var fails = __webpack_require__(12);
var isArray = __webpack_require__(51);
var isObject = __webpack_require__(13);
var toObject = __webpack_require__(36);
var toLength = __webpack_require__(34);
var createProperty = __webpack_require__(89);
var arraySpeciesCreate = __webpack_require__(85);
var arrayMethodHasSpeciesSupport = __webpack_require__(52);
var wellKnownSymbol = __webpack_require__(9);
var V8_VERSION = __webpack_require__(82);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var global = __webpack_require__(8);
var getBuiltIn = __webpack_require__(26);
var IS_PURE = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(14);
var NATIVE_SYMBOL = __webpack_require__(76);
var USE_SYMBOL_AS_UID = __webpack_require__(100);
var fails = __webpack_require__(12);
var has = __webpack_require__(15);
var isArray = __webpack_require__(51);
var isObject = __webpack_require__(13);
var anObject = __webpack_require__(23);
var toObject = __webpack_require__(36);
var toIndexedObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(56);
var createPropertyDescriptor = __webpack_require__(33);
var nativeObjectCreate = __webpack_require__(47);
var objectKeys = __webpack_require__(57);
var getOwnPropertyNamesModule = __webpack_require__(118);
var getOwnPropertyNamesExternal = __webpack_require__(230);
var getOwnPropertySymbolsModule = __webpack_require__(119);
var getOwnPropertyDescriptorModule = __webpack_require__(66);
var definePropertyModule = __webpack_require__(17);
var propertyIsEnumerableModule = __webpack_require__(55);
var createNonEnumerableProperty = __webpack_require__(16);
var redefine = __webpack_require__(49);
var shared = __webpack_require__(72);
var sharedKey = __webpack_require__(59);
var hiddenKeys = __webpack_require__(48);
var uid = __webpack_require__(60);
var wellKnownSymbol = __webpack_require__(9);
var wrappedWellKnownSymbolModule = __webpack_require__(92);
var defineWellKnownSymbol = __webpack_require__(11);
var setToStringTag = __webpack_require__(39);
var InternalStateModule = __webpack_require__(40);
var $forEach = __webpack_require__(41).forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(25);
var nativeGetOwnPropertyNames = __webpack_require__(118).f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.matchAll` well-known symbol
defineWellKnownSymbol('matchAll');


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.replace` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.search` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.species` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.split` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.toStringTag` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.unscopables` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var setToStringTag = __webpack_require__(39);

// JSON[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 246 */
/***/ (function(module, exports) {

// empty


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(11);

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = __webpack_require__(11);

defineWellKnownSymbol('replaceAll');


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(253);
var path = __webpack_require__(10);

module.exports = path.setTimeout;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var global = __webpack_require__(8);
var userAgent = __webpack_require__(79);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(255);

module.exports = parent;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(256);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.slice;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.slice) ? slice : own;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(257);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').slice;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var isObject = __webpack_require__(13);
var isArray = __webpack_require__(51);
var toAbsoluteIndex = __webpack_require__(70);
var toLength = __webpack_require__(34);
var toIndexedObject = __webpack_require__(25);
var createProperty = __webpack_require__(89);
var wellKnownSymbol = __webpack_require__(9);
var arrayMethodHasSpeciesSupport = __webpack_require__(52);
var arrayMethodUsesToLength = __webpack_require__(27);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(259);

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(260);

module.exports = parent;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(261);
var path = __webpack_require__(10);

module.exports = path.parseInt;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var parseIntImplementation = __webpack_require__(262);

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var trim = __webpack_require__(90).trim;
var whitespaces = __webpack_require__(65);

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 编辑器配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _assign = _interopRequireDefault(__webpack_require__(264));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2gk87wsd8v() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/index.ts";
  var hash = "5fd51351fe8c69ea27f6a788dca50d11d519865a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 10,
          column: 49
        }
      },
      "4": {
        start: {
          line: 11,
          column: 15
        },
        end: {
          line: 11,
          column: 51
        }
      },
      "5": {
        start: {
          line: 12,
          column: 14
        },
        end: {
          line: 12,
          column: 49
        }
      },
      "6": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 13,
          column: 49
        }
      },
      "7": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 14,
          column: 45
        }
      },
      "8": {
        start: {
          line: 15,
          column: 14
        },
        end: {
          line: 15,
          column: 49
        }
      },
      "9": {
        start: {
          line: 16,
          column: 13
        },
        end: {
          line: 16,
          column: 47
        }
      },
      "10": {
        start: {
          line: 17,
          column: 13
        },
        end: {
          line: 17,
          column: 47
        }
      },
      "11": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 53
        }
      },
      "12": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 32,
          column: 2
        }
      },
      "13": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 20
        }
      },
      "14": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 20
        }
      },
      "15": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 33,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 15
          },
          end: {
            line: 23,
            column: 16
          }
        },
        loc: {
          start: {
            line: 23,
            column: 37
          },
          end: {
            line: 25,
            column: 5
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 18
          },
          end: {
            line: 29,
            column: 19
          }
        },
        loc: {
          start: {
            line: 29,
            column: 33
          },
          end: {
            line: 31,
            column: 5
          }
        },
        line: 29
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,kDAAsF;AACtF,oDAAmC;AACnC,kDAAiC;AACjC,kDAAiC;AACjC,8CAA6B;AAC7B,kDAA2D;AAC3D,gDAA+B;AAC/B,gDAA+B;AAC/B,sDAAqC;AA2ErC,YAAY;AACZ,IAAM,aAAa,GAAG,MAAM,CAAC,MAAM,CAC/B,EAAE,EACF,eAAW,EACX,gBAAY,EACZ,eAAW,EACX,aAAS,EACT,eAAW,EACX,eAAW,EACX,cAAU,EACV,cAAU,EACV,iBAAa;AACb,WAAW;AACX;IACI,SAAS,EAAE,UAAU,IAAY,EAAE,IAAY;QAC3C,OAAO,IAAI,CAAA;IACf,CAAC;CACJ;AACD,aAAa;AACb;IACI,YAAY,EAAE,UAAU,GAAW;QAC/B,OAAO,IAAI,CAAA;IACf,CAAC;CACJ,CACJ,CAAA;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u7F16\u8F91\u5668\u914D\u7F6E\n * @author wangfupeng\n */\n\nimport menusConfig, { EmotionsType, FontSizeConfType, IndentationType } from './menus'\nimport eventsConfig from './events'\nimport styleConfig from './style'\nimport pasteConfig from './paste'\nimport cmdConfig from './cmd'\nimport imageConfig, { UploadImageHooksType } from './image'\nimport textConfig from './text'\nimport langConfig from './lang'\nimport historyConfig from './history'\n\n// \u5B57\u5178\u7C7B\u578B\nexport type DicType = {\n    [key: string]: string\n}\n\n// \u5B9A\u4E49\u914D\u7F6E\u9879\u7684\u7C7B\u578B\u89C4\u8303\nexport type ConfigType = {\n    height: number\n    languageType: string[]\n    languageTab: string\n    menus: string[]\n    fontNames: string[]\n    lineHeights: string[]\n    indentation: IndentationType\n    fontSizes: FontSizeConfType\n    colors: string[]\n    emotions: EmotionsType[]\n    zIndex: number\n    onchange: Function\n    onfocus: Function\n    onblur: Function\n    onchangeTimeout: number\n    pasteFilterStyle: boolean\n    pasteIgnoreImg: boolean\n    pasteTextHandle: Function\n    styleWithCSS: boolean\n    linkImgCallback: Function\n\n    placeholder: string\n    zIndexFullScreen: number\n    showFullScreen: boolean\n    showLinkImg: boolean\n    uploadImgServer: string\n    uploadImgShowBase64: boolean\n    uploadImgMaxSize: number\n    uploadImgMaxLength: number\n    uploadFileName: string\n    uploadImgParams: DicType\n    uploadImgParamsWithUrl: boolean\n    uploadImgHeaders: DicType\n    uploadImgHooks: UploadImageHooksType\n    uploadImgTimeout: number\n    withCredentials: boolean\n    customUploadImg: Function | null\n    customAlert: Function | null\n\n    onCatalogChange: Function | null\n\n    lang: string\n    languages: typeof langConfig\n\n    linkCheck: Function\n    linkImgCheck: Function\n    compatibleMode: () => boolean\n    historyMaxSize: number\n\n    focus: boolean\n}\n\nexport type Resource = {\n    [language: string]: ResourceLanguage\n}\n\nexport type ResourceLanguage = {\n    [namespace: string]: ResourceKey\n}\n\nexport type ResourceKey =\n    | string\n    | {\n          [key: string]: any\n      }\n\n// \u5408\u5E76\u6240\u6709\u7684\u914D\u7F6E\u4FE1\u606F\nconst defaultConfig = Object.assign(\n    {},\n    menusConfig,\n    eventsConfig,\n    styleConfig,\n    cmdConfig,\n    pasteConfig,\n    imageConfig,\n    textConfig,\n    langConfig,\n    historyConfig,\n    //\u94FE\u63A5\u6821\u9A8C\u7684\u914D\u7F6E\u51FD\u6570\n    {\n        linkCheck: function (text: string, link: string): string | boolean {\n            return true\n        },\n    },\n    //\u7F51\u7EDC\u56FE\u7247\u6821\u9A8C\u7684\u914D\u7F6E\u51FD\u6570\n    {\n        linkImgCheck: function (src: string): string | boolean {\n            return true\n        },\n    }\n)\n\nexport default defaultConfig\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5fd51351fe8c69ea27f6a788dca50d11d519865a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2gk87wsd8v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2gk87wsd8v();

var __importDefault = (cov_2gk87wsd8v().s[0]++, (cov_2gk87wsd8v().b[0][0]++, void 0) && (cov_2gk87wsd8v().b[0][1]++, (void 0).__importDefault) || (cov_2gk87wsd8v().b[0][2]++, function (mod) {
  cov_2gk87wsd8v().f[0]++;
  cov_2gk87wsd8v().s[1]++;
  return (cov_2gk87wsd8v().b[2][0]++, mod) && (cov_2gk87wsd8v().b[2][1]++, mod.__esModule) ? (cov_2gk87wsd8v().b[1][0]++, mod) : (cov_2gk87wsd8v().b[1][1]++, {
    "default": mod
  });
}));

cov_2gk87wsd8v().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var menus_1 = (cov_2gk87wsd8v().s[3]++, __importDefault(__webpack_require__(269)));
var events_1 = (cov_2gk87wsd8v().s[4]++, __importDefault(__webpack_require__(270)));
var style_1 = (cov_2gk87wsd8v().s[5]++, __importDefault(__webpack_require__(121)));
var paste_1 = (cov_2gk87wsd8v().s[6]++, __importDefault(__webpack_require__(271)));
var cmd_1 = (cov_2gk87wsd8v().s[7]++, __importDefault(__webpack_require__(272)));
var image_1 = (cov_2gk87wsd8v().s[8]++, __importDefault(__webpack_require__(273)));
var text_1 = (cov_2gk87wsd8v().s[9]++, __importDefault(__webpack_require__(274)));
var lang_1 = (cov_2gk87wsd8v().s[10]++, __importDefault(__webpack_require__(275)));
var history_1 = (cov_2gk87wsd8v().s[11]++, __importDefault(__webpack_require__(276))); // 合并所有的配置信息

var defaultConfig = (cov_2gk87wsd8v().s[12]++, (0, _assign["default"])({}, menus_1["default"], events_1["default"], style_1["default"], cmd_1["default"], paste_1["default"], image_1["default"], text_1["default"], lang_1["default"], history_1["default"], //链接校验的配置函数
{
  linkCheck: function linkCheck(text, link) {
    cov_2gk87wsd8v().f[1]++;
    cov_2gk87wsd8v().s[13]++;
    return true;
  }
}, //网络图片校验的配置函数
{
  linkImgCheck: function linkImgCheck(src) {
    cov_2gk87wsd8v().f[2]++;
    cov_2gk87wsd8v().s[14]++;
    return true;
  }
}));
cov_2gk87wsd8v().s[15]++;
exports["default"] = defaultConfig;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(265);

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(266);

module.exports = parent;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(267);
var path = __webpack_require__(10);

module.exports = path.Object.assign;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var assign = __webpack_require__(268);

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var fails = __webpack_require__(12);
var objectKeys = __webpack_require__(57);
var getOwnPropertySymbolsModule = __webpack_require__(119);
var propertyIsEnumerableModule = __webpack_require__(55);
var toObject = __webpack_require__(36);
var IndexedObject = __webpack_require__(67);

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 菜单配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2ggprxltyf() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/menus.ts";
  var hash = "f18f0158ee62b1630840d33c41ede2097b18180b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/menus.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 17
        },
        end: {
          line: 7,
          column: 75
        }
      },
      "2": {
        start: {
          line: 8,
          column: 17
        },
        end: {
          line: 8,
          column: 81
        }
      },
      "3": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 217,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/menus.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/menus.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,IAAM,UAAU,GAAG,0DAA0D,CAAA;AAC7E,IAAM,UAAU,GAAG,gEAAgE,CAAA;AA4BnF,iBAAiB;AACjB,kBAAe;IACX,KAAK,EAAE;QACH,MAAM;QACN,MAAM;QACN,UAAU;QACV,oBAAoB;QACpB,UAAU;QACV,QAAQ;QACR,WAAW;QACX,eAAe;QACf,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,WAAW;QACX,MAAM;QACN,MAAM;QACN,SAAS;QACT,OAAO;QACP,UAAU;QACV,OAAO;QACP,OAAO;QACP,OAAO;QACP,MAAM;QACN,WAAW;QACX,MAAM;QACN,MAAM;KACT;IAED,SAAS,EAAE;QACP,IAAI;QACJ,IAAI;QACJ,IAAI;QACJ,KAAK;QACL,MAAM;QACN,MAAM;QACN,IAAI;QACJ,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,iBAAiB;QACjB,aAAa;KAChB;IAED,SAAS,EAAE;QACP,SAAS,EAAE;YACP,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,KAAK,EAAE;YACH,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,MAAM,EAAE;YACJ,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,KAAK,EAAE;YACH,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,SAAS,EAAE;YACP,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,UAAU,EAAE;YACR,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;QACD,WAAW,EAAE;YACT,IAAI,EAAE,MAAM;YACZ,KAAK,EAAE,GAAG;SACb;KACJ;IAED,8CAA8C;IAC9C,mCAAmC;IACnC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,KAAK;IAEL,MAAM,EAAE;QACJ,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;QACT,SAAS;KACZ;IAED,UAAU;IACV,YAAY,EAAE;QACV,MAAM;QACN,GAAG;QACH,IAAI;QACJ,KAAK;QACL,KAAK;QACL,MAAM;QACN,YAAY;QACZ,MAAM;QACN,YAAY;QACZ,YAAY;QACZ,MAAM;QACN,KAAK;QACL,KAAK;QACL,IAAI;QACJ,QAAQ;QACR,KAAK;QACL,UAAU;QACV,KAAK;QACL,QAAQ;QACR,eAAe;QACf,MAAM;KACT;IAED,WAAW,EAAE,MAAM;IACnB;;;;OAIG;IACH,QAAQ,EAAE;QACN;YACI,UAAU;YACV,KAAK,EAAE,IAAI;YACX,4BAA4B;YAC5B,IAAI,EAAE,OAAO;YACb,gBAAgB;YAChB,OAAO,EAAE;gBACL;oBACI,GAAG,EAAE,MAAM;oBACX,GAAG,EAAK,UAAU,iCAA8B;iBACnD;gBACD;oBACI,GAAG,EAAE,MAAM;oBACX,GAAG,EAAK,UAAU,6BAA0B;iBAC/C;gBACD;oBACI,GAAG,EAAE,KAAK;oBACV,GAAG,EAAK,UAAU,2BAAwB;iBAC7C;aACJ;SACJ;QACD;YACI,UAAU;YACV,KAAK,EAAE,IAAI;YACX,4BAA4B;YAC5B,IAAI,EAAE,OAAO;YACb,gBAAgB;YAChB,OAAO,EAAE;gBACL;oBACI,GAAG,EAAK,UAAU,2BAAwB;oBAC1C,GAAG,EAAE,OAAO;iBACf;gBACD;oBACI,GAAG,EAAK,UAAU,yBAAsB;oBACxC,GAAG,EAAE,MAAM;iBACd;gBACD;oBACI,GAAG,EAAK,UAAU,wBAAqB;oBACvC,GAAG,EAAE,MAAM;iBACd;aACJ;SACJ;QACD;YACI,UAAU;YACV,KAAK,EAAE,OAAO;YACd,4BAA4B;YAC5B,IAAI,EAAE,OAAO;YACb,gBAAgB;YAChB,OAAO,EAAE,0DAA0D,CAAC,KAAK,CAAC,IAAI,CAAC;SAClF;QACD;YACI,UAAU;YACV,KAAK,EAAE,IAAI;YACX,4BAA4B;YAC5B,IAAI,EAAE,OAAO;YACb,gBAAgB;YAChB,OAAO,EAAE;gBACL,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,GAAG;gBACH,KAAK;gBACL,GAAG;gBACH,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,KAAK;gBACL,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;gBACJ,IAAI;aACP;SACJ;KACJ;IAED,WAAW,EAAE,CAAC,GAAG,EAAE,MAAM,EAAE,KAAK,EAAE,GAAG,EAAE,KAAK,EAAE,GAAG,CAAC;IAElD,SAAS,EAAE,EAAE;IAEb,WAAW,EAAE,KAAK;CACrB,CAAA",
      sourcesContent: ["/**\n * @description \u83DC\u5355\u914D\u7F6E\n * @author wangfupeng\n */\n\nconst SINA_PATH1 = 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal'\nconst SINA_PATH2 = 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal'\n\n// \u8868\u60C5\u83DC\u5355\u6570\u636E\u7ED3\u6784\u7C7B\u578B\nexport type EmotionsContentType = {\n    alt: string\n    src: string\n}\nexport type EmotionsType = {\n    title: string\n    type: string\n    content: Array<EmotionsContentType | string>\n}\n\n// font-size \u7C7B\u578B\nexport type FontSizeConfType = {\n    [key: string]: {\n        name: string\n        value: string\n    }\n}\n\n// indent\nexport interface IndentationOptions {\n    value: number\n    unit: string\n}\nexport type IndentationType = string | IndentationOptions\n\n/*\u8868\u60C5\u83DC\u5355\u6570\u636E\u7ED3\u6784\u7C7B\u578BEND*/\nexport default {\n    menus: [\n        'head',\n        'bold',\n        'fontSize',\n        // 'customFontSize',\n        'fontName',\n        'italic',\n        'underline',\n        'strikeThrough',\n        'indent',\n        'lineHeight',\n        'foreColor',\n        'backColor',\n        'link',\n        'list',\n        'justify',\n        'quote',\n        'emoticon',\n        'image',\n        'video',\n        'table',\n        'code',\n        'splitLine',\n        'undo',\n        'redo',\n    ],\n\n    fontNames: [\n        '\u9ED1\u4F53',\n        '\u4EFF\u5B8B',\n        '\u6977\u4F53',\n        '\u6807\u6977\u4F53',\n        '\u534E\u6587\u4EFF\u5B8B',\n        '\u534E\u6587\u6977\u4F53',\n        '\u5B8B\u4F53',\n        '\u5FAE\u8F6F\u96C5\u9ED1',\n        'Arial',\n        'Tahoma',\n        'Verdana',\n        'Times New Roman',\n        'Courier New',\n    ],\n\n    fontSizes: {\n        'x-small': {\n            name: '10px',\n            value: '1',\n        },\n        small: {\n            name: '13px',\n            value: '2',\n        },\n        normal: {\n            name: '16px',\n            value: '3',\n        },\n        large: {\n            name: '18px',\n            value: '4',\n        },\n        'x-large': {\n            name: '24px',\n            value: '5',\n        },\n        'xx-large': {\n            name: '32px',\n            value: '6',\n        },\n        'xxx-large': {\n            name: '48px',\n            value: '7',\n        },\n    },\n\n    // customFontSize: [ // \u8BE5\u83DC\u5355\u6682\u65F6\u4E0D\u7528 - \u738B\u798F\u670B 20200924\n    //     { value: '9px', text: '9' },\n    //     { value: '10px', text: '10' },\n    //     { value: '12px', text: '12' },\n    //     { value: '14px', text: '14' },\n    //     { value: '16px', text: '16' },\n    //     { value: '20px', text: '20' },\n    //     { value: '42px', text: '42' },\n    //     { value: '72px', text: '72' },\n    // ],\n\n    colors: [\n        '#000000',\n        '#eeece0',\n        '#1c487f',\n        '#4d80bf',\n        '#c24f4a',\n        '#8baa4a',\n        '#7b5ba1',\n        '#46acc8',\n        '#f9963b',\n        '#ffffff',\n    ],\n\n    //\u63D2\u5165\u4EE3\u7801\u8BED\u8A00\u914D\u7F6E\n    languageType: [\n        'Bash',\n        'C',\n        'C#',\n        'C++',\n        'CSS',\n        'Java',\n        'JavaScript',\n        'JSON',\n        'TypeScript',\n        'Plain text',\n        'Html',\n        'XML',\n        'SQL',\n        'Go',\n        'Kotlin',\n        'Lua',\n        'Markdown',\n        'PHP',\n        'Python',\n        'Shell Session',\n        'Ruby',\n    ],\n\n    languageTab: '\u3000\u3000\u3000\u3000',\n    /**\n     * \u8868\u60C5\u914D\u7F6E\u83DC\u5355\n     * \u5982\u679C\u4E3Aemoji\u8868\u60C5\u76F4\u63A5\u4F5C\u4E3A\u5143\u7D20\u63D2\u5165\n     * emoticon:Array<EmotionsType>\n     */\n    emotions: [\n        {\n            // tab \u7684\u6807\u9898\n            title: '\u9ED8\u8BA4',\n            // type -> 'emoji' / 'image'\n            type: 'image',\n            // content -> \u6570\u7EC4\n            content: [\n                {\n                    alt: '[\u574F\u7B11]',\n                    src: `${SINA_PATH1}/50/pcmoren_huaixiao_org.png`,\n                },\n                {\n                    alt: '[\u8214\u5C4F]',\n                    src: `${SINA_PATH1}/40/pcmoren_tian_org.png`,\n                },\n                {\n                    alt: '[\u6C61]',\n                    src: `${SINA_PATH1}/3c/pcmoren_wu_org.png`,\n                },\n            ],\n        },\n        {\n            // tab \u7684\u6807\u9898\n            title: '\u65B0\u6D6A',\n            // type -> 'emoji' / 'image'\n            type: 'image',\n            // content -> \u6570\u7EC4\n            content: [\n                {\n                    src: `${SINA_PATH2}/7a/shenshou_thumb.gif`,\n                    alt: '[\u8349\u6CE5\u9A6C]',\n                },\n                {\n                    src: `${SINA_PATH2}/60/horse2_thumb.gif`,\n                    alt: '[\u795E\u9A6C]',\n                },\n                {\n                    src: `${SINA_PATH2}/bc/fuyun_thumb.gif`,\n                    alt: '[\u6D6E\u4E91]',\n                },\n            ],\n        },\n        {\n            // tab \u7684\u6807\u9898\n            title: 'emoji',\n            // type -> 'emoji' / 'image'\n            type: 'emoji',\n            // content -> \u6570\u7EC4\n            content: '\uD83D\uDE00 \uD83D\uDE03 \uD83D\uDE04 \uD83D\uDE01 \uD83D\uDE06 \uD83D\uDE05 \uD83D\uDE02 \uD83D\uDE0A \uD83D\uDE07 \uD83D\uDE42 \uD83D\uDE43 \uD83D\uDE09 \uD83D\uDE13 \uD83D\uDE2A \uD83D\uDE34 \uD83D\uDE44 \uD83E\uDD14 \uD83D\uDE2C \uD83E\uDD10'.split(/\\s/),\n        },\n        {\n            // tab \u7684\u6807\u9898\n            title: '\u624B\u52BF',\n            // type -> 'emoji' / 'image'\n            type: 'emoji',\n            // content -> \u6570\u7EC4\n            content: [\n                '\uD83D\uDE4C',\n                '\uD83D\uDC4F',\n                '\uD83D\uDC4B',\n                '\uD83D\uDC4D',\n                '\uD83D\uDC4E',\n                '\uD83D\uDC4A',\n                '\u270A',\n                '\uFE0F\uD83D\uDC4C',\n                '\u270B',\n                '\uD83D\uDC50',\n                '\uD83D\uDCAA',\n                '\uD83D\uDE4F',\n                '\uFE0F\uD83D\uDC46',\n                '\uD83D\uDC47',\n                '\uD83D\uDC48',\n                '\uD83D\uDC49',\n                '\uD83D\uDD95',\n                '\uD83D\uDD90',\n                '\uD83E\uDD18',\n            ],\n        },\n    ],\n\n    lineHeights: ['1', '1.15', '1.6', '2', '2.5', '3'],\n\n    undoLimit: 20,\n\n    indentation: '2em',\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f18f0158ee62b1630840d33c41ede2097b18180b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ggprxltyf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2ggprxltyf();
cov_2ggprxltyf().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var SINA_PATH1 = (cov_2ggprxltyf().s[1]++, 'http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal');
var SINA_PATH2 = (cov_2ggprxltyf().s[2]++, 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal');
/*表情菜单数据结构类型END*/

cov_2ggprxltyf().s[3]++;
exports["default"] = {
  menus: ['head', 'bold', 'fontSize', // 'customFontSize',
  'fontName', 'italic', 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'backColor', 'link', 'list', 'justify', 'quote', 'emoticon', 'image', 'video', 'table', 'code', 'splitLine', 'undo', 'redo'],
  fontNames: ['黑体', '仿宋', '楷体', '标楷体', '华文仿宋', '华文楷体', '宋体', '微软雅黑', 'Arial', 'Tahoma', 'Verdana', 'Times New Roman', 'Courier New'],
  fontSizes: {
    'x-small': {
      name: '10px',
      value: '1'
    },
    small: {
      name: '13px',
      value: '2'
    },
    normal: {
      name: '16px',
      value: '3'
    },
    large: {
      name: '18px',
      value: '4'
    },
    'x-large': {
      name: '24px',
      value: '5'
    },
    'xx-large': {
      name: '32px',
      value: '6'
    },
    'xxx-large': {
      name: '48px',
      value: '7'
    }
  },
  // customFontSize: [ // 该菜单暂时不用 - 王福朋 20200924
  //     { value: '9px', text: '9' },
  //     { value: '10px', text: '10' },
  //     { value: '12px', text: '12' },
  //     { value: '14px', text: '14' },
  //     { value: '16px', text: '16' },
  //     { value: '20px', text: '20' },
  //     { value: '42px', text: '42' },
  //     { value: '72px', text: '72' },
  // ],
  colors: ['#000000', '#eeece0', '#1c487f', '#4d80bf', '#c24f4a', '#8baa4a', '#7b5ba1', '#46acc8', '#f9963b', '#ffffff'],
  //插入代码语言配置
  languageType: ['Bash', 'C', 'C#', 'C++', 'CSS', 'Java', 'JavaScript', 'JSON', 'TypeScript', 'Plain text', 'Html', 'XML', 'SQL', 'Go', 'Kotlin', 'Lua', 'Markdown', 'PHP', 'Python', 'Shell Session', 'Ruby'],
  languageTab: '　　　　',

  /**
   * 表情配置菜单
   * 如果为emoji表情直接作为元素插入
   * emoticon:Array<EmotionsType>
   */
  emotions: [{
    // tab 的标题
    title: '默认',
    // type -> 'emoji' / 'image'
    type: 'image',
    // content -> 数组
    content: [{
      alt: '[坏笑]',
      src: SINA_PATH1 + "/50/pcmoren_huaixiao_org.png"
    }, {
      alt: '[舔屏]',
      src: SINA_PATH1 + "/40/pcmoren_tian_org.png"
    }, {
      alt: '[污]',
      src: SINA_PATH1 + "/3c/pcmoren_wu_org.png"
    }]
  }, {
    // tab 的标题
    title: '新浪',
    // type -> 'emoji' / 'image'
    type: 'image',
    // content -> 数组
    content: [{
      src: SINA_PATH2 + "/7a/shenshou_thumb.gif",
      alt: '[草泥马]'
    }, {
      src: SINA_PATH2 + "/60/horse2_thumb.gif",
      alt: '[神马]'
    }, {
      src: SINA_PATH2 + "/bc/fuyun_thumb.gif",
      alt: '[浮云]'
    }]
  }, {
    // tab 的标题
    title: 'emoji',
    // type -> 'emoji' / 'image'
    type: 'emoji',
    // content -> 数组
    content: '😀 😃 😄 😁 😆 😅 😂 😊 😇 🙂 🙃 😉 😓 😪 😴 🙄 🤔 😬 🤐'.split(/\s/)
  }, {
    // tab 的标题
    title: '手势',
    // type -> 'emoji' / 'image'
    type: 'emoji',
    // content -> 数组
    content: ['🙌', '👏', '👋', '👍', '👎', '👊', '✊', '️👌', '✋', '👐', '💪', '🙏', '️👆', '👇', '👈', '👉', '🖕', '🖐', '🤘']
  }],
  lineHeights: ['1', '1.15', '1.6', '2', '2.5', '3'],
  undoLimit: 20,
  indentation: '2em'
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 事件配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2a7fzh8eyu() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/events.ts";
  var hash = "e27c1a602d6f893654c0523c37dec288bc239bb9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/events.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 14
        },
        end: {
          line: 7,
          column: 39
        }
      },
      "2": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 14,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/events.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/events.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,wCAAyC;AAQzC,kBAAe;IACX,eAAe,EAAE,GAAG;IAEpB,QAAQ,EAAE,gBAAQ;IAClB,OAAO,EAAE,gBAAQ;IACjB,MAAM,EAAE,gBAAQ;IAEhB,eAAe,EAAE,IAAI;CACxB,CAAA",
      sourcesContent: ["/**\n * @description \u4E8B\u4EF6\u914D\u7F6E\n * @author wangfupeng\n */\n\nimport { EMPTY_FN } from '../utils/const'\n\nexport type TCatalog = {\n    tag: string\n    id: string\n    text: string\n}\n\nexport default {\n    onchangeTimeout: 200,\n\n    onchange: EMPTY_FN,\n    onfocus: EMPTY_FN,\n    onblur: EMPTY_FN,\n\n    onCatalogChange: null,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e27c1a602d6f893654c0523c37dec288bc239bb9"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2a7fzh8eyu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2a7fzh8eyu();
cov_2a7fzh8eyu().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var const_1 = (cov_2a7fzh8eyu().s[1]++, __webpack_require__(30));
cov_2a7fzh8eyu().s[2]++;
exports["default"] = {
  onchangeTimeout: 200,
  onchange: const_1.EMPTY_FN,
  onfocus: const_1.EMPTY_FN,
  onblur: const_1.EMPTY_FN,
  onCatalogChange: null
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 粘贴，配置文件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1oev5behhe() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/paste.ts";
  var hash = "860d45ce2d3aa0934d2507e02bb050e97592b171";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/paste.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 18,
          column: 2
        }
      },
      "2": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 21
          },
          end: {
            line: 14,
            column: 22
          }
        },
        loc: {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/paste.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/paste.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,kBAAe;IACX,cAAc;IACd,gBAAgB,EAAE,IAAI;IAEtB,kBAAkB;IAClB,cAAc,EAAE,KAAK;IAErB,8CAA8C;IAC9C,WAAW;IACX,eAAe,EAAE,UAAU,OAAe;QACtC,4CAA4C;QAC5C,OAAO,OAAO,CAAA;IAClB,CAAC;CACJ,CAAA",
      sourcesContent: ["/**\n * @description \u7C98\u8D34\uFF0C\u914D\u7F6E\u6587\u4EF6\n * @author wangfupeng\n */\n\nexport default {\n    // \u7C98\u8D34\u8FC7\u6EE4\u6837\u5F0F\uFF0C\u9ED8\u8BA4\u5F00\u542F\n    pasteFilterStyle: true,\n\n    // \u7C98\u8D34\u5185\u5BB9\u65F6\uFF0C\u5FFD\u7565\u56FE\u7247\u3002\u9ED8\u8BA4\u5173\u95ED\n    pasteIgnoreImg: false,\n\n    // \u5BF9\u7C98\u8D34\u7684\u6587\u5B57\u8FDB\u884C\u81EA\u5B9A\u4E49\u5904\u7406\uFF0C\u8FD4\u56DE\u5904\u7406\u540E\u7684\u7ED3\u679C\u3002\u7F16\u8F91\u5668\u4F1A\u5C06\u5904\u7406\u540E\u7684\u7ED3\u679C\u7C98\u8D34\u5230\u7F16\u8F91\u533A\u57DF\u4E2D\u3002\n    // IE \u6682\u65F6\u4E0D\u652F\u6301\n    pasteTextHandle: function (content: string): string {\n        // content \u5373\u7C98\u8D34\u8FC7\u6765\u7684\u5185\u5BB9\uFF08html \u6216 \u7EAF\u6587\u672C\uFF09\uFF0C\u53EF\u8FDB\u884C\u81EA\u5B9A\u4E49\u5904\u7406\u7136\u540E\u8FD4\u56DE\n        return content\n    },\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "860d45ce2d3aa0934d2507e02bb050e97592b171"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1oev5behhe = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1oev5behhe();
cov_1oev5behhe().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_1oev5behhe().s[1]++;
exports["default"] = {
  // 粘贴过滤样式，默认开启
  pasteFilterStyle: true,
  // 粘贴内容时，忽略图片。默认关闭
  pasteIgnoreImg: false,
  // 对粘贴的文字进行自定义处理，返回处理后的结果。编辑器会将处理后的结果粘贴到编辑区域中。
  // IE 暂时不支持
  pasteTextHandle: function pasteTextHandle(content) {
    cov_1oev5behhe().f[0]++;
    cov_1oev5behhe().s[2]++;
    // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
    return content;
  }
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 命令配置项
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_vfyyazyd6() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/cmd.ts";
  var hash = "ec216aeed60a4d47f53d4fb584821379f6c3b348";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/cmd.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 9,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/cmd.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/cmd.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,kBAAe;IACX,YAAY,EAAE,KAAK;CACtB,CAAA",
      sourcesContent: ["/**\n * @description \u547D\u4EE4\u914D\u7F6E\u9879\n * @author wangfupeng\n */\n\nexport default {\n    styleWithCSS: false, // \u9ED8\u8BA4 false\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ec216aeed60a4d47f53d4fb584821379f6c3b348"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_vfyyazyd6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_vfyyazyd6();
cov_vfyyazyd6().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_vfyyazyd6().s[1]++;
exports["default"] = {
  styleWithCSS: false
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 图片相关的配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_qrfr350cs() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/image.ts";
  var hash = "dc70755306e1fc80e131d157141342f2cda608e6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/image.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 14
        },
        end: {
          line: 7,
          column: 39
        }
      },
      "2": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 37,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/image.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/image.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAGH,wCAAyC;AAoBzC,kBAAe;IACX,aAAa;IACb,WAAW,EAAE,IAAI;IAEjB,gBAAgB;IAChB,eAAe,EAAE,gBAAQ;IAEzB,QAAQ;IACR,eAAe,EAAE,EAAE;IAEnB,iBAAiB;IACjB,mBAAmB,EAAE,KAAK;IAE1B,kBAAkB;IAClB,gBAAgB,EAAE,CAAC,GAAG,IAAI,GAAG,IAAI;IAEjC,cAAc;IACd,kBAAkB,EAAE,GAAG;IAEvB,aAAa;IACb,cAAc,EAAE,EAAE;IAElB,YAAY;IACZ,eAAe,EAAE,EAAE;IAEnB,iBAAiB;IACjB,sBAAsB,EAAE,KAAK;IAE7B,iBAAiB;IACjB,gBAAgB,EAAE,EAAE;IAEpB,OAAO;IACP,cAAc,EAAE,EAAE;IAElB,cAAc;IACd,gBAAgB,EAAE,EAAE,GAAG,IAAI;IAE3B,aAAa;IACb,eAAe,EAAE,KAAK;IAEtB,QAAQ;IACR,eAAe,EAAE,IAAI;CACxB,CAAA",
      sourcesContent: ["/**\n * @description \u56FE\u7247\u76F8\u5173\u7684\u914D\u7F6E\n * @author wangfupeng\n */\n\nimport Editor from '../editor/index'\nimport { EMPTY_FN } from '../utils/const'\nimport { ResType } from '../menus/img/upload-img'\n\nexport type UploadImageHooksType = {\n    before?: (\n        xhr: XMLHttpRequest,\n        editor: Editor,\n        files: File[]\n    ) => { prevent: boolean; msg: string } | void\n    success?: (xhr: XMLHttpRequest, editor: Editor, result: ResType) => void\n    fail?: (xhr: XMLHttpRequest, editor: Editor, err: ResType | string) => void\n    error?: (xhr: XMLHttpRequest, editor: Editor) => void\n    timeout?: (xhr: XMLHttpRequest, editor: Editor) => void\n    customInsert?: (\n        inserImg: (this: Editor, src: string) => void,\n        result: ResType,\n        editor: Editor\n    ) => void\n}\n\nexport default {\n    // \u663E\u793A\u201C\u63D2\u5165\u7F51\u7EDC\u56FE\u7247\u201D\n    showLinkImg: true,\n\n    // \u63D2\u5165\u56FE\u7247\u6210\u529F\u4E4B\u540E\u7684\u56DE\u8C03\u51FD\u6570\n    linkImgCallback: EMPTY_FN,\n\n    // \u670D\u52A1\u7AEF\u5730\u5740\n    uploadImgServer: '',\n\n    // \u4F7F\u7528 base64 \u5B58\u50A8\u56FE\u7247\n    uploadImgShowBase64: false,\n\n    // \u4E0A\u4F20\u56FE\u7247\u7684\u6700\u5927\u4F53\u79EF\uFF0C\u9ED8\u8BA4 5M\n    uploadImgMaxSize: 5 * 1024 * 1024,\n\n    // \u4E00\u6B21\u6700\u591A\u4E0A\u4F20\u591A\u5C11\u4E2A\u56FE\u7247\n    uploadImgMaxLength: 100,\n\n    // \u81EA\u5B9A\u4E49\u4E0A\u4F20\u56FE\u7247\u7684\u540D\u79F0\n    uploadFileName: '',\n\n    // \u4E0A\u4F20\u56FE\u7247\u81EA\u5B9A\u4E49\u53C2\u6570\n    uploadImgParams: {},\n\n    // \u81EA\u5B9A\u4E49\u53C2\u6570\u62FC\u63A5\u5230 url \u4E2D\n    uploadImgParamsWithUrl: false,\n\n    // \u4E0A\u4F20\u56FE\u7247\u81EA\u5B9A\u4E49 header\n    uploadImgHeaders: {},\n\n    // \u94A9\u5B50\u51FD\u6570\n    uploadImgHooks: {},\n\n    // \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6\u65F6\u95F4 ms\n    uploadImgTimeout: 10 * 1000,\n\n    // \u8DE8\u57DF\u5E26 cookie\n    withCredentials: false,\n\n    // \u81EA\u5B9A\u4E49\u4E0A\u4F20\n    customUploadImg: null,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dc70755306e1fc80e131d157141342f2cda608e6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qrfr350cs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_qrfr350cs();
cov_qrfr350cs().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var const_1 = (cov_qrfr350cs().s[1]++, __webpack_require__(30));
cov_qrfr350cs().s[2]++;
exports["default"] = {
  // 显示“插入网络图片”
  showLinkImg: true,
  // 插入图片成功之后的回调函数
  linkImgCallback: const_1.EMPTY_FN,
  // 服务端地址
  uploadImgServer: '',
  // 使用 base64 存储图片
  uploadImgShowBase64: false,
  // 上传图片的最大体积，默认 5M
  uploadImgMaxSize: 5 * 1024 * 1024,
  // 一次最多上传多少个图片
  uploadImgMaxLength: 100,
  // 自定义上传图片的名称
  uploadFileName: '',
  // 上传图片自定义参数
  uploadImgParams: {},
  // 自定义参数拼接到 url 中
  uploadImgParamsWithUrl: false,
  // 上传图片自定义 header
  uploadImgHeaders: {},
  // 钩子函数
  uploadImgHooks: {},
  // 上传图片超时时间 ms
  uploadImgTimeout: 10 * 1000,
  // 跨域带 cookie
  withCredentials: false,
  // 自定义上传
  customUploadImg: null
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 默认常量配置
 * @author xiaokyo
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1edih0lkvl() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/text.ts";
  var hash = "472fe685fa48f212bff1bc90ba66c5618de92d9d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/text.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 13,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/text.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/text.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,kBAAe;IACX,KAAK,EAAE,IAAI;IACX,MAAM,EAAE,GAAG;IACX,WAAW,EAAE,OAAO;IACpB,gBAAgB,EAAE,KAAK;IACvB,cAAc,EAAE,IAAI;CACvB,CAAA",
      sourcesContent: ["/**\n * @description \u9ED8\u8BA4\u5E38\u91CF\u914D\u7F6E\n * @author xiaokyo\n */\n\nexport default {\n    focus: true,\n    height: 300,\n    placeholder: '\u8BF7\u8F93\u5165\u6B63\u6587',\n    zIndexFullScreen: 10000,\n    showFullScreen: true,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "472fe685fa48f212bff1bc90ba66c5618de92d9d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1edih0lkvl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1edih0lkvl();
cov_1edih0lkvl().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_1edih0lkvl().s[1]++;
exports["default"] = {
  focus: true,
  height: 300,
  placeholder: '请输入正文',
  zIndexFullScreen: 10000,
  showFullScreen: true
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_10lzabxv0l() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/lang.ts";
  var hash = "ef4416a657ef3682e5444eed5b801e4e1c67cd41";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/lang.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 2,
          column: 62
        }
      },
      "1": {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 207,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/lang.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/lang.ts"],
      names: [],
      mappings: ";;AAAA,kBAAe;IACX,IAAI,EAAE,OAAO;IACb,SAAS,EAAE;QACP,OAAO,EAAE;YACL,UAAU,EAAE;gBACR,EAAE,EAAE,IAAI;gBACR,EAAE,EAAE,IAAI;gBACR,EAAE,EAAE,IAAI;gBACR,EAAE,EAAE,IAAI;gBACR,CAAC,EAAE,GAAG;gBACN,KAAK,EAAE,OAAO;gBACd,KAAK,EAAE;oBACH,YAAY,EAAE;wBACV,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,IAAI,EAAE,MAAM;wBACZ,EAAE,EAAE,IAAI;wBACR,IAAI,EAAE;4BACF,EAAE,EAAE,IAAI;yBACX;wBACD,MAAM,EAAE;4BACJ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;wBACD,OAAO,EAAE;4BACL,EAAE,EAAE,IAAI;4BACR,EAAE,EAAE,IAAI;4BACR,EAAE,EAAE,IAAI;4BACR,EAAE,EAAE,IAAI;yBACX;wBACD,IAAI,EAAE;4BACF,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;qBACJ;oBACD,UAAU,EAAE;wBACR,QAAQ,EAAE;4BACN,EAAE,EAAE,IAAI;4BACR,EAAE,EAAE,IAAI;4BACR,KAAK,EAAE,OAAO;4BACd,EAAE,EAAE,IAAI;yBACX;wBACD,KAAK,EAAE;4BACH,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;wBACD,IAAI,EAAE;4BACF,EAAE,EAAE,IAAI;4BACR,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;wBACD,KAAK,EAAE;4BACH,IAAI,EAAE,MAAM;yBACf;wBACD,KAAK,EAAE;4BACH,CAAC,EAAE,GAAG;4BACN,CAAC,EAAE,GAAG;4BACN,CAAC,EAAE,GAAG;4BACN,EAAE,EAAE,IAAI;4BACR,GAAG,EAAE,KAAK;4BACV,GAAG,EAAE,KAAK;4BACV,GAAG,EAAE,KAAK;4BACV,GAAG,EAAE,KAAK;4BACV,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;wBACD,IAAI,EAAE;4BACF,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;4BACZ,IAAI,EAAE,MAAM;yBACf;qBACJ;iBACJ;gBACD,QAAQ,EAAE;oBACN,GAAG,EAAE,KAAK;oBACV,EAAE,EAAE,IAAI;oBACR,IAAI,EAAE,MAAM;oBACZ,IAAI,EAAE,MAAM;oBACZ,IAAI,EAAE,MAAM;oBACZ,MAAM,EAAE,QAAQ;oBAChB,MAAM,EAAE,QAAQ;oBAChB,MAAM,EAAE,QAAQ;oBAChB,MAAM,EAAE,QAAQ;oBAChB,MAAM,EAAE,QAAQ;oBAChB,MAAM,EAAE,QAAQ;oBAChB,OAAO,EAAE,SAAS;oBAClB,OAAO,EAAE,SAAS;oBAClB,UAAU,EAAE,YAAY;oBACxB,WAAW,EAAE,aAAa;oBAC1B,YAAY,EAAE,cAAc;oBAC5B,kBAAkB,EAAE,oBAAoB;iBAC3C;aACJ;SACJ;QACD,EAAE,EAAE;YACA,UAAU,EAAE;gBACR,EAAE,EAAE,QAAQ;gBACZ,EAAE,EAAE,SAAS;gBACb,EAAE,EAAE,QAAQ;gBACZ,EAAE,EAAE,MAAM;gBACV,CAAC,EAAE,MAAM;gBACT,KAAK,EAAE,uBAAuB;gBAC9B,KAAK,EAAE;oBACH,YAAY,EAAE;wBACV,IAAI,EAAE,OAAO;wBACb,IAAI,EAAE,YAAY;wBAClB,IAAI,EAAE,YAAY;wBAClB,IAAI,EAAE,WAAW;wBACjB,IAAI,EAAE,aAAa;wBACnB,IAAI,EAAE,QAAQ;wBACd,IAAI,EAAE,OAAO;wBACb,IAAI,EAAE,aAAa;wBACnB,EAAE,EAAE,MAAM;wBACV,IAAI,EAAE;4BACF,EAAE,EAAE,MAAM;yBACb;wBACD,MAAM,EAAE;4BACJ,IAAI,EAAE,QAAQ;4BACd,IAAI,EAAE,SAAS;yBAClB;wBACD,OAAO,EAAE;4BACL,EAAE,EAAE,MAAM;4BACV,EAAE,EAAE,QAAQ;4BACZ,EAAE,EAAE,OAAO;4BACX,EAAE,EAAE,SAAS;yBAChB;wBACD,IAAI,EAAE;4BACF,IAAI,EAAE,WAAW;4BACjB,IAAI,EAAE,SAAS;yBAClB;qBACJ;oBACD,UAAU,EAAE;wBACR,QAAQ,EAAE;4BACN,EAAE,EAAE,SAAS;4BACb,EAAE,EAAE,MAAM;4BACV,KAAK,EAAE,OAAO;4BACd,EAAE,EAAE,SAAS;yBAChB;wBACD,KAAK,EAAE;4BACH,IAAI,EAAE,YAAY;4BAClB,IAAI,EAAE,cAAc;4BACpB,IAAI,EAAE,eAAe;yBACxB;wBACD,IAAI,EAAE;4BACF,EAAE,EAAE,MAAM;4BACV,IAAI,EAAE,WAAW;4BACjB,IAAI,EAAE,QAAQ;4BACd,IAAI,EAAE,YAAY;yBACrB;wBACD,KAAK,EAAE;4BACH,IAAI,EAAE,cAAc;yBACvB;wBACD,KAAK,EAAE;4BACH,CAAC,EAAE,MAAM;4BACT,CAAC,EAAE,SAAS;4BACZ,CAAC,EAAE,GAAG;4BACN,EAAE,EAAE,OAAO;4BACX,GAAG,EAAE,YAAY;4BACjB,GAAG,EAAE,YAAY;4BACjB,GAAG,EAAE,eAAe;4BACpB,GAAG,EAAE,eAAe;4BACpB,IAAI,EAAE,YAAY;4BAClB,IAAI,EAAE,eAAe;4BACrB,IAAI,EAAE,cAAc;4BACpB,IAAI,EAAE,cAAc;yBACvB;wBACD,IAAI,EAAE;4BACF,IAAI,EAAE,aAAa;4BACnB,IAAI,EAAE,WAAW;4BACjB,IAAI,EAAE,aAAa;yBACtB;qBACJ;iBACJ;gBACD,QAAQ,EAAE;oBACN,GAAG,EAAE,QAAQ;oBACb,EAAE,EAAE,cAAc;oBAClB,IAAI,EAAE,YAAY;oBAClB,IAAI,EAAE,cAAc;oBACpB,IAAI,EAAE,gBAAgB;oBACtB,MAAM,EAAE,sBAAsB;oBAC9B,MAAM,EAAE,oBAAoB;oBAC5B,MAAM,EAAE,qBAAqB;oBAC7B,MAAM,EAAE,oBAAoB;oBAC5B,MAAM,EAAE,qBAAqB;oBAC7B,MAAM,EAAE,sBAAsB;oBAC9B,OAAO,EAAE,uBAAuB;oBAChC,OAAO,EAAE,sBAAsB;oBAC/B,UAAU,EAAE,mCAAmC;oBAC/C,WAAW,EAAE,4CAA4C;oBACzD,YAAY,EAAE,oDAAoD;oBAClE,kBAAkB,EACd,uEAAuE;iBAC9E;aACJ;SACJ;KACJ;CACJ,CAAA",
      sourcesContent: ["export default {\n    lang: 'zh-CN',\n    languages: {\n        'zh-CN': {\n            wangEditor: {\n                \u63D2\u5165: '\u63D2\u5165',\n                \u9ED8\u8BA4: '\u9ED8\u8BA4',\n                \u521B\u5EFA: '\u521B\u5EFA',\n                \u4FEE\u6539: '\u4FEE\u6539',\n                \u5982: '\u5982',\n                \u8BF7\u8F93\u5165\u6B63\u6587: '\u8BF7\u8F93\u5165\u6B63\u6587',\n                menus: {\n                    dropListMenu: {\n                        \u8BBE\u7F6E\u6807\u9898: '\u8BBE\u7F6E\u6807\u9898',\n                        \u80CC\u666F\u989C\u8272: '\u80CC\u666F\u989C\u8272',\n                        \u6587\u5B57\u989C\u8272: '\u6587\u5B57\u989C\u8272',\n                        \u8BBE\u7F6E\u5B57\u53F7: '\u8BBE\u7F6E\u5B57\u53F7',\n                        \u8BBE\u7F6E\u5B57\u4F53: '\u8BBE\u7F6E\u5B57\u4F53',\n                        \u8BBE\u7F6E\u7F29\u8FDB: '\u8BBE\u7F6E\u7F29\u8FDB',\n                        \u5BF9\u9F50\u65B9\u5F0F: '\u5BF9\u9F50\u65B9\u5F0F',\n                        \u8BBE\u7F6E\u884C\u9AD8: '\u8BBE\u7F6E\u884C\u9AD8',\n                        \u5E8F\u5217: '\u5E8F\u5217',\n                        head: {\n                            \u6B63\u6587: '\u6B63\u6587',\n                        },\n                        indent: {\n                            \u589E\u52A0\u7F29\u8FDB: '\u589E\u52A0\u7F29\u8FDB',\n                            \u51CF\u5C11\u7F29\u8FDB: '\u51CF\u5C11\u7F29\u8FDB',\n                        },\n                        justify: {\n                            \u9760\u5DE6: '\u9760\u5DE6',\n                            \u5C45\u4E2D: '\u5C45\u4E2D',\n                            \u9760\u53F3: '\u9760\u53F3',\n                            \u4E24\u7AEF: '\u4E24\u7AEF',\n                        },\n                        list: {\n                            \u65E0\u5E8F\u5217\u8868: '\u65E0\u5E8F\u5217\u8868',\n                            \u6709\u5E8F\u5217\u8868: '\u6709\u5E8F\u5217\u8868',\n                        },\n                    },\n                    panelMenus: {\n                        emoticon: {\n                            \u9ED8\u8BA4: '\u9ED8\u8BA4',\n                            \u65B0\u6D6A: '\u65B0\u6D6A',\n                            emoji: 'emoji',\n                            \u624B\u52BF: '\u624B\u52BF',\n                        },\n                        image: {\n                            \u56FE\u7247\u94FE\u63A5: '\u56FE\u7247\u94FE\u63A5',\n                            \u4E0A\u4F20\u56FE\u7247: '\u4E0A\u4F20\u56FE\u7247',\n                            \u7F51\u7EDC\u56FE\u7247: '\u7F51\u7EDC\u56FE\u7247',\n                        },\n                        link: {\n                            \u94FE\u63A5: '\u94FE\u63A5',\n                            \u94FE\u63A5\u6587\u5B57: '\u94FE\u63A5\u6587\u5B57',\n                            \u53D6\u6D88\u94FE\u63A5: '\u53D6\u6D88\u94FE\u63A5',\n                            \u67E5\u770B\u94FE\u63A5: '\u67E5\u770B\u94FE\u63A5',\n                        },\n                        video: {\n                            \u63D2\u5165\u89C6\u9891: '\u63D2\u5165\u89C6\u9891',\n                        },\n                        table: {\n                            \u884C: '\u884C',\n                            \u5217: '\u5217',\n                            \u7684: '\u7684',\n                            \u8868\u683C: '\u8868\u683C',\n                            \u6DFB\u52A0\u884C: '\u6DFB\u52A0\u884C',\n                            \u5220\u9664\u884C: '\u5220\u9664\u884C',\n                            \u6DFB\u52A0\u5217: '\u6DFB\u52A0\u5217',\n                            \u5220\u9664\u5217: '\u5220\u9664\u5217',\n                            \u8BBE\u7F6E\u8868\u5934: '\u8BBE\u7F6E\u8868\u5934',\n                            \u53D6\u6D88\u8868\u5934: '\u53D6\u6D88\u8868\u5934',\n                            \u63D2\u5165\u8868\u683C: '\u63D2\u5165\u8868\u683C',\n                            \u5220\u9664\u8868\u683C: '\u5220\u9664\u8868\u683C',\n                        },\n                        code: {\n                            \u5220\u9664\u4EE3\u7801: '\u5220\u9664\u4EE3\u7801',\n                            \u4FEE\u6539\u4EE3\u7801: '\u4FEE\u6539\u4EE3\u7801',\n                            \u63D2\u5165\u4EE3\u7801: '\u63D2\u5165\u4EE3\u7801',\n                        },\n                    },\n                },\n                validate: {\n                    \u5F20\u56FE\u7247: '\u5F20\u56FE\u7247',\n                    \u5927\u4E8E: '\u5927\u4E8E',\n                    \u56FE\u7247\u94FE\u63A5: '\u56FE\u7247\u94FE\u63A5',\n                    \u4E0D\u662F\u56FE\u7247: '\u4E0D\u662F\u56FE\u7247',\n                    \u8FD4\u56DE\u7ED3\u679C: '\u8FD4\u56DE\u7ED3\u679C',\n                    \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6: '\u4E0A\u4F20\u56FE\u7247\u8D85\u65F6',\n                    \u4E0A\u4F20\u56FE\u7247\u9519\u8BEF: '\u4E0A\u4F20\u56FE\u7247\u9519\u8BEF',\n                    \u4E0A\u4F20\u56FE\u7247\u5931\u8D25: '\u4E0A\u4F20\u56FE\u7247\u5931\u8D25',\n                    \u63D2\u5165\u56FE\u7247\u9519\u8BEF: '\u63D2\u5165\u56FE\u7247\u9519\u8BEF',\n                    \u4E00\u6B21\u6700\u591A\u4E0A\u4F20: '\u4E00\u6B21\u6700\u591A\u4E0A\u4F20',\n                    \u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25: '\u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25',\n                    \u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7: '\u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7',\n                    \u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001: '\u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001',\n                    \u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: '\u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF',\n                    \u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B: '\u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B',\n                    \u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B: '\u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B',\n                    \u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C: '\u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C',\n                },\n            },\n        },\n        en: {\n            wangEditor: {\n                \u63D2\u5165: 'insert',\n                \u9ED8\u8BA4: 'default',\n                \u521B\u5EFA: 'create',\n                \u4FEE\u6539: 'edit',\n                \u5982: 'like',\n                \u8BF7\u8F93\u5165\u6B63\u6587: 'please enter the text',\n                menus: {\n                    dropListMenu: {\n                        \u8BBE\u7F6E\u6807\u9898: 'title',\n                        \u80CC\u666F\u989C\u8272: 'background',\n                        \u6587\u5B57\u989C\u8272: 'font color',\n                        \u8BBE\u7F6E\u5B57\u53F7: 'font size',\n                        \u8BBE\u7F6E\u5B57\u4F53: 'font family',\n                        \u8BBE\u7F6E\u7F29\u8FDB: 'indent',\n                        \u5BF9\u9F50\u65B9\u5F0F: 'align',\n                        \u8BBE\u7F6E\u884C\u9AD8: 'line heihgt',\n                        \u5E8F\u5217: 'list',\n                        head: {\n                            \u6B63\u6587: 'text',\n                        },\n                        indent: {\n                            \u589E\u52A0\u7F29\u8FDB: 'indent',\n                            \u51CF\u5C11\u7F29\u8FDB: 'outdent',\n                        },\n                        justify: {\n                            \u9760\u5DE6: 'left',\n                            \u5C45\u4E2D: 'center',\n                            \u9760\u53F3: 'right',\n                            \u4E24\u7AEF: 'justify',\n                        },\n                        list: {\n                            \u65E0\u5E8F\u5217\u8868: 'unordered',\n                            \u6709\u5E8F\u5217\u8868: 'ordered',\n                        },\n                    },\n                    panelMenus: {\n                        emoticon: {\n                            \u9ED8\u8BA4: 'default',\n                            \u65B0\u6D6A: 'sina',\n                            emoji: 'emoji',\n                            \u624B\u52BF: 'gesture',\n                        },\n                        image: {\n                            \u56FE\u7247\u94FE\u63A5: 'image link',\n                            \u4E0A\u4F20\u56FE\u7247: 'upload image',\n                            \u7F51\u7EDC\u56FE\u7247: 'network image',\n                        },\n                        link: {\n                            \u94FE\u63A5: 'link',\n                            \u94FE\u63A5\u6587\u5B57: 'link text',\n                            \u53D6\u6D88\u94FE\u63A5: 'unlink',\n                            \u67E5\u770B\u94FE\u63A5: 'view links',\n                        },\n                        video: {\n                            \u63D2\u5165\u89C6\u9891: 'insert video',\n                        },\n                        table: {\n                            \u884C: 'rows',\n                            \u5217: 'columns',\n                            \u7684: ' ',\n                            \u8868\u683C: 'table',\n                            \u6DFB\u52A0\u884C: 'insert row',\n                            \u5220\u9664\u884C: 'delete row',\n                            \u6DFB\u52A0\u5217: 'insert column',\n                            \u5220\u9664\u5217: 'delete column',\n                            \u8BBE\u7F6E\u8868\u5934: 'set header',\n                            \u53D6\u6D88\u8868\u5934: 'cancel header',\n                            \u63D2\u5165\u8868\u683C: 'insert table',\n                            \u5220\u9664\u8868\u683C: 'delete table',\n                        },\n                        code: {\n                            \u5220\u9664\u4EE3\u7801: 'delete code',\n                            \u4FEE\u6539\u4EE3\u7801: 'edit code',\n                            \u63D2\u5165\u4EE3\u7801: 'insert code',\n                        },\n                    },\n                },\n                validate: {\n                    \u5F20\u56FE\u7247: 'images',\n                    \u5927\u4E8E: 'greater than',\n                    \u56FE\u7247\u94FE\u63A5: 'image link',\n                    \u4E0D\u662F\u56FE\u7247: 'is not image',\n                    \u8FD4\u56DE\u7ED3\u679C: 'return results',\n                    \u4E0A\u4F20\u56FE\u7247\u8D85\u65F6: 'upload image timeout',\n                    \u4E0A\u4F20\u56FE\u7247\u9519\u8BEF: 'upload image error',\n                    \u4E0A\u4F20\u56FE\u7247\u5931\u8D25: 'upload image failed',\n                    \u63D2\u5165\u56FE\u7247\u9519\u8BEF: 'insert image error',\n                    \u4E00\u6B21\u6700\u591A\u4E0A\u4F20: 'once most at upload',\n                    \u4E0B\u8F7D\u94FE\u63A5\u5931\u8D25: 'download link failed',\n                    \u56FE\u7247\u9A8C\u8BC1\u672A\u901A\u8FC7: 'image validate failed',\n                    \u670D\u52A1\u5668\u8FD4\u56DE\u72B6\u6001: 'server return status',\n                    \u4E0A\u4F20\u56FE\u7247\u8FD4\u56DE\u7ED3\u679C\u9519\u8BEF: 'upload image return results error',\n                    \u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B: 'please replace with a supported image type',\n                    \u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B: 'the network picture you inserted is not recognized',\n                    \u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C:\n                        'the image link you just inserted did not pass the editor verification',\n                },\n            },\n        },\n    },\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ef4416a657ef3682e5444eed5b801e4e1c67cd41"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10lzabxv0l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_10lzabxv0l();
cov_10lzabxv0l().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_10lzabxv0l().s[1]++;
exports["default"] = {
  lang: 'zh-CN',
  languages: {
    'zh-CN': {
      wangEditor: {
        插入: '插入',
        默认: '默认',
        创建: '创建',
        修改: '修改',
        如: '如',
        请输入正文: '请输入正文',
        menus: {
          dropListMenu: {
            设置标题: '设置标题',
            背景颜色: '背景颜色',
            文字颜色: '文字颜色',
            设置字号: '设置字号',
            设置字体: '设置字体',
            设置缩进: '设置缩进',
            对齐方式: '对齐方式',
            设置行高: '设置行高',
            序列: '序列',
            head: {
              正文: '正文'
            },
            indent: {
              增加缩进: '增加缩进',
              减少缩进: '减少缩进'
            },
            justify: {
              靠左: '靠左',
              居中: '居中',
              靠右: '靠右',
              两端: '两端'
            },
            list: {
              无序列表: '无序列表',
              有序列表: '有序列表'
            }
          },
          panelMenus: {
            emoticon: {
              默认: '默认',
              新浪: '新浪',
              emoji: 'emoji',
              手势: '手势'
            },
            image: {
              图片链接: '图片链接',
              上传图片: '上传图片',
              网络图片: '网络图片'
            },
            link: {
              链接: '链接',
              链接文字: '链接文字',
              取消链接: '取消链接',
              查看链接: '查看链接'
            },
            video: {
              插入视频: '插入视频'
            },
            table: {
              行: '行',
              列: '列',
              的: '的',
              表格: '表格',
              添加行: '添加行',
              删除行: '删除行',
              添加列: '添加列',
              删除列: '删除列',
              设置表头: '设置表头',
              取消表头: '取消表头',
              插入表格: '插入表格',
              删除表格: '删除表格'
            },
            code: {
              删除代码: '删除代码',
              修改代码: '修改代码',
              插入代码: '插入代码'
            }
          }
        },
        validate: {
          张图片: '张图片',
          大于: '大于',
          图片链接: '图片链接',
          不是图片: '不是图片',
          返回结果: '返回结果',
          上传图片超时: '上传图片超时',
          上传图片错误: '上传图片错误',
          上传图片失败: '上传图片失败',
          插入图片错误: '插入图片错误',
          一次最多上传: '一次最多上传',
          下载链接失败: '下载链接失败',
          图片验证未通过: '图片验证未通过',
          服务器返回状态: '服务器返回状态',
          上传图片返回结果错误: '上传图片返回结果错误',
          请替换为支持的图片类型: '请替换为支持的图片类型',
          您插入的网络图片无法识别: '您插入的网络图片无法识别',
          您刚才插入的图片链接未通过编辑器校验: '您刚才插入的图片链接未通过编辑器校验'
        }
      }
    },
    en: {
      wangEditor: {
        插入: 'insert',
        默认: 'default',
        创建: 'create',
        修改: 'edit',
        如: 'like',
        请输入正文: 'please enter the text',
        menus: {
          dropListMenu: {
            设置标题: 'title',
            背景颜色: 'background',
            文字颜色: 'font color',
            设置字号: 'font size',
            设置字体: 'font family',
            设置缩进: 'indent',
            对齐方式: 'align',
            设置行高: 'line heihgt',
            序列: 'list',
            head: {
              正文: 'text'
            },
            indent: {
              增加缩进: 'indent',
              减少缩进: 'outdent'
            },
            justify: {
              靠左: 'left',
              居中: 'center',
              靠右: 'right',
              两端: 'justify'
            },
            list: {
              无序列表: 'unordered',
              有序列表: 'ordered'
            }
          },
          panelMenus: {
            emoticon: {
              默认: 'default',
              新浪: 'sina',
              emoji: 'emoji',
              手势: 'gesture'
            },
            image: {
              图片链接: 'image link',
              上传图片: 'upload image',
              网络图片: 'network image'
            },
            link: {
              链接: 'link',
              链接文字: 'link text',
              取消链接: 'unlink',
              查看链接: 'view links'
            },
            video: {
              插入视频: 'insert video'
            },
            table: {
              行: 'rows',
              列: 'columns',
              的: ' ',
              表格: 'table',
              添加行: 'insert row',
              删除行: 'delete row',
              添加列: 'insert column',
              删除列: 'delete column',
              设置表头: 'set header',
              取消表头: 'cancel header',
              插入表格: 'insert table',
              删除表格: 'delete table'
            },
            code: {
              删除代码: 'delete code',
              修改代码: 'edit code',
              插入代码: 'insert code'
            }
          }
        },
        validate: {
          张图片: 'images',
          大于: 'greater than',
          图片链接: 'image link',
          不是图片: 'is not image',
          返回结果: 'return results',
          上传图片超时: 'upload image timeout',
          上传图片错误: 'upload image error',
          上传图片失败: 'upload image failed',
          插入图片错误: 'insert image error',
          一次最多上传: 'once most at upload',
          下载链接失败: 'download link failed',
          图片验证未通过: 'image validate failed',
          服务器返回状态: 'server return status',
          上传图片返回结果错误: 'upload image return results error',
          请替换为支持的图片类型: 'please replace with a supported image type',
          您插入的网络图片无法识别: 'the network picture you inserted is not recognized',
          您刚才插入的图片链接未通过编辑器校验: 'the image link you just inserted did not pass the editor verification'
        }
      }
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 历史记录 - 数据缓存的模式
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1y1cf6nhal() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/config/history.ts";
  var hash = "48a1416b0b31581d2142825bf5773f18adfe43a0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/config/history.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 13
        },
        end: {
          line: 7,
          column: 37
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      "3": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 20
        }
      },
      "4": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 17
        }
      },
      "5": {
        start: {
          line: 17,
          column: 0
        },
        end: {
          line: 20,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "compatibleMode",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 23
          }
        },
        loc: {
          start: {
            line: 11,
            column: 26
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 24
          }
        }, {
          start: {
            line: 12,
            column: 28
          },
          end: {
            line: 12,
            column: 47
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/config/history.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/config/history.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,sCAAkC;AAElC;;GAEG;AACH,SAAS,cAAc;IACnB,IAAI,SAAE,CAAC,IAAI,EAAE,IAAI,SAAE,CAAC,SAAS,EAAE;QAC3B,OAAO,IAAI,CAAA;KACd;IACD,OAAO,KAAK,CAAA;AAChB,CAAC;AAED,kBAAe;IACX,cAAc,gBAAA;IACd,cAAc,EAAE,EAAE;CACrB,CAAA",
      sourcesContent: ["/**\n * @description \u5386\u53F2\u8BB0\u5F55 - \u6570\u636E\u7F13\u5B58\u7684\u6A21\u5F0F\n * @author fangzhicong\n */\n\nimport { UA } from '../utils/util'\n\n/**\n * \u662F\u5426\u4E3A\u517C\u5BB9\u6A21\u5F0F\u3002\u8FD4\u56DE true \u8868\u793A\u5F53\u524D\u4F7F\u7528\u517C\u5BB9\uFF08\u5185\u5BB9\u5907\u4EFD\uFF09\u6A21\u5F0F\uFF0C\u5426\u5219\u4F7F\u7528\u6807\u51C6\uFF08\u5DEE\u5F02\u5907\u4EFD\uFF09\u6A21\u5F0F\n */\nfunction compatibleMode() {\n    if (UA.isIE() || UA.isOldEdge) {\n        return true\n    }\n    return false\n}\n\nexport default {\n    compatibleMode,\n    historyMaxSize: 30,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "48a1416b0b31581d2142825bf5773f18adfe43a0"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1y1cf6nhal = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1y1cf6nhal();
cov_1y1cf6nhal().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_1y1cf6nhal().s[1]++, __webpack_require__(7));
/**
 * 是否为兼容模式。返回 true 表示当前使用兼容（内容备份）模式，否则使用标准（差异备份）模式
 */

function compatibleMode() {
  cov_1y1cf6nhal().f[0]++;
  cov_1y1cf6nhal().s[2]++;

  if ((cov_1y1cf6nhal().b[1][0]++, util_1.UA.isIE()) || (cov_1y1cf6nhal().b[1][1]++, util_1.UA.isOldEdge)) {
    cov_1y1cf6nhal().b[0][0]++;
    cov_1y1cf6nhal().s[3]++;
    return true;
  } else {
    cov_1y1cf6nhal().b[0][1]++;
  }

  cov_1y1cf6nhal().s[4]++;
  return false;
}

cov_1y1cf6nhal().s[5]++;
exports["default"] = {
  compatibleMode: compatibleMode,
  historyMaxSize: 30
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1zgnm6djud() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/selection.ts";
  var hash = "4e41eb964194d747e1bf4ceb6e79e666320f4f91";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/selection.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 62
        }
      },
      "4": {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 11,
          column: 37
        }
      },
      "5": {
        start: {
          line: 12,
          column: 14
        },
        end: {
          line: 12,
          column: 75
        }
      },
      "6": {
        start: {
          line: 13,
          column: 39
        },
        end: {
          line: 243,
          column: 3
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 34
        }
      },
      "8": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 29
        }
      },
      "9": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 6
        }
      },
      "10": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 34
        }
      },
      "11": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 66,
          column: 6
        }
      },
      "12": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 33,
          column: 9
        }
      },
      "13": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 40
        }
      },
      "14": {
        start: {
          line: 32,
          column: 12
        },
        end: {
          line: 32,
          column: 19
        }
      },
      "15": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 35,
          column: 45
        }
      },
      "16": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 38,
          column: 9
        }
      },
      "17": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 19
        }
      },
      "18": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 43
        }
      },
      "19": {
        start: {
          line: 41,
          column: 29
        },
        end: {
          line: 41,
          column: 66
        }
      },
      "20": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 45,
          column: 9
        }
      },
      "21": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 19
        }
      },
      "22": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "23": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "24": {
        start: {
          line: 52,
          column: 21
        },
        end: {
          line: 52,
          column: 32
        }
      },
      "25": {
        start: {
          line: 53,
          column: 24
        },
        end: {
          line: 53,
          column: 40
        }
      },
      "26": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 65,
          column: 9
        }
      },
      "27": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 62,
          column: 13
        }
      },
      "28": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 61,
          column: 17
        }
      },
      "29": {
        start: {
          line: 57,
          column: 36
        },
        end: {
          line: 57,
          column: 56
        }
      },
      "30": {
        start: {
          line: 58,
          column: 32
        },
        end: {
          line: 58,
          column: 102
        }
      },
      "31": {
        start: {
          line: 59,
          column: 20
        },
        end: {
          line: 59,
          column: 74
        }
      },
      "32": {
        start: {
          line: 60,
          column: 20
        },
        end: {
          line: 60,
          column: 56
        }
      },
      "33": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 39
        }
      },
      "34": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 77,
          column: 6
        }
      },
      "35": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 52
        }
      },
      "36": {
        start: {
          line: 72,
          column: 34
        },
        end: {
          line: 72,
          column: 50
        }
      },
      "37": {
        start: {
          line: 73,
          column: 20
        },
        end: {
          line: 73,
          column: 38
        }
      },
      "38": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "39": {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 75,
          column: 36
        }
      },
      "40": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 89,
          column: 6
        }
      },
      "41": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 82,
          column: 38
        }
      },
      "42": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 88,
          column: 9
        }
      },
      "43": {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 84,
          column: 36
        }
      },
      "44": {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 87,
          column: 22
        }
      },
      "45": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 102,
          column: 6
        }
      },
      "46": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 40
        }
      },
      "47": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 101,
          column: 9
        }
      },
      "48": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 45
        }
      },
      "49": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 84
        }
      },
      "50": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 115,
          column: 6
        }
      },
      "51": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 40
        }
      },
      "52": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 114,
          column: 9
        }
      },
      "53": {
        start: {
          line: 112,
          column: 12
        },
        end: {
          line: 112,
          column: 36
        }
      },
      "54": {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 113,
          column: 84
        }
      },
      "55": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 128,
          column: 6
        }
      },
      "56": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 40
        }
      },
      "57": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "58": {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 125,
          column: 34
        }
      },
      "59": {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 126,
          column: 84
        }
      },
      "60": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 142,
          column: 6
        }
      },
      "61": {
        start: {
          line: 133,
          column: 20
        },
        end: {
          line: 133,
          column: 38
        }
      },
      "62": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 140,
          column: 9
        }
      },
      "63": {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 139,
          column: 13
        }
      },
      "64": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 138,
          column: 17
        }
      },
      "65": {
        start: {
          line: 137,
          column: 20
        },
        end: {
          line: 137,
          column: 32
        }
      },
      "66": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 21
        }
      },
      "67": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 153,
          column: 6
        }
      },
      "68": {
        start: {
          line: 147,
          column: 24
        },
        end: {
          line: 147,
          column: 45
        }
      },
      "69": {
        start: {
          line: 148,
          column: 16
        },
        end: {
          line: 148,
          column: 34
        }
      },
      "70": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 152,
          column: 9
        }
      },
      "71": {
        start: {
          line: 150,
          column: 12
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "72": {
        start: {
          line: 151,
          column: 12
        },
        end: {
          line: 151,
          column: 34
        }
      },
      "73": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 188,
          column: 6
        }
      },
      "74": {
        start: {
          line: 158,
          column: 21
        },
        end: {
          line: 158,
          column: 32
        }
      },
      "75": {
        start: {
          line: 159,
          column: 20
        },
        end: {
          line: 159,
          column: 35
        }
      },
      "76": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 164,
          column: 9
        }
      },
      "77": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 163,
          column: 19
        }
      },
      "78": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 168,
          column: 9
        }
      },
      "79": {
        start: {
          line: 167,
          column: 12
        },
        end: {
          line: 167,
          column: 19
        }
      },
      "80": {
        start: {
          line: 169,
          column: 8
        },
        end: {
          line: 187,
          column: 9
        }
      },
      "81": {
        start: {
          line: 171,
          column: 12
        },
        end: {
          line: 183,
          column: 13
        }
      },
      "82": {
        start: {
          line: 173,
          column: 16
        },
        end: {
          line: 173,
          column: 55
        }
      },
      "83": {
        start: {
          line: 175,
          column: 16
        },
        end: {
          line: 175,
          column: 70
        }
      },
      "84": {
        start: {
          line: 177,
          column: 16
        },
        end: {
          line: 177,
          column: 38
        }
      },
      "85": {
        start: {
          line: 180,
          column: 16
        },
        end: {
          line: 180,
          column: 71
        }
      },
      "86": {
        start: {
          line: 181,
          column: 16
        },
        end: {
          line: 181,
          column: 51
        }
      },
      "87": {
        start: {
          line: 182,
          column: 16
        },
        end: {
          line: 182,
          column: 52
        }
      },
      "88": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 214,
          column: 6
        }
      },
      "89": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 198,
          column: 9
        }
      },
      "90": {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 197,
          column: 19
        }
      },
      "91": {
        start: {
          line: 199,
          column: 19
        },
        end: {
          line: 199,
          column: 33
        }
      },
      "92": {
        start: {
          line: 200,
          column: 20
        },
        end: {
          line: 200,
          column: 42
        }
      },
      "93": {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 207,
          column: 9
        }
      },
      "94": {
        start: {
          line: 202,
          column: 12
        },
        end: {
          line: 202,
          column: 43
        }
      },
      "95": {
        start: {
          line: 206,
          column: 12
        },
        end: {
          line: 206,
          column: 35
        }
      },
      "96": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 211,
          column: 9
        }
      },
      "97": {
        start: {
          line: 210,
          column: 12
        },
        end: {
          line: 210,
          column: 36
        }
      },
      "98": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 30
        }
      },
      "99": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 223,
          column: 6
        }
      },
      "100": {
        start: {
          line: 220,
          column: 19
        },
        end: {
          line: 220,
          column: 46
        }
      },
      "101": {
        start: {
          line: 221,
          column: 8
        },
        end: {
          line: 221,
          column: 20
        }
      },
      "102": {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 222,
          column: 40
        }
      },
      "103": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 241,
          column: 6
        }
      },
      "104": {
        start: {
          line: 230,
          column: 8
        },
        end: {
          line: 230,
          column: 52
        }
      },
      "105": {
        start: {
          line: 230,
          column: 34
        },
        end: {
          line: 230,
          column: 50
        }
      },
      "106": {
        start: {
          line: 231,
          column: 20
        },
        end: {
          line: 231,
          column: 35
        }
      },
      "107": {
        start: {
          line: 232,
          column: 18
        },
        end: {
          line: 232,
          column: 54
        }
      },
      "108": {
        start: {
          line: 233,
          column: 8
        },
        end: {
          line: 235,
          column: 9
        }
      },
      "109": {
        start: {
          line: 234,
          column: 12
        },
        end: {
          line: 234,
          column: 19
        }
      },
      "110": {
        start: {
          line: 236,
          column: 8
        },
        end: {
          line: 240,
          column: 9
        }
      },
      "111": {
        start: {
          line: 237,
          column: 12
        },
        end: {
          line: 237,
          column: 38
        }
      },
      "112": {
        start: {
          line: 238,
          column: 12
        },
        end: {
          line: 238,
          column: 36
        }
      },
      "113": {
        start: {
          line: 239,
          column: 12
        },
        end: {
          line: 239,
          column: 36
        }
      },
      "114": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 29
        }
      },
      "115": {
        start: {
          line: 244,
          column: 0
        },
        end: {
          line: 244,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 39
          },
          end: {
            line: 13,
            column: 40
          }
        },
        loc: {
          start: {
            line: 13,
            column: 51
          },
          end: {
            line: 243,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "SelectionAndRange",
        decl: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 30
          }
        },
        loc: {
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 14
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 44
          }
        },
        loc: {
          start: {
            line: 21,
            column: 55
          },
          end: {
            line: 23,
            column: 5
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 44
          },
          end: {
            line: 28,
            column: 45
          }
        },
        loc: {
          start: {
            line: 28,
            column: 62
          },
          end: {
            line: 66,
            column: 5
          }
        },
        line: 28
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 71,
            column: 48
          },
          end: {
            line: 71,
            column: 49
          }
        },
        loc: {
          start: {
            line: 71,
            column: 67
          },
          end: {
            line: 77,
            column: 5
          }
        },
        line: 71
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 81,
            column: 51
          },
          end: {
            line: 81,
            column: 52
          }
        },
        loc: {
          start: {
            line: 81,
            column: 63
          },
          end: {
            line: 89,
            column: 5
          }
        },
        line: 81
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 94,
            column: 60
          },
          end: {
            line: 94,
            column: 61
          }
        },
        loc: {
          start: {
            line: 94,
            column: 77
          },
          end: {
            line: 102,
            column: 5
          }
        },
        line: 94
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 107,
            column: 56
          },
          end: {
            line: 107,
            column: 57
          }
        },
        loc: {
          start: {
            line: 107,
            column: 73
          },
          end: {
            line: 115,
            column: 5
          }
        },
        line: 107
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 120,
            column: 54
          },
          end: {
            line: 120,
            column: 55
          }
        },
        loc: {
          start: {
            line: 120,
            column: 71
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 120
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 132,
            column: 51
          },
          end: {
            line: 132,
            column: 52
          }
        },
        loc: {
          start: {
            line: 132,
            column: 63
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 132
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 146,
            column: 51
          },
          end: {
            line: 146,
            column: 52
          }
        },
        loc: {
          start: {
            line: 146,
            column: 63
          },
          end: {
            line: 153,
            column: 5
          }
        },
        line: 146
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 157,
            column: 51
          },
          end: {
            line: 157,
            column: 52
          }
        },
        loc: {
          start: {
            line: 157,
            column: 63
          },
          end: {
            line: 188,
            column: 5
          }
        },
        line: 157
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 195,
            column: 52
          },
          end: {
            line: 195,
            column: 53
          }
        },
        loc: {
          start: {
            line: 195,
            column: 89
          },
          end: {
            line: 214,
            column: 5
          }
        },
        line: 195
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 219,
            column: 60
          },
          end: {
            line: 219,
            column: 61
          }
        },
        loc: {
          start: {
            line: 219,
            column: 78
          },
          end: {
            line: 223,
            column: 5
          }
        },
        line: 219
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 229,
            column: 45
          },
          end: {
            line: 229,
            column: 46
          }
        },
        loc: {
          start: {
            line: 229,
            column: 70
          },
          end: {
            line: 241,
            column: 5
          }
        },
        line: 229
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        }],
        line: 29
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }, {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }],
        line: 42
      },
      "6": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 46
      },
      "7": {
        loc: {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 47,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 46,
            column: 62
          }
        }, {
          start: {
            line: 47,
            column: 12
          },
          end: {
            line: 47,
            column: 65
          }
        }],
        line: 46
      },
      "8": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }],
        line: 54
      },
      "9": {
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        }, {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        }],
        line: 55
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 61,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 61,
            column: 17
          }
        }, {
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 61,
            column: 17
          }
        }],
        line: 56
      },
      "11": {
        loc: {
          start: {
            line: 58,
            column: 32
          },
          end: {
            line: 58,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 77
          },
          end: {
            line: 58,
            column: 83
          }
        }, {
          start: {
            line: 58,
            column: 86
          },
          end: {
            line: 58,
            column: 102
          }
        }],
        line: 58
      },
      "12": {
        loc: {
          start: {
            line: 58,
            column: 32
          },
          end: {
            line: 58,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 32
          },
          end: {
            line: 58,
            column: 50
          }
        }, {
          start: {
            line: 58,
            column: 54
          },
          end: {
            line: 58,
            column: 74
          }
        }],
        line: 58
      },
      "13": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 52
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 52
          }
        }],
        line: 72
      },
      "14": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 76,
            column: 9
          }
        }],
        line: 74
      },
      "15": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }, {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }],
        line: 83
      },
      "16": {
        loc: {
          start: {
            line: 96,
            column: 12
          },
          end: {
            line: 96,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 12
          },
          end: {
            line: 96,
            column: 17
          }
        }, {
          start: {
            line: 96,
            column: 21
          },
          end: {
            line: 96,
            column: 39
          }
        }],
        line: 96
      },
      "17": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }, {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 101,
            column: 9
          }
        }],
        line: 98
      },
      "18": {
        loc: {
          start: {
            line: 100,
            column: 38
          },
          end: {
            line: 100,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 60
          },
          end: {
            line: 100,
            column: 64
          }
        }, {
          start: {
            line: 100,
            column: 67
          },
          end: {
            line: 100,
            column: 82
          }
        }],
        line: 100
      },
      "19": {
        loc: {
          start: {
            line: 109,
            column: 12
          },
          end: {
            line: 109,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 12
          },
          end: {
            line: 109,
            column: 17
          }
        }, {
          start: {
            line: 109,
            column: 21
          },
          end: {
            line: 109,
            column: 39
          }
        }],
        line: 109
      },
      "20": {
        loc: {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }, {
          start: {
            line: 111,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }],
        line: 111
      },
      "21": {
        loc: {
          start: {
            line: 113,
            column: 38
          },
          end: {
            line: 113,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 60
          },
          end: {
            line: 113,
            column: 64
          }
        }, {
          start: {
            line: 113,
            column: 67
          },
          end: {
            line: 113,
            column: 82
          }
        }],
        line: 113
      },
      "22": {
        loc: {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 122,
            column: 17
          }
        }, {
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 39
          }
        }],
        line: 122
      },
      "23": {
        loc: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        }, {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        }],
        line: 124
      },
      "24": {
        loc: {
          start: {
            line: 126,
            column: 38
          },
          end: {
            line: 126,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 60
          },
          end: {
            line: 126,
            column: 64
          }
        }, {
          start: {
            line: 126,
            column: 67
          },
          end: {
            line: 126,
            column: 82
          }
        }],
        line: 126
      },
      "25": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        }, {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        }],
        line: 134
      },
      "26": {
        loc: {
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 17
          }
        }, {
          start: {
            line: 134,
            column: 21
          },
          end: {
            line: 134,
            column: 41
          }
        }],
        line: 134
      },
      "27": {
        loc: {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 139,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 139,
            column: 13
          }
        }, {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 139,
            column: 13
          }
        }],
        line: 135
      },
      "28": {
        loc: {
          start: {
            line: 136,
            column: 16
          },
          end: {
            line: 138,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 16
          },
          end: {
            line: 138,
            column: 17
          }
        }, {
          start: {
            line: 136,
            column: 16
          },
          end: {
            line: 138,
            column: 17
          }
        }],
        line: 136
      },
      "29": {
        loc: {
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 152,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 152,
            column: 9
          }
        }, {
          start: {
            line: 149,
            column: 8
          },
          end: {
            line: 152,
            column: 9
          }
        }],
        line: 149
      },
      "30": {
        loc: {
          start: {
            line: 149,
            column: 12
          },
          end: {
            line: 149,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 12
          },
          end: {
            line: 149,
            column: 21
          }
        }, {
          start: {
            line: 149,
            column: 25
          },
          end: {
            line: 149,
            column: 26
          }
        }],
        line: 149
      },
      "31": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        }, {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        }],
        line: 161
      },
      "32": {
        loc: {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 168,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 168,
            column: 9
          }
        }, {
          start: {
            line: 165,
            column: 8
          },
          end: {
            line: 168,
            column: 9
          }
        }],
        line: 165
      },
      "33": {
        loc: {
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }, {
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 183,
            column: 13
          }
        }],
        line: 171
      },
      "34": {
        loc: {
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        }, {
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 198,
            column: 9
          }
        }],
        line: 196
      },
      "35": {
        loc: {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 207,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 207,
            column: 9
          }
        }, {
          start: {
            line: 201,
            column: 8
          },
          end: {
            line: 207,
            column: 9
          }
        }],
        line: 201
      },
      "36": {
        loc: {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        }, {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        }],
        line: 208
      },
      "37": {
        loc: {
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 230,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 230,
            column: 52
          }
        }, {
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 230,
            column: 52
          }
        }],
        line: 230
      },
      "38": {
        loc: {
          start: {
            line: 232,
            column: 18
          },
          end: {
            line: 232,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 232,
            column: 28
          },
          end: {
            line: 232,
            column: 29
          }
        }, {
          start: {
            line: 232,
            column: 32
          },
          end: {
            line: 232,
            column: 54
          }
        }],
        line: 232
      },
      "39": {
        loc: {
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }, {
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }],
        line: 233
      },
      "40": {
        loc: {
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        }, {
          start: {
            line: 236,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        }],
        line: 236
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/selection.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/selection.ts"],
      names: [],
      mappings: ";;;;;AAAA;;;GAGG;AACH,+DAAiD;AACjD,sCAAkC;AAElC,4EAAsE;AAEtE;IAII,2BAAY,MAAc;QAFlB,kBAAa,GAA6B,IAAI,CAAA;QAGlD,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;OAEG;IACI,oCAAQ,GAAf;QACI,OAAO,IAAI,CAAC,aAAa,CAAA;IAC7B,CAAC;IAED;;;OAGG;IACI,qCAAS,GAAhB,UAAiB,MAAc;QAC3B,IAAI,MAAM,EAAE;YACR,SAAS;YACT,IAAI,CAAC,aAAa,GAAG,MAAM,CAAA;YAC3B,OAAM;SACT;QAED,UAAU;QACV,IAAM,SAAS,GAAG,MAAM,CAAC,YAAY,EAAe,CAAA;QACpD,IAAI,SAAS,CAAC,UAAU,KAAK,CAAC,EAAE;YAC5B,OAAM;SACT;QACD,IAAM,KAAK,GAAG,SAAS,CAAC,UAAU,CAAC,CAAC,CAAC,CAAA;QAErC,iBAAiB;QACjB,IAAM,cAAc,GAAG,IAAI,CAAC,yBAAyB,CAAC,KAAK,CAAC,CAAA;QAC5D,IAAI,CAAC,cAAc,EAAE;YACjB,sBAAsB;YACtB,OAAM;SACT;QACD,IACI,cAAc,CAAC,IAAI,CAAC,iBAAiB,CAAC,KAAK,OAAO;YAClD,cAAc,CAAC,WAAW,CAAC,yBAAyB,CAAC,EACvD;YACE,eAAe;YACf,uCAAuC;YACvC,OAAM;SACT;QAED,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAI,SAAS,CAAC,SAAS,CAAC,cAAc,CAAC,EAAE;YACrC,IAAI,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,KAAK,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE;gBAChD,IAAI,SAAS,CAAC,IAAI,EAAE,KAAK,aAAa,EAAE;oBACpC,IAAM,SAAS,GAAG,SAAS,CAAC,QAAQ,EAAE,CAAA;oBACtC,IAAM,KAAK,GAAG,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,IAAI,EAAE,CAAA;oBAC/B,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAmB,EAAE,IAAI,EAAE,IAAI,CAAC,CAAA;oBACnE,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;iBACtC;aACJ;YACD,WAAW;YACX,IAAI,CAAC,aAAa,GAAG,KAAK,CAAA;SAC7B;IACL,CAAC;IAED;;;OAGG;IACI,yCAAa,GAApB,UAAqB,OAAwB;QAAxB,wBAAA,EAAA,eAAwB;QACzC,IAAM,KAAK,GAAG,IAAI,CAAC,aAAa,CAAA;QAChC,IAAI,KAAK,EAAE;YACP,KAAK,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAA;SAC1B;IACL,CAAC;IAED;;OAEG;IACI,4CAAgB,GAAvB;QACI,IAAM,KAAK,GAAG,IAAI,CAAC,aAAa,CAAA;QAChC,IAAI,KAAK,EAAE;YACP,OAAO,KAAK,CAAC,QAAQ,EAAE,CAAA;SAC1B;aAAM;YACH,OAAO,EAAE,CAAA;SACZ;IACL,CAAC;IAED;;;OAGG;IACI,qDAAyB,GAAhC,UAAiC,KAAa;QAC1C,IAAI,CAA2B,CAAA;QAC/B,CAAC,GAAG,KAAK,IAAI,IAAI,CAAC,aAAa,CAAA;QAC/B,IAAI,IAAU,CAAA;QACd,IAAI,CAAC,EAAE;YACH,IAAI,GAAG,CAAC,CAAC,uBAAuB,CAAA;YAChC,OAAO,kBAAC,CAAC,IAAI,CAAC,QAAQ,KAAK,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;SACzD;IACL,CAAC;IAED;;;OAGG;IACI,iDAAqB,GAA5B,UAA6B,KAAa;QACtC,IAAI,CAA2B,CAAA;QAC/B,CAAC,GAAG,KAAK,IAAI,IAAI,CAAC,aAAa,CAAA;QAC/B,IAAI,IAAU,CAAA;QACd,IAAI,CAAC,EAAE;YACH,IAAI,GAAG,CAAC,CAAC,cAAc,CAAA;YACvB,OAAO,kBAAC,CAAC,IAAI,CAAC,QAAQ,KAAK,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;SACzD;IACL,CAAC;IAED;;;OAGG;IACI,+CAAmB,GAA1B,UAA2B,KAAa;QACpC,IAAI,CAA2B,CAAA;QAC/B,CAAC,GAAG,KAAK,IAAI,IAAI,CAAC,aAAa,CAAA;QAC/B,IAAI,IAAU,CAAA;QACd,IAAI,CAAC,EAAE;YACH,IAAI,GAAG,CAAC,CAAC,YAAY,CAAA;YACrB,OAAO,kBAAC,CAAC,IAAI,CAAC,QAAQ,KAAK,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;SACzD;IACL,CAAC;IAED;;OAEG;IACI,4CAAgB,GAAvB;QACI,IAAM,KAAK,GAAG,IAAI,CAAC,aAAa,CAAA;QAChC,IAAI,KAAK,IAAI,KAAK,CAAC,cAAc,EAAE;YAC/B,IAAI,KAAK,CAAC,cAAc,KAAK,KAAK,CAAC,YAAY,EAAE;gBAC7C,IAAI,KAAK,CAAC,WAAW,KAAK,KAAK,CAAC,SAAS,EAAE;oBACvC,OAAO,IAAI,CAAA;iBACd;aACJ;SACJ;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED;;OAEG;IACI,4CAAgB,GAAvB;QACI,IAAM,SAAS,GAAG,MAAM,CAAC,YAAY,EAAE,CAAA;QACvC,IAAM,CAAC,GAAG,IAAI,CAAC,aAAa,CAAA;QAC5B,IAAI,SAAS,IAAI,CAAC,EAAE;YAChB,SAAS,CAAC,eAAe,EAAE,CAAA;YAC3B,SAAS,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAA;SACxB;IACL,CAAC;IAED;;OAEG;IACI,4CAAgB,GAAvB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,KAAK,GAAG,IAAI,CAAC,QAAQ,EAAE,CAAA;QAC7B,IAAI,KAAiB,CAAA;QAErB,IAAI,CAAC,KAAK,EAAE;YACR,YAAY;YACZ,OAAM;SACT;QACD,IAAI,CAAC,IAAI,CAAC,gBAAgB,EAAE,EAAE;YAC1B,8BAA8B;YAC9B,OAAM;SACT;QAED,IAAI;YACA,kBAAkB;YAClB,IAAI,SAAE,CAAC,QAAQ,EAAE,EAAE;gBACf,YAAY;gBACZ,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,SAAS,CAAC,CAAA;gBACtC,eAAe;gBACf,KAAK,CAAC,MAAM,CAAC,KAAK,CAAC,YAAY,EAAE,KAAK,CAAC,SAAS,GAAG,CAAC,CAAC,CAAA;gBACrD,KAAK;gBACL,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,CAAA;aACxB;iBAAM;gBACH,KAAK,GAAG,kBAAC,CAAC,0BAA0B,CAAC,CAAA;gBACrC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,KAAK,CAAC,CAAA;gBAClC,IAAI,CAAC,iBAAiB,CAAC,KAAK,EAAE,IAAI,CAAC,CAAA;aACtC;SACJ;QAAC,OAAO,EAAE,EAAE;YACT,gBAAgB;SACnB;IACL,CAAC;IAED;;;;;OAKG;IACI,6CAAiB,GAAxB,UAAyB,KAAiB,EAAE,OAAiB,EAAE,SAAmB;QAC9E,IAAI,CAAC,KAAK,CAAC,MAAM,EAAE;YACf,OAAM;SACT;QAED,IAAM,IAAI,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC3B,IAAM,KAAK,GAAG,QAAQ,CAAC,WAAW,EAAE,CAAA;QAEpC,IAAI,SAAS,EAAE;YACX,KAAK,CAAC,kBAAkB,CAAC,IAAI,CAAC,CAAA;SACjC;aAAM;YACH,oCAAoC;YACpC,KAAK,CAAC,UAAU,CAAC,IAAI,CAAC,CAAA;SACzB;QAED,IAAI,OAAO,IAAI,IAAI,EAAE;YACjB,8CAA8C;YAC9C,KAAK,CAAC,QAAQ,CAAC,OAAO,CAAC,CAAA;SAC1B;QAED,WAAW;QACX,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,CAAA;IACzB,CAAC;IAED;;;OAGG;IACI,qDAAyB,GAAhC,UAAiC,MAAc;QAC3C,IAAM,IAAI,GAAG,IAAI,eAAsB,CAAC,MAAM,CAAC,CAAA;QAC/C,IAAI,CAAC,IAAI,EAAE,CAAA;QACX,OAAO,IAAI,CAAC,iBAAiB,EAAE,CAAA;IACnC,CAAC;IAED;;;;OAIG;IACI,sCAAU,GAAjB,UAAkB,IAAU,EAAE,OAAwB;QAAxB,wBAAA,EAAA,eAAwB;QAClD,IAAM,KAAK,GAAG,IAAI,CAAC,QAAQ,EAAE,CAAA;QAC7B,IAAM,GAAG,GAAG,OAAO,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,UAAU,CAAC,MAAM,CAAA;QAEhD,IAAI,CAAC,KAAK,EAAE;YACR,OAAM;SACT;QACD,IAAI,IAAI,EAAE;YACN,KAAK,CAAC,QAAQ,CAAC,IAAI,EAAE,GAAG,CAAC,CAAA;YACzB,KAAK,CAAC,MAAM,CAAC,IAAI,EAAE,GAAG,CAAC,CAAA;YACvB,IAAI,CAAC,gBAAgB,EAAE,CAAA;SAC1B;IACL,CAAC;IACL,wBAAC;AAAD,CAAC,AA1PD,IA0PC;AAED,kBAAe,iBAAiB,CAAA",
      sourcesContent: ["/**\n * @description selection range API\n * @author wangfupeng\n */\nimport $, { DomElement } from '../utils/dom-core'\nimport { UA } from '../utils/util'\nimport Editor from './index'\nimport SelectionRangeTopNodes from './selection-range-top-nodes/index'\n\nclass SelectionAndRange {\n    public editor: Editor\n    private _currentRange: Range | null | undefined = null\n\n    constructor(editor: Editor) {\n        this.editor = editor\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D range\n     */\n    public getRange(): Range | null | undefined {\n        return this._currentRange\n    }\n\n    /**\n     * \u4FDD\u5B58\u9009\u533A\u8303\u56F4\n     * @param _range \u9009\u533A\u8303\u56F4\n     */\n    public saveRange(_range?: Range): void {\n        if (_range) {\n            // \u4FDD\u5B58\u5DF2\u6709\u9009\u533A\n            this._currentRange = _range\n            return\n        }\n\n        // \u83B7\u53D6\u5F53\u524D\u7684\u9009\u533A\n        const selection = window.getSelection() as Selection\n        if (selection.rangeCount === 0) {\n            return\n        }\n        const range = selection.getRangeAt(0)\n\n        // \u83B7\u53D6\u9009\u533A\u8303\u56F4\u7684 DOM \u5143\u7D20\n        const $containerElem = this.getSelectionContainerElem(range)\n        if (!$containerElem) {\n            // \u5F53 \u9009\u533A\u8303\u56F4\u5185\u6CA1\u6709 DOM\u5143\u7D20 \u5219\u629B\u51FA\n            return\n        }\n        if (\n            $containerElem.attr('contenteditable') === 'false' ||\n            $containerElem.parentUntil('[contenteditable=false]')\n        ) {\n            // \u8FD9\u91CC\u5927\u4F53\u610F\u4E49\u4E0A\u5C31\u662F\u4E2A\u4FDD\u9669\n            // \u786E\u4FDD \u7F16\u8F91\u533A\u57DF \u7684 contenteditable\u5C5E\u6027 \u7684\u503C\u4E3A true\n            return\n        }\n\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        if ($textElem.isContain($containerElem)) {\n            if ($textElem.elems[0] === $containerElem.elems[0]) {\n                if ($textElem.html() === '<p><br></p>') {\n                    const $children = $textElem.children()\n                    const $last = $children?.last()\n                    editor.selection.createRangeByElem($last as DomElement, true, true)\n                    editor.selection.restoreSelection()\n                }\n            }\n            // \u662F\u7F16\u8F91\u5185\u5BB9\u4E4B\u5185\u7684\n            this._currentRange = range\n        }\n    }\n\n    /**\n     * \u6298\u53E0\u9009\u533A\u8303\u56F4\n     * @param toStart true \u5F00\u59CB\u4F4D\u7F6E\uFF0Cfalse \u7ED3\u675F\u4F4D\u7F6E\n     */\n    public collapseRange(toStart: boolean = false): void {\n        const range = this._currentRange\n        if (range) {\n            range.collapse(toStart)\n        }\n    }\n\n    /**\n     * \u83B7\u53D6\u9009\u533A\u8303\u56F4\u5185\u7684\u6587\u5B57\n     */\n    public getSelectionText(): string {\n        const range = this._currentRange\n        if (range) {\n            return range.toString()\n        } else {\n            return ''\n        }\n    }\n\n    /**\n     * \u83B7\u53D6\u9009\u533A\u8303\u56F4\u7684 DOM \u5143\u7D20\n     * @param range \u9009\u533A\u8303\u56F4\n     */\n    public getSelectionContainerElem(range?: Range): DomElement | undefined {\n        let r: Range | null | undefined\n        r = range || this._currentRange\n        let elem: Node\n        if (r) {\n            elem = r.commonAncestorContainer\n            return $(elem.nodeType === 1 ? elem : elem.parentNode)\n        }\n    }\n\n    /**\n     * \u9009\u533A\u8303\u56F4\u5F00\u59CB\u7684 DOM \u5143\u7D20\n     * @param range \u9009\u533A\u8303\u56F4\n     */\n    public getSelectionStartElem(range?: Range): DomElement | undefined {\n        let r: Range | null | undefined\n        r = range || this._currentRange\n        let elem: Node\n        if (r) {\n            elem = r.startContainer\n            return $(elem.nodeType === 1 ? elem : elem.parentNode)\n        }\n    }\n\n    /**\n     * \u9009\u533A\u8303\u56F4\u7ED3\u675F\u7684 DOM \u5143\u7D20\n     * @param range \u9009\u533A\u8303\u56F4\n     */\n    public getSelectionEndElem(range?: Range): DomElement | undefined {\n        let r: Range | null | undefined\n        r = range || this._currentRange\n        let elem: Node\n        if (r) {\n            elem = r.endContainer\n            return $(elem.nodeType === 1 ? elem : elem.parentNode)\n        }\n    }\n\n    /**\n     * \u9009\u533A\u662F\u5426\u4E3A\u7A7A\uFF08\u6CA1\u6709\u9009\u62E9\u6587\u5B57\uFF09\n     */\n    public isSelectionEmpty(): boolean {\n        const range = this._currentRange\n        if (range && range.startContainer) {\n            if (range.startContainer === range.endContainer) {\n                if (range.startOffset === range.endOffset) {\n                    return true\n                }\n            }\n        }\n        return false\n    }\n\n    /**\n     * \u6062\u590D\u9009\u533A\u8303\u56F4\n     */\n    public restoreSelection(): void {\n        const selection = window.getSelection()\n        const r = this._currentRange\n        if (selection && r) {\n            selection.removeAllRanges()\n            selection.addRange(r)\n        }\n    }\n\n    /**\n     * \u521B\u5EFA\u4E00\u4E2A\u7A7A\u767D\uFF08\u5373 &#8203 \u5B57\u7B26\uFF09\u9009\u533A\n     */\n    public createEmptyRange(): void {\n        const editor = this.editor\n        const range = this.getRange()\n        let $elem: DomElement\n\n        if (!range) {\n            // \u5F53\u524D\u65E0 range\n            return\n        }\n        if (!this.isSelectionEmpty()) {\n            // \u5F53\u524D\u9009\u533A\u5FC5\u987B\u6CA1\u6709\u5185\u5BB9\u624D\u53EF\u4EE5\uFF0C\u6709\u5185\u5BB9\u5C31\u76F4\u63A5 return\n            return\n        }\n\n        try {\n            // \u76EE\u524D\u53EA\u652F\u6301 webkit \u5185\u6838\n            if (UA.isWebkit()) {\n                // \u63D2\u5165 &#8203\n                editor.cmd.do('insertHTML', '&#8203;')\n                // \u4FEE\u6539 offset \u4F4D\u7F6E\n                range.setEnd(range.endContainer, range.endOffset + 1)\n                // \u5B58\u50A8\n                this.saveRange(range)\n            } else {\n                $elem = $('<strong>&#8203;</strong>')\n                editor.cmd.do('insertElem', $elem)\n                this.createRangeByElem($elem, true)\n            }\n        } catch (ex) {\n            // \u90E8\u5206\u60C5\u51B5\u4E0B\u4F1A\u62A5\u9519\uFF0C\u517C\u5BB9\u4E00\u4E0B\n        }\n    }\n\n    /**\n     * \u6839\u636E DOM \u5143\u7D20\u8BBE\u7F6E\u9009\u533A\n     * @param $elem DOM \u5143\u7D20\n     * @param toStart true \u5F00\u59CB\u4F4D\u7F6E\uFF0Cfalse \u7ED3\u675F\u4F4D\u7F6E\n     * @param isContent \u662F\u5426\u9009\u4E2D $elem \u7684\u5185\u5BB9\n     */\n    public createRangeByElem($elem: DomElement, toStart?: boolean, isContent?: boolean): void {\n        if (!$elem.length) {\n            return\n        }\n\n        const elem = $elem.elems[0]\n        const range = document.createRange()\n\n        if (isContent) {\n            range.selectNodeContents(elem)\n        } else {\n            // \u5982\u679C\u7528\u6237\u6CA1\u6709\u4F20\u5165 isContent \u53C2\u6570\uFF0C\u90A3\u5C31\u9ED8\u8BA4\u4E3A false\n            range.selectNode(elem)\n        }\n\n        if (toStart != null) {\n            // \u4F20\u5165\u4E86 toStart \u53C2\u6570\uFF0C\u6298\u53E0\u9009\u533A\u3002\u5982\u679C\u6CA1\u4F20\u5165 toStart \u53C2\u6570\uFF0C\u5219\u5FFD\u7565\u8FD9\u4E00\u6B65\n            range.collapse(toStart)\n        }\n\n        // \u5B58\u50A8 range\n        this.saveRange(range)\n    }\n\n    /**\n     * \u83B7\u53D6 \u5F53\u524D \u9009\u53D6\u8303\u56F4\u7684 \u9876\u7EA7(\u6BB5\u843D) \u5143\u7D20\n     * @param $editor\n     */\n    public getSelectionRangeTopNodes(editor: Editor): DomElement[] {\n        const item = new SelectionRangeTopNodes(editor)\n        item.init()\n        return item.getSelectionNodes()\n    }\n\n    /**\n     * \u79FB\u52A8\u5149\u6807\u4F4D\u7F6E\n     * @param {Node} node \u5143\u7D20\u8282\u70B9\n     * @param {Boolean} toStart \u4E3Atrue\u5149\u6807\u5728\u5F00\u59CB\u4F4D\u7F6E \u4E3Afalse\u5728\u7ED3\u675F\u4F4D\u7F6E \u9ED8\u8BA4\u5728\u7ED3\u675F\u4F4D\u7F6E\n     */\n    public moveCursor(node: Node, toStart: boolean = false) {\n        const range = this.getRange()\n        const pos = toStart ? 0 : node.childNodes.length\n\n        if (!range) {\n            return\n        }\n        if (node) {\n            range.setStart(node, pos)\n            range.setEnd(node, pos)\n            this.restoreSelection()\n        }\n    }\n}\n\nexport default SelectionAndRange\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4e41eb964194d747e1bf4ceb6e79e666320f4f91"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1zgnm6djud = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1zgnm6djud();

var __importDefault = (cov_1zgnm6djud().s[0]++, (cov_1zgnm6djud().b[0][0]++, void 0) && (cov_1zgnm6djud().b[0][1]++, (void 0).__importDefault) || (cov_1zgnm6djud().b[0][2]++, function (mod) {
  cov_1zgnm6djud().f[0]++;
  cov_1zgnm6djud().s[1]++;
  return (cov_1zgnm6djud().b[2][0]++, mod) && (cov_1zgnm6djud().b[2][1]++, mod.__esModule) ? (cov_1zgnm6djud().b[1][0]++, mod) : (cov_1zgnm6djud().b[1][1]++, {
    "default": mod
  });
}));

cov_1zgnm6djud().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description selection range API
 * @author wangfupeng
 */

var dom_core_1 = (cov_1zgnm6djud().s[3]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_1zgnm6djud().s[4]++, __webpack_require__(7));
var index_1 = (cov_1zgnm6djud().s[5]++, __importDefault(__webpack_require__(278)));
var SelectionAndRange = (
/** @class */
cov_1zgnm6djud().s[6]++, function () {
  cov_1zgnm6djud().f[1]++;

  function SelectionAndRange(editor) {
    cov_1zgnm6djud().f[2]++;
    cov_1zgnm6djud().s[7]++;
    this._currentRange = null;
    cov_1zgnm6djud().s[8]++;
    this.editor = editor;
  }
  /**
   * 获取当前 range
   */


  cov_1zgnm6djud().s[9]++;

  SelectionAndRange.prototype.getRange = function () {
    cov_1zgnm6djud().f[3]++;
    cov_1zgnm6djud().s[10]++;
    return this._currentRange;
  };
  /**
   * 保存选区范围
   * @param _range 选区范围
   */


  cov_1zgnm6djud().s[11]++;

  SelectionAndRange.prototype.saveRange = function (_range) {
    cov_1zgnm6djud().f[4]++;
    cov_1zgnm6djud().s[12]++;

    if (_range) {
      cov_1zgnm6djud().b[3][0]++;
      cov_1zgnm6djud().s[13]++;
      // 保存已有选区
      this._currentRange = _range;
      cov_1zgnm6djud().s[14]++;
      return;
    } else {
      cov_1zgnm6djud().b[3][1]++;
    } // 获取当前的选区


    var selection = (cov_1zgnm6djud().s[15]++, window.getSelection());
    cov_1zgnm6djud().s[16]++;

    if (selection.rangeCount === 0) {
      cov_1zgnm6djud().b[4][0]++;
      cov_1zgnm6djud().s[17]++;
      return;
    } else {
      cov_1zgnm6djud().b[4][1]++;
    }

    var range = (cov_1zgnm6djud().s[18]++, selection.getRangeAt(0)); // 获取选区范围的 DOM 元素

    var $containerElem = (cov_1zgnm6djud().s[19]++, this.getSelectionContainerElem(range));
    cov_1zgnm6djud().s[20]++;

    if (!$containerElem) {
      cov_1zgnm6djud().b[5][0]++;
      cov_1zgnm6djud().s[21]++;
      // 当 选区范围内没有 DOM元素 则抛出
      return;
    } else {
      cov_1zgnm6djud().b[5][1]++;
    }

    cov_1zgnm6djud().s[22]++;

    if ((cov_1zgnm6djud().b[7][0]++, $containerElem.attr('contenteditable') === 'false') || (cov_1zgnm6djud().b[7][1]++, $containerElem.parentUntil('[contenteditable=false]'))) {
      cov_1zgnm6djud().b[6][0]++;
      cov_1zgnm6djud().s[23]++;
      // 这里大体意义上就是个保险
      // 确保 编辑区域 的 contenteditable属性 的值为 true
      return;
    } else {
      cov_1zgnm6djud().b[6][1]++;
    }

    var editor = (cov_1zgnm6djud().s[24]++, this.editor);
    var $textElem = (cov_1zgnm6djud().s[25]++, editor.$textElem);
    cov_1zgnm6djud().s[26]++;

    if ($textElem.isContain($containerElem)) {
      cov_1zgnm6djud().b[8][0]++;
      cov_1zgnm6djud().s[27]++;

      if ($textElem.elems[0] === $containerElem.elems[0]) {
        cov_1zgnm6djud().b[9][0]++;
        cov_1zgnm6djud().s[28]++;

        if ($textElem.html() === '<p><br></p>') {
          cov_1zgnm6djud().b[10][0]++;
          var $children = (cov_1zgnm6djud().s[29]++, $textElem.children());
          var $last = (cov_1zgnm6djud().s[30]++, (cov_1zgnm6djud().b[12][0]++, $children === null) || (cov_1zgnm6djud().b[12][1]++, $children === void 0) ? (cov_1zgnm6djud().b[11][0]++, void 0) : (cov_1zgnm6djud().b[11][1]++, $children.last()));
          cov_1zgnm6djud().s[31]++;
          editor.selection.createRangeByElem($last, true, true);
          cov_1zgnm6djud().s[32]++;
          editor.selection.restoreSelection();
        } else {
          cov_1zgnm6djud().b[10][1]++;
        }
      } else {
        cov_1zgnm6djud().b[9][1]++;
      } // 是编辑内容之内的


      cov_1zgnm6djud().s[33]++;
      this._currentRange = range;
    } else {
      cov_1zgnm6djud().b[8][1]++;
    }
  };
  /**
   * 折叠选区范围
   * @param toStart true 开始位置，false 结束位置
   */


  cov_1zgnm6djud().s[34]++;

  SelectionAndRange.prototype.collapseRange = function (toStart) {
    cov_1zgnm6djud().f[5]++;
    cov_1zgnm6djud().s[35]++;

    if (toStart === void 0) {
      cov_1zgnm6djud().b[13][0]++;
      cov_1zgnm6djud().s[36]++;
      toStart = false;
    } else {
      cov_1zgnm6djud().b[13][1]++;
    }

    var range = (cov_1zgnm6djud().s[37]++, this._currentRange);
    cov_1zgnm6djud().s[38]++;

    if (range) {
      cov_1zgnm6djud().b[14][0]++;
      cov_1zgnm6djud().s[39]++;
      range.collapse(toStart);
    } else {
      cov_1zgnm6djud().b[14][1]++;
    }
  };
  /**
   * 获取选区范围内的文字
   */


  cov_1zgnm6djud().s[40]++;

  SelectionAndRange.prototype.getSelectionText = function () {
    cov_1zgnm6djud().f[6]++;
    var range = (cov_1zgnm6djud().s[41]++, this._currentRange);
    cov_1zgnm6djud().s[42]++;

    if (range) {
      cov_1zgnm6djud().b[15][0]++;
      cov_1zgnm6djud().s[43]++;
      return range.toString();
    } else {
      cov_1zgnm6djud().b[15][1]++;
      cov_1zgnm6djud().s[44]++;
      return '';
    }
  };
  /**
   * 获取选区范围的 DOM 元素
   * @param range 选区范围
   */


  cov_1zgnm6djud().s[45]++;

  SelectionAndRange.prototype.getSelectionContainerElem = function (range) {
    cov_1zgnm6djud().f[7]++;
    var r;
    cov_1zgnm6djud().s[46]++;
    r = (cov_1zgnm6djud().b[16][0]++, range) || (cov_1zgnm6djud().b[16][1]++, this._currentRange);
    var elem;
    cov_1zgnm6djud().s[47]++;

    if (r) {
      cov_1zgnm6djud().b[17][0]++;
      cov_1zgnm6djud().s[48]++;
      elem = r.commonAncestorContainer;
      cov_1zgnm6djud().s[49]++;
      return dom_core_1["default"](elem.nodeType === 1 ? (cov_1zgnm6djud().b[18][0]++, elem) : (cov_1zgnm6djud().b[18][1]++, elem.parentNode));
    } else {
      cov_1zgnm6djud().b[17][1]++;
    }
  };
  /**
   * 选区范围开始的 DOM 元素
   * @param range 选区范围
   */


  cov_1zgnm6djud().s[50]++;

  SelectionAndRange.prototype.getSelectionStartElem = function (range) {
    cov_1zgnm6djud().f[8]++;
    var r;
    cov_1zgnm6djud().s[51]++;
    r = (cov_1zgnm6djud().b[19][0]++, range) || (cov_1zgnm6djud().b[19][1]++, this._currentRange);
    var elem;
    cov_1zgnm6djud().s[52]++;

    if (r) {
      cov_1zgnm6djud().b[20][0]++;
      cov_1zgnm6djud().s[53]++;
      elem = r.startContainer;
      cov_1zgnm6djud().s[54]++;
      return dom_core_1["default"](elem.nodeType === 1 ? (cov_1zgnm6djud().b[21][0]++, elem) : (cov_1zgnm6djud().b[21][1]++, elem.parentNode));
    } else {
      cov_1zgnm6djud().b[20][1]++;
    }
  };
  /**
   * 选区范围结束的 DOM 元素
   * @param range 选区范围
   */


  cov_1zgnm6djud().s[55]++;

  SelectionAndRange.prototype.getSelectionEndElem = function (range) {
    cov_1zgnm6djud().f[9]++;
    var r;
    cov_1zgnm6djud().s[56]++;
    r = (cov_1zgnm6djud().b[22][0]++, range) || (cov_1zgnm6djud().b[22][1]++, this._currentRange);
    var elem;
    cov_1zgnm6djud().s[57]++;

    if (r) {
      cov_1zgnm6djud().b[23][0]++;
      cov_1zgnm6djud().s[58]++;
      elem = r.endContainer;
      cov_1zgnm6djud().s[59]++;
      return dom_core_1["default"](elem.nodeType === 1 ? (cov_1zgnm6djud().b[24][0]++, elem) : (cov_1zgnm6djud().b[24][1]++, elem.parentNode));
    } else {
      cov_1zgnm6djud().b[23][1]++;
    }
  };
  /**
   * 选区是否为空（没有选择文字）
   */


  cov_1zgnm6djud().s[60]++;

  SelectionAndRange.prototype.isSelectionEmpty = function () {
    cov_1zgnm6djud().f[10]++;
    var range = (cov_1zgnm6djud().s[61]++, this._currentRange);
    cov_1zgnm6djud().s[62]++;

    if ((cov_1zgnm6djud().b[26][0]++, range) && (cov_1zgnm6djud().b[26][1]++, range.startContainer)) {
      cov_1zgnm6djud().b[25][0]++;
      cov_1zgnm6djud().s[63]++;

      if (range.startContainer === range.endContainer) {
        cov_1zgnm6djud().b[27][0]++;
        cov_1zgnm6djud().s[64]++;

        if (range.startOffset === range.endOffset) {
          cov_1zgnm6djud().b[28][0]++;
          cov_1zgnm6djud().s[65]++;
          return true;
        } else {
          cov_1zgnm6djud().b[28][1]++;
        }
      } else {
        cov_1zgnm6djud().b[27][1]++;
      }
    } else {
      cov_1zgnm6djud().b[25][1]++;
    }

    cov_1zgnm6djud().s[66]++;
    return false;
  };
  /**
   * 恢复选区范围
   */


  cov_1zgnm6djud().s[67]++;

  SelectionAndRange.prototype.restoreSelection = function () {
    cov_1zgnm6djud().f[11]++;
    var selection = (cov_1zgnm6djud().s[68]++, window.getSelection());
    var r = (cov_1zgnm6djud().s[69]++, this._currentRange);
    cov_1zgnm6djud().s[70]++;

    if ((cov_1zgnm6djud().b[30][0]++, selection) && (cov_1zgnm6djud().b[30][1]++, r)) {
      cov_1zgnm6djud().b[29][0]++;
      cov_1zgnm6djud().s[71]++;
      selection.removeAllRanges();
      cov_1zgnm6djud().s[72]++;
      selection.addRange(r);
    } else {
      cov_1zgnm6djud().b[29][1]++;
    }
  };
  /**
   * 创建一个空白（即 &#8203 字符）选区
   */


  cov_1zgnm6djud().s[73]++;

  SelectionAndRange.prototype.createEmptyRange = function () {
    cov_1zgnm6djud().f[12]++;
    var editor = (cov_1zgnm6djud().s[74]++, this.editor);
    var range = (cov_1zgnm6djud().s[75]++, this.getRange());
    var $elem;
    cov_1zgnm6djud().s[76]++;

    if (!range) {
      cov_1zgnm6djud().b[31][0]++;
      cov_1zgnm6djud().s[77]++;
      // 当前无 range
      return;
    } else {
      cov_1zgnm6djud().b[31][1]++;
    }

    cov_1zgnm6djud().s[78]++;

    if (!this.isSelectionEmpty()) {
      cov_1zgnm6djud().b[32][0]++;
      cov_1zgnm6djud().s[79]++;
      // 当前选区必须没有内容才可以，有内容就直接 return
      return;
    } else {
      cov_1zgnm6djud().b[32][1]++;
    }

    cov_1zgnm6djud().s[80]++;

    try {
      cov_1zgnm6djud().s[81]++;

      // 目前只支持 webkit 内核
      if (util_1.UA.isWebkit()) {
        cov_1zgnm6djud().b[33][0]++;
        cov_1zgnm6djud().s[82]++;
        // 插入 &#8203
        editor.cmd["do"]('insertHTML', '&#8203;'); // 修改 offset 位置

        cov_1zgnm6djud().s[83]++;
        range.setEnd(range.endContainer, range.endOffset + 1); // 存储

        cov_1zgnm6djud().s[84]++;
        this.saveRange(range);
      } else {
        cov_1zgnm6djud().b[33][1]++;
        cov_1zgnm6djud().s[85]++;
        $elem = dom_core_1["default"]('<strong>&#8203;</strong>');
        cov_1zgnm6djud().s[86]++;
        editor.cmd["do"]('insertElem', $elem);
        cov_1zgnm6djud().s[87]++;
        this.createRangeByElem($elem, true);
      }
    } catch (ex) {// 部分情况下会报错，兼容一下
    }
  };
  /**
   * 根据 DOM 元素设置选区
   * @param $elem DOM 元素
   * @param toStart true 开始位置，false 结束位置
   * @param isContent 是否选中 $elem 的内容
   */


  cov_1zgnm6djud().s[88]++;

  SelectionAndRange.prototype.createRangeByElem = function ($elem, toStart, isContent) {
    cov_1zgnm6djud().f[13]++;
    cov_1zgnm6djud().s[89]++;

    if (!$elem.length) {
      cov_1zgnm6djud().b[34][0]++;
      cov_1zgnm6djud().s[90]++;
      return;
    } else {
      cov_1zgnm6djud().b[34][1]++;
    }

    var elem = (cov_1zgnm6djud().s[91]++, $elem.elems[0]);
    var range = (cov_1zgnm6djud().s[92]++, document.createRange());
    cov_1zgnm6djud().s[93]++;

    if (isContent) {
      cov_1zgnm6djud().b[35][0]++;
      cov_1zgnm6djud().s[94]++;
      range.selectNodeContents(elem);
    } else {
      cov_1zgnm6djud().b[35][1]++;
      cov_1zgnm6djud().s[95]++;
      // 如果用户没有传入 isContent 参数，那就默认为 false
      range.selectNode(elem);
    }

    cov_1zgnm6djud().s[96]++;

    if (toStart != null) {
      cov_1zgnm6djud().b[36][0]++;
      cov_1zgnm6djud().s[97]++;
      // 传入了 toStart 参数，折叠选区。如果没传入 toStart 参数，则忽略这一步
      range.collapse(toStart);
    } else {
      cov_1zgnm6djud().b[36][1]++;
    } // 存储 range


    cov_1zgnm6djud().s[98]++;
    this.saveRange(range);
  };
  /**
   * 获取 当前 选取范围的 顶级(段落) 元素
   * @param $editor
   */


  cov_1zgnm6djud().s[99]++;

  SelectionAndRange.prototype.getSelectionRangeTopNodes = function (editor) {
    cov_1zgnm6djud().f[14]++;
    var item = (cov_1zgnm6djud().s[100]++, new index_1["default"](editor));
    cov_1zgnm6djud().s[101]++;
    item.init();
    cov_1zgnm6djud().s[102]++;
    return item.getSelectionNodes();
  };
  /**
   * 移动光标位置
   * @param {Node} node 元素节点
   * @param {Boolean} toStart 为true光标在开始位置 为false在结束位置 默认在结束位置
   */


  cov_1zgnm6djud().s[103]++;

  SelectionAndRange.prototype.moveCursor = function (node, toStart) {
    cov_1zgnm6djud().f[15]++;
    cov_1zgnm6djud().s[104]++;

    if (toStart === void 0) {
      cov_1zgnm6djud().b[37][0]++;
      cov_1zgnm6djud().s[105]++;
      toStart = false;
    } else {
      cov_1zgnm6djud().b[37][1]++;
    }

    var range = (cov_1zgnm6djud().s[106]++, this.getRange());
    var pos = (cov_1zgnm6djud().s[107]++, toStart ? (cov_1zgnm6djud().b[38][0]++, 0) : (cov_1zgnm6djud().b[38][1]++, node.childNodes.length));
    cov_1zgnm6djud().s[108]++;

    if (!range) {
      cov_1zgnm6djud().b[39][0]++;
      cov_1zgnm6djud().s[109]++;
      return;
    } else {
      cov_1zgnm6djud().b[39][1]++;
    }

    cov_1zgnm6djud().s[110]++;

    if (node) {
      cov_1zgnm6djud().b[40][0]++;
      cov_1zgnm6djud().s[111]++;
      range.setStart(node, pos);
      cov_1zgnm6djud().s[112]++;
      range.setEnd(node, pos);
      cov_1zgnm6djud().s[113]++;
      this.restoreSelection();
    } else {
      cov_1zgnm6djud().b[40][1]++;
    }
  };

  cov_1zgnm6djud().s[114]++;
  return SelectionAndRange;
}());
cov_1zgnm6djud().s[115]++;
exports["default"] = SelectionAndRange;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 选取范围所有顶级(段落)节点
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_c1t46h9x5() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/selection-range-top-nodes/index.ts";
  var hash = "d9f0b995e4da75b7ce2a006d2fd9a41e4d8ab779";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/selection-range-top-nodes/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 12,
          column: 44
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "5": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 29
        }
      },
      "6": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 28
        }
      },
      "7": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 111
        }
      },
      "8": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 107
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      "10": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 71
        }
      },
      "11": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 36,
          column: 6
        }
      },
      "12": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 55
        }
      },
      "13": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 44,
          column: 6
        }
      },
      "14": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 89
        }
      },
      "15": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "16": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 62
        }
      },
      "17": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 64,
          column: 6
        }
      },
      "18": {
        start: {
          line: 57,
          column: 20
        },
        end: {
          line: 57,
          column: 49
        }
      },
      "19": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 63,
          column: 9
        }
      },
      "20": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 36
        }
      },
      "21": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 62,
          column: 13
        }
      },
      "22": {
        start: {
          line: 61,
          column: 16
        },
        end: {
          line: 61,
          column: 70
        }
      },
      "23": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "24": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 30
        }
      },
      "25": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "26": {
        start: {
          line: 76,
          column: 0
        },
        end: {
          line: 76,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 44
          },
          end: {
            line: 12,
            column: 45
          }
        },
        loc: {
          start: {
            line: 12,
            column: 56
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "SelectionRangeTopNodes",
        decl: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 17,
            column: 35
          }
        },
        loc: {
          start: {
            line: 17,
            column: 44
          },
          end: {
            line: 23,
            column: 5
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 44
          },
          end: {
            line: 27,
            column: 45
          }
        },
        loc: {
          start: {
            line: 27,
            column: 56
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 51
          },
          end: {
            line: 34,
            column: 52
          }
        },
        loc: {
          start: {
            line: 34,
            column: 68
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 34
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 41,
            column: 49
          },
          end: {
            line: 41,
            column: 50
          }
        },
        loc: {
          start: {
            line: 41,
            column: 66
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 41
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 54
          },
          end: {
            line: 49,
            column: 55
          }
        },
        loc: {
          start: {
            line: 49,
            column: 71
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 56,
            column: 60
          },
          end: {
            line: 56,
            column: 61
          }
        },
        loc: {
          start: {
            line: 56,
            column: 77
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 56
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 68,
            column: 57
          },
          end: {
            line: 68,
            column: 58
          }
        },
        loc: {
          start: {
            line: 68,
            column: 69
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 68
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 43,
            column: 64
          },
          end: {
            line: 43,
            column: 70
          }
        }, {
          start: {
            line: 43,
            column: 73
          },
          end: {
            line: 43,
            column: 88
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 43,
            column: 44
          }
        }, {
          start: {
            line: 43,
            column: 48
          },
          end: {
            line: 43,
            column: 61
          }
        }],
        line: 43
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        }, {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 62,
            column: 13
          }
        }],
        line: 60
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/selection-range-top-nodes/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/selection-range-top-nodes/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,kEAAoD;AAGpD,OAAO;AACP;IAOI;;;OAGG;IACH,gCAAY,MAAc;QACtB,QAAQ;QACR,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QACpB,IAAI,CAAC,SAAS,GAAG,EAAE,CAAA;QACnB,IAAI,CAAC,UAAU,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAC,UAAU,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACrF,IAAI,CAAC,QAAQ,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,mBAAmB,EAAE,CAAC,CAAC,UAAU,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;IACrF,CAAC;IAED;;OAEG;IACI,qCAAI,GAAX;QACI,IAAI,CAAC,oBAAoB,CAAC,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC,CAAA;IACjD,CAAC;IAED;;;OAGG;IACK,4CAAW,GAAnB,UAAoB,KAA+B;QAC/C,IAAI,CAAC,SAAS,CAAC,IAAI,CAAC,kBAAC,CAAC,KAAK,CAAC,CAAC,CAAA;IACjC,CAAC;IAED;;;OAGG;IACK,0CAAS,GAAjB,UAAkB,KAAiB;;QAC/B,aAAO,IAAI,CAAC,QAAQ,0CAAE,KAAK,CAAC,KAAK,EAAC;IACtC,CAAC;IAED;;;OAGG;IACK,+CAAc,GAAtB,UAAuB,KAAiB;QACpC,OAAO,kBAAC,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,CAAA;IACxC,CAAC;IAED;;;OAGG;IACK,qDAAoB,GAA5B,UAA6B,KAAiB;QAC1C,IAAM,KAAK,GAAG,KAAK,CAAC,UAAU,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QAC3C,IAAI,KAAK,CAAC,MAAM,GAAG,CAAC,EAAE;YAClB,IAAI,CAAC,WAAW,CAAC,KAAK,CAAC,CAAA;YACvB,IAAI,CAAC,IAAI,CAAC,SAAS,CAAC,KAAK,CAAC,EAAE;gBACxB,IAAI,CAAC,oBAAoB,CAAC,IAAI,CAAC,cAAc,CAAC,KAAK,CAAC,CAAC,CAAA;aACxD;SACJ;IACL,CAAC;IAED;;OAEG;IACI,kDAAiB,GAAxB;QACI,OAAO,IAAI,CAAC,SAAS,CAAA;IACzB,CAAC;IACL,6BAAC;AAAD,CAAC,AAtED,IAsEC;AAED;;GAEG;AACH,kBAAe,sBAAsB,CAAA",
      sourcesContent: ["/**\n * @description \u9009\u53D6\u8303\u56F4\u6240\u6709\u9876\u7EA7(\u6BB5\u843D)\u8282\u70B9\n * @author tonghan\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../index'\n\n// \u6784\u9020\u51FD\u6570\nclass SelectionRangeTopNodes {\n    // \u5B9A\u4E49\u5C5E\u6027\n    editor: Editor\n    $nodeList: DomElement[]\n    $startElem: DomElement | undefined\n    $endElem: DomElement | undefined\n\n    /**\n     * \u6784\u9020\u51FD\u6570\n     * @param editor\n     */\n    constructor(editor: Editor) {\n        // \u521D\u59CB\u5316\u5C5E\u6027\n        this.editor = editor\n        this.$nodeList = []\n        this.$startElem = $(editor.selection.getSelectionStartElem()).getNodeTop(this.editor)\n        this.$endElem = $(editor.selection.getSelectionEndElem()).getNodeTop(this.editor)\n    }\n\n    /**\n     * \u521D\u59CB\u5316\n     */\n    public init(): void {\n        this.recordSelectionNodes($(this.$startElem))\n    }\n\n    /**\n     * \u6DFB\u52A0 \u8282\u70B9 \u5230nodeList\n     * @param $node \u8282\u70B9\n     */\n    private addNodeList($node: DomElement | HTMLElement): void {\n        this.$nodeList.push($($node))\n    }\n\n    /**\n     * \u662F\u5426\u662F \u9009\u533A\u7ED3\u675F \u8282\u70B9\n     * @param $node \u8282\u70B9\n     */\n    private isEndElem($node: DomElement): boolean | undefined {\n        return this.$endElem?.equal($node)\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u8282\u70B9\u7684\u4E0B\u4E00\u4E2A\u5144\u5F1F\u8282\u70B9\n     * @param $node \u8282\u70B9\n     */\n    private getNextSibling($node: DomElement): DomElement {\n        return $($node.elems[0].nextSibling)\n    }\n\n    /**\n     * \u8BB0\u5F55\u8282\u70B9 - \u4ECE\u9009\u533A\u5F00\u59CB\u8282\u70B9\u5F00\u59CB \u4E00\u76F4\u5230\u5339\u914D\u5230\u9009\u533A\u7ED3\u675F\u8282\u70B9\u4E3A\u6B62\n     * @param $node \u8282\u70B9\n     */\n    private recordSelectionNodes($node: DomElement): void {\n        const $elem = $node.getNodeTop(this.editor)\n        if ($elem.length > 0) {\n            this.addNodeList($elem)\n            if (!this.isEndElem($elem)) {\n                this.recordSelectionNodes(this.getNextSibling($elem))\n            }\n        }\n    }\n\n    /**\n     * \u83B7\u53D6 \u9009\u4E2D\u8282\u70B9\u5217\u8868\n     */\n    public getSelectionNodes(): DomElement[] {\n        return this.$nodeList\n    }\n}\n\n/**\n * \u5BFC\u51FA\n */\nexport default SelectionRangeTopNodes\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d9f0b995e4da75b7ce2a006d2fd9a41e4d8ab779"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_c1t46h9x5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_c1t46h9x5();

var __importDefault = (cov_c1t46h9x5().s[0]++, (cov_c1t46h9x5().b[0][0]++, void 0) && (cov_c1t46h9x5().b[0][1]++, (void 0).__importDefault) || (cov_c1t46h9x5().b[0][2]++, function (mod) {
  cov_c1t46h9x5().f[0]++;
  cov_c1t46h9x5().s[1]++;
  return (cov_c1t46h9x5().b[2][0]++, mod) && (cov_c1t46h9x5().b[2][1]++, mod.__esModule) ? (cov_c1t46h9x5().b[1][0]++, mod) : (cov_c1t46h9x5().b[1][1]++, {
    "default": mod
  });
}));

cov_c1t46h9x5().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_c1t46h9x5().s[3]++, __importDefault(__webpack_require__(2))); // 构造函数

var SelectionRangeTopNodes = (
/** @class */
cov_c1t46h9x5().s[4]++, function () {
  cov_c1t46h9x5().f[1]++;

  /**
   * 构造函数
   * @param editor
   */
  function SelectionRangeTopNodes(editor) {
    cov_c1t46h9x5().f[2]++;
    cov_c1t46h9x5().s[5]++;
    // 初始化属性
    this.editor = editor;
    cov_c1t46h9x5().s[6]++;
    this.$nodeList = [];
    cov_c1t46h9x5().s[7]++;
    this.$startElem = dom_core_1["default"](editor.selection.getSelectionStartElem()).getNodeTop(this.editor);
    cov_c1t46h9x5().s[8]++;
    this.$endElem = dom_core_1["default"](editor.selection.getSelectionEndElem()).getNodeTop(this.editor);
  }
  /**
   * 初始化
   */


  cov_c1t46h9x5().s[9]++;

  SelectionRangeTopNodes.prototype.init = function () {
    cov_c1t46h9x5().f[3]++;
    cov_c1t46h9x5().s[10]++;
    this.recordSelectionNodes(dom_core_1["default"](this.$startElem));
  };
  /**
   * 添加 节点 到nodeList
   * @param $node 节点
   */


  cov_c1t46h9x5().s[11]++;

  SelectionRangeTopNodes.prototype.addNodeList = function ($node) {
    cov_c1t46h9x5().f[4]++;
    cov_c1t46h9x5().s[12]++;
    this.$nodeList.push(dom_core_1["default"]($node));
  };
  /**
   * 是否是 选区结束 节点
   * @param $node 节点
   */


  cov_c1t46h9x5().s[13]++;

  SelectionRangeTopNodes.prototype.isEndElem = function ($node) {
    cov_c1t46h9x5().f[5]++;

    var _a;

    cov_c1t46h9x5().s[14]++;
    return (cov_c1t46h9x5().b[4][0]++, (_a = this.$endElem) === null) || (cov_c1t46h9x5().b[4][1]++, _a === void 0) ? (cov_c1t46h9x5().b[3][0]++, void 0) : (cov_c1t46h9x5().b[3][1]++, _a.equal($node));
  };
  /**
   * 获取当前节点的下一个兄弟节点
   * @param $node 节点
   */


  cov_c1t46h9x5().s[15]++;

  SelectionRangeTopNodes.prototype.getNextSibling = function ($node) {
    cov_c1t46h9x5().f[6]++;
    cov_c1t46h9x5().s[16]++;
    return dom_core_1["default"]($node.elems[0].nextSibling);
  };
  /**
   * 记录节点 - 从选区开始节点开始 一直到匹配到选区结束节点为止
   * @param $node 节点
   */


  cov_c1t46h9x5().s[17]++;

  SelectionRangeTopNodes.prototype.recordSelectionNodes = function ($node) {
    cov_c1t46h9x5().f[7]++;
    var $elem = (cov_c1t46h9x5().s[18]++, $node.getNodeTop(this.editor));
    cov_c1t46h9x5().s[19]++;

    if ($elem.length > 0) {
      cov_c1t46h9x5().b[5][0]++;
      cov_c1t46h9x5().s[20]++;
      this.addNodeList($elem);
      cov_c1t46h9x5().s[21]++;

      if (!this.isEndElem($elem)) {
        cov_c1t46h9x5().b[6][0]++;
        cov_c1t46h9x5().s[22]++;
        this.recordSelectionNodes(this.getNextSibling($elem));
      } else {
        cov_c1t46h9x5().b[6][1]++;
      }
    } else {
      cov_c1t46h9x5().b[5][1]++;
    }
  };
  /**
   * 获取 选中节点列表
   */


  cov_c1t46h9x5().s[23]++;

  SelectionRangeTopNodes.prototype.getSelectionNodes = function () {
    cov_c1t46h9x5().f[8]++;
    cov_c1t46h9x5().s[24]++;
    return this.$nodeList;
  };

  cov_c1t46h9x5().s[25]++;
  return SelectionRangeTopNodes;
}());
/**
 * 导出
 */

cov_c1t46h9x5().s[26]++;
exports["default"] = SelectionRangeTopNodes;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 封装 document.execCommand
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_f95dcq80g() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/command.ts";
  var hash = "24418cd7fd2aafd454695dbc78273f606345b0a4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/command.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 62
        }
      },
      "4": {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 119,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "6": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "7": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 32
        }
      },
      "8": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 24,
          column: 9
        }
      },
      "9": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 64
        }
      },
      "10": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "11": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 29,
          column: 9
        }
      },
      "12": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 19
        }
      },
      "13": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 37
        }
      },
      "14": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 44,
          column: 9
        }
      },
      "15": {
        start: {
          line: 35,
          column: 16
        },
        end: {
          line: 35,
          column: 39
        }
      },
      "16": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 36,
          column: 22
        }
      },
      "17": {
        start: {
          line: 38,
          column: 16
        },
        end: {
          line: 38,
          column: 39
        }
      },
      "18": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 39,
          column: 22
        }
      },
      "19": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 46
        }
      },
      "20": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 43,
          column: 22
        }
      },
      "21": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 36
        }
      },
      "22": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "23": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 37
        }
      },
      "24": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 74,
          column: 6
        }
      },
      "25": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 56,
          column: 32
        }
      },
      "26": {
        start: {
          line: 57,
          column: 20
        },
        end: {
          line: 57,
          column: 47
        }
      },
      "27": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 59,
          column: 19
        }
      },
      "28": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 19
        }
      },
      "29": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "30": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 49
        }
      },
      "31": {
        start: {
          line: 64,
          column: 13
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "32": {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 66,
          column: 35
        }
      },
      "33": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 64
        }
      },
      "34": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 45
        }
      },
      "35": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "36": {
        start: {
          line: 80,
          column: 21
        },
        end: {
          line: 80,
          column: 32
        }
      },
      "37": {
        start: {
          line: 81,
          column: 20
        },
        end: {
          line: 81,
          column: 47
        }
      },
      "38": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 83,
          column: 19
        }
      },
      "39": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 83,
          column: 19
        }
      },
      "40": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 87,
          column: 9
        }
      },
      "41": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 85,
          column: 35
        }
      },
      "42": {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 86,
          column: 45
        }
      },
      "43": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 96,
          column: 6
        }
      },
      "44": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 95,
          column: 49
        }
      },
      "45": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 103,
          column: 6
        }
      },
      "46": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 102,
          column: 48
        }
      },
      "47": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 110,
          column: 6
        }
      },
      "48": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 48
        }
      },
      "49": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 117,
          column: 6
        }
      },
      "50": {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 52
        }
      },
      "51": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 19
        }
      },
      "52": {
        start: {
          line: 120,
          column: 0
        },
        end: {
          line: 120,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 29
          },
          end: {
            line: 11,
            column: 30
          }
        },
        loc: {
          start: {
            line: 11,
            column: 41
          },
          end: {
            line: 119,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "Command",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 20
          }
        },
        loc: {
          start: {
            line: 12,
            column: 29
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 28
          }
        },
        loc: {
          start: {
            line: 20,
            column: 50
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 35
          },
          end: {
            line: 55,
            column: 36
          }
        },
        loc: {
          start: {
            line: 55,
            column: 51
          },
          end: {
            line: 74,
            column: 5
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 79,
            column: 35
          },
          end: {
            line: 79,
            column: 36
          }
        },
        loc: {
          start: {
            line: 79,
            column: 52
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 79
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 94,
            column: 36
          },
          end: {
            line: 94,
            column: 37
          }
        },
        loc: {
          start: {
            line: 94,
            column: 59
          },
          end: {
            line: 96,
            column: 5
          }
        },
        line: 94
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 101,
            column: 42
          },
          end: {
            line: 101,
            column: 43
          }
        },
        loc: {
          start: {
            line: 101,
            column: 58
          },
          end: {
            line: 103,
            column: 5
          }
        },
        line: 101
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 42
          },
          end: {
            line: 108,
            column: 43
          }
        },
        loc: {
          start: {
            line: 108,
            column: 58
          },
          end: {
            line: 110,
            column: 5
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 115,
            column: 46
          },
          end: {
            line: 115,
            column: 47
          }
        },
        loc: {
          start: {
            line: 115,
            column: 62
          },
          end: {
            line: 117,
            column: 5
          }
        },
        line: 115
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }, {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }, {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }],
        line: 27
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 34,
            column: 12
          },
          end: {
            line: 36,
            column: 22
          }
        }, {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 39,
            column: 22
          }
        }, {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 43,
            column: 22
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 59,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 59,
            column: 19
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 59,
            column: 19
          }
        }],
        line: 58
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 64,
            column: 13
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 13
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 64,
            column: 13
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 64
      },
      "9": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 83,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 83,
            column: 19
          }
        }, {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 83,
            column: 19
          }
        }],
        line: 82
      },
      "10": {
        loc: {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        }, {
          start: {
            line: 84,
            column: 8
          },
          end: {
            line: 87,
            column: 9
          }
        }],
        line: 84
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/command.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/command.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,+DAAiD;AAGjD;IAGI,iBAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;;;OAIG;IACI,oBAAE,GAAT,UAAU,IAAY,EAAE,KAA2B;QAC/C,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAE1B,IAAI,MAAM,CAAC,MAAM,CAAC,YAAY,EAAE;YAC5B,QAAQ,CAAC,WAAW,CAAC,cAAc,EAAE,KAAK,EAAE,MAAM,CAAC,CAAA;SACtD;QAED,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAElC,WAAW;QACX,IAAI,CAAC,SAAS,CAAC,QAAQ,EAAE,EAAE;YACvB,OAAM;SACT;QAED,OAAO;QACP,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAE5B,KAAK;QACL,QAAQ,IAAI,EAAE;YACV,KAAK,YAAY;gBACb,IAAI,CAAC,UAAU,CAAC,KAAe,CAAC,CAAA;gBAChC,MAAK;YACT,KAAK,YAAY;gBACb,IAAI,CAAC,UAAU,CAAC,KAAmB,CAAC,CAAA;gBACpC,MAAK;YACT;gBACI,aAAa;gBACb,IAAI,CAAC,WAAW,CAAC,IAAI,EAAE,KAAe,CAAC,CAAA;gBACvC,MAAK;SACZ;QAED,SAAS;QACT,MAAM,CAAC,KAAK,CAAC,YAAY,EAAE,CAAA;QAE3B,sBAAsB;QACtB,SAAS,CAAC,SAAS,EAAE,CAAA;QACrB,SAAS,CAAC,gBAAgB,EAAE,CAAA;IAChC,CAAC;IAED;;;OAGG;IACK,4BAAU,GAAlB,UAAmB,IAAY;QAC3B,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,KAAK,GAAG,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,CAAA;QACzC,IAAI,KAAK,IAAI,IAAI;YAAE,OAAM;QAEzB,IAAI,IAAI,CAAC,qBAAqB,CAAC,YAAY,CAAC,EAAE;YAC1C,MAAM;YACN,IAAI,CAAC,WAAW,CAAC,YAAY,EAAE,IAAI,CAAC,CAAA;SACvC;aAAM,IAAI,KAAK,CAAC,UAAU,EAAE;YACzB,KAAK;YACL,KAAK,CAAC,cAAc,EAAE,CAAA;YACtB,KAAK,CAAC,UAAU,CAAC,kBAAC,CAAC,IAAI,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;YAClC,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;SACnC;QACD,8BAA8B;QAC9B,kBAAkB;QAClB,4BAA4B;QAC5B,IAAI;IACR,CAAC;IAED;;;OAGG;IACK,4BAAU,GAAlB,UAAmB,KAAiB;QAChC,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,KAAK,GAAG,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,CAAA;QACzC,IAAI,KAAK,IAAI,IAAI;YAAE,OAAM;QAEzB,IAAI,KAAK,CAAC,UAAU,EAAE;YAClB,KAAK,CAAC,cAAc,EAAE,CAAA;YACtB,KAAK,CAAC,UAAU,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;SACnC;IACL,CAAC;IAED;;;;OAIG;IACK,6BAAW,GAAnB,UAAoB,IAAY,EAAE,KAAa;QAC3C,QAAQ,CAAC,WAAW,CAAC,IAAI,EAAE,KAAK,EAAE,KAAK,CAAC,CAAA;IAC5C,CAAC;IAED;;;OAGG;IACI,mCAAiB,GAAxB,UAAyB,IAAY;QACjC,OAAO,QAAQ,CAAC,iBAAiB,CAAC,IAAI,CAAC,CAAA;IAC3C,CAAC;IAED;;;OAGG;IACI,mCAAiB,GAAxB,UAAyB,IAAY;QACjC,OAAO,QAAQ,CAAC,iBAAiB,CAAC,IAAI,CAAC,CAAA;IAC3C,CAAC;IAED;;;OAGG;IACI,uCAAqB,GAA5B,UAA6B,IAAY;QACrC,OAAO,QAAQ,CAAC,qBAAqB,CAAC,IAAI,CAAC,CAAA;IAC/C,CAAC;IACL,cAAC;AAAD,CAAC,AA1HD,IA0HC;AAED,kBAAe,OAAO,CAAA",
      sourcesContent: ["/**\n * @description \u5C01\u88C5 document.execCommand\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../utils/dom-core'\nimport Editor from './index'\n\nclass Command {\n    public editor: Editor\n\n    constructor(editor: Editor) {\n        this.editor = editor\n    }\n\n    /**\n     * \u6267\u884C\u5BCC\u6587\u672C\u64CD\u4F5C\u7684\u547D\u4EE4\n     * @param name name\n     * @param value value\n     */\n    public do(name: string, value?: string | DomElement): void {\n        const editor = this.editor\n\n        if (editor.config.styleWithCSS) {\n            document.execCommand('styleWithCSS', false, 'true')\n        }\n\n        const selection = editor.selection\n\n        // \u5982\u679C\u65E0\u9009\u533A\uFF0C\u5FFD\u7565\n        if (!selection.getRange()) {\n            return\n        }\n\n        // \u6062\u590D\u9009\u53D6\n        selection.restoreSelection()\n\n        // \u6267\u884C\n        switch (name) {\n            case 'insertHTML':\n                this.insertHTML(value as string)\n                break\n            case 'insertElem':\n                this.insertElem(value as DomElement)\n                break\n            default:\n                // \u9ED8\u8BA4 command\n                this.execCommand(name, value as string)\n                break\n        }\n\n        // \u4FEE\u6539\u83DC\u5355\u72B6\u6001\n        editor.menus.changeActive()\n\n        // \u6700\u540E\uFF0C\u6062\u590D\u9009\u53D6\u4FDD\u8BC1\u5149\u6807\u5728\u539F\u6765\u7684\u4F4D\u7F6E\u95EA\u70C1\n        selection.saveRange()\n        selection.restoreSelection()\n    }\n\n    /**\n     * \u63D2\u5165 html\n     * @param html html \u5B57\u7B26\u4E32\n     */\n    private insertHTML(html: string): void {\n        const editor = this.editor\n        const range = editor.selection.getRange()\n        if (range == null) return\n\n        if (this.queryCommandSupported('insertHTML')) {\n            // W3C\n            this.execCommand('insertHTML', html)\n        } else if (range.insertNode) {\n            // IE\n            range.deleteContents()\n            range.insertNode($(html).elems[0])\n            editor.selection.collapseRange()\n        }\n        // else if (range.pasteHTML) {\n        //     // IE <= 10\n        //     range.pasteHTML(html)\n        // }\n    }\n\n    /**\n     * \u63D2\u5165 DOM \u5143\u7D20\n     * @param $elem DOM \u5143\u7D20\n     */\n    private insertElem($elem: DomElement): void {\n        const editor = this.editor\n        const range = editor.selection.getRange()\n        if (range == null) return\n\n        if (range.insertNode) {\n            range.deleteContents()\n            range.insertNode($elem.elems[0])\n        }\n    }\n\n    /**\n     * \u6267\u884C document.execCommand\n     * @param name name\n     * @param value value\n     */\n    private execCommand(name: string, value: string): void {\n        document.execCommand(name, false, value)\n    }\n\n    /**\n     * \u6267\u884C document.queryCommandValue\n     * @param name name\n     */\n    public queryCommandValue(name: string): string {\n        return document.queryCommandValue(name)\n    }\n\n    /**\n     * \u6267\u884C document.queryCommandState\n     * @param name name\n     */\n    public queryCommandState(name: string): boolean {\n        return document.queryCommandState(name)\n    }\n\n    /**\n     * \u6267\u884C document.queryCommandSupported\n     * @param name name\n     */\n    public queryCommandSupported(name: string): boolean {\n        return document.queryCommandSupported(name)\n    }\n}\n\nexport default Command\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "24418cd7fd2aafd454695dbc78273f606345b0a4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_f95dcq80g = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_f95dcq80g();

var __importDefault = (cov_f95dcq80g().s[0]++, (cov_f95dcq80g().b[0][0]++, void 0) && (cov_f95dcq80g().b[0][1]++, (void 0).__importDefault) || (cov_f95dcq80g().b[0][2]++, function (mod) {
  cov_f95dcq80g().f[0]++;
  cov_f95dcq80g().s[1]++;
  return (cov_f95dcq80g().b[2][0]++, mod) && (cov_f95dcq80g().b[2][1]++, mod.__esModule) ? (cov_f95dcq80g().b[1][0]++, mod) : (cov_f95dcq80g().b[1][1]++, {
    "default": mod
  });
}));

cov_f95dcq80g().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_f95dcq80g().s[3]++, __importDefault(__webpack_require__(2)));
var Command = (
/** @class */
cov_f95dcq80g().s[4]++, function () {
  cov_f95dcq80g().f[1]++;

  function Command(editor) {
    cov_f95dcq80g().f[2]++;
    cov_f95dcq80g().s[5]++;
    this.editor = editor;
  }
  /**
   * 执行富文本操作的命令
   * @param name name
   * @param value value
   */


  cov_f95dcq80g().s[6]++;

  Command.prototype["do"] = function (name, value) {
    cov_f95dcq80g().f[3]++;
    var editor = (cov_f95dcq80g().s[7]++, this.editor);
    cov_f95dcq80g().s[8]++;

    if (editor.config.styleWithCSS) {
      cov_f95dcq80g().b[3][0]++;
      cov_f95dcq80g().s[9]++;
      document.execCommand('styleWithCSS', false, 'true');
    } else {
      cov_f95dcq80g().b[3][1]++;
    }

    var selection = (cov_f95dcq80g().s[10]++, editor.selection); // 如果无选区，忽略

    cov_f95dcq80g().s[11]++;

    if (!selection.getRange()) {
      cov_f95dcq80g().b[4][0]++;
      cov_f95dcq80g().s[12]++;
      return;
    } else {
      cov_f95dcq80g().b[4][1]++;
    } // 恢复选取


    cov_f95dcq80g().s[13]++;
    selection.restoreSelection(); // 执行

    cov_f95dcq80g().s[14]++;

    switch (name) {
      case 'insertHTML':
        cov_f95dcq80g().b[5][0]++;
        cov_f95dcq80g().s[15]++;
        this.insertHTML(value);
        cov_f95dcq80g().s[16]++;
        break;

      case 'insertElem':
        cov_f95dcq80g().b[5][1]++;
        cov_f95dcq80g().s[17]++;
        this.insertElem(value);
        cov_f95dcq80g().s[18]++;
        break;

      default:
        cov_f95dcq80g().b[5][2]++;
        cov_f95dcq80g().s[19]++;
        // 默认 command
        this.execCommand(name, value);
        cov_f95dcq80g().s[20]++;
        break;
    } // 修改菜单状态


    cov_f95dcq80g().s[21]++;
    editor.menus.changeActive(); // 最后，恢复选取保证光标在原来的位置闪烁

    cov_f95dcq80g().s[22]++;
    selection.saveRange();
    cov_f95dcq80g().s[23]++;
    selection.restoreSelection();
  };
  /**
   * 插入 html
   * @param html html 字符串
   */


  cov_f95dcq80g().s[24]++;

  Command.prototype.insertHTML = function (html) {
    cov_f95dcq80g().f[4]++;
    var editor = (cov_f95dcq80g().s[25]++, this.editor);
    var range = (cov_f95dcq80g().s[26]++, editor.selection.getRange());
    cov_f95dcq80g().s[27]++;

    if (range == null) {
      cov_f95dcq80g().b[6][0]++;
      cov_f95dcq80g().s[28]++;
      return;
    } else {
      cov_f95dcq80g().b[6][1]++;
    }

    cov_f95dcq80g().s[29]++;

    if (this.queryCommandSupported('insertHTML')) {
      cov_f95dcq80g().b[7][0]++;
      cov_f95dcq80g().s[30]++;
      // W3C
      this.execCommand('insertHTML', html);
    } else {
      cov_f95dcq80g().b[7][1]++;
      cov_f95dcq80g().s[31]++;

      if (range.insertNode) {
        cov_f95dcq80g().b[8][0]++;
        cov_f95dcq80g().s[32]++;
        // IE
        range.deleteContents();
        cov_f95dcq80g().s[33]++;
        range.insertNode(dom_core_1["default"](html).elems[0]);
        cov_f95dcq80g().s[34]++;
        editor.selection.collapseRange();
      } else {
        cov_f95dcq80g().b[8][1]++;
      }
    } // else if (range.pasteHTML) {
    //     // IE <= 10
    //     range.pasteHTML(html)
    // }

  };
  /**
   * 插入 DOM 元素
   * @param $elem DOM 元素
   */


  cov_f95dcq80g().s[35]++;

  Command.prototype.insertElem = function ($elem) {
    cov_f95dcq80g().f[5]++;
    var editor = (cov_f95dcq80g().s[36]++, this.editor);
    var range = (cov_f95dcq80g().s[37]++, editor.selection.getRange());
    cov_f95dcq80g().s[38]++;

    if (range == null) {
      cov_f95dcq80g().b[9][0]++;
      cov_f95dcq80g().s[39]++;
      return;
    } else {
      cov_f95dcq80g().b[9][1]++;
    }

    cov_f95dcq80g().s[40]++;

    if (range.insertNode) {
      cov_f95dcq80g().b[10][0]++;
      cov_f95dcq80g().s[41]++;
      range.deleteContents();
      cov_f95dcq80g().s[42]++;
      range.insertNode($elem.elems[0]);
    } else {
      cov_f95dcq80g().b[10][1]++;
    }
  };
  /**
   * 执行 document.execCommand
   * @param name name
   * @param value value
   */


  cov_f95dcq80g().s[43]++;

  Command.prototype.execCommand = function (name, value) {
    cov_f95dcq80g().f[6]++;
    cov_f95dcq80g().s[44]++;
    document.execCommand(name, false, value);
  };
  /**
   * 执行 document.queryCommandValue
   * @param name name
   */


  cov_f95dcq80g().s[45]++;

  Command.prototype.queryCommandValue = function (name) {
    cov_f95dcq80g().f[7]++;
    cov_f95dcq80g().s[46]++;
    return document.queryCommandValue(name);
  };
  /**
   * 执行 document.queryCommandState
   * @param name name
   */


  cov_f95dcq80g().s[47]++;

  Command.prototype.queryCommandState = function (name) {
    cov_f95dcq80g().f[8]++;
    cov_f95dcq80g().s[48]++;
    return document.queryCommandState(name);
  };
  /**
   * 执行 document.queryCommandSupported
   * @param name name
   */


  cov_f95dcq80g().s[49]++;

  Command.prototype.queryCommandSupported = function (name) {
    cov_f95dcq80g().f[9]++;
    cov_f95dcq80g().s[50]++;
    return document.queryCommandSupported(name);
  };

  cov_f95dcq80g().s[51]++;
  return Command;
}());
cov_f95dcq80g().s[52]++;
exports["default"] = Command;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 编辑区域，入口文件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _indexOf = _interopRequireDefault(__webpack_require__(53));

var _trim = _interopRequireDefault(__webpack_require__(21));

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1ywwwnyyy3() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/index.ts";
  var hash = "aa4a1dd1f55cb6b6bbe64a70250163a1e763cd55";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 62
        }
      },
      "4": {
        start: {
          line: 11,
          column: 14
        },
        end: {
          line: 11,
          column: 61
        }
      },
      "5": {
        start: {
          line: 12,
          column: 13
        },
        end: {
          line: 12,
          column: 37
        }
      },
      "6": {
        start: {
          line: 13,
          column: 24
        },
        end: {
          line: 13,
          column: 69
        }
      },
      "7": {
        start: {
          line: 14,
          column: 26
        },
        end: {
          line: 14,
          column: 73
        }
      },
      "8": {
        start: {
          line: 15,
          column: 26
        },
        end: {
          line: 437,
          column: 3
        }
      },
      "9": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 29
        }
      },
      "10": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 40,
          column: 10
        }
      },
      "11": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      "12": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 26
        }
      },
      "13": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 31
        }
      },
      "14": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 30
        }
      },
      "15": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "16": {
        start: {
          line: 57,
          column: 19
        },
        end: {
          line: 57,
          column: 30
        }
      },
      "17": {
        start: {
          line: 58,
          column: 27
        },
        end: {
          line: 58,
          column: 78
        }
      },
      "18": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 28
        }
      },
      "19": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 61,
          column: 32
        }
      },
      "20": {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 61,
          column: 32
        }
      },
      "21": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 68,
          column: 6
        }
      },
      "22": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 33
        }
      },
      "23": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 112,
          column: 6
        }
      },
      "24": {
        start: {
          line: 74,
          column: 21
        },
        end: {
          line: 74,
          column: 32
        }
      },
      "25": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 40
        }
      },
      "26": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 99,
          column: 9
        }
      },
      "27": {
        start: {
          line: 78,
          column: 23
        },
        end: {
          line: 78,
          column: 39
        }
      },
      "28": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 80,
          column: 48
        }
      },
      "29": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 81,
          column: 51
        }
      },
      "30": {
        start: {
          line: 82,
          column: 12
        },
        end: {
          line: 82,
          column: 59
        }
      },
      "31": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 24
        }
      },
      "32": {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 101,
          column: 25
        }
      },
      "33": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 104,
          column: 9
        }
      },
      "34": {
        start: {
          line: 103,
          column: 12
        },
        end: {
          line: 103,
          column: 32
        }
      },
      "35": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 108,
          column: 9
        }
      },
      "36": {
        start: {
          line: 107,
          column: 12
        },
        end: {
          line: 107,
          column: 39
        }
      },
      "37": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 28
        }
      },
      "38": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 31
        }
      },
      "39": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 126,
          column: 6
        }
      },
      "40": {
        start: {
          line: 118,
          column: 19
        },
        end: {
          line: 118,
          column: 67
        }
      },
      "41": {
        start: {
          line: 119,
          column: 21
        },
        end: {
          line: 119,
          column: 32
        }
      },
      "42": {
        start: {
          line: 120,
          column: 24
        },
        end: {
          line: 120,
          column: 40
        }
      },
      "43": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 123,
          column: 19
        }
      },
      "44": {
        start: {
          line: 123,
          column: 12
        },
        end: {
          line: 123,
          column: 19
        }
      },
      "45": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 40
        }
      },
      "46": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 134,
          column: 6
        }
      },
      "47": {
        start: {
          line: 131,
          column: 21
        },
        end: {
          line: 131,
          column: 32
        }
      },
      "48": {
        start: {
          line: 132,
          column: 24
        },
        end: {
          line: 132,
          column: 40
        }
      },
      "49": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 52
        }
      },
      "50": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 149,
          column: 6
        }
      },
      "51": {
        start: {
          line: 136,
          column: 21
        },
        end: {
          line: 136,
          column: 32
        }
      },
      "52": {
        start: {
          line: 137,
          column: 24
        },
        end: {
          line: 137,
          column: 40
        }
      },
      "53": {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 144,
          column: 9
        }
      },
      "54": {
        start: {
          line: 140,
          column: 23
        },
        end: {
          line: 140,
          column: 39
        }
      },
      "55": {
        start: {
          line: 142,
          column: 12
        },
        end: {
          line: 142,
          column: 48
        }
      },
      "56": {
        start: {
          line: 143,
          column: 12
        },
        end: {
          line: 143,
          column: 24
        }
      },
      "57": {
        start: {
          line: 146,
          column: 8
        },
        end: {
          line: 146,
          column: 45
        }
      },
      "58": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 31
        }
      },
      "59": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 164,
          column: 6
        }
      },
      "60": {
        start: {
          line: 155,
          column: 21
        },
        end: {
          line: 155,
          column: 32
        }
      },
      "61": {
        start: {
          line: 156,
          column: 24
        },
        end: {
          line: 156,
          column: 40
        }
      },
      "62": {
        start: {
          line: 157,
          column: 8
        },
        end: {
          line: 160,
          column: 9
        }
      },
      "63": {
        start: {
          line: 159,
          column: 12
        },
        end: {
          line: 159,
          column: 41
        }
      },
      "64": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 161,
          column: 51
        }
      },
      "65": {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 31
        }
      },
      "66": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 199,
          column: 6
        }
      },
      "67": {
        start: {
          line: 169,
          column: 21
        },
        end: {
          line: 169,
          column: 32
        }
      },
      "68": {
        start: {
          line: 170,
          column: 24
        },
        end: {
          line: 170,
          column: 40
        }
      },
      "69": {
        start: {
          line: 174,
          column: 12
        },
        end: {
          line: 174,
          column: 41
        }
      },
      "70": {
        start: {
          line: 176,
          column: 12
        },
        end: {
          line: 176,
          column: 40
        }
      },
      "71": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 41
        }
      },
      "72": {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 183,
          column: 11
        }
      },
      "73": {
        start: {
          line: 182,
          column: 12
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "74": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 198,
          column: 11
        }
      },
      "75": {
        start: {
          line: 185,
          column: 28
        },
        end: {
          line: 185,
          column: 44
        }
      },
      "76": {
        start: {
          line: 186,
          column: 24
        },
        end: {
          line: 186,
          column: 44
        }
      },
      "77": {
        start: {
          line: 187,
          column: 12
        },
        end: {
          line: 188,
          column: 23
        }
      },
      "78": {
        start: {
          line: 188,
          column: 16
        },
        end: {
          line: 188,
          column: 23
        }
      },
      "79": {
        start: {
          line: 189,
          column: 30
        },
        end: {
          line: 189,
          column: 47
        }
      },
      "80": {
        start: {
          line: 189,
          column: 61
        },
        end: {
          line: 189,
          column: 76
        }
      },
      "81": {
        start: {
          line: 190,
          column: 31
        },
        end: {
          line: 190,
          column: 95
        }
      },
      "82": {
        start: {
          line: 192,
          column: 12
        },
        end: {
          line: 194,
          column: 13
        }
      },
      "83": {
        start: {
          line: 193,
          column: 16
        },
        end: {
          line: 193,
          column: 102
        }
      },
      "84": {
        start: {
          line: 195,
          column: 12
        },
        end: {
          line: 195,
          column: 24
        }
      },
      "85": {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 197,
          column: 51
        }
      },
      "86": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 435,
          column: 6
        }
      },
      "87": {
        start: {
          line: 204,
          column: 21
        },
        end: {
          line: 204,
          column: 32
        }
      },
      "88": {
        start: {
          line: 205,
          column: 24
        },
        end: {
          line: 205,
          column: 40
        }
      },
      "89": {
        start: {
          line: 206,
          column: 25
        },
        end: {
          line: 206,
          column: 40
        }
      },
      "90": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 211,
          column: 11
        }
      },
      "91": {
        start: {
          line: 209,
          column: 30
        },
        end: {
          line: 209,
          column: 52
        }
      },
      "92": {
        start: {
          line: 210,
          column: 12
        },
        end: {
          line: 210,
          column: 65
        }
      },
      "93": {
        start: {
          line: 210,
          column: 48
        },
        end: {
          line: 210,
          column: 61
        }
      },
      "94": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 218,
          column: 11
        }
      },
      "95": {
        start: {
          line: 214,
          column: 12
        },
        end: {
          line: 215,
          column: 23
        }
      },
      "96": {
        start: {
          line: 215,
          column: 16
        },
        end: {
          line: 215,
          column: 23
        }
      },
      "97": {
        start: {
          line: 216,
          column: 32
        },
        end: {
          line: 216,
          column: 56
        }
      },
      "98": {
        start: {
          line: 217,
          column: 12
        },
        end: {
          line: 217,
          column: 67
        }
      },
      "99": {
        start: {
          line: 217,
          column: 50
        },
        end: {
          line: 217,
          column: 63
        }
      },
      "100": {
        start: {
          line: 220,
          column: 8
        },
        end: {
          line: 223,
          column: 11
        }
      },
      "101": {
        start: {
          line: 221,
          column: 30
        },
        end: {
          line: 221,
          column: 52
        }
      },
      "102": {
        start: {
          line: 222,
          column: 12
        },
        end: {
          line: 222,
          column: 65
        }
      },
      "103": {
        start: {
          line: 222,
          column: 48
        },
        end: {
          line: 222,
          column: 61
        }
      },
      "104": {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 230,
          column: 11
        }
      },
      "105": {
        start: {
          line: 226,
          column: 12
        },
        end: {
          line: 227,
          column: 23
        }
      },
      "106": {
        start: {
          line: 227,
          column: 16
        },
        end: {
          line: 227,
          column: 23
        }
      },
      "107": {
        start: {
          line: 228,
          column: 33
        },
        end: {
          line: 228,
          column: 58
        }
      },
      "108": {
        start: {
          line: 229,
          column: 12
        },
        end: {
          line: 229,
          column: 68
        }
      },
      "109": {
        start: {
          line: 229,
          column: 51
        },
        end: {
          line: 229,
          column: 64
        }
      },
      "110": {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 237,
          column: 11
        }
      },
      "111": {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 234,
          column: 23
        }
      },
      "112": {
        start: {
          line: 234,
          column: 16
        },
        end: {
          line: 234,
          column: 23
        }
      },
      "113": {
        start: {
          line: 235,
          column: 35
        },
        end: {
          line: 235,
          column: 62
        }
      },
      "114": {
        start: {
          line: 236,
          column: 12
        },
        end: {
          line: 236,
          column: 70
        }
      },
      "115": {
        start: {
          line: 236,
          column: 53
        },
        end: {
          line: 236,
          column: 66
        }
      },
      "116": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 246,
          column: 11
        }
      },
      "117": {
        start: {
          line: 240,
          column: 12
        },
        end: {
          line: 241,
          column: 23
        }
      },
      "118": {
        start: {
          line: 241,
          column: 16
        },
        end: {
          line: 241,
          column: 23
        }
      },
      "119": {
        start: {
          line: 243,
          column: 12
        },
        end: {
          line: 243,
          column: 31
        }
      },
      "120": {
        start: {
          line: 244,
          column: 30
        },
        end: {
          line: 244,
          column: 52
        }
      },
      "121": {
        start: {
          line: 245,
          column: 12
        },
        end: {
          line: 245,
          column: 65
        }
      },
      "122": {
        start: {
          line: 245,
          column: 48
        },
        end: {
          line: 245,
          column: 61
        }
      },
      "123": {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 266,
          column: 11
        }
      },
      "124": {
        start: {
          line: 249,
          column: 12
        },
        end: {
          line: 265,
          column: 13
        }
      },
      "125": {
        start: {
          line: 255,
          column: 16
        },
        end: {
          line: 255,
          column: 35
        }
      },
      "126": {
        start: {
          line: 257,
          column: 16
        },
        end: {
          line: 264,
          column: 17
        }
      },
      "127": {
        start: {
          line: 259,
          column: 20
        },
        end: {
          line: 259,
          column: 45
        }
      },
      "128": {
        start: {
          line: 263,
          column: 20
        },
        end: {
          line: 263,
          column: 44
        }
      },
      "129": {
        start: {
          line: 268,
          column: 8
        },
        end: {
          line: 274,
          column: 11
        }
      },
      "130": {
        start: {
          line: 269,
          column: 12
        },
        end: {
          line: 270,
          column: 23
        }
      },
      "131": {
        start: {
          line: 270,
          column: 16
        },
        end: {
          line: 270,
          column: 23
        }
      },
      "132": {
        start: {
          line: 271,
          column: 12
        },
        end: {
          line: 271,
          column: 31
        }
      },
      "133": {
        start: {
          line: 272,
          column: 30
        },
        end: {
          line: 272,
          column: 52
        }
      },
      "134": {
        start: {
          line: 273,
          column: 12
        },
        end: {
          line: 273,
          column: 65
        }
      },
      "135": {
        start: {
          line: 273,
          column: 48
        },
        end: {
          line: 273,
          column: 61
        }
      },
      "136": {
        start: {
          line: 276,
          column: 8
        },
        end: {
          line: 282,
          column: 11
        }
      },
      "137": {
        start: {
          line: 277,
          column: 12
        },
        end: {
          line: 278,
          column: 23
        }
      },
      "138": {
        start: {
          line: 278,
          column: 16
        },
        end: {
          line: 278,
          column: 23
        }
      },
      "139": {
        start: {
          line: 279,
          column: 12
        },
        end: {
          line: 279,
          column: 31
        }
      },
      "140": {
        start: {
          line: 280,
          column: 32
        },
        end: {
          line: 280,
          column: 56
        }
      },
      "141": {
        start: {
          line: 281,
          column: 12
        },
        end: {
          line: 281,
          column: 67
        }
      },
      "142": {
        start: {
          line: 281,
          column: 50
        },
        end: {
          line: 281,
          column: 63
        }
      },
      "143": {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 289,
          column: 17
        }
      },
      "144": {
        start: {
          line: 287,
          column: 35
        },
        end: {
          line: 287,
          column: 62
        }
      },
      "145": {
        start: {
          line: 288,
          column: 12
        },
        end: {
          line: 288,
          column: 70
        }
      },
      "146": {
        start: {
          line: 288,
          column: 53
        },
        end: {
          line: 288,
          column: 66
        }
      },
      "147": {
        start: {
          line: 293,
          column: 12
        },
        end: {
          line: 293,
          column: 31
        }
      },
      "148": {
        start: {
          line: 295,
          column: 8
        },
        end: {
          line: 299,
          column: 44
        }
      },
      "149": {
        start: {
          line: 301,
          column: 8
        },
        end: {
          line: 307,
          column: 11
        }
      },
      "150": {
        start: {
          line: 302,
          column: 12
        },
        end: {
          line: 306,
          column: 49
        }
      },
      "151": {
        start: {
          line: 308,
          column: 8
        },
        end: {
          line: 312,
          column: 11
        }
      },
      "152": {
        start: {
          line: 309,
          column: 12
        },
        end: {
          line: 309,
          column: 31
        }
      },
      "153": {
        start: {
          line: 310,
          column: 25
        },
        end: {
          line: 310,
          column: 46
        }
      },
      "154": {
        start: {
          line: 311,
          column: 12
        },
        end: {
          line: 311,
          column: 60
        }
      },
      "155": {
        start: {
          line: 311,
          column: 43
        },
        end: {
          line: 311,
          column: 56
        }
      },
      "156": {
        start: {
          line: 314,
          column: 8
        },
        end: {
          line: 335,
          column: 11
        }
      },
      "157": {
        start: {
          line: 316,
          column: 24
        },
        end: {
          line: 316,
          column: 28
        }
      },
      "158": {
        start: {
          line: 317,
          column: 25
        },
        end: {
          line: 317,
          column: 33
        }
      },
      "159": {
        start: {
          line: 318,
          column: 26
        },
        end: {
          line: 318,
          column: 52
        }
      },
      "160": {
        start: {
          line: 319,
          column: 12
        },
        end: {
          line: 330,
          column: 13
        }
      },
      "161": {
        start: {
          line: 321,
          column: 16
        },
        end: {
          line: 321,
          column: 32
        }
      },
      "162": {
        start: {
          line: 325,
          column: 30
        },
        end: {
          line: 325,
          column: 54
        }
      },
      "163": {
        start: {
          line: 326,
          column: 16
        },
        end: {
          line: 329,
          column: 17
        }
      },
      "164": {
        start: {
          line: 328,
          column: 20
        },
        end: {
          line: 328,
          column: 36
        }
      },
      "165": {
        start: {
          line: 331,
          column: 12
        },
        end: {
          line: 332,
          column: 23
        }
      },
      "166": {
        start: {
          line: 332,
          column: 16
        },
        end: {
          line: 332,
          column: 23
        }
      },
      "167": {
        start: {
          line: 333,
          column: 34
        },
        end: {
          line: 333,
          column: 60
        }
      },
      "168": {
        start: {
          line: 334,
          column: 12
        },
        end: {
          line: 334,
          column: 73
        }
      },
      "169": {
        start: {
          line: 334,
          column: 52
        },
        end: {
          line: 334,
          column: 69
        }
      },
      "170": {
        start: {
          line: 337,
          column: 8
        },
        end: {
          line: 355,
          column: 11
        }
      },
      "171": {
        start: {
          line: 339,
          column: 23
        },
        end: {
          line: 339,
          column: 27
        }
      },
      "172": {
        start: {
          line: 340,
          column: 25
        },
        end: {
          line: 340,
          column: 33
        }
      },
      "173": {
        start: {
          line: 341,
          column: 26
        },
        end: {
          line: 341,
          column: 52
        }
      },
      "174": {
        start: {
          line: 343,
          column: 12
        },
        end: {
          line: 350,
          column: 13
        }
      },
      "175": {
        start: {
          line: 348,
          column: 16
        },
        end: {
          line: 348,
          column: 36
        }
      },
      "176": {
        start: {
          line: 349,
          column: 16
        },
        end: {
          line: 349,
          column: 31
        }
      },
      "177": {
        start: {
          line: 351,
          column: 12
        },
        end: {
          line: 352,
          column: 23
        }
      },
      "178": {
        start: {
          line: 352,
          column: 16
        },
        end: {
          line: 352,
          column: 23
        }
      },
      "179": {
        start: {
          line: 353,
          column: 33
        },
        end: {
          line: 353,
          column: 58
        }
      },
      "180": {
        start: {
          line: 354,
          column: 12
        },
        end: {
          line: 354,
          column: 71
        }
      },
      "181": {
        start: {
          line: 354,
          column: 51
        },
        end: {
          line: 354,
          column: 67
        }
      },
      "182": {
        start: {
          line: 357,
          column: 8
        },
        end: {
          line: 378,
          column: 11
        }
      },
      "183": {
        start: {
          line: 359,
          column: 24
        },
        end: {
          line: 359,
          column: 28
        }
      },
      "184": {
        start: {
          line: 360,
          column: 25
        },
        end: {
          line: 360,
          column: 33
        }
      },
      "185": {
        start: {
          line: 361,
          column: 26
        },
        end: {
          line: 361,
          column: 52
        }
      },
      "186": {
        start: {
          line: 362,
          column: 12
        },
        end: {
          line: 373,
          column: 13
        }
      },
      "187": {
        start: {
          line: 364,
          column: 16
        },
        end: {
          line: 364,
          column: 32
        }
      },
      "188": {
        start: {
          line: 368,
          column: 30
        },
        end: {
          line: 368,
          column: 56
        }
      },
      "189": {
        start: {
          line: 369,
          column: 16
        },
        end: {
          line: 372,
          column: 17
        }
      },
      "190": {
        start: {
          line: 371,
          column: 20
        },
        end: {
          line: 371,
          column: 36
        }
      },
      "191": {
        start: {
          line: 374,
          column: 12
        },
        end: {
          line: 375,
          column: 23
        }
      },
      "192": {
        start: {
          line: 375,
          column: 16
        },
        end: {
          line: 375,
          column: 23
        }
      },
      "193": {
        start: {
          line: 376,
          column: 34
        },
        end: {
          line: 376,
          column: 60
        }
      },
      "194": {
        start: {
          line: 377,
          column: 12
        },
        end: {
          line: 377,
          column: 73
        }
      },
      "195": {
        start: {
          line: 377,
          column: 52
        },
        end: {
          line: 377,
          column: 69
        }
      },
      "196": {
        start: {
          line: 380,
          column: 8
        },
        end: {
          line: 399,
          column: 11
        }
      },
      "197": {
        start: {
          line: 382,
          column: 29
        },
        end: {
          line: 382,
          column: 33
        }
      },
      "198": {
        start: {
          line: 383,
          column: 25
        },
        end: {
          line: 383,
          column: 33
        }
      },
      "199": {
        start: {
          line: 384,
          column: 26
        },
        end: {
          line: 384,
          column: 52
        }
      },
      "200": {
        start: {
          line: 386,
          column: 12
        },
        end: {
          line: 391,
          column: 13
        }
      },
      "201": {
        start: {
          line: 387,
          column: 16
        },
        end: {
          line: 387,
          column: 37
        }
      },
      "202": {
        start: {
          line: 390,
          column: 16
        },
        end: {
          line: 390,
          column: 32
        }
      },
      "203": {
        start: {
          line: 392,
          column: 12
        },
        end: {
          line: 393,
          column: 23
        }
      },
      "204": {
        start: {
          line: 393,
          column: 16
        },
        end: {
          line: 393,
          column: 23
        }
      },
      "205": {
        start: {
          line: 395,
          column: 12
        },
        end: {
          line: 395,
          column: 59
        }
      },
      "206": {
        start: {
          line: 396,
          column: 12
        },
        end: {
          line: 396,
          column: 48
        }
      },
      "207": {
        start: {
          line: 397,
          column: 39
        },
        end: {
          line: 397,
          column: 65
        }
      },
      "208": {
        start: {
          line: 398,
          column: 12
        },
        end: {
          line: 398,
          column: 83
        }
      },
      "209": {
        start: {
          line: 398,
          column: 57
        },
        end: {
          line: 398,
          column: 79
        }
      },
      "210": {
        start: {
          line: 401,
          column: 8
        },
        end: {
          line: 404,
          column: 11
        }
      },
      "211": {
        start: {
          line: 402,
          column: 37
        },
        end: {
          line: 402,
          column: 66
        }
      },
      "212": {
        start: {
          line: 403,
          column: 12
        },
        end: {
          line: 403,
          column: 72
        }
      },
      "213": {
        start: {
          line: 403,
          column: 55
        },
        end: {
          line: 403,
          column: 68
        }
      },
      "214": {
        start: {
          line: 406,
          column: 8
        },
        end: {
          line: 414,
          column: 11
        }
      },
      "215": {
        start: {
          line: 407,
          column: 25
        },
        end: {
          line: 407,
          column: 33
        }
      },
      "216": {
        start: {
          line: 408,
          column: 26
        },
        end: {
          line: 408,
          column: 52
        }
      },
      "217": {
        start: {
          line: 409,
          column: 12
        },
        end: {
          line: 413,
          column: 13
        }
      },
      "218": {
        start: {
          line: 411,
          column: 48
        },
        end: {
          line: 411,
          column: 84
        }
      },
      "219": {
        start: {
          line: 412,
          column: 16
        },
        end: {
          line: 412,
          column: 82
        }
      },
      "220": {
        start: {
          line: 412,
          column: 66
        },
        end: {
          line: 412,
          column: 78
        }
      },
      "221": {
        start: {
          line: 416,
          column: 8
        },
        end: {
          line: 427,
          column: 11
        }
      },
      "222": {
        start: {
          line: 418,
          column: 23
        },
        end: {
          line: 418,
          column: 27
        }
      },
      "223": {
        start: {
          line: 419,
          column: 25
        },
        end: {
          line: 419,
          column: 33
        }
      },
      "224": {
        start: {
          line: 421,
          column: 12
        },
        end: {
          line: 421,
          column: 75
        }
      },
      "225": {
        start: {
          line: 423,
          column: 12
        },
        end: {
          line: 424,
          column: 23
        }
      },
      "226": {
        start: {
          line: 424,
          column: 16
        },
        end: {
          line: 424,
          column: 23
        }
      },
      "227": {
        start: {
          line: 425,
          column: 35
        },
        end: {
          line: 425,
          column: 62
        }
      },
      "228": {
        start: {
          line: 426,
          column: 12
        },
        end: {
          line: 426,
          column: 73
        }
      },
      "229": {
        start: {
          line: 426,
          column: 53
        },
        end: {
          line: 426,
          column: 69
        }
      },
      "230": {
        start: {
          line: 429,
          column: 8
        },
        end: {
          line: 434,
          column: 11
        }
      },
      "231": {
        start: {
          line: 430,
          column: 12
        },
        end: {
          line: 431,
          column: 23
        }
      },
      "232": {
        start: {
          line: 431,
          column: 16
        },
        end: {
          line: 431,
          column: 23
        }
      },
      "233": {
        start: {
          line: 432,
          column: 34
        },
        end: {
          line: 432,
          column: 60
        }
      },
      "234": {
        start: {
          line: 433,
          column: 12
        },
        end: {
          line: 433,
          column: 69
        }
      },
      "235": {
        start: {
          line: 433,
          column: 52
        },
        end: {
          line: 433,
          column: 65
        }
      },
      "236": {
        start: {
          line: 436,
          column: 4
        },
        end: {
          line: 436,
          column: 16
        }
      },
      "237": {
        start: {
          line: 438,
          column: 0
        },
        end: {
          line: 438,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 26
          },
          end: {
            line: 15,
            column: 27
          }
        },
        loc: {
          start: {
            line: 15,
            column: 38
          },
          end: {
            line: 437,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "Text",
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 17
          }
        },
        loc: {
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 27
          }
        },
        loc: {
          start: {
            line: 45,
            column: 38
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 45
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 56,
            column: 39
          },
          end: {
            line: 56,
            column: 40
          }
        },
        loc: {
          start: {
            line: 56,
            column: 51
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 66,
            column: 27
          },
          end: {
            line: 66,
            column: 28
          }
        },
        loc: {
          start: {
            line: 66,
            column: 39
          },
          end: {
            line: 68,
            column: 5
          }
        },
        line: 66
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 26
          },
          end: {
            line: 73,
            column: 27
          }
        },
        loc: {
          start: {
            line: 73,
            column: 41
          },
          end: {
            line: 112,
            column: 5
          }
        },
        line: 73
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 117,
            column: 29
          },
          end: {
            line: 117,
            column: 30
          }
        },
        loc: {
          start: {
            line: 117,
            column: 49
          },
          end: {
            line: 126,
            column: 5
          }
        },
        line: 117
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 130,
            column: 29
          },
          end: {
            line: 130,
            column: 30
          }
        },
        loc: {
          start: {
            line: 130,
            column: 41
          },
          end: {
            line: 134,
            column: 5
          }
        },
        line: 130
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 135,
            column: 26
          },
          end: {
            line: 135,
            column: 27
          }
        },
        loc: {
          start: {
            line: 135,
            column: 41
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 135
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 154,
            column: 28
          },
          end: {
            line: 154,
            column: 29
          }
        },
        loc: {
          start: {
            line: 154,
            column: 44
          },
          end: {
            line: 164,
            column: 5
          }
        },
        line: 154
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 168,
            column: 32
          },
          end: {
            line: 168,
            column: 33
          }
        },
        loc: {
          start: {
            line: 168,
            column: 44
          },
          end: {
            line: 199,
            column: 5
          }
        },
        line: 168
      },
      "12": {
        name: "saveRange",
        decl: {
          start: {
            line: 172,
            column: 17
          },
          end: {
            line: 172,
            column: 26
          }
        },
        loc: {
          start: {
            line: 172,
            column: 29
          },
          end: {
            line: 177,
            column: 9
          }
        },
        line: 172
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 180,
            column: 34
          },
          end: {
            line: 180,
            column: 35
          }
        },
        loc: {
          start: {
            line: 180,
            column: 46
          },
          end: {
            line: 183,
            column: 9
          }
        },
        line: 180
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 184,
            column: 32
          },
          end: {
            line: 184,
            column: 33
          }
        },
        loc: {
          start: {
            line: 184,
            column: 44
          },
          end: {
            line: 198,
            column: 9
          }
        },
        line: 184
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 203,
            column: 37
          },
          end: {
            line: 203,
            column: 38
          }
        },
        loc: {
          start: {
            line: 203,
            column: 49
          },
          end: {
            line: 435,
            column: 5
          }
        },
        line: 203
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 208,
            column: 30
          },
          end: {
            line: 208,
            column: 31
          }
        },
        loc: {
          start: {
            line: 208,
            column: 43
          },
          end: {
            line: 211,
            column: 9
          }
        },
        line: 208
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 210,
            column: 32
          },
          end: {
            line: 210,
            column: 33
          }
        },
        loc: {
          start: {
            line: 210,
            column: 46
          },
          end: {
            line: 210,
            column: 63
          }
        },
        line: 210
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 213,
            column: 30
          },
          end: {
            line: 213,
            column: 31
          }
        },
        loc: {
          start: {
            line: 213,
            column: 43
          },
          end: {
            line: 218,
            column: 9
          }
        },
        line: 213
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 217,
            column: 34
          },
          end: {
            line: 217,
            column: 35
          }
        },
        loc: {
          start: {
            line: 217,
            column: 48
          },
          end: {
            line: 217,
            column: 65
          }
        },
        line: 217
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 220,
            column: 30
          },
          end: {
            line: 220,
            column: 31
          }
        },
        loc: {
          start: {
            line: 220,
            column: 43
          },
          end: {
            line: 223,
            column: 9
          }
        },
        line: 220
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 222,
            column: 32
          },
          end: {
            line: 222,
            column: 33
          }
        },
        loc: {
          start: {
            line: 222,
            column: 46
          },
          end: {
            line: 222,
            column: 63
          }
        },
        line: 222
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 225,
            column: 30
          },
          end: {
            line: 225,
            column: 31
          }
        },
        loc: {
          start: {
            line: 225,
            column: 43
          },
          end: {
            line: 230,
            column: 9
          }
        },
        line: 225
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 229,
            column: 35
          },
          end: {
            line: 229,
            column: 36
          }
        },
        loc: {
          start: {
            line: 229,
            column: 49
          },
          end: {
            line: 229,
            column: 66
          }
        },
        line: 229
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 232,
            column: 32
          },
          end: {
            line: 232,
            column: 33
          }
        },
        loc: {
          start: {
            line: 232,
            column: 45
          },
          end: {
            line: 237,
            column: 9
          }
        },
        line: 232
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 236,
            column: 37
          },
          end: {
            line: 236,
            column: 38
          }
        },
        loc: {
          start: {
            line: 236,
            column: 51
          },
          end: {
            line: 236,
            column: 68
          }
        },
        line: 236
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 239,
            column: 30
          },
          end: {
            line: 239,
            column: 31
          }
        },
        loc: {
          start: {
            line: 239,
            column: 43
          },
          end: {
            line: 246,
            column: 9
          }
        },
        line: 239
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 245,
            column: 32
          },
          end: {
            line: 245,
            column: 33
          }
        },
        loc: {
          start: {
            line: 245,
            column: 46
          },
          end: {
            line: 245,
            column: 63
          }
        },
        line: 245
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 248,
            column: 32
          },
          end: {
            line: 248,
            column: 33
          }
        },
        loc: {
          start: {
            line: 248,
            column: 45
          },
          end: {
            line: 266,
            column: 9
          }
        },
        line: 248
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 268,
            column: 30
          },
          end: {
            line: 268,
            column: 31
          }
        },
        loc: {
          start: {
            line: 268,
            column: 43
          },
          end: {
            line: 274,
            column: 9
          }
        },
        line: 268
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 273,
            column: 32
          },
          end: {
            line: 273,
            column: 33
          }
        },
        loc: {
          start: {
            line: 273,
            column: 46
          },
          end: {
            line: 273,
            column: 63
          }
        },
        line: 273
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 276,
            column: 32
          },
          end: {
            line: 276,
            column: 33
          }
        },
        loc: {
          start: {
            line: 276,
            column: 45
          },
          end: {
            line: 282,
            column: 9
          }
        },
        line: 276
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 281,
            column: 34
          },
          end: {
            line: 281,
            column: 35
          }
        },
        loc: {
          start: {
            line: 281,
            column: 48
          },
          end: {
            line: 281,
            column: 65
          }
        },
        line: 281
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 286,
            column: 24
          },
          end: {
            line: 286,
            column: 25
          }
        },
        loc: {
          start: {
            line: 286,
            column: 37
          },
          end: {
            line: 289,
            column: 9
          }
        },
        line: 286
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 288,
            column: 37
          },
          end: {
            line: 288,
            column: 38
          }
        },
        loc: {
          start: {
            line: 288,
            column: 51
          },
          end: {
            line: 288,
            column: 68
          }
        },
        line: 288
      },
      "35": {
        name: "preventDefault",
        decl: {
          start: {
            line: 291,
            column: 17
          },
          end: {
            line: 291,
            column: 31
          }
        },
        loc: {
          start: {
            line: 291,
            column: 35
          },
          end: {
            line: 294,
            column: 9
          }
        },
        line: 291
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 301,
            column: 29
          },
          end: {
            line: 301,
            column: 30
          }
        },
        loc: {
          start: {
            line: 301,
            column: 41
          },
          end: {
            line: 307,
            column: 9
          }
        },
        line: 301
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 308,
            column: 29
          },
          end: {
            line: 308,
            column: 30
          }
        },
        loc: {
          start: {
            line: 308,
            column: 42
          },
          end: {
            line: 312,
            column: 9
          }
        },
        line: 308
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 311,
            column: 27
          },
          end: {
            line: 311,
            column: 28
          }
        },
        loc: {
          start: {
            line: 311,
            column: 41
          },
          end: {
            line: 311,
            column: 58
          }
        },
        line: 311
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 314,
            column: 30
          },
          end: {
            line: 314,
            column: 31
          }
        },
        loc: {
          start: {
            line: 314,
            column: 43
          },
          end: {
            line: 335,
            column: 9
          }
        },
        line: 314
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 334,
            column: 36
          },
          end: {
            line: 334,
            column: 37
          }
        },
        loc: {
          start: {
            line: 334,
            column: 50
          },
          end: {
            line: 334,
            column: 71
          }
        },
        line: 334
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 337,
            column: 30
          },
          end: {
            line: 337,
            column: 31
          }
        },
        loc: {
          start: {
            line: 337,
            column: 43
          },
          end: {
            line: 355,
            column: 9
          }
        },
        line: 337
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 354,
            column: 35
          },
          end: {
            line: 354,
            column: 36
          }
        },
        loc: {
          start: {
            line: 354,
            column: 49
          },
          end: {
            line: 354,
            column: 69
          }
        },
        line: 354
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 357,
            column: 30
          },
          end: {
            line: 357,
            column: 31
          }
        },
        loc: {
          start: {
            line: 357,
            column: 43
          },
          end: {
            line: 378,
            column: 9
          }
        },
        line: 357
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 377,
            column: 36
          },
          end: {
            line: 377,
            column: 37
          }
        },
        loc: {
          start: {
            line: 377,
            column: 50
          },
          end: {
            line: 377,
            column: 71
          }
        },
        line: 377
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 380,
            column: 30
          },
          end: {
            line: 380,
            column: 31
          }
        },
        loc: {
          start: {
            line: 380,
            column: 43
          },
          end: {
            line: 399,
            column: 9
          }
        },
        line: 380
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 398,
            column: 41
          },
          end: {
            line: 398,
            column: 42
          }
        },
        loc: {
          start: {
            line: 398,
            column: 55
          },
          end: {
            line: 398,
            column: 81
          }
        },
        line: 398
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 401,
            column: 40
          },
          end: {
            line: 401,
            column: 41
          }
        },
        loc: {
          start: {
            line: 401,
            column: 53
          },
          end: {
            line: 404,
            column: 9
          }
        },
        line: 401
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 403,
            column: 39
          },
          end: {
            line: 403,
            column: 40
          }
        },
        loc: {
          start: {
            line: 403,
            column: 53
          },
          end: {
            line: 403,
            column: 70
          }
        },
        line: 403
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 406,
            column: 50
          },
          end: {
            line: 406,
            column: 51
          }
        },
        loc: {
          start: {
            line: 406,
            column: 63
          },
          end: {
            line: 414,
            column: 9
          }
        },
        line: 406
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 412,
            column: 50
          },
          end: {
            line: 412,
            column: 51
          }
        },
        loc: {
          start: {
            line: 412,
            column: 64
          },
          end: {
            line: 412,
            column: 80
          }
        },
        line: 412
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 416,
            column: 30
          },
          end: {
            line: 416,
            column: 31
          }
        },
        loc: {
          start: {
            line: 416,
            column: 43
          },
          end: {
            line: 427,
            column: 9
          }
        },
        line: 416
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 426,
            column: 37
          },
          end: {
            line: 426,
            column: 38
          }
        },
        loc: {
          start: {
            line: 426,
            column: 51
          },
          end: {
            line: 426,
            column: 71
          }
        },
        line: 426
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 429,
            column: 32
          },
          end: {
            line: 429,
            column: 33
          }
        },
        loc: {
          start: {
            line: 429,
            column: 45
          },
          end: {
            line: 434,
            column: 9
          }
        },
        line: 429
      },
      "54": {
        name: "(anonymous_54)",
        decl: {
          start: {
            line: 433,
            column: 36
          },
          end: {
            line: 433,
            column: 37
          }
        },
        loc: {
          start: {
            line: 433,
            column: 50
          },
          end: {
            line: 433,
            column: 67
          }
        },
        line: 433
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 61,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 61,
            column: 32
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 61,
            column: 32
          }
        }],
        line: 60
      },
      "4": {
        loc: {
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 60,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 12
          },
          end: {
            line: 60,
            column: 17
          }
        }, {
          start: {
            line: 60,
            column: 21
          },
          end: {
            line: 60,
            column: 33
          }
        }],
        line: 60
      },
      "5": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 99,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 99,
            column: 9
          }
        }, {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 99,
            column: 9
          }
        }],
        line: 77
      },
      "6": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        }, {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 104,
            column: 9
          }
        }],
        line: 102
      },
      "7": {
        loc: {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }, {
          start: {
            line: 105,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        }],
        line: 105
      },
      "8": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 123,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 123,
            column: 19
          }
        }, {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 123,
            column: 19
          }
        }],
        line: 122
      },
      "9": {
        loc: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }, {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }],
        line: 139
      },
      "10": {
        loc: {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 160,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 160,
            column: 9
          }
        }, {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 160,
            column: 9
          }
        }],
        line: 157
      },
      "11": {
        loc: {
          start: {
            line: 187,
            column: 12
          },
          end: {
            line: 188,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 187,
            column: 12
          },
          end: {
            line: 188,
            column: 23
          }
        }, {
          start: {
            line: 187,
            column: 12
          },
          end: {
            line: 188,
            column: 23
          }
        }],
        line: 187
      },
      "12": {
        loc: {
          start: {
            line: 190,
            column: 31
          },
          end: {
            line: 190,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 68
          },
          end: {
            line: 190,
            column: 74
          }
        }, {
          start: {
            line: 190,
            column: 77
          },
          end: {
            line: 190,
            column: 95
          }
        }],
        line: 190
      },
      "13": {
        loc: {
          start: {
            line: 190,
            column: 31
          },
          end: {
            line: 190,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 31
          },
          end: {
            line: 190,
            column: 45
          }
        }, {
          start: {
            line: 190,
            column: 49
          },
          end: {
            line: 190,
            column: 65
          }
        }],
        line: 190
      },
      "14": {
        loc: {
          start: {
            line: 192,
            column: 12
          },
          end: {
            line: 194,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 12
          },
          end: {
            line: 194,
            column: 13
          }
        }, {
          start: {
            line: 192,
            column: 12
          },
          end: {
            line: 194,
            column: 13
          }
        }],
        line: 192
      },
      "15": {
        loc: {
          start: {
            line: 192,
            column: 16
          },
          end: {
            line: 192,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 16
          },
          end: {
            line: 192,
            column: 41
          }
        }, {
          start: {
            line: 192,
            column: 45
          },
          end: {
            line: 192,
            column: 65
          }
        }],
        line: 192
      },
      "16": {
        loc: {
          start: {
            line: 193,
            column: 16
          },
          end: {
            line: 193,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 193,
            column: 53
          },
          end: {
            line: 193,
            column: 59
          }
        }, {
          start: {
            line: 193,
            column: 62
          },
          end: {
            line: 193,
            column: 101
          }
        }],
        line: 193
      },
      "17": {
        loc: {
          start: {
            line: 193,
            column: 16
          },
          end: {
            line: 193,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 193,
            column: 16
          },
          end: {
            line: 193,
            column: 30
          }
        }, {
          start: {
            line: 193,
            column: 34
          },
          end: {
            line: 193,
            column: 50
          }
        }],
        line: 193
      },
      "18": {
        loc: {
          start: {
            line: 214,
            column: 12
          },
          end: {
            line: 215,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 12
          },
          end: {
            line: 215,
            column: 23
          }
        }, {
          start: {
            line: 214,
            column: 12
          },
          end: {
            line: 215,
            column: 23
          }
        }],
        line: 214
      },
      "19": {
        loc: {
          start: {
            line: 226,
            column: 12
          },
          end: {
            line: 227,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 226,
            column: 12
          },
          end: {
            line: 227,
            column: 23
          }
        }, {
          start: {
            line: 226,
            column: 12
          },
          end: {
            line: 227,
            column: 23
          }
        }],
        line: 226
      },
      "20": {
        loc: {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 234,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 234,
            column: 23
          }
        }, {
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 234,
            column: 23
          }
        }],
        line: 233
      },
      "21": {
        loc: {
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 241,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 241,
            column: 23
          }
        }, {
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 241,
            column: 23
          }
        }],
        line: 240
      },
      "22": {
        loc: {
          start: {
            line: 249,
            column: 12
          },
          end: {
            line: 265,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 12
          },
          end: {
            line: 265,
            column: 13
          }
        }, {
          start: {
            line: 249,
            column: 12
          },
          end: {
            line: 265,
            column: 13
          }
        }],
        line: 249
      },
      "23": {
        loc: {
          start: {
            line: 251,
            column: 12
          },
          end: {
            line: 253,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 251,
            column: 13
          },
          end: {
            line: 251,
            column: 27
          }
        }, {
          start: {
            line: 251,
            column: 31
          },
          end: {
            line: 251,
            column: 54
          }
        }, {
          start: {
            line: 252,
            column: 17
          },
          end: {
            line: 252,
            column: 26
          }
        }, {
          start: {
            line: 252,
            column: 30
          },
          end: {
            line: 252,
            column: 39
          }
        }, {
          start: {
            line: 253,
            column: 16
          },
          end: {
            line: 253,
            column: 32
          }
        }],
        line: 251
      },
      "24": {
        loc: {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        }, {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        }],
        line: 257
      },
      "25": {
        loc: {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 270,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 270,
            column: 23
          }
        }, {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 270,
            column: 23
          }
        }],
        line: 269
      },
      "26": {
        loc: {
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 278,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 278,
            column: 23
          }
        }, {
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 278,
            column: 23
          }
        }],
        line: 277
      },
      "27": {
        loc: {
          start: {
            line: 319,
            column: 12
          },
          end: {
            line: 330,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 319,
            column: 12
          },
          end: {
            line: 330,
            column: 13
          }
        }, {
          start: {
            line: 319,
            column: 12
          },
          end: {
            line: 330,
            column: 13
          }
        }],
        line: 319
      },
      "28": {
        loc: {
          start: {
            line: 326,
            column: 16
          },
          end: {
            line: 329,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 326,
            column: 16
          },
          end: {
            line: 329,
            column: 17
          }
        }, {
          start: {
            line: 326,
            column: 16
          },
          end: {
            line: 329,
            column: 17
          }
        }],
        line: 326
      },
      "29": {
        loc: {
          start: {
            line: 331,
            column: 12
          },
          end: {
            line: 332,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 331,
            column: 12
          },
          end: {
            line: 332,
            column: 23
          }
        }, {
          start: {
            line: 331,
            column: 12
          },
          end: {
            line: 332,
            column: 23
          }
        }],
        line: 331
      },
      "30": {
        loc: {
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 350,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 350,
            column: 13
          }
        }, {
          start: {
            line: 343,
            column: 12
          },
          end: {
            line: 350,
            column: 13
          }
        }],
        line: 343
      },
      "31": {
        loc: {
          start: {
            line: 343,
            column: 16
          },
          end: {
            line: 346,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 343,
            column: 16
          },
          end: {
            line: 343,
            column: 47
          }
        }, {
          start: {
            line: 344,
            column: 17
          },
          end: {
            line: 344,
            column: 56
          }
        }, {
          start: {
            line: 345,
            column: 20
          },
          end: {
            line: 345,
            column: 71
          }
        }, {
          start: {
            line: 346,
            column: 16
          },
          end: {
            line: 346,
            column: 53
          }
        }],
        line: 343
      },
      "32": {
        loc: {
          start: {
            line: 351,
            column: 12
          },
          end: {
            line: 352,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 351,
            column: 12
          },
          end: {
            line: 352,
            column: 23
          }
        }, {
          start: {
            line: 351,
            column: 12
          },
          end: {
            line: 352,
            column: 23
          }
        }],
        line: 351
      },
      "33": {
        loc: {
          start: {
            line: 362,
            column: 12
          },
          end: {
            line: 373,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 362,
            column: 12
          },
          end: {
            line: 373,
            column: 13
          }
        }, {
          start: {
            line: 362,
            column: 12
          },
          end: {
            line: 373,
            column: 13
          }
        }],
        line: 362
      },
      "34": {
        loc: {
          start: {
            line: 369,
            column: 16
          },
          end: {
            line: 372,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 369,
            column: 16
          },
          end: {
            line: 372,
            column: 17
          }
        }, {
          start: {
            line: 369,
            column: 16
          },
          end: {
            line: 372,
            column: 17
          }
        }],
        line: 369
      },
      "35": {
        loc: {
          start: {
            line: 374,
            column: 12
          },
          end: {
            line: 375,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 374,
            column: 12
          },
          end: {
            line: 375,
            column: 23
          }
        }, {
          start: {
            line: 374,
            column: 12
          },
          end: {
            line: 375,
            column: 23
          }
        }],
        line: 374
      },
      "36": {
        loc: {
          start: {
            line: 386,
            column: 12
          },
          end: {
            line: 391,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 386,
            column: 12
          },
          end: {
            line: 391,
            column: 13
          }
        }, {
          start: {
            line: 386,
            column: 12
          },
          end: {
            line: 391,
            column: 13
          }
        }],
        line: 386
      },
      "37": {
        loc: {
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 393,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 393,
            column: 23
          }
        }, {
          start: {
            line: 392,
            column: 12
          },
          end: {
            line: 393,
            column: 23
          }
        }],
        line: 392
      },
      "38": {
        loc: {
          start: {
            line: 409,
            column: 12
          },
          end: {
            line: 413,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 409,
            column: 12
          },
          end: {
            line: 413,
            column: 13
          }
        }, {
          start: {
            line: 409,
            column: 12
          },
          end: {
            line: 413,
            column: 13
          }
        }],
        line: 409
      },
      "39": {
        loc: {
          start: {
            line: 423,
            column: 12
          },
          end: {
            line: 424,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 423,
            column: 12
          },
          end: {
            line: 424,
            column: 23
          }
        }, {
          start: {
            line: 423,
            column: 12
          },
          end: {
            line: 424,
            column: 23
          }
        }],
        line: 423
      },
      "40": {
        loc: {
          start: {
            line: 430,
            column: 12
          },
          end: {
            line: 431,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 430,
            column: 12
          },
          end: {
            line: 431,
            column: 23
          }
        }, {
          start: {
            line: 430,
            column: 12
          },
          end: {
            line: 431,
            column: 23
          }
        }],
        line: 430
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0,
      "222": 0,
      "223": 0,
      "224": 0,
      "225": 0,
      "226": 0,
      "227": 0,
      "228": 0,
      "229": 0,
      "230": 0,
      "231": 0,
      "232": 0,
      "233": 0,
      "234": 0,
      "235": 0,
      "236": 0,
      "237": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0, 0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,+DAAiD;AAEjD,8DAAgD;AAChD,sCAA4C;AAC5C,sEAAiE;AACjE,0EAAmD;AAgDnD;IAII,cAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QAEpB,IAAI,CAAC,UAAU,GAAG;YACd,YAAY,EAAE,EAAE;YAChB,UAAU,EAAE,EAAE;YACd,WAAW,EAAE,EAAE;YACf,WAAW,EAAE,EAAE;YACf,WAAW,EAAE,EAAE;YACf,aAAa,EAAE,EAAE;YACjB,aAAa,EAAE,EAAE;YACjB,eAAe,EAAE,EAAE;YACnB,cAAc,EAAE,EAAE;YAClB,gBAAgB,EAAE,EAAE;YACpB,WAAW,EAAE,EAAE;YACf,eAAe,EAAE,EAAE;YACnB,eAAe,EAAE,EAAE;YACnB,gBAAgB,EAAE,EAAE;YACpB,kBAAkB,EAAE,EAAE;YACtB,cAAc,EAAE,EAAE;YAClB,yBAAyB,EAAE,EAAE;YAC7B,gBAAgB,EAAE,EAAE;YACpB,eAAe,EAAE,EAAE;YACnB,uBAAuB,EAAE,EAAE;YAC3B,eAAe,EAAE,EAAE;SACtB,CAAA;IACL,CAAC;IAED;;OAEG;IACI,mBAAI,GAAX;QACI,WAAW;QACX,IAAI,CAAC,UAAU,EAAE,CAAA;QAEjB,OAAO;QACP,IAAI,CAAC,eAAe,EAAE,CAAA;QAEtB,kBAAkB;QAClB,eAAc,CAAC,IAAI,CAAC,CAAA;IACxB,CAAC;IAED;;OAEG;IACI,gCAAiB,GAAxB;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,EAAE,CAAA;QACxB,IAAM,YAAY,GAAG,IAAI,CAAC,MAAM,CAAC,kBAAkB,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;QACxE,YAAY,CAAC,IAAI,EAAE,CAAA;QACnB,IAAI,CAAC,IAAI,IAAI,IAAI,KAAK,GAAG;YAAE,YAAY,CAAC,IAAI,EAAE,CAAA;IAClD,CAAC;IAED;;OAEG;IACI,oBAAK,GAAZ;QACI,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;IAC5B,CAAC;IAED;;;OAGG;IACI,mBAAI,GAAX,UAAY,GAAY;QACpB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAElC,oBAAoB;QACpB,IAAI,GAAG,IAAI,IAAI,EAAE;YACb,IAAI,IAAI,GAAG,SAAS,CAAC,IAAI,EAAE,CAAA;YAC3B,sDAAsD;YACtD,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,UAAU,EAAE,EAAE,CAAC,CAAA;YACnC,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,aAAa,EAAE,EAAE,CAAC,CAAA,CAAC,OAAO;YAC9C,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,qBAAqB,EAAE,EAAE,CAAC,CAAA,CAAC,mBAAmB;YAElE;;;;;eAKG;YACH,oEAAoE;YACpE,oEAAoE;YAEpE;;;;;eAKG;YACH,sCAAsC;YAEtC,OAAO,IAAI,CAAA;SACd;QAED,mBAAmB;QACnB,GAAG,GAAG,GAAG,CAAC,IAAI,EAAE,CAAA;QAChB,IAAI,GAAG,KAAK,EAAE,EAAE;YACZ,GAAG,GAAG,aAAa,CAAA;SACtB;QACD,IAAI,GAAG,CAAC,OAAO,CAAC,GAAG,CAAC,KAAK,CAAC,EAAE;YACxB,aAAa;YACb,GAAG,GAAG,QAAM,GAAG,SAAM,CAAA;SACxB;QAED,SAAS,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;QAEnB,mBAAmB;QACnB,MAAM,CAAC,aAAa,EAAE,CAAA;IAC1B,CAAC;IAED;;;OAGG;IACI,sBAAO,GAAd,UAAe,QAAsB;QACjC,IAAM,IAAI,GAAG,2BAAiB,CAAC,QAAQ,CAAC,CAAC,QAAQ,EAAE,CAAA;QACnD,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,aAAa;QACb,IAAI,CAAC,IAAI;YAAE,OAAM;QACjB,eAAe;QACf,SAAS,CAAC,eAAe,CAAC,IAAI,CAAC,CAAA;IACnC,CAAC;IAED;;OAEG;IACI,sBAAO,GAAd;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,OAAO,yBAAe,CAAC,SAAS,CAAC,CAAA;IACrC,CAAC;IAWM,mBAAI,GAAX,UAAY,GAAY;QACpB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAElC,mBAAmB;QACnB,IAAI,GAAG,IAAI,IAAI,EAAE;YACb,IAAI,IAAI,GAAG,SAAS,CAAC,IAAI,EAAE,CAAA;YAC3B,sDAAsD;YACtD,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,UAAU,EAAE,EAAE,CAAC,CAAA;YACnC,OAAO,IAAI,CAAA;SACd;QAED,mBAAmB;QACnB,SAAS,CAAC,IAAI,CAAC,QAAM,GAAG,SAAM,CAAC,CAAA;QAE/B,mBAAmB;QACnB,MAAM,CAAC,aAAa,EAAE,CAAA;IAC1B,CAAC;IAED;;;OAGG;IACI,qBAAM,GAAb,UAAc,IAAY;QACtB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAI,IAAI,CAAC,OAAO,CAAC,GAAG,CAAC,KAAK,CAAC,EAAE;YACzB,iBAAiB;YACjB,IAAI,GAAG,QAAM,IAAI,SAAM,CAAA;SAC1B;QACD,SAAS,CAAC,MAAM,CAAC,kBAAC,CAAC,IAAI,CAAC,CAAC,CAAA;QAEzB,mBAAmB;QACnB,MAAM,CAAC,aAAa,EAAE,CAAA;IAC1B,CAAC;IAED;;OAEG;IACK,yBAAU,GAAlB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAElC,UAAU;QACV,SAAS,SAAS;YACd,SAAS;YACT,MAAM,CAAC,SAAS,CAAC,SAAS,EAAE,CAAA;YAC5B,iBAAiB;YACjB,MAAM,CAAC,KAAK,CAAC,YAAY,EAAE,CAAA;QAC/B,CAAC;QAED,QAAQ;QACR,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,SAAS,CAAC,CAAA;QAChC,SAAS,CAAC,EAAE,CAAC,WAAW,EAAE;YACtB,oCAAoC;YACpC,SAAS,CAAC,EAAE,CAAC,YAAY,EAAE,SAAS,CAAC,CAAA;QACzC,CAAC,CAAC,CAAA;QAEF,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE;YACpB,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;YAClC,IAAM,KAAK,GAAG,SAAS,CAAC,QAAQ,EAAE,CAAA;YAElC,IAAI,KAAK,IAAI,IAAI;gBAAE,OAAM;YAEjB,IAAA,WAAW,GAAgB,KAAK,YAArB,EAAE,SAAS,GAAK,KAAK,UAAV,CAAU;YACxC,IAAI,YAAY,GAAqB,KAAK,aAAL,KAAK,uBAAL,KAAK,CAAE,YAAY,CAAA;YACxD,oCAAoC;YACpC,IAAI,WAAW,KAAK,SAAS,IAAI,YAAY,IAAI,IAAI,EAAE;gBACnD,KAAK,aAAL,KAAK,uBAAL,KAAK,CAAE,QAAQ,CAAC,YAAY,EAAE,SAAS,EAAC;aAC3C;YAED,SAAS,EAAE,CAAA;YAEX,+BAA+B;YAC/B,SAAS,CAAC,GAAG,CAAC,YAAY,EAAE,SAAS,CAAC,CAAA;QAC1C,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACK,8BAAe,GAAvB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;QAElC,cAAc;QACd,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,IAAM,WAAW,GAAG,UAAU,CAAC,WAAW,CAAA;YAC1C,WAAW,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACpC,CAAC,CAAC,CAAA;QAEF,sBAAsB;QACtB,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAgB;YACnC,IAAI,CAAC,CAAC,OAAO,KAAK,EAAE;gBAAE,OAAM;YAC5B,IAAM,aAAa,GAAG,UAAU,CAAC,aAAa,CAAA;YAC9C,aAAa,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACtC,CAAC,CAAC,CAAA;QAEF,iBAAiB;QACjB,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAgB;YACnC,IAAM,WAAW,GAAG,UAAU,CAAC,WAAW,CAAA;YAC1C,WAAW,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACpC,CAAC,CAAC,CAAA;QAEF,sBAAsB;QACtB,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAgB;YACnC,IAAI,CAAC,CAAC,OAAO,KAAK,CAAC;gBAAE,OAAM;YAC3B,IAAM,cAAc,GAAG,UAAU,CAAC,cAAc,CAAA;YAChD,cAAc,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACvC,CAAC,CAAC,CAAA;QAEF,wBAAwB;QACxB,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,UAAC,CAAgB;YACrC,IAAI,CAAC,CAAC,OAAO,KAAK,CAAC;gBAAE,OAAM;YAC3B,IAAM,gBAAgB,GAAG,UAAU,CAAC,gBAAgB,CAAA;YACpD,gBAAgB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACzC,CAAC,CAAC,CAAA;QAEF,KAAK;QACL,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAiB;YACpC,IAAI,SAAE,CAAC,IAAI,EAAE;gBAAE,OAAM,CAAC,SAAS;YAE/B,8BAA8B;YAC9B,CAAC,CAAC,cAAc,EAAE,CAAA;YAElB,IAAM,WAAW,GAAG,UAAU,CAAC,WAAW,CAAA;YAC1C,WAAW,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACpC,CAAC,CAAC,CAAA;QAEF,YAAY;QACZ,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,UAAC,CAAgB;YACrC;YACI,sEAAsE;YACtE,CAAC,MAAM,CAAC,OAAO,IAAI,MAAM,CAAC,gBAAgB,CAAC;gBAC3C,CAAC,CAAC,CAAC,OAAO,IAAI,CAAC,CAAC,OAAO,CAAC;gBACxB,CAAC,CAAC,OAAO,KAAK,EAAE,EAClB;gBACE,SAAS;gBACT,CAAC,CAAC,cAAc,EAAE,CAAA;gBAClB,OAAO;gBACP,IAAI,CAAC,CAAC,QAAQ,EAAE;oBACZ,KAAK;oBACL,MAAM,CAAC,OAAO,CAAC,OAAO,EAAE,CAAA;iBAC3B;qBAAM;oBACH,KAAK;oBACL,MAAM,CAAC,OAAO,CAAC,MAAM,EAAE,CAAA;iBAC1B;aACJ;QACL,CAAC,CAAC,CAAA;QAEF,SAAS;QACT,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAgB;YACnC,IAAI,CAAC,CAAC,OAAO,KAAK,CAAC;gBAAE,OAAM;YAC3B,CAAC,CAAC,cAAc,EAAE,CAAA;YAClB,IAAM,WAAW,GAAG,UAAU,CAAC,WAAW,CAAA;YAC1C,WAAW,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACpC,CAAC,CAAC,CAAA;QAEF,WAAW;QACX,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,UAAC,CAAgB;YACrC,IAAI,CAAC,CAAC,OAAO,KAAK,CAAC;gBAAE,OAAM;YAC3B,CAAC,CAAC,cAAc,EAAE,CAAA;YAClB,IAAM,aAAa,GAAG,UAAU,CAAC,aAAa,CAAA;YAC9C,aAAa,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACtC,CAAC,CAAC,CAAA;QAEF,eAAe;QACf,SAAS,CAAC,EAAE,CACR,QAAQ;QACR,OAAO;QACP,eAAQ,CAAC,UAAC,CAAQ;YACd,IAAM,gBAAgB,GAAG,UAAU,CAAC,gBAAgB,CAAA;YACpD,gBAAgB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACzC,CAAC,EAAE,GAAG,CAAC,CACV,CAAA;QAED,UAAU;QACV,SAAS,cAAc,CAAC,CAAQ;YAC5B,mBAAmB;YACnB,CAAC,CAAC,cAAc,EAAE,CAAA;QACtB,CAAC;QAED,kBAAC,CAAC,QAAQ,CAAC;aACN,EAAE,CAAC,WAAW,EAAE,cAAc,CAAC;aAC/B,EAAE,CAAC,MAAM,EAAE,cAAc,CAAC;aAC1B,EAAE,CAAC,WAAW,EAAE,cAAc,CAAC;aAC/B,EAAE,CAAC,UAAU,EAAE,cAAc,CAAC,CAAA;QACnC,sBAAsB;QACtB,MAAM,CAAC,aAAa,CAAC;YACjB,kBAAC,CAAC,QAAQ,CAAC;iBACN,GAAG,CAAC,WAAW,EAAE,cAAc,CAAC;iBAChC,GAAG,CAAC,MAAM,EAAE,cAAc,CAAC;iBAC3B,GAAG,CAAC,WAAW,EAAE,cAAc,CAAC;iBAChC,GAAG,CAAC,UAAU,EAAE,cAAc,CAAC,CAAA;QACxC,CAAC,CAAC,CAAA;QAEF,SAAS,CAAC,EAAE,CAAC,MAAM,EAAE,UAAC,CAAY;YAC9B,CAAC,CAAC,cAAc,EAAE,CAAA;YAClB,IAAM,MAAM,GAAG,UAAU,CAAC,UAAU,CAAA;YACpC,MAAM,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QAC/B,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,SAAS;YACT,IAAI,KAAK,GAAsB,IAAI,CAAA;YAEnC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YACtC,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;YACzB,IAAI,OAAO,CAAC,WAAW,EAAE,KAAK,GAAG,EAAE;gBAC/B,cAAc;gBACd,KAAK,GAAG,OAAO,CAAA;aAClB;iBAAM;gBACH,eAAe;gBACf,IAAM,OAAO,GAAG,OAAO,CAAC,WAAW,CAAC,GAAG,CAAC,CAAA;gBACxC,IAAI,OAAO,IAAI,IAAI,EAAE;oBACjB,MAAM;oBACN,KAAK,GAAG,OAAO,CAAA;iBAClB;aACJ;YAED,IAAI,CAAC,KAAK;gBAAE,OAAM,CAAC,aAAa;YAEhC,IAAM,eAAe,GAAG,UAAU,CAAC,eAAe,CAAA;YAClD,eAAe,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,KAAmB,CAAC,EAAvB,CAAuB,CAAC,CAAA;QAC1D,CAAC,CAAC,CAAA;QAEF,YAAY;QACZ,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,SAAS;YACT,IAAI,IAAI,GAAsB,IAAI,CAAA;YAElC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YACtC,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;YAEzB,wDAAwD;YACxD,IACI,OAAO,CAAC,WAAW,EAAE,KAAK,KAAK;gBAC/B,CAAC,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,OAAO,CAAC;oBACpC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,OAAO,CAAC,KAAK,QAAQ,CAAC;gBACxD,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,YAAY,CAAC,KAAK,CAAC,EACvC;gBACE,aAAa;gBACb,CAAC,CAAC,eAAe,EAAE,CAAA;gBACnB,IAAI,GAAG,OAAO,CAAA;aACjB;YACD,IAAI,CAAC,IAAI;gBAAE,OAAM,CAAC,aAAa;YAE/B,IAAM,cAAc,GAAG,UAAU,CAAC,cAAc,CAAA;YAChD,cAAc,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,IAAkB,CAAC,EAAtB,CAAsB,CAAC,CAAA;QACxD,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,SAAS;YACT,IAAI,KAAK,GAAsB,IAAI,CAAA;YAEnC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YACtC,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;YACzB,IAAI,OAAO,CAAC,WAAW,EAAE,KAAK,KAAK,EAAE;gBACjC,cAAc;gBACd,KAAK,GAAG,OAAO,CAAA;aAClB;iBAAM;gBACH,eAAe;gBACf,IAAM,OAAO,GAAG,OAAO,CAAC,WAAW,CAAC,KAAK,CAAC,CAAA;gBAC1C,IAAI,OAAO,KAAK,IAAI,EAAE;oBAClB,MAAM;oBACN,KAAK,GAAG,OAAO,CAAA;iBAClB;aACJ;YAED,IAAI,CAAC,KAAK;gBAAE,OAAM;YAElB,IAAM,eAAe,GAAG,UAAU,CAAC,eAAe,CAAA;YAClD,eAAe,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,KAAmB,CAAC,EAAvB,CAAuB,CAAC,CAAA;QAC1D,CAAC,CAAC,CAAA;QAEF,kBAAkB;QAClB,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,UAAU;YACV,IAAI,UAAU,GAAsB,IAAI,CAAA;YAExC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YACtC,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;YACzB,WAAW;YACX,IAAI,OAAO,CAAC,WAAW,EAAE,KAAK,IAAI,EAAE;gBAChC,UAAU,GAAG,OAAO,CAAA;aACvB;iBAAM;gBACH,OAAO,IAAI,IAAI,CAAA;aAClB;YAED,IAAI,CAAC,UAAU;gBAAE,OAAM,CAAC,cAAc;YACtC,UAAU;YACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,UAAU,CAAC,CAAA;YAC9C,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;YACnC,IAAM,oBAAoB,GAAG,UAAU,CAAC,eAAe,CAAA;YACvD,oBAAoB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,UAAwB,CAAC,EAA5B,CAA4B,CAAC,CAAA;QACpE,CAAC,CAAC,CAAA;QAEF,SAAS;QACT,MAAM,CAAC,YAAY,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YACrC,IAAM,kBAAkB,GAAG,UAAU,CAAC,kBAAkB,CAAA;YACxD,kBAAkB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QAC3C,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,MAAM,CAAC,kBAAkB,CAAC,EAAE,CAAC,WAAW,EAAE,UAAC,CAAa;YACpD,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YACtC,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;YACzB,IAAI,OAAO,CAAC,QAAQ,CAAC,iBAAiB,CAAC,EAAE;gBACrC,uBAAuB;gBACvB,IAAM,yBAAyB,GAAG,UAAU,CAAC,yBAAyB,CAAA;gBACtE,yBAAyB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,EAAE,EAAJ,CAAI,CAAC,CAAA;aAChD;QACL,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,SAAS,CAAC,EAAE,CAAC,OAAO,EAAE,UAAC,CAAQ;YAC3B,OAAO;YACP,IAAI,IAAI,GAAsB,IAAI,CAAA;YAElC,IAAM,MAAM,GAAG,CAAC,CAAC,MAAqB,CAAA;YAEtC,SAAS;YACT,IAAI,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAC,WAAW,CAAC,OAAO,EAAE,MAAM,CAAC,CAAA;YAE7C,iBAAiB;YACjB,IAAI,CAAC,IAAI;gBAAE,OAAM;YAEjB,IAAM,gBAAgB,GAAG,UAAU,CAAC,gBAAgB,CAAA;YACpD,gBAAgB,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,IAAkB,CAAC,EAAtB,CAAsB,CAAC,CAAA;QAC1D,CAAC,CAAC,CAAA;QAEF,eAAe;QACf,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,UAAC,CAAgB;YACrC,IAAI,CAAC,CAAC,OAAO,KAAK,EAAE;gBAAE,OAAM;YAC5B,IAAM,eAAe,GAAG,UAAU,CAAC,eAAe,CAAA;YAClD,eAAe,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,CAAC,CAAC,CAAC,EAAL,CAAK,CAAC,CAAA;QACxC,CAAC,CAAC,CAAA;IACN,CAAC;IACL,WAAC;AAAD,CAAC,AAxeD,IAweC;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u7F16\u8F91\u533A\u57DF\uFF0C\u5165\u53E3\u6587\u4EF6\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../utils/dom-core'\nimport Editor from '../editor/index'\nimport initEventHooks from './event-hooks/index'\nimport { UA, throttle } from '../utils/util'\nimport getChildrenJSON, { NodeListType } from './getChildrenJSON'\nimport getHtmlByNodeList from './getHtmlByNodeList'\n\n/** \u6309\u952E\u51FD\u6570 */\ntype KeyBoardHandler = (event: KeyboardEvent) => unknown\n/** \u666E\u901A\u4E8B\u4EF6\u56DE\u8C03 */\ntype EventHandler = (event: Event) => unknown\n// \u5404\u4E2A\u4E8B\u4EF6\u94A9\u5B50\u51FD\u6570\ntype TextEventHooks = {\n    changeEvents: (() => void)[] // \u5185\u5BB9\u4FEE\u6539\u65F6\n    dropEvents: ((event: DragEvent) => unknown)[]\n    clickEvents: EventHandler[]\n    keyupEvents: KeyBoardHandler[]\n    /** tab \u952E\uFF08keyCode === \uFF09Up \u65F6 */\n    tabUpEvents: KeyBoardHandler[]\n    /** tab \u952E\uFF08keyCode === 9\uFF09Down \u65F6 */\n    tabDownEvents: KeyBoardHandler[]\n    /** enter \u952E\uFF08keyCode === 13\uFF09up \u65F6 */\n    enterUpEvents: KeyBoardHandler[]\n    /** enter \u952E\uFF08keyCode === 13\uFF09down \u65F6 */\n    enterDownEvents: KeyBoardHandler[]\n    /** \u5220\u9664\u952E\uFF08keyCode === 8\uFF09up \u65F6 */\n    deleteUpEvents: KeyBoardHandler[]\n    /** \u5220\u9664\u952E\uFF08keyCode === 8\uFF09down \u65F6 */\n    deleteDownEvents: KeyBoardHandler[]\n    /** \u7C98\u8D34\u4E8B\u4EF6 */\n    pasteEvents: ((e: ClipboardEvent) => void)[]\n    /** \u70B9\u51FB\u94FE\u63A5\u4E8B\u4EF6 */\n    linkClickEvents: ((e: DomElement) => void)[]\n    /** \u70B9\u51FB\u4EE3\u7801\u4E8B\u4EF6 */\n    codeClickEvents: ((e: DomElement) => void)[]\n    /** \u7F16\u8F91\u533A\u57DF\u6ED1\u52A8\u4E8B\u4EF6 */\n    textScrollEvents: EventHandler[]\n    /** \u83DC\u5355\u680F\u88AB\u70B9\u51FB */\n    toolbarClickEvents: EventHandler[]\n    /** \u56FE\u7247\u88AB\u70B9\u51FB\u4E8B\u4EF6 */\n    imgClickEvents: ((e: DomElement) => void)[]\n    /** \u56FE\u7247\u62D6\u62FDMouseDown */\n    imgDragBarMouseDownEvents: (() => void)[]\n    /** \u8868\u683C\u70B9\u51FB */\n    tableClickEvents: ((e: DomElement) => void)[]\n    /** \u6BCF\u4E2A\u83DC\u5355\u88AB\u70B9\u51FB\u65F6\uFF0C\u6309\u7406\u8BF4\u8FD9\u4E2A\u4E0D\u5C5E\u4E8E txt \u7684\uFF0C\u5148\u6682\u65F6\u5728\u8FD9\u653E\u7740\u5427 */\n    menuClickEvents: (() => void)[]\n    /** droplist \u83DC\u5355\u60AC\u6D6E\u4E8B\u4EF6\u3002\u6682\u65F6\u653E\u8FD9\u91CC */\n    dropListMenuHoverEvents: (() => void)[]\n    /** \u70B9\u51FB\u5206\u5272\u7EBF\u65F6 */\n    splitLineEvents: ((e: DomElement) => void)[]\n}\n\nclass Text {\n    public editor: Editor\n    public eventHooks: TextEventHooks // Text \u5404\u4E2A\u4E8B\u4EF6\u7684\u94A9\u5B50\u51FD\u6570\uFF0C\u5982 keyup \u65F6\u8981\u6267\u884C\u54EA\u4E9B\u51FD\u6570\n\n    constructor(editor: Editor) {\n        this.editor = editor\n\n        this.eventHooks = {\n            changeEvents: [],\n            dropEvents: [],\n            clickEvents: [],\n            keyupEvents: [],\n            tabUpEvents: [],\n            tabDownEvents: [],\n            enterUpEvents: [],\n            enterDownEvents: [],\n            deleteUpEvents: [],\n            deleteDownEvents: [],\n            pasteEvents: [],\n            linkClickEvents: [],\n            codeClickEvents: [],\n            textScrollEvents: [],\n            toolbarClickEvents: [],\n            imgClickEvents: [],\n            imgDragBarMouseDownEvents: [],\n            tableClickEvents: [],\n            menuClickEvents: [],\n            dropListMenuHoverEvents: [],\n            splitLineEvents: [],\n        }\n    }\n\n    /**\n     * \u521D\u59CB\u5316\n     */\n    public init(): void {\n        // \u5B9E\u65F6\u4FDD\u5B58\u9009\u53D6\u8303\u56F4\n        this._saveRange()\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\n        this._bindEventHooks()\n\n        // \u521D\u59CB\u5316 text \u4E8B\u4EF6\u94A9\u5B50\u51FD\u6570\n        initEventHooks(this)\n    }\n\n    /**\n     * \u5207\u6362placeholder\n     */\n    public togglePlaceholder(): void {\n        const html = this.html()\n        const $placeholder = this.editor.$textContainerElem.find('.placeholder')\n        $placeholder.hide()\n        if (!html || html === ' ') $placeholder.show()\n    }\n\n    /**\n     * \u6E05\u7A7A\u5185\u5BB9\n     */\n    public clear(): void {\n        this.html('<p><br></p>')\n    }\n\n    /**\n     * \u8BBE\u7F6E/\u83B7\u53D6 html\n     * @param val html \u5B57\u7B26\u4E32\n     */\n    public html(val?: string): void | string {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n\n        // \u6CA1\u6709 val \uFF0C\u5219\u662F\u83B7\u53D6 html\n        if (val == null) {\n            let html = $textElem.html()\n            // \u672A\u9009\u4E2D\u4EFB\u4F55\u5185\u5BB9\u7684\u65F6\u5019\u70B9\u51FB\u201C\u52A0\u7C97\u201D\u6216\u8005\u201C\u659C\u4F53\u201D\u7B49\u6309\u94AE\uFF0C\u5C31\u5F97\u9700\u8981\u4E00\u4E2A\u7A7A\u7684\u5360\u4F4D\u7B26 &#8203 \uFF0C\u8FD9\u91CC\u66FF\u6362\u6389\n            html = html.replace(/\\u200b/gm, '')\n            html = html.replace(/<p><\\/p>/gim, '') // \u53BB\u6389\u7A7A\u884C\n            html = html.replace(/<p><br\\/?><\\/p>$/gim, '') // \u53BB\u6389\u6700\u540E\u7684 <p><br><p>\n\n            /**\n             * \u8FD9\u91CC\u7684\u4EE3\u7801\u4E3A\u4E86\u5904\u7406\u706B\u72D0\u591A\u4F59\u7684\u7A7A\u884C\u6807\u7B7E,\u4F46\u662F\u5F3A\u5236\u5220\u9664\u7A7A\u884C\u6807\u7B7E\u4F1A\u5E26\u6765\u5176\u4ED6\u95EE\u9898\n             * html()\u65B9\u6CD5\u8FD4\u56DE\u7684\u7684\u503C,\"<p><br></p>\"\u4E2Dpr\u4F1A\u88AB\u5220\u9664,\u53EA\u7559\u4E0B<p>,\u70B9\u4E0D\u8FDB\u53BB,\u4ECE\u800C\u4EA7\u751F\u5783\u573E\u6570\u636E\n             * \u76EE\u524D\u5728\u672B\u4F4D\u6709\u591A\u4E2A\u7A7A\u884C\u7684\u60C5\u51B5\u4E0B\u6267\u884C\u64A4\u9500\u91CD\u505A\u64CD\u4F5C,\u4F1A\u4EA7\u751F\u4E00\u79CD\u4E0D\u8BB0\u5F55\u672B\u5C3E\u7A7A\u884C\u7684\u9519\u89C9\n             * \u6682\u65F6\u6CE8\u91CA, \u7B49\u5F85\u8FDB\u4E00\u6B65\u7684\u517C\u5BB9\u5904\u7406\n             */\n            // html = html.replace(/><br>(?!<)/gi, '>') // \u8FC7\u6EE4 <p><br>\u5185\u5BB9</p> \u4E2D\u7684br\n            // html = html.replace(/(?!>)<br></gi, '<') // \u8FC7\u6EE4 <p>\u5185\u5BB9<br></p> \u4E2D\u7684br\n\n            /**\n             * pre\u6807\u7B7E\u683C\u5F0F\u5316\n             * html()\u65B9\u6CD5\u7406\u8BBA\u4E0A\u5E94\u5F53\u8F93\u51FA\u7EAF\u51C0\u7684\u4EE3\u7801\u6587\u672C,\u4F46\u662F\u5BF9\u4E8E\u662F\u5426\u89E3\u6790html\u6807\u7B7E\u8FD8\u6CA1\u6709\u826F\u597D\u7684\u5224\u65AD\n             * \u5982\u679C\u53BB\u9664hljs\u7684\u6807\u7B7E,\u5728\u89E3\u6790\u72B6\u6001\u4E0B\u56DE\u663E,\u4F1A\u9020\u6210\u663E\u793A\u9519\u8BEF\u5E76\u4E14\u65E0\u6CD5\u518D\u901A\u8FC7hljs\u65B9\u6CD5\u6E32\u67D3\n             * \u6682\u4E14\u5176\u5F03\u7528\n             */\n            // html = formatCodeHtml(editor, html)\n\n            return html\n        }\n\n        // \u6709 val \uFF0C\u5219\u662F\u8BBE\u7F6E html\n        val = val.trim()\n        if (val === '') {\n            val = `<p><br></p>`\n        }\n        if (val.indexOf('<') !== 0) {\n            // \u5185\u5BB9\u7528 p \u6807\u7B7E\u5305\u88F9\n            val = `<p>${val}</p>`\n        }\n\n        $textElem.html(val)\n\n        // \u521D\u59CB\u5316\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u5185\u5BB9\u5C3E\u90E8\n        editor.initSelection()\n    }\n\n    /**\n     * \u5C06json\u8BBE\u7F6E\u6210html\u81F3\u7F16\u8F91\u5668\n     * @param nodeList json\u683C\u5F0F\n     */\n    public setJSON(nodeList: NodeListType): void {\n        const html = getHtmlByNodeList(nodeList).children()\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        // \u6CA1\u6709\u83B7\u53D6\u5230\u5143\u7D20\u7684\u60C5\u51B5\n        if (!html) return\n        // \u66FF\u6362\u6587\u672C\u8282\u70B9\u4E0B\u5168\u90E8\u5B50\u8282\u70B9\n        $textElem.replaceChildAll(html)\n    }\n\n    /**\n     * \u83B7\u53D6 json \u683C\u5F0F\u7684\u6570\u636E\n     */\n    public getJSON(): NodeListType {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        return getChildrenJSON($textElem)\n    }\n\n    /**\n     * \u8BBE\u7F6E \u5B57\u7B26\u4E32\u5185\u5BB9\n     * @param val text \u5B57\u7B26\u4E32\n     */\n    public text(val: string): void\n    /**\n     * \u83B7\u53D6 \u5B57\u7B26\u4E32\u5185\u5BB9\n     */\n    public text(): string\n    public text(val?: string): void | string {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n\n        // \u6CA1\u6709 val \uFF0C\u662F\u83B7\u53D6 text\n        if (val == null) {\n            let text = $textElem.text()\n            // \u672A\u9009\u4E2D\u4EFB\u4F55\u5185\u5BB9\u7684\u65F6\u5019\u70B9\u51FB\u201C\u52A0\u7C97\u201D\u6216\u8005\u201C\u659C\u4F53\u201D\u7B49\u6309\u94AE\uFF0C\u5C31\u5F97\u9700\u8981\u4E00\u4E2A\u7A7A\u7684\u5360\u4F4D\u7B26 &#8203 \uFF0C\u8FD9\u91CC\u66FF\u6362\u6389\n            text = text.replace(/\\u200b/gm, '')\n            return text\n        }\n\n        // \u6709 val \uFF0C\u5219\u662F\u8BBE\u7F6E text\n        $textElem.text(`<p>${val}</p>`)\n\n        // \u521D\u59CB\u5316\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u5185\u5BB9\u5C3E\u90E8\n        editor.initSelection()\n    }\n\n    /**\n     * \u8FFD\u52A0 html \u5185\u5BB9\n     * @param html html \u5B57\u7B26\u4E32\n     */\n    public append(html: string): void {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        if (html.indexOf('<') !== 0) {\n            // \u666E\u901A\u5B57\u7B26\u4E32\uFF0C\u7528 <p> \u5305\u88F9\n            html = `<p>${html}</p>`\n        }\n        $textElem.append($(html))\n\n        // \u521D\u59CB\u5316\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u5185\u5BB9\u5C3E\u90E8\n        editor.initSelection()\n    }\n\n    /**\n     * \u6BCF\u4E00\u6B65\u64CD\u4F5C\uFF0C\u90FD\u5B9E\u65F6\u4FDD\u5B58\u9009\u533A\u8303\u56F4\n     */\n    private _saveRange(): void {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n\n        // \u4FDD\u5B58\u5F53\u524D\u7684\u9009\u533A\n        function saveRange() {\n            // \u968F\u65F6\u4FDD\u5B58\u9009\u533A\n            editor.selection.saveRange()\n            // \u66F4\u65B0\u6309\u94AE active \u72B6\u6001\n            editor.menus.changeActive()\n        }\n\n        // \u6309\u952E\u540E\u4FDD\u5B58\n        $textElem.on('keyup', saveRange)\n        $textElem.on('mousedown', () => {\n            // mousedown \u72B6\u6001\u4E0B\uFF0C\u9F20\u6807\u6ED1\u52A8\u5230\u7F16\u8F91\u533A\u57DF\u5916\u9762\uFF0C\u4E5F\u9700\u8981\u4FDD\u5B58\u9009\u533A\n            $textElem.on('mouseleave', saveRange)\n        })\n\n        $textElem.on('mouseup', () => {\n            const selection = editor.selection\n            const range = selection.getRange()\n\n            if (range == null) return\n\n            const { startOffset, endOffset } = range\n            let endContainer: Node | undefined = range?.endContainer\n            // \u4FEE\u590D\u5F53selection\u7ED3\u675F\u65F6\uFF0C\u70B9\u51FB\u7F16\u8F91\u5668\u5185\u90E8\uFF0C\u4FDD\u5B58\u9009\u533A\u5F02\u5E38\u7684\u60C5\u51B5\n            if (startOffset !== endOffset && endContainer != null) {\n                range?.setStart(endContainer, endOffset)\n            }\n\n            saveRange()\n\n            // \u5728\u7F16\u8F91\u5668\u533A\u57DF\u4E4B\u5185\u5B8C\u6210\u70B9\u51FB\uFF0C\u53D6\u6D88\u9F20\u6807\u6ED1\u52A8\u5230\u7F16\u8F91\u533A\u5916\u9762\u7684\u4E8B\u4EF6\n            $textElem.off('mouseleave', saveRange)\n        })\n    }\n\n    /**\n     * \u7ED1\u5B9A\u4E8B\u4EF6\uFF0C\u4E8B\u4EF6\u4F1A\u89E6\u53D1\u94A9\u5B50\u51FD\u6570\n     */\n    private _bindEventHooks(): void {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        const eventHooks = this.eventHooks\n\n        // click hooks\n        $textElem.on('click', (e: Event) => {\n            const clickEvents = eventHooks.clickEvents\n            clickEvents.forEach(fn => fn(e))\n        })\n\n        // enter \u952E up \u65F6\u7684 hooks\n        $textElem.on('keyup', (e: KeyboardEvent) => {\n            if (e.keyCode !== 13) return\n            const enterUpEvents = eventHooks.enterUpEvents\n            enterUpEvents.forEach(fn => fn(e))\n        })\n\n        // \u952E\u76D8 up \u65F6\u7684 hooks\n        $textElem.on('keyup', (e: KeyboardEvent) => {\n            const keyupEvents = eventHooks.keyupEvents\n            keyupEvents.forEach(fn => fn(e))\n        })\n\n        // delete \u952E up \u65F6 hooks\n        $textElem.on('keyup', (e: KeyboardEvent) => {\n            if (e.keyCode !== 8) return\n            const deleteUpEvents = eventHooks.deleteUpEvents\n            deleteUpEvents.forEach(fn => fn(e))\n        })\n\n        // delete \u952E down \u65F6 hooks\n        $textElem.on('keydown', (e: KeyboardEvent) => {\n            if (e.keyCode !== 8) return\n            const deleteDownEvents = eventHooks.deleteDownEvents\n            deleteDownEvents.forEach(fn => fn(e))\n        })\n\n        // \u7C98\u8D34\n        $textElem.on('paste', (e: ClipboardEvent) => {\n            if (UA.isIE()) return // IE \u4E0D\u652F\u6301\n\n            // \u963B\u6B62\u9ED8\u8BA4\u884C\u4E3A\uFF0C\u4F7F\u7528 execCommand \u7684\u7C98\u8D34\u547D\u4EE4\n            e.preventDefault()\n\n            const pasteEvents = eventHooks.pasteEvents\n            pasteEvents.forEach(fn => fn(e))\n        })\n\n        // \u64A4\u9500/\u6062\u590D \u5FEB\u6377\u952E\n        $textElem.on('keydown', (e: KeyboardEvent) => {\n            if (\n                // \u7F16\u8F91\u5668\u5904\u4E8E\u805A\u7126\u72B6\u6001\u4E0B\uFF08\u591A\u7F16\u8F91\u5668\u5B9E\u4F8B\uFF09 || \u5F53\u524D\u5904\u4E8E\u517C\u5BB9\u6A21\u5F0F\uFF08\u517C\u5BB9\u6A21\u5F0F\u64A4\u9500/\u6062\u590D\u540E\u4E0D\u805A\u7126\uFF0C\u6240\u4EE5\u76F4\u63A5\u8FC7\uFF0C\u4F46\u4F1A\u9020\u6210\u591A\u7F16\u8F91\u5668\u540C\u65F6\u64A4\u9500/\u6062\u590D\uFF09\n                (editor.isFocus || editor.isCompatibleMode) &&\n                (e.ctrlKey || e.metaKey) &&\n                e.keyCode === 90\n            ) {\n                // \u53D6\u6D88\u9ED8\u8BA4\u884C\u4E3A\n                e.preventDefault()\n                // \u6267\u884C\u4E8B\u4EF6\n                if (e.shiftKey) {\n                    // \u6062\u590D\n                    editor.history.restore()\n                } else {\n                    // \u64A4\u9500\n                    editor.history.revoke()\n                }\n            }\n        })\n\n        // tab up\n        $textElem.on('keyup', (e: KeyboardEvent) => {\n            if (e.keyCode !== 9) return\n            e.preventDefault()\n            const tabUpEvents = eventHooks.tabUpEvents\n            tabUpEvents.forEach(fn => fn(e))\n        })\n\n        // tab down\n        $textElem.on('keydown', (e: KeyboardEvent) => {\n            if (e.keyCode !== 9) return\n            e.preventDefault()\n            const tabDownEvents = eventHooks.tabDownEvents\n            tabDownEvents.forEach(fn => fn(e))\n        })\n\n        // \u6587\u672C\u7F16\u8F91\u533A\u57DF \u6EDA\u52A8\u65F6\u89E6\u53D1\n        $textElem.on(\n            'scroll',\n            // \u4F7F\u7528\u8282\u6D41\n            throttle((e: Event) => {\n                const textScrollEvents = eventHooks.textScrollEvents\n                textScrollEvents.forEach(fn => fn(e))\n            }, 100)\n        )\n\n        // \u62D6\u62FD\u76F8\u5173\u7684\u4E8B\u4EF6\n        function preventDefault(e: Event) {\n            // \u7981\u7528 document \u62D6\u62FD\u4E8B\u4EF6\n            e.preventDefault()\n        }\n\n        $(document)\n            .on('dragleave', preventDefault)\n            .on('drop', preventDefault)\n            .on('dragenter', preventDefault)\n            .on('dragover', preventDefault)\n        // \u5168\u5C40\u4E8B\u4EF6\u5728\u7F16\u8F91\u5668\u5B9E\u4F8B\u9500\u6BC1\u7684\u65F6\u5019\u8FDB\u884C\u89E3\u7ED1\n        editor.beforeDestroy(function () {\n            $(document)\n                .off('dragleave', preventDefault)\n                .off('drop', preventDefault)\n                .off('dragenter', preventDefault)\n                .off('dragover', preventDefault)\n        })\n\n        $textElem.on('drop', (e: DragEvent) => {\n            e.preventDefault()\n            const events = eventHooks.dropEvents\n            events.forEach(fn => fn(e))\n        })\n\n        // link click\n        $textElem.on('click', (e: Event) => {\n            // \u5B58\u50A8\u94FE\u63A5\u5143\u7D20\n            let $link: DomElement | null = null\n\n            const target = e.target as HTMLElement\n            const $target = $(target)\n            if ($target.getNodeName() === 'A') {\n                // \u5F53\u524D\u70B9\u51FB\u7684\u5C31\u662F\u4E00\u4E2A\u94FE\u63A5\n                $link = $target\n            } else {\n                // \u5426\u5219\uFF0C\u5411\u7236\u8282\u70B9\u4E2D\u5BFB\u627E\u94FE\u63A5\n                const $parent = $target.parentUntil('a')\n                if ($parent != null) {\n                    // \u627E\u5230\u4E86\n                    $link = $parent\n                }\n            }\n\n            if (!$link) return // \u6CA1\u6709\u70B9\u51FB\u94FE\u63A5\uFF0C\u5219\u8FD4\u56DE\n\n            const linkClickEvents = eventHooks.linkClickEvents\n            linkClickEvents.forEach(fn => fn($link as DomElement))\n        })\n\n        // img click\n        $textElem.on('click', (e: Event) => {\n            // \u5B58\u50A8\u56FE\u7247\u5143\u7D20\n            let $img: DomElement | null = null\n\n            const target = e.target as HTMLElement\n            const $target = $(target)\n\n            //\u5904\u7406\u56FE\u7247\u70B9\u51FB \u5224\u65AD\u662F\u5426\u662F\u8868\u60C5 \u6839\u636E \u4E0D\u5B58\u5728class\u6216\u8005className!==eleImg\u3001\u6CA1\u6709alt\u5C5E\u6027\n            if (\n                $target.getNodeName() === 'IMG' &&\n                (!$target.elems[0].getAttribute('class') ||\n                    $target.elems[0].getAttribute('class') !== 'eleImg') &&\n                !$target.elems[0].getAttribute('alt')\n            ) {\n                // \u5F53\u524D\u70B9\u51FB\u7684\u5C31\u662Fimg\n                e.stopPropagation()\n                $img = $target\n            }\n            if (!$img) return // \u6CA1\u6709\u70B9\u51FB\u56FE\u7247\uFF0C\u5219\u8FD4\u56DE\n\n            const imgClickEvents = eventHooks.imgClickEvents\n            imgClickEvents.forEach(fn => fn($img as DomElement))\n        })\n\n        // code click\n        $textElem.on('click', (e: Event) => {\n            // \u5B58\u50A8\u4EE3\u7801\u5143\u7D20\n            let $code: DomElement | null = null\n\n            const target = e.target as HTMLElement\n            const $target = $(target)\n            if ($target.getNodeName() === 'PRE') {\n                // \u5F53\u524D\u70B9\u51FB\u7684\u5C31\u662F\u4E00\u4E2A\u94FE\u63A5\n                $code = $target\n            } else {\n                // \u5426\u5219\uFF0C\u5411\u7236\u8282\u70B9\u4E2D\u5BFB\u627E\u94FE\u63A5\n                const $parent = $target.parentUntil('pre')\n                if ($parent !== null) {\n                    // \u627E\u5230\u4E86\n                    $code = $parent\n                }\n            }\n\n            if (!$code) return\n\n            const codeClickEvents = eventHooks.codeClickEvents\n            codeClickEvents.forEach(fn => fn($code as DomElement))\n        })\n\n        // splitLine click\n        $textElem.on('click', (e: Event) => {\n            // \u5B58\u50A8\u5206\u5272\u7EBF\u5143\u7D20\n            let $splitLine: DomElement | null = null\n\n            const target = e.target as HTMLElement\n            const $target = $(target)\n            // \u5224\u65AD\u5F53\u524D\u70B9\u51FB\u5143\u7D20\n            if ($target.getNodeName() === 'HR') {\n                $splitLine = $target\n            } else {\n                $target == null\n            }\n\n            if (!$splitLine) return // \u6CA1\u6709\u70B9\u51FB\u5206\u5272\u7EBF\uFF0C\u5219\u8FD4\u56DE\n            // \u8BBE\u7F6E\u3001\u6062\u590D\u9009\u533A\n            editor.selection.createRangeByElem($splitLine)\n            editor.selection.restoreSelection()\n            const splitLineClickEvents = eventHooks.splitLineEvents\n            splitLineClickEvents.forEach(fn => fn($splitLine as DomElement))\n        })\n\n        // \u83DC\u5355\u680F\u88AB\u70B9\u51FB\n        editor.$toolbarElem.on('click', (e: Event) => {\n            const toolbarClickEvents = eventHooks.toolbarClickEvents\n            toolbarClickEvents.forEach(fn => fn(e))\n        })\n\n        //mousedown\u4E8B\u4EF6\n        editor.$textContainerElem.on('mousedown', (e: MouseEvent) => {\n            const target = e.target as HTMLElement\n            const $target = $(target)\n            if ($target.hasClass('w-e-img-drag-rb')) {\n                // \u70B9\u51FB\u7684\u5143\u7D20\uFF0C\u662F\u56FE\u7247\u62D6\u62FD\u8C03\u6574\u5927\u5C0F\u7684 bar\n                const imgDragBarMouseDownEvents = eventHooks.imgDragBarMouseDownEvents\n                imgDragBarMouseDownEvents.forEach(fn => fn())\n            }\n        })\n\n        //table click\n        $textElem.on('click', (e: Event) => {\n            // \u5B58\u50A8\u5143\u7D20\n            let $dom: DomElement | null = null\n\n            const target = e.target as HTMLElement\n\n            //\u83B7\u53D6\u6700\u7956\u7236\u5143\u7D20\n            $dom = $(target).parentUntil('TABLE', target)\n\n            // \u6CA1\u6709table\u8303\u56F4\u5185\uFF0C\u5219\u8FD4\u56DE\n            if (!$dom) return\n\n            const tableClickEvents = eventHooks.tableClickEvents\n            tableClickEvents.forEach(fn => fn($dom as DomElement))\n        })\n\n        // enter \u952E down\n        $textElem.on('keydown', (e: KeyboardEvent) => {\n            if (e.keyCode !== 13) return\n            const enterDownEvents = eventHooks.enterDownEvents\n            enterDownEvents.forEach(fn => fn(e))\n        })\n    }\n}\n\nexport default Text\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aa4a1dd1f55cb6b6bbe64a70250163a1e763cd55"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ywwwnyyy3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ywwwnyyy3();

var __importDefault = (cov_1ywwwnyyy3().s[0]++, (cov_1ywwwnyyy3().b[0][0]++, void 0) && (cov_1ywwwnyyy3().b[0][1]++, (void 0).__importDefault) || (cov_1ywwwnyyy3().b[0][2]++, function (mod) {
  cov_1ywwwnyyy3().f[0]++;
  cov_1ywwwnyyy3().s[1]++;
  return (cov_1ywwwnyyy3().b[2][0]++, mod) && (cov_1ywwwnyyy3().b[2][1]++, mod.__esModule) ? (cov_1ywwwnyyy3().b[1][0]++, mod) : (cov_1ywwwnyyy3().b[1][1]++, {
    "default": mod
  });
}));

cov_1ywwwnyyy3().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1ywwwnyyy3().s[3]++, __importDefault(__webpack_require__(2)));
var index_1 = (cov_1ywwwnyyy3().s[4]++, __importDefault(__webpack_require__(285)));
var util_1 = (cov_1ywwwnyyy3().s[5]++, __webpack_require__(7));
var getChildrenJSON_1 = (cov_1ywwwnyyy3().s[6]++, __importDefault(__webpack_require__(297)));
var getHtmlByNodeList_1 = (cov_1ywwwnyyy3().s[7]++, __importDefault(__webpack_require__(298)));
var Text = (
/** @class */
cov_1ywwwnyyy3().s[8]++, function () {
  cov_1ywwwnyyy3().f[1]++;

  function Text(editor) {
    cov_1ywwwnyyy3().f[2]++;
    cov_1ywwwnyyy3().s[9]++;
    this.editor = editor;
    cov_1ywwwnyyy3().s[10]++;
    this.eventHooks = {
      changeEvents: [],
      dropEvents: [],
      clickEvents: [],
      keyupEvents: [],
      tabUpEvents: [],
      tabDownEvents: [],
      enterUpEvents: [],
      enterDownEvents: [],
      deleteUpEvents: [],
      deleteDownEvents: [],
      pasteEvents: [],
      linkClickEvents: [],
      codeClickEvents: [],
      textScrollEvents: [],
      toolbarClickEvents: [],
      imgClickEvents: [],
      imgDragBarMouseDownEvents: [],
      tableClickEvents: [],
      menuClickEvents: [],
      dropListMenuHoverEvents: [],
      splitLineEvents: []
    };
  }
  /**
   * 初始化
   */


  cov_1ywwwnyyy3().s[11]++;

  Text.prototype.init = function () {
    cov_1ywwwnyyy3().f[3]++;
    cov_1ywwwnyyy3().s[12]++;

    // 实时保存选取范围
    this._saveRange(); // 绑定事件


    cov_1ywwwnyyy3().s[13]++;

    this._bindEventHooks(); // 初始化 text 事件钩子函数


    cov_1ywwwnyyy3().s[14]++;
    index_1["default"](this);
  };
  /**
   * 切换placeholder
   */


  cov_1ywwwnyyy3().s[15]++;

  Text.prototype.togglePlaceholder = function () {
    var _context;

    cov_1ywwwnyyy3().f[4]++;
    var html = (cov_1ywwwnyyy3().s[16]++, this.html());
    var $placeholder = (cov_1ywwwnyyy3().s[17]++, (0, _find["default"])(_context = this.editor.$textContainerElem).call(_context, '.placeholder'));
    cov_1ywwwnyyy3().s[18]++;
    $placeholder.hide();
    cov_1ywwwnyyy3().s[19]++;

    if ((cov_1ywwwnyyy3().b[4][0]++, !html) || (cov_1ywwwnyyy3().b[4][1]++, html === ' ')) {
      cov_1ywwwnyyy3().b[3][0]++;
      cov_1ywwwnyyy3().s[20]++;
      $placeholder.show();
    } else {
      cov_1ywwwnyyy3().b[3][1]++;
    }
  };
  /**
   * 清空内容
   */


  cov_1ywwwnyyy3().s[21]++;

  Text.prototype.clear = function () {
    cov_1ywwwnyyy3().f[5]++;
    cov_1ywwwnyyy3().s[22]++;
    this.html('<p><br></p>');
  };
  /**
   * 设置/获取 html
   * @param val html 字符串
   */


  cov_1ywwwnyyy3().s[23]++;

  Text.prototype.html = function (val) {
    cov_1ywwwnyyy3().f[6]++;
    var editor = (cov_1ywwwnyyy3().s[24]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[25]++, editor.$textElem); // 没有 val ，则是获取 html

    cov_1ywwwnyyy3().s[26]++;

    if (val == null) {
      cov_1ywwwnyyy3().b[5][0]++;
      var html = (cov_1ywwwnyyy3().s[27]++, $textElem.html()); // 未选中任何内容的时候点击“加粗”或者“斜体”等按钮，就得需要一个空的占位符 &#8203 ，这里替换掉

      cov_1ywwwnyyy3().s[28]++;
      html = html.replace(/\u200b/gm, '');
      cov_1ywwwnyyy3().s[29]++;
      html = html.replace(/<p><\/p>/gim, ''); // 去掉空行

      cov_1ywwwnyyy3().s[30]++;
      html = html.replace(/<p><br\/?><\/p>$/gim, ''); // 去掉最后的 <p><br><p>

      /**
       * 这里的代码为了处理火狐多余的空行标签,但是强制删除空行标签会带来其他问题
       * html()方法返回的的值,"<p><br></p>"中pr会被删除,只留下<p>,点不进去,从而产生垃圾数据
       * 目前在末位有多个空行的情况下执行撤销重做操作,会产生一种不记录末尾空行的错觉
       * 暂时注释, 等待进一步的兼容处理
       */
      // html = html.replace(/><br>(?!<)/gi, '>') // 过滤 <p><br>内容</p> 中的br
      // html = html.replace(/(?!>)<br></gi, '<') // 过滤 <p>内容<br></p> 中的br

      /**
       * pre标签格式化
       * html()方法理论上应当输出纯净的代码文本,但是对于是否解析html标签还没有良好的判断
       * 如果去除hljs的标签,在解析状态下回显,会造成显示错误并且无法再通过hljs方法渲染
       * 暂且其弃用
       */
      // html = formatCodeHtml(editor, html)

      cov_1ywwwnyyy3().s[31]++;
      return html;
    } else {
      cov_1ywwwnyyy3().b[5][1]++;
    } // 有 val ，则是设置 html


    cov_1ywwwnyyy3().s[32]++;
    val = (0, _trim["default"])(val).call(val);
    cov_1ywwwnyyy3().s[33]++;

    if (val === '') {
      cov_1ywwwnyyy3().b[6][0]++;
      cov_1ywwwnyyy3().s[34]++;
      val = "<p><br></p>";
    } else {
      cov_1ywwwnyyy3().b[6][1]++;
    }

    cov_1ywwwnyyy3().s[35]++;

    if ((0, _indexOf["default"])(val).call(val, '<') !== 0) {
      cov_1ywwwnyyy3().b[7][0]++;
      cov_1ywwwnyyy3().s[36]++;
      // 内容用 p 标签包裹
      val = "<p>" + val + "</p>";
    } else {
      cov_1ywwwnyyy3().b[7][1]++;
    }

    cov_1ywwwnyyy3().s[37]++;
    $textElem.html(val); // 初始化选区，将光标定位到内容尾部

    cov_1ywwwnyyy3().s[38]++;
    editor.initSelection();
  };
  /**
   * 将json设置成html至编辑器
   * @param nodeList json格式
   */


  cov_1ywwwnyyy3().s[39]++;

  Text.prototype.setJSON = function (nodeList) {
    cov_1ywwwnyyy3().f[7]++;
    var html = (cov_1ywwwnyyy3().s[40]++, getHtmlByNodeList_1["default"](nodeList).children());
    var editor = (cov_1ywwwnyyy3().s[41]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[42]++, editor.$textElem); // 没有获取到元素的情况

    cov_1ywwwnyyy3().s[43]++;

    if (!html) {
      cov_1ywwwnyyy3().b[8][0]++;
      cov_1ywwwnyyy3().s[44]++;
      return;
    } else {
      cov_1ywwwnyyy3().b[8][1]++;
    } // 替换文本节点下全部子节点


    cov_1ywwwnyyy3().s[45]++;
    $textElem.replaceChildAll(html);
  };
  /**
   * 获取 json 格式的数据
   */


  cov_1ywwwnyyy3().s[46]++;

  Text.prototype.getJSON = function () {
    cov_1ywwwnyyy3().f[8]++;
    var editor = (cov_1ywwwnyyy3().s[47]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[48]++, editor.$textElem);
    cov_1ywwwnyyy3().s[49]++;
    return getChildrenJSON_1["default"]($textElem);
  };

  cov_1ywwwnyyy3().s[50]++;

  Text.prototype.text = function (val) {
    cov_1ywwwnyyy3().f[9]++;
    var editor = (cov_1ywwwnyyy3().s[51]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[52]++, editor.$textElem); // 没有 val ，是获取 text

    cov_1ywwwnyyy3().s[53]++;

    if (val == null) {
      cov_1ywwwnyyy3().b[9][0]++;
      var text = (cov_1ywwwnyyy3().s[54]++, $textElem.text()); // 未选中任何内容的时候点击“加粗”或者“斜体”等按钮，就得需要一个空的占位符 &#8203 ，这里替换掉

      cov_1ywwwnyyy3().s[55]++;
      text = text.replace(/\u200b/gm, '');
      cov_1ywwwnyyy3().s[56]++;
      return text;
    } else {
      cov_1ywwwnyyy3().b[9][1]++;
    } // 有 val ，则是设置 text


    cov_1ywwwnyyy3().s[57]++;
    $textElem.text("<p>" + val + "</p>"); // 初始化选区，将光标定位到内容尾部

    cov_1ywwwnyyy3().s[58]++;
    editor.initSelection();
  };
  /**
   * 追加 html 内容
   * @param html html 字符串
   */


  cov_1ywwwnyyy3().s[59]++;

  Text.prototype.append = function (html) {
    cov_1ywwwnyyy3().f[10]++;
    var editor = (cov_1ywwwnyyy3().s[60]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[61]++, editor.$textElem);
    cov_1ywwwnyyy3().s[62]++;

    if ((0, _indexOf["default"])(html).call(html, '<') !== 0) {
      cov_1ywwwnyyy3().b[10][0]++;
      cov_1ywwwnyyy3().s[63]++;
      // 普通字符串，用 <p> 包裹
      html = "<p>" + html + "</p>";
    } else {
      cov_1ywwwnyyy3().b[10][1]++;
    }

    cov_1ywwwnyyy3().s[64]++;
    $textElem.append(dom_core_1["default"](html)); // 初始化选区，将光标定位到内容尾部

    cov_1ywwwnyyy3().s[65]++;
    editor.initSelection();
  };
  /**
   * 每一步操作，都实时保存选区范围
   */


  cov_1ywwwnyyy3().s[66]++;

  Text.prototype._saveRange = function () {
    cov_1ywwwnyyy3().f[11]++;
    var editor = (cov_1ywwwnyyy3().s[67]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[68]++, editor.$textElem); // 保存当前的选区

    function saveRange() {
      cov_1ywwwnyyy3().f[12]++;
      cov_1ywwwnyyy3().s[69]++;
      // 随时保存选区
      editor.selection.saveRange(); // 更新按钮 active 状态

      cov_1ywwwnyyy3().s[70]++;
      editor.menus.changeActive();
    } // 按键后保存


    cov_1ywwwnyyy3().s[71]++;
    $textElem.on('keyup', saveRange);
    cov_1ywwwnyyy3().s[72]++;
    $textElem.on('mousedown', function () {
      cov_1ywwwnyyy3().f[13]++;
      cov_1ywwwnyyy3().s[73]++;
      // mousedown 状态下，鼠标滑动到编辑区域外面，也需要保存选区
      $textElem.on('mouseleave', saveRange);
    });
    cov_1ywwwnyyy3().s[74]++;
    $textElem.on('mouseup', function () {
      cov_1ywwwnyyy3().f[14]++;
      var selection = (cov_1ywwwnyyy3().s[75]++, editor.selection);
      var range = (cov_1ywwwnyyy3().s[76]++, selection.getRange());
      cov_1ywwwnyyy3().s[77]++;

      if (range == null) {
        cov_1ywwwnyyy3().b[11][0]++;
        cov_1ywwwnyyy3().s[78]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[11][1]++;
      }

      var startOffset = (cov_1ywwwnyyy3().s[79]++, range.startOffset),
          endOffset = (cov_1ywwwnyyy3().s[80]++, range.endOffset);
      var endContainer = (cov_1ywwwnyyy3().s[81]++, (cov_1ywwwnyyy3().b[13][0]++, range === null) || (cov_1ywwwnyyy3().b[13][1]++, range === void 0) ? (cov_1ywwwnyyy3().b[12][0]++, void 0) : (cov_1ywwwnyyy3().b[12][1]++, range.endContainer)); // 修复当selection结束时，点击编辑器内部，保存选区异常的情况

      cov_1ywwwnyyy3().s[82]++;

      if ((cov_1ywwwnyyy3().b[15][0]++, startOffset !== endOffset) && (cov_1ywwwnyyy3().b[15][1]++, endContainer != null)) {
        cov_1ywwwnyyy3().b[14][0]++;
        cov_1ywwwnyyy3().s[83]++;
        (cov_1ywwwnyyy3().b[17][0]++, range === null) || (cov_1ywwwnyyy3().b[17][1]++, range === void 0) ? (cov_1ywwwnyyy3().b[16][0]++, void 0) : (cov_1ywwwnyyy3().b[16][1]++, range.setStart(endContainer, endOffset));
      } else {
        cov_1ywwwnyyy3().b[14][1]++;
      }

      cov_1ywwwnyyy3().s[84]++;
      saveRange(); // 在编辑器区域之内完成点击，取消鼠标滑动到编辑区外面的事件

      cov_1ywwwnyyy3().s[85]++;
      $textElem.off('mouseleave', saveRange);
    });
  };
  /**
   * 绑定事件，事件会触发钩子函数
   */


  cov_1ywwwnyyy3().s[86]++;

  Text.prototype._bindEventHooks = function () {
    cov_1ywwwnyyy3().f[15]++;
    var editor = (cov_1ywwwnyyy3().s[87]++, this.editor);
    var $textElem = (cov_1ywwwnyyy3().s[88]++, editor.$textElem);
    var eventHooks = (cov_1ywwwnyyy3().s[89]++, this.eventHooks); // click hooks

    cov_1ywwwnyyy3().s[90]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[16]++;
      var clickEvents = (cov_1ywwwnyyy3().s[91]++, eventHooks.clickEvents);
      cov_1ywwwnyyy3().s[92]++;
      (0, _forEach["default"])(clickEvents).call(clickEvents, function (fn) {
        cov_1ywwwnyyy3().f[17]++;
        cov_1ywwwnyyy3().s[93]++;
        return fn(e);
      });
    }); // enter 键 up 时的 hooks

    cov_1ywwwnyyy3().s[94]++;
    $textElem.on('keyup', function (e) {
      cov_1ywwwnyyy3().f[18]++;
      cov_1ywwwnyyy3().s[95]++;

      if (e.keyCode !== 13) {
        cov_1ywwwnyyy3().b[18][0]++;
        cov_1ywwwnyyy3().s[96]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[18][1]++;
      }

      var enterUpEvents = (cov_1ywwwnyyy3().s[97]++, eventHooks.enterUpEvents);
      cov_1ywwwnyyy3().s[98]++;
      (0, _forEach["default"])(enterUpEvents).call(enterUpEvents, function (fn) {
        cov_1ywwwnyyy3().f[19]++;
        cov_1ywwwnyyy3().s[99]++;
        return fn(e);
      });
    }); // 键盘 up 时的 hooks

    cov_1ywwwnyyy3().s[100]++;
    $textElem.on('keyup', function (e) {
      cov_1ywwwnyyy3().f[20]++;
      var keyupEvents = (cov_1ywwwnyyy3().s[101]++, eventHooks.keyupEvents);
      cov_1ywwwnyyy3().s[102]++;
      (0, _forEach["default"])(keyupEvents).call(keyupEvents, function (fn) {
        cov_1ywwwnyyy3().f[21]++;
        cov_1ywwwnyyy3().s[103]++;
        return fn(e);
      });
    }); // delete 键 up 时 hooks

    cov_1ywwwnyyy3().s[104]++;
    $textElem.on('keyup', function (e) {
      cov_1ywwwnyyy3().f[22]++;
      cov_1ywwwnyyy3().s[105]++;

      if (e.keyCode !== 8) {
        cov_1ywwwnyyy3().b[19][0]++;
        cov_1ywwwnyyy3().s[106]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[19][1]++;
      }

      var deleteUpEvents = (cov_1ywwwnyyy3().s[107]++, eventHooks.deleteUpEvents);
      cov_1ywwwnyyy3().s[108]++;
      (0, _forEach["default"])(deleteUpEvents).call(deleteUpEvents, function (fn) {
        cov_1ywwwnyyy3().f[23]++;
        cov_1ywwwnyyy3().s[109]++;
        return fn(e);
      });
    }); // delete 键 down 时 hooks

    cov_1ywwwnyyy3().s[110]++;
    $textElem.on('keydown', function (e) {
      cov_1ywwwnyyy3().f[24]++;
      cov_1ywwwnyyy3().s[111]++;

      if (e.keyCode !== 8) {
        cov_1ywwwnyyy3().b[20][0]++;
        cov_1ywwwnyyy3().s[112]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[20][1]++;
      }

      var deleteDownEvents = (cov_1ywwwnyyy3().s[113]++, eventHooks.deleteDownEvents);
      cov_1ywwwnyyy3().s[114]++;
      (0, _forEach["default"])(deleteDownEvents).call(deleteDownEvents, function (fn) {
        cov_1ywwwnyyy3().f[25]++;
        cov_1ywwwnyyy3().s[115]++;
        return fn(e);
      });
    }); // 粘贴

    cov_1ywwwnyyy3().s[116]++;
    $textElem.on('paste', function (e) {
      cov_1ywwwnyyy3().f[26]++;
      cov_1ywwwnyyy3().s[117]++;

      if (util_1.UA.isIE()) {
        cov_1ywwwnyyy3().b[21][0]++;
        cov_1ywwwnyyy3().s[118]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[21][1]++;
      } // IE 不支持
      // 阻止默认行为，使用 execCommand 的粘贴命令


      cov_1ywwwnyyy3().s[119]++;
      e.preventDefault();
      var pasteEvents = (cov_1ywwwnyyy3().s[120]++, eventHooks.pasteEvents);
      cov_1ywwwnyyy3().s[121]++;
      (0, _forEach["default"])(pasteEvents).call(pasteEvents, function (fn) {
        cov_1ywwwnyyy3().f[27]++;
        cov_1ywwwnyyy3().s[122]++;
        return fn(e);
      });
    }); // 撤销/恢复 快捷键

    cov_1ywwwnyyy3().s[123]++;
    $textElem.on('keydown', function (e) {
      cov_1ywwwnyyy3().f[28]++;
      cov_1ywwwnyyy3().s[124]++;

      if ( // 编辑器处于聚焦状态下（多编辑器实例） || 当前处于兼容模式（兼容模式撤销/恢复后不聚焦，所以直接过，但会造成多编辑器同时撤销/恢复）
      ((cov_1ywwwnyyy3().b[23][0]++, editor.isFocus) || (cov_1ywwwnyyy3().b[23][1]++, editor.isCompatibleMode)) && ((cov_1ywwwnyyy3().b[23][2]++, e.ctrlKey) || (cov_1ywwwnyyy3().b[23][3]++, e.metaKey)) && (cov_1ywwwnyyy3().b[23][4]++, e.keyCode === 90)) {
        cov_1ywwwnyyy3().b[22][0]++;
        cov_1ywwwnyyy3().s[125]++;
        // 取消默认行为
        e.preventDefault(); // 执行事件

        cov_1ywwwnyyy3().s[126]++;

        if (e.shiftKey) {
          cov_1ywwwnyyy3().b[24][0]++;
          cov_1ywwwnyyy3().s[127]++;
          // 恢复
          editor.history.restore();
        } else {
          cov_1ywwwnyyy3().b[24][1]++;
          cov_1ywwwnyyy3().s[128]++;
          // 撤销
          editor.history.revoke();
        }
      } else {
        cov_1ywwwnyyy3().b[22][1]++;
      }
    }); // tab up

    cov_1ywwwnyyy3().s[129]++;
    $textElem.on('keyup', function (e) {
      cov_1ywwwnyyy3().f[29]++;
      cov_1ywwwnyyy3().s[130]++;

      if (e.keyCode !== 9) {
        cov_1ywwwnyyy3().b[25][0]++;
        cov_1ywwwnyyy3().s[131]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[25][1]++;
      }

      cov_1ywwwnyyy3().s[132]++;
      e.preventDefault();
      var tabUpEvents = (cov_1ywwwnyyy3().s[133]++, eventHooks.tabUpEvents);
      cov_1ywwwnyyy3().s[134]++;
      (0, _forEach["default"])(tabUpEvents).call(tabUpEvents, function (fn) {
        cov_1ywwwnyyy3().f[30]++;
        cov_1ywwwnyyy3().s[135]++;
        return fn(e);
      });
    }); // tab down

    cov_1ywwwnyyy3().s[136]++;
    $textElem.on('keydown', function (e) {
      cov_1ywwwnyyy3().f[31]++;
      cov_1ywwwnyyy3().s[137]++;

      if (e.keyCode !== 9) {
        cov_1ywwwnyyy3().b[26][0]++;
        cov_1ywwwnyyy3().s[138]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[26][1]++;
      }

      cov_1ywwwnyyy3().s[139]++;
      e.preventDefault();
      var tabDownEvents = (cov_1ywwwnyyy3().s[140]++, eventHooks.tabDownEvents);
      cov_1ywwwnyyy3().s[141]++;
      (0, _forEach["default"])(tabDownEvents).call(tabDownEvents, function (fn) {
        cov_1ywwwnyyy3().f[32]++;
        cov_1ywwwnyyy3().s[142]++;
        return fn(e);
      });
    }); // 文本编辑区域 滚动时触发

    cov_1ywwwnyyy3().s[143]++;
    $textElem.on('scroll', // 使用节流
    util_1.throttle(function (e) {
      cov_1ywwwnyyy3().f[33]++;
      var textScrollEvents = (cov_1ywwwnyyy3().s[144]++, eventHooks.textScrollEvents);
      cov_1ywwwnyyy3().s[145]++;
      (0, _forEach["default"])(textScrollEvents).call(textScrollEvents, function (fn) {
        cov_1ywwwnyyy3().f[34]++;
        cov_1ywwwnyyy3().s[146]++;
        return fn(e);
      });
    }, 100)); // 拖拽相关的事件

    function preventDefault(e) {
      cov_1ywwwnyyy3().f[35]++;
      cov_1ywwwnyyy3().s[147]++;
      // 禁用 document 拖拽事件
      e.preventDefault();
    }

    cov_1ywwwnyyy3().s[148]++;
    dom_core_1["default"](document).on('dragleave', preventDefault).on('drop', preventDefault).on('dragenter', preventDefault).on('dragover', preventDefault); // 全局事件在编辑器实例销毁的时候进行解绑

    cov_1ywwwnyyy3().s[149]++;
    editor.beforeDestroy(function () {
      cov_1ywwwnyyy3().f[36]++;
      cov_1ywwwnyyy3().s[150]++;
      dom_core_1["default"](document).off('dragleave', preventDefault).off('drop', preventDefault).off('dragenter', preventDefault).off('dragover', preventDefault);
    });
    cov_1ywwwnyyy3().s[151]++;
    $textElem.on('drop', function (e) {
      cov_1ywwwnyyy3().f[37]++;
      cov_1ywwwnyyy3().s[152]++;
      e.preventDefault();
      var events = (cov_1ywwwnyyy3().s[153]++, eventHooks.dropEvents);
      cov_1ywwwnyyy3().s[154]++;
      (0, _forEach["default"])(events).call(events, function (fn) {
        cov_1ywwwnyyy3().f[38]++;
        cov_1ywwwnyyy3().s[155]++;
        return fn(e);
      });
    }); // link click

    cov_1ywwwnyyy3().s[156]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[39]++;
      // 存储链接元素
      var $link = (cov_1ywwwnyyy3().s[157]++, null);
      var target = (cov_1ywwwnyyy3().s[158]++, e.target);
      var $target = (cov_1ywwwnyyy3().s[159]++, dom_core_1["default"](target));
      cov_1ywwwnyyy3().s[160]++;

      if ($target.getNodeName() === 'A') {
        cov_1ywwwnyyy3().b[27][0]++;
        cov_1ywwwnyyy3().s[161]++;
        // 当前点击的就是一个链接
        $link = $target;
      } else {
        cov_1ywwwnyyy3().b[27][1]++;
        // 否则，向父节点中寻找链接
        var $parent = (cov_1ywwwnyyy3().s[162]++, $target.parentUntil('a'));
        cov_1ywwwnyyy3().s[163]++;

        if ($parent != null) {
          cov_1ywwwnyyy3().b[28][0]++;
          cov_1ywwwnyyy3().s[164]++;
          // 找到了
          $link = $parent;
        } else {
          cov_1ywwwnyyy3().b[28][1]++;
        }
      }

      cov_1ywwwnyyy3().s[165]++;

      if (!$link) {
        cov_1ywwwnyyy3().b[29][0]++;
        cov_1ywwwnyyy3().s[166]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[29][1]++;
      } // 没有点击链接，则返回


      var linkClickEvents = (cov_1ywwwnyyy3().s[167]++, eventHooks.linkClickEvents);
      cov_1ywwwnyyy3().s[168]++;
      (0, _forEach["default"])(linkClickEvents).call(linkClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[40]++;
        cov_1ywwwnyyy3().s[169]++;
        return fn($link);
      });
    }); // img click

    cov_1ywwwnyyy3().s[170]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[41]++;
      // 存储图片元素
      var $img = (cov_1ywwwnyyy3().s[171]++, null);
      var target = (cov_1ywwwnyyy3().s[172]++, e.target);
      var $target = (cov_1ywwwnyyy3().s[173]++, dom_core_1["default"](target)); //处理图片点击 判断是否是表情 根据 不存在class或者className!==eleImg、没有alt属性

      cov_1ywwwnyyy3().s[174]++;

      if ((cov_1ywwwnyyy3().b[31][0]++, $target.getNodeName() === 'IMG') && ((cov_1ywwwnyyy3().b[31][1]++, !$target.elems[0].getAttribute('class')) || (cov_1ywwwnyyy3().b[31][2]++, $target.elems[0].getAttribute('class') !== 'eleImg')) && (cov_1ywwwnyyy3().b[31][3]++, !$target.elems[0].getAttribute('alt'))) {
        cov_1ywwwnyyy3().b[30][0]++;
        cov_1ywwwnyyy3().s[175]++;
        // 当前点击的就是img
        e.stopPropagation();
        cov_1ywwwnyyy3().s[176]++;
        $img = $target;
      } else {
        cov_1ywwwnyyy3().b[30][1]++;
      }

      cov_1ywwwnyyy3().s[177]++;

      if (!$img) {
        cov_1ywwwnyyy3().b[32][0]++;
        cov_1ywwwnyyy3().s[178]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[32][1]++;
      } // 没有点击图片，则返回


      var imgClickEvents = (cov_1ywwwnyyy3().s[179]++, eventHooks.imgClickEvents);
      cov_1ywwwnyyy3().s[180]++;
      (0, _forEach["default"])(imgClickEvents).call(imgClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[42]++;
        cov_1ywwwnyyy3().s[181]++;
        return fn($img);
      });
    }); // code click

    cov_1ywwwnyyy3().s[182]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[43]++;
      // 存储代码元素
      var $code = (cov_1ywwwnyyy3().s[183]++, null);
      var target = (cov_1ywwwnyyy3().s[184]++, e.target);
      var $target = (cov_1ywwwnyyy3().s[185]++, dom_core_1["default"](target));
      cov_1ywwwnyyy3().s[186]++;

      if ($target.getNodeName() === 'PRE') {
        cov_1ywwwnyyy3().b[33][0]++;
        cov_1ywwwnyyy3().s[187]++;
        // 当前点击的就是一个链接
        $code = $target;
      } else {
        cov_1ywwwnyyy3().b[33][1]++;
        // 否则，向父节点中寻找链接
        var $parent = (cov_1ywwwnyyy3().s[188]++, $target.parentUntil('pre'));
        cov_1ywwwnyyy3().s[189]++;

        if ($parent !== null) {
          cov_1ywwwnyyy3().b[34][0]++;
          cov_1ywwwnyyy3().s[190]++;
          // 找到了
          $code = $parent;
        } else {
          cov_1ywwwnyyy3().b[34][1]++;
        }
      }

      cov_1ywwwnyyy3().s[191]++;

      if (!$code) {
        cov_1ywwwnyyy3().b[35][0]++;
        cov_1ywwwnyyy3().s[192]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[35][1]++;
      }

      var codeClickEvents = (cov_1ywwwnyyy3().s[193]++, eventHooks.codeClickEvents);
      cov_1ywwwnyyy3().s[194]++;
      (0, _forEach["default"])(codeClickEvents).call(codeClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[44]++;
        cov_1ywwwnyyy3().s[195]++;
        return fn($code);
      });
    }); // splitLine click

    cov_1ywwwnyyy3().s[196]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[45]++;
      // 存储分割线元素
      var $splitLine = (cov_1ywwwnyyy3().s[197]++, null);
      var target = (cov_1ywwwnyyy3().s[198]++, e.target);
      var $target = (cov_1ywwwnyyy3().s[199]++, dom_core_1["default"](target)); // 判断当前点击元素

      cov_1ywwwnyyy3().s[200]++;

      if ($target.getNodeName() === 'HR') {
        cov_1ywwwnyyy3().b[36][0]++;
        cov_1ywwwnyyy3().s[201]++;
        $splitLine = $target;
      } else {
        cov_1ywwwnyyy3().b[36][1]++;
        cov_1ywwwnyyy3().s[202]++;
        $target == null;
      }

      cov_1ywwwnyyy3().s[203]++;

      if (!$splitLine) {
        cov_1ywwwnyyy3().b[37][0]++;
        cov_1ywwwnyyy3().s[204]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[37][1]++;
      } // 没有点击分割线，则返回
      // 设置、恢复选区


      cov_1ywwwnyyy3().s[205]++;
      editor.selection.createRangeByElem($splitLine);
      cov_1ywwwnyyy3().s[206]++;
      editor.selection.restoreSelection();
      var splitLineClickEvents = (cov_1ywwwnyyy3().s[207]++, eventHooks.splitLineEvents);
      cov_1ywwwnyyy3().s[208]++;
      (0, _forEach["default"])(splitLineClickEvents).call(splitLineClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[46]++;
        cov_1ywwwnyyy3().s[209]++;
        return fn($splitLine);
      });
    }); // 菜单栏被点击

    cov_1ywwwnyyy3().s[210]++;
    editor.$toolbarElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[47]++;
      var toolbarClickEvents = (cov_1ywwwnyyy3().s[211]++, eventHooks.toolbarClickEvents);
      cov_1ywwwnyyy3().s[212]++;
      (0, _forEach["default"])(toolbarClickEvents).call(toolbarClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[48]++;
        cov_1ywwwnyyy3().s[213]++;
        return fn(e);
      });
    }); //mousedown事件

    cov_1ywwwnyyy3().s[214]++;
    editor.$textContainerElem.on('mousedown', function (e) {
      cov_1ywwwnyyy3().f[49]++;
      var target = (cov_1ywwwnyyy3().s[215]++, e.target);
      var $target = (cov_1ywwwnyyy3().s[216]++, dom_core_1["default"](target));
      cov_1ywwwnyyy3().s[217]++;

      if ($target.hasClass('w-e-img-drag-rb')) {
        cov_1ywwwnyyy3().b[38][0]++;
        // 点击的元素，是图片拖拽调整大小的 bar
        var imgDragBarMouseDownEvents = (cov_1ywwwnyyy3().s[218]++, eventHooks.imgDragBarMouseDownEvents);
        cov_1ywwwnyyy3().s[219]++;
        (0, _forEach["default"])(imgDragBarMouseDownEvents).call(imgDragBarMouseDownEvents, function (fn) {
          cov_1ywwwnyyy3().f[50]++;
          cov_1ywwwnyyy3().s[220]++;
          return fn();
        });
      } else {
        cov_1ywwwnyyy3().b[38][1]++;
      }
    }); //table click

    cov_1ywwwnyyy3().s[221]++;
    $textElem.on('click', function (e) {
      cov_1ywwwnyyy3().f[51]++;
      // 存储元素
      var $dom = (cov_1ywwwnyyy3().s[222]++, null);
      var target = (cov_1ywwwnyyy3().s[223]++, e.target); //获取最祖父元素

      cov_1ywwwnyyy3().s[224]++;
      $dom = dom_core_1["default"](target).parentUntil('TABLE', target); // 没有table范围内，则返回

      cov_1ywwwnyyy3().s[225]++;

      if (!$dom) {
        cov_1ywwwnyyy3().b[39][0]++;
        cov_1ywwwnyyy3().s[226]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[39][1]++;
      }

      var tableClickEvents = (cov_1ywwwnyyy3().s[227]++, eventHooks.tableClickEvents);
      cov_1ywwwnyyy3().s[228]++;
      (0, _forEach["default"])(tableClickEvents).call(tableClickEvents, function (fn) {
        cov_1ywwwnyyy3().f[52]++;
        cov_1ywwwnyyy3().s[229]++;
        return fn($dom);
      });
    }); // enter 键 down

    cov_1ywwwnyyy3().s[230]++;
    $textElem.on('keydown', function (e) {
      cov_1ywwwnyyy3().f[53]++;
      cov_1ywwwnyyy3().s[231]++;

      if (e.keyCode !== 13) {
        cov_1ywwwnyyy3().b[40][0]++;
        cov_1ywwwnyyy3().s[232]++;
        return;
      } else {
        cov_1ywwwnyyy3().b[40][1]++;
      }

      var enterDownEvents = (cov_1ywwwnyyy3().s[233]++, eventHooks.enterDownEvents);
      cov_1ywwwnyyy3().s[234]++;
      (0, _forEach["default"])(enterDownEvents).call(enterDownEvents, function (fn) {
        cov_1ywwwnyyy3().f[54]++;
        cov_1ywwwnyyy3().s[235]++;
        return fn(e);
      });
    });
  };

  cov_1ywwwnyyy3().s[236]++;
  return Text;
}());
cov_1ywwwnyyy3().s[237]++;
exports["default"] = Text;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(282);

module.exports = parent;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var find = __webpack_require__(283);

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.find;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.find) ? find : own;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(284);
var entryVirtual = __webpack_require__(18);

module.exports = entryVirtual('Array').find;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(4);
var $find = __webpack_require__(41).find;
var addToUnscopables = __webpack_require__(84);
var arrayMethodUsesToLength = __webpack_require__(27);

var FIND = 'find';
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description Text 事件钩子函数。Text 公共的，不是某个菜单独有的
 * @wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_s8vp2kyd0() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/index.ts";
  var hash = "7ba4fe2476918eaadaafad1c491cf0fc4c8a6985";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 73
        }
      },
      "4": {
        start: {
          line: 11,
          column: 22
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 12,
          column: 63
        }
      },
      "6": {
        start: {
          line: 13,
          column: 24
        },
        end: {
          line: 13,
          column: 69
        }
      },
      "7": {
        start: {
          line: 14,
          column: 25
        },
        end: {
          line: 14,
          column: 71
        }
      },
      "8": {
        start: {
          line: 20,
          column: 17
        },
        end: {
          line: 20,
          column: 28
        }
      },
      "9": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 36
        }
      },
      "10": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 94
        }
      },
      "11": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 92
        }
      },
      "12": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 61
        }
      },
      "13": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 62
        }
      },
      "14": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 66
        }
      },
      "15": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 33,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "initTextHooks",
        decl: {
          start: {
            line: 19,
            column: 9
          },
          end: {
            line: 19,
            column: 22
          }
        },
        loc: {
          start: {
            line: 19,
            column: 29
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,0EAAgD;AAChD,kEAA2C;AAC3C,gEAAsC;AACtC,sEAA6C;AAC7C,wEAA+C;AAE/C;;;GAGG;AACH,SAAS,aAAa,CAAC,IAAU;IAC7B,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;IAC1B,IAAM,UAAU,GAAG,IAAI,CAAC,UAAU,CAAA;IAElC,oBAAoB;IACpB,2BAAc,CAAC,MAAM,EAAE,UAAU,CAAC,aAAa,EAAE,UAAU,CAAC,eAAe,CAAC,CAAA;IAE5E,qBAAqB;IACrB,uBAAa,CAAC,MAAM,EAAE,UAAU,CAAC,cAAc,EAAE,UAAU,CAAC,gBAAgB,CAAC,CAAA;IAE7E,YAAY;IACZ,sBAAS,CAAC,MAAM,EAAE,UAAU,CAAC,aAAa,CAAC,CAAA;IAE3C,eAAe;IACf,yBAAa,CAAC,MAAM,EAAE,UAAU,CAAC,WAAW,CAAC,CAAA;IAE7C,mBAAmB;IACnB,0BAAc,CAAC,MAAM,EAAE,UAAU,CAAC,cAAc,CAAC,CAAA;AACrD,CAAC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description Text \u4E8B\u4EF6\u94A9\u5B50\u51FD\u6570\u3002Text \u516C\u5171\u7684\uFF0C\u4E0D\u662F\u67D0\u4E2A\u83DC\u5355\u72EC\u6709\u7684\n * @wangfupeng\n */\n\nimport Text from '../index'\nimport enterToCreateP from './enter-to-create-p'\nimport deleteToKeepP from './del-to-keep-p'\nimport tabToSpan from './tab-to-space'\nimport pasteTextHtml from './paste-text-html'\nimport imgClickActive from './img-click-active'\n\n/**\n * \u521D\u59CB\u5316 text \u4E8B\u4EF6\u94A9\u5B50\u51FD\u6570\n * @param text text \u5B9E\u4F8B\n */\nfunction initTextHooks(text: Text): void {\n    const editor = text.editor\n    const eventHooks = text.eventHooks\n\n    // \u56DE\u8F66\u65F6\uFF0C\u4FDD\u8BC1\u751F\u6210\u7684\u662F <p> \u6807\u7B7E\n    enterToCreateP(editor, eventHooks.enterUpEvents, eventHooks.enterDownEvents)\n\n    // \u5220\u9664\u65F6\uFF0C\u4FDD\u7559 <p><br></p>\n    deleteToKeepP(editor, eventHooks.deleteUpEvents, eventHooks.deleteDownEvents)\n\n    // tab \u8F6C\u6362\u4E3A\u7A7A\u683C\n    tabToSpan(editor, eventHooks.tabDownEvents)\n\n    // \u7C98\u8D34 text html\n    pasteTextHtml(editor, eventHooks.pasteEvents)\n\n    // img click active\n    imgClickActive(editor, eventHooks.imgClickEvents)\n}\n\nexport default initTextHooks\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7ba4fe2476918eaadaafad1c491cf0fc4c8a6985"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_s8vp2kyd0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_s8vp2kyd0();

var __importDefault = (cov_s8vp2kyd0().s[0]++, (cov_s8vp2kyd0().b[0][0]++, void 0) && (cov_s8vp2kyd0().b[0][1]++, (void 0).__importDefault) || (cov_s8vp2kyd0().b[0][2]++, function (mod) {
  cov_s8vp2kyd0().f[0]++;
  cov_s8vp2kyd0().s[1]++;
  return (cov_s8vp2kyd0().b[2][0]++, mod) && (cov_s8vp2kyd0().b[2][1]++, mod.__esModule) ? (cov_s8vp2kyd0().b[1][0]++, mod) : (cov_s8vp2kyd0().b[1][1]++, {
    "default": mod
  });
}));

cov_s8vp2kyd0().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var enter_to_create_p_1 = (cov_s8vp2kyd0().s[3]++, __importDefault(__webpack_require__(286)));
var del_to_keep_p_1 = (cov_s8vp2kyd0().s[4]++, __importDefault(__webpack_require__(287)));
var tab_to_space_1 = (cov_s8vp2kyd0().s[5]++, __importDefault(__webpack_require__(288)));
var paste_text_html_1 = (cov_s8vp2kyd0().s[6]++, __importDefault(__webpack_require__(289)));
var img_click_active_1 = (cov_s8vp2kyd0().s[7]++, __importDefault(__webpack_require__(296)));
/**
 * 初始化 text 事件钩子函数
 * @param text text 实例
 */

function initTextHooks(text) {
  cov_s8vp2kyd0().f[1]++;
  var editor = (cov_s8vp2kyd0().s[8]++, text.editor);
  var eventHooks = (cov_s8vp2kyd0().s[9]++, text.eventHooks); // 回车时，保证生成的是 <p> 标签

  cov_s8vp2kyd0().s[10]++;
  enter_to_create_p_1["default"](editor, eventHooks.enterUpEvents, eventHooks.enterDownEvents); // 删除时，保留 <p><br></p>

  cov_s8vp2kyd0().s[11]++;
  del_to_keep_p_1["default"](editor, eventHooks.deleteUpEvents, eventHooks.deleteDownEvents); // tab 转换为空格

  cov_s8vp2kyd0().s[12]++;
  tab_to_space_1["default"](editor, eventHooks.tabDownEvents); // 粘贴 text html

  cov_s8vp2kyd0().s[13]++;
  paste_text_html_1["default"](editor, eventHooks.pasteEvents); // img click active

  cov_s8vp2kyd0().s[14]++;
  img_click_active_1["default"](editor, eventHooks.imgClickEvents);
}

cov_s8vp2kyd0().s[15]++;
exports["default"] = initTextHooks;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 回车时，保证生成的是 <p> 标签
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_ck6yyj10n() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/enter-to-create-p.ts";
  var hash = "6b2e3b5a192df1cbc0e390b1de88d22a2610964b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/enter-to-create-p.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 19,
          column: 17
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "5": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "6": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 53
        }
      },
      "7": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 44
        }
      },
      "8": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "9": {
        start: {
          line: 27,
          column: 24
        },
        end: {
          line: 27,
          column: 40
        }
      },
      "10": {
        start: {
          line: 28,
          column: 29
        },
        end: {
          line: 28,
          column: 73
        }
      },
      "11": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 29,
          column: 49
        }
      },
      "12": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 35,
          column: 9
        }
      },
      "13": {
        start: {
          line: 33,
          column: 12
        },
        end: {
          line: 33,
          column: 41
        }
      },
      "14": {
        start: {
          line: 34,
          column: 12
        },
        end: {
          line: 34,
          column: 19
        }
      },
      "15": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 39,
          column: 9
        }
      },
      "16": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 19
        }
      },
      "17": {
        start: {
          line: 40,
          column: 23
        },
        end: {
          line: 40,
          column: 51
        }
      },
      "18": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 44,
          column: 9
        }
      },
      "19": {
        start: {
          line: 43,
          column: 12
        },
        end: {
          line: 43,
          column: 19
        }
      },
      "20": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 48,
          column: 9
        }
      },
      "21": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 19
        }
      },
      "22": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 37
        }
      },
      "23": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 27
        }
      },
      "24": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 112
        }
      },
      "25": {
        start: {
          line: 58,
          column: 26
        },
        end: {
          line: 58,
          column: 70
        }
      },
      "26": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 64,
          column: 9
        }
      },
      "27": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 31
        }
      },
      "28": {
        start: {
          line: 63,
          column: 12
        },
        end: {
          line: 63,
          column: 55
        }
      },
      "29": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 47
        }
      },
      "30": {
        start: {
          line: 68,
          column: 0
        },
        end: {
          line: 68,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "enterToCreateP",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 23
          }
        },
        loc: {
          start: {
            line: 17,
            column: 64
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "insertEmptyP",
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 25
          }
        },
        loc: {
          start: {
            line: 18,
            column: 42
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 18
      },
      "3": {
        name: "fn",
        decl: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 15
          }
        },
        loc: {
          start: {
            line: 26,
            column: 18
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 26
      },
      "4": {
        name: "createPWhenEnterText",
        decl: {
          start: {
            line: 54,
            column: 13
          },
          end: {
            line: 54,
            column: 33
          }
        },
        loc: {
          start: {
            line: 54,
            column: 37
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }, {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        }],
        line: 41
      },
      "6": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }],
        line: 45
      },
      "7": {
        loc: {
          start: {
            line: 57,
            column: 35
          },
          end: {
            line: 57,
            column: 110
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 85
          },
          end: {
            line: 57,
            column: 91
          }
        }, {
          start: {
            line: 57,
            column: 94
          },
          end: {
            line: 57,
            column: 110
          }
        }],
        line: 57
      },
      "8": {
        loc: {
          start: {
            line: 57,
            column: 35
          },
          end: {
            line: 57,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 35
          },
          end: {
            line: 57,
            column: 65
          }
        }, {
          start: {
            line: 57,
            column: 69
          },
          end: {
            line: 57,
            column: 82
          }
        }],
        line: 57
      },
      "9": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        }],
        line: 59
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/enter-to-create-p.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/enter-to-create-p.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoD;AAEpD;;;;;GAKG;AACH,SAAS,cAAc,CAAC,MAAc,EAAE,aAAyB,EAAE,eAA2B;IAC1F,SAAS,YAAY,CAAC,cAA0B;QAC5C,IAAM,EAAE,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QAC3B,EAAE,CAAC,YAAY,CAAC,cAAc,CAAC,CAAA;QAC/B,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,EAAE,EAAE,IAAI,CAAC,CAAA;QAC5C,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QACnC,cAAc,CAAC,MAAM,EAAE,CAAA;IAC3B,CAAC;IAED,aAAa;IACb,SAAS,EAAE;QACP,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAgB,CAAA;QACjF,IAAM,WAAW,GAAG,cAAc,CAAC,MAAM,EAAE,CAAA;QAE3C,IAAI,WAAW,CAAC,IAAI,EAAE,KAAK,mBAAmB,EAAE;YAC5C,4EAA4E;YAC5E,sBAAsB;YACtB,YAAY,CAAC,cAAc,CAAC,CAAA;YAC5B,OAAM;SACT;QAED,IAAI,CAAC,WAAW,CAAC,KAAK,CAAC,SAAS,CAAC,EAAE;YAC/B,SAAS;YACT,OAAM;SACT;QAED,IAAM,QAAQ,GAAG,cAAc,CAAC,WAAW,EAAE,CAAA;QAC7C,IAAI,QAAQ,KAAK,GAAG,EAAE;YAClB,kBAAkB;YAClB,OAAM;SACT;QAED,IAAI,cAAc,CAAC,IAAI,EAAE,EAAE;YACvB,WAAW;YACX,OAAM;SACT;QAED,6BAA6B;QAC7B,YAAY,CAAC,cAAc,CAAC,CAAA;IAChC,CAAC;IACD,aAAa,CAAC,IAAI,CAAC,EAAE,CAAC,CAAA;IAEtB,eAAe;IACf,SAAS,oBAAoB,CAAC,CAAQ;;QAClC,uDAAuD;QACvD,MAAM,CAAC,SAAS,CAAC,SAAS,OAAC,YAAY,EAAE,0CAAE,UAAU,CAAC,CAAC,EAAE,CAAA;QACzD,IAAM,WAAW,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAgB,CAAA;QAC9E,IAAI,WAAW,CAAC,EAAE,KAAK,MAAM,CAAC,UAAU,EAAE;YACtC,iDAAiD;YACjD,iCAAiC;YACjC,CAAC,CAAC,cAAc,EAAE,CAAA;YAClB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,aAAa,CAAC,CAAA;SAC7C;IACL,CAAC;IACD,eAAe,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;AAC9C,CAAC;AAED,kBAAe,cAAc,CAAA",
      sourcesContent: ["/**\n * @description \u56DE\u8F66\u65F6\uFF0C\u4FDD\u8BC1\u751F\u6210\u7684\u662F <p> \u6807\u7B7E\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport $, { DomElement } from '../../utils/dom-core'\n\n/**\n * \u56DE\u8F66\u65F6\uFF0C\u4FDD\u8BC1\u751F\u6210\u7684\u662F <p> \u6807\u7B7E\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param enterUpEvents enter \u952E up \u65F6\u7684 hooks\n * @param enterDownEvents enter \u952E down \u65F6\u7684 hooks\n */\nfunction enterToCreateP(editor: Editor, enterUpEvents: Function[], enterDownEvents: Function[]) {\n    function insertEmptyP($selectionElem: DomElement) {\n        const $p = $('<p><br></p>')\n        $p.insertBefore($selectionElem)\n        editor.selection.createRangeByElem($p, true)\n        editor.selection.restoreSelection()\n        $selectionElem.remove()\n    }\n\n    // enter up \u65F6\n    function fn() {\n        const $textElem = editor.$textElem\n        const $selectionElem = editor.selection.getSelectionContainerElem() as DomElement\n        const $parentElem = $selectionElem.parent()\n\n        if ($parentElem.html() === '<code><br></code>') {\n            // \u56DE\u8F66\u4E4B\u524D\u5149\u6807\u6240\u5728\u4E00\u4E2A <p><code>.....</code></p> \uFF0C\u5FFD\u7136\u56DE\u8F66\u751F\u6210\u4E00\u4E2A\u7A7A\u7684 <p><code><br></code></p>\n            // \u800C\u4E14\u7EE7\u7EED\u56DE\u8F66\u8DF3\u4E0D\u51FA\u53BB\uFF0C\u56E0\u6B64\u53EA\u80FD\u7279\u6B8A\u5904\u7406\n            insertEmptyP($selectionElem)\n            return\n        }\n\n        if (!$parentElem.equal($textElem)) {\n            // \u4E0D\u662F\u9876\u7EA7\u6807\u7B7E\n            return\n        }\n\n        const nodeName = $selectionElem.getNodeName()\n        if (nodeName === 'P') {\n            // \u5F53\u524D\u7684\u6807\u7B7E\u662F P \uFF0C\u4E0D\u7528\u505A\u5904\u7406\n            return\n        }\n\n        if ($selectionElem.text()) {\n            // \u6709\u5185\u5BB9\uFF0C\u4E0D\u505A\u5904\u7406\n            return\n        }\n\n        // \u63D2\u5165 <p> \uFF0C\u5E76\u5C06\u9009\u53D6\u5B9A\u4F4D\u5230 <p>\uFF0C\u5220\u9664\u5F53\u524D\u6807\u7B7E\n        insertEmptyP($selectionElem)\n    }\n    enterUpEvents.push(fn)\n\n    // enter down \u65F6\n    function createPWhenEnterText(e: Event) {\n        // selection\u4E2D\u7684range\u7F13\u5B58\u8FD8\u6709\u95EE\u9898,\u66F4\u65B0\u4E0D\u53CA\u65F6,\u6B64\u5904\u624B\u52A8\u66F4\u65B0range,\u5904\u7406enter\u7684bug\n        editor.selection.saveRange(getSelection()?.getRangeAt(0))\n        const $selectElem = editor.selection.getSelectionContainerElem() as DomElement\n        if ($selectElem.id === editor.textElemId) {\n            // \u56DE\u8F66\u65F6\uFF0C\u9ED8\u8BA4\u521B\u5EFA\u4E86 text \u6807\u7B7E\uFF08\u6CA1\u6709 p \u6807\u7B7E\u5305\u88F9\uFF09\uFF0C\u7236\u5143\u7D20\u76F4\u63A5\u5C31\u662F $textElem\n            // \u4F8B\u5982\uFF0C\u5149\u6807\u653E\u5728 table \u6700\u540E\u4FA7\uFF0C\u56DE\u8F66\u65F6\uFF0C\u9ED8\u8BA4\u5C31\u662F\u8FD9\u4E2A\u60C5\u51B5\n            e.preventDefault()\n            editor.cmd.do('insertHTML', '<p><br></p>')\n        }\n    }\n    enterDownEvents.push(createPWhenEnterText)\n}\n\nexport default enterToCreateP\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6b2e3b5a192df1cbc0e390b1de88d22a2610964b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ck6yyj10n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_ck6yyj10n();

var __importDefault = (cov_ck6yyj10n().s[0]++, (cov_ck6yyj10n().b[0][0]++, void 0) && (cov_ck6yyj10n().b[0][1]++, (void 0).__importDefault) || (cov_ck6yyj10n().b[0][2]++, function (mod) {
  cov_ck6yyj10n().f[0]++;
  cov_ck6yyj10n().s[1]++;
  return (cov_ck6yyj10n().b[2][0]++, mod) && (cov_ck6yyj10n().b[2][1]++, mod.__esModule) ? (cov_ck6yyj10n().b[1][0]++, mod) : (cov_ck6yyj10n().b[1][1]++, {
    "default": mod
  });
}));

cov_ck6yyj10n().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_ck6yyj10n().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 回车时，保证生成的是 <p> 标签
 * @param editor 编辑器实例
 * @param enterUpEvents enter 键 up 时的 hooks
 * @param enterDownEvents enter 键 down 时的 hooks
 */

function enterToCreateP(editor, enterUpEvents, enterDownEvents) {
  cov_ck6yyj10n().f[1]++;

  function insertEmptyP($selectionElem) {
    cov_ck6yyj10n().f[2]++;
    var $p = (cov_ck6yyj10n().s[4]++, dom_core_1["default"]('<p><br></p>'));
    cov_ck6yyj10n().s[5]++;
    $p.insertBefore($selectionElem);
    cov_ck6yyj10n().s[6]++;
    editor.selection.createRangeByElem($p, true);
    cov_ck6yyj10n().s[7]++;
    editor.selection.restoreSelection();
    cov_ck6yyj10n().s[8]++;
    $selectionElem.remove();
  } // enter up 时


  function fn() {
    cov_ck6yyj10n().f[3]++;
    var $textElem = (cov_ck6yyj10n().s[9]++, editor.$textElem);
    var $selectionElem = (cov_ck6yyj10n().s[10]++, editor.selection.getSelectionContainerElem());
    var $parentElem = (cov_ck6yyj10n().s[11]++, $selectionElem.parent());
    cov_ck6yyj10n().s[12]++;

    if ($parentElem.html() === '<code><br></code>') {
      cov_ck6yyj10n().b[3][0]++;
      cov_ck6yyj10n().s[13]++;
      // 回车之前光标所在一个 <p><code>.....</code></p> ，忽然回车生成一个空的 <p><code><br></code></p>
      // 而且继续回车跳不出去，因此只能特殊处理
      insertEmptyP($selectionElem);
      cov_ck6yyj10n().s[14]++;
      return;
    } else {
      cov_ck6yyj10n().b[3][1]++;
    }

    cov_ck6yyj10n().s[15]++;

    if (!$parentElem.equal($textElem)) {
      cov_ck6yyj10n().b[4][0]++;
      cov_ck6yyj10n().s[16]++;
      // 不是顶级标签
      return;
    } else {
      cov_ck6yyj10n().b[4][1]++;
    }

    var nodeName = (cov_ck6yyj10n().s[17]++, $selectionElem.getNodeName());
    cov_ck6yyj10n().s[18]++;

    if (nodeName === 'P') {
      cov_ck6yyj10n().b[5][0]++;
      cov_ck6yyj10n().s[19]++;
      // 当前的标签是 P ，不用做处理
      return;
    } else {
      cov_ck6yyj10n().b[5][1]++;
    }

    cov_ck6yyj10n().s[20]++;

    if ($selectionElem.text()) {
      cov_ck6yyj10n().b[6][0]++;
      cov_ck6yyj10n().s[21]++;
      // 有内容，不做处理
      return;
    } else {
      cov_ck6yyj10n().b[6][1]++;
    } // 插入 <p> ，并将选取定位到 <p>，删除当前标签


    cov_ck6yyj10n().s[22]++;
    insertEmptyP($selectionElem);
  }

  cov_ck6yyj10n().s[23]++;
  enterUpEvents.push(fn); // enter down 时

  function createPWhenEnterText(e) {
    cov_ck6yyj10n().f[4]++;

    var _a; // selection中的range缓存还有问题,更新不及时,此处手动更新range,处理enter的bug


    cov_ck6yyj10n().s[24]++;
    editor.selection.saveRange((cov_ck6yyj10n().b[8][0]++, (_a = getSelection()) === null) || (cov_ck6yyj10n().b[8][1]++, _a === void 0) ? (cov_ck6yyj10n().b[7][0]++, void 0) : (cov_ck6yyj10n().b[7][1]++, _a.getRangeAt(0)));
    var $selectElem = (cov_ck6yyj10n().s[25]++, editor.selection.getSelectionContainerElem());
    cov_ck6yyj10n().s[26]++;

    if ($selectElem.id === editor.textElemId) {
      cov_ck6yyj10n().b[9][0]++;
      cov_ck6yyj10n().s[27]++;
      // 回车时，默认创建了 text 标签（没有 p 标签包裹），父元素直接就是 $textElem
      // 例如，光标放在 table 最后侧，回车时，默认就是这个情况
      e.preventDefault();
      cov_ck6yyj10n().s[28]++;
      editor.cmd["do"]('insertHTML', '<p><br></p>');
    } else {
      cov_ck6yyj10n().b[9][1]++;
    }
  }

  cov_ck6yyj10n().s[29]++;
  enterDownEvents.push(createPWhenEnterText);
}

cov_ck6yyj10n().s[30]++;
exports["default"] = enterToCreateP;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 删除时保留 <p><br></p>
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2clvvni2o1() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/del-to-keep-p.ts";
  var hash = "ef997c0367e6ce468b30f464486fe51879623ff9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/del-to-keep-p.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 19,
          column: 24
        },
        end: {
          line: 19,
          column: 40
        }
      },
      "5": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 59
        }
      },
      "6": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 29,
          column: 9
        }
      },
      "7": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 55
        }
      },
      "8": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 32
        }
      },
      "9": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 33
        }
      },
      "10": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 64
        }
      },
      "11": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 48
        }
      },
      "12": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 30
        }
      },
      "13": {
        start: {
          line: 33,
          column: 24
        },
        end: {
          line: 33,
          column: 40
        }
      },
      "14": {
        start: {
          line: 34,
          column: 22
        },
        end: {
          line: 34,
          column: 59
        }
      },
      "15": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 39,
          column: 9
        }
      },
      "16": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 31
        }
      },
      "17": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 19
        }
      },
      "18": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 34
        }
      },
      "19": {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 43,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "deleteToKeepP",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 22
          }
        },
        loc: {
          start: {
            line: 17,
            column: 65
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "upFn",
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 18
      },
      "3": {
        name: "downFn",
        decl: {
          start: {
            line: 32,
            column: 13
          },
          end: {
            line: 32,
            column: 19
          }
        },
        loc: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 32
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }, {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 22,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 22,
            column: 20
          }
        }, {
          start: {
            line: 22,
            column: 24
          },
          end: {
            line: 22,
            column: 42
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }, {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/del-to-keep-p.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/del-to-keep-p.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoC;AAEpC;;;;;GAKG;AACH,SAAS,aAAa,CAAC,MAAc,EAAE,cAA0B,EAAE,gBAA4B;IAC3F,SAAS,IAAI;QACT,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,OAAO,GAAG,SAAS,CAAC,IAAI,EAAE,CAAC,WAAW,EAAE,CAAC,IAAI,EAAE,CAAA;QAErD,mDAAmD;QACnD,IAAI,CAAC,OAAO,IAAI,OAAO,KAAK,MAAM,EAAE;YAChC,OAAO;YACP,IAAM,EAAE,GAAG,kBAAC,CAAC,cAAc,CAAC,CAAA;YAC5B,SAAS,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA,CAAC,0BAA0B;YAC9C,SAAS,CAAC,MAAM,CAAC,EAAE,CAAC,CAAA;YACpB,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,EAAE,EAAE,KAAK,EAAE,IAAI,CAAC,CAAA;YACnD,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IACD,cAAc,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;IAEzB,SAAS,MAAM,CAAC,CAAQ;QACpB,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,OAAO,GAAG,SAAS,CAAC,IAAI,EAAE,CAAC,WAAW,EAAE,CAAC,IAAI,EAAE,CAAA;QACrD,IAAI,OAAO,KAAK,aAAa,EAAE;YAC3B,kBAAkB;YAClB,CAAC,CAAC,cAAc,EAAE,CAAA;YAClB,OAAM;SACT;IACL,CAAC;IACD,gBAAgB,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;AACjC,CAAC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u5220\u9664\u65F6\u4FDD\u7559 <p><br></p>\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\n\n/**\n * \u5220\u9664\u65F6\u4FDD\u7559 <p><br></p>\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param deleteUpEvents delete \u952E up \u65F6\u7684 hooks\n * @param deleteDownEvents delete \u5EFA down \u65F6\u7684 hooks\n */\nfunction deleteToKeepP(editor: Editor, deleteUpEvents: Function[], deleteDownEvents: Function[]) {\n    function upFn() {\n        const $textElem = editor.$textElem\n        const txtHtml = $textElem.html().toLowerCase().trim()\n\n        // firefox \u65F6\u7528 txtHtml === '<br>' \u5224\u65AD\uFF0C\u5176\u4ED6\u7528 !txtHtml \u5224\u65AD\n        if (!txtHtml || txtHtml === '<br>') {\n            // \u5185\u5BB9\u7A7A\u4E86\n            const $p = $('<p><br/></p>')\n            $textElem.html(' ') // \u4E00\u5B9A\u8981\u5148\u6E05\u7A7A\uFF0C\u5426\u5219\u5728 firefox \u4E0B\u6709\u95EE\u9898\n            $textElem.append($p)\n            editor.selection.createRangeByElem($p, false, true)\n            editor.selection.restoreSelection()\n        }\n    }\n    deleteUpEvents.push(upFn)\n\n    function downFn(e: Event) {\n        const $textElem = editor.$textElem\n        const txtHtml = $textElem.html().toLowerCase().trim()\n        if (txtHtml === '<p><br></p>') {\n            // \u6700\u540E\u5269\u4E0B\u4E00\u4E2A\u7A7A\u884C\uFF0C\u5C31\u4E0D\u518D\u5220\u9664\u4E86\n            e.preventDefault()\n            return\n        }\n    }\n    deleteDownEvents.push(downFn)\n}\n\nexport default deleteToKeepP\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ef997c0367e6ce468b30f464486fe51879623ff9"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2clvvni2o1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2clvvni2o1();

var __importDefault = (cov_2clvvni2o1().s[0]++, (cov_2clvvni2o1().b[0][0]++, void 0) && (cov_2clvvni2o1().b[0][1]++, (void 0).__importDefault) || (cov_2clvvni2o1().b[0][2]++, function (mod) {
  cov_2clvvni2o1().f[0]++;
  cov_2clvvni2o1().s[1]++;
  return (cov_2clvvni2o1().b[2][0]++, mod) && (cov_2clvvni2o1().b[2][1]++, mod.__esModule) ? (cov_2clvvni2o1().b[1][0]++, mod) : (cov_2clvvni2o1().b[1][1]++, {
    "default": mod
  });
}));

cov_2clvvni2o1().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_2clvvni2o1().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 删除时保留 <p><br></p>
 * @param editor 编辑器实例
 * @param deleteUpEvents delete 键 up 时的 hooks
 * @param deleteDownEvents delete 建 down 时的 hooks
 */

function deleteToKeepP(editor, deleteUpEvents, deleteDownEvents) {
  cov_2clvvni2o1().f[1]++;

  function upFn() {
    var _context;

    cov_2clvvni2o1().f[2]++;
    var $textElem = (cov_2clvvni2o1().s[4]++, editor.$textElem);
    var txtHtml = (cov_2clvvni2o1().s[5]++, (0, _trim["default"])(_context = $textElem.html().toLowerCase()).call(_context)); // firefox 时用 txtHtml === '<br>' 判断，其他用 !txtHtml 判断

    cov_2clvvni2o1().s[6]++;

    if ((cov_2clvvni2o1().b[4][0]++, !txtHtml) || (cov_2clvvni2o1().b[4][1]++, txtHtml === '<br>')) {
      cov_2clvvni2o1().b[3][0]++;
      // 内容空了
      var $p = (cov_2clvvni2o1().s[7]++, dom_core_1["default"]('<p><br/></p>'));
      cov_2clvvni2o1().s[8]++;
      $textElem.html(' '); // 一定要先清空，否则在 firefox 下有问题

      cov_2clvvni2o1().s[9]++;
      $textElem.append($p);
      cov_2clvvni2o1().s[10]++;
      editor.selection.createRangeByElem($p, false, true);
      cov_2clvvni2o1().s[11]++;
      editor.selection.restoreSelection();
    } else {
      cov_2clvvni2o1().b[3][1]++;
    }
  }

  cov_2clvvni2o1().s[12]++;
  deleteUpEvents.push(upFn);

  function downFn(e) {
    var _context2;

    cov_2clvvni2o1().f[3]++;
    var $textElem = (cov_2clvvni2o1().s[13]++, editor.$textElem);
    var txtHtml = (cov_2clvvni2o1().s[14]++, (0, _trim["default"])(_context2 = $textElem.html().toLowerCase()).call(_context2));
    cov_2clvvni2o1().s[15]++;

    if (txtHtml === '<p><br></p>') {
      cov_2clvvni2o1().b[5][0]++;
      cov_2clvvni2o1().s[16]++;
      // 最后剩下一个空行，就不再删除了
      e.preventDefault();
      cov_2clvvni2o1().s[17]++;
      return;
    } else {
      cov_2clvvni2o1().b[5][1]++;
    }
  }

  cov_2clvvni2o1().s[18]++;
  deleteDownEvents.push(downFn);
}

cov_2clvvni2o1().s[19]++;
exports["default"] = deleteToKeepP;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 编辑区域 tab 的特殊处理
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2hwcrplp9n() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/tab-to-space.ts";
  var hash = "ce811b2652bfe51dba2db3c37cb391db913aba72";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/tab-to-space.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 18,
          column: 9
        }
      },
      "2": {
        start: {
          line: 17,
          column: 12
        },
        end: {
          line: 17,
          column: 19
        }
      },
      "3": {
        start: {
          line: 19,
          column: 29
        },
        end: {
          line: 19,
          column: 73
        }
      },
      "4": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 22,
          column: 9
        }
      },
      "5": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 19
        }
      },
      "6": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 49
        }
      },
      "7": {
        start: {
          line: 24,
          column: 32
        },
        end: {
          line: 24,
          column: 60
        }
      },
      "8": {
        start: {
          line: 25,
          column: 29
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "9": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 36,
          column: 9
        }
      },
      "10": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 67
        }
      },
      "11": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 35,
          column: 68
        }
      },
      "12": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 27
        }
      },
      "13": {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 41,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "tabHandler",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 19
          }
        },
        loc: {
          start: {
            line: 12,
            column: 43
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "fn",
        decl: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 15
          }
        },
        loc: {
          start: {
            line: 14,
            column: 18
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 14
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        }, {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 22,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 22,
            column: 9
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 22,
            column: 9
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }, {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }],
        line: 26
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 29,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 39
          }
        }, {
          start: {
            line: 27,
            column: 12
          },
          end: {
            line: 27,
            column: 37
          }
        }, {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 36
          }
        }, {
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 29,
            column: 39
          }
        }],
        line: 26
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/tab-to-space.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/tab-to-space.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAIH;;;;GAIG;AACH,SAAS,UAAU,CAAC,MAAc,EAAE,aAAyB;IACzD,OAAO;IACP,SAAS,EAAE;QACP,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,qBAAqB,CAAC,YAAY,CAAC,EAAE;YACjD,uBAAuB;YACvB,OAAM;SACT;QACD,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACnE,IAAI,CAAC,cAAc,EAAE;YACjB,OAAM;SACT;QACD,IAAM,WAAW,GAAG,cAAc,CAAC,MAAM,EAAE,CAAA;QAC3C,IAAM,iBAAiB,GAAG,cAAc,CAAC,WAAW,EAAE,CAAA;QACtD,IAAM,cAAc,GAAG,WAAW,CAAC,WAAW,EAAE,CAAA;QAEhD,IACI,iBAAiB,IAAI,MAAM;YAC3B,cAAc,KAAK,MAAM;YACzB,cAAc,KAAK,KAAK;YACxB,MAAM,CAAC,IAAI,CAAC,cAAc,CAAC,EAC7B;YACE,iBAAiB;YACjB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,MAAM,CAAC,WAAW,CAAC,CAAA;SACzD;aAAM;YACH,OAAO;YACP,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,0BAA0B,CAAC,CAAA;SAC1D;IACL,CAAC;IAED,OAAO;IACP,aAAa,CAAC,IAAI,CAAC,EAAE,CAAC,CAAA;AAC1B,CAAC;AAED,kBAAe,UAAU,CAAA",
      sourcesContent: ["/**\n * @description \u7F16\u8F91\u533A\u57DF tab \u7684\u7279\u6B8A\u5904\u7406\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\n\n/**\n * \u7F16\u8F91\u533A\u57DF tab \u7684\u7279\u6B8A\u5904\u7406\uFF0C\u8F6C\u6362\u4E3A\u7A7A\u683C\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param tabDownEvents tab down \u4E8B\u4EF6\u94A9\u5B50\n */\nfunction tabHandler(editor: Editor, tabDownEvents: Function[]) {\n    // \u5B9A\u4E49\u51FD\u6570\n    function fn() {\n        if (!editor.cmd.queryCommandSupported('insertHTML')) {\n            // \u5FC5\u987B\u539F\u751F\u652F\u6301 insertHTML \u547D\u4EE4\n            return\n        }\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n        if (!$selectionElem) {\n            return\n        }\n        const $parentElem = $selectionElem.parent()\n        const selectionNodeName = $selectionElem.getNodeName()\n        const parentNodeName = $parentElem.getNodeName()\n\n        if (\n            selectionNodeName == 'CODE' ||\n            parentNodeName === 'CODE' ||\n            parentNodeName === 'PRE' ||\n            /hljs/.test(parentNodeName)\n        ) {\n            // <pre><code> \u91CC\u9762\n            editor.cmd.do('insertHTML', editor.config.languageTab)\n        } else {\n            // \u666E\u901A\u6587\u5B57\n            editor.cmd.do('insertHTML', '&nbsp;&nbsp;&nbsp;&nbsp;')\n        }\n    }\n\n    // \u4FDD\u7559\u51FD\u6570\n    tabDownEvents.push(fn)\n}\n\nexport default tabHandler\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ce811b2652bfe51dba2db3c37cb391db913aba72"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hwcrplp9n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2hwcrplp9n();
cov_2hwcrplp9n().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * 编辑区域 tab 的特殊处理，转换为空格
 * @param editor 编辑器实例
 * @param tabDownEvents tab down 事件钩子
 */

function tabHandler(editor, tabDownEvents) {
  cov_2hwcrplp9n().f[0]++;

  // 定义函数
  function fn() {
    cov_2hwcrplp9n().f[1]++;
    cov_2hwcrplp9n().s[1]++;

    if (!editor.cmd.queryCommandSupported('insertHTML')) {
      cov_2hwcrplp9n().b[0][0]++;
      cov_2hwcrplp9n().s[2]++;
      // 必须原生支持 insertHTML 命令
      return;
    } else {
      cov_2hwcrplp9n().b[0][1]++;
    }

    var $selectionElem = (cov_2hwcrplp9n().s[3]++, editor.selection.getSelectionContainerElem());
    cov_2hwcrplp9n().s[4]++;

    if (!$selectionElem) {
      cov_2hwcrplp9n().b[1][0]++;
      cov_2hwcrplp9n().s[5]++;
      return;
    } else {
      cov_2hwcrplp9n().b[1][1]++;
    }

    var $parentElem = (cov_2hwcrplp9n().s[6]++, $selectionElem.parent());
    var selectionNodeName = (cov_2hwcrplp9n().s[7]++, $selectionElem.getNodeName());
    var parentNodeName = (cov_2hwcrplp9n().s[8]++, $parentElem.getNodeName());
    cov_2hwcrplp9n().s[9]++;

    if ((cov_2hwcrplp9n().b[3][0]++, selectionNodeName == 'CODE') || (cov_2hwcrplp9n().b[3][1]++, parentNodeName === 'CODE') || (cov_2hwcrplp9n().b[3][2]++, parentNodeName === 'PRE') || (cov_2hwcrplp9n().b[3][3]++, /hljs/.test(parentNodeName))) {
      cov_2hwcrplp9n().b[2][0]++;
      cov_2hwcrplp9n().s[10]++;
      // <pre><code> 里面
      editor.cmd["do"]('insertHTML', editor.config.languageTab);
    } else {
      cov_2hwcrplp9n().b[2][1]++;
      cov_2hwcrplp9n().s[11]++;
      // 普通文字
      editor.cmd["do"]('insertHTML', '&nbsp;&nbsp;&nbsp;&nbsp;');
    }
  } // 保留函数


  cov_2hwcrplp9n().s[12]++;
  tabDownEvents.push(fn);
}

cov_2hwcrplp9n().s[13]++;
exports["default"] = tabHandler;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 粘贴 text html
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2fntltyqi9() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/paste-text-html.ts";
  var hash = "8eb4233c8f0d124dd2004fd933eacbf38e6c664c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/paste-text-html.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 7,
          column: 51
        }
      },
      "2": {
        start: {
          line: 8,
          column: 13
        },
        end: {
          line: 8,
          column: 40
        }
      },
      "3": {
        start: {
          line: 9,
          column: 14
        },
        end: {
          line: 9,
          column: 42
        }
      },
      "4": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 23
        }
      },
      "5": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 83
        }
      },
      "6": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 64
        }
      },
      "7": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 28
        }
      },
      "8": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 79
        }
      },
      "9": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "10": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 41,
          column: 34
        }
      },
      "11": {
        start: {
          line: 42,
          column: 31
        },
        end: {
          line: 42,
          column: 54
        }
      },
      "12": {
        start: {
          line: 43,
          column: 29
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "13": {
        start: {
          line: 44,
          column: 30
        },
        end: {
          line: 44,
          column: 52
        }
      },
      "14": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 46,
          column: 87
        }
      },
      "15": {
        start: {
          line: 47,
          column: 24
        },
        end: {
          line: 47,
          column: 53
        }
      },
      "16": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 54
        }
      },
      "17": {
        start: {
          line: 50,
          column: 29
        },
        end: {
          line: 50,
          column: 73
        }
      },
      "18": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 53,
          column: 9
        }
      },
      "19": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 52,
          column: 19
        }
      },
      "20": {
        start: {
          line: 54,
          column: 23
        },
        end: {
          line: 54,
          column: 115
        }
      },
      "21": {
        start: {
          line: 55,
          column: 23
        },
        end: {
          line: 55,
          column: 120
        }
      },
      "22": {
        start: {
          line: 57,
          column: 26
        },
        end: {
          line: 57,
          column: 28
        }
      },
      "23": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 60,
          column: 9
        }
      },
      "24": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 101
        }
      },
      "25": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "26": {
        start: {
          line: 63,
          column: 12
        },
        end: {
          line: 66,
          column: 13
        }
      },
      "27": {
        start: {
          line: 65,
          column: 16
        },
        end: {
          line: 65,
          column: 68
        }
      },
      "28": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 63
        }
      },
      "29": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 19
        }
      },
      "30": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 73,
          column: 9
        }
      },
      "31": {
        start: {
          line: 72,
          column: 12
        },
        end: {
          line: 72,
          column: 120
        }
      },
      "32": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 77,
          column: 9
        }
      },
      "33": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 76,
          column: 19
        }
      },
      "34": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 94,
          column: 9
        }
      },
      "35": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 84,
          column: 13
        }
      },
      "36": {
        start: {
          line: 83,
          column: 16
        },
        end: {
          line: 83,
          column: 68
        }
      },
      "37": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 85,
          column: 68
        }
      },
      "38": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 92,
          column: 13
        }
      },
      "39": {
        start: {
          line: 91,
          column: 16
        },
        end: {
          line: 91,
          column: 68
        }
      },
      "40": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 68
        }
      },
      "41": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 25
        }
      },
      "42": {
        start: {
          line: 98,
          column: 0
        },
        end: {
          line: 98,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "formatHtml",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 25
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "formatCode",
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 19
          }
        },
        loc: {
          start: {
            line: 29,
            column: 25
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 29
      },
      "2": {
        name: "pasteTextHtml",
        decl: {
          start: {
            line: 38,
            column: 9
          },
          end: {
            line: 38,
            column: 22
          }
        },
        loc: {
          start: {
            line: 38,
            column: 44
          },
          end: {
            line: 97,
            column: 1
          }
        },
        line: 38
      },
      "3": {
        name: "fn",
        decl: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 15
          }
        },
        loc: {
          start: {
            line: 39,
            column: 19
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 53,
            column: 9
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 54,
            column: 115
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 54,
            column: 78
          },
          end: {
            line: 54,
            column: 84
          }
        }, {
          start: {
            line: 54,
            column: 87
          },
          end: {
            line: 54,
            column: 115
          }
        }],
        line: 54
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 54,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 54,
            column: 46
          }
        }, {
          start: {
            line: 54,
            column: 50
          },
          end: {
            line: 54,
            column: 75
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 120
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 78
          },
          end: {
            line: 55,
            column: 84
          }
        }, {
          start: {
            line: 55,
            column: 87
          },
          end: {
            line: 55,
            column: 120
          }
        }],
        line: 55
      },
      "4": {
        loc: {
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 23
          },
          end: {
            line: 55,
            column: 46
          }
        }, {
          start: {
            line: 55,
            column: 50
          },
          end: {
            line: 55,
            column: 75
          }
        }],
        line: 55
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        }, {
          start: {
            line: 58,
            column: 8
          },
          end: {
            line: 60,
            column: 9
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 69
          },
          end: {
            line: 59,
            column: 75
          }
        }, {
          start: {
            line: 59,
            column: 78
          },
          end: {
            line: 59,
            column: 100
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 43
          }
        }, {
          start: {
            line: 59,
            column: 47
          },
          end: {
            line: 59,
            column: 66
          }
        }],
        line: 59
      },
      "8": {
        loc: {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 62
      },
      "9": {
        loc: {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 62,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 62,
            column: 31
          }
        }, {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 62,
            column: 56
          }
        }],
        line: 62
      },
      "10": {
        loc: {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }, {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        }],
        line: 63
      },
      "11": {
        loc: {
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 16
          },
          end: {
            line: 63,
            column: 31
          }
        }, {
          start: {
            line: 63,
            column: 35
          },
          end: {
            line: 63,
            column: 69
          }
        }],
        line: 63
      },
      "12": {
        loc: {
          start: {
            line: 65,
            column: 34
          },
          end: {
            line: 65,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 34
          },
          end: {
            line: 65,
            column: 60
          }
        }, {
          start: {
            line: 65,
            column: 64
          },
          end: {
            line: 65,
            column: 66
          }
        }],
        line: 65
      },
      "13": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }],
        line: 71
      },
      "14": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        }, {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        }],
        line: 75
      },
      "15": {
        loc: {
          start: {
            line: 81,
            column: 12
          },
          end: {
            line: 84,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 12
          },
          end: {
            line: 84,
            column: 13
          }
        }, {
          start: {
            line: 81,
            column: 12
          },
          end: {
            line: 84,
            column: 13
          }
        }],
        line: 81
      },
      "16": {
        loc: {
          start: {
            line: 81,
            column: 16
          },
          end: {
            line: 81,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 16
          },
          end: {
            line: 81,
            column: 31
          }
        }, {
          start: {
            line: 81,
            column: 35
          },
          end: {
            line: 81,
            column: 69
          }
        }],
        line: 81
      },
      "17": {
        loc: {
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 83,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 34
          },
          end: {
            line: 83,
            column: 60
          }
        }, {
          start: {
            line: 83,
            column: 64
          },
          end: {
            line: 83,
            column: 66
          }
        }],
        line: 83
      },
      "18": {
        loc: {
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 92,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 92,
            column: 13
          }
        }, {
          start: {
            line: 89,
            column: 12
          },
          end: {
            line: 92,
            column: 13
          }
        }],
        line: 89
      },
      "19": {
        loc: {
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 16
          },
          end: {
            line: 89,
            column: 31
          }
        }, {
          start: {
            line: 89,
            column: 35
          },
          end: {
            line: 89,
            column: 69
          }
        }],
        line: 89
      },
      "20": {
        loc: {
          start: {
            line: 91,
            column: 34
          },
          end: {
            line: 91,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 34
          },
          end: {
            line: 91,
            column: 60
          }
        }, {
          start: {
            line: 91,
            column: 64
          },
          end: {
            line: 91,
            column: 66
          }
        }],
        line: 91
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/paste-text-html.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/paste-text-html.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAGH,oDAAiE;AACjE,yCAA6C;AAC7C,2CAA4C;AAE5C;;;;GAIG;AACH,SAAS,UAAU,CAAC,GAAW;IAC3B,IAAI,SAAS,GAAG,GAAG,CAAA;IACnB,iBAAiB;IACjB,SAAS,GAAG,SAAS,CAAC,OAAO,CAAC,UAAU,EAAE,KAAK,CAAC,CAAC,OAAO,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;IAC9E,aAAa;IACb,SAAS,GAAG,SAAS,CAAC,OAAO,CAAC,aAAa,EAAE,aAAa,CAAC,CAAA;IAC3D,OAAO;IACP,OAAO,SAAS,CAAC,IAAI,EAAE,CAAA;AAC3B,CAAC;AAED;;;;GAIG;AACH,SAAS,UAAU,CAAC,GAAW;IAC3B,IAAI,SAAS,GAAG,GAAG,CAAC,OAAO,CAAC,eAAe,EAAE,IAAI,CAAC,CAAC,OAAO,CAAC,WAAW,EAAE,EAAE,CAAC,CAAA;IAE3E,OAAO,SAAS,CAAA;AACpB,CAAC;AAED;;;;GAIG;AACH,SAAS,aAAa,CAAC,MAAc,EAAE,WAAuB;IAC1D,SAAS,EAAE,CAAC,CAAQ;QAChB,OAAO;QACP,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;QAC5B,IAAM,gBAAgB,GAAG,MAAM,CAAC,gBAAgB,CAAA;QAChD,IAAM,cAAc,GAAG,MAAM,CAAC,cAAc,CAAA;QAC5C,IAAM,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;QAE9C,UAAU;QACV,IAAI,SAAS,GAAG,0BAAY,CAAC,CAAmB,EAAE,gBAAgB,EAAE,cAAc,CAAC,CAAA;QACnF,IAAI,SAAS,GAAG,0BAAY,CAAC,CAAmB,CAAC,CAAA;QACjD,SAAS,GAAG,SAAS,CAAC,OAAO,CAAC,MAAM,EAAE,MAAM,CAAC,CAAA;QAE7C,iBAAiB;QACjB,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACnE,IAAI,CAAC,cAAc,EAAE;YACjB,OAAM;SACT;QACD,IAAM,QAAQ,GAAG,cAAc,aAAd,cAAc,uBAAd,cAAc,CAAE,WAAW,EAAE,CAAA;QAC9C,IAAM,QAAQ,GAAG,cAAc,aAAd,cAAc,uBAAd,cAAc,CAAE,UAAU,CAAC,MAAM,CAAC,CAAA;QAEnD,aAAa;QACb,IAAI,WAAW,GAAW,EAAE,CAAA;QAC5B,IAAI,QAAQ,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE;YACnB,WAAW,GAAG,QAAQ,aAAR,QAAQ,uBAAR,QAAQ,CAAE,WAAW,EAAE,CAAA;SACxC;QACD,gBAAgB;QAChB,IAAI,QAAQ,KAAK,MAAM,IAAI,WAAW,KAAK,KAAK,EAAE;YAC9C,IAAI,eAAe,IAAI,iBAAU,CAAC,eAAe,CAAC,EAAE;gBAChD,gBAAgB;gBAChB,SAAS,GAAG,EAAE,GAAG,CAAC,eAAe,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA;aACtD;YACD,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,UAAU,CAAC,SAAS,CAAC,CAAC,CAAA;YAClD,OAAM;SACT;QAED,0BAA0B;QAC1B,IAAI,gBAAQ,CAAC,IAAI,CAAC,SAAS,CAAC,EAAE;YAC1B,OAAO,MAAM,CAAC,GAAG,CAAC,EAAE,CAChB,YAAY,EACZ,eAAY,SAAS,6BAAqB,SAAS,SAAM,CAC5D,CAAA;SACJ;QAED,wBAAwB;QAExB,IAAI,CAAC,SAAS,EAAE;YACZ,OAAM;SACT;QAED,IAAI;YACA,8CAA8C;YAC9C,sBAAsB;YACtB,IAAI,eAAe,IAAI,iBAAU,CAAC,eAAe,CAAC,EAAE;gBAChD,gBAAgB;gBAChB,SAAS,GAAG,EAAE,GAAG,CAAC,eAAe,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA,CAAC,OAAO;aAC9D;YACD,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,KAAG,UAAU,CAAC,SAAS,CAAG,CAAC,CAAA;SAC1D;QAAC,OAAO,EAAE,EAAE;YACT,uBAAuB;YACvB,IAAI,eAAe,IAAI,iBAAU,CAAC,eAAe,CAAC,EAAE;gBAChD,gBAAgB;gBAChB,SAAS,GAAG,EAAE,GAAG,CAAC,eAAe,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA;aACtD;YACD,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,KAAG,UAAU,CAAC,SAAS,CAAG,CAAC,CAAA,CAAC,OAAO;SAClE;IACL,CAAC;IAED,WAAW,CAAC,IAAI,CAAC,EAAE,CAAC,CAAA;AACxB,CAAC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u7C98\u8D34 text html\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport { getPasteText, getPasteHtml } from '../paste/paste-event'\nimport { isFunction } from '../../utils/util'\nimport { urlRegex } from '../../utils/const'\n\n/**\n * \u683C\u5F0F\u5316html\n * @param val \u7C98\u8D34\u7684html\n * @author liuwei\n */\nfunction formatHtml(val: string) {\n    let pasteText = val\n    // div \u5168\u90E8\u66FF\u6362\u4E3A p \u6807\u7B7E\n    pasteText = pasteText.replace(/<div>/gim, '<p>').replace(/<\\/div>/gim, '</p>')\n    // \u4E0D\u5141\u8BB8\u7A7A\u884C\uFF0C\u653E\u5728\u6700\u540E\n    pasteText = pasteText.replace(/<p><\\/p>/gim, '<p><br></p>')\n    // \u53BB\u9664''\n    return pasteText.trim()\n}\n\n/**\n * \u683C\u5F0F\u5316html\n * @param val \u7C98\u8D34\u7684html\n * @author liuwei\n */\nfunction formatCode(val: string) {\n    let pasteText = val.replace(/<br>|<br\\/>/gm, '\\n').replace(/<[^>]+>/gm, '')\n\n    return pasteText\n}\n\n/**\n * \u7C98\u8D34\u6587\u672C\u548C html\n * @param editor \u7F16\u8F91\u5668\u5BF9\u8C61\n * @param pasteEvents \u7C98\u8D34\u4E8B\u4EF6\u5217\u8868\n */\nfunction pasteTextHtml(editor: Editor, pasteEvents: Function[]) {\n    function fn(e: Event) {\n        // \u83B7\u53D6\u914D\u7F6E\n        const config = editor.config\n        const pasteFilterStyle = config.pasteFilterStyle\n        const pasteIgnoreImg = config.pasteIgnoreImg\n        const pasteTextHandle = config.pasteTextHandle\n\n        // \u83B7\u53D6\u7C98\u8D34\u7684\u6587\u5B57\n        let pasteHtml = getPasteHtml(e as ClipboardEvent, pasteFilterStyle, pasteIgnoreImg)\n        let pasteText = getPasteText(e as ClipboardEvent)\n        pasteText = pasteText.replace(/\\n/gm, '<br>')\n\n        // \u5F53\u524D\u9009\u533A\u6240\u5728\u7684 DOM \u8282\u70B9\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n        if (!$selectionElem) {\n            return\n        }\n        const nodeName = $selectionElem?.getNodeName()\n        const $topElem = $selectionElem?.getNodeTop(editor)\n\n        // \u5F53\u524D\u8282\u70B9\u9876\u7EA7\u53EF\u80FD\u6CA1\u6709\n        let topNodeName: string = ''\n        if ($topElem.elems[0]) {\n            topNodeName = $topElem?.getNodeName()\n        }\n        // code \u4E2D\u53EA\u80FD\u7C98\u8D34\u7EAF\u6587\u672C\n        if (nodeName === 'CODE' || topNodeName === 'PRE') {\n            if (pasteTextHandle && isFunction(pasteTextHandle)) {\n                // \u7528\u6237\u81EA\u5B9A\u4E49\u8FC7\u6EE4\u5904\u7406\u7C98\u8D34\u5185\u5BB9\n                pasteText = '' + (pasteTextHandle(pasteText) || '')\n            }\n            editor.cmd.do('insertHTML', formatCode(pasteText))\n            return\n        }\n\n        // \u5982\u679C\u590D\u5236\u8FDB\u6765\u7684\u662Furl\u94FE\u63A5\u5219\u63D2\u5165\u65F6\u5C06\u5B83\u8F6C\u4E3A\u94FE\u63A5\n        if (urlRegex.test(pasteText)) {\n            return editor.cmd.do(\n                'insertHTML',\n                `<a href=\"${pasteText}\" target=\"_blank\">${pasteText}</a>`\n            )\n        }\n\n        // table \u4E2D\uFF08td\u3001th\uFF09\uFF0C\u5F85\u5F00\u53D1\u3002\u3002\u3002\n\n        if (!pasteHtml) {\n            return\n        }\n\n        try {\n            // firefox \u4E2D\uFF0C\u83B7\u53D6\u7684 pasteHtml \u53EF\u80FD\u662F\u6CA1\u6709 <ul> \u5305\u88F9\u7684 <li>\n            // \u56E0\u6B64\u6267\u884C insertHTML \u4F1A\u62A5\u9519\n            if (pasteTextHandle && isFunction(pasteTextHandle)) {\n                // \u7528\u6237\u81EA\u5B9A\u4E49\u8FC7\u6EE4\u5904\u7406\u7C98\u8D34\u5185\u5BB9\n                pasteHtml = '' + (pasteTextHandle(pasteHtml) || '') // html\n            }\n            editor.cmd.do('insertHTML', `${formatHtml(pasteHtml)}`)\n        } catch (ex) {\n            // \u6B64\u65F6\u4F7F\u7528 pasteText \u6765\u517C\u5BB9\u4E00\u4E0B\n            if (pasteTextHandle && isFunction(pasteTextHandle)) {\n                // \u7528\u6237\u81EA\u5B9A\u4E49\u8FC7\u6EE4\u5904\u7406\u7C98\u8D34\u5185\u5BB9\n                pasteText = '' + (pasteTextHandle(pasteText) || '')\n            }\n            editor.cmd.do('insertHTML', `${formatHtml(pasteText)}`) // text\n        }\n    }\n\n    pasteEvents.push(fn)\n}\n\nexport default pasteTextHtml\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8eb4233c8f0d124dd2004fd933eacbf38e6c664c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2fntltyqi9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2fntltyqi9();
cov_2fntltyqi9().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var paste_event_1 = (cov_2fntltyqi9().s[1]++, __webpack_require__(122));
var util_1 = (cov_2fntltyqi9().s[2]++, __webpack_require__(7));
var const_1 = (cov_2fntltyqi9().s[3]++, __webpack_require__(30));
/**
 * 格式化html
 * @param val 粘贴的html
 * @author liuwei
 */

function formatHtml(val) {
  cov_2fntltyqi9().f[0]++;
  var pasteText = (cov_2fntltyqi9().s[4]++, val); // div 全部替换为 p 标签

  cov_2fntltyqi9().s[5]++;
  pasteText = pasteText.replace(/<div>/gim, '<p>').replace(/<\/div>/gim, '</p>'); // 不允许空行，放在最后

  cov_2fntltyqi9().s[6]++;
  pasteText = pasteText.replace(/<p><\/p>/gim, '<p><br></p>'); // 去除''

  cov_2fntltyqi9().s[7]++;
  return (0, _trim["default"])(pasteText).call(pasteText);
}
/**
 * 格式化html
 * @param val 粘贴的html
 * @author liuwei
 */


function formatCode(val) {
  cov_2fntltyqi9().f[1]++;
  var pasteText = (cov_2fntltyqi9().s[8]++, val.replace(/<br>|<br\/>/gm, '\n').replace(/<[^>]+>/gm, ''));
  cov_2fntltyqi9().s[9]++;
  return pasteText;
}
/**
 * 粘贴文本和 html
 * @param editor 编辑器对象
 * @param pasteEvents 粘贴事件列表
 */


function pasteTextHtml(editor, pasteEvents) {
  cov_2fntltyqi9().f[2]++;

  function fn(e) {
    cov_2fntltyqi9().f[3]++;
    // 获取配置
    var config = (cov_2fntltyqi9().s[10]++, editor.config);
    var pasteFilterStyle = (cov_2fntltyqi9().s[11]++, config.pasteFilterStyle);
    var pasteIgnoreImg = (cov_2fntltyqi9().s[12]++, config.pasteIgnoreImg);
    var pasteTextHandle = (cov_2fntltyqi9().s[13]++, config.pasteTextHandle); // 获取粘贴的文字

    var pasteHtml = (cov_2fntltyqi9().s[14]++, paste_event_1.getPasteHtml(e, pasteFilterStyle, pasteIgnoreImg));
    var pasteText = (cov_2fntltyqi9().s[15]++, paste_event_1.getPasteText(e));
    cov_2fntltyqi9().s[16]++;
    pasteText = pasteText.replace(/\n/gm, '<br>'); // 当前选区所在的 DOM 节点

    var $selectionElem = (cov_2fntltyqi9().s[17]++, editor.selection.getSelectionContainerElem());
    cov_2fntltyqi9().s[18]++;

    if (!$selectionElem) {
      cov_2fntltyqi9().b[0][0]++;
      cov_2fntltyqi9().s[19]++;
      return;
    } else {
      cov_2fntltyqi9().b[0][1]++;
    }

    var nodeName = (cov_2fntltyqi9().s[20]++, (cov_2fntltyqi9().b[2][0]++, $selectionElem === null) || (cov_2fntltyqi9().b[2][1]++, $selectionElem === void 0) ? (cov_2fntltyqi9().b[1][0]++, void 0) : (cov_2fntltyqi9().b[1][1]++, $selectionElem.getNodeName()));
    var $topElem = (cov_2fntltyqi9().s[21]++, (cov_2fntltyqi9().b[4][0]++, $selectionElem === null) || (cov_2fntltyqi9().b[4][1]++, $selectionElem === void 0) ? (cov_2fntltyqi9().b[3][0]++, void 0) : (cov_2fntltyqi9().b[3][1]++, $selectionElem.getNodeTop(editor))); // 当前节点顶级可能没有

    var topNodeName = (cov_2fntltyqi9().s[22]++, '');
    cov_2fntltyqi9().s[23]++;

    if ($topElem.elems[0]) {
      cov_2fntltyqi9().b[5][0]++;
      cov_2fntltyqi9().s[24]++;
      topNodeName = (cov_2fntltyqi9().b[7][0]++, $topElem === null) || (cov_2fntltyqi9().b[7][1]++, $topElem === void 0) ? (cov_2fntltyqi9().b[6][0]++, void 0) : (cov_2fntltyqi9().b[6][1]++, $topElem.getNodeName());
    } else {
      cov_2fntltyqi9().b[5][1]++;
    } // code 中只能粘贴纯文本


    cov_2fntltyqi9().s[25]++;

    if ((cov_2fntltyqi9().b[9][0]++, nodeName === 'CODE') || (cov_2fntltyqi9().b[9][1]++, topNodeName === 'PRE')) {
      cov_2fntltyqi9().b[8][0]++;
      cov_2fntltyqi9().s[26]++;

      if ((cov_2fntltyqi9().b[11][0]++, pasteTextHandle) && (cov_2fntltyqi9().b[11][1]++, util_1.isFunction(pasteTextHandle))) {
        cov_2fntltyqi9().b[10][0]++;
        cov_2fntltyqi9().s[27]++;
        // 用户自定义过滤处理粘贴内容
        pasteText = '' + ((cov_2fntltyqi9().b[12][0]++, pasteTextHandle(pasteText)) || (cov_2fntltyqi9().b[12][1]++, ''));
      } else {
        cov_2fntltyqi9().b[10][1]++;
      }

      cov_2fntltyqi9().s[28]++;
      editor.cmd["do"]('insertHTML', formatCode(pasteText));
      cov_2fntltyqi9().s[29]++;
      return;
    } else {
      cov_2fntltyqi9().b[8][1]++;
    } // 如果复制进来的是url链接则插入时将它转为链接


    cov_2fntltyqi9().s[30]++;

    if (const_1.urlRegex.test(pasteText)) {
      cov_2fntltyqi9().b[13][0]++;
      cov_2fntltyqi9().s[31]++;
      return editor.cmd["do"]('insertHTML', "<a href=\"" + pasteText + "\" target=\"_blank\">" + pasteText + "</a>");
    } else {
      cov_2fntltyqi9().b[13][1]++;
    } // table 中（td、th），待开发。。。


    cov_2fntltyqi9().s[32]++;

    if (!pasteHtml) {
      cov_2fntltyqi9().b[14][0]++;
      cov_2fntltyqi9().s[33]++;
      return;
    } else {
      cov_2fntltyqi9().b[14][1]++;
    }

    cov_2fntltyqi9().s[34]++;

    try {
      cov_2fntltyqi9().s[35]++;

      // firefox 中，获取的 pasteHtml 可能是没有 <ul> 包裹的 <li>
      // 因此执行 insertHTML 会报错
      if ((cov_2fntltyqi9().b[16][0]++, pasteTextHandle) && (cov_2fntltyqi9().b[16][1]++, util_1.isFunction(pasteTextHandle))) {
        cov_2fntltyqi9().b[15][0]++;
        cov_2fntltyqi9().s[36]++;
        // 用户自定义过滤处理粘贴内容
        pasteHtml = '' + ((cov_2fntltyqi9().b[17][0]++, pasteTextHandle(pasteHtml)) || (cov_2fntltyqi9().b[17][1]++, '')); // html
      } else {
        cov_2fntltyqi9().b[15][1]++;
      }

      cov_2fntltyqi9().s[37]++;
      editor.cmd["do"]('insertHTML', "" + formatHtml(pasteHtml));
    } catch (ex) {
      cov_2fntltyqi9().s[38]++;

      // 此时使用 pasteText 来兼容一下
      if ((cov_2fntltyqi9().b[19][0]++, pasteTextHandle) && (cov_2fntltyqi9().b[19][1]++, util_1.isFunction(pasteTextHandle))) {
        cov_2fntltyqi9().b[18][0]++;
        cov_2fntltyqi9().s[39]++;
        // 用户自定义过滤处理粘贴内容
        pasteText = '' + ((cov_2fntltyqi9().b[20][0]++, pasteTextHandle(pasteText)) || (cov_2fntltyqi9().b[20][1]++, ''));
      } else {
        cov_2fntltyqi9().b[18][1]++;
      }

      cov_2fntltyqi9().s[40]++;
      editor.cmd["do"]('insertHTML', "" + formatHtml(pasteText)); // text
    }
  }

  cov_2fntltyqi9().s[41]++;
  pasteEvents.push(fn);
}

cov_2fntltyqi9().s[42]++;
exports["default"] = pasteTextHtml;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 将粘贴的 html 字符串，转换为正确、简洁的 html 代码。剔除不必要的标签和属性。
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _includes = _interopRequireDefault(__webpack_require__(111));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1z3m5ioo4() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/paste/parse-html.ts";
  var hash = "1b3527790e6fdabef63887c92580861fbcaa4f17";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/paste/parse-html.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 30
        }
      },
      "4": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 11,
          column: 85
        }
      },
      "5": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 45
        }
      },
      "6": {
        start: {
          line: 18,
          column: 22
        },
        end: {
          line: 18,
          column: 43
        }
      },
      "7": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 25,
          column: 7
        }
      },
      "8": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 41
        }
      },
      "9": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 23,
          column: 22
        }
      },
      "10": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 22
        }
      },
      "11": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 25
        }
      },
      "12": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 35
        }
      },
      "13": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "14": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 20
        }
      },
      "15": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "16": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "17": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 24
        }
      },
      "18": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 17
        }
      },
      "19": {
        start: {
          line: 52,
          column: 17
        },
        end: {
          line: 52,
          column: 19
        }
      },
      "20": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 23
        }
      },
      "21": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 56,
          column: 23
        }
      },
      "22": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 59,
          column: 7
        }
      },
      "23": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 63
        }
      },
      "24": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "25": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 53
        }
      },
      "26": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 64,
          column: 44
        }
      },
      "27": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 49
        }
      },
      "28": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 18
        }
      },
      "29": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 28
        }
      },
      "30": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 55
        }
      },
      "31": {
        start: {
          line: 82,
          column: 34
        },
        end: {
          line: 82,
          column: 53
        }
      },
      "32": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 52
        }
      },
      "33": {
        start: {
          line: 83,
          column: 32
        },
        end: {
          line: 83,
          column: 50
        }
      },
      "34": {
        start: {
          line: 84,
          column: 20
        },
        end: {
          line: 84,
          column: 22
        }
      },
      "35": {
        start: {
          line: 86,
          column: 18
        },
        end: {
          line: 86,
          column: 20
        }
      },
      "36": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 88,
          column: 25
        }
      },
      "37": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 90,
          column: 19
        }
      },
      "38": {
        start: {
          line: 90,
          column: 12
        },
        end: {
          line: 90,
          column: 19
        }
      },
      "39": {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 92,
          column: 19
        }
      },
      "40": {
        start: {
          line: 92,
          column: 12
        },
        end: {
          line: 92,
          column: 19
        }
      },
      "41": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 22
        }
      },
      "42": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 21
        }
      },
      "43": {
        start: {
          line: 99,
          column: 21
        },
        end: {
          line: 99,
          column: 56
        }
      },
      "44": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 157,
          column: 7
        }
      },
      "45": {
        start: {
          line: 103,
          column: 12
        },
        end: {
          line: 103,
          column: 30
        }
      },
      "46": {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 107,
          column: 13
        }
      },
      "47": {
        start: {
          line: 106,
          column: 16
        },
        end: {
          line: 106,
          column: 23
        }
      },
      "48": {
        start: {
          line: 109,
          column: 36
        },
        end: {
          line: 109,
          column: 73
        }
      },
      "49": {
        start: {
          line: 110,
          column: 30
        },
        end: {
          line: 110,
          column: 32
        }
      },
      "50": {
        start: {
          line: 111,
          column: 12
        },
        end: {
          line: 128,
          column: 15
        }
      },
      "51": {
        start: {
          line: 113,
          column: 27
        },
        end: {
          line: 113,
          column: 36
        }
      },
      "52": {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 121,
          column: 17
        }
      },
      "53": {
        start: {
          line: 117,
          column: 20
        },
        end: {
          line: 119,
          column: 21
        }
      },
      "54": {
        start: {
          line: 118,
          column: 24
        },
        end: {
          line: 118,
          column: 47
        }
      },
      "55": {
        start: {
          line: 120,
          column: 20
        },
        end: {
          line: 120,
          column: 27
        }
      },
      "56": {
        start: {
          line: 123,
          column: 16
        },
        end: {
          line: 126,
          column: 17
        }
      },
      "57": {
        start: {
          line: 125,
          column: 20
        },
        end: {
          line: 125,
          column: 27
        }
      },
      "58": {
        start: {
          line: 127,
          column: 16
        },
        end: {
          line: 127,
          column: 39
        }
      },
      "59": {
        start: {
          line: 130,
          column: 23
        },
        end: {
          line: 130,
          column: 53
        }
      },
      "60": {
        start: {
          line: 131,
          column: 12
        },
        end: {
          line: 131,
          column: 33
        }
      },
      "61": {
        start: {
          line: 134,
          column: 12
        },
        end: {
          line: 134,
          column: 29
        }
      },
      "62": {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 136,
          column: 23
        }
      },
      "63": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 136,
          column: 23
        }
      },
      "64": {
        start: {
          line: 138,
          column: 12
        },
        end: {
          line: 140,
          column: 13
        }
      },
      "65": {
        start: {
          line: 139,
          column: 16
        },
        end: {
          line: 139,
          column: 23
        }
      },
      "66": {
        start: {
          line: 141,
          column: 12
        },
        end: {
          line: 141,
          column: 32
        }
      },
      "67": {
        start: {
          line: 145,
          column: 12
        },
        end: {
          line: 147,
          column: 13
        }
      },
      "68": {
        start: {
          line: 146,
          column: 16
        },
        end: {
          line: 146,
          column: 23
        }
      },
      "69": {
        start: {
          line: 149,
          column: 23
        },
        end: {
          line: 149,
          column: 38
        }
      },
      "70": {
        start: {
          line: 150,
          column: 12
        },
        end: {
          line: 150,
          column: 33
        }
      },
      "71": {
        start: {
          line: 152,
          column: 12
        },
        end: {
          line: 152,
          column: 25
        }
      },
      "72": {
        start: {
          line: 158,
          column: 17
        },
        end: {
          line: 158,
          column: 35
        }
      },
      "73": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 37
        }
      },
      "74": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "75": {
        start: {
          line: 163,
          column: 0
        },
        end: {
          line: 163,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "filterEmptySpan",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 24
          }
        },
        loc: {
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 39
          },
          end: {
            line: 19,
            column: 40
          }
        },
        loc: {
          start: {
            line: 19,
            column: 52
          },
          end: {
            line: 25,
            column: 5
          }
        },
        line: 19
      },
      "3": {
        name: "isIgnoreTag",
        decl: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 20
          }
        },
        loc: {
          start: {
            line: 32,
            column: 37
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 32
      },
      "4": {
        name: "genStartHtml",
        decl: {
          start: {
            line: 51,
            column: 9
          },
          end: {
            line: 51,
            column: 21
          }
        },
        loc: {
          start: {
            line: 51,
            column: 34
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 51
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 57,
            column: 18
          },
          end: {
            line: 57,
            column: 19
          }
        },
        loc: {
          start: {
            line: 57,
            column: 34
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 57
      },
      "6": {
        name: "genEndHtml",
        decl: {
          start: {
            line: 72,
            column: 9
          },
          end: {
            line: 72,
            column: 19
          }
        },
        loc: {
          start: {
            line: 72,
            column: 25
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 72
      },
      "7": {
        name: "parseHtml",
        decl: {
          start: {
            line: 81,
            column: 9
          },
          end: {
            line: 81,
            column: 18
          }
        },
        loc: {
          start: {
            line: 81,
            column: 49
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 81
      },
      "8": {
        name: "markTagStart",
        decl: {
          start: {
            line: 87,
            column: 13
          },
          end: {
            line: 87,
            column: 25
          }
        },
        loc: {
          start: {
            line: 87,
            column: 31
          },
          end: {
            line: 94,
            column: 5
          }
        },
        line: 87
      },
      "9": {
        name: "markTagEnd",
        decl: {
          start: {
            line: 95,
            column: 13
          },
          end: {
            line: 95,
            column: 23
          }
        },
        loc: {
          start: {
            line: 95,
            column: 26
          },
          end: {
            line: 97,
            column: 5
          }
        },
        line: 95
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 101,
            column: 22
          },
          end: {
            line: 101,
            column: 23
          }
        },
        loc: {
          start: {
            line: 101,
            column: 44
          },
          end: {
            line: 132,
            column: 9
          }
        },
        line: 101
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 111,
            column: 26
          },
          end: {
            line: 111,
            column: 27
          }
        },
        loc: {
          start: {
            line: 111,
            column: 42
          },
          end: {
            line: 128,
            column: 13
          }
        },
        line: 111
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 133,
            column: 20
          },
          end: {
            line: 133,
            column: 21
          }
        },
        loc: {
          start: {
            line: 133,
            column: 35
          },
          end: {
            line: 142,
            column: 9
          }
        },
        line: 133
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 143,
            column: 20
          },
          end: {
            line: 143,
            column: 21
          }
        },
        loc: {
          start: {
            line: 143,
            column: 35
          },
          end: {
            line: 153,
            column: 9
          }
        },
        line: 143
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 154,
            column: 17
          },
          end: {
            line: 154,
            column: 18
          }
        },
        loc: {
          start: {
            line: 154,
            column: 32
          },
          end: {
            line: 156,
            column: 9
          }
        },
        line: 154
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 23,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 23,
            column: 22
          }
        }, {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 23,
            column: 22
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 35
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 39
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 65,
            column: 23
          },
          end: {
            line: 65,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 33
          },
          end: {
            line: 65,
            column: 36
          }
        }, {
          start: {
            line: 65,
            column: 39
          },
          end: {
            line: 65,
            column: 41
          }
        }],
        line: 65
      },
      "9": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 55
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 82,
            column: 55
          }
        }],
        line: 82
      },
      "10": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 52
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 83,
            column: 52
          }
        }],
        line: 83
      },
      "11": {
        loc: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 90,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 90,
            column: 19
          }
        }, {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 90,
            column: 19
          }
        }],
        line: 89
      },
      "12": {
        loc: {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        }, {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        }],
        line: 91
      },
      "13": {
        loc: {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 107,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 107,
            column: 13
          }
        }, {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 107,
            column: 13
          }
        }],
        line: 105
      },
      "14": {
        loc: {
          start: {
            line: 109,
            column: 36
          },
          end: {
            line: 109,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 109,
            column: 36
          },
          end: {
            line: 109,
            column: 67
          }
        }, {
          start: {
            line: 109,
            column: 71
          },
          end: {
            line: 109,
            column: 73
          }
        }],
        line: 109
      },
      "15": {
        loc: {
          start: {
            line: 115,
            column: 16
          },
          end: {
            line: 121,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 16
          },
          end: {
            line: 121,
            column: 17
          }
        }, {
          start: {
            line: 115,
            column: 16
          },
          end: {
            line: 121,
            column: 17
          }
        }],
        line: 115
      },
      "16": {
        loc: {
          start: {
            line: 117,
            column: 20
          },
          end: {
            line: 119,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 20
          },
          end: {
            line: 119,
            column: 21
          }
        }, {
          start: {
            line: 117,
            column: 20
          },
          end: {
            line: 119,
            column: 21
          }
        }],
        line: 117
      },
      "17": {
        loc: {
          start: {
            line: 123,
            column: 16
          },
          end: {
            line: 126,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 16
          },
          end: {
            line: 126,
            column: 17
          }
        }, {
          start: {
            line: 123,
            column: 16
          },
          end: {
            line: 126,
            column: 17
          }
        }],
        line: 123
      },
      "18": {
        loc: {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 136,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 136,
            column: 23
          }
        }, {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 136,
            column: 23
          }
        }],
        line: 135
      },
      "19": {
        loc: {
          start: {
            line: 138,
            column: 12
          },
          end: {
            line: 140,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 12
          },
          end: {
            line: 140,
            column: 13
          }
        }, {
          start: {
            line: 138,
            column: 12
          },
          end: {
            line: 140,
            column: 13
          }
        }],
        line: 138
      },
      "20": {
        loc: {
          start: {
            line: 145,
            column: 12
          },
          end: {
            line: 147,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 12
          },
          end: {
            line: 147,
            column: 13
          }
        }, {
          start: {
            line: 145,
            column: 12
          },
          end: {
            line: 147,
            column: 13
          }
        }],
        line: 145
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/paste/parse-html.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/paste/parse-html.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,+BAAiE;AACjE,sFAAsD;AAOtD;;;GAGG;AACH,SAAS,eAAe,CAAC,IAAY;IACjC,IAAM,aAAa,GAAG,qBAAqB,CAAA;IAC3C,IAAM,WAAW,GAAG,qBAAqB,CAAA;IACzC,OAAO,IAAI,CAAC,OAAO,CAAC,aAAa,EAAE,UAAC,CAAS;QACzC,gCAAgC;QAChC,IAAM,MAAM,GAAG,CAAC,CAAC,KAAK,CAAC,WAAW,CAAC,CAAA;QACnC,IAAI,MAAM,IAAI,IAAI;YAAE,OAAO,EAAE,CAAA;QAC7B,OAAO,MAAM,CAAC,CAAC,CAAC,CAAA;IACpB,CAAC,CAAC,CAAA;AACN,CAAC;AAED;;;;GAIG;AACH,SAAS,WAAW,CAAC,GAAW,EAAE,SAAkB;IAChD,GAAG,GAAG,GAAG,CAAC,WAAW,EAAE,CAAC,IAAI,EAAE,CAAA;IAE9B,QAAQ;IACR,IAAI,kBAAW,CAAC,GAAG,CAAC,GAAG,CAAC,EAAE;QACtB,OAAO,IAAI,CAAA;KACd;IAED,SAAS;IACT,IAAI,SAAS,EAAE;QACX,IAAI,GAAG,KAAK,KAAK,EAAE;YACf,OAAO,IAAI,CAAA;SACd;KACJ;IAED,OAAO,KAAK,CAAA;AAChB,CAAC;AAED;;;;GAIG;AACH,SAAS,YAAY,CAAC,GAAW,EAAE,KAAiB;IAChD,IAAI,MAAM,GAAG,EAAE,CAAA;IAEf,WAAW;IACX,MAAM,GAAG,MAAI,GAAK,CAAA;IAElB,OAAO;IACP,IAAI,UAAU,GAAa,EAAE,CAAA;IAC7B,KAAK,CAAC,OAAO,CAAC,UAAC,IAAc;QACzB,UAAU,CAAC,IAAI,CAAI,IAAI,CAAC,IAAI,WAAK,IAAI,CAAC,KAAK,OAAG,CAAC,CAAA;IACnD,CAAC,CAAC,CAAA;IACF,IAAI,UAAU,CAAC,MAAM,GAAG,CAAC,EAAE;QACvB,MAAM,GAAG,MAAM,GAAG,GAAG,GAAG,UAAU,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;KAC/C;IAED,WAAW;IACX,IAAM,OAAO,GAAG,iBAAU,CAAC,GAAG,CAAC,GAAG,CAAC,CAAA,CAAC,oBAAoB;IACxD,MAAM,GAAG,MAAM,GAAG,CAAC,OAAO,CAAC,CAAC,CAAC,GAAG,CAAC,CAAC,CAAC,EAAE,CAAC,GAAG,GAAG,CAAA;IAE5C,OAAO,MAAM,CAAA;AACjB,CAAC;AAED;;;GAGG;AACH,SAAS,UAAU,CAAC,GAAW;IAC3B,OAAO,OAAK,GAAG,MAAG,CAAA;AACtB,CAAC;AAED;;;;;GAKG;AACH,SAAS,SAAS,CAAC,IAAY,EAAE,WAA2B,EAAE,SAA0B;IAAvD,4BAAA,EAAA,kBAA2B;IAAE,0BAAA,EAAA,iBAA0B;IACpF,IAAI,SAAS,GAAa,EAAE,CAAA,CAAC,qBAAqB;IAElD,uBAAuB;IACvB,IAAI,OAAO,GAAG,EAAE,CAAA;IAChB,SAAS,YAAY,CAAC,GAAW;QAC7B,GAAG,GAAG,GAAG,CAAC,IAAI,EAAE,CAAA;QAChB,IAAI,CAAC,GAAG;YAAE,OAAM;QAChB,IAAI,iBAAU,CAAC,GAAG,CAAC,GAAG,CAAC;YAAE,OAAM,CAAC,sBAAsB;QACtD,OAAO,GAAG,GAAG,CAAA;IACjB,CAAC;IACD,SAAS,UAAU;QACf,OAAO,GAAG,EAAE,CAAA;IAChB,CAAC;IAED,4BAA4B;IAC5B,IAAM,UAAU,GAAG,IAAI,6BAAU,EAAE,CAAA;IACnC,UAAU,CAAC,KAAK,CAAC,IAAI,EAAE;QACnB,YAAY,EAAZ,UAAa,GAAW,EAAE,KAAS;YAC/B,UAAU;YACV,YAAY,CAAC,GAAG,CAAC,CAAA;YAEjB,QAAQ;YACR,IAAI,WAAW,CAAC,GAAG,EAAE,SAAS,CAAC,EAAE;gBAC7B,OAAM;aACT;YAED,sBAAsB;YACtB,IAAM,iBAAiB,GAAG,sBAAe,CAAC,GAAG,CAAC,GAAG,CAAC,IAAI,EAAE,CAAA;YACxD,IAAM,WAAW,GAAe,EAAE,CAAA;YAClC,KAAK,CAAC,OAAO,CAAC,UAAC,IAAc;gBACzB,MAAM;gBACN,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;gBAEtB,aAAa;gBACb,IAAI,IAAI,KAAK,OAAO,EAAE;oBAClB,cAAc;oBACd,IAAI,CAAC,WAAW,EAAE;wBACd,WAAW,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;qBACzB;oBACD,OAAM;iBACT;gBAED,mBAAmB;gBACnB,IAAI,iBAAiB,CAAC,QAAQ,CAAC,IAAI,CAAC,KAAK,KAAK,EAAE;oBAC5C,aAAa;oBACb,OAAM;iBACT;gBACD,WAAW,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YAC1B,CAAC,CAAC,CAAA;YAEF,cAAc;YACd,IAAM,IAAI,GAAG,YAAY,CAAC,GAAG,EAAE,WAAW,CAAC,CAAA;YAC3C,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QACxB,CAAC;QACD,UAAU,EAAV,UAAW,GAAW;YAClB,GAAG,GAAG,GAAG,CAAC,IAAI,EAAE,CAAA;YAChB,IAAI,CAAC,GAAG;gBAAE,OAAM;YAEhB,QAAQ;YACR,IAAI,WAAW,CAAC,OAAO,EAAE,SAAS,CAAC,EAAE;gBACjC,OAAM;aACT;YAED,SAAS,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;QACvB,CAAC;QACD,UAAU,EAAV,UAAW,GAAW;YAClB,QAAQ;YACR,IAAI,WAAW,CAAC,GAAG,EAAE,SAAS,CAAC,EAAE;gBAC7B,OAAM;aACT;YAED,cAAc;YACd,IAAM,IAAI,GAAG,UAAU,CAAC,GAAG,CAAC,CAAA;YAC5B,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YAEpB,UAAU;YACV,UAAU,EAAE,CAAA;QAChB,CAAC;QACD,OAAO,EAAP,UAAQ,GAAW;YACf,aAAa;QACjB,CAAC;KACJ,CAAC,CAAA;IAEF,IAAI,MAAM,GAAG,SAAS,CAAC,IAAI,CAAC,EAAE,CAAC,CAAA,CAAC,SAAS;IAEzC,eAAe;IACf,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;IAEhC,OAAO,MAAM,CAAA;AACjB,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u5C06\u7C98\u8D34\u7684 html \u5B57\u7B26\u4E32\uFF0C\u8F6C\u6362\u4E3A\u6B63\u786E\u3001\u7B80\u6D01\u7684 html \u4EE3\u7801\u3002\u5254\u9664\u4E0D\u5FC5\u8981\u7684\u6807\u7B7E\u548C\u5C5E\u6027\u3002\n * @author wangfupeng\n */\n\nimport { EMPTY_TAGS, IGNORE_TAGS, NECESSARY_ATTRS } from './tags'\nimport HtmlParser from '../../lib/simplehtmlparser.js'\n\ntype AttrType = {\n    name: string\n    value: string\n}\n\n/**\n * \u8FC7\u6EE4\u6389\u7A7A span\n * @param html html\n */\nfunction filterEmptySpan(html: string): string {\n    const regForReplace = /<span>.*?<\\/span>/gi\n    const regForMatch = /<span>(.*?)<\\/span>/\n    return html.replace(regForReplace, (s: string): string => {\n        // s \u662F\u5355\u4E2A span \uFF0C\u5982 <span>\u6587\u5B57</span>\n        const result = s.match(regForMatch)\n        if (result == null) return ''\n        return result[1]\n    })\n}\n\n/**\n * \u662F\u5426\u5FFD\u7565\u6807\u7B7E\n * @param tag tag\n * @param ignoreImg \u662F\u5426\u5FFD\u7565 img \u6807\u7B7E\n */\nfunction isIgnoreTag(tag: string, ignoreImg: boolean): boolean {\n    tag = tag.toLowerCase().trim()\n\n    // \u5FFD\u7565\u7684\u6807\u7B7E\n    if (IGNORE_TAGS.has(tag)) {\n        return true\n    }\n\n    // \u662F\u5426\u5FFD\u7565\u56FE\u7247\n    if (ignoreImg) {\n        if (tag === 'img') {\n            return true\n        }\n    }\n\n    return false\n}\n\n/**\n * \u4E3A tag \u751F\u6210 html \u5B57\u7B26\u4E32\uFF0C\u5F00\u59CB\u90E8\u5206\n * @param tag tag\n * @param attrs \u5C5E\u6027\n */\nfunction genStartHtml(tag: string, attrs: AttrType[]): string {\n    let result = ''\n\n    // tag < \u7B26\u53F7\n    result = `<${tag}`\n\n    // \u62FC\u63A5\u5C5E\u6027\n    let attrStrArr: string[] = []\n    attrs.forEach((attr: AttrType) => {\n        attrStrArr.push(`${attr.name}=\"${attr.value}\"`)\n    })\n    if (attrStrArr.length > 0) {\n        result = result + ' ' + attrStrArr.join(' ')\n    }\n\n    // tag > \u7B26\u53F7\n    const isEmpty = EMPTY_TAGS.has(tag) // \u6CA1\u6709\u5B50\u8282\u70B9\u6216\u6587\u672C\u7684\u6807\u7B7E\uFF0C\u5982 img\n    result = result + (isEmpty ? '/' : '') + '>'\n\n    return result\n}\n\n/**\n * \u4E3A tag \u751F\u6210 html \u5B57\u7B26\u4E32\uFF0C\u7ED3\u5C3E\u90E8\u5206\n * @param tag tag\n */\nfunction genEndHtml(tag: string) {\n    return `</${tag}>`\n}\n\n/**\n * \u5904\u7406\u7C98\u8D34\u7684 html\n * @param html html \u5B57\u7B26\u4E32\n * @param filterStyle \u662F\u5426\u8FC7\u6EE4 style \u6837\u5F0F\n * @param ignoreImg \u662F\u5426\u5FFD\u7565 img \u6807\u7B7E\n */\nfunction parseHtml(html: string, filterStyle: boolean = true, ignoreImg: boolean = false): string {\n    let resultArr: string[] = [] // \u5B58\u50A8\u7ED3\u679C\uFF0C\u6570\u7EC4\u5F62\u5F0F\uFF0C\u6700\u540E\u518D join\n\n    // \u5F53\u524D\u6B63\u5728\u5904\u7406\u7684\u6807\u7B7E\uFF0C\u4EE5\u53CA\u8BB0\u5F55\u548C\u6E05\u9664\u7684\u65B9\u6CD5\n    let CUR_TAG = ''\n    function markTagStart(tag: string): void {\n        tag = tag.trim()\n        if (!tag) return\n        if (EMPTY_TAGS.has(tag)) return // \u5185\u5BB9\u4E3A\u7A7A\u7684\u6807\u7B7E\uFF0C\u5982 img \uFF0C\u4E0D\u7528\u8BB0\u5F55\n        CUR_TAG = tag\n    }\n    function markTagEnd(): void {\n        CUR_TAG = ''\n    }\n\n    // \u80FD\u901A\u8FC7 'text/html' \u683C\u5F0F\u83B7\u53D6 html\n    const htmlParser = new HtmlParser()\n    htmlParser.parse(html, {\n        startElement(tag: string, attrs: []) {\n            // \u9996\u5148\uFF0C\u6807\u8BB0\u5F00\u59CB\n            markTagStart(tag)\n\n            // \u5FFD\u7565\u7684\u6807\u7B7E\n            if (isIgnoreTag(tag, ignoreImg)) {\n                return\n            }\n\n            // \u627E\u51FA\u8BE5\u6807\u7B7E\u5FC5\u987B\u7684\u5C5E\u6027\uFF08\u5176\u4ED6\u7684\u5C5E\u6027\u5FFD\u7565\uFF09\n            const necessaryAttrKeys = NECESSARY_ATTRS.get(tag) || []\n            const attrsForTag: AttrType[] = []\n            attrs.forEach((attr: AttrType) => {\n                // \u5C5E\u6027\u540D\n                const name = attr.name\n\n                // style \u5355\u72EC\u5904\u7406\n                if (name === 'style') {\n                    // \u4FDD\u7559 style \u6837\u5F0F\n                    if (!filterStyle) {\n                        attrsForTag.push(attr)\n                    }\n                    return\n                }\n\n                // \u9664\u4E86 style \u4E4B\u5916\u7684\u5176\u4ED6\u5C5E\u6027\n                if (necessaryAttrKeys.includes(name) === false) {\n                    // \u4E0D\u662F\u5FC5\u987B\u7684\u5C5E\u6027\uFF0C\u5FFD\u7565\n                    return\n                }\n                attrsForTag.push(attr)\n            })\n\n            // \u62FC\u63A5\u4E3A HTML \u6807\u7B7E\n            const html = genStartHtml(tag, attrsForTag)\n            resultArr.push(html)\n        },\n        characters(str: string) {\n            str = str.trim()\n            if (!str) return\n\n            // \u5FFD\u7565\u7684\u6807\u7B7E\n            if (isIgnoreTag(CUR_TAG, ignoreImg)) {\n                return\n            }\n\n            resultArr.push(str)\n        },\n        endElement(tag: string) {\n            // \u5FFD\u7565\u7684\u6807\u7B7E\n            if (isIgnoreTag(tag, ignoreImg)) {\n                return\n            }\n\n            // \u62FC\u63A5\u4E3A HTML \u6807\u7B7E\n            const html = genEndHtml(tag)\n            resultArr.push(html)\n\n            // \u6700\u540E\uFF0C\u6807\u8BB0\u7ED3\u675F\n            markTagEnd()\n        },\n        comment(str: string) {\n            /* \u6CE8\u91CA\uFF0C\u4E0D\u505A\u5904\u7406 */\n        },\n    })\n\n    let result = resultArr.join('') // \u8F6C\u6362\u4E3A\u5B57\u7B26\u4E32\n\n    // \u8FC7\u6EE4\u6389\u7A7A span \u6807\u7B7E\n    result = filterEmptySpan(result)\n\n    return result\n}\n\nexport default parseHtml\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1b3527790e6fdabef63887c92580861fbcaa4f17"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1z3m5ioo4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1z3m5ioo4();

var __importDefault = (cov_1z3m5ioo4().s[0]++, (cov_1z3m5ioo4().b[0][0]++, void 0) && (cov_1z3m5ioo4().b[0][1]++, (void 0).__importDefault) || (cov_1z3m5ioo4().b[0][2]++, function (mod) {
  cov_1z3m5ioo4().f[0]++;
  cov_1z3m5ioo4().s[1]++;
  return (cov_1z3m5ioo4().b[2][0]++, mod) && (cov_1z3m5ioo4().b[2][1]++, mod.__esModule) ? (cov_1z3m5ioo4().b[1][0]++, mod) : (cov_1z3m5ioo4().b[1][1]++, {
    "default": mod
  });
}));

cov_1z3m5ioo4().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var tags_1 = (cov_1z3m5ioo4().s[3]++, __webpack_require__(291));
var simplehtmlparser_js_1 = (cov_1z3m5ioo4().s[4]++, __importDefault(__webpack_require__(295)));
/**
 * 过滤掉空 span
 * @param html html
 */

function filterEmptySpan(html) {
  cov_1z3m5ioo4().f[1]++;
  var regForReplace = (cov_1z3m5ioo4().s[5]++, /<span>.*?<\/span>/gi);
  var regForMatch = (cov_1z3m5ioo4().s[6]++, /<span>(.*?)<\/span>/);
  cov_1z3m5ioo4().s[7]++;
  return html.replace(regForReplace, function (s) {
    cov_1z3m5ioo4().f[2]++;
    // s 是单个 span ，如 <span>文字</span>
    var result = (cov_1z3m5ioo4().s[8]++, s.match(regForMatch));
    cov_1z3m5ioo4().s[9]++;

    if (result == null) {
      cov_1z3m5ioo4().b[3][0]++;
      cov_1z3m5ioo4().s[10]++;
      return '';
    } else {
      cov_1z3m5ioo4().b[3][1]++;
    }

    cov_1z3m5ioo4().s[11]++;
    return result[1];
  });
}
/**
 * 是否忽略标签
 * @param tag tag
 * @param ignoreImg 是否忽略 img 标签
 */


function isIgnoreTag(tag, ignoreImg) {
  var _context;

  cov_1z3m5ioo4().f[3]++;
  cov_1z3m5ioo4().s[12]++;
  tag = (0, _trim["default"])(_context = tag.toLowerCase()).call(_context); // 忽略的标签

  cov_1z3m5ioo4().s[13]++;

  if (tags_1.IGNORE_TAGS.has(tag)) {
    cov_1z3m5ioo4().b[4][0]++;
    cov_1z3m5ioo4().s[14]++;
    return true;
  } else {
    cov_1z3m5ioo4().b[4][1]++;
  } // 是否忽略图片


  cov_1z3m5ioo4().s[15]++;

  if (ignoreImg) {
    cov_1z3m5ioo4().b[5][0]++;
    cov_1z3m5ioo4().s[16]++;

    if (tag === 'img') {
      cov_1z3m5ioo4().b[6][0]++;
      cov_1z3m5ioo4().s[17]++;
      return true;
    } else {
      cov_1z3m5ioo4().b[6][1]++;
    }
  } else {
    cov_1z3m5ioo4().b[5][1]++;
  }

  cov_1z3m5ioo4().s[18]++;
  return false;
}
/**
 * 为 tag 生成 html 字符串，开始部分
 * @param tag tag
 * @param attrs 属性
 */


function genStartHtml(tag, attrs) {
  cov_1z3m5ioo4().f[4]++;
  var result = (cov_1z3m5ioo4().s[19]++, ''); // tag < 符号

  cov_1z3m5ioo4().s[20]++;
  result = "<" + tag; // 拼接属性

  var attrStrArr = (cov_1z3m5ioo4().s[21]++, []);
  cov_1z3m5ioo4().s[22]++;
  (0, _forEach["default"])(attrs).call(attrs, function (attr) {
    cov_1z3m5ioo4().f[5]++;
    cov_1z3m5ioo4().s[23]++;
    attrStrArr.push(attr.name + "=\"" + attr.value + "\"");
  });
  cov_1z3m5ioo4().s[24]++;

  if (attrStrArr.length > 0) {
    cov_1z3m5ioo4().b[7][0]++;
    cov_1z3m5ioo4().s[25]++;
    result = result + ' ' + attrStrArr.join(' ');
  } else {
    cov_1z3m5ioo4().b[7][1]++;
  } // tag > 符号


  var isEmpty = (cov_1z3m5ioo4().s[26]++, tags_1.EMPTY_TAGS.has(tag)); // 没有子节点或文本的标签，如 img

  cov_1z3m5ioo4().s[27]++;
  result = result + (isEmpty ? (cov_1z3m5ioo4().b[8][0]++, '/') : (cov_1z3m5ioo4().b[8][1]++, '')) + '>';
  cov_1z3m5ioo4().s[28]++;
  return result;
}
/**
 * 为 tag 生成 html 字符串，结尾部分
 * @param tag tag
 */


function genEndHtml(tag) {
  cov_1z3m5ioo4().f[6]++;
  cov_1z3m5ioo4().s[29]++;
  return "</" + tag + ">";
}
/**
 * 处理粘贴的 html
 * @param html html 字符串
 * @param filterStyle 是否过滤 style 样式
 * @param ignoreImg 是否忽略 img 标签
 */


function parseHtml(html, filterStyle, ignoreImg) {
  cov_1z3m5ioo4().f[7]++;
  cov_1z3m5ioo4().s[30]++;

  if (filterStyle === void 0) {
    cov_1z3m5ioo4().b[9][0]++;
    cov_1z3m5ioo4().s[31]++;
    filterStyle = true;
  } else {
    cov_1z3m5ioo4().b[9][1]++;
  }

  cov_1z3m5ioo4().s[32]++;

  if (ignoreImg === void 0) {
    cov_1z3m5ioo4().b[10][0]++;
    cov_1z3m5ioo4().s[33]++;
    ignoreImg = false;
  } else {
    cov_1z3m5ioo4().b[10][1]++;
  }

  var resultArr = (cov_1z3m5ioo4().s[34]++, []); // 存储结果，数组形式，最后再 join
  // 当前正在处理的标签，以及记录和清除的方法

  var CUR_TAG = (cov_1z3m5ioo4().s[35]++, '');

  function markTagStart(tag) {
    cov_1z3m5ioo4().f[8]++;
    cov_1z3m5ioo4().s[36]++;
    tag = (0, _trim["default"])(tag).call(tag);
    cov_1z3m5ioo4().s[37]++;

    if (!tag) {
      cov_1z3m5ioo4().b[11][0]++;
      cov_1z3m5ioo4().s[38]++;
      return;
    } else {
      cov_1z3m5ioo4().b[11][1]++;
    }

    cov_1z3m5ioo4().s[39]++;

    if (tags_1.EMPTY_TAGS.has(tag)) {
      cov_1z3m5ioo4().b[12][0]++;
      cov_1z3m5ioo4().s[40]++;
      return;
    } else {
      cov_1z3m5ioo4().b[12][1]++;
    } // 内容为空的标签，如 img ，不用记录


    cov_1z3m5ioo4().s[41]++;
    CUR_TAG = tag;
  }

  function markTagEnd() {
    cov_1z3m5ioo4().f[9]++;
    cov_1z3m5ioo4().s[42]++;
    CUR_TAG = '';
  } // 能通过 'text/html' 格式获取 html


  var htmlParser = (cov_1z3m5ioo4().s[43]++, new simplehtmlparser_js_1["default"]());
  cov_1z3m5ioo4().s[44]++;
  htmlParser.parse(html, {
    startElement: function startElement(tag, attrs) {
      cov_1z3m5ioo4().f[10]++;
      cov_1z3m5ioo4().s[45]++;
      // 首先，标记开始
      markTagStart(tag); // 忽略的标签

      cov_1z3m5ioo4().s[46]++;

      if (isIgnoreTag(tag, ignoreImg)) {
        cov_1z3m5ioo4().b[13][0]++;
        cov_1z3m5ioo4().s[47]++;
        return;
      } else {
        cov_1z3m5ioo4().b[13][1]++;
      } // 找出该标签必须的属性（其他的属性忽略）


      var necessaryAttrKeys = (cov_1z3m5ioo4().s[48]++, (cov_1z3m5ioo4().b[14][0]++, tags_1.NECESSARY_ATTRS.get(tag)) || (cov_1z3m5ioo4().b[14][1]++, []));
      var attrsForTag = (cov_1z3m5ioo4().s[49]++, []);
      cov_1z3m5ioo4().s[50]++;
      (0, _forEach["default"])(attrs).call(attrs, function (attr) {
        cov_1z3m5ioo4().f[11]++;
        // 属性名
        var name = (cov_1z3m5ioo4().s[51]++, attr.name); // style 单独处理

        cov_1z3m5ioo4().s[52]++;

        if (name === 'style') {
          cov_1z3m5ioo4().b[15][0]++;
          cov_1z3m5ioo4().s[53]++;

          // 保留 style 样式
          if (!filterStyle) {
            cov_1z3m5ioo4().b[16][0]++;
            cov_1z3m5ioo4().s[54]++;
            attrsForTag.push(attr);
          } else {
            cov_1z3m5ioo4().b[16][1]++;
          }

          cov_1z3m5ioo4().s[55]++;
          return;
        } else {
          cov_1z3m5ioo4().b[15][1]++;
        } // 除了 style 之外的其他属性


        cov_1z3m5ioo4().s[56]++;

        if ((0, _includes["default"])(necessaryAttrKeys).call(necessaryAttrKeys, name) === false) {
          cov_1z3m5ioo4().b[17][0]++;
          cov_1z3m5ioo4().s[57]++;
          // 不是必须的属性，忽略
          return;
        } else {
          cov_1z3m5ioo4().b[17][1]++;
        }

        cov_1z3m5ioo4().s[58]++;
        attrsForTag.push(attr);
      }); // 拼接为 HTML 标签

      var html = (cov_1z3m5ioo4().s[59]++, genStartHtml(tag, attrsForTag));
      cov_1z3m5ioo4().s[60]++;
      resultArr.push(html);
    },
    characters: function characters(str) {
      cov_1z3m5ioo4().f[12]++;
      cov_1z3m5ioo4().s[61]++;
      str = (0, _trim["default"])(str).call(str);
      cov_1z3m5ioo4().s[62]++;

      if (!str) {
        cov_1z3m5ioo4().b[18][0]++;
        cov_1z3m5ioo4().s[63]++;
        return;
      } else {
        cov_1z3m5ioo4().b[18][1]++;
      } // 忽略的标签


      cov_1z3m5ioo4().s[64]++;

      if (isIgnoreTag(CUR_TAG, ignoreImg)) {
        cov_1z3m5ioo4().b[19][0]++;
        cov_1z3m5ioo4().s[65]++;
        return;
      } else {
        cov_1z3m5ioo4().b[19][1]++;
      }

      cov_1z3m5ioo4().s[66]++;
      resultArr.push(str);
    },
    endElement: function endElement(tag) {
      cov_1z3m5ioo4().f[13]++;
      cov_1z3m5ioo4().s[67]++;

      // 忽略的标签
      if (isIgnoreTag(tag, ignoreImg)) {
        cov_1z3m5ioo4().b[20][0]++;
        cov_1z3m5ioo4().s[68]++;
        return;
      } else {
        cov_1z3m5ioo4().b[20][1]++;
      } // 拼接为 HTML 标签


      var html = (cov_1z3m5ioo4().s[69]++, genEndHtml(tag));
      cov_1z3m5ioo4().s[70]++;
      resultArr.push(html); // 最后，标记结束

      cov_1z3m5ioo4().s[71]++;
      markTagEnd();
    },
    comment: function comment(str) {
      /* 注释，不做处理 */

      cov_1z3m5ioo4().f[14]++;
    }
  });
  var result = (cov_1z3m5ioo4().s[72]++, resultArr.join('')); // 转换为字符串
  // 过滤掉空 span 标签

  cov_1z3m5ioo4().s[73]++;
  result = filterEmptySpan(result);
  cov_1z3m5ioo4().s[74]++;
  return result;
}

cov_1z3m5ioo4().s[75]++;
exports["default"] = parseHtml;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 粘贴相关的 tags
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _map = _interopRequireDefault(__webpack_require__(112));

var _set = _interopRequireDefault(__webpack_require__(123));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1cnp0g7slc() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/paste/tags.ts";
  var hash = "124ff240311ae5f9d4f4f4b0f38732fb987f5e18";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/paste/tags.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 101
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "3": {
        start: {
          line: 26,
          column: 0
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "4": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "5": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 60,
          column: 3
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/paste/tags.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/paste/tags.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;AAEH,QAAQ;AACK,QAAA,WAAW,GAAG,IAAI,GAAG,CAAC;IAC/B,SAAS;IACT,UAAU;IACV,MAAM;IACN,MAAM;IACN,MAAM;IACN,MAAM;IACN,QAAQ;IACR,OAAO;IACP,MAAM;IACN,OAAO;IACP,QAAQ;IACR,OAAO;IACP,KAAK;IACL,QAAQ;CACX,CAAC,CAAA;AAEF,YAAY;AACC,QAAA,eAAe,GAAG,IAAI,GAAG,CAAC;IACnC,CAAC,KAAK,EAAE,CAAC,KAAK,EAAE,KAAK,CAAC,CAAC;IACvB,CAAC,GAAG,EAAE,CAAC,MAAM,EAAE,QAAQ,CAAC,CAAC;IACzB,CAAC,IAAI,EAAE,CAAC,SAAS,EAAE,SAAS,CAAC,CAAC;IAC9B,CAAC,IAAI,EAAE,CAAC,SAAS,EAAE,SAAS,CAAC,CAAC;CACjC,CAAC,CAAA;AAEF,cAAc;AACD,QAAA,UAAU,GAAG,IAAI,GAAG,CAAC;IAC9B,MAAM;IACN,MAAM;IACN,UAAU;IACV,IAAI;IACJ,KAAK;IACL,IAAI;IACJ,KAAK;IACL,OAAO;IACP,SAAS;IACT,OAAO;CACV,CAAC,CAAA;AAEF,WAAW;AACE,QAAA,cAAc,GAAG,IAAI,GAAG,CAAC;IAClC,IAAI;IACJ,IAAI;IACJ,IAAI;IACJ,IAAI;IACJ,IAAI;IACJ,GAAG;IACH,IAAI;IACJ,IAAI;IACJ,OAAO;IACP,YAAY;IACZ,KAAK;IACL,IAAI;IACJ,MAAM;CACT,CAAC,CAAA",
      sourcesContent: ["/**\n * @description \u7C98\u8D34\u76F8\u5173\u7684 tags\n * @author wangfupeng\n */\n\n// \u5FFD\u7565\u7684\u6807\u7B7E\nexport const IGNORE_TAGS = new Set([\n    'doctype',\n    '!doctype',\n    'html',\n    'head',\n    'meta',\n    'body',\n    'script',\n    'style',\n    'link',\n    'frame',\n    'iframe',\n    'title',\n    'svg', // \u6682\u65F6\u5FFD\u7565\uFF0C\u6709\u9700\u8981\u518D\u4FEE\u6539\n    'center',\n])\n\n// \u6307\u5B9A\u6807\u7B7E\u5FC5\u8981\u7684\u5C5E\u6027\nexport const NECESSARY_ATTRS = new Map([\n    ['img', ['src', 'alt']],\n    ['a', ['href', 'target']],\n    ['td', ['colspan', 'rowspan']],\n    ['th', ['colspan', 'rowspan']],\n])\n\n// \u6CA1\u6709\u5B50\u8282\u70B9\u6216\u6587\u672C\u7684\u6807\u7B7E\nexport const EMPTY_TAGS = new Set([\n    'area',\n    'base',\n    'basefont',\n    'br',\n    'col',\n    'hr',\n    'img',\n    'input',\n    'isindex',\n    'embed',\n])\n\n// \u7F16\u8F91\u533A\u57DF\u9876\u7EA7\u8282\u70B9\nexport const TOP_LEVEL_TAGS = new Set([\n    'h1',\n    'h2',\n    'h3',\n    'h4',\n    'h5',\n    'p',\n    'ul',\n    'ol',\n    'table',\n    'blockquote', // \u5F15\u7528\n    'pre', // \u4EE3\u7801\n    'hr',\n    'form',\n])\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "124ff240311ae5f9d4f4f4b0f38732fb987f5e18"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cnp0g7slc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1cnp0g7slc();
cov_1cnp0g7slc().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_1cnp0g7slc().s[1]++;
exports.TOP_LEVEL_TAGS = exports.EMPTY_TAGS = exports.NECESSARY_ATTRS = exports.IGNORE_TAGS = void 0; // 忽略的标签

cov_1cnp0g7slc().s[2]++;
exports.IGNORE_TAGS = new _set["default"](['doctype', '!doctype', 'html', 'head', 'meta', 'body', 'script', 'style', 'link', 'frame', 'iframe', 'title', 'svg', 'center']); // 指定标签必要的属性

cov_1cnp0g7slc().s[3]++;
exports.NECESSARY_ATTRS = new _map["default"]([['img', ['src', 'alt']], ['a', ['href', 'target']], ['td', ['colspan', 'rowspan']], ['th', ['colspan', 'rowspan']]]); // 没有子节点或文本的标签

cov_1cnp0g7slc().s[4]++;
exports.EMPTY_TAGS = new _set["default"](['area', 'base', 'basefont', 'br', 'col', 'hr', 'img', 'input', 'isindex', 'embed']); // 编辑区域顶级节点

cov_1cnp0g7slc().s[5]++;
exports.TOP_LEVEL_TAGS = new _set["default"](['h1', 'h2', 'h3', 'h4', 'h5', 'p', 'ul', 'ol', 'table', 'blockquote', 'pre', 'hr', 'form']);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(293);

module.exports = parent;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294);
__webpack_require__(62);
__webpack_require__(64);
__webpack_require__(50);
var path = __webpack_require__(10);

module.exports = path.Set;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(113);
var collectionStrong = __webpack_require__(115);

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 295 */
/***/ (function(module, exports) {

// Copyright 2004 Erik Arvidsson. All Rights Reserved.
//
// This code is triple licensed using Apache Software License 2.0,
// Mozilla Public License or GNU Public License
//
///////////////////////////////////////////////////////////////////////////////
//
// Licensed under the Apache License, Version 2.0 (the "License"); you may not
// use this file except in compliance with the License.  You may obtain a copy
// of the License at http://www.apache.org/licenses/LICENSE-2.0
//
///////////////////////////////////////////////////////////////////////////////
//
// The contents of this file are subject to the Mozilla Public License
// Version 1.1 (the "License"); you may not use this file except in
// compliance with the License. You may obtain a copy of the License at
// http://www.mozilla.org/MPL/
//
// Software distributed under the License is distributed on an "AS IS"
// basis, WITHOUT WARRANTY OF ANY KIND, either express or implied. See the
// License for the specific language governing rights and limitations
// under the License.
//
// The Original Code is Simple HTML Parser.
//
// The Initial Developer of the Original Code is Erik Arvidsson.
// Portions created by Erik Arvidssson are Copyright (C) 2004. All Rights
// Reserved.
//
///////////////////////////////////////////////////////////////////////////////
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
///////////////////////////////////////////////////////////////////////////////

/*
var handler ={
	startElement:   function (sTagName, oAttrs) {},
	endElement:     function (sTagName) {},
    characters:		function (s) {},
    comment:		function (s) {}
};
*/

function SimpleHtmlParser() {}

SimpleHtmlParser.prototype = {
    handler: null,

    // regexps

    startTagRe: /^<([^>\s\/]+)((\s+[^=>\s]+(\s*=\s*((\"[^"]*\")|(\'[^']*\')|[^>\s]+))?)*)\s*\/?\s*>/m,
    endTagRe: /^<\/([^>\s]+)[^>]*>/m,
    attrRe: /([^=\s]+)(\s*=\s*((\"([^"]*)\")|(\'([^']*)\')|[^>\s]+))?/gm,

    parse: function (s, oHandler) {
        if (oHandler) this.contentHandler = oHandler

        var i = 0
        var res, lc, lm, rc, index
        var treatAsChars = false
        var oThis = this
        while (s.length > 0) {
            // Comment
            if (s.substring(0, 4) == '<!--') {
                index = s.indexOf('-->')
                if (index != -1) {
                    this.contentHandler.comment(s.substring(4, index))
                    s = s.substring(index + 3)
                    treatAsChars = false
                } else {
                    treatAsChars = true
                }
            }

            // end tag
            else if (s.substring(0, 2) == '</') {
                if (this.endTagRe.test(s)) {
                    lc = RegExp.leftContext
                    lm = RegExp.lastMatch
                    rc = RegExp.rightContext

                    lm.replace(this.endTagRe, function () {
                        return oThis.parseEndTag.apply(oThis, arguments)
                    })

                    s = rc
                    treatAsChars = false
                } else {
                    treatAsChars = true
                }
            }
            // start tag
            else if (s.charAt(0) == '<') {
                if (this.startTagRe.test(s)) {
                    lc = RegExp.leftContext
                    lm = RegExp.lastMatch
                    rc = RegExp.rightContext

                    lm.replace(this.startTagRe, function () {
                        return oThis.parseStartTag.apply(oThis, arguments)
                    })

                    s = rc
                    treatAsChars = false
                } else {
                    treatAsChars = true
                }
            }

            if (treatAsChars) {
                index = s.indexOf('<')
                if (index == -1) {
                    this.contentHandler.characters(s)
                    s = ''
                } else {
                    this.contentHandler.characters(s.substring(0, index))
                    s = s.substring(index)
                }
            }

            treatAsChars = true
        }
    },

    parseStartTag: function (sTag, sTagName, sRest) {
        var attrs = this.parseAttributes(sTagName, sRest)
        this.contentHandler.startElement(sTagName, attrs)
    },

    parseEndTag: function (sTag, sTagName) {
        this.contentHandler.endElement(sTagName)
    },

    parseAttributes: function (sTagName, s) {
        var oThis = this
        var attrs = []
        s.replace(this.attrRe, function (a0, a1, a2, a3, a4, a5, a6) {
            attrs.push(oThis.parseAttribute(sTagName, a0, a1, a2, a3, a4, a5, a6))
        })
        return attrs
    },

    parseAttribute: function (sTagName, sAttribute, sName) {
        var value = ''
        if (arguments[7]) value = arguments[8]
        else if (arguments[5]) value = arguments[6]
        else if (arguments[3]) value = arguments[4]

        var empty = !value && !arguments[3]
        return { name: sName, value: empty ? null : value }
    },
}

// export default SimpleHtmlParser
module.exports = SimpleHtmlParser


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 图片点击后选区更新到img的位置
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2b5ycigbtw() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/img-click-active.ts";
  var hash = "7af97bf3a519693e04fdf985a936c33f8d5df7e0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/img-click-active.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 49
        }
      },
      "2": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 44
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 33
        }
      },
      "4": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "imgClickActive",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 23
          }
        },
        loc: {
          start: {
            line: 12,
            column: 48
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "clickFn",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 20
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 13
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/img-click-active.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/event-hooks/img-click-active.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAKH;;;;GAIG;AACH,SAAS,cAAc,CAAC,MAAc,EAAE,cAA0B;IAC9D,SAAS,OAAO,CAAC,IAAgB;QAC7B,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,IAAI,CAAC,CAAA;QACxC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;IACvC,CAAC;IACD,cAAc,CAAC,IAAI,CAAC,OAAO,CAAC,CAAA;AAChC,CAAC;AAED,kBAAe,cAAc,CAAA",
      sourcesContent: ["/**\n * @description \u56FE\u7247\u70B9\u51FB\u540E\u9009\u533A\u66F4\u65B0\u5230img\u7684\u4F4D\u7F6E\n * @author tonghan\n */\n\nimport Editor from '../../editor/index'\nimport { DomElement } from '../../utils/dom-core'\n\n/**\n * \u56FE\u7247\u70B9\u51FB\u540E\u9009\u533A\u66F4\u65B0\u5230img\u7684\u4F4D\u7F6E\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param imgClickEvents delete \u952E up \u65F6\u7684 hooks\n */\nfunction imgClickActive(editor: Editor, imgClickEvents: Function[]) {\n    function clickFn($img: DomElement) {\n        editor.selection.createRangeByElem($img)\n        editor.selection.restoreSelection()\n    }\n    imgClickEvents.push(clickFn)\n}\n\nexport default imgClickActive\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7af97bf3a519693e04fdf985a936c33f8d5df7e0"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2b5ycigbtw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2b5ycigbtw();
cov_2b5ycigbtw().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * 图片点击后选区更新到img的位置
 * @param editor 编辑器实例
 * @param imgClickEvents delete 键 up 时的 hooks
 */

function imgClickActive(editor, imgClickEvents) {
  cov_2b5ycigbtw().f[0]++;

  function clickFn($img) {
    cov_2b5ycigbtw().f[1]++;
    cov_2b5ycigbtw().s[1]++;
    editor.selection.createRangeByElem($img);
    cov_2b5ycigbtw().s[2]++;
    editor.selection.restoreSelection();
  }

  cov_2b5ycigbtw().s[3]++;
  imgClickEvents.push(clickFn);
}

cov_2b5ycigbtw().s[4]++;
exports["default"] = imgClickActive;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 获取子元素的 JSON 格式数据
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_23y6fvyl27() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/getChildrenJSON.ts";
  var hash = "9d6535400c8e4fb0a223f286a52fd7d217e0a372";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/getChildrenJSON.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 37
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 62
        }
      },
      "5": {
        start: {
          line: 17,
          column: 17
        },
        end: {
          line: 17,
          column: 19
        }
      },
      "6": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 44
        }
      },
      "7": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 51,
          column: 7
        }
      },
      "8": {
        start: {
          line: 21,
          column: 23
        },
        end: {
          line: 21,
          column: 39
        }
      },
      "9": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 26,
          column: 9
        }
      },
      "10": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 51
        }
      },
      "11": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 62
        }
      },
      "12": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 47,
          column: 9
        }
      },
      "13": {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 29,
          column: 28
        }
      },
      "14": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 36
        }
      },
      "15": {
        start: {
          line: 32,
          column: 12
        },
        end: {
          line: 32,
          column: 60
        }
      },
      "16": {
        start: {
          line: 34,
          column: 27
        },
        end: {
          line: 34,
          column: 29
        }
      },
      "17": {
        start: {
          line: 35,
          column: 27
        },
        end: {
          line: 35,
          column: 51
        }
      },
      "18": {
        start: {
          line: 36,
          column: 33
        },
        end: {
          line: 36,
          column: 53
        }
      },
      "19": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 43,
          column: 13
        }
      },
      "20": {
        start: {
          line: 37,
          column: 25
        },
        end: {
          line: 37,
          column: 26
        }
      },
      "21": {
        start: {
          line: 38,
          column: 27
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "22": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 42,
          column: 19
        }
      },
      "23": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 40
        }
      },
      "24": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 79
        }
      },
      "25": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "26": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 36
        }
      },
      "27": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 18
        }
      },
      "28": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 54,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "getChildrenJSON",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 24
          }
        },
        loc: {
          start: {
            line: 16,
            column: 32
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 23
          }
        },
        loc: {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 38
          }
        }, {
          start: {
            line: 18,
            column: 42
          },
          end: {
            line: 18,
            column: 44
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 26,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 26,
            column: 9
          }
        }, {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 26,
            column: 9
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 25
          },
          end: {
            line: 24,
            column: 44
          }
        }, {
          start: {
            line: 24,
            column: 48
          },
          end: {
            line: 24,
            column: 50
          }
        }],
        line: 24
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }, {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 47,
            column: 9
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 35,
            column: 27
          },
          end: {
            line: 35,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 27
          },
          end: {
            line: 35,
            column: 45
          }
        }, {
          start: {
            line: 35,
            column: 49
          },
          end: {
            line: 35,
            column: 51
          }
        }],
        line: 35
      },
      "8": {
        loc: {
          start: {
            line: 36,
            column: 33
          },
          end: {
            line: 36,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 33
          },
          end: {
            line: 36,
            column: 48
          }
        }, {
          start: {
            line: 36,
            column: 52
          },
          end: {
            line: 36,
            column: 53
          }
        }],
        line: 36
      },
      "9": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }],
        line: 48
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/getChildrenJSON.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/getChildrenJSON.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,sCAAiD;AACjD,+DAAiD;AAajD;;;GAGG;AACH,SAAS,eAAe,CAAC,KAAiB;IACtC,IAAM,MAAM,GAAiB,EAAE,CAAA,CAAC,OAAO;IAEvC,IAAM,SAAS,GAAG,KAAK,CAAC,UAAU,EAAE,IAAI,EAAE,CAAA,CAAC,2BAA2B;IACtE,SAAS,CAAC,OAAO,CAAC,UAAC,OAAoB;QACnC,IAAI,UAAU,CAAA;QACd,IAAM,QAAQ,GAAG,OAAO,CAAC,QAAQ,CAAA;QAEjC,OAAO;QACP,IAAI,QAAQ,KAAK,CAAC,EAAE;YAChB,UAAU,GAAG,OAAO,CAAC,WAAW,IAAI,EAAE,CAAA;YACtC,UAAU,GAAG,wBAAiB,CAAC,UAAU,CAAC,CAAA;SAC7C;QAED,YAAY;QACZ,IAAI,QAAQ,KAAK,CAAC,EAAE;YAChB,UAAU,GAAG,EAAE,CAAA;YACf,UAAU,GAAG,UAAsB,CAAA;YAEnC,MAAM;YACN,UAAU,CAAC,GAAG,GAAG,OAAO,CAAC,QAAQ,CAAC,WAAW,EAAE,CAAA;YAC/C,OAAO;YACP,IAAM,QAAQ,GAAG,EAAE,CAAA;YACnB,IAAM,QAAQ,GAAG,OAAO,CAAC,UAAU,IAAI,EAAE,CAAA;YACzC,IAAM,cAAc,GAAG,QAAQ,CAAC,MAAM,IAAI,CAAC,CAAA;YAC3C,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,cAAc,EAAE,CAAC,EAAE,EAAE;gBACrC,IAAM,IAAI,GAAG,QAAQ,CAAC,CAAC,CAAC,CAAA;gBACxB,QAAQ,CAAC,IAAI,CAAC;oBACV,IAAI,EAAE,IAAI,CAAC,IAAI;oBACf,KAAK,EAAE,IAAI,CAAC,KAAK;iBACpB,CAAC,CAAA;aACL;YACD,UAAU,CAAC,KAAK,GAAG,QAAQ,CAAA;YAC3B,eAAe;YACf,UAAU,CAAC,QAAQ,GAAG,eAAe,CAAC,kBAAC,CAAC,OAAO,CAAC,CAAC,CAAA;SACpD;QAED,IAAI,UAAU,EAAE;YACZ,MAAM,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;SAC1B;IACL,CAAC,CAAC,CAAA;IACF,OAAO,MAAM,CAAA;AACjB,CAAC;AAED,kBAAe,eAAe,CAAA",
      sourcesContent: ["/**\n * @description \u83B7\u53D6\u5B50\u5143\u7D20\u7684 JSON \u683C\u5F0F\u6570\u636E\n * @author wangfupeng\n */\n\nimport { replaceHtmlSymbol } from '../utils/util'\nimport $, { DomElement } from '../utils/dom-core'\n\ntype AttrType = {\n    name: string\n    value: string\n}\nexport type NodeType = {\n    tag: string\n    attrs: AttrType[]\n    children: NodeListType\n}\nexport type NodeListType = Array<string | NodeType>\n\n/**\n * \u83B7\u53D6\u5B50\u5143\u7D20\u7684 JSON \u683C\u5F0F\u6570\u636E\n * @param $elem DOM \u8282\u70B9\n */\nfunction getChildrenJSON($elem: DomElement): NodeListType {\n    const result: NodeListType = [] // \u5B58\u50A8\u7ED3\u679C\n\n    const $children = $elem.childNodes() || [] // \u6CE8\u610F childNodes() \u53EF\u4EE5\u83B7\u53D6\u6587\u672C\u8282\u70B9\n    $children.forEach((curElem: HTMLElement) => {\n        let elemResult\n        const nodeType = curElem.nodeType\n\n        // \u6587\u672C\u8282\u70B9\n        if (nodeType === 3) {\n            elemResult = curElem.textContent || ''\n            elemResult = replaceHtmlSymbol(elemResult)\n        }\n\n        // \u666E\u901A DOM \u8282\u70B9\n        if (nodeType === 1) {\n            elemResult = {}\n            elemResult = elemResult as NodeType\n\n            // tag\n            elemResult.tag = curElem.nodeName.toLowerCase()\n            // attr\n            const attrData = []\n            const attrList = curElem.attributes || []\n            const attrListLength = attrList.length || 0\n            for (let i = 0; i < attrListLength; i++) {\n                const attr = attrList[i]\n                attrData.push({\n                    name: attr.name,\n                    value: attr.value,\n                })\n            }\n            elemResult.attrs = attrData\n            // children\uFF08\u9012\u5F52\uFF09\n            elemResult.children = getChildrenJSON($(curElem))\n        }\n\n        if (elemResult) {\n            result.push(elemResult)\n        }\n    })\n    return result\n}\n\nexport default getChildrenJSON\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9d6535400c8e4fb0a223f286a52fd7d217e0a372"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23y6fvyl27 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_23y6fvyl27();

var __importDefault = (cov_23y6fvyl27().s[0]++, (cov_23y6fvyl27().b[0][0]++, void 0) && (cov_23y6fvyl27().b[0][1]++, (void 0).__importDefault) || (cov_23y6fvyl27().b[0][2]++, function (mod) {
  cov_23y6fvyl27().f[0]++;
  cov_23y6fvyl27().s[1]++;
  return (cov_23y6fvyl27().b[2][0]++, mod) && (cov_23y6fvyl27().b[2][1]++, mod.__esModule) ? (cov_23y6fvyl27().b[1][0]++, mod) : (cov_23y6fvyl27().b[1][1]++, {
    "default": mod
  });
}));

cov_23y6fvyl27().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_23y6fvyl27().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_23y6fvyl27().s[4]++, __importDefault(__webpack_require__(2)));
/**
 * 获取子元素的 JSON 格式数据
 * @param $elem DOM 节点
 */

function getChildrenJSON($elem) {
  cov_23y6fvyl27().f[1]++;
  var result = (cov_23y6fvyl27().s[5]++, []); // 存储结果

  var $children = (cov_23y6fvyl27().s[6]++, (cov_23y6fvyl27().b[3][0]++, $elem.childNodes()) || (cov_23y6fvyl27().b[3][1]++, [])); // 注意 childNodes() 可以获取文本节点

  cov_23y6fvyl27().s[7]++;
  (0, _forEach["default"])($children).call($children, function (curElem) {
    cov_23y6fvyl27().f[2]++;
    var elemResult;
    var nodeType = (cov_23y6fvyl27().s[8]++, curElem.nodeType); // 文本节点

    cov_23y6fvyl27().s[9]++;

    if (nodeType === 3) {
      cov_23y6fvyl27().b[4][0]++;
      cov_23y6fvyl27().s[10]++;
      elemResult = (cov_23y6fvyl27().b[5][0]++, curElem.textContent) || (cov_23y6fvyl27().b[5][1]++, '');
      cov_23y6fvyl27().s[11]++;
      elemResult = util_1.replaceHtmlSymbol(elemResult);
    } else {
      cov_23y6fvyl27().b[4][1]++;
    } // 普通 DOM 节点


    cov_23y6fvyl27().s[12]++;

    if (nodeType === 1) {
      cov_23y6fvyl27().b[6][0]++;
      cov_23y6fvyl27().s[13]++;
      elemResult = {};
      cov_23y6fvyl27().s[14]++;
      elemResult = elemResult; // tag

      cov_23y6fvyl27().s[15]++;
      elemResult.tag = curElem.nodeName.toLowerCase(); // attr

      var attrData = (cov_23y6fvyl27().s[16]++, []);
      var attrList = (cov_23y6fvyl27().s[17]++, (cov_23y6fvyl27().b[7][0]++, curElem.attributes) || (cov_23y6fvyl27().b[7][1]++, []));
      var attrListLength = (cov_23y6fvyl27().s[18]++, (cov_23y6fvyl27().b[8][0]++, attrList.length) || (cov_23y6fvyl27().b[8][1]++, 0));
      cov_23y6fvyl27().s[19]++;

      for (var i = (cov_23y6fvyl27().s[20]++, 0); i < attrListLength; i++) {
        var attr = (cov_23y6fvyl27().s[21]++, attrList[i]);
        cov_23y6fvyl27().s[22]++;
        attrData.push({
          name: attr.name,
          value: attr.value
        });
      }

      cov_23y6fvyl27().s[23]++;
      elemResult.attrs = attrData; // children（递归）

      cov_23y6fvyl27().s[24]++;
      elemResult.children = getChildrenJSON(dom_core_1["default"](curElem));
    } else {
      cov_23y6fvyl27().b[6][1]++;
    }

    cov_23y6fvyl27().s[25]++;

    if (elemResult) {
      cov_23y6fvyl27().b[9][0]++;
      cov_23y6fvyl27().s[26]++;
      result.push(elemResult);
    } else {
      cov_23y6fvyl27().b[9][1]++;
    }
  });
  cov_23y6fvyl27().s[27]++;
  return result;
}

cov_23y6fvyl27().s[28]++;
exports["default"] = getChildrenJSON;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 从nodeList json格式中遍历生成dom元素
 * @author zhengwenjian
 */

var _interopRequireDefault = __webpack_require__(0);

var _typeof2 = _interopRequireDefault(__webpack_require__(91));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1hvwc0v17p() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/text/getHtmlByNodeList.ts";
  var hash = "e18e2d275a235b5f2c93013d02f93c4fde12ee9f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/text/getHtmlByNodeList.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 64
        }
      },
      "4": {
        start: {
          line: 13,
          column: 16
        },
        end: {
          line: 13,
          column: 49
        }
      },
      "5": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "6": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 42
        }
      },
      "7": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 20,
          column: 9
        }
      },
      "8": {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 68
        }
      },
      "9": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "10": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 80
        }
      },
      "11": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 26,
          column: 15
        }
      },
      "12": {
        start: {
          line: 25,
          column: 16
        },
        end: {
          line: 25,
          column: 50
        }
      },
      "13": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 31,
          column: 13
        }
      },
      "14": {
        start: {
          line: 29,
          column: 34
        },
        end: {
          line: 29,
          column: 77
        }
      },
      "15": {
        start: {
          line: 30,
          column: 16
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "16": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 28
        }
      },
      "17": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 17
        }
      },
      "18": {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 37,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "getHtmlByNodeList",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 26
          }
        },
        loc: {
          start: {
            line: 11,
            column: 37
          },
          end: {
            line: 36,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 22
          }
        },
        loc: {
          start: {
            line: 15,
            column: 37
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 31
          },
          end: {
            line: 24,
            column: 32
          }
        },
        loc: {
          start: {
            line: 24,
            column: 47
          },
          end: {
            line: 26,
            column: 13
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }, {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }, {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }],
        line: 28
      },
      "6": {
        loc: {
          start: {
            line: 28,
            column: 16
          },
          end: {
            line: 28,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 16
          },
          end: {
            line: 28,
            column: 29
          }
        }, {
          start: {
            line: 28,
            column: 33
          },
          end: {
            line: 28,
            column: 57
          }
        }],
        line: 28
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 27
          }
        }, {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/text/getHtmlByNodeList.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/text/getHtmlByNodeList.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,iEAAmD;AAGnD,SAAS,iBAAiB,CAAC,QAAsB;IAC7C,iBAAiB;IACjB,IAAI,KAAK,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;IAE5B,WAAW;IACX,QAAQ,CAAC,OAAO,CAAC,UAAA,IAAI;QACjB,IAAI,KAAK,GAAe,kBAAC,CAAC,EAAE,CAAC,CAAA;QAE7B,UAAU;QACV,IAAI,OAAO,IAAI,KAAK,QAAQ,EAAE;YAC1B,KAAK,GAAG,kBAAC,CAAC,WAAS,IAAI,YAAS,CAAC,CAAA;SACpC;QAED,UAAU;QACV,IAAI,OAAO,IAAI,KAAK,QAAQ,EAAE;YAC1B,KAAK,GAAG,kBAAC,CAAC,MAAI,IAAI,CAAC,GAAG,WAAM,IAAI,CAAC,GAAG,MAAG,CAAC,CAAA;YACxC,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,UAAA,IAAI;gBACnB,KAAK,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,KAAK,CAAC,CAAA;YACrC,CAAC,CAAC,CAAA;YAEF,oBAAoB;YACpB,IAAI,IAAI,CAAC,QAAQ,IAAI,IAAI,CAAC,QAAQ,CAAC,MAAM,GAAG,CAAC,EAAE;gBAC3C,IAAM,WAAW,GAAG,iBAAiB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,QAAQ,EAAE,CAAA;gBAC/D,WAAW,IAAI,KAAK,CAAC,MAAM,CAAC,WAAW,CAAC,CAAA;aAC3C;SACJ;QAED,KAAK,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;IACvB,CAAC,CAAC,CAAA;IACF,OAAO,KAAK,CAAA;AAChB,CAAC;AAED,kBAAe,iBAAiB,CAAA",
      sourcesContent: ["/**\n * @description \u4ECEnodeList json\u683C\u5F0F\u4E2D\u904D\u5386\u751F\u6210dom\u5143\u7D20\n * @author zhengwenjian\n */\n\nimport $, { DomElement } from './../utils/dom-core'\nimport { NodeListType } from './getChildrenJSON'\n\nfunction getHtmlByNodeList(nodeList: NodeListType): DomElement {\n    // \u8BBE\u7F6E\u4E00\u4E2A\u7236\u8282\u70B9\u5B58\u50A8\u6240\u6709\u5B50\u8282\u70B9\n    let $root = $(`<div></div>`)\n\n    // \u904D\u5386\u8282\u70B9JSON\n    nodeList.forEach(item => {\n        let $elem: DomElement = $('')\n\n        // \u5F53\u4E3A\u6587\u672C\u8282\u70B9\u65F6\n        if (typeof item === 'string') {\n            $elem = $(`<span>${item}</span>`)\n        }\n\n        // \u5F53\u4E3A\u666E\u901A\u8282\u70B9\u65F6\n        if (typeof item === 'object') {\n            $elem = $(`<${item.tag}></${item.tag}>`)\n            item.attrs.forEach(attr => {\n                $elem.attr(attr.name, attr.value)\n            })\n\n            // \u6709\u5B50\u8282\u70B9\u65F6\u9012\u5F52\u5C06\u5B50\u8282\u70B9\u52A0\u5165\u5F53\u524D\u8282\u70B9\n            if (item.children && item.children.length > 0) {\n                const $elemChilds = getHtmlByNodeList(item.children).children()\n                $elemChilds && $elem.append($elemChilds)\n            }\n        }\n\n        $root.append($elem)\n    })\n    return $root\n}\n\nexport default getHtmlByNodeList\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e18e2d275a235b5f2c93013d02f93c4fde12ee9f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hvwc0v17p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1hvwc0v17p();

var __importDefault = (cov_1hvwc0v17p().s[0]++, (cov_1hvwc0v17p().b[0][0]++, void 0) && (cov_1hvwc0v17p().b[0][1]++, (void 0).__importDefault) || (cov_1hvwc0v17p().b[0][2]++, function (mod) {
  cov_1hvwc0v17p().f[0]++;
  cov_1hvwc0v17p().s[1]++;
  return (cov_1hvwc0v17p().b[2][0]++, mod) && (cov_1hvwc0v17p().b[2][1]++, mod.__esModule) ? (cov_1hvwc0v17p().b[1][0]++, mod) : (cov_1hvwc0v17p().b[1][1]++, {
    "default": mod
  });
}));

cov_1hvwc0v17p().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1hvwc0v17p().s[3]++, __importDefault(__webpack_require__(2)));

function getHtmlByNodeList(nodeList) {
  cov_1hvwc0v17p().f[1]++;
  // 设置一个父节点存储所有子节点
  var $root = (cov_1hvwc0v17p().s[4]++, dom_core_1["default"]("<div></div>")); // 遍历节点JSON

  cov_1hvwc0v17p().s[5]++;
  (0, _forEach["default"])(nodeList).call(nodeList, function (item) {
    cov_1hvwc0v17p().f[2]++;
    var $elem = (cov_1hvwc0v17p().s[6]++, dom_core_1["default"]('')); // 当为文本节点时

    cov_1hvwc0v17p().s[7]++;

    if (typeof item === 'string') {
      cov_1hvwc0v17p().b[3][0]++;
      cov_1hvwc0v17p().s[8]++;
      $elem = dom_core_1["default"]("<span>" + item + "</span>");
    } else {
      cov_1hvwc0v17p().b[3][1]++;
    } // 当为普通节点时


    cov_1hvwc0v17p().s[9]++;

    if ((0, _typeof2["default"])(item) === 'object') {
      var _context;

      cov_1hvwc0v17p().b[4][0]++;
      cov_1hvwc0v17p().s[10]++;
      $elem = dom_core_1["default"]("<" + item.tag + "></" + item.tag + ">");
      cov_1hvwc0v17p().s[11]++;
      (0, _forEach["default"])(_context = item.attrs).call(_context, function (attr) {
        cov_1hvwc0v17p().f[3]++;
        cov_1hvwc0v17p().s[12]++;
        $elem.attr(attr.name, attr.value);
      }); // 有子节点时递归将子节点加入当前节点

      cov_1hvwc0v17p().s[13]++;

      if ((cov_1hvwc0v17p().b[6][0]++, item.children) && (cov_1hvwc0v17p().b[6][1]++, item.children.length > 0)) {
        cov_1hvwc0v17p().b[5][0]++;
        var $elemChilds = (cov_1hvwc0v17p().s[14]++, getHtmlByNodeList(item.children).children());
        cov_1hvwc0v17p().s[15]++;
        (cov_1hvwc0v17p().b[7][0]++, $elemChilds) && (cov_1hvwc0v17p().b[7][1]++, $elem.append($elemChilds));
      } else {
        cov_1hvwc0v17p().b[5][1]++;
      }
    } else {
      cov_1hvwc0v17p().b[4][1]++;
    }

    cov_1hvwc0v17p().s[16]++;
    $root.append($elem);
  });
  cov_1hvwc0v17p().s[17]++;
  return $root;
}

cov_1hvwc0v17p().s[18]++;
exports["default"] = getHtmlByNodeList;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description Menus 菜单栏 入口文件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _bind = _interopRequireDefault(__webpack_require__(86));

var _setTimeout2 = _interopRequireDefault(__webpack_require__(120));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1cye0l5oyw() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/index.ts";
  var hash = "b778d79a462de2a7fc2f06ed9ef45bd877f73c99";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 57
        }
      },
      "4": {
        start: {
          line: 12,
          column: 27
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "5": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 29
        }
      },
      "6": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 27
        }
      },
      "7": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 51
        }
      },
      "8": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "9": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 25,
          column: 19
        }
      },
      "10": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 19
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 41
        }
      },
      "12": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 46,
          column: 6
        }
      },
      "13": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "14": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 32,
          column: 39
        }
      },
      "15": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 43,
          column: 11
        }
      },
      "16": {
        start: {
          line: 34,
          column: 34
        },
        end: {
          line: 34,
          column: 64
        }
      },
      "17": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 38,
          column: 13
        }
      },
      "18": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 37,
          column: 23
        }
      },
      "19": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 53
        }
      },
      "20": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 28
        }
      },
      "21": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 35
        }
      },
      "22": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 29
        }
      },
      "23": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 58,
          column: 6
        }
      },
      "24": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 32
        }
      },
      "25": {
        start: {
          line: 50,
          column: 27
        },
        end: {
          line: 50,
          column: 46
        }
      },
      "26": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 57,
          column: 11
        }
      },
      "27": {
        start: {
          line: 53,
          column: 24
        },
        end: {
          line: 53,
          column: 34
        }
      },
      "28": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 56,
          column: 13
        }
      },
      "29": {
        start: {
          line: 55,
          column: 16
        },
        end: {
          line: 55,
          column: 43
        }
      },
      "30": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "31": {
        start: {
          line: 65,
          column: 23
        },
        end: {
          line: 65,
          column: 36
        }
      },
      "32": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "33": {
        start: {
          line: 66,
          column: 21
        },
        end: {
          line: 66,
          column: 22
        }
      },
      "34": {
        start: {
          line: 66,
          column: 28
        },
        end: {
          line: 66,
          column: 43
        }
      },
      "35": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 68,
          column: 35
        }
      },
      "36": {
        start: {
          line: 68,
          column: 16
        },
        end: {
          line: 68,
          column: 35
        }
      },
      "37": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 27
        }
      },
      "38": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "39": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 78,
          column: 11
        }
      },
      "40": {
        start: {
          line: 77,
          column: 12
        },
        end: {
          line: 77,
          column: 61
        }
      },
      "41": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 17
        }
      },
      "42": {
        start: {
          line: 82,
          column: 0
        },
        end: {
          line: 82,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 27
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 12,
            column: 39
          },
          end: {
            line: 81,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "Menus",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 18
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 23,
            column: 30
          }
        },
        loc: {
          start: {
            line: 23,
            column: 50
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 23
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 29,
            column: 27
          },
          end: {
            line: 29,
            column: 28
          }
        },
        loc: {
          start: {
            line: 29,
            column: 39
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 29
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 33,
            column: 29
          },
          end: {
            line: 33,
            column: 30
          }
        },
        loc: {
          start: {
            line: 33,
            column: 48
          },
          end: {
            line: 43,
            column: 9
          }
        },
        line: 33
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 36
          },
          end: {
            line: 48,
            column: 37
          }
        },
        loc: {
          start: {
            line: 48,
            column: 48
          },
          end: {
            line: 58,
            column: 5
          }
        },
        line: 48
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 30
          },
          end: {
            line: 52,
            column: 31
          }
        },
        loc: {
          start: {
            line: 52,
            column: 46
          },
          end: {
            line: 57,
            column: 9
          }
        },
        line: 52
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 64,
            column: 32
          }
        },
        loc: {
          start: {
            line: 64,
            column: 46
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 64
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 75,
            column: 35
          },
          end: {
            line: 75,
            column: 36
          }
        },
        loc: {
          start: {
            line: 75,
            column: 47
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 75
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 76,
            column: 30
          },
          end: {
            line: 76,
            column: 31
          }
        },
        loc: {
          start: {
            line: 76,
            column: 46
          },
          end: {
            line: 78,
            column: 9
          }
        },
        line: 76
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 25,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 25,
            column: 19
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 25,
            column: 19
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 24,
            column: 12
          },
          end: {
            line: 24,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 12
          },
          end: {
            line: 24,
            column: 17
          }
        }, {
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 47
          }
        }],
        line: 24
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 38,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 38,
            column: 13
          }
        }, {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 38,
            column: 13
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 39
          }
        }, {
          start: {
            line: 35,
            column: 43
          },
          end: {
            line: 35,
            column: 80
          }
        }],
        line: 35
      },
      "7": {
        loc: {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 56,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 56,
            column: 13
          }
        }, {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 56,
            column: 13
          }
        }],
        line: 54
      },
      "8": {
        loc: {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 68,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 68,
            column: 35
          }
        }, {
          start: {
            line: 67,
            column: 12
          },
          end: {
            line: 68,
            column: 35
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,0DAA+D;AAE/D,wDAAwD;AAExD;IAKI,eAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QACpB,IAAI,CAAC,QAAQ,GAAG,EAAE,CAAA;QAClB,IAAI,CAAC,eAAe,GAAG,mBAAmB,CAAA,CAAC,cAAc;IAC7D,CAAC;IAED;;;;OAIG;IACI,sBAAM,GAAb,UAAc,GAAW,EAAE,IAAS;QAChC,IAAI,CAAC,IAAI,IAAI,OAAO,IAAI,KAAK,UAAU;YAAE,OAAM;QAC/C,IAAI,CAAC,eAAe,CAAC,GAAG,CAAC,GAAG,IAAI,CAAA;IACpC,CAAC;IAED,QAAQ;IACD,oBAAI,GAAX;QAAA,iBAiBC;QAhBG,6BAA6B;QAC7B,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAC,MAAM,CAAA;QACjC,MAAM,CAAC,KAAK,CAAC,OAAO,CAAC,UAAA,OAAO;YACxB,IAAM,eAAe,GAAG,KAAI,CAAC,eAAe,CAAC,OAAO,CAAC,CAAA,CAAC,gBAAgB;YACtE,IAAI,eAAe,IAAI,IAAI,IAAI,OAAO,eAAe,KAAK,UAAU,EAAE;gBAClE,YAAY;gBACZ,OAAM;aACT;YACD,4BAA4B;YAC5B,IAAM,CAAC,GAAG,IAAI,eAAe,CAAC,KAAI,CAAC,MAAM,CAAC,CAAA;YAC1C,CAAC,CAAC,GAAG,GAAG,OAAO,CAAA;YACf,KAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,CAAC,CAAA;QACzB,CAAC,CAAC,CAAA;QAEF,SAAS;QACT,IAAI,CAAC,aAAa,EAAE,CAAA;IACxB,CAAC;IAED,SAAS;IACD,6BAAa,GAArB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;QAExC,YAAY;QACZ,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,UAAA,IAAI;YACtB,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAA;YACxB,IAAI,KAAK,EAAE;gBACP,YAAY,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;aAC7B;QACL,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;;;OAIG;IACI,wBAAQ,GAAf,UAAgB,GAAW;QACvB,IAAM,QAAQ,GAAG,IAAI,CAAC,QAAQ,CAAA;QAC9B,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,CAAC,MAAM,EAAE,CAAC,GAAG,CAAC,EAAE,CAAC,EAAE,EAAE;YAC7C,IAAI,QAAQ,CAAC,CAAC,CAAC,CAAC,GAAG,KAAK,GAAG;gBAAE,OAAO,QAAQ,CAAC,CAAC,CAAC,CAAA;SAClD;QAED,OAAO,QAAQ,CAAC,CAAC,CAAC,CAAA;IACtB,CAAC;IAED;;OAEG;IACI,4BAAY,GAAnB;QACI,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,UAAA,IAAI;YACtB,UAAU,CAAE,IAAY,CAAC,eAAe,CAAC,IAAI,CAAC,IAAI,CAAC,EAAE,GAAG,CAAC,CAAA,CAAC,gBAAgB;QAC9E,CAAC,CAAC,CAAA;IACN,CAAC;IACL,YAAC;AAAD,CAAC,AA7ED,IA6EC;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description Menus \u83DC\u5355\u680F \u5165\u53E3\u6587\u4EF6\n * @author wangfupeng\n */\n\nimport Editor from '../editor/index'\nimport Menu from './menu-constructors/Menu'\nimport MenuConstructorList, { MenuListType } from './menu-list'\n\n// import { MenuActive } from './menu-constructors/Menu'\n\nclass Menus {\n    public editor: Editor\n    public menuList: Menu[]\n    public constructorList: MenuListType\n\n    constructor(editor: Editor) {\n        this.editor = editor\n        this.menuList = []\n        this.constructorList = MenuConstructorList // \u6240\u6709\u83DC\u5355\u6784\u9020\u51FD\u6570\u7684\u5217\u8868\n    }\n\n    /**\n     * \u81EA\u5B9A\u4E49\u6DFB\u52A0\u83DC\u5355\n     * @param key \u83DC\u5355 key \uFF0C\u548C editor.config.menus \u5BF9\u5E94\n     * @param Menu \u83DC\u5355\u6784\u9020\u51FD\u6570\n     */\n    public extend(key: string, Menu: any) {\n        if (!Menu || typeof Menu !== 'function') return\n        this.constructorList[key] = Menu\n    }\n\n    // \u521D\u59CB\u5316\u83DC\u5355\n    public init(): void {\n        // \u4ECE\u7528\u6237\u914D\u7F6E\u7684 menus \u5165\u624B\uFF0C\u770B\u9700\u8981\u521D\u59CB\u5316\u54EA\u4E9B\u83DC\u5355\n        const config = this.editor.config\n        config.menus.forEach(menuKey => {\n            const MenuConstructor = this.constructorList[menuKey] // \u6682\u7528 any \uFF0C\u540E\u9762\u518D\u66FF\u6362\n            if (MenuConstructor == null || typeof MenuConstructor !== 'function') {\n                // \u5FC5\u987B\u662F class\n                return\n            }\n            // \u521B\u5EFA menu \u5B9E\u4F8B\uFF0C\u5E76\u653E\u5230 menuList \u4E2D\n            const m = new MenuConstructor(this.editor)\n            m.key = menuKey\n            this.menuList.push(m)\n        })\n\n        // \u6E32\u67D3 DOM\n        this._addToToolbar()\n    }\n\n    // \u6DFB\u52A0\u5230\u83DC\u5355\u680F\n    private _addToToolbar(): void {\n        const editor = this.editor\n        const $toolbarElem = editor.$toolbarElem\n\n        // \u904D\u5386\u6DFB\u52A0\u5230 DOM\n        this.menuList.forEach(menu => {\n            const $elem = menu.$elem\n            if ($elem) {\n                $toolbarElem.append($elem)\n            }\n        })\n    }\n\n    /**\n     * \u83B7\u53D6\u83DC\u5355\u5BF9\u8C61\n     * @param \u83DC\u5355\u540D\u79F0 \u5C0F\u5199\n     * @return Menus \u83DC\u5355\u5BF9\u8C61\n     */\n    public menuFind(key: string): Menu {\n        const menuList = this.menuList\n        for (let i = 0, l = menuList.length; i < l; i++) {\n            if (menuList[i].key === key) return menuList[i]\n        }\n\n        return menuList[0]\n    }\n\n    /**\n     * @description \u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public changeActive(): void {\n        this.menuList.forEach(menu => {\n            setTimeout((menu as any).tryChangeActive.bind(menu), 100) // \u6682\u7528 any \uFF0C\u540E\u9762\u518D\u66FF\u6362\n        })\n    }\n}\n\nexport default Menus\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b778d79a462de2a7fc2f06ed9ef45bd877f73c99"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cye0l5oyw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1cye0l5oyw();

var __importDefault = (cov_1cye0l5oyw().s[0]++, (cov_1cye0l5oyw().b[0][0]++, void 0) && (cov_1cye0l5oyw().b[0][1]++, (void 0).__importDefault) || (cov_1cye0l5oyw().b[0][2]++, function (mod) {
  cov_1cye0l5oyw().f[0]++;
  cov_1cye0l5oyw().s[1]++;
  return (cov_1cye0l5oyw().b[2][0]++, mod) && (cov_1cye0l5oyw().b[2][1]++, mod.__esModule) ? (cov_1cye0l5oyw().b[1][0]++, mod) : (cov_1cye0l5oyw().b[1][1]++, {
    "default": mod
  });
}));

cov_1cye0l5oyw().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var menu_list_1 = (cov_1cye0l5oyw().s[3]++, __importDefault(__webpack_require__(300))); // import { MenuActive } from './menu-constructors/Menu'

var Menus = (
/** @class */
cov_1cye0l5oyw().s[4]++, function () {
  cov_1cye0l5oyw().f[1]++;

  function Menus(editor) {
    cov_1cye0l5oyw().f[2]++;
    cov_1cye0l5oyw().s[5]++;
    this.editor = editor;
    cov_1cye0l5oyw().s[6]++;
    this.menuList = [];
    cov_1cye0l5oyw().s[7]++;
    this.constructorList = menu_list_1["default"]; // 所有菜单构造函数的列表
  }
  /**
   * 自定义添加菜单
   * @param key 菜单 key ，和 editor.config.menus 对应
   * @param Menu 菜单构造函数
   */


  cov_1cye0l5oyw().s[8]++;

  Menus.prototype.extend = function (key, Menu) {
    cov_1cye0l5oyw().f[3]++;
    cov_1cye0l5oyw().s[9]++;

    if ((cov_1cye0l5oyw().b[4][0]++, !Menu) || (cov_1cye0l5oyw().b[4][1]++, typeof Menu !== 'function')) {
      cov_1cye0l5oyw().b[3][0]++;
      cov_1cye0l5oyw().s[10]++;
      return;
    } else {
      cov_1cye0l5oyw().b[3][1]++;
    }

    cov_1cye0l5oyw().s[11]++;
    this.constructorList[key] = Menu;
  }; // 初始化菜单


  cov_1cye0l5oyw().s[12]++;

  Menus.prototype.init = function () {
    var _context;

    cov_1cye0l5oyw().f[4]++;

    var _this = (cov_1cye0l5oyw().s[13]++, this); // 从用户配置的 menus 入手，看需要初始化哪些菜单


    var config = (cov_1cye0l5oyw().s[14]++, this.editor.config);
    cov_1cye0l5oyw().s[15]++;
    (0, _forEach["default"])(_context = config.menus).call(_context, function (menuKey) {
      cov_1cye0l5oyw().f[5]++;
      var MenuConstructor = (cov_1cye0l5oyw().s[16]++, _this.constructorList[menuKey]); // 暂用 any ，后面再替换

      cov_1cye0l5oyw().s[17]++;

      if ((cov_1cye0l5oyw().b[6][0]++, MenuConstructor == null) || (cov_1cye0l5oyw().b[6][1]++, typeof MenuConstructor !== 'function')) {
        cov_1cye0l5oyw().b[5][0]++;
        cov_1cye0l5oyw().s[18]++;
        // 必须是 class
        return;
      } else {
        cov_1cye0l5oyw().b[5][1]++;
      } // 创建 menu 实例，并放到 menuList 中


      var m = (cov_1cye0l5oyw().s[19]++, new MenuConstructor(_this.editor));
      cov_1cye0l5oyw().s[20]++;
      m.key = menuKey;
      cov_1cye0l5oyw().s[21]++;

      _this.menuList.push(m);
    }); // 渲染 DOM

    cov_1cye0l5oyw().s[22]++;

    this._addToToolbar();
  }; // 添加到菜单栏


  cov_1cye0l5oyw().s[23]++;

  Menus.prototype._addToToolbar = function () {
    var _context2;

    cov_1cye0l5oyw().f[6]++;
    var editor = (cov_1cye0l5oyw().s[24]++, this.editor);
    var $toolbarElem = (cov_1cye0l5oyw().s[25]++, editor.$toolbarElem); // 遍历添加到 DOM

    cov_1cye0l5oyw().s[26]++;
    (0, _forEach["default"])(_context2 = this.menuList).call(_context2, function (menu) {
      cov_1cye0l5oyw().f[7]++;
      var $elem = (cov_1cye0l5oyw().s[27]++, menu.$elem);
      cov_1cye0l5oyw().s[28]++;

      if ($elem) {
        cov_1cye0l5oyw().b[7][0]++;
        cov_1cye0l5oyw().s[29]++;
        $toolbarElem.append($elem);
      } else {
        cov_1cye0l5oyw().b[7][1]++;
      }
    });
  };
  /**
   * 获取菜单对象
   * @param 菜单名称 小写
   * @return Menus 菜单对象
   */


  cov_1cye0l5oyw().s[30]++;

  Menus.prototype.menuFind = function (key) {
    cov_1cye0l5oyw().f[8]++;
    var menuList = (cov_1cye0l5oyw().s[31]++, this.menuList);
    cov_1cye0l5oyw().s[32]++;

    for (var i = (cov_1cye0l5oyw().s[33]++, 0), l = (cov_1cye0l5oyw().s[34]++, menuList.length); i < l; i++) {
      cov_1cye0l5oyw().s[35]++;

      if (menuList[i].key === key) {
        cov_1cye0l5oyw().b[8][0]++;
        cov_1cye0l5oyw().s[36]++;
        return menuList[i];
      } else {
        cov_1cye0l5oyw().b[8][1]++;
      }
    }

    cov_1cye0l5oyw().s[37]++;
    return menuList[0];
  };
  /**
   * @description 修改菜单激活状态
   */


  cov_1cye0l5oyw().s[38]++;

  Menus.prototype.changeActive = function () {
    var _context3;

    cov_1cye0l5oyw().f[9]++;
    cov_1cye0l5oyw().s[39]++;
    (0, _forEach["default"])(_context3 = this.menuList).call(_context3, function (menu) {
      var _context4;

      cov_1cye0l5oyw().f[10]++;
      cov_1cye0l5oyw().s[40]++;
      (0, _setTimeout2["default"])((0, _bind["default"])(_context4 = menu.tryChangeActive).call(_context4, menu), 100); // 暂用 any ，后面再替换
    });
  };

  cov_1cye0l5oyw().s[41]++;
  return Menus;
}());
cov_1cye0l5oyw().s[42]++;
exports["default"] = Menus;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 所有菜单的构造函数
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_17c81mnvs() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-list.ts";
  var hash = "2d410402c78377d2df522027402fa0b93718837b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-list.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 10,
          column: 54
        }
      },
      "4": {
        start: {
          line: 11,
          column: 14
        },
        end: {
          line: 11,
          column: 54
        }
      },
      "5": {
        start: {
          line: 12,
          column: 14
        },
        end: {
          line: 12,
          column: 54
        }
      },
      "6": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 13,
          column: 56
        }
      },
      "7": {
        start: {
          line: 14,
          column: 14
        },
        end: {
          line: 14,
          column: 59
        }
      },
      "8": {
        start: {
          line: 15,
          column: 14
        },
        end: {
          line: 15,
          column: 64
        }
      },
      "9": {
        start: {
          line: 16,
          column: 14
        },
        end: {
          line: 16,
          column: 60
        }
      },
      "10": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 57
        }
      },
      "11": {
        start: {
          line: 18,
          column: 14
        },
        end: {
          line: 18,
          column: 57
        }
      },
      "12": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 55
        }
      },
      "13": {
        start: {
          line: 20,
          column: 15
        },
        end: {
          line: 20,
          column: 61
        }
      },
      "14": {
        start: {
          line: 21,
          column: 15
        },
        end: {
          line: 21,
          column: 61
        }
      },
      "15": {
        start: {
          line: 22,
          column: 15
        },
        end: {
          line: 22,
          column: 56
        }
      },
      "16": {
        start: {
          line: 23,
          column: 15
        },
        end: {
          line: 23,
          column: 54
        }
      },
      "17": {
        start: {
          line: 24,
          column: 15
        },
        end: {
          line: 24,
          column: 57
        }
      },
      "18": {
        start: {
          line: 25,
          column: 15
        },
        end: {
          line: 25,
          column: 59
        }
      },
      "19": {
        start: {
          line: 26,
          column: 15
        },
        end: {
          line: 26,
          column: 55
        }
      },
      "20": {
        start: {
          line: 27,
          column: 15
        },
        end: {
          line: 27,
          column: 61
        }
      },
      "21": {
        start: {
          line: 28,
          column: 15
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "22": {
        start: {
          line: 29,
          column: 15
        },
        end: {
          line: 29,
          column: 55
        }
      },
      "23": {
        start: {
          line: 30,
          column: 15
        },
        end: {
          line: 30,
          column: 56
        }
      },
      "24": {
        start: {
          line: 31,
          column: 13
        },
        end: {
          line: 31,
          column: 47
        }
      },
      "25": {
        start: {
          line: 32,
          column: 15
        },
        end: {
          line: 32,
          column: 61
        }
      },
      "26": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 57,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-list.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-list.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,uDAA+B;AAC/B,uDAA+B;AAC/B,uDAA+B;AAC/B,yDAAmC;AACnC,4DAAyC;AACzC,iEAAkD;AAClD,6DAA0C;AAC1C,0DAAkC;AAClC,0DAAqC;AACrC,wDAAiC;AACjC,8DAA0C;AAC1C,8DAA0C;AAC1C,yDAAiC;AACjC,uDAA+B;AAC/B,0DAAmC;AACnC,4DAAuC;AACvC,wDAA+B;AAC/B,8DAA2C;AAC3C,wDAA+B;AAC/B,wDAA+B;AAC/B,yDAAiC;AACjC,gDAAyB;AACzB,8DAA0C;AAM1C,kBAAe;IACX,IAAI,EAAE,eAAI;IACV,IAAI,EAAE,eAAI;IACV,MAAM,EAAE,eAAM;IACd,IAAI,EAAE,eAAI;IACV,SAAS,EAAE,eAAS;IACpB,aAAa,EAAE,eAAa;IAC5B,QAAQ,EAAE,eAAS;IACnB,QAAQ,EAAE,mBAAQ;IAClB,OAAO,EAAE,eAAO;IAChB,KAAK,EAAE,eAAK;IACZ,SAAS,EAAE,gBAAS;IACpB,SAAS,EAAE,gBAAS;IACpB,KAAK,EAAE,gBAAK;IACZ,KAAK,EAAE,gBAAK;IACZ,MAAM,EAAE,gBAAM;IACd,QAAQ,EAAE,gBAAQ;IAClB,IAAI,EAAE,gBAAI;IACV,UAAU,EAAE,gBAAU;IACtB,IAAI,EAAE,gBAAI;IACV,IAAI,EAAE,gBAAI;IACV,KAAK,EAAE,gBAAK;IACZ,IAAI,EAAE,cAAI;IACV,SAAS,EAAE,gBAAS;CACvB,CAAA",
      sourcesContent: ["/**\n * @description \u6240\u6709\u83DC\u5355\u7684\u6784\u9020\u51FD\u6570\n * @author wangfupeng\n */\n\nimport Bold from './bold/index'\nimport Head from './head/index'\nimport Link from './link/index'\nimport Italic from './italic/index'\nimport Underline from './underline/index'\nimport StrikeThrough from './strike-through/index'\nimport FontStyle from './font-style/index'\nimport FontSize from './font-size'\nimport Justify from './justify/index'\nimport Quote from './quote/index'\nimport BackColor from './back-color/index'\nimport FontColor from './font-color/index'\nimport Video from './video/index'\nimport Image from './img/index'\nimport Indent from './indent/index'\nimport Emoticon from './emoticon/index'\nimport List from './list/index'\nimport LineHeight from './lineHeight/index'\nimport Undo from './undo/index'\nimport Redo from './redo/index'\nimport Table from './table/index'\nimport Code from './code'\nimport SplitLine from './split-line/index'\n\nexport type MenuListType = {\n    [key: string]: any\n}\n\nexport default {\n    bold: Bold,\n    head: Head,\n    italic: Italic,\n    link: Link,\n    underline: Underline,\n    strikeThrough: StrikeThrough,\n    fontName: FontStyle,\n    fontSize: FontSize,\n    justify: Justify,\n    quote: Quote,\n    backColor: BackColor,\n    foreColor: FontColor,\n    video: Video,\n    image: Image,\n    indent: Indent,\n    emoticon: Emoticon,\n    list: List,\n    lineHeight: LineHeight,\n    undo: Undo,\n    redo: Redo,\n    table: Table,\n    code: Code,\n    splitLine: SplitLine,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2d410402c78377d2df522027402fa0b93718837b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17c81mnvs = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_17c81mnvs();

var __importDefault = (cov_17c81mnvs().s[0]++, (cov_17c81mnvs().b[0][0]++, void 0) && (cov_17c81mnvs().b[0][1]++, (void 0).__importDefault) || (cov_17c81mnvs().b[0][2]++, function (mod) {
  cov_17c81mnvs().f[0]++;
  cov_17c81mnvs().s[1]++;
  return (cov_17c81mnvs().b[2][0]++, mod) && (cov_17c81mnvs().b[2][1]++, mod.__esModule) ? (cov_17c81mnvs().b[1][0]++, mod) : (cov_17c81mnvs().b[1][1]++, {
    "default": mod
  });
}));

cov_17c81mnvs().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var index_1 = (cov_17c81mnvs().s[3]++, __importDefault(__webpack_require__(301)));
var index_2 = (cov_17c81mnvs().s[4]++, __importDefault(__webpack_require__(305)));
var index_3 = (cov_17c81mnvs().s[5]++, __importDefault(__webpack_require__(310)));
var index_4 = (cov_17c81mnvs().s[6]++, __importDefault(__webpack_require__(314)));
var index_5 = (cov_17c81mnvs().s[7]++, __importDefault(__webpack_require__(315)));
var index_6 = (cov_17c81mnvs().s[8]++, __importDefault(__webpack_require__(316)));
var index_7 = (cov_17c81mnvs().s[9]++, __importDefault(__webpack_require__(317)));
var font_size_1 = (cov_17c81mnvs().s[10]++, __importDefault(__webpack_require__(319)));
var index_8 = (cov_17c81mnvs().s[11]++, __importDefault(__webpack_require__(321)));
var index_9 = (cov_17c81mnvs().s[12]++, __importDefault(__webpack_require__(322)));
var index_10 = (cov_17c81mnvs().s[13]++, __importDefault(__webpack_require__(325)));
var index_11 = (cov_17c81mnvs().s[14]++, __importDefault(__webpack_require__(326)));
var index_12 = (cov_17c81mnvs().s[15]++, __importDefault(__webpack_require__(327)));
var index_13 = (cov_17c81mnvs().s[16]++, __importDefault(__webpack_require__(329)));
var index_14 = (cov_17c81mnvs().s[17]++, __importDefault(__webpack_require__(349)));
var index_15 = (cov_17c81mnvs().s[18]++, __importDefault(__webpack_require__(353)));
var index_16 = (cov_17c81mnvs().s[19]++, __importDefault(__webpack_require__(355)));
var index_17 = (cov_17c81mnvs().s[20]++, __importDefault(__webpack_require__(356)));
var index_18 = (cov_17c81mnvs().s[21]++, __importDefault(__webpack_require__(358)));
var index_19 = (cov_17c81mnvs().s[22]++, __importDefault(__webpack_require__(359)));
var index_20 = (cov_17c81mnvs().s[23]++, __importDefault(__webpack_require__(360)));
var code_1 = (cov_17c81mnvs().s[24]++, __importDefault(__webpack_require__(369)));
var index_21 = (cov_17c81mnvs().s[25]++, __importDefault(__webpack_require__(373)));
cov_17c81mnvs().s[26]++;
exports["default"] = {
  bold: index_1["default"],
  head: index_2["default"],
  italic: index_4["default"],
  link: index_3["default"],
  underline: index_5["default"],
  strikeThrough: index_6["default"],
  fontName: index_7["default"],
  fontSize: font_size_1["default"],
  justify: index_8["default"],
  quote: index_9["default"],
  backColor: index_10["default"],
  foreColor: index_11["default"],
  video: index_12["default"],
  image: index_13["default"],
  indent: index_14["default"],
  emoticon: index_15["default"],
  list: index_16["default"],
  lineHeight: index_17["default"],
  undo: index_18["default"],
  redo: index_19["default"],
  table: index_20["default"],
  code: code_1["default"],
  splitLine: index_21["default"]
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 加粗
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1oolx41g90() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/bold/index.ts";
  var hash = "d5db09fb376311e59691be1d35add5fc1a992db2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/bold/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 72
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 64,
          column: 20
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 28
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 135
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "24": {
        start: {
          line: 37,
          column: 21
        },
        end: {
          line: 37,
          column: 32
        }
      },
      "25": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 38,
          column: 63
        }
      },
      "26": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "27": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "28": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 30
        }
      },
      "29": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "30": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 45
        }
      },
      "31": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "32": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "33": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "34": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "35": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "36": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 28
        }
      },
      "37": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 16
        }
      },
      "38": {
        start: {
          line: 65,
          column: 0
        },
        end: {
          line: 65,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "Bold",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 26
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 34
          },
          end: {
            line: 36,
            column: 35
          }
        },
        loc: {
          start: {
            line: 36,
            column: 46
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 54,
            column: 37
          },
          end: {
            line: 54,
            column: 38
          }
        },
        loc: {
          start: {
            line: 54,
            column: 49
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 52
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }],
        line: 39
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/bold/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/bold/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,yEAAkD;AAClD,kEAAoC;AAIpC;IAAmB,wBAAO;IACtB,cAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,+FAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,2BAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEzD,IAAI,aAAa,EAAE;YACf,sBAAsB;YACtB,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;QAED,aAAa;QACb,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,MAAM,CAAC,CAAA;QAErB,IAAI,aAAa,EAAE;YACf,cAAc;YACd,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;YAChC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,MAAM,CAAC,EAAE;YACtC,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AA3CD,CAAmB,iBAAO,GA2CzB;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u52A0\u7C97\n * @author wangfupeng\n */\n\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Bold extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-bold\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const isSelectEmpty = editor.selection.isSelectionEmpty()\n\n        if (isSelectEmpty) {\n            // \u9009\u533A\u8303\u56F4\u662F\u7A7A\u7684\uFF0C\u63D2\u5165\u5E76\u9009\u4E2D\u4E00\u4E2A\u201C\u7A7A\u767D\u201D\n            editor.selection.createEmptyRange()\n        }\n\n        // \u6267\u884C bold \u547D\u4EE4\n        editor.cmd.do('bold')\n\n        if (isSelectEmpty) {\n            // \u9700\u8981\u5C06\u9009\u533A\u8303\u56F4\u6298\u53E0\u8D77\u6765\n            editor.selection.collapseRange()\n            editor.selection.restoreSelection()\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        if (editor.cmd.queryCommandState('bold')) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Bold\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d5db09fb376311e59691be1d35add5fc1a992db2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1oolx41g90 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1oolx41g90();

var __extends = (cov_1oolx41g90().s[0]++, (cov_1oolx41g90().b[0][0]++, void 0) && (cov_1oolx41g90().b[0][1]++, (void 0).__extends) || (cov_1oolx41g90().b[0][2]++, function () {
  cov_1oolx41g90().f[0]++;
  cov_1oolx41g90().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1oolx41g90().f[1]++;
    cov_1oolx41g90().s[2]++;
    _extendStatics = (cov_1oolx41g90().b[1][0]++, _setPrototypeOf["default"]) || (cov_1oolx41g90().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1oolx41g90().b[1][2]++, function (d, b) {
      cov_1oolx41g90().f[2]++;
      cov_1oolx41g90().s[3]++;
      d.__proto__ = b;
    }) || (cov_1oolx41g90().b[1][3]++, function (d, b) {
      cov_1oolx41g90().f[3]++;
      cov_1oolx41g90().s[4]++;

      for (var p in b) {
        cov_1oolx41g90().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1oolx41g90().b[2][0]++;
          cov_1oolx41g90().s[6]++;
          d[p] = b[p];
        } else {
          cov_1oolx41g90().b[2][1]++;
        }
      }
    });
    cov_1oolx41g90().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1oolx41g90().s[8]++;
  return function (d, b) {
    cov_1oolx41g90().f[4]++;
    cov_1oolx41g90().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1oolx41g90().f[5]++;
      cov_1oolx41g90().s[10]++;
      this.constructor = d;
    }

    cov_1oolx41g90().s[11]++;
    d.prototype = b === null ? (cov_1oolx41g90().b[3][0]++, (0, _create["default"])(b)) : (cov_1oolx41g90().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1oolx41g90().s[12]++, (cov_1oolx41g90().b[4][0]++, void 0) && (cov_1oolx41g90().b[4][1]++, (void 0).__importDefault) || (cov_1oolx41g90().b[4][2]++, function (mod) {
  cov_1oolx41g90().f[6]++;
  cov_1oolx41g90().s[13]++;
  return (cov_1oolx41g90().b[6][0]++, mod) && (cov_1oolx41g90().b[6][1]++, mod.__esModule) ? (cov_1oolx41g90().b[5][0]++, mod) : (cov_1oolx41g90().b[5][1]++, {
    "default": mod
  });
}));

cov_1oolx41g90().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var BtnMenu_1 = (cov_1oolx41g90().s[15]++, __importDefault(__webpack_require__(24)));
var dom_core_1 = (cov_1oolx41g90().s[16]++, __importDefault(__webpack_require__(2)));
var Bold = (
/** @class */
cov_1oolx41g90().s[17]++, function (_super) {
  cov_1oolx41g90().f[7]++;
  cov_1oolx41g90().s[18]++;

  __extends(Bold, _super);

  function Bold(editor) {
    cov_1oolx41g90().f[8]++;

    var _this = (cov_1oolx41g90().s[19]++, this);

    var $elem = (cov_1oolx41g90().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-bold\"></i>\n            </div>"));
    cov_1oolx41g90().s[21]++;
    _this = (cov_1oolx41g90().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1oolx41g90().b[7][1]++, this);
    cov_1oolx41g90().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_1oolx41g90().s[23]++;

  Bold.prototype.clickHandler = function () {
    cov_1oolx41g90().f[9]++;
    var editor = (cov_1oolx41g90().s[24]++, this.editor);
    var isSelectEmpty = (cov_1oolx41g90().s[25]++, editor.selection.isSelectionEmpty());
    cov_1oolx41g90().s[26]++;

    if (isSelectEmpty) {
      cov_1oolx41g90().b[8][0]++;
      cov_1oolx41g90().s[27]++;
      // 选区范围是空的，插入并选中一个“空白”
      editor.selection.createEmptyRange();
    } else {
      cov_1oolx41g90().b[8][1]++;
    } // 执行 bold 命令


    cov_1oolx41g90().s[28]++;
    editor.cmd["do"]('bold');
    cov_1oolx41g90().s[29]++;

    if (isSelectEmpty) {
      cov_1oolx41g90().b[9][0]++;
      cov_1oolx41g90().s[30]++;
      // 需要将选区范围折叠起来
      editor.selection.collapseRange();
      cov_1oolx41g90().s[31]++;
      editor.selection.restoreSelection();
    } else {
      cov_1oolx41g90().b[9][1]++;
    }
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_1oolx41g90().s[32]++;

  Bold.prototype.tryChangeActive = function () {
    cov_1oolx41g90().f[10]++;
    var editor = (cov_1oolx41g90().s[33]++, this.editor);
    cov_1oolx41g90().s[34]++;

    if (editor.cmd.queryCommandState('bold')) {
      cov_1oolx41g90().b[10][0]++;
      cov_1oolx41g90().s[35]++;
      this.active();
    } else {
      cov_1oolx41g90().b[10][1]++;
      cov_1oolx41g90().s[36]++;
      this.unActive();
    }
  };

  cov_1oolx41g90().s[37]++;
  return Bold;
}(BtnMenu_1["default"]));
cov_1oolx41g90().s[38]++;
exports["default"] = Bold;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(303);

module.exports = parent;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(304);
var path = __webpack_require__(10);

module.exports = path.Object.setPrototypeOf;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var setPrototypeOf = __webpack_require__(75);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 标题
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _stringify = _interopRequireDefault(__webpack_require__(306));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_pr9m53m6m() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/head/index.ts";
  var hash = "09141336c6b367e6df0282f1ba9b5b0d3015f015";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/head/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 21
        },
        end: {
          line: 23,
          column: 82
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 13
        },
        end: {
          line: 25,
          column: 40
        }
      },
      "18": {
        start: {
          line: 26,
          column: 26
        },
        end: {
          line: 144,
          column: 25
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 28
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 101
        }
      },
      "22": {
        start: {
          line: 31,
          column: 27
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "23": {
        start: {
          line: 48,
          column: 16
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "24": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 71
        }
      },
      "25": {
        start: {
          line: 52,
          column: 30
        },
        end: {
          line: 52,
          column: 59
        }
      },
      "26": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      "27": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 35
        }
      },
      "28": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 39
        }
      },
      "29": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 32
        }
      },
      "30": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 21
        }
      },
      "31": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 76,
          column: 6
        }
      },
      "32": {
        start: {
          line: 66,
          column: 21
        },
        end: {
          line: 66,
          column: 32
        }
      },
      "33": {
        start: {
          line: 67,
          column: 29
        },
        end: {
          line: 67,
          column: 73
        }
      },
      "34": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 72,
          column: 9
        }
      },
      "35": {
        start: {
          line: 71,
          column: 12
        },
        end: {
          line: 71,
          column: 19
        }
      },
      "36": {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 73,
          column: 44
        }
      },
      "37": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 57
        }
      },
      "38": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 85,
          column: 6
        }
      },
      "39": {
        start: {
          line: 81,
          column: 21
        },
        end: {
          line: 81,
          column: 32
        }
      },
      "40": {
        start: {
          line: 82,
          column: 18
        },
        end: {
          line: 82,
          column: 62
        }
      },
      "41": {
        start: {
          line: 83,
          column: 17
        },
        end: {
          line: 83,
          column: 39
        }
      },
      "42": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 47
        }
      },
      "43": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 95,
          column: 6
        }
      },
      "44": {
        start: {
          line: 90,
          column: 20
        },
        end: {
          line: 90,
          column: 24
        }
      },
      "45": {
        start: {
          line: 91,
          column: 21
        },
        end: {
          line: 91,
          column: 32
        }
      },
      "46": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 94,
          column: 11
        }
      },
      "47": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 32
        }
      },
      "48": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 128,
          column: 6
        }
      },
      "49": {
        start: {
          line: 100,
          column: 21
        },
        end: {
          line: 100,
          column: 32
        }
      },
      "50": {
        start: {
          line: 101,
          column: 24
        },
        end: {
          line: 101,
          column: 45
        }
      },
      "51": {
        start: {
          line: 102,
          column: 30
        },
        end: {
          line: 102,
          column: 59
        }
      },
      "52": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 103,
          column: 52
        }
      },
      "53": {
        start: {
          line: 104,
          column: 23
        },
        end: {
          line: 104,
          column: 25
        }
      },
      "54": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 122,
          column: 11
        }
      },
      "55": {
        start: {
          line: 106,
          column: 24
        },
        end: {
          line: 106,
          column: 48
        }
      },
      "56": {
        start: {
          line: 107,
          column: 21
        },
        end: {
          line: 107,
          column: 37
        }
      },
      "57": {
        start: {
          line: 108,
          column: 22
        },
        end: {
          line: 108,
          column: 41
        }
      },
      "58": {
        start: {
          line: 109,
          column: 23
        },
        end: {
          line: 109,
          column: 35
        }
      },
      "59": {
        start: {
          line: 110,
          column: 12
        },
        end: {
          line: 113,
          column: 13
        }
      },
      "60": {
        start: {
          line: 111,
          column: 16
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "61": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 37
        }
      },
      "62": {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 116,
          column: 23
        }
      },
      "63": {
        start: {
          line: 116,
          column: 16
        },
        end: {
          line: 116,
          column: 23
        }
      },
      "64": {
        start: {
          line: 117,
          column: 12
        },
        end: {
          line: 121,
          column: 15
        }
      },
      "65": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "66": {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 125,
          column: 40
        }
      },
      "67": {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 126,
          column: 57
        }
      },
      "68": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 142,
          column: 6
        }
      },
      "69": {
        start: {
          line: 133,
          column: 21
        },
        end: {
          line: 133,
          column: 32
        }
      },
      "70": {
        start: {
          line: 134,
          column: 18
        },
        end: {
          line: 134,
          column: 23
        }
      },
      "71": {
        start: {
          line: 135,
          column: 23
        },
        end: {
          line: 135,
          column: 66
        }
      },
      "72": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 141,
          column: 9
        }
      },
      "73": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 26
        }
      },
      "74": {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 28
        }
      },
      "75": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 16
        }
      },
      "76": {
        start: {
          line: 145,
          column: 0
        },
        end: {
          line: 145,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 26
          },
          end: {
            line: 26,
            column: 27
          }
        },
        loc: {
          start: {
            line: 26,
            column: 44
          },
          end: {
            line: 144,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "Head",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 17
          }
        },
        loc: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 46,
            column: 26
          },
          end: {
            line: 46,
            column: 27
          }
        },
        loc: {
          start: {
            line: 46,
            column: 43
          },
          end: {
            line: 49,
            column: 13
          }
        },
        line: 46
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 65,
            column: 29
          },
          end: {
            line: 65,
            column: 30
          }
        },
        loc: {
          start: {
            line: 65,
            column: 46
          },
          end: {
            line: 76,
            column: 5
          }
        },
        line: 65
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 80,
            column: 44
          },
          end: {
            line: 80,
            column: 45
          }
        },
        loc: {
          start: {
            line: 80,
            column: 56
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 80
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 89,
            column: 40
          },
          end: {
            line: 89,
            column: 41
          }
        },
        loc: {
          start: {
            line: 89,
            column: 52
          },
          end: {
            line: 95,
            column: 5
          }
        },
        line: 89
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 92,
            column: 48
          },
          end: {
            line: 92,
            column: 49
          }
        },
        loc: {
          start: {
            line: 92,
            column: 60
          },
          end: {
            line: 94,
            column: 9
          }
        },
        line: 92
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 99,
            column: 33
          },
          end: {
            line: 99,
            column: 34
          }
        },
        loc: {
          start: {
            line: 99,
            column: 45
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 99
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 105,
            column: 22
          },
          end: {
            line: 105,
            column: 23
          }
        },
        loc: {
          start: {
            line: 105,
            column: 45
          },
          end: {
            line: 122,
            column: 9
          }
        },
        line: 105
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 132,
            column: 37
          },
          end: {
            line: 132,
            column: 38
          }
        },
        loc: {
          start: {
            line: 132,
            column: 49
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 132
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 51,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 51,
            column: 62
          }
        }, {
          start: {
            line: 51,
            column: 66
          },
          end: {
            line: 51,
            column: 70
          }
        }],
        line: 51
      },
      "8": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 54
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 72,
            column: 9
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 26
          }
        }, {
          start: {
            line: 68,
            column: 30
          },
          end: {
            line: 68,
            column: 68
          }
        }],
        line: 68
      },
      "11": {
        loc: {
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 23
          }
        }, {
          start: {
            line: 75,
            column: 27
          },
          end: {
            line: 75,
            column: 56
          }
        }],
        line: 75
      },
      "12": {
        loc: {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        }, {
          start: {
            line: 110,
            column: 12
          },
          end: {
            line: 113,
            column: 13
          }
        }],
        line: 110
      },
      "13": {
        loc: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 116,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 116,
            column: 23
          }
        }, {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 116,
            column: 23
          }
        }],
        line: 115
      },
      "14": {
        loc: {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        }, {
          start: {
            line: 124,
            column: 8
          },
          end: {
            line: 127,
            column: 9
          }
        }],
        line: 124
      },
      "15": {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 27
          }
        }, {
          start: {
            line: 126,
            column: 31
          },
          end: {
            line: 126,
            column: 56
          }
        }],
        line: 126
      },
      "16": {
        loc: {
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 141,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 141,
            column: 9
          }
        }, {
          start: {
            line: 136,
            column: 8
          },
          end: {
            line: 141,
            column: 9
          }
        }],
        line: 136
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/head/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/head/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoC;AAGpC,yCAAgD;AAGhD;IAAmB,wBAAY;IAE3B,cAAY,MAAc;QAA1B,iBA+BC;QA9BG,IAAM,KAAK,GAAG,kBAAC,CAAC,6DAA6D,CAAC,CAAA;QAC9E,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE;gBACF,EAAE,KAAK,EAAE,kBAAC,CAAC,aAAa,CAAC,EAAE,KAAK,EAAE,MAAM,EAAE;gBAC1C,EAAE,KAAK,EAAE,kBAAC,CAAC,aAAa,CAAC,EAAE,KAAK,EAAE,MAAM,EAAE;gBAC1C,EAAE,KAAK,EAAE,kBAAC,CAAC,aAAa,CAAC,EAAE,KAAK,EAAE,MAAM,EAAE;gBAC1C,EAAE,KAAK,EAAE,kBAAC,CAAC,aAAa,CAAC,EAAE,KAAK,EAAE,MAAM,EAAE;gBAC1C,EAAE,KAAK,EAAE,kBAAC,CAAC,aAAa,CAAC,EAAE,KAAK,EAAE,MAAM,EAAE;gBAC1C;oBACI,KAAK,EAAE,kBAAC,CAAC,QAAM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,4BAA4B,CAAC,SAAM,CAAC;oBACpE,KAAK,EAAE,KAAK;iBACf;aACJ;YACD,YAAY,EAAE,UAAC,KAAa;gBACxB,yBAAyB;gBACzB,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;QAElC,IAAM,eAAe,GAAG,MAAM,CAAC,MAAM,CAAC,eAAe,CAAA;QACrD,0BAA0B;QAC1B,IAAI,eAAe,EAAE;YACjB,KAAI,CAAC,WAAW,GAAG,EAAE,CAAA;YACrB,KAAI,CAAC,kBAAkB,EAAE,CAAA,CAAC,gBAAgB;YAC1C,KAAI,CAAC,WAAW,EAAE,CAAA,CAAC,kBAAkB;SACxC;;IACL,CAAC;IAED;;;OAGG;IACI,sBAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACnE,IAAI,cAAc,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,cAAc,CAAC,EAAE;YAC1D,sBAAsB;YACtB,sEAAsE;YACtE,OAAM;SACT;QAED,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,aAAa,EAAE,KAAK,CAAC,CAAA;QAEnC,0BAA0B;QAC1B,KAAK,KAAK,KAAK,IAAI,IAAI,CAAC,sBAAsB,EAAE,CAAA;IACpD,CAAC;IAED;;OAEG;IACK,qCAAsB,GAA9B;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,GAAG,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACxD,IAAM,EAAE,GAAG,oBAAa,EAAE,CAAA,CAAC,UAAU;QACrC,kBAAC,CAAC,GAAG,CAAC,CAAC,IAAI,CAAC,IAAI,EAAE,EAAE,CAAC,CAAA;IACzB,CAAC;IAED;;OAEG;IACK,iCAAkB,GAA1B;QAAA,iBAKC;QAJG,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,IAAI,CAAC;YACpC,KAAI,CAAC,WAAW,EAAE,CAAA;QACtB,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACK,0BAAW,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,IAAI,CAAC,MAAM,CAAC,SAAS,CAAA;QACvC,IAAM,eAAe,GAAG,MAAM,CAAC,MAAM,CAAC,eAAe,CAAA;QACrD,IAAM,KAAK,GAAG,SAAS,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;QAC9C,IAAM,QAAQ,GAAe,EAAE,CAAA;QAC/B,KAAK,CAAC,OAAO,CAAC,UAAC,IAAI,EAAE,KAAK;YACtB,IAAM,KAAK,GAAG,kBAAC,CAAC,IAAI,CAAC,CAAA;YACrB,IAAI,EAAE,GAAG,KAAK,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YACzB,IAAM,GAAG,GAAG,KAAK,CAAC,WAAW,EAAE,CAAA;YAC/B,IAAM,IAAI,GAAG,KAAK,CAAC,IAAI,EAAE,CAAA;YACzB,IAAI,CAAC,EAAE,EAAE;gBACL,EAAE,GAAG,oBAAa,EAAE,CAAA;gBACpB,KAAK,CAAC,IAAI,CAAC,IAAI,EAAE,EAAE,CAAC,CAAA;aACvB;YACD,eAAe;YACf,IAAI,CAAC,IAAI;gBAAE,OAAM;YACjB,QAAQ,CAAC,IAAI,CAAC;gBACV,GAAG,KAAA;gBACH,EAAE,IAAA;gBACF,IAAI,MAAA;aACP,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;QACF,8CAA8C;QAC9C,IAAI,IAAI,CAAC,SAAS,CAAC,IAAI,CAAC,WAAW,CAAC,KAAK,IAAI,CAAC,SAAS,CAAC,QAAQ,CAAC,EAAE;YAC/D,IAAI,CAAC,WAAW,GAAG,QAAQ,CAAA;YAC3B,eAAe,IAAI,eAAe,CAAC,QAAQ,CAAC,CAAA;SAC/C;IACL,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,GAAG,GAAG,KAAK,CAAA;QACjB,IAAM,QAAQ,GAAG,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,aAAa,CAAC,CAAA;QAC5D,IAAI,GAAG,CAAC,IAAI,CAAC,QAAQ,CAAC,EAAE;YACpB,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AAxHD,CAAmB,sBAAY,GAwH9B;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u6807\u9898\n * @author wangfupeng\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport { getRandomCode } from '../../utils/util'\nimport { TCatalog } from '../../config/events'\n\nclass Head extends DropListMenu implements MenuActive {\n    oldCatalogs: TCatalog[] | undefined\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-header\"></i></div>')\n        const dropListConf = {\n            width: 100,\n            title: '\u8BBE\u7F6E\u6807\u9898',\n            type: 'list', // droplist \u4EE5\u5217\u8868\u5F62\u5F0F\u5C55\u793A\n            list: [\n                { $elem: $('<h1>H1</h1>'), value: '<h1>' },\n                { $elem: $('<h2>H2</h2>'), value: '<h2>' },\n                { $elem: $('<h3>H3</h3>'), value: '<h3>' },\n                { $elem: $('<h4>H4</h4>'), value: '<h4>' },\n                { $elem: $('<h5>H5</h5>'), value: '<h5>' },\n                {\n                    $elem: $(`<p>${editor.i18next.t('menus.dropListMenu.head.\u6B63\u6587')}</p>`),\n                    value: '<p>',\n                },\n            ],\n            clickHandler: (value: string) => {\n                // \u6CE8\u610F this \u662F\u6307\u5411\u5F53\u524D\u7684 Head \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n        super($elem, editor, dropListConf)\n\n        const onCatalogChange = editor.config.onCatalogChange\n        // \u672A\u914D\u7F6E\u76EE\u5F55change\u76D1\u542C\u56DE\u8C03\u65F6\u4E0D\u8FD0\u884C\u4E0B\u9762\u64CD\u4F5C\n        if (onCatalogChange) {\n            this.oldCatalogs = []\n            this.addListenerCatalog() // \u76D1\u542C\u6587\u672C\u6846\u7F16\u8F91\u65F6\u7684\u5927\u7EB2\u4FE1\u606F\n            this.getCatalogs() // \u521D\u59CB\u6709\u503C\u7684\u60C5\u51B5\u83B7\u53D6\u4E00\u904D\u5927\u7EB2\u4FE1\u606F\n        }\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n        if ($selectionElem && editor.$textElem.equal($selectionElem)) {\n            // \u4E0D\u80FD\u9009\u4E2D\u591A\u884C\u6765\u8BBE\u7F6E\u6807\u9898\uFF0C\u5426\u5219\u4F1A\u51FA\u73B0\u95EE\u9898\n            // \u4F8B\u5982\u9009\u4E2D\u7684\u662F <p>xxx</p><p>yyy</p> \u6765\u8BBE\u7F6E\u6807\u9898\uFF0C\u8BBE\u7F6E\u4E4B\u540E\u4F1A\u6210\u4E3A <h1>xxx<br>yyy</h1> \u4E0D\u7B26\u5408\u9884\u671F\n            return\n        }\n\n        editor.cmd.do('formatBlock', value)\n\n        // \u6807\u9898\u8BBE\u7F6E\u6210\u529F\u4E14\u4E0D\u662F<p>\u6B63\u6587\u6807\u7B7E\u5C31\u914D\u7F6E\u5927\u7EB2id\n        value !== '<p>' && this.addUidForSelectionElem()\n    }\n\n    /**\n     * \u4E3A\u6807\u9898\u8BBE\u7F6E\u5927\u7EB2\n     */\n    private addUidForSelectionElem() {\n        const editor = this.editor\n        const tag = editor.selection.getSelectionContainerElem()\n        const id = getRandomCode() // \u9ED8\u8BA4\u4E94\u4F4D\u6570id\n        $(tag).attr('id', id)\n    }\n\n    /**\n     * \u76D1\u542Cchange\u4E8B\u4EF6\u6765\u8FD4\u56DE\u5927\u7EB2\u4FE1\u606F\n     */\n    private addListenerCatalog() {\n        const editor = this.editor\n        editor.txt.eventHooks.changeEvents.push(() => {\n            this.getCatalogs()\n        })\n    }\n\n    /**\n     * \u83B7\u53D6\u5927\u7EB2\u6570\u7EC4\n     */\n    private getCatalogs() {\n        const editor = this.editor\n        const $textElem = this.editor.$textElem\n        const onCatalogChange = editor.config.onCatalogChange\n        const elems = $textElem.find('h1,h2,h3,h4,h5')\n        const catalogs: TCatalog[] = []\n        elems.forEach((elem, index) => {\n            const $elem = $(elem)\n            let id = $elem.attr('id')\n            const tag = $elem.getNodeName()\n            const text = $elem.text()\n            if (!id) {\n                id = getRandomCode()\n                $elem.attr('id', id)\n            }\n            // \u6807\u9898\u4E3A\u7A7A\u7684\u60C5\u51B5\u4E0D\u751F\u6210\u76EE\u5F55\n            if (!text) return\n            catalogs.push({\n                tag,\n                id,\n                text,\n            })\n        })\n        // \u65E7\u76EE\u5F55\u548C\u65B0\u76EE\u5F55\u5BF9\u6BD4\u662F\u5426\u76F8\u7B49\uFF0C\u4E0D\u76F8\u7B49\u5219\u8FD0\u884C\u56DE\u8C03\u5E76\u4FDD\u5B58\u65B0\u76EE\u5F55\u5230\u65E7\u76EE\u5F55\u53D8\u91CF\uFF0C\u4EE5\u65B9\u4FBF\u4E0B\u4E00\u6B21\u5BF9\u6BD4\n        if (JSON.stringify(this.oldCatalogs) !== JSON.stringify(catalogs)) {\n            this.oldCatalogs = catalogs\n            onCatalogChange && onCatalogChange(catalogs)\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u6539\u53D8\u83DC\u5355\u6FC0\u6D3B\uFF08\u9AD8\u4EAE\uFF09\u72B6\u6001\n     */\n    public tryChangeActive() {\n        const editor = this.editor\n        const reg = /^h/i\n        const cmdValue = editor.cmd.queryCommandValue('formatBlock')\n        if (reg.test(cmdValue)) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Head\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "09141336c6b367e6df0282f1ba9b5b0d3015f015"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_pr9m53m6m = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_pr9m53m6m();

var __extends = (cov_pr9m53m6m().s[0]++, (cov_pr9m53m6m().b[0][0]++, void 0) && (cov_pr9m53m6m().b[0][1]++, (void 0).__extends) || (cov_pr9m53m6m().b[0][2]++, function () {
  cov_pr9m53m6m().f[0]++;
  cov_pr9m53m6m().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_pr9m53m6m().f[1]++;
    cov_pr9m53m6m().s[2]++;
    _extendStatics = (cov_pr9m53m6m().b[1][0]++, _setPrototypeOf["default"]) || (cov_pr9m53m6m().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_pr9m53m6m().b[1][2]++, function (d, b) {
      cov_pr9m53m6m().f[2]++;
      cov_pr9m53m6m().s[3]++;
      d.__proto__ = b;
    }) || (cov_pr9m53m6m().b[1][3]++, function (d, b) {
      cov_pr9m53m6m().f[3]++;
      cov_pr9m53m6m().s[4]++;

      for (var p in b) {
        cov_pr9m53m6m().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_pr9m53m6m().b[2][0]++;
          cov_pr9m53m6m().s[6]++;
          d[p] = b[p];
        } else {
          cov_pr9m53m6m().b[2][1]++;
        }
      }
    });
    cov_pr9m53m6m().s[7]++;
    return _extendStatics(d, b);
  };

  cov_pr9m53m6m().s[8]++;
  return function (d, b) {
    cov_pr9m53m6m().f[4]++;
    cov_pr9m53m6m().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_pr9m53m6m().f[5]++;
      cov_pr9m53m6m().s[10]++;
      this.constructor = d;
    }

    cov_pr9m53m6m().s[11]++;
    d.prototype = b === null ? (cov_pr9m53m6m().b[3][0]++, (0, _create["default"])(b)) : (cov_pr9m53m6m().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_pr9m53m6m().s[12]++, (cov_pr9m53m6m().b[4][0]++, void 0) && (cov_pr9m53m6m().b[4][1]++, (void 0).__importDefault) || (cov_pr9m53m6m().b[4][2]++, function (mod) {
  cov_pr9m53m6m().f[6]++;
  cov_pr9m53m6m().s[13]++;
  return (cov_pr9m53m6m().b[6][0]++, mod) && (cov_pr9m53m6m().b[6][1]++, mod.__esModule) ? (cov_pr9m53m6m().b[5][0]++, mod) : (cov_pr9m53m6m().b[5][1]++, {
    "default": mod
  });
}));

cov_pr9m53m6m().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_pr9m53m6m().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_pr9m53m6m().s[16]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_pr9m53m6m().s[17]++, __webpack_require__(7));
var Head = (
/** @class */
cov_pr9m53m6m().s[18]++, function (_super) {
  cov_pr9m53m6m().f[7]++;
  cov_pr9m53m6m().s[19]++;

  __extends(Head, _super);

  function Head(editor) {
    cov_pr9m53m6m().f[8]++;

    var _this = (cov_pr9m53m6m().s[20]++, this);

    var $elem = (cov_pr9m53m6m().s[21]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-header"></i></div>'));
    var dropListConf = (cov_pr9m53m6m().s[22]++, {
      width: 100,
      title: '设置标题',
      type: 'list',
      list: [{
        $elem: dom_core_1["default"]('<h1>H1</h1>'),
        value: '<h1>'
      }, {
        $elem: dom_core_1["default"]('<h2>H2</h2>'),
        value: '<h2>'
      }, {
        $elem: dom_core_1["default"]('<h3>H3</h3>'),
        value: '<h3>'
      }, {
        $elem: dom_core_1["default"]('<h4>H4</h4>'),
        value: '<h4>'
      }, {
        $elem: dom_core_1["default"]('<h5>H5</h5>'),
        value: '<h5>'
      }, {
        $elem: dom_core_1["default"]("<p>" + editor.i18next.t('menus.dropListMenu.head.正文') + "</p>"),
        value: '<p>'
      }],
      clickHandler: function clickHandler(value) {
        cov_pr9m53m6m().f[9]++;
        cov_pr9m53m6m().s[23]++;

        // 注意 this 是指向当前的 Head 对象
        _this.command(value);
      }
    });
    cov_pr9m53m6m().s[24]++;
    _this = (cov_pr9m53m6m().b[7][0]++, _super.call(this, $elem, editor, dropListConf)) || (cov_pr9m53m6m().b[7][1]++, this);
    var onCatalogChange = (cov_pr9m53m6m().s[25]++, editor.config.onCatalogChange); // 未配置目录change监听回调时不运行下面操作

    cov_pr9m53m6m().s[26]++;

    if (onCatalogChange) {
      cov_pr9m53m6m().b[8][0]++;
      cov_pr9m53m6m().s[27]++;
      _this.oldCatalogs = [];
      cov_pr9m53m6m().s[28]++;

      _this.addListenerCatalog(); // 监听文本框编辑时的大纲信息


      cov_pr9m53m6m().s[29]++;

      _this.getCatalogs(); // 初始有值的情况获取一遍大纲信息

    } else {
      cov_pr9m53m6m().b[8][1]++;
    }

    cov_pr9m53m6m().s[30]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_pr9m53m6m().s[31]++;

  Head.prototype.command = function (value) {
    cov_pr9m53m6m().f[10]++;
    var editor = (cov_pr9m53m6m().s[32]++, this.editor);
    var $selectionElem = (cov_pr9m53m6m().s[33]++, editor.selection.getSelectionContainerElem());
    cov_pr9m53m6m().s[34]++;

    if ((cov_pr9m53m6m().b[10][0]++, $selectionElem) && (cov_pr9m53m6m().b[10][1]++, editor.$textElem.equal($selectionElem))) {
      cov_pr9m53m6m().b[9][0]++;
      cov_pr9m53m6m().s[35]++;
      // 不能选中多行来设置标题，否则会出现问题
      // 例如选中的是 <p>xxx</p><p>yyy</p> 来设置标题，设置之后会成为 <h1>xxx<br>yyy</h1> 不符合预期
      return;
    } else {
      cov_pr9m53m6m().b[9][1]++;
    }

    cov_pr9m53m6m().s[36]++;
    editor.cmd["do"]('formatBlock', value); // 标题设置成功且不是<p>正文标签就配置大纲id

    cov_pr9m53m6m().s[37]++;
    (cov_pr9m53m6m().b[11][0]++, value !== '<p>') && (cov_pr9m53m6m().b[11][1]++, this.addUidForSelectionElem());
  };
  /**
   * 为标题设置大纲
   */


  cov_pr9m53m6m().s[38]++;

  Head.prototype.addUidForSelectionElem = function () {
    cov_pr9m53m6m().f[11]++;
    var editor = (cov_pr9m53m6m().s[39]++, this.editor);
    var tag = (cov_pr9m53m6m().s[40]++, editor.selection.getSelectionContainerElem());
    var id = (cov_pr9m53m6m().s[41]++, util_1.getRandomCode()); // 默认五位数id

    cov_pr9m53m6m().s[42]++;
    dom_core_1["default"](tag).attr('id', id);
  };
  /**
   * 监听change事件来返回大纲信息
   */


  cov_pr9m53m6m().s[43]++;

  Head.prototype.addListenerCatalog = function () {
    cov_pr9m53m6m().f[12]++;

    var _this = (cov_pr9m53m6m().s[44]++, this);

    var editor = (cov_pr9m53m6m().s[45]++, this.editor);
    cov_pr9m53m6m().s[46]++;
    editor.txt.eventHooks.changeEvents.push(function () {
      cov_pr9m53m6m().f[13]++;
      cov_pr9m53m6m().s[47]++;

      _this.getCatalogs();
    });
  };
  /**
   * 获取大纲数组
   */


  cov_pr9m53m6m().s[48]++;

  Head.prototype.getCatalogs = function () {
    cov_pr9m53m6m().f[14]++;
    var editor = (cov_pr9m53m6m().s[49]++, this.editor);
    var $textElem = (cov_pr9m53m6m().s[50]++, this.editor.$textElem);
    var onCatalogChange = (cov_pr9m53m6m().s[51]++, editor.config.onCatalogChange);
    var elems = (cov_pr9m53m6m().s[52]++, (0, _find["default"])($textElem).call($textElem, 'h1,h2,h3,h4,h5'));
    var catalogs = (cov_pr9m53m6m().s[53]++, []);
    cov_pr9m53m6m().s[54]++;
    (0, _forEach["default"])(elems).call(elems, function (elem, index) {
      cov_pr9m53m6m().f[15]++;
      var $elem = (cov_pr9m53m6m().s[55]++, dom_core_1["default"](elem));
      var id = (cov_pr9m53m6m().s[56]++, $elem.attr('id'));
      var tag = (cov_pr9m53m6m().s[57]++, $elem.getNodeName());
      var text = (cov_pr9m53m6m().s[58]++, $elem.text());
      cov_pr9m53m6m().s[59]++;

      if (!id) {
        cov_pr9m53m6m().b[12][0]++;
        cov_pr9m53m6m().s[60]++;
        id = util_1.getRandomCode();
        cov_pr9m53m6m().s[61]++;
        $elem.attr('id', id);
      } else {
        cov_pr9m53m6m().b[12][1]++;
      } // 标题为空的情况不生成目录


      cov_pr9m53m6m().s[62]++;

      if (!text) {
        cov_pr9m53m6m().b[13][0]++;
        cov_pr9m53m6m().s[63]++;
        return;
      } else {
        cov_pr9m53m6m().b[13][1]++;
      }

      cov_pr9m53m6m().s[64]++;
      catalogs.push({
        tag: tag,
        id: id,
        text: text
      });
    }); // 旧目录和新目录对比是否相等，不相等则运行回调并保存新目录到旧目录变量，以方便下一次对比

    cov_pr9m53m6m().s[65]++;

    if ((0, _stringify["default"])(this.oldCatalogs) !== (0, _stringify["default"])(catalogs)) {
      cov_pr9m53m6m().b[14][0]++;
      cov_pr9m53m6m().s[66]++;
      this.oldCatalogs = catalogs;
      cov_pr9m53m6m().s[67]++;
      (cov_pr9m53m6m().b[15][0]++, onCatalogChange) && (cov_pr9m53m6m().b[15][1]++, onCatalogChange(catalogs));
    } else {
      cov_pr9m53m6m().b[14][1]++;
    }
  };
  /**
   * 尝试改变菜单激活（高亮）状态
   */


  cov_pr9m53m6m().s[68]++;

  Head.prototype.tryChangeActive = function () {
    cov_pr9m53m6m().f[16]++;
    var editor = (cov_pr9m53m6m().s[69]++, this.editor);
    var reg = (cov_pr9m53m6m().s[70]++, /^h/i);
    var cmdValue = (cov_pr9m53m6m().s[71]++, editor.cmd.queryCommandValue('formatBlock'));
    cov_pr9m53m6m().s[72]++;

    if (reg.test(cmdValue)) {
      cov_pr9m53m6m().b[16][0]++;
      cov_pr9m53m6m().s[73]++;
      this.active();
    } else {
      cov_pr9m53m6m().b[16][1]++;
      cov_pr9m53m6m().s[74]++;
      this.unActive();
    }
  };

  cov_pr9m53m6m().s[75]++;
  return Head;
}(DropListMenu_1["default"]));
cov_pr9m53m6m().s[76]++;
exports["default"] = Head;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(307);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(308);

module.exports = parent;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(309);
var core = __webpack_require__(10);

if (!core.JSON) core.JSON = { stringify: JSON.stringify };

// eslint-disable-next-line no-unused-vars
module.exports = function stringify(it, replacer, space) {
  return core.JSON.stringify.apply(null, arguments);
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var getBuiltIn = __webpack_require__(26);
var fails = __webpack_require__(12);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 链接 菜单
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1cjxxm3x2s() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/link/index.ts";
  var hash = "585507f6b7ba53420fc6a5808b57b6dd572251fc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/link/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 76
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 25,
          column: 73
        }
      },
      "18": {
        start: {
          line: 26,
          column: 18
        },
        end: {
          line: 26,
          column: 57
        }
      },
      "19": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 68
        }
      },
      "20": {
        start: {
          line: 28,
          column: 14
        },
        end: {
          line: 28,
          column: 60
        }
      },
      "21": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 89,
          column: 22
        }
      },
      "22": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 28
        }
      },
      "23": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 24
        }
      },
      "24": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 99
        }
      },
      "25": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 57
        }
      },
      "26": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 32
        }
      },
      "27": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 21
        }
      },
      "28": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 65,
          column: 6
        }
      },
      "29": {
        start: {
          line: 43,
          column: 21
        },
        end: {
          line: 43,
          column: 32
        }
      },
      "30": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 64,
          column: 9
        }
      },
      "31": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 69
        }
      },
      "32": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 50,
          column: 13
        }
      },
      "33": {
        start: {
          line: 49,
          column: 16
        },
        end: {
          line: 49,
          column: 23
        }
      },
      "34": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 52,
          column: 71
        }
      },
      "35": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 63,
          column: 13
        }
      },
      "36": {
        start: {
          line: 58,
          column: 16
        },
        end: {
          line: 58,
          column: 41
        }
      },
      "37": {
        start: {
          line: 62,
          column: 16
        },
        end: {
          line: 62,
          column: 74
        }
      },
      "38": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 75,
          column: 6
        }
      },
      "39": {
        start: {
          line: 72,
          column: 19
        },
        end: {
          line: 72,
          column: 71
        }
      },
      "40": {
        start: {
          line: 73,
          column: 20
        },
        end: {
          line: 73,
          column: 51
        }
      },
      "41": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 23
        }
      },
      "42": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 87,
          column: 6
        }
      },
      "43": {
        start: {
          line: 80,
          column: 21
        },
        end: {
          line: 80,
          column: 32
        }
      },
      "44": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 86,
          column: 9
        }
      },
      "45": {
        start: {
          line: 82,
          column: 12
        },
        end: {
          line: 82,
          column: 26
        }
      },
      "46": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 85,
          column: 28
        }
      },
      "47": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 16
        }
      },
      "48": {
        start: {
          line: 90,
          column: 0
        },
        end: {
          line: 90,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 27
          }
        },
        loc: {
          start: {
            line: 29,
            column: 44
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 29
      },
      "8": {
        name: "Link",
        decl: {
          start: {
            line: 31,
            column: 13
          },
          end: {
            line: 31,
            column: 17
          }
        },
        loc: {
          start: {
            line: 31,
            column: 26
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 31
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 42,
            column: 34
          },
          end: {
            line: 42,
            column: 35
          }
        },
        loc: {
          start: {
            line: 42,
            column: 46
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 42
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 71,
            column: 33
          },
          end: {
            line: 71,
            column: 34
          }
        },
        loc: {
          start: {
            line: 71,
            column: 55
          },
          end: {
            line: 75,
            column: 5
          }
        },
        line: 71
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 79,
            column: 37
          },
          end: {
            line: 79,
            column: 38
          }
        },
        loc: {
          start: {
            line: 79,
            column: 49
          },
          end: {
            line: 87,
            column: 5
          }
        },
        line: 79
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 48
          }
        }, {
          start: {
            line: 34,
            column: 52
          },
          end: {
            line: 34,
            column: 56
          }
        }],
        line: 34
      },
      "8": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 64,
            column: 9
          }
        }],
        line: 45
      },
      "9": {
        loc: {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }, {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }],
        line: 48
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 63,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 63,
            column: 13
          }
        }, {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 63,
            column: 13
          }
        }],
        line: 56
      },
      "11": {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 86,
            column: 9
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/link/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/link/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,6EAAsD;AAEtD,kEAAoC;AACpC,0EAAiD;AACjD,0DAAkC;AAClC,qEAA8C;AAE9C,6DAA0C;AAE1C;IAAmB,wBAAS;IACxB,cAAY,MAAc;QAA1B,iBAMC;QALG,IAAM,KAAK,GAAG,kBAAC,CAAC,2DAA2D,CAAC,CAAA;QAC5E,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QAEpB,qBAAqB;QACrB,eAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IAED;;OAEG;IACI,2BAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,SAAS,CAAA;QAEb,IAAI,IAAI,CAAC,QAAQ,EAAE;YACf,iBAAiB;YACjB,SAAS,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;YACxD,IAAI,CAAC,SAAS,EAAE;gBACZ,OAAM;aACT;YAED,WAAW;YACX,IAAI,CAAC,WAAW,CAAC,SAAS,CAAC,IAAI,EAAE,EAAE,SAAS,CAAC,IAAI,CAAC,MAAM,CAAC,CAAC,CAAA;SAC7D;aAAM;YACH,mBAAmB;YACnB,IAAI,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,EAAE;gBACrC,cAAc;gBACd,IAAI,CAAC,WAAW,CAAC,EAAE,EAAE,EAAE,CAAC,CAAA;aAC3B;iBAAM;gBACH,QAAQ;gBACR,IAAI,CAAC,WAAW,CAAC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,EAAE,EAAE,CAAC,CAAA;aAC5D;SACJ;IACL,CAAC;IAED;;;;OAIG;IACK,0BAAW,GAAnB,UAAoB,IAAY,EAAE,IAAY;QAC1C,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,EAAE,IAAI,EAAE,IAAI,CAAC,CAAA;QACrD,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,mBAAQ,CAAC,MAAM,CAAC,EAAE;YAClB,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AA3DD,CAAmB,mBAAS,GA2D3B;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u94FE\u63A5 \u83DC\u5355\n * @author wangfupeng\n */\n\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\nimport createPanelConf from './create-panel-conf'\nimport isActive from './is-active'\nimport Panel from '../menu-constructors/Panel'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event/index'\n\nclass Link extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-link\"></i></div>')\n        super($elem, editor)\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\uFF0C\u5982\u70B9\u51FB\u94FE\u63A5\u65F6\uFF0C\u53EF\u4EE5\u67E5\u770B\u94FE\u63A5\n        bindEvent(editor)\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        let $linkElem\n\n        if (this.isActive) {\n            // \u83DC\u5355\u88AB\u6FC0\u6D3B\uFF0C\u8BF4\u660E\u9009\u533A\u5728\u94FE\u63A5\u91CC\n            $linkElem = editor.selection.getSelectionContainerElem()\n            if (!$linkElem) {\n                return\n            }\n\n            // \u5F39\u51FA panel\n            this.createPanel($linkElem.text(), $linkElem.attr('href'))\n        } else {\n            // \u83DC\u5355\u672A\u88AB\u6FC0\u6D3B\uFF0C\u8BF4\u660E\u9009\u533A\u4E0D\u5728\u94FE\u63A5\u91CC\n            if (editor.selection.isSelectionEmpty()) {\n                // \u9009\u533A\u662F\u7A7A\u7684\uFF0C\u672A\u9009\u4E2D\u5185\u5BB9\n                this.createPanel('', '')\n            } else {\n                // \u9009\u4E2D\u5185\u5BB9\u4E86\n                this.createPanel(editor.selection.getSelectionText(), '')\n            }\n        }\n    }\n\n    /**\n     * \u521B\u5EFA panel\n     * @param text \u6587\u672C\n     * @param link \u94FE\u63A5\n     */\n    private createPanel(text: string, link: string): void {\n        const conf = createPanelConf(this.editor, text, link)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355 active \u72B6\u6001\n     */\n    public tryChangeActive() {\n        const editor = this.editor\n        if (isActive(editor)) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Link\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "585507f6b7ba53420fc6a5808b57b6dd572251fc"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cjxxm3x2s = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1cjxxm3x2s();

var __extends = (cov_1cjxxm3x2s().s[0]++, (cov_1cjxxm3x2s().b[0][0]++, void 0) && (cov_1cjxxm3x2s().b[0][1]++, (void 0).__extends) || (cov_1cjxxm3x2s().b[0][2]++, function () {
  cov_1cjxxm3x2s().f[0]++;
  cov_1cjxxm3x2s().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1cjxxm3x2s().f[1]++;
    cov_1cjxxm3x2s().s[2]++;
    _extendStatics = (cov_1cjxxm3x2s().b[1][0]++, _setPrototypeOf["default"]) || (cov_1cjxxm3x2s().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1cjxxm3x2s().b[1][2]++, function (d, b) {
      cov_1cjxxm3x2s().f[2]++;
      cov_1cjxxm3x2s().s[3]++;
      d.__proto__ = b;
    }) || (cov_1cjxxm3x2s().b[1][3]++, function (d, b) {
      cov_1cjxxm3x2s().f[3]++;
      cov_1cjxxm3x2s().s[4]++;

      for (var p in b) {
        cov_1cjxxm3x2s().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1cjxxm3x2s().b[2][0]++;
          cov_1cjxxm3x2s().s[6]++;
          d[p] = b[p];
        } else {
          cov_1cjxxm3x2s().b[2][1]++;
        }
      }
    });
    cov_1cjxxm3x2s().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1cjxxm3x2s().s[8]++;
  return function (d, b) {
    cov_1cjxxm3x2s().f[4]++;
    cov_1cjxxm3x2s().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1cjxxm3x2s().f[5]++;
      cov_1cjxxm3x2s().s[10]++;
      this.constructor = d;
    }

    cov_1cjxxm3x2s().s[11]++;
    d.prototype = b === null ? (cov_1cjxxm3x2s().b[3][0]++, (0, _create["default"])(b)) : (cov_1cjxxm3x2s().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1cjxxm3x2s().s[12]++, (cov_1cjxxm3x2s().b[4][0]++, void 0) && (cov_1cjxxm3x2s().b[4][1]++, (void 0).__importDefault) || (cov_1cjxxm3x2s().b[4][2]++, function (mod) {
  cov_1cjxxm3x2s().f[6]++;
  cov_1cjxxm3x2s().s[13]++;
  return (cov_1cjxxm3x2s().b[6][0]++, mod) && (cov_1cjxxm3x2s().b[6][1]++, mod.__esModule) ? (cov_1cjxxm3x2s().b[5][0]++, mod) : (cov_1cjxxm3x2s().b[5][1]++, {
    "default": mod
  });
}));

cov_1cjxxm3x2s().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var PanelMenu_1 = (cov_1cjxxm3x2s().s[15]++, __importDefault(__webpack_require__(32)));
var dom_core_1 = (cov_1cjxxm3x2s().s[16]++, __importDefault(__webpack_require__(2)));
var create_panel_conf_1 = (cov_1cjxxm3x2s().s[17]++, __importDefault(__webpack_require__(311)));
var is_active_1 = (cov_1cjxxm3x2s().s[18]++, __importDefault(__webpack_require__(125)));
var Panel_1 = (cov_1cjxxm3x2s().s[19]++, __importDefault(__webpack_require__(28)));
var index_1 = (cov_1cjxxm3x2s().s[20]++, __importDefault(__webpack_require__(312)));
var Link = (
/** @class */
cov_1cjxxm3x2s().s[21]++, function (_super) {
  cov_1cjxxm3x2s().f[7]++;
  cov_1cjxxm3x2s().s[22]++;

  __extends(Link, _super);

  function Link(editor) {
    cov_1cjxxm3x2s().f[8]++;

    var _this = (cov_1cjxxm3x2s().s[23]++, this);

    var $elem = (cov_1cjxxm3x2s().s[24]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-link"></i></div>'));
    cov_1cjxxm3x2s().s[25]++;
    _this = (cov_1cjxxm3x2s().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1cjxxm3x2s().b[7][1]++, this); // 绑定事件，如点击链接时，可以查看链接

    cov_1cjxxm3x2s().s[26]++;
    index_1["default"](editor);
    cov_1cjxxm3x2s().s[27]++;
    return _this;
  }
  /**
   * 菜单点击事件
   */


  cov_1cjxxm3x2s().s[28]++;

  Link.prototype.clickHandler = function () {
    cov_1cjxxm3x2s().f[9]++;
    var editor = (cov_1cjxxm3x2s().s[29]++, this.editor);
    var $linkElem;
    cov_1cjxxm3x2s().s[30]++;

    if (this.isActive) {
      cov_1cjxxm3x2s().b[8][0]++;
      cov_1cjxxm3x2s().s[31]++;
      // 菜单被激活，说明选区在链接里
      $linkElem = editor.selection.getSelectionContainerElem();
      cov_1cjxxm3x2s().s[32]++;

      if (!$linkElem) {
        cov_1cjxxm3x2s().b[9][0]++;
        cov_1cjxxm3x2s().s[33]++;
        return;
      } else {
        cov_1cjxxm3x2s().b[9][1]++;
      } // 弹出 panel


      cov_1cjxxm3x2s().s[34]++;
      this.createPanel($linkElem.text(), $linkElem.attr('href'));
    } else {
      cov_1cjxxm3x2s().b[8][1]++;
      cov_1cjxxm3x2s().s[35]++;

      // 菜单未被激活，说明选区不在链接里
      if (editor.selection.isSelectionEmpty()) {
        cov_1cjxxm3x2s().b[10][0]++;
        cov_1cjxxm3x2s().s[36]++;
        // 选区是空的，未选中内容
        this.createPanel('', '');
      } else {
        cov_1cjxxm3x2s().b[10][1]++;
        cov_1cjxxm3x2s().s[37]++;
        // 选中内容了
        this.createPanel(editor.selection.getSelectionText(), '');
      }
    }
  };
  /**
   * 创建 panel
   * @param text 文本
   * @param link 链接
   */


  cov_1cjxxm3x2s().s[38]++;

  Link.prototype.createPanel = function (text, link) {
    cov_1cjxxm3x2s().f[10]++;
    var conf = (cov_1cjxxm3x2s().s[39]++, create_panel_conf_1["default"](this.editor, text, link));
    var panel = (cov_1cjxxm3x2s().s[40]++, new Panel_1["default"](this, conf));
    cov_1cjxxm3x2s().s[41]++;
    panel.create();
  };
  /**
   * 尝试修改菜单 active 状态
   */


  cov_1cjxxm3x2s().s[42]++;

  Link.prototype.tryChangeActive = function () {
    cov_1cjxxm3x2s().f[11]++;
    var editor = (cov_1cjxxm3x2s().s[43]++, this.editor);
    cov_1cjxxm3x2s().s[44]++;

    if (is_active_1["default"](editor)) {
      cov_1cjxxm3x2s().b[11][0]++;
      cov_1cjxxm3x2s().s[45]++;
      this.active();
    } else {
      cov_1cjxxm3x2s().b[11][1]++;
      cov_1cjxxm3x2s().s[46]++;
      this.unActive();
    }
  };

  cov_1cjxxm3x2s().s[47]++;
  return Link;
}(PanelMenu_1["default"]));
cov_1cjxxm3x2s().s[48]++;
exports["default"] = Link;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description link 菜单 panel tab 配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_axlmo78rm() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/link/create-panel-conf.ts";
  var hash = "ec9859d0cd6d4ce3945a6792c44269ce4169d618";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/link/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 18
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "6": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 52
        }
      },
      "7": {
        start: {
          line: 16,
          column: 22
        },
        end: {
          line: 16,
          column: 52
        }
      },
      "8": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 44
        }
      },
      "9": {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 18,
          column: 46
        }
      },
      "10": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 20,
          column: 77
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 27,
          column: 19
        }
      },
      "12": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 19
        }
      },
      "13": {
        start: {
          line: 28,
          column: 24
        },
        end: {
          line: 28,
          column: 68
        }
      },
      "14": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 30,
          column: 19
        }
      },
      "15": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 19
        }
      },
      "16": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 54
        }
      },
      "17": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 44
        }
      },
      "18": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 34
        }
      },
      "19": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "20": {
        start: {
          line: 43,
          column: 12
        },
        end: {
          line: 43,
          column: 29
        }
      },
      "21": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 103
        }
      },
      "22": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 103
        }
      },
      "23": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 57,
          column: 9
        }
      },
      "24": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 19
        }
      },
      "25": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 25
        }
      },
      "26": {
        start: {
          line: 61,
          column: 28
        },
        end: {
          line: 61,
          column: 48
        }
      },
      "27": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 74
        }
      },
      "28": {
        start: {
          line: 70,
          column: 20
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "29": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 81,
          column: 9
        }
      },
      "30": {
        start: {
          line: 74,
          column: 13
        },
        end: {
          line: 81,
          column: 9
        }
      },
      "31": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 76,
          column: 24
        }
      },
      "32": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 80,
          column: 25
        }
      },
      "33": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 21
        }
      },
      "34": {
        start: {
          line: 84,
          column: 15
        },
        end: {
          line: 134,
          column: 5
        }
      },
      "35": {
        start: {
          line: 102,
          column: 40
        },
        end: {
          line: 102,
          column: 77
        }
      },
      "36": {
        start: {
          line: 103,
          column: 40
        },
        end: {
          line: 103,
          column: 77
        }
      },
      "37": {
        start: {
          line: 104,
          column: 39
        },
        end: {
          line: 104,
          column: 57
        }
      },
      "38": {
        start: {
          line: 105,
          column: 39
        },
        end: {
          line: 105,
          column: 57
        }
      },
      "39": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 108,
          column: 39
        }
      },
      "40": {
        start: {
          line: 108,
          column: 32
        },
        end: {
          line: 108,
          column: 39
        }
      },
      "41": {
        start: {
          line: 110,
          column: 28
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "42": {
        start: {
          line: 111,
          column: 32
        },
        end: {
          line: 111,
          column: 44
        }
      },
      "43": {
        start: {
          line: 113,
          column: 28
        },
        end: {
          line: 114,
          column: 39
        }
      },
      "44": {
        start: {
          line: 114,
          column: 32
        },
        end: {
          line: 114,
          column: 39
        }
      },
      "45": {
        start: {
          line: 115,
          column: 28
        },
        end: {
          line: 115,
          column: 51
        }
      },
      "46": {
        start: {
          line: 117,
          column: 28
        },
        end: {
          line: 117,
          column: 40
        }
      },
      "47": {
        start: {
          line: 126,
          column: 28
        },
        end: {
          line: 126,
          column: 38
        }
      },
      "48": {
        start: {
          line: 128,
          column: 28
        },
        end: {
          line: 128,
          column: 40
        }
      },
      "49": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 16
        }
      },
      "50": {
        start: {
          line: 137,
          column: 0
        },
        end: {
          line: 137,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 18
          }
        },
        loc: {
          start: {
            line: 13,
            column: 39
          },
          end: {
            line: 136,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "selectLinkElem",
        decl: {
          start: {
            line: 25,
            column: 13
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 30
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 25
      },
      "3": {
        name: "insertLink",
        decl: {
          start: {
            line: 40,
            column: 13
          },
          end: {
            line: 40,
            column: 23
          }
        },
        loc: {
          start: {
            line: 40,
            column: 36
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 40
      },
      "4": {
        name: "delLink",
        decl: {
          start: {
            line: 54,
            column: 13
          },
          end: {
            line: 54,
            column: 20
          }
        },
        loc: {
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 54
      },
      "5": {
        name: "checkLink",
        decl: {
          start: {
            line: 68,
            column: 13
          },
          end: {
            line: 68,
            column: 22
          }
        },
        loc: {
          start: {
            line: 68,
            column: 35
          },
          end: {
            line: 83,
            column: 5
          }
        },
        line: 68
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 100,
            column: 28
          },
          end: {
            line: 100,
            column: 29
          }
        },
        loc: {
          start: {
            line: 100,
            column: 40
          },
          end: {
            line: 118,
            column: 25
          }
        },
        line: 100
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 124,
            column: 28
          },
          end: {
            line: 124,
            column: 29
          }
        },
        loc: {
          start: {
            line: 124,
            column: 40
          },
          end: {
            line: 129,
            column: 25
          }
        },
        line: 124
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 24
          },
          end: {
            line: 20,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 54
          },
          end: {
            line: 20,
            column: 68
          }
        }, {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 20,
            column: 77
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 27,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 27,
            column: 19
          }
        }, {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 27,
            column: 19
          }
        }],
        line: 26
      },
      "5": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 30,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 30,
            column: 19
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 30,
            column: 19
          }
        }],
        line: 29
      },
      "6": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 41
      },
      "7": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        }],
        line: 55
      },
      "8": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 81,
            column: 9
          }
        }],
        line: 71
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 13
          },
          end: {
            line: 81,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 13
          },
          end: {
            line: 81,
            column: 9
          }
        }, {
          start: {
            line: 74,
            column: 13
          },
          end: {
            line: 81,
            column: 9
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 108,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 108,
            column: 39
          }
        }, {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 108,
            column: 39
          }
        }],
        line: 107
      },
      "11": {
        loc: {
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 111,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 111,
            column: 44
          }
        }, {
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 111,
            column: 44
          }
        }],
        line: 110
      },
      "12": {
        loc: {
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 114,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 114,
            column: 39
          }
        }, {
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 114,
            column: 39
          }
        }],
        line: 113
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/link/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/link/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,yCAA4C;AAC5C,kEAAoD;AACpD,0DAAkC;AAElC,mBAAyB,MAAc,EAAE,IAAY,EAAE,IAAY;IAC/D,iBAAiB;IACjB,IAAM,WAAW,GAAG,gBAAS,CAAC,YAAY,CAAC,CAAA;IAC3C,IAAM,WAAW,GAAG,gBAAS,CAAC,YAAY,CAAC,CAAA;IAC3C,IAAM,OAAO,GAAG,gBAAS,CAAC,QAAQ,CAAC,CAAA;IACnC,IAAM,QAAQ,GAAG,gBAAS,CAAC,SAAS,CAAC,CAAA;IAErC,aAAa;IACb,IAAM,aAAa,GAAG,mBAAQ,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,cAAc,CAAC,CAAC,CAAC,MAAM,CAAA;IAEhE,IAAI,aAAyB,CAAA;IAE7B;;OAEG;IACH,SAAS,cAAc;QACnB,IAAI,CAAC,mBAAQ,CAAC,MAAM,CAAC;YAAE,OAAM;QAE7B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QAC9D,IAAI,CAAC,SAAS;YAAE,OAAM;QACtB,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,SAAS,CAAC,CAAA;QAC7C,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEnC,aAAa,GAAG,SAAS,CAAA,CAAC,aAAa;IAC3C,CAAC;IAED;;;;OAIG;IACH,SAAS,UAAU,CAAC,IAAY,EAAE,IAAY;QAC1C,IAAI,mBAAQ,CAAC,MAAM,CAAC,EAAE;YAClB,iCAAiC;YACjC,cAAc,EAAE,CAAA;YAChB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,eAAY,IAAI,6BAAqB,IAAI,SAAM,CAAC,CAAA;SAC/E;aAAM;YACH,kBAAkB;YAClB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,eAAY,IAAI,6BAAqB,IAAI,SAAM,CAAC,CAAA;SAC/E;IACL,CAAC;IAED;;OAEG;IACH,SAAS,OAAO;QACZ,IAAI,CAAC,mBAAQ,CAAC,MAAM,CAAC,EAAE;YACnB,OAAM;SACT;QACD,SAAS;QACT,cAAc,EAAE,CAAA;QAChB,UAAU;QACV,IAAM,aAAa,GAAG,aAAa,CAAC,IAAI,EAAE,CAAA;QAC1C,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,QAAQ,GAAG,aAAa,GAAG,SAAS,CAAC,CAAA;IACrE,CAAC;IAED;;;OAGG;IACH,SAAS,SAAS,CAAC,IAAY,EAAE,IAAY;QACzC,gBAAgB;QAChB,IAAM,KAAK,GAAG,MAAM,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACjD,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,6BAA6B;SAChC;aAAM,IAAI,KAAK,KAAK,IAAI,EAAE;YACvB,aAAa;YACb,OAAO,IAAI,CAAA;SACd;aAAM;YACH,6BAA6B;YAC7B,KAAK,CAAC,KAAK,CAAC,CAAA;SACf;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED,IAAM,IAAI,GAAG;QACT,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,CAAC;QAET,mBAAmB;QACnB,IAAI,EAAE;YACF;gBACI,UAAU;gBACV,KAAK,EAAE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,0BAA0B,CAAC;gBACnD,KAAK;gBACL,GAAG,EAAE,8EAEa,WAAW,2IAGR,IAAI,uDACE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,4BAA4B,CAAC,+GAGvD,WAAW,2IAGR,IAAI,uDACE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,GAAG,CAAC,gKAGtB,OAAO,6DACf,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,IAAI,CAAC,0FAEd,QAAQ,gDAAuC,aAAa,6CACpE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,4BAA4B,CAAC,wGAGrD;gBACX,OAAO;gBACP,MAAM,EAAE;oBACJ,OAAO;oBACP;wBACI,QAAQ,EAAE,GAAG,GAAG,OAAO;wBACvB,IAAI,EAAE,OAAO;wBACb,EAAE,EAAE;4BACA,SAAS;4BACT,IAAM,KAAK,GAAG,kBAAC,CAAC,GAAG,GAAG,WAAW,CAAC,CAAA;4BAClC,IAAM,KAAK,GAAG,kBAAC,CAAC,GAAG,GAAG,WAAW,CAAC,CAAA;4BAClC,IAAI,IAAI,GAAG,KAAK,CAAC,GAAG,EAAE,CAAC,IAAI,EAAE,CAAA;4BAC7B,IAAI,IAAI,GAAG,KAAK,CAAC,GAAG,EAAE,CAAC,IAAI,EAAE,CAAA;4BAE7B,YAAY;4BACZ,IAAI,CAAC,IAAI;gCAAE,OAAM;4BACjB,cAAc;4BACd,IAAI,CAAC,IAAI;gCAAE,IAAI,GAAG,IAAI,CAAA;4BACtB,yBAAyB;4BACzB,IAAI,CAAC,SAAS,CAAC,IAAI,EAAE,IAAI,CAAC;gCAAE,OAAM;4BAClC,UAAU,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;4BAEtB,6CAA6C;4BAC7C,OAAO,IAAI,CAAA;wBACf,CAAC;qBACJ;oBACD,OAAO;oBACP;wBACI,QAAQ,EAAE,GAAG,GAAG,QAAQ;wBACxB,IAAI,EAAE,OAAO;wBACb,EAAE,EAAE;4BACA,SAAS;4BACT,OAAO,EAAE,CAAA;4BAET,6CAA6C;4BAC7C,OAAO,IAAI,CAAA;wBACf,CAAC;qBACJ;iBACJ;aACJ;SACJ;KACJ,CAAA;IAED,OAAO,IAAI,CAAA;AACf,CAAC;AAxJD,4BAwJC",
      sourcesContent: ["/**\n * @description link \u83DC\u5355 panel tab \u914D\u7F6E\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf } from '../menu-constructors/Panel'\nimport { getRandom } from '../../utils/util'\nimport $, { DomElement } from '../../utils/dom-core'\nimport isActive from './is-active'\n\nexport default function (editor: Editor, text: string, link: string): PanelConf {\n    // panel \u4E2D\u9700\u8981\u7528\u5230\u7684id\n    const inputLinkId = getRandom('input-link')\n    const inputTextId = getRandom('input-text')\n    const btnOkId = getRandom('btn-ok')\n    const btnDelId = getRandom('btn-del')\n\n    // \u662F\u5426\u663E\u793A\u201C\u53D6\u6D88\u94FE\u63A5\u201D\n    const delBtnDisplay = isActive(editor) ? 'inline-block' : 'none'\n\n    let $selectedLink: DomElement\n\n    /**\n     * \u9009\u4E2D\u6574\u4E2A\u94FE\u63A5\u5143\u7D20\n     */\n    function selectLinkElem(): void {\n        if (!isActive(editor)) return\n\n        const $linkElem = editor.selection.getSelectionContainerElem()\n        if (!$linkElem) return\n        editor.selection.createRangeByElem($linkElem)\n        editor.selection.restoreSelection()\n\n        $selectedLink = $linkElem // \u8D4B\u503C\u7ED9\u51FD\u6570\u5185\u5168\u5C40\u53D8\u91CF\n    }\n\n    /**\n     * \u63D2\u5165\u94FE\u63A5\n     * @param text \u6587\u5B57\n     * @param link \u94FE\u63A5\n     */\n    function insertLink(text: string, link: string): void {\n        if (isActive(editor)) {\n            // \u9009\u533A\u5904\u4E8E\u94FE\u63A5\u4E2D\uFF0C\u5219\u9009\u4E2D\u6574\u4E2A\u83DC\u5355\uFF0C\u518D\u6267\u884C insertHTML\n            selectLinkElem()\n            editor.cmd.do('insertHTML', `<a href=\"${link}\" target=\"_blank\">${text}</a>`)\n        } else {\n            // \u9009\u533A\u672A\u5904\u4E8E\u94FE\u63A5\u4E2D\uFF0C\u76F4\u63A5\u63D2\u5165\u5373\u53EF\n            editor.cmd.do('insertHTML', `<a href=\"${link}\" target=\"_blank\">${text}</a>`)\n        }\n    }\n\n    /**\n     * \u53D6\u6D88\u94FE\u63A5\n     */\n    function delLink(): void {\n        if (!isActive(editor)) {\n            return\n        }\n        // \u9009\u4E2D\u6574\u4E2A\u94FE\u63A5\n        selectLinkElem()\n        // \u7528\u6587\u672C\u66FF\u6362\u94FE\u63A5\n        const selectionText = $selectedLink.text()\n        editor.cmd.do('insertHTML', '<span>' + selectionText + '</span>')\n    }\n\n    /**\n     * \u6821\u9A8C\u94FE\u63A5\u662F\u5426\u5408\u6CD5\n     * @param link \u94FE\u63A5\n     */\n    function checkLink(text: string, link: string): boolean {\n        //\u67E5\u770B\u5F00\u53D1\u8005\u81EA\u5B9A\u4E49\u914D\u7F6E\u7684\u8FD4\u56DE\u503C\n        const check = editor.config.linkCheck(text, link)\n        if (check === undefined) {\n            //\u7528\u6237\u672A\u80FD\u901A\u8FC7\u5F00\u53D1\u8005\u7684\u6821\u9A8C\uFF0C\u4E14\u5F00\u53D1\u8005\u4E0D\u5E0C\u671B\u7F16\u8F91\u5668\u63D0\u793A\u7528\u6237\n        } else if (check === true) {\n            //\u7528\u6237\u901A\u8FC7\u4E86\u5F00\u53D1\u8005\u7684\u6821\u9A8C\n            return true\n        } else {\n            //\u7528\u6237\u672A\u80FD\u901A\u8FC7\u5F00\u53D1\u8005\u7684\u6821\u9A8C\uFF0C\u5F00\u53D1\u8005\u5E0C\u671B\u6211\u4EEC\u63D0\u793A\u8FD9\u4E00\u5B57\u7B26\u4E32\n            alert(check)\n        }\n        return false\n    }\n\n    const conf = {\n        width: 300,\n        height: 0,\n\n        // panel \u4E2D\u53EF\u5305\u542B\u591A\u4E2A tab\n        tabs: [\n            {\n                // tab \u7684\u6807\u9898\n                title: editor.i18next.t('menus.panelMenus.link.\u94FE\u63A5'),\n                // \u6A21\u677F\n                tpl: `<div>\n                        <input \n                            id=\"${inputTextId}\" \n                            type=\"text\" \n                            class=\"block\" \n                            value=\"${text}\" \n                            placeholder=\"${editor.i18next.t('menus.panelMenus.link.\u94FE\u63A5\u6587\u5B57')}\"/>\n                        </td>\n                        <input \n                            id=\"${inputLinkId}\" \n                            type=\"text\" \n                            class=\"block\" \n                            value=\"${link}\" \n                            placeholder=\"${editor.i18next.t('\u5982')} https://...\"/>\n                        </td>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"${btnOkId}\" class=\"right\">\n                                ${editor.i18next.t('\u63D2\u5165')}\n                            </button>\n                            <button id=\"${btnDelId}\" class=\"gray right\" style=\"display:${delBtnDisplay}\">\n                                ${editor.i18next.t('menus.panelMenus.link.\u53D6\u6D88\u94FE\u63A5')}\n                            </button>\n                        </div>\n                    </div>`,\n                // \u4E8B\u4EF6\u7ED1\u5B9A\n                events: [\n                    // \u63D2\u5165\u94FE\u63A5\n                    {\n                        selector: '#' + btnOkId,\n                        type: 'click',\n                        fn: () => {\n                            // \u6267\u884C\u63D2\u5165\u94FE\u63A5\n                            const $link = $('#' + inputLinkId)\n                            const $text = $('#' + inputTextId)\n                            let link = $link.val().trim()\n                            let text = $text.val().trim()\n\n                            // \u94FE\u63A5\u4E3A\u7A7A\uFF0C\u5219\u4E0D\u63D2\u5165\n                            if (!link) return\n                            // \u6587\u672C\u4E3A\u7A7A\uFF0C\u5219\u7528\u94FE\u63A5\u4EE3\u66FF\n                            if (!text) text = link\n                            // \u6821\u9A8C\u94FE\u63A5\u662F\u5426\u6EE1\u8DB3\u7528\u6237\u7684\u89C4\u5219\uFF0C\u82E5\u4E0D\u6EE1\u8DB3\u5219\u4E0D\u63D2\u5165\n                            if (!checkLink(text, link)) return\n                            insertLink(text, link)\n\n                            // \u8FD4\u56DE true\uFF0C\u8868\u793A\u8BE5\u4E8B\u4EF6\u6267\u884C\u5B8C\u4E4B\u540E\uFF0Cpanel \u8981\u5173\u95ED\u3002\u5426\u5219 panel \u4E0D\u4F1A\u5173\u95ED\n                            return true\n                        },\n                    },\n                    // \u53D6\u6D88\u94FE\u63A5\n                    {\n                        selector: '#' + btnDelId,\n                        type: 'click',\n                        fn: () => {\n                            // \u6267\u884C\u53D6\u6D88\u94FE\u63A5\n                            delLink()\n\n                            // \u8FD4\u56DE true\uFF0C\u8868\u793A\u8BE5\u4E8B\u4EF6\u6267\u884C\u5B8C\u4E4B\u540E\uFF0Cpanel \u8981\u5173\u95ED\u3002\u5426\u5219 panel \u4E0D\u4F1A\u5173\u95ED\n                            return true\n                        },\n                    },\n                ],\n            }, // tab end\n        ], // tabs end\n    }\n\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ec9859d0cd6d4ce3945a6792c44269ce4169d618"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_axlmo78rm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_axlmo78rm();

var __importDefault = (cov_axlmo78rm().s[0]++, (cov_axlmo78rm().b[0][0]++, void 0) && (cov_axlmo78rm().b[0][1]++, (void 0).__importDefault) || (cov_axlmo78rm().b[0][2]++, function (mod) {
  cov_axlmo78rm().f[0]++;
  cov_axlmo78rm().s[1]++;
  return (cov_axlmo78rm().b[2][0]++, mod) && (cov_axlmo78rm().b[2][1]++, mod.__esModule) ? (cov_axlmo78rm().b[1][0]++, mod) : (cov_axlmo78rm().b[1][1]++, {
    "default": mod
  });
}));

cov_axlmo78rm().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_axlmo78rm().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_axlmo78rm().s[4]++, __importDefault(__webpack_require__(2)));
var is_active_1 = (cov_axlmo78rm().s[5]++, __importDefault(__webpack_require__(125)));

function default_1(editor, text, link) {
  cov_axlmo78rm().f[1]++;
  // panel 中需要用到的id
  var inputLinkId = (cov_axlmo78rm().s[6]++, util_1.getRandom('input-link'));
  var inputTextId = (cov_axlmo78rm().s[7]++, util_1.getRandom('input-text'));
  var btnOkId = (cov_axlmo78rm().s[8]++, util_1.getRandom('btn-ok'));
  var btnDelId = (cov_axlmo78rm().s[9]++, util_1.getRandom('btn-del')); // 是否显示“取消链接”

  var delBtnDisplay = (cov_axlmo78rm().s[10]++, is_active_1["default"](editor) ? (cov_axlmo78rm().b[3][0]++, 'inline-block') : (cov_axlmo78rm().b[3][1]++, 'none'));
  var $selectedLink;
  /**
   * 选中整个链接元素
   */

  function selectLinkElem() {
    cov_axlmo78rm().f[2]++;
    cov_axlmo78rm().s[11]++;

    if (!is_active_1["default"](editor)) {
      cov_axlmo78rm().b[4][0]++;
      cov_axlmo78rm().s[12]++;
      return;
    } else {
      cov_axlmo78rm().b[4][1]++;
    }

    var $linkElem = (cov_axlmo78rm().s[13]++, editor.selection.getSelectionContainerElem());
    cov_axlmo78rm().s[14]++;

    if (!$linkElem) {
      cov_axlmo78rm().b[5][0]++;
      cov_axlmo78rm().s[15]++;
      return;
    } else {
      cov_axlmo78rm().b[5][1]++;
    }

    cov_axlmo78rm().s[16]++;
    editor.selection.createRangeByElem($linkElem);
    cov_axlmo78rm().s[17]++;
    editor.selection.restoreSelection();
    cov_axlmo78rm().s[18]++;
    $selectedLink = $linkElem; // 赋值给函数内全局变量
  }
  /**
   * 插入链接
   * @param text 文字
   * @param link 链接
   */


  function insertLink(text, link) {
    cov_axlmo78rm().f[3]++;
    cov_axlmo78rm().s[19]++;

    if (is_active_1["default"](editor)) {
      cov_axlmo78rm().b[6][0]++;
      cov_axlmo78rm().s[20]++;
      // 选区处于链接中，则选中整个菜单，再执行 insertHTML
      selectLinkElem();
      cov_axlmo78rm().s[21]++;
      editor.cmd["do"]('insertHTML', "<a href=\"" + link + "\" target=\"_blank\">" + text + "</a>");
    } else {
      cov_axlmo78rm().b[6][1]++;
      cov_axlmo78rm().s[22]++;
      // 选区未处于链接中，直接插入即可
      editor.cmd["do"]('insertHTML', "<a href=\"" + link + "\" target=\"_blank\">" + text + "</a>");
    }
  }
  /**
   * 取消链接
   */


  function delLink() {
    cov_axlmo78rm().f[4]++;
    cov_axlmo78rm().s[23]++;

    if (!is_active_1["default"](editor)) {
      cov_axlmo78rm().b[7][0]++;
      cov_axlmo78rm().s[24]++;
      return;
    } else {
      cov_axlmo78rm().b[7][1]++;
    } // 选中整个链接


    cov_axlmo78rm().s[25]++;
    selectLinkElem(); // 用文本替换链接

    var selectionText = (cov_axlmo78rm().s[26]++, $selectedLink.text());
    cov_axlmo78rm().s[27]++;
    editor.cmd["do"]('insertHTML', '<span>' + selectionText + '</span>');
  }
  /**
   * 校验链接是否合法
   * @param link 链接
   */


  function checkLink(text, link) {
    cov_axlmo78rm().f[5]++;
    //查看开发者自定义配置的返回值
    var check = (cov_axlmo78rm().s[28]++, editor.config.linkCheck(text, link));
    cov_axlmo78rm().s[29]++;

    if (check === undefined) {//用户未能通过开发者的校验，且开发者不希望编辑器提示用户

      cov_axlmo78rm().b[8][0]++;
    } else {
      cov_axlmo78rm().b[8][1]++;
      cov_axlmo78rm().s[30]++;

      if (check === true) {
        cov_axlmo78rm().b[9][0]++;
        cov_axlmo78rm().s[31]++;
        //用户通过了开发者的校验
        return true;
      } else {
        cov_axlmo78rm().b[9][1]++;
        cov_axlmo78rm().s[32]++;
        //用户未能通过开发者的校验，开发者希望我们提示这一字符串
        alert(check);
      }
    }

    cov_axlmo78rm().s[33]++;
    return false;
  }

  var conf = (cov_axlmo78rm().s[34]++, {
    width: 300,
    height: 0,
    // panel 中可包含多个 tab
    tabs: [{
      // tab 的标题
      title: editor.i18next.t('menus.panelMenus.link.链接'),
      // 模板
      tpl: "<div>\n                        <input \n                            id=\"" + inputTextId + "\" \n                            type=\"text\" \n                            class=\"block\" \n                            value=\"" + text + "\" \n                            placeholder=\"" + editor.i18next.t('menus.panelMenus.link.链接文字') + "\"/>\n                        </td>\n                        <input \n                            id=\"" + inputLinkId + "\" \n                            type=\"text\" \n                            class=\"block\" \n                            value=\"" + link + "\" \n                            placeholder=\"" + editor.i18next.t('如') + " https://...\"/>\n                        </td>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"" + btnOkId + "\" class=\"right\">\n                                " + editor.i18next.t('插入') + "\n                            </button>\n                            <button id=\"" + btnDelId + "\" class=\"gray right\" style=\"display:" + delBtnDisplay + "\">\n                                " + editor.i18next.t('menus.panelMenus.link.取消链接') + "\n                            </button>\n                        </div>\n                    </div>",
      // 事件绑定
      events: [// 插入链接
      {
        selector: '#' + btnOkId,
        type: 'click',
        fn: function fn() {
          var _context, _context2;

          cov_axlmo78rm().f[6]++;
          // 执行插入链接
          var $link = (cov_axlmo78rm().s[35]++, dom_core_1["default"]('#' + inputLinkId));
          var $text = (cov_axlmo78rm().s[36]++, dom_core_1["default"]('#' + inputTextId));
          var link = (cov_axlmo78rm().s[37]++, (0, _trim["default"])(_context = $link.val()).call(_context));
          var text = (cov_axlmo78rm().s[38]++, (0, _trim["default"])(_context2 = $text.val()).call(_context2)); // 链接为空，则不插入

          cov_axlmo78rm().s[39]++;

          if (!link) {
            cov_axlmo78rm().b[10][0]++;
            cov_axlmo78rm().s[40]++;
            return;
          } else {
            cov_axlmo78rm().b[10][1]++;
          } // 文本为空，则用链接代替


          cov_axlmo78rm().s[41]++;

          if (!text) {
            cov_axlmo78rm().b[11][0]++;
            cov_axlmo78rm().s[42]++;
            text = link;
          } else {
            cov_axlmo78rm().b[11][1]++;
          } // 校验链接是否满足用户的规则，若不满足则不插入


          cov_axlmo78rm().s[43]++;

          if (!checkLink(text, link)) {
            cov_axlmo78rm().b[12][0]++;
            cov_axlmo78rm().s[44]++;
            return;
          } else {
            cov_axlmo78rm().b[12][1]++;
          }

          cov_axlmo78rm().s[45]++;
          insertLink(text, link); // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭

          cov_axlmo78rm().s[46]++;
          return true;
        }
      }, // 取消链接
      {
        selector: '#' + btnDelId,
        type: 'click',
        fn: function fn() {
          cov_axlmo78rm().f[7]++;
          cov_axlmo78rm().s[47]++;
          // 执行取消链接
          delLink(); // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭

          cov_axlmo78rm().s[48]++;
          return true;
        }
      }]
    }]
  });
  cov_axlmo78rm().s[49]++;
  return conf;
}

cov_axlmo78rm().s[50]++;
exports["default"] = default_1;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 绑定链接元素的事件，入口
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2hfmhbv7l6() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/index.ts";
  var hash = "440b93cd57041d0ee0f789c288aa9e31d4168650";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "5": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 18
          }
        },
        loc: {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAA8C;AAE9C;;;GAGG;AACH,SAAS,SAAS,CAAC,MAAc;IAC7B,aAAa;IACb,uBAAgB,CAAC,MAAM,CAAC,CAAA;AAC5B,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u94FE\u63A5\u5143\u7D20\u7684\u4E8B\u4EF6\uFF0C\u5165\u53E3\n * @author wangfupeng\n */\n\nimport Editor from '../../../editor/index'\nimport bindTooltipEvent from './tooltip-event'\n\n/**\n * \u7ED1\u5B9A\u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindEvent(editor: Editor) {\n    // tooltip \u4E8B\u4EF6\n    bindTooltipEvent(editor)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "440b93cd57041d0ee0f789c288aa9e31d4168650"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hfmhbv7l6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2hfmhbv7l6();

var __importDefault = (cov_2hfmhbv7l6().s[0]++, (cov_2hfmhbv7l6().b[0][0]++, void 0) && (cov_2hfmhbv7l6().b[0][1]++, (void 0).__importDefault) || (cov_2hfmhbv7l6().b[0][2]++, function (mod) {
  cov_2hfmhbv7l6().f[0]++;
  cov_2hfmhbv7l6().s[1]++;
  return (cov_2hfmhbv7l6().b[2][0]++, mod) && (cov_2hfmhbv7l6().b[2][1]++, mod.__esModule) ? (cov_2hfmhbv7l6().b[1][0]++, mod) : (cov_2hfmhbv7l6().b[1][1]++, {
    "default": mod
  });
}));

cov_2hfmhbv7l6().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var tooltip_event_1 = (cov_2hfmhbv7l6().s[3]++, __importDefault(__webpack_require__(313)));
/**
 * 绑定事件
 * @param editor 编辑器实例
 */

function bindEvent(editor) {
  cov_2hfmhbv7l6().f[1]++;
  cov_2hfmhbv7l6().s[4]++;
  // tooltip 事件
  tooltip_event_1["default"](editor);
}

cov_2hfmhbv7l6().s[5]++;
exports["default"] = bindEvent;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description tooltip 事件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_20l72dgj7j() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/tooltip-event.ts";
  var hash = "cb3297f6e4d485eaeeccc5d58fac94c1deab4dc6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/tooltip-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 75
        }
      },
      "5": {
        start: {
          line: 22,
          column: 19
        },
        end: {
          line: 45,
          column: 9
        }
      },
      "6": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 26,
          column: 49
        }
      },
      "7": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 49
        }
      },
      "8": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 32
        }
      },
      "9": {
        start: {
          line: 36,
          column: 20
        },
        end: {
          line: 36,
          column: 62
        }
      },
      "10": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 37,
          column: 56
        }
      },
      "11": {
        start: {
          line: 39,
          column: 40
        },
        end: {
          line: 39,
          column: 52
        }
      },
      "12": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 86
        }
      },
      "13": {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 42,
          column: 32
        }
      },
      "14": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 61
        }
      },
      "15": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 25
        }
      },
      "16": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      "17": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 29
        }
      },
      "18": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 27
        }
      },
      "19": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "20": {
        start: {
          line: 70,
          column: 13
        },
        end: {
          line: 70,
          column: 37
        }
      },
      "21": {
        start: {
          line: 70,
          column: 57
        },
        end: {
          line: 70,
          column: 75
        }
      },
      "22": {
        start: {
          line: 70,
          column: 95
        },
        end: {
          line: 70,
          column: 113
        }
      },
      "23": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 64
        }
      },
      "24": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 60
        }
      },
      "25": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 60
        }
      },
      "26": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 67
        }
      },
      "27": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 64
        }
      },
      "28": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 65
        }
      },
      "29": {
        start: {
          line: 80,
          column: 0
        },
        end: {
          line: 80,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 25
          }
        },
        loc: {
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "showLinkTooltip",
        decl: {
          start: {
            line: 21,
            column: 13
          },
          end: {
            line: 21,
            column: 28
          }
        },
        loc: {
          start: {
            line: 21,
            column: 36
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 25
          },
          end: {
            line: 25,
            column: 26
          }
        },
        loc: {
          start: {
            line: 25,
            column: 50
          },
          end: {
            line: 30,
            column: 17
          }
        },
        line: 25
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 34,
            column: 25
          },
          end: {
            line: 34,
            column: 26
          }
        },
        loc: {
          start: {
            line: 34,
            column: 50
          },
          end: {
            line: 43,
            column: 17
          }
        },
        line: 34
      },
      "5": {
        name: "hideLinkTooltip",
        decl: {
          start: {
            line: 53,
            column: 13
          },
          end: {
            line: 53,
            column: 28
          }
        },
        loc: {
          start: {
            line: 53,
            column: 31
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 53
      },
      "6": {
        name: "bindTooltipEvent",
        decl: {
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 25
          }
        },
        loc: {
          start: {
            line: 69,
            column: 34
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 69
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 55
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/tooltip-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/link/bind-event/tooltip-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,qEAAuD;AACvD,4EAA0E;AAG1E;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAI,OAAuB,CAAA;IAE3B;;;OAGG;IACH,SAAS,eAAe,CAAC,KAAiB;QACtC,IAAM,IAAI,GAAoB;YAC1B;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,4BAA4B,CAAC,YAAS,CAAC;gBAC1E,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,IAAM,IAAI,GAAG,KAAK,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;oBAC/B,MAAM,CAAC,IAAI,CAAC,IAAI,EAAE,SAAS,CAAC,CAAA;oBAE5B,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,4BAA4B,CAAC,YAAS,CAAC;gBAC1E,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,WAAW;oBACX,IAAM,aAAa,GAAG,KAAK,CAAC,IAAI,EAAE,CAAA;oBAClC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,QAAQ,GAAG,aAAa,GAAG,SAAS,CAAC,CAAA;oBAEjE,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;SACJ,CAAA;QAED,aAAa;QACb,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,EAAE,KAAK,EAAE,IAAI,CAAC,CAAA;QAC1C,OAAO,CAAC,MAAM,EAAE,CAAA;IACpB,CAAC;IAED;;OAEG;IACH,SAAS,eAAe;QACpB,aAAa;QACb,IAAI,OAAO,EAAE;YACT,OAAO,CAAC,MAAM,EAAE,CAAA;YAChB,OAAO,GAAG,IAAI,CAAA;SACjB;IACL,CAAC;IAED,OAAO;QACH,eAAe,iBAAA;QACf,eAAe,iBAAA;KAClB,CAAA;AACL,CAAC;AAED;;;GAGG;AACH,SAAS,gBAAgB,CAAC,MAAc;IAC9B,IAAA,KAAuC,gBAAgB,CAAC,MAAM,CAAC,EAA7D,eAAe,qBAAA,EAAE,eAAe,qBAA6B,CAAA;IAErE,qBAAqB;IACrB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAE3D,0BAA0B;IAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IACvD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IACvD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAC9D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAC3D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;AAChE,CAAC;AAED,kBAAe,gBAAgB,CAAA",
      sourcesContent: ["/**\n * @description tooltip \u4E8B\u4EF6\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../../../utils/dom-core'\nimport Tooltip, { TooltipConfType } from '../../menu-constructors/Tooltip'\nimport Editor from '../../../editor/index'\n\n/**\n * \u751F\u6210 Tooltip \u7684\u663E\u793A\u9690\u85CF\u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    let tooltip: Tooltip | null\n\n    /**\n     * \u663E\u793A tooltip\n     * @param $link \u94FE\u63A5\u5143\u7D20\n     */\n    function showLinkTooltip($link: DomElement) {\n        const conf: TooltipConfType = [\n            {\n                $elem: $(`<span>${editor.i18next.t('menus.panelMenus.link.\u67E5\u770B\u94FE\u63A5')}</span>`),\n                onClick: (editor: Editor, $link: DomElement) => {\n                    const link = $link.attr('href')\n                    window.open(link, '_target')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${editor.i18next.t('menus.panelMenus.link.\u53D6\u6D88\u94FE\u63A5')}</span>`),\n                onClick: (editor: Editor, $link: DomElement) => {\n                    // \u9009\u4E2D\u94FE\u63A5\u5143\u7D20\n                    editor.selection.createRangeByElem($link)\n                    editor.selection.restoreSelection()\n\n                    // \u7528\u6587\u5B57\uFF0C\u66FF\u6362\u94FE\u63A5\n                    const selectionText = $link.text()\n                    editor.cmd.do('insertHTML', '<span>' + selectionText + '</span>')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n        ]\n\n        // \u521B\u5EFA tooltip\n        tooltip = new Tooltip(editor, $link, conf)\n        tooltip.create()\n    }\n\n    /**\n     * \u9690\u85CF tooltip\n     */\n    function hideLinkTooltip() {\n        // \u79FB\u9664 tooltip\n        if (tooltip) {\n            tooltip.remove()\n            tooltip = null\n        }\n    }\n\n    return {\n        showLinkTooltip,\n        hideLinkTooltip,\n    }\n}\n\n/**\n * \u7ED1\u5B9A tooltip \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindTooltipEvent(editor: Editor) {\n    const { showLinkTooltip, hideLinkTooltip } = createShowHideFn(editor)\n\n    // \u70B9\u51FB\u94FE\u63A5\u5143\u7D20\u662F\uFF0C\u663E\u793A tooltip\n    editor.txt.eventHooks.linkClickEvents.push(showLinkTooltip)\n\n    // \u70B9\u51FB\u5176\u4ED6\u5730\u65B9\uFF0C\u6216\u8005\u6EDA\u52A8\u65F6\uFF0C\u9690\u85CF tooltip\n    editor.txt.eventHooks.clickEvents.push(hideLinkTooltip)\n    editor.txt.eventHooks.keyupEvents.push(hideLinkTooltip)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideLinkTooltip)\n    editor.txt.eventHooks.menuClickEvents.push(hideLinkTooltip)\n    editor.txt.eventHooks.textScrollEvents.push(hideLinkTooltip)\n}\n\nexport default bindTooltipEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cb3297f6e4d485eaeeccc5d58fac94c1deab4dc6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20l72dgj7j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_20l72dgj7j();

var __importDefault = (cov_20l72dgj7j().s[0]++, (cov_20l72dgj7j().b[0][0]++, void 0) && (cov_20l72dgj7j().b[0][1]++, (void 0).__importDefault) || (cov_20l72dgj7j().b[0][2]++, function (mod) {
  cov_20l72dgj7j().f[0]++;
  cov_20l72dgj7j().s[1]++;
  return (cov_20l72dgj7j().b[2][0]++, mod) && (cov_20l72dgj7j().b[2][1]++, mod.__esModule) ? (cov_20l72dgj7j().b[1][0]++, mod) : (cov_20l72dgj7j().b[1][1]++, {
    "default": mod
  });
}));

cov_20l72dgj7j().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_20l72dgj7j().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip_1 = (cov_20l72dgj7j().s[4]++, __importDefault(__webpack_require__(43)));
/**
 * 生成 Tooltip 的显示隐藏函数
 */

function createShowHideFn(editor) {
  cov_20l72dgj7j().f[1]++;
  var tooltip;
  /**
   * 显示 tooltip
   * @param $link 链接元素
   */

  function showLinkTooltip($link) {
    cov_20l72dgj7j().f[2]++;
    var conf = (cov_20l72dgj7j().s[5]++, [{
      $elem: dom_core_1["default"]("<span>" + editor.i18next.t('menus.panelMenus.link.查看链接') + "</span>"),
      onClick: function onClick(editor, $link) {
        cov_20l72dgj7j().f[3]++;
        var link = (cov_20l72dgj7j().s[6]++, $link.attr('href'));
        cov_20l72dgj7j().s[7]++;
        window.open(link, '_target'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_20l72dgj7j().s[8]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + editor.i18next.t('menus.panelMenus.link.取消链接') + "</span>"),
      onClick: function onClick(editor, $link) {
        cov_20l72dgj7j().f[4]++;
        cov_20l72dgj7j().s[9]++;
        // 选中链接元素
        editor.selection.createRangeByElem($link);
        cov_20l72dgj7j().s[10]++;
        editor.selection.restoreSelection(); // 用文字，替换链接

        var selectionText = (cov_20l72dgj7j().s[11]++, $link.text());
        cov_20l72dgj7j().s[12]++;
        editor.cmd["do"]('insertHTML', '<span>' + selectionText + '</span>'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_20l72dgj7j().s[13]++;
        return true;
      }
    }]); // 创建 tooltip

    cov_20l72dgj7j().s[14]++;
    tooltip = new Tooltip_1["default"](editor, $link, conf);
    cov_20l72dgj7j().s[15]++;
    tooltip.create();
  }
  /**
   * 隐藏 tooltip
   */


  function hideLinkTooltip() {
    cov_20l72dgj7j().f[5]++;
    cov_20l72dgj7j().s[16]++;

    // 移除 tooltip
    if (tooltip) {
      cov_20l72dgj7j().b[3][0]++;
      cov_20l72dgj7j().s[17]++;
      tooltip.remove();
      cov_20l72dgj7j().s[18]++;
      tooltip = null;
    } else {
      cov_20l72dgj7j().b[3][1]++;
    }
  }

  cov_20l72dgj7j().s[19]++;
  return {
    showLinkTooltip: showLinkTooltip,
    hideLinkTooltip: hideLinkTooltip
  };
}
/**
 * 绑定 tooltip 事件
 * @param editor 编辑器实例
 */


function bindTooltipEvent(editor) {
  cov_20l72dgj7j().f[6]++;

  var _a = (cov_20l72dgj7j().s[20]++, createShowHideFn(editor)),
      showLinkTooltip = (cov_20l72dgj7j().s[21]++, _a.showLinkTooltip),
      hideLinkTooltip = (cov_20l72dgj7j().s[22]++, _a.hideLinkTooltip); // 点击链接元素是，显示 tooltip


  cov_20l72dgj7j().s[23]++;
  editor.txt.eventHooks.linkClickEvents.push(showLinkTooltip); // 点击其他地方，或者滚动时，隐藏 tooltip

  cov_20l72dgj7j().s[24]++;
  editor.txt.eventHooks.clickEvents.push(hideLinkTooltip);
  cov_20l72dgj7j().s[25]++;
  editor.txt.eventHooks.keyupEvents.push(hideLinkTooltip);
  cov_20l72dgj7j().s[26]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideLinkTooltip);
  cov_20l72dgj7j().s[27]++;
  editor.txt.eventHooks.menuClickEvents.push(hideLinkTooltip);
  cov_20l72dgj7j().s[28]++;
  editor.txt.eventHooks.textScrollEvents.push(hideLinkTooltip);
}

cov_20l72dgj7j().s[29]++;
exports["default"] = bindTooltipEvent;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 斜体
 * @author liuwei
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_26r0ln8kpx() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/italic/index.ts";
  var hash = "81bb4960fe2567651887098a038fea24fa319b60";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/italic/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 72
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 28
        },
        end: {
          line: 64,
          column: 20
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 30
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 137
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "24": {
        start: {
          line: 37,
          column: 21
        },
        end: {
          line: 37,
          column: 32
        }
      },
      "25": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 38,
          column: 63
        }
      },
      "26": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "27": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "28": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 32
        }
      },
      "29": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "30": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 45
        }
      },
      "31": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "32": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "33": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "34": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "35": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "36": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 28
        }
      },
      "37": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 18
        }
      },
      "38": {
        start: {
          line: 65,
          column: 0
        },
        end: {
          line: 65,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 29
          }
        },
        loc: {
          start: {
            line: 25,
            column: 46
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "Italic",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 19
          }
        },
        loc: {
          start: {
            line: 27,
            column: 28
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 36
          },
          end: {
            line: 36,
            column: 37
          }
        },
        loc: {
          start: {
            line: 36,
            column: 48
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 54,
            column: 40
          }
        },
        loc: {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 52
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }],
        line: 39
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/italic/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/italic/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,yEAAkD;AAClD,kEAAoC;AAIpC;IAAqB,0BAAO;IACxB,gBAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,iGAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,6BAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEzD,IAAI,aAAa,EAAE;YACf,sBAAsB;YACtB,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;QAED,eAAe;QACf,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,QAAQ,CAAC,CAAA;QAEvB,IAAI,aAAa,EAAE;YACf,cAAc;YACd,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;YAChC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IAED;;OAEG;IACI,gCAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,QAAQ,CAAC,EAAE;YACxC,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,aAAC;AAAD,CAAC,AA3CD,CAAqB,iBAAO,GA2C3B;AAED,kBAAe,MAAM,CAAA",
      sourcesContent: ["/**\n * @description \u659C\u4F53\n * @author liuwei\n */\n\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Italic extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-italic\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const isSelectEmpty = editor.selection.isSelectionEmpty()\n\n        if (isSelectEmpty) {\n            // \u9009\u533A\u8303\u56F4\u662F\u7A7A\u7684\uFF0C\u63D2\u5165\u5E76\u9009\u4E2D\u4E00\u4E2A\u201C\u7A7A\u767D\u201D\n            editor.selection.createEmptyRange()\n        }\n\n        // \u6267\u884C italic \u547D\u4EE4\n        editor.cmd.do('italic')\n\n        if (isSelectEmpty) {\n            // \u9700\u8981\u5C06\u9009\u533A\u8303\u56F4\u6298\u53E0\u8D77\u6765\n            editor.selection.collapseRange()\n            editor.selection.restoreSelection()\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        if (editor.cmd.queryCommandState('italic')) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Italic\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "81bb4960fe2567651887098a038fea24fa319b60"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26r0ln8kpx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_26r0ln8kpx();

var __extends = (cov_26r0ln8kpx().s[0]++, (cov_26r0ln8kpx().b[0][0]++, void 0) && (cov_26r0ln8kpx().b[0][1]++, (void 0).__extends) || (cov_26r0ln8kpx().b[0][2]++, function () {
  cov_26r0ln8kpx().f[0]++;
  cov_26r0ln8kpx().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_26r0ln8kpx().f[1]++;
    cov_26r0ln8kpx().s[2]++;
    _extendStatics = (cov_26r0ln8kpx().b[1][0]++, _setPrototypeOf["default"]) || (cov_26r0ln8kpx().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_26r0ln8kpx().b[1][2]++, function (d, b) {
      cov_26r0ln8kpx().f[2]++;
      cov_26r0ln8kpx().s[3]++;
      d.__proto__ = b;
    }) || (cov_26r0ln8kpx().b[1][3]++, function (d, b) {
      cov_26r0ln8kpx().f[3]++;
      cov_26r0ln8kpx().s[4]++;

      for (var p in b) {
        cov_26r0ln8kpx().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_26r0ln8kpx().b[2][0]++;
          cov_26r0ln8kpx().s[6]++;
          d[p] = b[p];
        } else {
          cov_26r0ln8kpx().b[2][1]++;
        }
      }
    });
    cov_26r0ln8kpx().s[7]++;
    return _extendStatics(d, b);
  };

  cov_26r0ln8kpx().s[8]++;
  return function (d, b) {
    cov_26r0ln8kpx().f[4]++;
    cov_26r0ln8kpx().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_26r0ln8kpx().f[5]++;
      cov_26r0ln8kpx().s[10]++;
      this.constructor = d;
    }

    cov_26r0ln8kpx().s[11]++;
    d.prototype = b === null ? (cov_26r0ln8kpx().b[3][0]++, (0, _create["default"])(b)) : (cov_26r0ln8kpx().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_26r0ln8kpx().s[12]++, (cov_26r0ln8kpx().b[4][0]++, void 0) && (cov_26r0ln8kpx().b[4][1]++, (void 0).__importDefault) || (cov_26r0ln8kpx().b[4][2]++, function (mod) {
  cov_26r0ln8kpx().f[6]++;
  cov_26r0ln8kpx().s[13]++;
  return (cov_26r0ln8kpx().b[6][0]++, mod) && (cov_26r0ln8kpx().b[6][1]++, mod.__esModule) ? (cov_26r0ln8kpx().b[5][0]++, mod) : (cov_26r0ln8kpx().b[5][1]++, {
    "default": mod
  });
}));

cov_26r0ln8kpx().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var BtnMenu_1 = (cov_26r0ln8kpx().s[15]++, __importDefault(__webpack_require__(24)));
var dom_core_1 = (cov_26r0ln8kpx().s[16]++, __importDefault(__webpack_require__(2)));
var Italic = (
/** @class */
cov_26r0ln8kpx().s[17]++, function (_super) {
  cov_26r0ln8kpx().f[7]++;
  cov_26r0ln8kpx().s[18]++;

  __extends(Italic, _super);

  function Italic(editor) {
    cov_26r0ln8kpx().f[8]++;

    var _this = (cov_26r0ln8kpx().s[19]++, this);

    var $elem = (cov_26r0ln8kpx().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-italic\"></i>\n            </div>"));
    cov_26r0ln8kpx().s[21]++;
    _this = (cov_26r0ln8kpx().b[7][0]++, _super.call(this, $elem, editor)) || (cov_26r0ln8kpx().b[7][1]++, this);
    cov_26r0ln8kpx().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_26r0ln8kpx().s[23]++;

  Italic.prototype.clickHandler = function () {
    cov_26r0ln8kpx().f[9]++;
    var editor = (cov_26r0ln8kpx().s[24]++, this.editor);
    var isSelectEmpty = (cov_26r0ln8kpx().s[25]++, editor.selection.isSelectionEmpty());
    cov_26r0ln8kpx().s[26]++;

    if (isSelectEmpty) {
      cov_26r0ln8kpx().b[8][0]++;
      cov_26r0ln8kpx().s[27]++;
      // 选区范围是空的，插入并选中一个“空白”
      editor.selection.createEmptyRange();
    } else {
      cov_26r0ln8kpx().b[8][1]++;
    } // 执行 italic 命令


    cov_26r0ln8kpx().s[28]++;
    editor.cmd["do"]('italic');
    cov_26r0ln8kpx().s[29]++;

    if (isSelectEmpty) {
      cov_26r0ln8kpx().b[9][0]++;
      cov_26r0ln8kpx().s[30]++;
      // 需要将选区范围折叠起来
      editor.selection.collapseRange();
      cov_26r0ln8kpx().s[31]++;
      editor.selection.restoreSelection();
    } else {
      cov_26r0ln8kpx().b[9][1]++;
    }
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_26r0ln8kpx().s[32]++;

  Italic.prototype.tryChangeActive = function () {
    cov_26r0ln8kpx().f[10]++;
    var editor = (cov_26r0ln8kpx().s[33]++, this.editor);
    cov_26r0ln8kpx().s[34]++;

    if (editor.cmd.queryCommandState('italic')) {
      cov_26r0ln8kpx().b[10][0]++;
      cov_26r0ln8kpx().s[35]++;
      this.active();
    } else {
      cov_26r0ln8kpx().b[10][1]++;
      cov_26r0ln8kpx().s[36]++;
      this.unActive();
    }
  };

  cov_26r0ln8kpx().s[37]++;
  return Italic;
}(BtnMenu_1["default"]));
cov_26r0ln8kpx().s[38]++;
exports["default"] = Italic;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 下划线 underline
 * @author dyl
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_20l0bnpr1h() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/underline/index.ts";
  var hash = "6b1e9c8a6b6180a519ffc0d6a2ccfa6cf63f86eb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/underline/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 72
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 65,
          column: 20
        }
      },
      "18": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "19": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "20": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 140
        }
      },
      "21": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 57
        }
      },
      "22": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 21
        }
      },
      "23": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "24": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 32
        }
      },
      "25": {
        start: {
          line: 39,
          column: 28
        },
        end: {
          line: 39,
          column: 63
        }
      },
      "26": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 43,
          column: 9
        }
      },
      "27": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 48
        }
      },
      "28": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 35
        }
      },
      "29": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "30": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 45
        }
      },
      "31": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 48
        }
      },
      "32": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "33": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 56,
          column: 32
        }
      },
      "34": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 62,
          column: 9
        }
      },
      "35": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 26
        }
      },
      "36": {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 61,
          column: 28
        }
      },
      "37": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 21
        }
      },
      "38": {
        start: {
          line: 66,
          column: 0
        },
        end: {
          line: 66,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "Underline",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 37,
            column: 39
          },
          end: {
            line: 37,
            column: 40
          }
        },
        loc: {
          start: {
            line: 37,
            column: 51
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 37
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 55,
            column: 42
          },
          end: {
            line: 55,
            column: 43
          }
        },
        loc: {
          start: {
            line: 55,
            column: 54
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 48
          }
        }, {
          start: {
            line: 31,
            column: 52
          },
          end: {
            line: 31,
            column: 56
          }
        }],
        line: 31
      },
      "8": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        }],
        line: 40
      },
      "9": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }],
        line: 46
      },
      "10": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }, {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }],
        line: 57
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/underline/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/underline/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,yEAAkD;AAClD,kEAAoC;AAIpC;IAAwB,6BAAO;IAC3B,mBAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,oGAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,gCAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEzD,IAAI,aAAa,EAAE;YACf,sBAAsB;YACtB,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;QAED,kBAAkB;QAClB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,WAAW,CAAC,CAAA;QAE1B,IAAI,aAAa,EAAE;YACf,cAAc;YACd,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;YAChC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IAED;;OAEG;IACI,mCAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,WAAW,CAAC,EAAE;YAC3C,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,gBAAC;AAAD,CAAC,AA3CD,CAAwB,iBAAO,GA2C9B;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u4E0B\u5212\u7EBF underline\n * @author dyl\n *\n */\n\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Underline extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-underline\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const isSelectEmpty = editor.selection.isSelectionEmpty()\n\n        if (isSelectEmpty) {\n            // \u9009\u533A\u8303\u56F4\u662F\u7A7A\u7684\uFF0C\u63D2\u5165\u5E76\u9009\u4E2D\u4E00\u4E2A\u201C\u7A7A\u767D\u201D\n            editor.selection.createEmptyRange()\n        }\n\n        // \u6267\u884C Underline \u547D\u4EE4\n        editor.cmd.do('underline')\n\n        if (isSelectEmpty) {\n            // \u9700\u8981\u5C06\u9009\u533A\u8303\u56F4\u6298\u53E0\u8D77\u6765\n            editor.selection.collapseRange()\n            editor.selection.restoreSelection()\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        if (editor.cmd.queryCommandState('underline')) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Underline\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6b1e9c8a6b6180a519ffc0d6a2ccfa6cf63f86eb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_20l0bnpr1h = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_20l0bnpr1h();

var __extends = (cov_20l0bnpr1h().s[0]++, (cov_20l0bnpr1h().b[0][0]++, void 0) && (cov_20l0bnpr1h().b[0][1]++, (void 0).__extends) || (cov_20l0bnpr1h().b[0][2]++, function () {
  cov_20l0bnpr1h().f[0]++;
  cov_20l0bnpr1h().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_20l0bnpr1h().f[1]++;
    cov_20l0bnpr1h().s[2]++;
    _extendStatics = (cov_20l0bnpr1h().b[1][0]++, _setPrototypeOf["default"]) || (cov_20l0bnpr1h().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_20l0bnpr1h().b[1][2]++, function (d, b) {
      cov_20l0bnpr1h().f[2]++;
      cov_20l0bnpr1h().s[3]++;
      d.__proto__ = b;
    }) || (cov_20l0bnpr1h().b[1][3]++, function (d, b) {
      cov_20l0bnpr1h().f[3]++;
      cov_20l0bnpr1h().s[4]++;

      for (var p in b) {
        cov_20l0bnpr1h().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_20l0bnpr1h().b[2][0]++;
          cov_20l0bnpr1h().s[6]++;
          d[p] = b[p];
        } else {
          cov_20l0bnpr1h().b[2][1]++;
        }
      }
    });
    cov_20l0bnpr1h().s[7]++;
    return _extendStatics(d, b);
  };

  cov_20l0bnpr1h().s[8]++;
  return function (d, b) {
    cov_20l0bnpr1h().f[4]++;
    cov_20l0bnpr1h().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_20l0bnpr1h().f[5]++;
      cov_20l0bnpr1h().s[10]++;
      this.constructor = d;
    }

    cov_20l0bnpr1h().s[11]++;
    d.prototype = b === null ? (cov_20l0bnpr1h().b[3][0]++, (0, _create["default"])(b)) : (cov_20l0bnpr1h().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_20l0bnpr1h().s[12]++, (cov_20l0bnpr1h().b[4][0]++, void 0) && (cov_20l0bnpr1h().b[4][1]++, (void 0).__importDefault) || (cov_20l0bnpr1h().b[4][2]++, function (mod) {
  cov_20l0bnpr1h().f[6]++;
  cov_20l0bnpr1h().s[13]++;
  return (cov_20l0bnpr1h().b[6][0]++, mod) && (cov_20l0bnpr1h().b[6][1]++, mod.__esModule) ? (cov_20l0bnpr1h().b[5][0]++, mod) : (cov_20l0bnpr1h().b[5][1]++, {
    "default": mod
  });
}));

cov_20l0bnpr1h().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var BtnMenu_1 = (cov_20l0bnpr1h().s[15]++, __importDefault(__webpack_require__(24)));
var dom_core_1 = (cov_20l0bnpr1h().s[16]++, __importDefault(__webpack_require__(2)));
var Underline = (
/** @class */
cov_20l0bnpr1h().s[17]++, function (_super) {
  cov_20l0bnpr1h().f[7]++;
  cov_20l0bnpr1h().s[18]++;

  __extends(Underline, _super);

  function Underline(editor) {
    cov_20l0bnpr1h().f[8]++;

    var _this = (cov_20l0bnpr1h().s[19]++, this);

    var $elem = (cov_20l0bnpr1h().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-underline\"></i>\n            </div>"));
    cov_20l0bnpr1h().s[21]++;
    _this = (cov_20l0bnpr1h().b[7][0]++, _super.call(this, $elem, editor)) || (cov_20l0bnpr1h().b[7][1]++, this);
    cov_20l0bnpr1h().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_20l0bnpr1h().s[23]++;

  Underline.prototype.clickHandler = function () {
    cov_20l0bnpr1h().f[9]++;
    var editor = (cov_20l0bnpr1h().s[24]++, this.editor);
    var isSelectEmpty = (cov_20l0bnpr1h().s[25]++, editor.selection.isSelectionEmpty());
    cov_20l0bnpr1h().s[26]++;

    if (isSelectEmpty) {
      cov_20l0bnpr1h().b[8][0]++;
      cov_20l0bnpr1h().s[27]++;
      // 选区范围是空的，插入并选中一个“空白”
      editor.selection.createEmptyRange();
    } else {
      cov_20l0bnpr1h().b[8][1]++;
    } // 执行 Underline 命令


    cov_20l0bnpr1h().s[28]++;
    editor.cmd["do"]('underline');
    cov_20l0bnpr1h().s[29]++;

    if (isSelectEmpty) {
      cov_20l0bnpr1h().b[9][0]++;
      cov_20l0bnpr1h().s[30]++;
      // 需要将选区范围折叠起来
      editor.selection.collapseRange();
      cov_20l0bnpr1h().s[31]++;
      editor.selection.restoreSelection();
    } else {
      cov_20l0bnpr1h().b[9][1]++;
    }
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_20l0bnpr1h().s[32]++;

  Underline.prototype.tryChangeActive = function () {
    cov_20l0bnpr1h().f[10]++;
    var editor = (cov_20l0bnpr1h().s[33]++, this.editor);
    cov_20l0bnpr1h().s[34]++;

    if (editor.cmd.queryCommandState('underline')) {
      cov_20l0bnpr1h().b[10][0]++;
      cov_20l0bnpr1h().s[35]++;
      this.active();
    } else {
      cov_20l0bnpr1h().b[10][1]++;
      cov_20l0bnpr1h().s[36]++;
      this.unActive();
    }
  };

  cov_20l0bnpr1h().s[37]++;
  return Underline;
}(BtnMenu_1["default"]));
cov_20l0bnpr1h().s[38]++;
exports["default"] = Underline;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 删除线
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_2o2n8hsu12() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/strike-through/index.ts";
  var hash = "891a5342d558b6d0beb7dfdf69b3c3e2efa2eced";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/strike-through/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 72
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 35
        },
        end: {
          line: 64,
          column: 20
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 37
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 144
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "24": {
        start: {
          line: 37,
          column: 21
        },
        end: {
          line: 37,
          column: 32
        }
      },
      "25": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 38,
          column: 63
        }
      },
      "26": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "27": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "28": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 39
        }
      },
      "29": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "30": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 45
        }
      },
      "31": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "32": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "33": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "34": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "35": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "36": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 28
        }
      },
      "37": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 25
        }
      },
      "38": {
        start: {
          line: 65,
          column: 0
        },
        end: {
          line: 65,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 35
          },
          end: {
            line: 25,
            column: 36
          }
        },
        loc: {
          start: {
            line: 25,
            column: 53
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "StrikeThrough",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 26
          }
        },
        loc: {
          start: {
            line: 27,
            column: 35
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 43
          },
          end: {
            line: 36,
            column: 44
          }
        },
        loc: {
          start: {
            line: 36,
            column: 55
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 54,
            column: 46
          },
          end: {
            line: 54,
            column: 47
          }
        },
        loc: {
          start: {
            line: 54,
            column: 58
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 52
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 42,
            column: 9
          }
        }],
        line: 39
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 49,
            column: 9
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/strike-through/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/strike-through/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,yEAAkD;AAClD,kEAAoC;AAIpC;IAA4B,iCAAO;IAC/B,uBAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,wGAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,oCAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEzD,IAAI,aAAa,EAAE;YACf,sBAAsB;YACtB,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;QAED,sBAAsB;QACtB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,eAAe,CAAC,CAAA;QAE9B,IAAI,aAAa,EAAE;YACf,cAAc;YACd,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;YAChC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IAED;;OAEG;IACI,uCAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,eAAe,CAAC,EAAE;YAC/C,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,oBAAC;AAAD,CAAC,AA3CD,CAA4B,iBAAO,GA2ClC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u5220\u9664\u7EBF\n * @author lkw\n */\n\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass StrikeThrough extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-strikethrough\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const isSelectEmpty = editor.selection.isSelectionEmpty()\n\n        if (isSelectEmpty) {\n            // \u9009\u533A\u8303\u56F4\u662F\u7A7A\u7684\uFF0C\u63D2\u5165\u5E76\u9009\u4E2D\u4E00\u4E2A\u201C\u7A7A\u767D\u201D\n            editor.selection.createEmptyRange()\n        }\n\n        // \u6267\u884C strikeThrough \u547D\u4EE4\n        editor.cmd.do('strikeThrough')\n\n        if (isSelectEmpty) {\n            // \u9700\u8981\u5C06\u9009\u533A\u8303\u56F4\u6298\u53E0\u8D77\u6765\n            editor.selection.collapseRange()\n            editor.selection.restoreSelection()\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        if (editor.cmd.queryCommandState('strikeThrough')) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default StrikeThrough\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "891a5342d558b6d0beb7dfdf69b3c3e2efa2eced"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2o2n8hsu12 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2o2n8hsu12();

var __extends = (cov_2o2n8hsu12().s[0]++, (cov_2o2n8hsu12().b[0][0]++, void 0) && (cov_2o2n8hsu12().b[0][1]++, (void 0).__extends) || (cov_2o2n8hsu12().b[0][2]++, function () {
  cov_2o2n8hsu12().f[0]++;
  cov_2o2n8hsu12().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_2o2n8hsu12().f[1]++;
    cov_2o2n8hsu12().s[2]++;
    _extendStatics = (cov_2o2n8hsu12().b[1][0]++, _setPrototypeOf["default"]) || (cov_2o2n8hsu12().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_2o2n8hsu12().b[1][2]++, function (d, b) {
      cov_2o2n8hsu12().f[2]++;
      cov_2o2n8hsu12().s[3]++;
      d.__proto__ = b;
    }) || (cov_2o2n8hsu12().b[1][3]++, function (d, b) {
      cov_2o2n8hsu12().f[3]++;
      cov_2o2n8hsu12().s[4]++;

      for (var p in b) {
        cov_2o2n8hsu12().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_2o2n8hsu12().b[2][0]++;
          cov_2o2n8hsu12().s[6]++;
          d[p] = b[p];
        } else {
          cov_2o2n8hsu12().b[2][1]++;
        }
      }
    });
    cov_2o2n8hsu12().s[7]++;
    return _extendStatics(d, b);
  };

  cov_2o2n8hsu12().s[8]++;
  return function (d, b) {
    cov_2o2n8hsu12().f[4]++;
    cov_2o2n8hsu12().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_2o2n8hsu12().f[5]++;
      cov_2o2n8hsu12().s[10]++;
      this.constructor = d;
    }

    cov_2o2n8hsu12().s[11]++;
    d.prototype = b === null ? (cov_2o2n8hsu12().b[3][0]++, (0, _create["default"])(b)) : (cov_2o2n8hsu12().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_2o2n8hsu12().s[12]++, (cov_2o2n8hsu12().b[4][0]++, void 0) && (cov_2o2n8hsu12().b[4][1]++, (void 0).__importDefault) || (cov_2o2n8hsu12().b[4][2]++, function (mod) {
  cov_2o2n8hsu12().f[6]++;
  cov_2o2n8hsu12().s[13]++;
  return (cov_2o2n8hsu12().b[6][0]++, mod) && (cov_2o2n8hsu12().b[6][1]++, mod.__esModule) ? (cov_2o2n8hsu12().b[5][0]++, mod) : (cov_2o2n8hsu12().b[5][1]++, {
    "default": mod
  });
}));

cov_2o2n8hsu12().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var BtnMenu_1 = (cov_2o2n8hsu12().s[15]++, __importDefault(__webpack_require__(24)));
var dom_core_1 = (cov_2o2n8hsu12().s[16]++, __importDefault(__webpack_require__(2)));
var StrikeThrough = (
/** @class */
cov_2o2n8hsu12().s[17]++, function (_super) {
  cov_2o2n8hsu12().f[7]++;
  cov_2o2n8hsu12().s[18]++;

  __extends(StrikeThrough, _super);

  function StrikeThrough(editor) {
    cov_2o2n8hsu12().f[8]++;

    var _this = (cov_2o2n8hsu12().s[19]++, this);

    var $elem = (cov_2o2n8hsu12().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-strikethrough\"></i>\n            </div>"));
    cov_2o2n8hsu12().s[21]++;
    _this = (cov_2o2n8hsu12().b[7][0]++, _super.call(this, $elem, editor)) || (cov_2o2n8hsu12().b[7][1]++, this);
    cov_2o2n8hsu12().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_2o2n8hsu12().s[23]++;

  StrikeThrough.prototype.clickHandler = function () {
    cov_2o2n8hsu12().f[9]++;
    var editor = (cov_2o2n8hsu12().s[24]++, this.editor);
    var isSelectEmpty = (cov_2o2n8hsu12().s[25]++, editor.selection.isSelectionEmpty());
    cov_2o2n8hsu12().s[26]++;

    if (isSelectEmpty) {
      cov_2o2n8hsu12().b[8][0]++;
      cov_2o2n8hsu12().s[27]++;
      // 选区范围是空的，插入并选中一个“空白”
      editor.selection.createEmptyRange();
    } else {
      cov_2o2n8hsu12().b[8][1]++;
    } // 执行 strikeThrough 命令


    cov_2o2n8hsu12().s[28]++;
    editor.cmd["do"]('strikeThrough');
    cov_2o2n8hsu12().s[29]++;

    if (isSelectEmpty) {
      cov_2o2n8hsu12().b[9][0]++;
      cov_2o2n8hsu12().s[30]++;
      // 需要将选区范围折叠起来
      editor.selection.collapseRange();
      cov_2o2n8hsu12().s[31]++;
      editor.selection.restoreSelection();
    } else {
      cov_2o2n8hsu12().b[9][1]++;
    }
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_2o2n8hsu12().s[32]++;

  StrikeThrough.prototype.tryChangeActive = function () {
    cov_2o2n8hsu12().f[10]++;
    var editor = (cov_2o2n8hsu12().s[33]++, this.editor);
    cov_2o2n8hsu12().s[34]++;

    if (editor.cmd.queryCommandState('strikeThrough')) {
      cov_2o2n8hsu12().b[10][0]++;
      cov_2o2n8hsu12().s[35]++;
      this.active();
    } else {
      cov_2o2n8hsu12().b[10][1]++;
      cov_2o2n8hsu12().s[36]++;
      this.unActive();
    }
  };

  cov_2o2n8hsu12().s[37]++;
  return StrikeThrough;
}(BtnMenu_1["default"]));
cov_2o2n8hsu12().s[38]++;
exports["default"] = StrikeThrough;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 字体样式 FontStyle
 * @author dyl
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_22ufnemfkh() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/index.ts";
  var hash = "40f34b1e576de3194e474d6fc746a482ec379646";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 26,
          column: 65
        }
      },
      "18": {
        start: {
          line: 27,
          column: 31
        },
        end: {
          line: 68,
          column: 25
        }
      },
      "19": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 33
        }
      },
      "20": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "21": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 135
        }
      },
      "22": {
        start: {
          line: 32,
          column: 28
        },
        end: {
          line: 32,
          column: 80
        }
      },
      "23": {
        start: {
          line: 33,
          column: 27
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "24": {
        start: {
          line: 40,
          column: 16
        },
        end: {
          line: 40,
          column: 37
        }
      },
      "25": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 71
        }
      },
      "26": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "27": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "28": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 32
        }
      },
      "29": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 41
        }
      },
      "30": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 66,
          column: 6
        }
      },
      "31": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 21
        }
      },
      "32": {
        start: {
          line: 69,
          column: 0
        },
        end: {
          line: 69,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 31
          },
          end: {
            line: 27,
            column: 32
          }
        },
        loc: {
          start: {
            line: 27,
            column: 49
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 27
      },
      "8": {
        name: "FontStyle",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 22
          }
        },
        loc: {
          start: {
            line: 29,
            column: 31
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 29
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 38,
            column: 43
          },
          end: {
            line: 41,
            column: 13
          }
        },
        line: 38
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 50,
            column: 34
          },
          end: {
            line: 50,
            column: 35
          }
        },
        loc: {
          start: {
            line: 50,
            column: 51
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 50
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 58,
            column: 42
          },
          end: {
            line: 58,
            column: 43
          }
        },
        loc: {
          start: {
            line: 58,
            column: 54
          },
          end: {
            line: 66,
            column: 5
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 62
          }
        }, {
          start: {
            line: 43,
            column: 66
          },
          end: {
            line: 43,
            column: 70
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/font-style/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoC;AAGpC,kEAA2C;AAE3C;IAAwB,6BAAY;IAChC,mBAAY,MAAc;QAA1B,iBAkBC;QAjBG,IAAM,KAAK,GAAG,kBAAC,CACX,+FAEO,CACV,CAAA;QACD,IAAI,aAAa,GAAG,IAAI,uBAAa,CAAC,MAAM,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;QAC9D,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE,aAAa,CAAC,WAAW,EAAE;YACjC,YAAY,EAAE,UAAC,KAAa;gBACxB,2BAA2B;gBAC3B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IAED;;;OAGG;IACI,2BAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,UAAU,EAAE,KAAK,CAAC,CAAA;IACpC,CAAC;IAED;;;OAGG;IACI,mCAAe,GAAtB;QACI,6BAA6B;QAC7B,4DAA4D;QAC5D,sDAAsD;QACtD,oBAAoB;QACpB,WAAW;QACX,sBAAsB;QACtB,IAAI;IACR,CAAC;IACL,gBAAC;AAAD,CAAC,AA3CD,CAAwB,sBAAY,GA2CnC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u5B57\u4F53\u6837\u5F0F FontStyle\n * @author dyl\n *\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport FontStyleList from './FontStyleList'\n\nclass FontStyle extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-font\"></i>\n            </div>`\n        )\n        let fontStyleList = new FontStyleList(editor.config.fontNames)\n        const fontListConf = {\n            width: 100,\n            title: '\u8BBE\u7F6E\u5B57\u4F53',\n            type: 'list',\n            list: fontStyleList.getItemList(),\n            clickHandler: (value: string) => {\n                // this \u662F\u6307\u5411\u5F53\u524D\u7684 FontStyle \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n        super($elem, editor, fontListConf)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        editor.cmd.do('fontName', value)\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     * ?\u5B57\u4F53\u662F\u5426\u9700\u8981\u6709\u6FC0\u6D3B\u72B6\u6001\u8FD9\u4E2A\u64CD\u4F5C?\n     */\n    public tryChangeActive(): void {\n        // const editor = this.editor\n        // const cmdValue = editor.cmd.queryCommandValue('fontName')\n        // if (menusConfig.fontNames.indexOf(cmdValue) >= 0) {\n        //     this.active()\n        // } else {\n        //     this.unActive()\n        // }\n    }\n}\n\nexport default FontStyle\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "40f34b1e576de3194e474d6fc746a482ec379646"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22ufnemfkh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_22ufnemfkh();

var __extends = (cov_22ufnemfkh().s[0]++, (cov_22ufnemfkh().b[0][0]++, void 0) && (cov_22ufnemfkh().b[0][1]++, (void 0).__extends) || (cov_22ufnemfkh().b[0][2]++, function () {
  cov_22ufnemfkh().f[0]++;
  cov_22ufnemfkh().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_22ufnemfkh().f[1]++;
    cov_22ufnemfkh().s[2]++;
    _extendStatics = (cov_22ufnemfkh().b[1][0]++, _setPrototypeOf["default"]) || (cov_22ufnemfkh().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_22ufnemfkh().b[1][2]++, function (d, b) {
      cov_22ufnemfkh().f[2]++;
      cov_22ufnemfkh().s[3]++;
      d.__proto__ = b;
    }) || (cov_22ufnemfkh().b[1][3]++, function (d, b) {
      cov_22ufnemfkh().f[3]++;
      cov_22ufnemfkh().s[4]++;

      for (var p in b) {
        cov_22ufnemfkh().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_22ufnemfkh().b[2][0]++;
          cov_22ufnemfkh().s[6]++;
          d[p] = b[p];
        } else {
          cov_22ufnemfkh().b[2][1]++;
        }
      }
    });
    cov_22ufnemfkh().s[7]++;
    return _extendStatics(d, b);
  };

  cov_22ufnemfkh().s[8]++;
  return function (d, b) {
    cov_22ufnemfkh().f[4]++;
    cov_22ufnemfkh().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_22ufnemfkh().f[5]++;
      cov_22ufnemfkh().s[10]++;
      this.constructor = d;
    }

    cov_22ufnemfkh().s[11]++;
    d.prototype = b === null ? (cov_22ufnemfkh().b[3][0]++, (0, _create["default"])(b)) : (cov_22ufnemfkh().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_22ufnemfkh().s[12]++, (cov_22ufnemfkh().b[4][0]++, void 0) && (cov_22ufnemfkh().b[4][1]++, (void 0).__importDefault) || (cov_22ufnemfkh().b[4][2]++, function (mod) {
  cov_22ufnemfkh().f[6]++;
  cov_22ufnemfkh().s[13]++;
  return (cov_22ufnemfkh().b[6][0]++, mod) && (cov_22ufnemfkh().b[6][1]++, mod.__esModule) ? (cov_22ufnemfkh().b[5][0]++, mod) : (cov_22ufnemfkh().b[5][1]++, {
    "default": mod
  });
}));

cov_22ufnemfkh().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_22ufnemfkh().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_22ufnemfkh().s[16]++, __importDefault(__webpack_require__(2)));
var FontStyleList_1 = (cov_22ufnemfkh().s[17]++, __importDefault(__webpack_require__(318)));
var FontStyle = (
/** @class */
cov_22ufnemfkh().s[18]++, function (_super) {
  cov_22ufnemfkh().f[7]++;
  cov_22ufnemfkh().s[19]++;

  __extends(FontStyle, _super);

  function FontStyle(editor) {
    cov_22ufnemfkh().f[8]++;

    var _this = (cov_22ufnemfkh().s[20]++, this);

    var $elem = (cov_22ufnemfkh().s[21]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-font\"></i>\n            </div>"));
    var fontStyleList = (cov_22ufnemfkh().s[22]++, new FontStyleList_1["default"](editor.config.fontNames));
    var fontListConf = (cov_22ufnemfkh().s[23]++, {
      width: 100,
      title: '设置字体',
      type: 'list',
      list: fontStyleList.getItemList(),
      clickHandler: function clickHandler(value) {
        cov_22ufnemfkh().f[9]++;
        cov_22ufnemfkh().s[24]++;

        // this 是指向当前的 FontStyle 对象
        _this.command(value);
      }
    });
    cov_22ufnemfkh().s[25]++;
    _this = (cov_22ufnemfkh().b[7][0]++, _super.call(this, $elem, editor, fontListConf)) || (cov_22ufnemfkh().b[7][1]++, this);
    cov_22ufnemfkh().s[26]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_22ufnemfkh().s[27]++;

  FontStyle.prototype.command = function (value) {
    cov_22ufnemfkh().f[10]++;
    var editor = (cov_22ufnemfkh().s[28]++, this.editor);
    cov_22ufnemfkh().s[29]++;
    editor.cmd["do"]('fontName', value);
  };
  /**
   * 尝试修改菜单激活状态
   * ?字体是否需要有激活状态这个操作?
   */


  cov_22ufnemfkh().s[30]++;

  FontStyle.prototype.tryChangeActive = function () {// const editor = this.editor
    // const cmdValue = editor.cmd.queryCommandValue('fontName')
    // if (menusConfig.fontNames.indexOf(cmdValue) >= 0) {
    //     this.active()
    // } else {
    //     this.unActive()
    // }

    cov_22ufnemfkh().f[11]++;
  };

  cov_22ufnemfkh().s[31]++;
  return FontStyle;
}(DropListMenu_1["default"]));
cov_22ufnemfkh().s[32]++;
exports["default"] = FontStyle;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2expdhc8h6() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/FontStyleList.ts";
  var hash = "7daf906e501d0ba1894e5652dbd4427a960630b9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/FontStyleList.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 17,
          column: 35
        },
        end: {
          line: 32,
          column: 3
        }
      },
      "5": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 24
        }
      },
      "6": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 27
        }
      },
      "7": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 26,
          column: 11
        }
      },
      "8": {
        start: {
          line: 22,
          column: 12
        },
        end: {
          line: 25,
          column: 15
        }
      },
      "9": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 30,
          column: 6
        }
      },
      "10": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 29
        }
      },
      "11": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 25
        }
      },
      "12": {
        start: {
          line: 33,
          column: 0
        },
        end: {
          line: 33,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 36
          }
        },
        loc: {
          start: {
            line: 17,
            column: 47
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "FontStyleList",
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 26
          }
        },
        loc: {
          start: {
            line: 18,
            column: 33
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 18
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 21,
            column: 22
          }
        },
        loc: {
          start: {
            line: 21,
            column: 42
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 42
          },
          end: {
            line: 28,
            column: 43
          }
        },
        loc: {
          start: {
            line: 28,
            column: 54
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 28
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/font-style/FontStyleList.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/font-style/FontStyleList.ts"],
      names: [],
      mappings: ";;;;;AAAA;;;GAGG;AACH,kEAAoC;AAGpC;;;;;GAKG;AACH;IAGI,uBAAY,IAAc;QAA1B,iBAQC;QAPG,IAAI,CAAC,QAAQ,GAAG,EAAE,CAAA;QAClB,IAAI,CAAC,OAAO,CAAC,UAAA,SAAS;YAClB,KAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;gBACf,KAAK,EAAE,kBAAC,CAAC,6BAA0B,SAAS,YAAM,SAAS,SAAM,CAAC;gBAClE,KAAK,EAAE,SAAS;aACnB,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;IACN,CAAC;IAEM,mCAAW,GAAlB;QACI,OAAO,IAAI,CAAC,QAAQ,CAAA;IACxB,CAAC;IACL,oBAAC;AAAD,CAAC,AAhBD,IAgBC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u5B57\u4F53 class\n * @author dyl\n */\nimport $ from '../../utils/dom-core'\nimport { DropListItem } from '../menu-constructors/DropList'\n\n/**\n * \u5C01\u88C5\u7684\u4E00\u4E2A\u5B57\u4F53\u83DC\u5355\u5217\u8868\u6570\u636E\u7684\u7EC4\u88C5\u5BF9\u8C61,\n * \u539F\u56E0\u662F\u56E0\u4E3A\u5728constructor\u51FD\u6570\u4E2D,\u76F4\u63A5\u6267\u884C\u6B64\u6D41\u7A0B,\u4F1A\u8BA9\u4EE3\u7801\u91CF\u770B\u8D77\u6765\u8F83\u591A,\n * \u5982\u679C\u8981\u5728constructor\u8C03\u7528\u5916\u90E8\u51FD\u6570,\u4E2A\u4EBA\u76EE\u524D\u53D1\u73B0\u4F1A\u6709\u9519\u8BEF\u63D0\u793A,\n * \u56E0\u6B64,\u60F3\u7740\u987A\u4FBF\u7814\u7A76\u5B9E\u8DF5\u4E0Bts,\u904D\u521B\u5EFA\u4E86\u8FD9\u6837\u4E00\u4E2A\u7C7B\n */\nclass FontStyleList {\n    private itemList: DropListItem[]\n\n    constructor(list: string[]) {\n        this.itemList = []\n        list.forEach(fontValue => {\n            this.itemList.push({\n                $elem: $(`<p style=\"font-family:'${fontValue}'\">${fontValue}</p>`),\n                value: fontValue,\n            })\n        })\n    }\n\n    public getItemList(): DropListItem[] {\n        return this.itemList\n    }\n}\n\nexport default FontStyleList\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7daf906e501d0ba1894e5652dbd4427a960630b9"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2expdhc8h6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2expdhc8h6();

var __importDefault = (cov_2expdhc8h6().s[0]++, (cov_2expdhc8h6().b[0][0]++, void 0) && (cov_2expdhc8h6().b[0][1]++, (void 0).__importDefault) || (cov_2expdhc8h6().b[0][2]++, function (mod) {
  cov_2expdhc8h6().f[0]++;
  cov_2expdhc8h6().s[1]++;
  return (cov_2expdhc8h6().b[2][0]++, mod) && (cov_2expdhc8h6().b[2][1]++, mod.__esModule) ? (cov_2expdhc8h6().b[1][0]++, mod) : (cov_2expdhc8h6().b[1][1]++, {
    "default": mod
  });
}));

cov_2expdhc8h6().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description 字体 class
 * @author dyl
 */

var dom_core_1 = (cov_2expdhc8h6().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 封装的一个字体菜单列表数据的组装对象,
 * 原因是因为在constructor函数中,直接执行此流程,会让代码量看起来较多,
 * 如果要在constructor调用外部函数,个人目前发现会有错误提示,
 * 因此,想着顺便研究实践下ts,遍创建了这样一个类
 */

var FontStyleList = (
/** @class */
cov_2expdhc8h6().s[4]++, function () {
  cov_2expdhc8h6().f[1]++;

  function FontStyleList(list) {
    cov_2expdhc8h6().f[2]++;

    var _this = (cov_2expdhc8h6().s[5]++, this);

    cov_2expdhc8h6().s[6]++;
    this.itemList = [];
    cov_2expdhc8h6().s[7]++;
    (0, _forEach["default"])(list).call(list, function (fontValue) {
      cov_2expdhc8h6().f[3]++;
      cov_2expdhc8h6().s[8]++;

      _this.itemList.push({
        $elem: dom_core_1["default"]("<p style=\"font-family:'" + fontValue + "'\">" + fontValue + "</p>"),
        value: fontValue
      });
    });
  }

  cov_2expdhc8h6().s[9]++;

  FontStyleList.prototype.getItemList = function () {
    cov_2expdhc8h6().f[4]++;
    cov_2expdhc8h6().s[10]++;
    return this.itemList;
  };

  cov_2expdhc8h6().s[11]++;
  return FontStyleList;
}());
cov_2expdhc8h6().s[12]++;
exports["default"] = FontStyleList;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 字号 FontSize
 * @author lkw
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_17m4m7tlhb() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/index.ts";
  var hash = "ae0d950293ab6ea78226b9b9091ebafcad2707c5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 26,
          column: 63
        }
      },
      "18": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 60,
          column: 25
        }
      },
      "19": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 32
        }
      },
      "20": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "21": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 141
        }
      },
      "22": {
        start: {
          line: 32,
          column: 28
        },
        end: {
          line: 32,
          column: 79
        }
      },
      "23": {
        start: {
          line: 33,
          column: 27
        },
        end: {
          line: 42,
          column: 9
        }
      },
      "24": {
        start: {
          line: 40,
          column: 16
        },
        end: {
          line: 40,
          column: 37
        }
      },
      "25": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 71
        }
      },
      "26": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "27": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "28": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 32
        }
      },
      "29": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 41
        }
      },
      "30": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 57
        }
      },
      "31": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 20
        }
      },
      "32": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 61,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 30
          },
          end: {
            line: 27,
            column: 31
          }
        },
        loc: {
          start: {
            line: 27,
            column: 48
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 27
      },
      "8": {
        name: "FontSize",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 21
          }
        },
        loc: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 29
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 38,
            column: 26
          },
          end: {
            line: 38,
            column: 27
          }
        },
        loc: {
          start: {
            line: 38,
            column: 43
          },
          end: {
            line: 41,
            column: 13
          }
        },
        line: 38
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 50,
            column: 33
          },
          end: {
            line: 50,
            column: 34
          }
        },
        loc: {
          start: {
            line: 50,
            column: 50
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 50
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 58,
            column: 41
          },
          end: {
            line: 58,
            column: 42
          }
        },
        loc: {
          start: {
            line: 58,
            column: 53
          },
          end: {
            line: 58,
            column: 56
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 43,
            column: 62
          }
        }, {
          start: {
            line: 43,
            column: 66
          },
          end: {
            line: 43,
            column: 70
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/font-size/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoC;AAGpC,gEAAyC;AAEzC;IAAuB,4BAAY;IAC/B,kBAAY,MAAc;QAA1B,iBAkBC;QAjBG,IAAM,KAAK,GAAG,kBAAC,CACX,qGAEO,CACV,CAAA;QACD,IAAI,aAAa,GAAG,IAAI,sBAAY,CAAC,MAAM,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;QAC7D,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE,aAAa,CAAC,WAAW,EAAE;YACjC,YAAY,EAAE,UAAC,KAAa;gBACxB,0BAA0B;gBAC1B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IAED;;;OAGG;IACI,0BAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,UAAU,EAAE,KAAK,CAAC,CAAA;IACpC,CAAC;IAED;;;OAGG;IACI,kCAAe,GAAtB,cAAgC,CAAC;IACrC,eAAC;AAAD,CAAC,AAnCD,CAAuB,sBAAY,GAmClC;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u5B57\u53F7 FontSize\n * @author lkw\n *\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport FontSizeList from './FontSizeList'\n\nclass FontSize extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-text-heigh\"></i>\n            </div>`\n        )\n        let fontStyleList = new FontSizeList(editor.config.fontSizes)\n        const fontListConf = {\n            width: 160,\n            title: '\u8BBE\u7F6E\u5B57\u53F7',\n            type: 'list',\n            list: fontStyleList.getItemList(),\n            clickHandler: (value: string) => {\n                // this \u662F\u6307\u5411\u5F53\u524D\u7684 FontSize \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n        super($elem, editor, fontListConf)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        editor.cmd.do('fontSize', value)\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     * ?\u5B57\u53F7\u662F\u5426\u9700\u8981\u6709\u6FC0\u6D3B\u72B6\u6001\u8FD9\u4E2A\u64CD\u4F5C?\n     */\n    public tryChangeActive(): void {}\n}\n\nexport default FontSize\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ae0d950293ab6ea78226b9b9091ebafcad2707c5"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17m4m7tlhb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_17m4m7tlhb();

var __extends = (cov_17m4m7tlhb().s[0]++, (cov_17m4m7tlhb().b[0][0]++, void 0) && (cov_17m4m7tlhb().b[0][1]++, (void 0).__extends) || (cov_17m4m7tlhb().b[0][2]++, function () {
  cov_17m4m7tlhb().f[0]++;
  cov_17m4m7tlhb().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_17m4m7tlhb().f[1]++;
    cov_17m4m7tlhb().s[2]++;
    _extendStatics = (cov_17m4m7tlhb().b[1][0]++, _setPrototypeOf["default"]) || (cov_17m4m7tlhb().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_17m4m7tlhb().b[1][2]++, function (d, b) {
      cov_17m4m7tlhb().f[2]++;
      cov_17m4m7tlhb().s[3]++;
      d.__proto__ = b;
    }) || (cov_17m4m7tlhb().b[1][3]++, function (d, b) {
      cov_17m4m7tlhb().f[3]++;
      cov_17m4m7tlhb().s[4]++;

      for (var p in b) {
        cov_17m4m7tlhb().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_17m4m7tlhb().b[2][0]++;
          cov_17m4m7tlhb().s[6]++;
          d[p] = b[p];
        } else {
          cov_17m4m7tlhb().b[2][1]++;
        }
      }
    });
    cov_17m4m7tlhb().s[7]++;
    return _extendStatics(d, b);
  };

  cov_17m4m7tlhb().s[8]++;
  return function (d, b) {
    cov_17m4m7tlhb().f[4]++;
    cov_17m4m7tlhb().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_17m4m7tlhb().f[5]++;
      cov_17m4m7tlhb().s[10]++;
      this.constructor = d;
    }

    cov_17m4m7tlhb().s[11]++;
    d.prototype = b === null ? (cov_17m4m7tlhb().b[3][0]++, (0, _create["default"])(b)) : (cov_17m4m7tlhb().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_17m4m7tlhb().s[12]++, (cov_17m4m7tlhb().b[4][0]++, void 0) && (cov_17m4m7tlhb().b[4][1]++, (void 0).__importDefault) || (cov_17m4m7tlhb().b[4][2]++, function (mod) {
  cov_17m4m7tlhb().f[6]++;
  cov_17m4m7tlhb().s[13]++;
  return (cov_17m4m7tlhb().b[6][0]++, mod) && (cov_17m4m7tlhb().b[6][1]++, mod.__esModule) ? (cov_17m4m7tlhb().b[5][0]++, mod) : (cov_17m4m7tlhb().b[5][1]++, {
    "default": mod
  });
}));

cov_17m4m7tlhb().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_17m4m7tlhb().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_17m4m7tlhb().s[16]++, __importDefault(__webpack_require__(2)));
var FontSizeList_1 = (cov_17m4m7tlhb().s[17]++, __importDefault(__webpack_require__(320)));
var FontSize = (
/** @class */
cov_17m4m7tlhb().s[18]++, function (_super) {
  cov_17m4m7tlhb().f[7]++;
  cov_17m4m7tlhb().s[19]++;

  __extends(FontSize, _super);

  function FontSize(editor) {
    cov_17m4m7tlhb().f[8]++;

    var _this = (cov_17m4m7tlhb().s[20]++, this);

    var $elem = (cov_17m4m7tlhb().s[21]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-text-heigh\"></i>\n            </div>"));
    var fontStyleList = (cov_17m4m7tlhb().s[22]++, new FontSizeList_1["default"](editor.config.fontSizes));
    var fontListConf = (cov_17m4m7tlhb().s[23]++, {
      width: 160,
      title: '设置字号',
      type: 'list',
      list: fontStyleList.getItemList(),
      clickHandler: function clickHandler(value) {
        cov_17m4m7tlhb().f[9]++;
        cov_17m4m7tlhb().s[24]++;

        // this 是指向当前的 FontSize 对象
        _this.command(value);
      }
    });
    cov_17m4m7tlhb().s[25]++;
    _this = (cov_17m4m7tlhb().b[7][0]++, _super.call(this, $elem, editor, fontListConf)) || (cov_17m4m7tlhb().b[7][1]++, this);
    cov_17m4m7tlhb().s[26]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_17m4m7tlhb().s[27]++;

  FontSize.prototype.command = function (value) {
    cov_17m4m7tlhb().f[10]++;
    var editor = (cov_17m4m7tlhb().s[28]++, this.editor);
    cov_17m4m7tlhb().s[29]++;
    editor.cmd["do"]('fontSize', value);
  };
  /**
   * 尝试修改菜单激活状态
   * ?字号是否需要有激活状态这个操作?
   */


  cov_17m4m7tlhb().s[30]++;

  FontSize.prototype.tryChangeActive = function () {
    cov_17m4m7tlhb().f[11]++;
  };

  cov_17m4m7tlhb().s[31]++;
  return FontSize;
}(DropListMenu_1["default"]));
cov_17m4m7tlhb().s[32]++;
exports["default"] = FontSize;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_yue8gntm8() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/FontSizeList.ts";
  var hash = "87b01e1e86c9ba833623e10ca2581c7668eb12ce";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/FontSizeList.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 14,
          column: 34
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "5": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 27
        }
      },
      "6": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 23,
          column: 9
        }
      },
      "7": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 18,
          column: 32
        }
      },
      "8": {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 22,
          column: 15
        }
      },
      "9": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "10": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 29
        }
      },
      "11": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "12": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 30,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 34
          },
          end: {
            line: 14,
            column: 35
          }
        },
        loc: {
          start: {
            line: 14,
            column: 46
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "FontSizeList",
        decl: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 25
          }
        },
        loc: {
          start: {
            line: 15,
            column: 32
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 41
          },
          end: {
            line: 25,
            column: 42
          }
        },
        loc: {
          start: {
            line: 25,
            column: 53
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 25
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/font-size/FontSizeList.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/font-size/FontSizeList.ts"],
      names: [],
      mappings: ";;;;;AAAA;;;GAGG;AACH,kEAAoC;AAIpC;;GAEG;AACH;IAGI,sBAAY,IAAsB;QAC9B,IAAI,CAAC,QAAQ,GAAG,EAAE,CAAA;QAClB,KAAK,IAAI,GAAG,IAAI,IAAI,EAAE;YAClB,IAAM,IAAI,GAAG,IAAI,CAAC,GAAG,CAAC,CAAA;YACtB,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;gBACf,KAAK,EAAE,kBAAC,CAAC,0BAAuB,GAAG,WAAK,IAAI,CAAC,IAAI,SAAM,CAAC;gBACxD,KAAK,EAAE,IAAI,CAAC,KAAK;aACpB,CAAC,CAAA;SACL;IACL,CAAC;IAEM,kCAAW,GAAlB;QACI,OAAO,IAAI,CAAC,QAAQ,CAAA;IACxB,CAAC;IACL,mBAAC;AAAD,CAAC,AAjBD,IAiBC;AAED,kBAAe,YAAY,CAAA",
      sourcesContent: ["/**\n * @description \u5B57\u53F7 class\n * @author lkw\n */\nimport $ from '../../utils/dom-core'\nimport { DropListItem } from '../menu-constructors/DropList'\nimport { FontSizeConfType } from '../../config/menus'\n\n/**\n * FontSizeList \u5B57\u53F7\u914D\u7F6E\u5217\u8868\n */\nclass FontSizeList {\n    private itemList: DropListItem[]\n\n    constructor(list: FontSizeConfType) {\n        this.itemList = []\n        for (let key in list) {\n            const item = list[key]\n            this.itemList.push({\n                $elem: $(`<p style=\"font-size:${key}\">${item.name}</p>`),\n                value: item.value,\n            })\n        }\n    }\n\n    public getItemList(): DropListItem[] {\n        return this.itemList\n    }\n}\n\nexport default FontSizeList\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "87b01e1e86c9ba833623e10ca2581c7668eb12ce"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yue8gntm8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_yue8gntm8();

var __importDefault = (cov_yue8gntm8().s[0]++, (cov_yue8gntm8().b[0][0]++, void 0) && (cov_yue8gntm8().b[0][1]++, (void 0).__importDefault) || (cov_yue8gntm8().b[0][2]++, function (mod) {
  cov_yue8gntm8().f[0]++;
  cov_yue8gntm8().s[1]++;
  return (cov_yue8gntm8().b[2][0]++, mod) && (cov_yue8gntm8().b[2][1]++, mod.__esModule) ? (cov_yue8gntm8().b[1][0]++, mod) : (cov_yue8gntm8().b[1][1]++, {
    "default": mod
  });
}));

cov_yue8gntm8().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description 字号 class
 * @author lkw
 */

var dom_core_1 = (cov_yue8gntm8().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * FontSizeList 字号配置列表
 */

var FontSizeList = (
/** @class */
cov_yue8gntm8().s[4]++, function () {
  cov_yue8gntm8().f[1]++;

  function FontSizeList(list) {
    cov_yue8gntm8().f[2]++;
    cov_yue8gntm8().s[5]++;
    this.itemList = [];
    cov_yue8gntm8().s[6]++;

    for (var key in list) {
      var item = (cov_yue8gntm8().s[7]++, list[key]);
      cov_yue8gntm8().s[8]++;
      this.itemList.push({
        $elem: dom_core_1["default"]("<p style=\"font-size:" + key + "\">" + item.name + "</p>"),
        value: item.value
      });
    }
  }

  cov_yue8gntm8().s[9]++;

  FontSizeList.prototype.getItemList = function () {
    cov_yue8gntm8().f[3]++;
    cov_yue8gntm8().s[10]++;
    return this.itemList;
  };

  cov_yue8gntm8().s[11]++;
  return FontSizeList;
}());
cov_yue8gntm8().s[12]++;
exports["default"] = FontSizeList;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 对齐方式
 * @author liuwei
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1auzquc5yv() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/justify/index.ts";
  var hash = "30bd703f579a187c5d511ad01e3754d28f3cb034";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/justify/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 21
        },
        end: {
          line: 23,
          column: 82
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 29
        },
        end: {
          line: 109,
          column: 25
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 31
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 109
        }
      },
      "21": {
        start: {
          line: 30,
          column: 27
        },
        end: {
          line: 56,
          column: 9
        }
      },
      "22": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 54,
          column: 37
        }
      },
      "23": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 71
        }
      },
      "24": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 21
        }
      },
      "25": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 93,
          column: 6
        }
      },
      "26": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 32
        }
      },
      "27": {
        start: {
          line: 66,
          column: 24
        },
        end: {
          line: 66,
          column: 40
        }
      },
      "28": {
        start: {
          line: 67,
          column: 29
        },
        end: {
          line: 67,
          column: 66
        }
      },
      "29": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 30
        }
      },
      "30": {
        start: {
          line: 71,
          column: 27
        },
        end: {
          line: 76,
          column: 9
        }
      },
      "31": {
        start: {
          line: 78,
          column: 21
        },
        end: {
          line: 78,
          column: 71
        }
      },
      "32": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 90,
          column: 9
        }
      },
      "33": {
        start: {
          line: 82,
          column: 33
        },
        end: {
          line: 82,
          column: 52
        }
      },
      "34": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 85,
          column: 15
        }
      },
      "35": {
        start: {
          line: 84,
          column: 16
        },
        end: {
          line: 84,
          column: 53
        }
      },
      "36": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 89,
          column: 40
        }
      },
      "37": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 37
        }
      },
      "38": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 107,
          column: 6
        }
      },
      "39": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 19
        }
      },
      "40": {
        start: {
          line: 110,
          column: 0
        },
        end: {
          line: 110,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 29
          },
          end: {
            line: 25,
            column: 30
          }
        },
        loc: {
          start: {
            line: 25,
            column: 47
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "Justify",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 20
          }
        },
        loc: {
          start: {
            line: 27,
            column: 29
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 52,
            column: 26
          },
          end: {
            line: 52,
            column: 27
          }
        },
        loc: {
          start: {
            line: 52,
            column: 43
          },
          end: {
            line: 55,
            column: 13
          }
        },
        line: 52
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 64,
            column: 32
          },
          end: {
            line: 64,
            column: 33
          }
        },
        loc: {
          start: {
            line: 64,
            column: 49
          },
          end: {
            line: 93,
            column: 5
          }
        },
        line: 64
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 83,
            column: 27
          },
          end: {
            line: 83,
            column: 28
          }
        },
        loc: {
          start: {
            line: 83,
            column: 41
          },
          end: {
            line: 85,
            column: 13
          }
        },
        line: 83
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 99,
            column: 40
          },
          end: {
            line: 99,
            column: 41
          }
        },
        loc: {
          start: {
            line: 99,
            column: 52
          },
          end: {
            line: 107,
            column: 5
          }
        },
        line: 99
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 16
          },
          end: {
            line: 57,
            column: 62
          }
        }, {
          start: {
            line: 57,
            column: 66
          },
          end: {
            line: 57,
            column: 70
          }
        }],
        line: 57
      },
      "8": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        }, {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 90,
            column: 9
          }
        }],
        line: 80
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 80,
            column: 26
          }
        }, {
          start: {
            line: 80,
            column: 30
          },
          end: {
            line: 80,
            column: 68
          }
        }],
        line: 80
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/justify/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/justify/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoD;AAIpD;IAAsB,2BAAY;IAC9B,iBAAY,MAAc;QAA1B,iBAmDC;QAlDG,IAAM,KAAK,GAAG,kBAAC,CAAC,qEAAqE,CAAC,CAAA;QAEtF,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE;gBACF;oBACI,KAAK,EAAE,kBAAC,CACJ,gIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,+BAA+B,CAAC,mCAClD,CACR;oBACD,KAAK,EAAE,aAAa;iBACvB;gBACD;oBACI,KAAK,EAAE,kBAAC,CACJ,kIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,+BAA+B,CAAC,mCAClD,CACR;oBACD,KAAK,EAAE,eAAe;iBACzB;gBACD;oBACI,KAAK,EAAE,kBAAC,CACJ,iIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,+BAA+B,CAAC,mCAClD,CACR;oBACD,KAAK,EAAE,cAAc;iBACxB;gBACD;oBACI,KAAK,EAAE,kBAAC,CACJ,mIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,+BAA+B,CAAC,mCAClD,CACR;oBACD,KAAK,EAAE,aAAa;iBACvB;aACJ;YACD,YAAY,EAAE,UAAC,KAAa;gBACxB,eAAe;gBACf,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IACD;;;OAGG;IACI,yBAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,cAAc,GAAG,SAAS,CAAC,yBAAyB,EAAE,CAAA;QAC5D,OAAO;QACP,SAAS,CAAC,SAAS,EAAE,CAAA;QAKrB,MAAM;QACN,IAAM,YAAY,GAAgB;YAC9B,WAAW,EAAE,MAAM;YACnB,aAAa,EAAE,QAAQ;YACvB,YAAY,EAAE,OAAO;YACrB,WAAW,EAAE,SAAS;SACzB,CAAA;QACD,SAAS;QACT,IAAM,MAAM,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAA;QACjE,yBAAyB;QACzB,IAAI,cAAc,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,cAAc,CAAC,EAAE;YAC1D,mBAAmB;YACnB,IAAM,cAAY,GAAG,YAAY,CAAC,KAAK,CAAC,CAAA;YACxC,MAAM,CAAC,OAAO,CAAC,UAAC,EAAc;gBAC1B,EAAE,CAAC,GAAG,CAAC,YAAY,EAAE,cAAY,CAAC,CAAA;YACtC,CAAC,CAAC,CAAA;SACL;aAAM;YACH,uBAAuB;YACvB,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,KAAK,EAAE,KAAK,CAAC,CAAA;SAC9B;QACD,MAAM;QACN,SAAS,CAAC,gBAAgB,EAAE,CAAA;IAChC,CAAC;IAED;;;;OAIG;IACI,iCAAe,GAAtB;QACI,6BAA6B;QAC7B,+FAA+F;QAC/F,mBAAmB;QACnB,oBAAoB;QACpB,WAAW;QACX,sBAAsB;QACtB,IAAI;IACR,CAAC;IACL,cAAC;AAAD,CAAC,AAzGD,CAAsB,sBAAY,GAyGjC;AAED,kBAAe,OAAO,CAAA",
      sourcesContent: ["/**\n * @description \u5BF9\u9F50\u65B9\u5F0F\n * @author liuwei\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Justify extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-paragraph-left\"></i></div>')\n\n        const dropListConf = {\n            width: 100,\n            title: '\u5BF9\u9F50\u65B9\u5F0F',\n            type: 'list', // droplist \u4EE5\u5217\u8868\u5F62\u5F0F\u5C55\u793A\n            list: [\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-paragraph-left w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.justify.\u9760\u5DE6')}\n                        </p>`\n                    ),\n                    value: 'justifyLeft',\n                },\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-paragraph-center w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.justify.\u5C45\u4E2D')}\n                        </p>`\n                    ),\n                    value: 'justifyCenter',\n                },\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-paragraph-right w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.justify.\u9760\u53F3')}\n                        </p>`\n                    ),\n                    value: 'justifyRight',\n                },\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-paragraph-justify w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.justify.\u4E24\u7AEF')}\n                        </p>`\n                    ),\n                    value: 'justifyFull',\n                },\n            ],\n            clickHandler: (value: string) => {\n                // \u6267\u884C\u5BF9\u5E94\u7684value\u64CD\u4F5C\n                this.command(value)\n            },\n        }\n        super($elem, editor, dropListConf)\n    }\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        const selection = editor.selection\n        const $selectionElem = selection.getSelectionContainerElem()\n        // \u4FDD\u5B58\u9009\u533A\n        selection.saveRange()\n        // \u5B9A\u4E49\u5BF9\u9F50\u65B9\u5F0F\u7684type\n        type justifyType = {\n            [key: string]: string\n        }\n        // \u6570\u636E\u9879\n        const justifyClass: justifyType = {\n            justifyLeft: 'left',\n            justifyCenter: 'center',\n            justifyRight: 'right',\n            justifyFull: 'justify',\n        }\n        // \u83B7\u53D6\u9876\u7EA7\u5143\u7D20\n        const $elems = editor.selection.getSelectionRangeTopNodes(editor)\n        // \u9009\u533A\u7B49\u4E8EtextElem\u65F6\u8868\u793A\u9009\u62E9\u4E86\u591A\u4E2A\u6BB5\u843D\n        if ($selectionElem && editor.$textElem.equal($selectionElem)) {\n            // \u83B7\u53D6\u5728css\u4E2D\u5BF9\u5E94style\u7684\u503C\n            const justifyValue = justifyClass[value]\n            $elems.forEach((el: DomElement) => {\n                el.css('text-align', justifyValue)\n            })\n        } else {\n            // \u5982\u679C\u5355\u884C\u7684\u4F7F\u7528execcommand\u5B9E\u73B0\n            editor.cmd.do(value, value)\n        }\n        //\u6062\u590D\u9009\u533A\n        selection.restoreSelection()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u6539\u53D8\u83DC\u5355\u6FC0\u6D3B\uFF08\u9AD8\u4EAE\uFF09\u72B6\u6001\n     * \u9ED8\u8BA4\u5DE6\u5BF9\u9F50,\u82E5\u9009\u62E9\u5176\u4ED6\u5BF9\u5176\u65B9\u5F0F\u5BF9active\u8FDB\u884C\u9AD8\u4EAE\u5426\u5219unActive\n     * ?\u8003\u8651\u4F18\u5316\u7684\u8BDD \u662F\u5426\u53EF\u4EE5\u5BF9\u5177\u4F53\u9009\u4E2D\u7684\u8FDB\u884C\u9AD8\u4EAE\n     */\n    public tryChangeActive(): void {\n        // const editor = this.editor\n        // let isjustify = ['justifyCenter', 'justifyRight'].some(e => editor.cmd.queryCommandState(e))\n        // if (isjustify) {\n        //     this.active()\n        // } else {\n        //     this.unActive()\n        // }\n    }\n}\n\nexport default Justify\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "30bd703f579a187c5d511ad01e3754d28f3cb034"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1auzquc5yv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1auzquc5yv();

var __extends = (cov_1auzquc5yv().s[0]++, (cov_1auzquc5yv().b[0][0]++, void 0) && (cov_1auzquc5yv().b[0][1]++, (void 0).__extends) || (cov_1auzquc5yv().b[0][2]++, function () {
  cov_1auzquc5yv().f[0]++;
  cov_1auzquc5yv().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1auzquc5yv().f[1]++;
    cov_1auzquc5yv().s[2]++;
    _extendStatics = (cov_1auzquc5yv().b[1][0]++, _setPrototypeOf["default"]) || (cov_1auzquc5yv().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1auzquc5yv().b[1][2]++, function (d, b) {
      cov_1auzquc5yv().f[2]++;
      cov_1auzquc5yv().s[3]++;
      d.__proto__ = b;
    }) || (cov_1auzquc5yv().b[1][3]++, function (d, b) {
      cov_1auzquc5yv().f[3]++;
      cov_1auzquc5yv().s[4]++;

      for (var p in b) {
        cov_1auzquc5yv().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1auzquc5yv().b[2][0]++;
          cov_1auzquc5yv().s[6]++;
          d[p] = b[p];
        } else {
          cov_1auzquc5yv().b[2][1]++;
        }
      }
    });
    cov_1auzquc5yv().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1auzquc5yv().s[8]++;
  return function (d, b) {
    cov_1auzquc5yv().f[4]++;
    cov_1auzquc5yv().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1auzquc5yv().f[5]++;
      cov_1auzquc5yv().s[10]++;
      this.constructor = d;
    }

    cov_1auzquc5yv().s[11]++;
    d.prototype = b === null ? (cov_1auzquc5yv().b[3][0]++, (0, _create["default"])(b)) : (cov_1auzquc5yv().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1auzquc5yv().s[12]++, (cov_1auzquc5yv().b[4][0]++, void 0) && (cov_1auzquc5yv().b[4][1]++, (void 0).__importDefault) || (cov_1auzquc5yv().b[4][2]++, function (mod) {
  cov_1auzquc5yv().f[6]++;
  cov_1auzquc5yv().s[13]++;
  return (cov_1auzquc5yv().b[6][0]++, mod) && (cov_1auzquc5yv().b[6][1]++, mod.__esModule) ? (cov_1auzquc5yv().b[5][0]++, mod) : (cov_1auzquc5yv().b[5][1]++, {
    "default": mod
  });
}));

cov_1auzquc5yv().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_1auzquc5yv().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_1auzquc5yv().s[16]++, __importDefault(__webpack_require__(2)));
var Justify = (
/** @class */
cov_1auzquc5yv().s[17]++, function (_super) {
  cov_1auzquc5yv().f[7]++;
  cov_1auzquc5yv().s[18]++;

  __extends(Justify, _super);

  function Justify(editor) {
    cov_1auzquc5yv().f[8]++;

    var _this = (cov_1auzquc5yv().s[19]++, this);

    var $elem = (cov_1auzquc5yv().s[20]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-paragraph-left"></i></div>'));
    var dropListConf = (cov_1auzquc5yv().s[21]++, {
      width: 100,
      title: '对齐方式',
      type: 'list',
      list: [{
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-paragraph-left w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.靠左') + "\n                        </p>"),
        value: 'justifyLeft'
      }, {
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-paragraph-center w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.居中') + "\n                        </p>"),
        value: 'justifyCenter'
      }, {
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-paragraph-right w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.靠右') + "\n                        </p>"),
        value: 'justifyRight'
      }, {
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-paragraph-justify w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.justify.两端') + "\n                        </p>"),
        value: 'justifyFull'
      }],
      clickHandler: function clickHandler(value) {
        cov_1auzquc5yv().f[9]++;
        cov_1auzquc5yv().s[22]++;

        // 执行对应的value操作
        _this.command(value);
      }
    });
    cov_1auzquc5yv().s[23]++;
    _this = (cov_1auzquc5yv().b[7][0]++, _super.call(this, $elem, editor, dropListConf)) || (cov_1auzquc5yv().b[7][1]++, this);
    cov_1auzquc5yv().s[24]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_1auzquc5yv().s[25]++;

  Justify.prototype.command = function (value) {
    cov_1auzquc5yv().f[10]++;
    var editor = (cov_1auzquc5yv().s[26]++, this.editor);
    var selection = (cov_1auzquc5yv().s[27]++, editor.selection);
    var $selectionElem = (cov_1auzquc5yv().s[28]++, selection.getSelectionContainerElem()); // 保存选区

    cov_1auzquc5yv().s[29]++;
    selection.saveRange(); // 数据项

    var justifyClass = (cov_1auzquc5yv().s[30]++, {
      justifyLeft: 'left',
      justifyCenter: 'center',
      justifyRight: 'right',
      justifyFull: 'justify'
    }); // 获取顶级元素

    var $elems = (cov_1auzquc5yv().s[31]++, editor.selection.getSelectionRangeTopNodes(editor)); // 选区等于textElem时表示选择了多个段落

    cov_1auzquc5yv().s[32]++;

    if ((cov_1auzquc5yv().b[9][0]++, $selectionElem) && (cov_1auzquc5yv().b[9][1]++, editor.$textElem.equal($selectionElem))) {
      cov_1auzquc5yv().b[8][0]++;
      // 获取在css中对应style的值
      var justifyValue_1 = (cov_1auzquc5yv().s[33]++, justifyClass[value]);
      cov_1auzquc5yv().s[34]++;
      (0, _forEach["default"])($elems).call($elems, function (el) {
        cov_1auzquc5yv().f[11]++;
        cov_1auzquc5yv().s[35]++;
        el.css('text-align', justifyValue_1);
      });
    } else {
      cov_1auzquc5yv().b[8][1]++;
      cov_1auzquc5yv().s[36]++;
      // 如果单行的使用execcommand实现
      editor.cmd["do"](value, value);
    } //恢复选区


    cov_1auzquc5yv().s[37]++;
    selection.restoreSelection();
  };
  /**
   * 尝试改变菜单激活（高亮）状态
   * 默认左对齐,若选择其他对其方式对active进行高亮否则unActive
   * ?考虑优化的话 是否可以对具体选中的进行高亮
   */


  cov_1auzquc5yv().s[38]++;

  Justify.prototype.tryChangeActive = function () {// const editor = this.editor
    // let isjustify = ['justifyCenter', 'justifyRight'].some(e => editor.cmd.queryCommandState(e))
    // if (isjustify) {
    //     this.active()
    // } else {
    //     this.unActive()
    // }

    cov_1auzquc5yv().f[12]++;
  };

  cov_1auzquc5yv().s[39]++;
  return Justify;
}(DropListMenu_1["default"]));
cov_1auzquc5yv().s[40]++;
exports["default"] = Justify;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 引用
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1ykf3ozmui() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/quote/index.ts";
  var hash = "f82321156f9880a20603f529ec373c13519adfff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 72
        }
      },
      "17": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 25,
          column: 59
        }
      },
      "18": {
        start: {
          line: 26,
          column: 26
        },
        end: {
          line: 26,
          column: 73
        }
      },
      "19": {
        start: {
          line: 27,
          column: 27
        },
        end: {
          line: 120,
          column: 20
        }
      },
      "20": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "22": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 142
        }
      },
      "23": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 57
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "25": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 21
        }
      },
      "26": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 84,
          column: 6
        }
      },
      "27": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 41,
          column: 32
        }
      },
      "28": {
        start: {
          line: 42,
          column: 28
        },
        end: {
          line: 42,
          column: 63
        }
      },
      "29": {
        start: {
          line: 43,
          column: 26
        },
        end: {
          line: 43,
          column: 76
        }
      },
      "30": {
        start: {
          line: 44,
          column: 27
        },
        end: {
          line: 44,
          column: 62
        }
      },
      "31": {
        start: {
          line: 45,
          column: 23
        },
        end: {
          line: 45,
          column: 44
        }
      },
      "32": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 78,
          column: 9
        }
      },
      "33": {
        start: {
          line: 50,
          column: 30
        },
        end: {
          line: 50,
          column: 75
        }
      },
      "34": {
        start: {
          line: 51,
          column: 22
        },
        end: {
          line: 51,
          column: 40
        }
      },
      "35": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 52,
          column: 40
        }
      },
      "36": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 57,
          column: 15
        }
      },
      "37": {
        start: {
          line: 54,
          column: 28
        },
        end: {
          line: 54,
          column: 52
        }
      },
      "38": {
        start: {
          line: 55,
          column: 16
        },
        end: {
          line: 55,
          column: 45
        }
      },
      "39": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 56,
          column: 34
        }
      },
      "40": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 34
        }
      },
      "41": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 68
        }
      },
      "42": {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 61,
          column: 35
        }
      },
      "43": {
        start: {
          line: 65,
          column: 25
        },
        end: {
          line: 65,
          column: 65
        }
      },
      "44": {
        start: {
          line: 66,
          column: 12
        },
        end: {
          line: 66,
          column: 45
        }
      },
      "45": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 67,
          column: 44
        }
      },
      "46": {
        start: {
          line: 68,
          column: 27
        },
        end: {
          line: 68,
          column: 110
        }
      },
      "47": {
        start: {
          line: 70,
          column: 12
        },
        end: {
          line: 72,
          column: 62
        }
      },
      "48": {
        start: {
          line: 74,
          column: 12
        },
        end: {
          line: 74,
          column: 35
        }
      },
      "49": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 76,
          column: 66
        }
      },
      "50": {
        start: {
          line: 77,
          column: 12
        },
        end: {
          line: 77,
          column: 19
        }
      },
      "51": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      "52": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 81,
          column: 45
        }
      },
      "53": {
        start: {
          line: 82,
          column: 12
        },
        end: {
          line: 82,
          column: 48
        }
      },
      "54": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 98,
          column: 6
        }
      },
      "55": {
        start: {
          line: 90,
          column: 21
        },
        end: {
          line: 90,
          column: 32
        }
      },
      "56": {
        start: {
          line: 91,
          column: 23
        },
        end: {
          line: 91,
          column: 137
        }
      },
      "57": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 97,
          column: 9
        }
      },
      "58": {
        start: {
          line: 93,
          column: 12
        },
        end: {
          line: 93,
          column: 26
        }
      },
      "59": {
        start: {
          line: 96,
          column: 12
        },
        end: {
          line: 96,
          column: 28
        }
      },
      "60": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 109,
          column: 6
        }
      },
      "61": {
        start: {
          line: 105,
          column: 21
        },
        end: {
          line: 105,
          column: 32
        }
      },
      "62": {
        start: {
          line: 106,
          column: 27
        },
        end: {
          line: 106,
          column: 80
        }
      },
      "63": {
        start: {
          line: 107,
          column: 23
        },
        end: {
          line: 107,
          column: 109
        }
      },
      "64": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 108,
          column: 24
        }
      },
      "65": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 6
        }
      },
      "66": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 117,
          column: 11
        }
      },
      "67": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 116,
          column: 26
        }
      },
      "68": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 17
        }
      },
      "69": {
        start: {
          line: 121,
          column: 0
        },
        end: {
          line: 121,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 28
          }
        },
        loc: {
          start: {
            line: 27,
            column: 45
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 27
      },
      "8": {
        name: "Quote",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 27
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 29
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 39,
            column: 36
          }
        },
        loc: {
          start: {
            line: 39,
            column: 47
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 39
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 53,
            column: 32
          },
          end: {
            line: 53,
            column: 33
          }
        },
        loc: {
          start: {
            line: 53,
            column: 48
          },
          end: {
            line: 57,
            column: 13
          }
        },
        line: 53
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 88,
            column: 38
          },
          end: {
            line: 88,
            column: 39
          }
        },
        loc: {
          start: {
            line: 88,
            column: 50
          },
          end: {
            line: 98,
            column: 5
          }
        },
        line: 88
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 104,
            column: 37
          },
          end: {
            line: 104,
            column: 38
          }
        },
        loc: {
          start: {
            line: 104,
            column: 49
          },
          end: {
            line: 109,
            column: 5
          }
        },
        line: 104
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 114,
            column: 36
          },
          end: {
            line: 114,
            column: 37
          }
        },
        loc: {
          start: {
            line: 114,
            column: 58
          },
          end: {
            line: 118,
            column: 5
          }
        },
        line: 114
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 115,
            column: 27
          },
          end: {
            line: 115,
            column: 28
          }
        },
        loc: {
          start: {
            line: 115,
            column: 43
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 115
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 48
          }
        }, {
          start: {
            line: 32,
            column: 52
          },
          end: {
            line: 32,
            column: 56
          }
        }],
        line: 32
      },
      "8": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }, {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 78,
            column: 9
          }
        }],
        line: 48
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 27
          },
          end: {
            line: 68,
            column: 110
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 82
          },
          end: {
            line: 68,
            column: 88
          }
        }, {
          start: {
            line: 68,
            column: 91
          },
          end: {
            line: 68,
            column: 110
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 68,
            column: 27
          },
          end: {
            line: 68,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 27
          },
          end: {
            line: 68,
            column: 62
          }
        }, {
          start: {
            line: 68,
            column: 66
          },
          end: {
            line: 68,
            column: 79
          }
        }],
        line: 68
      },
      "11": {
        loc: {
          start: {
            line: 70,
            column: 12
          },
          end: {
            line: 72,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 18
          },
          end: {
            line: 71,
            column: 55
          }
        }, {
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 61
          }
        }],
        line: 70
      },
      "12": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }],
        line: 79
      },
      "13": {
        loc: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 137
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 112
          },
          end: {
            line: 91,
            column: 118
          }
        }, {
          start: {
            line: 91,
            column: 121
          },
          end: {
            line: 91,
            column: 137
          }
        }],
        line: 91
      },
      "14": {
        loc: {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 92
          }
        }, {
          start: {
            line: 91,
            column: 96
          },
          end: {
            line: 91,
            column: 109
          }
        }],
        line: 91
      },
      "15": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }, {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 97,
            column: 9
          }
        }],
        line: 92
      },
      "16": {
        loc: {
          start: {
            line: 107,
            column: 23
          },
          end: {
            line: 107,
            column: 109
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 74
          },
          end: {
            line: 107,
            column: 80
          }
        }, {
          start: {
            line: 107,
            column: 83
          },
          end: {
            line: 107,
            column: 109
          }
        }],
        line: 107
      },
      "17": {
        loc: {
          start: {
            line: 107,
            column: 23
          },
          end: {
            line: 107,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 23
          },
          end: {
            line: 107,
            column: 44
          }
        }, {
          start: {
            line: 107,
            column: 48
          },
          end: {
            line: 107,
            column: 71
          }
        }],
        line: 107
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/quote/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoD;AAEpD,yEAAkD;AAElD,4DAAoC;AACpC,0EAA6C;AAE7C;IAAoB,yBAAO;IACvB,eAAY,MAAc;QAA1B,iBAQC;QAPG,IAAM,KAAK,GAAG,kBAAC,CACX,sGAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QACpB,oBAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IAED;;OAEG;IACI,4BAAY,GAAnB;;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QACzD,IAAM,WAAW,GAAiB,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAA;QACpF,IAAM,YAAY,GAAe,WAAW,CAAC,WAAW,CAAC,MAAM,GAAG,CAAC,CAAC,CAAA;QACpE,IAAM,QAAQ,GAAG,IAAI,CAAC,cAAc,EAAE,CAAA;QACtC,6CAA6C;QAC7C,6BAA6B;QAC7B,IAAI,QAAQ,KAAK,YAAY,EAAE;YAC3B,WAAW;YACX,IAAM,WAAW,GAAG,kBAAC,CAAC,YAAY,CAAC,UAAU,EAAE,CAAC,CAAA;YAChD,IAAM,GAAG,GAAG,WAAW,CAAC,MAAM,CAAA;YAC9B,IAAI,SAAO,GAAG,YAAY,CAAA;YAC1B,WAAW,CAAC,OAAO,CAAC,UAAC,IAAU;gBAC3B,IAAM,KAAK,GAAG,kBAAC,CAAC,IAAI,CAAC,CAAA;gBACrB,KAAK,CAAC,WAAW,CAAC,SAAO,CAAC,CAAA;gBAC1B,SAAO,GAAG,KAAK,CAAA;YACnB,CAAC,CAAC,CAAA;YACF,YAAY,CAAC,MAAM,EAAE,CAAA;YACrB,MAAM,CAAC,SAAS,CAAC,UAAU,CAAC,WAAW,CAAC,KAAK,CAAC,GAAG,GAAG,CAAC,CAAC,CAAC,CAAA;YACvD,YAAY;YACZ,IAAI,CAAC,eAAe,EAAE,CAAA;SACzB;aAAM;YACH,gBAAgB;YAChB,IAAM,MAAM,GAAG,2BAAW,CAAC,WAAW,CAAC,CAAA;YACvC,MAAM,CAAC,WAAW,CAAC,YAAY,CAAC,CAAA;YAChC,IAAI,CAAC,aAAa,CAAC,WAAW,CAAC,CAAA;YAC/B,IAAM,QAAQ,GAAG,MAAA,MAAM,CAAC,UAAU,EAAE,0CAAE,IAAI,GAAG,OAAO,EAAU,CAAA;YAC9D,4CAA4C;YAC5C,QAAQ,CAAC,WAAW;gBAChB,CAAC,CAAC,MAAM,CAAC,SAAS,CAAC,UAAU,CAAC,QAAQ,CAAC;gBACvC,CAAC,CAAC,MAAM,CAAC,SAAS,CAAC,UAAU,CAAC,QAAQ,EAAE,IAAI,CAAC,CAAA;YACjD,YAAY;YACZ,IAAI,CAAC,eAAe,EAAE,CAAA;YACtB,aAAa;YACb,kBAAC,CAAC,aAAa,CAAC,CAAC,WAAW,CAAC,MAAM,CAAC,CAAA;YACpC,OAAM;SACT;QAED,IAAI,aAAa,EAAE;YACf,cAAc;YACd,MAAM,CAAC,SAAS,CAAC,aAAa,EAAE,CAAA;YAChC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;SACtC;IACL,CAAC;IAED;;OAEG;IACI,+BAAe,GAAtB;;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,QAAQ,SAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,0CAAE,WAAW,EAAE,CAAA;QACrF,IAAI,QAAQ,KAAK,YAAY,EAAE;YAC3B,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IAED;;;;OAIG;IACK,8BAAc,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,YAAY,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAA;QAC1E,IAAM,QAAQ,GAAG,YAAY,aAAZ,YAAY,uBAAZ,YAAY,CAAE,WAAW,EAAE,CAAA;QAE5C,OAAO,QAAQ,CAAA;IACnB,CAAC;IAED;;;OAGG;IACK,6BAAa,GAArB,UAAsB,UAAwB;QAC1C,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;YACnB,IAAI,CAAC,MAAM,EAAE,CAAA;QACjB,CAAC,CAAC,CAAA;IACN,CAAC;IACL,YAAC;AAAD,CAAC,AA/FD,CAAoB,iBAAO,GA+F1B;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description \u5F15\u7528\n * @author tonghan\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event'\nimport createQuote from './create-quote-node'\n\nclass Quote extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-quotes-left\"></i>\n            </div>`\n        )\n        super($elem, editor)\n        bindEvent(editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const isSelectEmpty = editor.selection.isSelectionEmpty()\n        const topNodeElem: DomElement[] = editor.selection.getSelectionRangeTopNodes(editor)\n        const $topNodeElem: DomElement = topNodeElem[topNodeElem.length - 1]\n        const nodeName = this.getTopNodeName()\n        // IE \u4E2D\u4E0D\u652F\u6301 formatBlock <BLOCKQUOTE> \uFF0C\u8981\u7528\u5176\u4ED6\u65B9\u5F0F\u517C\u5BB9\n        // \u517C\u5BB9firefox\u65E0\u6CD5\u53D6\u6D88blockquote\u7684\u95EE\u9898\n        if (nodeName === 'BLOCKQUOTE') {\n            // \u64A4\u9500 quote\n            const $targetELem = $($topNodeElem.childNodes())\n            const len = $targetELem.length\n            let $middle = $topNodeElem\n            $targetELem.forEach((elem: Node) => {\n                const $elem = $(elem)\n                $elem.insertAfter($middle)\n                $middle = $elem\n            })\n            $topNodeElem.remove()\n            editor.selection.moveCursor($targetELem.elems[len - 1])\n            // \u5373\u65F6\u66F4\u65B0btn\u72B6\u6001\n            this.tryChangeActive()\n        } else {\n            // \u5C06 P \u8F6C\u6362\u4E3A quote\n            const $quote = createQuote(topNodeElem)\n            $quote.insertAfter($topNodeElem)\n            this.delSelectNode(topNodeElem)\n            const moveNode = $quote.childNodes()?.last().getNode() as Node\n            // \u517C\u5BB9firefox\uFF08firefox\u4E0B\u7A7A\u884C\u60C5\u51B5\u4E0B\u9009\u533A\u4F1A\u5728br\u540E\uFF0C\u9020\u6210\u81EA\u52A8\u6362\u884C\u7684\u95EE\u9898\uFF09\n            moveNode.textContent\n                ? editor.selection.moveCursor(moveNode)\n                : editor.selection.moveCursor(moveNode, true)\n            // \u5373\u65F6\u66F4\u65B0btn\u72B6\u6001\n            this.tryChangeActive()\n            // \u9632\u6B62\u6700\u540E\u4E00\u884C\u65E0\u6CD5\u8DF3\u51FA\n            $(`<p><br></p>`).insertAfter($quote)\n            return\n        }\n\n        if (isSelectEmpty) {\n            // \u9700\u8981\u5C06\u9009\u533A\u8303\u56F4\u6298\u53E0\u8D77\u6765\n            editor.selection.collapseRange()\n            editor.selection.restoreSelection()\n        }\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        const cmdValue = editor.selection.getSelectionRangeTopNodes(editor)[0]?.getNodeName()\n        if (cmdValue === 'BLOCKQUOTE') {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n\n    /**\n     * \u83B7\u53D6\u5305\u88F9\u5728\u6700\u5916\u5C42\u7684\u8282\u70B9(\u9632\u6B62\u5185\u90E8\u5D4C\u5165\u591A\u4E2A\u6837\u5F0F)\n     * @param selectionElem \u9009\u4E2D\u7684\u8282\u70B9\n     * @returns {string} \u6700\u7EC8\u8981\u5904\u7406\u7684\u8282\u70B9\u540D\u79F0\n     */\n    private getTopNodeName(): string {\n        const editor = this.editor\n        const $topNodeElem = editor.selection.getSelectionRangeTopNodes(editor)[0]\n        const nodeName = $topNodeElem?.getNodeName()\n\n        return nodeName\n    }\n\n    /**\n     * \u5220\u9664\u9009\u4E2D\u7684\u5143\u7D20\n     * @param selectElem \u9009\u4E2D\u7684\u5143\u7D20\u8282\u70B9\u6570\u7EC4\n     */\n    private delSelectNode(selectElem: DomElement[]) {\n        selectElem.forEach(node => {\n            node.remove()\n        })\n    }\n}\n\nexport default Quote\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f82321156f9880a20603f529ec373c13519adfff"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ykf3ozmui = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ykf3ozmui();

var __extends = (cov_1ykf3ozmui().s[0]++, (cov_1ykf3ozmui().b[0][0]++, void 0) && (cov_1ykf3ozmui().b[0][1]++, (void 0).__extends) || (cov_1ykf3ozmui().b[0][2]++, function () {
  cov_1ykf3ozmui().f[0]++;
  cov_1ykf3ozmui().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1ykf3ozmui().f[1]++;
    cov_1ykf3ozmui().s[2]++;
    _extendStatics = (cov_1ykf3ozmui().b[1][0]++, _setPrototypeOf["default"]) || (cov_1ykf3ozmui().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1ykf3ozmui().b[1][2]++, function (d, b) {
      cov_1ykf3ozmui().f[2]++;
      cov_1ykf3ozmui().s[3]++;
      d.__proto__ = b;
    }) || (cov_1ykf3ozmui().b[1][3]++, function (d, b) {
      cov_1ykf3ozmui().f[3]++;
      cov_1ykf3ozmui().s[4]++;

      for (var p in b) {
        cov_1ykf3ozmui().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1ykf3ozmui().b[2][0]++;
          cov_1ykf3ozmui().s[6]++;
          d[p] = b[p];
        } else {
          cov_1ykf3ozmui().b[2][1]++;
        }
      }
    });
    cov_1ykf3ozmui().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1ykf3ozmui().s[8]++;
  return function (d, b) {
    cov_1ykf3ozmui().f[4]++;
    cov_1ykf3ozmui().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1ykf3ozmui().f[5]++;
      cov_1ykf3ozmui().s[10]++;
      this.constructor = d;
    }

    cov_1ykf3ozmui().s[11]++;
    d.prototype = b === null ? (cov_1ykf3ozmui().b[3][0]++, (0, _create["default"])(b)) : (cov_1ykf3ozmui().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1ykf3ozmui().s[12]++, (cov_1ykf3ozmui().b[4][0]++, void 0) && (cov_1ykf3ozmui().b[4][1]++, (void 0).__importDefault) || (cov_1ykf3ozmui().b[4][2]++, function (mod) {
  cov_1ykf3ozmui().f[6]++;
  cov_1ykf3ozmui().s[13]++;
  return (cov_1ykf3ozmui().b[6][0]++, mod) && (cov_1ykf3ozmui().b[6][1]++, mod.__esModule) ? (cov_1ykf3ozmui().b[5][0]++, mod) : (cov_1ykf3ozmui().b[5][1]++, {
    "default": mod
  });
}));

cov_1ykf3ozmui().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1ykf3ozmui().s[15]++, __importDefault(__webpack_require__(2)));
var BtnMenu_1 = (cov_1ykf3ozmui().s[16]++, __importDefault(__webpack_require__(24)));
var bind_event_1 = (cov_1ykf3ozmui().s[17]++, __importDefault(__webpack_require__(323)));
var create_quote_node_1 = (cov_1ykf3ozmui().s[18]++, __importDefault(__webpack_require__(324)));
var Quote = (
/** @class */
cov_1ykf3ozmui().s[19]++, function (_super) {
  cov_1ykf3ozmui().f[7]++;
  cov_1ykf3ozmui().s[20]++;

  __extends(Quote, _super);

  function Quote(editor) {
    cov_1ykf3ozmui().f[8]++;

    var _this = (cov_1ykf3ozmui().s[21]++, this);

    var $elem = (cov_1ykf3ozmui().s[22]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-quotes-left\"></i>\n            </div>"));
    cov_1ykf3ozmui().s[23]++;
    _this = (cov_1ykf3ozmui().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1ykf3ozmui().b[7][1]++, this);
    cov_1ykf3ozmui().s[24]++;
    bind_event_1["default"](editor);
    cov_1ykf3ozmui().s[25]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_1ykf3ozmui().s[26]++;

  Quote.prototype.clickHandler = function () {
    cov_1ykf3ozmui().f[9]++;

    var _a;

    var editor = (cov_1ykf3ozmui().s[27]++, this.editor);
    var isSelectEmpty = (cov_1ykf3ozmui().s[28]++, editor.selection.isSelectionEmpty());
    var topNodeElem = (cov_1ykf3ozmui().s[29]++, editor.selection.getSelectionRangeTopNodes(editor));
    var $topNodeElem = (cov_1ykf3ozmui().s[30]++, topNodeElem[topNodeElem.length - 1]);
    var nodeName = (cov_1ykf3ozmui().s[31]++, this.getTopNodeName()); // IE 中不支持 formatBlock <BLOCKQUOTE> ，要用其他方式兼容
    // 兼容firefox无法取消blockquote的问题

    cov_1ykf3ozmui().s[32]++;

    if (nodeName === 'BLOCKQUOTE') {
      cov_1ykf3ozmui().b[8][0]++;
      // 撤销 quote
      var $targetELem = (cov_1ykf3ozmui().s[33]++, dom_core_1["default"]($topNodeElem.childNodes()));
      var len = (cov_1ykf3ozmui().s[34]++, $targetELem.length);
      var $middle_1 = (cov_1ykf3ozmui().s[35]++, $topNodeElem);
      cov_1ykf3ozmui().s[36]++;
      (0, _forEach["default"])($targetELem).call($targetELem, function (elem) {
        cov_1ykf3ozmui().f[10]++;
        var $elem = (cov_1ykf3ozmui().s[37]++, dom_core_1["default"](elem));
        cov_1ykf3ozmui().s[38]++;
        $elem.insertAfter($middle_1);
        cov_1ykf3ozmui().s[39]++;
        $middle_1 = $elem;
      });
      cov_1ykf3ozmui().s[40]++;
      $topNodeElem.remove();
      cov_1ykf3ozmui().s[41]++;
      editor.selection.moveCursor($targetELem.elems[len - 1]); // 即时更新btn状态

      cov_1ykf3ozmui().s[42]++;
      this.tryChangeActive();
    } else {
      cov_1ykf3ozmui().b[8][1]++;
      // 将 P 转换为 quote
      var $quote = (cov_1ykf3ozmui().s[43]++, create_quote_node_1["default"](topNodeElem));
      cov_1ykf3ozmui().s[44]++;
      $quote.insertAfter($topNodeElem);
      cov_1ykf3ozmui().s[45]++;
      this.delSelectNode(topNodeElem);
      var moveNode = (cov_1ykf3ozmui().s[46]++, (cov_1ykf3ozmui().b[10][0]++, (_a = $quote.childNodes()) === null) || (cov_1ykf3ozmui().b[10][1]++, _a === void 0) ? (cov_1ykf3ozmui().b[9][0]++, void 0) : (cov_1ykf3ozmui().b[9][1]++, _a.last().getNode())); // 兼容firefox（firefox下空行情况下选区会在br后，造成自动换行的问题）

      cov_1ykf3ozmui().s[47]++;
      moveNode.textContent ? (cov_1ykf3ozmui().b[11][0]++, editor.selection.moveCursor(moveNode)) : (cov_1ykf3ozmui().b[11][1]++, editor.selection.moveCursor(moveNode, true)); // 即时更新btn状态

      cov_1ykf3ozmui().s[48]++;
      this.tryChangeActive(); // 防止最后一行无法跳出

      cov_1ykf3ozmui().s[49]++;
      dom_core_1["default"]("<p><br></p>").insertAfter($quote);
      cov_1ykf3ozmui().s[50]++;
      return;
    }

    cov_1ykf3ozmui().s[51]++;

    if (isSelectEmpty) {
      cov_1ykf3ozmui().b[12][0]++;
      cov_1ykf3ozmui().s[52]++;
      // 需要将选区范围折叠起来
      editor.selection.collapseRange();
      cov_1ykf3ozmui().s[53]++;
      editor.selection.restoreSelection();
    } else {
      cov_1ykf3ozmui().b[12][1]++;
    }
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_1ykf3ozmui().s[54]++;

  Quote.prototype.tryChangeActive = function () {
    cov_1ykf3ozmui().f[11]++;

    var _a;

    var editor = (cov_1ykf3ozmui().s[55]++, this.editor);
    var cmdValue = (cov_1ykf3ozmui().s[56]++, (cov_1ykf3ozmui().b[14][0]++, (_a = editor.selection.getSelectionRangeTopNodes(editor)[0]) === null) || (cov_1ykf3ozmui().b[14][1]++, _a === void 0) ? (cov_1ykf3ozmui().b[13][0]++, void 0) : (cov_1ykf3ozmui().b[13][1]++, _a.getNodeName()));
    cov_1ykf3ozmui().s[57]++;

    if (cmdValue === 'BLOCKQUOTE') {
      cov_1ykf3ozmui().b[15][0]++;
      cov_1ykf3ozmui().s[58]++;
      this.active();
    } else {
      cov_1ykf3ozmui().b[15][1]++;
      cov_1ykf3ozmui().s[59]++;
      this.unActive();
    }
  };
  /**
   * 获取包裹在最外层的节点(防止内部嵌入多个样式)
   * @param selectionElem 选中的节点
   * @returns {string} 最终要处理的节点名称
   */


  cov_1ykf3ozmui().s[60]++;

  Quote.prototype.getTopNodeName = function () {
    cov_1ykf3ozmui().f[12]++;
    var editor = (cov_1ykf3ozmui().s[61]++, this.editor);
    var $topNodeElem = (cov_1ykf3ozmui().s[62]++, editor.selection.getSelectionRangeTopNodes(editor)[0]);
    var nodeName = (cov_1ykf3ozmui().s[63]++, (cov_1ykf3ozmui().b[17][0]++, $topNodeElem === null) || (cov_1ykf3ozmui().b[17][1]++, $topNodeElem === void 0) ? (cov_1ykf3ozmui().b[16][0]++, void 0) : (cov_1ykf3ozmui().b[16][1]++, $topNodeElem.getNodeName()));
    cov_1ykf3ozmui().s[64]++;
    return nodeName;
  };
  /**
   * 删除选中的元素
   * @param selectElem 选中的元素节点数组
   */


  cov_1ykf3ozmui().s[65]++;

  Quote.prototype.delSelectNode = function (selectElem) {
    cov_1ykf3ozmui().f[13]++;
    cov_1ykf3ozmui().s[66]++;
    (0, _forEach["default"])(selectElem).call(selectElem, function (node) {
      cov_1ykf3ozmui().f[14]++;
      cov_1ykf3ozmui().s[67]++;
      node.remove();
    });
  };

  cov_1ykf3ozmui().s[68]++;
  return Quote;
}(BtnMenu_1["default"]));
cov_1ykf3ozmui().s[69]++;
exports["default"] = Quote;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2lr73sinbv() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/quote/bind-event/index.ts";
  var hash = "92fc3b033990fcf89dd6527646f7a1d5c73aecd8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 68
        }
      },
      "4": {
        start: {
          line: 10,
          column: 26
        },
        end: {
          line: 10,
          column: 70
        }
      },
      "5": {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 11,
          column: 82
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "7": {
        start: {
          line: 16,
          column: 12
        },
        end: {
          line: 19,
          column: 13
        }
      },
      "8": {
        start: {
          line: 17,
          column: 33
        },
        end: {
          line: 17,
          column: 114
        }
      },
      "9": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 56
        }
      },
      "10": {
        start: {
          line: 20,
          column: 12
        },
        end: {
          line: 27,
          column: 13
        }
      },
      "11": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 21,
          column: 35
        }
      },
      "12": {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 22,
          column: 37
        }
      },
      "13": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 23,
          column: 64
        }
      },
      "14": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "15": {
        start: {
          line: 26,
          column: 16
        },
        end: {
          line: 26,
          column: 70
        }
      },
      "16": {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 31,
          column: 13
        }
      },
      "17": {
        start: {
          line: 30,
          column: 16
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "18": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 59
        }
      },
      "19": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 18
          }
        },
        loc: {
          start: {
            line: 7,
            column: 27
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 7
      },
      "2": {
        name: "quoteEnter",
        decl: {
          start: {
            line: 8,
            column: 13
          },
          end: {
            line: 8,
            column: 23
          }
        },
        loc: {
          start: {
            line: 8,
            column: 27
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 14
      },
      "4": {
        loc: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 105
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 68
          },
          end: {
            line: 14,
            column: 74
          }
        }, {
          start: {
            line: 14,
            column: 77
          },
          end: {
            line: 14,
            column: 105
          }
        }],
        line: 14
      },
      "5": {
        loc: {
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 14,
            column: 13
          },
          end: {
            line: 14,
            column: 36
          }
        }, {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 14,
            column: 65
          }
        }],
        line: 14
      },
      "6": {
        loc: {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 19,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 19,
            column: 13
          }
        }, {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 19,
            column: 13
          }
        }],
        line: 16
      },
      "7": {
        loc: {
          start: {
            line: 17,
            column: 33
          },
          end: {
            line: 17,
            column: 114
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 93
          },
          end: {
            line: 17,
            column: 99
          }
        }, {
          start: {
            line: 17,
            column: 102
          },
          end: {
            line: 17,
            column: 114
          }
        }],
        line: 17
      },
      "8": {
        loc: {
          start: {
            line: 17,
            column: 33
          },
          end: {
            line: 17,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 33
          },
          end: {
            line: 17,
            column: 73
          }
        }, {
          start: {
            line: 17,
            column: 77
          },
          end: {
            line: 17,
            column: 90
          }
        }],
        line: 17
      },
      "9": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 27,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 27,
            column: 13
          }
        }, {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 27,
            column: 13
          }
        }],
        line: 20
      },
      "10": {
        loc: {
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }, {
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/quote/bind-event/index.ts"],
      names: [],
      mappings: ";;;;;AACA,qEAAuD;AACvD,SAAS,SAAS,CAAC,MAAc;IAC7B,SAAS,UAAU,CAAC,CAAQ;;QACxB,IAAM,WAAW,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAgB,CAAA;QAC9E,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAA;QAC5E,qBAAqB;QACrB,mCAAmC;QACnC,IAAI,CAAA,cAAc,aAAd,cAAc,uBAAd,cAAc,CAAE,WAAW,QAAO,YAAY,EAAE;YAChD,gDAAgD;YAChD,IAAI,WAAW,CAAC,WAAW,EAAE,KAAK,YAAY,EAAE;gBAC5C,IAAM,UAAU,GAAG,MAAA,WAAW,CAAC,UAAU,EAAE,0CAAE,OAAO,EAAU,CAAA;gBAC9D,MAAM,CAAC,SAAS,CAAC,UAAU,CAAC,UAAU,CAAC,CAAA;aAC1C;YACD,IAAI,WAAW,CAAC,IAAI,EAAE,KAAK,EAAE,EAAE;gBAC3B,CAAC,CAAC,cAAc,EAAE,CAAA;gBAClB,WAAW,CAAC,MAAM,EAAE,CAAA;gBACpB,IAAM,QAAQ,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;gBACjC,QAAQ,CAAC,WAAW,CAAC,cAAc,CAAC,CAAA;gBACpC,YAAY;gBACZ,MAAM,CAAC,SAAS,CAAC,UAAU,CAAC,QAAQ,CAAC,OAAO,EAAE,EAAE,IAAI,CAAC,CAAA;aACxD;YAED,kCAAkC;YAClC,IAAI,cAAc,CAAC,IAAI,EAAE,KAAK,EAAE,EAAE;gBAC9B,cAAc,CAAC,MAAM,EAAE,CAAA;aAC1B;SACJ;IACL,CAAC;IACD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC1D,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["import Editor from '../../../editor/index'\nimport $, { DomElement } from '../../../utils/dom-core'\nfunction bindEvent(editor: Editor) {\n    function quoteEnter(e: Event) {\n        const $selectElem = editor.selection.getSelectionContainerElem() as DomElement\n        const $topSelectElem = editor.selection.getSelectionRangeTopNodes(editor)[0]\n        // \u5BF9quote\u7684enter\u8FDB\u884C\u7279\u6B8A\u5904\u7406\n        //\u6700\u540E\u4E00\u884C\u4E3A<p><br></p>\u65F6\u518D\u6309\u4F1A\u51FA\u8DF3\u51FAblockquote\n        if ($topSelectElem?.getNodeName() === 'BLOCKQUOTE') {\n            // firefox\u4E0B\u70B9\u51FB\u5F15\u7528\u6309\u94AE\u4F1A\u9009\u4E2D\u5916\u5BB9\u5668<blockquote></blockquote>\n            if ($selectElem.getNodeName() === 'BLOCKQUOTE') {\n                const selectNode = $selectElem.childNodes()?.getNode() as Node\n                editor.selection.moveCursor(selectNode)\n            }\n            if ($selectElem.text() === '') {\n                e.preventDefault()\n                $selectElem.remove()\n                const $newLine = $('<p><br></p>')\n                $newLine.insertAfter($topSelectElem)\n                // \u5C06\u5149\u6807\u79FB\u52A8br\u524D\u9762\n                editor.selection.moveCursor($newLine.getNode(), true)\n            }\n\n            // \u5F53blockQuote\u4E2D\u6CA1\u6709\u5185\u5BB9\u56DE\u8F66\u540E\u79FB\u9664blockquote\n            if ($topSelectElem.text() === '') {\n                $topSelectElem.remove()\n            }\n        }\n    }\n    editor.txt.eventHooks.enterDownEvents.push(quoteEnter)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "92fc3b033990fcf89dd6527646f7a1d5c73aecd8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2lr73sinbv = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2lr73sinbv();

var __importDefault = (cov_2lr73sinbv().s[0]++, (cov_2lr73sinbv().b[0][0]++, void 0) && (cov_2lr73sinbv().b[0][1]++, (void 0).__importDefault) || (cov_2lr73sinbv().b[0][2]++, function (mod) {
  cov_2lr73sinbv().f[0]++;
  cov_2lr73sinbv().s[1]++;
  return (cov_2lr73sinbv().b[2][0]++, mod) && (cov_2lr73sinbv().b[2][1]++, mod.__esModule) ? (cov_2lr73sinbv().b[1][0]++, mod) : (cov_2lr73sinbv().b[1][1]++, {
    "default": mod
  });
}));

cov_2lr73sinbv().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_2lr73sinbv().s[3]++, __importDefault(__webpack_require__(2)));

function bindEvent(editor) {
  cov_2lr73sinbv().f[1]++;

  function quoteEnter(e) {
    cov_2lr73sinbv().f[2]++;

    var _a;

    var $selectElem = (cov_2lr73sinbv().s[4]++, editor.selection.getSelectionContainerElem());
    var $topSelectElem = (cov_2lr73sinbv().s[5]++, editor.selection.getSelectionRangeTopNodes(editor)[0]); // 对quote的enter进行特殊处理
    //最后一行为<p><br></p>时再按会出跳出blockquote

    cov_2lr73sinbv().s[6]++;

    if (((cov_2lr73sinbv().b[5][0]++, $topSelectElem === null) || (cov_2lr73sinbv().b[5][1]++, $topSelectElem === void 0) ? (cov_2lr73sinbv().b[4][0]++, void 0) : (cov_2lr73sinbv().b[4][1]++, $topSelectElem.getNodeName())) === 'BLOCKQUOTE') {
      cov_2lr73sinbv().b[3][0]++;
      cov_2lr73sinbv().s[7]++;

      // firefox下点击引用按钮会选中外容器<blockquote></blockquote>
      if ($selectElem.getNodeName() === 'BLOCKQUOTE') {
        cov_2lr73sinbv().b[6][0]++;
        var selectNode = (cov_2lr73sinbv().s[8]++, (cov_2lr73sinbv().b[8][0]++, (_a = $selectElem.childNodes()) === null) || (cov_2lr73sinbv().b[8][1]++, _a === void 0) ? (cov_2lr73sinbv().b[7][0]++, void 0) : (cov_2lr73sinbv().b[7][1]++, _a.getNode()));
        cov_2lr73sinbv().s[9]++;
        editor.selection.moveCursor(selectNode);
      } else {
        cov_2lr73sinbv().b[6][1]++;
      }

      cov_2lr73sinbv().s[10]++;

      if ($selectElem.text() === '') {
        cov_2lr73sinbv().b[9][0]++;
        cov_2lr73sinbv().s[11]++;
        e.preventDefault();
        cov_2lr73sinbv().s[12]++;
        $selectElem.remove();
        var $newLine = (cov_2lr73sinbv().s[13]++, dom_core_1["default"]('<p><br></p>'));
        cov_2lr73sinbv().s[14]++;
        $newLine.insertAfter($topSelectElem); // 将光标移动br前面

        cov_2lr73sinbv().s[15]++;
        editor.selection.moveCursor($newLine.getNode(), true);
      } else {
        cov_2lr73sinbv().b[9][1]++;
      } // 当blockQuote中没有内容回车后移除blockquote


      cov_2lr73sinbv().s[16]++;

      if ($topSelectElem.text() === '') {
        cov_2lr73sinbv().b[10][0]++;
        cov_2lr73sinbv().s[17]++;
        $topSelectElem.remove();
      } else {
        cov_2lr73sinbv().b[10][1]++;
      }
    } else {
      cov_2lr73sinbv().b[3][1]++;
    }
  }

  cov_2lr73sinbv().s[18]++;
  editor.txt.eventHooks.enterDownEvents.push(quoteEnter);
}

cov_2lr73sinbv().s[19]++;
exports["default"] = bindEvent;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_17ejqr751f() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/quote/create-quote-node.ts";
  var hash = "c1aa732ae5b44f28740647768c26da0d5b207eb8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/create-quote-node.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 65
        }
      },
      "4": {
        start: {
          line: 12,
          column: 22
        },
        end: {
          line: 12,
          column: 69
        }
      },
      "5": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 7
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 45
        }
      },
      "7": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 23
        }
      },
      "8": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "createQuote",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 33
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 23
          },
          end: {
            line: 13,
            column: 24
          }
        },
        loc: {
          start: {
            line: 13,
            column: 39
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 13
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/quote/create-quote-node.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/quote/create-quote-node.ts"],
      names: [],
      mappings: ";;;;;AAAA,kEAAoD;AAEpD;;;GAGG;AACH,SAAS,WAAW,CAAC,UAAwB;IACzC,IAAM,WAAW,GAAG,kBAAC,CAAC,2BAA2B,CAAC,CAAA;IAClD,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;QACnB,WAAW,CAAC,MAAM,CAAC,IAAI,CAAC,KAAK,CAAC,IAAI,CAAC,CAAC,CAAA;IACxC,CAAC,CAAC,CAAA;IACF,OAAO,WAAW,CAAA;AACtB,CAAC;AAED,kBAAe,WAAW,CAAA",
      sourcesContent: ["import $, { DomElement } from '../../utils/dom-core'\n\n/**\n * \u521B\u5EFA\u4E00\u4E2Ablockquote\u5143\u7D20\u8282\u70B9\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction createQuote($childElem: DomElement[]): DomElement {\n    const $targetElem = $(`<blockquote></blockquote>`)\n    $childElem.forEach(node => {\n        $targetElem.append(node.clone(true))\n    })\n    return $targetElem\n}\n\nexport default createQuote\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c1aa732ae5b44f28740647768c26da0d5b207eb8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_17ejqr751f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_17ejqr751f();

var __importDefault = (cov_17ejqr751f().s[0]++, (cov_17ejqr751f().b[0][0]++, void 0) && (cov_17ejqr751f().b[0][1]++, (void 0).__importDefault) || (cov_17ejqr751f().b[0][2]++, function (mod) {
  cov_17ejqr751f().f[0]++;
  cov_17ejqr751f().s[1]++;
  return (cov_17ejqr751f().b[2][0]++, mod) && (cov_17ejqr751f().b[2][1]++, mod.__esModule) ? (cov_17ejqr751f().b[1][0]++, mod) : (cov_17ejqr751f().b[1][1]++, {
    "default": mod
  });
}));

cov_17ejqr751f().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_17ejqr751f().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 创建一个blockquote元素节点
 * @param editor 编辑器实例
 */

function createQuote($childElem) {
  cov_17ejqr751f().f[1]++;
  var $targetElem = (cov_17ejqr751f().s[4]++, dom_core_1["default"]("<blockquote></blockquote>"));
  cov_17ejqr751f().s[5]++;
  (0, _forEach["default"])($childElem).call($childElem, function (node) {
    cov_17ejqr751f().f[2]++;
    cov_17ejqr751f().s[6]++;
    $targetElem.append(node.clone(true));
  });
  cov_17ejqr751f().s[7]++;
  return $targetElem;
}

cov_17ejqr751f().s[8]++;
exports["default"] = createQuote;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 背景颜色 BackColor
 * @author lkw
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _map = _interopRequireDefault(__webpack_require__(42));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1wtdviswi7() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/back-color/index.ts";
  var hash = "6f7d6e14de5c38805631dcec8bc44e1868e627dd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/back-color/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 63,
          column: 25
        }
      },
      "18": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "19": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "20": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 142
        }
      },
      "21": {
        start: {
          line: 31,
          column: 28
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "22": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 40,
          column: 18
        }
      },
      "23": {
        start: {
          line: 44,
          column: 16
        },
        end: {
          line: 44,
          column: 37
        }
      },
      "24": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 72
        }
      },
      "25": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 21
        }
      },
      "26": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      "27": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "28": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "29": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 58
        }
      },
      "30": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 21
        }
      },
      "31": {
        start: {
          line: 64,
          column: 0
        },
        end: {
          line: 64,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "BackColor",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 43
          },
          end: {
            line: 36,
            column: 44
          }
        },
        loc: {
          start: {
            line: 36,
            column: 60
          },
          end: {
            line: 41,
            column: 13
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 42,
            column: 26
          },
          end: {
            line: 42,
            column: 27
          }
        },
        loc: {
          start: {
            line: 42,
            column: 43
          },
          end: {
            line: 45,
            column: 13
          }
        },
        line: 42
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 35
          }
        },
        loc: {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 54
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 61,
            column: 42
          },
          end: {
            line: 61,
            column: 43
          }
        },
        loc: {
          start: {
            line: 61,
            column: 54
          },
          end: {
            line: 61,
            column: 57
          }
        },
        line: 61
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 63
          }
        }, {
          start: {
            line: 47,
            column: 67
          },
          end: {
            line: 47,
            column: 71
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/back-color/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/back-color/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoC;AAIpC;IAAwB,6BAAY;IAChC,mBAAY,MAAc;QAA1B,iBAuBC;QAtBG,IAAM,KAAK,GAAG,kBAAC,CACX,sGAEO,CACV,CAAA;QACD,IAAM,aAAa,GAAG;YAClB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,0BAA0B;YAC1B,IAAI,EAAE,cAAc;YACpB,IAAI,EAAE,MAAM,CAAC,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,UAAA,KAAK;gBAChC,OAAO;oBACH,KAAK,EAAE,kBAAC,CAAC,sBAAmB,KAAK,4CAAsC,CAAC;oBACxE,KAAK,EAAE,KAAK;iBACf,CAAA;YACL,CAAC,CAAC;YACF,YAAY,EAAE,UAAC,KAAa;gBACxB,2BAA2B;gBAC3B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,aAAa,CAAC,SAAA;;IACvC,CAAC;IAED;;;OAGG;IACI,2BAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,WAAW,EAAE,KAAK,CAAC,CAAA;IACrC,CAAC;IAED;;OAEG;IACI,mCAAe,GAAtB,cAAgC,CAAC;IACrC,gBAAC;AAAD,CAAC,AAvCD,CAAwB,sBAAY,GAuCnC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u80CC\u666F\u989C\u8272 BackColor\n * @author lkw\n *\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass BackColor extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-paint-brush\"></i>\n            </div>`\n        )\n        const colorListConf = {\n            width: 120,\n            title: '\u80CC\u666F\u989C\u8272',\n            // droplist \u5185\u5BB9\u4EE5 block \u5F62\u5F0F\u5C55\u793A\n            type: 'inline-block',\n            list: editor.config.colors.map(color => {\n                return {\n                    $elem: $(`<i style=\"color:${color};\" class=\"w-e-icon-paint-brush\"></i>`),\n                    value: color,\n                }\n            }),\n            clickHandler: (value: string) => {\n                // this \u662F\u6307\u5411\u5F53\u524D\u7684 BackColor \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n        super($elem, editor, colorListConf)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        editor.cmd.do('backColor', value)\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {}\n}\n\nexport default BackColor\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6f7d6e14de5c38805631dcec8bc44e1868e627dd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1wtdviswi7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1wtdviswi7();

var __extends = (cov_1wtdviswi7().s[0]++, (cov_1wtdviswi7().b[0][0]++, void 0) && (cov_1wtdviswi7().b[0][1]++, (void 0).__extends) || (cov_1wtdviswi7().b[0][2]++, function () {
  cov_1wtdviswi7().f[0]++;
  cov_1wtdviswi7().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1wtdviswi7().f[1]++;
    cov_1wtdviswi7().s[2]++;
    _extendStatics = (cov_1wtdviswi7().b[1][0]++, _setPrototypeOf["default"]) || (cov_1wtdviswi7().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1wtdviswi7().b[1][2]++, function (d, b) {
      cov_1wtdviswi7().f[2]++;
      cov_1wtdviswi7().s[3]++;
      d.__proto__ = b;
    }) || (cov_1wtdviswi7().b[1][3]++, function (d, b) {
      cov_1wtdviswi7().f[3]++;
      cov_1wtdviswi7().s[4]++;

      for (var p in b) {
        cov_1wtdviswi7().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1wtdviswi7().b[2][0]++;
          cov_1wtdviswi7().s[6]++;
          d[p] = b[p];
        } else {
          cov_1wtdviswi7().b[2][1]++;
        }
      }
    });
    cov_1wtdviswi7().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1wtdviswi7().s[8]++;
  return function (d, b) {
    cov_1wtdviswi7().f[4]++;
    cov_1wtdviswi7().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1wtdviswi7().f[5]++;
      cov_1wtdviswi7().s[10]++;
      this.constructor = d;
    }

    cov_1wtdviswi7().s[11]++;
    d.prototype = b === null ? (cov_1wtdviswi7().b[3][0]++, (0, _create["default"])(b)) : (cov_1wtdviswi7().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1wtdviswi7().s[12]++, (cov_1wtdviswi7().b[4][0]++, void 0) && (cov_1wtdviswi7().b[4][1]++, (void 0).__importDefault) || (cov_1wtdviswi7().b[4][2]++, function (mod) {
  cov_1wtdviswi7().f[6]++;
  cov_1wtdviswi7().s[13]++;
  return (cov_1wtdviswi7().b[6][0]++, mod) && (cov_1wtdviswi7().b[6][1]++, mod.__esModule) ? (cov_1wtdviswi7().b[5][0]++, mod) : (cov_1wtdviswi7().b[5][1]++, {
    "default": mod
  });
}));

cov_1wtdviswi7().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_1wtdviswi7().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_1wtdviswi7().s[16]++, __importDefault(__webpack_require__(2)));
var BackColor = (
/** @class */
cov_1wtdviswi7().s[17]++, function (_super) {
  cov_1wtdviswi7().f[7]++;
  cov_1wtdviswi7().s[18]++;

  __extends(BackColor, _super);

  function BackColor(editor) {
    var _context;

    cov_1wtdviswi7().f[8]++;

    var _this = (cov_1wtdviswi7().s[19]++, this);

    var $elem = (cov_1wtdviswi7().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-paint-brush\"></i>\n            </div>"));
    var colorListConf = (cov_1wtdviswi7().s[21]++, {
      width: 120,
      title: '背景颜色',
      // droplist 内容以 block 形式展示
      type: 'inline-block',
      list: (0, _map["default"])(_context = editor.config.colors).call(_context, function (color) {
        cov_1wtdviswi7().f[9]++;
        cov_1wtdviswi7().s[22]++;
        return {
          $elem: dom_core_1["default"]("<i style=\"color:" + color + ";\" class=\"w-e-icon-paint-brush\"></i>"),
          value: color
        };
      }),
      clickHandler: function clickHandler(value) {
        cov_1wtdviswi7().f[10]++;
        cov_1wtdviswi7().s[23]++;

        // this 是指向当前的 BackColor 对象
        _this.command(value);
      }
    });
    cov_1wtdviswi7().s[24]++;
    _this = (cov_1wtdviswi7().b[7][0]++, _super.call(this, $elem, editor, colorListConf)) || (cov_1wtdviswi7().b[7][1]++, this);
    cov_1wtdviswi7().s[25]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_1wtdviswi7().s[26]++;

  BackColor.prototype.command = function (value) {
    cov_1wtdviswi7().f[11]++;
    var editor = (cov_1wtdviswi7().s[27]++, this.editor);
    cov_1wtdviswi7().s[28]++;
    editor.cmd["do"]('backColor', value);
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_1wtdviswi7().s[29]++;

  BackColor.prototype.tryChangeActive = function () {
    cov_1wtdviswi7().f[12]++;
  };

  cov_1wtdviswi7().s[30]++;
  return BackColor;
}(DropListMenu_1["default"]));
cov_1wtdviswi7().s[31]++;
exports["default"] = BackColor;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 文字颜色 FontColor
 * @author lkw
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _map = _interopRequireDefault(__webpack_require__(42));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_qd592cke6() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/font-color/index.ts";
  var hash = "f9a19ff284d2bbc2f2bab607e0fa4ac138a5d467";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/font-color/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 63,
          column: 25
        }
      },
      "18": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "19": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "20": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 138
        }
      },
      "21": {
        start: {
          line: 31,
          column: 28
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "22": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 40,
          column: 18
        }
      },
      "23": {
        start: {
          line: 44,
          column: 16
        },
        end: {
          line: 44,
          column: 37
        }
      },
      "24": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 72
        }
      },
      "25": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 21
        }
      },
      "26": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      "27": {
        start: {
          line: 55,
          column: 21
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "28": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "29": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 58
        }
      },
      "30": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 21
        }
      },
      "31": {
        start: {
          line: 64,
          column: 0
        },
        end: {
          line: 64,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 63,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "FontColor",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 43
          },
          end: {
            line: 36,
            column: 44
          }
        },
        loc: {
          start: {
            line: 36,
            column: 60
          },
          end: {
            line: 41,
            column: 13
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 42,
            column: 26
          },
          end: {
            line: 42,
            column: 27
          }
        },
        loc: {
          start: {
            line: 42,
            column: 43
          },
          end: {
            line: 45,
            column: 13
          }
        },
        line: 42
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 35
          }
        },
        loc: {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 54
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 61,
            column: 42
          },
          end: {
            line: 61,
            column: 43
          }
        },
        loc: {
          start: {
            line: 61,
            column: 54
          },
          end: {
            line: 61,
            column: 57
          }
        },
        line: 61
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 63
          }
        }, {
          start: {
            line: 47,
            column: 67
          },
          end: {
            line: 47,
            column: 71
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/font-color/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/font-color/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoC;AAIpC;IAAwB,6BAAY;IAChC,mBAAY,MAAc;QAA1B,iBAuBC;QAtBG,IAAM,KAAK,GAAG,kBAAC,CACX,kGAEO,CACV,CAAA;QACD,IAAM,aAAa,GAAG;YAClB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,0BAA0B;YAC1B,IAAI,EAAE,cAAc;YACpB,IAAI,EAAE,MAAM,CAAC,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,UAAA,KAAK;gBAChC,OAAO;oBACH,KAAK,EAAE,kBAAC,CAAC,sBAAmB,KAAK,wCAAkC,CAAC;oBACpE,KAAK,EAAE,KAAK;iBACf,CAAA;YACL,CAAC,CAAC;YACF,YAAY,EAAE,UAAC,KAAa;gBACxB,2BAA2B;gBAC3B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,aAAa,CAAC,SAAA;;IACvC,CAAC;IAED;;;OAGG;IACI,2BAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,WAAW,EAAE,KAAK,CAAC,CAAA;IACrC,CAAC;IAED;;OAEG;IACI,mCAAe,GAAtB,cAAgC,CAAC;IACrC,gBAAC;AAAD,CAAC,AAvCD,CAAwB,sBAAY,GAuCnC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u6587\u5B57\u989C\u8272 FontColor\n * @author lkw\n *\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass FontColor extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-pencil2\"></i>\n            </div>`\n        )\n        const colorListConf = {\n            width: 120,\n            title: '\u6587\u5B57\u989C\u8272',\n            // droplist \u5185\u5BB9\u4EE5 block \u5F62\u5F0F\u5C55\u793A\n            type: 'inline-block',\n            list: editor.config.colors.map(color => {\n                return {\n                    $elem: $(`<i style=\"color:${color};\" class=\"w-e-icon-pencil2\"></i>`),\n                    value: color,\n                }\n            }),\n            clickHandler: (value: string) => {\n                // this \u662F\u6307\u5411\u5F53\u524D\u7684 BackColor \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n        super($elem, editor, colorListConf)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        editor.cmd.do('foreColor', value)\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {}\n}\n\nexport default FontColor\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f9a19ff284d2bbc2f2bab607e0fa4ac138a5d467"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qd592cke6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_qd592cke6();

var __extends = (cov_qd592cke6().s[0]++, (cov_qd592cke6().b[0][0]++, void 0) && (cov_qd592cke6().b[0][1]++, (void 0).__extends) || (cov_qd592cke6().b[0][2]++, function () {
  cov_qd592cke6().f[0]++;
  cov_qd592cke6().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_qd592cke6().f[1]++;
    cov_qd592cke6().s[2]++;
    _extendStatics = (cov_qd592cke6().b[1][0]++, _setPrototypeOf["default"]) || (cov_qd592cke6().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_qd592cke6().b[1][2]++, function (d, b) {
      cov_qd592cke6().f[2]++;
      cov_qd592cke6().s[3]++;
      d.__proto__ = b;
    }) || (cov_qd592cke6().b[1][3]++, function (d, b) {
      cov_qd592cke6().f[3]++;
      cov_qd592cke6().s[4]++;

      for (var p in b) {
        cov_qd592cke6().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_qd592cke6().b[2][0]++;
          cov_qd592cke6().s[6]++;
          d[p] = b[p];
        } else {
          cov_qd592cke6().b[2][1]++;
        }
      }
    });
    cov_qd592cke6().s[7]++;
    return _extendStatics(d, b);
  };

  cov_qd592cke6().s[8]++;
  return function (d, b) {
    cov_qd592cke6().f[4]++;
    cov_qd592cke6().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_qd592cke6().f[5]++;
      cov_qd592cke6().s[10]++;
      this.constructor = d;
    }

    cov_qd592cke6().s[11]++;
    d.prototype = b === null ? (cov_qd592cke6().b[3][0]++, (0, _create["default"])(b)) : (cov_qd592cke6().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_qd592cke6().s[12]++, (cov_qd592cke6().b[4][0]++, void 0) && (cov_qd592cke6().b[4][1]++, (void 0).__importDefault) || (cov_qd592cke6().b[4][2]++, function (mod) {
  cov_qd592cke6().f[6]++;
  cov_qd592cke6().s[13]++;
  return (cov_qd592cke6().b[6][0]++, mod) && (cov_qd592cke6().b[6][1]++, mod.__esModule) ? (cov_qd592cke6().b[5][0]++, mod) : (cov_qd592cke6().b[5][1]++, {
    "default": mod
  });
}));

cov_qd592cke6().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_qd592cke6().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_qd592cke6().s[16]++, __importDefault(__webpack_require__(2)));
var FontColor = (
/** @class */
cov_qd592cke6().s[17]++, function (_super) {
  cov_qd592cke6().f[7]++;
  cov_qd592cke6().s[18]++;

  __extends(FontColor, _super);

  function FontColor(editor) {
    var _context;

    cov_qd592cke6().f[8]++;

    var _this = (cov_qd592cke6().s[19]++, this);

    var $elem = (cov_qd592cke6().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-pencil2\"></i>\n            </div>"));
    var colorListConf = (cov_qd592cke6().s[21]++, {
      width: 120,
      title: '文字颜色',
      // droplist 内容以 block 形式展示
      type: 'inline-block',
      list: (0, _map["default"])(_context = editor.config.colors).call(_context, function (color) {
        cov_qd592cke6().f[9]++;
        cov_qd592cke6().s[22]++;
        return {
          $elem: dom_core_1["default"]("<i style=\"color:" + color + ";\" class=\"w-e-icon-pencil2\"></i>"),
          value: color
        };
      }),
      clickHandler: function clickHandler(value) {
        cov_qd592cke6().f[10]++;
        cov_qd592cke6().s[23]++;

        // this 是指向当前的 BackColor 对象
        _this.command(value);
      }
    });
    cov_qd592cke6().s[24]++;
    _this = (cov_qd592cke6().b[7][0]++, _super.call(this, $elem, editor, colorListConf)) || (cov_qd592cke6().b[7][1]++, this);
    cov_qd592cke6().s[25]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_qd592cke6().s[26]++;

  FontColor.prototype.command = function (value) {
    cov_qd592cke6().f[11]++;
    var editor = (cov_qd592cke6().s[27]++, this.editor);
    cov_qd592cke6().s[28]++;
    editor.cmd["do"]('foreColor', value);
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_qd592cke6().s[29]++;

  FontColor.prototype.tryChangeActive = function () {
    cov_qd592cke6().f[12]++;
  };

  cov_qd592cke6().s[30]++;
  return FontColor;
}(DropListMenu_1["default"]));
cov_qd592cke6().s[31]++;
exports["default"] = FontColor;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 视频 菜单
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_s9k4ru5u5() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/video/index.ts";
  var hash = "e63655617352bb51b5ef5bd529fd38c875ea285d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/video/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 14
        },
        end: {
          line: 24,
          column: 68
        }
      },
      "17": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 25,
          column: 76
        }
      },
      "18": {
        start: {
          line: 26,
          column: 26
        },
        end: {
          line: 26,
          column: 73
        }
      },
      "19": {
        start: {
          line: 27,
          column: 27
        },
        end: {
          line: 56,
          column: 22
        }
      },
      "20": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "22": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 135
        }
      },
      "23": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 57
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 21
        }
      },
      "25": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 41,
          column: 6
        }
      },
      "26": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 29
        }
      },
      "27": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "28": {
        start: {
          line: 47,
          column: 19
        },
        end: {
          line: 47,
          column: 67
        }
      },
      "29": {
        start: {
          line: 48,
          column: 20
        },
        end: {
          line: 48,
          column: 51
        }
      },
      "30": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 23
        }
      },
      "31": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 54
        }
      },
      "32": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 17
        }
      },
      "33": {
        start: {
          line: 57,
          column: 0
        },
        end: {
          line: 57,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 27
          },
          end: {
            line: 27,
            column: 28
          }
        },
        loc: {
          start: {
            line: 27,
            column: 45
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 27
      },
      "8": {
        name: "Video",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 18
          }
        },
        loc: {
          start: {
            line: 29,
            column: 27
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 29
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 38,
            column: 35
          },
          end: {
            line: 38,
            column: 36
          }
        },
        loc: {
          start: {
            line: 38,
            column: 47
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 38
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 46,
            column: 34
          },
          end: {
            line: 46,
            column: 35
          }
        },
        loc: {
          start: {
            line: 46,
            column: 52
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 46
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 54,
            column: 39
          }
        },
        loc: {
          start: {
            line: 54,
            column: 50
          },
          end: {
            line: 54,
            column: 53
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 48
          }
        }, {
          start: {
            line: 32,
            column: 52
          },
          end: {
            line: 32,
            column: 56
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/video/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/video/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoC;AACpC,qEAA8C;AAE9C,6EAAsD;AAEtD,0EAAiD;AAEjD;IAAoB,yBAAS;IACzB,eAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,+FAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,4BAAY,GAAnB;QACI,WAAW;QACX,IAAI,CAAC,WAAW,CAAC,EAAE,CAAC,CAAA;IACxB,CAAC;IAED;;;OAGG;IACK,2BAAW,GAAnB,UAAoB,MAAc;QAC9B,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,EAAE,MAAM,CAAC,CAAA;QACjD,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,+BAAe,GAAtB,cAA0B,CAAC;IAC/B,YAAC;AAAD,CAAC,AAhCD,CAAoB,mBAAS,GAgC5B;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description \u89C6\u9891 \u83DC\u5355\n * @author tonghan\n */\n\nimport $ from '../../utils/dom-core'\nimport Panel from '../menu-constructors/Panel'\nimport Editor from '../../editor/index'\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport createPanelConf from './create-panel-conf'\n\nclass Video extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-play\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        // \u5F39\u51FA panel\n        this.createPanel('')\n    }\n\n    /**\n     * \u521B\u5EFA panel\n     * @param link \u94FE\u63A5\n     */\n    private createPanel(iframe: string): void {\n        const conf = createPanelConf(this.editor, iframe)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355 active \u72B6\u6001\n     */\n    public tryChangeActive() {}\n}\n\nexport default Video\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e63655617352bb51b5ef5bd529fd38c875ea285d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_s9k4ru5u5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_s9k4ru5u5();

var __extends = (cov_s9k4ru5u5().s[0]++, (cov_s9k4ru5u5().b[0][0]++, void 0) && (cov_s9k4ru5u5().b[0][1]++, (void 0).__extends) || (cov_s9k4ru5u5().b[0][2]++, function () {
  cov_s9k4ru5u5().f[0]++;
  cov_s9k4ru5u5().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_s9k4ru5u5().f[1]++;
    cov_s9k4ru5u5().s[2]++;
    _extendStatics = (cov_s9k4ru5u5().b[1][0]++, _setPrototypeOf["default"]) || (cov_s9k4ru5u5().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_s9k4ru5u5().b[1][2]++, function (d, b) {
      cov_s9k4ru5u5().f[2]++;
      cov_s9k4ru5u5().s[3]++;
      d.__proto__ = b;
    }) || (cov_s9k4ru5u5().b[1][3]++, function (d, b) {
      cov_s9k4ru5u5().f[3]++;
      cov_s9k4ru5u5().s[4]++;

      for (var p in b) {
        cov_s9k4ru5u5().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_s9k4ru5u5().b[2][0]++;
          cov_s9k4ru5u5().s[6]++;
          d[p] = b[p];
        } else {
          cov_s9k4ru5u5().b[2][1]++;
        }
      }
    });
    cov_s9k4ru5u5().s[7]++;
    return _extendStatics(d, b);
  };

  cov_s9k4ru5u5().s[8]++;
  return function (d, b) {
    cov_s9k4ru5u5().f[4]++;
    cov_s9k4ru5u5().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_s9k4ru5u5().f[5]++;
      cov_s9k4ru5u5().s[10]++;
      this.constructor = d;
    }

    cov_s9k4ru5u5().s[11]++;
    d.prototype = b === null ? (cov_s9k4ru5u5().b[3][0]++, (0, _create["default"])(b)) : (cov_s9k4ru5u5().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_s9k4ru5u5().s[12]++, (cov_s9k4ru5u5().b[4][0]++, void 0) && (cov_s9k4ru5u5().b[4][1]++, (void 0).__importDefault) || (cov_s9k4ru5u5().b[4][2]++, function (mod) {
  cov_s9k4ru5u5().f[6]++;
  cov_s9k4ru5u5().s[13]++;
  return (cov_s9k4ru5u5().b[6][0]++, mod) && (cov_s9k4ru5u5().b[6][1]++, mod.__esModule) ? (cov_s9k4ru5u5().b[5][0]++, mod) : (cov_s9k4ru5u5().b[5][1]++, {
    "default": mod
  });
}));

cov_s9k4ru5u5().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_s9k4ru5u5().s[15]++, __importDefault(__webpack_require__(2)));
var Panel_1 = (cov_s9k4ru5u5().s[16]++, __importDefault(__webpack_require__(28)));
var PanelMenu_1 = (cov_s9k4ru5u5().s[17]++, __importDefault(__webpack_require__(32)));
var create_panel_conf_1 = (cov_s9k4ru5u5().s[18]++, __importDefault(__webpack_require__(328)));
var Video = (
/** @class */
cov_s9k4ru5u5().s[19]++, function (_super) {
  cov_s9k4ru5u5().f[7]++;
  cov_s9k4ru5u5().s[20]++;

  __extends(Video, _super);

  function Video(editor) {
    cov_s9k4ru5u5().f[8]++;

    var _this = (cov_s9k4ru5u5().s[21]++, this);

    var $elem = (cov_s9k4ru5u5().s[22]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-play\"></i>\n            </div>"));
    cov_s9k4ru5u5().s[23]++;
    _this = (cov_s9k4ru5u5().b[7][0]++, _super.call(this, $elem, editor)) || (cov_s9k4ru5u5().b[7][1]++, this);
    cov_s9k4ru5u5().s[24]++;
    return _this;
  }
  /**
   * 菜单点击事件
   */


  cov_s9k4ru5u5().s[25]++;

  Video.prototype.clickHandler = function () {
    cov_s9k4ru5u5().f[9]++;
    cov_s9k4ru5u5().s[26]++;
    // 弹出 panel
    this.createPanel('');
  };
  /**
   * 创建 panel
   * @param link 链接
   */


  cov_s9k4ru5u5().s[27]++;

  Video.prototype.createPanel = function (iframe) {
    cov_s9k4ru5u5().f[10]++;
    var conf = (cov_s9k4ru5u5().s[28]++, create_panel_conf_1["default"](this.editor, iframe));
    var panel = (cov_s9k4ru5u5().s[29]++, new Panel_1["default"](this, conf));
    cov_s9k4ru5u5().s[30]++;
    panel.create();
  };
  /**
   * 尝试修改菜单 active 状态
   */


  cov_s9k4ru5u5().s[31]++;

  Video.prototype.tryChangeActive = function () {
    cov_s9k4ru5u5().f[11]++;
  };

  cov_s9k4ru5u5().s[32]++;
  return Video;
}(PanelMenu_1["default"]));
cov_s9k4ru5u5().s[33]++;
exports["default"] = Video;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description video 菜单 panel tab 配置
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1isvegb0kg() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/video/create-panel-conf.ts";
  var hash = "565103bd96e478365b29158cc4b567c6cbc26aae";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/video/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 14,
          column: 24
        },
        end: {
          line: 14,
          column: 56
        }
      },
      "6": {
        start: {
          line: 15,
          column: 18
        },
        end: {
          line: 15,
          column: 44
        }
      },
      "7": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 59
        }
      },
      "8": {
        start: {
          line: 23,
          column: 15
        },
        end: {
          line: 54,
          column: 5
        }
      },
      "9": {
        start: {
          line: 41,
          column: 41
        },
        end: {
          line: 41,
          column: 80
        }
      },
      "10": {
        start: {
          line: 42,
          column: 40
        },
        end: {
          line: 42,
          column: 59
        }
      },
      "11": {
        start: {
          line: 44,
          column: 28
        },
        end: {
          line: 45,
          column: 39
        }
      },
      "12": {
        start: {
          line: 45,
          column: 32
        },
        end: {
          line: 45,
          column: 39
        }
      },
      "13": {
        start: {
          line: 46,
          column: 28
        },
        end: {
          line: 46,
          column: 47
        }
      },
      "14": {
        start: {
          line: 48,
          column: 28
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "15": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 16
        }
      },
      "16": {
        start: {
          line: 57,
          column: 0
        },
        end: {
          line: 57,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 18
          }
        },
        loc: {
          start: {
            line: 12,
            column: 34
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "insertVideo",
        decl: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 24
          }
        },
        loc: {
          start: {
            line: 20,
            column: 32
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 28
          },
          end: {
            line: 39,
            column: 29
          }
        },
        loc: {
          start: {
            line: 39,
            column: 40
          },
          end: {
            line: 49,
            column: 25
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 44,
            column: 28
          },
          end: {
            line: 45,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 28
          },
          end: {
            line: 45,
            column: 39
          }
        }, {
          start: {
            line: 44,
            column: 28
          },
          end: {
            line: 45,
            column: 39
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/video/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/video/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,yCAA4C;AAC5C,kEAAoC;AAEpC,mBAAyB,MAAc,EAAE,KAAa;IAClD,iBAAiB;IACjB,IAAM,aAAa,GAAG,gBAAS,CAAC,cAAc,CAAC,CAAA;IAC/C,IAAM,OAAO,GAAG,gBAAS,CAAC,QAAQ,CAAC,CAAA;IAEnC;;;OAGG;IACH,SAAS,WAAW,CAAC,KAAa;QAC9B,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,KAAK,GAAG,aAAa,CAAC,CAAA;IACtD,CAAC;IAED,IAAM,IAAI,GAAG;QACT,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,CAAC;QAET,mBAAmB;QACnB,IAAI,EAAE;YACF;gBACI,UAAU;gBACV,KAAK,EAAE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,6BAA6B,CAAC;gBACtD,KAAK;gBACL,GAAG,EAAE,8EAEa,aAAa,iJAGJ,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,GAAG,CAAC,oLAGtB,OAAO,6DACf,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,IAAI,CAAC,wGAG7B;gBACX,OAAO;gBACP,MAAM,EAAE;oBACJ,OAAO;oBACP;wBACI,QAAQ,EAAE,GAAG,GAAG,OAAO;wBACvB,IAAI,EAAE,OAAO;wBACb,EAAE,EAAE;4BACA,SAAS;4BACT,IAAM,MAAM,GAAG,kBAAC,CAAC,GAAG,GAAG,aAAa,CAAC,CAAA;4BACrC,IAAI,KAAK,GAAG,MAAM,CAAC,GAAG,EAAE,CAAC,IAAI,EAAE,CAAA;4BAE/B,YAAY;4BACZ,IAAI,CAAC,KAAK;gCAAE,OAAM;4BAElB,WAAW,CAAC,KAAK,CAAC,CAAA;4BAElB,6CAA6C;4BAC7C,OAAO,IAAI,CAAA;wBACf,CAAC;qBACJ;iBACJ;aACJ;SACJ;KACJ,CAAA;IAED,OAAO,IAAI,CAAA;AACf,CAAC;AA9DD,4BA8DC",
      sourcesContent: ["/**\n * @description video \u83DC\u5355 panel tab \u914D\u7F6E\n * @author tonghan\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf } from '../menu-constructors/Panel'\nimport { getRandom } from '../../utils/util'\nimport $ from '../../utils/dom-core'\n\nexport default function (editor: Editor, video: string): PanelConf {\n    // panel \u4E2D\u9700\u8981\u7528\u5230\u7684id\n    const inputIFrameId = getRandom('input-iframe')\n    const btnOkId = getRandom('btn-ok')\n\n    /**\n     * \u63D2\u5165\u94FE\u63A5\n     * @param iframe html\u6807\u7B7E\n     */\n    function insertVideo(video: string): void {\n        editor.cmd.do('insertHTML', video + '<p><br></p>')\n    }\n\n    const conf = {\n        width: 300,\n        height: 0,\n\n        // panel \u4E2D\u53EF\u5305\u542B\u591A\u4E2A tab\n        tabs: [\n            {\n                // tab \u7684\u6807\u9898\n                title: editor.i18next.t('menus.panelMenus.video.\u63D2\u5165\u89C6\u9891'),\n                // \u6A21\u677F\n                tpl: `<div>\n                        <input \n                            id=\"${inputIFrameId}\" \n                            type=\"text\" \n                            class=\"block\" \n                            placeholder=\"${editor.i18next.t('\u5982')}\uFF1A<iframe src=... ></iframe>\"/>\n                        </td>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"${btnOkId}\" class=\"right\">\n                                ${editor.i18next.t('\u63D2\u5165')}\n                            </button>\n                        </div>\n                    </div>`,\n                // \u4E8B\u4EF6\u7ED1\u5B9A\n                events: [\n                    // \u63D2\u5165\u89C6\u9891\n                    {\n                        selector: '#' + btnOkId,\n                        type: 'click',\n                        fn: () => {\n                            // \u6267\u884C\u63D2\u5165\u89C6\u9891\n                            const $video = $('#' + inputIFrameId)\n                            let video = $video.val().trim()\n\n                            // \u89C6\u9891\u4E3A\u7A7A\uFF0C\u5219\u4E0D\u63D2\u5165\n                            if (!video) return\n\n                            insertVideo(video)\n\n                            // \u8FD4\u56DE true\uFF0C\u8868\u793A\u8BE5\u4E8B\u4EF6\u6267\u884C\u5B8C\u4E4B\u540E\uFF0Cpanel \u8981\u5173\u95ED\u3002\u5426\u5219 panel \u4E0D\u4F1A\u5173\u95ED\n                            return true\n                        },\n                    },\n                ],\n            }, // tab end\n        ], // tabs end\n    }\n\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "565103bd96e478365b29158cc4b567c6cbc26aae"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1isvegb0kg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1isvegb0kg();

var __importDefault = (cov_1isvegb0kg().s[0]++, (cov_1isvegb0kg().b[0][0]++, void 0) && (cov_1isvegb0kg().b[0][1]++, (void 0).__importDefault) || (cov_1isvegb0kg().b[0][2]++, function (mod) {
  cov_1isvegb0kg().f[0]++;
  cov_1isvegb0kg().s[1]++;
  return (cov_1isvegb0kg().b[2][0]++, mod) && (cov_1isvegb0kg().b[2][1]++, mod.__esModule) ? (cov_1isvegb0kg().b[1][0]++, mod) : (cov_1isvegb0kg().b[1][1]++, {
    "default": mod
  });
}));

cov_1isvegb0kg().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_1isvegb0kg().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_1isvegb0kg().s[4]++, __importDefault(__webpack_require__(2)));

function default_1(editor, video) {
  cov_1isvegb0kg().f[1]++;
  // panel 中需要用到的id
  var inputIFrameId = (cov_1isvegb0kg().s[5]++, util_1.getRandom('input-iframe'));
  var btnOkId = (cov_1isvegb0kg().s[6]++, util_1.getRandom('btn-ok'));
  /**
   * 插入链接
   * @param iframe html标签
   */

  function insertVideo(video) {
    cov_1isvegb0kg().f[2]++;
    cov_1isvegb0kg().s[7]++;
    editor.cmd["do"]('insertHTML', video + '<p><br></p>');
  }

  var conf = (cov_1isvegb0kg().s[8]++, {
    width: 300,
    height: 0,
    // panel 中可包含多个 tab
    tabs: [{
      // tab 的标题
      title: editor.i18next.t('menus.panelMenus.video.插入视频'),
      // 模板
      tpl: "<div>\n                        <input \n                            id=\"" + inputIFrameId + "\" \n                            type=\"text\" \n                            class=\"block\" \n                            placeholder=\"" + editor.i18next.t('如') + "\uFF1A<iframe src=... ></iframe>\"/>\n                        </td>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"" + btnOkId + "\" class=\"right\">\n                                " + editor.i18next.t('插入') + "\n                            </button>\n                        </div>\n                    </div>",
      // 事件绑定
      events: [// 插入视频
      {
        selector: '#' + btnOkId,
        type: 'click',
        fn: function fn() {
          var _context;

          cov_1isvegb0kg().f[3]++;
          // 执行插入视频
          var $video = (cov_1isvegb0kg().s[9]++, dom_core_1["default"]('#' + inputIFrameId));
          var video = (cov_1isvegb0kg().s[10]++, (0, _trim["default"])(_context = $video.val()).call(_context)); // 视频为空，则不插入

          cov_1isvegb0kg().s[11]++;

          if (!video) {
            cov_1isvegb0kg().b[3][0]++;
            cov_1isvegb0kg().s[12]++;
            return;
          } else {
            cov_1isvegb0kg().b[3][1]++;
          }

          cov_1isvegb0kg().s[13]++;
          insertVideo(video); // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭

          cov_1isvegb0kg().s[14]++;
          return true;
        }
      }]
    }]
  });
  cov_1isvegb0kg().s[15]++;
  return conf;
}

cov_1isvegb0kg().s[16]++;
exports["default"] = default_1;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 插入、上传图片
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_syaq7mn9t() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/index.ts";
  var hash = "858307f6479c40271823aa252c52c84bab72d4e6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 76
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 25,
          column: 73
        }
      },
      "18": {
        start: {
          line: 26,
          column: 14
        },
        end: {
          line: 26,
          column: 68
        }
      },
      "19": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 60
        }
      },
      "20": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 57,
          column: 22
        }
      },
      "21": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 29
        }
      },
      "22": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 24
        }
      },
      "23": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 100
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 57
        }
      },
      "25": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 32
        }
      },
      "26": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 21
        }
      },
      "27": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 6
        }
      },
      "28": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 27
        }
      },
      "29": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "30": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 59
        }
      },
      "31": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "32": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 23
        }
      },
      "33": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 54
        }
      },
      "34": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 17
        }
      },
      "35": {
        start: {
          line: 58,
          column: 0
        },
        end: {
          line: 58,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 28
          }
        },
        loc: {
          start: {
            line: 28,
            column: 45
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 28
      },
      "8": {
        name: "Image",
        decl: {
          start: {
            line: 30,
            column: 13
          },
          end: {
            line: 30,
            column: 18
          }
        },
        loc: {
          start: {
            line: 30,
            column: 27
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 30
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 41,
            column: 35
          },
          end: {
            line: 41,
            column: 36
          }
        },
        loc: {
          start: {
            line: 41,
            column: 47
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 41
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 47,
            column: 35
          }
        },
        loc: {
          start: {
            line: 47,
            column: 46
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 47
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 55,
            column: 38
          },
          end: {
            line: 55,
            column: 39
          }
        },
        loc: {
          start: {
            line: 55,
            column: 50
          },
          end: {
            line: 55,
            column: 53
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 48
          }
        }, {
          start: {
            line: 33,
            column: 52
          },
          end: {
            line: 33,
            column: 56
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,6EAAsD;AAEtD,kEAAoC;AACpC,0EAAiD;AACjD,qEAA8C;AAE9C,6DAA0C;AAE1C;IAAoB,yBAAS;IACzB,eAAY,MAAc;QAA1B,iBAMC;QALG,IAAM,KAAK,GAAG,kBAAC,CAAC,4DAA4D,CAAC,CAAA;QAC7E,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QAEpB,aAAa;QACb,eAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IAED;;OAEG;IACI,4BAAY,GAAnB;QACI,IAAI,CAAC,WAAW,EAAE,CAAA;IACtB,CAAC;IAED;;OAEG;IACK,2BAAW,GAAnB;QACI,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACzC,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,+BAAe,GAAtB,cAA0B,CAAC;IAC/B,YAAC;AAAD,CAAC,AA7BD,CAAoB,mBAAS,GA6B5B;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description \u63D2\u5165\u3001\u4E0A\u4F20\u56FE\u7247\n * @author wangfupeng\n */\n\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\nimport createPanelConf from './create-panel-conf'\nimport Panel from '../menu-constructors/Panel'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event/index'\n\nclass Image extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-image\"></i></div>')\n        super($elem, editor)\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\uFF0C\u5982\u7C98\u8D34\u56FE\u7247\n        bindEvent(editor)\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        this.createPanel()\n    }\n\n    /**\n     * \u521B\u5EFA panel\n     */\n    private createPanel(): void {\n        const conf = createPanelConf(this.editor)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355 active \u72B6\u6001\n     */\n    public tryChangeActive() {}\n}\n\nexport default Image\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "858307f6479c40271823aa252c52c84bab72d4e6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_syaq7mn9t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_syaq7mn9t();

var __extends = (cov_syaq7mn9t().s[0]++, (cov_syaq7mn9t().b[0][0]++, void 0) && (cov_syaq7mn9t().b[0][1]++, (void 0).__extends) || (cov_syaq7mn9t().b[0][2]++, function () {
  cov_syaq7mn9t().f[0]++;
  cov_syaq7mn9t().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_syaq7mn9t().f[1]++;
    cov_syaq7mn9t().s[2]++;
    _extendStatics = (cov_syaq7mn9t().b[1][0]++, _setPrototypeOf["default"]) || (cov_syaq7mn9t().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_syaq7mn9t().b[1][2]++, function (d, b) {
      cov_syaq7mn9t().f[2]++;
      cov_syaq7mn9t().s[3]++;
      d.__proto__ = b;
    }) || (cov_syaq7mn9t().b[1][3]++, function (d, b) {
      cov_syaq7mn9t().f[3]++;
      cov_syaq7mn9t().s[4]++;

      for (var p in b) {
        cov_syaq7mn9t().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_syaq7mn9t().b[2][0]++;
          cov_syaq7mn9t().s[6]++;
          d[p] = b[p];
        } else {
          cov_syaq7mn9t().b[2][1]++;
        }
      }
    });
    cov_syaq7mn9t().s[7]++;
    return _extendStatics(d, b);
  };

  cov_syaq7mn9t().s[8]++;
  return function (d, b) {
    cov_syaq7mn9t().f[4]++;
    cov_syaq7mn9t().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_syaq7mn9t().f[5]++;
      cov_syaq7mn9t().s[10]++;
      this.constructor = d;
    }

    cov_syaq7mn9t().s[11]++;
    d.prototype = b === null ? (cov_syaq7mn9t().b[3][0]++, (0, _create["default"])(b)) : (cov_syaq7mn9t().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_syaq7mn9t().s[12]++, (cov_syaq7mn9t().b[4][0]++, void 0) && (cov_syaq7mn9t().b[4][1]++, (void 0).__importDefault) || (cov_syaq7mn9t().b[4][2]++, function (mod) {
  cov_syaq7mn9t().f[6]++;
  cov_syaq7mn9t().s[13]++;
  return (cov_syaq7mn9t().b[6][0]++, mod) && (cov_syaq7mn9t().b[6][1]++, mod.__esModule) ? (cov_syaq7mn9t().b[5][0]++, mod) : (cov_syaq7mn9t().b[5][1]++, {
    "default": mod
  });
}));

cov_syaq7mn9t().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var PanelMenu_1 = (cov_syaq7mn9t().s[15]++, __importDefault(__webpack_require__(32)));
var dom_core_1 = (cov_syaq7mn9t().s[16]++, __importDefault(__webpack_require__(2)));
var create_panel_conf_1 = (cov_syaq7mn9t().s[17]++, __importDefault(__webpack_require__(330)));
var Panel_1 = (cov_syaq7mn9t().s[18]++, __importDefault(__webpack_require__(28)));
var index_1 = (cov_syaq7mn9t().s[19]++, __importDefault(__webpack_require__(337)));
var Image = (
/** @class */
cov_syaq7mn9t().s[20]++, function (_super) {
  cov_syaq7mn9t().f[7]++;
  cov_syaq7mn9t().s[21]++;

  __extends(Image, _super);

  function Image(editor) {
    cov_syaq7mn9t().f[8]++;

    var _this = (cov_syaq7mn9t().s[22]++, this);

    var $elem = (cov_syaq7mn9t().s[23]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-image"></i></div>'));
    cov_syaq7mn9t().s[24]++;
    _this = (cov_syaq7mn9t().b[7][0]++, _super.call(this, $elem, editor)) || (cov_syaq7mn9t().b[7][1]++, this); // 绑定事件，如粘贴图片

    cov_syaq7mn9t().s[25]++;
    index_1["default"](editor);
    cov_syaq7mn9t().s[26]++;
    return _this;
  }
  /**
   * 菜单点击事件
   */


  cov_syaq7mn9t().s[27]++;

  Image.prototype.clickHandler = function () {
    cov_syaq7mn9t().f[9]++;
    cov_syaq7mn9t().s[28]++;
    this.createPanel();
  };
  /**
   * 创建 panel
   */


  cov_syaq7mn9t().s[29]++;

  Image.prototype.createPanel = function () {
    cov_syaq7mn9t().f[10]++;
    var conf = (cov_syaq7mn9t().s[30]++, create_panel_conf_1["default"](this.editor));
    var panel = (cov_syaq7mn9t().s[31]++, new Panel_1["default"](this, conf));
    cov_syaq7mn9t().s[32]++;
    panel.create();
  };
  /**
   * 尝试修改菜单 active 状态
   */


  cov_syaq7mn9t().s[33]++;

  Image.prototype.tryChangeActive = function () {
    cov_syaq7mn9t().f[11]++;
  };

  cov_syaq7mn9t().s[34]++;
  return Image;
}(PanelMenu_1["default"]));
cov_syaq7mn9t().s[35]++;
exports["default"] = Image;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description image 菜单 panel tab 配置
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1ozggu3xkf() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/create-panel-conf.ts";
  var hash = "d0ff377f223cd58fc78503bdf10d107f443be22d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 12,
          column: 59
        }
      },
      "6": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 13,
          column: 42
        }
      },
      "7": {
        start: {
          line: 15,
          column: 17
        },
        end: {
          line: 15,
          column: 30
        }
      },
      "8": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 16,
          column: 52
        }
      },
      "9": {
        start: {
          line: 18,
          column: 22
        },
        end: {
          line: 18,
          column: 55
        }
      },
      "10": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 49
        }
      },
      "11": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 54
        }
      },
      "12": {
        start: {
          line: 21,
          column: 20
        },
        end: {
          line: 21,
          column: 48
        }
      },
      "13": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 22,
          column: 46
        }
      },
      "14": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 26,
          column: 5
        }
      },
      "15": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 55
        }
      },
      "16": {
        start: {
          line: 24,
          column: 33
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "17": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 47
        }
      },
      "18": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 33,
          column: 23
        }
      },
      "19": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 36,
          column: 9
        }
      },
      "20": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 35,
          column: 25
        }
      },
      "21": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 44
        }
      },
      "22": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "23": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 42,
          column: 66
        }
      },
      "24": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 66
        }
      },
      "25": {
        start: {
          line: 44,
          column: 13
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "26": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 50,
          column: 28
        }
      },
      "27": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 47,
          column: 127
        }
      },
      "28": {
        start: {
          line: 50,
          column: 16
        },
        end: {
          line: 50,
          column: 28
        }
      },
      "29": {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 25
        }
      },
      "30": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 21
        }
      },
      "31": {
        start: {
          line: 59,
          column: 27
        },
        end: {
          line: 59,
          column: 87
        }
      },
      "32": {
        start: {
          line: 60,
          column: 19
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "33": {
        start: {
          line: 74,
          column: 36
        },
        end: {
          line: 74,
          column: 70
        }
      },
      "34": {
        start: {
          line: 75,
          column: 39
        },
        end: {
          line: 75,
          column: 53
        }
      },
      "35": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 82,
          column: 25
        }
      },
      "36": {
        start: {
          line: 77,
          column: 28
        },
        end: {
          line: 77,
          column: 45
        }
      },
      "37": {
        start: {
          line: 81,
          column: 28
        },
        end: {
          line: 81,
          column: 40
        }
      },
      "38": {
        start: {
          line: 90,
          column: 36
        },
        end: {
          line: 90,
          column: 70
        }
      },
      "39": {
        start: {
          line: 91,
          column: 39
        },
        end: {
          line: 91,
          column: 53
        }
      },
      "40": {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 95,
          column: 25
        }
      },
      "41": {
        start: {
          line: 94,
          column: 28
        },
        end: {
          line: 94,
          column: 40
        }
      },
      "42": {
        start: {
          line: 97,
          column: 39
        },
        end: {
          line: 97,
          column: 53
        }
      },
      "43": {
        start: {
          line: 98,
          column: 24
        },
        end: {
          line: 100,
          column: 25
        }
      },
      "44": {
        start: {
          line: 99,
          column: 28
        },
        end: {
          line: 99,
          column: 58
        }
      },
      "45": {
        start: {
          line: 102,
          column: 24
        },
        end: {
          line: 102,
          column: 36
        }
      },
      "46": {
        start: {
          line: 116,
          column: 39
        },
        end: {
          line: 116,
          column: 74
        }
      },
      "47": {
        start: {
          line: 117,
          column: 34
        },
        end: {
          line: 117,
          column: 55
        }
      },
      "48": {
        start: {
          line: 119,
          column: 24
        },
        end: {
          line: 120,
          column: 35
        }
      },
      "49": {
        start: {
          line: 120,
          column: 28
        },
        end: {
          line: 120,
          column: 35
        }
      },
      "50": {
        start: {
          line: 122,
          column: 24
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "51": {
        start: {
          line: 123,
          column: 28
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "52": {
        start: {
          line: 125,
          column: 24
        },
        end: {
          line: 125,
          column: 49
        }
      },
      "53": {
        start: {
          line: 127,
          column: 24
        },
        end: {
          line: 127,
          column: 36
        }
      },
      "54": {
        start: {
          line: 135,
          column: 15
        },
        end: {
          line: 139,
          column: 5
        }
      },
      "55": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      },
      "56": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 36
        }
      },
      "57": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "58": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 36
        }
      },
      "59": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 16
        }
      },
      "60": {
        start: {
          line: 151,
          column: 0
        },
        end: {
          line: 151,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 18
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 150,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 23,
            column: 13
          }
        },
        loc: {
          start: {
            line: 23,
            column: 36
          },
          end: {
            line: 26,
            column: 5
          }
        },
        line: 23
      },
      "3": {
        name: "checkLinkImg",
        decl: {
          start: {
            line: 31,
            column: 13
          },
          end: {
            line: 31,
            column: 25
          }
        },
        loc: {
          start: {
            line: 31,
            column: 31
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 73,
            column: 24
          },
          end: {
            line: 73,
            column: 25
          }
        },
        loc: {
          start: {
            line: 73,
            column: 36
          },
          end: {
            line: 83,
            column: 21
          }
        },
        line: 73
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 89,
            column: 24
          },
          end: {
            line: 89,
            column: 25
          }
        },
        loc: {
          start: {
            line: 89,
            column: 36
          },
          end: {
            line: 103,
            column: 21
          }
        },
        line: 89
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 115,
            column: 24
          },
          end: {
            line: 115,
            column: 25
          }
        },
        loc: {
          start: {
            line: 115,
            column: 36
          },
          end: {
            line: 128,
            column: 21
          }
        },
        line: 115
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 55
          }
        }, {
          start: {
            line: 24,
            column: 8
          },
          end: {
            line: 24,
            column: 55
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 36,
            column: 9
          }
        }],
        line: 34
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 39
      },
      "6": {
        loc: {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 42,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 42,
            column: 66
          }
        }, {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 42,
            column: 66
          }
        }],
        line: 41
      },
      "7": {
        loc: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 44
      },
      "8": {
        loc: {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 50,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 50,
            column: 28
          }
        }, {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 50,
            column: 28
          }
        }],
        line: 46
      },
      "9": {
        loc: {
          start: {
            line: 59,
            column: 27
          },
          end: {
            line: 59,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 61
          },
          end: {
            line: 59,
            column: 63
          }
        }, {
          start: {
            line: 59,
            column: 66
          },
          end: {
            line: 59,
            column: 87
          }
        }],
        line: 59
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 82,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 82,
            column: 25
          }
        }, {
          start: {
            line: 76,
            column: 24
          },
          end: {
            line: 82,
            column: 25
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 95,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 95,
            column: 25
          }
        }, {
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 95,
            column: 25
          }
        }],
        line: 92
      },
      "12": {
        loc: {
          start: {
            line: 98,
            column: 24
          },
          end: {
            line: 100,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 24
          },
          end: {
            line: 100,
            column: 25
          }
        }, {
          start: {
            line: 98,
            column: 24
          },
          end: {
            line: 100,
            column: 25
          }
        }],
        line: 98
      },
      "13": {
        loc: {
          start: {
            line: 119,
            column: 24
          },
          end: {
            line: 120,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 24
          },
          end: {
            line: 120,
            column: 35
          }
        }, {
          start: {
            line: 119,
            column: 24
          },
          end: {
            line: 120,
            column: 35
          }
        }],
        line: 119
      },
      "14": {
        loc: {
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 123,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 123,
            column: 35
          }
        }, {
          start: {
            line: 122,
            column: 24
          },
          end: {
            line: 123,
            column: 35
          }
        }],
        line: 122
      },
      "15": {
        loc: {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }, {
          start: {
            line: 141,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }],
        line: 141
      },
      "16": {
        loc: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 142,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 141,
            column: 25
          }
        }, {
          start: {
            line: 142,
            column: 9
          },
          end: {
            line: 142,
            column: 35
          }
        }, {
          start: {
            line: 142,
            column: 39
          },
          end: {
            line: 142,
            column: 61
          }
        }, {
          start: {
            line: 142,
            column: 65
          },
          end: {
            line: 142,
            column: 87
          }
        }],
        line: 141
      },
      "17": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }],
        line: 146
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0, 0],
      "17": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,yCAA4C;AAC5C,kEAAoC;AACpC,4DAAoC;AACpC,2CAA4C;AAE5C,mBAAyB,MAAc;IACnC,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,SAAS,GAAG,IAAI,oBAAS,CAAC,MAAM,CAAC,CAAA;IAEvC,iBAAiB;IACjB,IAAM,WAAW,GAAG,gBAAS,CAAC,eAAe,CAAC,CAAA;IAC9C,IAAM,QAAQ,GAAG,gBAAS,CAAC,YAAY,CAAC,CAAA;IACxC,IAAM,SAAS,GAAG,gBAAS,CAAC,gBAAgB,CAAC,CAAA;IAC7C,IAAM,SAAS,GAAG,gBAAS,CAAC,UAAU,CAAC,CAAA;IAEvC,IAAM,UAAU,GAAG,yBAAyB,CAAA;IAC5C,IAAM,CAAC,GAAG,UAAC,IAAY,EAAE,MAA2B;QAA3B,uBAAA,EAAA,mBAA2B;QAChD,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,MAAM,GAAG,IAAI,CAAC,CAAA;IAC1C,CAAC,CAAA;IAED;;;OAGG;IACH,SAAS,YAAY,CAAC,GAAW;QAC7B,mCAAmC;QACnC,IAAI,IAAI,GAAG,IAAI,CAAA;QACf,IAAI,CAAC,gBAAQ,CAAC,IAAI,CAAC,GAAG,CAAC,EAAE;YACrB,IAAI,GAAG,KAAK,CAAA;SACf;QAED,gBAAgB;QAChB,IAAM,KAAK,GAAG,MAAM,CAAC,YAAY,CAAC,GAAG,CAAC,CAAA;QACtC,IAAI,KAAK,KAAK,SAAS,EAAE;YACrB,6BAA6B;YAC7B,IAAI,IAAI,KAAK,KAAK;gBAAE,OAAO,CAAC,GAAG,CAAC,CAAC,CAAC,oBAAoB,EAAE,WAAW,CAAC,CAAC,CAAA;SACxE;aAAM,IAAI,KAAK,KAAK,IAAI,EAAE;YACvB,aAAa;YACb,IAAI,IAAI,KAAK,KAAK,EAAE;gBAChB,KAAK,CACE,CAAC,CAAC,cAAc,EAAE,WAAW,CAAC,cAAI,CAAC,CAClC,aAAa,EACb,WAAW,CACd,8BAAsB,CAC1B,CAAA;aACJ;;gBAAM,OAAO,IAAI,CAAA;SACrB;aAAM;YACH,6BAA6B;YAC7B,KAAK,CAAC,KAAK,CAAC,CAAA;SACf;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED,oDAAoD;IACpD,IAAM,gBAAgB,GAAG,MAAM,CAAC,kBAAkB,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC,qBAAqB,CAAA;IACrF,IAAM,QAAQ,GAAmB;QAC7B,YAAY;QACZ;YACI,KAAK;YACL,KAAK,EAAE,CAAC,CAAC,MAAM,CAAC;YAChB,KAAK;YACL,GAAG,EAAE,yEACc,WAAW,iNAIL,QAAQ,yBAAiB,gBAAgB,yHAEvD;YACX,OAAO;YACP,MAAM,EAAE;gBACJ,SAAS;gBACT;oBACI,QAAQ,EAAE,GAAG,GAAG,WAAW;oBAC3B,IAAI,EAAE,OAAO;oBACb,EAAE,EAAE;wBACA,IAAM,KAAK,GAAG,kBAAC,CAAC,GAAG,GAAG,QAAQ,CAAC,CAAA;wBAC/B,IAAM,QAAQ,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;wBAC/B,IAAI,QAAQ,EAAE;4BACV,QAAQ,CAAC,KAAK,EAAE,CAAA;yBACnB;6BAAM;4BACH,oBAAoB;4BACpB,OAAO,IAAI,CAAA;yBACd;oBACL,CAAC;iBACJ;gBACD,SAAS;gBACT;oBACI,QAAQ,EAAE,GAAG,GAAG,QAAQ;oBACxB,IAAI,EAAE,QAAQ;oBACd,EAAE,EAAE;wBACA,IAAM,KAAK,GAAG,kBAAC,CAAC,GAAG,GAAG,QAAQ,CAAC,CAAA;wBAC/B,IAAM,QAAQ,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;wBAC/B,IAAI,CAAC,QAAQ,EAAE;4BACX,oBAAoB;4BACpB,OAAO,IAAI,CAAA;yBACd;wBAED,kBAAkB;wBAClB,IAAM,QAAQ,GAAI,QAAgB,CAAC,KAAK,CAAA;wBACxC,IAAI,QAAQ,CAAC,MAAM,EAAE;4BACjB,SAAS,CAAC,SAAS,CAAC,QAAQ,CAAC,CAAA;yBAChC;wBAED,oBAAoB;wBACpB,OAAO,IAAI,CAAA;oBACf,CAAC;iBACJ;aACJ;SACJ;QACD,aAAa;QACb;YACI,KAAK,EAAE,CAAC,CAAC,MAAM,CAAC;YAChB,GAAG,EAAE,qEAEa,SAAS,kIAGA,CAAC,CAAC,MAAM,CAAC,wIAGV,SAAS,2BAAmB,CAAC,CAAC,IAAI,EAAE,EAAE,CAAC,kEAEtD;YACX,MAAM,EAAE;gBACJ;oBACI,QAAQ,EAAE,GAAG,GAAG,SAAS;oBACzB,IAAI,EAAE,OAAO;oBACb,EAAE,EAAE;wBACA,IAAM,QAAQ,GAAG,kBAAC,CAAC,GAAG,GAAG,SAAS,CAAC,CAAA;wBACnC,IAAM,GAAG,GAAG,QAAQ,CAAC,GAAG,EAAE,CAAC,IAAI,EAAE,CAAA;wBAEjC,cAAc;wBACd,IAAI,CAAC,GAAG;4BAAE,OAAM;wBAChB,eAAe;wBACf,IAAI,CAAC,YAAY,CAAC,GAAG,CAAC;4BAAE,OAAM;wBAE9B,SAAS;wBACT,SAAS,CAAC,SAAS,CAAC,GAAG,CAAC,CAAA;wBACxB,6BAA6B;wBAC7B,OAAO,IAAI,CAAA;oBACf,CAAC;iBACJ;aACJ;SACJ;KACJ,CAAA;IACD,WAAW;IAEX,kDAAkD;IAClD,IAAM,IAAI,GAAc;QACpB,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,CAAC;QACT,IAAI,EAAE,EAAE;KACX,CAAA;IACD,WAAW;IACX,IACI,MAAM,CAAC,UAAU;QACjB,CAAC,MAAM,CAAC,mBAAmB,IAAI,MAAM,CAAC,eAAe,IAAI,MAAM,CAAC,eAAe,CAAC,EAClF;QACE,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAA;KAC9B;IACD,aAAa;IACb,IAAI,MAAM,CAAC,WAAW,EAAE;QACpB,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAA;KAC9B;IAED,OAAO,IAAI,CAAA;AACf,CAAC;AAlKD,4BAkKC",
      sourcesContent: ["/**\n * @description image \u83DC\u5355 panel tab \u914D\u7F6E\n * @author wangfupeng\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf, PanelTabConf } from '../menu-constructors/Panel'\nimport { getRandom } from '../../utils/util'\nimport $ from '../../utils/dom-core'\nimport UploadImg from './upload-img'\nimport { imgRegex } from '../../utils/const'\n\nexport default function (editor: Editor): PanelConf {\n    const config = editor.config\n    const uploadImg = new UploadImg(editor)\n\n    // panel \u4E2D\u9700\u8981\u7528\u5230\u7684id\n    const upTriggerId = getRandom('up-trigger-id')\n    const upFileId = getRandom('up-file-id')\n    const linkUrlId = getRandom('input-link-url')\n    const linkBtnId = getRandom('btn-link')\n\n    const i18nPrefix = 'menus.panelMenus.image.'\n    const t = (text: string, prefix: string = i18nPrefix): string => {\n        return editor.i18next.t(prefix + text)\n    }\n\n    /**\n     * \u6821\u9A8C\u7F51\u7EDC\u56FE\u7247\u94FE\u63A5\u662F\u5426\u5408\u6CD5\n     * @param linkImg \u7F51\u7EDC\u56FE\u7247\u94FE\u63A5\n     */\n    function checkLinkImg(src: string): boolean {\n        //\u7F16\u8F91\u5668\u8FDB\u884C\u6B63\u5E38\u6821\u9A8C\uFF0C\u56FE\u7247\u5408\u89C4\u5219\u4F7F\u6307\u9488\u4E3Atrue\uFF0C\u4E0D\u5408\u89C4\u4E3Afalse\n        let flag = true\n        if (!imgRegex.test(src)) {\n            flag = false\n        }\n\n        //\u67E5\u770B\u5F00\u53D1\u8005\u81EA\u5B9A\u4E49\u914D\u7F6E\u7684\u8FD4\u56DE\u503C\n        const check = config.linkImgCheck(src)\n        if (check === undefined) {\n            //\u7528\u6237\u672A\u80FD\u901A\u8FC7\u5F00\u53D1\u8005\u7684\u6821\u9A8C\uFF0C\u4E14\u5F00\u53D1\u8005\u4E0D\u5E0C\u671B\u7F16\u8F91\u5668\u63D0\u793A\u7528\u6237\n            if (flag === false) console.log(t('\u60A8\u521A\u624D\u63D2\u5165\u7684\u56FE\u7247\u94FE\u63A5\u672A\u901A\u8FC7\u7F16\u8F91\u5668\u6821\u9A8C', 'validate.'))\n        } else if (check === true) {\n            //\u7528\u6237\u901A\u8FC7\u4E86\u5F00\u53D1\u8005\u7684\u6821\u9A8C\n            if (flag === false) {\n                alert(\n                    `${t('\u60A8\u63D2\u5165\u7684\u7F51\u7EDC\u56FE\u7247\u65E0\u6CD5\u8BC6\u522B', 'validate.')}\uFF0C${t(\n                        '\u8BF7\u66FF\u6362\u4E3A\u652F\u6301\u7684\u56FE\u7247\u7C7B\u578B',\n                        'validate.'\n                    )}\uFF1Ajpg | png | gif ...`\n                )\n            } else return true\n        } else {\n            //\u7528\u6237\u672A\u80FD\u901A\u8FC7\u5F00\u53D1\u8005\u7684\u6821\u9A8C\uFF0C\u5F00\u53D1\u8005\u5E0C\u671B\u6211\u4EEC\u63D0\u793A\u8FD9\u4E00\u5B57\u7B26\u4E32\n            alert(check)\n        }\n        return false\n    }\n\n    // tabs \u914D\u7F6E -----------------------------------------\n    const fileMultipleAttr = config.uploadImgMaxLength === 1 ? '' : 'multiple=\"multiple\"'\n    const tabsConf: PanelTabConf[] = [\n        // first tab\n        {\n            // \u6807\u9898\n            title: t('\u4E0A\u4F20\u56FE\u7247'),\n            // \u6A21\u677F\n            tpl: `<div class=\"w-e-up-img-container\">\n                    <div id=\"${upTriggerId}\" class=\"w-e-up-btn\">\n                        <i class=\"w-e-icon-upload2\"></i>\n                    </div>\n                    <div style=\"display:none;\">\n                        <input id=\"${upFileId}\" type=\"file\" ${fileMultipleAttr} accept=\"image/jpg,image/jpeg,image/png,image/gif,image/bmp\"/>\n                    </div>\n                </div>`,\n            // \u4E8B\u4EF6\u7ED1\u5B9A\n            events: [\n                // \u89E6\u53D1\u9009\u62E9\u56FE\u7247\n                {\n                    selector: '#' + upTriggerId,\n                    type: 'click',\n                    fn: () => {\n                        const $file = $('#' + upFileId)\n                        const fileElem = $file.elems[0]\n                        if (fileElem) {\n                            fileElem.click()\n                        } else {\n                            // \u8FD4\u56DE true \u53EF\u5173\u95ED panel\n                            return true\n                        }\n                    },\n                },\n                // \u9009\u62E9\u56FE\u7247\u5B8C\u6BD5\n                {\n                    selector: '#' + upFileId,\n                    type: 'change',\n                    fn: () => {\n                        const $file = $('#' + upFileId)\n                        const fileElem = $file.elems[0]\n                        if (!fileElem) {\n                            // \u8FD4\u56DE true \u53EF\u5173\u95ED panel\n                            return true\n                        }\n\n                        // \u83B7\u53D6\u9009\u4E2D\u7684 file \u5BF9\u8C61\u5217\u8868\n                        const fileList = (fileElem as any).files\n                        if (fileList.length) {\n                            uploadImg.uploadImg(fileList)\n                        }\n\n                        // \u8FD4\u56DE true \u53EF\u5173\u95ED panel\n                        return true\n                    },\n                },\n            ],\n        }, // first tab end\n        // second tab\n        {\n            title: t('\u7F51\u7EDC\u56FE\u7247'),\n            tpl: `<div>\n                    <input\n                        id=\"${linkUrlId}\"\n                        type=\"text\"\n                        class=\"block\"\n                        placeholder=\"${t('\u56FE\u7247\u94FE\u63A5')}\"/>\n                    </td>\n                    <div class=\"w-e-button-container\">\n                        <button id=\"${linkBtnId}\" class=\"right\">${t('\u63D2\u5165', '')}</button>\n                    </div>\n                </div>`,\n            events: [\n                {\n                    selector: '#' + linkBtnId,\n                    type: 'click',\n                    fn: () => {\n                        const $linkUrl = $('#' + linkUrlId)\n                        const url = $linkUrl.val().trim()\n\n                        //\u5982\u679Curl\u4E3A\u7A7A\u5219\u76F4\u63A5\u8FD4\u56DE\n                        if (!url) return\n                        //\u5982\u679C\u4E0D\u80FD\u901A\u8FC7\u6821\u9A8C\u4E5F\u76F4\u63A5\u8FD4\u56DE\n                        if (!checkLinkImg(url)) return\n\n                        //\u63D2\u5165\u56FE\u7247url\n                        uploadImg.insertImg(url)\n                        // \u8FD4\u56DE true \u8868\u793A\u51FD\u6570\u6267\u884C\u7ED3\u675F\u4E4B\u540E\u5173\u95ED panel\n                        return true\n                    },\n                },\n            ],\n        }, // second tab end\n    ]\n    // tabs end\n\n    // \u6700\u7EC8\u7684\u914D\u7F6E -----------------------------------------\n    const conf: PanelConf = {\n        width: 300,\n        height: 0,\n        tabs: [],\n    }\n    // \u663E\u793A\u201C\u4E0A\u4F20\u56FE\u7247\u201D\n    if (\n        window.FileReader &&\n        (config.uploadImgShowBase64 || config.uploadImgServer || config.customUploadImg)\n    ) {\n        conf.tabs.push(tabsConf[0])\n    }\n    // \u663E\u793A\u201C\u63D2\u5165\u7F51\u7EDC\u56FE\u7247\u201D\n    if (config.showLinkImg) {\n        conf.tabs.push(tabsConf[1])\n    }\n\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d0ff377f223cd58fc78503bdf10d107f443be22d"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ozggu3xkf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ozggu3xkf();

var __importDefault = (cov_1ozggu3xkf().s[0]++, (cov_1ozggu3xkf().b[0][0]++, void 0) && (cov_1ozggu3xkf().b[0][1]++, (void 0).__importDefault) || (cov_1ozggu3xkf().b[0][2]++, function (mod) {
  cov_1ozggu3xkf().f[0]++;
  cov_1ozggu3xkf().s[1]++;
  return (cov_1ozggu3xkf().b[2][0]++, mod) && (cov_1ozggu3xkf().b[2][1]++, mod.__esModule) ? (cov_1ozggu3xkf().b[1][0]++, mod) : (cov_1ozggu3xkf().b[1][1]++, {
    "default": mod
  });
}));

cov_1ozggu3xkf().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_1ozggu3xkf().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_1ozggu3xkf().s[4]++, __importDefault(__webpack_require__(2)));
var upload_img_1 = (cov_1ozggu3xkf().s[5]++, __importDefault(__webpack_require__(94)));
var const_1 = (cov_1ozggu3xkf().s[6]++, __webpack_require__(30));

function default_1(editor) {
  cov_1ozggu3xkf().f[1]++;
  var config = (cov_1ozggu3xkf().s[7]++, editor.config);
  var uploadImg = (cov_1ozggu3xkf().s[8]++, new upload_img_1["default"](editor)); // panel 中需要用到的id

  var upTriggerId = (cov_1ozggu3xkf().s[9]++, util_1.getRandom('up-trigger-id'));
  var upFileId = (cov_1ozggu3xkf().s[10]++, util_1.getRandom('up-file-id'));
  var linkUrlId = (cov_1ozggu3xkf().s[11]++, util_1.getRandom('input-link-url'));
  var linkBtnId = (cov_1ozggu3xkf().s[12]++, util_1.getRandom('btn-link'));
  var i18nPrefix = (cov_1ozggu3xkf().s[13]++, 'menus.panelMenus.image.');
  cov_1ozggu3xkf().s[14]++;

  var t = function t(text, prefix) {
    cov_1ozggu3xkf().f[2]++;
    cov_1ozggu3xkf().s[15]++;

    if (prefix === void 0) {
      cov_1ozggu3xkf().b[3][0]++;
      cov_1ozggu3xkf().s[16]++;
      prefix = i18nPrefix;
    } else {
      cov_1ozggu3xkf().b[3][1]++;
    }

    cov_1ozggu3xkf().s[17]++;
    return editor.i18next.t(prefix + text);
  };
  /**
   * 校验网络图片链接是否合法
   * @param linkImg 网络图片链接
   */


  function checkLinkImg(src) {
    cov_1ozggu3xkf().f[3]++;
    //编辑器进行正常校验，图片合规则使指针为true，不合规为false
    var flag = (cov_1ozggu3xkf().s[18]++, true);
    cov_1ozggu3xkf().s[19]++;

    if (!const_1.imgRegex.test(src)) {
      cov_1ozggu3xkf().b[4][0]++;
      cov_1ozggu3xkf().s[20]++;
      flag = false;
    } else {
      cov_1ozggu3xkf().b[4][1]++;
    } //查看开发者自定义配置的返回值


    var check = (cov_1ozggu3xkf().s[21]++, config.linkImgCheck(src));
    cov_1ozggu3xkf().s[22]++;

    if (check === undefined) {
      cov_1ozggu3xkf().b[5][0]++;
      cov_1ozggu3xkf().s[23]++;

      //用户未能通过开发者的校验，且开发者不希望编辑器提示用户
      if (flag === false) {
        cov_1ozggu3xkf().b[6][0]++;
        cov_1ozggu3xkf().s[24]++;
        console.log(t('您刚才插入的图片链接未通过编辑器校验', 'validate.'));
      } else {
        cov_1ozggu3xkf().b[6][1]++;
      }
    } else {
      cov_1ozggu3xkf().b[5][1]++;
      cov_1ozggu3xkf().s[25]++;

      if (check === true) {
        cov_1ozggu3xkf().b[7][0]++;
        cov_1ozggu3xkf().s[26]++;

        //用户通过了开发者的校验
        if (flag === false) {
          cov_1ozggu3xkf().b[8][0]++;
          cov_1ozggu3xkf().s[27]++;
          alert(t('您插入的网络图片无法识别', 'validate.') + "\uFF0C" + t('请替换为支持的图片类型', 'validate.') + "\uFF1Ajpg | png | gif ...");
        } else {
          cov_1ozggu3xkf().b[8][1]++;
          cov_1ozggu3xkf().s[28]++;
          return true;
        }
      } else {
        cov_1ozggu3xkf().b[7][1]++;
        cov_1ozggu3xkf().s[29]++;
        //用户未能通过开发者的校验，开发者希望我们提示这一字符串
        alert(check);
      }
    }

    cov_1ozggu3xkf().s[30]++;
    return false;
  } // tabs 配置 -----------------------------------------


  var fileMultipleAttr = (cov_1ozggu3xkf().s[31]++, config.uploadImgMaxLength === 1 ? (cov_1ozggu3xkf().b[9][0]++, '') : (cov_1ozggu3xkf().b[9][1]++, 'multiple="multiple"'));
  var tabsConf = (cov_1ozggu3xkf().s[32]++, [// first tab
  {
    // 标题
    title: t('上传图片'),
    // 模板
    tpl: "<div class=\"w-e-up-img-container\">\n                    <div id=\"" + upTriggerId + "\" class=\"w-e-up-btn\">\n                        <i class=\"w-e-icon-upload2\"></i>\n                    </div>\n                    <div style=\"display:none;\">\n                        <input id=\"" + upFileId + "\" type=\"file\" " + fileMultipleAttr + " accept=\"image/jpg,image/jpeg,image/png,image/gif,image/bmp\"/>\n                    </div>\n                </div>",
    // 事件绑定
    events: [// 触发选择图片
    {
      selector: '#' + upTriggerId,
      type: 'click',
      fn: function fn() {
        cov_1ozggu3xkf().f[4]++;
        var $file = (cov_1ozggu3xkf().s[33]++, dom_core_1["default"]('#' + upFileId));
        var fileElem = (cov_1ozggu3xkf().s[34]++, $file.elems[0]);
        cov_1ozggu3xkf().s[35]++;

        if (fileElem) {
          cov_1ozggu3xkf().b[10][0]++;
          cov_1ozggu3xkf().s[36]++;
          fileElem.click();
        } else {
          cov_1ozggu3xkf().b[10][1]++;
          cov_1ozggu3xkf().s[37]++;
          // 返回 true 可关闭 panel
          return true;
        }
      }
    }, // 选择图片完毕
    {
      selector: '#' + upFileId,
      type: 'change',
      fn: function fn() {
        cov_1ozggu3xkf().f[5]++;
        var $file = (cov_1ozggu3xkf().s[38]++, dom_core_1["default"]('#' + upFileId));
        var fileElem = (cov_1ozggu3xkf().s[39]++, $file.elems[0]);
        cov_1ozggu3xkf().s[40]++;

        if (!fileElem) {
          cov_1ozggu3xkf().b[11][0]++;
          cov_1ozggu3xkf().s[41]++;
          // 返回 true 可关闭 panel
          return true;
        } else {
          cov_1ozggu3xkf().b[11][1]++;
        } // 获取选中的 file 对象列表


        var fileList = (cov_1ozggu3xkf().s[42]++, fileElem.files);
        cov_1ozggu3xkf().s[43]++;

        if (fileList.length) {
          cov_1ozggu3xkf().b[12][0]++;
          cov_1ozggu3xkf().s[44]++;
          uploadImg.uploadImg(fileList);
        } else {
          cov_1ozggu3xkf().b[12][1]++;
        } // 返回 true 可关闭 panel


        cov_1ozggu3xkf().s[45]++;
        return true;
      }
    }]
  }, // second tab
  {
    title: t('网络图片'),
    tpl: "<div>\n                    <input\n                        id=\"" + linkUrlId + "\"\n                        type=\"text\"\n                        class=\"block\"\n                        placeholder=\"" + t('图片链接') + "\"/>\n                    </td>\n                    <div class=\"w-e-button-container\">\n                        <button id=\"" + linkBtnId + "\" class=\"right\">" + t('插入', '') + "</button>\n                    </div>\n                </div>",
    events: [{
      selector: '#' + linkBtnId,
      type: 'click',
      fn: function fn() {
        var _context;

        cov_1ozggu3xkf().f[6]++;
        var $linkUrl = (cov_1ozggu3xkf().s[46]++, dom_core_1["default"]('#' + linkUrlId));
        var url = (cov_1ozggu3xkf().s[47]++, (0, _trim["default"])(_context = $linkUrl.val()).call(_context)); //如果url为空则直接返回

        cov_1ozggu3xkf().s[48]++;

        if (!url) {
          cov_1ozggu3xkf().b[13][0]++;
          cov_1ozggu3xkf().s[49]++;
          return;
        } else {
          cov_1ozggu3xkf().b[13][1]++;
        } //如果不能通过校验也直接返回


        cov_1ozggu3xkf().s[50]++;

        if (!checkLinkImg(url)) {
          cov_1ozggu3xkf().b[14][0]++;
          cov_1ozggu3xkf().s[51]++;
          return;
        } else {
          cov_1ozggu3xkf().b[14][1]++;
        } //插入图片url


        cov_1ozggu3xkf().s[52]++;
        uploadImg.insertImg(url); // 返回 true 表示函数执行结束之后关闭 panel

        cov_1ozggu3xkf().s[53]++;
        return true;
      }
    }]
  }]); // tabs end
  // 最终的配置 -----------------------------------------

  var conf = (cov_1ozggu3xkf().s[54]++, {
    width: 300,
    height: 0,
    tabs: []
  }); // 显示“上传图片”

  cov_1ozggu3xkf().s[55]++;

  if ((cov_1ozggu3xkf().b[16][0]++, window.FileReader) && ((cov_1ozggu3xkf().b[16][1]++, config.uploadImgShowBase64) || (cov_1ozggu3xkf().b[16][2]++, config.uploadImgServer) || (cov_1ozggu3xkf().b[16][3]++, config.customUploadImg))) {
    cov_1ozggu3xkf().b[15][0]++;
    cov_1ozggu3xkf().s[56]++;
    conf.tabs.push(tabsConf[0]);
  } else {
    cov_1ozggu3xkf().b[15][1]++;
  } // 显示“插入网络图片”


  cov_1ozggu3xkf().s[57]++;

  if (config.showLinkImg) {
    cov_1ozggu3xkf().b[17][0]++;
    cov_1ozggu3xkf().s[58]++;
    conf.tabs.push(tabsConf[1]);
  } else {
    cov_1ozggu3xkf().b[17][1]++;
  }

  cov_1ozggu3xkf().s[59]++;
  return conf;
}

cov_1ozggu3xkf().s[60]++;
exports["default"] = default_1;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 上传的核心方法
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _typeof2 = _interopRequireDefault(__webpack_require__(91));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2hnu1s7u5i() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/upload/upload-core.ts";
  var hash = "cb9459032db1c7dac5c0ded81861331a3467c38c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/upload/upload-core.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 13
        },
        end: {
          line: 7,
          column: 40
        }
      },
      "2": {
        start: {
          line: 14,
          column: 14
        },
        end: {
          line: 14,
          column: 34
        }
      },
      "3": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 26
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 46
        }
      },
      "5": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 21,
          column: 6
        }
      },
      "6": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 43
        }
      },
      "7": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 50
        }
      },
      "8": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 28,
          column: 5
        }
      },
      "9": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 27,
          column: 10
        }
      },
      "10": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 25,
          column: 44
        }
      },
      "11": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 63
        }
      },
      "12": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      "13": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 33,
          column: 11
        }
      },
      "14": {
        start: {
          line: 32,
          column: 12
        },
        end: {
          line: 32,
          column: 43
        }
      },
      "15": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 51
        }
      },
      "16": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "17": {
        start: {
          line: 39,
          column: 27
        },
        end: {
          line: 39,
          column: 49
        }
      },
      "18": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 45,
          column: 9
        }
      },
      "19": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 44,
          column: 13
        }
      },
      "20": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 43,
          column: 40
        }
      },
      "21": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 81,
          column: 6
        }
      },
      "22": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "23": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "24": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 31
        }
      },
      "25": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 53,
          column: 19
        }
      },
      "26": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 53,
          column: 19
        }
      },
      "27": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 55,
          column: 19
        }
      },
      "28": {
        start: {
          line: 55,
          column: 12
        },
        end: {
          line: 55,
          column: 19
        }
      },
      "29": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 62,
          column: 9
        }
      },
      "30": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 63
        }
      },
      "31": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 60,
          column: 36
        }
      },
      "32": {
        start: {
          line: 60,
          column: 16
        },
        end: {
          line: 60,
          column: 36
        }
      },
      "33": {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 61,
          column: 19
        }
      },
      "34": {
        start: {
          line: 64,
          column: 24
        },
        end: {
          line: 64,
          column: 40
        }
      },
      "35": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 79,
          column: 9
        }
      },
      "36": {
        start: {
          line: 67,
          column: 12
        },
        end: {
          line: 75,
          column: 13
        }
      },
      "37": {
        start: {
          line: 68,
          column: 16
        },
        end: {
          line: 68,
          column: 47
        }
      },
      "38": {
        start: {
          line: 71,
          column: 16
        },
        end: {
          line: 71,
          column: 72
        }
      },
      "39": {
        start: {
          line: 72,
          column: 16
        },
        end: {
          line: 73,
          column: 50
        }
      },
      "40": {
        start: {
          line: 73,
          column: 20
        },
        end: {
          line: 73,
          column: 50
        }
      },
      "41": {
        start: {
          line: 74,
          column: 16
        },
        end: {
          line: 74,
          column: 23
        }
      },
      "42": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 31
        }
      },
      "43": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 38
        }
      },
      "44": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 38
        }
      },
      "45": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 15
        }
      },
      "46": {
        start: {
          line: 86,
          column: 0
        },
        end: {
          line: 86,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "post",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 13
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 13
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 20
          },
          end: {
            line: 18,
            column: 21
          }
        },
        loc: {
          start: {
            line: 18,
            column: 32
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 32
          },
          end: {
            line: 24,
            column: 33
          }
        },
        loc: {
          start: {
            line: 24,
            column: 45
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 39
          },
          end: {
            line: 31,
            column: 40
          }
        },
        loc: {
          start: {
            line: 31,
            column: 59
          },
          end: {
            line: 33,
            column: 9
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 48,
            column: 29
          },
          end: {
            line: 48,
            column: 30
          }
        },
        loc: {
          start: {
            line: 48,
            column: 41
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 48
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 32
          }
        }, {
          start: {
            line: 17,
            column: 36
          },
          end: {
            line: 17,
            column: 45
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 24
          }
        }, {
          start: {
            line: 20,
            column: 28
          },
          end: {
            line: 20,
            column: 49
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 29
          }
        }, {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 26,
            column: 62
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 46,
            column: 5
          }
        }],
        line: 38
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 45,
            column: 9
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 12
          },
          end: {
            line: 40,
            column: 24
          }
        }, {
          start: {
            line: 40,
            column: 28
          },
          end: {
            line: 40,
            column: 60
          }
        }],
        line: 40
      },
      "8": {
        loc: {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        }, {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 44,
            column: 13
          }
        }],
        line: 41
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        }, {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }],
        line: 52
      },
      "11": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 55,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 55,
            column: 19
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 55,
            column: 19
          }
        }],
        line: 54
      },
      "12": {
        loc: {
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 12
          },
          end: {
            line: 54,
            column: 25
          }
        }, {
          start: {
            line: 54,
            column: 29
          },
          end: {
            line: 54,
            column: 41
          }
        }],
        line: 54
      },
      "13": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 62,
            column: 9
          }
        }],
        line: 56
      },
      "14": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 60,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 60,
            column: 36
          }
        }, {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 60,
            column: 36
          }
        }],
        line: 59
      },
      "15": {
        loc: {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }, {
          start: {
            line: 66,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }],
        line: 66
      },
      "16": {
        loc: {
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 73,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 73,
            column: 50
          }
        }, {
          start: {
            line: 72,
            column: 16
          },
          end: {
            line: 73,
            column: 50
          }
        }],
        line: 72
      },
      "17": {
        loc: {
          start: {
            line: 83,
            column: 13
          },
          end: {
            line: 83,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 13
          },
          end: {
            line: 83,
            column: 28
          }
        }, {
          start: {
            line: 83,
            column: 32
          },
          end: {
            line: 83,
            column: 36
          }
        }],
        line: 83
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/upload/upload-core.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/upload/upload-core.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAEH,yCAA0C;AAgB1C;;;;GAIG;AACH,SAAS,IAAI,CAAmB,GAAW,EAAE,MAAyB;IAClE,IAAM,GAAG,GAAG,IAAI,cAAc,EAAE,CAAA;IAChC,GAAG,CAAC,IAAI,CAAC,MAAM,EAAE,GAAG,CAAC,CAAA;IAErB,YAAY;IACZ,GAAG,CAAC,OAAO,GAAG,MAAM,CAAC,OAAO,IAAI,EAAE,GAAG,IAAI,CAAA;IACzC,GAAG,CAAC,SAAS,GAAG;QACZ,OAAO,CAAC,KAAK,CAAC,mBAAmB,CAAC,CAAA;QAClC,MAAM,CAAC,SAAS,IAAI,MAAM,CAAC,SAAS,CAAC,GAAG,CAAC,CAAA;IAC7C,CAAC,CAAA;IAED,KAAK;IACL,IAAI,GAAG,CAAC,MAAM,EAAE;QACZ,GAAG,CAAC,MAAM,CAAC,UAAU,GAAG,UAAC,CAAgB;YACrC,IAAM,OAAO,GAAG,CAAC,CAAC,MAAM,GAAG,CAAC,CAAC,KAAK,CAAA;YAClC,MAAM,CAAC,UAAU,IAAI,MAAM,CAAC,UAAU,CAAC,OAAO,EAAE,CAAC,CAAC,CAAA;QACtD,CAAC,CAAA;KACJ;IAED,aAAa;IACb,IAAI,MAAM,CAAC,OAAO,EAAE;QAChB,cAAO,CAAC,MAAM,CAAC,OAAO,EAAE,UAAC,GAAW,EAAE,GAAW;YAC7C,GAAG,CAAC,gBAAgB,CAAC,GAAG,EAAE,GAAG,CAAC,CAAA;QAClC,CAAC,CAAC,CAAA;KACL;IAED,aAAa;IACb,GAAG,CAAC,eAAe,GAAG,CAAC,CAAC,MAAM,CAAC,eAAe,CAAA;IAE9C,8BAA8B;IAC9B,IAAI,MAAM,CAAC,UAAU,EAAE;QACnB,IAAM,YAAY,GAAG,MAAM,CAAC,UAAU,CAAC,GAAG,CAAC,CAAA;QAC3C,IAAI,YAAY,IAAI,OAAO,YAAY,KAAK,QAAQ,EAAE;YAClD,IAAI,YAAY,CAAC,OAAO,EAAE;gBACtB,kDAAkD;gBAClD,OAAO,YAAY,CAAC,GAAG,CAAA;aAC1B;SACJ;KACJ;IAED,UAAU;IACV,GAAG,CAAC,kBAAkB,GAAG;QACrB,IAAI,GAAG,CAAC,UAAU,KAAK,CAAC;YAAE,OAAM;QAChC,IAAM,MAAM,GAAG,GAAG,CAAC,MAAM,CAAA;QACzB,IAAI,MAAM,GAAG,GAAG;YAAE,OAAM,CAAC,eAAe;QACxC,IAAI,MAAM,IAAI,GAAG,IAAI,MAAM,GAAG,GAAG;YAAE,OAAM,CAAC,MAAM;QAChD,IAAI,MAAM,IAAI,GAAG,EAAE;YACf,aAAa;YACb,OAAO,CAAC,KAAK,CAAC,0BAA0B,GAAG,MAAM,CAAC,CAAA;YAClD,IAAI,MAAM,CAAC,OAAO;gBAAE,MAAM,CAAC,OAAO,CAAC,GAAG,CAAC,CAAA,CAAC,qBAAqB;YAC7D,OAAM;SACT;QAED,qBAAqB;QACrB,IAAM,SAAS,GAAG,GAAG,CAAC,YAAY,CAAA;QAClC,IAAI,MAAS,CAAA;QACb,IAAI,OAAO,SAAS,KAAK,QAAQ,EAAE;YAC/B,IAAI;gBACA,MAAM,GAAG,IAAI,CAAC,KAAK,CAAC,SAAS,CAAC,CAAA;aACjC;YAAC,OAAO,EAAE,EAAE;gBACT,OAAO,CAAC,KAAK,CAAC,6BAA6B,EAAE,SAAS,CAAC,CAAA;gBACvD,IAAI,MAAM,CAAC,MAAM;oBAAE,MAAM,CAAC,MAAM,CAAC,GAAG,EAAE,SAAS,CAAC,CAAA;gBAChD,OAAM;aACT;SACJ;aAAM;YACH,MAAM,GAAG,SAAS,CAAA;SACrB;QACD,MAAM,CAAC,SAAS,CAAC,GAAG,EAAE,MAAM,CAAC,CAAA;IACjC,CAAC,CAAA;IAED,OAAO;IACP,GAAG,CAAC,IAAI,CAAC,MAAM,CAAC,QAAQ,IAAI,IAAI,CAAC,CAAA;IAEjC,OAAO,GAAG,CAAA;AACd,CAAC;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u4E0A\u4F20\u7684\u6838\u5FC3\u65B9\u6CD5\n * @author wangfupeng\n */\n\nimport { forEach } from '../../utils/util'\nimport { DicType } from '../../config/index'\n\ntype PostOptionType<T> = {\n    timeout?: number\n    formData?: FormData\n    headers?: DicType\n    withCredentials?: boolean\n    onTimeout?: (xhr: XMLHttpRequest) => void\n    onProgress?: (percent: number, event: ProgressEvent) => void\n    beforeSend?: (xhr: XMLHttpRequest) => { prevent: boolean; msg: string } | void\n    onError?: (xhr: XMLHttpRequest) => void\n    onFail?: (xhr: XMLHttpRequest, msg: string) => void\n    onSuccess: (xhr: XMLHttpRequest, result: T) => void\n}\n\n/**\n * \u53D1\u9001 post \u8BF7\u6C42\uFF08\u7528\u4E8E\u6587\u4EF6\u4E0A\u4F20\uFF09\n * @param url url\n * @param option \u914D\u7F6E\u9879\n */\nfunction post<T extends Object>(url: string, option: PostOptionType<T>): XMLHttpRequest | string {\n    const xhr = new XMLHttpRequest()\n    xhr.open('POST', url)\n\n    // \u8D85\u65F6\uFF0C\u9ED8\u8BA4 10s\n    xhr.timeout = option.timeout || 10 * 1000\n    xhr.ontimeout = () => {\n        console.error('wangEditor - \u8BF7\u6C42\u8D85\u65F6')\n        option.onTimeout && option.onTimeout(xhr)\n    }\n\n    // \u8FDB\u5EA6\n    if (xhr.upload) {\n        xhr.upload.onprogress = (e: ProgressEvent) => {\n            const percent = e.loaded / e.total\n            option.onProgress && option.onProgress(percent, e)\n        }\n    }\n\n    // \u81EA\u5B9A\u4E49 header\n    if (option.headers) {\n        forEach(option.headers, (key: string, val: string) => {\n            xhr.setRequestHeader(key, val)\n        })\n    }\n\n    // \u8DE8\u57DF\u4F20 cookie\n    xhr.withCredentials = !!option.withCredentials\n\n    // \u4E0A\u4F20\u4E4B\u524D\u7684\u94A9\u5B50\u51FD\u6570\uFF0C\u5728 xhr.send() \u4E4B\u524D\u6267\u884C\n    if (option.beforeSend) {\n        const beforeResult = option.beforeSend(xhr)\n        if (beforeResult && typeof beforeResult === 'object') {\n            if (beforeResult.prevent) {\n                // \u5982\u679C\u8FD4\u56DE\u7684\u7ED3\u679C\u662F {prevent: true, msg: 'xxxx'} \u5219\u8868\u793A\u7528\u6237\u653E\u5F03\u4E0A\u4F20\n                return beforeResult.msg\n            }\n        }\n    }\n\n    // \u670D\u52A1\u7AEF\u8FD4\u56DE\u4E4B\u540E\n    xhr.onreadystatechange = () => {\n        if (xhr.readyState !== 4) return\n        const status = xhr.status\n        if (status < 200) return // \u8BF7\u6C42\u53D1\u9001\u8FC7\u7A0B\u4E2D\uFF0C\u5C1A\u672A\u8FD4\u56DE\n        if (status >= 300 && status < 400) return // \u91CD\u5B9A\u5411\n        if (status >= 400) {\n            // 40x 50x \u62A5\u9519\n            console.error('wangEditor - XHR \u62A5\u9519\uFF0C\u72B6\u6001\u7801 ' + status)\n            if (option.onError) option.onError(xhr) // \u6709\uFF0C\u5219\u6267\u884C onError \u51FD\u6570\u5373\u53EF\n            return\n        }\n\n        // status = 200 \uFF0C\u5F97\u5230\u7ED3\u679C\n        const resultStr = xhr.responseText\n        let result: T\n        if (typeof resultStr !== 'object') {\n            try {\n                result = JSON.parse(resultStr)\n            } catch (ex) {\n                console.error('wangEditor - \u8FD4\u56DE\u7ED3\u679C\u4E0D\u662F JSON \u683C\u5F0F', resultStr)\n                if (option.onFail) option.onFail(xhr, resultStr)\n                return\n            }\n        } else {\n            result = resultStr\n        }\n        option.onSuccess(xhr, result)\n    }\n\n    // \u53D1\u9001\u8BF7\u6C42\n    xhr.send(option.formData || null)\n\n    return xhr\n}\n\nexport default post\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cb9459032db1c7dac5c0ded81861331a3467c38c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hnu1s7u5i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2hnu1s7u5i();
cov_2hnu1s7u5i().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_2hnu1s7u5i().s[1]++, __webpack_require__(7));
/**
 * 发送 post 请求（用于文件上传）
 * @param url url
 * @param option 配置项
 */

function post(url, option) {
  cov_2hnu1s7u5i().f[0]++;
  var xhr = (cov_2hnu1s7u5i().s[2]++, new XMLHttpRequest());
  cov_2hnu1s7u5i().s[3]++;
  xhr.open('POST', url); // 超时，默认 10s

  cov_2hnu1s7u5i().s[4]++;
  xhr.timeout = (cov_2hnu1s7u5i().b[0][0]++, option.timeout) || (cov_2hnu1s7u5i().b[0][1]++, 10 * 1000);
  cov_2hnu1s7u5i().s[5]++;

  xhr.ontimeout = function () {
    cov_2hnu1s7u5i().f[1]++;
    cov_2hnu1s7u5i().s[6]++;
    console.error('wangEditor - 请求超时');
    cov_2hnu1s7u5i().s[7]++;
    (cov_2hnu1s7u5i().b[1][0]++, option.onTimeout) && (cov_2hnu1s7u5i().b[1][1]++, option.onTimeout(xhr));
  }; // 进度


  cov_2hnu1s7u5i().s[8]++;

  if (xhr.upload) {
    cov_2hnu1s7u5i().b[2][0]++;
    cov_2hnu1s7u5i().s[9]++;

    xhr.upload.onprogress = function (e) {
      cov_2hnu1s7u5i().f[2]++;
      var percent = (cov_2hnu1s7u5i().s[10]++, e.loaded / e.total);
      cov_2hnu1s7u5i().s[11]++;
      (cov_2hnu1s7u5i().b[3][0]++, option.onProgress) && (cov_2hnu1s7u5i().b[3][1]++, option.onProgress(percent, e));
    };
  } else {
    cov_2hnu1s7u5i().b[2][1]++;
  } // 自定义 header


  cov_2hnu1s7u5i().s[12]++;

  if (option.headers) {
    cov_2hnu1s7u5i().b[4][0]++;
    cov_2hnu1s7u5i().s[13]++;
    (0, _forEach["default"])(util_1).call(util_1, option.headers, function (key, val) {
      cov_2hnu1s7u5i().f[3]++;
      cov_2hnu1s7u5i().s[14]++;
      xhr.setRequestHeader(key, val);
    });
  } else {
    cov_2hnu1s7u5i().b[4][1]++;
  } // 跨域传 cookie


  cov_2hnu1s7u5i().s[15]++;
  xhr.withCredentials = !!option.withCredentials; // 上传之前的钩子函数，在 xhr.send() 之前执行

  cov_2hnu1s7u5i().s[16]++;

  if (option.beforeSend) {
    cov_2hnu1s7u5i().b[5][0]++;
    var beforeResult = (cov_2hnu1s7u5i().s[17]++, option.beforeSend(xhr));
    cov_2hnu1s7u5i().s[18]++;

    if ((cov_2hnu1s7u5i().b[7][0]++, beforeResult) && (cov_2hnu1s7u5i().b[7][1]++, (0, _typeof2["default"])(beforeResult) === 'object')) {
      cov_2hnu1s7u5i().b[6][0]++;
      cov_2hnu1s7u5i().s[19]++;

      if (beforeResult.prevent) {
        cov_2hnu1s7u5i().b[8][0]++;
        cov_2hnu1s7u5i().s[20]++;
        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        return beforeResult.msg;
      } else {
        cov_2hnu1s7u5i().b[8][1]++;
      }
    } else {
      cov_2hnu1s7u5i().b[6][1]++;
    }
  } else {
    cov_2hnu1s7u5i().b[5][1]++;
  } // 服务端返回之后


  cov_2hnu1s7u5i().s[21]++;

  xhr.onreadystatechange = function () {
    cov_2hnu1s7u5i().f[4]++;
    cov_2hnu1s7u5i().s[22]++;

    if (xhr.readyState !== 4) {
      cov_2hnu1s7u5i().b[9][0]++;
      cov_2hnu1s7u5i().s[23]++;
      return;
    } else {
      cov_2hnu1s7u5i().b[9][1]++;
    }

    var status = (cov_2hnu1s7u5i().s[24]++, xhr.status);
    cov_2hnu1s7u5i().s[25]++;

    if (status < 200) {
      cov_2hnu1s7u5i().b[10][0]++;
      cov_2hnu1s7u5i().s[26]++;
      return;
    } else {
      cov_2hnu1s7u5i().b[10][1]++;
    } // 请求发送过程中，尚未返回


    cov_2hnu1s7u5i().s[27]++;

    if ((cov_2hnu1s7u5i().b[12][0]++, status >= 300) && (cov_2hnu1s7u5i().b[12][1]++, status < 400)) {
      cov_2hnu1s7u5i().b[11][0]++;
      cov_2hnu1s7u5i().s[28]++;
      return;
    } else {
      cov_2hnu1s7u5i().b[11][1]++;
    } // 重定向


    cov_2hnu1s7u5i().s[29]++;

    if (status >= 400) {
      cov_2hnu1s7u5i().b[13][0]++;
      cov_2hnu1s7u5i().s[30]++;
      // 40x 50x 报错
      console.error('wangEditor - XHR 报错，状态码 ' + status);
      cov_2hnu1s7u5i().s[31]++;

      if (option.onError) {
        cov_2hnu1s7u5i().b[14][0]++;
        cov_2hnu1s7u5i().s[32]++;
        option.onError(xhr);
      } else {
        cov_2hnu1s7u5i().b[14][1]++;
      } // 有，则执行 onError 函数即可


      cov_2hnu1s7u5i().s[33]++;
      return;
    } else {
      cov_2hnu1s7u5i().b[13][1]++;
    } // status = 200 ，得到结果


    var resultStr = (cov_2hnu1s7u5i().s[34]++, xhr.responseText);
    var result;
    cov_2hnu1s7u5i().s[35]++;

    if ((0, _typeof2["default"])(resultStr) !== 'object') {
      cov_2hnu1s7u5i().b[15][0]++;
      cov_2hnu1s7u5i().s[36]++;

      try {
        cov_2hnu1s7u5i().s[37]++;
        result = JSON.parse(resultStr);
      } catch (ex) {
        cov_2hnu1s7u5i().s[38]++;
        console.error('wangEditor - 返回结果不是 JSON 格式', resultStr);
        cov_2hnu1s7u5i().s[39]++;

        if (option.onFail) {
          cov_2hnu1s7u5i().b[16][0]++;
          cov_2hnu1s7u5i().s[40]++;
          option.onFail(xhr, resultStr);
        } else {
          cov_2hnu1s7u5i().b[16][1]++;
        }

        cov_2hnu1s7u5i().s[41]++;
        return;
      }
    } else {
      cov_2hnu1s7u5i().b[15][1]++;
      cov_2hnu1s7u5i().s[42]++;
      result = resultStr;
    }

    cov_2hnu1s7u5i().s[43]++;
    option.onSuccess(xhr, result);
  }; // 发送请求


  cov_2hnu1s7u5i().s[44]++;
  xhr.send((cov_2hnu1s7u5i().b[17][0]++, option.formData) || (cov_2hnu1s7u5i().b[17][1]++, null));
  cov_2hnu1s7u5i().s[45]++;
  return xhr;
}

cov_2hnu1s7u5i().s[46]++;
exports["default"] = post;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 上传进度条
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _now = _interopRequireDefault(__webpack_require__(333));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_skxece2ui() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/upload/progress.ts";
  var hash = "3be51d885eae900f080ec680605c25b6865aa6d6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/upload/progress.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 56
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 75
        }
      },
      "8": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 28
        }
      },
      "9": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 22
        }
      },
      "10": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 27
        }
      },
      "11": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "12": {
        start: {
          line: 25,
          column: 20
        },
        end: {
          line: 25,
          column: 24
        }
      },
      "13": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 29,
          column: 9
        }
      },
      "14": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 19
        }
      },
      "15": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 27
        }
      },
      "16": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 32,
          column: 28
        }
      },
      "17": {
        start: {
          line: 33,
          column: 29
        },
        end: {
          line: 33,
          column: 48
        }
      },
      "18": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 36
        }
      },
      "19": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 41,
          column: 9
        }
      },
      "20": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 40,
          column: 13
        }
      },
      "21": {
        start: {
          line: 38,
          column: 16
        },
        end: {
          line: 38,
          column: 56
        }
      },
      "22": {
        start: {
          line: 39,
          column: 16
        },
        end: {
          line: 39,
          column: 39
        }
      },
      "23": {
        start: {
          line: 43,
          column: 24
        },
        end: {
          line: 43,
          column: 38
        }
      },
      "24": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "25": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "26": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 49,
          column: 16
        }
      },
      "27": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 25
        }
      },
      "28": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 60,
          column: 6
        }
      },
      "29": {
        start: {
          line: 55,
          column: 19
        },
        end: {
          line: 55,
          column: 28
        }
      },
      "30": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 22
        }
      },
      "31": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 28
        }
      },
      "32": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 22
        }
      },
      "33": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 27
        }
      },
      "34": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 20
        }
      },
      "35": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 63,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 11,
            column: 31
          }
        },
        loc: {
          start: {
            line: 11,
            column: 42
          },
          end: {
            line: 62,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "Progress",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 21
          }
        },
        loc: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 19,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 30
          },
          end: {
            line: 24,
            column: 31
          }
        },
        loc: {
          start: {
            line: 24,
            column: 50
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 43
          },
          end: {
            line: 47,
            column: 44
          }
        },
        loc: {
          start: {
            line: 47,
            column: 55
          },
          end: {
            line: 49,
            column: 9
          }
        },
        line: 47
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 54,
            column: 30
          },
          end: {
            line: 54,
            column: 31
          }
        },
        loc: {
          start: {
            line: 54,
            column: 42
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }, {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 29,
            column: 9
          }
        }],
        line: 27
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 40,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 40,
            column: 13
          }
        }, {
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 40,
            column: 13
          }
        }],
        line: 37
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        }, {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/upload/progress.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/upload/progress.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,kEAAoD;AAGpD;IAQI,kBAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;QACpB,IAAI,CAAC,cAAc,GAAG,MAAM,CAAC,kBAAkB,CAAA;QAC/C,IAAI,CAAC,IAAI,GAAG,kBAAC,CAAC,kCAAkC,CAAC,CAAA;QAEjD,IAAI,CAAC,MAAM,GAAG,KAAK,CAAA;QACnB,IAAI,CAAC,IAAI,GAAG,CAAC,CAAA;QACb,IAAI,CAAC,SAAS,GAAG,CAAC,CAAA;IACtB,CAAC;IAED;;;OAGG;IACI,uBAAI,GAAX,UAAY,QAAgB;QAA5B,iBA4BC;QA3BG,SAAS;QACT,IAAI,IAAI,CAAC,MAAM,EAAE;YACb,OAAM;SACT;QACD,IAAI,CAAC,MAAM,GAAG,IAAI,CAAA;QAElB,UAAU;QACV,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAM,cAAc,GAAG,IAAI,CAAC,cAAc,CAAA;QAC1C,cAAc,CAAC,MAAM,CAAC,IAAI,CAAC,CAAA;QAE3B,uBAAuB;QACvB,IAAI,IAAI,CAAC,GAAG,EAAE,GAAG,IAAI,CAAC,IAAI,GAAG,GAAG,EAAE;YAC9B,IAAI,QAAQ,IAAI,CAAC,EAAE;gBACf,IAAI,CAAC,GAAG,CAAC,OAAO,EAAE,QAAQ,GAAG,GAAG,GAAG,GAAG,CAAC,CAAA;gBACvC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,GAAG,EAAE,CAAA;aACzB;SACJ;QAED,aAAa;QACb,IAAI,SAAS,GAAG,IAAI,CAAC,SAAS,CAAA;QAC9B,IAAI,SAAS,EAAE;YACX,YAAY,CAAC,SAAS,CAAC,CAAA;SAC1B;QACD,IAAI,CAAC,SAAS,GAAG,MAAM,CAAC,UAAU,CAAC;YAC/B,KAAI,CAAC,IAAI,EAAE,CAAA;QACf,CAAC,EAAE,GAAG,CAAC,CAAA;IACX,CAAC;IAED;;OAEG;IACK,uBAAI,GAAZ;QACI,IAAM,IAAI,GAAG,IAAI,CAAC,IAAI,CAAA;QACtB,IAAI,CAAC,MAAM,EAAE,CAAA;QAEb,IAAI,CAAC,MAAM,GAAG,KAAK,CAAA;QACnB,IAAI,CAAC,IAAI,GAAG,CAAC,CAAA;QACb,IAAI,CAAC,SAAS,GAAG,CAAC,CAAA;IACtB,CAAC;IACL,eAAC;AAAD,CAAC,AA/DD,IA+DC;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u4E0A\u4F20\u8FDB\u5EA6\u6761\n * @author wangfupeng\n */\n\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\n\nclass Progress {\n    private editor: Editor\n    private $bar: DomElement\n    private $textContainer: DomElement\n    private isShow: boolean\n    private time: number\n    private timeoutId: number\n\n    constructor(editor: Editor) {\n        this.editor = editor\n        this.$textContainer = editor.$textContainerElem\n        this.$bar = $('<div class=\"w-e-progress\"></div>')\n\n        this.isShow = false\n        this.time = 0\n        this.timeoutId = 0\n    }\n\n    /**\n     * \u663E\u793A\u8FDB\u5EA6\u6761\n     * @param progress \u8FDB\u5EA6\u767E\u5206\u6BD4\n     */\n    public show(progress: number): void {\n        // \u4E0D\u8981\u91CD\u65B0\u663E\u793A\n        if (this.isShow) {\n            return\n        }\n        this.isShow = true\n\n        // \u6E32\u67D3 $bar\n        const $bar = this.$bar\n        const $textContainer = this.$textContainer\n        $textContainer.append($bar)\n\n        // \u6539\u53D8\u8FDB\u5EA6\u6761\uFF08\u9632\u6296\uFF0C100ms \u6E32\u67D3\u4E00\u6B21\uFF09\n        if (Date.now() - this.time > 100) {\n            if (progress <= 1) {\n                $bar.css('width', progress * 100 + '%')\n                this.time = Date.now()\n            }\n        }\n\n        // 500ms \u4E4B\u540E\u9690\u85CF\n        let timeoutId = this.timeoutId\n        if (timeoutId) {\n            clearTimeout(timeoutId)\n        }\n        this.timeoutId = window.setTimeout(() => {\n            this.hide()\n        }, 500)\n    }\n\n    /**\n     * \u9690\u85CF\n     */\n    private hide() {\n        const $bar = this.$bar\n        $bar.remove()\n\n        this.isShow = false\n        this.time = 0\n        this.timeoutId = 0\n    }\n}\n\nexport default Progress\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3be51d885eae900f080ec680605c25b6865aa6d6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_skxece2ui = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_skxece2ui();

var __importDefault = (cov_skxece2ui().s[0]++, (cov_skxece2ui().b[0][0]++, void 0) && (cov_skxece2ui().b[0][1]++, (void 0).__importDefault) || (cov_skxece2ui().b[0][2]++, function (mod) {
  cov_skxece2ui().f[0]++;
  cov_skxece2ui().s[1]++;
  return (cov_skxece2ui().b[2][0]++, mod) && (cov_skxece2ui().b[2][1]++, mod.__esModule) ? (cov_skxece2ui().b[1][0]++, mod) : (cov_skxece2ui().b[1][1]++, {
    "default": mod
  });
}));

cov_skxece2ui().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_skxece2ui().s[3]++, __importDefault(__webpack_require__(2)));
var Progress = (
/** @class */
cov_skxece2ui().s[4]++, function () {
  cov_skxece2ui().f[1]++;

  function Progress(editor) {
    cov_skxece2ui().f[2]++;
    cov_skxece2ui().s[5]++;
    this.editor = editor;
    cov_skxece2ui().s[6]++;
    this.$textContainer = editor.$textContainerElem;
    cov_skxece2ui().s[7]++;
    this.$bar = dom_core_1["default"]('<div class="w-e-progress"></div>');
    cov_skxece2ui().s[8]++;
    this.isShow = false;
    cov_skxece2ui().s[9]++;
    this.time = 0;
    cov_skxece2ui().s[10]++;
    this.timeoutId = 0;
  }
  /**
   * 显示进度条
   * @param progress 进度百分比
   */


  cov_skxece2ui().s[11]++;

  Progress.prototype.show = function (progress) {
    cov_skxece2ui().f[3]++;

    var _this = (cov_skxece2ui().s[12]++, this); // 不要重新显示


    cov_skxece2ui().s[13]++;

    if (this.isShow) {
      cov_skxece2ui().b[3][0]++;
      cov_skxece2ui().s[14]++;
      return;
    } else {
      cov_skxece2ui().b[3][1]++;
    }

    cov_skxece2ui().s[15]++;
    this.isShow = true; // 渲染 $bar

    var $bar = (cov_skxece2ui().s[16]++, this.$bar);
    var $textContainer = (cov_skxece2ui().s[17]++, this.$textContainer);
    cov_skxece2ui().s[18]++;
    $textContainer.append($bar); // 改变进度条（防抖，100ms 渲染一次）

    cov_skxece2ui().s[19]++;

    if ((0, _now["default"])() - this.time > 100) {
      cov_skxece2ui().b[4][0]++;
      cov_skxece2ui().s[20]++;

      if (progress <= 1) {
        cov_skxece2ui().b[5][0]++;
        cov_skxece2ui().s[21]++;
        $bar.css('width', progress * 100 + '%');
        cov_skxece2ui().s[22]++;
        this.time = (0, _now["default"])();
      } else {
        cov_skxece2ui().b[5][1]++;
      }
    } else {
      cov_skxece2ui().b[4][1]++;
    } // 500ms 之后隐藏


    var timeoutId = (cov_skxece2ui().s[23]++, this.timeoutId);
    cov_skxece2ui().s[24]++;

    if (timeoutId) {
      cov_skxece2ui().b[6][0]++;
      cov_skxece2ui().s[25]++;
      clearTimeout(timeoutId);
    } else {
      cov_skxece2ui().b[6][1]++;
    }

    cov_skxece2ui().s[26]++;
    this.timeoutId = window.setTimeout(function () {
      cov_skxece2ui().f[4]++;
      cov_skxece2ui().s[27]++;

      _this.hide();
    }, 500);
  };
  /**
   * 隐藏
   */


  cov_skxece2ui().s[28]++;

  Progress.prototype.hide = function () {
    cov_skxece2ui().f[5]++;
    var $bar = (cov_skxece2ui().s[29]++, this.$bar);
    cov_skxece2ui().s[30]++;
    $bar.remove();
    cov_skxece2ui().s[31]++;
    this.isShow = false;
    cov_skxece2ui().s[32]++;
    this.time = 0;
    cov_skxece2ui().s[33]++;
    this.timeoutId = 0;
  };

  cov_skxece2ui().s[34]++;
  return Progress;
}());
cov_skxece2ui().s[35]++;
exports["default"] = Progress;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(334);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(335);

module.exports = parent;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(336);
var path = __webpack_require__(10);

module.exports = path.Date.now;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);

// `Date.now` method
// https://tc39.github.io/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 绑定图片的事件
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_15blxvxpmj() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/index.ts";
  var hash = "5ffb041e7c51a49d5a5bc1372aed33e2798e8486";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 57
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 55
        }
      },
      "5": {
        start: {
          line: 12,
          column: 18
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "6": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 13,
          column: 65
        }
      },
      "7": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 32
        }
      },
      "8": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 31
        }
      },
      "9": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 32
        }
      },
      "10": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 36
        }
      },
      "11": {
        start: {
          line: 29,
          column: 0
        },
        end: {
          line: 29,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 18
          }
        },
        loc: {
          start: {
            line: 18,
            column: 27
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,0DAAsC;AACtC,wDAAoC;AACpC,0DAAyC;AACzC,kEAA4C;AAE5C;;;GAGG;AACH,SAAS,SAAS,CAAC,MAAc;IAC7B,OAAO;IACP,mBAAY,CAAC,MAAM,CAAC,CAAA;IAEpB,OAAO;IACP,kBAAW,CAAC,MAAM,CAAC,CAAA;IAEnB,2BAA2B;IAC3B,SAAS;IACT,mBAAe,CAAC,MAAM,CAAC,CAAA;IAEvB,SAAS;IACT,uBAAc,CAAC,MAAM,CAAC,CAAA;AAC1B,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u56FE\u7247\u7684\u4E8B\u4EF6\n * @author wangfupeng\n */\n\nimport Editor from '../../../editor/index'\nimport bindPasteImg from './paste-img'\nimport bindDropImg from './drop-img'\nimport bindDragImgSize from './drag-size'\nimport bindTooltipImg from './tooltip-event'\n\n/**\n * \u7ED1\u5B9A\u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindEvent(editor: Editor): void {\n    // \u7C98\u8D34\u56FE\u7247\n    bindPasteImg(editor)\n\n    // \u62D6\u62FD\u56FE\u7247\n    bindDropImg(editor)\n\n    // \u53EF\u518D\u6269\u5C55\u5176\u4ED6\u4E8B\u4EF6...\u5982\u56FE\u7247 tooltip \u7B49\n    // \u62D6\u62FD\u56FE\u7247\u5C3A\u5BF8\n    bindDragImgSize(editor)\n\n    //Tooltip\n    bindTooltipImg(editor)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ffb041e7c51a49d5a5bc1372aed33e2798e8486"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15blxvxpmj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_15blxvxpmj();

var __importDefault = (cov_15blxvxpmj().s[0]++, (cov_15blxvxpmj().b[0][0]++, void 0) && (cov_15blxvxpmj().b[0][1]++, (void 0).__importDefault) || (cov_15blxvxpmj().b[0][2]++, function (mod) {
  cov_15blxvxpmj().f[0]++;
  cov_15blxvxpmj().s[1]++;
  return (cov_15blxvxpmj().b[2][0]++, mod) && (cov_15blxvxpmj().b[2][1]++, mod.__esModule) ? (cov_15blxvxpmj().b[1][0]++, mod) : (cov_15blxvxpmj().b[1][1]++, {
    "default": mod
  });
}));

cov_15blxvxpmj().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var paste_img_1 = (cov_15blxvxpmj().s[3]++, __importDefault(__webpack_require__(338)));
var drop_img_1 = (cov_15blxvxpmj().s[4]++, __importDefault(__webpack_require__(339)));
var drag_size_1 = (cov_15blxvxpmj().s[5]++, __importDefault(__webpack_require__(340)));
var tooltip_event_1 = (cov_15blxvxpmj().s[6]++, __importDefault(__webpack_require__(348)));
/**
 * 绑定事件
 * @param editor 编辑器实例
 */

function bindEvent(editor) {
  cov_15blxvxpmj().f[1]++;
  cov_15blxvxpmj().s[7]++;
  // 粘贴图片
  paste_img_1["default"](editor); // 拖拽图片

  cov_15blxvxpmj().s[8]++;
  drop_img_1["default"](editor); // 可再扩展其他事件...如图片 tooltip 等
  // 拖拽图片尺寸

  cov_15blxvxpmj().s[9]++;
  drag_size_1["default"](editor); //Tooltip

  cov_15blxvxpmj().s[10]++;
  tooltip_event_1["default"](editor);
}

cov_15blxvxpmj().s[11]++;
exports["default"] = bindEvent;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 粘贴图片
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_7qhf8yzh() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/paste-img.ts";
  var hash = "e005f6fd1c7efb048198a57716d78078a6707d51";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/paste-img.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 62
        }
      },
      "4": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 60
        }
      },
      "5": {
        start: {
          line: 18,
          column: 17
        },
        end: {
          line: 18,
          column: 30
        }
      },
      "6": {
        start: {
          line: 19,
          column: 27
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "7": {
        start: {
          line: 20,
          column: 25
        },
        end: {
          line: 20,
          column: 46
        }
      },
      "8": {
        start: {
          line: 21,
          column: 20
        },
        end: {
          line: 21,
          column: 83
        }
      },
      "9": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 23,
          column: 20
        }
      },
      "10": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 20
        }
      },
      "11": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 49
        }
      },
      "12": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 26,
          column: 20
        }
      },
      "13": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 20
        }
      },
      "14": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 17
        }
      },
      "15": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "16": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 15
        }
      },
      "17": {
        start: {
          line: 39,
          column: 22
        },
        end: {
          line: 39,
          column: 51
        }
      },
      "18": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "19": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 15
        }
      },
      "20": {
        start: {
          line: 45,
          column: 20
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "21": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 37
        }
      },
      "22": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "23": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 35
        }
      },
      "24": {
        start: {
          line: 59,
          column: 0
        },
        end: {
          line: 59,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "_haveTextOrHtml",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 24
          }
        },
        loc: {
          start: {
            line: 17,
            column: 36
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 17
      },
      "2": {
        name: "pasteImgHandler",
        decl: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 24
          }
        },
        loc: {
          start: {
            line: 33,
            column: 36
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 33
      },
      "3": {
        name: "bindPasteImg",
        decl: {
          start: {
            line: 53,
            column: 9
          },
          end: {
            line: 53,
            column: 21
          }
        },
        loc: {
          start: {
            line: 53,
            column: 30
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 53
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 43
          },
          end: {
            line: 55,
            column: 44
          }
        },
        loc: {
          start: {
            line: 55,
            column: 56
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 20
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 20
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 20
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 20
          }
        }],
        line: 25
      },
      "5": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 34
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/paste-img.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/paste-img.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,+DAA0F;AAC1F,6DAAqC;AAErC;;;;GAIG;AACH,SAAS,eAAe,CAAC,MAAc,EAAE,CAAiB;IACtD,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,gBAAgB,GAAG,MAAM,CAAC,gBAAgB,CAAA;IAChD,IAAM,cAAc,GAAG,MAAM,CAAC,cAAc,CAAA;IAC5C,IAAI,SAAS,GAAG,0BAAY,CAAC,CAAC,EAAE,gBAAgB,EAAE,cAAc,CAAC,CAAA;IACjE,IAAI,SAAS;QAAE,OAAO,IAAI,CAAA;IAC1B,IAAI,SAAS,GAAG,0BAAY,CAAC,CAAC,CAAC,CAAA;IAC/B,IAAI,SAAS;QAAE,OAAO,IAAI,CAAA;IAE1B,OAAO,KAAK,CAAA,CAAC,0BAA0B;AAC3C,CAAC;AAED;;;GAGG;AACH,SAAS,eAAe,CAAC,CAAiB,EAAE,MAAc;IACtD,IAAI,eAAe,CAAC,MAAM,EAAE,CAAC,CAAC,EAAE;QAC5B,kCAAkC;QAClC,OAAM;KACT;IAED,YAAY;IACZ,IAAM,WAAW,GAAG,0BAAY,CAAC,CAAC,CAAC,CAAA;IACnC,IAAI,CAAC,WAAW,CAAC,MAAM,EAAE;QACrB,OAAM;KACT;IAED,iBAAiB;IAEjB,OAAO;IACP,IAAM,SAAS,GAAG,IAAI,oBAAS,CAAC,MAAM,CAAC,CAAA;IACvC,SAAS,CAAC,SAAS,CAAC,WAAW,CAAC,CAAA;AACpC,CAAC;AAED;;;;GAIG;AACH,SAAS,YAAY,CAAC,MAAc;IAChC,cAAc;IACd,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,UAAC,CAAiB;QACrD,eAAe,CAAC,CAAC,EAAE,MAAM,CAAC,CAAA;IAC9B,CAAC,CAAC,CAAA;AACN,CAAC;AAED,kBAAe,YAAY,CAAA",
      sourcesContent: ["/**\n * @description \u7C98\u8D34\u56FE\u7247\n * @author wangfupeng\n */\n\nimport Editor from '../../../editor/index'\nimport { getPasteText, getPasteHtml, getPasteImgs } from '../../../text/paste/paste-event'\nimport UploadImg from '../upload-img'\n\n/**\n * \u526A\u5207\u677F\u662F\u5426\u6709 text \u6216\u8005 html \uFF1F\n * @param editor \u7F16\u8F91\u5668\u5BF9\u8C61\n * @param e \u7C98\u8D34\u4E8B\u4EF6\u53C2\u6570\n */\nfunction _haveTextOrHtml(editor: Editor, e: ClipboardEvent): boolean {\n    const config = editor.config\n    const pasteFilterStyle = config.pasteFilterStyle\n    const pasteIgnoreImg = config.pasteIgnoreImg\n    let pasteHtml = getPasteHtml(e, pasteFilterStyle, pasteIgnoreImg)\n    if (pasteHtml) return true\n    let pasteText = getPasteText(e)\n    if (pasteText) return true\n\n    return false // text html \u90FD\u6CA1\u6709\uFF0C\u5219\u8FD4\u56DE false\n}\n\n/**\n * \u7C98\u8D34\u56FE\u7247\u4E8B\u4EF6\u65B9\u6CD5\n * @param e \u4E8B\u4EF6\u53C2\u6570\n */\nfunction pasteImgHandler(e: ClipboardEvent, editor: Editor): void {\n    if (_haveTextOrHtml(editor, e)) {\n        // \u7C98\u8D34\u8FC7\u6765\u7684\u6709 text \u6216\u8005 html \uFF0C\u5219\u4E0D\u6267\u884C\u7C98\u8D34\u56FE\u7247\u903B\u8F91\n        return\n    }\n\n    // \u83B7\u53D6\u7C98\u8D34\u7684\u56FE\u7247\u5217\u8868\n    const pastedFiles = getPasteImgs(e)\n    if (!pastedFiles.length) {\n        return\n    }\n\n    // code \u4E2D\u5FFD\u7565\uFF08\u6682\u4E0D\u7BA1\u5B83\uFF09\n\n    // \u6267\u884C\u4E0A\u4F20\n    const uploadImg = new UploadImg(editor)\n    uploadImg.uploadImg(pastedFiles)\n}\n\n/**\n * \u7C98\u8D34\u56FE\u7247\n * @param editor \u7F16\u8F91\u5668\u5BF9\u8C61\n * @param pasteEvents \u7C98\u8D34\u4E8B\u4EF6\u5217\u8868\n */\nfunction bindPasteImg(editor: Editor): void {\n    // \u7ED1\u5B9A paste \u4E8B\u4EF6\n    editor.txt.eventHooks.pasteEvents.push((e: ClipboardEvent) => {\n        pasteImgHandler(e, editor)\n    })\n}\n\nexport default bindPasteImg\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e005f6fd1c7efb048198a57716d78078a6707d51"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_7qhf8yzh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_7qhf8yzh();

var __importDefault = (cov_7qhf8yzh().s[0]++, (cov_7qhf8yzh().b[0][0]++, void 0) && (cov_7qhf8yzh().b[0][1]++, (void 0).__importDefault) || (cov_7qhf8yzh().b[0][2]++, function (mod) {
  cov_7qhf8yzh().f[0]++;
  cov_7qhf8yzh().s[1]++;
  return (cov_7qhf8yzh().b[2][0]++, mod) && (cov_7qhf8yzh().b[2][1]++, mod.__esModule) ? (cov_7qhf8yzh().b[1][0]++, mod) : (cov_7qhf8yzh().b[1][1]++, {
    "default": mod
  });
}));

cov_7qhf8yzh().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var paste_event_1 = (cov_7qhf8yzh().s[3]++, __webpack_require__(122));
var upload_img_1 = (cov_7qhf8yzh().s[4]++, __importDefault(__webpack_require__(94)));
/**
 * 剪切板是否有 text 或者 html ？
 * @param editor 编辑器对象
 * @param e 粘贴事件参数
 */

function _haveTextOrHtml(editor, e) {
  cov_7qhf8yzh().f[1]++;
  var config = (cov_7qhf8yzh().s[5]++, editor.config);
  var pasteFilterStyle = (cov_7qhf8yzh().s[6]++, config.pasteFilterStyle);
  var pasteIgnoreImg = (cov_7qhf8yzh().s[7]++, config.pasteIgnoreImg);
  var pasteHtml = (cov_7qhf8yzh().s[8]++, paste_event_1.getPasteHtml(e, pasteFilterStyle, pasteIgnoreImg));
  cov_7qhf8yzh().s[9]++;

  if (pasteHtml) {
    cov_7qhf8yzh().b[3][0]++;
    cov_7qhf8yzh().s[10]++;
    return true;
  } else {
    cov_7qhf8yzh().b[3][1]++;
  }

  var pasteText = (cov_7qhf8yzh().s[11]++, paste_event_1.getPasteText(e));
  cov_7qhf8yzh().s[12]++;

  if (pasteText) {
    cov_7qhf8yzh().b[4][0]++;
    cov_7qhf8yzh().s[13]++;
    return true;
  } else {
    cov_7qhf8yzh().b[4][1]++;
  }

  cov_7qhf8yzh().s[14]++;
  return false; // text html 都没有，则返回 false
}
/**
 * 粘贴图片事件方法
 * @param e 事件参数
 */


function pasteImgHandler(e, editor) {
  cov_7qhf8yzh().f[2]++;
  cov_7qhf8yzh().s[15]++;

  if (_haveTextOrHtml(editor, e)) {
    cov_7qhf8yzh().b[5][0]++;
    cov_7qhf8yzh().s[16]++;
    // 粘贴过来的有 text 或者 html ，则不执行粘贴图片逻辑
    return;
  } else {
    cov_7qhf8yzh().b[5][1]++;
  } // 获取粘贴的图片列表


  var pastedFiles = (cov_7qhf8yzh().s[17]++, paste_event_1.getPasteImgs(e));
  cov_7qhf8yzh().s[18]++;

  if (!pastedFiles.length) {
    cov_7qhf8yzh().b[6][0]++;
    cov_7qhf8yzh().s[19]++;
    return;
  } else {
    cov_7qhf8yzh().b[6][1]++;
  } // code 中忽略（暂不管它）
  // 执行上传


  var uploadImg = (cov_7qhf8yzh().s[20]++, new upload_img_1["default"](editor));
  cov_7qhf8yzh().s[21]++;
  uploadImg.uploadImg(pastedFiles);
}
/**
 * 粘贴图片
 * @param editor 编辑器对象
 * @param pasteEvents 粘贴事件列表
 */


function bindPasteImg(editor) {
  cov_7qhf8yzh().f[3]++;
  cov_7qhf8yzh().s[22]++;
  // 绑定 paste 事件
  editor.txt.eventHooks.pasteEvents.push(function (e) {
    cov_7qhf8yzh().f[4]++;
    cov_7qhf8yzh().s[23]++;
    pasteImgHandler(e, editor);
  });
}

cov_7qhf8yzh().s[24]++;
exports["default"] = bindPasteImg;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 拖拽上传图片
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_t7wt6drp7() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drop-img.ts";
  var hash = "d2c1362037219cafa97d3b82b46f3979e3b8cbb3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drop-img.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 19
        },
        end: {
          line: 10,
          column: 60
        }
      },
      "4": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 58
        }
      },
      "5": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 20,
          column: 9
        }
      },
      "6": {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 19
        }
      },
      "7": {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 22,
          column: 56
        }
      },
      "8": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 35
        }
      },
      "9": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 58
        }
      },
      "10": {
        start: {
          line: 28,
          column: 0
        },
        end: {
          line: 28,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindDropImg",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 29
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "dropImgHandler",
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 27
          }
        },
        loc: {
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 20
          },
          end: {
            line: 17,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 20
          },
          end: {
            line: 17,
            column: 34
          }
        }, {
          start: {
            line: 17,
            column: 38
          },
          end: {
            line: 17,
            column: 58
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }, {
          start: {
            line: 18,
            column: 8
          },
          end: {
            line: 20,
            column: 9
          }
        }],
        line: 18
      },
      "5": {
        loc: {
          start: {
            line: 18,
            column: 12
          },
          end: {
            line: 18,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 12
          },
          end: {
            line: 18,
            column: 18
          }
        }, {
          start: {
            line: 18,
            column: 22
          },
          end: {
            line: 18,
            column: 35
          }
        }],
        line: 18
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drop-img.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drop-img.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,6DAAqC;AAErC,SAAwB,WAAW,CAAC,MAAc;IAC9C;;;OAGG;IACH,SAAS,cAAc,CAAC,CAAM;QAC1B,IAAM,KAAK,GAAG,CAAC,CAAC,YAAY,IAAI,CAAC,CAAC,YAAY,CAAC,KAAK,CAAA;QACpD,IAAI,CAAC,KAAK,IAAI,CAAC,KAAK,CAAC,MAAM,EAAE;YACzB,OAAM;SACT;QAED,OAAO;QACP,IAAM,SAAS,GAAG,IAAI,oBAAS,CAAC,MAAM,CAAC,CAAA;QACvC,SAAS,CAAC,SAAS,CAAC,KAAK,CAAC,CAAA;IAC9B,CAAC;IAED,aAAa;IACb,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,UAAU,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;AACzD,CAAC;AAlBD,8BAkBC",
      sourcesContent: ["/**\n * @description \u62D6\u62FD\u4E0A\u4F20\u56FE\u7247\n * @author wangfupeng\n */\n\nimport Editor from '../../../editor/index'\nimport UploadImg from '../upload-img'\n\nexport default function bindDropImg(editor: Editor): void {\n    /**\n     * \u62D6\u62FD\u56FE\u7247\u7684\u4E8B\u4EF6\n     * @param e \u4E8B\u4EF6\u53C2\u6570\n     */\n    function dropImgHandler(e: any): void {\n        const files = e.dataTransfer && e.dataTransfer.files\n        if (!files || !files.length) {\n            return\n        }\n\n        // \u4E0A\u4F20\u56FE\u7247\n        const uploadImg = new UploadImg(editor)\n        uploadImg.uploadImg(files)\n    }\n\n    // \u7ED1\u5B9A drop \u4E8B\u4EF6\n    editor.txt.eventHooks.dropEvents.push(dropImgHandler)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d2c1362037219cafa97d3b82b46f3979e3b8cbb3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_t7wt6drp7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_t7wt6drp7();

var __importDefault = (cov_t7wt6drp7().s[0]++, (cov_t7wt6drp7().b[0][0]++, void 0) && (cov_t7wt6drp7().b[0][1]++, (void 0).__importDefault) || (cov_t7wt6drp7().b[0][2]++, function (mod) {
  cov_t7wt6drp7().f[0]++;
  cov_t7wt6drp7().s[1]++;
  return (cov_t7wt6drp7().b[2][0]++, mod) && (cov_t7wt6drp7().b[2][1]++, mod.__esModule) ? (cov_t7wt6drp7().b[1][0]++, mod) : (cov_t7wt6drp7().b[1][1]++, {
    "default": mod
  });
}));

cov_t7wt6drp7().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var upload_img_1 = (cov_t7wt6drp7().s[3]++, __importDefault(__webpack_require__(94)));

function bindDropImg(editor) {
  cov_t7wt6drp7().f[1]++;

  /**
   * 拖拽图片的事件
   * @param e 事件参数
   */
  function dropImgHandler(e) {
    cov_t7wt6drp7().f[2]++;
    var files = (cov_t7wt6drp7().s[4]++, (cov_t7wt6drp7().b[3][0]++, e.dataTransfer) && (cov_t7wt6drp7().b[3][1]++, e.dataTransfer.files));
    cov_t7wt6drp7().s[5]++;

    if ((cov_t7wt6drp7().b[5][0]++, !files) || (cov_t7wt6drp7().b[5][1]++, !files.length)) {
      cov_t7wt6drp7().b[4][0]++;
      cov_t7wt6drp7().s[6]++;
      return;
    } else {
      cov_t7wt6drp7().b[4][1]++;
    } // 上传图片


    var uploadImg = (cov_t7wt6drp7().s[7]++, new upload_img_1["default"](editor));
    cov_t7wt6drp7().s[8]++;
    uploadImg.uploadImg(files);
  } // 绑定 drop 事件


  cov_t7wt6drp7().s[9]++;
  editor.txt.eventHooks.dropEvents.push(dropImgHandler);
}

cov_t7wt6drp7().s[10]++;
exports["default"] = bindDropImg;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 图片拖拽事件绑定
 * @author xiaokyo
 */

var _interopRequireDefault = __webpack_require__(0);

var _parseFloat2 = _interopRequireDefault(__webpack_require__(341));

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_sia4oz5gp() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drag-size.ts";
  var hash = "0d4ebc38fff9b61079b7d4caa833157dbc366455";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drag-size.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 48
        }
      },
      "5": {
        start: {
          line: 12,
          column: 13
        },
        end: {
          line: 12,
          column: 43
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 115
        }
      },
      "7": {
        start: {
          line: 30,
          column: 16
        },
        end: {
          line: 30,
          column: 197
        }
      },
      "8": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 17
        }
      },
      "9": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 37
        }
      },
      "10": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 17
        }
      },
      "11": {
        start: {
          line: 41,
          column: 18
        },
        end: {
          line: 41,
          column: 60
        }
      },
      "12": {
        start: {
          line: 42,
          column: 15
        },
        end: {
          line: 42,
          column: 43
        }
      },
      "13": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 43,
          column: 37
        }
      },
      "14": {
        start: {
          line: 44,
          column: 16
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "15": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 79
        }
      },
      "16": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 112
        }
      },
      "17": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 17
        }
      },
      "18": {
        start: {
          line: 53,
          column: 29
        },
        end: {
          line: 53,
          column: 54
        }
      },
      "19": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 56,
          column: 57
        }
      },
      "20": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 65,
          column: 11
        }
      },
      "21": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 32
        }
      },
      "22": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 117,
          column: 11
        }
      },
      "23": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 31
        }
      },
      "24": {
        start: {
          line: 69,
          column: 12
        },
        end: {
          line: 70,
          column: 23
        }
      },
      "25": {
        start: {
          line: 70,
          column: 16
        },
        end: {
          line: 70,
          column: 23
        }
      },
      "26": {
        start: {
          line: 71,
          column: 25
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "27": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 34
        }
      },
      "28": {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 60
        }
      },
      "29": {
        start: {
          line: 74,
          column: 26
        },
        end: {
          line: 74,
          column: 60
        }
      },
      "30": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 37
        }
      },
      "31": {
        start: {
          line: 76,
          column: 25
        },
        end: {
          line: 76,
          column: 39
        }
      },
      "32": {
        start: {
          line: 77,
          column: 23
        },
        end: {
          line: 77,
          column: 50
        }
      },
      "33": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 47
        }
      },
      "34": {
        start: {
          line: 79,
          column: 24
        },
        end: {
          line: 79,
          column: 38
        }
      },
      "35": {
        start: {
          line: 80,
          column: 23
        },
        end: {
          line: 80,
          column: 28
        }
      },
      "36": {
        start: {
          line: 81,
          column: 23
        },
        end: {
          line: 81,
          column: 29
        }
      },
      "37": {
        start: {
          line: 82,
          column: 28
        },
        end: {
          line: 82,
          column: 56
        }
      },
      "38": {
        start: {
          line: 84,
          column: 16
        },
        end: {
          line: 84,
          column: 61
        }
      },
      "39": {
        start: {
          line: 85,
          column: 16
        },
        end: {
          line: 85,
          column: 57
        }
      },
      "40": {
        start: {
          line: 88,
          column: 16
        },
        end: {
          line: 88,
          column: 37
        }
      },
      "41": {
        start: {
          line: 89,
          column: 16
        },
        end: {
          line: 89,
          column: 36
        }
      },
      "42": {
        start: {
          line: 90,
          column: 16
        },
        end: {
          line: 90,
          column: 53
        }
      },
      "43": {
        start: {
          line: 91,
          column: 16
        },
        end: {
          line: 91,
          column: 54
        }
      },
      "44": {
        start: {
          line: 93,
          column: 16
        },
        end: {
          line: 95,
          column: 17
        }
      },
      "45": {
        start: {
          line: 94,
          column: 20
        },
        end: {
          line: 94,
          column: 40
        }
      },
      "46": {
        start: {
          line: 96,
          column: 16
        },
        end: {
          line: 96,
          column: 51
        }
      },
      "47": {
        start: {
          line: 97,
          column: 16
        },
        end: {
          line: 97,
          column: 51
        }
      },
      "48": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 102,
          column: 48
        }
      },
      "49": {
        start: {
          line: 103,
          column: 16
        },
        end: {
          line: 103,
          column: 59
        }
      },
      "50": {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 105,
          column: 56
        }
      },
      "51": {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 52
        }
      },
      "52": {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 53
        }
      },
      "53": {
        start: {
          line: 109,
          column: 33
        },
        end: {
          line: 109,
          column: 67
        }
      },
      "54": {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 110
        }
      },
      "55": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 28
        }
      },
      "56": {
        start: {
          line: 114,
          column: 12
        },
        end: {
          line: 114,
          column: 52
        }
      },
      "57": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 116,
          column: 50
        }
      },
      "58": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 122,
          column: 25
        }
      },
      "59": {
        start: {
          line: 122,
          column: 12
        },
        end: {
          line: 122,
          column: 25
        }
      },
      "60": {
        start: {
          line: 123,
          column: 8
        },
        end: {
          line: 126,
          column: 9
        }
      },
      "61": {
        start: {
          line: 124,
          column: 12
        },
        end: {
          line: 124,
          column: 33
        }
      },
      "62": {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 125,
          column: 63
        }
      },
      "63": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 61
        }
      },
      "64": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 46
        }
      },
      "65": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 55
        }
      },
      "66": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 138,
          column: 7
        }
      },
      "67": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 137,
          column: 60
        }
      },
      "68": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 142,
          column: 6
        }
      },
      "69": {
        start: {
          line: 149,
          column: 13
        },
        end: {
          line: 149,
          column: 37
        }
      },
      "70": {
        start: {
          line: 149,
          column: 50
        },
        end: {
          line: 149,
          column: 61
        }
      },
      "71": {
        start: {
          line: 149,
          column: 74
        },
        end: {
          line: 149,
          column: 85
        }
      },
      "72": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 56
        }
      },
      "73": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 58
        }
      },
      "74": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 53
        }
      },
      "75": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 60
        }
      },
      "76": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 156,
          column: 57
        }
      },
      "77": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 54
        }
      },
      "78": {
        start: {
          line: 159,
          column: 0
        },
        end: {
          line: 159,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "setDragStyle",
        decl: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 21
          }
        },
        loc: {
          start: {
            line: 21,
            column: 55
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 21
      },
      "2": {
        name: "createDragBox",
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 22
          }
        },
        loc: {
          start: {
            line: 29,
            column: 51
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 29
      },
      "3": {
        name: "showDargBox",
        decl: {
          start: {
            line: 40,
            column: 9
          },
          end: {
            line: 40,
            column: 20
          }
        },
        loc: {
          start: {
            line: 40,
            column: 54
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 40
      },
      "4": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 52,
            column: 9
          },
          end: {
            line: 52,
            column: 25
          }
        },
        loc: {
          start: {
            line: 52,
            column: 34
          },
          end: {
            line: 143,
            column: 1
          }
        },
        line: 52
      },
      "5": {
        name: "bindDragEvents",
        decl: {
          start: {
            line: 62,
            column: 13
          },
          end: {
            line: 62,
            column: 27
          }
        },
        loc: {
          start: {
            line: 62,
            column: 47
          },
          end: {
            line: 118,
            column: 5
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 63,
            column: 26
          },
          end: {
            line: 63,
            column: 27
          }
        },
        loc: {
          start: {
            line: 63,
            column: 39
          },
          end: {
            line: 65,
            column: 9
          }
        },
        line: 63
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 66,
            column: 50
          },
          end: {
            line: 66,
            column: 51
          }
        },
        loc: {
          start: {
            line: 66,
            column: 63
          },
          end: {
            line: 117,
            column: 9
          }
        },
        line: 66
      },
      "8": {
        name: "offEvents",
        decl: {
          start: {
            line: 83,
            column: 21
          },
          end: {
            line: 83,
            column: 30
          }
        },
        loc: {
          start: {
            line: 83,
            column: 33
          },
          end: {
            line: 86,
            column: 13
          }
        },
        line: 83
      },
      "9": {
        name: "mouseMoveHandler",
        decl: {
          start: {
            line: 87,
            column: 21
          },
          end: {
            line: 87,
            column: 37
          }
        },
        loc: {
          start: {
            line: 87,
            column: 42
          },
          end: {
            line: 104,
            column: 13
          }
        },
        line: 87
      },
      "10": {
        name: "mouseUpHandler",
        decl: {
          start: {
            line: 106,
            column: 21
          },
          end: {
            line: 106,
            column: 35
          }
        },
        loc: {
          start: {
            line: 106,
            column: 38
          },
          end: {
            line: 113,
            column: 13
          }
        },
        line: 106
      },
      "11": {
        name: "showDrag",
        decl: {
          start: {
            line: 120,
            column: 13
          },
          end: {
            line: 120,
            column: 21
          }
        },
        loc: {
          start: {
            line: 120,
            column: 31
          },
          end: {
            line: 127,
            column: 5
          }
        },
        line: 120
      },
      "12": {
        name: "hideDrag",
        decl: {
          start: {
            line: 129,
            column: 13
          },
          end: {
            line: 129,
            column: 21
          }
        },
        loc: {
          start: {
            line: 129,
            column: 24
          },
          end: {
            line: 131,
            column: 5
          }
        },
        line: 129
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 136,
            column: 25
          },
          end: {
            line: 136,
            column: 26
          }
        },
        loc: {
          start: {
            line: 136,
            column: 37
          },
          end: {
            line: 138,
            column: 5
          }
        },
        line: 136
      },
      "14": {
        name: "bindDragImgSize",
        decl: {
          start: {
            line: 148,
            column: 9
          },
          end: {
            line: 148,
            column: 24
          }
        },
        loc: {
          start: {
            line: 148,
            column: 33
          },
          end: {
            line: 158,
            column: 1
          }
        },
        line: 148
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 70,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 70,
            column: 23
          }
        }, {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 70,
            column: 23
          }
        }],
        line: 69
      },
      "4": {
        loc: {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        }, {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        }],
        line: 93
      },
      "5": {
        loc: {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 122,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 122,
            column: 25
          }
        }, {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 122,
            column: 25
          }
        }],
        line: 121
      },
      "6": {
        loc: {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 126,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 126,
            column: 9
          }
        }, {
          start: {
            line: 123,
            column: 8
          },
          end: {
            line: 126,
            column: 9
          }
        }],
        line: 123
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drag-size.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/drag-size.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,qEAAuD;AACvD,gDAA6C;AAC7C,4CAAwC;AAExC;;;;;;;GAOG;AACH,SAAS,YAAY,CAAC,KAAiB,EAAE,KAAa,EAAE,MAAc,EAAE,IAAY,EAAE,GAAW;IAC7F,KAAK,CAAC,IAAI,CAAC,OAAO,EAAE,WAAS,KAAK,mBAAc,MAAM,iBAAY,IAAI,gBAAW,GAAG,QAAK,CAAC,CAAA;AAC9F,CAAC;AAED;;;;GAIG;AACH,SAAS,aAAa,CAAC,MAAc,EAAE,kBAA8B;IACjE,IAAM,KAAK,GAAG,kBAAC,CACX,iKAGQ,CACX,CAAA;IAED,KAAK,CAAC,IAAI,EAAE,CAAA;IACZ,kBAAkB,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;IAChC,OAAO,KAAK,CAAA;AAChB,CAAC;AAED;;;;GAIG;AACH,SAAS,WAAW,CAAC,kBAA8B,EAAE,KAAiB,EAAE,IAAgB;IACpF,IAAM,OAAO,GAAG,kBAAkB,CAAC,qBAAqB,EAAE,CAAA;IAC1D,IAAM,IAAI,GAAG,IAAI,CAAC,qBAAqB,EAAE,CAAA;IACzC,IAAM,KAAK,GAAG,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,CAAC,CAAC,CAAA;IACnC,IAAM,KAAK,GAAG,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,CAAA;IACpC,KAAK,CAAC,IAAI,CAAC,yBAAyB,CAAC,CAAC,IAAI,CAAI,KAAK,aAAQ,KAAK,OAAI,CAAC,CAAA;IACrE,YAAY,CACR,KAAK,EACL,UAAU,CAAC,KAAK,CAAC,EACjB,UAAU,CAAC,KAAK,CAAC,EACjB,IAAI,CAAC,IAAI,GAAG,OAAO,CAAC,IAAI,EACxB,IAAI,CAAC,GAAG,GAAG,OAAO,CAAC,GAAG,CACzB,CAAA;IACD,KAAK,CAAC,IAAI,EAAE,CAAA;AAChB,CAAC;AAED;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAM,kBAAkB,GAAG,MAAM,CAAC,kBAAkB,CAAA;IACpD,IAAI,UAAsB,CAAA;IAE1B,QAAQ;IACR,IAAM,KAAK,GAAG,aAAa,CAAC,MAAM,EAAE,kBAAkB,CAAC,CAAA;IAEvD;;;;OAIG;IACH,SAAS,cAAc,CAAC,KAAiB,EAAE,UAAsB;QAC7D,KAAK,CAAC,EAAE,CAAC,OAAO,EAAE,UAAU,CAAQ;YAChC,CAAC,CAAC,eAAe,EAAE,CAAA;QACvB,CAAC,CAAC,CAAA;QACF,KAAK,CAAC,EAAE,CAAC,WAAW,EAAE,kBAAkB,EAAE,UAAC,CAAa;YACpD,sBAAsB;YACtB,CAAC,CAAC,cAAc,EAAE,CAAA;YAElB,IAAI,CAAC,UAAU;gBAAE,OAAM;YAEvB,IAAM,MAAM,GAAG,CAAC,CAAC,OAAO,CAAA;YACxB,IAAM,MAAM,GAAG,CAAC,CAAC,OAAO,CAAA;YACxB,IAAM,OAAO,GAAG,UAAU,CAAC,qBAAqB,EAAE,CAAA;YAClD,IAAM,OAAO,GAAG,UAAU,CAAC,qBAAqB,EAAE,CAAA;YAClD,IAAM,KAAK,GAAG,OAAO,CAAC,KAAK,CAAA;YAC3B,IAAM,MAAM,GAAG,OAAO,CAAC,MAAM,CAAA;YAC7B,IAAM,IAAI,GAAG,OAAO,CAAC,IAAI,GAAG,OAAO,CAAC,IAAI,CAAA;YACxC,IAAM,GAAG,GAAG,OAAO,CAAC,GAAG,GAAG,OAAO,CAAC,GAAG,CAAA;YACrC,IAAM,KAAK,GAAG,KAAK,GAAG,MAAM,CAAA;YAE5B,IAAI,IAAI,GAAG,KAAK,CAAA;YAChB,IAAI,IAAI,GAAG,MAAM,CAAA;YACjB,IAAM,SAAS,GAAG,kBAAC,CAAC,QAAQ,CAAC,CAAA;YAE7B,SAAS,SAAS;gBACd,SAAS,CAAC,GAAG,CAAC,WAAW,EAAE,gBAAgB,CAAC,CAAA;gBAC5C,SAAS,CAAC,GAAG,CAAC,SAAS,EAAE,cAAc,CAAC,CAAA;YAC5C,CAAC;YAED,SAAS,gBAAgB,CAAC,EAAc;gBACpC,EAAE,CAAC,eAAe,EAAE,CAAA;gBACpB,EAAE,CAAC,cAAc,EAAE,CAAA;gBAEnB,IAAI,GAAG,KAAK,GAAG,CAAC,EAAE,CAAC,OAAO,GAAG,MAAM,CAAC,CAAA;gBACpC,IAAI,GAAG,MAAM,GAAG,CAAC,EAAE,CAAC,OAAO,GAAG,MAAM,CAAC,CAAA;gBAErC,OAAO;gBACP,IAAI,IAAI,GAAG,IAAI,IAAI,KAAK,EAAE;oBACtB,IAAI,GAAG,IAAI,GAAG,KAAK,CAAA;iBACtB;gBAED,IAAI,GAAG,UAAU,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,CAAA;gBAClC,IAAI,GAAG,UAAU,CAAC,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,CAAA;gBAElC,KAAK;qBACA,IAAI,CAAC,yBAAyB,CAAC;qBAC/B,IAAI,CACE,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,OAAO,CAAC,KAAK,EAAE,EAAE,CAAC,aAAQ,IAAI;qBAC5C,OAAO,CAAC,CAAC,CAAC;qBACV,OAAO,CAAC,KAAK,EAAE,EAAE,CAAC,OAAI,CAC9B,CAAA;gBACL,YAAY,CAAC,KAAK,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,GAAG,CAAC,CAAA;YAC9C,CAAC;YACD,SAAS,CAAC,EAAE,CAAC,WAAW,EAAE,gBAAgB,CAAC,CAAA;YAE3C,SAAS,cAAc;gBACnB,UAAU,CAAC,IAAI,CAAC,OAAO,EAAE,IAAI,GAAG,EAAE,CAAC,CAAA;gBACnC,UAAU,CAAC,IAAI,CAAC,QAAQ,EAAE,IAAI,GAAG,EAAE,CAAC,CAAA;gBACpC,IAAM,UAAU,GAAG,UAAU,CAAC,qBAAqB,EAAE,CAAA;gBACrD,YAAY,CACR,KAAK,EACL,IAAI,EACJ,IAAI,EACJ,UAAU,CAAC,IAAI,GAAG,OAAO,CAAC,IAAI,EAC9B,UAAU,CAAC,GAAG,GAAG,OAAO,CAAC,GAAG,CAC/B,CAAA;gBAED,OAAO;gBACP,SAAS,EAAE,CAAA;YACf,CAAC;YACD,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,cAAc,CAAC,CAAA;YAEvC,OAAO;YACP,SAAS,CAAC,EAAE,CAAC,YAAY,EAAE,SAAS,CAAC,CAAA;QACzC,CAAC,CAAC,CAAA;IACN,CAAC;IAED,QAAQ;IACR,SAAS,QAAQ,CAAC,OAAmB;QACjC,IAAI,SAAE,CAAC,IAAI,EAAE;YAAE,OAAO,KAAK,CAAA;QAC3B,IAAI,OAAO,EAAE;YACT,UAAU,GAAG,OAAO,CAAA;YACpB,WAAW,CAAC,kBAAkB,EAAE,KAAK,EAAE,UAAU,CAAC,CAAA;SACrD;IACL,CAAC;IAED,QAAQ;IACR,SAAS,QAAQ;QACb,kBAAkB,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAC,IAAI,EAAE,CAAA;IACxD,CAAC;IAED,OAAO;IACP,cAAc,CAAC,KAAK,EAAE,kBAAkB,CAAC,CAAA;IAEzC,eAAe;IACf,kBAAC,CAAC,QAAQ,CAAC,CAAC,EAAE,CAAC,OAAO,EAAE,QAAQ,CAAC,CAAA;IACjC,MAAM,CAAC,aAAa,CAAC;QACjB,kBAAC,CAAC,QAAQ,CAAC,CAAC,GAAG,CAAC,OAAO,EAAE,QAAQ,CAAC,CAAA;IACtC,CAAC,CAAC,CAAA;IAEF,OAAO;QACH,QAAQ,UAAA;QACR,QAAQ,UAAA;KACX,CAAA;AACL,CAAC;AACD;;;GAGG;AACH,SAAwB,eAAe,CAAC,MAAc;IAC5C,IAAA,KAAyB,gBAAgB,CAAC,MAAM,CAAC,EAA/C,QAAQ,cAAA,EAAE,QAAQ,cAA6B,CAAA;IAEvD,QAAQ;IACR,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,cAAc,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IAEnD,QAAQ;IACR,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IACrD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IAChD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IACvD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;IACpD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;AACrD,CAAC;AAZD,kCAYC",
      sourcesContent: ["/**\n * @description \u56FE\u7247\u62D6\u62FD\u4E8B\u4EF6\u7ED1\u5B9A\n * @author xiaokyo\n */\n\nimport Editor from '../../../editor'\nimport $, { DomElement } from '../../../utils/dom-core'\nimport '../../../assets/style/drag-size.less'\nimport { UA } from '../../../utils/util'\n\n/**\n * \u8BBE\u7F6E\u62D6\u62FD\u6846\u7684rect\n * @param $drag drag Dom\n * @param width \u8981\u8BBE\u7F6E\u7684\u5BBD\u5EA6\n * @param height \u8981\u8BBE\u7F6E\u7684\u9AD8\u5EA6\n * @param left \u8981\u8BBE\u7F6E\u7684\u5DE6\u8FB9\n * @param top \u8981\u8BBE\u7F6E\u7684\u9876\u90E8\u8DDD\u79BB\n */\nfunction setDragStyle($drag: DomElement, width: number, height: number, left: number, top: number) {\n    $drag.attr('style', `width:${width}px; height:${height}px; left:${left}px; top:${top}px;`)\n}\n\n/**\n * \u751F\u6210\u4E00\u4E2A\u56FE\u7247\u6307\u5B9A\u5927\u5C0F\u7684\u62D6\u62FD\u6846\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param $textContainerElem \u7F16\u8F91\u6846\u5BF9\u8C61\n */\nfunction createDragBox(editor: Editor, $textContainerElem: DomElement): DomElement {\n    const $drag = $(\n        `<div class=\"w-e-img-drag-mask\">\n            <div class=\"w-e-img-drag-show-size\"></div>\n            <div class=\"w-e-img-drag-rb\"></div>\n         </div>`\n    )\n\n    $drag.hide()\n    $textContainerElem.append($drag)\n    return $drag\n}\n\n/**\n * \u663E\u793A\u62D6\u62FD\u6846\u5E76\u8BBE\u7F6E\u5BBD\u5EA6\n * @param $textContainerElem \u7F16\u8F91\u6846\u5B9E\u4F8B\n * @param $drag \u62D6\u62FD\u6846\u5BF9\u8C61\n */\nfunction showDargBox($textContainerElem: DomElement, $drag: DomElement, $img: DomElement) {\n    const boxRect = $textContainerElem.getBoundingClientRect()\n    const rect = $img.getBoundingClientRect()\n    const rectW = rect.width.toFixed(2)\n    const rectH = rect.height.toFixed(2)\n    $drag.find('.w-e-img-drag-show-size').text(`${rectW}px * ${rectH}px`)\n    setDragStyle(\n        $drag,\n        parseFloat(rectW),\n        parseFloat(rectH),\n        rect.left - boxRect.left,\n        rect.top - boxRect.top\n    )\n    $drag.show()\n}\n\n/**\n * \u751F\u6210\u56FE\u7247\u62D6\u62FD\u6846\u7684 \u663E\u793A/\u9690\u85CF \u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    const $textContainerElem = editor.$textContainerElem\n    let $imgTarget: DomElement\n\n    // \u751F\u6210\u62D6\u62FD\u6846\n    const $drag = createDragBox(editor, $textContainerElem)\n\n    /**\n     * \u8BBE\u7F6E\u62D6\u62FD\u4E8B\u4EF6\n     * @param $drag \u62D6\u62FD\u6846\u7684domElement\n     * @param $textContainerElem \u7F16\u8F91\u5668\u5B9E\u4F8B\n     */\n    function bindDragEvents($drag: DomElement, $container: DomElement) {\n        $drag.on('click', function (e: Event) {\n            e.stopPropagation()\n        })\n        $drag.on('mousedown', '.w-e-img-drag-rb', (e: MouseEvent) => {\n            // e.stopPropagation()\n            e.preventDefault()\n\n            if (!$imgTarget) return\n\n            const firstX = e.clientX\n            const firstY = e.clientY\n            const boxRect = $container.getBoundingClientRect()\n            const imgRect = $imgTarget.getBoundingClientRect()\n            const width = imgRect.width\n            const height = imgRect.height\n            const left = imgRect.left - boxRect.left\n            const top = imgRect.top - boxRect.top\n            const ratio = width / height\n\n            let setW = width\n            let setH = height\n            const $document = $(document)\n\n            function offEvents() {\n                $document.off('mousemove', mouseMoveHandler)\n                $document.off('mouseup', mouseUpHandler)\n            }\n\n            function mouseMoveHandler(ev: MouseEvent) {\n                ev.stopPropagation()\n                ev.preventDefault()\n\n                setW = width + (ev.clientX - firstX)\n                setH = height + (ev.clientY - firstY)\n\n                // \u7B49\u6BD4\u8BA1\u7B97\n                if (setW / setH != ratio) {\n                    setH = setW / ratio\n                }\n\n                setW = parseFloat(setW.toFixed(2))\n                setH = parseFloat(setH.toFixed(2))\n\n                $drag\n                    .find('.w-e-img-drag-show-size')\n                    .text(\n                        `${setW.toFixed(2).replace('.00', '')}px * ${setH\n                            .toFixed(2)\n                            .replace('.00', '')}px`\n                    )\n                setDragStyle($drag, setW, setH, left, top)\n            }\n            $document.on('mousemove', mouseMoveHandler)\n\n            function mouseUpHandler() {\n                $imgTarget.attr('width', setW + '')\n                $imgTarget.attr('height', setH + '')\n                const newImgRect = $imgTarget.getBoundingClientRect()\n                setDragStyle(\n                    $drag,\n                    setW,\n                    setH,\n                    newImgRect.left - boxRect.left,\n                    newImgRect.top - boxRect.top\n                )\n\n                // \u89E3\u7ED1\u4E8B\u4EF6\n                offEvents()\n            }\n            $document.on('mouseup', mouseUpHandler)\n\n            // \u89E3\u7ED1\u4E8B\u4EF6\n            $document.on('mouseleave', offEvents)\n        })\n    }\n\n    // \u663E\u793A\u62D6\u62FD\u6846\n    function showDrag($target: DomElement) {\n        if (UA.isIE()) return false\n        if ($target) {\n            $imgTarget = $target\n            showDargBox($textContainerElem, $drag, $imgTarget)\n        }\n    }\n\n    // \u9690\u85CF\u62D6\u62FD\u6846\n    function hideDrag() {\n        $textContainerElem.find('.w-e-img-drag-mask').hide()\n    }\n\n    // \u4E8B\u4EF6\u7ED1\u5B9A\n    bindDragEvents($drag, $textContainerElem)\n\n    // \u540E\u671F\u6539\u6210 blur \u89E6\u53D1\n    $(document).on('click', hideDrag)\n    editor.beforeDestroy(function () {\n        $(document).off('click', hideDrag)\n    })\n\n    return {\n        showDrag,\n        hideDrag,\n    }\n}\n/**\n * \u70B9\u51FB\u4E8B\u4EF6\u59D4\u6258\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport default function bindDragImgSize(editor: Editor) {\n    const { showDrag, hideDrag } = createShowHideFn(editor)\n\n    // \u663E\u793A\u62D6\u62FD\u6846\n    editor.txt.eventHooks.imgClickEvents.push(showDrag)\n\n    // \u9690\u85CF\u62D6\u62FD\u6846\n    editor.txt.eventHooks.textScrollEvents.push(hideDrag)\n    editor.txt.eventHooks.keyupEvents.push(hideDrag)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideDrag)\n    editor.txt.eventHooks.menuClickEvents.push(hideDrag)\n    editor.txt.eventHooks.changeEvents.push(hideDrag)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0d4ebc38fff9b61079b7d4caa833157dbc366455"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_sia4oz5gp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_sia4oz5gp();

var __importDefault = (cov_sia4oz5gp().s[0]++, (cov_sia4oz5gp().b[0][0]++, void 0) && (cov_sia4oz5gp().b[0][1]++, (void 0).__importDefault) || (cov_sia4oz5gp().b[0][2]++, function (mod) {
  cov_sia4oz5gp().f[0]++;
  cov_sia4oz5gp().s[1]++;
  return (cov_sia4oz5gp().b[2][0]++, mod) && (cov_sia4oz5gp().b[2][1]++, mod.__esModule) ? (cov_sia4oz5gp().b[1][0]++, mod) : (cov_sia4oz5gp().b[1][1]++, {
    "default": mod
  });
}));

cov_sia4oz5gp().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_sia4oz5gp().s[3]++, __importDefault(__webpack_require__(2)));
cov_sia4oz5gp().s[4]++;

__webpack_require__(346);

var util_1 = (cov_sia4oz5gp().s[5]++, __webpack_require__(7));
/**
 * 设置拖拽框的rect
 * @param $drag drag Dom
 * @param width 要设置的宽度
 * @param height 要设置的高度
 * @param left 要设置的左边
 * @param top 要设置的顶部距离
 */

function setDragStyle($drag, width, height, left, top) {
  cov_sia4oz5gp().f[1]++;
  cov_sia4oz5gp().s[6]++;
  $drag.attr('style', "width:" + width + "px; height:" + height + "px; left:" + left + "px; top:" + top + "px;");
}
/**
 * 生成一个图片指定大小的拖拽框
 * @param editor 编辑器实例
 * @param $textContainerElem 编辑框对象
 */


function createDragBox(editor, $textContainerElem) {
  cov_sia4oz5gp().f[2]++;
  var $drag = (cov_sia4oz5gp().s[7]++, dom_core_1["default"]("<div class=\"w-e-img-drag-mask\">\n            <div class=\"w-e-img-drag-show-size\"></div>\n            <div class=\"w-e-img-drag-rb\"></div>\n         </div>"));
  cov_sia4oz5gp().s[8]++;
  $drag.hide();
  cov_sia4oz5gp().s[9]++;
  $textContainerElem.append($drag);
  cov_sia4oz5gp().s[10]++;
  return $drag;
}
/**
 * 显示拖拽框并设置宽度
 * @param $textContainerElem 编辑框实例
 * @param $drag 拖拽框对象
 */


function showDargBox($textContainerElem, $drag, $img) {
  cov_sia4oz5gp().f[3]++;
  var boxRect = (cov_sia4oz5gp().s[11]++, $textContainerElem.getBoundingClientRect());
  var rect = (cov_sia4oz5gp().s[12]++, $img.getBoundingClientRect());
  var rectW = (cov_sia4oz5gp().s[13]++, rect.width.toFixed(2));
  var rectH = (cov_sia4oz5gp().s[14]++, rect.height.toFixed(2));
  cov_sia4oz5gp().s[15]++;
  (0, _find["default"])($drag).call($drag, '.w-e-img-drag-show-size').text(rectW + "px * " + rectH + "px");
  cov_sia4oz5gp().s[16]++;
  setDragStyle($drag, (0, _parseFloat2["default"])(rectW), (0, _parseFloat2["default"])(rectH), rect.left - boxRect.left, rect.top - boxRect.top);
  cov_sia4oz5gp().s[17]++;
  $drag.show();
}
/**
 * 生成图片拖拽框的 显示/隐藏 函数
 */


function createShowHideFn(editor) {
  cov_sia4oz5gp().f[4]++;
  var $textContainerElem = (cov_sia4oz5gp().s[18]++, editor.$textContainerElem);
  var $imgTarget; // 生成拖拽框

  var $drag = (cov_sia4oz5gp().s[19]++, createDragBox(editor, $textContainerElem));
  /**
   * 设置拖拽事件
   * @param $drag 拖拽框的domElement
   * @param $textContainerElem 编辑器实例
   */

  function bindDragEvents($drag, $container) {
    cov_sia4oz5gp().f[5]++;
    cov_sia4oz5gp().s[20]++;
    $drag.on('click', function (e) {
      cov_sia4oz5gp().f[6]++;
      cov_sia4oz5gp().s[21]++;
      e.stopPropagation();
    });
    cov_sia4oz5gp().s[22]++;
    $drag.on('mousedown', '.w-e-img-drag-rb', function (e) {
      cov_sia4oz5gp().f[7]++;
      cov_sia4oz5gp().s[23]++;
      // e.stopPropagation()
      e.preventDefault();
      cov_sia4oz5gp().s[24]++;

      if (!$imgTarget) {
        cov_sia4oz5gp().b[3][0]++;
        cov_sia4oz5gp().s[25]++;
        return;
      } else {
        cov_sia4oz5gp().b[3][1]++;
      }

      var firstX = (cov_sia4oz5gp().s[26]++, e.clientX);
      var firstY = (cov_sia4oz5gp().s[27]++, e.clientY);
      var boxRect = (cov_sia4oz5gp().s[28]++, $container.getBoundingClientRect());
      var imgRect = (cov_sia4oz5gp().s[29]++, $imgTarget.getBoundingClientRect());
      var width = (cov_sia4oz5gp().s[30]++, imgRect.width);
      var height = (cov_sia4oz5gp().s[31]++, imgRect.height);
      var left = (cov_sia4oz5gp().s[32]++, imgRect.left - boxRect.left);
      var top = (cov_sia4oz5gp().s[33]++, imgRect.top - boxRect.top);
      var ratio = (cov_sia4oz5gp().s[34]++, width / height);
      var setW = (cov_sia4oz5gp().s[35]++, width);
      var setH = (cov_sia4oz5gp().s[36]++, height);
      var $document = (cov_sia4oz5gp().s[37]++, dom_core_1["default"](document));

      function offEvents() {
        cov_sia4oz5gp().f[8]++;
        cov_sia4oz5gp().s[38]++;
        $document.off('mousemove', mouseMoveHandler);
        cov_sia4oz5gp().s[39]++;
        $document.off('mouseup', mouseUpHandler);
      }

      function mouseMoveHandler(ev) {
        cov_sia4oz5gp().f[9]++;
        cov_sia4oz5gp().s[40]++;
        ev.stopPropagation();
        cov_sia4oz5gp().s[41]++;
        ev.preventDefault();
        cov_sia4oz5gp().s[42]++;
        setW = width + (ev.clientX - firstX);
        cov_sia4oz5gp().s[43]++;
        setH = height + (ev.clientY - firstY); // 等比计算

        cov_sia4oz5gp().s[44]++;

        if (setW / setH != ratio) {
          cov_sia4oz5gp().b[4][0]++;
          cov_sia4oz5gp().s[45]++;
          setH = setW / ratio;
        } else {
          cov_sia4oz5gp().b[4][1]++;
        }

        cov_sia4oz5gp().s[46]++;
        setW = (0, _parseFloat2["default"])(setW.toFixed(2));
        cov_sia4oz5gp().s[47]++;
        setH = (0, _parseFloat2["default"])(setH.toFixed(2));
        cov_sia4oz5gp().s[48]++;
        (0, _find["default"])($drag).call($drag, '.w-e-img-drag-show-size').text(setW.toFixed(2).replace('.00', '') + "px * " + setH.toFixed(2).replace('.00', '') + "px");
        cov_sia4oz5gp().s[49]++;
        setDragStyle($drag, setW, setH, left, top);
      }

      cov_sia4oz5gp().s[50]++;
      $document.on('mousemove', mouseMoveHandler);

      function mouseUpHandler() {
        cov_sia4oz5gp().f[10]++;
        cov_sia4oz5gp().s[51]++;
        $imgTarget.attr('width', setW + '');
        cov_sia4oz5gp().s[52]++;
        $imgTarget.attr('height', setH + '');
        var newImgRect = (cov_sia4oz5gp().s[53]++, $imgTarget.getBoundingClientRect());
        cov_sia4oz5gp().s[54]++;
        setDragStyle($drag, setW, setH, newImgRect.left - boxRect.left, newImgRect.top - boxRect.top); // 解绑事件

        cov_sia4oz5gp().s[55]++;
        offEvents();
      }

      cov_sia4oz5gp().s[56]++;
      $document.on('mouseup', mouseUpHandler); // 解绑事件

      cov_sia4oz5gp().s[57]++;
      $document.on('mouseleave', offEvents);
    });
  } // 显示拖拽框


  function showDrag($target) {
    cov_sia4oz5gp().f[11]++;
    cov_sia4oz5gp().s[58]++;

    if (util_1.UA.isIE()) {
      cov_sia4oz5gp().b[5][0]++;
      cov_sia4oz5gp().s[59]++;
      return false;
    } else {
      cov_sia4oz5gp().b[5][1]++;
    }

    cov_sia4oz5gp().s[60]++;

    if ($target) {
      cov_sia4oz5gp().b[6][0]++;
      cov_sia4oz5gp().s[61]++;
      $imgTarget = $target;
      cov_sia4oz5gp().s[62]++;
      showDargBox($textContainerElem, $drag, $imgTarget);
    } else {
      cov_sia4oz5gp().b[6][1]++;
    }
  } // 隐藏拖拽框


  function hideDrag() {
    cov_sia4oz5gp().f[12]++;
    cov_sia4oz5gp().s[63]++;
    (0, _find["default"])($textContainerElem).call($textContainerElem, '.w-e-img-drag-mask').hide();
  } // 事件绑定


  cov_sia4oz5gp().s[64]++;
  bindDragEvents($drag, $textContainerElem); // 后期改成 blur 触发

  cov_sia4oz5gp().s[65]++;
  dom_core_1["default"](document).on('click', hideDrag);
  cov_sia4oz5gp().s[66]++;
  editor.beforeDestroy(function () {
    cov_sia4oz5gp().f[13]++;
    cov_sia4oz5gp().s[67]++;
    dom_core_1["default"](document).off('click', hideDrag);
  });
  cov_sia4oz5gp().s[68]++;
  return {
    showDrag: showDrag,
    hideDrag: hideDrag
  };
}
/**
 * 点击事件委托
 * @param editor 编辑器实例
 */


function bindDragImgSize(editor) {
  cov_sia4oz5gp().f[14]++;

  var _a = (cov_sia4oz5gp().s[69]++, createShowHideFn(editor)),
      showDrag = (cov_sia4oz5gp().s[70]++, _a.showDrag),
      hideDrag = (cov_sia4oz5gp().s[71]++, _a.hideDrag); // 显示拖拽框


  cov_sia4oz5gp().s[72]++;
  editor.txt.eventHooks.imgClickEvents.push(showDrag); // 隐藏拖拽框

  cov_sia4oz5gp().s[73]++;
  editor.txt.eventHooks.textScrollEvents.push(hideDrag);
  cov_sia4oz5gp().s[74]++;
  editor.txt.eventHooks.keyupEvents.push(hideDrag);
  cov_sia4oz5gp().s[75]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideDrag);
  cov_sia4oz5gp().s[76]++;
  editor.txt.eventHooks.menuClickEvents.push(hideDrag);
  cov_sia4oz5gp().s[77]++;
  editor.txt.eventHooks.changeEvents.push(hideDrag);
}

cov_sia4oz5gp().s[78]++;
exports["default"] = bindDragImgSize;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(342);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(343);

module.exports = parent;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
var path = __webpack_require__(10);

module.exports = path.parseFloat;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var parseFloatImplementation = __webpack_require__(345);

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != parseFloatImplementation }, {
  parseFloat: parseFloatImplementation
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var trim = __webpack_require__(90).trim;
var whitespaces = __webpack_require__(65);

var $parseFloat = global.parseFloat;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity;

// `parseFloat` method
// https://tc39.github.io/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(String(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(347);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-text-container {\n  overflow: hidden;\n}\n.w-e-img-drag-mask {\n  position: absolute;\n  z-index: 1;\n  border: 1px dashed #ccc;\n  box-sizing: border-box;\n}\n.w-e-img-drag-mask .w-e-img-drag-rb {\n  position: absolute;\n  right: -5px;\n  bottom: -5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #ccc;\n  cursor: se-resize;\n}\n.w-e-img-drag-mask .w-e-img-drag-show-size {\n  min-width: 110px;\n  height: 22px;\n  line-height: 22px;\n  font-size: 14px;\n  color: #999;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #999;\n  color: #fff;\n  border-radius: 2px;\n  padding: 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description tooltip 事件
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2p68u6ffw() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/tooltip-event.ts";
  var hash = "a7f890fb2f0d66d435ab111e1c2a8f6a9c5e894b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/tooltip-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 75
        }
      },
      "5": {
        start: {
          line: 22,
          column: 19
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "6": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 62
        }
      },
      "7": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 56
        }
      },
      "8": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 44
        }
      },
      "9": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 32
        }
      },
      "10": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 37,
          column: 47
        }
      },
      "11": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 47
        }
      },
      "12": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "13": {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 46,
          column: 47
        }
      },
      "14": {
        start: {
          line: 47,
          column: 20
        },
        end: {
          line: 47,
          column: 47
        }
      },
      "15": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 49,
          column: 32
        }
      },
      "16": {
        start: {
          line: 55,
          column: 20
        },
        end: {
          line: 55,
          column: 48
        }
      },
      "17": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 47
        }
      },
      "18": {
        start: {
          line: 58,
          column: 20
        },
        end: {
          line: 58,
          column: 32
        }
      },
      "19": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 61
        }
      },
      "20": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 25
        }
      },
      "21": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 73,
          column: 9
        }
      },
      "22": {
        start: {
          line: 71,
          column: 12
        },
        end: {
          line: 71,
          column: 29
        }
      },
      "23": {
        start: {
          line: 72,
          column: 12
        },
        end: {
          line: 72,
          column: 27
        }
      },
      "24": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 6
        }
      },
      "25": {
        start: {
          line: 85,
          column: 13
        },
        end: {
          line: 85,
          column: 37
        }
      },
      "26": {
        start: {
          line: 85,
          column: 56
        },
        end: {
          line: 85,
          column: 73
        }
      },
      "27": {
        start: {
          line: 85,
          column: 92
        },
        end: {
          line: 85,
          column: 109
        }
      },
      "28": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 62
        }
      },
      "29": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 59
        }
      },
      "30": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 59
        }
      },
      "31": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 66
        }
      },
      "32": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 63
        }
      },
      "33": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 64
        }
      },
      "34": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 73
        }
      },
      "35": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 60
        }
      },
      "36": {
        start: {
          line: 98,
          column: 0
        },
        end: {
          line: 98,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 25
          }
        },
        loc: {
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "showImgTooltip",
        decl: {
          start: {
            line: 21,
            column: 13
          },
          end: {
            line: 21,
            column: 27
          }
        },
        loc: {
          start: {
            line: 21,
            column: 35
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 25
          },
          end: {
            line: 25,
            column: 26
          }
        },
        loc: {
          start: {
            line: 25,
            column: 50
          },
          end: {
            line: 32,
            column: 17
          }
        },
        line: 25
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 25
          },
          end: {
            line: 36,
            column: 26
          }
        },
        loc: {
          start: {
            line: 36,
            column: 50
          },
          end: {
            line: 41,
            column: 17
          }
        },
        line: 36
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 45,
            column: 25
          },
          end: {
            line: 45,
            column: 26
          }
        },
        loc: {
          start: {
            line: 45,
            column: 50
          },
          end: {
            line: 50,
            column: 17
          }
        },
        line: 45
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 54,
            column: 25
          },
          end: {
            line: 54,
            column: 26
          }
        },
        loc: {
          start: {
            line: 54,
            column: 50
          },
          end: {
            line: 59,
            column: 17
          }
        },
        line: 54
      },
      "7": {
        name: "hideImgTooltip",
        decl: {
          start: {
            line: 68,
            column: 13
          },
          end: {
            line: 68,
            column: 27
          }
        },
        loc: {
          start: {
            line: 68,
            column: 30
          },
          end: {
            line: 74,
            column: 5
          }
        },
        line: 68
      },
      "8": {
        name: "bindTooltipEvent",
        decl: {
          start: {
            line: 84,
            column: 9
          },
          end: {
            line: 84,
            column: 25
          }
        },
        loc: {
          start: {
            line: 84,
            column: 34
          },
          end: {
            line: 97,
            column: 1
          }
        },
        line: 84
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }],
        line: 70
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/tooltip-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/img/bind-event/tooltip-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,qEAAuD;AACvD,4EAA0E;AAG1E;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAI,OAAuB,CAAA;IAE3B;;;OAGG;IACH,SAAS,cAAc,CAAC,KAAiB;QACrC,IAAM,IAAI,GAAoB;YAC1B;gBACI,KAAK,EAAE,kBAAC,CAAC,wCAAwC,CAAC;gBAClD,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBACnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,QAAQ,CAAC,CAAA;oBACvB,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,kBAAkB,CAAC;gBAC5B,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,KAAK,CAAC,IAAI,CAAC,OAAO,EAAE,KAAK,CAAC,CAAA;oBAC1B,KAAK,CAAC,UAAU,CAAC,QAAQ,CAAC,CAAA;oBAE1B,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,kBAAkB,CAAC;gBAC5B,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,KAAK,CAAC,IAAI,CAAC,OAAO,EAAE,KAAK,CAAC,CAAA;oBAC1B,KAAK,CAAC,UAAU,CAAC,QAAQ,CAAC,CAAA;oBAE1B,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,mBAAmB,CAAC;gBAC7B,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,KAAK,CAAC,IAAI,CAAC,OAAO,EAAE,MAAM,CAAC,CAAA;oBAC3B,KAAK,CAAC,UAAU,CAAC,QAAQ,CAAC,CAAA;oBAE1B,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;SACJ,CAAA;QAED,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,EAAE,KAAK,EAAE,IAAI,CAAC,CAAA;QAC1C,OAAO,CAAC,MAAM,EAAE,CAAA;IACpB,CAAC;IAED;;OAEG;IACH,SAAS,cAAc;QACnB,aAAa;QACb,IAAI,OAAO,EAAE;YACT,OAAO,CAAC,MAAM,EAAE,CAAA;YAChB,OAAO,GAAG,IAAI,CAAA;SACjB;IACL,CAAC;IAED,OAAO;QACH,cAAc,gBAAA;QACd,cAAc,gBAAA;KACjB,CAAA;AACL,CAAC;AAED;;;GAGG;AACH,SAAwB,gBAAgB,CAAC,MAAc;IAC7C,IAAA,KAAqC,gBAAgB,CAAC,MAAM,CAAC,EAA3D,cAAc,oBAAA,EAAE,cAAc,oBAA6B,CAAA;IAEnE,qBAAqB;IACrB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,cAAc,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IAEzD,0BAA0B;IAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IACtD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IACtD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IAC7D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IAC1D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IAC3D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,yBAAyB,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;IAEpE,aAAa;IACb,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,IAAI,CAAC,cAAc,CAAC,CAAA;AAC3D,CAAC;AAhBD,mCAgBC",
      sourcesContent: ["/**\n * @description tooltip \u4E8B\u4EF6\n * @author lichunlin\n */\n\nimport $, { DomElement } from '../../../utils/dom-core'\nimport Tooltip, { TooltipConfType } from '../../menu-constructors/Tooltip'\nimport Editor from '../../../editor/index'\n\n/**\n * \u751F\u6210 Tooltip \u7684\u663E\u793A\u9690\u85CF\u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    let tooltip: Tooltip | null\n\n    /**\n     * \u663E\u793A tooltip\n     * @param $node \u94FE\u63A5\u5143\u7D20\n     */\n    function showImgTooltip($node: DomElement) {\n        const conf: TooltipConfType = [\n            {\n                $elem: $(\"<span class='w-e-icon-trash-o'></span>\"),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u9009\u4E2Dimg\u5143\u7D20\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n                    editor.cmd.do('delete')\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n            {\n                $elem: $('<span>30%</span>'),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    $node.attr('width', '30%')\n                    $node.removeAttr('height')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n            {\n                $elem: $('<span>50%</span>'),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    $node.attr('width', '50%')\n                    $node.removeAttr('height')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n            {\n                $elem: $('<span>100%</span>'),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    $node.attr('width', '100%')\n                    $node.removeAttr('height')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n        ]\n\n        tooltip = new Tooltip(editor, $node, conf)\n        tooltip.create()\n    }\n\n    /**\n     * \u9690\u85CF tooltip\n     */\n    function hideImgTooltip() {\n        // \u79FB\u9664 tooltip\n        if (tooltip) {\n            tooltip.remove()\n            tooltip = null\n        }\n    }\n\n    return {\n        showImgTooltip,\n        hideImgTooltip,\n    }\n}\n\n/**\n * \u7ED1\u5B9A tooltip \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport default function bindTooltipEvent(editor: Editor) {\n    const { showImgTooltip, hideImgTooltip } = createShowHideFn(editor)\n\n    // \u70B9\u51FB\u56FE\u7247\u5143\u7D20\u662F\uFF0C\u663E\u793A tooltip\n    editor.txt.eventHooks.imgClickEvents.push(showImgTooltip)\n\n    // \u70B9\u51FB\u5176\u4ED6\u5730\u65B9\uFF0C\u6216\u8005\u6EDA\u52A8\u65F6\uFF0C\u9690\u85CF tooltip\n    editor.txt.eventHooks.clickEvents.push(hideImgTooltip)\n    editor.txt.eventHooks.keyupEvents.push(hideImgTooltip)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideImgTooltip)\n    editor.txt.eventHooks.menuClickEvents.push(hideImgTooltip)\n    editor.txt.eventHooks.textScrollEvents.push(hideImgTooltip)\n    editor.txt.eventHooks.imgDragBarMouseDownEvents.push(hideImgTooltip)\n\n    // change \u65F6\u9690\u85CF\n    editor.txt.eventHooks.changeEvents.push(hideImgTooltip)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a7f890fb2f0d66d435ab111e1c2a8f6a9c5e894b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2p68u6ffw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2p68u6ffw();

var __importDefault = (cov_2p68u6ffw().s[0]++, (cov_2p68u6ffw().b[0][0]++, void 0) && (cov_2p68u6ffw().b[0][1]++, (void 0).__importDefault) || (cov_2p68u6ffw().b[0][2]++, function (mod) {
  cov_2p68u6ffw().f[0]++;
  cov_2p68u6ffw().s[1]++;
  return (cov_2p68u6ffw().b[2][0]++, mod) && (cov_2p68u6ffw().b[2][1]++, mod.__esModule) ? (cov_2p68u6ffw().b[1][0]++, mod) : (cov_2p68u6ffw().b[1][1]++, {
    "default": mod
  });
}));

cov_2p68u6ffw().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_2p68u6ffw().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip_1 = (cov_2p68u6ffw().s[4]++, __importDefault(__webpack_require__(43)));
/**
 * 生成 Tooltip 的显示隐藏函数
 */

function createShowHideFn(editor) {
  cov_2p68u6ffw().f[1]++;
  var tooltip;
  /**
   * 显示 tooltip
   * @param $node 链接元素
   */

  function showImgTooltip($node) {
    cov_2p68u6ffw().f[2]++;
    var conf = (cov_2p68u6ffw().s[5]++, [{
      $elem: dom_core_1["default"]("<span class='w-e-icon-trash-o'></span>"),
      onClick: function onClick(editor, $node) {
        cov_2p68u6ffw().f[3]++;
        cov_2p68u6ffw().s[6]++;
        // 选中img元素
        editor.selection.createRangeByElem($node);
        cov_2p68u6ffw().s[7]++;
        editor.selection.restoreSelection();
        cov_2p68u6ffw().s[8]++;
        editor.cmd["do"]('delete'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_2p68u6ffw().s[9]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]('<span>30%</span>'),
      onClick: function onClick(editor, $node) {
        cov_2p68u6ffw().f[4]++;
        cov_2p68u6ffw().s[10]++;
        $node.attr('width', '30%');
        cov_2p68u6ffw().s[11]++;
        $node.removeAttr('height'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_2p68u6ffw().s[12]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]('<span>50%</span>'),
      onClick: function onClick(editor, $node) {
        cov_2p68u6ffw().f[5]++;
        cov_2p68u6ffw().s[13]++;
        $node.attr('width', '50%');
        cov_2p68u6ffw().s[14]++;
        $node.removeAttr('height'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_2p68u6ffw().s[15]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]('<span>100%</span>'),
      onClick: function onClick(editor, $node) {
        cov_2p68u6ffw().f[6]++;
        cov_2p68u6ffw().s[16]++;
        $node.attr('width', '100%');
        cov_2p68u6ffw().s[17]++;
        $node.removeAttr('height'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_2p68u6ffw().s[18]++;
        return true;
      }
    }]);
    cov_2p68u6ffw().s[19]++;
    tooltip = new Tooltip_1["default"](editor, $node, conf);
    cov_2p68u6ffw().s[20]++;
    tooltip.create();
  }
  /**
   * 隐藏 tooltip
   */


  function hideImgTooltip() {
    cov_2p68u6ffw().f[7]++;
    cov_2p68u6ffw().s[21]++;

    // 移除 tooltip
    if (tooltip) {
      cov_2p68u6ffw().b[3][0]++;
      cov_2p68u6ffw().s[22]++;
      tooltip.remove();
      cov_2p68u6ffw().s[23]++;
      tooltip = null;
    } else {
      cov_2p68u6ffw().b[3][1]++;
    }
  }

  cov_2p68u6ffw().s[24]++;
  return {
    showImgTooltip: showImgTooltip,
    hideImgTooltip: hideImgTooltip
  };
}
/**
 * 绑定 tooltip 事件
 * @param editor 编辑器实例
 */


function bindTooltipEvent(editor) {
  cov_2p68u6ffw().f[8]++;

  var _a = (cov_2p68u6ffw().s[25]++, createShowHideFn(editor)),
      showImgTooltip = (cov_2p68u6ffw().s[26]++, _a.showImgTooltip),
      hideImgTooltip = (cov_2p68u6ffw().s[27]++, _a.hideImgTooltip); // 点击图片元素是，显示 tooltip


  cov_2p68u6ffw().s[28]++;
  editor.txt.eventHooks.imgClickEvents.push(showImgTooltip); // 点击其他地方，或者滚动时，隐藏 tooltip

  cov_2p68u6ffw().s[29]++;
  editor.txt.eventHooks.clickEvents.push(hideImgTooltip);
  cov_2p68u6ffw().s[30]++;
  editor.txt.eventHooks.keyupEvents.push(hideImgTooltip);
  cov_2p68u6ffw().s[31]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideImgTooltip);
  cov_2p68u6ffw().s[32]++;
  editor.txt.eventHooks.menuClickEvents.push(hideImgTooltip);
  cov_2p68u6ffw().s[33]++;
  editor.txt.eventHooks.textScrollEvents.push(hideImgTooltip);
  cov_2p68u6ffw().s[34]++;
  editor.txt.eventHooks.imgDragBarMouseDownEvents.push(hideImgTooltip); // change 时隐藏

  cov_2p68u6ffw().s[35]++;
  editor.txt.eventHooks.changeEvents.push(hideImgTooltip);
}

cov_2p68u6ffw().s[36]++;
exports["default"] = bindTooltipEvent;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 增加缩进/减少缩进
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_9yvdnt11() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/indent/index.ts";
  var hash = "27e7a9703bbbf0698f126b34f5d72302dd036fd2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "17": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 69
        }
      },
      "18": {
        start: {
          line: 26,
          column: 28
        },
        end: {
          line: 101,
          column: 25
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 30
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 146
        }
      },
      "22": {
        start: {
          line: 31,
          column: 27
        },
        end: {
          line: 49,
          column: 9
        }
      },
      "23": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 47,
          column: 37
        }
      },
      "24": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 71
        }
      },
      "25": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 21
        }
      },
      "26": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 83,
          column: 6
        }
      },
      "27": {
        start: {
          line: 58,
          column: 21
        },
        end: {
          line: 58,
          column: 32
        }
      },
      "28": {
        start: {
          line: 59,
          column: 29
        },
        end: {
          line: 59,
          column: 73
        }
      },
      "29": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 79,
          column: 9
        }
      },
      "30": {
        start: {
          line: 64,
          column: 25
        },
        end: {
          line: 64,
          column: 75
        }
      },
      "31": {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 69,
          column: 13
        }
      },
      "32": {
        start: {
          line: 66,
          column: 16
        },
        end: {
          line: 68,
          column: 19
        }
      },
      "33": {
        start: {
          line: 67,
          column: 20
        },
        end: {
          line: 67,
          column: 87
        }
      },
      "34": {
        start: {
          line: 74,
          column: 12
        },
        end: {
          line: 78,
          column: 13
        }
      },
      "35": {
        start: {
          line: 75,
          column: 16
        },
        end: {
          line: 77,
          column: 19
        }
      },
      "36": {
        start: {
          line: 76,
          column: 20
        },
        end: {
          line: 76,
          column: 87
        }
      },
      "37": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 81,
          column: 44
        }
      },
      "38": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 31
        }
      },
      "39": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 99,
          column: 6
        }
      },
      "40": {
        start: {
          line: 88,
          column: 21
        },
        end: {
          line: 88,
          column: 32
        }
      },
      "41": {
        start: {
          line: 89,
          column: 29
        },
        end: {
          line: 89,
          column: 69
        }
      },
      "42": {
        start: {
          line: 90,
          column: 34
        },
        end: {
          line: 90,
          column: 87
        }
      },
      "43": {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 92,
          column: 19
        }
      },
      "44": {
        start: {
          line: 92,
          column: 12
        },
        end: {
          line: 92,
          column: 19
        }
      },
      "45": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 98,
          column: 9
        }
      },
      "46": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 26
        }
      },
      "47": {
        start: {
          line: 97,
          column: 12
        },
        end: {
          line: 97,
          column: 28
        }
      },
      "48": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 18
        }
      },
      "49": {
        start: {
          line: 102,
          column: 0
        },
        end: {
          line: 102,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 29
          }
        },
        loc: {
          start: {
            line: 26,
            column: 46
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "Indent",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 19
          }
        },
        loc: {
          start: {
            line: 28,
            column: 28
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 27
          }
        },
        loc: {
          start: {
            line: 45,
            column: 43
          },
          end: {
            line: 48,
            column: 13
          }
        },
        line: 45
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 57,
            column: 31
          },
          end: {
            line: 57,
            column: 32
          }
        },
        loc: {
          start: {
            line: 57,
            column: 48
          },
          end: {
            line: 83,
            column: 5
          }
        },
        line: 57
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 66,
            column: 31
          },
          end: {
            line: 66,
            column: 32
          }
        },
        loc: {
          start: {
            line: 66,
            column: 47
          },
          end: {
            line: 68,
            column: 17
          }
        },
        line: 66
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 75,
            column: 39
          },
          end: {
            line: 75,
            column: 40
          }
        },
        loc: {
          start: {
            line: 75,
            column: 55
          },
          end: {
            line: 77,
            column: 17
          }
        },
        line: 75
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 87,
            column: 39
          },
          end: {
            line: 87,
            column: 40
          }
        },
        loc: {
          start: {
            line: 87,
            column: 51
          },
          end: {
            line: 99,
            column: 5
          }
        },
        line: 87
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 62
          }
        }, {
          start: {
            line: 50,
            column: 66
          },
          end: {
            line: 50,
            column: 70
          }
        }],
        line: 50
      },
      "8": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }, {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }],
        line: 61
      },
      "9": {
        loc: {
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 26
          }
        }, {
          start: {
            line: 61,
            column: 30
          },
          end: {
            line: 61,
            column: 68
          }
        }],
        line: 61
      },
      "10": {
        loc: {
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 69,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 69,
            column: 13
          }
        }, {
          start: {
            line: 65,
            column: 12
          },
          end: {
            line: 69,
            column: 13
          }
        }],
        line: 65
      },
      "11": {
        loc: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 78,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 78,
            column: 13
          }
        }, {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 78,
            column: 13
          }
        }],
        line: 74
      },
      "12": {
        loc: {
          start: {
            line: 74,
            column: 16
          },
          end: {
            line: 74,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 16
          },
          end: {
            line: 74,
            column: 30
          }
        }, {
          start: {
            line: 74,
            column: 34
          },
          end: {
            line: 74,
            column: 59
          }
        }],
        line: 74
      },
      "13": {
        loc: {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        }, {
          start: {
            line: 91,
            column: 8
          },
          end: {
            line: 92,
            column: 19
          }
        }],
        line: 91
      },
      "14": {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }, {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 98,
            column: 9
          }
        }],
        line: 93
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/indent/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoC;AAEpC,mFAA4D;AAE5D,sEAA8C;AAE9C;IAAqB,0BAAY;IAC7B,gBAAY,MAAc;QAA1B,iBAsCC;QArCG,IAAM,KAAK,GAAG,kBAAC,CACX,0GAEO,CACV,CAAA;QACD,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE;gBACF;oBACI,KAAK,EAAE,kBAAC,CACJ,iIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,gCAAgC,CAAC,kCACpD,CACP;oBACD,KAAK,EAAE,UAAU;iBACpB;gBAED;oBACI,KAAK,EAAE,kBAAC,CACJ,iIAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,gCAAgC,CAAC,kCACpD,CACP;oBACD,KAAK,EAAE,UAAU;iBACpB;aACJ;YACD,YAAY,EAAE,UAAC,KAAa;gBACxB,2BAA2B;gBAC3B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QAED,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IAED;;;OAGG;IACI,wBAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QAEnE,sBAAsB;QACtB,IAAI,cAAc,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,cAAc,CAAC,EAAE;YAC1D,uBAAuB;YACvB,gCAAgC;YAChC,IAAM,MAAM,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,CAAC,MAAM,CAAC,CAAA;YACjE,IAAI,MAAM,CAAC,MAAM,GAAG,CAAC,EAAE;gBACnB,MAAM,CAAC,OAAO,CAAC,UAAC,IAAS;oBACrB,yBAAc,CAAC,kBAAC,CAAC,IAAI,CAAC,EAAE,KAAK,EAAE,MAAM,CAAC,CAAA;gBAC1C,CAAC,CAAC,CAAA;aACL;SACJ;aAAM;YACH,wBAAwB;YACxB,4BAA4B;YAC5B,IAAI,cAAc,IAAI,cAAc,CAAC,MAAM,GAAG,CAAC,EAAE;gBAC7C,cAAc,CAAC,OAAO,CAAC,UAAC,IAAS;oBAC7B,yBAAc,CAAC,kBAAC,CAAC,IAAI,CAAC,EAAE,KAAK,EAAE,MAAM,CAAC,CAAA;gBAC1C,CAAC,CAAC,CAAA;aACL;SACJ;QAED,OAAO;QACP,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QACnC,IAAI,CAAC,eAAe,EAAE,CAAA;IAC1B,CAAC;IAED;;OAEG;IACI,gCAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAA;QAC/D,IAAM,mBAAmB,GAAG,kBAAC,CAAC,cAAc,CAAC,CAAC,UAAU,CAAC,MAAM,CAAC,CAAA;QAEhE,IAAI,mBAAmB,CAAC,MAAM,IAAI,CAAC;YAAE,OAAM;QAE3C,IAAI,mBAAmB,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,KAAK,CAAC,aAAa,CAAC,IAAI,EAAE,EAAE;YACzD,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,aAAC;AAAD,CAAC,AA1FD,CAAqB,sBAAY,GA0FhC;AAED,kBAAe,MAAM,CAAA",
      sourcesContent: ["/**\n * @description \u589E\u52A0\u7F29\u8FDB/\u51CF\u5C11\u7F29\u8FDB\n * @author tonghan\n */\n\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport operateElement from './operate-element'\n\nclass Indent extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-indent-increase\"></i>\n            </div>`\n        )\n        const dropListConf = {\n            width: 130,\n            title: '\u8BBE\u7F6E\u7F29\u8FDB',\n            type: 'list',\n            list: [\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-indent-increase w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.indent.\u589E\u52A0\u7F29\u8FDB')}\n                        <p>`\n                    ),\n                    value: 'increase',\n                },\n\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-indent-decrease w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.indent.\u51CF\u5C11\u7F29\u8FDB')}\n                        <p>`\n                    ),\n                    value: 'decrease',\n                },\n            ],\n            clickHandler: (value: string) => {\n                // \u6CE8\u610F this \u662F\u6307\u5411\u5F53\u524D\u7684 Indent \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n\n        super($elem, editor, dropListConf)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        const editor = this.editor\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n\n        // \u5224\u65AD \u5F53\u524D\u9009\u533A\u4E3A textElem \u65F6\n        if ($selectionElem && editor.$textElem.equal($selectionElem)) {\n            // \u5F53 \u5F53\u524D\u9009\u533A \u7B49\u4E8E textElem \u65F6\n            // \u4EE3\u8868 \u5F53\u524D\u9009\u533A \u53EF\u80FD\u662F\u4E00\u4E2A\u9009\u62E9\u4E86\u4E00\u4E2A\u5B8C\u6574\u7684\u6BB5\u843D\u6216\u8005\u591A\u4E2A\u6BB5\u843D\n            const $elems = editor.selection.getSelectionRangeTopNodes(editor)\n            if ($elems.length > 0) {\n                $elems.forEach((item: any) => {\n                    operateElement($(item), value, editor)\n                })\n            }\n        } else {\n            // \u5F53 \u5F53\u524D\u9009\u533A \u4E0D\u7B49\u4E8E textElem \u65F6\n            // \u4EE3\u8868 \u5F53\u524D\u9009\u533A\u8981\u4E48\u662F\u4E00\u4E2A\u6BB5\u843D\uFF0C\u8981\u4E48\u662F\u6BB5\u843D\u4E2D\u7684\u4E00\u90E8\u5206\n            if ($selectionElem && $selectionElem.length > 0) {\n                $selectionElem.forEach((item: any) => {\n                    operateElement($(item), value, editor)\n                })\n            }\n        }\n\n        // \u6062\u590D\u9009\u533A\n        editor.selection.restoreSelection()\n        this.tryChangeActive()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u6539\u53D8\u83DC\u5355\u6FC0\u6D3B\uFF08\u9AD8\u4EAE\uFF09\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        const $selectionElem = editor.selection.getSelectionStartElem()\n        const $selectionStartElem = $($selectionElem).getNodeTop(editor)\n\n        if ($selectionStartElem.length <= 0) return\n\n        if ($selectionStartElem.elems[0].style['paddingLeft'] != '') {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Indent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "27e7a9703bbbf0698f126b34f5d72302dd036fd2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_9yvdnt11 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_9yvdnt11();

var __extends = (cov_9yvdnt11().s[0]++, (cov_9yvdnt11().b[0][0]++, void 0) && (cov_9yvdnt11().b[0][1]++, (void 0).__extends) || (cov_9yvdnt11().b[0][2]++, function () {
  cov_9yvdnt11().f[0]++;
  cov_9yvdnt11().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_9yvdnt11().f[1]++;
    cov_9yvdnt11().s[2]++;
    _extendStatics = (cov_9yvdnt11().b[1][0]++, _setPrototypeOf["default"]) || (cov_9yvdnt11().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_9yvdnt11().b[1][2]++, function (d, b) {
      cov_9yvdnt11().f[2]++;
      cov_9yvdnt11().s[3]++;
      d.__proto__ = b;
    }) || (cov_9yvdnt11().b[1][3]++, function (d, b) {
      cov_9yvdnt11().f[3]++;
      cov_9yvdnt11().s[4]++;

      for (var p in b) {
        cov_9yvdnt11().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_9yvdnt11().b[2][0]++;
          cov_9yvdnt11().s[6]++;
          d[p] = b[p];
        } else {
          cov_9yvdnt11().b[2][1]++;
        }
      }
    });
    cov_9yvdnt11().s[7]++;
    return _extendStatics(d, b);
  };

  cov_9yvdnt11().s[8]++;
  return function (d, b) {
    cov_9yvdnt11().f[4]++;
    cov_9yvdnt11().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_9yvdnt11().f[5]++;
      cov_9yvdnt11().s[10]++;
      this.constructor = d;
    }

    cov_9yvdnt11().s[11]++;
    d.prototype = b === null ? (cov_9yvdnt11().b[3][0]++, (0, _create["default"])(b)) : (cov_9yvdnt11().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_9yvdnt11().s[12]++, (cov_9yvdnt11().b[4][0]++, void 0) && (cov_9yvdnt11().b[4][1]++, (void 0).__importDefault) || (cov_9yvdnt11().b[4][2]++, function (mod) {
  cov_9yvdnt11().f[6]++;
  cov_9yvdnt11().s[13]++;
  return (cov_9yvdnt11().b[6][0]++, mod) && (cov_9yvdnt11().b[6][1]++, mod.__esModule) ? (cov_9yvdnt11().b[5][0]++, mod) : (cov_9yvdnt11().b[5][1]++, {
    "default": mod
  });
}));

cov_9yvdnt11().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_9yvdnt11().s[15]++, __importDefault(__webpack_require__(2)));
var DropListMenu_1 = (cov_9yvdnt11().s[16]++, __importDefault(__webpack_require__(22)));
var operate_element_1 = (cov_9yvdnt11().s[17]++, __importDefault(__webpack_require__(350)));
var Indent = (
/** @class */
cov_9yvdnt11().s[18]++, function (_super) {
  cov_9yvdnt11().f[7]++;
  cov_9yvdnt11().s[19]++;

  __extends(Indent, _super);

  function Indent(editor) {
    cov_9yvdnt11().f[8]++;

    var _this = (cov_9yvdnt11().s[20]++, this);

    var $elem = (cov_9yvdnt11().s[21]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-indent-increase\"></i>\n            </div>"));
    var dropListConf = (cov_9yvdnt11().s[22]++, {
      width: 130,
      title: '设置缩进',
      type: 'list',
      list: [{
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-indent-increase w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.indent.增加缩进') + "\n                        <p>"),
        value: 'increase'
      }, {
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-indent-decrease w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.indent.减少缩进') + "\n                        <p>"),
        value: 'decrease'
      }],
      clickHandler: function clickHandler(value) {
        cov_9yvdnt11().f[9]++;
        cov_9yvdnt11().s[23]++;

        // 注意 this 是指向当前的 Indent 对象
        _this.command(value);
      }
    });
    cov_9yvdnt11().s[24]++;
    _this = (cov_9yvdnt11().b[7][0]++, _super.call(this, $elem, editor, dropListConf)) || (cov_9yvdnt11().b[7][1]++, this);
    cov_9yvdnt11().s[25]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_9yvdnt11().s[26]++;

  Indent.prototype.command = function (value) {
    cov_9yvdnt11().f[10]++;
    var editor = (cov_9yvdnt11().s[27]++, this.editor);
    var $selectionElem = (cov_9yvdnt11().s[28]++, editor.selection.getSelectionContainerElem()); // 判断 当前选区为 textElem 时

    cov_9yvdnt11().s[29]++;

    if ((cov_9yvdnt11().b[9][0]++, $selectionElem) && (cov_9yvdnt11().b[9][1]++, editor.$textElem.equal($selectionElem))) {
      cov_9yvdnt11().b[8][0]++;
      // 当 当前选区 等于 textElem 时
      // 代表 当前选区 可能是一个选择了一个完整的段落或者多个段落
      var $elems = (cov_9yvdnt11().s[30]++, editor.selection.getSelectionRangeTopNodes(editor));
      cov_9yvdnt11().s[31]++;

      if ($elems.length > 0) {
        cov_9yvdnt11().b[10][0]++;
        cov_9yvdnt11().s[32]++;
        (0, _forEach["default"])($elems).call($elems, function (item) {
          cov_9yvdnt11().f[11]++;
          cov_9yvdnt11().s[33]++;
          operate_element_1["default"](dom_core_1["default"](item), value, editor);
        });
      } else {
        cov_9yvdnt11().b[10][1]++;
      }
    } else {
      cov_9yvdnt11().b[8][1]++;
      cov_9yvdnt11().s[34]++;

      // 当 当前选区 不等于 textElem 时
      // 代表 当前选区要么是一个段落，要么是段落中的一部分
      if ((cov_9yvdnt11().b[12][0]++, $selectionElem) && (cov_9yvdnt11().b[12][1]++, $selectionElem.length > 0)) {
        cov_9yvdnt11().b[11][0]++;
        cov_9yvdnt11().s[35]++;
        (0, _forEach["default"])($selectionElem).call($selectionElem, function (item) {
          cov_9yvdnt11().f[12]++;
          cov_9yvdnt11().s[36]++;
          operate_element_1["default"](dom_core_1["default"](item), value, editor);
        });
      } else {
        cov_9yvdnt11().b[11][1]++;
      }
    } // 恢复选区


    cov_9yvdnt11().s[37]++;
    editor.selection.restoreSelection();
    cov_9yvdnt11().s[38]++;
    this.tryChangeActive();
  };
  /**
   * 尝试改变菜单激活（高亮）状态
   */


  cov_9yvdnt11().s[39]++;

  Indent.prototype.tryChangeActive = function () {
    cov_9yvdnt11().f[13]++;
    var editor = (cov_9yvdnt11().s[40]++, this.editor);
    var $selectionElem = (cov_9yvdnt11().s[41]++, editor.selection.getSelectionStartElem());
    var $selectionStartElem = (cov_9yvdnt11().s[42]++, dom_core_1["default"]($selectionElem).getNodeTop(editor));
    cov_9yvdnt11().s[43]++;

    if ($selectionStartElem.length <= 0) {
      cov_9yvdnt11().b[13][0]++;
      cov_9yvdnt11().s[44]++;
      return;
    } else {
      cov_9yvdnt11().b[13][1]++;
    }

    cov_9yvdnt11().s[45]++;

    if ($selectionStartElem.elems[0].style['paddingLeft'] != '') {
      cov_9yvdnt11().b[14][0]++;
      cov_9yvdnt11().s[46]++;
      this.active();
    } else {
      cov_9yvdnt11().b[14][1]++;
      cov_9yvdnt11().s[47]++;
      this.unActive();
    }
  };

  cov_9yvdnt11().s[48]++;
  return Indent;
}(DropListMenu_1["default"]));
cov_9yvdnt11().s[49]++;
exports["default"] = Indent;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 对节点 操作 进行封装
 *                  获取当前节点的段落
 *                  根据type判断是增加还是减少缩进
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _slice = _interopRequireDefault(__webpack_require__(54));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2iry1j3cjr() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/indent/operate-element.ts";
  var hash = "7e30cd1710a12551e942686f31b9557966fecae4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/operate-element.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "2": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 62
        }
      },
      "3": {
        start: {
          line: 12,
          column: 30
        },
        end: {
          line: 12,
          column: 81
        }
      },
      "4": {
        start: {
          line: 13,
          column: 30
        },
        end: {
          line: 13,
          column: 81
        }
      },
      "5": {
        start: {
          line: 14,
          column: 18
        },
        end: {
          line: 14,
          column: 32
        }
      },
      "6": {
        start: {
          line: 15,
          column: 19
        },
        end: {
          line: 15,
          column: 29
        }
      },
      "7": {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 17,
          column: 47
        }
      },
      "8": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "9": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 31,
          column: 9
        }
      },
      "10": {
        start: {
          line: 20,
          column: 21
        },
        end: {
          line: 20,
          column: 70
        }
      },
      "11": {
        start: {
          line: 20,
          column: 80
        },
        end: {
          line: 20,
          column: 85
        }
      },
      "12": {
        start: {
          line: 20,
          column: 94
        },
        end: {
          line: 20,
          column: 99
        }
      },
      "13": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 24,
          column: 14
        }
      },
      "14": {
        start: {
          line: 26,
          column: 13
        },
        end: {
          line: 31,
          column: 9
        }
      },
      "15": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 30,
          column: 14
        }
      },
      "16": {
        start: {
          line: 33,
          column: 9
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "17": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 27
        }
      },
      "18": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 39,
          column: 6
        }
      },
      "19": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 40
        }
      },
      "20": {
        start: {
          line: 43,
          column: 14
        },
        end: {
          line: 43,
          column: 20
        }
      },
      "21": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "22": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 48,
          column: 77
        }
      },
      "23": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 77
        }
      },
      "24": {
        start: {
          line: 47,
          column: 13
        },
        end: {
          line: 48,
          column: 77
        }
      },
      "25": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 77
        }
      },
      "26": {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 51,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 56
          },
          end: {
            line: 8,
            column: 57
          }
        },
        loc: {
          start: {
            line: 8,
            column: 71
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 8
      },
      "1": {
        name: "parseIndentation",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 25
          }
        },
        loc: {
          start: {
            line: 16,
            column: 34
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "operateElement",
        decl: {
          start: {
            line: 41,
            column: 9
          },
          end: {
            line: 41,
            column: 23
          }
        },
        loc: {
          start: {
            line: 41,
            column: 45
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 41
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 22
          },
          end: {
            line: 10,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 23
          },
          end: {
            line: 8,
            column: 27
          }
        }, {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 8,
            column: 51
          }
        }, {
          start: {
            line: 8,
            column: 56
          },
          end: {
            line: 10,
            column: 1
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 9,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 37
          },
          end: {
            line: 9,
            column: 40
          }
        }, {
          start: {
            line: 9,
            column: 43
          },
          end: {
            line: 9,
            column: 61
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 9,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 9,
            column: 15
          }
        }, {
          start: {
            line: 9,
            column: 19
          },
          end: {
            line: 9,
            column: 33
          }
        }],
        line: 9
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 31,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 31,
            column: 9
          }
        }, {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 31,
            column: 9
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 31,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 31,
            column: 9
          }
        }, {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 31,
            column: 9
          }
        }],
        line: 26
      },
      "6": {
        loc: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 5
          }
        }],
        line: 33
      },
      "7": {
        loc: {
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 13
          },
          end: {
            line: 33,
            column: 41
          }
        }, {
          start: {
            line: 33,
            column: 45
          },
          end: {
            line: 33,
            column: 61
          }
        }],
        line: 33
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }],
        line: 44
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 77
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 77
          }
        }],
        line: 45
      },
      "10": {
        loc: {
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 48,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 48,
            column: 77
          }
        }, {
          start: {
            line: 47,
            column: 13
          },
          end: {
            line: 48,
            column: 77
          }
        }],
        line: 47
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/operate-element.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/indent/operate-element.ts"],
      names: [],
      mappings: ";AAAA;;;;;GAKG;;;;;AAKH,kFAAyD;AACzD,kFAAyD;AAEzD,IAAM,WAAW,GAAG,cAAc,CAAA;AAClC,IAAM,YAAY,GAAG,UAAU,CAAA;AAE/B,SAAS,gBAAgB,CAAC,MAAc;IAC5B,IAAA,WAAW,GAAK,MAAM,CAAC,MAAM,YAAlB,CAAkB;IAErC,IAAI,OAAO,WAAW,KAAK,QAAQ,EAAE;QACjC,IAAI,WAAW,CAAC,IAAI,CAAC,WAAW,CAAC,EAAE;YACzB,IAAA,KAAgB,WAAW,CAAC,IAAI,EAAE,CAAC,KAAK,CAAC,WAAW,CAAE,CAAC,KAAK,CAAC,CAAC,EAAE,CAAC,CAAC,EAAjE,KAAK,QAAA,EAAE,IAAI,QAAsD,CAAA;YACxE,OAAO;gBACH,KAAK,EAAE,MAAM,CAAC,KAAK,CAAC;gBACpB,IAAI,MAAA;aACP,CAAA;SACJ;aAAM,IAAI,YAAY,CAAC,IAAI,CAAC,WAAW,CAAC,EAAE;YACvC,OAAO;gBACH,KAAK,EAAE,MAAM,CAAC,WAAW,CAAC,IAAI,EAAE,CAAC,KAAK,CAAC,YAAY,CAAE,CAAC,CAAC,CAAC,CAAC;gBACzD,IAAI,EAAE,GAAG;aACZ,CAAA;SACJ;KACJ;SAAM,IAAI,WAAW,CAAC,KAAK,KAAK,KAAK,CAAC,IAAI,WAAW,CAAC,IAAI,EAAE;QACzD,OAAO,WAAW,CAAA;KACrB;IAED,OAAO;QACH,KAAK,EAAE,CAAC;QACR,IAAI,EAAE,IAAI;KACb,CAAA;AACL,CAAC;AAED,SAAS,cAAc,CAAC,KAAiB,EAAE,IAAY,EAAE,MAAc;IACnE,IAAM,KAAK,GAAG,KAAK,CAAC,UAAU,CAAC,MAAM,CAAC,CAAA;IACtC,IAAM,GAAG,GAAG,MAAM,CAAA;IAElB,IAAI,GAAG,CAAC,IAAI,CAAC,KAAK,CAAC,WAAW,EAAE,CAAC,EAAE;QAC/B,IAAI,IAAI,KAAK,UAAU;YAAE,+BAAmB,CAAC,KAAK,EAAE,gBAAgB,CAAC,MAAM,CAAC,CAAC,CAAA;aACxE,IAAI,IAAI,KAAK,UAAU;YAAE,+BAAmB,CAAC,KAAK,EAAE,gBAAgB,CAAC,MAAM,CAAC,CAAC,CAAA;KACrF;AACL,CAAC;AAED,kBAAe,cAAc,CAAA",
      sourcesContent: ["/**\n * @description \u5BF9\u8282\u70B9 \u64CD\u4F5C \u8FDB\u884C\u5C01\u88C5\n *                  \u83B7\u53D6\u5F53\u524D\u8282\u70B9\u7684\u6BB5\u843D\n *                  \u6839\u636Etype\u5224\u65AD\u662F\u589E\u52A0\u8FD8\u662F\u51CF\u5C11\u7F29\u8FDB\n * @author tonghan\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { IndentationOptions } from '../../config/menus'\nimport increaseIndentStyle from './increase-indent-style'\nimport decreaseIndentStyle from './decrease-indent-style'\n\nconst lengthRegex = /^(\\d+)(\\w+)$/\nconst percentRegex = /^(\\d+)%$/\n\nfunction parseIndentation(editor: Editor): IndentationOptions {\n    const { indentation } = editor.config\n\n    if (typeof indentation === 'string') {\n        if (lengthRegex.test(indentation)) {\n            const [value, unit] = indentation.trim().match(lengthRegex)!.slice(1, 3)\n            return {\n                value: Number(value),\n                unit,\n            }\n        } else if (percentRegex.test(indentation)) {\n            return {\n                value: Number(indentation.trim().match(percentRegex)![1]),\n                unit: '%',\n            }\n        }\n    } else if (indentation.value !== void 0 && indentation.unit) {\n        return indentation\n    }\n\n    return {\n        value: 2,\n        unit: 'em',\n    }\n}\n\nfunction operateElement($node: DomElement, type: String, editor: Editor): void {\n    const $elem = $node.getNodeTop(editor)\n    const reg = /^P$/i\n\n    if (reg.test($elem.getNodeName())) {\n        if (type === 'increase') increaseIndentStyle($elem, parseIndentation(editor))\n        else if (type === 'decrease') decreaseIndentStyle($elem, parseIndentation(editor))\n    }\n}\n\nexport default operateElement\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7e30cd1710a12551e942686f31b9557966fecae4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2iry1j3cjr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2iry1j3cjr();

var __importDefault = (cov_2iry1j3cjr().s[0]++, (cov_2iry1j3cjr().b[0][0]++, void 0) && (cov_2iry1j3cjr().b[0][1]++, (void 0).__importDefault) || (cov_2iry1j3cjr().b[0][2]++, function (mod) {
  cov_2iry1j3cjr().f[0]++;
  cov_2iry1j3cjr().s[1]++;
  return (cov_2iry1j3cjr().b[2][0]++, mod) && (cov_2iry1j3cjr().b[2][1]++, mod.__esModule) ? (cov_2iry1j3cjr().b[1][0]++, mod) : (cov_2iry1j3cjr().b[1][1]++, {
    "default": mod
  });
}));

cov_2iry1j3cjr().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var increase_indent_style_1 = (cov_2iry1j3cjr().s[3]++, __importDefault(__webpack_require__(351)));
var decrease_indent_style_1 = (cov_2iry1j3cjr().s[4]++, __importDefault(__webpack_require__(352)));
var lengthRegex = (cov_2iry1j3cjr().s[5]++, /^(\d+)(\w+)$/);
var percentRegex = (cov_2iry1j3cjr().s[6]++, /^(\d+)%$/);

function parseIndentation(editor) {
  cov_2iry1j3cjr().f[1]++;
  var indentation = (cov_2iry1j3cjr().s[7]++, editor.config.indentation);
  cov_2iry1j3cjr().s[8]++;

  if (typeof indentation === 'string') {
    cov_2iry1j3cjr().b[3][0]++;
    cov_2iry1j3cjr().s[9]++;

    if (lengthRegex.test(indentation)) {
      var _context;

      cov_2iry1j3cjr().b[4][0]++;

      var _a = (cov_2iry1j3cjr().s[10]++, (0, _slice["default"])(_context = (0, _trim["default"])(indentation).call(indentation).match(lengthRegex)).call(_context, 1, 3)),
          value = (cov_2iry1j3cjr().s[11]++, _a[0]),
          unit = (cov_2iry1j3cjr().s[12]++, _a[1]);

      cov_2iry1j3cjr().s[13]++;
      return {
        value: Number(value),
        unit: unit
      };
    } else {
      cov_2iry1j3cjr().b[4][1]++;
      cov_2iry1j3cjr().s[14]++;

      if (percentRegex.test(indentation)) {
        cov_2iry1j3cjr().b[5][0]++;
        cov_2iry1j3cjr().s[15]++;
        return {
          value: Number((0, _trim["default"])(indentation).call(indentation).match(percentRegex)[1]),
          unit: '%'
        };
      } else {
        cov_2iry1j3cjr().b[5][1]++;
      }
    }
  } else {
    cov_2iry1j3cjr().b[3][1]++;
    cov_2iry1j3cjr().s[16]++;

    if ((cov_2iry1j3cjr().b[7][0]++, indentation.value !== void 0) && (cov_2iry1j3cjr().b[7][1]++, indentation.unit)) {
      cov_2iry1j3cjr().b[6][0]++;
      cov_2iry1j3cjr().s[17]++;
      return indentation;
    } else {
      cov_2iry1j3cjr().b[6][1]++;
    }
  }

  cov_2iry1j3cjr().s[18]++;
  return {
    value: 2,
    unit: 'em'
  };
}

function operateElement($node, type, editor) {
  cov_2iry1j3cjr().f[2]++;
  var $elem = (cov_2iry1j3cjr().s[19]++, $node.getNodeTop(editor));
  var reg = (cov_2iry1j3cjr().s[20]++, /^P$/i);
  cov_2iry1j3cjr().s[21]++;

  if (reg.test($elem.getNodeName())) {
    cov_2iry1j3cjr().b[8][0]++;
    cov_2iry1j3cjr().s[22]++;

    if (type === 'increase') {
      cov_2iry1j3cjr().b[9][0]++;
      cov_2iry1j3cjr().s[23]++;
      increase_indent_style_1["default"]($elem, parseIndentation(editor));
    } else {
      cov_2iry1j3cjr().b[9][1]++;
      cov_2iry1j3cjr().s[24]++;

      if (type === 'decrease') {
        cov_2iry1j3cjr().b[10][0]++;
        cov_2iry1j3cjr().s[25]++;
        decrease_indent_style_1["default"]($elem, parseIndentation(editor));
      } else {
        cov_2iry1j3cjr().b[10][1]++;
      }
    }
  } else {
    cov_2iry1j3cjr().b[8][1]++;
  }
}

cov_2iry1j3cjr().s[26]++;
exports["default"] = operateElement;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 增加缩进
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _slice = _interopRequireDefault(__webpack_require__(54));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1mwa14rhm() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/indent/increase-indent-style.ts";
  var hash = "6074e199cdf501c94ec424dc443b62bf9d069730";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/increase-indent-style.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 8,
          column: 30
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "3": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 64
        }
      },
      "4": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 46
        }
      },
      "5": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 14,
          column: 71
        }
      },
      "6": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 15,
          column: 51
        }
      },
      "7": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 62
        }
      },
      "8": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "increaseIndentStyle",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 28
          }
        },
        loc: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        }],
        line: 9
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/increase-indent-style.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/indent/increase-indent-style.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAKH,SAAS,mBAAmB,CAAC,KAAiB,EAAE,OAA2B;IACvE,IAAM,KAAK,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;IAC5B,IAAI,KAAK,CAAC,KAAK,CAAC,aAAa,CAAC,KAAK,EAAE,EAAE;QACnC,KAAK,CAAC,GAAG,CAAC,cAAc,EAAE,OAAO,CAAC,KAAK,GAAG,OAAO,CAAC,IAAI,CAAC,CAAA;KAC1D;SAAM;QACH,IAAM,KAAK,GAAG,KAAK,CAAC,KAAK,CAAC,aAAa,CAAC,CAAA;QACxC,IAAM,MAAM,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,EAAE,KAAK,CAAC,MAAM,GAAG,OAAO,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACjE,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAC,GAAG,OAAO,CAAC,KAAK,CAAA;QAC7C,KAAK,CAAC,GAAG,CAAC,cAAc,EAAE,KAAG,MAAM,GAAG,OAAO,CAAC,IAAM,CAAC,CAAA;KACxD;AACL,CAAC;AAED,kBAAe,mBAAmB,CAAA",
      sourcesContent: ["/**\n * @description \u589E\u52A0\u7F29\u8FDB\n * @author tonghan\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport { IndentationOptions } from '../../config/menus'\n\nfunction increaseIndentStyle($node: DomElement, options: IndentationOptions): void {\n    const $elem = $node.elems[0]\n    if ($elem.style['paddingLeft'] === '') {\n        $node.css('padding-left', options.value + options.unit)\n    } else {\n        const oldPL = $elem.style['paddingLeft']\n        const oldVal = oldPL.slice(0, oldPL.length - options.unit.length)\n        const newVal = Number(oldVal) + options.value\n        $node.css('padding-left', `${newVal}${options.unit}`)\n    }\n}\n\nexport default increaseIndentStyle\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6074e199cdf501c94ec424dc443b62bf9d069730"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1mwa14rhm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1mwa14rhm();
cov_1mwa14rhm().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

function increaseIndentStyle($node, options) {
  cov_1mwa14rhm().f[0]++;
  var $elem = (cov_1mwa14rhm().s[1]++, $node.elems[0]);
  cov_1mwa14rhm().s[2]++;

  if ($elem.style['paddingLeft'] === '') {
    cov_1mwa14rhm().b[0][0]++;
    cov_1mwa14rhm().s[3]++;
    $node.css('padding-left', options.value + options.unit);
  } else {
    cov_1mwa14rhm().b[0][1]++;
    var oldPL = (cov_1mwa14rhm().s[4]++, $elem.style['paddingLeft']);
    var oldVal = (cov_1mwa14rhm().s[5]++, (0, _slice["default"])(oldPL).call(oldPL, 0, oldPL.length - options.unit.length));
    var newVal = (cov_1mwa14rhm().s[6]++, Number(oldVal) + options.value);
    cov_1mwa14rhm().s[7]++;
    $node.css('padding-left', "" + newVal + options.unit);
  }
}

cov_1mwa14rhm().s[8]++;
exports["default"] = increaseIndentStyle;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 减少缩进
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _slice = _interopRequireDefault(__webpack_require__(54));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_m3m1i6o58() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/indent/decrease-indent-style.ts";
  var hash = "dc6eca9be443993214b5764a89fe2f74208a0b23";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/decrease-indent-style.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 8,
          column: 30
        }
      },
      "2": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "3": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 46
        }
      },
      "4": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 71
        }
      },
      "5": {
        start: {
          line: 12,
          column: 21
        },
        end: {
          line: 12,
          column: 51
        }
      },
      "6": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 18,
          column: 9
        }
      },
      "7": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 14,
          column: 66
        }
      },
      "8": {
        start: {
          line: 17,
          column: 12
        },
        end: {
          line: 17,
          column: 42
        }
      },
      "9": {
        start: {
          line: 21,
          column: 0
        },
        end: {
          line: 21,
          column: 38
        }
      }
    },
    fnMap: {
      "0": {
        name: "decreaseIndentStyle",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 28
          }
        },
        loc: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }, {
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        }, {
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 18,
            column: 9
          }
        }],
        line: 13
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/indent/decrease-indent-style.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/indent/decrease-indent-style.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAKH,SAAS,mBAAmB,CAAC,KAAiB,EAAE,OAA2B;IACvE,IAAM,KAAK,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;IAC5B,IAAI,KAAK,CAAC,KAAK,CAAC,aAAa,CAAC,KAAK,EAAE,EAAE;QACnC,IAAM,KAAK,GAAG,KAAK,CAAC,KAAK,CAAC,aAAa,CAAC,CAAA;QACxC,IAAM,MAAM,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,EAAE,KAAK,CAAC,MAAM,GAAG,OAAO,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACjE,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAC,GAAG,OAAO,CAAC,KAAK,CAAA;QAC7C,IAAI,MAAM,GAAG,CAAC,EAAE;YACZ,KAAK,CAAC,GAAG,CAAC,cAAc,EAAE,KAAG,MAAM,GAAG,OAAO,CAAC,IAAM,CAAC,CAAA;SACxD;aAAM;YACH,KAAK,CAAC,GAAG,CAAC,cAAc,EAAE,EAAE,CAAC,CAAA;SAChC;KACJ;AACL,CAAC;AAED,kBAAe,mBAAmB,CAAA",
      sourcesContent: ["/**\n * @description \u51CF\u5C11\u7F29\u8FDB\n * @author tonghan\n */\n\nimport { DomElement } from '../../utils/dom-core'\nimport { IndentationOptions } from '../../config/menus'\n\nfunction decreaseIndentStyle($node: DomElement, options: IndentationOptions): void {\n    const $elem = $node.elems[0]\n    if ($elem.style['paddingLeft'] !== '') {\n        const oldPL = $elem.style['paddingLeft']\n        const oldVal = oldPL.slice(0, oldPL.length - options.unit.length)\n        const newVal = Number(oldVal) - options.value\n        if (newVal > 0) {\n            $node.css('padding-left', `${newVal}${options.unit}`)\n        } else {\n            $node.css('padding-left', '')\n        }\n    }\n}\n\nexport default decreaseIndentStyle\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dc6eca9be443993214b5764a89fe2f74208a0b23"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_m3m1i6o58 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_m3m1i6o58();
cov_m3m1i6o58().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

function decreaseIndentStyle($node, options) {
  cov_m3m1i6o58().f[0]++;
  var $elem = (cov_m3m1i6o58().s[1]++, $node.elems[0]);
  cov_m3m1i6o58().s[2]++;

  if ($elem.style['paddingLeft'] !== '') {
    cov_m3m1i6o58().b[0][0]++;
    var oldPL = (cov_m3m1i6o58().s[3]++, $elem.style['paddingLeft']);
    var oldVal = (cov_m3m1i6o58().s[4]++, (0, _slice["default"])(oldPL).call(oldPL, 0, oldPL.length - options.unit.length));
    var newVal = (cov_m3m1i6o58().s[5]++, Number(oldVal) - options.value);
    cov_m3m1i6o58().s[6]++;

    if (newVal > 0) {
      cov_m3m1i6o58().b[1][0]++;
      cov_m3m1i6o58().s[7]++;
      $node.css('padding-left', "" + newVal + options.unit);
    } else {
      cov_m3m1i6o58().b[1][1]++;
      cov_m3m1i6o58().s[8]++;
      $node.css('padding-left', '');
    }
  } else {
    cov_m3m1i6o58().b[0][1]++;
  }
}

cov_m3m1i6o58().s[9]++;
exports["default"] = decreaseIndentStyle;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1ynrlzu42w() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/index.ts";
  var hash = "3bdb4ea7162daf66562e88b3aa313d0568b4208b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 16
        },
        end: {
          line: 14,
          column: 4
        }
      },
      "1": {
        start: {
          line: 3,
          column: 24
        },
        end: {
          line: 8,
          column: 5
        }
      },
      "2": {
        start: {
          line: 4,
          column: 8
        },
        end: {
          line: 6,
          column: 110
        }
      },
      "3": {
        start: {
          line: 5,
          column: 69
        },
        end: {
          line: 5,
          column: 85
        }
      },
      "4": {
        start: {
          line: 6,
          column: 30
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "5": {
        start: {
          line: 6,
          column: 47
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "6": {
        start: {
          line: 6,
          column: 95
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "7": {
        start: {
          line: 7,
          column: 8
        },
        end: {
          line: 7,
          column: 35
        }
      },
      "8": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 13,
          column: 6
        }
      },
      "9": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 28
        }
      },
      "10": {
        start: {
          line: 11,
          column: 24
        },
        end: {
          line: 11,
          column: 45
        }
      },
      "11": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 93
        }
      },
      "12": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "13": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 62
        }
      },
      "14": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 76
        }
      },
      "17": {
        start: {
          line: 25,
          column: 14
        },
        end: {
          line: 25,
          column: 68
        }
      },
      "18": {
        start: {
          line: 26,
          column: 26
        },
        end: {
          line: 26,
          column: 73
        }
      },
      "19": {
        start: {
          line: 27,
          column: 30
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "20": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 32
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "22": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 136
        }
      },
      "23": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 57
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 21
        }
      },
      "25": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "26": {
        start: {
          line: 39,
          column: 19
        },
        end: {
          line: 39,
          column: 59
        }
      },
      "27": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 51
        }
      },
      "28": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 23
        }
      },
      "29": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 48,
          column: 6
        }
      },
      "30": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 27
        }
      },
      "31": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 57
        }
      },
      "32": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 20
        }
      },
      "33": {
        start: {
          line: 52,
          column: 0
        },
        end: {
          line: 52,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 45
          },
          end: {
            line: 2,
            column: 46
          }
        },
        loc: {
          start: {
            line: 2,
            column: 57
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 25
          }
        },
        loc: {
          start: {
            line: 3,
            column: 40
          },
          end: {
            line: 8,
            column: 5
          }
        },
        line: 3
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 5,
            column: 51
          },
          end: {
            line: 5,
            column: 52
          }
        },
        loc: {
          start: {
            line: 5,
            column: 67
          },
          end: {
            line: 5,
            column: 87
          }
        },
        line: 5
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 13
          }
        },
        loc: {
          start: {
            line: 6,
            column: 28
          },
          end: {
            line: 6,
            column: 109
          }
        },
        line: 6
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 9,
            column: 12
          }
        },
        loc: {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 9
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 19
          }
        },
        loc: {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 47
          }
        },
        line: 11
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 15,
            column: 56
          },
          end: {
            line: 15,
            column: 57
          }
        },
        loc: {
          start: {
            line: 15,
            column: 71
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 15
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 27,
            column: 30
          },
          end: {
            line: 27,
            column: 31
          }
        },
        loc: {
          start: {
            line: 27,
            column: 48
          },
          end: {
            line: 51,
            column: 1
          }
        },
        line: 27
      },
      "8": {
        name: "Emoticon",
        decl: {
          start: {
            line: 29,
            column: 13
          },
          end: {
            line: 29,
            column: 21
          }
        },
        loc: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 29
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 38,
            column: 37
          },
          end: {
            line: 38,
            column: 38
          }
        },
        loc: {
          start: {
            line: 38,
            column: 49
          },
          end: {
            line: 42,
            column: 5
          }
        },
        line: 38
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 46,
            column: 38
          },
          end: {
            line: 46,
            column: 39
          }
        },
        loc: {
          start: {
            line: 46,
            column: 50
          },
          end: {
            line: 48,
            column: 5
          }
        },
        line: 46
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 49,
            column: 41
          },
          end: {
            line: 49,
            column: 42
          }
        },
        loc: {
          start: {
            line: 49,
            column: 53
          },
          end: {
            line: 49,
            column: 56
          }
        },
        line: 49
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 16
          },
          end: {
            line: 14,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 17
          },
          end: {
            line: 2,
            column: 21
          }
        }, {
          start: {
            line: 2,
            column: 25
          },
          end: {
            line: 2,
            column: 39
          }
        }, {
          start: {
            line: 2,
            column: 44
          },
          end: {
            line: 14,
            column: 4
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 6,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 4,
            column: 45
          }
        }, {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 5,
            column: 47
          }
        }, {
          start: {
            line: 5,
            column: 51
          },
          end: {
            line: 5,
            column: 87
          }
        }, {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 109
          }
        }],
        line: 4
      },
      "2": {
        loc: {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        }, {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        }],
        line: 6
      },
      "3": {
        loc: {
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 12,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 35
          },
          end: {
            line: 12,
            column: 51
          }
        }, {
          start: {
            line: 12,
            column: 55
          },
          end: {
            line: 12,
            column: 91
          }
        }],
        line: 12
      },
      "4": {
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 17,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 23
          },
          end: {
            line: 15,
            column: 27
          }
        }, {
          start: {
            line: 15,
            column: 31
          },
          end: {
            line: 15,
            column: 51
          }
        }, {
          start: {
            line: 15,
            column: 56
          },
          end: {
            line: 17,
            column: 1
          }
        }],
        line: 15
      },
      "5": {
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 37
          },
          end: {
            line: 16,
            column: 40
          }
        }, {
          start: {
            line: 16,
            column: 43
          },
          end: {
            line: 16,
            column: 61
          }
        }],
        line: 16
      },
      "6": {
        loc: {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 15
          }
        }, {
          start: {
            line: 16,
            column: 19
          },
          end: {
            line: 16,
            column: 33
          }
        }],
        line: 16
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 16
          },
          end: {
            line: 32,
            column: 48
          }
        }, {
          start: {
            line: 32,
            column: 52
          },
          end: {
            line: 32,
            column: 56
          }
        }],
        line: 32
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/index.ts"],
      names: [],
      mappings: ";;;;;;;;;;;;;;;;;;AAAA;;;GAGG;AACH,kEAAoC;AAEpC,6EAAsD;AACtD,qEAA8C;AAE9C,0EAAiD;AAEjD;IAAuB,4BAAS;IAC5B,kBAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,gGAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IACD;;OAEG;IACK,8BAAW,GAAnB;QACI,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACzC,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,+BAAY,GAAnB;QACI,IAAI,CAAC,WAAW,EAAE,CAAA;IACtB,CAAC;IAEM,kCAAe,GAAtB,cAA0B,CAAC;IAC/B,eAAC;AAAD,CAAC,AA1BD,CAAuB,mBAAS,GA0B/B;AAED,kBAAe,QAAQ,CAAA",
      sourcesContent: ["/**\n * @description \u63D2\u5165\u8868\u60C5\n * @author liuwe\n */\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport Panel from '../menu-constructors/Panel'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport createPanelConf from './create-panel-conf'\n\nclass Emoticon extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-happy\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n    /**\n     * \u521B\u5EFA panel\n     */\n    private createPanel(): void {\n        const conf = createPanelConf(this.editor)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u83DC\u5355\u8868\u60C5\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        this.createPanel()\n    }\n\n    public tryChangeActive() {}\n}\n\nexport default Emoticon\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3bdb4ea7162daf66562e88b3aa313d0568b4208b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ynrlzu42w = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ynrlzu42w();

var __extends = (cov_1ynrlzu42w().s[0]++, (cov_1ynrlzu42w().b[0][0]++, void 0) && (cov_1ynrlzu42w().b[0][1]++, (void 0).__extends) || (cov_1ynrlzu42w().b[0][2]++, function () {
  cov_1ynrlzu42w().f[0]++;
  cov_1ynrlzu42w().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1ynrlzu42w().f[1]++;
    cov_1ynrlzu42w().s[2]++;
    _extendStatics = (cov_1ynrlzu42w().b[1][0]++, _setPrototypeOf["default"]) || (cov_1ynrlzu42w().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1ynrlzu42w().b[1][2]++, function (d, b) {
      cov_1ynrlzu42w().f[2]++;
      cov_1ynrlzu42w().s[3]++;
      d.__proto__ = b;
    }) || (cov_1ynrlzu42w().b[1][3]++, function (d, b) {
      cov_1ynrlzu42w().f[3]++;
      cov_1ynrlzu42w().s[4]++;

      for (var p in b) {
        cov_1ynrlzu42w().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1ynrlzu42w().b[2][0]++;
          cov_1ynrlzu42w().s[6]++;
          d[p] = b[p];
        } else {
          cov_1ynrlzu42w().b[2][1]++;
        }
      }
    });
    cov_1ynrlzu42w().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1ynrlzu42w().s[8]++;
  return function (d, b) {
    cov_1ynrlzu42w().f[4]++;
    cov_1ynrlzu42w().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1ynrlzu42w().f[5]++;
      cov_1ynrlzu42w().s[10]++;
      this.constructor = d;
    }

    cov_1ynrlzu42w().s[11]++;
    d.prototype = b === null ? (cov_1ynrlzu42w().b[3][0]++, (0, _create["default"])(b)) : (cov_1ynrlzu42w().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1ynrlzu42w().s[12]++, (cov_1ynrlzu42w().b[4][0]++, void 0) && (cov_1ynrlzu42w().b[4][1]++, (void 0).__importDefault) || (cov_1ynrlzu42w().b[4][2]++, function (mod) {
  cov_1ynrlzu42w().f[6]++;
  cov_1ynrlzu42w().s[13]++;
  return (cov_1ynrlzu42w().b[6][0]++, mod) && (cov_1ynrlzu42w().b[6][1]++, mod.__esModule) ? (cov_1ynrlzu42w().b[5][0]++, mod) : (cov_1ynrlzu42w().b[5][1]++, {
    "default": mod
  });
}));

cov_1ynrlzu42w().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description 插入表情
 * @author liuwe
 */

var dom_core_1 = (cov_1ynrlzu42w().s[15]++, __importDefault(__webpack_require__(2)));
var PanelMenu_1 = (cov_1ynrlzu42w().s[16]++, __importDefault(__webpack_require__(32)));
var Panel_1 = (cov_1ynrlzu42w().s[17]++, __importDefault(__webpack_require__(28)));
var create_panel_conf_1 = (cov_1ynrlzu42w().s[18]++, __importDefault(__webpack_require__(354)));
var Emoticon = (
/** @class */
cov_1ynrlzu42w().s[19]++, function (_super) {
  cov_1ynrlzu42w().f[7]++;
  cov_1ynrlzu42w().s[20]++;

  __extends(Emoticon, _super);

  function Emoticon(editor) {
    cov_1ynrlzu42w().f[8]++;

    var _this = (cov_1ynrlzu42w().s[21]++, this);

    var $elem = (cov_1ynrlzu42w().s[22]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-happy\"></i>\n            </div>"));
    cov_1ynrlzu42w().s[23]++;
    _this = (cov_1ynrlzu42w().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1ynrlzu42w().b[7][1]++, this);
    cov_1ynrlzu42w().s[24]++;
    return _this;
  }
  /**
   * 创建 panel
   */


  cov_1ynrlzu42w().s[25]++;

  Emoticon.prototype.createPanel = function () {
    cov_1ynrlzu42w().f[9]++;
    var conf = (cov_1ynrlzu42w().s[26]++, create_panel_conf_1["default"](this.editor));
    var panel = (cov_1ynrlzu42w().s[27]++, new Panel_1["default"](this, conf));
    cov_1ynrlzu42w().s[28]++;
    panel.create();
  };
  /**
   * 菜单表情点击事件
   */


  cov_1ynrlzu42w().s[29]++;

  Emoticon.prototype.clickHandler = function () {
    cov_1ynrlzu42w().f[10]++;
    cov_1ynrlzu42w().s[30]++;
    this.createPanel();
  };

  cov_1ynrlzu42w().s[31]++;

  Emoticon.prototype.tryChangeActive = function () {
    cov_1ynrlzu42w().f[11]++;
  };

  cov_1ynrlzu42w().s[32]++;
  return Emoticon;
}(PanelMenu_1["default"]));
cov_1ynrlzu42w().s[33]++;
exports["default"] = Emoticon;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description  表情菜单 panel配置
 * @author liuwei
 */

var _interopRequireDefault = __webpack_require__(0);

var _trim = _interopRequireDefault(__webpack_require__(21));

var _filter = _interopRequireDefault(__webpack_require__(87));

var _map = _interopRequireDefault(__webpack_require__(42));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1rh7yhruzj() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/create-panel-conf.ts";
  var hash = "0f8ba26459ea8f261629fb309b04688bb72f5054";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 41
        }
      },
      "5": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 20
        }
      },
      "6": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 33,
          column: 9
        }
      },
      "7": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 25,
          column: 15
        }
      },
      "8": {
        start: {
          line: 22,
          column: 16
        },
        end: {
          line: 23,
          column: 30
        }
      },
      "9": {
        start: {
          line: 23,
          column: 20
        },
        end: {
          line: 23,
          column: 30
        }
      },
      "10": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 184
        }
      },
      "11": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 64
        }
      },
      "12": {
        start: {
          line: 26,
          column: 44
        },
        end: {
          line: 26,
          column: 60
        }
      },
      "13": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 32,
          column: 15
        }
      },
      "14": {
        start: {
          line: 31,
          column: 16
        },
        end: {
          line: 31,
          column: 89
        }
      },
      "15": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 51
        }
      },
      "16": {
        start: {
          line: 36,
          column: 19
        },
        end: {
          line: 65,
          column: 6
        }
      },
      "17": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 64,
          column: 10
        }
      },
      "18": {
        start: {
          line: 47,
          column: 38
        },
        end: {
          line: 47,
          column: 66
        }
      },
      "19": {
        start: {
          line: 48,
          column: 39
        },
        end: {
          line: 48,
          column: 60
        }
      },
      "20": {
        start: {
          line: 50,
          column: 24
        },
        end: {
          line: 57,
          column: 25
        }
      },
      "21": {
        start: {
          line: 52,
          column: 28
        },
        end: {
          line: 52,
          column: 72
        }
      },
      "22": {
        start: {
          line: 56,
          column: 28
        },
        end: {
          line: 56,
          column: 79
        }
      },
      "23": {
        start: {
          line: 58,
          column: 24
        },
        end: {
          line: 58,
          column: 64
        }
      },
      "24": {
        start: {
          line: 60,
          column: 24
        },
        end: {
          line: 60,
          column: 36
        }
      },
      "25": {
        start: {
          line: 68,
          column: 15
        },
        end: {
          line: 72,
          column: 5
        }
      },
      "26": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 16
        }
      },
      "27": {
        start: {
          line: 75,
          column: 0
        },
        end: {
          line: 75,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 18
          }
        },
        loc: {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "GenerateExpressionStructure",
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 40
          }
        },
        loc: {
          start: {
            line: 16,
            column: 46
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 34
          },
          end: {
            line: 21,
            column: 35
          }
        },
        loc: {
          start: {
            line: 21,
            column: 49
          },
          end: {
            line: 25,
            column: 13
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 29
          },
          end: {
            line: 26,
            column: 30
          }
        },
        loc: {
          start: {
            line: 26,
            column: 42
          },
          end: {
            line: 26,
            column: 62
          }
        },
        line: 26
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 30,
            column: 34
          },
          end: {
            line: 30,
            column: 35
          }
        },
        loc: {
          start: {
            line: 30,
            column: 49
          },
          end: {
            line: 32,
            column: 13
          }
        },
        line: 30
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 36,
            column: 32
          },
          end: {
            line: 36,
            column: 33
          }
        },
        loc: {
          start: {
            line: 36,
            column: 47
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 36
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 45,
            column: 24
          },
          end: {
            line: 45,
            column: 25
          }
        },
        loc: {
          start: {
            line: 45,
            column: 37
          },
          end: {
            line: 61,
            column: 21
          }
        },
        line: 45
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 33,
            column: 9
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 23,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 23,
            column: 30
          }
        }, {
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 23,
            column: 30
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 57,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 57,
            column: 25
          }
        }, {
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 57,
            column: 25
          }
        }],
        line: 50
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/emoticon/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,kEAAoC;AAGpC,mBAAyB,MAAc;IACnC,iBAAiB;IACjB,IAAM,QAAQ,GAAwB,MAAM,CAAC,MAAM,CAAC,QAAQ,CAAA;IAE5D,+EAA+E;IAE/E,6BAA6B;IAC7B,SAAS,2BAA2B,CAAC,GAAiB;QAClD,YAAY;QACZ,IAAI,GAAG,GAAa,EAAE,CAAA;QAEtB,2BAA2B;QAC3B,IAAI,GAAG,CAAC,IAAI,IAAI,OAAO,EAAE;YACrB,GAAG,GAAG,GAAG,CAAC,OAAO,CAAC,GAAG,CAAC,UAAC,GAAiC;gBACpD,IAAI,OAAO,GAAG,IAAI,QAAQ;oBAAE,OAAO,EAAE,CAAA;gBACrC,OAAO,oBAAiB,GAAG,CAAC,GAAG,mEACM,GAAG,CAAC,GAAG,kBAAW,GAAG,CAAC,GAAG,kCACtD,CAAA;YACZ,CAAC,CAAC,CAAA;YACF,GAAG,GAAG,GAAG,CAAC,MAAM,CAAC,UAAC,CAAS,IAAK,OAAA,CAAC,KAAK,EAAE,EAAR,CAAQ,CAAC,CAAA;SAC5C;QACD,WAAW;aACN;YACD,GAAG,GAAG,GAAG,CAAC,OAAO,CAAC,GAAG,CAAC,UAAC,GAAiC;gBACpD,OAAO,oCAA+B,GAAG,WAAK,GAAG,YAAS,CAAA;YAC9D,CAAC,CAAC,CAAA;SACL;QAED,OAAO,GAAG,CAAC,IAAI,CAAC,EAAE,CAAC,CAAC,OAAO,CAAC,SAAS,EAAE,EAAE,CAAC,CAAA;IAC9C,CAAC;IAED,IAAM,QAAQ,GAAmB,QAAQ,CAAC,GAAG,CAAC,UAAC,GAAiB;QAC5D,OAAO;YACH,KAAK,EAAE,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,+BAA6B,GAAG,CAAC,KAAO,CAAC;YAEjE,kCAAkC;YAClC,GAAG,EAAE,UAAQ,2BAA2B,CAAC,GAAG,CAAC,WAAQ;YAErD,MAAM,EAAE;gBACJ;oBACI,QAAQ,EAAE,SAAS;oBACnB,IAAI,EAAE,OAAO;oBACb,EAAE,EAAE,UAAC,CAAQ;wBACT,SAAS;wBACT,IAAM,OAAO,GAAG,kBAAC,CAAC,CAAC,CAAC,MAAM,CAAC,CAAA;wBAC3B,IAAM,QAAQ,GAAG,OAAO,CAAC,WAAW,EAAE,CAAA;wBACtC,IAAI,UAAU,CAAA;wBAEd,IAAI,QAAQ,KAAK,KAAK,EAAE;4BACpB,OAAO;4BACP,UAAU,GAAG,OAAO,CAAC,MAAM,EAAE,CAAC,IAAI,EAAE,CAAC,IAAI,EAAE,CAAA;yBAC9C;6BAAM;4BACH,WAAW;4BACX,UAAU,GAAG,QAAQ,GAAG,OAAO,CAAC,IAAI,EAAE,GAAG,SAAS,CAAA;yBACrD;wBAED,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,UAAU,CAAC,CAAA;wBACvC,oBAAoB;wBACpB,OAAO,IAAI,CAAA;oBACf,CAAC;iBACJ;aACJ;SACJ,CAAA;IACL,CAAC,CAAC,CAAA;IACF,iFAAiF;IAEjF,kDAAkD;IAClD,IAAM,IAAI,GAAc;QACpB,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,GAAG;QACX,IAAI,EAAE,QAAQ;KACjB,CAAA;IACD,OAAO,IAAI,CAAA;AACf,CAAC;AAzED,4BAyEC",
      sourcesContent: ["/**\n * @description  \u8868\u60C5\u83DC\u5355 panel\u914D\u7F6E\n * @author liuwei\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf, PanelTabConf } from '../menu-constructors/Panel'\nimport $ from '../../utils/dom-core'\nimport { EmotionsType, EmotionsContentType } from '../../config/menus'\n\nexport default function (editor: Editor): PanelConf {\n    // \u58F0\u660Eemotions\u6570\u636E\u7ED3\u6784\n    const emotions: Array<EmotionsType> = editor.config.emotions\n\n    /* tabs\u914D\u7F6E\u9879 ==================================================================*/\n\n    // \u751F\u6210\u8868\u60C5\u7ED3\u6784 TODO jele type\u7C7B\u578B\u5F85\u4F18\u5316\n    function GenerateExpressionStructure(ele: EmotionsType) {\n        // \u8FD4\u56DE\u4E3A\u4E00\u4E2A\u6570\u7EC4\u5BF9\u8C61\n        let res: string[] = []\n\n        // \u5982\u679Ctype\u662Fimage\u7C7B\u578B\u5219\u751F\u6210\u4E00\u4E2Aimg\u6807\u7B7E\n        if (ele.type == 'image') {\n            res = ele.content.map((con: EmotionsContentType | string) => {\n                if (typeof con == 'string') return ''\n                return `<span  title=\"${con.alt}\">\n                    <img class=\"eleImg\" style src=\"${con.src}\" alt=\"[${con.alt}]\">\n                </span>`\n            })\n            res = res.filter((s: string) => s !== '')\n        }\n        //\u5426\u5219\u76F4\u63A5\u5F53\u5185\u5BB9\u5904\u7406\n        else {\n            res = ele.content.map((con: EmotionsContentType | string) => {\n                return `<span class=\"eleImg\" title=\"${con}\">${con}</span>`\n            })\n        }\n\n        return res.join('').replace(/&nbsp;/g, '')\n    }\n\n    const tabsConf: PanelTabConf[] = emotions.map((ele: EmotionsType) => {\n        return {\n            title: editor.i18next.t(`menus.panelMenus.emoticon.${ele.title}`),\n\n            // \u5224\u65ADtype\u7C7B\u578B\u5982\u679C\u662Fimage\u5219\u4EE5img\u7684\u5F62\u5F0F\u63D2\u5165\u5426\u5219\u4EE5\u5185\u5BB9\n            tpl: `<div>${GenerateExpressionStructure(ele)}</div>`,\n\n            events: [\n                {\n                    selector: '.eleImg',\n                    type: 'click',\n                    fn: (e: Event) => {\n                        // e\u4E3A\u4E8B\u4EF6\u5BF9\u8C61\n                        const $target = $(e.target)\n                        const nodeName = $target.getNodeName()\n                        let insertHtml\n\n                        if (nodeName === 'IMG') {\n                            // \u63D2\u5165\u56FE\u7247\n                            insertHtml = $target.parent().html().trim()\n                        } else {\n                            // \u63D2\u5165 emoji\n                            insertHtml = '<span>' + $target.html() + '</span>'\n                        }\n\n                        editor.cmd.do('insertHTML', insertHtml)\n                        // \u793A\u51FD\u6570\u6267\u884C\u7ED3\u675F\u4E4B\u540E\u5173\u95ED panel\n                        return true\n                    },\n                },\n            ],\n        }\n    })\n    /* tabs\u914D\u7F6E\u9879 =================================================================end*/\n\n    // \u6700\u7EC8\u7684\u914D\u7F6E -----------------------------------------\n    const conf: PanelConf = {\n        width: 300, // Panel\u5BB9\u5668\u5BBD\u5EA6\n        height: 230, // Panel\u5BB9\u5668\u9AD8\u5EA6\n        tabs: tabsConf,\n    }\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0f8ba26459ea8f261629fb309b04688bb72f5054"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1rh7yhruzj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1rh7yhruzj();

var __importDefault = (cov_1rh7yhruzj().s[0]++, (cov_1rh7yhruzj().b[0][0]++, void 0) && (cov_1rh7yhruzj().b[0][1]++, (void 0).__importDefault) || (cov_1rh7yhruzj().b[0][2]++, function (mod) {
  cov_1rh7yhruzj().f[0]++;
  cov_1rh7yhruzj().s[1]++;
  return (cov_1rh7yhruzj().b[2][0]++, mod) && (cov_1rh7yhruzj().b[2][1]++, mod.__esModule) ? (cov_1rh7yhruzj().b[1][0]++, mod) : (cov_1rh7yhruzj().b[1][1]++, {
    "default": mod
  });
}));

cov_1rh7yhruzj().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1rh7yhruzj().s[3]++, __importDefault(__webpack_require__(2)));

function default_1(editor) {
  cov_1rh7yhruzj().f[1]++;
  // 声明emotions数据结构
  var emotions = (cov_1rh7yhruzj().s[4]++, editor.config.emotions);
  /* tabs配置项 ==================================================================*/
  // 生成表情结构 TODO jele type类型待优化

  function GenerateExpressionStructure(ele) {
    cov_1rh7yhruzj().f[2]++;
    // 返回为一个数组对象
    var res = (cov_1rh7yhruzj().s[5]++, []); // 如果type是image类型则生成一个img标签

    cov_1rh7yhruzj().s[6]++;

    if (ele.type == 'image') {
      var _context;

      cov_1rh7yhruzj().b[3][0]++;
      cov_1rh7yhruzj().s[7]++;
      res = (0, _map["default"])(_context = ele.content).call(_context, function (con) {
        cov_1rh7yhruzj().f[3]++;
        cov_1rh7yhruzj().s[8]++;

        if (typeof con == 'string') {
          cov_1rh7yhruzj().b[4][0]++;
          cov_1rh7yhruzj().s[9]++;
          return '';
        } else {
          cov_1rh7yhruzj().b[4][1]++;
        }

        cov_1rh7yhruzj().s[10]++;
        return "<span  title=\"" + con.alt + "\">\n                    <img class=\"eleImg\" style src=\"" + con.src + "\" alt=\"[" + con.alt + "]\">\n                </span>";
      });
      cov_1rh7yhruzj().s[11]++;
      res = (0, _filter["default"])(res).call(res, function (s) {
        cov_1rh7yhruzj().f[4]++;
        cov_1rh7yhruzj().s[12]++;
        return s !== '';
      });
    } //否则直接当内容处理
    else {
        var _context2;

        cov_1rh7yhruzj().b[3][1]++;
        cov_1rh7yhruzj().s[13]++;
        res = (0, _map["default"])(_context2 = ele.content).call(_context2, function (con) {
          cov_1rh7yhruzj().f[5]++;
          cov_1rh7yhruzj().s[14]++;
          return "<span class=\"eleImg\" title=\"" + con + "\">" + con + "</span>";
        });
      }

    cov_1rh7yhruzj().s[15]++;
    return res.join('').replace(/&nbsp;/g, '');
  }

  var tabsConf = (cov_1rh7yhruzj().s[16]++, (0, _map["default"])(emotions).call(emotions, function (ele) {
    cov_1rh7yhruzj().f[6]++;
    cov_1rh7yhruzj().s[17]++;
    return {
      title: editor.i18next.t("menus.panelMenus.emoticon." + ele.title),
      // 判断type类型如果是image则以img的形式插入否则以内容
      tpl: "<div>" + GenerateExpressionStructure(ele) + "</div>",
      events: [{
        selector: '.eleImg',
        type: 'click',
        fn: function fn(e) {
          cov_1rh7yhruzj().f[7]++;
          // e为事件对象
          var $target = (cov_1rh7yhruzj().s[18]++, dom_core_1["default"](e.target));
          var nodeName = (cov_1rh7yhruzj().s[19]++, $target.getNodeName());
          var insertHtml;
          cov_1rh7yhruzj().s[20]++;

          if (nodeName === 'IMG') {
            var _context3;

            cov_1rh7yhruzj().b[5][0]++;
            cov_1rh7yhruzj().s[21]++;
            // 插入图片
            insertHtml = (0, _trim["default"])(_context3 = $target.parent().html()).call(_context3);
          } else {
            cov_1rh7yhruzj().b[5][1]++;
            cov_1rh7yhruzj().s[22]++;
            // 插入 emoji
            insertHtml = '<span>' + $target.html() + '</span>';
          }

          cov_1rh7yhruzj().s[23]++;
          editor.cmd["do"]('insertHTML', insertHtml); // 示函数执行结束之后关闭 panel

          cov_1rh7yhruzj().s[24]++;
          return true;
        }
      }]
    };
  }));
  /* tabs配置项 =================================================================end*/
  // 最终的配置 -----------------------------------------

  var conf = (cov_1rh7yhruzj().s[25]++, {
    width: 300,
    height: 230,
    tabs: tabsConf
  });
  cov_1rh7yhruzj().s[26]++;
  return conf;
}

cov_1rh7yhruzj().s[27]++;
exports["default"] = default_1;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 无序列表/有序列表
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1sddp9v35b() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/list/index.ts";
  var hash = "efd789e02fddc8ac24a34e30ccbd28cf42c41837";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/list/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 91,
          column: 25
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 28
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 136
        }
      },
      "21": {
        start: {
          line: 30,
          column: 27
        },
        end: {
          line: 48,
          column: 9
        }
      },
      "22": {
        start: {
          line: 46,
          column: 16
        },
        end: {
          line: 46,
          column: 37
        }
      },
      "23": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 71
        }
      },
      "24": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 21
        }
      },
      "25": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "26": {
        start: {
          line: 53,
          column: 21
        },
        end: {
          line: 53,
          column: 32
        }
      },
      "27": {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 54,
          column: 40
        }
      },
      "28": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 44
        }
      },
      "29": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "30": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 19
        }
      },
      "31": {
        start: {
          line: 61,
          column: 29
        },
        end: {
          line: 61,
          column: 93
        }
      },
      "32": {
        start: {
          line: 62,
          column: 19
        },
        end: {
          line: 62,
          column: 108
        }
      },
      "33": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 65,
          column: 9
        }
      },
      "34": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 19
        }
      },
      "35": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 29
        }
      },
      "36": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 70,
          column: 9
        }
      },
      "37": {
        start: {
          line: 69,
          column: 12
        },
        end: {
          line: 69,
          column: 53
        }
      },
      "38": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 73,
          column: 9
        }
      },
      "39": {
        start: {
          line: 72,
          column: 12
        },
        end: {
          line: 72,
          column: 19
        }
      },
      "40": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 77,
          column: 9
        }
      },
      "41": {
        start: {
          line: 76,
          column: 12
        },
        end: {
          line: 76,
          column: 19
        }
      },
      "42": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 45
        }
      },
      "43": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 82,
          column: 9
        }
      },
      "44": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 81,
          column: 19
        }
      },
      "45": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 44
        }
      },
      "46": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 25
        }
      },
      "47": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 44
        }
      },
      "48": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 31
        }
      },
      "49": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 53
        }
      },
      "50": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 16
        }
      },
      "51": {
        start: {
          line: 92,
          column: 0
        },
        end: {
          line: 92,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "List",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 26
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 44,
            column: 26
          },
          end: {
            line: 44,
            column: 27
          }
        },
        loc: {
          start: {
            line: 44,
            column: 43
          },
          end: {
            line: 47,
            column: 13
          }
        },
        line: 44
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 52,
            column: 29
          },
          end: {
            line: 52,
            column: 30
          }
        },
        loc: {
          start: {
            line: 52,
            column: 46
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 52
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 89,
            column: 37
          },
          end: {
            line: 89,
            column: 38
          }
        },
        loc: {
          start: {
            line: 89,
            column: 49
          },
          end: {
            line: 89,
            column: 52
          }
        },
        line: 89
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 49,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 49,
            column: 62
          }
        }, {
          start: {
            line: 49,
            column: 66
          },
          end: {
            line: 49,
            column: 70
          }
        }],
        line: 49
      },
      "8": {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }, {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }],
        line: 57
      },
      "9": {
        loc: {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }, {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        }],
        line: 63
      },
      "10": {
        loc: {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 63,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 63,
            column: 16
          }
        }, {
          start: {
            line: 63,
            column: 20
          },
          end: {
            line: 63,
            column: 79
          }
        }],
        line: 63
      },
      "11": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 70,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 70,
            column: 9
          }
        }, {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 70,
            column: 9
          }
        }],
        line: 68
      },
      "12": {
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 73,
            column: 9
          }
        }],
        line: 71
      },
      "13": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 77,
            column: 9
          }
        }],
        line: 74
      },
      "14": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 82,
            column: 9
          }
        }],
        line: 79
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/list/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/list/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoC;AAEpC,mFAA4D;AAG5D;IAAmB,wBAAY;IAC3B,cAAY,MAAc;QAA1B,iBAsCC;QArCG,IAAM,KAAK,GAAG,kBAAC,CACX,gGAEO,CACV,CAAA;QAED,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,IAAI;YACX,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE;gBACF;oBACI,KAAK,EAAE,kBAAC,CAAC,iJAGC,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,8BAA8B,CAAC,kCAClD,CAAC;oBACT,KAAK,EAAE,qBAAqB;iBAC/B;gBAED;oBACI,KAAK,EAAE,kBAAC,CACJ,+HAEM,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,8BAA8B,CAAC,kCAClD,CACP;oBACD,KAAK,EAAE,mBAAmB;iBAC7B;aACJ;YACD,YAAY,EAAE,UAAC,KAAa;gBACxB,yBAAyB;gBACzB,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QAED,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IAEM,sBAAO,GAAd,UAAe,KAAa;QACxB,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEnC,cAAc;QACd,IAAI,MAAM,CAAC,GAAG,CAAC,iBAAiB,CAAC,KAAK,CAAC,EAAE;YACrC,OAAM;SACT;QAED,eAAe;QACf,IAAI,cAAc,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAC,CAAA;QACpE,IAAI,IAAI,GAAG,kBAAC,CAAC,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,OAAO,EAAE,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QACnF,IAAI,IAAI,IAAI,kBAAC,CAAC,IAAI,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,OAAO,EAAE;YACpD,OAAM;SACT;QAED,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,KAAK,CAAC,CAAA;QAEpB,oBAAoB;QACpB,IAAI,cAAc,CAAC,WAAW,EAAE,KAAK,IAAI,EAAE;YACvC,cAAc,GAAG,cAAc,CAAC,MAAM,EAAE,CAAA;SAC3C;QAED,IAAI,UAAU,CAAC,IAAI,CAAC,cAAc,CAAC,WAAW,EAAE,CAAC,KAAK,KAAK,EAAE;YACzD,OAAM;SACT;QAED,IAAI,cAAc,CAAC,KAAK,CAAC,SAAS,CAAC,EAAE;YACjC,qBAAqB;YACrB,OAAM;SACT;QAED,IAAM,OAAO,GAAG,cAAc,CAAC,MAAM,EAAE,CAAA;QACvC,IAAI,OAAO,CAAC,KAAK,CAAC,SAAS,CAAC,EAAE;YAC1B,qBAAqB;YACrB,OAAM;SACT;QAED,cAAc,CAAC,WAAW,CAAC,OAAO,CAAC,CAAA;QACnC,OAAO,CAAC,MAAM,EAAE,CAAA;QAEhB,OAAO;QACP,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QACnC,IAAI,CAAC,eAAe,EAAE,CAAA;IAC1B,CAAC;IAEM,8BAAe,GAAtB,cAAgC,CAAC;IACrC,WAAC;AAAD,CAAC,AAzFD,CAAmB,sBAAY,GAyF9B;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u65E0\u5E8F\u5217\u8868/\u6709\u5E8F\u5217\u8868\n * @author tonghan\n */\n\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass List extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-list2\"></i>\n            </div>`\n        )\n\n        const dropListConf = {\n            width: 130,\n            title: '\u5E8F\u5217',\n            type: 'list',\n            list: [\n                {\n                    $elem: $(`\n                        <p>\n                            <i class=\"w-e-icon-list2 w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.list.\u65E0\u5E8F\u5217\u8868')}\n                        <p>`),\n                    value: 'insertUnorderedList',\n                },\n\n                {\n                    $elem: $(\n                        `<p>\n                            <i class=\"w-e-icon-list-numbered w-e-drop-list-item\"></i>\n                            ${editor.i18next.t('menus.dropListMenu.list.\u6709\u5E8F\u5217\u8868')}\n                        <p>`\n                    ),\n                    value: 'insertOrderedList',\n                },\n            ],\n            clickHandler: (value: string) => {\n                // \u6CE8\u610F this \u662F\u6307\u5411\u5F53\u524D\u7684 List \u5BF9\u8C61\n                this.command(value)\n            },\n        }\n\n        super($elem, editor, dropListConf)\n    }\n\n    public command(value: string): void {\n        const editor = this.editor\n        const $textElem = editor.$textElem\n        editor.selection.restoreSelection()\n\n        // \u5224\u65AD\u662F\u5426\u5DF2\u7ECF\u6267\u884C\u4E86\u547D\u4EE4\n        if (editor.cmd.queryCommandState(value)) {\n            return\n        }\n\n        //\u7981\u6B62\u5728table\u4E2D\u6DFB\u52A0\u5217\u8868\n        let $selectionElem = $(editor.selection.getSelectionContainerElem())\n        let $dom = $($selectionElem.elems[0]).parentUntil('TABLE', $selectionElem.elems[0])\n        if ($dom && $($dom.elems[0]).getNodeName() === 'TABLE') {\n            return\n        }\n\n        editor.cmd.do(value)\n\n        // \u9A8C\u8BC1\u5217\u8868\u662F\u5426\u88AB\u5305\u88F9\u5728 <p> \u4E4B\u5185\n        if ($selectionElem.getNodeName() === 'LI') {\n            $selectionElem = $selectionElem.parent()\n        }\n\n        if (/^ol|ul$/i.test($selectionElem.getNodeName()) === false) {\n            return\n        }\n\n        if ($selectionElem.equal($textElem)) {\n            // \u8BC1\u660E\u662F\u9876\u7EA7\u6807\u7B7E\uFF0C\u6CA1\u6709\u88AB <p> \u5305\u88F9\n            return\n        }\n\n        const $parent = $selectionElem.parent()\n        if ($parent.equal($textElem)) {\n            // $parent \u662F\u9876\u7EA7\u6807\u7B7E\uFF0C\u4E0D\u80FD\u5220\u9664\n            return\n        }\n\n        $selectionElem.insertAfter($parent)\n        $parent.remove()\n\n        // \u6062\u590D\u9009\u533A\n        editor.selection.restoreSelection()\n        this.tryChangeActive()\n    }\n\n    public tryChangeActive(): void {}\n}\n\nexport default List\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "efd789e02fddc8ac24a34e30ccbd28cf42c41837"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1sddp9v35b = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1sddp9v35b();

var __extends = (cov_1sddp9v35b().s[0]++, (cov_1sddp9v35b().b[0][0]++, void 0) && (cov_1sddp9v35b().b[0][1]++, (void 0).__extends) || (cov_1sddp9v35b().b[0][2]++, function () {
  cov_1sddp9v35b().f[0]++;
  cov_1sddp9v35b().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1sddp9v35b().f[1]++;
    cov_1sddp9v35b().s[2]++;
    _extendStatics = (cov_1sddp9v35b().b[1][0]++, _setPrototypeOf["default"]) || (cov_1sddp9v35b().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1sddp9v35b().b[1][2]++, function (d, b) {
      cov_1sddp9v35b().f[2]++;
      cov_1sddp9v35b().s[3]++;
      d.__proto__ = b;
    }) || (cov_1sddp9v35b().b[1][3]++, function (d, b) {
      cov_1sddp9v35b().f[3]++;
      cov_1sddp9v35b().s[4]++;

      for (var p in b) {
        cov_1sddp9v35b().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1sddp9v35b().b[2][0]++;
          cov_1sddp9v35b().s[6]++;
          d[p] = b[p];
        } else {
          cov_1sddp9v35b().b[2][1]++;
        }
      }
    });
    cov_1sddp9v35b().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1sddp9v35b().s[8]++;
  return function (d, b) {
    cov_1sddp9v35b().f[4]++;
    cov_1sddp9v35b().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1sddp9v35b().f[5]++;
      cov_1sddp9v35b().s[10]++;
      this.constructor = d;
    }

    cov_1sddp9v35b().s[11]++;
    d.prototype = b === null ? (cov_1sddp9v35b().b[3][0]++, (0, _create["default"])(b)) : (cov_1sddp9v35b().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1sddp9v35b().s[12]++, (cov_1sddp9v35b().b[4][0]++, void 0) && (cov_1sddp9v35b().b[4][1]++, (void 0).__importDefault) || (cov_1sddp9v35b().b[4][2]++, function (mod) {
  cov_1sddp9v35b().f[6]++;
  cov_1sddp9v35b().s[13]++;
  return (cov_1sddp9v35b().b[6][0]++, mod) && (cov_1sddp9v35b().b[6][1]++, mod.__esModule) ? (cov_1sddp9v35b().b[5][0]++, mod) : (cov_1sddp9v35b().b[5][1]++, {
    "default": mod
  });
}));

cov_1sddp9v35b().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1sddp9v35b().s[15]++, __importDefault(__webpack_require__(2)));
var DropListMenu_1 = (cov_1sddp9v35b().s[16]++, __importDefault(__webpack_require__(22)));
var List = (
/** @class */
cov_1sddp9v35b().s[17]++, function (_super) {
  cov_1sddp9v35b().f[7]++;
  cov_1sddp9v35b().s[18]++;

  __extends(List, _super);

  function List(editor) {
    cov_1sddp9v35b().f[8]++;

    var _this = (cov_1sddp9v35b().s[19]++, this);

    var $elem = (cov_1sddp9v35b().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-list2\"></i>\n            </div>"));
    var dropListConf = (cov_1sddp9v35b().s[21]++, {
      width: 130,
      title: '序列',
      type: 'list',
      list: [{
        $elem: dom_core_1["default"]("\n                        <p>\n                            <i class=\"w-e-icon-list2 w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.list.无序列表') + "\n                        <p>"),
        value: 'insertUnorderedList'
      }, {
        $elem: dom_core_1["default"]("<p>\n                            <i class=\"w-e-icon-list-numbered w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.list.有序列表') + "\n                        <p>"),
        value: 'insertOrderedList'
      }],
      clickHandler: function clickHandler(value) {
        cov_1sddp9v35b().f[9]++;
        cov_1sddp9v35b().s[22]++;

        // 注意 this 是指向当前的 List 对象
        _this.command(value);
      }
    });
    cov_1sddp9v35b().s[23]++;
    _this = (cov_1sddp9v35b().b[7][0]++, _super.call(this, $elem, editor, dropListConf)) || (cov_1sddp9v35b().b[7][1]++, this);
    cov_1sddp9v35b().s[24]++;
    return _this;
  }

  cov_1sddp9v35b().s[25]++;

  List.prototype.command = function (value) {
    cov_1sddp9v35b().f[10]++;
    var editor = (cov_1sddp9v35b().s[26]++, this.editor);
    var $textElem = (cov_1sddp9v35b().s[27]++, editor.$textElem);
    cov_1sddp9v35b().s[28]++;
    editor.selection.restoreSelection(); // 判断是否已经执行了命令

    cov_1sddp9v35b().s[29]++;

    if (editor.cmd.queryCommandState(value)) {
      cov_1sddp9v35b().b[8][0]++;
      cov_1sddp9v35b().s[30]++;
      return;
    } else {
      cov_1sddp9v35b().b[8][1]++;
    } //禁止在table中添加列表


    var $selectionElem = (cov_1sddp9v35b().s[31]++, dom_core_1["default"](editor.selection.getSelectionContainerElem()));
    var $dom = (cov_1sddp9v35b().s[32]++, dom_core_1["default"]($selectionElem.elems[0]).parentUntil('TABLE', $selectionElem.elems[0]));
    cov_1sddp9v35b().s[33]++;

    if ((cov_1sddp9v35b().b[10][0]++, $dom) && (cov_1sddp9v35b().b[10][1]++, dom_core_1["default"]($dom.elems[0]).getNodeName() === 'TABLE')) {
      cov_1sddp9v35b().b[9][0]++;
      cov_1sddp9v35b().s[34]++;
      return;
    } else {
      cov_1sddp9v35b().b[9][1]++;
    }

    cov_1sddp9v35b().s[35]++;
    editor.cmd["do"](value); // 验证列表是否被包裹在 <p> 之内

    cov_1sddp9v35b().s[36]++;

    if ($selectionElem.getNodeName() === 'LI') {
      cov_1sddp9v35b().b[11][0]++;
      cov_1sddp9v35b().s[37]++;
      $selectionElem = $selectionElem.parent();
    } else {
      cov_1sddp9v35b().b[11][1]++;
    }

    cov_1sddp9v35b().s[38]++;

    if (/^ol|ul$/i.test($selectionElem.getNodeName()) === false) {
      cov_1sddp9v35b().b[12][0]++;
      cov_1sddp9v35b().s[39]++;
      return;
    } else {
      cov_1sddp9v35b().b[12][1]++;
    }

    cov_1sddp9v35b().s[40]++;

    if ($selectionElem.equal($textElem)) {
      cov_1sddp9v35b().b[13][0]++;
      cov_1sddp9v35b().s[41]++;
      // 证明是顶级标签，没有被 <p> 包裹
      return;
    } else {
      cov_1sddp9v35b().b[13][1]++;
    }

    var $parent = (cov_1sddp9v35b().s[42]++, $selectionElem.parent());
    cov_1sddp9v35b().s[43]++;

    if ($parent.equal($textElem)) {
      cov_1sddp9v35b().b[14][0]++;
      cov_1sddp9v35b().s[44]++;
      // $parent 是顶级标签，不能删除
      return;
    } else {
      cov_1sddp9v35b().b[14][1]++;
    }

    cov_1sddp9v35b().s[45]++;
    $selectionElem.insertAfter($parent);
    cov_1sddp9v35b().s[46]++;
    $parent.remove(); // 恢复选区

    cov_1sddp9v35b().s[47]++;
    editor.selection.restoreSelection();
    cov_1sddp9v35b().s[48]++;
    this.tryChangeActive();
  };

  cov_1sddp9v35b().s[49]++;

  List.prototype.tryChangeActive = function () {
    cov_1sddp9v35b().f[11]++;
  };

  cov_1sddp9v35b().s[50]++;
  return List;
}(DropListMenu_1["default"]));
cov_1sddp9v35b().s[51]++;
exports["default"] = List;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 段落行高 LineHeight
 * @author lichunlin
 *
 */

var _interopRequireDefault = __webpack_require__(0);

var _indexOf = _interopRequireDefault(__webpack_require__(53));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_f0m6hnb45() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/index.ts";
  var hash = "c56eb7dcda82602c294a90767604445da21effa6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 19,
          column: 4
        }
      },
      "1": {
        start: {
          line: 8,
          column: 24
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 9,
          column: 8
        },
        end: {
          line: 11,
          column: 110
        }
      },
      "3": {
        start: {
          line: 10,
          column: 69
        },
        end: {
          line: 10,
          column: 85
        }
      },
      "4": {
        start: {
          line: 11,
          column: 30
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "5": {
        start: {
          line: 11,
          column: 47
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "6": {
        start: {
          line: 11,
          column: 95
        },
        end: {
          line: 11,
          column: 107
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 35
        }
      },
      "8": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "9": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 28
        }
      },
      "10": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 16,
          column: 45
        }
      },
      "11": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 93
        }
      },
      "12": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "13": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 62
        }
      },
      "14": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 62
        }
      },
      "15": {
        start: {
          line: 24,
          column: 21
        },
        end: {
          line: 24,
          column: 82
        }
      },
      "16": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "17": {
        start: {
          line: 26,
          column: 23
        },
        end: {
          line: 26,
          column: 67
        }
      },
      "18": {
        start: {
          line: 27,
          column: 13
        },
        end: {
          line: 27,
          column: 40
        }
      },
      "19": {
        start: {
          line: 28,
          column: 32
        },
        end: {
          line: 289,
          column: 25
        }
      },
      "20": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 34
        }
      },
      "21": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 24
        }
      },
      "22": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 149
        }
      },
      "23": {
        start: {
          line: 33,
          column: 29
        },
        end: {
          line: 33,
          column: 92
        }
      },
      "24": {
        start: {
          line: 34,
          column: 27
        },
        end: {
          line: 44,
          column: 9
        }
      },
      "25": {
        start: {
          line: 41,
          column: 16
        },
        end: {
          line: 41,
          column: 45
        }
      },
      "26": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 37
        }
      },
      "27": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 71
        }
      },
      "28": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "29": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 205,
          column: 6
        }
      },
      "30": {
        start: {
          line: 53,
          column: 20
        },
        end: {
          line: 53,
          column: 24
        }
      },
      "31": {
        start: {
          line: 55,
          column: 24
        },
        end: {
          line: 55,
          column: 93
        }
      },
      "32": {
        start: {
          line: 57,
          column: 25
        },
        end: {
          line: 57,
          column: 30
        }
      },
      "33": {
        start: {
          line: 58,
          column: 21
        },
        end: {
          line: 58,
          column: 32
        }
      },
      "34": {
        start: {
          line: 59,
          column: 17
        },
        end: {
          line: 59,
          column: 19
        }
      },
      "35": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 44
        }
      },
      "36": {
        start: {
          line: 62,
          column: 29
        },
        end: {
          line: 62,
          column: 93
        }
      },
      "37": {
        start: {
          line: 63,
          column: 28
        },
        end: {
          line: 63,
          column: 92
        }
      },
      "38": {
        start: {
          line: 65,
          column: 18
        },
        end: {
          line: 65,
          column: 87
        }
      },
      "39": {
        start: {
          line: 67,
          column: 20
        },
        end: {
          line: 67,
          column: 22
        }
      },
      "40": {
        start: {
          line: 68,
          column: 24
        },
        end: {
          line: 68,
          column: 26
        }
      },
      "41": {
        start: {
          line: 70,
          column: 23
        },
        end: {
          line: 70,
          column: 25
        }
      },
      "42": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 158,
          column: 9
        }
      },
      "43": {
        start: {
          line: 73,
          column: 23
        },
        end: {
          line: 73,
          column: 39
        }
      },
      "44": {
        start: {
          line: 74,
          column: 12
        },
        end: {
          line: 77,
          column: 13
        }
      },
      "45": {
        start: {
          line: 76,
          column: 16
        },
        end: {
          line: 76,
          column: 23
        }
      },
      "46": {
        start: {
          line: 79,
          column: 31
        },
        end: {
          line: 79,
          column: 33
        }
      },
      "47": {
        start: {
          line: 80,
          column: 29
        },
        end: {
          line: 80,
          column: 31
        }
      },
      "48": {
        start: {
          line: 81,
          column: 29
        },
        end: {
          line: 81,
          column: 31
        }
      },
      "49": {
        start: {
          line: 83,
          column: 30
        },
        end: {
          line: 83,
          column: 90
        }
      },
      "50": {
        start: {
          line: 84,
          column: 28
        },
        end: {
          line: 84,
          column: 86
        }
      },
      "51": {
        start: {
          line: 85,
          column: 28
        },
        end: {
          line: 85,
          column: 137
        }
      },
      "52": {
        start: {
          line: 86,
          column: 12
        },
        end: {
          line: 86,
          column: 63
        }
      },
      "53": {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 94,
          column: 15
        }
      },
      "54": {
        start: {
          line: 88,
          column: 16
        },
        end: {
          line: 90,
          column: 17
        }
      },
      "55": {
        start: {
          line: 89,
          column: 20
        },
        end: {
          line: 89,
          column: 45
        }
      },
      "56": {
        start: {
          line: 91,
          column: 16
        },
        end: {
          line: 93,
          column: 17
        }
      },
      "57": {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 45
        }
      },
      "58": {
        start: {
          line: 96,
          column: 20
        },
        end: {
          line: 96,
          column: 21
        }
      },
      "59": {
        start: {
          line: 97,
          column: 20
        },
        end: {
          line: 97,
          column: 26
        }
      },
      "60": {
        start: {
          line: 98,
          column: 12
        },
        end: {
          line: 98,
          column: 63
        }
      },
      "61": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 109,
          column: 13
        }
      },
      "62": {
        start: {
          line: 100,
          column: 16
        },
        end: {
          line: 100,
          column: 82
        }
      },
      "63": {
        start: {
          line: 101,
          column: 16
        },
        end: {
          line: 107,
          column: 17
        }
      },
      "64": {
        start: {
          line: 102,
          column: 20
        },
        end: {
          line: 102,
          column: 39
        }
      },
      "65": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 103,
          column: 39
        }
      },
      "66": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 39
        }
      },
      "67": {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 20
        }
      },
      "68": {
        start: {
          line: 111,
          column: 12
        },
        end: {
          line: 129,
          column: 13
        }
      },
      "69": {
        start: {
          line: 112,
          column: 16
        },
        end: {
          line: 112,
          column: 22
        }
      },
      "70": {
        start: {
          line: 114,
          column: 16
        },
        end: {
          line: 119,
          column: 17
        }
      },
      "71": {
        start: {
          line: 114,
          column: 29
        },
        end: {
          line: 114,
          column: 30
        }
      },
      "72": {
        start: {
          line: 115,
          column: 20
        },
        end: {
          line: 118,
          column: 21
        }
      },
      "73": {
        start: {
          line: 116,
          column: 24
        },
        end: {
          line: 116,
          column: 30
        }
      },
      "74": {
        start: {
          line: 117,
          column: 24
        },
        end: {
          line: 117,
          column: 30
        }
      },
      "75": {
        start: {
          line: 121,
          column: 16
        },
        end: {
          line: 123,
          column: 17
        }
      },
      "76": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 27
        }
      },
      "77": {
        start: {
          line: 124,
          column: 25
        },
        end: {
          line: 124,
          column: 26
        }
      },
      "78": {
        start: {
          line: 125,
          column: 16
        },
        end: {
          line: 128,
          column: 17
        }
      },
      "79": {
        start: {
          line: 126,
          column: 20
        },
        end: {
          line: 126,
          column: 39
        }
      },
      "80": {
        start: {
          line: 127,
          column: 20
        },
        end: {
          line: 127,
          column: 25
        }
      },
      "81": {
        start: {
          line: 131,
          column: 12
        },
        end: {
          line: 131,
          column: 76
        }
      },
      "82": {
        start: {
          line: 133,
          column: 12
        },
        end: {
          line: 152,
          column: 15
        }
      },
      "83": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 51
        }
      },
      "84": {
        start: {
          line: 135,
          column: 16
        },
        end: {
          line: 135,
          column: 58
        }
      },
      "85": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 136,
          column: 30
        }
      },
      "86": {
        start: {
          line: 137,
          column: 16
        },
        end: {
          line: 151,
          column: 17
        }
      },
      "87": {
        start: {
          line: 139,
          column: 20
        },
        end: {
          line: 141,
          column: 72
        }
      },
      "88": {
        start: {
          line: 142,
          column: 20
        },
        end: {
          line: 144,
          column: 207
        }
      },
      "89": {
        start: {
          line: 147,
          column: 20
        },
        end: {
          line: 147,
          column: 64
        }
      },
      "90": {
        start: {
          line: 148,
          column: 20
        },
        end: {
          line: 150,
          column: 207
        }
      },
      "91": {
        start: {
          line: 153,
          column: 12
        },
        end: {
          line: 153,
          column: 36
        }
      },
      "92": {
        start: {
          line: 155,
          column: 12
        },
        end: {
          line: 155,
          column: 41
        }
      },
      "93": {
        start: {
          line: 156,
          column: 12
        },
        end: {
          line: 156,
          column: 88
        }
      },
      "94": {
        start: {
          line: 157,
          column: 12
        },
        end: {
          line: 157,
          column: 19
        }
      },
      "95": {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 160,
          column: 31
        }
      },
      "96": {
        start: {
          line: 162,
          column: 8
        },
        end: {
          line: 164,
          column: 9
        }
      },
      "97": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 163,
          column: 19
        }
      },
      "98": {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 42
        }
      },
      "99": {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 166,
          column: 50
        }
      },
      "100": {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 168,
          column: 95
        }
      },
      "101": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 37
        }
      },
      "102": {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 187,
          column: 9
        }
      },
      "103": {
        start: {
          line: 173,
          column: 12
        },
        end: {
          line: 185,
          column: 13
        }
      },
      "104": {
        start: {
          line: 174,
          column: 16
        },
        end: {
          line: 174,
          column: 59
        }
      },
      "105": {
        start: {
          line: 176,
          column: 16
        },
        end: {
          line: 183,
          column: 17
        }
      },
      "106": {
        start: {
          line: 177,
          column: 20
        },
        end: {
          line: 179,
          column: 45
        }
      },
      "107": {
        start: {
          line: 182,
          column: 20
        },
        end: {
          line: 182,
          column: 199
        }
      },
      "108": {
        start: {
          line: 184,
          column: 16
        },
        end: {
          line: 184,
          column: 40
        }
      },
      "109": {
        start: {
          line: 186,
          column: 12
        },
        end: {
          line: 186,
          column: 19
        }
      },
      "110": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 194,
          column: 9
        }
      },
      "111": {
        start: {
          line: 190,
          column: 12
        },
        end: {
          line: 190,
          column: 88
        }
      },
      "112": {
        start: {
          line: 193,
          column: 12
        },
        end: {
          line: 193,
          column: 52
        }
      },
      "113": {
        start: {
          line: 195,
          column: 8
        },
        end: {
          line: 197,
          column: 33
        }
      },
      "114": {
        start: {
          line: 199,
          column: 8
        },
        end: {
          line: 204,
          column: 9
        }
      },
      "115": {
        start: {
          line: 200,
          column: 12
        },
        end: {
          line: 200,
          column: 62
        }
      },
      "116": {
        start: {
          line: 203,
          column: 12
        },
        end: {
          line: 203,
          column: 36
        }
      },
      "117": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 226,
          column: 6
        }
      },
      "118": {
        start: {
          line: 211,
          column: 18
        },
        end: {
          line: 211,
          column: 50
        }
      },
      "119": {
        start: {
          line: 212,
          column: 8
        },
        end: {
          line: 214,
          column: 9
        }
      },
      "120": {
        start: {
          line: 213,
          column: 12
        },
        end: {
          line: 213,
          column: 23
        }
      },
      "121": {
        start: {
          line: 216,
          column: 26
        },
        end: {
          line: 216,
          column: 62
        }
      },
      "122": {
        start: {
          line: 217,
          column: 12
        },
        end: {
          line: 222,
          column: 13
        }
      },
      "123": {
        start: {
          line: 218,
          column: 16
        },
        end: {
          line: 218,
          column: 29
        }
      },
      "124": {
        start: {
          line: 221,
          column: 16
        },
        end: {
          line: 221,
          column: 63
        }
      },
      "125": {
        start: {
          line: 224,
          column: 8
        },
        end: {
          line: 224,
          column: 46
        }
      },
      "126": {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 225,
          column: 19
        }
      },
      "127": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 233,
          column: 6
        }
      },
      "128": {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 232,
          column: 46
        }
      },
      "129": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 245,
          column: 6
        }
      },
      "130": {
        start: {
          line: 238,
          column: 23
        },
        end: {
          line: 238,
          column: 25
        }
      },
      "131": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 243,
          column: 11
        }
      },
      "132": {
        start: {
          line: 240,
          column: 12
        },
        end: {
          line: 242,
          column: 21
        }
      },
      "133": {
        start: {
          line: 244,
          column: 8
        },
        end: {
          line: 244,
          column: 24
        }
      },
      "134": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 266,
          column: 6
        }
      },
      "135": {
        start: {
          line: 250,
          column: 21
        },
        end: {
          line: 250,
          column: 32
        }
      },
      "136": {
        start: {
          line: 251,
          column: 24
        },
        end: {
          line: 251,
          column: 93
        }
      },
      "137": {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 253,
          column: 90
        }
      },
      "138": {
        start: {
          line: 254,
          column: 20
        },
        end: {
          line: 254,
          column: 42
        }
      },
      "139": {
        start: {
          line: 255,
          column: 19
        },
        end: {
          line: 255,
          column: 27
        }
      },
      "140": {
        start: {
          line: 256,
          column: 18
        },
        end: {
          line: 256,
          column: 24
        }
      },
      "141": {
        start: {
          line: 257,
          column: 8
        },
        end: {
          line: 257,
          column: 32
        }
      },
      "142": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 29
        }
      },
      "143": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 259,
          column: 88
        }
      },
      "144": {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 261,
          column: 37
        }
      },
      "145": {
        start: {
          line: 263,
          column: 8
        },
        end: {
          line: 263,
          column: 90
        }
      },
      "146": {
        start: {
          line: 265,
          column: 8
        },
        end: {
          line: 265,
          column: 44
        }
      },
      "147": {
        start: {
          line: 270,
          column: 4
        },
        end: {
          line: 287,
          column: 6
        }
      },
      "148": {
        start: {
          line: 271,
          column: 21
        },
        end: {
          line: 271,
          column: 32
        }
      },
      "149": {
        start: {
          line: 272,
          column: 29
        },
        end: {
          line: 272,
          column: 73
        }
      },
      "150": {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 276,
          column: 9
        }
      },
      "151": {
        start: {
          line: 275,
          column: 12
        },
        end: {
          line: 275,
          column: 19
        }
      },
      "152": {
        start: {
          line: 277,
          column: 18
        },
        end: {
          line: 277,
          column: 78
        }
      },
      "153": {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 278,
          column: 40
        }
      },
      "154": {
        start: {
          line: 279,
          column: 20
        },
        end: {
          line: 279,
          column: 78
        }
      },
      "155": {
        start: {
          line: 281,
          column: 8
        },
        end: {
          line: 286,
          column: 9
        }
      },
      "156": {
        start: {
          line: 282,
          column: 12
        },
        end: {
          line: 282,
          column: 26
        }
      },
      "157": {
        start: {
          line: 285,
          column: 12
        },
        end: {
          line: 285,
          column: 28
        }
      },
      "158": {
        start: {
          line: 288,
          column: 4
        },
        end: {
          line: 288,
          column: 22
        }
      },
      "159": {
        start: {
          line: 290,
          column: 0
        },
        end: {
          line: 290,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 45
          },
          end: {
            line: 7,
            column: 46
          }
        },
        loc: {
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 25
          }
        },
        loc: {
          start: {
            line: 8,
            column: 40
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 52
          }
        },
        loc: {
          start: {
            line: 10,
            column: 67
          },
          end: {
            line: 10,
            column: 87
          }
        },
        line: 10
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 13
          }
        },
        loc: {
          start: {
            line: 11,
            column: 28
          },
          end: {
            line: 11,
            column: 109
          }
        },
        line: 11
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 14,
            column: 11
          },
          end: {
            line: 14,
            column: 12
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 14
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 47
          }
        },
        line: 16
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 20,
            column: 57
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 20
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 33
          }
        },
        loc: {
          start: {
            line: 28,
            column: 50
          },
          end: {
            line: 289,
            column: 1
          }
        },
        line: 28
      },
      "8": {
        name: "LineHeight",
        decl: {
          start: {
            line: 30,
            column: 13
          },
          end: {
            line: 30,
            column: 23
          }
        },
        loc: {
          start: {
            line: 30,
            column: 32
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 30
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 39,
            column: 26
          },
          end: {
            line: 39,
            column: 27
          }
        },
        loc: {
          start: {
            line: 39,
            column: 43
          },
          end: {
            line: 43,
            column: 13
          }
        },
        line: 39
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 52,
            column: 35
          },
          end: {
            line: 52,
            column: 36
          }
        },
        loc: {
          start: {
            line: 52,
            column: 52
          },
          end: {
            line: 205,
            column: 5
          }
        },
        line: 52
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 87,
            column: 84
          },
          end: {
            line: 87,
            column: 85
          }
        },
        loc: {
          start: {
            line: 87,
            column: 107
          },
          end: {
            line: 94,
            column: 13
          }
        },
        line: 87
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 133,
            column: 31
          },
          end: {
            line: 133,
            column: 32
          }
        },
        loc: {
          start: {
            line: 133,
            column: 47
          },
          end: {
            line: 152,
            column: 13
          }
        },
        line: 133
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 210,
            column: 34
          },
          end: {
            line: 210,
            column: 35
          }
        },
        loc: {
          start: {
            line: 210,
            column: 49
          },
          end: {
            line: 226,
            column: 5
          }
        },
        line: 210
      },
      "14": {
        name: "getParentNode",
        decl: {
          start: {
            line: 215,
            column: 17
          },
          end: {
            line: 215,
            column: 30
          }
        },
        loc: {
          start: {
            line: 215,
            column: 46
          },
          end: {
            line: 223,
            column: 9
          }
        },
        line: 215
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 231,
            column: 34
          },
          end: {
            line: 231,
            column: 35
          }
        },
        loc: {
          start: {
            line: 231,
            column: 62
          },
          end: {
            line: 233,
            column: 5
          }
        },
        line: 231
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 237,
            column: 43
          },
          end: {
            line: 237,
            column: 44
          }
        },
        loc: {
          start: {
            line: 237,
            column: 64
          },
          end: {
            line: 245,
            column: 5
          }
        },
        line: 237
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 239,
            column: 26
          },
          end: {
            line: 239,
            column: 27
          }
        },
        loc: {
          start: {
            line: 239,
            column: 42
          },
          end: {
            line: 243,
            column: 9
          }
        },
        line: 239
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 249,
            column: 36
          },
          end: {
            line: 249,
            column: 37
          }
        },
        loc: {
          start: {
            line: 249,
            column: 64
          },
          end: {
            line: 266,
            column: 5
          }
        },
        line: 249
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 270,
            column: 43
          },
          end: {
            line: 270,
            column: 44
          }
        },
        loc: {
          start: {
            line: 270,
            column: 55
          },
          end: {
            line: 287,
            column: 5
          }
        },
        line: 270
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 19,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 21
          }
        }, {
          start: {
            line: 7,
            column: 25
          },
          end: {
            line: 7,
            column: 39
          }
        }, {
          start: {
            line: 7,
            column: 44
          },
          end: {
            line: 19,
            column: 4
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 11,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 9,
            column: 24
          },
          end: {
            line: 9,
            column: 45
          }
        }, {
          start: {
            line: 10,
            column: 13
          },
          end: {
            line: 10,
            column: 47
          }
        }, {
          start: {
            line: 10,
            column: 51
          },
          end: {
            line: 10,
            column: 87
          }
        }, {
          start: {
            line: 11,
            column: 12
          },
          end: {
            line: 11,
            column: 109
          }
        }],
        line: 9
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }, {
          start: {
            line: 11,
            column: 47
          },
          end: {
            line: 11,
            column: 107
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 17,
            column: 22
          },
          end: {
            line: 17,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 17,
            column: 35
          },
          end: {
            line: 17,
            column: 51
          }
        }, {
          start: {
            line: 17,
            column: 55
          },
          end: {
            line: 17,
            column: 91
          }
        }],
        line: 17
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 22
          },
          end: {
            line: 22,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 23
          },
          end: {
            line: 20,
            column: 27
          }
        }, {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 51
          }
        }, {
          start: {
            line: 20,
            column: 56
          },
          end: {
            line: 22,
            column: 1
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 21,
            column: 11
          },
          end: {
            line: 21,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 37
          },
          end: {
            line: 21,
            column: 40
          }
        }, {
          start: {
            line: 21,
            column: 43
          },
          end: {
            line: 21,
            column: 61
          }
        }],
        line: 21
      },
      "6": {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 33
          }
        }],
        line: 21
      },
      "7": {
        loc: {
          start: {
            line: 45,
            column: 16
          },
          end: {
            line: 45,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 16
          },
          end: {
            line: 45,
            column: 62
          }
        }, {
          start: {
            line: 45,
            column: 66
          },
          end: {
            line: 45,
            column: 70
          }
        }],
        line: 45
      },
      "8": {
        loc: {
          start: {
            line: 55,
            column: 24
          },
          end: {
            line: 55,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 46
          },
          end: {
            line: 55,
            column: 67
          }
        }, {
          start: {
            line: 55,
            column: 70
          },
          end: {
            line: 55,
            column: 93
          }
        }],
        line: 55
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 72,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 72,
            column: 26
          }
        }, {
          start: {
            line: 72,
            column: 30
          },
          end: {
            line: 72,
            column: 68
          }
        }],
        line: 72
      },
      "11": {
        loc: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 77,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 77,
            column: 13
          }
        }, {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 77,
            column: 13
          }
        }],
        line: 74
      },
      "12": {
        loc: {
          start: {
            line: 85,
            column: 28
          },
          end: {
            line: 85,
            column: 137
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 91
          },
          end: {
            line: 85,
            column: 97
          }
        }, {
          start: {
            line: 85,
            column: 100
          },
          end: {
            line: 85,
            column: 137
          }
        }],
        line: 85
      },
      "13": {
        loc: {
          start: {
            line: 85,
            column: 28
          },
          end: {
            line: 85,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 28
          },
          end: {
            line: 85,
            column: 71
          }
        }, {
          start: {
            line: 85,
            column: 75
          },
          end: {
            line: 85,
            column: 88
          }
        }],
        line: 85
      },
      "14": {
        loc: {
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 94,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 57
          },
          end: {
            line: 87,
            column: 63
          }
        }, {
          start: {
            line: 87,
            column: 66
          },
          end: {
            line: 94,
            column: 14
          }
        }],
        line: 87
      },
      "15": {
        loc: {
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 87,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 87,
            column: 30
          }
        }, {
          start: {
            line: 87,
            column: 34
          },
          end: {
            line: 87,
            column: 54
          }
        }],
        line: 87
      },
      "16": {
        loc: {
          start: {
            line: 88,
            column: 16
          },
          end: {
            line: 90,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 16
          },
          end: {
            line: 90,
            column: 17
          }
        }, {
          start: {
            line: 88,
            column: 16
          },
          end: {
            line: 90,
            column: 17
          }
        }],
        line: 88
      },
      "17": {
        loc: {
          start: {
            line: 91,
            column: 16
          },
          end: {
            line: 93,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 16
          },
          end: {
            line: 93,
            column: 17
          }
        }, {
          start: {
            line: 91,
            column: 16
          },
          end: {
            line: 93,
            column: 17
          }
        }],
        line: 91
      },
      "18": {
        loc: {
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 107,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 107,
            column: 17
          }
        }, {
          start: {
            line: 101,
            column: 16
          },
          end: {
            line: 107,
            column: 17
          }
        }],
        line: 101
      },
      "19": {
        loc: {
          start: {
            line: 111,
            column: 12
          },
          end: {
            line: 129,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 12
          },
          end: {
            line: 129,
            column: 13
          }
        }, {
          start: {
            line: 111,
            column: 12
          },
          end: {
            line: 129,
            column: 13
          }
        }],
        line: 111
      },
      "20": {
        loc: {
          start: {
            line: 115,
            column: 20
          },
          end: {
            line: 118,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 20
          },
          end: {
            line: 118,
            column: 21
          }
        }, {
          start: {
            line: 115,
            column: 20
          },
          end: {
            line: 118,
            column: 21
          }
        }],
        line: 115
      },
      "21": {
        loc: {
          start: {
            line: 121,
            column: 16
          },
          end: {
            line: 123,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 16
          },
          end: {
            line: 123,
            column: 17
          }
        }, {
          start: {
            line: 121,
            column: 16
          },
          end: {
            line: 123,
            column: 17
          }
        }],
        line: 121
      },
      "22": {
        loc: {
          start: {
            line: 135,
            column: 28
          },
          end: {
            line: 135,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 135,
            column: 36
          },
          end: {
            line: 135,
            column: 52
          }
        }, {
          start: {
            line: 135,
            column: 55
          },
          end: {
            line: 135,
            column: 57
          }
        }],
        line: 135
      },
      "23": {
        loc: {
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 151,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 151,
            column: 17
          }
        }, {
          start: {
            line: 137,
            column: 16
          },
          end: {
            line: 151,
            column: 17
          }
        }],
        line: 137
      },
      "24": {
        loc: {
          start: {
            line: 139,
            column: 20
          },
          end: {
            line: 141,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 140,
            column: 27
          },
          end: {
            line: 140,
            column: 103
          }
        }, {
          start: {
            line: 141,
            column: 27
          },
          end: {
            line: 141,
            column: 70
          }
        }],
        line: 139
      },
      "25": {
        loc: {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        }, {
          start: {
            line: 162,
            column: 8
          },
          end: {
            line: 164,
            column: 9
          }
        }],
        line: 162
      },
      "26": {
        loc: {
          start: {
            line: 166,
            column: 20
          },
          end: {
            line: 166,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 166,
            column: 28
          },
          end: {
            line: 166,
            column: 44
          }
        }, {
          start: {
            line: 166,
            column: 47
          },
          end: {
            line: 166,
            column: 49
          }
        }],
        line: 166
      },
      "27": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 168,
            column: 53
          },
          end: {
            line: 168,
            column: 59
          }
        }, {
          start: {
            line: 168,
            column: 62
          },
          end: {
            line: 168,
            column: 94
          }
        }],
        line: 168
      },
      "28": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 26
          }
        }, {
          start: {
            line: 168,
            column: 30
          },
          end: {
            line: 168,
            column: 50
          }
        }],
        line: 168
      },
      "29": {
        loc: {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        }, {
          start: {
            line: 172,
            column: 8
          },
          end: {
            line: 187,
            column: 9
          }
        }],
        line: 172
      },
      "30": {
        loc: {
          start: {
            line: 173,
            column: 12
          },
          end: {
            line: 185,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 12
          },
          end: {
            line: 185,
            column: 13
          }
        }, {
          start: {
            line: 173,
            column: 12
          },
          end: {
            line: 185,
            column: 13
          }
        }],
        line: 173
      },
      "31": {
        loc: {
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 183,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 183,
            column: 17
          }
        }, {
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 183,
            column: 17
          }
        }],
        line: 176
      },
      "32": {
        loc: {
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        }, {
          start: {
            line: 188,
            column: 8
          },
          end: {
            line: 194,
            column: 9
          }
        }],
        line: 188
      },
      "33": {
        loc: {
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        }, {
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 204,
            column: 9
          }
        }],
        line: 199
      },
      "34": {
        loc: {
          start: {
            line: 212,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 212,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        }, {
          start: {
            line: 212,
            column: 8
          },
          end: {
            line: 214,
            column: 9
          }
        }],
        line: 212
      },
      "35": {
        loc: {
          start: {
            line: 217,
            column: 12
          },
          end: {
            line: 222,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 12
          },
          end: {
            line: 222,
            column: 13
          }
        }, {
          start: {
            line: 217,
            column: 12
          },
          end: {
            line: 222,
            column: 13
          }
        }],
        line: 217
      },
      "36": {
        loc: {
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 242,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 241,
            column: 19
          },
          end: {
            line: 241,
            column: 51
          }
        }, {
          start: {
            line: 242,
            column: 18
          },
          end: {
            line: 242,
            column: 20
          }
        }],
        line: 240
      },
      "37": {
        loc: {
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 240,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 240,
            column: 12
          },
          end: {
            line: 240,
            column: 23
          }
        }, {
          start: {
            line: 240,
            column: 27
          },
          end: {
            line: 240,
            column: 61
          }
        }],
        line: 240
      },
      "38": {
        loc: {
          start: {
            line: 251,
            column: 24
          },
          end: {
            line: 251,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 251,
            column: 46
          },
          end: {
            line: 251,
            column: 67
          }
        }, {
          start: {
            line: 251,
            column: 70
          },
          end: {
            line: 251,
            column: 93
          }
        }],
        line: 251
      },
      "39": {
        loc: {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 253,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 253,
            column: 53
          },
          end: {
            line: 253,
            column: 59
          }
        }, {
          start: {
            line: 253,
            column: 62
          },
          end: {
            line: 253,
            column: 89
          }
        }],
        line: 253
      },
      "40": {
        loc: {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 253,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 253,
            column: 26
          }
        }, {
          start: {
            line: 253,
            column: 30
          },
          end: {
            line: 253,
            column: 50
          }
        }],
        line: 253
      },
      "41": {
        loc: {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 259,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 259,
            column: 53
          },
          end: {
            line: 259,
            column: 59
          }
        }, {
          start: {
            line: 259,
            column: 62
          },
          end: {
            line: 259,
            column: 87
          }
        }],
        line: 259
      },
      "42": {
        loc: {
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 259,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 259,
            column: 8
          },
          end: {
            line: 259,
            column: 26
          }
        }, {
          start: {
            line: 259,
            column: 30
          },
          end: {
            line: 259,
            column: 50
          }
        }],
        line: 259
      },
      "43": {
        loc: {
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 263,
            column: 53
          },
          end: {
            line: 263,
            column: 59
          }
        }, {
          start: {
            line: 263,
            column: 62
          },
          end: {
            line: 263,
            column: 89
          }
        }],
        line: 263
      },
      "44": {
        loc: {
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 263,
            column: 8
          },
          end: {
            line: 263,
            column: 26
          }
        }, {
          start: {
            line: 263,
            column: 30
          },
          end: {
            line: 263,
            column: 50
          }
        }],
        line: 263
      },
      "45": {
        loc: {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }, {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 276,
            column: 9
          }
        }],
        line: 273
      },
      "46": {
        loc: {
          start: {
            line: 273,
            column: 12
          },
          end: {
            line: 273,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 273,
            column: 12
          },
          end: {
            line: 273,
            column: 26
          }
        }, {
          start: {
            line: 273,
            column: 30
          },
          end: {
            line: 273,
            column: 68
          }
        }],
        line: 273
      },
      "47": {
        loc: {
          start: {
            line: 279,
            column: 20
          },
          end: {
            line: 279,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 279,
            column: 48
          },
          end: {
            line: 279,
            column: 73
          }
        }, {
          start: {
            line: 279,
            column: 76
          },
          end: {
            line: 279,
            column: 78
          }
        }],
        line: 279
      },
      "48": {
        loc: {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        }, {
          start: {
            line: 281,
            column: 8
          },
          end: {
            line: 286,
            column: 9
          }
        }],
        line: 281
      },
      "49": {
        loc: {
          start: {
            line: 281,
            column: 12
          },
          end: {
            line: 281,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 281,
            column: 12
          },
          end: {
            line: 281,
            column: 17
          }
        }, {
          start: {
            line: 281,
            column: 21
          },
          end: {
            line: 281,
            column: 56
          }
        }],
        line: 281
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/index.ts"],
      names: [],
      mappings: ";AAAA;;;;GAIG;;;;;;;;;;;;;;;;;;AAEH,mFAA4D;AAC5D,kEAAoD;AAGpD,oEAA6C;AAC7C,yCAAqC;AAErC;IAAyB,8BAAY;IACjC,oBAAY,MAAc;QAA1B,iBAoBC;QAnBG,IAAM,KAAK,GAAG,kBAAC,CACX,6GAEW,CACd,CAAA;QACD,IAAI,cAAc,GAAG,IAAI,wBAAc,CAAC,MAAM,EAAE,MAAM,CAAC,MAAM,CAAC,WAAW,CAAC,CAAA;QAC1E,IAAM,YAAY,GAAG;YACjB,KAAK,EAAE,GAAG;YACV,KAAK,EAAE,MAAM;YACb,IAAI,EAAE,MAAM;YACZ,IAAI,EAAE,cAAc,CAAC,WAAW,EAAE;YAClC,YAAY,EAAE,UAAC,KAAa;gBACxB,MAAM;gBACN,MAAM,CAAC,SAAS,CAAC,SAAS,EAAE,CAAA;gBAC5B,KAAI,CAAC,OAAO,CAAC,KAAK,CAAC,CAAA;YACvB,CAAC;SACJ,CAAA;QAED,QAAA,kBAAM,KAAK,EAAE,MAAM,EAAE,YAAY,CAAC,SAAA;;IACtC,CAAC;IAED;;;OAGG;IACI,4BAAO,GAAd,UAAe,KAAa;QAA5B,iBA+JC;;QA9JG,IAAI,SAAS,GAAG,MAAM,CAAC,YAAY,CAAC,CAAC,CAAC,MAAM,CAAC,YAAY,EAAE,CAAC,CAAC,CAAC,QAAQ,CAAC,YAAY,EAAE,CAAA;QACrF,SAAS;QACT,IAAM,UAAU,GAAa,CAAC,GAAG,CAAC,CAAA;QAClC,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,EAAE,GAAW,EAAE,CAAA;QACnB,MAAM;QACN,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QACnC,IAAM,cAAc,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAC,CAAA;QACtE,IAAM,aAAa,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAC,CAAA;QACrE,+CAA+C;QAC/C,IAAI,GAAG,GAAgB,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC3E,YAAY;QACZ,IAAI,KAAK,GAAkB,EAAE,CAAA;QAC7B,IAAI,SAAS,GAAa,EAAE,CAAA;QAC5B,oCAAoC;QACpC,IAAI,QAAQ,GAAW,EAAE,CAAA;QAEzB,QAAQ;QACR,IAAI,cAAc,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,cAAc,CAAC,EAAE;YAC1D,IAAI,IAAI,GAAG,SAAE,CAAC,IAAI,EAAE,CAAA;YACpB,IAAI,IAAI,EAAE;gBACN,iCAAiC;gBACjC,OAAM;aACT;YACD,2BAA2B;YAC3B,IAAI,YAAU,GAAkB,EAAE,CAAA;YAClC,IAAI,UAAU,GAAuB,EAAE,CAAA;YACvC,IAAI,UAAU,GAAuB,EAAE,CAAA;YACvC,kBAAkB;YAClB,IAAM,WAAS,GAAe,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;YACzE,IAAM,SAAO,GAAe,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,mBAAmB,EAAE,CAAC,CAAA;YACrE,IAAM,SAAS,SAAsC,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,0CAC1E,uBAAuB,CAAC,UAAU,CAAA;YACxC,UAAU,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,WAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAA;YAChD,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,OAAO,CAAC,UAAC,IAAI,EAAE,KAAK;gBAC3B,IAAI,IAAI,KAAK,KAAI,CAAC,MAAM,CAAC,WAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE;oBAC1C,YAAU,CAAC,IAAI,CAAC,KAAK,CAAC,CAAA;iBACzB;gBACD,IAAI,IAAI,KAAK,KAAI,CAAC,MAAM,CAAC,SAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE;oBACxC,YAAU,CAAC,IAAI,CAAC,KAAK,CAAC,CAAA;iBACzB;YACL,CAAC,EAAC;YACF,iBAAiB;YACjB,IAAI,CAAC,GAAG,CAAC,CAAA;YACT,IAAI,CAAC,SAAa,CAAA;YAClB,UAAU,CAAC,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,WAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAA;YAChD,OAAO,UAAU,CAAC,CAAC,CAAC,KAAK,IAAI,CAAC,MAAM,CAAC,SAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE;gBACpD,CAAC,GAAG,kBAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,kBAAkB,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;gBAChD,IAAI,UAAU,CAAC,OAAO,CAAC,kBAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,CAAC,KAAK,CAAC,CAAC,EAAE;oBAC/C,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAA;oBAClB,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAA;iBACrB;qBAAM;oBACH,UAAU,CAAC,IAAI,CAAC,CAAC,CAAC,CAAA;iBACrB;gBACD,CAAC,EAAE,CAAA;aACN;YAED,WAAW;YACX,IAAI,kBAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,GAAG,EAAE;gBACxC,CAAC,GAAG,CAAC,CAAA;gBACL,iBAAiB;gBACjB,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,UAAU,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;oBACxC,IAAI,kBAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,GAAG,EAAE;wBACxC,CAAC,GAAG,CAAC,CAAA;wBACL,MAAK;qBACR;iBACJ;gBACD,kBAAkB;gBAClB,IAAI,CAAC,KAAK,CAAC,EAAE;oBACT,OAAM;iBACT;gBACD,IAAI,EAAE,GAAG,CAAC,CAAA;gBACV,OAAO,EAAE,KAAK,CAAC,EAAE;oBACb,UAAU,CAAC,KAAK,EAAE,CAAA;oBAClB,EAAE,EAAE,CAAA;iBACP;aACJ;YACD,SAAS;YACT,IAAI,CAAC,QAAQ,CAAC,UAAU,CAAC,CAAC,CAAC,EAAE,UAAU,CAAC,UAAU,CAAC,MAAM,GAAG,CAAC,CAAC,CAAC,CAAA;YAC/D,qBAAqB;YACrB,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;gBACnB,KAAK,GAAG,IAAI,CAAC,YAAY,CAAC,OAAO,CAAC,CAAA;gBAClC,SAAS,GAAG,KAAK,CAAC,CAAC,CAAC,KAAK,CAAC,KAAK,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;gBACzC,QAAQ,GAAG,EAAE,CAAA;gBACb,IAAI,kBAAC,CAAC,IAAI,CAAC,CAAC,WAAW,EAAE,KAAK,GAAG,EAAE;oBAC/B,WAAW;oBACX,KAAK;wBACD,CAAC,CAAC,CAAC,QAAQ,GAAG,KAAI,CAAC,eAAe,CAAC,SAAS,CAAC,IAAG,iBAAe,KAAK,MAAG,CAAA,CAAC;wBACxE,CAAC,CAAC,CAAC,QAAQ,GAAG,KAAI,CAAC,eAAe,CAAC,SAAS,CAAC,CAAC,CAAA;oBAClD,EAAE;wBACE,EAAE;6BACF,MAAI,kBAAC,CAAC,IAAI,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,iBAAW,QAAQ,WACtD,IAAI,CAAC,SAAS,UACb,kBAAC,CAAC,IAAI,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,MAAG,CAAA,CAAA;iBAClD;qBAAM;oBACH,QAAQ,GAAG,KAAI,CAAC,eAAe,CAAC,SAAS,CAAC,CAAA;oBAC1C,EAAE;wBACE,EAAE;6BACF,MAAI,kBAAC,CAAC,IAAI,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,iBAAW,QAAQ,WACtD,IAAI,CAAC,SAAS,UACb,kBAAC,CAAC,IAAI,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,MAAG,CAAA,CAAA;iBAClD;YACL,CAAC,CAAC,CAAA;YACF,IAAI,CAAC,MAAM,CAAC,EAAE,EAAE,MAAM,CAAC,CAAA;YAEvB,UAAU;YACV,GAAG,GAAG,aAAa,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;YAC5B,IAAI,CAAC,QAAQ,CAAC,GAAG,CAAC,QAAQ,CAAC,YAAU,CAAC,CAAC,CAAC,CAAC,EAAE,GAAG,CAAC,QAAQ,CAAC,YAAU,CAAC,CAAC,CAAC,CAAC,CAAC,CAAA;YACvE,OAAM;SACT;QAED,wCAAwC;QACxC,GAAG,GAAG,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,CAAA;QAEtB,oBAAoB;QACpB,IAAI,UAAU,CAAC,OAAO,CAAC,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,CAAC,KAAK,CAAC,CAAC,EAAE;YACjD,OAAM;SACT;QACD,KAAK,GAAG,GAAG,CAAC,YAAY,CAAC,OAAO,CAAC,CAAA;QACjC,SAAS,GAAG,KAAK,CAAC,CAAC,CAAC,KAAK,CAAC,KAAK,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;QACzC,cAAc;QACd,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,iBAAiB,CAAC,GAAG,EAAC;QACjC,SAAS;QACT,MAAM,CAAC,SAAS,CAAC,SAAS,EAAE,CAAA;QAC5B,8BAA8B;QAC9B,IAAI,CAAC,KAAK,EAAE;YACR,IAAI,KAAK,EAAE;gBACP,QAAQ,GAAG,IAAI,CAAC,eAAe,CAAC,SAAS,CAAC,CAAA;gBAC1C,2BAA2B;gBAC3B,IAAI,QAAQ,KAAK,EAAE,EAAE;oBACjB,EAAE,GAAG,MAAI,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,SAAI,GAAG,CAAC,SAAS,UAAK,kBAAC,CAAC,GAAG,CAAC;yBAClE,WAAW,EAAE;yBACb,WAAW,EAAE,MAAG,CAAA;iBACxB;qBAAM;oBACH,EAAE,GAAG,MAAI,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,iBAAW,QAAQ,WAC1D,GAAG,CAAC,SAAS,UACZ,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,MAAG,CAAA;iBAC7C;gBACD,IAAI,CAAC,MAAM,CAAC,EAAE,EAAE,MAAM,CAAC,CAAA;aAC1B;YACD,OAAM;SACT;QACD,IAAI,KAAK,EAAE;YACP,qBAAqB;YACrB,QAAQ,GAAG,IAAI,CAAC,eAAe,CAAC,SAAS,CAAC,IAAG,iBAAe,KAAK,MAAG,CAAA,CAAA;SACvE;aAAM;YACH,QAAQ,GAAG,iBAAe,KAAK,MAAG,CAAA;SACrC;QACD,EAAE,GAAG,MAAI,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,CAAC,WAAW,EAAE,iBAAW,QAAQ,WAAK,GAAG,CAAC,SAAS,UAAK,kBAAC,CAAC,GAAG,CAAC;aACtF,WAAW,EAAE;aACb,WAAW,EAAE,MAAG,CAAA;QAErB,gBAAgB;QAChB,IAAI,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,EAAE,KAAK,YAAY,EAAE;YACvC,kBAAC,CAAC,GAAG,CAAC,CAAC,GAAG,CAAC,aAAa,EAAE,KAAK,CAAC,CAAA;SACnC;aAAM;YACH,IAAI,CAAC,MAAM,CAAC,EAAE,EAAE,MAAM,CAAC,CAAA;SAC1B;IACL,CAAC;IAED;;;OAGG;IACI,2BAAM,GAAb,UAAc,GAAgB;QAC1B,IAAI,GAAG,GAAgB,kBAAC,CAAC,GAAG,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QACtC,IAAI,CAAC,GAAG,CAAC,UAAU,EAAE;YACjB,OAAO,GAAG,CAAA;SACb;QACD,SAAS,aAAa,CAAC,KAAkB,EAAE,MAAc;YACrD,IAAM,OAAO,GAAG,kBAAC,CAAC,KAAK,CAAC,UAAU,CAAC,CAAA;YACnC,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,OAAO,CAAC,EAAE;gBACjC,OAAO,KAAK,CAAA;aACf;iBAAM;gBACH,OAAO,aAAa,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,MAAM,CAAC,CAAA;aACjD;QACL,CAAC;QACD,GAAG,GAAG,aAAa,CAAC,GAAG,EAAE,IAAI,CAAC,MAAM,CAAC,CAAA;QAErC,OAAO,GAAG,CAAA;IACd,CAAC;IAED;;;OAGG;IACI,2BAAM,GAAb,UAAc,QAAgB,EAAE,MAAc;QAC1C,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,QAAQ,CAAC,CAAA;IACzC,CAAC;IAED;;OAEG;IACI,oCAAe,GAAtB,UAAuB,SAAwB;QAC3C,IAAI,QAAQ,GAAG,EAAE,CAAA;QACjB,SAAS,CAAC,OAAO,CAAC,UAAA,IAAI;YAClB,IAAI,KAAK,EAAE,IAAI,IAAI,CAAC,OAAO,CAAC,aAAa,CAAC,KAAK,CAAC,CAAC;gBAC7C,CAAC,CAAC,CAAC,QAAQ,GAAG,QAAQ,GAAG,IAAI,GAAG,GAAG,CAAC;gBACpC,CAAC,CAAC,EAAE,CAAA;QACZ,CAAC,CAAC,CAAA;QACF,OAAO,QAAQ,CAAA;IACnB,CAAC;IAED;;OAEG;IACI,6BAAQ,GAAf,UAAgB,QAAc,EAAE,MAAY;QACxC,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,SAAS,GAAG,MAAM,CAAC,YAAY,CAAC,CAAC,CAAC,MAAM,CAAC,YAAY,EAAE,CAAC,CAAC,CAAC,QAAQ,CAAC,YAAY,EAAE,CAAA;QACrF,SAAS;QACT,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,eAAe,GAAE;QAC5B,IAAM,KAAK,GAAG,QAAQ,CAAC,WAAW,EAAE,CAAA;QACpC,IAAI,IAAI,GAAG,QAAQ,CAAA;QACnB,IAAI,GAAG,GAAG,MAAM,CAAA;QAChB,KAAK,CAAC,QAAQ,CAAC,IAAI,EAAE,CAAC,CAAC,CAAA;QACvB,KAAK,CAAC,MAAM,CAAC,GAAG,EAAE,CAAC,CAAC,CAAA;QACpB,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,QAAQ,CAAC,KAAK,EAAC;QAC1B,UAAU;QACV,MAAM,CAAC,SAAS,CAAC,SAAS,EAAE,CAAA;QAC5B,SAAS;QACT,SAAS,aAAT,SAAS,uBAAT,SAAS,CAAE,eAAe,GAAE;QAC5B,MAAM;QACN,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;IACvC,CAAC;IAED;;OAEG;IACI,oCAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACnE,IAAI,cAAc,IAAI,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,cAAc,CAAC,EAAE;YAC1D,UAAU;YACV,OAAM;SACT;QACD,IAAI,GAAG,GAA6B,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;QAC/E,GAAG,GAAG,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QAC/B,IAAI,KAAK,GAAkB,GAAG,CAAC,YAAY,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,YAAY,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;QAErF,yBAAyB;QACzB,IAAI,KAAK,IAAI,KAAK,CAAC,OAAO,CAAC,aAAa,CAAC,KAAK,CAAC,CAAC,EAAE;YAC9C,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,iBAAC;AAAD,CAAC,AAlRD,CAAyB,sBAAY,GAkRpC;AAED,kBAAe,UAAU,CAAA",
      sourcesContent: ["/**\n * @description \u6BB5\u843D\u884C\u9AD8 LineHeight\n * @author lichunlin\n *\n */\n\nimport DropListMenu from '../menu-constructors/DropListMenu'\nimport $, { DomElement } from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport lineHeightList from './lineHeightList'\nimport { UA } from '../../utils/util'\n\nclass LineHeight extends DropListMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                    <i class=\"w-e-icon-row-height\"></i>\n                </div>`\n        )\n        let lineHeightMenu = new lineHeightList(editor, editor.config.lineHeights)\n        const DropListMenu = {\n            width: 100,\n            title: '\u8BBE\u7F6E\u884C\u9AD8',\n            type: 'list', // droplist \u4EE5\u5217\u8868\u5F62\u5F0F\u5C55\u793A\n            list: lineHeightMenu.getItemList(),\n            clickHandler: (value: string) => {\n                //\u4FDD\u5B58\u7126\u70B9\n                editor.selection.saveRange()\n                this.command(value)\n            },\n        }\n\n        super($elem, editor, DropListMenu)\n    }\n\n    /**\n     * \u6267\u884C\u547D\u4EE4\n     * @param value value\n     */\n    public command(value: string): void {\n        let selection = window.getSelection ? window.getSelection() : document.getSelection()\n        //\u5141\u8BB8\u8BBE\u7F6Edom\n        const allowArray: string[] = ['P']\n        const editor = this.editor\n        let st: string = ''\n        //\u6062\u590D\u7126\u70B9\n        editor.selection.restoreSelection()\n        const $selectionElem = $(editor.selection.getSelectionContainerElem())\n        const $selectionAll = $(editor.selection.getSelectionContainerElem())\n        // let dom:HTMLElement= $selectionElem.elems[0]\n        let dom: HTMLElement = $(editor.selection.getSelectionStartElem()).elems[0]\n        //\u83B7\u53D6\u5143\u7D20\u7684style\n        let style: string | null = ''\n        let styleList: string[] = []\n        //\u70B9\u51FB\u9ED8\u8BA4\u7684\u65F6\u5019\u5220\u9664line-height\u5C5E\u6027 \u5E76\u91CD\u65B0\u8BBE\u7F6E style\n        let styleStr: string = ''\n\n        //\u9009\u4E2D\u591A\u884C\u64CD\u4F5C\n        if ($selectionElem && editor.$textElem.equal($selectionElem)) {\n            let isIE = UA.isIE()\n            if (isIE) {\n                // ie\u4E0B\u7981\u6B62\u591A\u884C\u64CD\u4F5C \u907F\u514D\u591A\u884C\u9020\u6210\u9664\u7B2C\u4E00\u884C\u5916\u7684\u6BB5\u843D\u5185\u5BB9\u90FD\u88AB\u5220\u9664\n                return\n            }\n            //\u83B7\u53D6range \u5F00\u5934\u7ED3\u675F\u7684dom\u5728 \u7956\u7236\u5143\u7D20\u7684\u4E0B\u6807\n            let indexStore: Array<number> = []\n            let arrayDom_a: Array<HTMLElement> = []\n            let arrayDom_b: Array<HTMLElement> = []\n            //\u83B7\u53D6range \u5F00\u5934\u7ED3\u675F\u7684dom\n            const StartElem: DomElement = $(editor.selection.getSelectionStartElem())\n            const EndElem: DomElement = $(editor.selection.getSelectionEndElem())\n            const childList: NodeListOf<ChildNode> | undefined = editor.selection.getRange()\n                ?.commonAncestorContainer.childNodes\n            arrayDom_a.push(this.getDom(StartElem.elems[0]))\n            childList?.forEach((item, index) => {\n                if (item === this.getDom(StartElem.elems[0])) {\n                    indexStore.push(index)\n                }\n                if (item === this.getDom(EndElem.elems[0])) {\n                    indexStore.push(index)\n                }\n            })\n            //\u904D\u5386 \u83B7\u53D6\u5934\u5C3E\u4E4B\u95F4\u7684dom\u5143\u7D20\n            let i = 0\n            let d: HTMLElement\n            arrayDom_b.push(this.getDom(StartElem.elems[0]))\n            while (arrayDom_a[i] !== this.getDom(EndElem.elems[0])) {\n                d = $(arrayDom_a[i].nextElementSibling).elems[0]\n                if (allowArray.indexOf($(d).getNodeName()) !== -1) {\n                    arrayDom_b.push(d)\n                    arrayDom_a.push(d)\n                } else {\n                    arrayDom_a.push(d)\n                }\n                i++\n            }\n\n            //\u8BBE\u7F6E\u6BB5\u843D\u9009\u53D6 \u5168\u9009\n            if ($(arrayDom_a[0]).getNodeName() !== 'P') {\n                i = 0\n                //\u904D\u5386\u96C6\u5408\u5F97\u5230\u7B2C\u4E00\u4E2Ap\u6807\u7B7E\u7684\u4E0B\u6807\n                for (var k = 0; k < arrayDom_a.length; k++) {\n                    if ($(arrayDom_a[k]).getNodeName() === 'P') {\n                        i = k\n                        break\n                    }\n                }\n                //i===0 \u8BF4\u660E\u9009\u533A\u4E2D\u6CA1\u6709p\u6BB5\u843D\n                if (i === 0) {\n                    return\n                }\n                let _i = 0\n                while (_i !== i) {\n                    arrayDom_a.shift()\n                    _i++\n                }\n            }\n            //\u8BBE\u7F6E\u66FF\u6362\u7684\u9009\u533A\n            this.setRange(arrayDom_a[0], arrayDom_a[arrayDom_a.length - 1])\n            //\u751F\u6210innerHtml html\u5B57\u7B26\u4E32\n            arrayDom_a.forEach(item => {\n                style = item.getAttribute('style')\n                styleList = style ? style.split(';') : []\n                styleStr = ''\n                if ($(item).getNodeName() === 'P') {\n                    //\u5224\u65AD\u662F\u5426 \u70B9\u51FB\u9ED8\u8BA4\n                    value\n                        ? (styleStr = this.styleProcessing(styleList) + `line-height:${value};`)\n                        : (styleStr = this.styleProcessing(styleList))\n                    st =\n                        st +\n                        `<${$(item).getNodeName().toLowerCase()} style=\"${styleStr}\">${\n                            item.innerHTML\n                        }</${$(item).getNodeName().toLowerCase()}>`\n                } else {\n                    styleStr = this.styleProcessing(styleList)\n                    st =\n                        st +\n                        `<${$(item).getNodeName().toLowerCase()} style=\"${styleStr}\">${\n                            item.innerHTML\n                        }</${$(item).getNodeName().toLowerCase()}>`\n                }\n            })\n            this.action(st, editor)\n\n            //\u6062\u590D\u5DF2\u9009\u62E9\u7684\u9009\u533A\n            dom = $selectionAll.elems[0]\n            this.setRange(dom.children[indexStore[0]], dom.children[indexStore[1]])\n            return\n        }\n\n        //\u904D\u5386dom \u83B7\u53D6\u7956\u7236\u5143\u7D20 \u76F4\u5230contenteditable\u5C5E\u6027\u7684div\u6807\u7B7E\n        dom = this.getDom(dom)\n\n        //\u6821\u9A8C\u5141\u8BB8lineheight\u8BBE\u7F6E\u6807\u7B7E\n        if (allowArray.indexOf($(dom).getNodeName()) === -1) {\n            return\n        }\n        style = dom.getAttribute('style')\n        styleList = style ? style.split(';') : []\n        //\u5168\u9009 dom\u4E0B\u6240\u6709\u7684\u5185\u5BB9\n        selection?.selectAllChildren(dom)\n        //\u4FDD\u5B58range\n        editor.selection.saveRange()\n        //\u5224\u65AD\u662F\u5426\u5B58\u5728value \u9ED8\u8BA4 \u79FB\u9664line-height\n        if (!value) {\n            if (style) {\n                styleStr = this.styleProcessing(styleList)\n                //\u907F\u514D\u6CA1\u6709\u5176\u5B83\u5C5E\u6027 \u53EA\u7559\u4E0B \u2018style\u2019 \u51CF\u5C11\u4EE3\u7801\n                if (styleStr === '') {\n                    st = `<${$(dom).getNodeName().toLowerCase()}>${dom.innerHTML}</${$(dom)\n                        .getNodeName()\n                        .toLowerCase()}>`\n                } else {\n                    st = `<${$(dom).getNodeName().toLowerCase()} style=\"${styleStr}\">${\n                        dom.innerHTML\n                    }</${$(dom).getNodeName().toLowerCase()}>`\n                }\n                this.action(st, editor)\n            }\n            return\n        }\n        if (style) {\n            //\u5B58\u5728style \u68C0\u7D22\u5176\u5B83style\u5C5E\u6027\n            styleStr = this.styleProcessing(styleList) + `line-height:${value};`\n        } else {\n            styleStr = `line-height:${value};`\n        }\n        st = `<${$(dom).getNodeName().toLowerCase()} style=\"${styleStr}\">${dom.innerHTML}</${$(dom)\n            .getNodeName()\n            .toLowerCase()}>`\n\n        //\u9632\u6B62BLOCKQUOTE\u53E0\u52A0\n        if ($(dom).getNodeName() === 'BLOCKQUOTE') {\n            $(dom).css('line-height', value)\n        } else {\n            this.action(st, editor)\n        }\n    }\n\n    /**\n     * \u904D\u5386dom \u83B7\u53D6\u7956\u7236\u5143\u7D20 \u76F4\u5230contenteditable\u5C5E\u6027\u7684div\u6807\u7B7E\n     *\n     */\n    public getDom(dom: HTMLElement): HTMLElement {\n        let DOM: HTMLElement = $(dom).elems[0]\n        if (!DOM.parentNode) {\n            return DOM\n        }\n        function getParentNode($node: HTMLElement, editor: Editor): HTMLElement {\n            const $parent = $($node.parentNode)\n            if (editor.$textElem.equal($parent)) {\n                return $node\n            } else {\n                return getParentNode($parent.elems[0], editor)\n            }\n        }\n        DOM = getParentNode(DOM, this.editor)\n\n        return DOM\n    }\n\n    /**\n     * \u6267\u884C document.execCommand\n     *\n     */\n    public action(html_str: string, editor: Editor): void {\n        editor.cmd.do('insertHTML', html_str)\n    }\n\n    /**\n     * style \u5904\u7406\n     */\n    public styleProcessing(styleList: Array<string>): string {\n        let styleStr = ''\n        styleList.forEach(item => {\n            item !== '' && item.indexOf('line-height') === -1\n                ? (styleStr = styleStr + item + ';')\n                : ''\n        })\n        return styleStr\n    }\n\n    /**\n     * \u6BB5\u843D\u5168\u9009 \u6BD4\u5982\uFF1A\u907F\u514D11\u53D8\u6210111\n     */\n    public setRange(startDom: Node, endDom: Node): void {\n        const editor = this.editor\n        let selection = window.getSelection ? window.getSelection() : document.getSelection()\n        //\u6E05\u9664\u6240\u6709\u7684\u9009\u533A\n        selection?.removeAllRanges()\n        const range = document.createRange()\n        let star = startDom\n        let end = endDom\n        range.setStart(star, 0)\n        range.setEnd(end, 1)\n        selection?.addRange(range)\n        //\u4FDD\u5B58\u8BBE\u7F6E\u597D\u7684\u9009\u533A\n        editor.selection.saveRange()\n        //\u6E05\u9664\u6240\u6709\u7684\u9009\u533A\n        selection?.removeAllRanges()\n        //\u6062\u590D\u9009\u533A\n        editor.selection.restoreSelection()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        const editor = this.editor\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n        if ($selectionElem && editor.$textElem.equal($selectionElem)) {\n            //\u907F\u514D\u9009\u4E2D\u591A\u884C\u8BBE\u7F6E\n            return\n        }\n        let dom: DomElement | HTMLElement = $(editor.selection.getSelectionStartElem())\n        dom = this.getDom(dom.elems[0])\n        let style: string | null = dom.getAttribute('style') ? dom.getAttribute('style') : ''\n\n        //\u5224\u65AD\u5F53\u524D\u6807\u7B7E\u662F\u5426\u5177\u6709line-height\u5C5E\u6027\n        if (style && style.indexOf('line-height') !== -1) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default LineHeight\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c56eb7dcda82602c294a90767604445da21effa6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_f0m6hnb45 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_f0m6hnb45();

var __extends = (cov_f0m6hnb45().s[0]++, (cov_f0m6hnb45().b[0][0]++, void 0) && (cov_f0m6hnb45().b[0][1]++, (void 0).__extends) || (cov_f0m6hnb45().b[0][2]++, function () {
  cov_f0m6hnb45().f[0]++;
  cov_f0m6hnb45().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_f0m6hnb45().f[1]++;
    cov_f0m6hnb45().s[2]++;
    _extendStatics = (cov_f0m6hnb45().b[1][0]++, _setPrototypeOf["default"]) || (cov_f0m6hnb45().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_f0m6hnb45().b[1][2]++, function (d, b) {
      cov_f0m6hnb45().f[2]++;
      cov_f0m6hnb45().s[3]++;
      d.__proto__ = b;
    }) || (cov_f0m6hnb45().b[1][3]++, function (d, b) {
      cov_f0m6hnb45().f[3]++;
      cov_f0m6hnb45().s[4]++;

      for (var p in b) {
        cov_f0m6hnb45().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_f0m6hnb45().b[2][0]++;
          cov_f0m6hnb45().s[6]++;
          d[p] = b[p];
        } else {
          cov_f0m6hnb45().b[2][1]++;
        }
      }
    });
    cov_f0m6hnb45().s[7]++;
    return _extendStatics(d, b);
  };

  cov_f0m6hnb45().s[8]++;
  return function (d, b) {
    cov_f0m6hnb45().f[4]++;
    cov_f0m6hnb45().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_f0m6hnb45().f[5]++;
      cov_f0m6hnb45().s[10]++;
      this.constructor = d;
    }

    cov_f0m6hnb45().s[11]++;
    d.prototype = b === null ? (cov_f0m6hnb45().b[3][0]++, (0, _create["default"])(b)) : (cov_f0m6hnb45().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_f0m6hnb45().s[12]++, (cov_f0m6hnb45().b[4][0]++, void 0) && (cov_f0m6hnb45().b[4][1]++, (void 0).__importDefault) || (cov_f0m6hnb45().b[4][2]++, function (mod) {
  cov_f0m6hnb45().f[6]++;
  cov_f0m6hnb45().s[13]++;
  return (cov_f0m6hnb45().b[6][0]++, mod) && (cov_f0m6hnb45().b[6][1]++, mod.__esModule) ? (cov_f0m6hnb45().b[5][0]++, mod) : (cov_f0m6hnb45().b[5][1]++, {
    "default": mod
  });
}));

cov_f0m6hnb45().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var DropListMenu_1 = (cov_f0m6hnb45().s[15]++, __importDefault(__webpack_require__(22)));
var dom_core_1 = (cov_f0m6hnb45().s[16]++, __importDefault(__webpack_require__(2)));
var lineHeightList_1 = (cov_f0m6hnb45().s[17]++, __importDefault(__webpack_require__(357)));
var util_1 = (cov_f0m6hnb45().s[18]++, __webpack_require__(7));
var LineHeight = (
/** @class */
cov_f0m6hnb45().s[19]++, function (_super) {
  cov_f0m6hnb45().f[7]++;
  cov_f0m6hnb45().s[20]++;

  __extends(LineHeight, _super);

  function LineHeight(editor) {
    cov_f0m6hnb45().f[8]++;

    var _this = (cov_f0m6hnb45().s[21]++, this);

    var $elem = (cov_f0m6hnb45().s[22]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                    <i class=\"w-e-icon-row-height\"></i>\n                </div>"));
    var lineHeightMenu = (cov_f0m6hnb45().s[23]++, new lineHeightList_1["default"](editor, editor.config.lineHeights));
    var DropListMenu = (cov_f0m6hnb45().s[24]++, {
      width: 100,
      title: '设置行高',
      type: 'list',
      list: lineHeightMenu.getItemList(),
      clickHandler: function clickHandler(value) {
        cov_f0m6hnb45().f[9]++;
        cov_f0m6hnb45().s[25]++;
        //保存焦点
        editor.selection.saveRange();
        cov_f0m6hnb45().s[26]++;

        _this.command(value);
      }
    });
    cov_f0m6hnb45().s[27]++;
    _this = (cov_f0m6hnb45().b[7][0]++, _super.call(this, $elem, editor, DropListMenu)) || (cov_f0m6hnb45().b[7][1]++, this);
    cov_f0m6hnb45().s[28]++;
    return _this;
  }
  /**
   * 执行命令
   * @param value value
   */


  cov_f0m6hnb45().s[29]++;

  LineHeight.prototype.command = function (value) {
    cov_f0m6hnb45().f[10]++;

    var _this = (cov_f0m6hnb45().s[30]++, this);

    var _a;

    var selection = (cov_f0m6hnb45().s[31]++, window.getSelection ? (cov_f0m6hnb45().b[8][0]++, window.getSelection()) : (cov_f0m6hnb45().b[8][1]++, document.getSelection())); //允许设置dom

    var allowArray = (cov_f0m6hnb45().s[32]++, ['P']);
    var editor = (cov_f0m6hnb45().s[33]++, this.editor);
    var st = (cov_f0m6hnb45().s[34]++, ''); //恢复焦点

    cov_f0m6hnb45().s[35]++;
    editor.selection.restoreSelection();
    var $selectionElem = (cov_f0m6hnb45().s[36]++, dom_core_1["default"](editor.selection.getSelectionContainerElem()));
    var $selectionAll = (cov_f0m6hnb45().s[37]++, dom_core_1["default"](editor.selection.getSelectionContainerElem())); // let dom:HTMLElement= $selectionElem.elems[0]

    var dom = (cov_f0m6hnb45().s[38]++, dom_core_1["default"](editor.selection.getSelectionStartElem()).elems[0]); //获取元素的style

    var style = (cov_f0m6hnb45().s[39]++, '');
    var styleList = (cov_f0m6hnb45().s[40]++, []); //点击默认的时候删除line-height属性 并重新设置 style

    var styleStr = (cov_f0m6hnb45().s[41]++, ''); //选中多行操作

    cov_f0m6hnb45().s[42]++;

    if ((cov_f0m6hnb45().b[10][0]++, $selectionElem) && (cov_f0m6hnb45().b[10][1]++, editor.$textElem.equal($selectionElem))) {
      cov_f0m6hnb45().b[9][0]++;
      var isIE = (cov_f0m6hnb45().s[43]++, util_1.UA.isIE());
      cov_f0m6hnb45().s[44]++;

      if (isIE) {
        cov_f0m6hnb45().b[11][0]++;
        cov_f0m6hnb45().s[45]++;
        // ie下禁止多行操作 避免多行造成除第一行外的段落内容都被删除
        return;
      } else {
        cov_f0m6hnb45().b[11][1]++;
      } //获取range 开头结束的dom在 祖父元素的下标


      var indexStore_1 = (cov_f0m6hnb45().s[46]++, []);
      var arrayDom_a = (cov_f0m6hnb45().s[47]++, []);
      var arrayDom_b = (cov_f0m6hnb45().s[48]++, []); //获取range 开头结束的dom

      var StartElem_1 = (cov_f0m6hnb45().s[49]++, dom_core_1["default"](editor.selection.getSelectionStartElem()));
      var EndElem_1 = (cov_f0m6hnb45().s[50]++, dom_core_1["default"](editor.selection.getSelectionEndElem()));
      var childList = (cov_f0m6hnb45().s[51]++, (cov_f0m6hnb45().b[13][0]++, (_a = editor.selection.getRange()) === null) || (cov_f0m6hnb45().b[13][1]++, _a === void 0) ? (cov_f0m6hnb45().b[12][0]++, void 0) : (cov_f0m6hnb45().b[12][1]++, _a.commonAncestorContainer.childNodes));
      cov_f0m6hnb45().s[52]++;
      arrayDom_a.push(this.getDom(StartElem_1.elems[0]));
      cov_f0m6hnb45().s[53]++;
      (cov_f0m6hnb45().b[15][0]++, childList === null) || (cov_f0m6hnb45().b[15][1]++, childList === void 0) ? (cov_f0m6hnb45().b[14][0]++, void 0) : (cov_f0m6hnb45().b[14][1]++, (0, _forEach["default"])(childList).call(childList, function (item, index) {
        cov_f0m6hnb45().f[11]++;
        cov_f0m6hnb45().s[54]++;

        if (item === _this.getDom(StartElem_1.elems[0])) {
          cov_f0m6hnb45().b[16][0]++;
          cov_f0m6hnb45().s[55]++;
          indexStore_1.push(index);
        } else {
          cov_f0m6hnb45().b[16][1]++;
        }

        cov_f0m6hnb45().s[56]++;

        if (item === _this.getDom(EndElem_1.elems[0])) {
          cov_f0m6hnb45().b[17][0]++;
          cov_f0m6hnb45().s[57]++;
          indexStore_1.push(index);
        } else {
          cov_f0m6hnb45().b[17][1]++;
        }
      })); //遍历 获取头尾之间的dom元素

      var i = (cov_f0m6hnb45().s[58]++, 0);
      var d = (cov_f0m6hnb45().s[59]++, void 0);
      cov_f0m6hnb45().s[60]++;
      arrayDom_b.push(this.getDom(StartElem_1.elems[0]));
      cov_f0m6hnb45().s[61]++;

      while (arrayDom_a[i] !== this.getDom(EndElem_1.elems[0])) {
        cov_f0m6hnb45().s[62]++;
        d = dom_core_1["default"](arrayDom_a[i].nextElementSibling).elems[0];
        cov_f0m6hnb45().s[63]++;

        if ((0, _indexOf["default"])(allowArray).call(allowArray, dom_core_1["default"](d).getNodeName()) !== -1) {
          cov_f0m6hnb45().b[18][0]++;
          cov_f0m6hnb45().s[64]++;
          arrayDom_b.push(d);
          cov_f0m6hnb45().s[65]++;
          arrayDom_a.push(d);
        } else {
          cov_f0m6hnb45().b[18][1]++;
          cov_f0m6hnb45().s[66]++;
          arrayDom_a.push(d);
        }

        cov_f0m6hnb45().s[67]++;
        i++;
      } //设置段落选取 全选


      cov_f0m6hnb45().s[68]++;

      if (dom_core_1["default"](arrayDom_a[0]).getNodeName() !== 'P') {
        cov_f0m6hnb45().b[19][0]++;
        cov_f0m6hnb45().s[69]++;
        i = 0; //遍历集合得到第一个p标签的下标

        cov_f0m6hnb45().s[70]++;

        for (var k = (cov_f0m6hnb45().s[71]++, 0); k < arrayDom_a.length; k++) {
          cov_f0m6hnb45().s[72]++;

          if (dom_core_1["default"](arrayDom_a[k]).getNodeName() === 'P') {
            cov_f0m6hnb45().b[20][0]++;
            cov_f0m6hnb45().s[73]++;
            i = k;
            cov_f0m6hnb45().s[74]++;
            break;
          } else {
            cov_f0m6hnb45().b[20][1]++;
          }
        } //i===0 说明选区中没有p段落


        cov_f0m6hnb45().s[75]++;

        if (i === 0) {
          cov_f0m6hnb45().b[21][0]++;
          cov_f0m6hnb45().s[76]++;
          return;
        } else {
          cov_f0m6hnb45().b[21][1]++;
        }

        var _i = (cov_f0m6hnb45().s[77]++, 0);

        cov_f0m6hnb45().s[78]++;

        while (_i !== i) {
          cov_f0m6hnb45().s[79]++;
          arrayDom_a.shift();
          cov_f0m6hnb45().s[80]++;
          _i++;
        }
      } else {
        cov_f0m6hnb45().b[19][1]++;
      } //设置替换的选区


      cov_f0m6hnb45().s[81]++;
      this.setRange(arrayDom_a[0], arrayDom_a[arrayDom_a.length - 1]); //生成innerHtml html字符串

      cov_f0m6hnb45().s[82]++;
      (0, _forEach["default"])(arrayDom_a).call(arrayDom_a, function (item) {
        cov_f0m6hnb45().f[12]++;
        cov_f0m6hnb45().s[83]++;
        style = item.getAttribute('style');
        cov_f0m6hnb45().s[84]++;
        styleList = style ? (cov_f0m6hnb45().b[22][0]++, style.split(';')) : (cov_f0m6hnb45().b[22][1]++, []);
        cov_f0m6hnb45().s[85]++;
        styleStr = '';
        cov_f0m6hnb45().s[86]++;

        if (dom_core_1["default"](item).getNodeName() === 'P') {
          cov_f0m6hnb45().b[23][0]++;
          cov_f0m6hnb45().s[87]++;
          //判断是否 点击默认
          value ? (cov_f0m6hnb45().b[24][0]++, styleStr = _this.styleProcessing(styleList) + ("line-height:" + value + ";")) : (cov_f0m6hnb45().b[24][1]++, styleStr = _this.styleProcessing(styleList));
          cov_f0m6hnb45().s[88]++;
          st = st + ("<" + dom_core_1["default"](item).getNodeName().toLowerCase() + " style=\"" + styleStr + "\">" + item.innerHTML + "</" + dom_core_1["default"](item).getNodeName().toLowerCase() + ">");
        } else {
          cov_f0m6hnb45().b[23][1]++;
          cov_f0m6hnb45().s[89]++;
          styleStr = _this.styleProcessing(styleList);
          cov_f0m6hnb45().s[90]++;
          st = st + ("<" + dom_core_1["default"](item).getNodeName().toLowerCase() + " style=\"" + styleStr + "\">" + item.innerHTML + "</" + dom_core_1["default"](item).getNodeName().toLowerCase() + ">");
        }
      });
      cov_f0m6hnb45().s[91]++;
      this.action(st, editor); //恢复已选择的选区

      cov_f0m6hnb45().s[92]++;
      dom = $selectionAll.elems[0];
      cov_f0m6hnb45().s[93]++;
      this.setRange(dom.children[indexStore_1[0]], dom.children[indexStore_1[1]]);
      cov_f0m6hnb45().s[94]++;
      return;
    } else {
      cov_f0m6hnb45().b[9][1]++;
    } //遍历dom 获取祖父元素 直到contenteditable属性的div标签


    cov_f0m6hnb45().s[95]++;
    dom = this.getDom(dom); //校验允许lineheight设置标签

    cov_f0m6hnb45().s[96]++;

    if ((0, _indexOf["default"])(allowArray).call(allowArray, dom_core_1["default"](dom).getNodeName()) === -1) {
      cov_f0m6hnb45().b[25][0]++;
      cov_f0m6hnb45().s[97]++;
      return;
    } else {
      cov_f0m6hnb45().b[25][1]++;
    }

    cov_f0m6hnb45().s[98]++;
    style = dom.getAttribute('style');
    cov_f0m6hnb45().s[99]++;
    styleList = style ? (cov_f0m6hnb45().b[26][0]++, style.split(';')) : (cov_f0m6hnb45().b[26][1]++, []); //全选 dom下所有的内容

    cov_f0m6hnb45().s[100]++;
    (cov_f0m6hnb45().b[28][0]++, selection === null) || (cov_f0m6hnb45().b[28][1]++, selection === void 0) ? (cov_f0m6hnb45().b[27][0]++, void 0) : (cov_f0m6hnb45().b[27][1]++, selection.selectAllChildren(dom)); //保存range

    cov_f0m6hnb45().s[101]++;
    editor.selection.saveRange(); //判断是否存在value 默认 移除line-height

    cov_f0m6hnb45().s[102]++;

    if (!value) {
      cov_f0m6hnb45().b[29][0]++;
      cov_f0m6hnb45().s[103]++;

      if (style) {
        cov_f0m6hnb45().b[30][0]++;
        cov_f0m6hnb45().s[104]++;
        styleStr = this.styleProcessing(styleList); //避免没有其它属性 只留下 ‘style’ 减少代码

        cov_f0m6hnb45().s[105]++;

        if (styleStr === '') {
          cov_f0m6hnb45().b[31][0]++;
          cov_f0m6hnb45().s[106]++;
          st = "<" + dom_core_1["default"](dom).getNodeName().toLowerCase() + ">" + dom.innerHTML + "</" + dom_core_1["default"](dom).getNodeName().toLowerCase() + ">";
        } else {
          cov_f0m6hnb45().b[31][1]++;
          cov_f0m6hnb45().s[107]++;
          st = "<" + dom_core_1["default"](dom).getNodeName().toLowerCase() + " style=\"" + styleStr + "\">" + dom.innerHTML + "</" + dom_core_1["default"](dom).getNodeName().toLowerCase() + ">";
        }

        cov_f0m6hnb45().s[108]++;
        this.action(st, editor);
      } else {
        cov_f0m6hnb45().b[30][1]++;
      }

      cov_f0m6hnb45().s[109]++;
      return;
    } else {
      cov_f0m6hnb45().b[29][1]++;
    }

    cov_f0m6hnb45().s[110]++;

    if (style) {
      cov_f0m6hnb45().b[32][0]++;
      cov_f0m6hnb45().s[111]++;
      //存在style 检索其它style属性
      styleStr = this.styleProcessing(styleList) + ("line-height:" + value + ";");
    } else {
      cov_f0m6hnb45().b[32][1]++;
      cov_f0m6hnb45().s[112]++;
      styleStr = "line-height:" + value + ";";
    }

    cov_f0m6hnb45().s[113]++;
    st = "<" + dom_core_1["default"](dom).getNodeName().toLowerCase() + " style=\"" + styleStr + "\">" + dom.innerHTML + "</" + dom_core_1["default"](dom).getNodeName().toLowerCase() + ">"; //防止BLOCKQUOTE叠加

    cov_f0m6hnb45().s[114]++;

    if (dom_core_1["default"](dom).getNodeName() === 'BLOCKQUOTE') {
      cov_f0m6hnb45().b[33][0]++;
      cov_f0m6hnb45().s[115]++;
      dom_core_1["default"](dom).css('line-height', value);
    } else {
      cov_f0m6hnb45().b[33][1]++;
      cov_f0m6hnb45().s[116]++;
      this.action(st, editor);
    }
  };
  /**
   * 遍历dom 获取祖父元素 直到contenteditable属性的div标签
   *
   */


  cov_f0m6hnb45().s[117]++;

  LineHeight.prototype.getDom = function (dom) {
    cov_f0m6hnb45().f[13]++;
    var DOM = (cov_f0m6hnb45().s[118]++, dom_core_1["default"](dom).elems[0]);
    cov_f0m6hnb45().s[119]++;

    if (!DOM.parentNode) {
      cov_f0m6hnb45().b[34][0]++;
      cov_f0m6hnb45().s[120]++;
      return DOM;
    } else {
      cov_f0m6hnb45().b[34][1]++;
    }

    function getParentNode($node, editor) {
      cov_f0m6hnb45().f[14]++;
      var $parent = (cov_f0m6hnb45().s[121]++, dom_core_1["default"]($node.parentNode));
      cov_f0m6hnb45().s[122]++;

      if (editor.$textElem.equal($parent)) {
        cov_f0m6hnb45().b[35][0]++;
        cov_f0m6hnb45().s[123]++;
        return $node;
      } else {
        cov_f0m6hnb45().b[35][1]++;
        cov_f0m6hnb45().s[124]++;
        return getParentNode($parent.elems[0], editor);
      }
    }

    cov_f0m6hnb45().s[125]++;
    DOM = getParentNode(DOM, this.editor);
    cov_f0m6hnb45().s[126]++;
    return DOM;
  };
  /**
   * 执行 document.execCommand
   *
   */


  cov_f0m6hnb45().s[127]++;

  LineHeight.prototype.action = function (html_str, editor) {
    cov_f0m6hnb45().f[15]++;
    cov_f0m6hnb45().s[128]++;
    editor.cmd["do"]('insertHTML', html_str);
  };
  /**
   * style 处理
   */


  cov_f0m6hnb45().s[129]++;

  LineHeight.prototype.styleProcessing = function (styleList) {
    cov_f0m6hnb45().f[16]++;
    var styleStr = (cov_f0m6hnb45().s[130]++, '');
    cov_f0m6hnb45().s[131]++;
    (0, _forEach["default"])(styleList).call(styleList, function (item) {
      cov_f0m6hnb45().f[17]++;
      cov_f0m6hnb45().s[132]++;
      (cov_f0m6hnb45().b[37][0]++, item !== '') && (cov_f0m6hnb45().b[37][1]++, (0, _indexOf["default"])(item).call(item, 'line-height') === -1) ? (cov_f0m6hnb45().b[36][0]++, styleStr = styleStr + item + ';') : (cov_f0m6hnb45().b[36][1]++, '');
    });
    cov_f0m6hnb45().s[133]++;
    return styleStr;
  };
  /**
   * 段落全选 比如：避免11变成111
   */


  cov_f0m6hnb45().s[134]++;

  LineHeight.prototype.setRange = function (startDom, endDom) {
    cov_f0m6hnb45().f[18]++;
    var editor = (cov_f0m6hnb45().s[135]++, this.editor);
    var selection = (cov_f0m6hnb45().s[136]++, window.getSelection ? (cov_f0m6hnb45().b[38][0]++, window.getSelection()) : (cov_f0m6hnb45().b[38][1]++, document.getSelection())); //清除所有的选区

    cov_f0m6hnb45().s[137]++;
    (cov_f0m6hnb45().b[40][0]++, selection === null) || (cov_f0m6hnb45().b[40][1]++, selection === void 0) ? (cov_f0m6hnb45().b[39][0]++, void 0) : (cov_f0m6hnb45().b[39][1]++, selection.removeAllRanges());
    var range = (cov_f0m6hnb45().s[138]++, document.createRange());
    var star = (cov_f0m6hnb45().s[139]++, startDom);
    var end = (cov_f0m6hnb45().s[140]++, endDom);
    cov_f0m6hnb45().s[141]++;
    range.setStart(star, 0);
    cov_f0m6hnb45().s[142]++;
    range.setEnd(end, 1);
    cov_f0m6hnb45().s[143]++;
    (cov_f0m6hnb45().b[42][0]++, selection === null) || (cov_f0m6hnb45().b[42][1]++, selection === void 0) ? (cov_f0m6hnb45().b[41][0]++, void 0) : (cov_f0m6hnb45().b[41][1]++, selection.addRange(range)); //保存设置好的选区

    cov_f0m6hnb45().s[144]++;
    editor.selection.saveRange(); //清除所有的选区

    cov_f0m6hnb45().s[145]++;
    (cov_f0m6hnb45().b[44][0]++, selection === null) || (cov_f0m6hnb45().b[44][1]++, selection === void 0) ? (cov_f0m6hnb45().b[43][0]++, void 0) : (cov_f0m6hnb45().b[43][1]++, selection.removeAllRanges()); //恢复选区

    cov_f0m6hnb45().s[146]++;
    editor.selection.restoreSelection();
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_f0m6hnb45().s[147]++;

  LineHeight.prototype.tryChangeActive = function () {
    cov_f0m6hnb45().f[19]++;
    var editor = (cov_f0m6hnb45().s[148]++, this.editor);
    var $selectionElem = (cov_f0m6hnb45().s[149]++, editor.selection.getSelectionContainerElem());
    cov_f0m6hnb45().s[150]++;

    if ((cov_f0m6hnb45().b[46][0]++, $selectionElem) && (cov_f0m6hnb45().b[46][1]++, editor.$textElem.equal($selectionElem))) {
      cov_f0m6hnb45().b[45][0]++;
      cov_f0m6hnb45().s[151]++;
      //避免选中多行设置
      return;
    } else {
      cov_f0m6hnb45().b[45][1]++;
    }

    var dom = (cov_f0m6hnb45().s[152]++, dom_core_1["default"](editor.selection.getSelectionStartElem()));
    cov_f0m6hnb45().s[153]++;
    dom = this.getDom(dom.elems[0]);
    var style = (cov_f0m6hnb45().s[154]++, dom.getAttribute('style') ? (cov_f0m6hnb45().b[47][0]++, dom.getAttribute('style')) : (cov_f0m6hnb45().b[47][1]++, '')); //判断当前标签是否具有line-height属性

    cov_f0m6hnb45().s[155]++;

    if ((cov_f0m6hnb45().b[49][0]++, style) && (cov_f0m6hnb45().b[49][1]++, (0, _indexOf["default"])(style).call(style, 'line-height') !== -1)) {
      cov_f0m6hnb45().b[48][0]++;
      cov_f0m6hnb45().s[156]++;
      this.active();
    } else {
      cov_f0m6hnb45().b[48][1]++;
      cov_f0m6hnb45().s[157]++;
      this.unActive();
    }
  };

  cov_f0m6hnb45().s[158]++;
  return LineHeight;
}(DropListMenu_1["default"]));
cov_f0m6hnb45().s[159]++;
exports["default"] = LineHeight;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_111bzuaxfg() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/lineHeightList.ts";
  var hash = "b11b97611ae3009cafb67392e251263b0baca1ac";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/lineHeightList.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 36
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 24
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 114
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 20,
          column: 11
        }
      },
      "8": {
        start: {
          line: 16,
          column: 12
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "9": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 24,
          column: 6
        }
      },
      "10": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "11": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 26
        }
      },
      "12": {
        start: {
          line: 27,
          column: 0
        },
        end: {
          line: 27,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 36
          },
          end: {
            line: 11,
            column: 37
          }
        },
        loc: {
          start: {
            line: 11,
            column: 48
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "lineHeightList",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 27
          }
        },
        loc: {
          start: {
            line: 12,
            column: 42
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 22
          }
        },
        loc: {
          start: {
            line: 15,
            column: 37
          },
          end: {
            line: 20,
            column: 9
          }
        },
        line: 15
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 22,
            column: 43
          },
          end: {
            line: 22,
            column: 44
          }
        },
        loc: {
          start: {
            line: 22,
            column: 55
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/lineHeightList.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/lineHeight/lineHeightList.ts"],
      names: [],
      mappings: ";;;;;AAAA;;;GAGG;AACH,kEAAoC;AAIpC;IAGI,wBAAY,MAAc,EAAE,IAAc;QAA1C,iBAQC;QAPG,IAAI,CAAC,QAAQ,GAAG,CAAC,EAAE,KAAK,EAAE,kBAAC,CAAC,WAAS,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,IAAI,CAAC,YAAS,CAAC,EAAE,KAAK,EAAE,EAAE,EAAE,CAAC,CAAA;QACnF,IAAI,CAAC,OAAO,CAAC,UAAA,IAAI;YACb,KAAI,CAAC,QAAQ,CAAC,IAAI,CAAC;gBACf,KAAK,EAAE,kBAAC,CAAC,WAAS,IAAI,YAAS,CAAC;gBAChC,KAAK,EAAE,IAAI;aACd,CAAC,CAAA;QACN,CAAC,CAAC,CAAA;IACN,CAAC;IAEM,oCAAW,GAAlB;QACI,OAAO,IAAI,CAAC,QAAQ,CAAA;IACxB,CAAC;IACL,qBAAC;AAAD,CAAC,AAhBD,IAgBC;AAED,kBAAe,cAAc,CAAA",
      sourcesContent: ["/**\n * @description \u884C\u9AD8 \u83DC\u5355\n * @author lichunlin\n */\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { DropListItem } from '../menu-constructors/DropList'\n\nclass lineHeightList {\n    private itemList: DropListItem[]\n\n    constructor(editor: Editor, list: string[]) {\n        this.itemList = [{ $elem: $(`<span>${editor.i18next.t('\u9ED8\u8BA4')}</span>`), value: '' }]\n        list.forEach(item => {\n            this.itemList.push({\n                $elem: $(`<span>${item}</span>`),\n                value: item,\n            })\n        })\n    }\n\n    public getItemList(): DropListItem[] {\n        return this.itemList\n    }\n}\n\nexport default lineHeightList\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b11b97611ae3009cafb67392e251263b0baca1ac"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_111bzuaxfg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_111bzuaxfg();

var __importDefault = (cov_111bzuaxfg().s[0]++, (cov_111bzuaxfg().b[0][0]++, void 0) && (cov_111bzuaxfg().b[0][1]++, (void 0).__importDefault) || (cov_111bzuaxfg().b[0][2]++, function (mod) {
  cov_111bzuaxfg().f[0]++;
  cov_111bzuaxfg().s[1]++;
  return (cov_111bzuaxfg().b[2][0]++, mod) && (cov_111bzuaxfg().b[2][1]++, mod.__esModule) ? (cov_111bzuaxfg().b[1][0]++, mod) : (cov_111bzuaxfg().b[1][1]++, {
    "default": mod
  });
}));

cov_111bzuaxfg().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description 行高 菜单
 * @author lichunlin
 */

var dom_core_1 = (cov_111bzuaxfg().s[3]++, __importDefault(__webpack_require__(2)));
var lineHeightList = (
/** @class */
cov_111bzuaxfg().s[4]++, function () {
  cov_111bzuaxfg().f[1]++;

  function lineHeightList(editor, list) {
    cov_111bzuaxfg().f[2]++;

    var _this = (cov_111bzuaxfg().s[5]++, this);

    cov_111bzuaxfg().s[6]++;
    this.itemList = [{
      $elem: dom_core_1["default"]("<span>" + editor.i18next.t('默认') + "</span>"),
      value: ''
    }];
    cov_111bzuaxfg().s[7]++;
    (0, _forEach["default"])(list).call(list, function (item) {
      cov_111bzuaxfg().f[3]++;
      cov_111bzuaxfg().s[8]++;

      _this.itemList.push({
        $elem: dom_core_1["default"]("<span>" + item + "</span>"),
        value: item
      });
    });
  }

  cov_111bzuaxfg().s[9]++;

  lineHeightList.prototype.getItemList = function () {
    cov_111bzuaxfg().f[4]++;
    cov_111bzuaxfg().s[10]++;
    return this.itemList;
  };

  cov_111bzuaxfg().s[11]++;
  return lineHeightList;
}());
cov_111bzuaxfg().s[12]++;
exports["default"] = lineHeightList;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 撤销
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1tx50tfndc() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/undo/index.ts";
  var hash = "41d1f6d35cdc4d3dfebb7abb99badd52de2c7272";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/undo/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 72
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 54,
          column: 20
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 28
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 135
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "24": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 37
        }
      },
      "25": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      "26": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "27": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 50,
          column: 13
        }
      },
      "28": {
        start: {
          line: 46,
          column: 16
        },
        end: {
          line: 46,
          column: 30
        }
      },
      "29": {
        start: {
          line: 49,
          column: 16
        },
        end: {
          line: 49,
          column: 32
        }
      },
      "30": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 16
        }
      },
      "31": {
        start: {
          line: 55,
          column: 0
        },
        end: {
          line: 55,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "Undo",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 26
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 34
          },
          end: {
            line: 36,
            column: 35
          }
        },
        loc: {
          start: {
            line: 36,
            column: 46
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 42,
            column: 37
          },
          end: {
            line: 42,
            column: 38
          }
        },
        loc: {
          start: {
            line: 42,
            column: 49
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 42
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 52
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 44
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }, {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }],
        line: 45
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/undo/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/undo/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoC;AAEpC,yEAAkD;AAGlD;IAAmB,wBAAO;IACtB,cAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,+FAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,2BAAY,GAAnB;QACI,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,MAAM,EAAE,CAAA;IAChC,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,aAAa;QACb,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;YAC/B,IAAI,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC,CAAC,CAAC,EAAE;gBAC7B,IAAI,CAAC,MAAM,EAAE,CAAA;aAChB;iBAAM;gBACH,IAAI,CAAC,QAAQ,EAAE,CAAA;aAClB;SACJ;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AA9BD,CAAmB,iBAAO,GA8BzB;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u64A4\u9500\n * @author tonghan\n */\n\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Undo extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-undo\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        this.editor.history.revoke()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u8FDB\u884C\u64CD\u4F5C\n        if (!this.editor.isCompatibleMode) {\n            if (this.editor.history.size[0]) {\n                this.active()\n            } else {\n                this.unActive()\n            }\n        }\n    }\n}\n\nexport default Undo\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "41d1f6d35cdc4d3dfebb7abb99badd52de2c7272"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tx50tfndc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1tx50tfndc();

var __extends = (cov_1tx50tfndc().s[0]++, (cov_1tx50tfndc().b[0][0]++, void 0) && (cov_1tx50tfndc().b[0][1]++, (void 0).__extends) || (cov_1tx50tfndc().b[0][2]++, function () {
  cov_1tx50tfndc().f[0]++;
  cov_1tx50tfndc().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1tx50tfndc().f[1]++;
    cov_1tx50tfndc().s[2]++;
    _extendStatics = (cov_1tx50tfndc().b[1][0]++, _setPrototypeOf["default"]) || (cov_1tx50tfndc().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1tx50tfndc().b[1][2]++, function (d, b) {
      cov_1tx50tfndc().f[2]++;
      cov_1tx50tfndc().s[3]++;
      d.__proto__ = b;
    }) || (cov_1tx50tfndc().b[1][3]++, function (d, b) {
      cov_1tx50tfndc().f[3]++;
      cov_1tx50tfndc().s[4]++;

      for (var p in b) {
        cov_1tx50tfndc().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1tx50tfndc().b[2][0]++;
          cov_1tx50tfndc().s[6]++;
          d[p] = b[p];
        } else {
          cov_1tx50tfndc().b[2][1]++;
        }
      }
    });
    cov_1tx50tfndc().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1tx50tfndc().s[8]++;
  return function (d, b) {
    cov_1tx50tfndc().f[4]++;
    cov_1tx50tfndc().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1tx50tfndc().f[5]++;
      cov_1tx50tfndc().s[10]++;
      this.constructor = d;
    }

    cov_1tx50tfndc().s[11]++;
    d.prototype = b === null ? (cov_1tx50tfndc().b[3][0]++, (0, _create["default"])(b)) : (cov_1tx50tfndc().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1tx50tfndc().s[12]++, (cov_1tx50tfndc().b[4][0]++, void 0) && (cov_1tx50tfndc().b[4][1]++, (void 0).__importDefault) || (cov_1tx50tfndc().b[4][2]++, function (mod) {
  cov_1tx50tfndc().f[6]++;
  cov_1tx50tfndc().s[13]++;
  return (cov_1tx50tfndc().b[6][0]++, mod) && (cov_1tx50tfndc().b[6][1]++, mod.__esModule) ? (cov_1tx50tfndc().b[5][0]++, mod) : (cov_1tx50tfndc().b[5][1]++, {
    "default": mod
  });
}));

cov_1tx50tfndc().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1tx50tfndc().s[15]++, __importDefault(__webpack_require__(2)));
var BtnMenu_1 = (cov_1tx50tfndc().s[16]++, __importDefault(__webpack_require__(24)));
var Undo = (
/** @class */
cov_1tx50tfndc().s[17]++, function (_super) {
  cov_1tx50tfndc().f[7]++;
  cov_1tx50tfndc().s[18]++;

  __extends(Undo, _super);

  function Undo(editor) {
    cov_1tx50tfndc().f[8]++;

    var _this = (cov_1tx50tfndc().s[19]++, this);

    var $elem = (cov_1tx50tfndc().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-undo\"></i>\n            </div>"));
    cov_1tx50tfndc().s[21]++;
    _this = (cov_1tx50tfndc().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1tx50tfndc().b[7][1]++, this);
    cov_1tx50tfndc().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_1tx50tfndc().s[23]++;

  Undo.prototype.clickHandler = function () {
    cov_1tx50tfndc().f[9]++;
    cov_1tx50tfndc().s[24]++;
    this.editor.history.revoke();
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_1tx50tfndc().s[25]++;

  Undo.prototype.tryChangeActive = function () {
    cov_1tx50tfndc().f[10]++;
    cov_1tx50tfndc().s[26]++;

    // 标准模式下才进行操作
    if (!this.editor.isCompatibleMode) {
      cov_1tx50tfndc().b[8][0]++;
      cov_1tx50tfndc().s[27]++;

      if (this.editor.history.size[0]) {
        cov_1tx50tfndc().b[9][0]++;
        cov_1tx50tfndc().s[28]++;
        this.active();
      } else {
        cov_1tx50tfndc().b[9][1]++;
        cov_1tx50tfndc().s[29]++;
        this.unActive();
      }
    } else {
      cov_1tx50tfndc().b[8][1]++;
    }
  };

  cov_1tx50tfndc().s[30]++;
  return Undo;
}(BtnMenu_1["default"]));
cov_1tx50tfndc().s[31]++;
exports["default"] = Undo;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 重做
 * @author tonghan
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1kdvmv3gor() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/redo/index.ts";
  var hash = "ef150c149a2fd9257d222d595dedaacfc3adea57";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/redo/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 65
        }
      },
      "16": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 72
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 54,
          column: 20
        }
      },
      "18": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 28
        }
      },
      "19": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 24
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 135
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      "24": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 38
        }
      },
      "25": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      "26": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "27": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 50,
          column: 13
        }
      },
      "28": {
        start: {
          line: 46,
          column: 16
        },
        end: {
          line: 46,
          column: 30
        }
      },
      "29": {
        start: {
          line: 49,
          column: 16
        },
        end: {
          line: 49,
          column: 32
        }
      },
      "30": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 16
        }
      },
      "31": {
        start: {
          line: 55,
          column: 0
        },
        end: {
          line: 55,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 25,
            column: 26
          },
          end: {
            line: 25,
            column: 27
          }
        },
        loc: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 25
      },
      "8": {
        name: "Redo",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 26
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 27
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 36,
            column: 34
          },
          end: {
            line: 36,
            column: 35
          }
        },
        loc: {
          start: {
            line: 36,
            column: 46
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 36
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 42,
            column: 37
          },
          end: {
            line: 42,
            column: 38
          }
        },
        loc: {
          start: {
            line: 42,
            column: 49
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 42
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 16
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 52
          },
          end: {
            line: 30,
            column: 56
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 44
      },
      "9": {
        loc: {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }, {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 50,
            column: 13
          }
        }],
        line: 45
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/redo/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/redo/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,kEAAoC;AAEpC,yEAAkD;AAGlD;IAAmB,wBAAO;IACtB,cAAY,MAAc;QAA1B,iBAOC;QANG,IAAM,KAAK,GAAG,kBAAC,CACX,+FAEO,CACV,CAAA;QACD,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;;IACxB,CAAC;IAED;;OAEG;IACI,2BAAY,GAAnB;QACI,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,OAAO,EAAE,CAAA;IACjC,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,aAAa;QACb,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;YAC/B,IAAI,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC,CAAC,CAAC,EAAE;gBAC7B,IAAI,CAAC,MAAM,EAAE,CAAA;aAChB;iBAAM;gBACH,IAAI,CAAC,QAAQ,EAAE,CAAA;aAClB;SACJ;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AA9BD,CAAmB,iBAAO,GA8BzB;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u91CD\u505A\n * @author tonghan\n */\n\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport { MenuActive } from '../menu-constructors/Menu'\n\nclass Redo extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $(\n            `<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-redo\"></i>\n            </div>`\n        )\n        super($elem, editor)\n    }\n\n    /**\n     * \u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        this.editor.history.restore()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {\n        // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u8FDB\u884C\u64CD\u4F5C\n        if (!this.editor.isCompatibleMode) {\n            if (this.editor.history.size[1]) {\n                this.active()\n            } else {\n                this.unActive()\n            }\n        }\n    }\n}\n\nexport default Redo\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ef150c149a2fd9257d222d595dedaacfc3adea57"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kdvmv3gor = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1kdvmv3gor();

var __extends = (cov_1kdvmv3gor().s[0]++, (cov_1kdvmv3gor().b[0][0]++, void 0) && (cov_1kdvmv3gor().b[0][1]++, (void 0).__extends) || (cov_1kdvmv3gor().b[0][2]++, function () {
  cov_1kdvmv3gor().f[0]++;
  cov_1kdvmv3gor().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1kdvmv3gor().f[1]++;
    cov_1kdvmv3gor().s[2]++;
    _extendStatics = (cov_1kdvmv3gor().b[1][0]++, _setPrototypeOf["default"]) || (cov_1kdvmv3gor().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1kdvmv3gor().b[1][2]++, function (d, b) {
      cov_1kdvmv3gor().f[2]++;
      cov_1kdvmv3gor().s[3]++;
      d.__proto__ = b;
    }) || (cov_1kdvmv3gor().b[1][3]++, function (d, b) {
      cov_1kdvmv3gor().f[3]++;
      cov_1kdvmv3gor().s[4]++;

      for (var p in b) {
        cov_1kdvmv3gor().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1kdvmv3gor().b[2][0]++;
          cov_1kdvmv3gor().s[6]++;
          d[p] = b[p];
        } else {
          cov_1kdvmv3gor().b[2][1]++;
        }
      }
    });
    cov_1kdvmv3gor().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1kdvmv3gor().s[8]++;
  return function (d, b) {
    cov_1kdvmv3gor().f[4]++;
    cov_1kdvmv3gor().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1kdvmv3gor().f[5]++;
      cov_1kdvmv3gor().s[10]++;
      this.constructor = d;
    }

    cov_1kdvmv3gor().s[11]++;
    d.prototype = b === null ? (cov_1kdvmv3gor().b[3][0]++, (0, _create["default"])(b)) : (cov_1kdvmv3gor().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1kdvmv3gor().s[12]++, (cov_1kdvmv3gor().b[4][0]++, void 0) && (cov_1kdvmv3gor().b[4][1]++, (void 0).__importDefault) || (cov_1kdvmv3gor().b[4][2]++, function (mod) {
  cov_1kdvmv3gor().f[6]++;
  cov_1kdvmv3gor().s[13]++;
  return (cov_1kdvmv3gor().b[6][0]++, mod) && (cov_1kdvmv3gor().b[6][1]++, mod.__esModule) ? (cov_1kdvmv3gor().b[5][0]++, mod) : (cov_1kdvmv3gor().b[5][1]++, {
    "default": mod
  });
}));

cov_1kdvmv3gor().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1kdvmv3gor().s[15]++, __importDefault(__webpack_require__(2)));
var BtnMenu_1 = (cov_1kdvmv3gor().s[16]++, __importDefault(__webpack_require__(24)));
var Redo = (
/** @class */
cov_1kdvmv3gor().s[17]++, function (_super) {
  cov_1kdvmv3gor().f[7]++;
  cov_1kdvmv3gor().s[18]++;

  __extends(Redo, _super);

  function Redo(editor) {
    cov_1kdvmv3gor().f[8]++;

    var _this = (cov_1kdvmv3gor().s[19]++, this);

    var $elem = (cov_1kdvmv3gor().s[20]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-redo\"></i>\n            </div>"));
    cov_1kdvmv3gor().s[21]++;
    _this = (cov_1kdvmv3gor().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1kdvmv3gor().b[7][1]++, this);
    cov_1kdvmv3gor().s[22]++;
    return _this;
  }
  /**
   * 点击事件
   */


  cov_1kdvmv3gor().s[23]++;

  Redo.prototype.clickHandler = function () {
    cov_1kdvmv3gor().f[9]++;
    cov_1kdvmv3gor().s[24]++;
    this.editor.history.restore();
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_1kdvmv3gor().s[25]++;

  Redo.prototype.tryChangeActive = function () {
    cov_1kdvmv3gor().f[10]++;
    cov_1kdvmv3gor().s[26]++;

    // 标准模式下才进行操作
    if (!this.editor.isCompatibleMode) {
      cov_1kdvmv3gor().b[8][0]++;
      cov_1kdvmv3gor().s[27]++;

      if (this.editor.history.size[1]) {
        cov_1kdvmv3gor().b[9][0]++;
        cov_1kdvmv3gor().s[28]++;
        this.active();
      } else {
        cov_1kdvmv3gor().b[9][1]++;
        cov_1kdvmv3gor().s[29]++;
        this.unActive();
      }
    } else {
      cov_1kdvmv3gor().b[8][1]++;
    }
  };

  cov_1kdvmv3gor().s[30]++;
  return Redo;
}(BtnMenu_1["default"]));
cov_1kdvmv3gor().s[31]++;
exports["default"] = Redo;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 创建table
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_1ztwlggg5q() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/index.ts";
  var hash = "f876648143d71d6346906d6d066f8226165573ee";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 76
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 25,
          column: 73
        }
      },
      "18": {
        start: {
          line: 26,
          column: 14
        },
        end: {
          line: 26,
          column: 68
        }
      },
      "19": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 60
        }
      },
      "20": {
        start: {
          line: 28,
          column: 27
        },
        end: {
          line: 57,
          column: 22
        }
      },
      "21": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 29
        }
      },
      "22": {
        start: {
          line: 31,
          column: 20
        },
        end: {
          line: 31,
          column: 24
        }
      },
      "23": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 101
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 57
        }
      },
      "25": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 32
        }
      },
      "26": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 21
        }
      },
      "27": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 6
        }
      },
      "28": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 27
        }
      },
      "29": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "30": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 59
        }
      },
      "31": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "32": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 23
        }
      },
      "33": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 54
        }
      },
      "34": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 17
        }
      },
      "35": {
        start: {
          line: 58,
          column: 0
        },
        end: {
          line: 58,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 28,
            column: 27
          },
          end: {
            line: 28,
            column: 28
          }
        },
        loc: {
          start: {
            line: 28,
            column: 45
          },
          end: {
            line: 57,
            column: 1
          }
        },
        line: 28
      },
      "8": {
        name: "Table",
        decl: {
          start: {
            line: 30,
            column: 13
          },
          end: {
            line: 30,
            column: 18
          }
        },
        loc: {
          start: {
            line: 30,
            column: 27
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 30
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 41,
            column: 35
          },
          end: {
            line: 41,
            column: 36
          }
        },
        loc: {
          start: {
            line: 41,
            column: 47
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 41
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 47,
            column: 35
          }
        },
        loc: {
          start: {
            line: 47,
            column: 46
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 47
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 55,
            column: 38
          },
          end: {
            line: 55,
            column: 39
          }
        },
        loc: {
          start: {
            line: 55,
            column: 50
          },
          end: {
            line: 55,
            column: 53
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 16
          },
          end: {
            line: 33,
            column: 48
          }
        }, {
          start: {
            line: 33,
            column: 52
          },
          end: {
            line: 33,
            column: 56
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,6EAAsD;AAEtD,kEAAoC;AACpC,0EAAiD;AACjD,qEAA8C;AAE9C,6DAA0C;AAE1C;IAAoB,yBAAS;IACzB,eAAY,MAAc;QAA1B,iBAMC;QALG,IAAM,KAAK,GAAG,kBAAC,CAAC,6DAA6D,CAAC,CAAA;QAC9E,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QAEpB,OAAO;QACP,eAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IAED;;OAEG;IACI,4BAAY,GAAnB;QACI,IAAI,CAAC,WAAW,EAAE,CAAA;IACtB,CAAC;IAED;;OAEG;IACK,2BAAW,GAAnB;QACI,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;QACzC,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,+BAAe,GAAtB,cAA0B,CAAC;IAC/B,YAAC;AAAD,CAAC,AA7BD,CAAoB,mBAAS,GA6B5B;AAED,kBAAe,KAAK,CAAA",
      sourcesContent: ["/**\n * @description \u521B\u5EFAtable\n * @author lichunlin\n */\n\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\nimport createPanelConf from './create-panel-conf'\nimport Panel from '../menu-constructors/Panel'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event/index'\n\nclass Table extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-table2\"></i></div>')\n        super($elem, editor)\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\n        bindEvent(editor)\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        this.createPanel()\n    }\n\n    /**\n     * \u521B\u5EFA panel\n     */\n    private createPanel(): void {\n        const conf = createPanelConf(this.editor)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355 active \u72B6\u6001\n     */\n    public tryChangeActive() {}\n}\n\nexport default Table\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f876648143d71d6346906d6d066f8226165573ee"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ztwlggg5q = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ztwlggg5q();

var __extends = (cov_1ztwlggg5q().s[0]++, (cov_1ztwlggg5q().b[0][0]++, void 0) && (cov_1ztwlggg5q().b[0][1]++, (void 0).__extends) || (cov_1ztwlggg5q().b[0][2]++, function () {
  cov_1ztwlggg5q().f[0]++;
  cov_1ztwlggg5q().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_1ztwlggg5q().f[1]++;
    cov_1ztwlggg5q().s[2]++;
    _extendStatics = (cov_1ztwlggg5q().b[1][0]++, _setPrototypeOf["default"]) || (cov_1ztwlggg5q().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_1ztwlggg5q().b[1][2]++, function (d, b) {
      cov_1ztwlggg5q().f[2]++;
      cov_1ztwlggg5q().s[3]++;
      d.__proto__ = b;
    }) || (cov_1ztwlggg5q().b[1][3]++, function (d, b) {
      cov_1ztwlggg5q().f[3]++;
      cov_1ztwlggg5q().s[4]++;

      for (var p in b) {
        cov_1ztwlggg5q().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_1ztwlggg5q().b[2][0]++;
          cov_1ztwlggg5q().s[6]++;
          d[p] = b[p];
        } else {
          cov_1ztwlggg5q().b[2][1]++;
        }
      }
    });
    cov_1ztwlggg5q().s[7]++;
    return _extendStatics(d, b);
  };

  cov_1ztwlggg5q().s[8]++;
  return function (d, b) {
    cov_1ztwlggg5q().f[4]++;
    cov_1ztwlggg5q().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_1ztwlggg5q().f[5]++;
      cov_1ztwlggg5q().s[10]++;
      this.constructor = d;
    }

    cov_1ztwlggg5q().s[11]++;
    d.prototype = b === null ? (cov_1ztwlggg5q().b[3][0]++, (0, _create["default"])(b)) : (cov_1ztwlggg5q().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_1ztwlggg5q().s[12]++, (cov_1ztwlggg5q().b[4][0]++, void 0) && (cov_1ztwlggg5q().b[4][1]++, (void 0).__importDefault) || (cov_1ztwlggg5q().b[4][2]++, function (mod) {
  cov_1ztwlggg5q().f[6]++;
  cov_1ztwlggg5q().s[13]++;
  return (cov_1ztwlggg5q().b[6][0]++, mod) && (cov_1ztwlggg5q().b[6][1]++, mod.__esModule) ? (cov_1ztwlggg5q().b[5][0]++, mod) : (cov_1ztwlggg5q().b[5][1]++, {
    "default": mod
  });
}));

cov_1ztwlggg5q().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var PanelMenu_1 = (cov_1ztwlggg5q().s[15]++, __importDefault(__webpack_require__(32)));
var dom_core_1 = (cov_1ztwlggg5q().s[16]++, __importDefault(__webpack_require__(2)));
var create_panel_conf_1 = (cov_1ztwlggg5q().s[17]++, __importDefault(__webpack_require__(361)));
var Panel_1 = (cov_1ztwlggg5q().s[18]++, __importDefault(__webpack_require__(28)));
var index_1 = (cov_1ztwlggg5q().s[19]++, __importDefault(__webpack_require__(365)));
var Table = (
/** @class */
cov_1ztwlggg5q().s[20]++, function (_super) {
  cov_1ztwlggg5q().f[7]++;
  cov_1ztwlggg5q().s[21]++;

  __extends(Table, _super);

  function Table(editor) {
    cov_1ztwlggg5q().f[8]++;

    var _this = (cov_1ztwlggg5q().s[22]++, this);

    var $elem = (cov_1ztwlggg5q().s[23]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-table2"></i></div>'));
    cov_1ztwlggg5q().s[24]++;
    _this = (cov_1ztwlggg5q().b[7][0]++, _super.call(this, $elem, editor)) || (cov_1ztwlggg5q().b[7][1]++, this); // 绑定事件

    cov_1ztwlggg5q().s[25]++;
    index_1["default"](editor);
    cov_1ztwlggg5q().s[26]++;
    return _this;
  }
  /**
   * 菜单点击事件
   */


  cov_1ztwlggg5q().s[27]++;

  Table.prototype.clickHandler = function () {
    cov_1ztwlggg5q().f[9]++;
    cov_1ztwlggg5q().s[28]++;
    this.createPanel();
  };
  /**
   * 创建 panel
   */


  cov_1ztwlggg5q().s[29]++;

  Table.prototype.createPanel = function () {
    cov_1ztwlggg5q().f[10]++;
    var conf = (cov_1ztwlggg5q().s[30]++, create_panel_conf_1["default"](this.editor));
    var panel = (cov_1ztwlggg5q().s[31]++, new Panel_1["default"](this, conf));
    cov_1ztwlggg5q().s[32]++;
    panel.create();
  };
  /**
   * 尝试修改菜单 active 状态
   */


  cov_1ztwlggg5q().s[33]++;

  Table.prototype.tryChangeActive = function () {
    cov_1ztwlggg5q().f[11]++;
  };

  cov_1ztwlggg5q().s[34]++;
  return Table;
}(PanelMenu_1["default"]));
cov_1ztwlggg5q().s[35]++;
exports["default"] = Table;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description table 菜单 panel tab 配置
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_m17lrd2fk() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-panel-conf.ts";
  var hash = "a217a1b20d849fbb813bed5ce67fd7158bdca684";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 53
        }
      },
      "6": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 13,
          column: 63
        }
      },
      "7": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 15,
          column: 56
        }
      },
      "8": {
        start: {
          line: 17,
          column: 16
        },
        end: {
          line: 17,
          column: 44
        }
      },
      "9": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 44
        }
      },
      "10": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 50
        }
      },
      "11": {
        start: {
          line: 20,
          column: 21
        },
        end: {
          line: 20,
          column: 46
        }
      },
      "12": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 23,
          column: 5
        }
      },
      "13": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 38
        }
      },
      "14": {
        start: {
          line: 25,
          column: 19
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "15": {
        start: {
          line: 34,
          column: 39
        },
        end: {
          line: 34,
          column: 84
        }
      },
      "16": {
        start: {
          line: 35,
          column: 39
        },
        end: {
          line: 35,
          column: 84
        }
      },
      "17": {
        start: {
          line: 37,
          column: 24
        },
        end: {
          line: 39,
          column: 25
        }
      },
      "18": {
        start: {
          line: 38,
          column: 28
        },
        end: {
          line: 38,
          column: 73
        }
      },
      "19": {
        start: {
          line: 41,
          column: 24
        },
        end: {
          line: 41,
          column: 36
        }
      },
      "20": {
        start: {
          line: 49,
          column: 15
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "21": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 32
        }
      },
      "22": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 16
        }
      },
      "23": {
        start: {
          line: 57,
          column: 0
        },
        end: {
          line: 57,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 18
          }
        },
        loc: {
          start: {
            line: 14,
            column: 27
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 21,
            column: 13
          }
        },
        loc: {
          start: {
            line: 21,
            column: 28
          },
          end: {
            line: 23,
            column: 5
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 33,
            column: 24
          },
          end: {
            line: 33,
            column: 25
          }
        },
        loc: {
          start: {
            line: 33,
            column: 36
          },
          end: {
            line: 42,
            column: 21
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 39,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 39,
            column: 25
          }
        }, {
          start: {
            line: 37,
            column: 24
          },
          end: {
            line: 39,
            column: 25
          }
        }],
        line: 37
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 37,
            column: 36
          }
        }, {
          start: {
            line: 37,
            column: 40
          },
          end: {
            line: 37,
            column: 48
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,yCAA4C;AAC5C,kEAAoC;AACpC,qDAAkD;AAClD,gEAAwC;AAExC,mBAAyB,MAAc;IACnC,IAAM,WAAW,GAAG,IAAI,sBAAW,CAAC,MAAM,CAAC,CAAA;IAE3C,iBAAiB;IACjB,IAAM,KAAK,GAAG,gBAAS,CAAC,UAAU,CAAC,CAAA;IACnC,IAAM,KAAK,GAAG,gBAAS,CAAC,UAAU,CAAC,CAAA;IACnC,IAAM,WAAW,GAAG,gBAAS,CAAC,UAAU,CAAC,CAAA;IAEzC,IAAM,UAAU,GAAG,yBAAyB,CAAA;IAC5C,IAAM,CAAC,GAAG,UAAC,IAAY;QACnB,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,IAAI,CAAC,CAAA;IACjC,CAAC,CAAA;IAED,oDAAoD;IACpD,IAAM,QAAQ,GAAmB;QAC7B;YACI,KAAK,EAAE,CAAC,CAAI,UAAU,6BAAM,CAAC;YAC7B,GAAG,EAAE,yFAEe,CAAC,CAAC,IAAI,CAAC,qDACF,KAAK,sGACV,CAAC,CAAI,UAAU,WAAG,CAAC,qDACd,KAAK,sGAEd,CAAC,CAAI,UAAU,WAAG,CAAC,GAAG,CAAC,CAAI,UAAU,WAAG,CAAC,GAAG,CAAC,CAAI,UAAU,iBAAI,CAAC,6IAItD,WAAW,2BAAmB,CAAC,CAAC,IAAI,CAAC,kEAEpD;YACX,MAAM,EAAE;gBACJ;oBACI,QAAQ,EAAE,GAAG,GAAG,WAAW;oBAC3B,IAAI,EAAE,OAAO;oBACb,EAAE,EAAE;wBACA,IAAM,QAAQ,GAAG,MAAM,CAAC,kBAAC,CAAC,GAAG,GAAG,KAAK,CAAC,CAAC,GAAG,EAAE,CAAC,CAAA;wBAC7C,IAAM,QAAQ,GAAG,MAAM,CAAC,kBAAC,CAAC,GAAG,GAAG,KAAK,CAAC,CAAC,GAAG,EAAE,CAAC,CAAA;wBAC7C,QAAQ;wBACR,IAAI,QAAQ,IAAI,QAAQ,EAAE;4BACtB,WAAW,CAAC,YAAY,CAAC,QAAQ,EAAE,QAAQ,CAAC,CAAA;yBAC/C;wBACD,6BAA6B;wBAC7B,OAAO,IAAI,CAAA;oBACf,CAAC;iBACJ;aACJ;SACJ;KACJ,CAAA;IACD,WAAW;IAEX,kDAAkD;IAClD,IAAM,IAAI,GAAc;QACpB,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,CAAC;QACT,IAAI,EAAE,EAAE;KACX,CAAA;IACD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAA;IAE3B,OAAO,IAAI,CAAA;AACf,CAAC;AA5DD,4BA4DC",
      sourcesContent: ["/**\n * @description table \u83DC\u5355 panel tab \u914D\u7F6E\n * @author lichunlin\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf, PanelTabConf } from '../menu-constructors/Panel'\nimport { getRandom } from '../../utils/util'\nimport $ from '../../utils/dom-core'\nimport '../../assets/style/create-panel-conf.less'\nimport CreateTable from './create-table'\n\nexport default function (editor: Editor): PanelConf {\n    const createTable = new CreateTable(editor)\n\n    // panel \u4E2D\u9700\u8981\u7528\u5230\u7684id\n    const colId = getRandom('w-col-id')\n    const rowId = getRandom('w-row-id')\n    const insertBtnId = getRandom('btn-link')\n\n    const i18nPrefix = 'menus.panelMenus.table.'\n    const t = (text: string): string => {\n        return editor.i18next.t(text)\n    }\n\n    // tabs \u914D\u7F6E -----------------------------------------\n    const tabsConf: PanelTabConf[] = [\n        {\n            title: t(`${i18nPrefix}\u63D2\u5165\u8868\u683C`),\n            tpl: `<div>\n                    <div class=\"w-e-table\">\n                        <span>${t('\u521B\u5EFA')}</span>\n                        <input id=\"${rowId}\"  type=\"text\" class=\"w-e-table-input\" value=\"5\"/></td>\n                        <span>${t(`${i18nPrefix}\u884C`)}</span>\n                        <input id=\"${colId}\" type=\"text\" class=\"w-e-table-input\" value=\"5\"/></td>\n                        <span>${\n                            t(`${i18nPrefix}\u5217`) + t(`${i18nPrefix}\u7684`) + t(`${i18nPrefix}\u8868\u683C`)\n                        }</span>\n                    </div>\n                    <div class=\"w-e-button-container\">\n                        <button id=\"${insertBtnId}\" class=\"right\">${t('\u63D2\u5165')}</button>\n                    </div>\n                </div>`,\n            events: [\n                {\n                    selector: '#' + insertBtnId,\n                    type: 'click',\n                    fn: () => {\n                        const colValue = Number($('#' + colId).val())\n                        const rowValue = Number($('#' + rowId).val())\n                        //\u6821\u9A8C\u662F\u5426\u4F20\u503C\n                        if (colValue && rowValue) {\n                            createTable.createAction(rowValue, colValue)\n                        }\n                        // \u8FD4\u56DE true \u8868\u793A\u51FD\u6570\u6267\u884C\u7ED3\u675F\u4E4B\u540E\u5173\u95ED panel\n                        return true\n                    },\n                },\n            ],\n        },\n    ]\n    // tabs end\n\n    // \u6700\u7EC8\u7684\u914D\u7F6E -----------------------------------------\n    const conf: PanelConf = {\n        width: 330,\n        height: 0,\n        tabs: [],\n    }\n    conf.tabs.push(tabsConf[0])\n\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a217a1b20d849fbb813bed5ce67fd7158bdca684"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_m17lrd2fk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_m17lrd2fk();

var __importDefault = (cov_m17lrd2fk().s[0]++, (cov_m17lrd2fk().b[0][0]++, void 0) && (cov_m17lrd2fk().b[0][1]++, (void 0).__importDefault) || (cov_m17lrd2fk().b[0][2]++, function (mod) {
  cov_m17lrd2fk().f[0]++;
  cov_m17lrd2fk().s[1]++;
  return (cov_m17lrd2fk().b[2][0]++, mod) && (cov_m17lrd2fk().b[2][1]++, mod.__esModule) ? (cov_m17lrd2fk().b[1][0]++, mod) : (cov_m17lrd2fk().b[1][1]++, {
    "default": mod
  });
}));

cov_m17lrd2fk().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_m17lrd2fk().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_m17lrd2fk().s[4]++, __importDefault(__webpack_require__(2)));
cov_m17lrd2fk().s[5]++;

__webpack_require__(362);

var create_table_1 = (cov_m17lrd2fk().s[6]++, __importDefault(__webpack_require__(364)));

function default_1(editor) {
  cov_m17lrd2fk().f[1]++;
  var createTable = (cov_m17lrd2fk().s[7]++, new create_table_1["default"](editor)); // panel 中需要用到的id

  var colId = (cov_m17lrd2fk().s[8]++, util_1.getRandom('w-col-id'));
  var rowId = (cov_m17lrd2fk().s[9]++, util_1.getRandom('w-row-id'));
  var insertBtnId = (cov_m17lrd2fk().s[10]++, util_1.getRandom('btn-link'));
  var i18nPrefix = (cov_m17lrd2fk().s[11]++, 'menus.panelMenus.table.');
  cov_m17lrd2fk().s[12]++;

  var t = function t(text) {
    cov_m17lrd2fk().f[2]++;
    cov_m17lrd2fk().s[13]++;
    return editor.i18next.t(text);
  }; // tabs 配置 -----------------------------------------


  var tabsConf = (cov_m17lrd2fk().s[14]++, [{
    title: t(i18nPrefix + "\u63D2\u5165\u8868\u683C"),
    tpl: "<div>\n                    <div class=\"w-e-table\">\n                        <span>" + t('创建') + "</span>\n                        <input id=\"" + rowId + "\"  type=\"text\" class=\"w-e-table-input\" value=\"5\"/></td>\n                        <span>" + t(i18nPrefix + "\u884C") + "</span>\n                        <input id=\"" + colId + "\" type=\"text\" class=\"w-e-table-input\" value=\"5\"/></td>\n                        <span>" + (t(i18nPrefix + "\u5217") + t(i18nPrefix + "\u7684") + t(i18nPrefix + "\u8868\u683C")) + "</span>\n                    </div>\n                    <div class=\"w-e-button-container\">\n                        <button id=\"" + insertBtnId + "\" class=\"right\">" + t('插入') + "</button>\n                    </div>\n                </div>",
    events: [{
      selector: '#' + insertBtnId,
      type: 'click',
      fn: function fn() {
        cov_m17lrd2fk().f[3]++;
        var colValue = (cov_m17lrd2fk().s[15]++, Number(dom_core_1["default"]('#' + colId).val()));
        var rowValue = (cov_m17lrd2fk().s[16]++, Number(dom_core_1["default"]('#' + rowId).val())); //校验是否传值

        cov_m17lrd2fk().s[17]++;

        if ((cov_m17lrd2fk().b[4][0]++, colValue) && (cov_m17lrd2fk().b[4][1]++, rowValue)) {
          cov_m17lrd2fk().b[3][0]++;
          cov_m17lrd2fk().s[18]++;
          createTable.createAction(rowValue, colValue);
        } else {
          cov_m17lrd2fk().b[3][1]++;
        } // 返回 true 表示函数执行结束之后关闭 panel


        cov_m17lrd2fk().s[19]++;
        return true;
      }
    }]
  }]); // tabs end
  // 最终的配置 -----------------------------------------

  var conf = (cov_m17lrd2fk().s[20]++, {
    width: 330,
    height: 0,
    tabs: []
  });
  cov_m17lrd2fk().s[21]++;
  conf.tabs.push(tabsConf[0]);
  cov_m17lrd2fk().s[22]++;
  return conf;
}

cov_m17lrd2fk().s[23]++;
exports["default"] = default_1;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(363);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-table {\n  display: flex;\n}\n.w-e-table .w-e-table-input {\n  width: 40px;\n  text-align: center!important;\n  margin: 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 创建tabel
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1qd25atndc() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-table.ts";
  var hash = "9ca983adf124c06440b1899fd9d70834d6f285f8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-table.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 33
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "6": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 31,
          column: 6
        }
      },
      "7": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 32
        }
      },
      "8": {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 23,
          column: 93
        }
      },
      "9": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 104
        }
      },
      "10": {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 25,
          column: 104
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 28,
          column: 9
        }
      },
      "12": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 19
        }
      },
      "13": {
        start: {
          line: 29,
          column: 23
        },
        end: {
          line: 29,
          column: 63
        }
      },
      "14": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 46
        }
      },
      "15": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "16": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 23
        }
      },
      "17": {
        start: {
          line: 39,
          column: 21
        },
        end: {
          line: 39,
          column: 23
        }
      },
      "18": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "19": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 22
        }
      },
      "20": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 24
        }
      },
      "21": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 49,
          column: 13
        }
      },
      "22": {
        start: {
          line: 42,
          column: 25
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "23": {
        start: {
          line: 43,
          column: 16
        },
        end: {
          line: 48,
          column: 17
        }
      },
      "24": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 50
        }
      },
      "25": {
        start: {
          line: 47,
          column: 20
        },
        end: {
          line: 47,
          column: 50
        }
      },
      "26": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 56
        }
      },
      "27": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 54,
          column: 41
        }
      },
      "28": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 24
        }
      },
      "29": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 23
        }
      },
      "30": {
        start: {
          line: 59,
          column: 0
        },
        end: {
          line: 59,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 33
          },
          end: {
            line: 11,
            column: 34
          }
        },
        loc: {
          start: {
            line: 11,
            column: 45
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "CreateTable",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 24
          }
        },
        loc: {
          start: {
            line: 12,
            column: 33
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 41
          },
          end: {
            line: 20,
            column: 42
          }
        },
        loc: {
          start: {
            line: 20,
            column: 71
          },
          end: {
            line: 31,
            column: 5
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 44
          },
          end: {
            line: 37,
            column: 45
          }
        },
        loc: {
          start: {
            line: 37,
            column: 74
          },
          end: {
            line: 56,
            column: 5
          }
        },
        line: 37
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }, {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 12
          },
          end: {
            line: 26,
            column: 15
          }
        }, {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 22
          }
        }],
        line: 26
      },
      "5": {
        loc: {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 48,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 48,
            column: 17
          }
        }, {
          start: {
            line: 43,
            column: 16
          },
          end: {
            line: 48,
            column: 17
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/create-table.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/create-table.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoC;AAEpC;IAGI,qBAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;;;OAIG;IACI,kCAAY,GAAnB,UAAoB,QAAgB,EAAE,QAAgB;QAClD,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAE1B,kBAAkB;QAClB,IAAI,cAAc,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAC,CAAA;QACpE,IAAM,GAAG,GAAG,kBAAC,CAAC,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,IAAI,EAAE,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QACjF,IAAM,GAAG,GAAG,kBAAC,CAAC,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,IAAI,EAAE,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QACjF,IAAI,GAAG,IAAI,GAAG,EAAE;YACZ,OAAM;SACT;QAED,IAAM,QAAQ,GAAW,IAAI,CAAC,eAAe,CAAC,QAAQ,EAAE,QAAQ,CAAC,CAAA;QACjE,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,QAAQ,CAAC,CAAA;IACzC,CAAC;IAED;;;;OAIG;IACI,qCAAe,GAAtB,UAAuB,QAAgB,EAAE,QAAgB;QACrD,IAAI,MAAM,GAAW,EAAE,CAAA;QACvB,IAAI,MAAM,GAAW,EAAE,CAAA;QACvB,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,EAAE,CAAC,EAAE,EAAE;YAC/B,MAAM,GAAG,EAAE,CAAA;YACX,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,EAAE,CAAC,EAAE,EAAE;gBAC/B,IAAI,CAAC,KAAK,CAAC,EAAE;oBACT,MAAM,GAAG,MAAM,GAAG,WAAW,CAAA;iBAChC;qBAAM;oBACH,MAAM,GAAG,MAAM,GAAG,WAAW,CAAA;iBAChC;aACJ;YACD,MAAM,GAAG,MAAM,GAAG,MAAM,GAAG,MAAM,GAAG,OAAO,CAAA;SAC9C;QACD,IAAM,QAAQ,GACV,gFAAwE;YACxE,MAAM;YACN,6BAA6B,CAAA;QACjC,OAAO,QAAQ,CAAA;IACnB,CAAC;IACL,kBAAC;AAAD,CAAC,AApDD,IAoDC;AAED,kBAAe,WAAW,CAAA",
      sourcesContent: ["/**\n * @description \u521B\u5EFAtabel\n * @author lichunlin\n */\n\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\n\nclass CreateTable {\n    private editor: Editor\n\n    constructor(editor: Editor) {\n        this.editor = editor\n    }\n\n    /**\n     * \u6267\u884C\u521B\u5EFA\n     * @param rowValue \u884C\u6570\n     * @param colValue \u5217\u6570\n     */\n    public createAction(rowValue: number, colValue: number) {\n        const editor = this.editor\n\n        //\u4E0D\u5141\u8BB8\u5728\u6709\u5E8F\u5217\u8868\u4E2D\u6DFB\u52A0table\n        let $selectionElem = $(editor.selection.getSelectionContainerElem())\n        const $ul = $($selectionElem.elems[0]).parentUntil('UL', $selectionElem.elems[0])\n        const $ol = $($selectionElem.elems[0]).parentUntil('OL', $selectionElem.elems[0])\n        if ($ul || $ol) {\n            return\n        }\n\n        const tableDom: string = this.createTableHtml(rowValue, colValue)\n        editor.cmd.do('insertHTML', tableDom)\n    }\n\n    /**\n     * \u521B\u5EFAtable\u3001\u884C\u3001\u5217\n     * @param rowValue \u884C\u6570\n     * @param colValue \u5217\u6570\n     */\n    public createTableHtml(rowValue: number, colValue: number): string {\n        let rowStr: string = ''\n        let colStr: string = ''\n        for (let i = 0; i < rowValue; i++) {\n            colStr = ''\n            for (let j = 0; j < colValue; j++) {\n                if (i === 0) {\n                    colStr = colStr + '<th></th>'\n                } else {\n                    colStr = colStr + '<td></td>'\n                }\n            }\n            rowStr = rowStr + '<tr>' + colStr + '</tr>'\n        }\n        const tableDom =\n            `<table border=\"0\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\"><tbody>` +\n            rowStr +\n            '</tbody></table><p><br></p>'\n        return tableDom\n    }\n}\n\nexport default CreateTable\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9ca983adf124c06440b1899fd9d70834d6f285f8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1qd25atndc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1qd25atndc();

var __importDefault = (cov_1qd25atndc().s[0]++, (cov_1qd25atndc().b[0][0]++, void 0) && (cov_1qd25atndc().b[0][1]++, (void 0).__importDefault) || (cov_1qd25atndc().b[0][2]++, function (mod) {
  cov_1qd25atndc().f[0]++;
  cov_1qd25atndc().s[1]++;
  return (cov_1qd25atndc().b[2][0]++, mod) && (cov_1qd25atndc().b[2][1]++, mod.__esModule) ? (cov_1qd25atndc().b[1][0]++, mod) : (cov_1qd25atndc().b[1][1]++, {
    "default": mod
  });
}));

cov_1qd25atndc().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1qd25atndc().s[3]++, __importDefault(__webpack_require__(2)));
var CreateTable = (
/** @class */
cov_1qd25atndc().s[4]++, function () {
  cov_1qd25atndc().f[1]++;

  function CreateTable(editor) {
    cov_1qd25atndc().f[2]++;
    cov_1qd25atndc().s[5]++;
    this.editor = editor;
  }
  /**
   * 执行创建
   * @param rowValue 行数
   * @param colValue 列数
   */


  cov_1qd25atndc().s[6]++;

  CreateTable.prototype.createAction = function (rowValue, colValue) {
    cov_1qd25atndc().f[3]++;
    var editor = (cov_1qd25atndc().s[7]++, this.editor); //不允许在有序列表中添加table

    var $selectionElem = (cov_1qd25atndc().s[8]++, dom_core_1["default"](editor.selection.getSelectionContainerElem()));
    var $ul = (cov_1qd25atndc().s[9]++, dom_core_1["default"]($selectionElem.elems[0]).parentUntil('UL', $selectionElem.elems[0]));
    var $ol = (cov_1qd25atndc().s[10]++, dom_core_1["default"]($selectionElem.elems[0]).parentUntil('OL', $selectionElem.elems[0]));
    cov_1qd25atndc().s[11]++;

    if ((cov_1qd25atndc().b[4][0]++, $ul) || (cov_1qd25atndc().b[4][1]++, $ol)) {
      cov_1qd25atndc().b[3][0]++;
      cov_1qd25atndc().s[12]++;
      return;
    } else {
      cov_1qd25atndc().b[3][1]++;
    }

    var tableDom = (cov_1qd25atndc().s[13]++, this.createTableHtml(rowValue, colValue));
    cov_1qd25atndc().s[14]++;
    editor.cmd["do"]('insertHTML', tableDom);
  };
  /**
   * 创建table、行、列
   * @param rowValue 行数
   * @param colValue 列数
   */


  cov_1qd25atndc().s[15]++;

  CreateTable.prototype.createTableHtml = function (rowValue, colValue) {
    cov_1qd25atndc().f[4]++;
    var rowStr = (cov_1qd25atndc().s[16]++, '');
    var colStr = (cov_1qd25atndc().s[17]++, '');
    cov_1qd25atndc().s[18]++;

    for (var i = (cov_1qd25atndc().s[19]++, 0); i < rowValue; i++) {
      cov_1qd25atndc().s[20]++;
      colStr = '';
      cov_1qd25atndc().s[21]++;

      for (var j = (cov_1qd25atndc().s[22]++, 0); j < colValue; j++) {
        cov_1qd25atndc().s[23]++;

        if (i === 0) {
          cov_1qd25atndc().b[5][0]++;
          cov_1qd25atndc().s[24]++;
          colStr = colStr + '<th></th>';
        } else {
          cov_1qd25atndc().b[5][1]++;
          cov_1qd25atndc().s[25]++;
          colStr = colStr + '<td></td>';
        }
      }

      cov_1qd25atndc().s[26]++;
      rowStr = rowStr + '<tr>' + colStr + '</tr>';
    }

    var tableDom = (cov_1qd25atndc().s[27]++, "<table border=\"0\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\"><tbody>" + rowStr + '</tbody></table><p><br></p>');
    cov_1qd25atndc().s[28]++;
    return tableDom;
  };

  cov_1qd25atndc().s[29]++;
  return CreateTable;
}());
cov_1qd25atndc().s[30]++;
exports["default"] = CreateTable;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 绑定点击事件
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1fvdlu9e4() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/index.ts";
  var hash = "4c3eaa5533a1ae813967a541c9d3eacb20af07b7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "5": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 18
          }
        },
        loc: {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAyC;AAEzC;;;GAGG;AACH,SAAS,SAAS,CAAC,MAAc;IAC7B,SAAS;IACT,uBAAW,CAAC,MAAM,CAAC,CAAA;AACvB,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u70B9\u51FB\u4E8B\u4EF6\n * @author lichunlin\n */\n\nimport Editor from '../../../editor/index'\nimport bindTooltip from './tooltip-event'\n\n/**\n * \u7ED1\u5B9A\u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindEvent(editor: Editor): void {\n    //Tooltip\n    bindTooltip(editor)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4c3eaa5533a1ae813967a541c9d3eacb20af07b7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fvdlu9e4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1fvdlu9e4();

var __importDefault = (cov_1fvdlu9e4().s[0]++, (cov_1fvdlu9e4().b[0][0]++, void 0) && (cov_1fvdlu9e4().b[0][1]++, (void 0).__importDefault) || (cov_1fvdlu9e4().b[0][2]++, function (mod) {
  cov_1fvdlu9e4().f[0]++;
  cov_1fvdlu9e4().s[1]++;
  return (cov_1fvdlu9e4().b[2][0]++, mod) && (cov_1fvdlu9e4().b[2][1]++, mod.__esModule) ? (cov_1fvdlu9e4().b[1][0]++, mod) : (cov_1fvdlu9e4().b[1][1]++, {
    "default": mod
  });
}));

cov_1fvdlu9e4().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var tooltip_event_1 = (cov_1fvdlu9e4().s[3]++, __importDefault(__webpack_require__(366)));
/**
 * 绑定事件
 * @param editor 编辑器实例
 */

function bindEvent(editor) {
  cov_1fvdlu9e4().f[1]++;
  cov_1fvdlu9e4().s[4]++;
  //Tooltip
  tooltip_event_1["default"](editor);
}

cov_1fvdlu9e4().s[5]++;
exports["default"] = bindEvent;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description tooltip 事件
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1hvvz6tyk6() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/tooltip-event.ts";
  var hash = "1c129d668091186512a5272c1ca8ca98c0ddd9a2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/tooltip-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 75
        }
      },
      "5": {
        start: {
          line: 13,
          column: 24
        },
        end: {
          line: 13,
          column: 75
        }
      },
      "6": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 14,
          column: 59
        }
      },
      "7": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 51
        }
      },
      "8": {
        start: {
          line: 26,
          column: 25
        },
        end: {
          line: 26,
          column: 50
        }
      },
      "9": {
        start: {
          line: 27,
          column: 16
        },
        end: {
          line: 30,
          column: 9
        }
      },
      "10": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 59
        }
      },
      "11": {
        start: {
          line: 28,
          column: 37
        },
        end: {
          line: 28,
          column: 57
        }
      },
      "12": {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 29,
          column: 51
        }
      },
      "13": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 223,
          column: 9
        }
      },
      "14": {
        start: {
          line: 37,
          column: 20
        },
        end: {
          line: 37,
          column: 62
        }
      },
      "15": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 38,
          column: 56
        }
      },
      "16": {
        start: {
          line: 39,
          column: 20
        },
        end: {
          line: 39,
          column: 63
        }
      },
      "17": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 32
        }
      },
      "18": {
        start: {
          line: 48,
          column: 33
        },
        end: {
          line: 48,
          column: 56
        }
      },
      "19": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 51,
          column: 21
        }
      },
      "20": {
        start: {
          line: 50,
          column: 24
        },
        end: {
          line: 50,
          column: 36
        }
      },
      "21": {
        start: {
          line: 53,
          column: 36
        },
        end: {
          line: 53,
          column: 96
        }
      },
      "22": {
        start: {
          line: 55,
          column: 38
        },
        end: {
          line: 55,
          column: 76
        }
      },
      "23": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 58,
          column: 21
        }
      },
      "24": {
        start: {
          line: 57,
          column: 24
        },
        end: {
          line: 57,
          column: 36
        }
      },
      "25": {
        start: {
          line: 60,
          column: 32
        },
        end: {
          line: 60,
          column: 95
        }
      },
      "26": {
        start: {
          line: 62,
          column: 34
        },
        end: {
          line: 62,
          column: 70
        }
      },
      "27": {
        start: {
          line: 64,
          column: 33
        },
        end: {
          line: 64,
          column: 139
        }
      },
      "28": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 66,
          column: 62
        }
      },
      "29": {
        start: {
          line: 67,
          column: 20
        },
        end: {
          line: 67,
          column: 56
        }
      },
      "30": {
        start: {
          line: 68,
          column: 20
        },
        end: {
          line: 68,
          column: 56
        }
      },
      "31": {
        start: {
          line: 69,
          column: 20
        },
        end: {
          line: 69,
          column: 32
        }
      },
      "32": {
        start: {
          line: 76,
          column: 33
        },
        end: {
          line: 76,
          column: 56
        }
      },
      "33": {
        start: {
          line: 77,
          column: 20
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "34": {
        start: {
          line: 78,
          column: 24
        },
        end: {
          line: 78,
          column: 36
        }
      },
      "35": {
        start: {
          line: 81,
          column: 36
        },
        end: {
          line: 81,
          column: 96
        }
      },
      "36": {
        start: {
          line: 83,
          column: 38
        },
        end: {
          line: 83,
          column: 76
        }
      },
      "37": {
        start: {
          line: 84,
          column: 20
        },
        end: {
          line: 86,
          column: 21
        }
      },
      "38": {
        start: {
          line: 85,
          column: 24
        },
        end: {
          line: 85,
          column: 36
        }
      },
      "39": {
        start: {
          line: 88,
          column: 32
        },
        end: {
          line: 88,
          column: 95
        }
      },
      "40": {
        start: {
          line: 90,
          column: 34
        },
        end: {
          line: 90,
          column: 70
        }
      },
      "41": {
        start: {
          line: 92,
          column: 35
        },
        end: {
          line: 93,
          column: 56
        }
      },
      "42": {
        start: {
          line: 95,
          column: 33
        },
        end: {
          line: 95,
          column: 35
        }
      },
      "43": {
        start: {
          line: 97,
          column: 20
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "44": {
        start: {
          line: 98,
          column: 20
        },
        end: {
          line: 98,
          column: 56
        }
      },
      "45": {
        start: {
          line: 99,
          column: 20
        },
        end: {
          line: 104,
          column: 21
        }
      },
      "46": {
        start: {
          line: 100,
          column: 24
        },
        end: {
          line: 100,
          column: 47
        }
      },
      "47": {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 103,
          column: 136
        }
      },
      "48": {
        start: {
          line: 105,
          column: 20
        },
        end: {
          line: 105,
          column: 56
        }
      },
      "49": {
        start: {
          line: 106,
          column: 20
        },
        end: {
          line: 106,
          column: 32
        }
      },
      "50": {
        start: {
          line: 113,
          column: 33
        },
        end: {
          line: 113,
          column: 56
        }
      },
      "51": {
        start: {
          line: 114,
          column: 20
        },
        end: {
          line: 116,
          column: 21
        }
      },
      "52": {
        start: {
          line: 115,
          column: 24
        },
        end: {
          line: 115,
          column: 36
        }
      },
      "53": {
        start: {
          line: 118,
          column: 36
        },
        end: {
          line: 118,
          column: 96
        }
      },
      "54": {
        start: {
          line: 120,
          column: 32
        },
        end: {
          line: 120,
          column: 78
        }
      },
      "55": {
        start: {
          line: 122,
          column: 34
        },
        end: {
          line: 122,
          column: 70
        }
      },
      "56": {
        start: {
          line: 124,
          column: 33
        },
        end: {
          line: 124,
          column: 139
        }
      },
      "57": {
        start: {
          line: 126,
          column: 20
        },
        end: {
          line: 126,
          column: 62
        }
      },
      "58": {
        start: {
          line: 127,
          column: 20
        },
        end: {
          line: 127,
          column: 56
        }
      },
      "59": {
        start: {
          line: 128,
          column: 20
        },
        end: {
          line: 128,
          column: 56
        }
      },
      "60": {
        start: {
          line: 129,
          column: 20
        },
        end: {
          line: 129,
          column: 32
        }
      },
      "61": {
        start: {
          line: 136,
          column: 33
        },
        end: {
          line: 136,
          column: 56
        }
      },
      "62": {
        start: {
          line: 137,
          column: 20
        },
        end: {
          line: 139,
          column: 21
        }
      },
      "63": {
        start: {
          line: 138,
          column: 24
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "64": {
        start: {
          line: 141,
          column: 36
        },
        end: {
          line: 141,
          column: 96
        }
      },
      "65": {
        start: {
          line: 143,
          column: 32
        },
        end: {
          line: 143,
          column: 78
        }
      },
      "66": {
        start: {
          line: 145,
          column: 34
        },
        end: {
          line: 145,
          column: 70
        }
      },
      "67": {
        start: {
          line: 147,
          column: 35
        },
        end: {
          line: 148,
          column: 70
        }
      },
      "68": {
        start: {
          line: 150,
          column: 33
        },
        end: {
          line: 150,
          column: 35
        }
      },
      "69": {
        start: {
          line: 152,
          column: 20
        },
        end: {
          line: 152,
          column: 62
        }
      },
      "70": {
        start: {
          line: 153,
          column: 20
        },
        end: {
          line: 153,
          column: 56
        }
      },
      "71": {
        start: {
          line: 154,
          column: 20
        },
        end: {
          line: 159,
          column: 21
        }
      },
      "72": {
        start: {
          line: 155,
          column: 24
        },
        end: {
          line: 155,
          column: 47
        }
      },
      "73": {
        start: {
          line: 158,
          column: 24
        },
        end: {
          line: 158,
          column: 136
        }
      },
      "74": {
        start: {
          line: 160,
          column: 20
        },
        end: {
          line: 160,
          column: 56
        }
      },
      "75": {
        start: {
          line: 161,
          column: 20
        },
        end: {
          line: 161,
          column: 32
        }
      },
      "76": {
        start: {
          line: 168,
          column: 33
        },
        end: {
          line: 168,
          column: 56
        }
      },
      "77": {
        start: {
          line: 169,
          column: 20
        },
        end: {
          line: 171,
          column: 21
        }
      },
      "78": {
        start: {
          line: 170,
          column: 24
        },
        end: {
          line: 170,
          column: 36
        }
      },
      "79": {
        start: {
          line: 173,
          column: 36
        },
        end: {
          line: 173,
          column: 96
        }
      },
      "80": {
        start: {
          line: 175,
          column: 38
        },
        end: {
          line: 175,
          column: 76
        }
      },
      "81": {
        start: {
          line: 176,
          column: 20
        },
        end: {
          line: 178,
          column: 21
        }
      },
      "82": {
        start: {
          line: 177,
          column: 24
        },
        end: {
          line: 177,
          column: 36
        }
      },
      "83": {
        start: {
          line: 180,
          column: 32
        },
        end: {
          line: 180,
          column: 95
        }
      },
      "84": {
        start: {
          line: 181,
          column: 20
        },
        end: {
          line: 184,
          column: 21
        }
      },
      "85": {
        start: {
          line: 183,
          column: 24
        },
        end: {
          line: 183,
          column: 34
        }
      },
      "86": {
        start: {
          line: 186,
          column: 34
        },
        end: {
          line: 186,
          column: 70
        }
      },
      "87": {
        start: {
          line: 188,
          column: 33
        },
        end: {
          line: 188,
          column: 144
        }
      },
      "88": {
        start: {
          line: 190,
          column: 20
        },
        end: {
          line: 190,
          column: 62
        }
      },
      "89": {
        start: {
          line: 191,
          column: 20
        },
        end: {
          line: 191,
          column: 56
        }
      },
      "90": {
        start: {
          line: 192,
          column: 20
        },
        end: {
          line: 192,
          column: 56
        }
      },
      "91": {
        start: {
          line: 193,
          column: 20
        },
        end: {
          line: 193,
          column: 32
        }
      },
      "92": {
        start: {
          line: 200,
          column: 36
        },
        end: {
          line: 200,
          column: 96
        }
      },
      "93": {
        start: {
          line: 202,
          column: 38
        },
        end: {
          line: 202,
          column: 76
        }
      },
      "94": {
        start: {
          line: 203,
          column: 20
        },
        end: {
          line: 205,
          column: 21
        }
      },
      "95": {
        start: {
          line: 204,
          column: 24
        },
        end: {
          line: 204,
          column: 36
        }
      },
      "96": {
        start: {
          line: 207,
          column: 32
        },
        end: {
          line: 207,
          column: 95
        }
      },
      "97": {
        start: {
          line: 208,
          column: 20
        },
        end: {
          line: 211,
          column: 21
        }
      },
      "98": {
        start: {
          line: 210,
          column: 24
        },
        end: {
          line: 210,
          column: 34
        }
      },
      "99": {
        start: {
          line: 213,
          column: 34
        },
        end: {
          line: 213,
          column: 70
        }
      },
      "100": {
        start: {
          line: 215,
          column: 33
        },
        end: {
          line: 215,
          column: 144
        }
      },
      "101": {
        start: {
          line: 217,
          column: 20
        },
        end: {
          line: 217,
          column: 62
        }
      },
      "102": {
        start: {
          line: 218,
          column: 20
        },
        end: {
          line: 218,
          column: 56
        }
      },
      "103": {
        start: {
          line: 219,
          column: 20
        },
        end: {
          line: 219,
          column: 56
        }
      },
      "104": {
        start: {
          line: 220,
          column: 20
        },
        end: {
          line: 220,
          column: 32
        }
      },
      "105": {
        start: {
          line: 224,
          column: 8
        },
        end: {
          line: 224,
          column: 61
        }
      },
      "106": {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 225,
          column: 25
        }
      },
      "107": {
        start: {
          line: 232,
          column: 8
        },
        end: {
          line: 235,
          column: 9
        }
      },
      "108": {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 233,
          column: 29
        }
      },
      "109": {
        start: {
          line: 234,
          column: 12
        },
        end: {
          line: 234,
          column: 27
        }
      },
      "110": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 240,
          column: 6
        }
      },
      "111": {
        start: {
          line: 246,
          column: 21
        },
        end: {
          line: 246,
          column: 61
        }
      },
      "112": {
        start: {
          line: 247,
          column: 19
        },
        end: {
          line: 247,
          column: 57
        }
      },
      "113": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 253,
          column: 5
        }
      },
      "114": {
        start: {
          line: 249,
          column: 8
        },
        end: {
          line: 249,
          column: 20
        }
      },
      "115": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 21
        }
      },
      "116": {
        start: {
          line: 260,
          column: 13
        },
        end: {
          line: 260,
          column: 37
        }
      },
      "117": {
        start: {
          line: 260,
          column: 58
        },
        end: {
          line: 260,
          column: 77
        }
      },
      "118": {
        start: {
          line: 260,
          column: 98
        },
        end: {
          line: 260,
          column: 117
        }
      },
      "119": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 66
        }
      },
      "120": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 61
        }
      },
      "121": {
        start: {
          line: 265,
          column: 4
        },
        end: {
          line: 265,
          column: 61
        }
      },
      "122": {
        start: {
          line: 266,
          column: 4
        },
        end: {
          line: 266,
          column: 68
        }
      },
      "123": {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 267,
          column: 65
        }
      },
      "124": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 268,
          column: 66
        }
      },
      "125": {
        start: {
          line: 270,
          column: 0
        },
        end: {
          line: 270,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 25
          }
        },
        loc: {
          start: {
            line: 18,
            column: 34
          },
          end: {
            line: 241,
            column: 1
          }
        },
        line: 18
      },
      "2": {
        name: "showTableTooltip",
        decl: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 29
          }
        },
        loc: {
          start: {
            line: 24,
            column: 37
          },
          end: {
            line: 226,
            column: 5
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 16
          },
          end: {
            line: 27,
            column: 17
          }
        },
        loc: {
          start: {
            line: 27,
            column: 40
          },
          end: {
            line: 30,
            column: 9
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 35,
            column: 26
          }
        },
        loc: {
          start: {
            line: 35,
            column: 50
          },
          end: {
            line: 42,
            column: 17
          }
        },
        line: 35
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 26
          }
        },
        loc: {
          start: {
            line: 46,
            column: 50
          },
          end: {
            line: 70,
            column: 17
          }
        },
        line: 46
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 25
          },
          end: {
            line: 74,
            column: 26
          }
        },
        loc: {
          start: {
            line: 74,
            column: 50
          },
          end: {
            line: 107,
            column: 17
          }
        },
        line: 74
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 111,
            column: 25
          },
          end: {
            line: 111,
            column: 26
          }
        },
        loc: {
          start: {
            line: 111,
            column: 50
          },
          end: {
            line: 130,
            column: 17
          }
        },
        line: 111
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 26
          }
        },
        loc: {
          start: {
            line: 134,
            column: 50
          },
          end: {
            line: 162,
            column: 17
          }
        },
        line: 134
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 166,
            column: 25
          },
          end: {
            line: 166,
            column: 26
          }
        },
        loc: {
          start: {
            line: 166,
            column: 50
          },
          end: {
            line: 194,
            column: 17
          }
        },
        line: 166
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 198,
            column: 25
          },
          end: {
            line: 198,
            column: 26
          }
        },
        loc: {
          start: {
            line: 198,
            column: 50
          },
          end: {
            line: 221,
            column: 17
          }
        },
        line: 198
      },
      "11": {
        name: "hideTableTooltip",
        decl: {
          start: {
            line: 230,
            column: 13
          },
          end: {
            line: 230,
            column: 29
          }
        },
        loc: {
          start: {
            line: 230,
            column: 32
          },
          end: {
            line: 236,
            column: 5
          }
        },
        line: 230
      },
      "12": {
        name: "isMoreRowAction",
        decl: {
          start: {
            line: 245,
            column: 9
          },
          end: {
            line: 245,
            column: 24
          }
        },
        loc: {
          start: {
            line: 245,
            column: 33
          },
          end: {
            line: 254,
            column: 1
          }
        },
        line: 245
      },
      "13": {
        name: "bindTooltipEvent",
        decl: {
          start: {
            line: 259,
            column: 9
          },
          end: {
            line: 259,
            column: 25
          }
        },
        loc: {
          start: {
            line: 259,
            column: 34
          },
          end: {
            line: 269,
            column: 1
          }
        },
        line: 259
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 59
          }
        }, {
          start: {
            line: 28,
            column: 12
          },
          end: {
            line: 28,
            column: 59
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        }, {
          start: {
            line: 49,
            column: 20
          },
          end: {
            line: 51,
            column: 21
          }
        }],
        line: 49
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 58,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 58,
            column: 21
          }
        }, {
          start: {
            line: 56,
            column: 20
          },
          end: {
            line: 58,
            column: 21
          }
        }],
        line: 56
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 20
          },
          end: {
            line: 79,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 20
          },
          end: {
            line: 79,
            column: 21
          }
        }, {
          start: {
            line: 77,
            column: 20
          },
          end: {
            line: 79,
            column: 21
          }
        }],
        line: 77
      },
      "7": {
        loc: {
          start: {
            line: 84,
            column: 20
          },
          end: {
            line: 86,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 20
          },
          end: {
            line: 86,
            column: 21
          }
        }, {
          start: {
            line: 84,
            column: 20
          },
          end: {
            line: 86,
            column: 21
          }
        }],
        line: 84
      },
      "8": {
        loc: {
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 104,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 104,
            column: 21
          }
        }, {
          start: {
            line: 99,
            column: 20
          },
          end: {
            line: 104,
            column: 21
          }
        }],
        line: 99
      },
      "9": {
        loc: {
          start: {
            line: 114,
            column: 20
          },
          end: {
            line: 116,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 20
          },
          end: {
            line: 116,
            column: 21
          }
        }, {
          start: {
            line: 114,
            column: 20
          },
          end: {
            line: 116,
            column: 21
          }
        }],
        line: 114
      },
      "10": {
        loc: {
          start: {
            line: 137,
            column: 20
          },
          end: {
            line: 139,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 20
          },
          end: {
            line: 139,
            column: 21
          }
        }, {
          start: {
            line: 137,
            column: 20
          },
          end: {
            line: 139,
            column: 21
          }
        }],
        line: 137
      },
      "11": {
        loc: {
          start: {
            line: 154,
            column: 20
          },
          end: {
            line: 159,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 20
          },
          end: {
            line: 159,
            column: 21
          }
        }, {
          start: {
            line: 154,
            column: 20
          },
          end: {
            line: 159,
            column: 21
          }
        }],
        line: 154
      },
      "12": {
        loc: {
          start: {
            line: 169,
            column: 20
          },
          end: {
            line: 171,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 20
          },
          end: {
            line: 171,
            column: 21
          }
        }, {
          start: {
            line: 169,
            column: 20
          },
          end: {
            line: 171,
            column: 21
          }
        }],
        line: 169
      },
      "13": {
        loc: {
          start: {
            line: 176,
            column: 20
          },
          end: {
            line: 178,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 20
          },
          end: {
            line: 178,
            column: 21
          }
        }, {
          start: {
            line: 176,
            column: 20
          },
          end: {
            line: 178,
            column: 21
          }
        }],
        line: 176
      },
      "14": {
        loc: {
          start: {
            line: 181,
            column: 20
          },
          end: {
            line: 184,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 20
          },
          end: {
            line: 184,
            column: 21
          }
        }, {
          start: {
            line: 181,
            column: 20
          },
          end: {
            line: 184,
            column: 21
          }
        }],
        line: 181
      },
      "15": {
        loc: {
          start: {
            line: 203,
            column: 20
          },
          end: {
            line: 205,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 20
          },
          end: {
            line: 205,
            column: 21
          }
        }, {
          start: {
            line: 203,
            column: 20
          },
          end: {
            line: 205,
            column: 21
          }
        }],
        line: 203
      },
      "16": {
        loc: {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 211,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 211,
            column: 21
          }
        }, {
          start: {
            line: 208,
            column: 20
          },
          end: {
            line: 211,
            column: 21
          }
        }],
        line: 208
      },
      "17": {
        loc: {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }, {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }],
        line: 232
      },
      "18": {
        loc: {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 253,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 253,
            column: 5
          }
        }, {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 253,
            column: 5
          }
        }],
        line: 248
      },
      "19": {
        loc: {
          start: {
            line: 248,
            column: 9
          },
          end: {
            line: 248,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 248,
            column: 56
          },
          end: {
            line: 248,
            column: 62
          }
        }, {
          start: {
            line: 248,
            column: 65
          },
          end: {
            line: 248,
            column: 84
          }
        }],
        line: 248
      },
      "20": {
        loc: {
          start: {
            line: 248,
            column: 9
          },
          end: {
            line: 248,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 9
          },
          end: {
            line: 248,
            column: 28
          }
        }, {
          start: {
            line: 248,
            column: 32
          },
          end: {
            line: 248,
            column: 53
          }
        }],
        line: 248
      },
      "21": {
        loc: {
          start: {
            line: 248,
            column: 91
          },
          end: {
            line: 248,
            column: 160
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 248,
            column: 134
          },
          end: {
            line: 248,
            column: 140
          }
        }, {
          start: {
            line: 248,
            column: 143
          },
          end: {
            line: 248,
            column: 160
          }
        }],
        line: 248
      },
      "22": {
        loc: {
          start: {
            line: 248,
            column: 91
          },
          end: {
            line: 248,
            column: 131
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 91
          },
          end: {
            line: 248,
            column: 108
          }
        }, {
          start: {
            line: 248,
            column: 112
          },
          end: {
            line: 248,
            column: 131
          }
        }],
        line: 248
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/tooltip-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/tooltip-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,qEAAuD;AACvD,4EAA0E;AAG1E,MAAM;AACN,4EAAoD;AAEpD,4DAAqC;AAErC;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAI,OAAuB,CAAA;IAE3B;;;OAGG;IACH,SAAS,gBAAgB,CAAC,KAAiB;QACvC,IAAM,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,CAAC,CAAA;QAEnC,IAAM,UAAU,GAAG,yBAAyB,CAAA;QAC5C,IAAM,CAAC,GAAG,UAAC,IAAY,EAAE,MAA2B;YAA3B,uBAAA,EAAA,mBAA2B;YAChD,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,MAAM,GAAG,IAAI,CAAC,CAAA;QAC1C,CAAC,CAAA;QAED,IAAM,IAAI,GAAoB;YAC1B;gBACI,sDAAsD;gBACtD,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,MAAM,CAAC,YAAS,CAAC;gBACrC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBACnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,aAAa,CAAC,CAAA;oBAC1C,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,KAAK,CAAC,YAAS,CAAC;gBACpC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,IAAI,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;oBACpC,IAAI,MAAM,EAAE;wBACR,OAAO,IAAI,CAAA;qBACd;oBACD,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,KAAK;oBACL,IAAI,WAAW,GAAG,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBACxD,IAAI,CAAC,WAAW,EAAE;wBACd,OAAO,IAAI,CAAA;qBACd;oBACD,aAAa;oBACb,IAAM,KAAK,GAAG,MAAM,CAAC,OAAO,CAAC,kBAAkB,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,WAAW,CAAC,CAAC,CAAA;oBAC7E,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,WAAW;oBACX,IAAI,MAAM,GAAW,OAAO,CAAC,YAAY,CACrC,yBAAc,CAAC,aAAa,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAC3D,CAAA;oBACD,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,KAAK,CAAC,YAAS,CAAC;gBACpC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,IAAI,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;oBACpC,IAAI,MAAM,EAAE;wBACR,OAAO,IAAI,CAAA;qBACd;oBACD,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,KAAK;oBACL,IAAI,WAAW,GAAG,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBACxD,IAAI,CAAC,WAAW,EAAE;wBACd,OAAO,IAAI,CAAA;qBACd;oBACD,aAAa;oBACb,IAAM,KAAK,GAAG,MAAM,CAAC,OAAO,CAAC,kBAAkB,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,WAAW,CAAC,CAAC,CAAA;oBAC7E,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,sCAAsC;oBACtC,IAAM,QAAQ,GAAW,yBAAc,CAAC,SAAS,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC;yBACxE,UAAU,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,CAAA;oBACpC,WAAW;oBACX,IAAI,MAAM,GAAW,EAAE,CAAA;oBACvB,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,IAAI,QAAQ,KAAK,CAAC,EAAE;wBAChB,MAAM,GAAG,aAAa,CAAA;qBACzB;yBAAM;wBACH,MAAM,GAAG,OAAO,CAAC,YAAY,CACzB,yBAAc,CAAC,SAAS,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CACvD,CAAA;qBACJ;oBACD,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,KAAK,CAAC,YAAS,CAAC;gBACpC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,IAAI,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;oBACpC,IAAI,MAAM,EAAE;wBACR,OAAO,IAAI,CAAA;qBACd;oBACD,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,WAAW;oBACX,IAAM,KAAK,GAAG,OAAO,CAAC,kBAAkB,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAC5D,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,WAAW;oBACX,IAAI,MAAM,GAAW,OAAO,CAAC,YAAY,CACrC,yBAAc,CAAC,aAAa,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAC3D,CAAA;oBACD,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,KAAK,CAAC,YAAS,CAAC;gBACpC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,IAAI,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;oBACpC,IAAI,MAAM,EAAE;wBACR,OAAO,IAAI,CAAA;qBACd;oBACD,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,WAAW;oBACX,IAAM,KAAK,GAAG,OAAO,CAAC,kBAAkB,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAC5D,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,sCAAsC;oBACtC,IAAM,QAAQ,GAAW,yBAAc,CAAC,SAAS,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC;yBACxE,UAAU,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,CAAA;oBAClD,WAAW;oBACX,IAAI,MAAM,GAAW,EAAE,CAAA;oBACvB,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,IAAI,QAAQ,KAAK,CAAC,EAAE;wBAChB,MAAM,GAAG,aAAa,CAAA;qBACzB;yBAAM;wBACH,MAAM,GAAG,OAAO,CAAC,YAAY,CACzB,yBAAc,CAAC,SAAS,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CACvD,CAAA;qBACJ;oBAED,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,MAAM,CAAC,YAAS,CAAC;gBACrC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,IAAI,MAAM,GAAG,eAAe,CAAC,MAAM,CAAC,CAAA;oBACpC,IAAI,MAAM,EAAE;wBACR,OAAO,IAAI,CAAA;qBACd;oBACD,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,KAAK;oBACL,IAAI,WAAW,GAAG,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBACxD,IAAI,CAAC,WAAW,EAAE;wBACd,OAAO,IAAI,CAAA;qBACd;oBACD,aAAa;oBACb,IAAI,KAAK,GAAG,MAAM,CAAC,OAAO,CAAC,kBAAkB,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,WAAW,CAAC,CAAC,CAAA;oBAC3E,IAAI,KAAK,KAAK,CAAC,EAAE;wBACb,cAAc;wBACd,KAAK,GAAG,CAAC,CAAA;qBACZ;oBACD,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,WAAW;oBACX,IAAI,MAAM,GAAW,OAAO,CAAC,YAAY,CACrC,yBAAc,CAAC,YAAY,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAChE,CAAA;oBACD,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;YACD;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,MAAM,CAAC,YAAS,CAAC;gBACrC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,MAAM;oBACN,IAAI,SAAS,GAAG,kBAAC,CAAC,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAC,CAAA;oBAC3D,KAAK;oBACL,IAAI,WAAW,GAAG,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBACxD,IAAI,CAAC,WAAW,EAAE;wBACd,OAAO,IAAI,CAAA;qBACd;oBACD,aAAa;oBACb,IAAI,KAAK,GAAG,MAAM,CAAC,OAAO,CAAC,kBAAkB,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE,WAAW,CAAC,CAAC,CAAA;oBAC3E,IAAI,KAAK,KAAK,CAAC,EAAE;wBACb,cAAc;wBACd,KAAK,GAAG,CAAC,CAAA;qBACZ;oBACD,YAAY;oBACZ,IAAI,OAAO,GAAG,OAAO,CAAC,YAAY,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;oBAClD,WAAW;oBACX,IAAI,MAAM,GAAW,OAAO,CAAC,YAAY,CACrC,yBAAc,CAAC,YAAY,CAAC,kBAAC,CAAC,OAAO,CAAC,EAAE,KAAK,EAAE,IAAI,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAChE,CAAA;oBACD,UAAU;oBACV,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,CAAC,CAAA;oBACzC,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBAEnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;oBAEnC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;SACJ,CAAA;QAED,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,EAAE,KAAK,EAAE,IAAI,CAAC,CAAA;QAC1C,OAAO,CAAC,MAAM,EAAE,CAAA;IACpB,CAAC;IAED;;OAEG;IACH,SAAS,gBAAgB;QACrB,aAAa;QACb,IAAI,OAAO,EAAE;YACT,OAAO,CAAC,MAAM,EAAE,CAAA;YAChB,OAAO,GAAG,IAAI,CAAA;SACjB;IACL,CAAC;IAED,OAAO;QACH,gBAAgB,kBAAA;QAChB,gBAAgB,kBAAA;KACnB,CAAA;AACL,CAAC;AAED;;GAEG;AACH,SAAS,eAAe,CAAC,MAAc;IACnC,IAAM,UAAU,GAAG,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAA;IAC3D,IAAM,QAAQ,GAAG,MAAM,CAAC,SAAS,CAAC,mBAAmB,EAAE,CAAA;IACvD,IAAI,CAAA,UAAU,aAAV,UAAU,uBAAV,UAAU,CAAE,KAAK,CAAC,CAAC,QAAM,QAAQ,aAAR,QAAQ,uBAAR,QAAQ,CAAE,KAAK,CAAC,CAAC,EAAC,EAAE;QAC7C,OAAO,IAAI,CAAA;KACd;SAAM;QACH,OAAO,KAAK,CAAA;KACf;AACL,CAAC;AAED;;;GAGG;AACH,SAAwB,gBAAgB,CAAC,MAAc;IAC7C,IAAA,KAAyC,gBAAgB,CAAC,MAAM,CAAC,EAA/D,gBAAgB,sBAAA,EAAE,gBAAgB,sBAA6B,CAAA;IAEvE,wBAAwB;IACxB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;IAE7D,0BAA0B;IAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;IACxD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;IACxD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;IAC/D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;IAC5D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,gBAAgB,CAAC,CAAA;AACjE,CAAC;AAZD,mCAYC",
      sourcesContent: ["/**\n * @description tooltip \u4E8B\u4EF6\n * @author lichunlin\n */\n\nimport $, { DomElement } from '../../../utils/dom-core'\nimport Tooltip, { TooltipConfType } from '../../menu-constructors/Tooltip'\nimport Editor from '../../../editor/index'\n\n//\u64CD\u4F5C\u4E8B\u4EF6\nimport operatingEvent from './event/operating-event'\n\nimport getNode from './event/getNode'\n\n/**\n * \u751F\u6210 Tooltip \u7684\u663E\u793A\u9690\u85CF\u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    let tooltip: Tooltip | null\n\n    /**\n     * \u663E\u793A tooltip\n     * @param  table\u5143\u7D20\n     */\n    function showTableTooltip($node: DomElement) {\n        const getnode = new getNode(editor)\n\n        const i18nPrefix = 'menus.panelMenus.table.'\n        const t = (text: string, prefix: string = i18nPrefix): string => {\n            return editor.i18next.t(prefix + text)\n        }\n\n        const conf: TooltipConfType = [\n            {\n                // $elem: $(\"<span class='w-e-icon-trash-o'></span>\"),\n                $elem: $(`<span>${t('\u5220\u9664\u8868\u683C')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u9009\u4E2Dimg\u5143\u7D20\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n                    editor.cmd.do('insertHTML', '<p><br></p>')\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u6DFB\u52A0\u884C')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u7981\u6B62\u591A\u9009\u64CD\u4F5C\n                    let isMore = isMoreRowAction(editor)\n                    if (isMore) {\n                        return true\n                    }\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u884C\n                    let $currentRow = getnode.getRowNode(selectDom.elems[0])\n                    if (!$currentRow) {\n                        return true\n                    }\n                    //\u83B7\u53D6\u5F53\u524D\u884C\u7684index\n                    const index = Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = getnode.getTableHtml(\n                        operatingEvent.ProcessingRow($(htmlStr), index).elems[0]\n                    )\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u5220\u9664\u884C')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u7981\u6B62\u591A\u9009\u64CD\u4F5C\n                    let isMore = isMoreRowAction(editor)\n                    if (isMore) {\n                        return true\n                    }\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u884C\n                    let $currentRow = getnode.getRowNode(selectDom.elems[0])\n                    if (!$currentRow) {\n                        return true\n                    }\n                    //\u83B7\u53D6\u5F53\u524D\u884C\u7684index\n                    const index = Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u83B7\u53D6\u65B0\u751F\u6210\u7684table \u5224\u65AD\u662F\u5426\u662F\u6700\u540E\u4E00\u884C\u88AB\u5220\u9664 \u662F \u5220\u9664\u6574\u4E2Atable\n                    const trLength: number = operatingEvent.DeleteRow($(htmlStr), index).elems[0]\n                        .childNodes[0].childNodes.length\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = ''\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    if (trLength === 0) {\n                        newdom = '<p><br></p>'\n                    } else {\n                        newdom = getnode.getTableHtml(\n                            operatingEvent.DeleteRow($(htmlStr), index).elems[0]\n                        )\n                    }\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u6DFB\u52A0\u5217')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u7981\u6B62\u591A\u9009\u64CD\u4F5C\n                    let isMore = isMoreRowAction(editor)\n                    if (isMore) {\n                        return true\n                    }\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u5217\u7684index\n                    const index = getnode.getCurrentColIndex(selectDom.elems[0])\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = getnode.getTableHtml(\n                        operatingEvent.ProcessingCol($(htmlStr), index).elems[0]\n                    )\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u5220\u9664\u5217')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u7981\u6B62\u591A\u9009\u64CD\u4F5C\n                    let isMore = isMoreRowAction(editor)\n                    if (isMore) {\n                        return true\n                    }\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u5217\u7684index\n                    const index = getnode.getCurrentColIndex(selectDom.elems[0])\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u83B7\u53D6\u65B0\u751F\u6210\u7684table \u5224\u65AD\u662F\u5426\u662F\u6700\u540E\u4E00\u5217\u88AB\u5220\u9664 \u662F \u5220\u9664\u6574\u4E2Atable\n                    const tdLength: number = operatingEvent.DeleteCol($(htmlStr), index).elems[0]\n                        .childNodes[0].childNodes[0].childNodes.length\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = ''\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    if (tdLength === 1) {\n                        newdom = '<p><br></p>'\n                    } else {\n                        newdom = getnode.getTableHtml(\n                            operatingEvent.DeleteCol($(htmlStr), index).elems[0]\n                        )\n                    }\n\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u8BBE\u7F6E\u8868\u5934')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    // \u7981\u6B62\u591A\u9009\u64CD\u4F5C\n                    let isMore = isMoreRowAction(editor)\n                    if (isMore) {\n                        return true\n                    }\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u884C\n                    let $currentRow = getnode.getRowNode(selectDom.elems[0])\n                    if (!$currentRow) {\n                        return true\n                    }\n                    //\u83B7\u53D6\u5F53\u524D\u884C\u7684index\n                    let index = Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))\n                    if (index !== 0) {\n                        //\u63A7\u5236\u5728table\u7684\u7B2C\u4E00\u884C\n                        index = 0\n                    }\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = getnode.getTableHtml(\n                        operatingEvent.setTheHeader($(htmlStr), index, 'th').elems[0]\n                    )\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n            {\n                $elem: $(`<span>${t('\u53D6\u6D88\u8868\u5934')}</span>`),\n                onClick: (editor: Editor, $node: DomElement) => {\n                    //\u5F53\u524D\u5143\u7D20\n                    let selectDom = $(editor.selection.getSelectionStartElem())\n                    //\u5F53\u524D\u884C\n                    let $currentRow = getnode.getRowNode(selectDom.elems[0])\n                    if (!$currentRow) {\n                        return true\n                    }\n                    //\u83B7\u53D6\u5F53\u524D\u884C\u7684index\n                    let index = Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))\n                    if (index !== 0) {\n                        //\u63A7\u5236\u5728table\u7684\u7B2C\u4E00\u884C\n                        index = 0\n                    }\n                    //\u751F\u6210\u8981\u66FF\u6362\u7684html\n                    let htmlStr = getnode.getTableHtml($node.elems[0])\n                    //\u751F\u6210\u65B0\u7684table\n                    let newdom: string = getnode.getTableHtml(\n                        operatingEvent.setTheHeader($(htmlStr), index, 'td').elems[0]\n                    )\n                    // \u9009\u4E2Dtable\n                    editor.selection.createRangeByElem($node)\n                    editor.selection.restoreSelection()\n\n                    editor.cmd.do('insertHTML', newdom)\n\n                    return true\n                },\n            },\n        ]\n\n        tooltip = new Tooltip(editor, $node, conf)\n        tooltip.create()\n    }\n\n    /**\n     * \u9690\u85CF tooltip\n     */\n    function hideTableTooltip() {\n        // \u79FB\u9664 tooltip\n        if (tooltip) {\n            tooltip.remove()\n            tooltip = null\n        }\n    }\n\n    return {\n        showTableTooltip,\n        hideTableTooltip,\n    }\n}\n\n/**\n * \u5224\u65AD\u662F\u5426\u662F\u591A\u884C\n */\nfunction isMoreRowAction(editor: Editor): boolean {\n    const $startElem = editor.selection.getSelectionStartElem()\n    const $endElem = editor.selection.getSelectionEndElem()\n    if ($startElem?.elems[0] !== $endElem?.elems[0]) {\n        return true\n    } else {\n        return false\n    }\n}\n\n/**\n * \u7ED1\u5B9A tooltip \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport default function bindTooltipEvent(editor: Editor) {\n    const { showTableTooltip, hideTableTooltip } = createShowHideFn(editor)\n\n    // \u70B9\u51FBtable\u5143\u7D20\u662F\uFF0C\u663E\u793A tooltip\n    editor.txt.eventHooks.tableClickEvents.push(showTableTooltip)\n\n    // \u70B9\u51FB\u5176\u4ED6\u5730\u65B9\uFF0C\u6216\u8005\u6EDA\u52A8\u65F6\uFF0C\u9690\u85CF tooltip\n    editor.txt.eventHooks.clickEvents.push(hideTableTooltip)\n    editor.txt.eventHooks.keyupEvents.push(hideTableTooltip)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideTableTooltip)\n    editor.txt.eventHooks.menuClickEvents.push(hideTableTooltip)\n    editor.txt.eventHooks.textScrollEvents.push(hideTableTooltip)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1c129d668091186512a5272c1ca8ca98c0ddd9a2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hvvz6tyk6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1hvvz6tyk6();

var __importDefault = (cov_1hvvz6tyk6().s[0]++, (cov_1hvvz6tyk6().b[0][0]++, void 0) && (cov_1hvvz6tyk6().b[0][1]++, (void 0).__importDefault) || (cov_1hvvz6tyk6().b[0][2]++, function (mod) {
  cov_1hvvz6tyk6().f[0]++;
  cov_1hvvz6tyk6().s[1]++;
  return (cov_1hvvz6tyk6().b[2][0]++, mod) && (cov_1hvvz6tyk6().b[2][1]++, mod.__esModule) ? (cov_1hvvz6tyk6().b[1][0]++, mod) : (cov_1hvvz6tyk6().b[1][1]++, {
    "default": mod
  });
}));

cov_1hvvz6tyk6().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1hvvz6tyk6().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip_1 = (cov_1hvvz6tyk6().s[4]++, __importDefault(__webpack_require__(43))); //操作事件

var operating_event_1 = (cov_1hvvz6tyk6().s[5]++, __importDefault(__webpack_require__(367)));
var getNode_1 = (cov_1hvvz6tyk6().s[6]++, __importDefault(__webpack_require__(368)));
/**
 * 生成 Tooltip 的显示隐藏函数
 */

function createShowHideFn(editor) {
  cov_1hvvz6tyk6().f[1]++;
  var tooltip;
  /**
   * 显示 tooltip
   * @param  table元素
   */

  function showTableTooltip($node) {
    cov_1hvvz6tyk6().f[2]++;
    var getnode = (cov_1hvvz6tyk6().s[7]++, new getNode_1["default"](editor));
    var i18nPrefix = (cov_1hvvz6tyk6().s[8]++, 'menus.panelMenus.table.');
    cov_1hvvz6tyk6().s[9]++;

    var t = function t(text, prefix) {
      cov_1hvvz6tyk6().f[3]++;
      cov_1hvvz6tyk6().s[10]++;

      if (prefix === void 0) {
        cov_1hvvz6tyk6().b[3][0]++;
        cov_1hvvz6tyk6().s[11]++;
        prefix = i18nPrefix;
      } else {
        cov_1hvvz6tyk6().b[3][1]++;
      }

      cov_1hvvz6tyk6().s[12]++;
      return editor.i18next.t(prefix + text);
    };

    var conf = (cov_1hvvz6tyk6().s[13]++, [{
      // $elem: $("<span class='w-e-icon-trash-o'></span>"),
      $elem: dom_core_1["default"]("<span>" + t('删除表格') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[4]++;
        cov_1hvvz6tyk6().s[14]++;
        // 选中img元素
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[15]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[16]++;
        editor.cmd["do"]('insertHTML', '<p><br></p>'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_1hvvz6tyk6().s[17]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('添加行') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[5]++;
        // 禁止多选操作
        var isMore = (cov_1hvvz6tyk6().s[18]++, isMoreRowAction(editor));
        cov_1hvvz6tyk6().s[19]++;

        if (isMore) {
          cov_1hvvz6tyk6().b[4][0]++;
          cov_1hvvz6tyk6().s[20]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[4][1]++;
        } //当前元素


        var selectDom = (cov_1hvvz6tyk6().s[21]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前行

        var $currentRow = (cov_1hvvz6tyk6().s[22]++, getnode.getRowNode(selectDom.elems[0]));
        cov_1hvvz6tyk6().s[23]++;

        if (!$currentRow) {
          cov_1hvvz6tyk6().b[5][0]++;
          cov_1hvvz6tyk6().s[24]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[5][1]++;
        } //获取当前行的index


        var index = (cov_1hvvz6tyk6().s[25]++, Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))); //生成要替换的html

        var htmlStr = (cov_1hvvz6tyk6().s[26]++, getnode.getTableHtml($node.elems[0])); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[27]++, getnode.getTableHtml(operating_event_1["default"].ProcessingRow(dom_core_1["default"](htmlStr), index).elems[0])); // 选中table

        cov_1hvvz6tyk6().s[28]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[29]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[30]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[31]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('删除行') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[6]++;
        // 禁止多选操作
        var isMore = (cov_1hvvz6tyk6().s[32]++, isMoreRowAction(editor));
        cov_1hvvz6tyk6().s[33]++;

        if (isMore) {
          cov_1hvvz6tyk6().b[6][0]++;
          cov_1hvvz6tyk6().s[34]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[6][1]++;
        } //当前元素


        var selectDom = (cov_1hvvz6tyk6().s[35]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前行

        var $currentRow = (cov_1hvvz6tyk6().s[36]++, getnode.getRowNode(selectDom.elems[0]));
        cov_1hvvz6tyk6().s[37]++;

        if (!$currentRow) {
          cov_1hvvz6tyk6().b[7][0]++;
          cov_1hvvz6tyk6().s[38]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[7][1]++;
        } //获取当前行的index


        var index = (cov_1hvvz6tyk6().s[39]++, Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow))); //生成要替换的html

        var htmlStr = (cov_1hvvz6tyk6().s[40]++, getnode.getTableHtml($node.elems[0])); //获取新生成的table 判断是否是最后一行被删除 是 删除整个table

        var trLength = (cov_1hvvz6tyk6().s[41]++, operating_event_1["default"].DeleteRow(dom_core_1["default"](htmlStr), index).elems[0].childNodes[0].childNodes.length); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[42]++, ''); // 选中table

        cov_1hvvz6tyk6().s[43]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[44]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[45]++;

        if (trLength === 0) {
          cov_1hvvz6tyk6().b[8][0]++;
          cov_1hvvz6tyk6().s[46]++;
          newdom = '<p><br></p>';
        } else {
          cov_1hvvz6tyk6().b[8][1]++;
          cov_1hvvz6tyk6().s[47]++;
          newdom = getnode.getTableHtml(operating_event_1["default"].DeleteRow(dom_core_1["default"](htmlStr), index).elems[0]);
        }

        cov_1hvvz6tyk6().s[48]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[49]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('添加列') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[7]++;
        // 禁止多选操作
        var isMore = (cov_1hvvz6tyk6().s[50]++, isMoreRowAction(editor));
        cov_1hvvz6tyk6().s[51]++;

        if (isMore) {
          cov_1hvvz6tyk6().b[9][0]++;
          cov_1hvvz6tyk6().s[52]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[9][1]++;
        } //当前元素


        var selectDom = (cov_1hvvz6tyk6().s[53]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前列的index

        var index = (cov_1hvvz6tyk6().s[54]++, getnode.getCurrentColIndex(selectDom.elems[0])); //生成要替换的html

        var htmlStr = (cov_1hvvz6tyk6().s[55]++, getnode.getTableHtml($node.elems[0])); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[56]++, getnode.getTableHtml(operating_event_1["default"].ProcessingCol(dom_core_1["default"](htmlStr), index).elems[0])); // 选中table

        cov_1hvvz6tyk6().s[57]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[58]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[59]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[60]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('删除列') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[8]++;
        // 禁止多选操作
        var isMore = (cov_1hvvz6tyk6().s[61]++, isMoreRowAction(editor));
        cov_1hvvz6tyk6().s[62]++;

        if (isMore) {
          cov_1hvvz6tyk6().b[10][0]++;
          cov_1hvvz6tyk6().s[63]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[10][1]++;
        } //当前元素


        var selectDom = (cov_1hvvz6tyk6().s[64]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前列的index

        var index = (cov_1hvvz6tyk6().s[65]++, getnode.getCurrentColIndex(selectDom.elems[0])); //生成要替换的html

        var htmlStr = (cov_1hvvz6tyk6().s[66]++, getnode.getTableHtml($node.elems[0])); //获取新生成的table 判断是否是最后一列被删除 是 删除整个table

        var tdLength = (cov_1hvvz6tyk6().s[67]++, operating_event_1["default"].DeleteCol(dom_core_1["default"](htmlStr), index).elems[0].childNodes[0].childNodes[0].childNodes.length); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[68]++, ''); // 选中table

        cov_1hvvz6tyk6().s[69]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[70]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[71]++;

        if (tdLength === 1) {
          cov_1hvvz6tyk6().b[11][0]++;
          cov_1hvvz6tyk6().s[72]++;
          newdom = '<p><br></p>';
        } else {
          cov_1hvvz6tyk6().b[11][1]++;
          cov_1hvvz6tyk6().s[73]++;
          newdom = getnode.getTableHtml(operating_event_1["default"].DeleteCol(dom_core_1["default"](htmlStr), index).elems[0]);
        }

        cov_1hvvz6tyk6().s[74]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[75]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('设置表头') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[9]++;
        // 禁止多选操作
        var isMore = (cov_1hvvz6tyk6().s[76]++, isMoreRowAction(editor));
        cov_1hvvz6tyk6().s[77]++;

        if (isMore) {
          cov_1hvvz6tyk6().b[12][0]++;
          cov_1hvvz6tyk6().s[78]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[12][1]++;
        } //当前元素


        var selectDom = (cov_1hvvz6tyk6().s[79]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前行

        var $currentRow = (cov_1hvvz6tyk6().s[80]++, getnode.getRowNode(selectDom.elems[0]));
        cov_1hvvz6tyk6().s[81]++;

        if (!$currentRow) {
          cov_1hvvz6tyk6().b[13][0]++;
          cov_1hvvz6tyk6().s[82]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[13][1]++;
        } //获取当前行的index


        var index = (cov_1hvvz6tyk6().s[83]++, Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow)));
        cov_1hvvz6tyk6().s[84]++;

        if (index !== 0) {
          cov_1hvvz6tyk6().b[14][0]++;
          cov_1hvvz6tyk6().s[85]++;
          //控制在table的第一行
          index = 0;
        } else {
          cov_1hvvz6tyk6().b[14][1]++;
        } //生成要替换的html


        var htmlStr = (cov_1hvvz6tyk6().s[86]++, getnode.getTableHtml($node.elems[0])); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[87]++, getnode.getTableHtml(operating_event_1["default"].setTheHeader(dom_core_1["default"](htmlStr), index, 'th').elems[0])); // 选中table

        cov_1hvvz6tyk6().s[88]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[89]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[90]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[91]++;
        return true;
      }
    }, {
      $elem: dom_core_1["default"]("<span>" + t('取消表头') + "</span>"),
      onClick: function onClick(editor, $node) {
        cov_1hvvz6tyk6().f[10]++;
        //当前元素
        var selectDom = (cov_1hvvz6tyk6().s[92]++, dom_core_1["default"](editor.selection.getSelectionStartElem())); //当前行

        var $currentRow = (cov_1hvvz6tyk6().s[93]++, getnode.getRowNode(selectDom.elems[0]));
        cov_1hvvz6tyk6().s[94]++;

        if (!$currentRow) {
          cov_1hvvz6tyk6().b[15][0]++;
          cov_1hvvz6tyk6().s[95]++;
          return true;
        } else {
          cov_1hvvz6tyk6().b[15][1]++;
        } //获取当前行的index


        var index = (cov_1hvvz6tyk6().s[96]++, Number(getnode.getCurrentRowIndex($node.elems[0], $currentRow)));
        cov_1hvvz6tyk6().s[97]++;

        if (index !== 0) {
          cov_1hvvz6tyk6().b[16][0]++;
          cov_1hvvz6tyk6().s[98]++;
          //控制在table的第一行
          index = 0;
        } else {
          cov_1hvvz6tyk6().b[16][1]++;
        } //生成要替换的html


        var htmlStr = (cov_1hvvz6tyk6().s[99]++, getnode.getTableHtml($node.elems[0])); //生成新的table

        var newdom = (cov_1hvvz6tyk6().s[100]++, getnode.getTableHtml(operating_event_1["default"].setTheHeader(dom_core_1["default"](htmlStr), index, 'td').elems[0])); // 选中table

        cov_1hvvz6tyk6().s[101]++;
        editor.selection.createRangeByElem($node);
        cov_1hvvz6tyk6().s[102]++;
        editor.selection.restoreSelection();
        cov_1hvvz6tyk6().s[103]++;
        editor.cmd["do"]('insertHTML', newdom);
        cov_1hvvz6tyk6().s[104]++;
        return true;
      }
    }]);
    cov_1hvvz6tyk6().s[105]++;
    tooltip = new Tooltip_1["default"](editor, $node, conf);
    cov_1hvvz6tyk6().s[106]++;
    tooltip.create();
  }
  /**
   * 隐藏 tooltip
   */


  function hideTableTooltip() {
    cov_1hvvz6tyk6().f[11]++;
    cov_1hvvz6tyk6().s[107]++;

    // 移除 tooltip
    if (tooltip) {
      cov_1hvvz6tyk6().b[17][0]++;
      cov_1hvvz6tyk6().s[108]++;
      tooltip.remove();
      cov_1hvvz6tyk6().s[109]++;
      tooltip = null;
    } else {
      cov_1hvvz6tyk6().b[17][1]++;
    }
  }

  cov_1hvvz6tyk6().s[110]++;
  return {
    showTableTooltip: showTableTooltip,
    hideTableTooltip: hideTableTooltip
  };
}
/**
 * 判断是否是多行
 */


function isMoreRowAction(editor) {
  cov_1hvvz6tyk6().f[12]++;
  var $startElem = (cov_1hvvz6tyk6().s[111]++, editor.selection.getSelectionStartElem());
  var $endElem = (cov_1hvvz6tyk6().s[112]++, editor.selection.getSelectionEndElem());
  cov_1hvvz6tyk6().s[113]++;

  if (((cov_1hvvz6tyk6().b[20][0]++, $startElem === null) || (cov_1hvvz6tyk6().b[20][1]++, $startElem === void 0) ? (cov_1hvvz6tyk6().b[19][0]++, void 0) : (cov_1hvvz6tyk6().b[19][1]++, $startElem.elems[0])) !== ((cov_1hvvz6tyk6().b[22][0]++, $endElem === null) || (cov_1hvvz6tyk6().b[22][1]++, $endElem === void 0) ? (cov_1hvvz6tyk6().b[21][0]++, void 0) : (cov_1hvvz6tyk6().b[21][1]++, $endElem.elems[0]))) {
    cov_1hvvz6tyk6().b[18][0]++;
    cov_1hvvz6tyk6().s[114]++;
    return true;
  } else {
    cov_1hvvz6tyk6().b[18][1]++;
    cov_1hvvz6tyk6().s[115]++;
    return false;
  }
}
/**
 * 绑定 tooltip 事件
 * @param editor 编辑器实例
 */


function bindTooltipEvent(editor) {
  cov_1hvvz6tyk6().f[13]++;

  var _a = (cov_1hvvz6tyk6().s[116]++, createShowHideFn(editor)),
      showTableTooltip = (cov_1hvvz6tyk6().s[117]++, _a.showTableTooltip),
      hideTableTooltip = (cov_1hvvz6tyk6().s[118]++, _a.hideTableTooltip); // 点击table元素是，显示 tooltip


  cov_1hvvz6tyk6().s[119]++;
  editor.txt.eventHooks.tableClickEvents.push(showTableTooltip); // 点击其他地方，或者滚动时，隐藏 tooltip

  cov_1hvvz6tyk6().s[120]++;
  editor.txt.eventHooks.clickEvents.push(hideTableTooltip);
  cov_1hvvz6tyk6().s[121]++;
  editor.txt.eventHooks.keyupEvents.push(hideTableTooltip);
  cov_1hvvz6tyk6().s[122]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideTableTooltip);
  cov_1hvvz6tyk6().s[123]++;
  editor.txt.eventHooks.menuClickEvents.push(hideTableTooltip);
  cov_1hvvz6tyk6().s[124]++;
  editor.txt.eventHooks.textScrollEvents.push(hideTableTooltip);
}

cov_1hvvz6tyk6().s[125]++;
exports["default"] = bindTooltipEvent;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _splice = _interopRequireDefault(__webpack_require__(88));

var _slice = _interopRequireDefault(__webpack_require__(54));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_iuyk7ixoa() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/operating-event.ts";
  var hash = "1289d01c3bda5a39985c3eafef0948011b9f4be1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/operating-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 71
        }
      },
      "4": {
        start: {
          line: 14,
          column: 15
        },
        end: {
          line: 14,
          column: 39
        }
      },
      "5": {
        start: {
          line: 16,
          column: 19
        },
        end: {
          line: 16,
          column: 63
        }
      },
      "6": {
        start: {
          line: 18,
          column: 27
        },
        end: {
          line: 18,
          column: 56
        }
      },
      "7": {
        start: {
          line: 20,
          column: 13
        },
        end: {
          line: 20,
          column: 41
        }
      },
      "8": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      "9": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 18
        }
      },
      "10": {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 45
        }
      },
      "11": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 27
        }
      },
      "12": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 39
        }
      },
      "13": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 42
        }
      },
      "14": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 47
        }
      },
      "15": {
        start: {
          line: 38,
          column: 15
        },
        end: {
          line: 38,
          column: 39
        }
      },
      "16": {
        start: {
          line: 40,
          column: 19
        },
        end: {
          line: 40,
          column: 63
        }
      },
      "17": {
        start: {
          line: 41,
          column: 18
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "18": {
        start: {
          line: 42,
          column: 21
        },
        end: {
          line: 42,
          column: 23
        }
      },
      "19": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 46,
          column: 11
        }
      },
      "20": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 30
        }
      },
      "21": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "22": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 63
        }
      },
      "23": {
        start: {
          line: 52,
          column: 17
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "24": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 41
        }
      },
      "25": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 60,
          column: 9
        }
      },
      "26": {
        start: {
          line: 58,
          column: 21
        },
        end: {
          line: 58,
          column: 22
        }
      },
      "27": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 47
        }
      },
      "28": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "29": {
        start: {
          line: 63,
          column: 17
        },
        end: {
          line: 63,
          column: 18
        }
      },
      "30": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 19
        }
      },
      "31": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 42
        }
      },
      "32": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 47
        }
      },
      "33": {
        start: {
          line: 77,
          column: 15
        },
        end: {
          line: 77,
          column: 39
        }
      },
      "34": {
        start: {
          line: 79,
          column: 19
        },
        end: {
          line: 79,
          column: 63
        }
      },
      "35": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 31
        }
      },
      "36": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 42
        }
      },
      "37": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 47
        }
      },
      "38": {
        start: {
          line: 93,
          column: 15
        },
        end: {
          line: 93,
          column: 39
        }
      },
      "39": {
        start: {
          line: 95,
          column: 19
        },
        end: {
          line: 95,
          column: 63
        }
      },
      "40": {
        start: {
          line: 96,
          column: 18
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "41": {
        start: {
          line: 97,
          column: 21
        },
        end: {
          line: 97,
          column: 23
        }
      },
      "42": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 101,
          column: 11
        }
      },
      "43": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 30
        }
      },
      "44": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 105,
          column: 9
        }
      },
      "45": {
        start: {
          line: 104,
          column: 12
        },
        end: {
          line: 104,
          column: 63
        }
      },
      "46": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 33
        }
      },
      "47": {
        start: {
          line: 108,
          column: 8
        },
        end: {
          line: 110,
          column: 9
        }
      },
      "48": {
        start: {
          line: 108,
          column: 21
        },
        end: {
          line: 108,
          column: 22
        }
      },
      "49": {
        start: {
          line: 109,
          column: 12
        },
        end: {
          line: 109,
          column: 47
        }
      },
      "50": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "51": {
        start: {
          line: 113,
          column: 17
        },
        end: {
          line: 113,
          column: 18
        }
      },
      "52": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 19
        }
      },
      "53": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 42
        }
      },
      "54": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 47
        }
      },
      "55": {
        start: {
          line: 128,
          column: 15
        },
        end: {
          line: 128,
          column: 39
        }
      },
      "56": {
        start: {
          line: 130,
          column: 19
        },
        end: {
          line: 130,
          column: 63
        }
      },
      "57": {
        start: {
          line: 132,
          column: 27
        },
        end: {
          line: 132,
          column: 54
        }
      },
      "58": {
        start: {
          line: 134,
          column: 13
        },
        end: {
          line: 134,
          column: 41
        }
      },
      "59": {
        start: {
          line: 135,
          column: 18
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "60": {
        start: {
          line: 137,
          column: 17
        },
        end: {
          line: 137,
          column: 45
        }
      },
      "61": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 140,
          column: 11
        }
      },
      "62": {
        start: {
          line: 139,
          column: 12
        },
        end: {
          line: 139,
          column: 33
        }
      },
      "63": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 27
        }
      },
      "64": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "65": {
        start: {
          line: 143,
          column: 17
        },
        end: {
          line: 143,
          column: 18
        }
      },
      "66": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 144,
          column: 19
        }
      },
      "67": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 147,
          column: 35
        }
      },
      "68": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 42
        }
      },
      "69": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 47
        }
      },
      "70": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "71": {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 160,
          column: 45
        }
      },
      "72": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 165,
          column: 5
        }
      },
      "73": {
        start: {
          line: 163,
          column: 17
        },
        end: {
          line: 163,
          column: 18
        }
      },
      "74": {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 164,
          column: 38
        }
      },
      "75": {
        start: {
          line: 173,
          column: 15
        },
        end: {
          line: 173,
          column: 43
        }
      },
      "76": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "77": {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 79
        }
      },
      "78": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 16
        }
      },
      "79": {
        start: {
          line: 179,
          column: 0
        },
        end: {
          line: 185,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "ProcessingRow",
        decl: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 22
          }
        },
        loc: {
          start: {
            line: 12,
            column: 38
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "ProcessingCol",
        decl: {
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 22
          }
        },
        loc: {
          start: {
            line: 36,
            column: 38
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 36
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 18
          },
          end: {
            line: 41,
            column: 19
          }
        },
        loc: {
          start: {
            line: 41,
            column: 31
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 44,
            column: 39
          },
          end: {
            line: 44,
            column: 40
          }
        },
        loc: {
          start: {
            line: 44,
            column: 55
          },
          end: {
            line: 46,
            column: 9
          }
        },
        line: 44
      },
      "5": {
        name: "DeleteRow",
        decl: {
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 18
          }
        },
        loc: {
          start: {
            line: 75,
            column: 34
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 75
      },
      "6": {
        name: "DeleteCol",
        decl: {
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 18
          }
        },
        loc: {
          start: {
            line: 91,
            column: 34
          },
          end: {
            line: 119,
            column: 1
          }
        },
        line: 91
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 96,
            column: 18
          },
          end: {
            line: 96,
            column: 19
          }
        },
        loc: {
          start: {
            line: 96,
            column: 31
          },
          end: {
            line: 111,
            column: 5
          }
        },
        line: 96
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 99,
            column: 39
          },
          end: {
            line: 99,
            column: 40
          }
        },
        loc: {
          start: {
            line: 99,
            column: 55
          },
          end: {
            line: 101,
            column: 9
          }
        },
        line: 99
      },
      "9": {
        name: "setTheHeader",
        decl: {
          start: {
            line: 126,
            column: 9
          },
          end: {
            line: 126,
            column: 21
          }
        },
        loc: {
          start: {
            line: 126,
            column: 43
          },
          end: {
            line: 151,
            column: 1
          }
        },
        line: 126
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 135,
            column: 18
          },
          end: {
            line: 135,
            column: 19
          }
        },
        loc: {
          start: {
            line: 135,
            column: 31
          },
          end: {
            line: 142,
            column: 5
          }
        },
        line: 135
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 138,
            column: 47
          },
          end: {
            line: 138,
            column: 48
          }
        },
        loc: {
          start: {
            line: 138,
            column: 63
          },
          end: {
            line: 140,
            column: 9
          }
        },
        line: 138
      },
      "12": {
        name: "removeAndInsertAction",
        decl: {
          start: {
            line: 157,
            column: 9
          },
          end: {
            line: 157,
            column: 30
          }
        },
        loc: {
          start: {
            line: 157,
            column: 47
          },
          end: {
            line: 166,
            column: 1
          }
        },
        line: 157
      },
      "13": {
        name: "generateDomAction",
        decl: {
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 172,
            column: 26
          }
        },
        loc: {
          start: {
            line: 172,
            column: 34
          },
          end: {
            line: 178,
            column: 1
          }
        },
        line: 172
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 52,
            column: 17
          },
          end: {
            line: 54,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 53,
            column: 14
          },
          end: {
            line: 53,
            column: 42
          }
        }, {
          start: {
            line: 54,
            column: 14
          },
          end: {
            line: 54,
            column: 42
          }
        }],
        line: 52
      },
      "4": {
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }],
        line: 174
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/operating-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/operating-event.ts"],
      names: [],
      mappings: ";;;;;AAAA,wEAA0D;AAE1D;;;;GAIG;AACH,SAAS,aAAa,CAAC,KAAiB,EAAE,MAAc;IACpD,aAAa;IACb,IAAI,IAAI,GAAG,iBAAiB,CAAC,KAAK,CAAC,CAAA;IACnC,QAAQ;IACR,IAAI,QAAQ,GAAW,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;IACnE,MAAM;IACN,IAAM,gBAAgB,GAAG,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,CAAA;IACtD,OAAO;IACP,IAAI,EAAE,GAAG,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;IACrC,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,gBAAgB,EAAE,CAAC,EAAE,EAAE;QACvC,IAAM,EAAE,GAAG,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;QACvC,EAAE,CAAC,WAAW,CAAC,EAAE,CAAC,CAAA;KACrB;IACD,OAAO;IACP,QAAQ,CAAC,MAAM,CAAC,MAAM,GAAG,CAAC,EAAE,CAAC,EAAE,EAAE,CAAC,CAAA;IAClC,WAAW;IACX,qBAAqB,CAAC,IAAI,EAAE,QAAQ,CAAC,CAAA;IACrC,OAAO,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC7B,CAAC;AAED;;;;GAIG;AACH,SAAS,aAAa,CAAC,KAAiB,EAAE,MAAc;IACpD,aAAa;IACb,IAAI,IAAI,GAAG,iBAAiB,CAAC,KAAK,CAAC,CAAA;IACnC,QAAQ;IACR,IAAI,QAAQ,GAAW,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;4BAE1D,CAAC;QACN,IAAI,MAAM,GAAW,EAAE,CAAA;QACvB,QAAQ;QACR,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;YAC/B,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QACrB,CAAC,CAAC,CAAA;QACF,WAAW;QACX,OAAO,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,KAAK,CAAC,EAAE;YACxC,QAAQ,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAA;SACrD;QACD,SAAS;QACT,IAAI,EAAE,GACF,kBAAC,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,IAAI;YAC/B,CAAC,CAAC,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC;YAC9B,CAAC,CAAC,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;QACtC,wCAAwC;QACxC,MAAM,CAAC,MAAM,CAAC,MAAM,GAAG,CAAC,EAAE,CAAC,EAAE,EAAE,CAAC,CAAA;QAChC,SAAS;QACT,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,MAAM,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;YACpC,QAAQ,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAA;SACrC;;IArBL,MAAM;IACN,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,CAAC,MAAM,EAAE,CAAC,EAAE;gBAA/B,CAAC;KAqBT;IACD,WAAW;IACX,qBAAqB,CAAC,IAAI,EAAE,QAAQ,CAAC,CAAA;IACrC,OAAO,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC7B,CAAC;AAED;;;;GAIG;AACH,SAAS,SAAS,CAAC,KAAiB,EAAE,MAAc;IAChD,aAAa;IACb,IAAI,IAAI,GAAG,iBAAiB,CAAC,KAAK,CAAC,CAAA;IACnC,QAAQ;IACR,IAAI,QAAQ,GAAW,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;IACnE,KAAK;IACL,QAAQ,CAAC,MAAM,CAAC,MAAM,EAAE,CAAC,CAAC,CAAA;IAC1B,WAAW;IACX,qBAAqB,CAAC,IAAI,EAAE,QAAQ,CAAC,CAAA;IACrC,OAAO,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC7B,CAAC;AAED;;;;GAIG;AACH,SAAS,SAAS,CAAC,KAAiB,EAAE,MAAc;IAChD,aAAa;IACb,IAAI,IAAI,GAAG,iBAAiB,CAAC,KAAK,CAAC,CAAA;IACnC,QAAQ;IACR,IAAI,QAAQ,GAAW,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;4BAE1D,CAAC;QACN,IAAI,MAAM,GAAW,EAAE,CAAA;QACvB,QAAQ;QACR,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;YAC/B,MAAM,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QACrB,CAAC,CAAC,CAAA;QACF,WAAW;QACX,OAAO,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,KAAK,CAAC,EAAE;YACxC,QAAQ,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAA;SACrD;QACD,MAAM,CAAC,MAAM,CAAC,MAAM,EAAE,CAAC,CAAC,CAAA;QACxB,SAAS;QACT,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,MAAM,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;YACpC,QAAQ,CAAC,CAAC,CAAC,CAAC,WAAW,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAA;SACrC;;IAfL,MAAM;IACN,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,CAAC,MAAM,EAAE,CAAC,EAAE;gBAA/B,CAAC;KAeT;IACD,WAAW;IACX,qBAAqB,CAAC,IAAI,EAAE,QAAQ,CAAC,CAAA;IACrC,OAAO,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC7B,CAAC;AAED;;;;;GAKG;AACH,SAAS,YAAY,CAAC,KAAiB,EAAE,MAAc,EAAE,IAAY;IACjE,aAAa;IACb,IAAI,IAAI,GAAG,iBAAiB,CAAC,KAAK,CAAC,CAAA;IACnC,QAAQ;IACR,IAAI,QAAQ,GAAW,KAAK,CAAC,SAAS,CAAC,KAAK,CAAC,KAAK,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;IACnE,MAAM;IACN,IAAM,gBAAgB,GAAG,QAAQ,CAAC,MAAM,CAAC,CAAC,UAAU,CAAA;IACpD,OAAO;IACP,IAAI,EAAE,GAAG,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;4BAC5B,CAAC;QACN,SAAS;QACT,IAAM,EAAE,GAAG,QAAQ,CAAC,aAAa,CAAC,IAAI,CAAC,CAAA;QACvC,gBAAgB,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,OAAO,CAAC,UAAA,IAAI;YACvC,EAAE,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;QACxB,CAAC,CAAC,CAAA;QACF,EAAE,CAAC,WAAW,CAAC,EAAE,CAAC,CAAA;;IANtB,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,gBAAgB,CAAC,MAAM,EAAE,CAAC,EAAE;gBAAvC,CAAC;KAOT;IACD,OAAO;IACP,QAAQ,CAAC,MAAM,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE,CAAC,CAAA;IAC9B,WAAW;IACX,qBAAqB,CAAC,IAAI,EAAE,QAAQ,CAAC,CAAA;IACrC,OAAO,kBAAC,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;AAC7B,CAAC;AAED;;;;GAIG;AACH,SAAS,qBAAqB,CAAC,IAAe,EAAE,QAAgB;IAC5D,YAAY;IACZ,OAAO,IAAI,CAAC,UAAU,CAAC,MAAM,KAAK,CAAC,EAAE;QACjC,IAAI,CAAC,WAAW,CAAC,IAAI,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAA;KACvC;IACD,SAAS;IACT,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,QAAQ,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;QACtC,IAAI,CAAC,WAAW,CAAC,QAAQ,CAAC,CAAC,CAAC,CAAC,CAAA;KAChC;AACL,CAAC;AAED;;;;GAIG;AACH,SAAS,iBAAiB,CAAC,KAAiB;IACxC,IAAI,IAAI,GAAc,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,CAAA;IAClD,IAAI,IAAI,CAAC,QAAQ,KAAK,UAAU,EAAE;QAC9B,IAAI,GAAG,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,KAAK,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,MAAM,GAAG,CAAC,CAAC,CAAA;KACzE;IACD,OAAO,IAAI,CAAA;AACf,CAAC;AAED,kBAAe;IACX,aAAa,eAAA;IACb,aAAa,eAAA;IACb,SAAS,WAAA;IACT,SAAS,WAAA;IACT,YAAY,cAAA;CACf,CAAA",
      sourcesContent: ["import $, { DomElement } from '../../../../utils/dom-core'\n\n/**\n * \u5904\u7406\u65B0\u6DFB\u52A0\u884C\n * @param $node \u6574\u4E2Atable\n * @param _index \u884C\u7684inde\n */\nfunction ProcessingRow($node: DomElement, _index: number): DomElement {\n    //\u6267\u884C\u83B7\u53D6tbody\u8282\u70B9\n    let $dom = generateDomAction($node)\n    //\u53D6\u51FA\u6240\u6709\u7684\u884C\n    let domArray: Node[] = Array.prototype.slice.apply($dom.childNodes)\n    //\u5217\u7684\u6570\u91CF\n    const childNodesLenght = domArray[0].childNodes.length\n    //\u521B\u5EFA\u65B0tr\n    let tr = document.createElement('tr')\n    for (let i = 0; i < childNodesLenght; i++) {\n        const td = document.createElement('td')\n        tr.appendChild(td)\n    }\n    //\u63D2\u5165\u96C6\u5408\u4E2D\n    domArray.splice(_index + 1, 0, tr)\n    //\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n    removeAndInsertAction($dom, domArray)\n    return $($dom.parentNode)\n}\n\n/**\n * \u5904\u7406\u65B0\u6DFB\u52A0\u5217\n * @param $node \u6574\u4E2Atable\n * @param _index \u5217\u7684inde\n */\nfunction ProcessingCol($node: DomElement, _index: number): DomElement {\n    //\u6267\u884C\u83B7\u53D6tbody\u8282\u70B9\n    let $dom = generateDomAction($node)\n    //\u53D6\u51FA\u6240\u6709\u7684\u884C\n    let domArray: Node[] = Array.prototype.slice.apply($dom.childNodes)\n    //\u521B\u5EFAtd\n    for (let i = 0; i < domArray.length; i++) {\n        let cArray: Node[] = []\n        //\u53D6\u51FA\u6240\u6709\u7684\u5217\n        domArray[i].childNodes.forEach(item => {\n            cArray.push(item)\n        })\n        //\u79FB\u9664\u884C\u7684\u65E7\u7684\u5B50\u8282\u70B9\n        while (domArray[i].childNodes.length !== 0) {\n            domArray[i].removeChild(domArray[i].childNodes[0])\n        }\n        //\u5217\u5206th td\n        let td =\n            $(cArray[0]).getNodeName() !== 'TH'\n                ? document.createElement('td')\n                : document.createElement('th')\n        // let td = document.createElement('td')\n        cArray.splice(_index + 1, 0, td)\n        //\u63D2\u5165\u65B0\u7684\u5B50\u8282\u70B9\n        for (let j = 0; j < cArray.length; j++) {\n            domArray[i].appendChild(cArray[j])\n        }\n    }\n    //\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n    removeAndInsertAction($dom, domArray)\n    return $($dom.parentNode)\n}\n\n/**\n * \u5904\u7406\u5220\u9664\u884C\n * @param $node  \u6574\u4E2Atable\n * @param _index  \u884C\u7684inde\n */\nfunction DeleteRow($node: DomElement, _index: number): DomElement {\n    //\u6267\u884C\u83B7\u53D6tbody\u8282\u70B9\n    let $dom = generateDomAction($node)\n    //\u53D6\u51FA\u6240\u6709\u7684\u884C\n    let domArray: Node[] = Array.prototype.slice.apply($dom.childNodes)\n    //\u5220\u9664\u884C\n    domArray.splice(_index, 1)\n    //\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n    removeAndInsertAction($dom, domArray)\n    return $($dom.parentNode)\n}\n\n/**\n * \u5904\u7406\u5220\u9664\u5217\n * @param $node\n * @param _index\n */\nfunction DeleteCol($node: DomElement, _index: number): DomElement {\n    //\u6267\u884C\u83B7\u53D6tbody\u8282\u70B9\n    let $dom = generateDomAction($node)\n    //\u53D6\u51FA\u6240\u6709\u7684\u884C\n    let domArray: Node[] = Array.prototype.slice.apply($dom.childNodes)\n    //\u521B\u5EFAtd\n    for (let i = 0; i < domArray.length; i++) {\n        let cArray: Node[] = []\n        //\u53D6\u51FA\u6240\u6709\u7684\u5217\n        domArray[i].childNodes.forEach(item => {\n            cArray.push(item)\n        })\n        //\u79FB\u9664\u884C\u7684\u65E7\u7684\u5B50\u8282\u70B9\n        while (domArray[i].childNodes.length !== 0) {\n            domArray[i].removeChild(domArray[i].childNodes[0])\n        }\n        cArray.splice(_index, 1)\n        //\u63D2\u5165\u65B0\u7684\u5B50\u8282\u70B9\n        for (let j = 0; j < cArray.length; j++) {\n            domArray[i].appendChild(cArray[j])\n        }\n    }\n    //\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n    removeAndInsertAction($dom, domArray)\n    return $($dom.parentNode)\n}\n\n/**\n * \u5904\u7406\u8BBE\u7F6E/\u53D6\u6D88\u8868\u5934\n * @param $node\n * @param _index\n * @type \u66FF\u6362\u7684\u5217 th \u8FD8\u662Ftd\n */\nfunction setTheHeader($node: DomElement, _index: number, type: string): DomElement {\n    //\u6267\u884C\u83B7\u53D6tbody\u8282\u70B9\n    let $dom = generateDomAction($node)\n    //\u53D6\u51FA\u6240\u6709\u7684\u884C\n    let domArray: Node[] = Array.prototype.slice.apply($dom.childNodes)\n    //\u5217\u7684\u6570\u91CF\n    const childNodesLenght = domArray[_index].childNodes\n    //\u521B\u5EFA\u65B0tr\n    let tr = document.createElement('tr')\n    for (let i = 0; i < childNodesLenght.length; i++) {\n        //\u66FF\u6362td\u4E3Ath\n        const th = document.createElement(type)\n        childNodesLenght[i].childNodes.forEach(item => {\n            th.appendChild(item)\n        })\n        tr.appendChild(th)\n    }\n    //\u63D2\u5165\u96C6\u5408\u4E2D\n    domArray.splice(_index, 1, tr)\n    //\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n    removeAndInsertAction($dom, domArray)\n    return $($dom.parentNode)\n}\n\n/**\n * \u5C01\u88C5\u79FB\u9664\u3001\u65B0\u589E\u8282\u70B9\u4E8B\u4EF6\n * @param $dom tbody\u8282\u70B9\n * @param domArray  \u6240\u6709\u7684\u884C\n */\nfunction removeAndInsertAction($dom: ChildNode, domArray: Node[]) {\n    //\u79FB\u9664\u6240\u6709\u7684\u65E7\u7684\u5B50\u8282\u70B9\n    while ($dom.childNodes.length !== 0) {\n        $dom.removeChild($dom.childNodes[0])\n    }\n    //\u63D2\u5165\u65B0\u7684\u5B50\u8282\u70B9\n    for (let i = 0; i < domArray.length; i++) {\n        $dom.appendChild(domArray[i])\n    }\n}\n\n/**\n * \u5C01\u88C5\u5224\u65AD\u662F\u5426tbody\u8282\u70B9\n * \u7C98\u8D34\u7684table \u7B2C\u4E00\u4E2A\u8282\u70B9\u662F<colgroup> \u6700\u540E\u7684\u8282\u70B9<tbody>\n * @param dom\n */\nfunction generateDomAction($node: DomElement): ChildNode {\n    let $dom: ChildNode = $node.elems[0].childNodes[0]\n    if ($dom.nodeName === 'COLGROUP') {\n        $dom = $node.elems[0].childNodes[$node.elems[0].childNodes.length - 1]\n    }\n    return $dom\n}\n\nexport default {\n    ProcessingRow,\n    ProcessingCol,\n    DeleteRow,\n    DeleteCol,\n    setTheHeader,\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1289d01c3bda5a39985c3eafef0948011b9f4be1"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_iuyk7ixoa = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_iuyk7ixoa();

var __importDefault = (cov_iuyk7ixoa().s[0]++, (cov_iuyk7ixoa().b[0][0]++, void 0) && (cov_iuyk7ixoa().b[0][1]++, (void 0).__importDefault) || (cov_iuyk7ixoa().b[0][2]++, function (mod) {
  cov_iuyk7ixoa().f[0]++;
  cov_iuyk7ixoa().s[1]++;
  return (cov_iuyk7ixoa().b[2][0]++, mod) && (cov_iuyk7ixoa().b[2][1]++, mod.__esModule) ? (cov_iuyk7ixoa().b[1][0]++, mod) : (cov_iuyk7ixoa().b[1][1]++, {
    "default": mod
  });
}));

cov_iuyk7ixoa().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_iuyk7ixoa().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 处理新添加行
 * @param $node 整个table
 * @param _index 行的inde
 */

function ProcessingRow($node, _index) {
  cov_iuyk7ixoa().f[1]++;
  //执行获取tbody节点
  var $dom = (cov_iuyk7ixoa().s[4]++, generateDomAction($node)); //取出所有的行

  var domArray = (cov_iuyk7ixoa().s[5]++, (0, _slice["default"])(Array.prototype).apply($dom.childNodes)); //列的数量

  var childNodesLenght = (cov_iuyk7ixoa().s[6]++, domArray[0].childNodes.length); //创建新tr

  var tr = (cov_iuyk7ixoa().s[7]++, document.createElement('tr'));
  cov_iuyk7ixoa().s[8]++;

  for (var i = (cov_iuyk7ixoa().s[9]++, 0); i < childNodesLenght; i++) {
    var td = (cov_iuyk7ixoa().s[10]++, document.createElement('td'));
    cov_iuyk7ixoa().s[11]++;
    tr.appendChild(td);
  } //插入集合中


  cov_iuyk7ixoa().s[12]++;
  (0, _splice["default"])(domArray).call(domArray, _index + 1, 0, tr); //移除、新增节点事件

  cov_iuyk7ixoa().s[13]++;
  removeAndInsertAction($dom, domArray);
  cov_iuyk7ixoa().s[14]++;
  return dom_core_1["default"]($dom.parentNode);
}
/**
 * 处理新添加列
 * @param $node 整个table
 * @param _index 列的inde
 */


function ProcessingCol($node, _index) {
  cov_iuyk7ixoa().f[2]++;
  //执行获取tbody节点
  var $dom = (cov_iuyk7ixoa().s[15]++, generateDomAction($node)); //取出所有的行

  var domArray = (cov_iuyk7ixoa().s[16]++, (0, _slice["default"])(Array.prototype).apply($dom.childNodes));
  cov_iuyk7ixoa().s[17]++;

  var _loop_1 = function _loop_1(i) {
    var _context;

    cov_iuyk7ixoa().f[3]++;
    var cArray = (cov_iuyk7ixoa().s[18]++, []); //取出所有的列

    cov_iuyk7ixoa().s[19]++;
    (0, _forEach["default"])(_context = domArray[i].childNodes).call(_context, function (item) {
      cov_iuyk7ixoa().f[4]++;
      cov_iuyk7ixoa().s[20]++;
      cArray.push(item);
    }); //移除行的旧的子节点

    cov_iuyk7ixoa().s[21]++;

    while (domArray[i].childNodes.length !== 0) {
      cov_iuyk7ixoa().s[22]++;
      domArray[i].removeChild(domArray[i].childNodes[0]);
    } //列分th td


    var td = (cov_iuyk7ixoa().s[23]++, dom_core_1["default"](cArray[0]).getNodeName() !== 'TH' ? (cov_iuyk7ixoa().b[3][0]++, document.createElement('td')) : (cov_iuyk7ixoa().b[3][1]++, document.createElement('th'))); // let td = document.createElement('td')

    cov_iuyk7ixoa().s[24]++;
    (0, _splice["default"])(cArray).call(cArray, _index + 1, 0, td); //插入新的子节点

    cov_iuyk7ixoa().s[25]++;

    for (var j = (cov_iuyk7ixoa().s[26]++, 0); j < cArray.length; j++) {
      cov_iuyk7ixoa().s[27]++;
      domArray[i].appendChild(cArray[j]);
    }
  }; //创建td


  cov_iuyk7ixoa().s[28]++;

  for (var i = (cov_iuyk7ixoa().s[29]++, 0); i < domArray.length; i++) {
    cov_iuyk7ixoa().s[30]++;

    _loop_1(i);
  } //移除、新增节点事件


  cov_iuyk7ixoa().s[31]++;
  removeAndInsertAction($dom, domArray);
  cov_iuyk7ixoa().s[32]++;
  return dom_core_1["default"]($dom.parentNode);
}
/**
 * 处理删除行
 * @param $node  整个table
 * @param _index  行的inde
 */


function DeleteRow($node, _index) {
  cov_iuyk7ixoa().f[5]++;
  //执行获取tbody节点
  var $dom = (cov_iuyk7ixoa().s[33]++, generateDomAction($node)); //取出所有的行

  var domArray = (cov_iuyk7ixoa().s[34]++, (0, _slice["default"])(Array.prototype).apply($dom.childNodes)); //删除行

  cov_iuyk7ixoa().s[35]++;
  (0, _splice["default"])(domArray).call(domArray, _index, 1); //移除、新增节点事件

  cov_iuyk7ixoa().s[36]++;
  removeAndInsertAction($dom, domArray);
  cov_iuyk7ixoa().s[37]++;
  return dom_core_1["default"]($dom.parentNode);
}
/**
 * 处理删除列
 * @param $node
 * @param _index
 */


function DeleteCol($node, _index) {
  cov_iuyk7ixoa().f[6]++;
  //执行获取tbody节点
  var $dom = (cov_iuyk7ixoa().s[38]++, generateDomAction($node)); //取出所有的行

  var domArray = (cov_iuyk7ixoa().s[39]++, (0, _slice["default"])(Array.prototype).apply($dom.childNodes));
  cov_iuyk7ixoa().s[40]++;

  var _loop_2 = function _loop_2(i) {
    var _context2;

    cov_iuyk7ixoa().f[7]++;
    var cArray = (cov_iuyk7ixoa().s[41]++, []); //取出所有的列

    cov_iuyk7ixoa().s[42]++;
    (0, _forEach["default"])(_context2 = domArray[i].childNodes).call(_context2, function (item) {
      cov_iuyk7ixoa().f[8]++;
      cov_iuyk7ixoa().s[43]++;
      cArray.push(item);
    }); //移除行的旧的子节点

    cov_iuyk7ixoa().s[44]++;

    while (domArray[i].childNodes.length !== 0) {
      cov_iuyk7ixoa().s[45]++;
      domArray[i].removeChild(domArray[i].childNodes[0]);
    }

    cov_iuyk7ixoa().s[46]++;
    (0, _splice["default"])(cArray).call(cArray, _index, 1); //插入新的子节点

    cov_iuyk7ixoa().s[47]++;

    for (var j = (cov_iuyk7ixoa().s[48]++, 0); j < cArray.length; j++) {
      cov_iuyk7ixoa().s[49]++;
      domArray[i].appendChild(cArray[j]);
    }
  }; //创建td


  cov_iuyk7ixoa().s[50]++;

  for (var i = (cov_iuyk7ixoa().s[51]++, 0); i < domArray.length; i++) {
    cov_iuyk7ixoa().s[52]++;

    _loop_2(i);
  } //移除、新增节点事件


  cov_iuyk7ixoa().s[53]++;
  removeAndInsertAction($dom, domArray);
  cov_iuyk7ixoa().s[54]++;
  return dom_core_1["default"]($dom.parentNode);
}
/**
 * 处理设置/取消表头
 * @param $node
 * @param _index
 * @type 替换的列 th 还是td
 */


function setTheHeader($node, _index, type) {
  cov_iuyk7ixoa().f[9]++;
  //执行获取tbody节点
  var $dom = (cov_iuyk7ixoa().s[55]++, generateDomAction($node)); //取出所有的行

  var domArray = (cov_iuyk7ixoa().s[56]++, (0, _slice["default"])(Array.prototype).apply($dom.childNodes)); //列的数量

  var childNodesLenght = (cov_iuyk7ixoa().s[57]++, domArray[_index].childNodes); //创建新tr

  var tr = (cov_iuyk7ixoa().s[58]++, document.createElement('tr'));
  cov_iuyk7ixoa().s[59]++;

  var _loop_3 = function _loop_3(i) {
    var _context3;

    cov_iuyk7ixoa().f[10]++;
    //替换td为th
    var th = (cov_iuyk7ixoa().s[60]++, document.createElement(type));
    cov_iuyk7ixoa().s[61]++;
    (0, _forEach["default"])(_context3 = childNodesLenght[i].childNodes).call(_context3, function (item) {
      cov_iuyk7ixoa().f[11]++;
      cov_iuyk7ixoa().s[62]++;
      th.appendChild(item);
    });
    cov_iuyk7ixoa().s[63]++;
    tr.appendChild(th);
  };

  cov_iuyk7ixoa().s[64]++;

  for (var i = (cov_iuyk7ixoa().s[65]++, 0); i < childNodesLenght.length; i++) {
    cov_iuyk7ixoa().s[66]++;

    _loop_3(i);
  } //插入集合中


  cov_iuyk7ixoa().s[67]++;
  (0, _splice["default"])(domArray).call(domArray, _index, 1, tr); //移除、新增节点事件

  cov_iuyk7ixoa().s[68]++;
  removeAndInsertAction($dom, domArray);
  cov_iuyk7ixoa().s[69]++;
  return dom_core_1["default"]($dom.parentNode);
}
/**
 * 封装移除、新增节点事件
 * @param $dom tbody节点
 * @param domArray  所有的行
 */


function removeAndInsertAction($dom, domArray) {
  cov_iuyk7ixoa().f[12]++;
  cov_iuyk7ixoa().s[70]++;

  //移除所有的旧的子节点
  while ($dom.childNodes.length !== 0) {
    cov_iuyk7ixoa().s[71]++;
    $dom.removeChild($dom.childNodes[0]);
  } //插入新的子节点


  cov_iuyk7ixoa().s[72]++;

  for (var i = (cov_iuyk7ixoa().s[73]++, 0); i < domArray.length; i++) {
    cov_iuyk7ixoa().s[74]++;
    $dom.appendChild(domArray[i]);
  }
}
/**
 * 封装判断是否tbody节点
 * 粘贴的table 第一个节点是<colgroup> 最后的节点<tbody>
 * @param dom
 */


function generateDomAction($node) {
  cov_iuyk7ixoa().f[13]++;
  var $dom = (cov_iuyk7ixoa().s[75]++, $node.elems[0].childNodes[0]);
  cov_iuyk7ixoa().s[76]++;

  if ($dom.nodeName === 'COLGROUP') {
    cov_iuyk7ixoa().b[4][0]++;
    cov_iuyk7ixoa().s[77]++;
    $dom = $node.elems[0].childNodes[$node.elems[0].childNodes.length - 1];
  } else {
    cov_iuyk7ixoa().b[4][1]++;
  }

  cov_iuyk7ixoa().s[78]++;
  return $dom;
}

cov_iuyk7ixoa().s[79]++;
exports["default"] = {
  ProcessingRow: ProcessingRow,
  ProcessingCol: ProcessingCol,
  DeleteRow: DeleteRow,
  DeleteCol: DeleteCol,
  setTheHeader: setTheHeader
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 获取dom节点
 * @author lichunlin
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_yhb10dq0c() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/getNode.ts";
  var hash = "de9e7d7ed889d8a00990beeb04b0fd8b6fd49332";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/getNode.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 71
        }
      },
      "4": {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 29
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "7": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 52
        }
      },
      "8": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 24,
          column: 9
        }
      },
      "9": {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 23
        }
      },
      "10": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 117
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 19
        }
      },
      "12": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 44,
          column: 6
        }
      },
      "13": {
        start: {
          line: 34,
          column: 21
        },
        end: {
          line: 34,
          column: 22
        }
      },
      "14": {
        start: {
          line: 35,
          column: 25
        },
        end: {
          line: 35,
          column: 44
        }
      },
      "15": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 39,
          column: 9
        }
      },
      "16": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 71
        }
      },
      "17": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 42,
          column: 11
        }
      },
      "18": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 50
        }
      },
      "19": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 22
        }
      },
      "20": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "21": {
        start: {
          line: 52,
          column: 21
        },
        end: {
          line: 52,
          column: 22
        }
      },
      "22": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 56,
          column: 120
        }
      },
      "23": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 57,
          column: 56
        }
      },
      "24": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 60,
          column: 11
        }
      },
      "25": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 52
        }
      },
      "26": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 22
        }
      },
      "27": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "28": {
        start: {
          line: 68,
          column: 22
        },
        end: {
          line: 68,
          column: 143
        }
      },
      "29": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 23
        }
      },
      "30": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 19
        }
      },
      "31": {
        start: {
          line: 73,
          column: 0
        },
        end: {
          line: 73,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 29
          },
          end: {
            line: 11,
            column: 30
          }
        },
        loc: {
          start: {
            line: 11,
            column: 41
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "getNode",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 20
          }
        },
        loc: {
          start: {
            line: 12,
            column: 29
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 35
          },
          end: {
            line: 19,
            column: 36
          }
        },
        loc: {
          start: {
            line: 19,
            column: 52
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 19
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 43
          },
          end: {
            line: 33,
            column: 44
          }
        },
        loc: {
          start: {
            line: 33,
            column: 66
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 33
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 40,
            column: 38
          },
          end: {
            line: 40,
            column: 39
          }
        },
        loc: {
          start: {
            line: 40,
            column: 61
          },
          end: {
            line: 42,
            column: 9
          }
        },
        line: 40
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 43
          },
          end: {
            line: 49,
            column: 44
          }
        },
        loc: {
          start: {
            line: 49,
            column: 60
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 58,
            column: 43
          },
          end: {
            line: 58,
            column: 44
          }
        },
        loc: {
          start: {
            line: 58,
            column: 66
          },
          end: {
            line: 60,
            column: 9
          }
        },
        line: 58
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 67,
            column: 37
          },
          end: {
            line: 67,
            column: 38
          }
        },
        loc: {
          start: {
            line: 67,
            column: 54
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 67
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }, {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 24,
            column: 9
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 25,
            column: 14
          },
          end: {
            line: 25,
            column: 116
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 96
          },
          end: {
            line: 25,
            column: 102
          }
        }, {
          start: {
            line: 25,
            column: 105
          },
          end: {
            line: 25,
            column: 116
          }
        }],
        line: 25
      },
      "5": {
        loc: {
          start: {
            line: 25,
            column: 14
          },
          end: {
            line: 25,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 14
          },
          end: {
            line: 25,
            column: 76
          }
        }, {
          start: {
            line: 25,
            column: 80
          },
          end: {
            line: 25,
            column: 93
          }
        }],
        line: 25
      },
      "6": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 39,
            column: 9
          }
        }],
        line: 37
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 41,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 29
          },
          end: {
            line: 41,
            column: 43
          }
        }, {
          start: {
            line: 41,
            column: 47
          },
          end: {
            line: 41,
            column: 49
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 56,
            column: 120
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 14
          },
          end: {
            line: 55,
            column: 19
          }
        }, {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 120
          }
        }],
        line: 54
      },
      "9": {
        loc: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 121
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 69
          }
        }, {
          start: {
            line: 54,
            column: 73
          },
          end: {
            line: 54,
            column: 121
          }
        }],
        line: 54
      },
      "10": {
        loc: {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 120
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 56,
            column: 100
          },
          end: {
            line: 56,
            column: 106
          }
        }, {
          start: {
            line: 56,
            column: 109
          },
          end: {
            line: 56,
            column: 120
          }
        }],
        line: 56
      },
      "11": {
        loc: {
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 14
          },
          end: {
            line: 56,
            column: 80
          }
        }, {
          start: {
            line: 56,
            column: 84
          },
          end: {
            line: 56,
            column: 97
          }
        }],
        line: 56
      },
      "12": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 59,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 31
          },
          end: {
            line: 59,
            column: 45
          }
        }, {
          start: {
            line: 59,
            column: 49
          },
          end: {
            line: 59,
            column: 51
          }
        }],
        line: 59
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/getNode.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/table/bind-event/event/getNode.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,wEAA0C;AAG1C;IAEI,iBAAY,MAAc;QACtB,IAAI,CAAC,MAAM,GAAG,MAAM,CAAA;IACxB,CAAC;IAED;;;OAGG;IACI,4BAAU,GAAjB,UAAkB,KAAkB;;QAChC,IAAI,GAAG,GAAmC,kBAAC,CAAC,KAAK,CAAC,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC3D,IAAI,CAAC,GAAG,CAAC,UAAU,EAAE;YACjB,OAAO,GAAG,CAAA;SACb;QACD,GAAG,SAAG,kBAAC,CAAC,GAAG,CAAC,CAAC,WAAW,CAAC,IAAI,EAAE,GAAG,CAAC,0CAAE,KAAK,CAAC,CAAC,CAAC,CAAA;QAC7C,OAAO,GAAG,CAAA;IACd,CAAC;IAED;;;;OAIG;IACI,oCAAkB,GAAzB,UAA0B,KAAkB,EAAE,IAAiB;QAC3D,IAAI,MAAM,GAAW,CAAC,CAAA;QACtB,IAAI,UAAU,GAAG,KAAK,CAAC,UAAU,CAAC,CAAC,CAAC,CAAA;QACpC,wBAAwB;QACxB,IAAI,UAAU,CAAC,QAAQ,KAAK,UAAU,EAAE;YACpC,UAAU,GAAG,KAAK,CAAC,UAAU,CAAC,KAAK,CAAC,UAAU,CAAC,MAAM,GAAG,CAAC,CAAC,CAAA;SAC7D;QACD,UAAU,CAAC,UAAU,CAAC,OAAO,CAAC,UAAC,IAAI,EAAE,KAAK;YACtC,IAAI,KAAK,IAAI,CAAC,CAAC,CAAC,CAAC,MAAM,GAAG,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;QACzC,CAAC,CAAC,CAAA;QACF,OAAO,MAAM,CAAA;IACjB,CAAC;IAED;;;OAGG;IACI,oCAAkB,GAAzB,UAA0B,KAAkB;;QACxC,KAAK;QACL,IAAI,MAAM,GAAW,CAAC,CAAA;QACtB,aAAa;QACb,IAAI,MAAM,GACN,kBAAC,CAAC,KAAK,CAAC,CAAC,WAAW,EAAE,KAAK,IAAI,IAAI,kBAAC,CAAC,KAAK,CAAC,CAAC,WAAW,EAAE,KAAK,IAAI;YAC9D,CAAC,CAAC,KAAK;YACP,CAAC,OAAC,kBAAC,CAAC,KAAK,CAAC,CAAC,WAAW,CAAC,IAAI,EAAE,KAAK,CAAC,0CAAE,KAAK,CAAC,CAAC,CAAC,CAAA;QACrD,IAAI,MAAM,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAC,MAAM,EAAE,CAAA;QAC/B,MAAM,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,UAAU,CAAC,OAAO,CAAC,UAAC,IAAI,EAAE,KAAK;YAC3C,IAAI,KAAK,MAAM,CAAC,CAAC,CAAC,CAAC,MAAM,GAAG,KAAK,CAAC,CAAC,CAAC,CAAC,EAAE,CAAA;QAC3C,CAAC,CAAC,CAAA;QACF,OAAO,MAAM,CAAA;IACjB,CAAC;IAED;;;OAGG;IACI,8BAAY,GAAnB,UAAoB,KAAkB;QAClC,IAAM,OAAO,GAAG,4EAAkE,kBAAC,CAC/E,KAAK,CACR,CAAC,IAAI,EAAE,aAAU,CAAA;QAClB,OAAO,OAAO,CAAA;IAClB,CAAC;IACL,cAAC;AAAD,CAAC,AAlED,IAkEC;AAED,kBAAe,OAAO,CAAA",
      sourcesContent: ["/**\n * @description \u83B7\u53D6dom\u8282\u70B9\n * @author lichunlin\n */\n\nimport $ from '../../../../utils/dom-core'\nimport Editor from '../../../../editor/index'\n\nclass getNode {\n    public editor: Editor\n    constructor(editor: Editor) {\n        this.editor = editor\n    }\n\n    /**\n     * \u83B7\u53D6\u7126\u70B9\u6240\u5728\u884C\n     * @param $node \u5F53\u524Dtable\n     */\n    public getRowNode($node: HTMLElement): HTMLElement | null | undefined {\n        let DOM: HTMLElement | null | undefined = $($node).elems[0]\n        if (!DOM.parentNode) {\n            return DOM\n        }\n        DOM = $(DOM).parentUntil('TR', DOM)?.elems[0]\n        return DOM\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u884C\u7684\u4E0B\u6807\n     * @param $node \u5F53\u524Dtable\n     * @param $dmo \u5F53\u524D\u884C\u8282\u70B9\n     */\n    public getCurrentRowIndex($node: HTMLElement, $dom: HTMLElement): Number {\n        let _index: number = 0\n        let $nodeChild = $node.childNodes[0]\n        //\u7C98\u8D34\u7684table \u6700\u540E\u4E00\u4E2A\u8282\u70B9\u624D\u662Ftbody\n        if ($nodeChild.nodeName === 'COLGROUP') {\n            $nodeChild = $node.childNodes[$node.childNodes.length - 1]\n        }\n        $nodeChild.childNodes.forEach((item, index) => {\n            item === $dom ? (_index = index) : ''\n        })\n        return _index\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u5217\u7684\u4E0B\u6807\n     * @param $node \u5F53\u524D\u70B9\u51FB\u5143\u7D20\n     */\n    public getCurrentColIndex($node: HTMLElement): number {\n        //\u5F53\u524D\u884C\n        let _index: number = 0\n        //\u83B7\u53D6\u5F53\u524D\u5217 td\u6216th\n        let rowDom =\n            $($node).getNodeName() === 'TD' || $($node).getNodeName() === 'TH'\n                ? $node\n                : $($node).parentUntil('TD', $node)?.elems[0]\n        let colDom = $(rowDom).parent()\n        colDom.elems[0].childNodes.forEach((item, index) => {\n            item === rowDom ? (_index = index) : ''\n        })\n        return _index\n    }\n\n    /**\n     * \u8FD4\u56DE\u5143\u7D20html\u5B57\u7B26\u4E32\n     * @param $node\n     */\n    public getTableHtml($node: HTMLElement): string {\n        const htmlStr = `<table border=\"0\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\">${$(\n            $node\n        ).html()}</table>`\n        return htmlStr\n    }\n}\n\nexport default getNode\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "de9e7d7ed889d8a00990beeb04b0fd8b6fd49332"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_yhb10dq0c = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_yhb10dq0c();

var __importDefault = (cov_yhb10dq0c().s[0]++, (cov_yhb10dq0c().b[0][0]++, void 0) && (cov_yhb10dq0c().b[0][1]++, (void 0).__importDefault) || (cov_yhb10dq0c().b[0][2]++, function (mod) {
  cov_yhb10dq0c().f[0]++;
  cov_yhb10dq0c().s[1]++;
  return (cov_yhb10dq0c().b[2][0]++, mod) && (cov_yhb10dq0c().b[2][1]++, mod.__esModule) ? (cov_yhb10dq0c().b[1][0]++, mod) : (cov_yhb10dq0c().b[1][1]++, {
    "default": mod
  });
}));

cov_yhb10dq0c().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_yhb10dq0c().s[3]++, __importDefault(__webpack_require__(2)));
var getNode = (
/** @class */
cov_yhb10dq0c().s[4]++, function () {
  cov_yhb10dq0c().f[1]++;

  function getNode(editor) {
    cov_yhb10dq0c().f[2]++;
    cov_yhb10dq0c().s[5]++;
    this.editor = editor;
  }
  /**
   * 获取焦点所在行
   * @param $node 当前table
   */


  cov_yhb10dq0c().s[6]++;

  getNode.prototype.getRowNode = function ($node) {
    cov_yhb10dq0c().f[3]++;

    var _a;

    var DOM = (cov_yhb10dq0c().s[7]++, dom_core_1["default"]($node).elems[0]);
    cov_yhb10dq0c().s[8]++;

    if (!DOM.parentNode) {
      cov_yhb10dq0c().b[3][0]++;
      cov_yhb10dq0c().s[9]++;
      return DOM;
    } else {
      cov_yhb10dq0c().b[3][1]++;
    }

    cov_yhb10dq0c().s[10]++;
    DOM = (cov_yhb10dq0c().b[5][0]++, (_a = dom_core_1["default"](DOM).parentUntil('TR', DOM)) === null) || (cov_yhb10dq0c().b[5][1]++, _a === void 0) ? (cov_yhb10dq0c().b[4][0]++, void 0) : (cov_yhb10dq0c().b[4][1]++, _a.elems[0]);
    cov_yhb10dq0c().s[11]++;
    return DOM;
  };
  /**
   * 获取当前行的下标
   * @param $node 当前table
   * @param $dmo 当前行节点
   */


  cov_yhb10dq0c().s[12]++;

  getNode.prototype.getCurrentRowIndex = function ($node, $dom) {
    var _context;

    cov_yhb10dq0c().f[4]++;

    var _index = (cov_yhb10dq0c().s[13]++, 0);

    var $nodeChild = (cov_yhb10dq0c().s[14]++, $node.childNodes[0]); //粘贴的table 最后一个节点才是tbody

    cov_yhb10dq0c().s[15]++;

    if ($nodeChild.nodeName === 'COLGROUP') {
      cov_yhb10dq0c().b[6][0]++;
      cov_yhb10dq0c().s[16]++;
      $nodeChild = $node.childNodes[$node.childNodes.length - 1];
    } else {
      cov_yhb10dq0c().b[6][1]++;
    }

    cov_yhb10dq0c().s[17]++;
    (0, _forEach["default"])(_context = $nodeChild.childNodes).call(_context, function (item, index) {
      cov_yhb10dq0c().f[5]++;
      cov_yhb10dq0c().s[18]++;
      item === $dom ? (cov_yhb10dq0c().b[7][0]++, _index = index) : (cov_yhb10dq0c().b[7][1]++, '');
    });
    cov_yhb10dq0c().s[19]++;
    return _index;
  };
  /**
   * 获取当前列的下标
   * @param $node 当前点击元素
   */


  cov_yhb10dq0c().s[20]++;

  getNode.prototype.getCurrentColIndex = function ($node) {
    var _context2;

    cov_yhb10dq0c().f[6]++;

    var _a; //当前行


    var _index = (cov_yhb10dq0c().s[21]++, 0); //获取当前列 td或th


    var rowDom = (cov_yhb10dq0c().s[22]++, (cov_yhb10dq0c().b[9][0]++, dom_core_1["default"]($node).getNodeName() === 'TD') || (cov_yhb10dq0c().b[9][1]++, dom_core_1["default"]($node).getNodeName() === 'TH') ? (cov_yhb10dq0c().b[8][0]++, $node) : (cov_yhb10dq0c().b[8][1]++, (cov_yhb10dq0c().b[11][0]++, (_a = dom_core_1["default"]($node).parentUntil('TD', $node)) === null) || (cov_yhb10dq0c().b[11][1]++, _a === void 0) ? (cov_yhb10dq0c().b[10][0]++, void 0) : (cov_yhb10dq0c().b[10][1]++, _a.elems[0])));
    var colDom = (cov_yhb10dq0c().s[23]++, dom_core_1["default"](rowDom).parent());
    cov_yhb10dq0c().s[24]++;
    (0, _forEach["default"])(_context2 = colDom.elems[0].childNodes).call(_context2, function (item, index) {
      cov_yhb10dq0c().f[7]++;
      cov_yhb10dq0c().s[25]++;
      item === rowDom ? (cov_yhb10dq0c().b[12][0]++, _index = index) : (cov_yhb10dq0c().b[12][1]++, '');
    });
    cov_yhb10dq0c().s[26]++;
    return _index;
  };
  /**
   * 返回元素html字符串
   * @param $node
   */


  cov_yhb10dq0c().s[27]++;

  getNode.prototype.getTableHtml = function ($node) {
    cov_yhb10dq0c().f[8]++;
    var htmlStr = (cov_yhb10dq0c().s[28]++, "<table border=\"0\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\">" + dom_core_1["default"]($node).html() + "</table>");
    cov_yhb10dq0c().s[29]++;
    return htmlStr;
  };

  cov_yhb10dq0c().s[30]++;
  return getNode;
}());
cov_yhb10dq0c().s[31]++;
exports["default"] = getNode;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 代码 菜单
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _map = _interopRequireDefault(__webpack_require__(42));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_2hc8jeuucx() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/code/index.ts";
  var hash = "b7716d74031eebe715927c45c5b953f4585c08dc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/code/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 0
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "16": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 76
        }
      },
      "17": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 65
        }
      },
      "18": {
        start: {
          line: 26,
          column: 13
        },
        end: {
          line: 26,
          column: 40
        }
      },
      "19": {
        start: {
          line: 27,
          column: 26
        },
        end: {
          line: 27,
          column: 73
        }
      },
      "20": {
        start: {
          line: 28,
          column: 18
        },
        end: {
          line: 28,
          column: 57
        }
      },
      "21": {
        start: {
          line: 29,
          column: 14
        },
        end: {
          line: 29,
          column: 68
        }
      },
      "22": {
        start: {
          line: 30,
          column: 14
        },
        end: {
          line: 30,
          column: 60
        }
      },
      "23": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 33,
          column: 20
        }
      },
      "24": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 20
        }
      },
      "25": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 37
        }
      },
      "26": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 33
        }
      },
      "27": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 45
        }
      },
      "28": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 16
        }
      },
      "29": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 55
        }
      },
      "30": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 42,
          column: 24
        }
      },
      "31": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 24
        }
      },
      "32": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 46,
          column: 11
        }
      },
      "33": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 98
        }
      },
      "34": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 20
        }
      },
      "35": {
        start: {
          line: 52,
          column: 16
        },
        end: {
          line: 52,
          column: 66
        }
      },
      "36": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 56,
          column: 24
        }
      },
      "37": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 24
        }
      },
      "38": {
        start: {
          line: 58,
          column: 16
        },
        end: {
          line: 61,
          column: 10
        }
      },
      "39": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 58
        }
      },
      "40": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 45
        }
      },
      "41": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 65,
          column: 9
        }
      },
      "42": {
        start: {
          line: 63,
          column: 21
        },
        end: {
          line: 63,
          column: 22
        }
      },
      "43": {
        start: {
          line: 64,
          column: 12
        },
        end: {
          line: 64,
          column: 44
        }
      },
      "44": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 41
        }
      },
      "45": {
        start: {
          line: 69,
          column: 0
        },
        end: {
          line: 69,
          column: 40
        }
      },
      "46": {
        start: {
          line: 70,
          column: 26
        },
        end: {
          line: 137,
          column: 22
        }
      },
      "47": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 28
        }
      },
      "48": {
        start: {
          line: 73,
          column: 20
        },
        end: {
          line: 73,
          column: 24
        }
      },
      "49": {
        start: {
          line: 74,
          column: 20
        },
        end: {
          line: 74,
          column: 103
        }
      },
      "50": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 57
        }
      },
      "51": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 32
        }
      },
      "52": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 21
        }
      },
      "53": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 92,
          column: 6
        }
      },
      "54": {
        start: {
          line: 86,
          column: 21
        },
        end: {
          line: 86,
          column: 32
        }
      },
      "55": {
        start: {
          line: 88,
          column: 20
        },
        end: {
          line: 88,
          column: 67
        }
      },
      "56": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 43
        }
      },
      "57": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 90,
          column: 57
        }
      },
      "58": {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 91,
          column: 44
        }
      },
      "59": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 113,
          column: 6
        }
      },
      "60": {
        start: {
          line: 97,
          column: 21
        },
        end: {
          line: 97,
          column: 32
        }
      },
      "61": {
        start: {
          line: 98,
          column: 28
        },
        end: {
          line: 98,
          column: 63
        }
      },
      "62": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 112,
          column: 9
        }
      },
      "63": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 19
        }
      },
      "64": {
        start: {
          line: 104,
          column: 12
        },
        end: {
          line: 111,
          column: 13
        }
      },
      "65": {
        start: {
          line: 106,
          column: 16
        },
        end: {
          line: 106,
          column: 41
        }
      },
      "66": {
        start: {
          line: 110,
          column: 16
        },
        end: {
          line: 110,
          column: 51
        }
      },
      "67": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 123,
          column: 6
        }
      },
      "68": {
        start: {
          line: 120,
          column: 19
        },
        end: {
          line: 120,
          column: 79
        }
      },
      "69": {
        start: {
          line: 121,
          column: 20
        },
        end: {
          line: 121,
          column: 51
        }
      },
      "70": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 23
        }
      },
      "71": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 135,
          column: 6
        }
      },
      "72": {
        start: {
          line: 128,
          column: 21
        },
        end: {
          line: 128,
          column: 32
        }
      },
      "73": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 134,
          column: 9
        }
      },
      "74": {
        start: {
          line: 130,
          column: 12
        },
        end: {
          line: 130,
          column: 26
        }
      },
      "75": {
        start: {
          line: 133,
          column: 12
        },
        end: {
          line: 133,
          column: 28
        }
      },
      "76": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 16
        }
      },
      "77": {
        start: {
          line: 138,
          column: 0
        },
        end: {
          line: 138,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "formatCodeHtml",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 23
          }
        },
        loc: {
          start: {
            line: 31,
            column: 38
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 31
      },
      "8": {
        name: "formatEnterCode",
        decl: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 28
          }
        },
        loc: {
          start: {
            line: 39,
            column: 35
          },
          end: {
            line: 48,
            column: 5
          }
        },
        line: 39
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 43,
            column: 19
          },
          end: {
            line: 43,
            column: 20
          }
        },
        loc: {
          start: {
            line: 43,
            column: 35
          },
          end: {
            line: 46,
            column: 9
          }
        },
        line: 43
      },
      "10": {
        name: "deleteHighlightCode",
        decl: {
          start: {
            line: 50,
            column: 13
          },
          end: {
            line: 50,
            column: 32
          }
        },
        loc: {
          start: {
            line: 50,
            column: 39
          },
          end: {
            line: 67,
            column: 5
          }
        },
        line: 50
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 58,
            column: 40
          },
          end: {
            line: 58,
            column: 41
          }
        },
        loc: {
          start: {
            line: 58,
            column: 53
          },
          end: {
            line: 61,
            column: 9
          }
        },
        line: 58
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 70,
            column: 26
          },
          end: {
            line: 70,
            column: 27
          }
        },
        loc: {
          start: {
            line: 70,
            column: 44
          },
          end: {
            line: 137,
            column: 1
          }
        },
        line: 70
      },
      "13": {
        name: "Code",
        decl: {
          start: {
            line: 72,
            column: 13
          },
          end: {
            line: 72,
            column: 17
          }
        },
        loc: {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 72
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 85,
            column: 36
          },
          end: {
            line: 85,
            column: 37
          }
        },
        loc: {
          start: {
            line: 85,
            column: 52
          },
          end: {
            line: 92,
            column: 5
          }
        },
        line: 85
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 35
          }
        },
        loc: {
          start: {
            line: 96,
            column: 46
          },
          end: {
            line: 113,
            column: 5
          }
        },
        line: 96
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 34
          }
        },
        loc: {
          start: {
            line: 119,
            column: 63
          },
          end: {
            line: 123,
            column: 5
          }
        },
        line: 119
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 127,
            column: 37
          },
          end: {
            line: 127,
            column: 38
          }
        },
        loc: {
          start: {
            line: 127,
            column: 49
          },
          end: {
            line: 135,
            column: 5
          }
        },
        line: 127
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 20
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 20
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 20
          }
        }],
        line: 32
      },
      "8": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 42,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 42,
            column: 24
          }
        }, {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 42,
            column: 24
          }
        }],
        line: 41
      },
      "9": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 56,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 56,
            column: 24
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 56,
            column: 24
          }
        }],
        line: 55
      },
      "10": {
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 14
          }
        }, {
          start: {
            line: 55,
            column: 18
          },
          end: {
            line: 55,
            column: 27
          }
        }],
        line: 55
      },
      "11": {
        loc: {
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 48
          }
        }, {
          start: {
            line: 75,
            column: 52
          },
          end: {
            line: 75,
            column: 56
          }
        }],
        line: 75
      },
      "12": {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        }, {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 112,
            column: 9
          }
        }],
        line: 99
      },
      "13": {
        loc: {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 111,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 111,
            column: 13
          }
        }, {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 111,
            column: 13
          }
        }],
        line: 104
      },
      "14": {
        loc: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }, {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }],
        line: 129
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/code/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/code/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;;AAEH,6EAAsD;AAEtD,kEAAoC;AACpC,yCAAkE;AAClE,0EAAiD;AACjD,0DAAkC;AAClC,qEAA8C;AAE9C,6DAA0C;AAE1C,SAAgB,cAAc,CAAC,MAAc,EAAE,IAAY;IACvD,IAAI,CAAC,IAAI;QAAE,OAAO,IAAI,CAAA;IAEtB,IAAI,GAAG,mBAAmB,CAAC,IAAI,CAAC,CAAA;IAEhC,IAAI,GAAG,eAAe,CAAC,IAAI,CAAC,CAAA;IAE5B,IAAI,GAAG,2BAAoB,CAAC,IAAI,CAAC,CAAA;IAEjC,OAAO,IAAI,CAAA;IAEX,kBAAkB;IAClB,SAAS,eAAe,CAAC,IAAY;QACjC,IAAI,MAAM,GAAG,IAAI,CAAC,KAAK,CAAC,sBAAsB,CAAC,CAAA;QAE/C,IAAI,MAAM,KAAK,IAAI;YAAE,OAAO,IAAI,CAAA;QAEhC,MAAM,CAAC,GAAG,CAAC,UAAA,IAAI;YACX,kBAAkB;YAClB,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,IAAI,EAAE,IAAI,CAAC,OAAO,CAAC,iBAAiB,EAAE,IAAI,CAAC,CAAC,OAAO,CAAC,OAAO,EAAE,EAAE,CAAC,CAAC,CAAA;QACzF,CAAC,CAAC,CAAA;QAEF,OAAO,IAAI,CAAA;IACf,CAAC;IAED,iBAAiB;IACjB,SAAS,mBAAmB,CAAC,IAAY;QACrC,aAAa;QACb,IAAI,CAAC,GAAG,IAAI,CAAC,KAAK,CAAC,sCAAsC,CAAC,CAAA;QAE1D,cAAc;QACd,aAAa;QACb,IAAI,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,MAAM;YAAE,OAAO,IAAI,CAAA;QAEhC,SAAS;QACT,IAAI,CAAC,GAAG,gBAAS,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,UAAC,CAAS;YAC/B,CAAC,GAAG,CAAC,CAAC,OAAO,CAAC,0BAA0B,EAAE,EAAE,CAAC,CAAA;YAC7C,OAAO,CAAC,CAAC,OAAO,CAAC,UAAU,EAAE,EAAE,CAAC,CAAA;QACpC,CAAC,CAAC,CAAA;QAEF,aAAa;QACb,KAAK,IAAI,CAAC,GAAG,CAAC,EAAE,CAAC,GAAG,CAAC,CAAC,MAAM,EAAE,CAAC,EAAE,EAAE;YAC/B,IAAI,GAAG,IAAI,CAAC,OAAO,CAAC,CAAC,CAAC,CAAC,CAAC,EAAE,CAAC,CAAC,CAAC,CAAC,CAAC,CAAA;SAClC;QAED,OAAO,mBAAmB,CAAC,IAAI,CAAC,CAAA;IACpC,CAAC;AACL,CAAC;AA/CD,wCA+CC;AAED;IAAmB,wBAAS;IACxB,cAAY,MAAc;QAA1B,iBAMC;QALG,IAAM,KAAK,GAAG,kBAAC,CAAC,+DAA+D,CAAC,CAAA;QAChF,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QAEpB,qBAAqB;QACrB,eAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IAED;;;;OAIG;IACK,6BAAc,GAAtB,UAAuB,IAAY;QAC/B,IAAI,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QACxB,SAAS;QACT,IAAI,KAAK,GAAG,kBAAC,CAAC,WAAS,IAAI,YAAS,CAAC,CAAA;QACrC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,KAAK,CAAC,CAAA;QAClC,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,EAAE,KAAK,CAAC,CAAA;QAChD,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;IACvC,CAAC;IAED;;OAEG;IACI,2BAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,aAAa,GAAG,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEzD,IAAI,IAAI,CAAC,QAAQ,EAAE;YACf,OAAM;SACT;aAAM;YACH,mBAAmB;YACnB,IAAI,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,EAAE;gBACrC,cAAc;gBACd,IAAI,CAAC,WAAW,CAAC,EAAE,EAAE,EAAE,CAAC,CAAA;aAC3B;iBAAM;gBACH,kBAAkB;gBAClB,IAAI,CAAC,cAAc,CAAC,aAAa,CAAC,CAAA;aACrC;SACJ;IACL,CAAC;IAED;;;;OAIG;IACI,0BAAW,GAAlB,UAAmB,IAAY,EAAE,YAAoB;QACjD,IAAM,IAAI,GAAG,2BAAe,CAAC,IAAI,CAAC,MAAM,EAAE,IAAI,EAAE,YAAY,CAAC,CAAA;QAC7D,IAAM,KAAK,GAAG,IAAI,eAAK,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;QACnC,KAAK,CAAC,MAAM,EAAE,CAAA;IAClB,CAAC;IAED;;OAEG;IACI,8BAAe,GAAtB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAI,mBAAQ,CAAC,MAAM,CAAC,EAAE;YAClB,IAAI,CAAC,MAAM,EAAE,CAAA;SAChB;aAAM;YACH,IAAI,CAAC,QAAQ,EAAE,CAAA;SAClB;IACL,CAAC;IACL,WAAC;AAAD,CAAC,AAlED,CAAmB,mBAAS,GAkE3B;AAED,kBAAe,IAAI,CAAA",
      sourcesContent: ["/**\n * @description \u4EE3\u7801 \u83DC\u5355\n * @author lkw\n */\n\nimport PanelMenu from '../menu-constructors/PanelMenu'\nimport Editor from '../../editor/index'\nimport $ from '../../utils/dom-core'\nimport { replaceSpecialSymbol, deepClone } from '../../utils/util'\nimport createPanelConf from './create-panel-conf'\nimport isActive from './is-active'\nimport Panel from '../menu-constructors/Panel'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event/index'\n\nexport function formatCodeHtml(editor: Editor, html: string) {\n    if (!html) return html\n\n    html = deleteHighlightCode(html)\n\n    html = formatEnterCode(html)\n\n    html = replaceSpecialSymbol(html)\n\n    return html\n\n    // \u683C\u5F0F\u5316\u6362\u6362\u6240\u4EA7\u751F\u7684code\u6807\u7B7E\n    function formatEnterCode(html: string): string {\n        let preArr = html.match(/<pre[\\s|\\S]+?\\/pre>/g)\n\n        if (preArr === null) return html\n\n        preArr.map(item => {\n            //\u5C06\u8FDE\u7EED\u7684code\u6807\u7B7E\u6362\u4E3A\\n\u6362\u884C\n            html = html.replace(item, item.replace(/<\\/code><code>/g, '\\n').replace(/<br>/g, ''))\n        })\n\n        return html\n    }\n\n    // highlight\u683C\u5F0F\u5316\u65B9\u6CD5\n    function deleteHighlightCode(html: string): string {\n        // \u83B7\u53D6\u6240\u6709hljs\u6587\u672C\n        let m = html.match(/<span\\sclass=\"hljs[\\s|\\S]+?\\/span>/gm)\n\n        // \u6CA1\u6709\u4EE3\u7801\u6E32\u67D3\u6587\u672C\u5219\u9000\u51FA\n        // @ts-ignore\n        if (!m || !m.length) return html\n\n        // \u83B7\u53D6\u66FF\u6362\u6587\u672C\n        let r = deepClone(m).map((i: string) => {\n            i = i.replace(/<span\\sclass=\"hljs[^>]+>/, '')\n            return i.replace(/<\\/span>/, '')\n        })\n\n        // @ts-ignore\n        for (let i = 0; i < m.length; i++) {\n            html = html.replace(m[i], r[i])\n        }\n\n        return deleteHighlightCode(html)\n    }\n}\n\nclass Code extends PanelMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-terminal\"></i></div>')\n        super($elem, editor)\n\n        // \u7ED1\u5B9A\u4E8B\u4EF6\uFF0C\u5982\u70B9\u51FB\u94FE\u63A5\u65F6\uFF0C\u53EF\u4EE5\u67E5\u770B\u94FE\u63A5\n        bindEvent(editor)\n    }\n\n    /**\n     * \u63D2\u5165\u884C\u5185\u4EE3\u7801\n     * @param text\n     * @return null\n     */\n    private insertLineCode(text: string) {\n        let editor = this.editor\n        // \u884C\u5185\u4EE3\u7801\u5904\u7406\n        let $code = $(`<code>${text}</code>`)\n        editor.cmd.do('insertElem', $code)\n        editor.selection.createRangeByElem($code, false)\n        editor.selection.restoreSelection()\n    }\n\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const selectionText = editor.selection.getSelectionText()\n\n        if (this.isActive) {\n            return\n        } else {\n            // \u83DC\u5355\u672A\u88AB\u6FC0\u6D3B\uFF0C\u8BF4\u660E\u9009\u533A\u4E0D\u5728\u94FE\u63A5\u91CC\n            if (editor.selection.isSelectionEmpty()) {\n                // \u9009\u533A\u662F\u7A7A\u7684\uFF0C\u672A\u9009\u4E2D\u5185\u5BB9\n                this.createPanel('', '')\n            } else {\n                // \u884C\u5185\u4EE3\u7801\u5904\u7406 \u9009\u4E2D\u4E86\u975E\u4EE3\u7801\u5185\u5BB9\n                this.insertLineCode(selectionText)\n            }\n        }\n    }\n\n    /**\n     * \u521B\u5EFA panel\n     * @param text \u4EE3\u7801\u6587\u672C\n     * @param languageType \u4EE3\u7801\u7C7B\u578B\n     */\n    public createPanel(text: string, languageType: string): void {\n        const conf = createPanelConf(this.editor, text, languageType)\n        const panel = new Panel(this, conf)\n        panel.create()\n    }\n\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355 active \u72B6\u6001\n     */\n    public tryChangeActive() {\n        const editor = this.editor\n        if (isActive(editor)) {\n            this.active()\n        } else {\n            this.unActive()\n        }\n    }\n}\n\nexport default Code\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b7716d74031eebe715927c45c5b953f4585c08dc"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hc8jeuucx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2hc8jeuucx();

var __extends = (cov_2hc8jeuucx().s[0]++, (cov_2hc8jeuucx().b[0][0]++, void 0) && (cov_2hc8jeuucx().b[0][1]++, (void 0).__extends) || (cov_2hc8jeuucx().b[0][2]++, function () {
  cov_2hc8jeuucx().f[0]++;
  cov_2hc8jeuucx().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_2hc8jeuucx().f[1]++;
    cov_2hc8jeuucx().s[2]++;
    _extendStatics = (cov_2hc8jeuucx().b[1][0]++, _setPrototypeOf["default"]) || (cov_2hc8jeuucx().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_2hc8jeuucx().b[1][2]++, function (d, b) {
      cov_2hc8jeuucx().f[2]++;
      cov_2hc8jeuucx().s[3]++;
      d.__proto__ = b;
    }) || (cov_2hc8jeuucx().b[1][3]++, function (d, b) {
      cov_2hc8jeuucx().f[3]++;
      cov_2hc8jeuucx().s[4]++;

      for (var p in b) {
        cov_2hc8jeuucx().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_2hc8jeuucx().b[2][0]++;
          cov_2hc8jeuucx().s[6]++;
          d[p] = b[p];
        } else {
          cov_2hc8jeuucx().b[2][1]++;
        }
      }
    });
    cov_2hc8jeuucx().s[7]++;
    return _extendStatics(d, b);
  };

  cov_2hc8jeuucx().s[8]++;
  return function (d, b) {
    cov_2hc8jeuucx().f[4]++;
    cov_2hc8jeuucx().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_2hc8jeuucx().f[5]++;
      cov_2hc8jeuucx().s[10]++;
      this.constructor = d;
    }

    cov_2hc8jeuucx().s[11]++;
    d.prototype = b === null ? (cov_2hc8jeuucx().b[3][0]++, (0, _create["default"])(b)) : (cov_2hc8jeuucx().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_2hc8jeuucx().s[12]++, (cov_2hc8jeuucx().b[4][0]++, void 0) && (cov_2hc8jeuucx().b[4][1]++, (void 0).__importDefault) || (cov_2hc8jeuucx().b[4][2]++, function (mod) {
  cov_2hc8jeuucx().f[6]++;
  cov_2hc8jeuucx().s[13]++;
  return (cov_2hc8jeuucx().b[6][0]++, mod) && (cov_2hc8jeuucx().b[6][1]++, mod.__esModule) ? (cov_2hc8jeuucx().b[5][0]++, mod) : (cov_2hc8jeuucx().b[5][1]++, {
    "default": mod
  });
}));

cov_2hc8jeuucx().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_2hc8jeuucx().s[15]++;
exports.formatCodeHtml = void 0;
var PanelMenu_1 = (cov_2hc8jeuucx().s[16]++, __importDefault(__webpack_require__(32)));
var dom_core_1 = (cov_2hc8jeuucx().s[17]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_2hc8jeuucx().s[18]++, __webpack_require__(7));
var create_panel_conf_1 = (cov_2hc8jeuucx().s[19]++, __importDefault(__webpack_require__(370)));
var is_active_1 = (cov_2hc8jeuucx().s[20]++, __importDefault(__webpack_require__(126)));
var Panel_1 = (cov_2hc8jeuucx().s[21]++, __importDefault(__webpack_require__(28)));
var index_1 = (cov_2hc8jeuucx().s[22]++, __importDefault(__webpack_require__(371)));

function formatCodeHtml(editor, html) {
  cov_2hc8jeuucx().f[7]++;
  cov_2hc8jeuucx().s[23]++;

  if (!html) {
    cov_2hc8jeuucx().b[7][0]++;
    cov_2hc8jeuucx().s[24]++;
    return html;
  } else {
    cov_2hc8jeuucx().b[7][1]++;
  }

  cov_2hc8jeuucx().s[25]++;
  html = deleteHighlightCode(html);
  cov_2hc8jeuucx().s[26]++;
  html = formatEnterCode(html);
  cov_2hc8jeuucx().s[27]++;
  html = util_1.replaceSpecialSymbol(html);
  cov_2hc8jeuucx().s[28]++;
  return html; // 格式化换换所产生的code标签

  function formatEnterCode(html) {
    cov_2hc8jeuucx().f[8]++;
    var preArr = (cov_2hc8jeuucx().s[29]++, html.match(/<pre[\s|\S]+?\/pre>/g));
    cov_2hc8jeuucx().s[30]++;

    if (preArr === null) {
      cov_2hc8jeuucx().b[8][0]++;
      cov_2hc8jeuucx().s[31]++;
      return html;
    } else {
      cov_2hc8jeuucx().b[8][1]++;
    }

    cov_2hc8jeuucx().s[32]++;
    (0, _map["default"])(preArr).call(preArr, function (item) {
      cov_2hc8jeuucx().f[9]++;
      cov_2hc8jeuucx().s[33]++;
      //将连续的code标签换为\n换行
      html = html.replace(item, item.replace(/<\/code><code>/g, '\n').replace(/<br>/g, ''));
    });
    cov_2hc8jeuucx().s[34]++;
    return html;
  } // highlight格式化方法


  function deleteHighlightCode(html) {
    var _context;

    cov_2hc8jeuucx().f[10]++;
    // 获取所有hljs文本
    var m = (cov_2hc8jeuucx().s[35]++, html.match(/<span\sclass="hljs[\s|\S]+?\/span>/gm)); // 没有代码渲染文本则退出
    // @ts-ignore

    cov_2hc8jeuucx().s[36]++;

    if ((cov_2hc8jeuucx().b[10][0]++, !m) || (cov_2hc8jeuucx().b[10][1]++, !m.length)) {
      cov_2hc8jeuucx().b[9][0]++;
      cov_2hc8jeuucx().s[37]++;
      return html;
    } else {
      cov_2hc8jeuucx().b[9][1]++;
    } // 获取替换文本


    var r = (cov_2hc8jeuucx().s[38]++, (0, _map["default"])(_context = util_1.deepClone(m)).call(_context, function (i) {
      cov_2hc8jeuucx().f[11]++;
      cov_2hc8jeuucx().s[39]++;
      i = i.replace(/<span\sclass="hljs[^>]+>/, '');
      cov_2hc8jeuucx().s[40]++;
      return i.replace(/<\/span>/, '');
    })); // @ts-ignore

    cov_2hc8jeuucx().s[41]++;

    for (var i = (cov_2hc8jeuucx().s[42]++, 0); i < m.length; i++) {
      cov_2hc8jeuucx().s[43]++;
      html = html.replace(m[i], r[i]);
    }

    cov_2hc8jeuucx().s[44]++;
    return deleteHighlightCode(html);
  }
}

cov_2hc8jeuucx().s[45]++;
exports.formatCodeHtml = formatCodeHtml;
var Code = (
/** @class */
cov_2hc8jeuucx().s[46]++, function (_super) {
  cov_2hc8jeuucx().f[12]++;
  cov_2hc8jeuucx().s[47]++;

  __extends(Code, _super);

  function Code(editor) {
    cov_2hc8jeuucx().f[13]++;

    var _this = (cov_2hc8jeuucx().s[48]++, this);

    var $elem = (cov_2hc8jeuucx().s[49]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-terminal"></i></div>'));
    cov_2hc8jeuucx().s[50]++;
    _this = (cov_2hc8jeuucx().b[11][0]++, _super.call(this, $elem, editor)) || (cov_2hc8jeuucx().b[11][1]++, this); // 绑定事件，如点击链接时，可以查看链接

    cov_2hc8jeuucx().s[51]++;
    index_1["default"](editor);
    cov_2hc8jeuucx().s[52]++;
    return _this;
  }
  /**
   * 插入行内代码
   * @param text
   * @return null
   */


  cov_2hc8jeuucx().s[53]++;

  Code.prototype.insertLineCode = function (text) {
    cov_2hc8jeuucx().f[14]++;
    var editor = (cov_2hc8jeuucx().s[54]++, this.editor); // 行内代码处理

    var $code = (cov_2hc8jeuucx().s[55]++, dom_core_1["default"]("<code>" + text + "</code>"));
    cov_2hc8jeuucx().s[56]++;
    editor.cmd["do"]('insertElem', $code);
    cov_2hc8jeuucx().s[57]++;
    editor.selection.createRangeByElem($code, false);
    cov_2hc8jeuucx().s[58]++;
    editor.selection.restoreSelection();
  };
  /**
   * 菜单点击事件
   */


  cov_2hc8jeuucx().s[59]++;

  Code.prototype.clickHandler = function () {
    cov_2hc8jeuucx().f[15]++;
    var editor = (cov_2hc8jeuucx().s[60]++, this.editor);
    var selectionText = (cov_2hc8jeuucx().s[61]++, editor.selection.getSelectionText());
    cov_2hc8jeuucx().s[62]++;

    if (this.isActive) {
      cov_2hc8jeuucx().b[12][0]++;
      cov_2hc8jeuucx().s[63]++;
      return;
    } else {
      cov_2hc8jeuucx().b[12][1]++;
      cov_2hc8jeuucx().s[64]++;

      // 菜单未被激活，说明选区不在链接里
      if (editor.selection.isSelectionEmpty()) {
        cov_2hc8jeuucx().b[13][0]++;
        cov_2hc8jeuucx().s[65]++;
        // 选区是空的，未选中内容
        this.createPanel('', '');
      } else {
        cov_2hc8jeuucx().b[13][1]++;
        cov_2hc8jeuucx().s[66]++;
        // 行内代码处理 选中了非代码内容
        this.insertLineCode(selectionText);
      }
    }
  };
  /**
   * 创建 panel
   * @param text 代码文本
   * @param languageType 代码类型
   */


  cov_2hc8jeuucx().s[67]++;

  Code.prototype.createPanel = function (text, languageType) {
    cov_2hc8jeuucx().f[16]++;
    var conf = (cov_2hc8jeuucx().s[68]++, create_panel_conf_1["default"](this.editor, text, languageType));
    var panel = (cov_2hc8jeuucx().s[69]++, new Panel_1["default"](this, conf));
    cov_2hc8jeuucx().s[70]++;
    panel.create();
  };
  /**
   * 尝试修改菜单 active 状态
   */


  cov_2hc8jeuucx().s[71]++;

  Code.prototype.tryChangeActive = function () {
    cov_2hc8jeuucx().f[17]++;
    var editor = (cov_2hc8jeuucx().s[72]++, this.editor);
    cov_2hc8jeuucx().s[73]++;

    if (is_active_1["default"](editor)) {
      cov_2hc8jeuucx().b[14][0]++;
      cov_2hc8jeuucx().s[74]++;
      this.active();
    } else {
      cov_2hc8jeuucx().b[14][1]++;
      cov_2hc8jeuucx().s[75]++;
      this.unActive();
    }
  };

  cov_2hc8jeuucx().s[76]++;
  return Code;
}(PanelMenu_1["default"]));
cov_2hc8jeuucx().s[77]++;
exports["default"] = Code;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description code 菜单 panel tab 配置
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _map = _interopRequireDefault(__webpack_require__(42));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1lo5bn9dfk() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/code/create-panel-conf.ts";
  var hash = "6d2f366a734ca9386ef9eab351f485868914599f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/code/create-panel-conf.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 18
        },
        end: {
          line: 12,
          column: 57
        }
      },
      "6": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 56
        }
      },
      "7": {
        start: {
          line: 16,
          column: 21
        },
        end: {
          line: 16,
          column: 47
        }
      },
      "8": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 44
        }
      },
      "9": {
        start: {
          line: 25,
          column: 21
        },
        end: {
          line: 25,
          column: 48
        }
      },
      "10": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 28,
          column: 9
        }
      },
      "11": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 29
        }
      },
      "12": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "13": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 60
        }
      },
      "14": {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 31,
          column: 94
        }
      },
      "15": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 65
        }
      },
      "16": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 41,
          column: 19
        }
      },
      "17": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 19
        }
      },
      "18": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 60
        }
      },
      "19": {
        start: {
          line: 45,
          column: 24
        },
        end: {
          line: 45,
          column: 94
        }
      },
      "20": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 47,
          column: 19
        }
      },
      "21": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 19
        }
      },
      "22": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 54
        }
      },
      "23": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 44
        }
      },
      "24": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 34
        }
      },
      "25": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 54,
          column: 5
        }
      },
      "26": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 53,
          column: 38
        }
      },
      "27": {
        start: {
          line: 56,
          column: 15
        },
        end: {
          line: 114,
          column: 5
        }
      },
      "28": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 72,
          column: 37
        }
      },
      "29": {
        start: {
          line: 82,
          column: 40
        },
        end: {
          line: 82,
          column: 78
        }
      },
      "30": {
        start: {
          line: 83,
          column: 42
        },
        end: {
          line: 83,
          column: 78
        }
      },
      "31": {
        start: {
          line: 84,
          column: 47
        },
        end: {
          line: 84,
          column: 60
        }
      },
      "32": {
        start: {
          line: 86,
          column: 39
        },
        end: {
          line: 86,
          column: 50
        }
      },
      "33": {
        start: {
          line: 88,
          column: 28
        },
        end: {
          line: 93,
          column: 29
        }
      },
      "34": {
        start: {
          line: 89,
          column: 32
        },
        end: {
          line: 89,
          column: 88
        }
      },
      "35": {
        start: {
          line: 92,
          column: 32
        },
        end: {
          line: 92,
          column: 71
        }
      },
      "36": {
        start: {
          line: 95,
          column: 28
        },
        end: {
          line: 96,
          column: 39
        }
      },
      "37": {
        start: {
          line: 96,
          column: 32
        },
        end: {
          line: 96,
          column: 39
        }
      },
      "38": {
        start: {
          line: 98,
          column: 28
        },
        end: {
          line: 106,
          column: 29
        }
      },
      "39": {
        start: {
          line: 99,
          column: 32
        },
        end: {
          line: 99,
          column: 45
        }
      },
      "40": {
        start: {
          line: 103,
          column: 32
        },
        end: {
          line: 103,
          column: 117
        }
      },
      "41": {
        start: {
          line: 105,
          column: 32
        },
        end: {
          line: 105,
          column: 52
        }
      },
      "42": {
        start: {
          line: 108,
          column: 28
        },
        end: {
          line: 108,
          column: 40
        }
      },
      "43": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 16
        }
      },
      "44": {
        start: {
          line: 117,
          column: 0
        },
        end: {
          line: 117,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 18
          }
        },
        loc: {
          start: {
            line: 13,
            column: 47
          },
          end: {
            line: 116,
            column: 1
          }
        },
        line: 13
      },
      "2": {
        name: "insertCode",
        decl: {
          start: {
            line: 23,
            column: 13
          },
          end: {
            line: 23,
            column: 23
          }
        },
        loc: {
          start: {
            line: 23,
            column: 30
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 23
      },
      "3": {
        name: "selectCodeElem",
        decl: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 27
          }
        },
        loc: {
          start: {
            line: 39,
            column: 30
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 13
          }
        },
        loc: {
          start: {
            line: 52,
            column: 28
          },
          end: {
            line: 54,
            column: 5
          }
        },
        line: 52
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 65,
            column: 162
          },
          end: {
            line: 65,
            column: 163
          }
        },
        loc: {
          start: {
            line: 65,
            column: 182
          },
          end: {
            line: 73,
            column: 17
          }
        },
        line: 65
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 80,
            column: 28
          },
          end: {
            line: 80,
            column: 29
          }
        },
        loc: {
          start: {
            line: 80,
            column: 40
          },
          end: {
            line: 109,
            column: 25
          }
        },
        line: 80
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }, {
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 28,
            column: 9
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 31,
            column: 61
          },
          end: {
            line: 31,
            column: 67
          }
        }, {
          start: {
            line: 31,
            column: 70
          },
          end: {
            line: 31,
            column: 94
          }
        }],
        line: 31
      },
      "5": {
        loc: {
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 38
          }
        }, {
          start: {
            line: 31,
            column: 42
          },
          end: {
            line: 31,
            column: 58
          }
        }],
        line: 31
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 41,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 41,
            column: 19
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 41,
            column: 19
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 45,
            column: 24
          },
          end: {
            line: 45,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 61
          },
          end: {
            line: 45,
            column: 67
          }
        }, {
          start: {
            line: 45,
            column: 70
          },
          end: {
            line: 45,
            column: 94
          }
        }],
        line: 45
      },
      "8": {
        loc: {
          start: {
            line: 45,
            column: 24
          },
          end: {
            line: 45,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 24
          },
          end: {
            line: 45,
            column: 38
          }
        }, {
          start: {
            line: 45,
            column: 42
          },
          end: {
            line: 45,
            column: 58
          }
        }],
        line: 45
      },
      "9": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 47,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 47,
            column: 19
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 47,
            column: 19
          }
        }],
        line: 46
      },
      "10": {
        loc: {
          start: {
            line: 67,
            column: 25
          },
          end: {
            line: 67,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 52
          },
          end: {
            line: 67,
            column: 62
          }
        }, {
          start: {
            line: 67,
            column: 65
          },
          end: {
            line: 67,
            column: 67
          }
        }],
        line: 67
      },
      "11": {
        loc: {
          start: {
            line: 73,
            column: 397
          },
          end: {
            line: 73,
            column: 444
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 427
          },
          end: {
            line: 73,
            column: 434
          }
        }, {
          start: {
            line: 73,
            column: 437
          },
          end: {
            line: 73,
            column: 444
          }
        }],
        line: 73
      },
      "12": {
        loc: {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 93,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 93,
            column: 29
          }
        }, {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 93,
            column: 29
          }
        }],
        line: 88
      },
      "13": {
        loc: {
          start: {
            line: 95,
            column: 28
          },
          end: {
            line: 96,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 28
          },
          end: {
            line: 96,
            column: 39
          }
        }, {
          start: {
            line: 95,
            column: 28
          },
          end: {
            line: 96,
            column: 39
          }
        }],
        line: 95
      },
      "14": {
        loc: {
          start: {
            line: 98,
            column: 28
          },
          end: {
            line: 106,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 28
          },
          end: {
            line: 106,
            column: 29
          }
        }, {
          start: {
            line: 98,
            column: 28
          },
          end: {
            line: 106,
            column: 29
          }
        }],
        line: 98
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/code/create-panel-conf.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/code/create-panel-conf.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAIH,yCAA4C;AAC5C,kEAAoD;AACpD,0DAAkC;AAElC,mBAAyB,MAAc,EAAE,IAAY,EAAE,YAAoB;IACvE,iBAAiB;IACjB,IAAM,aAAa,GAAG,gBAAS,CAAC,cAAc,CAAC,CAAA;IAC/C,IAAM,UAAU,GAAG,gBAAS,CAAC,QAAQ,CAAC,CAAA;IACtC,IAAM,OAAO,GAAG,gBAAS,CAAC,QAAQ,CAAC,CAAA;IAEnC;;;;OAIG;IACH,SAAS,UAAU,CAAC,IAAY;QAC5B,iCAAiC;QACjC,IAAI,MAAM,GAAG,mBAAQ,CAAC,MAAM,CAAC,CAAA;QAE7B,IAAI,MAAM,EAAE;YACR,cAAc,EAAE,CAAA;SACnB;QAED,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,IAAI,CAAC,CAAA;QAEjC,IAAM,KAAK,GAAG,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAA;QACtD,IAAM,SAAS,GAAG,KAAK,aAAL,KAAK,uBAAL,KAAK,CAAE,UAAU,CAAC,MAAM,CAAC,CAAA;QAE3C,gBAAgB;QAChB,aAAa;QACb,kBAAC,CAAC,aAAa,CAAC,CAAC,WAAW,CAAC,SAAS,CAAC,CAAA;IAC3C,CAAC;IAED;;OAEG;IACH,SAAS,cAAc;QACnB,IAAI,CAAC,mBAAQ,CAAC,MAAM,CAAC;YAAE,OAAM;QAE7B,6DAA6D;QAC7D,IAAI,aAAyB,CAAA;QAE7B,IAAM,KAAK,GAAG,MAAM,CAAC,SAAS,CAAC,qBAAqB,EAAE,CAAA;QACtD,IAAM,SAAS,GAAG,KAAK,aAAL,KAAK,uBAAL,KAAK,CAAE,UAAU,CAAC,MAAM,CAAC,CAAA;QAC3C,IAAI,CAAC,SAAS;YAAE,OAAM;QAEtB,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,SAAS,CAAC,CAAA;QAC7C,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;QAEnC,aAAa,GAAG,SAAS,CAAA,CAAC,aAAa;IAC3C,CAAC;IAED,IAAM,CAAC,GAAG,UAAC,IAAY;QACnB,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,IAAI,CAAC,CAAA;IACjC,CAAC,CAAA;IAED,aAAa;IACb,IAAM,IAAI,GAAG;QACT,KAAK,EAAE,GAAG;QACV,MAAM,EAAE,CAAC;QAET,mBAAmB;QACnB,IAAI,EAAE;YACF;gBACI,UAAU;gBACV,KAAK,EAAE,CAAC,CAAC,4BAA4B,CAAC;gBACtC,KAAK;gBACL,GAAG,EAAE,2DACyB,UAAU,yCAC1B,MAAM,CAAC,MAAM,CAAC,YAAY,CAAC,GAAG,CAAC,UAAA,QAAQ;oBACrC,OAAO,CACH,UAAU;wBACV,CAAC,YAAY,IAAI,QAAQ,CAAC,CAAC,CAAC,UAAU,CAAC,CAAC,CAAC,EAAE,CAAC;wBAC5C,WAAW;wBACX,QAAQ;wBACR,IAAI;wBACJ,QAAQ;wBACR,WAAW,CACd,CAAA;gBACL,CAAC,CAAC,oFAEU,aAAa,+FAAiF,IAAI,CAAC,OAAO,CAC9H,SAAS,EACT,GAAG,CACN,4HAEyB,OAAO,4BAC7B,mBAAQ,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,2EAG7B;gBACX,OAAO;gBACP,MAAM,EAAE;oBACJ,OAAO;oBACP;wBACI,QAAQ,EAAE,GAAG,GAAG,OAAO;wBACvB,IAAI,EAAE,OAAO;wBACb,EAAE,EAAE;4BACA,IAAI,UAAU,EAAE,OAAO,CAAA;4BAEvB,IAAM,KAAK,GAAG,QAAQ,CAAC,cAAc,CAAC,aAAa,CAAC,CAAA;4BACpD,IAAM,OAAO,GAAG,kBAAC,CAAC,GAAG,GAAG,UAAU,CAAC,CAAA;4BAEnC,IAAI,YAAY,GAAG,OAAO,CAAC,GAAG,EAAE,CAAA;4BAChC,aAAa;4BACb,IAAI,IAAI,GAAG,KAAK,CAAC,KAAK,CAAA;4BAEtB,OAAO;4BACP,IAAI,MAAM,CAAC,SAAS,EAAE;gCAClB,UAAU,GAAG,MAAM,CAAC,SAAS,CAAC,aAAa,CAAC,IAAI,CAAC,CAAC,KAAK,CAAA;6BAC1D;iCAAM;gCACH,UAAU,GAAG,UAAQ,IAAI,WAAQ,CAAA;6BACpC;4BAED,YAAY;4BACZ,IAAI,CAAC,IAAI;gCAAE,OAAM;4BAEjB,MAAM;4BACN,IAAI,mBAAQ,CAAC,MAAM,CAAC,EAAE;gCAClB,OAAO,KAAK,CAAA;6BACf;iCAAM;gCACH,SAAS;gCACT,OAAO,GAAG,iBAAc,YAAY,iBAAW,UAAU,kBAAe,CAAA;gCAExE,aAAa;gCACb,UAAU,CAAC,OAAO,CAAC,CAAA;6BACtB;4BAED,6CAA6C;4BAC7C,OAAO,IAAI,CAAA;wBACf,CAAC;qBACJ;iBACJ;aACJ;SACJ;KACJ,CAAA;IAED,OAAO,IAAI,CAAA;AACf,CAAC;AAtID,4BAsIC",
      sourcesContent: ["/**\n * @description code \u83DC\u5355 panel tab \u914D\u7F6E\n * @author lkw\n */\n\nimport Editor from '../../editor/index'\nimport { PanelConf } from '../menu-constructors/Panel'\nimport { getRandom } from '../../utils/util'\nimport $, { DomElement } from '../../utils/dom-core'\nimport isActive from './is-active'\n\nexport default function (editor: Editor, text: string, languageType: string): PanelConf {\n    // panel \u4E2D\u9700\u8981\u7528\u5230\u7684id\n    const inputIFrameId = getRandom('input-iframe')\n    const languageId = getRandom('select')\n    const btnOkId = getRandom('btn-ok')\n\n    /**\n     * \u63D2\u5165\u94FE\u63A5\n     * @param text \u6587\u5B57\n     * @param code \u94FE\u63A5\n     */\n    function insertCode(text: string): void {\n        // \u9009\u533A\u5904\u4E8E\u94FE\u63A5\u4E2D\uFF0C\u5219\u9009\u4E2D\u6574\u4E2A\u83DC\u5355\uFF0C\u518D\u6267\u884C insertHTML\n        let active = isActive(editor)\n\n        if (active) {\n            selectCodeElem()\n        }\n\n        editor.cmd.do('insertHTML', text)\n\n        const $code = editor.selection.getSelectionStartElem()\n        const $codeElem = $code?.getNodeTop(editor)\n\n        // \u901A\u8FC7dom\u64CD\u4F5C\u6DFB\u52A0\u6362\u884C\u6807\u7B7E\n        // @ts-ignore\n        $('<p><br></p>').insertAfter($codeElem)\n    }\n\n    /**\n     * \u9009\u4E2D\u6574\u4E2A\u94FE\u63A5\u5143\u7D20\n     */\n    function selectCodeElem(): void {\n        if (!isActive(editor)) return\n\n        // eslint-disable-next-line @typescript-eslint/no-unused-vars\n        let $selectedCode: DomElement\n\n        const $code = editor.selection.getSelectionStartElem()\n        const $codeElem = $code?.getNodeTop(editor)\n        if (!$codeElem) return\n\n        editor.selection.createRangeByElem($codeElem)\n        editor.selection.restoreSelection()\n\n        $selectedCode = $codeElem // \u8D4B\u503C\u7ED9\u51FD\u6570\u5185\u5168\u5C40\u53D8\u91CF\n    }\n\n    const t = (text: string): string => {\n        return editor.i18next.t(text)\n    }\n\n    // @ts-ignore\n    const conf = {\n        width: 500,\n        height: 0,\n\n        // panel \u4E2D\u53EF\u5305\u542B\u591A\u4E2A tab\n        tabs: [\n            {\n                // tab \u7684\u6807\u9898\n                title: t('menus.panelMenus.code.\u63D2\u5165\u4EE3\u7801'),\n                // \u6A21\u677F\n                tpl: `<div>\n                        <select name=\"\" id=\"${languageId}\">\n                            ${editor.config.languageType.map(language => {\n                                return (\n                                    '<option ' +\n                                    (languageType == language ? 'selected' : '') +\n                                    ' value =\"' +\n                                    language +\n                                    '\">' +\n                                    language +\n                                    '</option>'\n                                )\n                            })}\n                        </select>\n                        <textarea id=\"${inputIFrameId}\" type=\"text\" class=\"wang-code-textarea\" placeholder=\"\" style=\"height: 160px\">${text.replace(\n                    /&quot;/g,\n                    '\"'\n                )}</textarea>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"${btnOkId}\" class=\"right\">${\n                    isActive(editor) ? t('\u4FEE\u6539') : t('\u63D2\u5165')\n                }</button>\n                        </div>\n                    </div>`,\n                // \u4E8B\u4EF6\u7ED1\u5B9A\n                events: [\n                    // \u63D2\u5165\u94FE\u63A5\n                    {\n                        selector: '#' + btnOkId,\n                        type: 'click',\n                        fn: () => {\n                            let formatCode, codeDom\n\n                            const $code = document.getElementById(inputIFrameId)\n                            const $select = $('#' + languageId)\n\n                            let languageType = $select.val()\n                            // @ts-ignore\n                            let code = $code.value\n\n                            // \u9AD8\u4EAE\u6E32\u67D3\n                            if (editor.highlight) {\n                                formatCode = editor.highlight.highlightAuto(code).value\n                            } else {\n                                formatCode = `<xmp>${code}</xmp>`\n                            }\n\n                            // \u4EE3\u7801\u4E3A\u7A7A\uFF0C\u5219\u4E0D\u63D2\u5165\n                            if (!code) return\n\n                            //\u589E\u52A0\u6807\u7B7E\n                            if (isActive(editor)) {\n                                return false\n                            } else {\n                                //\u589E\u52A0pre\u6807\u7B7E\n                                codeDom = `<pre type=\"${languageType}\"><code>${formatCode}</code></pre>`\n\n                                // @ts-ignore\n                                insertCode(codeDom)\n                            }\n\n                            // \u8FD4\u56DE true\uFF0C\u8868\u793A\u8BE5\u4E8B\u4EF6\u6267\u884C\u5B8C\u4E4B\u540E\uFF0Cpanel \u8981\u5173\u95ED\u3002\u5426\u5219 panel \u4E0D\u4F1A\u5173\u95ED\n                            return true\n                        },\n                    },\n                ],\n            }, // tab end\n        ], // tabs end\n    }\n\n    return conf\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6d2f366a734ca9386ef9eab351f485868914599f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lo5bn9dfk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1lo5bn9dfk();

var __importDefault = (cov_1lo5bn9dfk().s[0]++, (cov_1lo5bn9dfk().b[0][0]++, void 0) && (cov_1lo5bn9dfk().b[0][1]++, (void 0).__importDefault) || (cov_1lo5bn9dfk().b[0][2]++, function (mod) {
  cov_1lo5bn9dfk().f[0]++;
  cov_1lo5bn9dfk().s[1]++;
  return (cov_1lo5bn9dfk().b[2][0]++, mod) && (cov_1lo5bn9dfk().b[2][1]++, mod.__esModule) ? (cov_1lo5bn9dfk().b[1][0]++, mod) : (cov_1lo5bn9dfk().b[1][1]++, {
    "default": mod
  });
}));

cov_1lo5bn9dfk().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_1lo5bn9dfk().s[3]++, __webpack_require__(7));
var dom_core_1 = (cov_1lo5bn9dfk().s[4]++, __importDefault(__webpack_require__(2)));
var is_active_1 = (cov_1lo5bn9dfk().s[5]++, __importDefault(__webpack_require__(126)));

function default_1(editor, text, languageType) {
  var _context;

  cov_1lo5bn9dfk().f[1]++;
  // panel 中需要用到的id
  var inputIFrameId = (cov_1lo5bn9dfk().s[6]++, util_1.getRandom('input-iframe'));
  var languageId = (cov_1lo5bn9dfk().s[7]++, util_1.getRandom('select'));
  var btnOkId = (cov_1lo5bn9dfk().s[8]++, util_1.getRandom('btn-ok'));
  /**
   * 插入链接
   * @param text 文字
   * @param code 链接
   */

  function insertCode(text) {
    cov_1lo5bn9dfk().f[2]++;
    // 选区处于链接中，则选中整个菜单，再执行 insertHTML
    var active = (cov_1lo5bn9dfk().s[9]++, is_active_1["default"](editor));
    cov_1lo5bn9dfk().s[10]++;

    if (active) {
      cov_1lo5bn9dfk().b[3][0]++;
      cov_1lo5bn9dfk().s[11]++;
      selectCodeElem();
    } else {
      cov_1lo5bn9dfk().b[3][1]++;
    }

    cov_1lo5bn9dfk().s[12]++;
    editor.cmd["do"]('insertHTML', text);
    var $code = (cov_1lo5bn9dfk().s[13]++, editor.selection.getSelectionStartElem());
    var $codeElem = (cov_1lo5bn9dfk().s[14]++, (cov_1lo5bn9dfk().b[5][0]++, $code === null) || (cov_1lo5bn9dfk().b[5][1]++, $code === void 0) ? (cov_1lo5bn9dfk().b[4][0]++, void 0) : (cov_1lo5bn9dfk().b[4][1]++, $code.getNodeTop(editor))); // 通过dom操作添加换行标签
    // @ts-ignore

    cov_1lo5bn9dfk().s[15]++;
    dom_core_1["default"]('<p><br></p>').insertAfter($codeElem);
  }
  /**
   * 选中整个链接元素
   */


  function selectCodeElem() {
    cov_1lo5bn9dfk().f[3]++;
    cov_1lo5bn9dfk().s[16]++;

    if (!is_active_1["default"](editor)) {
      cov_1lo5bn9dfk().b[6][0]++;
      cov_1lo5bn9dfk().s[17]++;
      return;
    } else {
      cov_1lo5bn9dfk().b[6][1]++;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars


    var $selectedCode;
    var $code = (cov_1lo5bn9dfk().s[18]++, editor.selection.getSelectionStartElem());
    var $codeElem = (cov_1lo5bn9dfk().s[19]++, (cov_1lo5bn9dfk().b[8][0]++, $code === null) || (cov_1lo5bn9dfk().b[8][1]++, $code === void 0) ? (cov_1lo5bn9dfk().b[7][0]++, void 0) : (cov_1lo5bn9dfk().b[7][1]++, $code.getNodeTop(editor)));
    cov_1lo5bn9dfk().s[20]++;

    if (!$codeElem) {
      cov_1lo5bn9dfk().b[9][0]++;
      cov_1lo5bn9dfk().s[21]++;
      return;
    } else {
      cov_1lo5bn9dfk().b[9][1]++;
    }

    cov_1lo5bn9dfk().s[22]++;
    editor.selection.createRangeByElem($codeElem);
    cov_1lo5bn9dfk().s[23]++;
    editor.selection.restoreSelection();
    cov_1lo5bn9dfk().s[24]++;
    $selectedCode = $codeElem; // 赋值给函数内全局变量
  }

  cov_1lo5bn9dfk().s[25]++;

  var t = function t(text) {
    cov_1lo5bn9dfk().f[4]++;
    cov_1lo5bn9dfk().s[26]++;
    return editor.i18next.t(text);
  }; // @ts-ignore


  var conf = (cov_1lo5bn9dfk().s[27]++, {
    width: 500,
    height: 0,
    // panel 中可包含多个 tab
    tabs: [{
      // tab 的标题
      title: t('menus.panelMenus.code.插入代码'),
      // 模板
      tpl: "<div>\n                        <select name=\"\" id=\"" + languageId + "\">\n                            " + (0, _map["default"])(_context = editor.config.languageType).call(_context, function (language) {
        cov_1lo5bn9dfk().f[5]++;
        cov_1lo5bn9dfk().s[28]++;
        return '<option ' + (languageType == language ? (cov_1lo5bn9dfk().b[10][0]++, 'selected') : (cov_1lo5bn9dfk().b[10][1]++, '')) + ' value ="' + language + '">' + language + '</option>';
      }) + "\n                        </select>\n                        <textarea id=\"" + inputIFrameId + "\" type=\"text\" class=\"wang-code-textarea\" placeholder=\"\" style=\"height: 160px\">" + text.replace(/&quot;/g, '"') + "</textarea>\n                        <div class=\"w-e-button-container\">\n                            <button id=\"" + btnOkId + "\" class=\"right\">" + (is_active_1["default"](editor) ? (cov_1lo5bn9dfk().b[11][0]++, t('修改')) : (cov_1lo5bn9dfk().b[11][1]++, t('插入'))) + "</button>\n                        </div>\n                    </div>",
      // 事件绑定
      events: [// 插入链接
      {
        selector: '#' + btnOkId,
        type: 'click',
        fn: function fn() {
          cov_1lo5bn9dfk().f[6]++;
          var formatCode, codeDom;
          var $code = (cov_1lo5bn9dfk().s[29]++, document.getElementById(inputIFrameId));
          var $select = (cov_1lo5bn9dfk().s[30]++, dom_core_1["default"]('#' + languageId));
          var languageType = (cov_1lo5bn9dfk().s[31]++, $select.val()); // @ts-ignore

          var code = (cov_1lo5bn9dfk().s[32]++, $code.value); // 高亮渲染

          cov_1lo5bn9dfk().s[33]++;

          if (editor.highlight) {
            cov_1lo5bn9dfk().b[12][0]++;
            cov_1lo5bn9dfk().s[34]++;
            formatCode = editor.highlight.highlightAuto(code).value;
          } else {
            cov_1lo5bn9dfk().b[12][1]++;
            cov_1lo5bn9dfk().s[35]++;
            formatCode = "<xmp>" + code + "</xmp>";
          } // 代码为空，则不插入


          cov_1lo5bn9dfk().s[36]++;

          if (!code) {
            cov_1lo5bn9dfk().b[13][0]++;
            cov_1lo5bn9dfk().s[37]++;
            return;
          } else {
            cov_1lo5bn9dfk().b[13][1]++;
          } //增加标签


          cov_1lo5bn9dfk().s[38]++;

          if (is_active_1["default"](editor)) {
            cov_1lo5bn9dfk().b[14][0]++;
            cov_1lo5bn9dfk().s[39]++;
            return false;
          } else {
            cov_1lo5bn9dfk().b[14][1]++;
            cov_1lo5bn9dfk().s[40]++;
            //增加pre标签
            codeDom = "<pre type=\"" + languageType + "\"><code>" + formatCode + "</code></pre>"; // @ts-ignore

            cov_1lo5bn9dfk().s[41]++;
            insertCode(codeDom);
          } // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭


          cov_1lo5bn9dfk().s[42]++;
          return true;
        }
      }]
    }]
  });
  cov_1lo5bn9dfk().s[43]++;
  return conf;
}

cov_1lo5bn9dfk().s[44]++;
exports["default"] = default_1;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 绑定链接元素的事件，入口
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2jp5dv5nj5() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/index.ts";
  var hash = "128f8f6ac710e73c1356ef022c1bb297b413446e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 22
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "5": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 18
          }
        },
        loc: {
          start: {
            line: 15,
            column: 27
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAA8C;AAE9C;;;GAGG;AACH,SAAS,SAAS,CAAC,MAAc;IAC7B,aAAa;IACb,uBAAgB,CAAC,MAAM,CAAC,CAAA;AAC5B,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u94FE\u63A5\u5143\u7D20\u7684\u4E8B\u4EF6\uFF0C\u5165\u53E3\n * @author lkw\n */\n\nimport Editor from '../../../editor/index'\nimport bindTooltipEvent from './tooltip-event'\n\n/**\n * \u7ED1\u5B9A\u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindEvent(editor: Editor) {\n    // tooltip \u4E8B\u4EF6\n    bindTooltipEvent(editor)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "128f8f6ac710e73c1356ef022c1bb297b413446e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2jp5dv5nj5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2jp5dv5nj5();

var __importDefault = (cov_2jp5dv5nj5().s[0]++, (cov_2jp5dv5nj5().b[0][0]++, void 0) && (cov_2jp5dv5nj5().b[0][1]++, (void 0).__importDefault) || (cov_2jp5dv5nj5().b[0][2]++, function (mod) {
  cov_2jp5dv5nj5().f[0]++;
  cov_2jp5dv5nj5().s[1]++;
  return (cov_2jp5dv5nj5().b[2][0]++, mod) && (cov_2jp5dv5nj5().b[2][1]++, mod.__esModule) ? (cov_2jp5dv5nj5().b[1][0]++, mod) : (cov_2jp5dv5nj5().b[1][1]++, {
    "default": mod
  });
}));

cov_2jp5dv5nj5().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var tooltip_event_1 = (cov_2jp5dv5nj5().s[3]++, __importDefault(__webpack_require__(372)));
/**
 * 绑定事件
 * @param editor 编辑器实例
 */

function bindEvent(editor) {
  cov_2jp5dv5nj5().f[1]++;
  cov_2jp5dv5nj5().s[4]++;
  // tooltip 事件
  tooltip_event_1["default"](editor);
}

cov_2jp5dv5nj5().s[5]++;
exports["default"] = bindEvent;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description tooltip 事件
 * @author lkw
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1kd0trhgci() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/tooltip-event.ts";
  var hash = "595aca7776afdc1e86f1fff7cdd5143181fff57a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/tooltip-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 75
        }
      },
      "5": {
        start: {
          line: 22,
          column: 25
        },
        end: {
          line: 22,
          column: 49
        }
      },
      "6": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 26,
          column: 9
        }
      },
      "7": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 59
        }
      },
      "8": {
        start: {
          line: 24,
          column: 37
        },
        end: {
          line: 24,
          column: 57
        }
      },
      "9": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 51
        }
      },
      "10": {
        start: {
          line: 27,
          column: 19
        },
        end: {
          line: 37,
          column: 9
        }
      },
      "11": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 35
        }
      },
      "12": {
        start: {
          line: 34,
          column: 20
        },
        end: {
          line: 34,
          column: 32
        }
      },
      "13": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 61
        }
      },
      "14": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 25
        }
      },
      "15": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "16": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 29
        }
      },
      "17": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 27
        }
      },
      "18": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 55,
          column: 6
        }
      },
      "19": {
        start: {
          line: 67,
          column: 25
        },
        end: {
          line: 67,
          column: 69
        }
      },
      "20": {
        start: {
          line: 69,
          column: 19
        },
        end: {
          line: 69,
          column: 116
        }
      },
      "21": {
        start: {
          line: 71,
          column: 22
        },
        end: {
          line: 71,
          column: 96
        }
      },
      "22": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 74,
          column: 15
        }
      },
      "23": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 15
        }
      },
      "24": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 23
        }
      },
      "25": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 40
        }
      },
      "26": {
        start: {
          line: 85,
          column: 13
        },
        end: {
          line: 85,
          column: 37
        }
      },
      "27": {
        start: {
          line: 85,
          column: 57
        },
        end: {
          line: 85,
          column: 75
        }
      },
      "28": {
        start: {
          line: 85,
          column: 95
        },
        end: {
          line: 85,
          column: 113
        }
      },
      "29": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 64
        }
      },
      "30": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 60
        }
      },
      "31": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 67
        }
      },
      "32": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 64
        }
      },
      "33": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 65
        }
      },
      "34": {
        start: {
          line: 94,
          column: 0
        },
        end: {
          line: 94,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 25
          }
        },
        loc: {
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "showCodeTooltip",
        decl: {
          start: {
            line: 21,
            column: 13
          },
          end: {
            line: 21,
            column: 28
          }
        },
        loc: {
          start: {
            line: 21,
            column: 36
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 23,
            column: 17
          }
        },
        loc: {
          start: {
            line: 23,
            column: 40
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 23
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 30,
            column: 25
          },
          end: {
            line: 30,
            column: 26
          }
        },
        loc: {
          start: {
            line: 30,
            column: 50
          },
          end: {
            line: 35,
            column: 17
          }
        },
        line: 30
      },
      "5": {
        name: "hideCodeTooltip",
        decl: {
          start: {
            line: 45,
            column: 13
          },
          end: {
            line: 45,
            column: 28
          }
        },
        loc: {
          start: {
            line: 45,
            column: 31
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 45
      },
      "6": {
        name: "preEnterListener",
        decl: {
          start: {
            line: 65,
            column: 9
          },
          end: {
            line: 65,
            column: 25
          }
        },
        loc: {
          start: {
            line: 65,
            column: 37
          },
          end: {
            line: 79,
            column: 1
          }
        },
        line: 65
      },
      "7": {
        name: "bindTooltipEvent",
        decl: {
          start: {
            line: 84,
            column: 9
          },
          end: {
            line: 84,
            column: 25
          }
        },
        loc: {
          start: {
            line: 84,
            column: 34
          },
          end: {
            line: 93,
            column: 1
          }
        },
        line: 84
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 24,
            column: 12
          },
          end: {
            line: 24,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 12
          },
          end: {
            line: 24,
            column: 59
          }
        }, {
          start: {
            line: 24,
            column: 12
          },
          end: {
            line: 24,
            column: 59
          }
        }],
        line: 24
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 116
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 74
          },
          end: {
            line: 69,
            column: 80
          }
        }, {
          start: {
            line: 69,
            column: 83
          },
          end: {
            line: 69,
            column: 116
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 42
          }
        }, {
          start: {
            line: 69,
            column: 46
          },
          end: {
            line: 69,
            column: 71
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 71,
            column: 22
          },
          end: {
            line: 71,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 71,
            column: 65
          },
          end: {
            line: 71,
            column: 71
          }
        }, {
          start: {
            line: 71,
            column: 74
          },
          end: {
            line: 71,
            column: 96
          }
        }],
        line: 71
      },
      "8": {
        loc: {
          start: {
            line: 71,
            column: 22
          },
          end: {
            line: 71,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 22
          },
          end: {
            line: 71,
            column: 39
          }
        }, {
          start: {
            line: 71,
            column: 43
          },
          end: {
            line: 71,
            column: 62
          }
        }],
        line: 71
      },
      "9": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 74,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 74,
            column: 15
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 74,
            column: 15
          }
        }],
        line: 73
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/tooltip-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/code/bind-event/tooltip-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,qEAAuD;AACvD,4EAAqD;AAGrD;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAI,OAAuB,CAAA;IAE3B;;;OAGG;IACH,SAAS,eAAe,CAAC,KAAiB;QACtC,IAAM,UAAU,GAAG,wBAAwB,CAAA;QAC3C,IAAM,CAAC,GAAG,UAAC,IAAY,EAAE,MAA2B;YAA3B,uBAAA,EAAA,mBAA2B;YAChD,OAAO,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,MAAM,GAAG,IAAI,CAAC,CAAA;QAC1C,CAAC,CAAA;QAED,IAAM,IAAI,GAAG;YACT;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,CAAC,CAAC,MAAM,CAAC,YAAS,CAAC;gBACrC,OAAO,EAAE,UAAC,MAAc,EAAE,KAAiB;oBACvC,SAAS;oBACT,KAAK,CAAC,MAAM,EAAE,CAAA;oBAEd,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;SACJ,CAAA;QAED,aAAa;QACb,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,EAAE,KAAK,EAAE,IAAI,CAAC,CAAA;QAC1C,OAAO,CAAC,MAAM,EAAE,CAAA;IACpB,CAAC;IAED;;OAEG;IACH,SAAS,eAAe;QACpB,aAAa;QACb,IAAI,OAAO,EAAE;YACT,OAAO,CAAC,MAAM,EAAE,CAAA;YAChB,OAAO,GAAG,IAAI,CAAA;SACjB;IACL,CAAC;IAED,OAAO;QACH,eAAe,iBAAA;QACf,eAAe,iBAAA;KAClB,CAAA;AACL,CAAC;AAED;;;;;;GAMG;AACH,6DAA6D;AAC7D,SAAS,gBAAgB,CAAC,CAAgB,EAAE,MAAc;IACtD,WAAW;IACX,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAgB,CAAA;IAEjF,gBAAgB;IAChB,IAAM,QAAQ,GAAG,cAAc,aAAd,cAAc,uBAAd,cAAc,CAAE,UAAU,CAAC,MAAM,CAAC,CAAA;IAEnD,YAAY;IACZ,IAAM,WAAW,GAAG,QAAQ,aAAR,QAAQ,uBAAR,QAAQ,CAAE,WAAW,EAAE,CAAA;IAE3C,WAAW;IACX,IAAI,WAAW,KAAK,KAAK;QAAE,OAAM;IAEjC,SAAS;IACT,CAAC,CAAC,cAAc,EAAE,CAAA;IAElB,OAAO;IACP,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,MAAM,CAAC,CAAA;AACvC,CAAC;AAED;;;GAGG;AACH,SAAwB,gBAAgB,CAAC,MAAc;IAC7C,IAAA,KAAuC,gBAAgB,CAAC,MAAM,CAAC,EAA7D,eAAe,qBAAA,EAAE,eAAe,qBAA6B,CAAA;IAErE,qBAAqB;IACrB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAE3D,0BAA0B;IAC1B,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IACvD,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAC9D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;IAC3D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,eAAe,CAAC,CAAA;AAChE,CAAC;AAXD,mCAWC",
      sourcesContent: ["/**\n * @description tooltip \u4E8B\u4EF6\n * @author lkw\n */\n\nimport $, { DomElement } from '../../../utils/dom-core'\nimport Tooltip from '../../menu-constructors/Tooltip'\nimport Editor from '../../../editor/index'\n\n/**\n * \u751F\u6210 Tooltip \u7684\u663E\u793A\u9690\u85CF\u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    let tooltip: Tooltip | null\n\n    /**\n     * \u663E\u793A tooltip\n     * @param $code \u94FE\u63A5\u5143\u7D20\n     */\n    function showCodeTooltip($code: DomElement) {\n        const i18nPrefix = 'menus.panelMenus.code.'\n        const t = (text: string, prefix: string = i18nPrefix): string => {\n            return editor.i18next.t(prefix + text)\n        }\n\n        const conf = [\n            {\n                $elem: $(`<span>${t('\u5220\u9664\u4EE3\u7801')}</span>`),\n                onClick: (editor: Editor, $code: DomElement) => {\n                    //dom\u64CD\u4F5C\u5220\u9664\n                    $code.remove()\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n        ]\n\n        // \u521B\u5EFA tooltip\n        tooltip = new Tooltip(editor, $code, conf)\n        tooltip.create()\n    }\n\n    /**\n     * \u9690\u85CF tooltip\n     */\n    function hideCodeTooltip() {\n        // \u79FB\u9664 tooltip\n        if (tooltip) {\n            tooltip.remove()\n            tooltip = null\n        }\n    }\n\n    return {\n        showCodeTooltip,\n        hideCodeTooltip,\n    }\n}\n\n/**\n * preEnterListener\u662F\u4E3A\u4E86\u7EDF\u4E00\u6D4F\u89C8\u5668 \u5728pre\u6807\u7B7E\u5185\u7684enter\u884C\u4E3A\u800C\u8FDB\u884C\u7684\u76D1\u542C\n * \u76EE\u524D\u5E76\u6CA1\u6709\u4F7F\u7528, \u4F46\u662F\u5728\u672A\u6765\u5904\u7406\u4E0EFirefox\u548Cie\u7684\u517C\u5BB9\u6027\u65F6\u9700\u8981\u7528\u5230 \u6682\u4E14\u653E\u7F6E\n * pre\u6807\u7B7E\u5185\u7684\u56DE\u8F66\u76D1\u542C\n * @param e\n * @param editor\n */\n// eslint-disable-next-line @typescript-eslint/no-unused-vars\nfunction preEnterListener(e: KeyboardEvent, editor: Editor) {\n    // \u83B7\u53D6\u5F53\u524D\u6807\u7B7E\u5143\u7D20\n    const $selectionElem = editor.selection.getSelectionContainerElem() as DomElement\n\n    // \u83B7\u53D6\u5F53\u524D\u8282\u70B9\u6700\u9876\u7EA7\u6807\u7B7E\u5143\u7D20\n    const $topElem = $selectionElem?.getNodeTop(editor)\n\n    // \u83B7\u53D6\u9876\u7EA7\u8282\u70B9\u8282\u70B9\u540D\n    const topNodeName = $topElem?.getNodeName()\n\n    // \u975Epre\u6807\u7B7E\u9000\u51FA\n    if (topNodeName !== 'PRE') return\n\n    // \u53D6\u6D88\u9ED8\u8BA4\u884C\u4E3A\n    e.preventDefault()\n\n    // \u6267\u884C\u6362\u884C\n    editor.cmd.do('insertHTML', '\\n\\r')\n}\n\n/**\n * \u7ED1\u5B9A tooltip \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport default function bindTooltipEvent(editor: Editor) {\n    const { showCodeTooltip, hideCodeTooltip } = createShowHideFn(editor)\n\n    // \u70B9\u51FB\u4EE3\u7801\u5143\u7D20\u65F6\uFF0C\u663E\u793A tooltip\n    editor.txt.eventHooks.codeClickEvents.push(showCodeTooltip)\n\n    // \u70B9\u51FB\u5176\u4ED6\u5730\u65B9\uFF0C\u6216\u8005\u6EDA\u52A8\u65F6\uFF0C\u9690\u85CF tooltip\n    editor.txt.eventHooks.clickEvents.push(hideCodeTooltip)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideCodeTooltip)\n    editor.txt.eventHooks.menuClickEvents.push(hideCodeTooltip)\n    editor.txt.eventHooks.textScrollEvents.push(hideCodeTooltip)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "595aca7776afdc1e86f1fff7cdd5143181fff57a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kd0trhgci = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1kd0trhgci();

var __importDefault = (cov_1kd0trhgci().s[0]++, (cov_1kd0trhgci().b[0][0]++, void 0) && (cov_1kd0trhgci().b[0][1]++, (void 0).__importDefault) || (cov_1kd0trhgci().b[0][2]++, function (mod) {
  cov_1kd0trhgci().f[0]++;
  cov_1kd0trhgci().s[1]++;
  return (cov_1kd0trhgci().b[2][0]++, mod) && (cov_1kd0trhgci().b[2][1]++, mod.__esModule) ? (cov_1kd0trhgci().b[1][0]++, mod) : (cov_1kd0trhgci().b[1][1]++, {
    "default": mod
  });
}));

cov_1kd0trhgci().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1kd0trhgci().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip_1 = (cov_1kd0trhgci().s[4]++, __importDefault(__webpack_require__(43)));
/**
 * 生成 Tooltip 的显示隐藏函数
 */

function createShowHideFn(editor) {
  cov_1kd0trhgci().f[1]++;
  var tooltip;
  /**
   * 显示 tooltip
   * @param $code 链接元素
   */

  function showCodeTooltip($code) {
    cov_1kd0trhgci().f[2]++;
    var i18nPrefix = (cov_1kd0trhgci().s[5]++, 'menus.panelMenus.code.');
    cov_1kd0trhgci().s[6]++;

    var t = function t(text, prefix) {
      cov_1kd0trhgci().f[3]++;
      cov_1kd0trhgci().s[7]++;

      if (prefix === void 0) {
        cov_1kd0trhgci().b[3][0]++;
        cov_1kd0trhgci().s[8]++;
        prefix = i18nPrefix;
      } else {
        cov_1kd0trhgci().b[3][1]++;
      }

      cov_1kd0trhgci().s[9]++;
      return editor.i18next.t(prefix + text);
    };

    var conf = (cov_1kd0trhgci().s[10]++, [{
      $elem: dom_core_1["default"]("<span>" + t('删除代码') + "</span>"),
      onClick: function onClick(editor, $code) {
        cov_1kd0trhgci().f[4]++;
        cov_1kd0trhgci().s[11]++;
        //dom操作删除
        $code.remove(); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_1kd0trhgci().s[12]++;
        return true;
      }
    }]); // 创建 tooltip

    cov_1kd0trhgci().s[13]++;
    tooltip = new Tooltip_1["default"](editor, $code, conf);
    cov_1kd0trhgci().s[14]++;
    tooltip.create();
  }
  /**
   * 隐藏 tooltip
   */


  function hideCodeTooltip() {
    cov_1kd0trhgci().f[5]++;
    cov_1kd0trhgci().s[15]++;

    // 移除 tooltip
    if (tooltip) {
      cov_1kd0trhgci().b[4][0]++;
      cov_1kd0trhgci().s[16]++;
      tooltip.remove();
      cov_1kd0trhgci().s[17]++;
      tooltip = null;
    } else {
      cov_1kd0trhgci().b[4][1]++;
    }
  }

  cov_1kd0trhgci().s[18]++;
  return {
    showCodeTooltip: showCodeTooltip,
    hideCodeTooltip: hideCodeTooltip
  };
}
/**
 * preEnterListener是为了统一浏览器 在pre标签内的enter行为而进行的监听
 * 目前并没有使用, 但是在未来处理与Firefox和ie的兼容性时需要用到 暂且放置
 * pre标签内的回车监听
 * @param e
 * @param editor
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars


function preEnterListener(e, editor) {
  cov_1kd0trhgci().f[6]++;
  // 获取当前标签元素
  var $selectionElem = (cov_1kd0trhgci().s[19]++, editor.selection.getSelectionContainerElem()); // 获取当前节点最顶级标签元素

  var $topElem = (cov_1kd0trhgci().s[20]++, (cov_1kd0trhgci().b[6][0]++, $selectionElem === null) || (cov_1kd0trhgci().b[6][1]++, $selectionElem === void 0) ? (cov_1kd0trhgci().b[5][0]++, void 0) : (cov_1kd0trhgci().b[5][1]++, $selectionElem.getNodeTop(editor))); // 获取顶级节点节点名

  var topNodeName = (cov_1kd0trhgci().s[21]++, (cov_1kd0trhgci().b[8][0]++, $topElem === null) || (cov_1kd0trhgci().b[8][1]++, $topElem === void 0) ? (cov_1kd0trhgci().b[7][0]++, void 0) : (cov_1kd0trhgci().b[7][1]++, $topElem.getNodeName())); // 非pre标签退出

  cov_1kd0trhgci().s[22]++;

  if (topNodeName !== 'PRE') {
    cov_1kd0trhgci().b[9][0]++;
    cov_1kd0trhgci().s[23]++;
    return;
  } else {
    cov_1kd0trhgci().b[9][1]++;
  } // 取消默认行为


  cov_1kd0trhgci().s[24]++;
  e.preventDefault(); // 执行换行

  cov_1kd0trhgci().s[25]++;
  editor.cmd["do"]('insertHTML', '\n\r');
}
/**
 * 绑定 tooltip 事件
 * @param editor 编辑器实例
 */


function bindTooltipEvent(editor) {
  cov_1kd0trhgci().f[7]++;

  var _a = (cov_1kd0trhgci().s[26]++, createShowHideFn(editor)),
      showCodeTooltip = (cov_1kd0trhgci().s[27]++, _a.showCodeTooltip),
      hideCodeTooltip = (cov_1kd0trhgci().s[28]++, _a.hideCodeTooltip); // 点击代码元素时，显示 tooltip


  cov_1kd0trhgci().s[29]++;
  editor.txt.eventHooks.codeClickEvents.push(showCodeTooltip); // 点击其他地方，或者滚动时，隐藏 tooltip

  cov_1kd0trhgci().s[30]++;
  editor.txt.eventHooks.clickEvents.push(hideCodeTooltip);
  cov_1kd0trhgci().s[31]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideCodeTooltip);
  cov_1kd0trhgci().s[32]++;
  editor.txt.eventHooks.menuClickEvents.push(hideCodeTooltip);
  cov_1kd0trhgci().s[33]++;
  editor.txt.eventHooks.textScrollEvents.push(hideCodeTooltip);
}

cov_1kd0trhgci().s[34]++;
exports["default"] = bindTooltipEvent;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_5zurvrnwg() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/index.ts";
  var hash = "d87fc18bd8c43ab664166093816569b4d82cac5a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 16
        },
        end: {
          line: 14,
          column: 4
        }
      },
      "1": {
        start: {
          line: 3,
          column: 24
        },
        end: {
          line: 8,
          column: 5
        }
      },
      "2": {
        start: {
          line: 4,
          column: 8
        },
        end: {
          line: 6,
          column: 110
        }
      },
      "3": {
        start: {
          line: 5,
          column: 69
        },
        end: {
          line: 5,
          column: 85
        }
      },
      "4": {
        start: {
          line: 6,
          column: 30
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "5": {
        start: {
          line: 6,
          column: 47
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "6": {
        start: {
          line: 6,
          column: 95
        },
        end: {
          line: 6,
          column: 107
        }
      },
      "7": {
        start: {
          line: 7,
          column: 8
        },
        end: {
          line: 7,
          column: 35
        }
      },
      "8": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 13,
          column: 6
        }
      },
      "9": {
        start: {
          line: 10,
          column: 8
        },
        end: {
          line: 10,
          column: 28
        }
      },
      "10": {
        start: {
          line: 11,
          column: 24
        },
        end: {
          line: 11,
          column: 45
        }
      },
      "11": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 93
        }
      },
      "12": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "13": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 62
        }
      },
      "14": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 16
        },
        end: {
          line: 23,
          column: 72
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 65
        }
      },
      "17": {
        start: {
          line: 25,
          column: 14
        },
        end: {
          line: 25,
          column: 60
        }
      },
      "18": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 76,
          column: 20
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "21": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 105
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 57
        }
      },
      "23": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 32
        }
      },
      "24": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 21
        }
      },
      "25": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "26": {
        start: {
          line: 40,
          column: 21
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "27": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 47
        }
      },
      "28": {
        start: {
          line: 42,
          column: 29
        },
        end: {
          line: 42,
          column: 73
        }
      },
      "29": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 44,
          column: 19
        }
      },
      "30": {
        start: {
          line: 44,
          column: 12
        },
        end: {
          line: 44,
          column: 19
        }
      },
      "31": {
        start: {
          line: 45,
          column: 26
        },
        end: {
          line: 45,
          column: 69
        }
      },
      "32": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 46,
          column: 81
        }
      },
      "33": {
        start: {
          line: 47,
          column: 22
        },
        end: {
          line: 47,
          column: 44
        }
      },
      "34": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "35": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "36": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 53,
          column: 19
        }
      },
      "37": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 53,
          column: 19
        }
      },
      "38": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 61,
          column: 9
        }
      },
      "39": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "40": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 31
        }
      },
      "41": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "42": {
        start: {
          line: 68,
          column: 27
        },
        end: {
          line: 68,
          column: 34
        }
      },
      "43": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 55
        }
      },
      "44": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 58
        }
      },
      "45": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 21
        }
      },
      "46": {
        start: {
          line: 77,
          column: 0
        },
        end: {
          line: 77,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 45
          },
          end: {
            line: 2,
            column: 46
          }
        },
        loc: {
          start: {
            line: 2,
            column: 57
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 25
          }
        },
        loc: {
          start: {
            line: 3,
            column: 40
          },
          end: {
            line: 8,
            column: 5
          }
        },
        line: 3
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 5,
            column: 51
          },
          end: {
            line: 5,
            column: 52
          }
        },
        loc: {
          start: {
            line: 5,
            column: 67
          },
          end: {
            line: 5,
            column: 87
          }
        },
        line: 5
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 13
          }
        },
        loc: {
          start: {
            line: 6,
            column: 28
          },
          end: {
            line: 6,
            column: 109
          }
        },
        line: 6
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 9,
            column: 11
          },
          end: {
            line: 9,
            column: 12
          }
        },
        loc: {
          start: {
            line: 9,
            column: 27
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 9
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 11,
            column: 17
          },
          end: {
            line: 11,
            column: 19
          }
        },
        loc: {
          start: {
            line: 11,
            column: 22
          },
          end: {
            line: 11,
            column: 47
          }
        },
        line: 11
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 15,
            column: 56
          },
          end: {
            line: 15,
            column: 57
          }
        },
        loc: {
          start: {
            line: 15,
            column: 71
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 15
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "splitLine",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 39,
            column: 39
          },
          end: {
            line: 39,
            column: 40
          }
        },
        loc: {
          start: {
            line: 39,
            column: 51
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 39
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 67,
            column: 42
          },
          end: {
            line: 67,
            column: 43
          }
        },
        loc: {
          start: {
            line: 67,
            column: 54
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 67
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 74,
            column: 42
          },
          end: {
            line: 74,
            column: 43
          }
        },
        loc: {
          start: {
            line: 74,
            column: 54
          },
          end: {
            line: 74,
            column: 57
          }
        },
        line: 74
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 16
          },
          end: {
            line: 14,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 17
          },
          end: {
            line: 2,
            column: 21
          }
        }, {
          start: {
            line: 2,
            column: 25
          },
          end: {
            line: 2,
            column: 39
          }
        }, {
          start: {
            line: 2,
            column: 44
          },
          end: {
            line: 14,
            column: 4
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 6,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 24
          },
          end: {
            line: 4,
            column: 45
          }
        }, {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 5,
            column: 47
          }
        }, {
          start: {
            line: 5,
            column: 51
          },
          end: {
            line: 5,
            column: 87
          }
        }, {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 6,
            column: 109
          }
        }],
        line: 4
      },
      "2": {
        loc: {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        }, {
          start: {
            line: 6,
            column: 47
          },
          end: {
            line: 6,
            column: 107
          }
        }],
        line: 6
      },
      "3": {
        loc: {
          start: {
            line: 12,
            column: 22
          },
          end: {
            line: 12,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 35
          },
          end: {
            line: 12,
            column: 51
          }
        }, {
          start: {
            line: 12,
            column: 55
          },
          end: {
            line: 12,
            column: 91
          }
        }],
        line: 12
      },
      "4": {
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 17,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 23
          },
          end: {
            line: 15,
            column: 27
          }
        }, {
          start: {
            line: 15,
            column: 31
          },
          end: {
            line: 15,
            column: 51
          }
        }, {
          start: {
            line: 15,
            column: 56
          },
          end: {
            line: 17,
            column: 1
          }
        }],
        line: 15
      },
      "5": {
        loc: {
          start: {
            line: 16,
            column: 11
          },
          end: {
            line: 16,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 37
          },
          end: {
            line: 16,
            column: 40
          }
        }, {
          start: {
            line: 16,
            column: 43
          },
          end: {
            line: 16,
            column: 61
          }
        }],
        line: 16
      },
      "6": {
        loc: {
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 15
          }
        }, {
          start: {
            line: 16,
            column: 19
          },
          end: {
            line: 16,
            column: 33
          }
        }],
        line: 16
      },
      "7": {
        loc: {
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 48
          }
        }, {
          start: {
            line: 31,
            column: 52
          },
          end: {
            line: 31,
            column: 56
          }
        }],
        line: 31
      },
      "8": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 19
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 44,
            column: 19
          }
        }],
        line: 43
      },
      "9": {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        }, {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 50,
            column: 19
          }
        }],
        line: 49
      },
      "10": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }],
        line: 52
      },
      "11": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 52,
            column: 21
          }
        }, {
          start: {
            line: 52,
            column: 25
          },
          end: {
            line: 52,
            column: 89
          }
        }],
        line: 52
      },
      "12": {
        loc: {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 61,
            column: 9
          }
        }],
        line: 55
      },
      "13": {
        loc: {
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 58,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 12
          },
          end: {
            line: 55,
            column: 19
          }
        }, {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 56,
            column: 32
          }
        }, {
          start: {
            line: 57,
            column: 12
          },
          end: {
            line: 57,
            column: 72
          }
        }, {
          start: {
            line: 58,
            column: 12
          },
          end: {
            line: 58,
            column: 76
          }
        }],
        line: 55
      },
      "14": {
        loc: {
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 58,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 51
          },
          end: {
            line: 58,
            column: 57
          }
        }, {
          start: {
            line: 58,
            column: 60
          },
          end: {
            line: 58,
            column: 75
          }
        }],
        line: 58
      },
      "15": {
        loc: {
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 58,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 58,
            column: 28
          }
        }, {
          start: {
            line: 58,
            column: 32
          },
          end: {
            line: 58,
            column: 48
          }
        }],
        line: 58
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/split-line/index.ts"],
      names: [],
      mappings: ";;;;;;;;;;;;;;;;;;AAAA;;;GAGG;AACH,yEAAkD;AAClD,kEAAoC;AAGpC,6DAA0C;AAC1C;IAAwB,6BAAO;IAC3B,mBAAY,MAAc;QAA1B,iBAKC;QAJG,IAAM,KAAK,GAAG,kBAAC,CAAC,iEAAiE,CAAC,CAAA;QAClF,QAAA,kBAAM,KAAK,EAAE,MAAM,CAAC,SAAA;QACpB,OAAO;QACP,eAAS,CAAC,MAAM,CAAC,CAAA;;IACrB,CAAC;IACD;;OAEG;IACI,gCAAY,GAAnB;QACI,IAAM,MAAM,GAAG,IAAI,CAAC,MAAM,CAAA;QAC1B,IAAM,KAAK,GAAG,MAAM,CAAC,SAAS,CAAC,QAAQ,EAAE,CAAA;QAEzC,IAAM,cAAc,GAAG,MAAM,CAAC,SAAS,CAAC,yBAAyB,EAAE,CAAA;QACnE,IAAI,CAAC,cAAc;YAAE,OAAM;QAE3B,IAAM,WAAW,GAAG,kBAAC,CAAC,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QAC9C,IAAM,SAAS,GAAG,WAAW,CAAC,WAAW,CAAC,OAAO,EAAE,cAAc,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QAC3E,IAAM,OAAO,GAAG,WAAW,CAAC,QAAQ,EAAE,CAAA;QAEtC,eAAe;QACf,IAAI,WAAW,CAAC,WAAW,EAAE,KAAK,MAAM;YAAE,OAAM;QAChD,cAAc;QACd,IAAI,SAAS,IAAI,kBAAC,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,OAAO;YAAE,OAAM;QAExE,cAAc;QACd,IACI,OAAO;YACP,OAAO,CAAC,MAAM,KAAK,CAAC;YACpB,kBAAC,CAAC,OAAO,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,WAAW,EAAE,KAAK,KAAK;YAC3C,EAAC,KAAK,aAAL,KAAK,uBAAL,KAAK,CAAE,SAAS,CAAA,CAAC,kBAAkB;UACtC;YACE,OAAM;SACT;QAED,IAAI,CAAC,eAAe,EAAE,CAAA;IAC1B,CAAC;IACD;;OAEG;IACK,mCAAe,GAAvB;QACI,IAAM,YAAY,GAAW,OAAO,CAAA;QACpC,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,YAAY,EAAE,YAAY,CAAC,CAAA;IAClD,CAAC;IACD;;OAEG;IACI,mCAAe,GAAtB,cAAgC,CAAC;IACrC,gBAAC;AAAD,CAAC,AAjDD,CAAwB,iBAAO,GAiD9B;AACD,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u5206\u5272\u7EBF\n * @author wangqiaoling\n */\nimport BtnMenu from '../menu-constructors/BtnMenu'\nimport $ from '../../utils/dom-core'\nimport Editor from '../../editor/index'\nimport { MenuActive } from '../menu-constructors/Menu'\nimport bindEvent from './bind-event/index'\nclass splitLine extends BtnMenu implements MenuActive {\n    constructor(editor: Editor) {\n        const $elem = $('<div class=\"w-e-menu\"><i class=\"w-e-icon-split-line\"></i></div>')\n        super($elem, editor)\n        // \u7ED1\u5B9A\u4E8B\u4EF6\n        bindEvent(editor)\n    }\n    /**\n     * \u83DC\u5355\u70B9\u51FB\u4E8B\u4EF6\n     */\n    public clickHandler(): void {\n        const editor = this.editor\n        const range = editor.selection.getRange()\n\n        const $selectionElem = editor.selection.getSelectionContainerElem()\n        if (!$selectionElem) return\n\n        const $DomElement = $($selectionElem.elems[0])\n        const $tableDOM = $DomElement.parentUntil('TABLE', $selectionElem.elems[0])\n        const $imgDOM = $DomElement.children()\n\n        // \u7981\u6B62\u5728\u4EE3\u7801\u5757\u4E2D\u6DFB\u52A0\u5206\u5272\u7EBF\n        if ($DomElement.getNodeName() === 'CODE') return\n        // \u7981\u6B62\u5728\u8868\u683C\u4E2D\u6DFB\u52A0\u5206\u5272\u7EBF\n        if ($tableDOM && $($tableDOM.elems[0]).getNodeName() === 'TABLE') return\n\n        // \u7981\u6B62\u5728\u56FE\u7247\u5904\u6DFB\u52A0\u5206\u5272\u7EBF\n        if (\n            $imgDOM &&\n            $imgDOM.length !== 0 &&\n            $($imgDOM.elems[0]).getNodeName() === 'IMG' &&\n            !range?.collapsed // \u5904\u7406\u5149\u6807\u5728 img \u540E\u9762\u7684\u60C5\u51B5\n        ) {\n            return\n        }\n\n        this.createSplitLine()\n    }\n    /**\n     * \u521B\u5EFA splitLine\n     */\n    private createSplitLine(): void {\n        const splitLineDOM: string = '<hr/>'\n        this.editor.cmd.do('insertHTML', splitLineDOM)\n    }\n    /**\n     * \u5C1D\u8BD5\u4FEE\u6539\u83DC\u5355\u6FC0\u6D3B\u72B6\u6001\n     */\n    public tryChangeActive(): void {}\n}\nexport default splitLine\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d87fc18bd8c43ab664166093816569b4d82cac5a"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_5zurvrnwg = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_5zurvrnwg();

var __extends = (cov_5zurvrnwg().s[0]++, (cov_5zurvrnwg().b[0][0]++, void 0) && (cov_5zurvrnwg().b[0][1]++, (void 0).__extends) || (cov_5zurvrnwg().b[0][2]++, function () {
  cov_5zurvrnwg().f[0]++;
  cov_5zurvrnwg().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_5zurvrnwg().f[1]++;
    cov_5zurvrnwg().s[2]++;
    _extendStatics = (cov_5zurvrnwg().b[1][0]++, _setPrototypeOf["default"]) || (cov_5zurvrnwg().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_5zurvrnwg().b[1][2]++, function (d, b) {
      cov_5zurvrnwg().f[2]++;
      cov_5zurvrnwg().s[3]++;
      d.__proto__ = b;
    }) || (cov_5zurvrnwg().b[1][3]++, function (d, b) {
      cov_5zurvrnwg().f[3]++;
      cov_5zurvrnwg().s[4]++;

      for (var p in b) {
        cov_5zurvrnwg().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_5zurvrnwg().b[2][0]++;
          cov_5zurvrnwg().s[6]++;
          d[p] = b[p];
        } else {
          cov_5zurvrnwg().b[2][1]++;
        }
      }
    });
    cov_5zurvrnwg().s[7]++;
    return _extendStatics(d, b);
  };

  cov_5zurvrnwg().s[8]++;
  return function (d, b) {
    cov_5zurvrnwg().f[4]++;
    cov_5zurvrnwg().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_5zurvrnwg().f[5]++;
      cov_5zurvrnwg().s[10]++;
      this.constructor = d;
    }

    cov_5zurvrnwg().s[11]++;
    d.prototype = b === null ? (cov_5zurvrnwg().b[3][0]++, (0, _create["default"])(b)) : (cov_5zurvrnwg().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_5zurvrnwg().s[12]++, (cov_5zurvrnwg().b[4][0]++, void 0) && (cov_5zurvrnwg().b[4][1]++, (void 0).__importDefault) || (cov_5zurvrnwg().b[4][2]++, function (mod) {
  cov_5zurvrnwg().f[6]++;
  cov_5zurvrnwg().s[13]++;
  return (cov_5zurvrnwg().b[6][0]++, mod) && (cov_5zurvrnwg().b[6][1]++, mod.__esModule) ? (cov_5zurvrnwg().b[5][0]++, mod) : (cov_5zurvrnwg().b[5][1]++, {
    "default": mod
  });
}));

cov_5zurvrnwg().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description 分割线
 * @author wangqiaoling
 */

var BtnMenu_1 = (cov_5zurvrnwg().s[15]++, __importDefault(__webpack_require__(24)));
var dom_core_1 = (cov_5zurvrnwg().s[16]++, __importDefault(__webpack_require__(2)));
var index_1 = (cov_5zurvrnwg().s[17]++, __importDefault(__webpack_require__(374)));
var splitLine = (
/** @class */
cov_5zurvrnwg().s[18]++, function (_super) {
  cov_5zurvrnwg().f[7]++;
  cov_5zurvrnwg().s[19]++;

  __extends(splitLine, _super);

  function splitLine(editor) {
    cov_5zurvrnwg().f[8]++;

    var _this = (cov_5zurvrnwg().s[20]++, this);

    var $elem = (cov_5zurvrnwg().s[21]++, dom_core_1["default"]('<div class="w-e-menu"><i class="w-e-icon-split-line"></i></div>'));
    cov_5zurvrnwg().s[22]++;
    _this = (cov_5zurvrnwg().b[7][0]++, _super.call(this, $elem, editor)) || (cov_5zurvrnwg().b[7][1]++, this); // 绑定事件

    cov_5zurvrnwg().s[23]++;
    index_1["default"](editor);
    cov_5zurvrnwg().s[24]++;
    return _this;
  }
  /**
   * 菜单点击事件
   */


  cov_5zurvrnwg().s[25]++;

  splitLine.prototype.clickHandler = function () {
    cov_5zurvrnwg().f[9]++;
    var editor = (cov_5zurvrnwg().s[26]++, this.editor);
    var range = (cov_5zurvrnwg().s[27]++, editor.selection.getRange());
    var $selectionElem = (cov_5zurvrnwg().s[28]++, editor.selection.getSelectionContainerElem());
    cov_5zurvrnwg().s[29]++;

    if (!$selectionElem) {
      cov_5zurvrnwg().b[8][0]++;
      cov_5zurvrnwg().s[30]++;
      return;
    } else {
      cov_5zurvrnwg().b[8][1]++;
    }

    var $DomElement = (cov_5zurvrnwg().s[31]++, dom_core_1["default"]($selectionElem.elems[0]));
    var $tableDOM = (cov_5zurvrnwg().s[32]++, $DomElement.parentUntil('TABLE', $selectionElem.elems[0]));
    var $imgDOM = (cov_5zurvrnwg().s[33]++, $DomElement.children()); // 禁止在代码块中添加分割线

    cov_5zurvrnwg().s[34]++;

    if ($DomElement.getNodeName() === 'CODE') {
      cov_5zurvrnwg().b[9][0]++;
      cov_5zurvrnwg().s[35]++;
      return;
    } else {
      cov_5zurvrnwg().b[9][1]++;
    } // 禁止在表格中添加分割线


    cov_5zurvrnwg().s[36]++;

    if ((cov_5zurvrnwg().b[11][0]++, $tableDOM) && (cov_5zurvrnwg().b[11][1]++, dom_core_1["default"]($tableDOM.elems[0]).getNodeName() === 'TABLE')) {
      cov_5zurvrnwg().b[10][0]++;
      cov_5zurvrnwg().s[37]++;
      return;
    } else {
      cov_5zurvrnwg().b[10][1]++;
    } // 禁止在图片处添加分割线


    cov_5zurvrnwg().s[38]++;

    if ((cov_5zurvrnwg().b[13][0]++, $imgDOM) && (cov_5zurvrnwg().b[13][1]++, $imgDOM.length !== 0) && (cov_5zurvrnwg().b[13][2]++, dom_core_1["default"]($imgDOM.elems[0]).getNodeName() === 'IMG') && (cov_5zurvrnwg().b[13][3]++, !((cov_5zurvrnwg().b[15][0]++, range === null) || (cov_5zurvrnwg().b[15][1]++, range === void 0) ? (cov_5zurvrnwg().b[14][0]++, void 0) : (cov_5zurvrnwg().b[14][1]++, range.collapsed))) // 处理光标在 img 后面的情况
    ) {
        cov_5zurvrnwg().b[12][0]++;
        cov_5zurvrnwg().s[39]++;
        return;
      } else {
      cov_5zurvrnwg().b[12][1]++;
    }

    cov_5zurvrnwg().s[40]++;
    this.createSplitLine();
  };
  /**
   * 创建 splitLine
   */


  cov_5zurvrnwg().s[41]++;

  splitLine.prototype.createSplitLine = function () {
    cov_5zurvrnwg().f[10]++;
    var splitLineDOM = (cov_5zurvrnwg().s[42]++, '<hr/>');
    cov_5zurvrnwg().s[43]++;
    this.editor.cmd["do"]('insertHTML', splitLineDOM);
  };
  /**
   * 尝试修改菜单激活状态
   */


  cov_5zurvrnwg().s[44]++;

  splitLine.prototype.tryChangeActive = function () {
    cov_5zurvrnwg().f[11]++;
  };

  cov_5zurvrnwg().s[45]++;
  return splitLine;
}(BtnMenu_1["default"]));
cov_5zurvrnwg().s[46]++;
exports["default"] = splitLine;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1r5f1li0xw() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/index.ts";
  var hash = "6467d9aac899f876f63a1f9aabb6415496dd62b7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 6,
          column: 65
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 36
        }
      },
      "5": {
        start: {
          line: 15,
          column: 0
        },
        end: {
          line: 15,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 18
          }
        },
        loc: {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/index.ts"],
      names: [],
      mappings: ";;;;;AAKA,kEAA8C;AAC9C;;;GAGG;AACH,SAAS,SAAS,CAAC,MAAc;IAC7B,kBAAkB;IAClB,uBAAgB,CAAC,MAAM,CAAC,CAAA;AAC5B,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u5206\u5272\u7EBF\u5143\u7D20\u7684\u4E8B\u4EF6\u5165\u53E3\n * @author wangqiaoling\n */\nimport Editor from '../../../editor/index'\nimport bindTooltipEvent from './tooltip-event'\n/**\n * \u7ED1\u5B9A\u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction bindEvent(editor: Editor) {\n    // \u5206\u5272\u7EBF\u7684 tooltip \u4E8B\u4EF6\n    bindTooltipEvent(editor)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6467d9aac899f876f63a1f9aabb6415496dd62b7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r5f1li0xw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1r5f1li0xw();

var __importDefault = (cov_1r5f1li0xw().s[0]++, (cov_1r5f1li0xw().b[0][0]++, void 0) && (cov_1r5f1li0xw().b[0][1]++, (void 0).__importDefault) || (cov_1r5f1li0xw().b[0][2]++, function (mod) {
  cov_1r5f1li0xw().f[0]++;
  cov_1r5f1li0xw().s[1]++;
  return (cov_1r5f1li0xw().b[2][0]++, mod) && (cov_1r5f1li0xw().b[2][1]++, mod.__esModule) ? (cov_1r5f1li0xw().b[1][0]++, mod) : (cov_1r5f1li0xw().b[1][1]++, {
    "default": mod
  });
}));

cov_1r5f1li0xw().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var tooltip_event_1 = (cov_1r5f1li0xw().s[3]++, __importDefault(__webpack_require__(375)));
/**
 * 绑定事件
 * @param editor 编辑器实例
 */

function bindEvent(editor) {
  cov_1r5f1li0xw().f[1]++;
  cov_1r5f1li0xw().s[4]++;
  // 分割线的 tooltip 事件
  tooltip_event_1["default"](editor);
}

cov_1r5f1li0xw().s[5]++;
exports["default"] = bindEvent;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_sor9xyfbz() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/tooltip-event.ts";
  var hash = "46885f52cd1b5265956dc4430d3744bf3b89a4e8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/tooltip-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 68
        }
      },
      "4": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 75
        }
      },
      "5": {
        start: {
          line: 23,
          column: 19
        },
        end: {
          line: 35,
          column: 9
        }
      },
      "6": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 67
        }
      },
      "7": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 56
        }
      },
      "8": {
        start: {
          line: 30,
          column: 20
        },
        end: {
          line: 30,
          column: 44
        }
      },
      "9": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 32
        }
      },
      "10": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 66
        }
      },
      "11": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 25
        }
      },
      "12": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 48,
          column: 9
        }
      },
      "13": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 29
        }
      },
      "14": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 27
        }
      },
      "15": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "16": {
        start: {
          line: 56,
          column: 13
        },
        end: {
          line: 56,
          column: 37
        }
      },
      "17": {
        start: {
          line: 56,
          column: 62
        },
        end: {
          line: 56,
          column: 85
        }
      },
      "18": {
        start: {
          line: 56,
          column: 110
        },
        end: {
          line: 56,
          column: 133
        }
      },
      "19": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 69
        }
      },
      "20": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 65
        }
      },
      "21": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 65
        }
      },
      "22": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 72
        }
      },
      "23": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 69
        }
      },
      "24": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 70
        }
      },
      "25": {
        start: {
          line: 66,
          column: 0
        },
        end: {
          line: 66,
          column: 35
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "createShowHideFn",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 25
          }
        },
        loc: {
          start: {
            line: 15,
            column: 34
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "showSplitLineTooltip",
        decl: {
          start: {
            line: 21,
            column: 13
          },
          end: {
            line: 21,
            column: 33
          }
        },
        loc: {
          start: {
            line: 21,
            column: 46
          },
          end: {
            line: 40,
            column: 5
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 26
          }
        },
        loc: {
          start: {
            line: 26,
            column: 55
          },
          end: {
            line: 33,
            column: 17
          }
        },
        line: 26
      },
      "4": {
        name: "hideSplitLineTooltip",
        decl: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 44,
            column: 33
          }
        },
        loc: {
          start: {
            line: 44,
            column: 36
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 44
      },
      "5": {
        name: "bindTooltipEvent",
        decl: {
          start: {
            line: 55,
            column: 9
          },
          end: {
            line: 55,
            column: 25
          }
        },
        loc: {
          start: {
            line: 55,
            column: 34
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }, {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 48,
            column: 9
          }
        }],
        line: 45
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/tooltip-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/split-line/bind-event/tooltip-event.ts"],
      names: [],
      mappings: ";;;;;AAAA;;;GAGG;AACH,qEAAuD;AACvD,4EAA0E;AAG1E;;GAEG;AACH,SAAS,gBAAgB,CAAC,MAAc;IACpC,IAAI,OAAuB,CAAA;IAE3B;;;OAGG;IACH,SAAS,oBAAoB,CAAC,UAAsB;QAChD,0BAA0B;QAC1B,IAAM,IAAI,GAAoB;YAC1B;gBACI,KAAK,EAAE,kBAAC,CAAC,WAAS,MAAM,CAAC,OAAO,CAAC,CAAC,CAAC,qBAAqB,CAAC,YAAS,CAAC;gBACnE,OAAO,EAAE,UAAC,MAAc,EAAE,UAAsB;oBAC5C,YAAY;oBACZ,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,UAAU,CAAC,CAAA;oBAC9C,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;oBACnC,MAAM,CAAC,GAAG,CAAC,EAAE,CAAC,QAAQ,CAAC,CAAA;oBAEvB,oCAAoC;oBACpC,OAAO,IAAI,CAAA;gBACf,CAAC;aACJ;SACJ,CAAA;QACD,cAAc;QACd,OAAO,GAAG,IAAI,iBAAO,CAAC,MAAM,EAAE,UAAU,EAAE,IAAI,CAAC,CAAA;QAC/C,aAAa;QACb,OAAO,CAAC,MAAM,EAAE,CAAA;IACpB,CAAC;IAED;;OAEG;IACH,SAAS,oBAAoB;QACzB,IAAI,OAAO,EAAE;YACT,OAAO,CAAC,MAAM,EAAE,CAAA;YAChB,OAAO,GAAG,IAAI,CAAA;SACjB;IACL,CAAC;IAED,OAAO;QACH,oBAAoB,sBAAA;QACpB,oBAAoB,sBAAA;KACvB,CAAA;AACL,CAAC;AAED,SAAwB,gBAAgB,CAAC,MAAc;IAC7C,IAAA,KAAiD,gBAAgB,CAAC,MAAM,CAAC,EAAvE,oBAAoB,0BAAA,EAAE,oBAAoB,0BAA6B,CAAA;IAE/E,oBAAoB;IACpB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;IAEhE,mCAAmC;IACnC,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;IAC5D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,WAAW,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;IAC5D,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,kBAAkB,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;IACnE,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,eAAe,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;IAChE,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,gBAAgB,CAAC,IAAI,CAAC,oBAAoB,CAAC,CAAA;AACrE,CAAC;AAZD,mCAYC",
      sourcesContent: ["/**\n * @description tooltip \u4E8B\u4EF6\n * @author wangqiaoling\n */\nimport $, { DomElement } from '../../../utils/dom-core'\nimport Tooltip, { TooltipConfType } from '../../menu-constructors/Tooltip'\nimport Editor from '../../../editor/index'\n\n/**\n * \u751F\u6210 Tooltip \u7684\u663E\u793A\u9690\u85CF\u51FD\u6570\n */\nfunction createShowHideFn(editor: Editor) {\n    let tooltip: Tooltip | null\n\n    /**\n     * \u663E\u793A\u5206\u5272\u7EBF\u7684 tooltip\n     * @param $splitLine \u5206\u5272\u7EBF\u5143\u7D20\n     */\n    function showSplitLineTooltip($splitLine: DomElement): void {\n        // \u5B9A\u4E49 splitLine tooltip \u914D\u7F6E\n        const conf: TooltipConfType = [\n            {\n                $elem: $(`<span>${editor.i18next.t('menus.panelMenus.\u5220\u9664')}</span>`),\n                onClick: (editor: Editor, $splitLine: DomElement) => {\n                    // \u9009\u4E2D \u5206\u5272\u7EBF \u5143\u7D20\n                    editor.selection.createRangeByElem($splitLine)\n                    editor.selection.restoreSelection()\n                    editor.cmd.do('delete')\n\n                    // \u8FD4\u56DE true\uFF0C\u8868\u793A\u6267\u884C\u5B8C\u4E4B\u540E\uFF0C\u9690\u85CF tooltip\u3002\u5426\u5219\u4E0D\u9690\u85CF\u3002\n                    return true\n                },\n            },\n        ]\n        // \u5B9E\u4F8B\u5316 tooltip\n        tooltip = new Tooltip(editor, $splitLine, conf)\n        // \u521B\u5EFA tooltip\n        tooltip.create()\n    }\n\n    /**\n     * \u9690\u85CF\u5206\u5272\u7EBF\u7684 tooltip\n     */\n    function hideSplitLineTooltip(): void {\n        if (tooltip) {\n            tooltip.remove()\n            tooltip = null\n        }\n    }\n\n    return {\n        showSplitLineTooltip,\n        hideSplitLineTooltip,\n    }\n}\n\nexport default function bindTooltipEvent(editor: Editor): void {\n    const { showSplitLineTooltip, hideSplitLineTooltip } = createShowHideFn(editor)\n\n    // \u70B9\u51FB\u5206\u5272\u7EBF\u65F6\uFF0C\u663E\u793A tooltip\n    editor.txt.eventHooks.splitLineEvents.push(showSplitLineTooltip)\n\n    // \u70B9\u51FB\u5176\u4ED6\u5730\u65B9\uFF08\u5DE5\u5177\u680F\u3001\u6EDA\u52A8\u3001keyup\uFF09\u65F6\uFF0C\u9690\u85CF tooltip\n    editor.txt.eventHooks.clickEvents.push(hideSplitLineTooltip)\n    editor.txt.eventHooks.keyupEvents.push(hideSplitLineTooltip)\n    editor.txt.eventHooks.toolbarClickEvents.push(hideSplitLineTooltip)\n    editor.txt.eventHooks.menuClickEvents.push(hideSplitLineTooltip)\n    editor.txt.eventHooks.textScrollEvents.push(hideSplitLineTooltip)\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "46885f52cd1b5265956dc4430d3744bf3b89a4e8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_sor9xyfbz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_sor9xyfbz();

var __importDefault = (cov_sor9xyfbz().s[0]++, (cov_sor9xyfbz().b[0][0]++, void 0) && (cov_sor9xyfbz().b[0][1]++, (void 0).__importDefault) || (cov_sor9xyfbz().b[0][2]++, function (mod) {
  cov_sor9xyfbz().f[0]++;
  cov_sor9xyfbz().s[1]++;
  return (cov_sor9xyfbz().b[2][0]++, mod) && (cov_sor9xyfbz().b[2][1]++, mod.__esModule) ? (cov_sor9xyfbz().b[1][0]++, mod) : (cov_sor9xyfbz().b[1][1]++, {
    "default": mod
  });
}));

cov_sor9xyfbz().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * @description tooltip 事件
 * @author wangqiaoling
 */

var dom_core_1 = (cov_sor9xyfbz().s[3]++, __importDefault(__webpack_require__(2)));
var Tooltip_1 = (cov_sor9xyfbz().s[4]++, __importDefault(__webpack_require__(43)));
/**
 * 生成 Tooltip 的显示隐藏函数
 */

function createShowHideFn(editor) {
  cov_sor9xyfbz().f[1]++;
  var tooltip;
  /**
   * 显示分割线的 tooltip
   * @param $splitLine 分割线元素
   */

  function showSplitLineTooltip($splitLine) {
    cov_sor9xyfbz().f[2]++;
    // 定义 splitLine tooltip 配置
    var conf = (cov_sor9xyfbz().s[5]++, [{
      $elem: dom_core_1["default"]("<span>" + editor.i18next.t('menus.panelMenus.删除') + "</span>"),
      onClick: function onClick(editor, $splitLine) {
        cov_sor9xyfbz().f[3]++;
        cov_sor9xyfbz().s[6]++;
        // 选中 分割线 元素
        editor.selection.createRangeByElem($splitLine);
        cov_sor9xyfbz().s[7]++;
        editor.selection.restoreSelection();
        cov_sor9xyfbz().s[8]++;
        editor.cmd["do"]('delete'); // 返回 true，表示执行完之后，隐藏 tooltip。否则不隐藏。

        cov_sor9xyfbz().s[9]++;
        return true;
      }
    }]); // 实例化 tooltip

    cov_sor9xyfbz().s[10]++;
    tooltip = new Tooltip_1["default"](editor, $splitLine, conf); // 创建 tooltip

    cov_sor9xyfbz().s[11]++;
    tooltip.create();
  }
  /**
   * 隐藏分割线的 tooltip
   */


  function hideSplitLineTooltip() {
    cov_sor9xyfbz().f[4]++;
    cov_sor9xyfbz().s[12]++;

    if (tooltip) {
      cov_sor9xyfbz().b[3][0]++;
      cov_sor9xyfbz().s[13]++;
      tooltip.remove();
      cov_sor9xyfbz().s[14]++;
      tooltip = null;
    } else {
      cov_sor9xyfbz().b[3][1]++;
    }
  }

  cov_sor9xyfbz().s[15]++;
  return {
    showSplitLineTooltip: showSplitLineTooltip,
    hideSplitLineTooltip: hideSplitLineTooltip
  };
}

function bindTooltipEvent(editor) {
  cov_sor9xyfbz().f[5]++;

  var _a = (cov_sor9xyfbz().s[16]++, createShowHideFn(editor)),
      showSplitLineTooltip = (cov_sor9xyfbz().s[17]++, _a.showSplitLineTooltip),
      hideSplitLineTooltip = (cov_sor9xyfbz().s[18]++, _a.hideSplitLineTooltip); // 点击分割线时，显示 tooltip


  cov_sor9xyfbz().s[19]++;
  editor.txt.eventHooks.splitLineEvents.push(showSplitLineTooltip); // 点击其他地方（工具栏、滚动、keyup）时，隐藏 tooltip

  cov_sor9xyfbz().s[20]++;
  editor.txt.eventHooks.clickEvents.push(hideSplitLineTooltip);
  cov_sor9xyfbz().s[21]++;
  editor.txt.eventHooks.keyupEvents.push(hideSplitLineTooltip);
  cov_sor9xyfbz().s[22]++;
  editor.txt.eventHooks.toolbarClickEvents.push(hideSplitLineTooltip);
  cov_sor9xyfbz().s[23]++;
  editor.txt.eventHooks.menuClickEvents.push(hideSplitLineTooltip);
  cov_sor9xyfbz().s[24]++;
  editor.txt.eventHooks.textScrollEvents.push(hideSplitLineTooltip);
}

cov_sor9xyfbz().s[25]++;
exports["default"] = bindTooltipEvent;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 初始化编辑器 DOM 结构
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_dm35q2gzm() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-dom.ts";
  var hash = "7bdeb32f85483cb81a1434a4b30c44f5333d76aa";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-dom.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 11,
          column: 40
        }
      },
      "5": {
        start: {
          line: 12,
          column: 20
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "6": {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 48
        }
      },
      "7": {
        start: {
          line: 19,
          column: 27
        },
        end: {
          line: 19,
          column: 62
        }
      },
      "8": {
        start: {
          line: 20,
          column: 23
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "9": {
        start: {
          line: 21,
          column: 17
        },
        end: {
          line: 21,
          column: 30
        }
      },
      "10": {
        start: {
          line: 22,
          column: 17
        },
        end: {
          line: 22,
          column: 30
        }
      },
      "11": {
        start: {
          line: 23,
          column: 18
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "12": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "13": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 57
        }
      },
      "14": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 63
        }
      },
      "15": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 48
        }
      },
      "16": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 73
        }
      },
      "17": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 40,
          column: 69
        }
      },
      "18": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 44,
          column: 42
        }
      },
      "19": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 40
        }
      },
      "20": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 49,
          column: 62
        }
      },
      "21": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 50
        }
      },
      "22": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 50
        }
      },
      "23": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 89
        }
      },
      "24": {
        start: {
          line: 57,
          column: 23
        },
        end: {
          line: 57,
          column: 100
        }
      },
      "25": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 41
        }
      },
      "26": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "27": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 36
        }
      },
      "28": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 28
        }
      },
      "29": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 60
        }
      },
      "30": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 41
        }
      },
      "31": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 44
        }
      },
      "32": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 86
        }
      },
      "33": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 54
        }
      },
      "34": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 75,
          column: 59
        }
      },
      "35": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 35
        }
      },
      "36": {
        start: {
          line: 78,
          column: 24
        },
        end: {
          line: 78,
          column: 56
        }
      },
      "37": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 43
        }
      },
      "38": {
        start: {
          line: 80,
          column: 21
        },
        end: {
          line: 80,
          column: 50
        }
      },
      "39": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 37
        }
      },
      "40": {
        start: {
          line: 83,
          column: 33
        },
        end: {
          line: 83,
          column: 69
        }
      },
      "41": {
        start: {
          line: 84,
          column: 31
        },
        end: {
          line: 84,
          column: 58
        }
      },
      "42": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "43": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 67
        }
      },
      "44": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 39
        }
      },
      "45": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 51
        }
      },
      "46": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 33
        }
      },
      "47": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 41
        }
      },
      "48": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 35
        }
      },
      "49": {
        start: {
          line: 95,
          column: 0
        },
        end: {
          line: 95,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "default_1",
        decl: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 18
          }
        },
        loc: {
          start: {
            line: 17,
            column: 27
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 17
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 60
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 17
          }
        }, {
          start: {
            line: 60,
            column: 21
          },
          end: {
            line: 60,
            column: 37
          }
        }],
        line: 60
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }],
        line: 85
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-dom.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-dom.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoD;AACpD,yCAA4C;AAE5C,IAAM,aAAa,GAAG;IAClB,MAAM,EAAE,mBAAmB;IAC3B,cAAc,EAAE,MAAM;IACtB,mBAAmB,EAAE,gBAAgB;CACxC,CAAA;AAED,mBAAyB,MAAc;IACnC,IAAM,eAAe,GAAG,MAAM,CAAC,eAAe,CAAA;IAC9C,IAAM,gBAAgB,GAAG,kBAAC,CAAC,eAAe,CAAC,CAAA;IAC3C,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;IAExC,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,OAAO,GAAG,MAAM,CAAC,OAAO,CAAA;IAE9B,IAAI,YAAwB,CAAA;IAC5B,IAAI,kBAA8B,CAAA;IAClC,IAAI,SAAqB,CAAA;IACzB,IAAI,SAA4B,CAAA;IAEhC,IAAI,YAAY,IAAI,IAAI,EAAE;QACtB,yDAAyD;QACzD,YAAY,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QAC/B,kBAAkB,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;QAErC,mBAAmB;QACnB,SAAS,GAAG,gBAAgB,CAAC,QAAQ,EAAE,CAAA;QAEvC,cAAc;QACd,gBAAgB,CAAC,MAAM,CAAC,YAAY,CAAC,CAAC,MAAM,CAAC,kBAAkB,CAAC,CAAA;QAEhE,kBAAkB;QAClB,YAAY;aACP,GAAG,CAAC,kBAAkB,EAAE,aAAa,CAAC,cAAc,CAAC;aACrD,GAAG,CAAC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC;aACnC,GAAG,CAAC,eAAe,EAAE,aAAa,CAAC,mBAAmB,CAAC,CAAA;QAC5D,kBAAkB;aACb,GAAG,CAAC,QAAQ,EAAE,aAAa,CAAC,MAAM,CAAC;aACnC,GAAG,CAAC,YAAY,EAAE,MAAM,CAAC;aACzB,GAAG,CAAC,QAAQ,EAAK,MAAM,OAAI,CAAC,CAAA;KACpC;SAAM;QACH,oCAAoC;QACpC,YAAY,GAAG,gBAAgB,CAAA;QAC/B,kBAAkB,GAAG,kBAAC,CAAC,YAAY,CAAC,CAAA;QACpC,mBAAmB;QACnB,SAAS,GAAG,kBAAkB,CAAC,QAAQ,EAAE,CAAA;KAC5C;IAED,OAAO;IACP,SAAS,GAAG,kBAAC,CAAC,aAAa,CAAC,CAAA;IAC5B,SAAS,CAAC,IAAI,CAAC,iBAAiB,EAAE,MAAM,CAAC,CAAC,GAAG,CAAC,OAAO,EAAE,MAAM,CAAC,CAAC,GAAG,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAA;IAEpF,iBAAiB;IACjB,IAAM,YAAY,GAAG,kBAAC,CAAC,UAAQ,OAAO,CAAC,CAAC,CAAC,MAAM,CAAC,MAAM,CAAC,WAAW,CAAC,WAAQ,CAAC,CAAA;IAC5E,YAAY,CAAC,QAAQ,CAAC,aAAa,CAAC,CAAA;IAEpC,YAAY;IACZ,IAAI,SAAS,IAAI,SAAS,CAAC,MAAM,EAAE;QAC/B,SAAS,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;QAC3B,0BAA0B;QAC1B,YAAY,CAAC,IAAI,EAAE,CAAA;KACtB;SAAM;QACH,SAAS,CAAC,MAAM,CAAC,kBAAC,CAAC,aAAa,CAAC,CAAC,CAAA,CAAC,cAAc;KACpD;IAED,YAAY;IACZ,kBAAkB,CAAC,MAAM,CAAC,SAAS,CAAC,CAAA;IAEpC,gBAAgB;IAChB,kBAAkB,CAAC,MAAM,CAAC,YAAY,CAAC,CAAA;IAEvC,cAAc;IACd,YAAY,CAAC,QAAQ,CAAC,aAAa,CAAC,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,SAAS,CAAC,CAAC,CAAA;IACjF,kBAAkB,CAAC,QAAQ,CAAC,oBAAoB,CAAC,CAAA;IACjD,kBAAkB,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,MAAM,CAAC,GAAG,EAAE,CAAC,CAAA;IACtD,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC,CAAA;IAE9B,QAAQ;IACR,IAAM,aAAa,GAAG,gBAAS,CAAC,cAAc,CAAC,CAAA;IAC/C,YAAY,CAAC,IAAI,CAAC,IAAI,EAAE,aAAa,CAAC,CAAA;IACtC,IAAM,UAAU,GAAG,gBAAS,CAAC,WAAW,CAAC,CAAA;IACzC,SAAS,CAAC,IAAI,CAAC,IAAI,EAAE,UAAU,CAAC,CAAA;IAEhC,iBAAiB;IACjB,IAAM,sBAAsB,GAAG,kBAAkB,CAAC,eAAe,EAAE,CAAA;IACnE,IAAM,oBAAoB,GAAG,SAAS,CAAC,eAAe,EAAE,CAAA;IACxD,IAAI,sBAAsB,KAAK,oBAAoB,EAAE;QACjD,SAAS,CAAC,GAAG,CAAC,YAAY,EAAE,sBAAsB,GAAG,IAAI,CAAC,CAAA;KAC7D;IAED,OAAO;IACP,MAAM,CAAC,YAAY,GAAG,YAAY,CAAA;IAClC,MAAM,CAAC,kBAAkB,GAAG,kBAAkB,CAAA;IAC9C,MAAM,CAAC,SAAS,GAAG,SAAS,CAAA;IAC5B,MAAM,CAAC,aAAa,GAAG,aAAa,CAAA;IACpC,MAAM,CAAC,UAAU,GAAG,UAAU,CAAA;AAClC,CAAC;AA1FD,4BA0FC",
      sourcesContent: ["/**\n * @description \u521D\u59CB\u5316\u7F16\u8F91\u5668 DOM \u7ED3\u6784\n * @author wangfupeng\n */\n\nimport Editor from '../index'\nimport $, { DomElement } from '../../utils/dom-core'\nimport { getRandom } from '../../utils/util'\n\nconst styleSettings = {\n    border: '1px solid #c9d8db',\n    toolbarBgColor: '#FFF',\n    toolbarBottomBorder: '1px solid #EEE',\n}\n\nexport default function (editor: Editor): void {\n    const toolbarSelector = editor.toolbarSelector\n    const $toolbarSelector = $(toolbarSelector)\n    const textSelector = editor.textSelector\n\n    const config = editor.config\n    const height = config.height\n    const i18next = editor.i18next\n\n    let $toolbarElem: DomElement\n    let $textContainerElem: DomElement\n    let $textElem: DomElement\n    let $children: DomElement | null\n\n    if (textSelector == null) {\n        // \u53EA\u6709 toolbarSelector \uFF0C\u5373\u662F\u5BB9\u5668\u7684\u9009\u62E9\u5668\u6216\u5143\u7D20\uFF0Ctoolbar \u548C text \u7684\u5143\u7D20\u81EA\u884C\u521B\u5EFA\n        $toolbarElem = $('<div></div>')\n        $textContainerElem = $('<div></div>')\n\n        // \u5C06\u7F16\u8F91\u5668\u533A\u57DF\u539F\u6709\u7684\u5185\u5BB9\uFF0C\u6682\u5B58\u8D77\u6765\n        $children = $toolbarSelector.children()\n\n        // \u6DFB\u52A0\u5230 DOM \u7ED3\u6784\u4E2D\n        $toolbarSelector.append($toolbarElem).append($textContainerElem)\n\n        // \u81EA\u884C\u521B\u5EFA\u7684\uFF0C\u9700\u8981\u914D\u7F6E\u9ED8\u8BA4\u7684\u6837\u5F0F\n        $toolbarElem\n            .css('background-color', styleSettings.toolbarBgColor)\n            .css('border', styleSettings.border)\n            .css('border-bottom', styleSettings.toolbarBottomBorder)\n        $textContainerElem\n            .css('border', styleSettings.border)\n            .css('border-top', 'none')\n            .css('height', `${height}px`)\n    } else {\n        // toolbarSelector \u548C textSelector \u90FD\u6709\n        $toolbarElem = $toolbarSelector\n        $textContainerElem = $(textSelector)\n        // \u5C06\u7F16\u8F91\u5668\u533A\u57DF\u539F\u6709\u7684\u5185\u5BB9\uFF0C\u6682\u5B58\u8D77\u6765\n        $children = $textContainerElem.children()\n    }\n\n    // \u7F16\u8F91\u533A\u57DF\n    $textElem = $('<div></div>')\n    $textElem.attr('contenteditable', 'true').css('width', '100%').css('height', '100%')\n\n    // \u6DFB\u52A0 placeholder\n    const $placeholder = $(`<div>${i18next.t(editor.config.placeholder)}</div>`)\n    $placeholder.addClass('placeholder')\n\n    // \u521D\u59CB\u5316\u7F16\u8F91\u533A\u57DF\u5185\u5BB9\n    if ($children && $children.length) {\n        $textElem.append($children)\n        // \u7F16\u8F91\u5668\u6709\u9ED8\u8BA4\u503C\u7684\u65F6\u5019\u9690\u85CFplaceholder\n        $placeholder.hide()\n    } else {\n        $textElem.append($('<p><br></p>')) // \u65B0\u589E\u4E00\u884C\uFF0C\u65B9\u4FBF\u7EE7\u7EED\u7F16\u8F91\n    }\n\n    // \u7F16\u8F91\u533A\u57DF\u52A0\u5165DOM\n    $textContainerElem.append($textElem)\n\n    // \u6DFB\u52A0placeholder\n    $textContainerElem.append($placeholder)\n\n    // \u8BBE\u7F6E\u901A\u7528\u7684 class\n    $toolbarElem.addClass('w-e-toolbar').css('z-index', editor.zIndex.get('toolbar'))\n    $textContainerElem.addClass('w-e-text-container')\n    $textContainerElem.css('z-index', editor.zIndex.get())\n    $textElem.addClass('w-e-text')\n\n    // \u6DFB\u52A0 ID\n    const toolbarElemId = getRandom('toolbar-elem')\n    $toolbarElem.attr('id', toolbarElemId)\n    const textElemId = getRandom('text-elem')\n    $textElem.attr('id', textElemId)\n\n    // \u5224\u65AD\u7F16\u8F91\u533A\u4E0E\u5BB9\u5668\u9AD8\u5EA6\u662F\u5426\u4E00\u81F4\n    const textContainerCliheight = $textContainerElem.getClientHeight()\n    const textElemClientHeight = $textElem.getClientHeight()\n    if (textContainerCliheight !== textElemClientHeight) {\n        $textElem.css('min-height', textContainerCliheight + 'px')\n    }\n\n    // \u8BB0\u5F55\u5C5E\u6027\n    editor.$toolbarElem = $toolbarElem\n    editor.$textContainerElem = $textContainerElem\n    editor.$textElem = $textElem\n    editor.toolbarElemId = toolbarElemId\n    editor.textElemId = textElemId\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7bdeb32f85483cb81a1434a4b30c44f5333d76aa"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dm35q2gzm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_dm35q2gzm();

var __importDefault = (cov_dm35q2gzm().s[0]++, (cov_dm35q2gzm().b[0][0]++, void 0) && (cov_dm35q2gzm().b[0][1]++, (void 0).__importDefault) || (cov_dm35q2gzm().b[0][2]++, function (mod) {
  cov_dm35q2gzm().f[0]++;
  cov_dm35q2gzm().s[1]++;
  return (cov_dm35q2gzm().b[2][0]++, mod) && (cov_dm35q2gzm().b[2][1]++, mod.__esModule) ? (cov_dm35q2gzm().b[1][0]++, mod) : (cov_dm35q2gzm().b[1][1]++, {
    "default": mod
  });
}));

cov_dm35q2gzm().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_dm35q2gzm().s[3]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_dm35q2gzm().s[4]++, __webpack_require__(7));
var styleSettings = (cov_dm35q2gzm().s[5]++, {
  border: '1px solid #c9d8db',
  toolbarBgColor: '#FFF',
  toolbarBottomBorder: '1px solid #EEE'
});

function default_1(editor) {
  cov_dm35q2gzm().f[1]++;
  var toolbarSelector = (cov_dm35q2gzm().s[6]++, editor.toolbarSelector);
  var $toolbarSelector = (cov_dm35q2gzm().s[7]++, dom_core_1["default"](toolbarSelector));
  var textSelector = (cov_dm35q2gzm().s[8]++, editor.textSelector);
  var config = (cov_dm35q2gzm().s[9]++, editor.config);
  var height = (cov_dm35q2gzm().s[10]++, config.height);
  var i18next = (cov_dm35q2gzm().s[11]++, editor.i18next);
  var $toolbarElem;
  var $textContainerElem;
  var $textElem;
  var $children;
  cov_dm35q2gzm().s[12]++;

  if (textSelector == null) {
    cov_dm35q2gzm().b[3][0]++;
    cov_dm35q2gzm().s[13]++;
    // 只有 toolbarSelector ，即是容器的选择器或元素，toolbar 和 text 的元素自行创建
    $toolbarElem = dom_core_1["default"]('<div></div>');
    cov_dm35q2gzm().s[14]++;
    $textContainerElem = dom_core_1["default"]('<div></div>'); // 将编辑器区域原有的内容，暂存起来

    cov_dm35q2gzm().s[15]++;
    $children = $toolbarSelector.children(); // 添加到 DOM 结构中

    cov_dm35q2gzm().s[16]++;
    $toolbarSelector.append($toolbarElem).append($textContainerElem); // 自行创建的，需要配置默认的样式

    cov_dm35q2gzm().s[17]++;
    $toolbarElem.css('background-color', styleSettings.toolbarBgColor).css('border', styleSettings.border).css('border-bottom', styleSettings.toolbarBottomBorder);
    cov_dm35q2gzm().s[18]++;
    $textContainerElem.css('border', styleSettings.border).css('border-top', 'none').css('height', height + "px");
  } else {
    cov_dm35q2gzm().b[3][1]++;
    cov_dm35q2gzm().s[19]++;
    // toolbarSelector 和 textSelector 都有
    $toolbarElem = $toolbarSelector;
    cov_dm35q2gzm().s[20]++;
    $textContainerElem = dom_core_1["default"](textSelector); // 将编辑器区域原有的内容，暂存起来

    cov_dm35q2gzm().s[21]++;
    $children = $textContainerElem.children();
  } // 编辑区域


  cov_dm35q2gzm().s[22]++;
  $textElem = dom_core_1["default"]('<div></div>');
  cov_dm35q2gzm().s[23]++;
  $textElem.attr('contenteditable', 'true').css('width', '100%').css('height', '100%'); // 添加 placeholder

  var $placeholder = (cov_dm35q2gzm().s[24]++, dom_core_1["default"]("<div>" + i18next.t(editor.config.placeholder) + "</div>"));
  cov_dm35q2gzm().s[25]++;
  $placeholder.addClass('placeholder'); // 初始化编辑区域内容

  cov_dm35q2gzm().s[26]++;

  if ((cov_dm35q2gzm().b[5][0]++, $children) && (cov_dm35q2gzm().b[5][1]++, $children.length)) {
    cov_dm35q2gzm().b[4][0]++;
    cov_dm35q2gzm().s[27]++;
    $textElem.append($children); // 编辑器有默认值的时候隐藏placeholder

    cov_dm35q2gzm().s[28]++;
    $placeholder.hide();
  } else {
    cov_dm35q2gzm().b[4][1]++;
    cov_dm35q2gzm().s[29]++;
    $textElem.append(dom_core_1["default"]('<p><br></p>')); // 新增一行，方便继续编辑
  } // 编辑区域加入DOM


  cov_dm35q2gzm().s[30]++;
  $textContainerElem.append($textElem); // 添加placeholder

  cov_dm35q2gzm().s[31]++;
  $textContainerElem.append($placeholder); // 设置通用的 class

  cov_dm35q2gzm().s[32]++;
  $toolbarElem.addClass('w-e-toolbar').css('z-index', editor.zIndex.get('toolbar'));
  cov_dm35q2gzm().s[33]++;
  $textContainerElem.addClass('w-e-text-container');
  cov_dm35q2gzm().s[34]++;
  $textContainerElem.css('z-index', editor.zIndex.get());
  cov_dm35q2gzm().s[35]++;
  $textElem.addClass('w-e-text'); // 添加 ID

  var toolbarElemId = (cov_dm35q2gzm().s[36]++, util_1.getRandom('toolbar-elem'));
  cov_dm35q2gzm().s[37]++;
  $toolbarElem.attr('id', toolbarElemId);
  var textElemId = (cov_dm35q2gzm().s[38]++, util_1.getRandom('text-elem'));
  cov_dm35q2gzm().s[39]++;
  $textElem.attr('id', textElemId); // 判断编辑区与容器高度是否一致

  var textContainerCliheight = (cov_dm35q2gzm().s[40]++, $textContainerElem.getClientHeight());
  var textElemClientHeight = (cov_dm35q2gzm().s[41]++, $textElem.getClientHeight());
  cov_dm35q2gzm().s[42]++;

  if (textContainerCliheight !== textElemClientHeight) {
    cov_dm35q2gzm().b[6][0]++;
    cov_dm35q2gzm().s[43]++;
    $textElem.css('min-height', textContainerCliheight + 'px');
  } else {
    cov_dm35q2gzm().b[6][1]++;
  } // 记录属性


  cov_dm35q2gzm().s[44]++;
  editor.$toolbarElem = $toolbarElem;
  cov_dm35q2gzm().s[45]++;
  editor.$textContainerElem = $textContainerElem;
  cov_dm35q2gzm().s[46]++;
  editor.$textElem = $textElem;
  cov_dm35q2gzm().s[47]++;
  editor.toolbarElemId = toolbarElemId;
  cov_dm35q2gzm().s[48]++;
  editor.textElemId = textElemId;
}

cov_dm35q2gzm().s[49]++;
exports["default"] = default_1;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 初始化编辑器选区，将光标定位到文档末尾
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1yqbadzxqu() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-selection.ts";
  var hash = "cc6c30d3573d2797c2b457f8e1a5fb61d21565b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-selection.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 36
        }
      },
      "5": {
        start: {
          line: 18,
          column: 20
        },
        end: {
          line: 18,
          column: 40
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 24,
          column: 5
        }
      },
      "7": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 60
        }
      },
      "8": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 30
        }
      },
      "9": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 15
        }
      },
      "10": {
        start: {
          line: 25,
          column: 16
        },
        end: {
          line: 25,
          column: 32
        }
      },
      "11": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "12": {
        start: {
          line: 28,
          column: 19
        },
        end: {
          line: 28,
          column: 45
        }
      },
      "13": {
        start: {
          line: 29,
          column: 23
        },
        end: {
          line: 29,
          column: 42
        }
      },
      "14": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 35,
          column: 9
        }
      },
      "15": {
        start: {
          line: 32,
          column: 12
        },
        end: {
          line: 32,
          column: 64
        }
      },
      "16": {
        start: {
          line: 33,
          column: 12
        },
        end: {
          line: 33,
          column: 34
        }
      },
      "17": {
        start: {
          line: 34,
          column: 12
        },
        end: {
          line: 34,
          column: 19
        }
      },
      "18": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      },
      "19": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 62
        }
      },
      "20": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 44
        }
      },
      "21": {
        start: {
          line: 42,
          column: 0
        },
        end: {
          line: 42,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "initSelection",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 22
          }
        },
        loc: {
          start: {
            line: 16,
            column: 40
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        }],
        line: 19
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 8
          },
          end: {
            line: 19,
            column: 18
          }
        }, {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 19,
            column: 39
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }],
        line: 26
      },
      "6": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 35,
            column: 9
          }
        }],
        line: 30
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 12
          },
          end: {
            line: 30,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 13
          },
          end: {
            line: 30,
            column: 28
          }
        }, {
          start: {
            line: 30,
            column: 32
          },
          end: {
            line: 30,
            column: 48
          }
        }, {
          start: {
            line: 30,
            column: 53
          },
          end: {
            line: 30,
            column: 69
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-selection.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/init-selection.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoC;AAEpC;;;;GAIG;AACH,SAAS,aAAa,CAAC,MAAc,EAAE,OAAiB;IACpD,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;IAClC,IAAM,SAAS,GAAG,SAAS,CAAC,QAAQ,EAAE,CAAA;IACtC,IAAI,CAAC,SAAS,IAAI,CAAC,SAAS,CAAC,MAAM,EAAE;QACjC,2BAA2B;QAC3B,SAAS,CAAC,MAAM,CAAC,kBAAC,CAAC,aAAa,CAAC,CAAC,CAAA;QAClC,aAAa,CAAC,MAAM,CAAC,CAAA;QACrB,OAAM;KACT;IAED,IAAM,KAAK,GAAG,SAAS,CAAC,IAAI,EAAE,CAAA;IAE9B,IAAI,OAAO,EAAE;QACT,SAAS;QACT,IAAM,IAAI,GAAG,KAAK,CAAC,IAAI,EAAE,CAAC,WAAW,EAAE,CAAA;QACvC,IAAM,QAAQ,GAAG,KAAK,CAAC,WAAW,EAAE,CAAA;QACpC,IAAI,CAAC,IAAI,KAAK,MAAM,IAAI,IAAI,KAAK,OAAO,CAAC,IAAI,QAAQ,KAAK,GAAG,EAAE;YAC3D,qCAAqC;YACrC,SAAS,CAAC,MAAM,CAAC,kBAAC,CAAC,aAAa,CAAC,CAAC,CAAA;YAClC,aAAa,CAAC,MAAM,CAAC,CAAA;YACrB,OAAM;SACT;KACJ;IAED,IAAI,MAAM,CAAC,MAAM,CAAC,KAAK,EAAE;QACrB,MAAM,CAAC,SAAS,CAAC,iBAAiB,CAAC,KAAK,EAAE,IAAI,EAAE,IAAI,CAAC,CAAA;QACrD,MAAM,CAAC,SAAS,CAAC,gBAAgB,EAAE,CAAA;KACtC;AACL,CAAC;AAED,kBAAe,aAAa,CAAA",
      sourcesContent: ["/**\n * @description \u521D\u59CB\u5316\u7F16\u8F91\u5668\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u6587\u6863\u672B\u5C3E\n * @author wangfupeng\n */\n\nimport Editor from '../index'\nimport $ from '../../utils/dom-core'\n\n/**\n * \u521D\u59CB\u5316\u7F16\u8F91\u5668\u9009\u533A\uFF0C\u5C06\u5149\u6807\u5B9A\u4F4D\u5230\u6587\u6863\u672B\u5C3E\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param newLine \u662F\u5426\u65B0\u589E\u4E00\u884C\n */\nfunction initSelection(editor: Editor, newLine?: boolean) {\n    const $textElem = editor.$textElem\n    const $children = $textElem.children()\n    if (!$children || !$children.length) {\n        // \u5982\u679C\u7F16\u8F91\u5668\u533A\u57DF\u65E0\u5185\u5BB9\uFF0C\u6DFB\u52A0\u4E00\u4E2A\u7A7A\u884C\uFF0C\u91CD\u65B0\u8BBE\u7F6E\u9009\u533A\n        $textElem.append($('<p><br></p>'))\n        initSelection(editor)\n        return\n    }\n\n    const $last = $children.last()\n\n    if (newLine) {\n        // \u65B0\u589E\u4E00\u4E2A\u7A7A\u884C\n        const html = $last.html().toLowerCase()\n        const nodeName = $last.getNodeName()\n        if ((html !== '<br>' && html !== '<br/>') || nodeName !== 'P') {\n            // \u6700\u540E\u4E00\u4E2A\u5143\u7D20\u4E0D\u662F <p><br></p>\uFF0C\u6DFB\u52A0\u4E00\u4E2A\u7A7A\u884C\uFF0C\u91CD\u65B0\u8BBE\u7F6E\u9009\u533A\n            $textElem.append($('<p><br></p>'))\n            initSelection(editor)\n            return\n        }\n    }\n\n    if (editor.config.focus) {\n        editor.selection.createRangeByElem($last, true, true)\n        editor.selection.restoreSelection()\n    }\n}\n\nexport default initSelection\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cc6c30d3573d2797c2b457f8e1a5fb61d21565b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1yqbadzxqu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1yqbadzxqu();

var __importDefault = (cov_1yqbadzxqu().s[0]++, (cov_1yqbadzxqu().b[0][0]++, void 0) && (cov_1yqbadzxqu().b[0][1]++, (void 0).__importDefault) || (cov_1yqbadzxqu().b[0][2]++, function (mod) {
  cov_1yqbadzxqu().f[0]++;
  cov_1yqbadzxqu().s[1]++;
  return (cov_1yqbadzxqu().b[2][0]++, mod) && (cov_1yqbadzxqu().b[2][1]++, mod.__esModule) ? (cov_1yqbadzxqu().b[1][0]++, mod) : (cov_1yqbadzxqu().b[1][1]++, {
    "default": mod
  });
}));

cov_1yqbadzxqu().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_1yqbadzxqu().s[3]++, __importDefault(__webpack_require__(2)));
/**
 * 初始化编辑器选区，将光标定位到文档末尾
 * @param editor 编辑器实例
 * @param newLine 是否新增一行
 */

function initSelection(editor, newLine) {
  cov_1yqbadzxqu().f[1]++;
  var $textElem = (cov_1yqbadzxqu().s[4]++, editor.$textElem);
  var $children = (cov_1yqbadzxqu().s[5]++, $textElem.children());
  cov_1yqbadzxqu().s[6]++;

  if ((cov_1yqbadzxqu().b[4][0]++, !$children) || (cov_1yqbadzxqu().b[4][1]++, !$children.length)) {
    cov_1yqbadzxqu().b[3][0]++;
    cov_1yqbadzxqu().s[7]++;
    // 如果编辑器区域无内容，添加一个空行，重新设置选区
    $textElem.append(dom_core_1["default"]('<p><br></p>'));
    cov_1yqbadzxqu().s[8]++;
    initSelection(editor);
    cov_1yqbadzxqu().s[9]++;
    return;
  } else {
    cov_1yqbadzxqu().b[3][1]++;
  }

  var $last = (cov_1yqbadzxqu().s[10]++, $children.last());
  cov_1yqbadzxqu().s[11]++;

  if (newLine) {
    cov_1yqbadzxqu().b[5][0]++;
    // 新增一个空行
    var html = (cov_1yqbadzxqu().s[12]++, $last.html().toLowerCase());
    var nodeName = (cov_1yqbadzxqu().s[13]++, $last.getNodeName());
    cov_1yqbadzxqu().s[14]++;

    if ((cov_1yqbadzxqu().b[7][0]++, html !== '<br>') && (cov_1yqbadzxqu().b[7][1]++, html !== '<br/>') || (cov_1yqbadzxqu().b[7][2]++, nodeName !== 'P')) {
      cov_1yqbadzxqu().b[6][0]++;
      cov_1yqbadzxqu().s[15]++;
      // 最后一个元素不是 <p><br></p>，添加一个空行，重新设置选区
      $textElem.append(dom_core_1["default"]('<p><br></p>'));
      cov_1yqbadzxqu().s[16]++;
      initSelection(editor);
      cov_1yqbadzxqu().s[17]++;
      return;
    } else {
      cov_1yqbadzxqu().b[6][1]++;
    }
  } else {
    cov_1yqbadzxqu().b[5][1]++;
  }

  cov_1yqbadzxqu().s[18]++;

  if (editor.config.focus) {
    cov_1yqbadzxqu().b[8][0]++;
    cov_1yqbadzxqu().s[19]++;
    editor.selection.createRangeByElem($last, true, true);
    cov_1yqbadzxqu().s[20]++;
    editor.selection.restoreSelection();
  } else {
    cov_1yqbadzxqu().b[8][1]++;
  }
}

cov_1yqbadzxqu().s[21]++;
exports["default"] = initSelection;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 绑定编辑器事件 change blur focus
 * @author wangfupeng
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_racah7y61() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/bind-event.ts";
  var hash = "c43d10d408bda5451c890adec58139a2df8625f7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/bind-event.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 24
        }
      },
      "5": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 30
        }
      },
      "6": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 23
        }
      },
      "7": {
        start: {
          line: 24,
          column: 19
        },
        end: {
          line: 24,
          column: 41
        }
      },
      "8": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 7
        }
      },
      "9": {
        start: {
          line: 26,
          column: 19
        },
        end: {
          line: 26,
          column: 42
        }
      },
      "10": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 23
        }
      },
      "11": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 39
        }
      },
      "12": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 27
        }
      },
      "13": {
        start: {
          line: 39,
          column: 21
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "14": {
        start: {
          line: 40,
          column: 22
        },
        end: {
          line: 40,
          column: 48
        }
      },
      "15": {
        start: {
          line: 41,
          column: 24
        },
        end: {
          line: 41,
          column: 40
        }
      },
      "16": {
        start: {
          line: 42,
          column: 27
        },
        end: {
          line: 42,
          column: 46
        }
      },
      "17": {
        start: {
          line: 44,
          column: 22
        },
        end: {
          line: 44,
          column: 50
        }
      },
      "18": {
        start: {
          line: 46,
          column: 24
        },
        end: {
          line: 46,
          column: 55
        }
      },
      "19": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 69
        }
      },
      "20": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 63,
          column: 9
        }
      },
      "21": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 52,
          column: 13
        }
      },
      "22": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 51,
          column: 23
        }
      },
      "23": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 55,
          column: 13
        }
      },
      "24": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 54,
          column: 37
        }
      },
      "25": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 35
        }
      },
      "26": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 61,
          column: 13
        }
      },
      "27": {
        start: {
          line: 60,
          column: 16
        },
        end: {
          line: 60,
          column: 38
        }
      },
      "28": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 34
        }
      },
      "29": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 68,
          column: 5
        }
      },
      "30": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 30
        }
      },
      "31": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 30
        }
      },
      "32": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 55
        }
      },
      "33": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "34": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 60
        }
      },
      "35": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 87,
          column: 7
        }
      },
      "36": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 34
        }
      },
      "37": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 35
        }
      },
      "38": {
        start: {
          line: 94,
          column: 17
        },
        end: {
          line: 94,
          column: 30
        }
      },
      "39": {
        start: {
          line: 95,
          column: 17
        },
        end: {
          line: 95,
          column: 30
        }
      },
      "40": {
        start: {
          line: 96,
          column: 22
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "41": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 24
        }
      },
      "42": {
        start: {
          line: 104,
          column: 17
        },
        end: {
          line: 104,
          column: 30
        }
      },
      "43": {
        start: {
          line: 105,
          column: 18
        },
        end: {
          line: 105,
          column: 32
        }
      },
      "44": {
        start: {
          line: 106,
          column: 22
        },
        end: {
          line: 106,
          column: 45
        }
      },
      "45": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 25
        }
      },
      "46": {
        start: {
          line: 109,
          column: 0
        },
        end: {
          line: 109,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "bindEvent",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 18
          }
        },
        loc: {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "_bindChange",
        decl: {
          start: {
            line: 23,
            column: 9
          },
          end: {
            line: 23,
            column: 20
          }
        },
        loc: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 23
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 44
          },
          end: {
            line: 25,
            column: 45
          }
        },
        loc: {
          start: {
            line: 25,
            column: 56
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 25
      },
      "4": {
        name: "_bindFocusAndBlur",
        decl: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 35,
            column: 26
          }
        },
        loc: {
          start: {
            line: 35,
            column: 35
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 35
      },
      "5": {
        name: "listener",
        decl: {
          start: {
            line: 38,
            column: 13
          },
          end: {
            line: 38,
            column: 21
          }
        },
        loc: {
          start: {
            line: 38,
            column: 25
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 38
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 71,
            column: 25
          },
          end: {
            line: 71,
            column: 26
          }
        },
        loc: {
          start: {
            line: 71,
            column: 37
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 71
      },
      "7": {
        name: "_bindInput",
        decl: {
          start: {
            line: 79,
            column: 9
          },
          end: {
            line: 79,
            column: 19
          }
        },
        loc: {
          start: {
            line: 79,
            column: 28
          },
          end: {
            line: 88,
            column: 1
          }
        },
        line: 79
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 82,
            column: 32
          },
          end: {
            line: 82,
            column: 33
          }
        },
        loc: {
          start: {
            line: 82,
            column: 44
          },
          end: {
            line: 84,
            column: 5
          }
        },
        line: 82
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 85,
            column: 30
          },
          end: {
            line: 85,
            column: 31
          }
        },
        loc: {
          start: {
            line: 85,
            column: 42
          },
          end: {
            line: 87,
            column: 5
          }
        },
        line: 85
      },
      "10": {
        name: "_blurHandler",
        decl: {
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 21
          }
        },
        loc: {
          start: {
            line: 93,
            column: 30
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 93
      },
      "11": {
        name: "_focusHandler",
        decl: {
          start: {
            line: 103,
            column: 9
          },
          end: {
            line: 103,
            column: 22
          }
        },
        loc: {
          start: {
            line: 103,
            column: 31
          },
          end: {
            line: 108,
            column: 1
          }
        },
        line: 103
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 19
          },
          end: {
            line: 26,
            column: 36
          }
        }, {
          start: {
            line: 26,
            column: 40
          },
          end: {
            line: 26,
            column: 42
          }
        }],
        line: 26
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 57
          },
          end: {
            line: 47,
            column: 61
          }
        }, {
          start: {
            line: 47,
            column: 64
          },
          end: {
            line: 47,
            column: 69
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }, {
          start: {
            line: 48,
            column: 8
          },
          end: {
            line: 63,
            column: 9
          }
        }],
        line: 48
      },
      "6": {
        loc: {
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 52,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 52,
            column: 13
          }
        }, {
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 52,
            column: 13
          }
        }],
        line: 50
      },
      "7": {
        loc: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 25
          }
        }, {
          start: {
            line: 50,
            column: 29
          },
          end: {
            line: 50,
            column: 36
          }
        }],
        line: 50
      },
      "8": {
        loc: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 55,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 55,
            column: 13
          }
        }, {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 55,
            column: 13
          }
        }],
        line: 53
      },
      "9": {
        loc: {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        }, {
          start: {
            line: 59,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        }],
        line: 59
      },
      "10": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        }],
        line: 65
      },
      "11": {
        loc: {
          start: {
            line: 96,
            column: 22
          },
          end: {
            line: 96,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 22
          },
          end: {
            line: 96,
            column: 39
          }
        }, {
          start: {
            line: 96,
            column: 43
          },
          end: {
            line: 96,
            column: 45
          }
        }],
        line: 96
      },
      "12": {
        loc: {
          start: {
            line: 106,
            column: 22
          },
          end: {
            line: 106,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 22
          },
          end: {
            line: 106,
            column: 39
          }
        }, {
          start: {
            line: 106,
            column: 43
          },
          end: {
            line: 106,
            column: 45
          }
        }],
        line: 106
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/bind-event.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/bind-event.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAGH,kEAAoC;AAEpC,SAAS,SAAS,CAAC,MAAc;IAC7B,eAAe;IACf,WAAW,CAAC,MAAM,CAAC,CAAA;IAEnB,mBAAmB;IACnB,iBAAiB,CAAC,MAAM,CAAC,CAAA;IAEzB,cAAc;IACd,UAAU,CAAC,MAAM,CAAC,CAAA;AACtB,CAAC;AAED;;;GAGG;AACH,SAAS,WAAW,CAAC,MAAc;IACvB,IAAA,QAAQ,GAAK,MAAM,CAAC,MAAM,SAAlB,CAAkB;IAClC,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,IAAI,CAAC;QACpC,IAAI,IAAI,GAAG,MAAM,CAAC,GAAG,CAAC,IAAI,EAAE,IAAI,EAAE,CAAA;QAClC,QAAQ,CAAC,IAAI,CAAC,CAAA;QACd,MAAM,CAAC,GAAG,CAAC,iBAAiB,EAAE,CAAA;IAClC,CAAC,CAAC,CAAA;AACN,CAAC;AAED;;;GAGG;AACH,SAAS,iBAAiB,CAAC,MAAc;IACrC,eAAe;IACf,MAAM,CAAC,OAAO,GAAG,KAAK,CAAA;IAEtB,SAAS,QAAQ,CAAC,CAAQ;QACtB,IAAM,MAAM,GAAG,CAAC,CAAC,MAAM,CAAA;QACvB,IAAM,OAAO,GAAG,kBAAC,CAAC,MAAM,CAAC,CAAA;QACzB,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;QAClC,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;QAExC,iBAAiB;QACjB,IAAM,OAAO,GAAG,SAAS,CAAC,SAAS,CAAC,OAAO,CAAC,CAAA;QAE5C,gBAAgB;QAChB,IAAM,SAAS,GAAG,YAAY,CAAC,SAAS,CAAC,OAAO,CAAC,CAAA;QACjD,IAAM,MAAM,GAAG,YAAY,CAAC,KAAK,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,MAAM,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,CAAC,KAAK,CAAA;QAE/D,IAAI,CAAC,OAAO,EAAE;YACV,4BAA4B;YAC5B,IAAI,SAAS,IAAI,CAAC,MAAM,EAAE;gBACtB,OAAM;aACT;YAED,IAAI,MAAM,CAAC,OAAO,EAAE;gBAChB,YAAY,CAAC,MAAM,CAAC,CAAA;aACvB;YACD,MAAM,CAAC,OAAO,GAAG,KAAK,CAAA;SACzB;aAAM;YACH,IAAI,CAAC,MAAM,CAAC,OAAO,EAAE;gBACjB,aAAa,CAAC,MAAM,CAAC,CAAA;aACxB;YAED,MAAM,CAAC,OAAO,GAAG,IAAI,CAAA;SACxB;IACL,CAAC;IACD,IAAI,QAAQ,CAAC,aAAa,KAAK,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,EAAE;QACtD,aAAa,CAAC,MAAM,CAAC,CAAA;QACrB,MAAM,CAAC,OAAO,GAAG,IAAI,CAAA;KACxB;IACD,kBAAC,CAAC,QAAQ,CAAC,CAAC,EAAE,CAAC,OAAO,EAAE,QAAQ,CAAC,CAAA;IACjC,sBAAsB;IACtB,MAAM,CAAC,aAAa,CAAC;QACjB,kBAAC,CAAC,QAAQ,CAAC,CAAC,GAAG,CAAC,OAAO,EAAE,QAAQ,CAAC,CAAA;IACtC,CAAC,CAAC,CAAA;AACN,CAAC;AAED;;;GAGG;AACH,SAAS,UAAU,CAAC,MAAc;IAC9B,SAAS;IACT,MAAM,CAAC,SAAS;SACX,EAAE,CAAC,kBAAkB,EAAE;QACpB,MAAM,CAAC,WAAW,GAAG,IAAI,CAAA;IAC7B,CAAC,CAAC;SACD,EAAE,CAAC,gBAAgB,EAAE;QAClB,MAAM,CAAC,WAAW,GAAG,KAAK,CAAA;IAC9B,CAAC,CAAC,CAAA;AACV,CAAC;AAED;;;GAGG;AACH,SAAS,YAAY,CAAC,MAAc;IAChC,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,WAAW,GAAG,MAAM,CAAC,GAAG,CAAC,IAAI,EAAE,IAAI,EAAE,CAAA;IAC3C,MAAM,CAAC,WAAW,CAAC,CAAA;AACvB,CAAC;AAED;;;GAGG;AACH,SAAS,aAAa,CAAC,MAAc;IACjC,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAC5B,IAAM,OAAO,GAAG,MAAM,CAAC,OAAO,CAAA;IAC9B,IAAM,WAAW,GAAG,MAAM,CAAC,GAAG,CAAC,IAAI,EAAE,IAAI,EAAE,CAAA;IAC3C,OAAO,CAAC,WAAW,CAAC,CAAA;AACxB,CAAC;AAED,kBAAe,SAAS,CAAA",
      sourcesContent: ["/**\n * @description \u7ED1\u5B9A\u7F16\u8F91\u5668\u4E8B\u4EF6 change blur focus\n * @author wangfupeng\n */\n\nimport Editor from '../index'\nimport $ from '../../utils/dom-core'\n\nfunction bindEvent(editor: Editor): void {\n    // \u7ED1\u5B9A change \u4E8B\u4EF6\n    _bindChange(editor)\n\n    // \u7ED1\u5B9A focus blur \u4E8B\u4EF6\n    _bindFocusAndBlur(editor)\n\n    // \u7ED1\u5B9A input \u8F93\u5165\n    _bindInput(editor)\n}\n\n/**\n * \u7ED1\u5B9A change \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction _bindChange(editor: Editor): void {\n    const { onchange } = editor.config\n    editor.txt.eventHooks.changeEvents.push(function () {\n        let html = editor.txt.html() || ''\n        onchange(html)\n        editor.txt.togglePlaceholder()\n    })\n}\n\n/**\n * \u7ED1\u5B9A focus blur \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction _bindFocusAndBlur(editor: Editor): void {\n    // \u5F53\u524D\u7F16\u8F91\u5668\u662F\u5426\u662F\u7126\u70B9\u72B6\u6001\n    editor.isFocus = false\n\n    function listener(e: Event) {\n        const target = e.target\n        const $target = $(target)\n        const $textElem = editor.$textElem\n        const $toolbarElem = editor.$toolbarElem\n\n        //\u5224\u65AD\u5F53\u524D\u70B9\u51FB\u5143\u7D20\u662F\u5426\u5728\u7F16\u8F91\u5668\u5185\n        const isChild = $textElem.isContain($target)\n\n        //\u5224\u65AD\u5F53\u524D\u70B9\u51FB\u5143\u7D20\u662F\u5426\u4E3A\u5DE5\u5177\u680F\n        const isToolbar = $toolbarElem.isContain($target)\n        const isMenu = $toolbarElem.elems[0] == e.target ? true : false\n\n        if (!isChild) {\n            // \u82E5\u4E3A\u9009\u62E9\u5DE5\u5177\u680F\u4E2D\u7684\u529F\u80FD\uFF0C\u5219\u4E0D\u89C6\u4E3A\u6210 blur \u64CD\u4F5C\n            if (isToolbar && !isMenu) {\n                return\n            }\n\n            if (editor.isFocus) {\n                _blurHandler(editor)\n            }\n            editor.isFocus = false\n        } else {\n            if (!editor.isFocus) {\n                _focusHandler(editor)\n            }\n\n            editor.isFocus = true\n        }\n    }\n    if (document.activeElement === editor.$textElem.elems[0]) {\n        _focusHandler(editor)\n        editor.isFocus = true\n    }\n    $(document).on('click', listener)\n    // \u5168\u5C40\u4E8B\u4EF6\u5728\u7F16\u8F91\u5668\u5B9E\u4F8B\u9500\u6BC1\u7684\u65F6\u5019\u8FDB\u884C\u89E3\u7ED1\n    editor.beforeDestroy(function () {\n        $(document).off('click', listener)\n    })\n}\n\n/**\n * \u7ED1\u5B9A input \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction _bindInput(editor: Editor) {\n    // \u7ED1\u5B9A\u4E2D\u6587\u8F93\u5165\n    editor.$textElem\n        .on('compositionstart', () => {\n            editor.isComposing = true\n        })\n        .on('compositionend', () => {\n            editor.isComposing = false\n        })\n}\n\n/**\n * blur \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction _blurHandler(editor: Editor) {\n    const config = editor.config\n    const onblur = config.onblur\n    const currentHtml = editor.txt.html() || ''\n    onblur(currentHtml)\n}\n\n/**\n * focus \u4E8B\u4EF6\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nfunction _focusHandler(editor: Editor) {\n    const config = editor.config\n    const onfocus = config.onfocus\n    const currentHtml = editor.txt.html() || ''\n    onfocus(currentHtml)\n}\n\nexport default bindEvent\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c43d10d408bda5451c890adec58139a2df8625f7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_racah7y61 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_racah7y61();

var __importDefault = (cov_racah7y61().s[0]++, (cov_racah7y61().b[0][0]++, void 0) && (cov_racah7y61().b[0][1]++, (void 0).__importDefault) || (cov_racah7y61().b[0][2]++, function (mod) {
  cov_racah7y61().f[0]++;
  cov_racah7y61().s[1]++;
  return (cov_racah7y61().b[2][0]++, mod) && (cov_racah7y61().b[2][1]++, mod.__esModule) ? (cov_racah7y61().b[1][0]++, mod) : (cov_racah7y61().b[1][1]++, {
    "default": mod
  });
}));

cov_racah7y61().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_racah7y61().s[3]++, __importDefault(__webpack_require__(2)));

function bindEvent(editor) {
  cov_racah7y61().f[1]++;
  cov_racah7y61().s[4]++;

  // 绑定 change 事件
  _bindChange(editor); // 绑定 focus blur 事件


  cov_racah7y61().s[5]++;

  _bindFocusAndBlur(editor); // 绑定 input 输入


  cov_racah7y61().s[6]++;

  _bindInput(editor);
}
/**
 * 绑定 change 事件
 * @param editor 编辑器实例
 */


function _bindChange(editor) {
  cov_racah7y61().f[2]++;
  var onchange = (cov_racah7y61().s[7]++, editor.config.onchange);
  cov_racah7y61().s[8]++;
  editor.txt.eventHooks.changeEvents.push(function () {
    cov_racah7y61().f[3]++;
    var html = (cov_racah7y61().s[9]++, (cov_racah7y61().b[3][0]++, editor.txt.html()) || (cov_racah7y61().b[3][1]++, ''));
    cov_racah7y61().s[10]++;
    onchange(html);
    cov_racah7y61().s[11]++;
    editor.txt.togglePlaceholder();
  });
}
/**
 * 绑定 focus blur 事件
 * @param editor 编辑器实例
 */


function _bindFocusAndBlur(editor) {
  cov_racah7y61().f[4]++;
  cov_racah7y61().s[12]++;
  // 当前编辑器是否是焦点状态
  editor.isFocus = false;

  function listener(e) {
    cov_racah7y61().f[5]++;
    var target = (cov_racah7y61().s[13]++, e.target);
    var $target = (cov_racah7y61().s[14]++, dom_core_1["default"](target));
    var $textElem = (cov_racah7y61().s[15]++, editor.$textElem);
    var $toolbarElem = (cov_racah7y61().s[16]++, editor.$toolbarElem); //判断当前点击元素是否在编辑器内

    var isChild = (cov_racah7y61().s[17]++, $textElem.isContain($target)); //判断当前点击元素是否为工具栏

    var isToolbar = (cov_racah7y61().s[18]++, $toolbarElem.isContain($target));
    var isMenu = (cov_racah7y61().s[19]++, $toolbarElem.elems[0] == e.target ? (cov_racah7y61().b[4][0]++, true) : (cov_racah7y61().b[4][1]++, false));
    cov_racah7y61().s[20]++;

    if (!isChild) {
      cov_racah7y61().b[5][0]++;
      cov_racah7y61().s[21]++;

      // 若为选择工具栏中的功能，则不视为成 blur 操作
      if ((cov_racah7y61().b[7][0]++, isToolbar) && (cov_racah7y61().b[7][1]++, !isMenu)) {
        cov_racah7y61().b[6][0]++;
        cov_racah7y61().s[22]++;
        return;
      } else {
        cov_racah7y61().b[6][1]++;
      }

      cov_racah7y61().s[23]++;

      if (editor.isFocus) {
        cov_racah7y61().b[8][0]++;
        cov_racah7y61().s[24]++;

        _blurHandler(editor);
      } else {
        cov_racah7y61().b[8][1]++;
      }

      cov_racah7y61().s[25]++;
      editor.isFocus = false;
    } else {
      cov_racah7y61().b[5][1]++;
      cov_racah7y61().s[26]++;

      if (!editor.isFocus) {
        cov_racah7y61().b[9][0]++;
        cov_racah7y61().s[27]++;

        _focusHandler(editor);
      } else {
        cov_racah7y61().b[9][1]++;
      }

      cov_racah7y61().s[28]++;
      editor.isFocus = true;
    }
  }

  cov_racah7y61().s[29]++;

  if (document.activeElement === editor.$textElem.elems[0]) {
    cov_racah7y61().b[10][0]++;
    cov_racah7y61().s[30]++;

    _focusHandler(editor);

    cov_racah7y61().s[31]++;
    editor.isFocus = true;
  } else {
    cov_racah7y61().b[10][1]++;
  }

  cov_racah7y61().s[32]++;
  dom_core_1["default"](document).on('click', listener); // 全局事件在编辑器实例销毁的时候进行解绑

  cov_racah7y61().s[33]++;
  editor.beforeDestroy(function () {
    cov_racah7y61().f[6]++;
    cov_racah7y61().s[34]++;
    dom_core_1["default"](document).off('click', listener);
  });
}
/**
 * 绑定 input 事件
 * @param editor 编辑器实例
 */


function _bindInput(editor) {
  cov_racah7y61().f[7]++;
  cov_racah7y61().s[35]++;
  // 绑定中文输入
  editor.$textElem.on('compositionstart', function () {
    cov_racah7y61().f[8]++;
    cov_racah7y61().s[36]++;
    editor.isComposing = true;
  }).on('compositionend', function () {
    cov_racah7y61().f[9]++;
    cov_racah7y61().s[37]++;
    editor.isComposing = false;
  });
}
/**
 * blur 事件
 * @param editor 编辑器实例
 */


function _blurHandler(editor) {
  cov_racah7y61().f[10]++;
  var config = (cov_racah7y61().s[38]++, editor.config);
  var onblur = (cov_racah7y61().s[39]++, config.onblur);
  var currentHtml = (cov_racah7y61().s[40]++, (cov_racah7y61().b[11][0]++, editor.txt.html()) || (cov_racah7y61().b[11][1]++, ''));
  cov_racah7y61().s[41]++;
  onblur(currentHtml);
}
/**
 * focus 事件
 * @param editor 编辑器实例
 */


function _focusHandler(editor) {
  cov_racah7y61().f[11]++;
  var config = (cov_racah7y61().s[42]++, editor.config);
  var onfocus = (cov_racah7y61().s[43]++, config.onfocus);
  var currentHtml = (cov_racah7y61().s[44]++, (cov_racah7y61().b[12][0]++, editor.txt.html()) || (cov_racah7y61().b[12][1]++, ''));
  cov_racah7y61().s[45]++;
  onfocus(currentHtml);
}

cov_racah7y61().s[46]++;
exports["default"] = bindEvent;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 国际化 初始化
 * @author tonghan
 * i18next 是使用 JavaScript 编写的国际化框架
 * i18next 提供了标准的i18n功能，例如（复数，上下文，插值，格式）等
 * i18next 文档地址： https://www.i18next.com/overview/getting-started
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1ahkmrf810() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/i18next-init.ts";
  var hash = "e37b878b9eaec1522eaec4126f0735fe89a04100";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/i18next-init.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "1": {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 11,
          column: 26
        }
      },
      "2": {
        start: {
          line: 11,
          column: 35
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "3": {
        start: {
          line: 11,
          column: 56
        },
        end: {
          line: 11,
          column: 68
        }
      },
      "4": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "5": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 23,
          column: 9
        }
      },
      "6": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "7": {
        start: {
          line: 22,
          column: 12
        },
        end: {
          line: 22,
          column: 48
        }
      },
      "8": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 15
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 32,
          column: 6
        }
      },
      "10": {
        start: {
          line: 29,
          column: 25
        },
        end: {
          line: 29,
          column: 39
        }
      },
      "11": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "12": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 34,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "i18nextInit",
        decl: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 20
          }
        },
        loc: {
          start: {
            line: 10,
            column: 29
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 28,
            column: 12
          }
        },
        loc: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 31,
            column: 9
          }
        },
        line: 28
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        }],
        line: 12
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/i18next-init.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/i18next-init.ts"],
      names: [],
      mappings: ";AAAA;;;;;;GAMG;;AAIH,SAAS,WAAW,CAAC,MAAc;IACzB,IAAA,KAAsB,MAAM,CAAC,MAAM,EAAjC,IAAI,UAAA,EAAE,SAAS,eAAkB,CAAA;IAEzC,IAAI,MAAM,CAAC,OAAO,IAAI,IAAI,EAAE;QACxB,IAAI;YACA,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC;gBAChB,EAAE,EAAE,YAAY;gBAChB,GAAG,EAAE,IAAI;gBACT,SAAS,EAAE,YAAY;gBACvB,SAAS,EAAE,SAAS;aACvB,CAAC,CAAA;SACL;QAAC,OAAO,KAAK,EAAE;YACZ,MAAM,IAAI,KAAK,CAAC,UAAU,GAAG,KAAK,CAAC,CAAA;SACtC;QACD,OAAM;KACT;IAED,oBAAoB;IACpB,MAAM,CAAC,OAAO,GAAG;QACb,CAAC,EAAD,UAAE,GAAW;YACT,IAAM,MAAM,GAAG,GAAG,CAAC,KAAK,CAAC,GAAG,CAAC,CAAA;YAC7B,OAAO,MAAM,CAAC,MAAM,CAAC,MAAM,GAAG,CAAC,CAAC,CAAA;QACpC,CAAC;KACJ,CAAA;AACL,CAAC;AAED,kBAAe,WAAW,CAAA",
      sourcesContent: ["/**\n * @description \u56FD\u9645\u5316 \u521D\u59CB\u5316\n * @author tonghan\n * i18next \u662F\u4F7F\u7528 JavaScript \u7F16\u5199\u7684\u56FD\u9645\u5316\u6846\u67B6\n * i18next \u63D0\u4F9B\u4E86\u6807\u51C6\u7684i18n\u529F\u80FD\uFF0C\u4F8B\u5982\uFF08\u590D\u6570\uFF0C\u4E0A\u4E0B\u6587\uFF0C\u63D2\u503C\uFF0C\u683C\u5F0F\uFF09\u7B49\n * i18next \u6587\u6863\u5730\u5740\uFF1A https://www.i18next.com/overview/getting-started\n */\n\nimport Editor from '../index'\n\nfunction i18nextInit(editor: Editor) {\n    const { lang, languages } = editor.config\n\n    if (editor.i18next != null) {\n        try {\n            editor.i18next.init({\n                ns: 'wangEditor',\n                lng: lang,\n                defaultNS: 'wangEditor',\n                resources: languages,\n            })\n        } catch (error) {\n            throw new Error('i18next:' + error)\n        }\n        return\n    }\n\n    // \u6CA1\u6709\u5F15\u5165 i18next \u7684\u66FF\u4EE3\u54C1\n    editor.i18next = {\n        t(str: string) {\n            const strArr = str.split('.')\n            return strArr[strArr.length - 1]\n        },\n    }\n}\n\nexport default i18nextInit\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e37b878b9eaec1522eaec4126f0735fe89a04100"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ahkmrf810 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1ahkmrf810();
cov_1ahkmrf810().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

function i18nextInit(editor) {
  cov_1ahkmrf810().f[0]++;

  var _a = (cov_1ahkmrf810().s[1]++, editor.config),
      lang = (cov_1ahkmrf810().s[2]++, _a.lang),
      languages = (cov_1ahkmrf810().s[3]++, _a.languages);

  cov_1ahkmrf810().s[4]++;

  if (editor.i18next != null) {
    cov_1ahkmrf810().b[0][0]++;
    cov_1ahkmrf810().s[5]++;

    try {
      cov_1ahkmrf810().s[6]++;
      editor.i18next.init({
        ns: 'wangEditor',
        lng: lang,
        defaultNS: 'wangEditor',
        resources: languages
      });
    } catch (error) {
      cov_1ahkmrf810().s[7]++;
      throw new Error('i18next:' + error);
    }

    cov_1ahkmrf810().s[8]++;
    return;
  } else {
    cov_1ahkmrf810().b[0][1]++;
  } // 没有引入 i18next 的替代品


  cov_1ahkmrf810().s[9]++;
  editor.i18next = {
    t: function t(str) {
      cov_1ahkmrf810().f[1]++;
      var strArr = (cov_1ahkmrf810().s[10]++, str.split('.'));
      cov_1ahkmrf810().s[11]++;
      return strArr[strArr.length - 1];
    }
  };
}

cov_1ahkmrf810().s[12]++;
exports["default"] = i18nextInit;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 全屏功能
 * @author xiaokyo
 */

var _interopRequireDefault = __webpack_require__(0);

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_15x388lvm() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/set-full-screen.ts";
  var hash = "c32e3bcd32bad8e36d70da56cbfd932a89983805";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/set-full-screen.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 57
        }
      },
      "4": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 65
        }
      },
      "5": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 47
        }
      },
      "6": {
        start: {
          line: 13,
          column: 25
        },
        end: {
          line: 13,
          column: 46
        }
      },
      "7": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 14,
          column: 55
        }
      },
      "8": {
        start: {
          line: 15,
          column: 28
        },
        end: {
          line: 15,
          column: 52
        }
      },
      "9": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "10": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 21,
          column: 66
        }
      },
      "11": {
        start: {
          line: 22,
          column: 29
        },
        end: {
          line: 22,
          column: 54
        }
      },
      "12": {
        start: {
          line: 23,
          column: 23
        },
        end: {
          line: 23,
          column: 42
        }
      },
      "13": {
        start: {
          line: 24,
          column: 20
        },
        end: {
          line: 24,
          column: 64
        }
      },
      "14": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 25,
          column: 30
        }
      },
      "15": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 46
        }
      },
      "16": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 47
        }
      },
      "17": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 50
        }
      },
      "18": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 58
        }
      },
      "19": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "20": {
        start: {
          line: 32,
          column: 0
        },
        end: {
          line: 32,
          column: 38
        }
      },
      "21": {
        start: {
          line: 37,
          column: 22
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "22": {
        start: {
          line: 38,
          column: 24
        },
        end: {
          line: 38,
          column: 66
        }
      },
      "23": {
        start: {
          line: 39,
          column: 29
        },
        end: {
          line: 39,
          column: 54
        }
      },
      "24": {
        start: {
          line: 40,
          column: 23
        },
        end: {
          line: 40,
          column: 42
        }
      },
      "25": {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 68
        }
      },
      "26": {
        start: {
          line: 42,
          column: 17
        },
        end: {
          line: 42,
          column: 30
        }
      },
      "27": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "28": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 43
        }
      },
      "29": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 53
        }
      },
      "30": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 41
        }
      },
      "31": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 59
        }
      },
      "32": {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 49,
          column: 42
        }
      },
      "33": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "34": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 57,
          column: 15
        }
      },
      "35": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 15
        }
      },
      "36": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 59,
          column: 15
        }
      },
      "37": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 15
        }
      },
      "38": {
        start: {
          line: 60,
          column: 23
        },
        end: {
          line: 60,
          column: 42
        }
      },
      "39": {
        start: {
          line: 61,
          column: 16
        },
        end: {
          line: 61,
          column: 136
        }
      },
      "40": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 70,
          column: 7
        }
      },
      "41": {
        start: {
          line: 63,
          column: 24
        },
        end: {
          line: 63,
          column: 69
        }
      },
      "42": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 69,
          column: 9
        }
      },
      "43": {
        start: {
          line: 65,
          column: 12
        },
        end: {
          line: 65,
          column: 42
        }
      },
      "44": {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 44
        }
      },
      "45": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 31
        }
      },
      "46": {
        start: {
          line: 73,
          column: 0
        },
        end: {
          line: 73,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 20
          },
          end: {
            line: 20,
            column: 21
          }
        },
        loc: {
          start: {
            line: 20,
            column: 38
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 20
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 22
          },
          end: {
            line: 37,
            column: 23
          }
        },
        loc: {
          start: {
            line: 37,
            column: 40
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 22
          }
        },
        loc: {
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 54
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 62,
            column: 22
          },
          end: {
            line: 62,
            column: 23
          }
        },
        loc: {
          start: {
            line: 62,
            column: 35
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 62
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 57,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 57,
            column: 15
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 57,
            column: 15
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 59,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 59,
            column: 15
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 59,
            column: 15
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }, {
          start: {
            line: 64,
            column: 8
          },
          end: {
            line: 69,
            column: 9
          }
        }],
        line: 64
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/set-full-screen.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/set-full-screen.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;AAGH,kEAAoC;AAEpC,+CAA4C;AAE5C,IAAM,kBAAkB,GAAG,qBAAqB,CAAA,CAAC,eAAe;AAChE,IAAM,sBAAsB,GAAG,0BAA0B,CAAA,CAAC,iBAAiB;AAC3E,IAAM,qBAAqB,GAAG,wBAAwB,CAAA,CAAC,iBAAiB;AAExE;;;GAGG;AACI,IAAM,aAAa,GAAG,UAAC,MAAc;IACxC,IAAM,aAAa,GAAG,kBAAC,CAAC,MAAM,CAAC,eAAe,CAAC,CAAA;IAC/C,IAAM,kBAAkB,GAAG,MAAM,CAAC,kBAAkB,CAAA;IACpD,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;IACxC,IAAM,SAAS,GAAG,YAAY,CAAC,IAAI,CAAC,OAAK,kBAAoB,CAAC,CAAA;IAC9D,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAE5B,SAAS,CAAC,WAAW,CAAC,kBAAkB,CAAC,CAAA;IACzC,SAAS,CAAC,QAAQ,CAAC,sBAAsB,CAAC,CAAA;IAC1C,aAAa,CAAC,QAAQ,CAAC,qBAAqB,CAAC,CAAA;IAC7C,aAAa,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,gBAAgB,CAAC,CAAA;IACrD,kBAAkB,CAAC,GAAG,CAAC,QAAQ,EAAE,MAAM,CAAC,CAAA;AAC5C,CAAC,CAAA;AAZY,QAAA,aAAa,iBAYzB;AAED;;;GAGG;AACI,IAAM,eAAe,GAAG,UAAC,MAAc;IAC1C,IAAM,aAAa,GAAG,kBAAC,CAAC,MAAM,CAAC,eAAe,CAAC,CAAA;IAC/C,IAAM,kBAAkB,GAAG,MAAM,CAAC,kBAAkB,CAAA;IACpD,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;IACxC,IAAM,SAAS,GAAG,YAAY,CAAC,IAAI,CAAC,OAAK,sBAAwB,CAAC,CAAA;IAClE,IAAM,MAAM,GAAG,MAAM,CAAC,MAAM,CAAA;IAE5B,SAAS,CAAC,WAAW,CAAC,sBAAsB,CAAC,CAAA;IAC7C,SAAS,CAAC,QAAQ,CAAC,kBAAkB,CAAC,CAAA;IACtC,aAAa,CAAC,WAAW,CAAC,qBAAqB,CAAC,CAAA;IAChD,aAAa,CAAC,GAAG,CAAC,SAAS,EAAE,MAAM,CAAC,CAAA;IACpC,kBAAkB,CAAC,GAAG,CAAC,QAAQ,EAAE,MAAM,CAAC,MAAM,GAAG,IAAI,CAAC,CAAA;AAC1D,CAAC,CAAA;AAZY,QAAA,eAAe,mBAY3B;AAED;;;GAGG;AACH,IAAM,cAAc,GAAG,UAAC,MAAc;IAClC,sDAAsD;IACtD,IAAI,MAAM,CAAC,YAAY;QAAE,OAAM;IAC/B,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,cAAc;QAAE,OAAM;IACzC,IAAM,YAAY,GAAG,MAAM,CAAC,YAAY,CAAA;IACxC,IAAM,KAAK,GAAG,kBAAC,CACX,sDACgB,kBAAkB,4BAC3B,CACV,CAAA;IACD,KAAK,CAAC,EAAE,CAAC,OAAO,EAAE,UAAU,CAAa;QACrC,IAAM,SAAS,GAAG,kBAAC,CAAC,CAAC,CAAC,aAAa,CAAC,CAAC,IAAI,CAAC,GAAG,CAAC,CAAA;QAC9C,IAAI,SAAS,CAAC,QAAQ,CAAC,kBAAkB,CAAC,EAAE;YACxC,qBAAa,CAAC,MAAM,CAAC,CAAA;SACxB;aAAM;YACH,uBAAe,CAAC,MAAM,CAAC,CAAA;SAC1B;IACL,CAAC,CAAC,CAAA;IAEF,YAAY,CAAC,MAAM,CAAC,KAAK,CAAC,CAAA;AAC9B,CAAC,CAAA;AAED,kBAAe,cAAc,CAAA",
      sourcesContent: ["/**\n * @description \u5168\u5C4F\u529F\u80FD\n * @author xiaokyo\n */\n\nimport Editor from '../index'\nimport $ from '../../utils/dom-core'\n\nimport '../../assets/style/full-screen.less'\n\nconst iconFullScreenText = 'w-e-icon-fullscreen' // \u5168\u5C4Ficon class\nconst iconExitFullScreenText = 'w-e-icon-fullscreen_exit' // \u9000\u51FA\u5168\u5C4Ficon class\nconst classfullScreenEditor = 'w-e-full-screen-editor' // \u5168\u5C4F\u6DFB\u52A0\u81F3\u7F16\u8F91\u5668\u7684class\n\n/**\n * \u8BBE\u7F6E\u5168\u5C4F\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport const setFullScreen = (editor: Editor) => {\n    const $editorParent = $(editor.toolbarSelector)\n    const $textContainerElem = editor.$textContainerElem\n    const $toolbarElem = editor.$toolbarElem\n    const $iconElem = $toolbarElem.find(`i.${iconFullScreenText}`)\n    const config = editor.config\n\n    $iconElem.removeClass(iconFullScreenText)\n    $iconElem.addClass(iconExitFullScreenText)\n    $editorParent.addClass(classfullScreenEditor)\n    $editorParent.css('z-index', config.zIndexFullScreen)\n    $textContainerElem.css('height', '100%')\n}\n\n/**\n * \u53D6\u6D88\u5168\u5C4F\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nexport const setUnFullScreen = (editor: Editor) => {\n    const $editorParent = $(editor.toolbarSelector)\n    const $textContainerElem = editor.$textContainerElem\n    const $toolbarElem = editor.$toolbarElem\n    const $iconElem = $toolbarElem.find(`i.${iconExitFullScreenText}`)\n    const config = editor.config\n\n    $iconElem.removeClass(iconExitFullScreenText)\n    $iconElem.addClass(iconFullScreenText)\n    $editorParent.removeClass(classfullScreenEditor)\n    $editorParent.css('z-index', 'auto')\n    $textContainerElem.css('height', config.height + 'px')\n}\n\n/**\n * \u521D\u59CB\u5316\u5168\u5C4F\u529F\u80FD\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n */\nconst initFullScreen = (editor: Editor) => {\n    // \u5F53textSelector\u6709\u503C\u7684\u65F6\u5019\uFF0C\u4E5F\u5C31\u662F\u7F16\u8F91\u5668\u662F\u5DE5\u5177\u680F\u548C\u7F16\u8F91\u533A\u57DF\u5206\u79BB\u7684\u60C5\u51B5\uFF0C \u5219\u4E0D\u751F\u6210\u5168\u5C4F\u529F\u80FD\u6309\u94AE\n    if (editor.textSelector) return\n    if (!editor.config.showFullScreen) return\n    const $toolbarElem = editor.$toolbarElem\n    const $elem = $(\n        `<div class=\"w-e-menu\">\n            <i class=\"${iconFullScreenText}\"></i>\n        </div>`\n    )\n    $elem.on('click', function (e: MouseEvent) {\n        const $elemIcon = $(e.currentTarget).find('i')\n        if ($elemIcon.hasClass(iconFullScreenText)) {\n            setFullScreen(editor)\n        } else {\n            setUnFullScreen(editor)\n        }\n    })\n\n    $toolbarElem.append($elem)\n}\n\nexport default initFullScreen\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c32e3bcd32bad8e36d70da56cbfd932a89983805"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_15x388lvm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_15x388lvm();

var __importDefault = (cov_15x388lvm().s[0]++, (cov_15x388lvm().b[0][0]++, void 0) && (cov_15x388lvm().b[0][1]++, (void 0).__importDefault) || (cov_15x388lvm().b[0][2]++, function (mod) {
  cov_15x388lvm().f[0]++;
  cov_15x388lvm().s[1]++;
  return (cov_15x388lvm().b[2][0]++, mod) && (cov_15x388lvm().b[2][1]++, mod.__esModule) ? (cov_15x388lvm().b[1][0]++, mod) : (cov_15x388lvm().b[1][1]++, {
    "default": mod
  });
}));

cov_15x388lvm().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_15x388lvm().s[3]++;
exports.setUnFullScreen = exports.setFullScreen = void 0;
var dom_core_1 = (cov_15x388lvm().s[4]++, __importDefault(__webpack_require__(2)));
cov_15x388lvm().s[5]++;

__webpack_require__(381);

var iconFullScreenText = (cov_15x388lvm().s[6]++, 'w-e-icon-fullscreen'); // 全屏icon class

var iconExitFullScreenText = (cov_15x388lvm().s[7]++, 'w-e-icon-fullscreen_exit'); // 退出全屏icon class

var classfullScreenEditor = (cov_15x388lvm().s[8]++, 'w-e-full-screen-editor'); // 全屏添加至编辑器的class

/**
 * 设置全屏
 * @param editor 编辑器实例
 */

cov_15x388lvm().s[9]++;

var setFullScreen = function setFullScreen(editor) {
  cov_15x388lvm().f[1]++;
  var $editorParent = (cov_15x388lvm().s[10]++, dom_core_1["default"](editor.toolbarSelector));
  var $textContainerElem = (cov_15x388lvm().s[11]++, editor.$textContainerElem);
  var $toolbarElem = (cov_15x388lvm().s[12]++, editor.$toolbarElem);
  var $iconElem = (cov_15x388lvm().s[13]++, (0, _find["default"])($toolbarElem).call($toolbarElem, "i." + iconFullScreenText));
  var config = (cov_15x388lvm().s[14]++, editor.config);
  cov_15x388lvm().s[15]++;
  $iconElem.removeClass(iconFullScreenText);
  cov_15x388lvm().s[16]++;
  $iconElem.addClass(iconExitFullScreenText);
  cov_15x388lvm().s[17]++;
  $editorParent.addClass(classfullScreenEditor);
  cov_15x388lvm().s[18]++;
  $editorParent.css('z-index', config.zIndexFullScreen);
  cov_15x388lvm().s[19]++;
  $textContainerElem.css('height', '100%');
};

cov_15x388lvm().s[20]++;
exports.setFullScreen = setFullScreen;
/**
 * 取消全屏
 * @param editor 编辑器实例
 */

cov_15x388lvm().s[21]++;

var setUnFullScreen = function setUnFullScreen(editor) {
  cov_15x388lvm().f[2]++;
  var $editorParent = (cov_15x388lvm().s[22]++, dom_core_1["default"](editor.toolbarSelector));
  var $textContainerElem = (cov_15x388lvm().s[23]++, editor.$textContainerElem);
  var $toolbarElem = (cov_15x388lvm().s[24]++, editor.$toolbarElem);
  var $iconElem = (cov_15x388lvm().s[25]++, (0, _find["default"])($toolbarElem).call($toolbarElem, "i." + iconExitFullScreenText));
  var config = (cov_15x388lvm().s[26]++, editor.config);
  cov_15x388lvm().s[27]++;
  $iconElem.removeClass(iconExitFullScreenText);
  cov_15x388lvm().s[28]++;
  $iconElem.addClass(iconFullScreenText);
  cov_15x388lvm().s[29]++;
  $editorParent.removeClass(classfullScreenEditor);
  cov_15x388lvm().s[30]++;
  $editorParent.css('z-index', 'auto');
  cov_15x388lvm().s[31]++;
  $textContainerElem.css('height', config.height + 'px');
};

cov_15x388lvm().s[32]++;
exports.setUnFullScreen = setUnFullScreen;
/**
 * 初始化全屏功能
 * @param editor 编辑器实例
 */

cov_15x388lvm().s[33]++;

var initFullScreen = function initFullScreen(editor) {
  cov_15x388lvm().f[3]++;
  cov_15x388lvm().s[34]++;

  // 当textSelector有值的时候，也就是编辑器是工具栏和编辑区域分离的情况， 则不生成全屏功能按钮
  if (editor.textSelector) {
    cov_15x388lvm().b[3][0]++;
    cov_15x388lvm().s[35]++;
    return;
  } else {
    cov_15x388lvm().b[3][1]++;
  }

  cov_15x388lvm().s[36]++;

  if (!editor.config.showFullScreen) {
    cov_15x388lvm().b[4][0]++;
    cov_15x388lvm().s[37]++;
    return;
  } else {
    cov_15x388lvm().b[4][1]++;
  }

  var $toolbarElem = (cov_15x388lvm().s[38]++, editor.$toolbarElem);
  var $elem = (cov_15x388lvm().s[39]++, dom_core_1["default"]("<div class=\"w-e-menu\">\n            <i class=\"" + iconFullScreenText + "\"></i>\n        </div>"));
  cov_15x388lvm().s[40]++;
  $elem.on('click', function (e) {
    var _context;

    cov_15x388lvm().f[4]++;
    var $elemIcon = (cov_15x388lvm().s[41]++, (0, _find["default"])(_context = dom_core_1["default"](e.currentTarget)).call(_context, 'i'));
    cov_15x388lvm().s[42]++;

    if ($elemIcon.hasClass(iconFullScreenText)) {
      cov_15x388lvm().b[5][0]++;
      cov_15x388lvm().s[43]++;
      exports.setFullScreen(editor);
    } else {
      cov_15x388lvm().b[5][1]++;
      cov_15x388lvm().s[44]++;
      exports.setUnFullScreen(editor);
    }
  });
  cov_15x388lvm().s[45]++;
  $toolbarElem.append($elem);
};

cov_15x388lvm().s[46]++;
exports["default"] = initFullScreen;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(382);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-full-screen-editor {\n  position: fixed;\n  width: 100%!important;\n  height: 100%!important;\n  left: 0;\n  top: 0;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 滚动到指定锚点
 * @author zhengwenjian
 */

var _interopRequireDefault = __webpack_require__(0);

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1whyzhf4wu() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/scroll-to-head.ts";
  var hash = "1ad93225239eb1f374cc26fa55c52832499dcf54";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/scroll-to-head.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 12,
          column: 19
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "2": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 36
        }
      },
      "3": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 57
        }
      },
      "4": {
        start: {
          line: 15,
          column: 20
        },
        end: {
          line: 15,
          column: 51
        }
      },
      "5": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 35
        }
      },
      "6": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 19
          },
          end: {
            line: 12,
            column: 20
          }
        },
        loc: {
          start: {
            line: 12,
            column: 41
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 12
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/scroll-to-head.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/init-fns/scroll-to-head.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAIH;;;;GAIG;AACH,IAAM,YAAY,GAAG,UAAC,MAAc,EAAE,EAAU;IAC5C,IAAM,SAAS,GAAG,MAAM,CAAC,SAAS,CAAA;IAClC,IAAM,WAAW,GAAG,SAAS,CAAC,IAAI,CAAC,UAAQ,EAAE,OAAI,CAAC,CAAA;IAClD,IAAM,SAAS,GAAG,WAAW,CAAC,aAAa,EAAE,CAAC,GAAG,CAAA;IACjD,SAAS,CAAC,SAAS,CAAC,SAAS,CAAC,CAAA;AAClC,CAAC,CAAA;AAED,kBAAe,YAAY,CAAA",
      sourcesContent: ["/**\n * @description \u6EDA\u52A8\u5230\u6307\u5B9A\u951A\u70B9\n * @author zhengwenjian\n */\n\nimport Editor from '../index'\n\n/**\n * \u7F16\u8F91\u5668\u6EDA\u52A8\u5230\u6307\u5B9A\u951A\u70B9\n * @param editor \u7F16\u8F91\u5668\u5B9E\u4F8B\n * @param id \u6807\u9898\u951A\u70B9id\n */\nconst scrollToHead = (editor: Editor, id: string) => {\n    const $textElem = editor.$textElem\n    const $targetHead = $textElem.find(`[id='${id}']`)\n    const targetTop = $targetHead.getOffsetData().top\n    $textElem.scrollTop(targetTop)\n}\n\nexport default scrollToHead\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1ad93225239eb1f374cc26fa55c52832499dcf54"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1whyzhf4wu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1whyzhf4wu();
cov_1whyzhf4wu().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * 编辑器滚动到指定锚点
 * @param editor 编辑器实例
 * @param id 标题锚点id
 */

cov_1whyzhf4wu().s[1]++;

var scrollToHead = function scrollToHead(editor, id) {
  cov_1whyzhf4wu().f[0]++;
  var $textElem = (cov_1whyzhf4wu().s[2]++, editor.$textElem);
  var $targetHead = (cov_1whyzhf4wu().s[3]++, (0, _find["default"])($textElem).call($textElem, "[id='" + id + "']"));
  var targetTop = (cov_1whyzhf4wu().s[4]++, $targetHead.getOffsetData().top);
  cov_1whyzhf4wu().s[5]++;
  $textElem.scrollTop(targetTop);
};

cov_1whyzhf4wu().s[6]++;
exports["default"] = scrollToHead;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_kc1i8b1wk() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/z-index/index.ts";
  var hash = "02fade86dee7c9ddc2180618ef9f4af9eedc74bc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/z-index/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 14
        },
        end: {
          line: 6,
          column: 60
        }
      },
      "4": {
        start: {
          line: 7,
          column: 11
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "5": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "6": {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 17,
          column: 25
        }
      },
      "7": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 49
        }
      },
      "8": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 27,
          column: 6
        }
      },
      "9": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 25,
          column: 9
        }
      },
      "10": {
        start: {
          line: 24,
          column: 12
        },
        end: {
          line: 24,
          column: 57
        }
      },
      "11": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 31
        }
      },
      "12": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      "13": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "14": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 51
        }
      },
      "15": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 18
        }
      },
      "16": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 28
          },
          end: {
            line: 14,
            column: 29
          }
        },
        loc: {
          start: {
            line: 14,
            column: 40
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "ZIndex",
        decl: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 15
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 27
          },
          end: {
            line: 22,
            column: 28
          }
        },
        loc: {
          start: {
            line: 22,
            column: 47
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 29,
            column: 28
          },
          end: {
            line: 29,
            column: 29
          }
        },
        loc: {
          start: {
            line: 29,
            column: 46
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 29
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 25,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 25,
            column: 9
          }
        }, {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 25,
            column: 9
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 23,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 12
          },
          end: {
            line: 23,
            column: 20
          }
        }, {
          start: {
            line: 23,
            column: 24
          },
          end: {
            line: 23,
            column: 43
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/z-index/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/z-index/index.ts"],
      names: [],
      mappings: ";;;;;AAKA,6DAAsC;AAEtC,IAAM,IAAI,GAAG;IACT,IAAI,EAAE,CAAC;IACP,KAAK,EAAE,CAAC;IACR,OAAO,EAAE,CAAC;IACV,OAAO,EAAE,CAAC;IACV,aAAa,EAAE,CAAC;CACnB,CAAA;AAKD;IAAA;QACI,OAAO;QACC,SAAI,GAAS,IAAI,CAAA;QAEzB,MAAM;QACE,eAAU,GAAG,eAAK,CAAC,MAAM,CAAA;IAgBrC,CAAC;IAdG,6DAA6D;IAC7D,oBAAG,GAAH,UAAI,QAAkB;QAClB,IAAI,QAAQ,IAAI,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,EAAE;YACjC,OAAO,IAAI,CAAC,UAAU,GAAG,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;SAC/C;QACD,OAAO,IAAI,CAAC,UAAU,CAAA;IAC1B,CAAC;IAED,MAAM;IACN,qBAAI,GAAJ,UAAK,MAAc;QACf,IAAI,IAAI,CAAC,UAAU,IAAI,eAAK,CAAC,MAAM,EAAE;YACjC,IAAI,CAAC,UAAU,GAAG,MAAM,CAAC,MAAM,CAAC,MAAM,CAAA;SACzC;IACL,CAAC;IACL,aAAC;AAAD,CAAC,AArBD,IAqBC",
      sourcesContent: ["/**\n * @description z-index \u7BA1\u7406\u5668\n * @author fangzhicong\n */\nimport Editor from '../index'\nimport style from '../../config/style'\n\nconst tier = {\n    menu: 2, // \u663E\u793A\u72B6\u6001\u4E0B\u7684\u83DC\u5355\u680F\n    panel: 2,\n    toolbar: 1, // \u83DC\u5355\u680F\u7236\u5BB9\u5668\n    tooltip: 1, // tooltip\n    textContainer: 1, // \u7F16\u8F91\u533A\u57DF\n}\n\ntype Tier = typeof tier\n\ntype TierKey = keyof Tier\nexport default class ZIndex {\n    // \u5C42\u7EA7\u53C2\u6570\n    private tier: Tier = tier\n\n    // \u9ED8\u8BA4\u503C\n    private baseZIndex = style.zIndex\n\n    // \u83B7\u53D6 tierName \u5BF9\u5E94\u7684 z-index \u7684\u503C\u3002\u5982\u679C tierName \u672A\u5B9A\u4E49\u5219\u8FD4\u56DE\u9ED8\u8BA4\u7684 z-index \u503C\n    get(tierName?: TierKey): number {\n        if (tierName && this.tier[tierName]) {\n            return this.baseZIndex + this.tier[tierName]\n        }\n        return this.baseZIndex\n    }\n\n    // \u521D\u59CB\u5316\n    init(editor: Editor) {\n        if (this.baseZIndex == style.zIndex) {\n            this.baseZIndex = editor.config.zIndex\n        }\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "02fade86dee7c9ddc2180618ef9f4af9eedc74bc"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kc1i8b1wk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_kc1i8b1wk();

var __importDefault = (cov_kc1i8b1wk().s[0]++, (cov_kc1i8b1wk().b[0][0]++, void 0) && (cov_kc1i8b1wk().b[0][1]++, (void 0).__importDefault) || (cov_kc1i8b1wk().b[0][2]++, function (mod) {
  cov_kc1i8b1wk().f[0]++;
  cov_kc1i8b1wk().s[1]++;
  return (cov_kc1i8b1wk().b[2][0]++, mod) && (cov_kc1i8b1wk().b[2][1]++, mod.__esModule) ? (cov_kc1i8b1wk().b[1][0]++, mod) : (cov_kc1i8b1wk().b[1][1]++, {
    "default": mod
  });
}));

cov_kc1i8b1wk().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var style_1 = (cov_kc1i8b1wk().s[3]++, __importDefault(__webpack_require__(121)));
var tier = (cov_kc1i8b1wk().s[4]++, {
  menu: 2,
  panel: 2,
  toolbar: 1,
  tooltip: 1,
  textContainer: 1
});
var ZIndex = (
/** @class */
cov_kc1i8b1wk().s[5]++, function () {
  cov_kc1i8b1wk().f[1]++;

  function ZIndex() {
    cov_kc1i8b1wk().f[2]++;
    cov_kc1i8b1wk().s[6]++;
    // 层级参数
    this.tier = tier; // 默认值

    cov_kc1i8b1wk().s[7]++;
    this.baseZIndex = style_1["default"].zIndex;
  } // 获取 tierName 对应的 z-index 的值。如果 tierName 未定义则返回默认的 z-index 值


  cov_kc1i8b1wk().s[8]++;

  ZIndex.prototype.get = function (tierName) {
    cov_kc1i8b1wk().f[3]++;
    cov_kc1i8b1wk().s[9]++;

    if ((cov_kc1i8b1wk().b[4][0]++, tierName) && (cov_kc1i8b1wk().b[4][1]++, this.tier[tierName])) {
      cov_kc1i8b1wk().b[3][0]++;
      cov_kc1i8b1wk().s[10]++;
      return this.baseZIndex + this.tier[tierName];
    } else {
      cov_kc1i8b1wk().b[3][1]++;
    }

    cov_kc1i8b1wk().s[11]++;
    return this.baseZIndex;
  }; // 初始化


  cov_kc1i8b1wk().s[12]++;

  ZIndex.prototype.init = function (editor) {
    cov_kc1i8b1wk().f[4]++;
    cov_kc1i8b1wk().s[13]++;

    if (this.baseZIndex == style_1["default"].zIndex) {
      cov_kc1i8b1wk().b[5][0]++;
      cov_kc1i8b1wk().s[14]++;
      this.baseZIndex = editor.config.zIndex;
    } else {
      cov_kc1i8b1wk().b[5][1]++;
    }
  };

  cov_kc1i8b1wk().s[15]++;
  return ZIndex;
}());
cov_kc1i8b1wk().s[16]++;
exports["default"] = ZIndex;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 编辑器 change 事件
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _filter = _interopRequireDefault(__webpack_require__(87));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_we3p0p7rd() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/change/index.ts";
  var hash = "3dcfc5ae942a67a7bf94bd4bd0251c26dd2702ff";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/change/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 17
        },
        end: {
          line: 23,
          column: 74
        }
      },
      "16": {
        start: {
          line: 24,
          column: 13
        },
        end: {
          line: 24,
          column: 40
        }
      },
      "17": {
        start: {
          line: 25,
          column: 14
        },
        end: {
          line: 25,
          column: 42
        }
      },
      "18": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 37,
          column: 7
        }
      },
      "19": {
        start: {
          line: 34,
          column: 19
        },
        end: {
          line: 34,
          column: 26
        }
      },
      "20": {
        start: {
          line: 34,
          column: 37
        },
        end: {
          line: 34,
          column: 46
        }
      },
      "21": {
        start: {
          line: 34,
          column: 64
        },
        end: {
          line: 34,
          column: 80
        }
      },
      "22": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 36,
          column: 93
        }
      },
      "23": {
        start: {
          line: 42,
          column: 28
        },
        end: {
          line: 109,
          column: 21
        }
      },
      "24": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 30
        }
      },
      "25": {
        start: {
          line: 45,
          column: 20
        },
        end: {
          line: 62,
          column: 18
        }
      },
      "26": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 68
        }
      },
      "27": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 56
        }
      },
      "28": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 61,
          column: 13
        }
      },
      "29": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 56,
          column: 17
        }
      },
      "30": {
        start: {
          line: 55,
          column: 20
        },
        end: {
          line: 55,
          column: 45
        }
      },
      "31": {
        start: {
          line: 60,
          column: 16
        },
        end: {
          line: 60,
          column: 34
        }
      },
      "32": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 63,
          column: 30
        }
      },
      "33": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 24
        }
      },
      "34": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 43
        }
      },
      "35": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 21
        }
      },
      "36": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 86,
          column: 6
        }
      },
      "37": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 85,
          column: 9
        }
      },
      "38": {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 81,
          column: 48
        }
      },
      "39": {
        start: {
          line: 83,
          column: 12
        },
        end: {
          line: 83,
          column: 33
        }
      },
      "40": {
        start: {
          line: 84,
          column: 12
        },
        end: {
          line: 84,
          column: 24
        }
      },
      "41": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 93,
          column: 6
        }
      },
      "42": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 88
        }
      },
      "43": {
        start: {
          line: 92,
          column: 72
        },
        end: {
          line: 92,
          column: 84
        }
      },
      "44": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 107,
          column: 6
        }
      },
      "45": {
        start: {
          line: 96,
          column: 20
        },
        end: {
          line: 96,
          column: 24
        }
      },
      "46": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 76
        }
      },
      "47": {
        start: {
          line: 98,
          column: 22
        },
        end: {
          line: 98,
          column: 56
        }
      },
      "48": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 101,
          column: 20
        }
      },
      "49": {
        start: {
          line: 100,
          column: 12
        },
        end: {
          line: 100,
          column: 25
        }
      },
      "50": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 106,
          column: 9
        }
      },
      "51": {
        start: {
          line: 103,
          column: 12
        },
        end: {
          line: 105,
          column: 15
        }
      },
      "52": {
        start: {
          line: 104,
          column: 16
        },
        end: {
          line: 104,
          column: 34
        }
      },
      "53": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 18
        }
      },
      "54": {
        start: {
          line: 110,
          column: 0
        },
        end: {
          line: 110,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "mutationsFilter",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 24
          }
        },
        loc: {
          start: {
            line: 31,
            column: 41
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 31
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 33,
            column: 28
          },
          end: {
            line: 33,
            column: 29
          }
        },
        loc: {
          start: {
            line: 33,
            column: 42
          },
          end: {
            line: 37,
            column: 5
          }
        },
        line: 33
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 42,
            column: 28
          },
          end: {
            line: 42,
            column: 29
          }
        },
        loc: {
          start: {
            line: 42,
            column: 46
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 42
      },
      "10": {
        name: "Change",
        decl: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 44,
            column: 19
          }
        },
        loc: {
          start: {
            line: 44,
            column: 28
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 44
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 45,
            column: 38
          },
          end: {
            line: 45,
            column: 39
          }
        },
        loc: {
          start: {
            line: 45,
            column: 69
          },
          end: {
            line: 62,
            column: 9
          }
        },
        line: 45
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 77,
            column: 28
          },
          end: {
            line: 77,
            column: 29
          }
        },
        loc: {
          start: {
            line: 77,
            column: 40
          },
          end: {
            line: 86,
            column: 5
          }
        },
        line: 77
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 90,
            column: 28
          },
          end: {
            line: 90,
            column: 29
          }
        },
        loc: {
          start: {
            line: 90,
            column: 40
          },
          end: {
            line: 93,
            column: 5
          }
        },
        line: 90
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 92,
            column: 56
          },
          end: {
            line: 92,
            column: 57
          }
        },
        loc: {
          start: {
            line: 92,
            column: 70
          },
          end: {
            line: 92,
            column: 86
          }
        },
        line: 92
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 95,
            column: 31
          },
          end: {
            line: 95,
            column: 32
          }
        },
        loc: {
          start: {
            line: 95,
            column: 43
          },
          end: {
            line: 107,
            column: 5
          }
        },
        line: 95
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 99,
            column: 41
          },
          end: {
            line: 99,
            column: 42
          }
        },
        loc: {
          start: {
            line: 99,
            column: 53
          },
          end: {
            line: 101,
            column: 9
          }
        },
        line: 99
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 103,
            column: 55
          },
          end: {
            line: 103,
            column: 56
          }
        },
        loc: {
          start: {
            line: 103,
            column: 67
          },
          end: {
            line: 105,
            column: 13
          }
        },
        line: 103
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 36,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 16
          },
          end: {
            line: 35,
            column: 36
          }
        }, {
          start: {
            line: 36,
            column: 13
          },
          end: {
            line: 36,
            column: 33
          }
        }, {
          start: {
            line: 36,
            column: 38
          },
          end: {
            line: 36,
            column: 72
          }
        }, {
          start: {
            line: 36,
            column: 76
          },
          end: {
            line: 36,
            column: 89
          }
        }],
        line: 35
      },
      "8": {
        loc: {
          start: {
            line: 45,
            column: 20
          },
          end: {
            line: 62,
            column: 18
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 20
          },
          end: {
            line: 62,
            column: 10
          }
        }, {
          start: {
            line: 62,
            column: 14
          },
          end: {
            line: 62,
            column: 18
          }
        }],
        line: 45
      },
      "9": {
        loc: {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        }, {
          start: {
            line: 52,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        }],
        line: 52
      },
      "10": {
        loc: {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }, {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 56,
            column: 17
          }
        }],
        line: 54
      },
      "11": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 85,
            column: 9
          }
        }],
        line: 79
      },
      "12": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }, {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 106,
            column: 9
          }
        }],
        line: 102
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/change/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/change/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAGH,2EAAoD;AACpD,yCAA2C;AAC3C,2CAA4C;AAE5C;;;;GAIG;AACH,SAAS,eAAe,CAAC,SAA2B,EAAE,GAAS;IAC3D,8CAA8C;IAC9C,OAAO,SAAS,CAAC,MAAM,CAAC,UAAC,EAA+B;YAA7B,IAAI,UAAA,EAAE,MAAM,YAAA,EAAE,aAAa,mBAAA;QAClD,OAAO,CACH,IAAI,IAAI,YAAY;YACpB,CAAC,IAAI,IAAI,YAAY,IAAI,CAAC,aAAa,IAAI,iBAAiB,IAAI,MAAM,IAAI,GAAG,CAAC,CAAC,CAClF,CAAA;IACL,CAAC,CAAC,CAAA;AACN,CAAC;AAED;;GAEG;AACH;IAAoC,0BAAQ;IAWxC,gBAAmB,MAAc;QAAjC,YACI,kBAAM,UAAC,SAAS,EAAE,QAAQ;;YACtB,OAAO;YACP,SAAS,GAAG,eAAe,CAAC,SAAS,EAAE,QAAQ,CAAC,MAAc,CAAC,CAAA;YAE/D,OAAO;YACP,CAAA,KAAA,KAAI,CAAC,IAAI,CAAA,CAAC,IAAI,WAAI,SAAS,EAAC;YAE5B,QAAQ;YACR,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;gBAC1B,kBAAkB;gBAClB,IAAI,CAAC,MAAM,CAAC,WAAW,EAAE;oBACrB,OAAO,KAAI,CAAC,SAAS,EAAE,CAAA;iBAC1B;aACJ;YACD,QAAQ;iBACH;gBACD,KAAI,CAAC,SAAS,EAAE,CAAA;aACnB;QACL,CAAC,CAAC,SACL;QApBkB,YAAM,GAAN,MAAM,CAAQ;QAVjC;;WAEG;QACK,UAAI,GAAqB,EAAE,CAAA;QAEnC;;WAEG;QACK,eAAS,GAAa,gBAAQ,CAAA;;IAsBtC,CAAC;IAED;;OAEG;IACK,qBAAI,GAAZ;QACI,MAAM;QACN,IAAI,IAAI,CAAC,IAAI,CAAC,MAAM,EAAE;YAClB,SAAS;YACT,IAAI,CAAC,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YAEnC,OAAO;YACP,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,CAAA;YAEpB,IAAI,CAAC,IAAI,EAAE,CAAA;SACd;IACL,CAAC;IAED;;OAEG;IACI,qBAAI,GAAX;QACI,iBAAiB;QACjB,IAAI,CAAC,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,OAAO,CAAC,UAAA,EAAE,IAAI,OAAA,EAAE,EAAE,EAAJ,CAAI,CAAC,CAAA;IAC/D,CAAC;IAED,aAAa;IACN,wBAAO,GAAd;QAAA,iBAaC;QAZG,iBAAM,OAAO,YAAC,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAA;QAE7C,IAAI,OAAO,GAAG,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,eAAe,CAAA;QAChD,IAAI,CAAC,SAAS,GAAG,eAAQ,CAAC;YACtB,KAAI,CAAC,IAAI,EAAE,CAAA;QACf,CAAC,EAAE,OAAO,CAAC,CAAA;QAEX,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;YAC/B,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,EAAE,CAAC,gBAAgB,EAAE;gBACvC,KAAI,CAAC,SAAS,EAAE,CAAA;YACpB,CAAC,CAAC,CAAA;SACL;IACL,CAAC;IACL,aAAC;AAAD,CAAC,AAxED,CAAoC,kBAAQ,GAwE3C",
      sourcesContent: ["/**\n * @description \u7F16\u8F91\u5668 change \u4E8B\u4EF6\n * @author fangzhicong\n */\n\nimport Editor from '../index'\nimport Mutation from '../../utils/observer/mutation'\nimport { debounce } from '../../utils/util'\nimport { EMPTY_FN } from '../../utils/const'\n\n/**\n * \u5254\u9664\u7F16\u8F91\u533A\u5BB9\u5668\u7684 attribute \u53D8\u5316\u4E2D\u7684\u975E contenteditable \u53D8\u5316\n * @param mutations MutationRecord[]\n * @param tar \u7F16\u8F91\u533A\u5BB9\u5668\u7684 DOM \u8282\u70B9\n */\nfunction mutationsFilter(mutations: MutationRecord[], tar: Node) {\n    // \u5254\u9664\u7F16\u8F91\u533A\u5BB9\u5668\u7684 attribute \u53D8\u5316\u4E2D\u7684\u975E contenteditable \u53D8\u5316\n    return mutations.filter(({ type, target, attributeName }) => {\n        return (\n            type != 'attributes' ||\n            (type == 'attributes' && (attributeName == 'contenteditable' || target != tar))\n        )\n    })\n}\n\n/**\n * Change \u5B9E\u73B0\n */\nexport default class Change extends Mutation {\n    /**\n     * \u53D8\u5316\u7684\u6570\u636E\u96C6\u5408\n     */\n    private data: MutationRecord[] = []\n\n    /**\n     * \u5F02\u6B65\u4FDD\u5B58\u6570\u636E\n     */\n    private asyncSave: Function = EMPTY_FN\n\n    constructor(public editor: Editor) {\n        super((mutations, observer) => {\n            // \u6570\u636E\u8FC7\u6EE4\n            mutations = mutationsFilter(mutations, observer.target as Node)\n\n            // \u5B58\u50A8\u6570\u636E\n            this.data.push(...mutations)\n\n            // \u6807\u51C6\u6A21\u5F0F\u4E0B\n            if (!editor.isCompatibleMode) {\n                // \u5728\u975E\u4E2D\u6587\u8F93\u5165\u72B6\u6001\u4E0B\u65F6\u624D\u4FDD\u5B58\u6570\u636E\n                if (!editor.isComposing) {\n                    return this.asyncSave()\n                }\n            }\n            // \u517C\u5BB9\u6A21\u5F0F\u4E0B\n            else {\n                this.asyncSave()\n            }\n        })\n    }\n\n    /**\n     * \u4FDD\u5B58\u53D8\u5316\u7684\u6570\u636E\u5E76\u53D1\u5E03 change event\n     */\n    private save() {\n        // \u6709\u6570\u636E\n        if (this.data.length) {\n            // \u4FDD\u5B58\u53D8\u5316\u6570\u636E\n            this.editor.history.save(this.data)\n\n            // \u6E05\u9664\u7F13\u5B58\n            this.data.length = 0\n\n            this.emit()\n        }\n    }\n\n    /**\n     * \u53D1\u5E03 change event\n     */\n    public emit() {\n        // \u6267\u884C onchange \u56DE\u8C03\n        this.editor.txt.eventHooks.changeEvents.forEach(fn => fn())\n    }\n\n    // \u91CD\u5199 observe\n    public observe() {\n        super.observe(this.editor.$textElem.elems[0])\n\n        let timeout = this.editor.config.onchangeTimeout\n        this.asyncSave = debounce(() => {\n            this.save()\n        }, timeout)\n\n        if (!this.editor.isCompatibleMode) {\n            this.editor.$textElem.on('compositionend', () => {\n                this.asyncSave()\n            })\n        }\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3dcfc5ae942a67a7bf94bd4bd0251c26dd2702ff"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_we3p0p7rd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_we3p0p7rd();

var __extends = (cov_we3p0p7rd().s[0]++, (cov_we3p0p7rd().b[0][0]++, void 0) && (cov_we3p0p7rd().b[0][1]++, (void 0).__extends) || (cov_we3p0p7rd().b[0][2]++, function () {
  cov_we3p0p7rd().f[0]++;
  cov_we3p0p7rd().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_we3p0p7rd().f[1]++;
    cov_we3p0p7rd().s[2]++;
    _extendStatics = (cov_we3p0p7rd().b[1][0]++, _setPrototypeOf["default"]) || (cov_we3p0p7rd().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_we3p0p7rd().b[1][2]++, function (d, b) {
      cov_we3p0p7rd().f[2]++;
      cov_we3p0p7rd().s[3]++;
      d.__proto__ = b;
    }) || (cov_we3p0p7rd().b[1][3]++, function (d, b) {
      cov_we3p0p7rd().f[3]++;
      cov_we3p0p7rd().s[4]++;

      for (var p in b) {
        cov_we3p0p7rd().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_we3p0p7rd().b[2][0]++;
          cov_we3p0p7rd().s[6]++;
          d[p] = b[p];
        } else {
          cov_we3p0p7rd().b[2][1]++;
        }
      }
    });
    cov_we3p0p7rd().s[7]++;
    return _extendStatics(d, b);
  };

  cov_we3p0p7rd().s[8]++;
  return function (d, b) {
    cov_we3p0p7rd().f[4]++;
    cov_we3p0p7rd().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_we3p0p7rd().f[5]++;
      cov_we3p0p7rd().s[10]++;
      this.constructor = d;
    }

    cov_we3p0p7rd().s[11]++;
    d.prototype = b === null ? (cov_we3p0p7rd().b[3][0]++, (0, _create["default"])(b)) : (cov_we3p0p7rd().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_we3p0p7rd().s[12]++, (cov_we3p0p7rd().b[4][0]++, void 0) && (cov_we3p0p7rd().b[4][1]++, (void 0).__importDefault) || (cov_we3p0p7rd().b[4][2]++, function (mod) {
  cov_we3p0p7rd().f[6]++;
  cov_we3p0p7rd().s[13]++;
  return (cov_we3p0p7rd().b[6][0]++, mod) && (cov_we3p0p7rd().b[6][1]++, mod.__esModule) ? (cov_we3p0p7rd().b[5][0]++, mod) : (cov_we3p0p7rd().b[5][1]++, {
    "default": mod
  });
}));

cov_we3p0p7rd().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var mutation_1 = (cov_we3p0p7rd().s[15]++, __importDefault(__webpack_require__(386)));
var util_1 = (cov_we3p0p7rd().s[16]++, __webpack_require__(7));
var const_1 = (cov_we3p0p7rd().s[17]++, __webpack_require__(30));
/**
 * 剔除编辑区容器的 attribute 变化中的非 contenteditable 变化
 * @param mutations MutationRecord[]
 * @param tar 编辑区容器的 DOM 节点
 */

function mutationsFilter(mutations, tar) {
  cov_we3p0p7rd().f[7]++;
  cov_we3p0p7rd().s[18]++;
  // 剔除编辑区容器的 attribute 变化中的非 contenteditable 变化
  return (0, _filter["default"])(mutations).call(mutations, function (_a) {
    cov_we3p0p7rd().f[8]++;
    var type = (cov_we3p0p7rd().s[19]++, _a.type),
        target = (cov_we3p0p7rd().s[20]++, _a.target),
        attributeName = (cov_we3p0p7rd().s[21]++, _a.attributeName);
    cov_we3p0p7rd().s[22]++;
    return (cov_we3p0p7rd().b[7][0]++, type != 'attributes') || (cov_we3p0p7rd().b[7][1]++, type == 'attributes') && ((cov_we3p0p7rd().b[7][2]++, attributeName == 'contenteditable') || (cov_we3p0p7rd().b[7][3]++, target != tar));
  });
}
/**
 * Change 实现
 */


var Change = (
/** @class */
cov_we3p0p7rd().s[23]++, function (_super) {
  cov_we3p0p7rd().f[9]++;
  cov_we3p0p7rd().s[24]++;

  __extends(Change, _super);

  function Change(editor) {
    cov_we3p0p7rd().f[10]++;

    var _this = (cov_we3p0p7rd().s[25]++, (cov_we3p0p7rd().b[8][0]++, _super.call(this, function (mutations, observer) {
      cov_we3p0p7rd().f[11]++;

      var _a; // 数据过滤


      cov_we3p0p7rd().s[26]++;
      mutations = mutationsFilter(mutations, observer.target); // 存储数据

      cov_we3p0p7rd().s[27]++;

      (_a = _this.data).push.apply(_a, mutations); // 标准模式下


      cov_we3p0p7rd().s[28]++;

      if (!editor.isCompatibleMode) {
        cov_we3p0p7rd().b[9][0]++;
        cov_we3p0p7rd().s[29]++;

        // 在非中文输入状态下时才保存数据
        if (!editor.isComposing) {
          cov_we3p0p7rd().b[10][0]++;
          cov_we3p0p7rd().s[30]++;
          return _this.asyncSave();
        } else {
          cov_we3p0p7rd().b[10][1]++;
        }
      } // 兼容模式下
      else {
          cov_we3p0p7rd().b[9][1]++;
          cov_we3p0p7rd().s[31]++;

          _this.asyncSave();
        }
    })) || (cov_we3p0p7rd().b[8][1]++, this));

    cov_we3p0p7rd().s[32]++;
    _this.editor = editor;
    /**
     * 变化的数据集合
     */

    cov_we3p0p7rd().s[33]++;
    _this.data = [];
    /**
     * 异步保存数据
     */

    cov_we3p0p7rd().s[34]++;
    _this.asyncSave = const_1.EMPTY_FN;
    cov_we3p0p7rd().s[35]++;
    return _this;
  }
  /**
   * 保存变化的数据并发布 change event
   */


  cov_we3p0p7rd().s[36]++;

  Change.prototype.save = function () {
    cov_we3p0p7rd().f[12]++;
    cov_we3p0p7rd().s[37]++;

    // 有数据
    if (this.data.length) {
      cov_we3p0p7rd().b[11][0]++;
      cov_we3p0p7rd().s[38]++;
      // 保存变化数据
      this.editor.history.save(this.data); // 清除缓存

      cov_we3p0p7rd().s[39]++;
      this.data.length = 0;
      cov_we3p0p7rd().s[40]++;
      this.emit();
    } else {
      cov_we3p0p7rd().b[11][1]++;
    }
  };
  /**
   * 发布 change event
   */


  cov_we3p0p7rd().s[41]++;

  Change.prototype.emit = function () {
    var _context;

    cov_we3p0p7rd().f[13]++;
    cov_we3p0p7rd().s[42]++;
    // 执行 onchange 回调
    (0, _forEach["default"])(_context = this.editor.txt.eventHooks.changeEvents).call(_context, function (fn) {
      cov_we3p0p7rd().f[14]++;
      cov_we3p0p7rd().s[43]++;
      return fn();
    });
  }; // 重写 observe


  cov_we3p0p7rd().s[44]++;

  Change.prototype.observe = function () {
    cov_we3p0p7rd().f[15]++;

    var _this = (cov_we3p0p7rd().s[45]++, this);

    cov_we3p0p7rd().s[46]++;

    _super.prototype.observe.call(this, this.editor.$textElem.elems[0]);

    var timeout = (cov_we3p0p7rd().s[47]++, this.editor.config.onchangeTimeout);
    cov_we3p0p7rd().s[48]++;
    this.asyncSave = util_1.debounce(function () {
      cov_we3p0p7rd().f[16]++;
      cov_we3p0p7rd().s[49]++;

      _this.save();
    }, timeout);
    cov_we3p0p7rd().s[50]++;

    if (!this.editor.isCompatibleMode) {
      cov_we3p0p7rd().b[12][0]++;
      cov_we3p0p7rd().s[51]++;
      this.editor.$textElem.on('compositionend', function () {
        cov_we3p0p7rd().f[17]++;
        cov_we3p0p7rd().s[52]++;

        _this.asyncSave();
      });
    } else {
      cov_we3p0p7rd().b[12][1]++;
    }
  };

  cov_we3p0p7rd().s[53]++;
  return Change;
}(mutation_1["default"]));
cov_we3p0p7rd().s[54]++;
exports["default"] = Change;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 封装 MutationObserver
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_k8if0aqnm() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/observer/mutation.ts";
  var hash = "ced47ccd48850687d47e9ccd0c0bb64945e960b9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/observer/mutation.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "2": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 24
        }
      },
      "3": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 28,
          column: 10
        }
      },
      "4": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 31,
          column: 10
        }
      },
      "5": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 33
        }
      },
      "6": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 60
        }
      },
      "7": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 44
        }
      },
      "8": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 41,
          column: 7
        }
      },
      "9": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 29
        }
      },
      "10": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 51,
          column: 6
        }
      },
      "11": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 50,
          column: 9
        }
      },
      "12": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 29
        }
      },
      "13": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 27
        }
      },
      "14": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 61,
          column: 6
        }
      },
      "15": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "16": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 59
        }
      },
      "17": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 24
        }
      },
      "18": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 52
        }
      },
      "19": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 69,
          column: 6
        }
      },
      "20": {
        start: {
          line: 66,
          column: 19
        },
        end: {
          line: 66,
          column: 46
        }
      },
      "21": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 43
        }
      },
      "22": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 35
        }
      },
      "23": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 20
        }
      },
      "24": {
        start: {
          line: 72,
          column: 0
        },
        end: {
          line: 72,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 30
          },
          end: {
            line: 10,
            column: 31
          }
        },
        loc: {
          start: {
            line: 10,
            column: 42
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "Mutation",
        decl: {
          start: {
            line: 16,
            column: 13
          },
          end: {
            line: 16,
            column: 21
          }
        },
        loc: {
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 24
          },
          end: {
            line: 29,
            column: 25
          }
        },
        loc: {
          start: {
            line: 29,
            column: 45
          },
          end: {
            line: 31,
            column: 9
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 36,
            column: 13
          },
          end: {
            line: 36,
            column: 14
          }
        },
        loc: {
          start: {
            line: 36,
            column: 25
          },
          end: {
            line: 38,
            column: 9
          }
        },
        line: 36
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 34
          }
        },
        loc: {
          start: {
            line: 46,
            column: 49
          },
          end: {
            line: 51,
            column: 5
          }
        },
        line: 46
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 55,
            column: 33
          },
          end: {
            line: 55,
            column: 34
          }
        },
        loc: {
          start: {
            line: 55,
            column: 45
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 55
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 65,
            column: 36
          },
          end: {
            line: 65,
            column: 37
          }
        },
        loc: {
          start: {
            line: 65,
            column: 48
          },
          end: {
            line: 69,
            column: 5
          }
        },
        line: 65
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 15
          }
        }, {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 42
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }, {
          start: {
            line: 47,
            column: 8
          },
          end: {
            line: 50,
            column: 9
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 59,
            column: 9
          }
        }],
        line: 56
      },
      "3": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 19
          }
        }, {
          start: {
            line: 67,
            column: 23
          },
          end: {
            line: 67,
            column: 42
          }
        }],
        line: 67
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/observer/mutation.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/observer/mutation.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAIH;;GAEG;AACH;IA4BI;;;;OAIG;IACH,kBAAY,EAAY,EAAE,OAA8B;QAAxD,iBAMC;QA5BD;;WAEG;QACO,YAAO,GAAyB;YACtC,OAAO,EAAE,IAAI;YACb,SAAS,EAAE,IAAI;YACf,UAAU,EAAE,IAAI;YAChB,iBAAiB,EAAE,IAAI;YACvB,aAAa,EAAE,IAAI;YACnB,qBAAqB,EAAE,IAAI;SAC9B,CAAA;QAaG,IAAI,CAAC,QAAQ,GAAG,UAAA,SAAS;YACrB,EAAE,CAAC,SAAS,EAAE,KAAI,CAAC,CAAA;QACvB,CAAC,CAAA;QACD,IAAI,CAAC,QAAQ,GAAG,IAAI,gBAAgB,CAAC,IAAI,CAAC,QAAQ,CAAC,CAAA;QACnD,OAAO,IAAI,CAAC,IAAI,CAAC,OAAO,GAAG,OAAO,CAAC,CAAA;IACvC,CAAC;IAED,sBAAW,4BAAM;aAAjB;YACI,OAAO,IAAI,CAAC,IAAI,CAAA;QACpB,CAAC;;;OAAA;IAED;;;OAGG;IACI,0BAAO,GAAd,UAAe,IAAU;QACrB,IAAI,CAAC,CAAC,IAAI,CAAC,IAAI,YAAY,IAAI,CAAC,EAAE;YAC9B,IAAI,CAAC,IAAI,GAAG,IAAI,CAAA;YAChB,IAAI,CAAC,OAAO,EAAE,CAAA;SACjB;IACL,CAAC;IAED;;OAEG;IACI,0BAAO,GAAd;QACI,IAAI,IAAI,CAAC,IAAI,EAAE;YACX,IAAI,CAAC,QAAQ,CAAC,OAAO,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,OAAO,CAAC,CAAA;YAC9C,OAAO,IAAI,CAAA;SACd;QACD,MAAM,IAAI,KAAK,CAAC,0BAA0B,CAAC,CAAA;IAC/C,CAAC;IAED;;OAEG;IACI,6BAAU,GAAjB;QACI,IAAI,IAAI,GAAG,IAAI,CAAC,QAAQ,CAAC,WAAW,EAAE,CAAA;QACtC,IAAI,CAAC,MAAM,IAAI,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAA;QAClC,IAAI,CAAC,QAAQ,CAAC,UAAU,EAAE,CAAA;IAC9B,CAAC;IACL,eAAC;AAAD,CAAC,AA3ED,IA2EC",
      sourcesContent: ["/**\n * @description \u5C01\u88C5 MutationObserver\n * @author fangzhicong\n */\n\nexport type callback = (mutations: MutationRecord[], observer: Mutation) => void\n\n/**\n * \u5C01\u88C5 MutationObserver\uFF0C\u62BD\u79BB\u6210\u516C\u5171\u7C7B\n */\nexport default class Mutation {\n    /**\n     * MutationObserver \u5B9E\u4F8B\n     */\n    protected observer: MutationObserver\n\n    /**\n     * \u88AB\u76D1\u542C\u7684 Node \u8282\u70B9\uFF08\u53EF\u7EE7\u627F\u7684\uFF0C\u65B9\u4FBF\u6269\u5C55\u4F46\u53C8\u4E0D\u4F1A\u5728\u5916\u90E8\u88AB\u4FEE\u6539\uFF09\n     */\n    protected node?: Node\n\n    /**\n     * \u9ED8\u8BA4\u7684 MutationObserverInit \u914D\u7F6E\n     */\n    protected options: MutationObserverInit = {\n        subtree: true,\n        childList: true,\n        attributes: true,\n        attributeOldValue: true,\n        characterData: true,\n        characterDataOldValue: true,\n    }\n\n    /**\n     * MutationCallback\n     */\n    protected callback: (mutations: MutationRecord[]) => void\n\n    /**\n     * \u6784\u9020\u5668\n     * @param fn \u53D1\u751F\u53D8\u5316\u65F6\u6267\u884C\u7684\u56DE\u8C03\u51FD\u6570\n     * @param options \u81EA\u5B9A\u4E49\u914D\u7F6E\u9879\n     */\n    constructor(fn: callback, options?: MutationObserverInit) {\n        this.callback = mutations => {\n            fn(mutations, this)\n        }\n        this.observer = new MutationObserver(this.callback)\n        options && (this.options = options)\n    }\n\n    public get target() {\n        return this.node\n    }\n\n    /**\n     * \u7ED1\u5B9A\u76D1\u542C\u8282\u70B9\uFF08\u521D\u6B21\u7ED1\u5B9A\u6709\u6548\uFF09\n     * @param node \u9700\u8981\u88AB\u76D1\u542C\u7684\u8282\u70B9\n     */\n    public observe(node: Node) {\n        if (!(this.node instanceof Node)) {\n            this.node = node\n            this.connect()\n        }\n    }\n\n    /**\n     * \u8FDE\u63A5\u76D1\u542C\u5668\uFF08\u5F00\u59CB\u89C2\u5BDF\uFF09\n     */\n    public connect() {\n        if (this.node) {\n            this.observer.observe(this.node, this.options)\n            return this\n        }\n        throw new Error('\u8FD8\u672A\u521D\u59CB\u5316\u7ED1\u5B9A\uFF0C\u8BF7\u60A8\u5148\u7ED1\u5B9A\u6709\u6548\u7684 Node \u8282\u70B9')\n    }\n\n    /**\n     * \u65AD\u5F00\u76D1\u542C\u5668\uFF08\u505C\u6B62\u89C2\u5BDF\uFF09\n     */\n    public disconnect() {\n        let list = this.observer.takeRecords()\n        list.length && this.callback(list)\n        this.observer.disconnect()\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ced47ccd48850687d47e9ccd0c0bb64945e960b9"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k8if0aqnm = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_k8if0aqnm();
cov_k8if0aqnm().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
/**
 * 封装 MutationObserver，抽离成公共类
 */

var Mutation = (
/** @class */
cov_k8if0aqnm().s[1]++, function () {
  cov_k8if0aqnm().f[0]++;

  /**
   * 构造器
   * @param fn 发生变化时执行的回调函数
   * @param options 自定义配置项
   */
  function Mutation(fn, options) {
    cov_k8if0aqnm().f[1]++;

    var _this = (cov_k8if0aqnm().s[2]++, this);
    /**
     * 默认的 MutationObserverInit 配置
     */


    cov_k8if0aqnm().s[3]++;
    this.options = {
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true,
      characterData: true,
      characterDataOldValue: true
    };
    cov_k8if0aqnm().s[4]++;

    this.callback = function (mutations) {
      cov_k8if0aqnm().f[2]++;
      cov_k8if0aqnm().s[5]++;
      fn(mutations, _this);
    };

    cov_k8if0aqnm().s[6]++;
    this.observer = new MutationObserver(this.callback);
    cov_k8if0aqnm().s[7]++;
    (cov_k8if0aqnm().b[0][0]++, options) && (cov_k8if0aqnm().b[0][1]++, this.options = options);
  }

  cov_k8if0aqnm().s[8]++;
  (0, _defineProperty["default"])(Mutation.prototype, "target", {
    get: function get() {
      cov_k8if0aqnm().f[3]++;
      cov_k8if0aqnm().s[9]++;
      return this.node;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 绑定监听节点（初次绑定有效）
   * @param node 需要被监听的节点
   */

  cov_k8if0aqnm().s[10]++;

  Mutation.prototype.observe = function (node) {
    cov_k8if0aqnm().f[4]++;
    cov_k8if0aqnm().s[11]++;

    if (!(this.node instanceof Node)) {
      cov_k8if0aqnm().b[1][0]++;
      cov_k8if0aqnm().s[12]++;
      this.node = node;
      cov_k8if0aqnm().s[13]++;
      this.connect();
    } else {
      cov_k8if0aqnm().b[1][1]++;
    }
  };
  /**
   * 连接监听器（开始观察）
   */


  cov_k8if0aqnm().s[14]++;

  Mutation.prototype.connect = function () {
    cov_k8if0aqnm().f[5]++;
    cov_k8if0aqnm().s[15]++;

    if (this.node) {
      cov_k8if0aqnm().b[2][0]++;
      cov_k8if0aqnm().s[16]++;
      this.observer.observe(this.node, this.options);
      cov_k8if0aqnm().s[17]++;
      return this;
    } else {
      cov_k8if0aqnm().b[2][1]++;
    }

    cov_k8if0aqnm().s[18]++;
    throw new Error('还未初始化绑定，请您先绑定有效的 Node 节点');
  };
  /**
   * 断开监听器（停止观察）
   */


  cov_k8if0aqnm().s[19]++;

  Mutation.prototype.disconnect = function () {
    cov_k8if0aqnm().f[6]++;
    var list = (cov_k8if0aqnm().s[20]++, this.observer.takeRecords());
    cov_k8if0aqnm().s[21]++;
    (cov_k8if0aqnm().b[3][0]++, list.length) && (cov_k8if0aqnm().b[3][1]++, this.callback(list));
    cov_k8if0aqnm().s[22]++;
    this.observer.disconnect();
  };

  cov_k8if0aqnm().s[23]++;
  return Mutation;
}());
cov_k8if0aqnm().s[24]++;
exports["default"] = Mutation;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 历史记录
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2pgn5cahmr() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/index.ts";
  var hash = "861554bc38e31d5fae74f3123cae289048a331b4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 10,
          column: 58
        }
      },
      "4": {
        start: {
          line: 11,
          column: 15
        },
        end: {
          line: 11,
          column: 56
        }
      },
      "5": {
        start: {
          line: 12,
          column: 14
        },
        end: {
          line: 12,
          column: 54
        }
      },
      "6": {
        start: {
          line: 16,
          column: 29
        },
        end: {
          line: 90,
          column: 3
        }
      },
      "7": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "8": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 53
        }
      },
      "9": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 51
        }
      },
      "10": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 49
        }
      },
      "11": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 32,
          column: 7
        }
      },
      "12": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 28,
          column: 36
        }
      },
      "13": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 41,
          column: 6
        }
      },
      "14": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 31
        }
      },
      "15": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 30
        }
      },
      "16": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 62
        }
      },
      "17": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      "18": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "19": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "20": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 31
        }
      },
      "21": {
        start: {
          line: 50,
          column: 12
        },
        end: {
          line: 50,
          column: 63
        }
      },
      "22": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 70,
          column: 6
        }
      },
      "23": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 40
        }
      },
      "24": {
        start: {
          line: 58,
          column: 18
        },
        end: {
          line: 58,
          column: 39
        }
      },
      "25": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 66,
          column: 9
        }
      },
      "26": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 33
        }
      },
      "27": {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 65,
          column: 13
        }
      },
      "28": {
        start: {
          line: 63,
          column: 16
        },
        end: {
          line: 63,
          column: 36
        }
      },
      "29": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 46
        }
      },
      "30": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 37
        }
      },
      "31": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 41
        }
      },
      "32": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      },
      "33": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 40
        }
      },
      "34": {
        start: {
          line: 76,
          column: 18
        },
        end: {
          line: 76,
          column: 40
        }
      },
      "35": {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 84,
          column: 9
        }
      },
      "36": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 34
        }
      },
      "37": {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 83,
          column: 13
        }
      },
      "38": {
        start: {
          line: 81,
          column: 16
        },
        end: {
          line: 81,
          column: 37
        }
      },
      "39": {
        start: {
          line: 82,
          column: 16
        },
        end: {
          line: 82,
          column: 46
        }
      },
      "40": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 37
        }
      },
      "41": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 41
        }
      },
      "42": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 19
        }
      },
      "43": {
        start: {
          line: 91,
          column: 0
        },
        end: {
          line: 91,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 29
          },
          end: {
            line: 16,
            column: 30
          }
        },
        loc: {
          start: {
            line: 16,
            column: 41
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "History",
        decl: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 17,
            column: 20
          }
        },
        loc: {
          start: {
            line: 17,
            column: 29
          },
          end: {
            line: 22,
            column: 5
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 27,
            column: 14
          }
        },
        loc: {
          start: {
            line: 27,
            column: 25
          },
          end: {
            line: 29,
            column: 9
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 32
          },
          end: {
            line: 36,
            column: 33
          }
        },
        loc: {
          start: {
            line: 36,
            column: 44
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 36
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 45,
            column: 29
          },
          end: {
            line: 45,
            column: 30
          }
        },
        loc: {
          start: {
            line: 45,
            column: 50
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 45
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 56,
            column: 31
          },
          end: {
            line: 56,
            column: 32
          }
        },
        loc: {
          start: {
            line: 56,
            column: 43
          },
          end: {
            line: 70,
            column: 5
          }
        },
        line: 56
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 74,
            column: 33
          }
        },
        loc: {
          start: {
            line: 74,
            column: 44
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 74
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 37
          }
        }, {
          start: {
            line: 40,
            column: 41
          },
          end: {
            line: 40,
            column: 61
          }
        }],
        line: 40
      },
      "4": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 46
      },
      "5": {
        loc: {
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 50,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 12
          },
          end: {
            line: 50,
            column: 41
          }
        }, {
          start: {
            line: 50,
            column: 45
          },
          end: {
            line: 50,
            column: 62
          }
        }],
        line: 50
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 65,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 65,
            column: 13
          }
        }, {
          start: {
            line: 62,
            column: 12
          },
          end: {
            line: 65,
            column: 13
          }
        }],
        line: 62
      },
      "8": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 11
          }
        }, {
          start: {
            line: 69,
            column: 15
          },
          end: {
            line: 69,
            column: 40
          }
        }],
        line: 69
      },
      "9": {
        loc: {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        }, {
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        }],
        line: 77
      },
      "10": {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 83,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 83,
            column: 13
          }
        }, {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 83,
            column: 13
          }
        }],
        line: 80
      },
      "11": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 11
          }
        }, {
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 40
          }
        }],
        line: 87
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,2DAAyC;AACzC,yDAAuC;AACvC,uDAAqC;AAGrC;;GAEG;AACH;IAUI,iBAAmB,MAAc;QAAd,WAAM,GAAN,MAAM,CAAQ;QAC7B,IAAI,CAAC,OAAO,GAAG,IAAI,iBAAY,CAAC,MAAM,CAAC,CAAA;QACvC,IAAI,CAAC,MAAM,GAAG,IAAI,gBAAW,CAAC,MAAM,CAAC,CAAA;QACrC,IAAI,CAAC,KAAK,GAAG,IAAI,eAAU,CAAC,MAAM,CAAC,CAAA;IACvC,CAAC;IAKD,sBAAW,yBAAI;QAHf;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,MAAM,CAAC,IAAI,CAAA;QAC3B,CAAC;;;OAAA;IAED;;OAEG;IACI,yBAAO,GAAd;QACI,IAAI,CAAC,OAAO,CAAC,OAAO,EAAE,CAAA;QACtB,IAAI,CAAC,MAAM,CAAC,OAAO,EAAE,CAAA;QACrB,gBAAgB;QAChB,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,IAAI,IAAI,CAAC,KAAK,CAAC,OAAO,EAAE,CAAA;IACzD,CAAC;IAED;;OAEG;IACI,sBAAI,GAAX,UAAY,SAA2B;QACnC,IAAI,SAAS,CAAC,MAAM,EAAE;YAClB,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,SAAS,CAAC,CAAA;YAC5B,IAAI,CAAC,MAAM,CAAC,IAAI,EAAE,CAAA;YAClB,aAAa;YACb,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,IAAI,IAAI,CAAC,KAAK,CAAC,IAAI,EAAE,CAAA;SACrD;IACL,CAAC;IAED;;OAEG;IACI,wBAAM,GAAb;QACI,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,UAAU,EAAE,CAAA;QAC/B,IAAM,GAAG,GAAG,IAAI,CAAC,OAAO,CAAC,MAAM,EAAE,CAAA;QACjC,IAAI,GAAG,EAAE;YACL,IAAI,CAAC,MAAM,CAAC,MAAM,EAAE,CAAA;YACpB,WAAW;YACX,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;gBAC/B,IAAI,CAAC,KAAK,CAAC,MAAM,EAAE,CAAA;gBACnB,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,EAAE,CAAA;aAChC;SACJ;QACD,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,OAAO,EAAE,CAAA;QAC5B,uFAAuF;QACvF,GAAG,IAAI,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,IAAI,EAAE,CAAA;IACpC,CAAC;IAED;;OAEG;IACI,yBAAO,GAAd;QACI,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,UAAU,EAAE,CAAA;QAC/B,IAAM,GAAG,GAAG,IAAI,CAAC,OAAO,CAAC,OAAO,EAAE,CAAA;QAClC,IAAI,GAAG,EAAE;YACL,IAAI,CAAC,MAAM,CAAC,OAAO,EAAE,CAAA;YACrB,WAAW;YACX,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;gBAC/B,IAAI,CAAC,KAAK,CAAC,OAAO,EAAE,CAAA;gBACpB,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,EAAE,CAAA;aAChC;SACJ;QACD,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,OAAO,EAAE,CAAA;QAC5B,cAAc;QACd,GAAG,IAAI,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,IAAI,EAAE,CAAA;IACpC,CAAC;IACL,cAAC;AAAD,CAAC,AAlFD,IAkFC",
      sourcesContent: ["/**\n * @description \u5386\u53F2\u8BB0\u5F55\n * @author fangzhicong\n */\n\nimport ContentCache from './data/content'\nimport ScrollCache from './data/scroll'\nimport RangeCache from './data/range'\nimport Editor from '../index'\n\n/**\n * \u5386\u53F2\u8BB0\u5F55\uFF08\u64A4\u9500\u3001\u6062\u590D\uFF09\n */\nexport default class History {\n    // \u6570\u636E\u7F13\u5B58\u5668\u5B9E\u4F8B\n    private content: ContentCache\n\n    // scroll \u7F13\u5B58\n    private scroll: ScrollCache\n\n    // Range \u7F13\u5B58\n    private range: RangeCache\n\n    constructor(public editor: Editor) {\n        this.content = new ContentCache(editor)\n        this.scroll = new ScrollCache(editor)\n        this.range = new RangeCache(editor)\n    }\n\n    /**\n     *  \u83B7\u53D6\u7F13\u5B58\u4E2D\u7684\u6570\u636E\u957F\u5EA6\u3002\u683C\u5F0F\u4E3A\uFF1A[\u6B63\u5E38\u7684\u6570\u636E\u7684\u6761\u6570\uFF0C\u88AB\u64A4\u9500\u7684\u6570\u636E\u7684\u6761\u6570]\n     */\n    public get size() {\n        return this.scroll.size\n    }\n\n    /**\n     * \u521D\u59CB\u5316\u7ED1\u5B9A\u3002\u5728 editor.create() \u7ED3\u5C3E\u65F6\u8C03\u7528\n     */\n    public observe() {\n        this.content.observe()\n        this.scroll.observe()\n        // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u8FDB\u884C\u521D\u59CB\u5316\u7ED1\u5B9A\n        !this.editor.isCompatibleMode && this.range.observe()\n    }\n\n    /**\n     * \u4FDD\u5B58\u6570\u636E\n     */\n    public save(mutations: MutationRecord[]) {\n        if (mutations.length) {\n            this.content.save(mutations)\n            this.scroll.save()\n            // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u8FDB\u884C\u7F13\u5B58\n            !this.editor.isCompatibleMode && this.range.save()\n        }\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        this.editor.change.disconnect()\n        const res = this.content.revoke()\n        if (res) {\n            this.scroll.revoke()\n            // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u6267\u884C\n            if (!this.editor.isCompatibleMode) {\n                this.range.revoke()\n                this.editor.$textElem.focus()\n            }\n        }\n        this.editor.change.connect()\n        // \u5982\u679C\u7528\u6237\u5728 onchange \u4E2D\u4FEE\u6539\u4E86\u5185\u5BB9\uFF08DOM\uFF09\uFF0C\u90A3\u4E48\u7F13\u5B58\u4E2D\u7684\u8282\u70B9\u6570\u636E\u53EF\u80FD\u4E0D\u8FDE\u8D2F\u4E86\uFF0C\u4E0D\u8FDE\u8D2F\u7684\u6570\u636E\u5FC5\u5C06\u5BFC\u81F4\u6062\u590D\u5931\u8D25\uFF0C\u6240\u4EE5\u5FC5\u987B\u5C06\u7528\u6237\u7684 onchange \u5904\u4E8E\u76D1\u63A7\u72B6\u6001\u4E2D\n        res && this.editor.change.emit()\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        this.editor.change.disconnect()\n        const res = this.content.restore()\n        if (res) {\n            this.scroll.restore()\n            // \u6807\u51C6\u6A21\u5F0F\u4E0B\u624D\u6267\u884C\n            if (!this.editor.isCompatibleMode) {\n                this.range.restore()\n                this.editor.$textElem.focus()\n            }\n        }\n        this.editor.change.connect()\n        // \u4E0E revoke \u540C\u7406\n        res && this.editor.change.emit()\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "861554bc38e31d5fae74f3123cae289048a331b4"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pgn5cahmr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2pgn5cahmr();

var __importDefault = (cov_2pgn5cahmr().s[0]++, (cov_2pgn5cahmr().b[0][0]++, void 0) && (cov_2pgn5cahmr().b[0][1]++, (void 0).__importDefault) || (cov_2pgn5cahmr().b[0][2]++, function (mod) {
  cov_2pgn5cahmr().f[0]++;
  cov_2pgn5cahmr().s[1]++;
  return (cov_2pgn5cahmr().b[2][0]++, mod) && (cov_2pgn5cahmr().b[2][1]++, mod.__esModule) ? (cov_2pgn5cahmr().b[1][0]++, mod) : (cov_2pgn5cahmr().b[1][1]++, {
    "default": mod
  });
}));

cov_2pgn5cahmr().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var content_1 = (cov_2pgn5cahmr().s[3]++, __importDefault(__webpack_require__(388)));
var scroll_1 = (cov_2pgn5cahmr().s[4]++, __importDefault(__webpack_require__(400)));
var range_1 = (cov_2pgn5cahmr().s[5]++, __importDefault(__webpack_require__(401)));
/**
 * 历史记录（撤销、恢复）
 */

var History = (
/** @class */
cov_2pgn5cahmr().s[6]++, function () {
  cov_2pgn5cahmr().f[1]++;

  function History(editor) {
    cov_2pgn5cahmr().f[2]++;
    cov_2pgn5cahmr().s[7]++;
    this.editor = editor;
    cov_2pgn5cahmr().s[8]++;
    this.content = new content_1["default"](editor);
    cov_2pgn5cahmr().s[9]++;
    this.scroll = new scroll_1["default"](editor);
    cov_2pgn5cahmr().s[10]++;
    this.range = new range_1["default"](editor);
  }

  cov_2pgn5cahmr().s[11]++;
  (0, _defineProperty["default"])(History.prototype, "size", {
    /**
     *  获取缓存中的数据长度。格式为：[正常的数据的条数，被撤销的数据的条数]
     */
    get: function get() {
      cov_2pgn5cahmr().f[3]++;
      cov_2pgn5cahmr().s[12]++;
      return this.scroll.size;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 初始化绑定。在 editor.create() 结尾时调用
   */

  cov_2pgn5cahmr().s[13]++;

  History.prototype.observe = function () {
    cov_2pgn5cahmr().f[4]++;
    cov_2pgn5cahmr().s[14]++;
    this.content.observe();
    cov_2pgn5cahmr().s[15]++;
    this.scroll.observe(); // 标准模式下才进行初始化绑定

    cov_2pgn5cahmr().s[16]++;
    (cov_2pgn5cahmr().b[3][0]++, !this.editor.isCompatibleMode) && (cov_2pgn5cahmr().b[3][1]++, this.range.observe());
  };
  /**
   * 保存数据
   */


  cov_2pgn5cahmr().s[17]++;

  History.prototype.save = function (mutations) {
    cov_2pgn5cahmr().f[5]++;
    cov_2pgn5cahmr().s[18]++;

    if (mutations.length) {
      cov_2pgn5cahmr().b[4][0]++;
      cov_2pgn5cahmr().s[19]++;
      this.content.save(mutations);
      cov_2pgn5cahmr().s[20]++;
      this.scroll.save(); // 标准模式下才进行缓存

      cov_2pgn5cahmr().s[21]++;
      (cov_2pgn5cahmr().b[5][0]++, !this.editor.isCompatibleMode) && (cov_2pgn5cahmr().b[5][1]++, this.range.save());
    } else {
      cov_2pgn5cahmr().b[4][1]++;
    }
  };
  /**
   * 撤销
   */


  cov_2pgn5cahmr().s[22]++;

  History.prototype.revoke = function () {
    cov_2pgn5cahmr().f[6]++;
    cov_2pgn5cahmr().s[23]++;
    this.editor.change.disconnect();
    var res = (cov_2pgn5cahmr().s[24]++, this.content.revoke());
    cov_2pgn5cahmr().s[25]++;

    if (res) {
      cov_2pgn5cahmr().b[6][0]++;
      cov_2pgn5cahmr().s[26]++;
      this.scroll.revoke(); // 标准模式下才执行

      cov_2pgn5cahmr().s[27]++;

      if (!this.editor.isCompatibleMode) {
        cov_2pgn5cahmr().b[7][0]++;
        cov_2pgn5cahmr().s[28]++;
        this.range.revoke();
        cov_2pgn5cahmr().s[29]++;
        this.editor.$textElem.focus();
      } else {
        cov_2pgn5cahmr().b[7][1]++;
      }
    } else {
      cov_2pgn5cahmr().b[6][1]++;
    }

    cov_2pgn5cahmr().s[30]++;
    this.editor.change.connect(); // 如果用户在 onchange 中修改了内容（DOM），那么缓存中的节点数据可能不连贯了，不连贯的数据必将导致恢复失败，所以必须将用户的 onchange 处于监控状态中

    cov_2pgn5cahmr().s[31]++;
    (cov_2pgn5cahmr().b[8][0]++, res) && (cov_2pgn5cahmr().b[8][1]++, this.editor.change.emit());
  };
  /**
   * 恢复
   */


  cov_2pgn5cahmr().s[32]++;

  History.prototype.restore = function () {
    cov_2pgn5cahmr().f[7]++;
    cov_2pgn5cahmr().s[33]++;
    this.editor.change.disconnect();
    var res = (cov_2pgn5cahmr().s[34]++, this.content.restore());
    cov_2pgn5cahmr().s[35]++;

    if (res) {
      cov_2pgn5cahmr().b[9][0]++;
      cov_2pgn5cahmr().s[36]++;
      this.scroll.restore(); // 标准模式下才执行

      cov_2pgn5cahmr().s[37]++;

      if (!this.editor.isCompatibleMode) {
        cov_2pgn5cahmr().b[10][0]++;
        cov_2pgn5cahmr().s[38]++;
        this.range.restore();
        cov_2pgn5cahmr().s[39]++;
        this.editor.$textElem.focus();
      } else {
        cov_2pgn5cahmr().b[10][1]++;
      }
    } else {
      cov_2pgn5cahmr().b[9][1]++;
    }

    cov_2pgn5cahmr().s[40]++;
    this.editor.change.connect(); // 与 revoke 同理

    cov_2pgn5cahmr().s[41]++;
    (cov_2pgn5cahmr().b[11][0]++, res) && (cov_2pgn5cahmr().b[11][1]++, this.editor.change.emit());
  };

  cov_2pgn5cahmr().s[42]++;
  return History;
}());
cov_2pgn5cahmr().s[43]++;
exports["default"] = History;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 整合差异备份和内容备份，进行统一管理
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1z17gzl03() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/content.ts";
  var hash = "a3bb9af85fb5d089bae335634fce67ab5f28b7db";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/content.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 8,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 62
        }
      },
      "2": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 62
        }
      },
      "3": {
        start: {
          line: 10,
          column: 13
        },
        end: {
          line: 10,
          column: 47
        }
      },
      "4": {
        start: {
          line: 11,
          column: 13
        },
        end: {
          line: 11,
          column: 47
        }
      },
      "5": {
        start: {
          line: 12,
          column: 34
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "6": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 29
        }
      },
      "7": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      "8": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 27,
          column: 9
        }
      },
      "9": {
        start: {
          line: 22,
          column: 12
        },
        end: {
          line: 22,
          column: 57
        }
      },
      "10": {
        start: {
          line: 26,
          column: 12
        },
        end: {
          line: 26,
          column: 57
        }
      },
      "11": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "12": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "13": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 41,
          column: 9
        }
      },
      "14": {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 30
        }
      },
      "15": {
        start: {
          line: 40,
          column: 12
        },
        end: {
          line: 40,
          column: 42
        }
      },
      "16": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 49,
          column: 6
        }
      },
      "17": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 82
        }
      },
      "18": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "19": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 83
        }
      },
      "20": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 24
        }
      },
      "21": {
        start: {
          line: 59,
          column: 0
        },
        end: {
          line: 59,
          column: 31
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 57
          }
        },
        loc: {
          start: {
            line: 6,
            column: 71
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 34
          },
          end: {
            line: 12,
            column: 35
          }
        },
        loc: {
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "ContentCache",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 25
          }
        },
        loc: {
          start: {
            line: 13,
            column: 34
          },
          end: {
            line: 15,
            column: 5
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 37
          },
          end: {
            line: 19,
            column: 38
          }
        },
        loc: {
          start: {
            line: 19,
            column: 49
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 19
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 34
          },
          end: {
            line: 33,
            column: 35
          }
        },
        loc: {
          start: {
            line: 33,
            column: 55
          },
          end: {
            line: 42,
            column: 5
          }
        },
        line: 33
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 46,
            column: 37
          }
        },
        loc: {
          start: {
            line: 46,
            column: 48
          },
          end: {
            line: 49,
            column: 5
          }
        },
        line: 46
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 53,
            column: 37
          },
          end: {
            line: 53,
            column: 38
          }
        },
        loc: {
          start: {
            line: 53,
            column: 49
          },
          end: {
            line: 56,
            column: 5
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 22
          },
          end: {
            line: 8,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 23
          },
          end: {
            line: 6,
            column: 27
          }
        }, {
          start: {
            line: 6,
            column: 31
          },
          end: {
            line: 6,
            column: 51
          }
        }, {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 8,
            column: 1
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 11
          },
          end: {
            line: 7,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 7,
            column: 37
          },
          end: {
            line: 7,
            column: 40
          }
        }, {
          start: {
            line: 7,
            column: 43
          },
          end: {
            line: 7,
            column: 61
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 12
          },
          end: {
            line: 7,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 33
          }
        }],
        line: 7
      },
      "3": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 27,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 27,
            column: 9
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 27,
            column: 9
          }
        }],
        line: 20
      },
      "4": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 41,
            column: 9
          }
        }],
        line: 34
      },
      "5": {
        loc: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 48,
            column: 61
          },
          end: {
            line: 48,
            column: 67
          }
        }, {
          start: {
            line: 48,
            column: 70
          },
          end: {
            line: 48,
            column: 81
          }
        }],
        line: 48
      },
      "6": {
        loc: {
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 15
          },
          end: {
            line: 48,
            column: 41
          }
        }, {
          start: {
            line: 48,
            column: 45
          },
          end: {
            line: 48,
            column: 58
          }
        }],
        line: 48
      },
      "7": {
        loc: {
          start: {
            line: 55,
            column: 15
          },
          end: {
            line: 55,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 55,
            column: 61
          },
          end: {
            line: 55,
            column: 67
          }
        }, {
          start: {
            line: 55,
            column: 70
          },
          end: {
            line: 55,
            column: 82
          }
        }],
        line: 55
      },
      "8": {
        loc: {
          start: {
            line: 55,
            column: 15
          },
          end: {
            line: 55,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 55,
            column: 15
          },
          end: {
            line: 55,
            column: 41
          }
        }, {
          start: {
            line: 55,
            column: 45
          },
          end: {
            line: 55,
            column: 58
          }
        }],
        line: 55
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/content.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/content.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;AAEH,gDAA8B;AAC9B,gDAA8B;AAG9B;IAMI,sBAAmB,MAAc;QAAd,WAAM,GAAN,MAAM,CAAQ;IAAG,CAAC;IAErC;;OAEG;IACH,8BAAO,GAAP;QACI,IAAI,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;YAC9B,aAAa;YACb,IAAI,CAAC,KAAK,GAAG,IAAI,cAAS,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;SAC1C;aAAM;YACH,kBAAkB;YAClB,IAAI,CAAC,KAAK,GAAG,IAAI,cAAS,CAAC,IAAI,CAAC,MAAM,CAAC,CAAA;SAC1C;QACD,IAAI,CAAC,KAAK,CAAC,OAAO,EAAE,CAAA;IACxB,CAAC;IAED;;OAEG;IACI,2BAAI,GAAX,UAAY,SAA2B;QACnC,IAAI,IAAI,CAAC,MAAM,CAAC,gBAAgB,EAAE;YAC9B,CAAC;YAAC,IAAI,CAAC,KAAmB,CAAC,IAAI,EAAE,CAAA;SACpC;aAAM;YACH,CAAC;YAAC,IAAI,CAAC,KAAmB,CAAC,OAAO,CAAC,SAAS,CAAC,CAAA;SAChD;IACL,CAAC;IAED;;OAEG;IACI,6BAAM,GAAb;;QACI,aAAO,IAAI,CAAC,KAAK,0CAAE,MAAM,GAAE;IAC/B,CAAC;IAED;;OAEG;IACI,8BAAO,GAAd;;QACI,aAAO,IAAI,CAAC,KAAK,0CAAE,OAAO,GAAE;IAChC,CAAC;IACL,mBAAC;AAAD,CAAC,AA9CD,IA8CC",
      sourcesContent: ["/**\n * @description \u6574\u5408\u5DEE\u5F02\u5907\u4EFD\u548C\u5185\u5BB9\u5907\u4EFD\uFF0C\u8FDB\u884C\u7EDF\u4E00\u7BA1\u7406\n * @author fangzhicong\n */\n\nimport NodeCache from './node'\nimport HtmlCache from './html'\nimport Editor from '../../index'\n\nexport default class ContentCache {\n    /**\n     * \u5185\u5BB9\u5907\u4EFD\u7684\u7BA1\u7406\u5668\n     */\n    public cache?: HtmlCache | NodeCache\n\n    constructor(public editor: Editor) {}\n\n    /**\n     * \u521D\u59CB\u5316\u7ED1\u5B9A\n     */\n    observe() {\n        if (this.editor.isCompatibleMode) {\n            // \u517C\u5BB9\u6A21\u5F0F\uFF08\u5185\u5BB9\u5907\u4EFD\uFF09\n            this.cache = new HtmlCache(this.editor)\n        } else {\n            // \u6807\u51C6\u6A21\u5F0F\uFF08\u5DEE\u5F02\u5907\u4EFD/\u8282\u70B9\u5907\u4EFD\uFF09\n            this.cache = new NodeCache(this.editor)\n        }\n        this.cache.observe()\n    }\n\n    /**\n     * \u4FDD\u5B58\n     */\n    public save(mutations: MutationRecord[]) {\n        if (this.editor.isCompatibleMode) {\n            ;(this.cache as HtmlCache).save()\n        } else {\n            ;(this.cache as NodeCache).compile(mutations)\n        }\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        return this.cache?.revoke()\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        return this.cache?.restore()\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a3bb9af85fb5d089bae335634fce67ab5f28b7db"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1z17gzl03 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1z17gzl03();

var __importDefault = (cov_1z17gzl03().s[0]++, (cov_1z17gzl03().b[0][0]++, void 0) && (cov_1z17gzl03().b[0][1]++, (void 0).__importDefault) || (cov_1z17gzl03().b[0][2]++, function (mod) {
  cov_1z17gzl03().f[0]++;
  cov_1z17gzl03().s[1]++;
  return (cov_1z17gzl03().b[2][0]++, mod) && (cov_1z17gzl03().b[2][1]++, mod.__esModule) ? (cov_1z17gzl03().b[1][0]++, mod) : (cov_1z17gzl03().b[1][1]++, {
    "default": mod
  });
}));

cov_1z17gzl03().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var node_1 = (cov_1z17gzl03().s[3]++, __importDefault(__webpack_require__(389)));
var html_1 = (cov_1z17gzl03().s[4]++, __importDefault(__webpack_require__(398)));
var ContentCache = (
/** @class */
cov_1z17gzl03().s[5]++, function () {
  cov_1z17gzl03().f[1]++;

  function ContentCache(editor) {
    cov_1z17gzl03().f[2]++;
    cov_1z17gzl03().s[6]++;
    this.editor = editor;
  }
  /**
   * 初始化绑定
   */


  cov_1z17gzl03().s[7]++;

  ContentCache.prototype.observe = function () {
    cov_1z17gzl03().f[3]++;
    cov_1z17gzl03().s[8]++;

    if (this.editor.isCompatibleMode) {
      cov_1z17gzl03().b[3][0]++;
      cov_1z17gzl03().s[9]++;
      // 兼容模式（内容备份）
      this.cache = new html_1["default"](this.editor);
    } else {
      cov_1z17gzl03().b[3][1]++;
      cov_1z17gzl03().s[10]++;
      // 标准模式（差异备份/节点备份）
      this.cache = new node_1["default"](this.editor);
    }

    cov_1z17gzl03().s[11]++;
    this.cache.observe();
  };
  /**
   * 保存
   */


  cov_1z17gzl03().s[12]++;

  ContentCache.prototype.save = function (mutations) {
    cov_1z17gzl03().f[4]++;
    cov_1z17gzl03().s[13]++;

    if (this.editor.isCompatibleMode) {
      cov_1z17gzl03().b[4][0]++;
      ;
      cov_1z17gzl03().s[14]++;
      this.cache.save();
    } else {
      cov_1z17gzl03().b[4][1]++;
      ;
      cov_1z17gzl03().s[15]++;
      this.cache.compile(mutations);
    }
  };
  /**
   * 撤销
   */


  cov_1z17gzl03().s[16]++;

  ContentCache.prototype.revoke = function () {
    cov_1z17gzl03().f[5]++;

    var _a;

    cov_1z17gzl03().s[17]++;
    return (cov_1z17gzl03().b[6][0]++, (_a = this.cache) === null) || (cov_1z17gzl03().b[6][1]++, _a === void 0) ? (cov_1z17gzl03().b[5][0]++, void 0) : (cov_1z17gzl03().b[5][1]++, _a.revoke());
  };
  /**
   * 恢复
   */


  cov_1z17gzl03().s[18]++;

  ContentCache.prototype.restore = function () {
    cov_1z17gzl03().f[6]++;

    var _a;

    cov_1z17gzl03().s[19]++;
    return (cov_1z17gzl03().b[8][0]++, (_a = this.cache) === null) || (cov_1z17gzl03().b[8][1]++, _a === void 0) ? (cov_1z17gzl03().b[7][0]++, void 0) : (cov_1z17gzl03().b[7][1]++, _a.restore());
  };

  cov_1z17gzl03().s[20]++;
  return ContentCache;
}());
cov_1z17gzl03().s[21]++;
exports["default"] = ContentCache;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 差异备份
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_27m3ie1qhy() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/index.ts";
  var hash = "60006d308c29171b9d3fd26c71e23b053da7bdd8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 14
        },
        end: {
          line: 23,
          column: 80
        }
      },
      "16": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "17": {
        start: {
          line: 25,
          column: 22
        },
        end: {
          line: 25,
          column: 48
        }
      },
      "18": {
        start: {
          line: 26,
          column: 31
        },
        end: {
          line: 60,
          column: 18
        }
      },
      "19": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 33
        }
      },
      "20": {
        start: {
          line: 29,
          column: 20
        },
        end: {
          line: 29,
          column: 75
        }
      },
      "21": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 30
        }
      },
      "22": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "23": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 35,
          column: 6
        }
      },
      "24": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 61
        }
      },
      "25": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "26": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 43
        }
      },
      "27": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 20
        }
      },
      "28": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 50,
          column: 6
        }
      },
      "29": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 49,
          column: 11
        }
      },
      "30": {
        start: {
          line: 48,
          column: 12
        },
        end: {
          line: 48,
          column: 41
        }
      },
      "31": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 58,
          column: 6
        }
      },
      "32": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 57,
          column: 11
        }
      },
      "33": {
        start: {
          line: 56,
          column: 12
        },
        end: {
          line: 56,
          column: 42
        }
      },
      "34": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 21
        }
      },
      "35": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 61,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 26,
            column: 31
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 26
      },
      "8": {
        name: "NodeCache",
        decl: {
          start: {
            line: 28,
            column: 13
          },
          end: {
            line: 28,
            column: 22
          }
        },
        loc: {
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 28
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 33,
            column: 34
          },
          end: {
            line: 33,
            column: 35
          }
        },
        loc: {
          start: {
            line: 33,
            column: 46
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 33
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 39,
            column: 34
          },
          end: {
            line: 39,
            column: 35
          }
        },
        loc: {
          start: {
            line: 39,
            column: 50
          },
          end: {
            line: 42,
            column: 5
          }
        },
        line: 39
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 46,
            column: 33
          },
          end: {
            line: 46,
            column: 34
          }
        },
        loc: {
          start: {
            line: 46,
            column: 45
          },
          end: {
            line: 50,
            column: 5
          }
        },
        line: 46
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 47,
            column: 50
          },
          end: {
            line: 47,
            column: 51
          }
        },
        loc: {
          start: {
            line: 47,
            column: 66
          },
          end: {
            line: 49,
            column: 9
          }
        },
        line: 47
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 35
          }
        },
        loc: {
          start: {
            line: 54,
            column: 46
          },
          end: {
            line: 58,
            column: 5
          }
        },
        line: 54
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 55,
            column: 51
          },
          end: {
            line: 55,
            column: 52
          }
        },
        loc: {
          start: {
            line: 55,
            column: 67
          },
          end: {
            line: 57,
            column: 9
          }
        },
        line: 55
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 20
          },
          end: {
            line: 29,
            column: 67
          }
        }, {
          start: {
            line: 29,
            column: 71
          },
          end: {
            line: 29,
            column: 75
          }
        }],
        line: 29
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,iFAA0D;AAC1D,sDAA+B;AAC/B,iDAAiD;AAIjD;IAAuC,6BAAgB;IACnD,mBAAmB,MAAc;QAAjC,YACI,kBAAM,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,SACtC;QAFkB,YAAM,GAAN,MAAM,CAAQ;;IAEjC,CAAC;IAEM,2BAAO,GAAd;QACI,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,CAAA;IACxD,CAAC;IAED;;OAEG;IACI,2BAAO,GAAd,UAAe,IAAsB;QACjC,IAAI,CAAC,IAAI,CAAC,iBAAO,CAAC,IAAI,CAAC,CAAC,CAAA;QACxB,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,0BAAM,GAAb;QACI,OAAO,iBAAM,MAAM,YAAC,UAAA,IAAI;YACpB,sBAAM,CAAC,IAAI,CAAC,CAAA;QAChB,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACI,2BAAO,GAAd;QACI,OAAO,iBAAM,OAAO,YAAC,UAAA,IAAI;YACrB,uBAAO,CAAC,IAAI,CAAC,CAAA;QACjB,CAAC,CAAC,CAAA;IACN,CAAC;IACL,gBAAC;AAAD,CAAC,AAlCD,CAAuC,eAAK,GAkC3C",
      sourcesContent: ["/**\n * @description \u5DEE\u5F02\u5907\u4EFD\n * @author fangzhicong\n */\n\nimport Cache from '../../../../utils/data-structure/cache'\nimport compile from './compile'\nimport { revoke, restore } from './decompilation'\nimport { Compile } from '../type'\nimport Editor from '../../../index'\n\nexport default class NodeCache extends Cache<Compile[]> {\n    constructor(public editor: Editor) {\n        super(editor.config.historyMaxSize)\n    }\n\n    public observe() {\n        this.resetMaxSize(this.editor.config.historyMaxSize)\n    }\n\n    /**\n     * \u7F16\u8BD1\u5E76\u4FDD\u5B58\u6570\u636E\n     */\n    public compile(data: MutationRecord[]) {\n        this.save(compile(data))\n        return this\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        return super.revoke(data => {\n            revoke(data)\n        })\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        return super.restore(data => {\n            restore(data)\n        })\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "60006d308c29171b9d3fd26c71e23b053da7bdd8"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27m3ie1qhy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_27m3ie1qhy();

var __extends = (cov_27m3ie1qhy().s[0]++, (cov_27m3ie1qhy().b[0][0]++, void 0) && (cov_27m3ie1qhy().b[0][1]++, (void 0).__extends) || (cov_27m3ie1qhy().b[0][2]++, function () {
  cov_27m3ie1qhy().f[0]++;
  cov_27m3ie1qhy().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_27m3ie1qhy().f[1]++;
    cov_27m3ie1qhy().s[2]++;
    _extendStatics = (cov_27m3ie1qhy().b[1][0]++, _setPrototypeOf["default"]) || (cov_27m3ie1qhy().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_27m3ie1qhy().b[1][2]++, function (d, b) {
      cov_27m3ie1qhy().f[2]++;
      cov_27m3ie1qhy().s[3]++;
      d.__proto__ = b;
    }) || (cov_27m3ie1qhy().b[1][3]++, function (d, b) {
      cov_27m3ie1qhy().f[3]++;
      cov_27m3ie1qhy().s[4]++;

      for (var p in b) {
        cov_27m3ie1qhy().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_27m3ie1qhy().b[2][0]++;
          cov_27m3ie1qhy().s[6]++;
          d[p] = b[p];
        } else {
          cov_27m3ie1qhy().b[2][1]++;
        }
      }
    });
    cov_27m3ie1qhy().s[7]++;
    return _extendStatics(d, b);
  };

  cov_27m3ie1qhy().s[8]++;
  return function (d, b) {
    cov_27m3ie1qhy().f[4]++;
    cov_27m3ie1qhy().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_27m3ie1qhy().f[5]++;
      cov_27m3ie1qhy().s[10]++;
      this.constructor = d;
    }

    cov_27m3ie1qhy().s[11]++;
    d.prototype = b === null ? (cov_27m3ie1qhy().b[3][0]++, (0, _create["default"])(b)) : (cov_27m3ie1qhy().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_27m3ie1qhy().s[12]++, (cov_27m3ie1qhy().b[4][0]++, void 0) && (cov_27m3ie1qhy().b[4][1]++, (void 0).__importDefault) || (cov_27m3ie1qhy().b[4][2]++, function (mod) {
  cov_27m3ie1qhy().f[6]++;
  cov_27m3ie1qhy().s[13]++;
  return (cov_27m3ie1qhy().b[6][0]++, mod) && (cov_27m3ie1qhy().b[6][1]++, mod.__esModule) ? (cov_27m3ie1qhy().b[5][0]++, mod) : (cov_27m3ie1qhy().b[5][1]++, {
    "default": mod
  });
}));

cov_27m3ie1qhy().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var cache_1 = (cov_27m3ie1qhy().s[15]++, __importDefault(__webpack_require__(95)));
var compile_1 = (cov_27m3ie1qhy().s[16]++, __importDefault(__webpack_require__(391)));
var decompilation_1 = (cov_27m3ie1qhy().s[17]++, __webpack_require__(392));
var NodeCache = (
/** @class */
cov_27m3ie1qhy().s[18]++, function (_super) {
  cov_27m3ie1qhy().f[7]++;
  cov_27m3ie1qhy().s[19]++;

  __extends(NodeCache, _super);

  function NodeCache(editor) {
    cov_27m3ie1qhy().f[8]++;

    var _this = (cov_27m3ie1qhy().s[20]++, (cov_27m3ie1qhy().b[7][0]++, _super.call(this, editor.config.historyMaxSize)) || (cov_27m3ie1qhy().b[7][1]++, this));

    cov_27m3ie1qhy().s[21]++;
    _this.editor = editor;
    cov_27m3ie1qhy().s[22]++;
    return _this;
  }

  cov_27m3ie1qhy().s[23]++;

  NodeCache.prototype.observe = function () {
    cov_27m3ie1qhy().f[9]++;
    cov_27m3ie1qhy().s[24]++;
    this.resetMaxSize(this.editor.config.historyMaxSize);
  };
  /**
   * 编译并保存数据
   */


  cov_27m3ie1qhy().s[25]++;

  NodeCache.prototype.compile = function (data) {
    cov_27m3ie1qhy().f[10]++;
    cov_27m3ie1qhy().s[26]++;
    this.save(compile_1["default"](data));
    cov_27m3ie1qhy().s[27]++;
    return this;
  };
  /**
   * 撤销
   */


  cov_27m3ie1qhy().s[28]++;

  NodeCache.prototype.revoke = function () {
    cov_27m3ie1qhy().f[11]++;
    cov_27m3ie1qhy().s[29]++;
    return _super.prototype.revoke.call(this, function (data) {
      cov_27m3ie1qhy().f[12]++;
      cov_27m3ie1qhy().s[30]++;
      decompilation_1.revoke(data);
    });
  };
  /**
   * 恢复
   */


  cov_27m3ie1qhy().s[31]++;

  NodeCache.prototype.restore = function () {
    cov_27m3ie1qhy().f[13]++;
    cov_27m3ie1qhy().s[32]++;
    return _super.prototype.restore.call(this, function (data) {
      cov_27m3ie1qhy().f[14]++;
      cov_27m3ie1qhy().s[33]++;
      decompilation_1.restore(data);
    });
  };

  cov_27m3ie1qhy().s[34]++;
  return NodeCache;
}(cache_1["default"]));
cov_27m3ie1qhy().s[35]++;
exports["default"] = NodeCache;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 数据结构 - 栈
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2a7v1xrlve() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/stack.ts";
  var hash = "4074a61440411853348b41926979de1fb00df49c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/stack.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 27
        }
      },
      "2": {
        start: {
          line: 12,
          column: 31
        },
        end: {
          line: 75,
          column: 3
        }
      },
      "3": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 40
        }
      },
      "4": {
        start: {
          line: 14,
          column: 30
        },
        end: {
          line: 14,
          column: 38
        }
      },
      "5": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 23
        }
      },
      "6": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 21
        }
      },
      "7": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 27
        }
      },
      "8": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 28
        }
      },
      "9": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 32
        }
      },
      "10": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 39,
          column: 6
        }
      },
      "11": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 36
        }
      },
      "12": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 38,
          column: 9
        }
      },
      "13": {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 31
        }
      },
      "14": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 30
        }
      },
      "15": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 49,
          column: 7
        }
      },
      "16": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "17": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 60,
          column: 6
        }
      },
      "18": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 32
        }
      },
      "19": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      "20": {
        start: {
          line: 57,
          column: 12
        },
        end: {
          line: 57,
          column: 40
        }
      },
      "21": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 59,
          column: 20
        }
      },
      "22": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 66,
          column: 6
        }
      },
      "23": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 33
        }
      },
      "24": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 73,
          column: 6
        }
      },
      "25": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 29
        }
      },
      "26": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 20
        }
      },
      "27": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 21
        }
      },
      "28": {
        start: {
          line: 76,
          column: 0
        },
        end: {
          line: 76,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 31
          },
          end: {
            line: 12,
            column: 32
          }
        },
        loc: {
          start: {
            line: 12,
            column: 43
          },
          end: {
            line: 75,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "CeilStack",
        decl: {
          start: {
            line: 13,
            column: 13
          },
          end: {
            line: 13,
            column: 22
          }
        },
        loc: {
          start: {
            line: 13,
            column: 28
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 35
          },
          end: {
            line: 33,
            column: 36
          }
        },
        loc: {
          start: {
            line: 33,
            column: 54
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 44,
            column: 13
          },
          end: {
            line: 44,
            column: 14
          }
        },
        loc: {
          start: {
            line: 44,
            column: 25
          },
          end: {
            line: 46,
            column: 9
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 54,
            column: 35
          }
        },
        loc: {
          start: {
            line: 54,
            column: 50
          },
          end: {
            line: 60,
            column: 5
          }
        },
        line: 54
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 64,
            column: 35
          },
          end: {
            line: 64,
            column: 36
          }
        },
        loc: {
          start: {
            line: 64,
            column: 47
          },
          end: {
            line: 66,
            column: 5
          }
        },
        line: 64
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 70,
            column: 32
          },
          end: {
            line: 70,
            column: 33
          }
        },
        loc: {
          start: {
            line: 70,
            column: 44
          },
          end: {
            line: 73,
            column: 5
          }
        },
        line: 70
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 14,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 14,
            column: 40
          }
        }, {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 14,
            column: 40
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 28,
            column: 11
          }
        }, {
          start: {
            line: 28,
            column: 16
          },
          end: {
            line: 28,
            column: 30
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }, {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 38,
            column: 9
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 23
          }
        }, {
          start: {
            line: 35,
            column: 27
          },
          end: {
            line: 35,
            column: 42
          }
        }],
        line: 35
      },
      "4": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 56
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 56,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 12
          },
          end: {
            line: 56,
            column: 20
          }
        }, {
          start: {
            line: 56,
            column: 24
          },
          end: {
            line: 56,
            column: 44
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/stack.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/stack.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;AAEH;;GAEG;AACH,0BAA0B;AAC1B;IAgBI,mBAAY,GAAe;QAAf,oBAAA,EAAA,OAAe;QAf3B;;WAEG;QACO,SAAI,GAAQ,EAAE,CAAA;QAExB;;WAEG;QACO,QAAG,GAAW,CAAC,CAAA;QAEzB;;WAEG;QACO,UAAK,GAAY,KAAK,CAAA;QAG5B,GAAG,GAAG,IAAI,CAAC,GAAG,CAAC,GAAG,CAAC,CAAA;QACnB,GAAG,IAAI,CAAC,IAAI,CAAC,GAAG,GAAG,GAAG,CAAC,CAAA;IAC3B,CAAC;IAED;;OAEG;IACI,4BAAQ,GAAf,UAAgB,OAAe;QAC3B,OAAO,GAAG,IAAI,CAAC,GAAG,CAAC,OAAO,CAAC,CAAA;QAC3B,IAAI,CAAC,IAAI,CAAC,KAAK,IAAI,CAAC,KAAK,CAAC,OAAO,CAAC,EAAE;YAChC,IAAI,CAAC,GAAG,GAAG,OAAO,CAAA;YAClB,IAAI,CAAC,KAAK,GAAG,IAAI,CAAA;SACpB;IACL,CAAC;IAKD,sBAAW,2BAAI;QAHf;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,IAAI,CAAC,MAAM,CAAA;QAC3B,CAAC;;;OAAA;IAED;;;OAGG;IACI,2BAAO,GAAd,UAAe,IAAO;QAClB,IAAI,CAAC,IAAI,CAAC,OAAO,CAAC,IAAI,CAAC,CAAA;QACvB,IAAI,IAAI,CAAC,GAAG,IAAI,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,GAAG,EAAE;YAClC,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,IAAI,CAAC,GAAG,CAAA;SAC9B;QACD,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,4BAAQ,GAAf;QACI,OAAO,IAAI,CAAC,IAAI,CAAC,KAAK,EAAE,CAAA;IAC5B,CAAC;IAED;;OAEG;IACI,yBAAK,GAAZ;QACI,IAAI,CAAC,IAAI,CAAC,MAAM,GAAG,CAAC,CAAA;QACpB,OAAO,IAAI,CAAA;IACf,CAAC;IACL,gBAAC;AAAD,CAAC,AAjED,IAiEC;AAjEY,8BAAS",
      sourcesContent: ["/**\n * @description \u6570\u636E\u7ED3\u6784 - \u6808\n * @author fangzhicong\n */\n\n/**\n * \u6808\uFF08\u9650\u5236\u6700\u5927\u6570\u636E\u6761\u6570\uFF0C\u6808\u6EE1\u540E\u53EF\u4EE5\u7EE7\u7EED\u5165\u6808\uFF0C\u800C\u5148\u5165\u6808\u7684\u6570\u636E\u5C06\u5931\u6548\uFF09\n */\n// \u53D6\u540D\u7075\u611F\u6765\u81EA Math.ceil\uFF0C\u5411\u4E0A\u53D6\u6709\u6548\u503C\nexport class CeilStack<T> {\n    /**\n     * \u6570\u636E\u7F13\u5B58\n     */\n    protected data: T[] = []\n\n    /**\n     * \u6808\u7684\u6700\u5927\u957F\u5EA6\u3002\u4E3A\u96F6\u5219\u957F\u5EA6\u4E0D\u9650\n     */\n    protected max: number = 0\n\n    /**\n     * \u6807\u8BC6\u662F\u5426\u91CD\u8BBE\u8FC7 max \u503C\n     */\n    protected reset: boolean = false\n\n    constructor(max: number = 0) {\n        max = Math.abs(max)\n        max && (this.max = max)\n    }\n\n    /**\n     * \u5141\u8BB8\u7528\u6237\u91CD\u8BBE\u4E00\u6B21 max \u503C\n     */\n    public resetMax(maxSize: number) {\n        maxSize = Math.abs(maxSize)\n        if (!this.reset && !isNaN(maxSize)) {\n            this.max = maxSize\n            this.reset = true\n        }\n    }\n\n    /**\n     * \u5F53\u524D\u6808\u4E2D\u7684\u6570\u636E\u6761\u6570\n     */\n    public get size() {\n        return this.data.length\n    }\n\n    /**\n     * \u5165\u6808\n     * @param data \u5165\u6808\u7684\u6570\u636E\n     */\n    public instack(data: T) {\n        this.data.unshift(data)\n        if (this.max && this.size > this.max) {\n            this.data.length = this.max\n        }\n        return this\n    }\n\n    /**\n     * \u51FA\u6808\n     */\n    public outstack(): T | undefined {\n        return this.data.shift()\n    }\n\n    /**\n     * \u6E05\u7A7A\u6808\n     */\n    public clear() {\n        this.data.length = 0\n        return this\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4074a61440411853348b41926979de1fb00df49c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2a7v1xrlve = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2a7v1xrlve();
cov_2a7v1xrlve().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_2a7v1xrlve().s[1]++;
exports.CeilStack = void 0;
/**
 * 栈（限制最大数据条数，栈满后可以继续入栈，而先入栈的数据将失效）
 */
// 取名灵感来自 Math.ceil，向上取有效值

var CeilStack = (
/** @class */
cov_2a7v1xrlve().s[2]++, function () {
  cov_2a7v1xrlve().f[0]++;

  function CeilStack(max) {
    cov_2a7v1xrlve().f[1]++;
    cov_2a7v1xrlve().s[3]++;

    if (max === void 0) {
      cov_2a7v1xrlve().b[0][0]++;
      cov_2a7v1xrlve().s[4]++;
      max = 0;
    } else {
      cov_2a7v1xrlve().b[0][1]++;
    }
    /**
     * 数据缓存
     */


    cov_2a7v1xrlve().s[5]++;
    this.data = [];
    /**
     * 栈的最大长度。为零则长度不限
     */

    cov_2a7v1xrlve().s[6]++;
    this.max = 0;
    /**
     * 标识是否重设过 max 值
     */

    cov_2a7v1xrlve().s[7]++;
    this.reset = false;
    cov_2a7v1xrlve().s[8]++;
    max = Math.abs(max);
    cov_2a7v1xrlve().s[9]++;
    (cov_2a7v1xrlve().b[1][0]++, max) && (cov_2a7v1xrlve().b[1][1]++, this.max = max);
  }
  /**
   * 允许用户重设一次 max 值
   */


  cov_2a7v1xrlve().s[10]++;

  CeilStack.prototype.resetMax = function (maxSize) {
    cov_2a7v1xrlve().f[2]++;
    cov_2a7v1xrlve().s[11]++;
    maxSize = Math.abs(maxSize);
    cov_2a7v1xrlve().s[12]++;

    if ((cov_2a7v1xrlve().b[3][0]++, !this.reset) && (cov_2a7v1xrlve().b[3][1]++, !isNaN(maxSize))) {
      cov_2a7v1xrlve().b[2][0]++;
      cov_2a7v1xrlve().s[13]++;
      this.max = maxSize;
      cov_2a7v1xrlve().s[14]++;
      this.reset = true;
    } else {
      cov_2a7v1xrlve().b[2][1]++;
    }
  };

  cov_2a7v1xrlve().s[15]++;
  (0, _defineProperty["default"])(CeilStack.prototype, "size", {
    /**
     * 当前栈中的数据条数
     */
    get: function get() {
      cov_2a7v1xrlve().f[3]++;
      cov_2a7v1xrlve().s[16]++;
      return this.data.length;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 入栈
   * @param data 入栈的数据
   */

  cov_2a7v1xrlve().s[17]++;

  CeilStack.prototype.instack = function (data) {
    cov_2a7v1xrlve().f[4]++;
    cov_2a7v1xrlve().s[18]++;
    this.data.unshift(data);
    cov_2a7v1xrlve().s[19]++;

    if ((cov_2a7v1xrlve().b[5][0]++, this.max) && (cov_2a7v1xrlve().b[5][1]++, this.size > this.max)) {
      cov_2a7v1xrlve().b[4][0]++;
      cov_2a7v1xrlve().s[20]++;
      this.data.length = this.max;
    } else {
      cov_2a7v1xrlve().b[4][1]++;
    }

    cov_2a7v1xrlve().s[21]++;
    return this;
  };
  /**
   * 出栈
   */


  cov_2a7v1xrlve().s[22]++;

  CeilStack.prototype.outstack = function () {
    cov_2a7v1xrlve().f[5]++;
    cov_2a7v1xrlve().s[23]++;
    return this.data.shift();
  };
  /**
   * 清空栈
   */


  cov_2a7v1xrlve().s[24]++;

  CeilStack.prototype.clear = function () {
    cov_2a7v1xrlve().f[6]++;
    cov_2a7v1xrlve().s[25]++;
    this.data.length = 0;
    cov_2a7v1xrlve().s[26]++;
    return this;
  };

  cov_2a7v1xrlve().s[27]++;
  return CeilStack;
}());
cov_2a7v1xrlve().s[28]++;
exports.CeilStack = CeilStack;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 数据整理
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _indexOf = _interopRequireDefault(__webpack_require__(53));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_1v6i6gl552() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/compile.ts";
  var hash = "aa72bb5bb43fc47fc9ed885395104f7bbd65b477";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/compile.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 13
        },
        end: {
          line: 7,
          column: 46
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "3": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 14,
          column: 26
        }
      },
      "4": {
        start: {
          line: 16,
          column: 12
        },
        end: {
          line: 16,
          column: 26
        }
      },
      "5": {
        start: {
          line: 18,
          column: 12
        },
        end: {
          line: 18,
          column: 26
        }
      },
      "6": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 32,
          column: 5
        }
      },
      "7": {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 70
        }
      },
      "8": {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 29,
          column: 43
        }
      },
      "9": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 22
        }
      },
      "10": {
        start: {
          line: 38,
          column: 15
        },
        end: {
          line: 38,
          column: 17
        }
      },
      "11": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "12": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 51
        }
      },
      "13": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "14": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 56
        }
      },
      "15": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 16
        }
      },
      "16": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "17": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 56,
          column: 10
        }
      },
      "18": {
        start: {
          line: 58,
          column: 9
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "19": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 62,
          column: 10
        }
      },
      "20": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 68,
          column: 10
        }
      },
      "21": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 16
        }
      },
      "22": {
        start: {
          line: 75,
          column: 10
        },
        end: {
          line: 75,
          column: 58
        }
      },
      "23": {
        start: {
          line: 80,
          column: 15
        },
        end: {
          line: 80,
          column: 17
        }
      },
      "24": {
        start: {
          line: 83,
          column: 21
        },
        end: {
          line: 83,
          column: 26
        }
      },
      "25": {
        start: {
          line: 85,
          column: 22
        },
        end: {
          line: 85,
          column: 24
        }
      },
      "26": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 149,
          column: 7
        }
      },
      "27": {
        start: {
          line: 87,
          column: 19
        },
        end: {
          line: 95,
          column: 9
        }
      },
      "28": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 24
        }
      },
      "29": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 100,
          column: 9
        }
      },
      "30": {
        start: {
          line: 99,
          column: 12
        },
        end: {
          line: 99,
          column: 19
        }
      },
      "31": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 139,
          column: 9
        }
      },
      "32": {
        start: {
          line: 106,
          column: 32
        },
        end: {
          line: 106,
          column: 52
        }
      },
      "33": {
        start: {
          line: 107,
          column: 32
        },
        end: {
          line: 120,
          column: 13
        }
      },
      "34": {
        start: {
          line: 122,
          column: 12
        },
        end: {
          line: 138,
          column: 13
        }
      },
      "35": {
        start: {
          line: 123,
          column: 16
        },
        end: {
          line: 123,
          column: 83
        }
      },
      "36": {
        start: {
          line: 124,
          column: 16
        },
        end: {
          line: 124,
          column: 41
        }
      },
      "37": {
        start: {
          line: 127,
          column: 17
        },
        end: {
          line: 138,
          column: 13
        }
      },
      "38": {
        start: {
          line: 128,
          column: 16
        },
        end: {
          line: 130,
          column: 17
        }
      },
      "39": {
        start: {
          line: 129,
          column: 20
        },
        end: {
          line: 129,
          column: 87
        }
      },
      "40": {
        start: {
          line: 131,
          column: 16
        },
        end: {
          line: 131,
          column: 41
        }
      },
      "41": {
        start: {
          line: 134,
          column: 17
        },
        end: {
          line: 138,
          column: 13
        }
      },
      "42": {
        start: {
          line: 136,
          column: 16
        },
        end: {
          line: 136,
          column: 83
        }
      },
      "43": {
        start: {
          line: 137,
          column: 16
        },
        end: {
          line: 137,
          column: 41
        }
      },
      "44": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 148,
          column: 9
        }
      },
      "45": {
        start: {
          line: 142,
          column: 12
        },
        end: {
          line: 142,
          column: 48
        }
      },
      "46": {
        start: {
          line: 143,
          column: 12
        },
        end: {
          line: 143,
          column: 41
        }
      },
      "47": {
        start: {
          line: 146,
          column: 12
        },
        end: {
          line: 146,
          column: 31
        }
      },
      "48": {
        start: {
          line: 147,
          column: 12
        },
        end: {
          line: 147,
          column: 35
        }
      },
      "49": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 16
        }
      },
      "50": {
        start: {
          line: 152,
          column: 0
        },
        end: {
          line: 152,
          column: 26
        }
      },
      "51": {
        start: {
          line: 155,
          column: 16
        },
        end: {
          line: 155,
          column: 17
        }
      },
      "52": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 163,
          column: 5
        }
      },
      "53": {
        start: {
          line: 156,
          column: 17
        },
        end: {
          line: 156,
          column: 34
        }
      },
      "54": {
        start: {
          line: 157,
          column: 8
        },
        end: {
          line: 162,
          column: 9
        }
      },
      "55": {
        start: {
          line: 158,
          column: 12
        },
        end: {
          line: 158,
          column: 20
        }
      },
      "56": {
        start: {
          line: 161,
          column: 12
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "57": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 17
        }
      }
    },
    fnMap: {
      "0": {
        name: "compileType",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "compileValue",
        decl: {
          start: {
            line: 24,
            column: 9
          },
          end: {
            line: 24,
            column: 21
          }
        },
        loc: {
          start: {
            line: 24,
            column: 28
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 24
      },
      "2": {
        name: "complieNodes",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 21
          }
        },
        loc: {
          start: {
            line: 37,
            column: 28
          },
          end: {
            line: 46,
            column: 1
          }
        },
        line: 37
      },
      "3": {
        name: "compliePosition",
        decl: {
          start: {
            line: 50,
            column: 9
          },
          end: {
            line: 50,
            column: 24
          }
        },
        loc: {
          start: {
            line: 50,
            column: 31
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 50
      },
      "4": {
        name: "compile",
        decl: {
          start: {
            line: 79,
            column: 9
          },
          end: {
            line: 79,
            column: 16
          }
        },
        loc: {
          start: {
            line: 79,
            column: 23
          },
          end: {
            line: 151,
            column: 1
          }
        },
        line: 79
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 86,
            column: 17
          },
          end: {
            line: 86,
            column: 18
          }
        },
        loc: {
          start: {
            line: 86,
            column: 42
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 86
      },
      "6": {
        name: "contains",
        decl: {
          start: {
            line: 154,
            column: 9
          },
          end: {
            line: 154,
            column: 17
          }
        },
        loc: {
          start: {
            line: 154,
            column: 31
          },
          end: {
            line: 165,
            column: 1
          }
        },
        line: 154
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 14,
            column: 26
          }
        }, {
          start: {
            line: 15,
            column: 8
          },
          end: {
            line: 16,
            column: 26
          }
        }, {
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 18,
            column: 26
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 32,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 26,
            column: 8
          },
          end: {
            line: 27,
            column: 70
          }
        }, {
          start: {
            line: 28,
            column: 8
          },
          end: {
            line: 29,
            column: 43
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 31,
            column: 22
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 19
          },
          end: {
            line: 27,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 19
          },
          end: {
            line: 27,
            column: 63
          }
        }, {
          start: {
            line: 27,
            column: 67
          },
          end: {
            line: 27,
            column: 69
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }],
        line: 42
      },
      "5": {
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 52
      },
      "6": {
        loc: {
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 69,
            column: 5
          }
        }],
        line: 58
      },
      "7": {
        loc: {
          start: {
            line: 90,
            column: 18
          },
          end: {
            line: 90,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 18
          },
          end: {
            line: 90,
            column: 38
          }
        }, {
          start: {
            line: 90,
            column: 42
          },
          end: {
            line: 90,
            column: 44
          }
        }],
        line: 90
      },
      "8": {
        loc: {
          start: {
            line: 91,
            column: 19
          },
          end: {
            line: 91,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 19
          },
          end: {
            line: 91,
            column: 39
          }
        }, {
          start: {
            line: 91,
            column: 43
          },
          end: {
            line: 91,
            column: 45
          }
        }],
        line: 91
      },
      "9": {
        loc: {
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 22
          },
          end: {
            line: 92,
            column: 37
          }
        }, {
          start: {
            line: 92,
            column: 41
          },
          end: {
            line: 92,
            column: 43
          }
        }],
        line: 92
      },
      "10": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }, {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 100,
            column: 9
          }
        }],
        line: 98
      },
      "11": {
        loc: {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 139,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 139,
            column: 9
          }
        }, {
          start: {
            line: 104,
            column: 8
          },
          end: {
            line: 139,
            column: 9
          }
        }],
        line: 104
      },
      "12": {
        loc: {
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 104,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 104,
            column: 12
          },
          end: {
            line: 104,
            column: 22
          }
        }, {
          start: {
            line: 104,
            column: 26
          },
          end: {
            line: 104,
            column: 50
          }
        }, {
          start: {
            line: 104,
            column: 54
          },
          end: {
            line: 104,
            column: 88
          }
        }],
        line: 104
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 138,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 138,
            column: 13
          }
        }, {
          start: {
            line: 122,
            column: 12
          },
          end: {
            line: 138,
            column: 13
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 127,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        }, {
          start: {
            line: 127,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        }],
        line: 127
      },
      "15": {
        loc: {
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 130,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 130,
            column: 17
          }
        }, {
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 130,
            column: 17
          }
        }],
        line: 128
      },
      "16": {
        loc: {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        }, {
          start: {
            line: 134,
            column: 17
          },
          end: {
            line: 138,
            column: 13
          }
        }],
        line: 134
      },
      "17": {
        loc: {
          start: {
            line: 134,
            column: 21
          },
          end: {
            line: 135,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 21
          },
          end: {
            line: 134,
            column: 62
          }
        }, {
          start: {
            line: 135,
            column: 16
          },
          end: {
            line: 135,
            column: 52
          }
        }],
        line: 134
      },
      "18": {
        loc: {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }, {
          start: {
            line: 141,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }],
        line: 141
      },
      "19": {
        loc: {
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 141,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 12
          },
          end: {
            line: 141,
            column: 31
          }
        }, {
          start: {
            line: 141,
            column: 35
          },
          end: {
            line: 141,
            column: 66
          }
        }],
        line: 141
      },
      "20": {
        loc: {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        }, {
          start: {
            line: 157,
            column: 8
          },
          end: {
            line: 162,
            column: 9
          }
        }],
        line: 157
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/compile.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/compile.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;AAGH,+CAAoD;AAEpD;;GAEG;AACH,SAAS,WAAW,CAAC,IAAY;IAC7B,QAAQ,IAAI,EAAE;QACV,KAAK,WAAW;YACZ,OAAO,MAAM,CAAA;QACjB,KAAK,YAAY;YACb,OAAO,MAAM,CAAA;QACjB;YACI,OAAO,MAAM,CAAA;KACpB;AACL,CAAC;AAED;;GAEG;AACH,SAAS,YAAY,CAAC,IAAoB;IACtC,QAAQ,IAAI,CAAC,IAAI,EAAE;QACf,KAAK,YAAY;YACb,OAAQ,IAAI,CAAC,MAAkB,CAAC,YAAY,CAAC,IAAI,CAAC,aAAuB,CAAC,IAAI,EAAE,CAAA;QACpF,KAAK,eAAe;YAChB,OAAO,IAAI,CAAC,MAAM,CAAC,WAAW,CAAA;QAClC;YACI,OAAO,EAAE,CAAA;KAChB;AACL,CAAC;AAED;;GAEG;AACH,SAAS,YAAY,CAAC,IAAoB;IACtC,IAAM,IAAI,GAAc,EAAE,CAAA;IAC1B,IAAI,IAAI,CAAC,UAAU,CAAC,MAAM,EAAE;QACxB,IAAI,CAAC,GAAG,GAAG,cAAO,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;KACtC;IACD,IAAI,IAAI,CAAC,YAAY,CAAC,MAAM,EAAE;QAC1B,IAAI,CAAC,MAAM,GAAG,cAAO,CAAC,IAAI,CAAC,YAAY,CAAC,CAAA;KAC3C;IACD,OAAO,IAAI,CAAA;AACf,CAAC;AAED;;GAEG;AACH,SAAS,eAAe,CAAC,IAAoB;IACzC,IAAI,IAAoB,CAAA;IACxB,IAAI,IAAI,CAAC,eAAe,EAAE;QACtB,IAAI,GAAG;YACH,IAAI,EAAE,QAAQ;YACd,MAAM,EAAE,IAAI,CAAC,eAAe;SAC/B,CAAA;KACJ;SAAM,IAAI,IAAI,CAAC,WAAW,EAAE;QACzB,IAAI,GAAG;YACH,IAAI,EAAE,OAAO;YACb,MAAM,EAAE,IAAI,CAAC,WAAW;SAC3B,CAAA;KACJ;SAAM;QACH,IAAI,GAAG;YACH,IAAI,EAAE,QAAQ;YACd,MAAM,EAAE,IAAI,CAAC,MAAM;SACtB,CAAA;KACJ;IACD,OAAO,IAAI,CAAA;AACf,CAAC;AAED;;GAEG;AACH,IAAM,GAAG,GAAG,CAAC,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,EAAE,IAAI,CAAC,CAAA;AAE5D;;GAEG;AACH,SAAwB,OAAO,CAAC,IAAsB;IAClD,IAAM,IAAI,GAAc,EAAE,CAAA;IAC1B,0BAA0B;IAC1B,eAAe;IACf,IAAI,UAAU,GAAiB,KAAK,CAAA;IACpC,YAAY;IACZ,IAAM,WAAW,GAAW,EAAE,CAAA;IAC9B,IAAI,CAAC,OAAO,CAAC,UAAC,MAAM,EAAE,KAAK;QACvB,IAAM,IAAI,GAAY;YAClB,IAAI,EAAE,WAAW,CAAC,MAAM,CAAC,IAAI,CAAC;YAC9B,MAAM,EAAE,MAAM,CAAC,MAAM;YACrB,IAAI,EAAE,MAAM,CAAC,aAAa,IAAI,EAAE;YAChC,KAAK,EAAE,YAAY,CAAC,MAAM,CAAC,IAAI,EAAE;YACjC,QAAQ,EAAE,MAAM,CAAC,QAAQ,IAAI,EAAE;YAC/B,KAAK,EAAE,YAAY,CAAC,MAAM,CAAC;YAC3B,QAAQ,EAAE,eAAe,CAAC,MAAM,CAAC;SACpC,CAAA;QACD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QACf,wCAAwC;QACxC,IAAI,CAAC,SAAE,CAAC,SAAS,EAAE;YACf,OAAM;SACT;QACD,gDAAgD;QAChD,yDAAyD;QACzD,8EAA8E;QAC9E,IAAI,UAAU,IAAI,MAAM,CAAC,UAAU,CAAC,MAAM,IAAI,MAAM,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,QAAQ,IAAI,CAAC,EAAE;YAC9E,cAAc;YACd,IAAM,aAAa,GAAG,MAAM,CAAC,UAAU,CAAC,CAAC,CAAC,CAAA;YAC1C,IAAM,aAAa,GAAY;gBAC3B,IAAI,EAAE,MAAM;gBACZ,MAAM,EAAE,aAAa;gBACrB,IAAI,EAAE,EAAE;gBACR,KAAK,EAAE,EAAE;gBACT,QAAQ,EAAE,EAAE;gBACZ,KAAK,EAAE;oBACH,GAAG,EAAE,CAAC,UAAU,CAAC;iBACpB;gBACD,QAAQ,EAAE;oBACN,IAAI,EAAE,QAAQ;oBACd,MAAM,EAAE,aAAa;iBACxB;aACJ,CAAA;YACD,yDAAyD;YACzD,IAAI,GAAG,CAAC,OAAO,CAAC,aAAa,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC,EAAE;gBAC3C,aAAa,CAAC,KAAK,CAAC,GAAG,GAAG,cAAO,CAAC,aAAa,CAAC,UAAU,CAAC,CAAA;gBAC3D,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;aAC3B;YACD,eAAe;iBACV,IAAI,UAAU,CAAC,QAAQ,IAAI,CAAC,EAAE;gBAC/B,IAAI,QAAQ,CAAC,aAAa,EAAE,WAAW,CAAC,EAAE;oBACtC,aAAa,CAAC,KAAK,CAAC,GAAG,GAAG,cAAO,CAAC,aAAa,CAAC,UAAU,CAAC,CAAA;iBAC9D;gBACD,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;aAC3B;YACD,kDAAkD;iBAC7C,IACD,GAAG,CAAC,OAAO,CAAC,MAAM,CAAC,MAAM,CAAC,QAAQ,CAAC,IAAI,CAAC,CAAC;gBACzC,QAAQ,CAAC,aAAa,EAAE,WAAW,CAAC,EACtC;gBACE,aAAa,CAAC,KAAK,CAAC,GAAG,GAAG,cAAO,CAAC,aAAa,CAAC,UAAU,CAAC,CAAA;gBAC3D,IAAI,CAAC,IAAI,CAAC,aAAa,CAAC,CAAA;aAC3B;SACJ;QACD,YAAY;QACZ,IAAI,IAAI,CAAC,IAAI,IAAI,MAAM,IAAI,MAAM,CAAC,YAAY,CAAC,MAAM,IAAI,CAAC,EAAE;YACxD,UAAU,GAAG,MAAM,CAAC,YAAY,CAAC,CAAC,CAAC,CAAA;YACnC,WAAW,CAAC,IAAI,CAAC,UAAU,CAAC,CAAA;SAC/B;aAAM;YACH,UAAU,GAAG,KAAK,CAAA;YAClB,WAAW,CAAC,MAAM,GAAG,CAAC,CAAA;SACzB;IACL,CAAC,CAAC,CAAA;IACF,OAAO,IAAI,CAAA;AACf,CAAC;AAzED,0BAyEC;AAED,2BAA2B;AAC3B,SAAS,QAAQ,CAAC,GAAS,EAAE,MAAc;IACvC,IAAI,KAAK,GAAG,CAAC,CAAA;IACb,KAAK,IAAI,CAAC,GAAG,MAAM,CAAC,MAAM,GAAG,CAAC,EAAE,CAAC,GAAG,CAAC,EAAE,CAAC,EAAE,EAAE;QACxC,IAAI,GAAG,CAAC,QAAQ,CAAC,MAAM,CAAC,CAAC,CAAC,CAAC,EAAE;YACzB,KAAK,EAAE,CAAA;SACV;aAAM;YACH,MAAK;SACR;KACJ;IACD,OAAO,KAAK,CAAA;AAChB,CAAC",
      sourcesContent: ["/**\n * @description \u6570\u636E\u6574\u7406\n * @author fangzhicong\n */\n\nimport { TargetPosition, DiffNodes, Compile } from '../type'\nimport { UA, toArray } from '../../../../utils/util'\n\n/**\n * \u6570\u636E\u7C7B\u578B\n */\nfunction compileType(data: string) {\n    switch (data) {\n        case 'childList':\n            return 'node'\n        case 'attributes':\n            return 'attr'\n        default:\n            return 'text'\n    }\n}\n\n/**\n * \u83B7\u53D6\u5F53\u524D\u7684\u6587\u672C\u5185\u5BB9\n */\nfunction compileValue(data: MutationRecord) {\n    switch (data.type) {\n        case 'attributes':\n            return (data.target as Element).getAttribute(data.attributeName as string) || ''\n        case 'characterData':\n            return data.target.textContent\n        default:\n            return ''\n    }\n}\n\n/**\n * addedNodes/removedNodes\n */\nfunction complieNodes(data: MutationRecord) {\n    const temp: DiffNodes = {}\n    if (data.addedNodes.length) {\n        temp.add = toArray(data.addedNodes)\n    }\n    if (data.removedNodes.length) {\n        temp.remove = toArray(data.removedNodes)\n    }\n    return temp\n}\n\n/**\n * addedNodes/removedNodes \u7684\u76F8\u5BF9\u4F4D\u7F6E\n */\nfunction compliePosition(data: MutationRecord) {\n    let temp: TargetPosition\n    if (data.previousSibling) {\n        temp = {\n            type: 'before',\n            target: data.previousSibling,\n        }\n    } else if (data.nextSibling) {\n        temp = {\n            type: 'after',\n            target: data.nextSibling,\n        }\n    } else {\n        temp = {\n            type: 'parent',\n            target: data.target,\n        }\n    }\n    return temp\n}\n\n/**\n * \u8865\u5168 Firefox \u6570\u636E\u7684\u7279\u6B8A\u6807\u7B7E\n */\nconst tag = ['UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']\n\n/**\n * \u5C06 MutationRecord \u8F6C\u6362\u6210\u81EA\u5B9A\u4E49\u683C\u5F0F\u7684\u6570\u636E\n */\nexport default function compile(data: MutationRecord[]) {\n    const temp: Compile[] = []\n    // \u4EE5\u4E0B\u4E24\u4E2A\u53D8\u91CF\u662F\u517C\u5BB9 Firefox \u65F6\u4F7F\u7528\u5230\u7684\n    // \u524D\u4E00\u6B21\u64CD\u4F5C\u4E3A\u5220\u9664\u5143\u7D20\u8282\u70B9\n    let removeNode: Node | false = false\n    // \u8FDE\u7EED\u7684\u8282\u70B9\u5220\u9664\u8BB0\u5F55\n    const removeCache: Node[] = []\n    data.forEach((record, index) => {\n        const item: Compile = {\n            type: compileType(record.type),\n            target: record.target,\n            attr: record.attributeName || '',\n            value: compileValue(record) || '',\n            oldValue: record.oldValue || '',\n            nodes: complieNodes(record),\n            position: compliePosition(record),\n        }\n        temp.push(item)\n        // \u517C\u5BB9 Firefox\uFF0C\u8865\u5168\u6570\u636E\uFF08\u8FD9\u51E0\u5341\u884C\u4EE3\u7801\u5199\u5F97\u5410\u8840\uFF0C\u8DDF IE \u6709\u5F97\u4E00\u62FC\uFF09\n        if (!UA.isFirefox) {\n            return\n        }\n        // \u6B63\u5E38\u7684\u6570\u636E\uFF1A\u7F29\u8FDB\u3001\u884C\u9AD8\u3001\u8D85\u94FE\u63A5\u3001\u5BF9\u9F50\u65B9\u5F0F\u3001\u5F15\u7528\u3001\u63D2\u5165\u8868\u60C5\u3001\u63D2\u5165\u56FE\u7247\u3001\u5206\u5272\u7EBF\u3001\u8868\u683C\u3001\u63D2\u5165\u4EE3\u7801\n        // \u666E\u901A\u7684\u6570\u636E\u8865\u5168\uFF1A\u6807\u9898\uFF08\u7EAF\u6587\u672C\u5185\u5BB9\uFF09\u3001\u52A0\u7C97\u3001\u659C\u4F53\u3001\u5220\u9664\u7EBF\u3001\u4E0B\u5212\u7EBF\u3001\u989C\u8272\u3001\u80CC\u666F\u8272\u3001\u5B57\u4F53\u3001\u5B57\u53F7\u3001\u5217\u8868\uFF08\u7EAF\u6587\u672C\u5185\u5BB9\uFF09\n        // \u7279\u6B8A\u7684\u6570\u636E\u8865\u5168\uFF1A\u6807\u9898\uFF08\u5305\u542B HTMLElement\uFF09\u3001\u5217\u8868\uFF08\u5305\u542B HTMLElement \u6216 ul -> ol \u6216 ol -> ul \u6216 Enter\uFF09\n        if (removeNode && record.addedNodes.length && record.addedNodes[0].nodeType == 1) {\n            // \u9700\u8981\u88AB\u5168\u6570\u636E\u7684\u76EE\u6807\u8282\u70B9\n            const replenishNode = record.addedNodes[0]\n            const replenishData: Compile = {\n                type: 'node',\n                target: replenishNode,\n                attr: '',\n                value: '',\n                oldValue: '',\n                nodes: {\n                    add: [removeNode],\n                },\n                position: {\n                    type: 'parent',\n                    target: replenishNode,\n                },\n            }\n            // \u7279\u6B8A\u7684\u6807\u7B7E\uFF1A['UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']\n            if (tag.indexOf(replenishNode.nodeName) != -1) {\n                replenishData.nodes.add = toArray(replenishNode.childNodes)\n                temp.push(replenishData)\n            }\n            // \u4E0A\u4E00\u4E2A\u5220\u9664\u5143\u7D20\u662F\u6587\u672C\u8282\u70B9\n            else if (removeNode.nodeType == 3) {\n                if (contains(replenishNode, removeCache)) {\n                    replenishData.nodes.add = toArray(replenishNode.childNodes)\n                }\n                temp.push(replenishData)\n            }\n            // \u4E0A\u4E00\u4E2A\u5220\u9664\u5143\u7D20\u662F Element && \u7531\u8FD1\u5230\u8FDC\u7684\u5220\u9664\u5143\u7D20\u81F3\u5C11\u6709\u4E00\u4E2A\u662F\u9700\u8981\u8865\u5168\u6570\u636E\u8282\u70B9\u7684\u5B50\u8282\u70B9\n            else if (\n                tag.indexOf(record.target.nodeName) == -1 &&\n                contains(replenishNode, removeCache)\n            ) {\n                replenishData.nodes.add = toArray(replenishNode.childNodes)\n                temp.push(replenishData)\n            }\n        }\n        // \u8BB0\u5F55\u672C\u6B21\u7684\u8282\u70B9\u4FE1\u606F\n        if (item.type == 'node' && record.removedNodes.length == 1) {\n            removeNode = record.removedNodes[0]\n            removeCache.push(removeNode)\n        } else {\n            removeNode = false\n            removeCache.length = 0\n        }\n    })\n    return temp\n}\n\n// \u5220\u9664\u5143\u7D20\u7684\u5386\u53F2\u8BB0\u5F55\u4E2D\u5305\u542B\u6709\u591A\u5C11\u4E2A\u76EE\u6807\u8282\u70B9\u7684\u5B50\u5143\u7D20\nfunction contains(tar: Node, childs: Node[]) {\n    let count = 0\n    for (let i = childs.length - 1; i > 0; i--) {\n        if (tar.contains(childs[i])) {\n            count++\n        } else {\n            break\n        }\n    }\n    return count\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "aa72bb5bb43fc47fc9ed885395104f7bbd65b477"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1v6i6gl552 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1v6i6gl552();
cov_1v6i6gl552().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var util_1 = (cov_1v6i6gl552().s[1]++, __webpack_require__(7));
/**
 * 数据类型
 */

function compileType(data) {
  cov_1v6i6gl552().f[0]++;
  cov_1v6i6gl552().s[2]++;

  switch (data) {
    case 'childList':
      cov_1v6i6gl552().b[0][0]++;
      cov_1v6i6gl552().s[3]++;
      return 'node';

    case 'attributes':
      cov_1v6i6gl552().b[0][1]++;
      cov_1v6i6gl552().s[4]++;
      return 'attr';

    default:
      cov_1v6i6gl552().b[0][2]++;
      cov_1v6i6gl552().s[5]++;
      return 'text';
  }
}
/**
 * 获取当前的文本内容
 */


function compileValue(data) {
  cov_1v6i6gl552().f[1]++;
  cov_1v6i6gl552().s[6]++;

  switch (data.type) {
    case 'attributes':
      cov_1v6i6gl552().b[1][0]++;
      cov_1v6i6gl552().s[7]++;
      return (cov_1v6i6gl552().b[2][0]++, data.target.getAttribute(data.attributeName)) || (cov_1v6i6gl552().b[2][1]++, '');

    case 'characterData':
      cov_1v6i6gl552().b[1][1]++;
      cov_1v6i6gl552().s[8]++;
      return data.target.textContent;

    default:
      cov_1v6i6gl552().b[1][2]++;
      cov_1v6i6gl552().s[9]++;
      return '';
  }
}
/**
 * addedNodes/removedNodes
 */


function complieNodes(data) {
  cov_1v6i6gl552().f[2]++;
  var temp = (cov_1v6i6gl552().s[10]++, {});
  cov_1v6i6gl552().s[11]++;

  if (data.addedNodes.length) {
    cov_1v6i6gl552().b[3][0]++;
    cov_1v6i6gl552().s[12]++;
    temp.add = util_1.toArray(data.addedNodes);
  } else {
    cov_1v6i6gl552().b[3][1]++;
  }

  cov_1v6i6gl552().s[13]++;

  if (data.removedNodes.length) {
    cov_1v6i6gl552().b[4][0]++;
    cov_1v6i6gl552().s[14]++;
    temp.remove = util_1.toArray(data.removedNodes);
  } else {
    cov_1v6i6gl552().b[4][1]++;
  }

  cov_1v6i6gl552().s[15]++;
  return temp;
}
/**
 * addedNodes/removedNodes 的相对位置
 */


function compliePosition(data) {
  cov_1v6i6gl552().f[3]++;
  var temp;
  cov_1v6i6gl552().s[16]++;

  if (data.previousSibling) {
    cov_1v6i6gl552().b[5][0]++;
    cov_1v6i6gl552().s[17]++;
    temp = {
      type: 'before',
      target: data.previousSibling
    };
  } else {
    cov_1v6i6gl552().b[5][1]++;
    cov_1v6i6gl552().s[18]++;

    if (data.nextSibling) {
      cov_1v6i6gl552().b[6][0]++;
      cov_1v6i6gl552().s[19]++;
      temp = {
        type: 'after',
        target: data.nextSibling
      };
    } else {
      cov_1v6i6gl552().b[6][1]++;
      cov_1v6i6gl552().s[20]++;
      temp = {
        type: 'parent',
        target: data.target
      };
    }
  }

  cov_1v6i6gl552().s[21]++;
  return temp;
}
/**
 * 补全 Firefox 数据的特殊标签
 */


var tag = (cov_1v6i6gl552().s[22]++, ['UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']);
/**
 * 将 MutationRecord 转换成自定义格式的数据
 */

function compile(data) {
  cov_1v6i6gl552().f[4]++;
  var temp = (cov_1v6i6gl552().s[23]++, []); // 以下两个变量是兼容 Firefox 时使用到的
  // 前一次操作为删除元素节点

  var removeNode = (cov_1v6i6gl552().s[24]++, false); // 连续的节点删除记录

  var removeCache = (cov_1v6i6gl552().s[25]++, []);
  cov_1v6i6gl552().s[26]++;
  (0, _forEach["default"])(data).call(data, function (record, index) {
    cov_1v6i6gl552().f[5]++;
    var item = (cov_1v6i6gl552().s[27]++, {
      type: compileType(record.type),
      target: record.target,
      attr: (cov_1v6i6gl552().b[7][0]++, record.attributeName) || (cov_1v6i6gl552().b[7][1]++, ''),
      value: (cov_1v6i6gl552().b[8][0]++, compileValue(record)) || (cov_1v6i6gl552().b[8][1]++, ''),
      oldValue: (cov_1v6i6gl552().b[9][0]++, record.oldValue) || (cov_1v6i6gl552().b[9][1]++, ''),
      nodes: complieNodes(record),
      position: compliePosition(record)
    });
    cov_1v6i6gl552().s[28]++;
    temp.push(item); // 兼容 Firefox，补全数据（这几十行代码写得吐血，跟 IE 有得一拼）

    cov_1v6i6gl552().s[29]++;

    if (!util_1.UA.isFirefox) {
      cov_1v6i6gl552().b[10][0]++;
      cov_1v6i6gl552().s[30]++;
      return;
    } else {
      cov_1v6i6gl552().b[10][1]++;
    } // 正常的数据：缩进、行高、超链接、对齐方式、引用、插入表情、插入图片、分割线、表格、插入代码
    // 普通的数据补全：标题（纯文本内容）、加粗、斜体、删除线、下划线、颜色、背景色、字体、字号、列表（纯文本内容）
    // 特殊的数据补全：标题（包含 HTMLElement）、列表（包含 HTMLElement 或 ul -> ol 或 ol -> ul 或 Enter）


    cov_1v6i6gl552().s[31]++;

    if ((cov_1v6i6gl552().b[12][0]++, removeNode) && (cov_1v6i6gl552().b[12][1]++, record.addedNodes.length) && (cov_1v6i6gl552().b[12][2]++, record.addedNodes[0].nodeType == 1)) {
      cov_1v6i6gl552().b[11][0]++;
      // 需要被全数据的目标节点
      var replenishNode = (cov_1v6i6gl552().s[32]++, record.addedNodes[0]);
      var replenishData = (cov_1v6i6gl552().s[33]++, {
        type: 'node',
        target: replenishNode,
        attr: '',
        value: '',
        oldValue: '',
        nodes: {
          add: [removeNode]
        },
        position: {
          type: 'parent',
          target: replenishNode
        }
      }); // 特殊的标签：['UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']

      cov_1v6i6gl552().s[34]++;

      if ((0, _indexOf["default"])(tag).call(tag, replenishNode.nodeName) != -1) {
        cov_1v6i6gl552().b[13][0]++;
        cov_1v6i6gl552().s[35]++;
        replenishData.nodes.add = util_1.toArray(replenishNode.childNodes);
        cov_1v6i6gl552().s[36]++;
        temp.push(replenishData);
      } // 上一个删除元素是文本节点
      else {
        cov_1v6i6gl552().b[13][1]++;
        cov_1v6i6gl552().s[37]++;

        if (removeNode.nodeType == 3) {
          cov_1v6i6gl552().b[14][0]++;
          cov_1v6i6gl552().s[38]++;

          if (contains(replenishNode, removeCache)) {
            cov_1v6i6gl552().b[15][0]++;
            cov_1v6i6gl552().s[39]++;
            replenishData.nodes.add = util_1.toArray(replenishNode.childNodes);
          } else {
            cov_1v6i6gl552().b[15][1]++;
          }

          cov_1v6i6gl552().s[40]++;
          temp.push(replenishData);
        } // 上一个删除元素是 Element && 由近到远的删除元素至少有一个是需要补全数据节点的子节点
        else {
          cov_1v6i6gl552().b[14][1]++;
          cov_1v6i6gl552().s[41]++;

          if ((cov_1v6i6gl552().b[17][0]++, (0, _indexOf["default"])(tag).call(tag, record.target.nodeName) == -1) && (cov_1v6i6gl552().b[17][1]++, contains(replenishNode, removeCache))) {
            cov_1v6i6gl552().b[16][0]++;
            cov_1v6i6gl552().s[42]++;
            replenishData.nodes.add = util_1.toArray(replenishNode.childNodes);
            cov_1v6i6gl552().s[43]++;
            temp.push(replenishData);
          } else {
            cov_1v6i6gl552().b[16][1]++;
          }
        }
      }
    } else {
      cov_1v6i6gl552().b[11][1]++;
    } // 记录本次的节点信息


    cov_1v6i6gl552().s[44]++;

    if ((cov_1v6i6gl552().b[19][0]++, item.type == 'node') && (cov_1v6i6gl552().b[19][1]++, record.removedNodes.length == 1)) {
      cov_1v6i6gl552().b[18][0]++;
      cov_1v6i6gl552().s[45]++;
      removeNode = record.removedNodes[0];
      cov_1v6i6gl552().s[46]++;
      removeCache.push(removeNode);
    } else {
      cov_1v6i6gl552().b[18][1]++;
      cov_1v6i6gl552().s[47]++;
      removeNode = false;
      cov_1v6i6gl552().s[48]++;
      removeCache.length = 0;
    }
  });
  cov_1v6i6gl552().s[49]++;
  return temp;
}

cov_1v6i6gl552().s[50]++;
exports["default"] = compile; // 删除元素的历史记录中包含有多少个目标节点的子元素

function contains(tar, childs) {
  cov_1v6i6gl552().f[6]++;
  var count = (cov_1v6i6gl552().s[51]++, 0);
  cov_1v6i6gl552().s[52]++;

  for (var i = (cov_1v6i6gl552().s[53]++, childs.length - 1); i > 0; i--) {
    cov_1v6i6gl552().s[54]++;

    if (tar.contains(childs[i])) {
      cov_1v6i6gl552().b[20][0]++;
      cov_1v6i6gl552().s[55]++;
      count++;
    } else {
      cov_1v6i6gl552().b[20][1]++;
      cov_1v6i6gl552().s[56]++;
      break;
    }
  }

  cov_1v6i6gl552().s[57]++;
  return count;
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _entries = _interopRequireDefault(__webpack_require__(393));

var _forEach = _interopRequireDefault(__webpack_require__(6));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_8o5wd0g2n() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/decompilation.ts";
  var hash = "e15db18bfd227d34f37ac8fc2e6984edd38595dd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/decompilation.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 2,
          column: 62
        }
      },
      "1": {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 3,
          column: 42
        }
      },
      "2": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "3": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 39,
          column: 5
        }
      },
      "4": {
        start: {
          line: 14,
          column: 12
        },
        end: {
          line: 24,
          column: 13
        }
      },
      "5": {
        start: {
          line: 15,
          column: 16
        },
        end: {
          line: 15,
          column: 50
        }
      },
      "6": {
        start: {
          line: 16,
          column: 16
        },
        end: {
          line: 18,
          column: 19
        }
      },
      "7": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 17,
          column: 62
        }
      },
      "8": {
        start: {
          line: 21,
          column: 16
        },
        end: {
          line: 23,
          column: 19
        }
      },
      "9": {
        start: {
          line: 22,
          column: 20
        },
        end: {
          line: 22,
          column: 50
        }
      },
      "10": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 18
        }
      },
      "11": {
        start: {
          line: 28,
          column: 12
        },
        end: {
          line: 30,
          column: 15
        }
      },
      "12": {
        start: {
          line: 29,
          column: 16
        },
        end: {
          line: 29,
          column: 58
        }
      },
      "13": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 18
        }
      },
      "14": {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 37,
          column: 15
        }
      },
      "15": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "16": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 18
        }
      },
      "17": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "18": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 19
        }
      },
      "19": {
        start: {
          line: 43,
          column: 26
        },
        end: {
          line: 43,
          column: 52
        }
      },
      "20": {
        start: {
          line: 44,
          column: 17
        },
        end: {
          line: 44,
          column: 23
        }
      },
      "21": {
        start: {
          line: 44,
          column: 36
        },
        end: {
          line: 44,
          column: 41
        }
      },
      "22": {
        start: {
          line: 44,
          column: 50
        },
        end: {
          line: 44,
          column: 55
        }
      },
      "23": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 57,
          column: 9
        }
      },
      "24": {
        start: {
          line: 48,
          column: 16
        },
        end: {
          line: 50,
          column: 19
        }
      },
      "25": {
        start: {
          line: 49,
          column: 20
        },
        end: {
          line: 49,
          column: 50
        }
      },
      "26": {
        start: {
          line: 51,
          column: 16
        },
        end: {
          line: 51,
          column: 22
        }
      },
      "27": {
        start: {
          line: 54,
          column: 16
        },
        end: {
          line: 54,
          column: 39
        }
      },
      "28": {
        start: {
          line: 55,
          column: 16
        },
        end: {
          line: 55,
          column: 22
        }
      },
      "29": {
        start: {
          line: 64,
          column: 17
        },
        end: {
          line: 64,
          column: 28
        }
      },
      "30": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "31": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 42
        }
      },
      "32": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 54
        }
      },
      "33": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 44
        }
      },
      "34": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "35": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 88,
          column: 5
        }
      },
      "36": {
        start: {
          line: 85,
          column: 17
        },
        end: {
          line: 85,
          column: 32
        }
      },
      "37": {
        start: {
          line: 86,
          column: 19
        },
        end: {
          line: 86,
          column: 26
        }
      },
      "38": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 35
        }
      },
      "39": {
        start: {
          line: 90,
          column: 0
        },
        end: {
          line: 90,
          column: 24
        }
      },
      "40": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "41": {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 19
        }
      },
      "42": {
        start: {
          line: 93,
          column: 26
        },
        end: {
          line: 93,
          column: 52
        }
      },
      "43": {
        start: {
          line: 94,
          column: 17
        },
        end: {
          line: 94,
          column: 23
        }
      },
      "44": {
        start: {
          line: 94,
          column: 36
        },
        end: {
          line: 94,
          column: 41
        }
      },
      "45": {
        start: {
          line: 94,
          column: 50
        },
        end: {
          line: 94,
          column: 55
        }
      },
      "46": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 108,
          column: 9
        }
      },
      "47": {
        start: {
          line: 97,
          column: 16
        },
        end: {
          line: 97,
          column: 39
        }
      },
      "48": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 98,
          column: 22
        }
      },
      "49": {
        start: {
          line: 102,
          column: 16
        },
        end: {
          line: 105,
          column: 19
        }
      },
      "50": {
        start: {
          line: 104,
          column: 20
        },
        end: {
          line: 104,
          column: 54
        }
      },
      "51": {
        start: {
          line: 106,
          column: 16
        },
        end: {
          line: 106,
          column: 22
        }
      },
      "52": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 41
        }
      },
      "53": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 52
        }
      },
      "54": {
        start: {
          line: 118,
          column: 17
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "55": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 128,
          column: 5
        }
      },
      "56": {
        start: {
          line: 125,
          column: 18
        },
        end: {
          line: 125,
          column: 19
        }
      },
      "57": {
        start: {
          line: 125,
          column: 30
        },
        end: {
          line: 125,
          column: 34
        }
      },
      "58": {
        start: {
          line: 126,
          column: 19
        },
        end: {
          line: 126,
          column: 29
        }
      },
      "59": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 36
        }
      },
      "60": {
        start: {
          line: 130,
          column: 0
        },
        end: {
          line: 130,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "insertNode",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 19
          }
        },
        loc: {
          start: {
            line: 9,
            column: 32
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 29
          },
          end: {
            line: 16,
            column: 30
          }
        },
        loc: {
          start: {
            line: 16,
            column: 45
          },
          end: {
            line: 18,
            column: 17
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 29
          },
          end: {
            line: 21,
            column: 30
          }
        },
        loc: {
          start: {
            line: 21,
            column: 45
          },
          end: {
            line: 23,
            column: 17
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 28,
            column: 25
          },
          end: {
            line: 28,
            column: 26
          }
        },
        loc: {
          start: {
            line: 28,
            column: 41
          },
          end: {
            line: 30,
            column: 13
          }
        },
        line: 28
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 35,
            column: 26
          }
        },
        loc: {
          start: {
            line: 35,
            column: 41
          },
          end: {
            line: 37,
            column: 13
          }
        },
        line: 35
      },
      "5": {
        name: "revokeNode",
        decl: {
          start: {
            line: 42,
            column: 9
          },
          end: {
            line: 42,
            column: 19
          }
        },
        loc: {
          start: {
            line: 42,
            column: 26
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 29
          },
          end: {
            line: 48,
            column: 30
          }
        },
        loc: {
          start: {
            line: 48,
            column: 45
          },
          end: {
            line: 50,
            column: 17
          }
        },
        line: 48
      },
      "7": {
        name: "revokeAttr",
        decl: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 19
          }
        },
        loc: {
          start: {
            line: 63,
            column: 26
          },
          end: {
            line: 71,
            column: 1
          }
        },
        line: 63
      },
      "8": {
        name: "revokeText",
        decl: {
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 19
          }
        },
        loc: {
          start: {
            line: 75,
            column: 26
          },
          end: {
            line: 77,
            column: 1
          }
        },
        line: 75
      },
      "9": {
        name: "revoke",
        decl: {
          start: {
            line: 84,
            column: 9
          },
          end: {
            line: 84,
            column: 15
          }
        },
        loc: {
          start: {
            line: 84,
            column: 22
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 84
      },
      "10": {
        name: "restoreNode",
        decl: {
          start: {
            line: 92,
            column: 9
          },
          end: {
            line: 92,
            column: 20
          }
        },
        loc: {
          start: {
            line: 92,
            column: 27
          },
          end: {
            line: 110,
            column: 1
          }
        },
        line: 92
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 102,
            column: 29
          },
          end: {
            line: 102,
            column: 30
          }
        },
        loc: {
          start: {
            line: 102,
            column: 45
          },
          end: {
            line: 105,
            column: 17
          }
        },
        line: 102
      },
      "12": {
        name: "restoreText",
        decl: {
          start: {
            line: 111,
            column: 9
          },
          end: {
            line: 111,
            column: 20
          }
        },
        loc: {
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 113,
            column: 1
          }
        },
        line: 111
      },
      "13": {
        name: "restoreAttr",
        decl: {
          start: {
            line: 114,
            column: 9
          },
          end: {
            line: 114,
            column: 20
          }
        },
        loc: {
          start: {
            line: 114,
            column: 27
          },
          end: {
            line: 117,
            column: 1
          }
        },
        line: 114
      },
      "14": {
        name: "restore",
        decl: {
          start: {
            line: 124,
            column: 9
          },
          end: {
            line: 124,
            column: 16
          }
        },
        loc: {
          start: {
            line: 124,
            column: 23
          },
          end: {
            line: 129,
            column: 1
          }
        },
        line: 124
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 39,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 25,
            column: 18
          }
        }, {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 31,
            column: 18
          }
        }, {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 38,
            column: 18
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 24,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 24,
            column: 13
          }
        }, {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 24,
            column: 13
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 57,
            column: 9
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 47,
            column: 12
          },
          end: {
            line: 51,
            column: 22
          }
        }, {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 56,
            column: 13
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 65
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 96,
            column: 12
          },
          end: {
            line: 99,
            column: 13
          }
        }, {
          start: {
            line: 101,
            column: 12
          },
          end: {
            line: 107,
            column: 13
          }
        }],
        line: 95
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/decompilation.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/node/decompilation.ts"],
      names: [],
      mappings: ";;;AAMA;;;;GAIG;AACH,SAAS,UAAU,CAAC,IAAa,EAAE,IAAY;IAC3C,IAAI,SAAS,GAAG,IAAI,CAAC,QAAQ,CAAC,MAAM,CAAA;IACpC,QAAQ,IAAI,CAAC,QAAQ,CAAC,IAAI,EAAE;QACxB,qBAAqB;QACrB,KAAK,QAAQ;YACT,IAAI,SAAS,CAAC,WAAW,EAAE;gBACvB,SAAS,GAAG,SAAS,CAAC,WAAW,CAAA;gBACjC,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;oBACpB,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,IAAI,EAAE,SAAS,CAAC,CAAA;gBAC7C,CAAC,CAAC,CAAA;aACL;iBAAM;gBACH,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;oBACpB,IAAI,CAAC,MAAM,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;gBACjC,CAAC,CAAC,CAAA;aACL;YACD,MAAK;QACT,qBAAqB;QACrB,KAAK,OAAO;YACR,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;gBACpB,IAAI,CAAC,MAAM,CAAC,YAAY,CAAC,IAAI,EAAE,SAAS,CAAC,CAAA;YAC7C,CAAC,CAAC,CAAA;YACF,MAAK;QACT,SAAS;QACT,sBAAsB;QACtB;YACI,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;gBACpB,SAAS,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;YAC/B,CAAC,CAAC,CAAA;YACF,MAAK;KACZ;AACL,CAAC;AAED,gJAAgJ;AAEhJ,SAAS,UAAU,CAAC,IAAa;IAC7B,KAA6B,UAA0B,EAA1B,KAAA,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC,KAAK,CAAC,EAA1B,cAA0B,EAA1B,IAA0B,EAAE;QAAhD,IAAA,WAAgB,EAAf,QAAQ,QAAA,EAAE,IAAI,QAAA;QACpB,QAAQ,QAAQ,EAAE;YACd,sBAAsB;YACtB,KAAK,KAAK;gBACN,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;oBACpB,IAAI,CAAC,MAAM,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;gBACjC,CAAC,CAAC,CAAA;gBACF,MAAK;YACT,8BAA8B;YAC9B,OAAO,CAAC,CAAC;gBACL,UAAU,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;gBACtB,MAAK;aACR;SACJ;KACJ;AACL,CAAC;AAED;;GAEG;AACH,SAAS,UAAU,CAAC,IAAa;IAC7B,IAAI,MAAM,GAAG,IAAI,CAAC,MAAqB,CAAA;IACvC,IAAI,IAAI,CAAC,QAAQ,IAAI,IAAI,EAAE;QACvB,MAAM,CAAC,eAAe,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;KACpC;SAAM;QACH,MAAM,CAAC,YAAY,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,QAAQ,CAAC,CAAA;KAChD;AACL,CAAC;AAED;;GAEG;AACH,SAAS,UAAU,CAAC,IAAa;IAC7B,IAAI,CAAC,MAAM,CAAC,WAAW,GAAG,IAAI,CAAC,QAAQ,CAAA;AAC3C,CAAC;AAED,IAAM,SAAS,GAAG;IACd,IAAI,EAAE,UAAU;IAChB,IAAI,EAAE,UAAU;IAChB,IAAI,EAAE,UAAU;CACnB,CAAA;AAED,eAAe;AACf,SAAgB,MAAM,CAAC,IAAe;IAClC,KAAK,IAAI,CAAC,GAAG,IAAI,CAAC,MAAM,GAAG,CAAC,EAAE,CAAC,GAAG,CAAC,CAAC,EAAE,CAAC,EAAE,EAAE;QACvC,IAAI,IAAI,GAAG,IAAI,CAAC,CAAC,CAAC,CAAA;QAClB,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,IAAI,CAAC,CAAA;KAC7B;AACL,CAAC;AALD,wBAKC;AAED,gJAAgJ;AAEhJ,SAAS,WAAW,CAAC,IAAa;IAC9B,KAA6B,UAA0B,EAA1B,KAAA,MAAM,CAAC,OAAO,CAAC,IAAI,CAAC,KAAK,CAAC,EAA1B,cAA0B,EAA1B,IAA0B,EAAE;QAAhD,IAAA,WAAgB,EAAf,QAAQ,QAAA,EAAE,IAAI,QAAA;QACpB,QAAQ,QAAQ,EAAE;YACd,KAAK,KAAK,CAAC,CAAC;gBACR,UAAU,CAAC,IAAI,EAAE,IAAI,CAAC,CAAA;gBACtB,MAAK;aACR;YACD,SAAS;YACT,OAAO,CAAC,CAAC;gBACL,IAAI,CAAC,OAAO,CAAC,UAAC,IAAU;oBACpB,CAAC;oBAAC,IAAI,CAAC,UAAmB,CAAC,WAAW,CAAC,IAAI,CAAC,CAAA;gBAChD,CAAC,CAAC,CAAA;gBACF,MAAK;aACR;SACJ;KACJ;AACL,CAAC;AAED,SAAS,WAAW,CAAC,IAAa;IAC9B,IAAI,CAAC,MAAM,CAAC,WAAW,GAAG,IAAI,CAAC,KAAK,CAAA;AACxC,CAAC;AAED,SAAS,WAAW,CAAC,IAAa;IAC9B,CAAC;IAAC,IAAI,CAAC,MAAsB,CAAC,YAAY,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,KAAK,CAAC,CAAA;AACrE,CAAC;AAED,IAAM,UAAU,GAAG;IACf,IAAI,EAAE,WAAW;IACjB,IAAI,EAAE,WAAW;IACjB,IAAI,EAAE,WAAW;CACpB,CAAA;AAED,eAAe;AACf,SAAgB,OAAO,CAAC,IAAe;IACnC,KAAiB,UAAI,EAAJ,aAAI,EAAJ,kBAAI,EAAJ,IAAI,EAAE;QAAlB,IAAI,IAAI,aAAA;QACT,UAAU,CAAC,IAAI,CAAC,IAAI,CAAC,CAAC,IAAI,CAAC,CAAA;KAC9B;AACL,CAAC;AAJD,0BAIC",
      sourcesContent: ["/**\n * @description \u64A4\u9500 - \u9006\u5411\u64CD\u4F5C\uFF0C\u5220\u9664\u8282\u70B9\n * @author fangzhicong\n */\nimport { Compile } from '../type'\n\n/**\n * \u5C06\u8282\u70B9\u6DFB\u52A0\u5230 DOM \u6811\u4E2D\n * @param data \u6570\u636E\u9879\n * @param list \u8282\u70B9\u96C6\u5408\uFF08addedNodes \u6216 removedNodes\uFF09\n */\nfunction insertNode(data: Compile, list: Node[]) {\n    let reference = data.position.target\n    switch (data.position.type) {\n        // reference \u5728\u8FD9\u4E9B\u8282\u70B9\u7684\u524D\u9762\n        case 'before':\n            if (reference.nextSibling) {\n                reference = reference.nextSibling\n                list.forEach((item: Node) => {\n                    data.target.insertBefore(item, reference)\n                })\n            } else {\n                list.forEach((item: Node) => {\n                    data.target.appendChild(item)\n                })\n            }\n            break\n        // reference \u5728\u8FD9\u4E9B\u8282\u70B9\u7684\u540E\u9762\n        case 'after':\n            list.forEach((item: Node) => {\n                data.target.insertBefore(item, reference)\n            })\n            break\n        // parent\n        // reference \u662F\u8FD9\u4E9B\u8282\u70B9\u7684\u7236\u8282\u70B9\n        default:\n            list.forEach((item: Node) => {\n                reference.appendChild(item)\n            })\n            break\n    }\n}\n\n/* ------------------------------------------------------------------ \u64A4\u9500\u903B\u8F91 ------------------------------------------------------------------ */\n\nfunction revokeNode(data: Compile) {\n    for (let [relative, list] of Object.entries(data.nodes)) {\n        switch (relative) {\n            // \u53CD\u5411\u64CD\u4F5C\uFF0C\u5C06\u8FD9\u4E9B\u8282\u70B9\u4ECE DOM \u4E2D\u79FB\u9664\n            case 'add':\n                list.forEach((item: Node) => {\n                    data.target.removeChild(item)\n                })\n                break\n            // remove\uFF08\u53CD\u5411\u64CD\u4F5C\uFF0C\u5C06\u8FD9\u4E9B\u8282\u70B9\u6DFB\u52A0\u5230 DOM \u4E2D\uFF09\n            default: {\n                insertNode(data, list)\n                break\n            }\n        }\n    }\n}\n\n/**\n * \u64A4\u9500 attribute\n */\nfunction revokeAttr(data: Compile) {\n    let target = data.target as HTMLElement\n    if (data.oldValue == null) {\n        target.removeAttribute(data.attr)\n    } else {\n        target.setAttribute(data.attr, data.oldValue)\n    }\n}\n\n/**\n * \u64A4\u9500\u6587\u672C\u5185\u5BB9\n */\nfunction revokeText(data: Compile) {\n    data.target.textContent = data.oldValue\n}\n\nconst revokeFns = {\n    node: revokeNode,\n    text: revokeText,\n    attr: revokeAttr,\n}\n\n// \u64A4\u9500 - \u5BF9\u5916\u66B4\u9732\u7684\u63A5\u53E3\nexport function revoke(data: Compile[]) {\n    for (let i = data.length - 1; i > -1; i--) {\n        let item = data[i]\n        revokeFns[item.type](item)\n    }\n}\n\n/* ------------------------------------------------------------------ \u6062\u590D\u903B\u8F91 ------------------------------------------------------------------ */\n\nfunction restoreNode(data: Compile) {\n    for (let [relative, list] of Object.entries(data.nodes)) {\n        switch (relative) {\n            case 'add': {\n                insertNode(data, list)\n                break\n            }\n            // remove\n            default: {\n                list.forEach((item: Node) => {\n                    ;(item.parentNode as Node).removeChild(item)\n                })\n                break\n            }\n        }\n    }\n}\n\nfunction restoreText(data: Compile) {\n    data.target.textContent = data.value\n}\n\nfunction restoreAttr(data: Compile) {\n    ;(data.target as HTMLElement).setAttribute(data.attr, data.value)\n}\n\nconst restoreFns = {\n    node: restoreNode,\n    text: restoreText,\n    attr: restoreAttr,\n}\n\n// \u6062\u590D - \u5BF9\u5916\u66B4\u9732\u7684\u63A5\u53E3\nexport function restore(data: Compile[]) {\n    for (let item of data) {\n        restoreFns[item.type](item)\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e15db18bfd227d34f37ac8fc2e6984edd38595dd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8o5wd0g2n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_8o5wd0g2n();
cov_8o5wd0g2n().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_8o5wd0g2n().s[1]++;
exports.restore = exports.revoke = void 0;
/**
 * 将节点添加到 DOM 树中
 * @param data 数据项
 * @param list 节点集合（addedNodes 或 removedNodes）
 */

function insertNode(data, list) {
  cov_8o5wd0g2n().f[0]++;
  var reference = (cov_8o5wd0g2n().s[2]++, data.position.target);
  cov_8o5wd0g2n().s[3]++;

  switch (data.position.type) {
    // reference 在这些节点的前面
    case 'before':
      cov_8o5wd0g2n().b[0][0]++;
      cov_8o5wd0g2n().s[4]++;

      if (reference.nextSibling) {
        cov_8o5wd0g2n().b[1][0]++;
        cov_8o5wd0g2n().s[5]++;
        reference = reference.nextSibling;
        cov_8o5wd0g2n().s[6]++;
        (0, _forEach["default"])(list).call(list, function (item) {
          cov_8o5wd0g2n().f[1]++;
          cov_8o5wd0g2n().s[7]++;
          data.target.insertBefore(item, reference);
        });
      } else {
        cov_8o5wd0g2n().b[1][1]++;
        cov_8o5wd0g2n().s[8]++;
        (0, _forEach["default"])(list).call(list, function (item) {
          cov_8o5wd0g2n().f[2]++;
          cov_8o5wd0g2n().s[9]++;
          data.target.appendChild(item);
        });
      }

      cov_8o5wd0g2n().s[10]++;
      break;
    // reference 在这些节点的后面

    case 'after':
      cov_8o5wd0g2n().b[0][1]++;
      cov_8o5wd0g2n().s[11]++;
      (0, _forEach["default"])(list).call(list, function (item) {
        cov_8o5wd0g2n().f[3]++;
        cov_8o5wd0g2n().s[12]++;
        data.target.insertBefore(item, reference);
      });
      cov_8o5wd0g2n().s[13]++;
      break;
    // parent
    // reference 是这些节点的父节点

    default:
      cov_8o5wd0g2n().b[0][2]++;
      cov_8o5wd0g2n().s[14]++;
      (0, _forEach["default"])(list).call(list, function (item) {
        cov_8o5wd0g2n().f[4]++;
        cov_8o5wd0g2n().s[15]++;
        reference.appendChild(item);
      });
      cov_8o5wd0g2n().s[16]++;
      break;
  }
}
/* ------------------------------------------------------------------ 撤销逻辑 ------------------------------------------------------------------ */


function revokeNode(data) {
  cov_8o5wd0g2n().f[5]++;
  cov_8o5wd0g2n().s[17]++;

  for (var _i = (cov_8o5wd0g2n().s[18]++, 0), _a = (cov_8o5wd0g2n().s[19]++, (0, _entries["default"])(data.nodes)); _i < _a.length; _i++) {
    var _b = (cov_8o5wd0g2n().s[20]++, _a[_i]),
        relative = (cov_8o5wd0g2n().s[21]++, _b[0]),
        list = (cov_8o5wd0g2n().s[22]++, _b[1]);

    cov_8o5wd0g2n().s[23]++;

    switch (relative) {
      // 反向操作，将这些节点从 DOM 中移除
      case 'add':
        cov_8o5wd0g2n().b[2][0]++;
        cov_8o5wd0g2n().s[24]++;
        (0, _forEach["default"])(list).call(list, function (item) {
          cov_8o5wd0g2n().f[6]++;
          cov_8o5wd0g2n().s[25]++;
          data.target.removeChild(item);
        });
        cov_8o5wd0g2n().s[26]++;
        break;
      // remove（反向操作，将这些节点添加到 DOM 中）

      default:
        cov_8o5wd0g2n().b[2][1]++;
        {
          cov_8o5wd0g2n().s[27]++;
          insertNode(data, list);
          cov_8o5wd0g2n().s[28]++;
          break;
        }
    }
  }
}
/**
 * 撤销 attribute
 */


function revokeAttr(data) {
  cov_8o5wd0g2n().f[7]++;
  var target = (cov_8o5wd0g2n().s[29]++, data.target);
  cov_8o5wd0g2n().s[30]++;

  if (data.oldValue == null) {
    cov_8o5wd0g2n().b[3][0]++;
    cov_8o5wd0g2n().s[31]++;
    target.removeAttribute(data.attr);
  } else {
    cov_8o5wd0g2n().b[3][1]++;
    cov_8o5wd0g2n().s[32]++;
    target.setAttribute(data.attr, data.oldValue);
  }
}
/**
 * 撤销文本内容
 */


function revokeText(data) {
  cov_8o5wd0g2n().f[8]++;
  cov_8o5wd0g2n().s[33]++;
  data.target.textContent = data.oldValue;
}

var revokeFns = (cov_8o5wd0g2n().s[34]++, {
  node: revokeNode,
  text: revokeText,
  attr: revokeAttr
}); // 撤销 - 对外暴露的接口

function revoke(data) {
  cov_8o5wd0g2n().f[9]++;
  cov_8o5wd0g2n().s[35]++;

  for (var i = (cov_8o5wd0g2n().s[36]++, data.length - 1); i > -1; i--) {
    var item = (cov_8o5wd0g2n().s[37]++, data[i]);
    cov_8o5wd0g2n().s[38]++;
    revokeFns[item.type](item);
  }
}

cov_8o5wd0g2n().s[39]++;
exports.revoke = revoke;
/* ------------------------------------------------------------------ 恢复逻辑 ------------------------------------------------------------------ */

function restoreNode(data) {
  cov_8o5wd0g2n().f[10]++;
  cov_8o5wd0g2n().s[40]++;

  for (var _i = (cov_8o5wd0g2n().s[41]++, 0), _a = (cov_8o5wd0g2n().s[42]++, (0, _entries["default"])(data.nodes)); _i < _a.length; _i++) {
    var _b = (cov_8o5wd0g2n().s[43]++, _a[_i]),
        relative = (cov_8o5wd0g2n().s[44]++, _b[0]),
        list = (cov_8o5wd0g2n().s[45]++, _b[1]);

    cov_8o5wd0g2n().s[46]++;

    switch (relative) {
      case 'add':
        cov_8o5wd0g2n().b[4][0]++;
        {
          cov_8o5wd0g2n().s[47]++;
          insertNode(data, list);
          cov_8o5wd0g2n().s[48]++;
          break;
        }
      // remove

      default:
        cov_8o5wd0g2n().b[4][1]++;
        {
          cov_8o5wd0g2n().s[49]++;
          (0, _forEach["default"])(list).call(list, function (item) {
            cov_8o5wd0g2n().f[11]++;
            ;
            cov_8o5wd0g2n().s[50]++;
            item.parentNode.removeChild(item);
          });
          cov_8o5wd0g2n().s[51]++;
          break;
        }
    }
  }
}

function restoreText(data) {
  cov_8o5wd0g2n().f[12]++;
  cov_8o5wd0g2n().s[52]++;
  data.target.textContent = data.value;
}

function restoreAttr(data) {
  cov_8o5wd0g2n().f[13]++;
  ;
  cov_8o5wd0g2n().s[53]++;
  data.target.setAttribute(data.attr, data.value);
}

var restoreFns = (cov_8o5wd0g2n().s[54]++, {
  node: restoreNode,
  text: restoreText,
  attr: restoreAttr
}); // 恢复 - 对外暴露的接口

function restore(data) {
  cov_8o5wd0g2n().f[14]++;
  cov_8o5wd0g2n().s[55]++;

  for (var _i = (cov_8o5wd0g2n().s[56]++, 0), data_1 = (cov_8o5wd0g2n().s[57]++, data); _i < data_1.length; _i++) {
    var item = (cov_8o5wd0g2n().s[58]++, data_1[_i]);
    cov_8o5wd0g2n().s[59]++;
    restoreFns[item.type](item);
  }
}

cov_8o5wd0g2n().s[60]++;
exports.restore = restore;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(394);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(395);

module.exports = parent;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(396);
var path = __webpack_require__(10);

module.exports = path.Object.entries;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(4);
var $entries = __webpack_require__(397).entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var objectKeys = __webpack_require__(57);
var toIndexedObject = __webpack_require__(25);
var propertyIsEnumerable = __webpack_require__(55).f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_26ms7f55ej() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/html/index.ts";
  var hash = "e07d712982505a2e067011b3f5a33d0456f1118c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/html/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 2,
          column: 62
        }
      },
      "1": {
        start: {
          line: 3,
          column: 14
        },
        end: {
          line: 3,
          column: 63
        }
      },
      "2": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "3": {
        start: {
          line: 6,
          column: 8
        },
        end: {
          line: 6,
          column: 29
        }
      },
      "4": {
        start: {
          line: 7,
          column: 8
        },
        end: {
          line: 7,
          column: 44
        }
      },
      "5": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 16,
          column: 6
        }
      },
      "6": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 62
        }
      },
      "7": {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 59
        }
      },
      "8": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 23,
          column: 6
        }
      },
      "9": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 59
        }
      },
      "10": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 20
        }
      },
      "11": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      "12": {
        start: {
          line: 28,
          column: 19
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "13": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "14": {
        start: {
          line: 30,
          column: 12
        },
        end: {
          line: 30,
          column: 45
        }
      },
      "15": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 24
        }
      },
      "16": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 21
        }
      },
      "17": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      "18": {
        start: {
          line: 39,
          column: 19
        },
        end: {
          line: 39,
          column: 35
        }
      },
      "19": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 43,
          column: 9
        }
      },
      "20": {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 45
        }
      },
      "21": {
        start: {
          line: 42,
          column: 12
        },
        end: {
          line: 42,
          column: 24
        }
      },
      "22": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 21
        }
      },
      "23": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "24": {
        start: {
          line: 48,
          column: 0
        },
        end: {
          line: 48,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 31
          },
          end: {
            line: 4,
            column: 32
          }
        },
        loc: {
          start: {
            line: 4,
            column: 43
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "HtmlCache",
        decl: {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 5,
            column: 22
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 8,
            column: 5
          }
        },
        line: 5
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 34
          },
          end: {
            line: 12,
            column: 35
          }
        },
        loc: {
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 32
          }
        },
        loc: {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 23,
            column: 5
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 27,
            column: 34
          }
        },
        loc: {
          start: {
            line: 27,
            column: 45
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 27
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 38,
            column: 34
          },
          end: {
            line: 38,
            column: 35
          }
        },
        loc: {
          start: {
            line: 38,
            column: 46
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 38
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }, {
          start: {
            line: 29,
            column: 8
          },
          end: {
            line: 32,
            column: 9
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        }, {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 43,
            column: 9
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/html/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/html/index.ts"],
      names: [],
      mappings: ";;AAKA,gEAAkE;AAElE;IAII,mBAAmB,MAAc;QAAd,WAAM,GAAN,MAAM,CAAQ;QAC7B,IAAI,CAAC,IAAI,GAAG,IAAI,iBAAS,EAAE,CAAA;IAC/B,CAAC;IAED;;OAEG;IACH,2BAAO,GAAP;QACI,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,CAAA;QACrD,SAAS;QACT,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA;IACtD,CAAC;IAED;;OAEG;IACI,wBAAI,GAAX;QACI,IAAI,CAAC,IAAI,CAAC,UAAU,CAAC,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA;QAClD,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,0BAAM,GAAb;QACI,IAAI,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,IAAI,EAAE,CAAA;QAC3B,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YAChC,OAAO,IAAI,CAAA;SACd;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED;;OAEG;IACI,2BAAO,GAAd;QACI,IAAI,IAAI,GAAG,IAAI,CAAC,IAAI,CAAC,IAAI,EAAE,CAAA;QAC3B,IAAI,IAAI,EAAE;YACN,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;YAChC,OAAO,IAAI,CAAA;SACd;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IACL,gBAAC;AAAD,CAAC,AAhDD,IAgDC",
      sourcesContent: ["/**\n * @description \u5B8C\u6574\u7684\u5185\u5BB9\u5907\u4EFD\uFF0C\u6BCF\u6B21\u53D8\u5316\u90FD\u5C06\u5907\u4EFD\u6574\u4E2A\u7F16\u8F91\u5668\u7684\u5185\u5BB9\n * @author fangzhicong\n */\nimport Editor from '../../../index'\nimport { TailChain } from '../../../../utils/data-structure/chain'\n\nexport default class HtmlCache {\n    // \u7F13\u5B58\u6570\u636E\n    private data: TailChain<string>\n\n    constructor(public editor: Editor) {\n        this.data = new TailChain()\n    }\n\n    /**\n     * \u521D\u59CB\u5316\u7ED1\u5B9A\n     */\n    observe() {\n        this.data.resetMax(this.editor.config.historyMaxSize)\n        // \u4FDD\u5B58\u521D\u59CB\u5316\u503C\n        this.data.insertLast(this.editor.$textElem.html())\n    }\n\n    /**\n     * \u4FDD\u5B58\n     */\n    public save() {\n        this.data.insertLast(this.editor.$textElem.html())\n        return this\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        let data = this.data.prev()\n        if (data) {\n            this.editor.$textElem.html(data)\n            return true\n        }\n        return false\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        let data = this.data.next()\n        if (data) {\n            this.editor.$textElem.html(data)\n            return true\n        }\n        return false\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e07d712982505a2e067011b3f5a33d0456f1118c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26ms7f55ej = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_26ms7f55ej();
cov_26ms7f55ej().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var chain_1 = (cov_26ms7f55ej().s[1]++, __webpack_require__(399));
var HtmlCache = (
/** @class */
cov_26ms7f55ej().s[2]++, function () {
  cov_26ms7f55ej().f[0]++;

  function HtmlCache(editor) {
    cov_26ms7f55ej().f[1]++;
    cov_26ms7f55ej().s[3]++;
    this.editor = editor;
    cov_26ms7f55ej().s[4]++;
    this.data = new chain_1.TailChain();
  }
  /**
   * 初始化绑定
   */


  cov_26ms7f55ej().s[5]++;

  HtmlCache.prototype.observe = function () {
    cov_26ms7f55ej().f[2]++;
    cov_26ms7f55ej().s[6]++;
    this.data.resetMax(this.editor.config.historyMaxSize); // 保存初始化值

    cov_26ms7f55ej().s[7]++;
    this.data.insertLast(this.editor.$textElem.html());
  };
  /**
   * 保存
   */


  cov_26ms7f55ej().s[8]++;

  HtmlCache.prototype.save = function () {
    cov_26ms7f55ej().f[3]++;
    cov_26ms7f55ej().s[9]++;
    this.data.insertLast(this.editor.$textElem.html());
    cov_26ms7f55ej().s[10]++;
    return this;
  };
  /**
   * 撤销
   */


  cov_26ms7f55ej().s[11]++;

  HtmlCache.prototype.revoke = function () {
    cov_26ms7f55ej().f[4]++;
    var data = (cov_26ms7f55ej().s[12]++, this.data.prev());
    cov_26ms7f55ej().s[13]++;

    if (data) {
      cov_26ms7f55ej().b[0][0]++;
      cov_26ms7f55ej().s[14]++;
      this.editor.$textElem.html(data);
      cov_26ms7f55ej().s[15]++;
      return true;
    } else {
      cov_26ms7f55ej().b[0][1]++;
    }

    cov_26ms7f55ej().s[16]++;
    return false;
  };
  /**
   * 恢复
   */


  cov_26ms7f55ej().s[17]++;

  HtmlCache.prototype.restore = function () {
    cov_26ms7f55ej().f[5]++;
    var data = (cov_26ms7f55ej().s[18]++, this.data.next());
    cov_26ms7f55ej().s[19]++;

    if (data) {
      cov_26ms7f55ej().b[1][0]++;
      cov_26ms7f55ej().s[20]++;
      this.editor.$textElem.html(data);
      cov_26ms7f55ej().s[21]++;
      return true;
    } else {
      cov_26ms7f55ej().b[1][1]++;
    }

    cov_26ms7f55ej().s[22]++;
    return false;
  };

  cov_26ms7f55ej().s[23]++;
  return HtmlCache;
}());
cov_26ms7f55ej().s[24]++;
exports["default"] = HtmlCache;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 数据结构 - 链表
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _splice = _interopRequireDefault(__webpack_require__(88));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_2a7rwhjze2() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/chain.ts";
  var hash = "67976e5ff14964c034183703e1eb3a26905a052c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/chain.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 62
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 27
        }
      },
      "2": {
        start: {
          line: 11,
          column: 31
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "3": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 23
        }
      },
      "4": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 21
        }
      },
      "5": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 23
        }
      },
      "6": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 26
        }
      },
      "7": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      "8": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 36
        }
      },
      "9": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 40
        }
      },
      "10": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 44,
          column: 7
        }
      },
      "11": {
        start: {
          line: 40,
          column: 12
        },
        end: {
          line: 40,
          column: 36
        }
      },
      "12": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "13": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "14": {
        start: {
          line: 52,
          column: 12
        },
        end: {
          line: 52,
          column: 45
        }
      },
      "15": {
        start: {
          line: 53,
          column: 12
        },
        end: {
          line: 53,
          column: 30
        }
      },
      "16": {
        start: {
          line: 55,
          column: 8
        },
        end: {
          line: 55,
          column: 29
        }
      },
      "17": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 59,
          column: 9
        }
      },
      "18": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 58,
          column: 30
        }
      },
      "19": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 35
        }
      },
      "20": {
        start: {
          line: 62,
          column: 8
        },
        end: {
          line: 62,
          column: 20
        }
      },
      "21": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 69,
          column: 6
        }
      },
      "22": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 37
        }
      },
      "23": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 81,
          column: 6
        }
      },
      "24": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 41
        }
      },
      "25": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 21
        }
      },
      "26": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 79,
          column: 9
        }
      },
      "27": {
        start: {
          line: 77,
          column: 12
        },
        end: {
          line: 77,
          column: 27
        }
      },
      "28": {
        start: {
          line: 78,
          column: 12
        },
        end: {
          line: 78,
          column: 29
        }
      },
      "29": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 30
        }
      },
      "30": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 93,
          column: 6
        }
      },
      "31": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 41
        }
      },
      "32": {
        start: {
          line: 87,
          column: 8
        },
        end: {
          line: 87,
          column: 21
        }
      },
      "33": {
        start: {
          line: 88,
          column: 8
        },
        end: {
          line: 91,
          column: 9
        }
      },
      "34": {
        start: {
          line: 89,
          column: 12
        },
        end: {
          line: 89,
          column: 39
        }
      },
      "35": {
        start: {
          line: 90,
          column: 12
        },
        end: {
          line: 90,
          column: 29
        }
      },
      "36": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 30
        }
      },
      "37": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 21
        }
      },
      "38": {
        start: {
          line: 96,
          column: 0
        },
        end: {
          line: 96,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 31
          },
          end: {
            line: 11,
            column: 32
          }
        },
        loc: {
          start: {
            line: 11,
            column: 43
          },
          end: {
            line: 95,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "TailChain",
        decl: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 22
          }
        },
        loc: {
          start: {
            line: 12,
            column: 25
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 31,
            column: 35
          },
          end: {
            line: 31,
            column: 36
          }
        },
        loc: {
          start: {
            line: 31,
            column: 54
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 31
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 14
          }
        },
        loc: {
          start: {
            line: 39,
            column: 25
          },
          end: {
            line: 41,
            column: 9
          }
        },
        line: 39
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 49,
            column: 37
          },
          end: {
            line: 49,
            column: 38
          }
        },
        loc: {
          start: {
            line: 49,
            column: 53
          },
          end: {
            line: 63,
            column: 5
          }
        },
        line: 49
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 67,
            column: 34
          },
          end: {
            line: 67,
            column: 35
          }
        },
        loc: {
          start: {
            line: 67,
            column: 46
          },
          end: {
            line: 69,
            column: 5
          }
        },
        line: 67
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 73,
            column: 31
          },
          end: {
            line: 73,
            column: 32
          }
        },
        loc: {
          start: {
            line: 73,
            column: 43
          },
          end: {
            line: 81,
            column: 5
          }
        },
        line: 73
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 85,
            column: 31
          },
          end: {
            line: 85,
            column: 32
          }
        },
        loc: {
          start: {
            line: 85,
            column: 43
          },
          end: {
            line: 93,
            column: 5
          }
        },
        line: 85
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 8
          },
          end: {
            line: 33,
            column: 15
          }
        }, {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 38
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }, {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 57,
            column: 15
          },
          end: {
            line: 57,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 57,
            column: 15
          },
          end: {
            line: 57,
            column: 23
          }
        }, {
          start: {
            line: 57,
            column: 27
          },
          end: {
            line: 57,
            column: 47
          }
        }],
        line: 57
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 18
          }
        }, {
          start: {
            line: 74,
            column: 23
          },
          end: {
            line: 74,
            column: 39
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }],
        line: 76
      },
      "5": {
        loc: {
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 8
          },
          end: {
            line: 86,
            column: 18
          }
        }, {
          start: {
            line: 86,
            column: 23
          },
          end: {
            line: 86,
            column: 39
          }
        }],
        line: 86
      },
      "6": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 91,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 91,
            column: 9
          }
        }, {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 91,
            column: 9
          }
        }],
        line: 88
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/chain.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/utils/data-structure/chain.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;AAEH;;GAEG;AACH;IAAA;QACI;;WAEG;QACO,SAAI,GAAQ,EAAE,CAAA;QAExB;;WAEG;QACO,QAAG,GAAW,CAAC,CAAA;QAEzB;;WAEG;QACO,UAAK,GAAG,CAAC,CAAA;QAEnB,cAAc;QACJ,SAAI,GAAG,KAAK,CAAA;IAqE1B,CAAC;IAnEG;;OAEG;IACH,4BAAQ,GAAR,UAAS,OAAe;QACpB,OAAO,GAAG,IAAI,CAAC,GAAG,CAAC,OAAO,CAAC,CAAA;QAC3B,OAAO,IAAI,CAAC,IAAI,CAAC,GAAG,GAAG,OAAO,CAAC,CAAA;IACnC,CAAC;IAKD,sBAAI,2BAAI;QAHR;;WAEG;aACH;YACI,OAAO,IAAI,CAAC,IAAI,CAAC,MAAM,CAAA;QAC3B,CAAC;;;OAAA;IAED;;;OAGG;IACI,8BAAU,GAAjB,UAA+B,IAAO;QAClC,oBAAoB;QACpB,IAAI,IAAI,CAAC,IAAI,EAAE;YACX,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,IAAI,CAAC,KAAK,GAAG,CAAC,CAAC,CAAA;YAChC,IAAI,CAAC,IAAI,GAAG,KAAK,CAAA;SACpB;QACD,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,CAAA;QACpB,WAAW;QACX,OAAO,IAAI,CAAC,GAAG,IAAI,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,GAAG,EAAE;YACrC,IAAI,CAAC,IAAI,CAAC,KAAK,EAAE,CAAA;SACpB;QACD,gBAAgB;QAChB,IAAI,CAAC,KAAK,GAAG,IAAI,CAAC,IAAI,GAAG,CAAC,CAAA;QAC1B,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,2BAAO,GAAd;QACI,OAAO,IAAI,CAAC,IAAI,CAAC,IAAI,CAAC,KAAK,CAAC,CAAA;IAChC,CAAC;IAED;;OAEG;IACI,wBAAI,GAAX;QACI,CAAC,IAAI,CAAC,IAAI,IAAI,CAAC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,CAAA;QAChC,IAAI,CAAC,KAAK,EAAE,CAAA;QACZ,IAAI,IAAI,CAAC,KAAK,GAAG,CAAC,EAAE;YAChB,IAAI,CAAC,KAAK,GAAG,CAAC,CAAA;YACd,OAAO,SAAS,CAAA;SACnB;QACD,OAAO,IAAI,CAAC,OAAO,EAAE,CAAA;IACzB,CAAC;IAED;;OAEG;IACI,wBAAI,GAAX;QACI,CAAC,IAAI,CAAC,IAAI,IAAI,CAAC,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,CAAA;QAChC,IAAI,CAAC,KAAK,EAAE,CAAA;QACZ,IAAI,IAAI,CAAC,KAAK,IAAI,IAAI,CAAC,IAAI,EAAE;YACzB,IAAI,CAAC,KAAK,GAAG,IAAI,CAAC,IAAI,GAAG,CAAC,CAAA;YAC1B,OAAO,SAAS,CAAA;SACnB;QACD,OAAO,IAAI,CAAC,OAAO,EAAE,CAAA;IACzB,CAAC;IACL,gBAAC;AAAD,CAAC,AAtFD,IAsFC;AAtFY,8BAAS",
      sourcesContent: ["/**\n * @description \u6570\u636E\u7ED3\u6784 - \u94FE\u8868\n * @author fangzhicong\n */\n\n/**\n * \u7279\u6B8A\u94FE\u8868\uFF08\u6570\u636E\u5C3E\u63D2\u5165\u3001\u63D2\u5165\u524D\u81EA\u52A8\u6E05\u7406\u6307\u9488\u540E\u8FB9\u7684\u6570\u636E\u3001\u63D2\u5165\u540E\u6307\u9488\u6C38\u8FDC\u5B9A\u4F4D\u4E8E\u6700\u540E\u4E00\u4F4D\u5143\u7D20\u3001\u53EF\u9650\u5236\u94FE\u8868\u957F\u5EA6\u3001\u6307\u9488\u53CC\u5411\u79FB\u52A8\uFF09\n */\nexport class TailChain<T> {\n    /**\n     * \u94FE\u8868\u6570\u636E\n     */\n    protected data: T[] = []\n\n    /**\n     * \u94FE\u8868\u6700\u5927\u957F\u5EA6\uFF0C\u96F6\u8868\u793A\u957F\u5EA6\u4E0D\u9650\n     */\n    protected max: number = 0\n\n    /**\n     * \u6307\u9488\n     */\n    protected point = 0\n\n    // \u5F53\u524D\u6307\u9488\u662F\u5426\u4EBA\u4E3A\u64CD\u4F5C\u8FC7\n    protected isRe = false\n\n    /**\n     * \u5141\u8BB8\u7528\u6237\u91CD\u8BBE\u4E00\u6B21 max \u503C\n     */\n    resetMax(maxSize: number) {\n        maxSize = Math.abs(maxSize)\n        maxSize && (this.max = maxSize)\n    }\n\n    /**\n     * \u5F53\u524D\u94FE\u8868\u7684\u957F\u5EA6\n     */\n    get size() {\n        return this.data.length\n    }\n\n    /**\n     * \u5C3E\u63D2\u5165\n     * @param data \u63D2\u5165\u7684\u6570\u636E\n     */\n    public insertLast<K extends T>(data: K) {\n        // \u4EBA\u4E3A\u64CD\u4F5C\u8FC7\u6307\u9488\uFF0C\u6E05\u9664\u6307\u9488\u540E\u9762\u7684\u5143\u7D20\n        if (this.isRe) {\n            this.data.splice(this.point + 1)\n            this.isRe = false\n        }\n        this.data.push(data)\n        // \u8D85\u51FA\u94FE\u8868\u6700\u5927\u957F\u5EA6\n        while (this.max && this.size > this.max) {\n            this.data.shift()\n        }\n        // \u4ECE\u65B0\u5B9A\u4F4D\u6307\u9488\u5230\u6700\u540E\u4E00\u4E2A\u5143\u7D20\n        this.point = this.size - 1\n        return this\n    }\n\n    /**\n     * \u83B7\u53D6\u5F53\u524D\u6307\u9488\u5143\u7D20\n     */\n    public current(): T | undefined {\n        return this.data[this.point]\n    }\n\n    /**\n     * \u83B7\u53D6\u4E0A\u4E00\u6307\u9488\u5143\u7D20\n     */\n    public prev(): T | undefined {\n        !this.isRe && (this.isRe = true)\n        this.point--\n        if (this.point < 0) {\n            this.point = 0\n            return undefined\n        }\n        return this.current()\n    }\n\n    /**\n     * \u4E0B\u4E00\u6307\u9488\u5143\u7D20\n     */\n    public next(): T | undefined {\n        !this.isRe && (this.isRe = true)\n        this.point++\n        if (this.point >= this.size) {\n            this.point = this.size - 1\n            return undefined\n        }\n        return this.current()\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "67976e5ff14964c034183703e1eb3a26905a052c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2a7rwhjze2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2a7rwhjze2();
cov_2a7rwhjze2().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
cov_2a7rwhjze2().s[1]++;
exports.TailChain = void 0;
/**
 * 特殊链表（数据尾插入、插入前自动清理指针后边的数据、插入后指针永远定位于最后一位元素、可限制链表长度、指针双向移动）
 */

var TailChain = (
/** @class */
cov_2a7rwhjze2().s[2]++, function () {
  cov_2a7rwhjze2().f[0]++;

  function TailChain() {
    cov_2a7rwhjze2().f[1]++;
    cov_2a7rwhjze2().s[3]++;

    /**
     * 链表数据
     */
    this.data = [];
    /**
     * 链表最大长度，零表示长度不限
     */

    cov_2a7rwhjze2().s[4]++;
    this.max = 0;
    /**
     * 指针
     */

    cov_2a7rwhjze2().s[5]++;
    this.point = 0; // 当前指针是否人为操作过

    cov_2a7rwhjze2().s[6]++;
    this.isRe = false;
  }
  /**
   * 允许用户重设一次 max 值
   */


  cov_2a7rwhjze2().s[7]++;

  TailChain.prototype.resetMax = function (maxSize) {
    cov_2a7rwhjze2().f[2]++;
    cov_2a7rwhjze2().s[8]++;
    maxSize = Math.abs(maxSize);
    cov_2a7rwhjze2().s[9]++;
    (cov_2a7rwhjze2().b[0][0]++, maxSize) && (cov_2a7rwhjze2().b[0][1]++, this.max = maxSize);
  };

  cov_2a7rwhjze2().s[10]++;
  (0, _defineProperty["default"])(TailChain.prototype, "size", {
    /**
     * 当前链表的长度
     */
    get: function get() {
      cov_2a7rwhjze2().f[3]++;
      cov_2a7rwhjze2().s[11]++;
      return this.data.length;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 尾插入
   * @param data 插入的数据
   */

  cov_2a7rwhjze2().s[12]++;

  TailChain.prototype.insertLast = function (data) {
    cov_2a7rwhjze2().f[4]++;
    cov_2a7rwhjze2().s[13]++;

    // 人为操作过指针，清除指针后面的元素
    if (this.isRe) {
      var _context;

      cov_2a7rwhjze2().b[1][0]++;
      cov_2a7rwhjze2().s[14]++;
      (0, _splice["default"])(_context = this.data).call(_context, this.point + 1);
      cov_2a7rwhjze2().s[15]++;
      this.isRe = false;
    } else {
      cov_2a7rwhjze2().b[1][1]++;
    }

    cov_2a7rwhjze2().s[16]++;
    this.data.push(data); // 超出链表最大长度

    cov_2a7rwhjze2().s[17]++;

    while ((cov_2a7rwhjze2().b[2][0]++, this.max) && (cov_2a7rwhjze2().b[2][1]++, this.size > this.max)) {
      cov_2a7rwhjze2().s[18]++;
      this.data.shift();
    } // 从新定位指针到最后一个元素


    cov_2a7rwhjze2().s[19]++;
    this.point = this.size - 1;
    cov_2a7rwhjze2().s[20]++;
    return this;
  };
  /**
   * 获取当前指针元素
   */


  cov_2a7rwhjze2().s[21]++;

  TailChain.prototype.current = function () {
    cov_2a7rwhjze2().f[5]++;
    cov_2a7rwhjze2().s[22]++;
    return this.data[this.point];
  };
  /**
   * 获取上一指针元素
   */


  cov_2a7rwhjze2().s[23]++;

  TailChain.prototype.prev = function () {
    cov_2a7rwhjze2().f[6]++;
    cov_2a7rwhjze2().s[24]++;
    (cov_2a7rwhjze2().b[3][0]++, !this.isRe) && (cov_2a7rwhjze2().b[3][1]++, this.isRe = true);
    cov_2a7rwhjze2().s[25]++;
    this.point--;
    cov_2a7rwhjze2().s[26]++;

    if (this.point < 0) {
      cov_2a7rwhjze2().b[4][0]++;
      cov_2a7rwhjze2().s[27]++;
      this.point = 0;
      cov_2a7rwhjze2().s[28]++;
      return undefined;
    } else {
      cov_2a7rwhjze2().b[4][1]++;
    }

    cov_2a7rwhjze2().s[29]++;
    return this.current();
  };
  /**
   * 下一指针元素
   */


  cov_2a7rwhjze2().s[30]++;

  TailChain.prototype.next = function () {
    cov_2a7rwhjze2().f[7]++;
    cov_2a7rwhjze2().s[31]++;
    (cov_2a7rwhjze2().b[5][0]++, !this.isRe) && (cov_2a7rwhjze2().b[5][1]++, this.isRe = true);
    cov_2a7rwhjze2().s[32]++;
    this.point++;
    cov_2a7rwhjze2().s[33]++;

    if (this.point >= this.size) {
      cov_2a7rwhjze2().b[6][0]++;
      cov_2a7rwhjze2().s[34]++;
      this.point = this.size - 1;
      cov_2a7rwhjze2().s[35]++;
      return undefined;
    } else {
      cov_2a7rwhjze2().b[6][1]++;
    }

    cov_2a7rwhjze2().s[36]++;
    return this.current();
  };

  cov_2a7rwhjze2().s[37]++;
  return TailChain;
}());
cov_2a7rwhjze2().s[38]++;
exports.TailChain = TailChain;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 记录 scrollTop
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_2c2k9mx84z() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/scroll/index.ts";
  var hash = "a4ed21e4028b1154786ab0243b53a691283dc33b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/scroll/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 14
        },
        end: {
          line: 23,
          column: 80
        }
      },
      "16": {
        start: {
          line: 24,
          column: 33
        },
        end: {
          line: 73,
          column: 18
        }
      },
      "17": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 35
        }
      },
      "18": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 75
        }
      },
      "19": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "20": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 23
        }
      },
      "21": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 49
        }
      },
      "22": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 21
        }
      },
      "23": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 46,
          column: 6
        }
      },
      "24": {
        start: {
          line: 40,
          column: 20
        },
        end: {
          line: 40,
          column: 24
        }
      },
      "25": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 53
        }
      },
      "26": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 44,
          column: 11
        }
      },
      "27": {
        start: {
          line: 43,
          column: 12
        },
        end: {
          line: 43,
          column: 48
        }
      },
      "28": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 61
        }
      },
      "29": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "30": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 77
        }
      },
      "31": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 20
        }
      },
      "32": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 62,
          column: 6
        }
      },
      "33": {
        start: {
          line: 58,
          column: 20
        },
        end: {
          line: 58,
          column: 24
        }
      },
      "34": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 61,
          column: 11
        }
      },
      "35": {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 45
        }
      },
      "36": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "37": {
        start: {
          line: 67,
          column: 20
        },
        end: {
          line: 67,
          column: 24
        }
      },
      "38": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 70,
          column: 11
        }
      },
      "39": {
        start: {
          line: 69,
          column: 12
        },
        end: {
          line: 69,
          column: 45
        }
      },
      "40": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 23
        }
      },
      "41": {
        start: {
          line: 74,
          column: 0
        },
        end: {
          line: 74,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 24,
            column: 33
          },
          end: {
            line: 24,
            column: 34
          }
        },
        loc: {
          start: {
            line: 24,
            column: 51
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 24
      },
      "8": {
        name: "ScrollCache",
        decl: {
          start: {
            line: 26,
            column: 13
          },
          end: {
            line: 26,
            column: 24
          }
        },
        loc: {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 26
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 39,
            column: 36
          },
          end: {
            line: 39,
            column: 37
          }
        },
        loc: {
          start: {
            line: 39,
            column: 48
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 39
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 42,
            column: 43
          },
          end: {
            line: 42,
            column: 44
          }
        },
        loc: {
          start: {
            line: 42,
            column: 55
          },
          end: {
            line: 44,
            column: 9
          }
        },
        line: 42
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 50,
            column: 33
          },
          end: {
            line: 50,
            column: 34
          }
        },
        loc: {
          start: {
            line: 50,
            column: 45
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 50
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 57,
            column: 35
          },
          end: {
            line: 57,
            column: 36
          }
        },
        loc: {
          start: {
            line: 57,
            column: 47
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 57
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 59,
            column: 50
          },
          end: {
            line: 59,
            column: 51
          }
        },
        loc: {
          start: {
            line: 59,
            column: 66
          },
          end: {
            line: 61,
            column: 9
          }
        },
        line: 59
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 66,
            column: 36
          },
          end: {
            line: 66,
            column: 37
          }
        },
        loc: {
          start: {
            line: 66,
            column: 48
          },
          end: {
            line: 71,
            column: 5
          }
        },
        line: 66
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 68,
            column: 51
          },
          end: {
            line: 68,
            column: 52
          }
        },
        loc: {
          start: {
            line: 68,
            column: 67
          },
          end: {
            line: 70,
            column: 9
          }
        },
        line: 68
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 20
          },
          end: {
            line: 27,
            column: 67
          }
        }, {
          start: {
            line: 27,
            column: 71
          },
          end: {
            line: 27,
            column: 75
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/scroll/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/scroll/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,iFAA0D;AAI1D;IAAyC,+BAAiB;IAWtD,qBAAmB,MAAc;QAAjC,YACI,kBAAM,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,SAEtC;QAHkB,YAAM,GAAN,MAAM,CAAQ;QAVjC;;WAEG;QACK,UAAI,GAAW,CAAC,CAAA;QASpB,KAAI,CAAC,MAAM,GAAG,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;;IAC3C,CAAC;IAED;;OAEG;IACI,6BAAO,GAAd;QAAA,iBAMC;QALG,IAAI,CAAC,MAAM,GAAG,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC5C,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,EAAE,CAAC,QAAQ,EAAE;YAC/B,KAAI,CAAC,IAAI,GAAG,KAAI,CAAC,MAAM,CAAC,SAAS,CAAA;QACrC,CAAC,CAAC,CAAA;QACF,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,CAAA;IACxD,CAAC;IAED;;OAEG;IACI,0BAAI,GAAX;QACI,iBAAM,IAAI,YAAC,CAAC,IAAI,CAAC,IAAI,EAAE,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,CAAC,CAAA;QAC9C,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;OAEG;IACI,4BAAM,GAAb;QAAA,iBAIC;QAHG,OAAO,iBAAM,MAAM,YAAC,UAAA,IAAI;YACpB,KAAI,CAAC,MAAM,CAAC,SAAS,GAAG,IAAI,CAAC,CAAC,CAAC,CAAA;QACnC,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACI,6BAAO,GAAd;QAAA,iBAIC;QAHG,OAAO,iBAAM,OAAO,YAAC,UAAA,IAAI;YACrB,KAAI,CAAC,MAAM,CAAC,SAAS,GAAG,IAAI,CAAC,CAAC,CAAC,CAAA;QACnC,CAAC,CAAC,CAAA;IACN,CAAC;IACL,kBAAC;AAAD,CAAC,AApDD,CAAyC,eAAK,GAoD7C",
      sourcesContent: ["/**\n * @description \u8BB0\u5F55 scrollTop\n * @author fangzhicong\n */\n\nimport Cache from '../../../../utils/data-structure/cache'\nimport Editor from '../../../index'\nimport { ScrollItem } from '../type'\n\nexport default class ScrollCache extends Cache<ScrollItem> {\n    /**\n     * \u4E0A\u4E00\u6B21\u7684 scrollTop\n     */\n    private last: number = 0\n\n    /**\n     * \u7F16\u8F91\u533A\u5BB9\u5668\u5143\u7D20\u8282\u70B9\n     */\n    private target: Element\n\n    constructor(public editor: Editor) {\n        super(editor.config.historyMaxSize)\n        this.target = editor.$textElem.elems[0]\n    }\n\n    /**\n     * \u7ED9\u7F16\u8F91\u533A\u5BB9\u5668\u7ED1\u5B9A scroll \u4E8B\u4EF6\n     */\n    public observe() {\n        this.target = this.editor.$textElem.elems[0]\n        this.editor.$textElem.on('scroll', () => {\n            this.last = this.target.scrollTop\n        })\n        this.resetMaxSize(this.editor.config.historyMaxSize)\n    }\n\n    /**\n     * \u4FDD\u5B58 scrollTop \u503C\n     */\n    public save() {\n        super.save([this.last, this.target.scrollTop])\n        return this\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        return super.revoke(data => {\n            this.target.scrollTop = data[0]\n        })\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        return super.restore(data => {\n            this.target.scrollTop = data[1]\n        })\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a4ed21e4028b1154786ab0243b53a691283dc33b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2c2k9mx84z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2c2k9mx84z();

var __extends = (cov_2c2k9mx84z().s[0]++, (cov_2c2k9mx84z().b[0][0]++, void 0) && (cov_2c2k9mx84z().b[0][1]++, (void 0).__extends) || (cov_2c2k9mx84z().b[0][2]++, function () {
  cov_2c2k9mx84z().f[0]++;
  cov_2c2k9mx84z().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_2c2k9mx84z().f[1]++;
    cov_2c2k9mx84z().s[2]++;
    _extendStatics = (cov_2c2k9mx84z().b[1][0]++, _setPrototypeOf["default"]) || (cov_2c2k9mx84z().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_2c2k9mx84z().b[1][2]++, function (d, b) {
      cov_2c2k9mx84z().f[2]++;
      cov_2c2k9mx84z().s[3]++;
      d.__proto__ = b;
    }) || (cov_2c2k9mx84z().b[1][3]++, function (d, b) {
      cov_2c2k9mx84z().f[3]++;
      cov_2c2k9mx84z().s[4]++;

      for (var p in b) {
        cov_2c2k9mx84z().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_2c2k9mx84z().b[2][0]++;
          cov_2c2k9mx84z().s[6]++;
          d[p] = b[p];
        } else {
          cov_2c2k9mx84z().b[2][1]++;
        }
      }
    });
    cov_2c2k9mx84z().s[7]++;
    return _extendStatics(d, b);
  };

  cov_2c2k9mx84z().s[8]++;
  return function (d, b) {
    cov_2c2k9mx84z().f[4]++;
    cov_2c2k9mx84z().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_2c2k9mx84z().f[5]++;
      cov_2c2k9mx84z().s[10]++;
      this.constructor = d;
    }

    cov_2c2k9mx84z().s[11]++;
    d.prototype = b === null ? (cov_2c2k9mx84z().b[3][0]++, (0, _create["default"])(b)) : (cov_2c2k9mx84z().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_2c2k9mx84z().s[12]++, (cov_2c2k9mx84z().b[4][0]++, void 0) && (cov_2c2k9mx84z().b[4][1]++, (void 0).__importDefault) || (cov_2c2k9mx84z().b[4][2]++, function (mod) {
  cov_2c2k9mx84z().f[6]++;
  cov_2c2k9mx84z().s[13]++;
  return (cov_2c2k9mx84z().b[6][0]++, mod) && (cov_2c2k9mx84z().b[6][1]++, mod.__esModule) ? (cov_2c2k9mx84z().b[5][0]++, mod) : (cov_2c2k9mx84z().b[5][1]++, {
    "default": mod
  });
}));

cov_2c2k9mx84z().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var cache_1 = (cov_2c2k9mx84z().s[15]++, __importDefault(__webpack_require__(95)));
var ScrollCache = (
/** @class */
cov_2c2k9mx84z().s[16]++, function (_super) {
  cov_2c2k9mx84z().f[7]++;
  cov_2c2k9mx84z().s[17]++;

  __extends(ScrollCache, _super);

  function ScrollCache(editor) {
    cov_2c2k9mx84z().f[8]++;

    var _this = (cov_2c2k9mx84z().s[18]++, (cov_2c2k9mx84z().b[7][0]++, _super.call(this, editor.config.historyMaxSize)) || (cov_2c2k9mx84z().b[7][1]++, this));

    cov_2c2k9mx84z().s[19]++;
    _this.editor = editor;
    /**
     * 上一次的 scrollTop
     */

    cov_2c2k9mx84z().s[20]++;
    _this.last = 0;
    cov_2c2k9mx84z().s[21]++;
    _this.target = editor.$textElem.elems[0];
    cov_2c2k9mx84z().s[22]++;
    return _this;
  }
  /**
   * 给编辑区容器绑定 scroll 事件
   */


  cov_2c2k9mx84z().s[23]++;

  ScrollCache.prototype.observe = function () {
    cov_2c2k9mx84z().f[9]++;

    var _this = (cov_2c2k9mx84z().s[24]++, this);

    cov_2c2k9mx84z().s[25]++;
    this.target = this.editor.$textElem.elems[0];
    cov_2c2k9mx84z().s[26]++;
    this.editor.$textElem.on('scroll', function () {
      cov_2c2k9mx84z().f[10]++;
      cov_2c2k9mx84z().s[27]++;
      _this.last = _this.target.scrollTop;
    });
    cov_2c2k9mx84z().s[28]++;
    this.resetMaxSize(this.editor.config.historyMaxSize);
  };
  /**
   * 保存 scrollTop 值
   */


  cov_2c2k9mx84z().s[29]++;

  ScrollCache.prototype.save = function () {
    cov_2c2k9mx84z().f[11]++;
    cov_2c2k9mx84z().s[30]++;

    _super.prototype.save.call(this, [this.last, this.target.scrollTop]);

    cov_2c2k9mx84z().s[31]++;
    return this;
  };
  /**
   * 撤销
   */


  cov_2c2k9mx84z().s[32]++;

  ScrollCache.prototype.revoke = function () {
    cov_2c2k9mx84z().f[12]++;

    var _this = (cov_2c2k9mx84z().s[33]++, this);

    cov_2c2k9mx84z().s[34]++;
    return _super.prototype.revoke.call(this, function (data) {
      cov_2c2k9mx84z().f[13]++;
      cov_2c2k9mx84z().s[35]++;
      _this.target.scrollTop = data[0];
    });
  };
  /**
   * 恢复
   */


  cov_2c2k9mx84z().s[36]++;

  ScrollCache.prototype.restore = function () {
    cov_2c2k9mx84z().f[14]++;

    var _this = (cov_2c2k9mx84z().s[37]++, this);

    cov_2c2k9mx84z().s[38]++;
    return _super.prototype.restore.call(this, function (data) {
      cov_2c2k9mx84z().f[15]++;
      cov_2c2k9mx84z().s[39]++;
      _this.target.scrollTop = data[1];
    });
  };

  cov_2c2k9mx84z().s[40]++;
  return ScrollCache;
}(cache_1["default"]));
cov_2c2k9mx84z().s[41]++;
exports["default"] = ScrollCache;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @description 记录 range 变化
 * @author fangzhicong
 */

var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

var _create = _interopRequireDefault(__webpack_require__(3));

var _setPrototypeOf = _interopRequireDefault(__webpack_require__(5));

function cov_qtxp8yb4o() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/range/index.ts";
  var hash = "e263028bcbf053bff2962bd7539b2214f13f8cfd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/range/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 16
        },
        end: {
          line: 18,
          column: 4
        }
      },
      "1": {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 10,
          column: 110
        }
      },
      "3": {
        start: {
          line: 9,
          column: 69
        },
        end: {
          line: 9,
          column: 85
        }
      },
      "4": {
        start: {
          line: 10,
          column: 30
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "5": {
        start: {
          line: 10,
          column: 47
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "6": {
        start: {
          line: 10,
          column: 95
        },
        end: {
          line: 10,
          column: 107
        }
      },
      "7": {
        start: {
          line: 11,
          column: 8
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "8": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      "9": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 14,
          column: 28
        }
      },
      "10": {
        start: {
          line: 15,
          column: 24
        },
        end: {
          line: 15,
          column: 45
        }
      },
      "11": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 93
        }
      },
      "12": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "13": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "14": {
        start: {
          line: 22,
          column: 0
        },
        end: {
          line: 22,
          column: 62
        }
      },
      "15": {
        start: {
          line: 23,
          column: 14
        },
        end: {
          line: 23,
          column: 80
        }
      },
      "16": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 71
        }
      },
      "17": {
        start: {
          line: 25,
          column: 13
        },
        end: {
          line: 25,
          column: 46
        }
      },
      "18": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 36,
          column: 6
        }
      },
      "19": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 141,
          column: 18
        }
      },
      "20": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 34
        }
      },
      "21": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 75
        }
      },
      "22": {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 30
        }
      },
      "23": {
        start: {
          line: 46,
          column: 8
        },
        end: {
          line: 46,
          column: 64
        }
      },
      "24": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 47
        }
      },
      "25": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 50,
          column: 42
        }
      },
      "26": {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 63
        }
      },
      "27": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 21
        }
      },
      "28": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "29": {
        start: {
          line: 58,
          column: 28
        },
        end: {
          line: 58,
          column: 51
        }
      },
      "30": {
        start: {
          line: 59,
          column: 12
        },
        end: {
          line: 59,
          column: 104
        }
      },
      "31": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 98,
          column: 6
        }
      },
      "32": {
        start: {
          line: 68,
          column: 19
        },
        end: {
          line: 68,
          column: 23
        }
      },
      "33": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 51
        }
      },
      "34": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 61
        }
      },
      "35": {
        start: {
          line: 74,
          column: 25
        },
        end: {
          line: 74,
          column: 41
        }
      },
      "36": {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 81,
          column: 13
        }
      },
      "37": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 80,
          column: 17
        }
      },
      "38": {
        start: {
          line: 79,
          column: 20
        },
        end: {
          line: 79,
          column: 43
        }
      },
      "39": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 88,
          column: 13
        }
      },
      "40": {
        start: {
          line: 87,
          column: 16
        },
        end: {
          line: 87,
          column: 39
        }
      },
      "41": {
        start: {
          line: 91,
          column: 8
        },
        end: {
          line: 91,
          column: 76
        }
      },
      "42": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 95,
          column: 11
        }
      },
      "43": {
        start: {
          line: 94,
          column: 12
        },
        end: {
          line: 94,
          column: 81
        }
      },
      "44": {
        start: {
          line: 97,
          column: 8
        },
        end: {
          line: 97,
          column: 60
        }
      },
      "45": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 107,
          column: 6
        }
      },
      "46": {
        start: {
          line: 103,
          column: 22
        },
        end: {
          line: 103,
          column: 53
        }
      },
      "47": {
        start: {
          line: 104,
          column: 8
        },
        end: {
          line: 104,
          column: 68
        }
      },
      "48": {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 33
        }
      },
      "49": {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 20
        }
      },
      "50": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 121,
          column: 6
        }
      },
      "51": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 119,
          column: 9
        }
      },
      "52": {
        start: {
          line: 114,
          column: 25
        },
        end: {
          line: 114,
          column: 41
        }
      },
      "53": {
        start: {
          line: 115,
          column: 12
        },
        end: {
          line: 115,
          column: 55
        }
      },
      "54": {
        start: {
          line: 116,
          column: 12
        },
        end: {
          line: 116,
          column: 51
        }
      },
      "55": {
        start: {
          line: 117,
          column: 12
        },
        end: {
          line: 117,
          column: 45
        }
      },
      "56": {
        start: {
          line: 118,
          column: 12
        },
        end: {
          line: 118,
          column: 24
        }
      },
      "57": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 120,
          column: 21
        }
      },
      "58": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 130,
          column: 6
        }
      },
      "59": {
        start: {
          line: 126,
          column: 20
        },
        end: {
          line: 126,
          column: 24
        }
      },
      "60": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 129,
          column: 11
        }
      },
      "61": {
        start: {
          line: 128,
          column: 12
        },
        end: {
          line: 128,
          column: 31
        }
      },
      "62": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 139,
          column: 6
        }
      },
      "63": {
        start: {
          line: 135,
          column: 20
        },
        end: {
          line: 135,
          column: 24
        }
      },
      "64": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 138,
          column: 11
        }
      },
      "65": {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 31
        }
      },
      "66": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 22
        }
      },
      "67": {
        start: {
          line: 142,
          column: 0
        },
        end: {
          line: 142,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 57
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 25
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 12,
            column: 5
          }
        },
        line: 7
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 52
          }
        },
        loc: {
          start: {
            line: 9,
            column: 67
          },
          end: {
            line: 9,
            column: 87
          }
        },
        line: 9
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 13
          }
        },
        loc: {
          start: {
            line: 10,
            column: 28
          },
          end: {
            line: 10,
            column: 109
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 13,
            column: 12
          }
        },
        loc: {
          start: {
            line: 13,
            column: 27
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "5": {
        name: "__",
        decl: {
          start: {
            line: 15,
            column: 17
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 47
          }
        },
        line: 15
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 57
          }
        },
        loc: {
          start: {
            line: 19,
            column: 71
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 19
      },
      "7": {
        name: "rangeToObject",
        decl: {
          start: {
            line: 30,
            column: 9
          },
          end: {
            line: 30,
            column: 22
          }
        },
        loc: {
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 30
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 41,
            column: 32
          },
          end: {
            line: 41,
            column: 33
          }
        },
        loc: {
          start: {
            line: 41,
            column: 50
          },
          end: {
            line: 141,
            column: 1
          }
        },
        line: 41
      },
      "9": {
        name: "RangeCache",
        decl: {
          start: {
            line: 43,
            column: 13
          },
          end: {
            line: 43,
            column: 23
          }
        },
        loc: {
          start: {
            line: 43,
            column: 32
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 43
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 48,
            column: 48
          },
          end: {
            line: 48,
            column: 49
          }
        },
        loc: {
          start: {
            line: 48,
            column: 60
          },
          end: {
            line: 50,
            column: 9
          }
        },
        line: 48
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 57,
            column: 13
          },
          end: {
            line: 57,
            column: 14
          }
        },
        loc: {
          start: {
            line: 57,
            column: 25
          },
          end: {
            line: 60,
            column: 9
          }
        },
        line: 57
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 67,
            column: 35
          },
          end: {
            line: 67,
            column: 36
          }
        },
        loc: {
          start: {
            line: 67,
            column: 47
          },
          end: {
            line: 98,
            column: 5
          }
        },
        line: 67
      },
      "13": {
        name: "selectionchange",
        decl: {
          start: {
            line: 73,
            column: 17
          },
          end: {
            line: 73,
            column: 32
          }
        },
        loc: {
          start: {
            line: 73,
            column: 35
          },
          end: {
            line: 82,
            column: 9
          }
        },
        line: 73
      },
      "14": {
        name: "deletecallback",
        decl: {
          start: {
            line: 84,
            column: 17
          },
          end: {
            line: 84,
            column: 31
          }
        },
        loc: {
          start: {
            line: 84,
            column: 35
          },
          end: {
            line: 89,
            column: 9
          }
        },
        line: 84
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 93,
            column: 34
          },
          end: {
            line: 93,
            column: 35
          }
        },
        loc: {
          start: {
            line: 93,
            column: 46
          },
          end: {
            line: 95,
            column: 9
          }
        },
        line: 93
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 102,
            column: 32
          },
          end: {
            line: 102,
            column: 33
          }
        },
        loc: {
          start: {
            line: 102,
            column: 44
          },
          end: {
            line: 107,
            column: 5
          }
        },
        line: 102
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 112,
            column: 31
          },
          end: {
            line: 112,
            column: 32
          }
        },
        loc: {
          start: {
            line: 112,
            column: 48
          },
          end: {
            line: 121,
            column: 5
          }
        },
        line: 112
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 125,
            column: 34
          },
          end: {
            line: 125,
            column: 35
          }
        },
        loc: {
          start: {
            line: 125,
            column: 46
          },
          end: {
            line: 130,
            column: 5
          }
        },
        line: 125
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 127,
            column: 50
          },
          end: {
            line: 127,
            column: 51
          }
        },
        loc: {
          start: {
            line: 127,
            column: 66
          },
          end: {
            line: 129,
            column: 9
          }
        },
        line: 127
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 134,
            column: 35
          },
          end: {
            line: 134,
            column: 36
          }
        },
        loc: {
          start: {
            line: 134,
            column: 47
          },
          end: {
            line: 139,
            column: 5
          }
        },
        line: 134
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 136,
            column: 51
          },
          end: {
            line: 136,
            column: 52
          }
        },
        loc: {
          start: {
            line: 136,
            column: 67
          },
          end: {
            line: 138,
            column: 9
          }
        },
        line: 136
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 18,
            column: 4
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 17
          },
          end: {
            line: 6,
            column: 21
          }
        }, {
          start: {
            line: 6,
            column: 25
          },
          end: {
            line: 6,
            column: 39
          }
        }, {
          start: {
            line: 6,
            column: 44
          },
          end: {
            line: 18,
            column: 4
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 10,
            column: 109
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 8,
            column: 45
          }
        }, {
          start: {
            line: 9,
            column: 13
          },
          end: {
            line: 9,
            column: 47
          }
        }, {
          start: {
            line: 9,
            column: 51
          },
          end: {
            line: 9,
            column: 87
          }
        }, {
          start: {
            line: 10,
            column: 12
          },
          end: {
            line: 10,
            column: 109
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }, {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 10,
            column: 107
          }
        }],
        line: 10
      },
      "3": {
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 91
          }
        }],
        line: 16
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 22
          },
          end: {
            line: 21,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 31
          },
          end: {
            line: 19,
            column: 51
          }
        }, {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 21,
            column: 1
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 37
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 43
          },
          end: {
            line: 20,
            column: 61
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 12
          },
          end: {
            line: 20,
            column: 15
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 20,
            column: 33
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 67
          }
        }, {
          start: {
            line: 44,
            column: 71
          },
          end: {
            line: 44,
            column: 75
          }
        }],
        line: 44
      },
      "8": {
        loc: {
          start: {
            line: 59,
            column: 19
          },
          end: {
            line: 59,
            column: 103
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 59,
            column: 55
          },
          end: {
            line: 59,
            column: 78
          }
        }, {
          start: {
            line: 59,
            column: 81
          },
          end: {
            line: 59,
            column: 103
          }
        }],
        line: 59
      },
      "9": {
        loc: {
          start: {
            line: 59,
            column: 19
          },
          end: {
            line: 59,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 19
          },
          end: {
            line: 59,
            column: 28
          }
        }, {
          start: {
            line: 59,
            column: 32
          },
          end: {
            line: 59,
            column: 52
          }
        }],
        line: 59
      },
      "10": {
        loc: {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 81,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 81,
            column: 13
          }
        }, {
          start: {
            line: 75,
            column: 12
          },
          end: {
            line: 81,
            column: 13
          }
        }],
        line: 75
      },
      "11": {
        loc: {
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 76,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 16
          },
          end: {
            line: 75,
            column: 60
          }
        }, {
          start: {
            line: 76,
            column: 16
          },
          end: {
            line: 76,
            column: 66
          }
        }],
        line: 75
      },
      "12": {
        loc: {
          start: {
            line: 78,
            column: 16
          },
          end: {
            line: 80,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 16
          },
          end: {
            line: 80,
            column: 17
          }
        }, {
          start: {
            line: 78,
            column: 16
          },
          end: {
            line: 80,
            column: 17
          }
        }],
        line: 78
      },
      "13": {
        loc: {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        }, {
          start: {
            line: 85,
            column: 12
          },
          end: {
            line: 88,
            column: 13
          }
        }],
        line: 85
      },
      "14": {
        loc: {
          start: {
            line: 85,
            column: 16
          },
          end: {
            line: 85,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 16
          },
          end: {
            line: 85,
            column: 36
          }
        }, {
          start: {
            line: 85,
            column: 40
          },
          end: {
            line: 85,
            column: 57
          }
        }],
        line: 85
      },
      "15": {
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        }, {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 119,
            column: 9
          }
        }],
        line: 113
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/history/data/range/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/history/data/range/index.ts"],
      names: [],
      mappings: ";AAAA;;;GAGG;;;;;;;;;;;;;;;;;;AAEH,iFAA0D;AAG1D,wEAA0C;AAC1C,+CAAiD;AAEjD;;;GAGG;AACH,SAAS,aAAa,CAAC,KAAY;IAC/B,OAAO;QACH,KAAK,EAAE,CAAC,KAAK,CAAC,cAAc,EAAE,KAAK,CAAC,WAAW,CAAC;QAChD,GAAG,EAAE,CAAC,KAAK,CAAC,YAAY,EAAE,KAAK,CAAC,SAAS,CAAC;QAC1C,IAAI,EAAE,KAAK,CAAC,uBAAuB;QACnC,SAAS,EAAE,KAAK,CAAC,SAAS;KAC7B,CAAA;AACL,CAAC;AAED;;GAEG;AACH;IAAwC,8BAA6B;IAajE,oBAAmB,MAAc;QAAjC,YACI,kBAAM,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,SAMtC;QAPkB,YAAM,GAAN,MAAM,CAAQ;QAE7B,KAAI,CAAC,SAAS,GAAG,aAAa,CAAC,QAAQ,CAAC,WAAW,EAAE,CAAC,CAAA;QACtD,KAAI,CAAC,IAAI,GAAG,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QACrC,KAAI,CAAC,eAAe,GAAG,eAAQ,CAAC;YAC5B,KAAI,CAAC,SAAS,GAAG,aAAa,CAAC,KAAI,CAAC,WAAW,CAAC,CAAA;QACpD,CAAC,EAAE,MAAM,CAAC,MAAM,CAAC,eAAe,CAAC,CAAA;;IACrC,CAAC;IAKD,sBAAW,mCAAW;QAHtB;;WAEG;aACH;YACI,IAAM,SAAS,GAAG,QAAQ,CAAC,YAAY,EAAE,CAAA;YACzC,OAAO,SAAS,IAAI,SAAS,CAAC,UAAU,CAAC,CAAC,CAAC,SAAS,CAAC,UAAU,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,QAAQ,CAAC,WAAW,EAAE,CAAA;QAC/F,CAAC;;;OAAA;IAED;;OAEG;IACI,4BAAO,GAAd;QACI,IAAM,IAAI,GAAG,IAAI,CAAA;QACjB,SAAS;QACT,IAAI,CAAC,IAAI,GAAG,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,KAAK,CAAC,CAAC,CAAC,CAAA;QAC1C,IAAI,CAAC,YAAY,CAAC,IAAI,CAAC,MAAM,CAAC,MAAM,CAAC,cAAc,CAAC,CAAA;QACpD,wBAAwB;QACxB,SAAS,eAAe;YACpB,IAAM,MAAM,GAAG,IAAI,CAAC,WAAW,CAAA;YAC/B,IACI,IAAI,CAAC,IAAI,KAAK,MAAM,CAAC,uBAAuB;gBAC5C,IAAI,CAAC,IAAI,CAAC,QAAQ,CAAC,MAAM,CAAC,uBAAuB,CAAC,EACpD;gBACE,gBAAgB;gBAChB,IAAI,CAAC,IAAI,CAAC,MAAM,CAAC,WAAW,EAAE;oBAC1B,IAAI,CAAC,eAAe,EAAE,CAAA;iBACzB;aACJ;QACL,CAAC;QACD,mCAAmC;QACnC,SAAS,cAAc,CAAC,CAAgB;YACpC,IAAI,CAAC,CAAC,GAAG,IAAI,WAAW,IAAI,CAAC,CAAC,GAAG,IAAI,QAAQ,EAAE;gBAC3C,mDAAmD;gBACnD,IAAI,CAAC,eAAe,EAAE,CAAA;aACzB;QACL,CAAC;QACD,wCAAwC;QACxC,kBAAC,CAAC,QAAQ,CAAC,CAAC,EAAE,CAAC,iBAAiB,EAAE,eAAe,CAAC,CAAA;QAClD,SAAS;QACT,IAAI,CAAC,MAAM,CAAC,aAAa,CAAC;YACtB,kBAAC,CAAC,QAAQ,CAAC,CAAC,GAAG,CAAC,iBAAiB,EAAE,eAAe,CAAC,CAAA;QACvD,CAAC,CAAC,CAAA;QAEF,kBAAkB;QAClB,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,EAAE,CAAC,SAAS,EAAE,cAAc,CAAC,CAAA;IACvD,CAAC;IAED;;OAEG;IACI,yBAAI,GAAX;QACI,IAAI,OAAO,GAAG,aAAa,CAAC,IAAI,CAAC,WAAW,CAAC,CAAA;QAC7C,iBAAM,IAAI,YAAC,CAAC,IAAI,CAAC,SAAS,EAAE,OAAO,CAAC,CAAC,CAAA;QACrC,IAAI,CAAC,SAAS,GAAG,OAAO,CAAA;QACxB,OAAO,IAAI,CAAA;IACf,CAAC;IAED;;;OAGG;IACI,wBAAG,GAAV,UAAW,KAA4B;QACnC,IAAI,KAAK,EAAE;YACP,IAAM,MAAM,GAAG,IAAI,CAAC,WAAW,CAAA;YAC/B,MAAM,CAAC,QAAQ,OAAf,MAAM,EAAa,KAAK,CAAC,KAAK,EAAC;YAC/B,MAAM,CAAC,MAAM,OAAb,MAAM,EAAW,KAAK,CAAC,GAAG,EAAC;YAC3B,IAAI,CAAC,MAAM,CAAC,KAAK,CAAC,YAAY,EAAE,CAAA;YAChC,OAAO,IAAI,CAAA;SACd;QACD,OAAO,KAAK,CAAA;IAChB,CAAC;IAED;;OAEG;IACI,2BAAM,GAAb;QAAA,iBAIC;QAHG,OAAO,iBAAM,MAAM,YAAC,UAAA,IAAI;YACpB,KAAI,CAAC,GAAG,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAA;QACrB,CAAC,CAAC,CAAA;IACN,CAAC;IAED;;OAEG;IACI,4BAAO,GAAd;QAAA,iBAIC;QAHG,OAAO,iBAAM,OAAO,YAAC,UAAA,IAAI;YACrB,KAAI,CAAC,GAAG,CAAC,IAAI,CAAC,CAAC,CAAC,CAAC,CAAA;QACrB,CAAC,CAAC,CAAA;IACN,CAAC;IACL,iBAAC;AAAD,CAAC,AA/GD,CAAwC,eAAK,GA+G5C",
      sourcesContent: ["/**\n * @description \u8BB0\u5F55 range \u53D8\u5316\n * @author fangzhicong\n */\n\nimport Cache from '../../../../utils/data-structure/cache'\nimport Editor from '../../../index'\nimport { RangeItem } from '../type'\nimport $ from '../../../../utils/dom-core'\nimport { debounce } from '../../../../utils/util'\n\n/**\n * \u628A Range \u5BF9\u8C61\u8F6C\u6362\u6210\u7F13\u5B58\u5BF9\u8C61\n * @param range Range \u5BF9\u8C61\n */\nfunction rangeToObject(range: Range): RangeItem {\n    return {\n        start: [range.startContainer, range.startOffset],\n        end: [range.endContainer, range.endOffset],\n        root: range.commonAncestorContainer,\n        collapsed: range.collapsed,\n    }\n}\n\n/**\n * \u7F16\u8F91\u533A range \u7F13\u5B58\u7BA1\u7406\u5668\n */\nexport default class RangeCache extends Cache<[RangeItem, RangeItem]> {\n    /**\n     * \u53D8\u5316\u524D\u7684 Range \u6570\u636E\n     */\n    private lastRange: RangeItem\n\n    /**\n     * \u6709\u6548\u9009\u533A\u7684\u6839\u8282\u70B9\n     */\n    private root: Element\n\n    public updateLastRange: Function\n\n    constructor(public editor: Editor) {\n        super(editor.config.historyMaxSize)\n        this.lastRange = rangeToObject(document.createRange())\n        this.root = editor.$textElem.elems[0]\n        this.updateLastRange = debounce(() => {\n            this.lastRange = rangeToObject(this.rangeHandle)\n        }, editor.config.onchangeTimeout)\n    }\n\n    /**\n     * \u83B7\u53D6 Range \u5BF9\u8C61\n     */\n    public get rangeHandle() {\n        const selection = document.getSelection()\n        return selection && selection.rangeCount ? selection.getRangeAt(0) : document.createRange()\n    }\n\n    /**\n     * \u521D\u59CB\u5316\u7ED1\u5B9A\n     */\n    public observe() {\n        const self = this\n        // \u540C\u6B65\u8282\u70B9\u6570\u636E\n        this.root = this.editor.$textElem.elems[0]\n        this.resetMaxSize(this.editor.config.historyMaxSize)\n        // selection change \u56DE\u8C03\u51FD\u6570\n        function selectionchange() {\n            const handle = self.rangeHandle\n            if (\n                self.root === handle.commonAncestorContainer ||\n                self.root.contains(handle.commonAncestorContainer)\n            ) {\n                // \u975E\u4E2D\u6587\u8F93\u5165\u72B6\u6001\u4E0B\u624D\u8FDB\u884C\u8BB0\u5F55\n                if (!self.editor.isComposing) {\n                    self.updateLastRange()\n                }\n            }\n        }\n        // backspace \u548C delete \u624B\u52A8\u66F4\u65B0 Range \u7F13\u5B58\n        function deletecallback(e: KeyboardEvent) {\n            if (e.key == 'Backspace' || e.key == 'Delete') {\n                // self.lastRange = rangeToObject(self.rangeHandle)\n                self.updateLastRange()\n            }\n        }\n        // \u7ED1\u5B9A\u4E8B\u4EF6\uFF08\u5FC5\u987B\u7ED1\u5B9A\u5728 document \u4E0A\uFF0C\u4E0D\u80FD\u7ED1\u5B9A\u5728 window \u4E0A\uFF09\n        $(document).on('selectionchange', selectionchange)\n        // \u89E3\u9664\u4E8B\u4EF6\u7ED1\u5B9A\n        this.editor.beforeDestroy(function () {\n            $(document).off('selectionchange', selectionchange)\n        })\n\n        // \u5220\u9664\u6587\u672C\u65F6\u624B\u52A8\u66F4\u65B0 range\n        self.editor.$textElem.on('keydown', deletecallback)\n    }\n\n    /**\n     * \u4FDD\u5B58 Range\n     */\n    public save() {\n        let current = rangeToObject(this.rangeHandle)\n        super.save([this.lastRange, current])\n        this.lastRange = current\n        return this\n    }\n\n    /**\n     * \u8BBE\u7F6E Range\uFF0C\u5728 \u64A4\u9500/\u6062\u590D \u4E2D\u8C03\u7528\n     * @param range \u7F13\u5B58\u7684 Range \u6570\u636E\n     */\n    public set(range: RangeItem | undefined) {\n        if (range) {\n            const handle = this.rangeHandle\n            handle.setStart(...range.start)\n            handle.setEnd(...range.end)\n            this.editor.menus.changeActive()\n            return true\n        }\n        return false\n    }\n\n    /**\n     * \u64A4\u9500\n     */\n    public revoke() {\n        return super.revoke(data => {\n            this.set(data[0])\n        })\n    }\n\n    /**\n     * \u6062\u590D\n     */\n    public restore() {\n        return super.restore(data => {\n            this.set(data[1])\n        })\n    }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e263028bcbf053bff2962bd7539b2214f13f8cfd"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_qtxp8yb4o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_qtxp8yb4o();

var __extends = (cov_qtxp8yb4o().s[0]++, (cov_qtxp8yb4o().b[0][0]++, void 0) && (cov_qtxp8yb4o().b[0][1]++, (void 0).__extends) || (cov_qtxp8yb4o().b[0][2]++, function () {
  cov_qtxp8yb4o().f[0]++;
  cov_qtxp8yb4o().s[1]++;

  var _extendStatics = function extendStatics(d, b) {
    cov_qtxp8yb4o().f[1]++;
    cov_qtxp8yb4o().s[2]++;
    _extendStatics = (cov_qtxp8yb4o().b[1][0]++, _setPrototypeOf["default"]) || (cov_qtxp8yb4o().b[1][1]++, {
      __proto__: []
    } instanceof Array) && (cov_qtxp8yb4o().b[1][2]++, function (d, b) {
      cov_qtxp8yb4o().f[2]++;
      cov_qtxp8yb4o().s[3]++;
      d.__proto__ = b;
    }) || (cov_qtxp8yb4o().b[1][3]++, function (d, b) {
      cov_qtxp8yb4o().f[3]++;
      cov_qtxp8yb4o().s[4]++;

      for (var p in b) {
        cov_qtxp8yb4o().s[5]++;

        if (Object.prototype.hasOwnProperty.call(b, p)) {
          cov_qtxp8yb4o().b[2][0]++;
          cov_qtxp8yb4o().s[6]++;
          d[p] = b[p];
        } else {
          cov_qtxp8yb4o().b[2][1]++;
        }
      }
    });
    cov_qtxp8yb4o().s[7]++;
    return _extendStatics(d, b);
  };

  cov_qtxp8yb4o().s[8]++;
  return function (d, b) {
    cov_qtxp8yb4o().f[4]++;
    cov_qtxp8yb4o().s[9]++;

    _extendStatics(d, b);

    function __() {
      cov_qtxp8yb4o().f[5]++;
      cov_qtxp8yb4o().s[10]++;
      this.constructor = d;
    }

    cov_qtxp8yb4o().s[11]++;
    d.prototype = b === null ? (cov_qtxp8yb4o().b[3][0]++, (0, _create["default"])(b)) : (cov_qtxp8yb4o().b[3][1]++, (__.prototype = b.prototype, new __()));
  };
}()));

var __importDefault = (cov_qtxp8yb4o().s[12]++, (cov_qtxp8yb4o().b[4][0]++, void 0) && (cov_qtxp8yb4o().b[4][1]++, (void 0).__importDefault) || (cov_qtxp8yb4o().b[4][2]++, function (mod) {
  cov_qtxp8yb4o().f[6]++;
  cov_qtxp8yb4o().s[13]++;
  return (cov_qtxp8yb4o().b[6][0]++, mod) && (cov_qtxp8yb4o().b[6][1]++, mod.__esModule) ? (cov_qtxp8yb4o().b[5][0]++, mod) : (cov_qtxp8yb4o().b[5][1]++, {
    "default": mod
  });
}));

cov_qtxp8yb4o().s[14]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var cache_1 = (cov_qtxp8yb4o().s[15]++, __importDefault(__webpack_require__(95)));
var dom_core_1 = (cov_qtxp8yb4o().s[16]++, __importDefault(__webpack_require__(2)));
var util_1 = (cov_qtxp8yb4o().s[17]++, __webpack_require__(7));
/**
 * 把 Range 对象转换成缓存对象
 * @param range Range 对象
 */

function rangeToObject(range) {
  cov_qtxp8yb4o().f[7]++;
  cov_qtxp8yb4o().s[18]++;
  return {
    start: [range.startContainer, range.startOffset],
    end: [range.endContainer, range.endOffset],
    root: range.commonAncestorContainer,
    collapsed: range.collapsed
  };
}
/**
 * 编辑区 range 缓存管理器
 */


var RangeCache = (
/** @class */
cov_qtxp8yb4o().s[19]++, function (_super) {
  cov_qtxp8yb4o().f[8]++;
  cov_qtxp8yb4o().s[20]++;

  __extends(RangeCache, _super);

  function RangeCache(editor) {
    cov_qtxp8yb4o().f[9]++;

    var _this = (cov_qtxp8yb4o().s[21]++, (cov_qtxp8yb4o().b[7][0]++, _super.call(this, editor.config.historyMaxSize)) || (cov_qtxp8yb4o().b[7][1]++, this));

    cov_qtxp8yb4o().s[22]++;
    _this.editor = editor;
    cov_qtxp8yb4o().s[23]++;
    _this.lastRange = rangeToObject(document.createRange());
    cov_qtxp8yb4o().s[24]++;
    _this.root = editor.$textElem.elems[0];
    cov_qtxp8yb4o().s[25]++;
    _this.updateLastRange = util_1.debounce(function () {
      cov_qtxp8yb4o().f[10]++;
      cov_qtxp8yb4o().s[26]++;
      _this.lastRange = rangeToObject(_this.rangeHandle);
    }, editor.config.onchangeTimeout);
    cov_qtxp8yb4o().s[27]++;
    return _this;
  }

  cov_qtxp8yb4o().s[28]++;
  (0, _defineProperty["default"])(RangeCache.prototype, "rangeHandle", {
    /**
     * 获取 Range 对象
     */
    get: function get() {
      cov_qtxp8yb4o().f[11]++;
      var selection = (cov_qtxp8yb4o().s[29]++, document.getSelection());
      cov_qtxp8yb4o().s[30]++;
      return (cov_qtxp8yb4o().b[9][0]++, selection) && (cov_qtxp8yb4o().b[9][1]++, selection.rangeCount) ? (cov_qtxp8yb4o().b[8][0]++, selection.getRangeAt(0)) : (cov_qtxp8yb4o().b[8][1]++, document.createRange());
    },
    enumerable: false,
    configurable: true
  });
  /**
   * 初始化绑定
   */

  cov_qtxp8yb4o().s[31]++;

  RangeCache.prototype.observe = function () {
    cov_qtxp8yb4o().f[12]++;
    var self = (cov_qtxp8yb4o().s[32]++, this); // 同步节点数据

    cov_qtxp8yb4o().s[33]++;
    this.root = this.editor.$textElem.elems[0];
    cov_qtxp8yb4o().s[34]++;
    this.resetMaxSize(this.editor.config.historyMaxSize); // selection change 回调函数

    function selectionchange() {
      cov_qtxp8yb4o().f[13]++;
      var handle = (cov_qtxp8yb4o().s[35]++, self.rangeHandle);
      cov_qtxp8yb4o().s[36]++;

      if ((cov_qtxp8yb4o().b[11][0]++, self.root === handle.commonAncestorContainer) || (cov_qtxp8yb4o().b[11][1]++, self.root.contains(handle.commonAncestorContainer))) {
        cov_qtxp8yb4o().b[10][0]++;
        cov_qtxp8yb4o().s[37]++;

        // 非中文输入状态下才进行记录
        if (!self.editor.isComposing) {
          cov_qtxp8yb4o().b[12][0]++;
          cov_qtxp8yb4o().s[38]++;
          self.updateLastRange();
        } else {
          cov_qtxp8yb4o().b[12][1]++;
        }
      } else {
        cov_qtxp8yb4o().b[10][1]++;
      }
    } // backspace 和 delete 手动更新 Range 缓存


    function deletecallback(e) {
      cov_qtxp8yb4o().f[14]++;
      cov_qtxp8yb4o().s[39]++;

      if ((cov_qtxp8yb4o().b[14][0]++, e.key == 'Backspace') || (cov_qtxp8yb4o().b[14][1]++, e.key == 'Delete')) {
        cov_qtxp8yb4o().b[13][0]++;
        cov_qtxp8yb4o().s[40]++;
        // self.lastRange = rangeToObject(self.rangeHandle)
        self.updateLastRange();
      } else {
        cov_qtxp8yb4o().b[13][1]++;
      }
    } // 绑定事件（必须绑定在 document 上，不能绑定在 window 上）


    cov_qtxp8yb4o().s[41]++;
    dom_core_1["default"](document).on('selectionchange', selectionchange); // 解除事件绑定

    cov_qtxp8yb4o().s[42]++;
    this.editor.beforeDestroy(function () {
      cov_qtxp8yb4o().f[15]++;
      cov_qtxp8yb4o().s[43]++;
      dom_core_1["default"](document).off('selectionchange', selectionchange);
    }); // 删除文本时手动更新 range

    cov_qtxp8yb4o().s[44]++;
    self.editor.$textElem.on('keydown', deletecallback);
  };
  /**
   * 保存 Range
   */


  cov_qtxp8yb4o().s[45]++;

  RangeCache.prototype.save = function () {
    cov_qtxp8yb4o().f[16]++;
    var current = (cov_qtxp8yb4o().s[46]++, rangeToObject(this.rangeHandle));
    cov_qtxp8yb4o().s[47]++;

    _super.prototype.save.call(this, [this.lastRange, current]);

    cov_qtxp8yb4o().s[48]++;
    this.lastRange = current;
    cov_qtxp8yb4o().s[49]++;
    return this;
  };
  /**
   * 设置 Range，在 撤销/恢复 中调用
   * @param range 缓存的 Range 数据
   */


  cov_qtxp8yb4o().s[50]++;

  RangeCache.prototype.set = function (range) {
    cov_qtxp8yb4o().f[17]++;
    cov_qtxp8yb4o().s[51]++;

    if (range) {
      cov_qtxp8yb4o().b[15][0]++;
      var handle = (cov_qtxp8yb4o().s[52]++, this.rangeHandle);
      cov_qtxp8yb4o().s[53]++;
      handle.setStart.apply(handle, range.start);
      cov_qtxp8yb4o().s[54]++;
      handle.setEnd.apply(handle, range.end);
      cov_qtxp8yb4o().s[55]++;
      this.editor.menus.changeActive();
      cov_qtxp8yb4o().s[56]++;
      return true;
    } else {
      cov_qtxp8yb4o().b[15][1]++;
    }

    cov_qtxp8yb4o().s[57]++;
    return false;
  };
  /**
   * 撤销
   */


  cov_qtxp8yb4o().s[58]++;

  RangeCache.prototype.revoke = function () {
    cov_qtxp8yb4o().f[18]++;

    var _this = (cov_qtxp8yb4o().s[59]++, this);

    cov_qtxp8yb4o().s[60]++;
    return _super.prototype.revoke.call(this, function (data) {
      cov_qtxp8yb4o().f[19]++;
      cov_qtxp8yb4o().s[61]++;

      _this.set(data[0]);
    });
  };
  /**
   * 恢复
   */


  cov_qtxp8yb4o().s[62]++;

  RangeCache.prototype.restore = function () {
    cov_qtxp8yb4o().f[20]++;

    var _this = (cov_qtxp8yb4o().s[63]++, this);

    cov_qtxp8yb4o().s[64]++;
    return _super.prototype.restore.call(this, function (data) {
      cov_qtxp8yb4o().f[21]++;
      cov_qtxp8yb4o().s[65]++;

      _this.set(data[1]);
    });
  };

  cov_qtxp8yb4o().s[66]++;
  return RangeCache;
}(cache_1["default"]));
cov_qtxp8yb4o().s[67]++;
exports["default"] = RangeCache;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _find = _interopRequireDefault(__webpack_require__(31));

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_55lbdzr5() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/editor/disable/index.ts";
  var hash = "97d58c739f5016b6dd8d17fc78533f2b91c07443";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/editor/disable/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 22
        },
        end: {
          line: 4,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "2": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 62
        }
      },
      "3": {
        start: {
          line: 6,
          column: 17
        },
        end: {
          line: 6,
          column: 65
        }
      },
      "4": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 43
        }
      },
      "5": {
        start: {
          line: 9,
          column: 20
        },
        end: {
          line: 9,
          column: 25
        }
      },
      "6": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 17,
          column: 7
        }
      },
      "7": {
        start: {
          line: 14,
          column: 8
        },
        end: {
          line: 16,
          column: 9
        }
      },
      "8": {
        start: {
          line: 15,
          column: 12
        },
        end: {
          line: 15,
          column: 83
        }
      },
      "9": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 21,
          column: 19
        }
      },
      "10": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 19
        }
      },
      "11": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 32
        }
      },
      "12": {
        start: {
          line: 25,
          column: 39
        },
        end: {
          line: 25,
          column: 73
        }
      },
      "13": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 26,
          column: 39
        }
      },
      "14": {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 233
        }
      },
      "15": {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 54
        }
      },
      "16": {
        start: {
          line: 30,
          column: 30
        },
        end: {
          line: 30,
          column: 55
        }
      },
      "17": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 122
        }
      },
      "18": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 45
        }
      },
      "19": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 25
        }
      },
      "20": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 38,
          column: 19
        }
      },
      "21": {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 19
        }
      },
      "22": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "23": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 26
        }
      },
      "24": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 32
        }
      },
      "25": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 26
        }
      },
      "26": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 48
        }
      },
      "27": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 46,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 2,
            column: 57
          }
        },
        loc: {
          start: {
            line: 2,
            column: 71
          },
          end: {
            line: 4,
            column: 1
          }
        },
        line: 2
      },
      "1": {
        name: "disableInit",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 20
          }
        },
        loc: {
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 44
          },
          end: {
            line: 13,
            column: 45
          }
        },
        loc: {
          start: {
            line: 13,
            column: 56
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 13
      },
      "3": {
        name: "disable",
        decl: {
          start: {
            line: 19,
            column: 13
          },
          end: {
            line: 19,
            column: 20
          }
        },
        loc: {
          start: {
            line: 19,
            column: 23
          },
          end: {
            line: 34,
            column: 5
          }
        },
        line: 19
      },
      "4": {
        name: "enable",
        decl: {
          start: {
            line: 36,
            column: 13
          },
          end: {
            line: 36,
            column: 19
          }
        },
        loc: {
          start: {
            line: 36,
            column: 22
          },
          end: {
            line: 43,
            column: 5
          }
        },
        line: 36
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 1
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 23
          },
          end: {
            line: 2,
            column: 27
          }
        }, {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 51
          }
        }, {
          start: {
            line: 2,
            column: 56
          },
          end: {
            line: 4,
            column: 1
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 40
          }
        }, {
          start: {
            line: 3,
            column: 43
          },
          end: {
            line: 3,
            column: 61
          }
        }],
        line: 3
      },
      "2": {
        loc: {
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 12
          },
          end: {
            line: 3,
            column: 15
          }
        }, {
          start: {
            line: 3,
            column: 19
          },
          end: {
            line: 3,
            column: 33
          }
        }],
        line: 3
      },
      "3": {
        loc: {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 16,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 16,
            column: 9
          }
        }, {
          start: {
            line: 14,
            column: 8
          },
          end: {
            line: 16,
            column: 9
          }
        }],
        line: 14
      },
      "4": {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 21,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 21,
            column: 19
          }
        }, {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 21,
            column: 19
          }
        }],
        line: 20
      },
      "5": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 38,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 38,
            column: 19
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 38,
            column: 19
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/editor/disable/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/editor/disable/index.ts"],
      names: [],
      mappings: ";;;;;AAKA,kEAAoD;AACpD,2CAAwC;AAExC,SAAwB,WAAW,CAAC,MAAc;IAC9C,IAAI,SAAS,GAAY,KAAK,CAAA,CAAC,WAAW;IAC1C,IAAI,WAAuB,CAAA;IAC3B,IAAI,QAAoB,CAAA;IAExB,wBAAwB;IACxB,MAAM,CAAC,GAAG,CAAC,UAAU,CAAC,YAAY,CAAC,IAAI,CAAC;QACpC,IAAI,SAAS,EAAE;YACX,WAAW,CAAC,IAAI,CAAC,sBAAsB,CAAC,CAAC,IAAI,CAAC,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,CAAC,CAAA;SACzE;IACL,CAAC,CAAC,CAAA;IAEF,OAAO;IACP,SAAS,OAAO;QACZ,IAAI,SAAS;YAAE,OAAM;QACrB,SAAS;QACT,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,CAAA;QACvB,eAAe;QACf,IAAI,wBAAwB,GAAG,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,eAAe,CAAC,CAAA;QACjE,IAAM,OAAO,GAAG,MAAM,CAAC,GAAG,CAAC,IAAI,EAAE,CAAA;QACjC,WAAW,GAAG,kBAAC,CACX,uDAAkD,wBAAwB,yEAC1B,OAAO,+BAChD,CACV,CAAA;QACD,MAAM,CAAC,kBAAkB,CAAC,MAAM,CAAC,WAAW,CAAC,CAAA;QAC7C,aAAa;QACb,IAAI,eAAe,GAAG,MAAM,CAAC,MAAM,CAAC,GAAG,CAAC,MAAM,CAAC,CAAA;QAC/C,QAAQ,GAAG,kBAAC,CAAC,qDAAgD,eAAe,cAAU,CAAC,CAAA;QACvF,MAAM,CAAC,YAAY,CAAC,MAAM,CAAC,QAAQ,CAAC,CAAA;QACpC,SAAS,GAAG,IAAI,CAAA;IACpB,CAAC;IAED,eAAe;IACf,SAAS,MAAM;QACX,IAAI,CAAC,SAAS;YAAE,OAAM;QACtB,WAAW,CAAC,MAAM,EAAE,CAAA;QACpB,QAAQ,CAAC,MAAM,EAAE,CAAA;QACjB,MAAM,CAAC,SAAS,CAAC,IAAI,EAAE,CAAA;QACvB,SAAS,GAAG,KAAK,CAAA;IACrB,CAAC;IAED,OAAO,EAAE,OAAO,SAAA,EAAE,MAAM,QAAA,EAAE,CAAA;AAC9B,CAAC;AA3CD,8BA2CC",
      sourcesContent: ["/**\n * @description disable \u5185\u5BB9\u7F16\u8F91\n * @author lichunlin\n */\nimport Editor from '../index'\nimport $, { DomElement } from '../../utils/dom-core'\nimport '../../assets/style/disable.less'\n\nexport default function disableInit(editor: Editor) {\n    let isCurtain: Boolean = false // \u907F\u514D\u91CD\u590D\u751F\u6210\u5E55\u5E03\n    let $contentDom: DomElement\n    let $menuDom: DomElement\n\n    // \u7981\u7528\u671F\u95F4\uFF0C\u901A\u8FC7 js \u4FEE\u6539\u5185\u5BB9\u540E\uFF0C\u5237\u65B0\u5185\u5BB9\n    editor.txt.eventHooks.changeEvents.push(function () {\n        if (isCurtain) {\n            $contentDom.find('.w-e-content-preview').html(editor.$textElem.html())\n        }\n    })\n\n    // \u521B\u5EFA\u5E55\u5E03\n    function disable() {\n        if (isCurtain) return\n        // \u9690\u85CF\u7F16\u8F91\u533A\u57DF\n        editor.$textElem.hide()\n        // \u751F\u6210div \u6E32\u67D3\u7F16\u8F91\u5185\u5BB9\n        let textContainerZindexValue = editor.zIndex.get('textContainer')\n        const content = editor.txt.html()\n        $contentDom = $(\n            `<div class=\"w-e-content-mantle\" style=\"z-index:${textContainerZindexValue}\">\n                <div class=\"w-e-content-preview w-e-text\">${content}</div>\n            </div>`\n        )\n        editor.$textContainerElem.append($contentDom)\n        // \u751F\u6210div \u83DC\u5355\u819C\u5E03\n        let menuZindexValue = editor.zIndex.get('menu')\n        $menuDom = $(`<div class=\"w-e-menue-mantle\" style=\"z-index:${menuZindexValue}\"></div>`)\n        editor.$toolbarElem.append($menuDom)\n        isCurtain = true\n    }\n\n    // \u9500\u6BC1\u5E55\u5E03\u5E76\u663E\u793A\u53EF\u7F16\u8F91\u533A\u57DF\n    function enable() {\n        if (!isCurtain) return\n        $contentDom.remove()\n        $menuDom.remove()\n        editor.$textElem.show()\n        isCurtain = false\n    }\n\n    return { disable, enable }\n}\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "97d58c739f5016b6dd8d17fc78533f2b91c07443"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_55lbdzr5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_55lbdzr5();

var __importDefault = (cov_55lbdzr5().s[0]++, (cov_55lbdzr5().b[0][0]++, void 0) && (cov_55lbdzr5().b[0][1]++, (void 0).__importDefault) || (cov_55lbdzr5().b[0][2]++, function (mod) {
  cov_55lbdzr5().f[0]++;
  cov_55lbdzr5().s[1]++;
  return (cov_55lbdzr5().b[2][0]++, mod) && (cov_55lbdzr5().b[2][1]++, mod.__esModule) ? (cov_55lbdzr5().b[1][0]++, mod) : (cov_55lbdzr5().b[1][1]++, {
    "default": mod
  });
}));

cov_55lbdzr5().s[2]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});
var dom_core_1 = (cov_55lbdzr5().s[3]++, __importDefault(__webpack_require__(2)));
cov_55lbdzr5().s[4]++;

__webpack_require__(403);

function disableInit(editor) {
  cov_55lbdzr5().f[1]++;
  var isCurtain = (cov_55lbdzr5().s[5]++, false); // 避免重复生成幕布

  var $contentDom;
  var $menuDom; // 禁用期间，通过 js 修改内容后，刷新内容

  cov_55lbdzr5().s[6]++;
  editor.txt.eventHooks.changeEvents.push(function () {
    cov_55lbdzr5().f[2]++;
    cov_55lbdzr5().s[7]++;

    if (isCurtain) {
      cov_55lbdzr5().b[3][0]++;
      cov_55lbdzr5().s[8]++;
      (0, _find["default"])($contentDom).call($contentDom, '.w-e-content-preview').html(editor.$textElem.html());
    } else {
      cov_55lbdzr5().b[3][1]++;
    }
  }); // 创建幕布

  function disable() {
    cov_55lbdzr5().f[3]++;
    cov_55lbdzr5().s[9]++;

    if (isCurtain) {
      cov_55lbdzr5().b[4][0]++;
      cov_55lbdzr5().s[10]++;
      return;
    } else {
      cov_55lbdzr5().b[4][1]++;
    } // 隐藏编辑区域


    cov_55lbdzr5().s[11]++;
    editor.$textElem.hide(); // 生成div 渲染编辑内容

    var textContainerZindexValue = (cov_55lbdzr5().s[12]++, editor.zIndex.get('textContainer'));
    var content = (cov_55lbdzr5().s[13]++, editor.txt.html());
    cov_55lbdzr5().s[14]++;
    $contentDom = dom_core_1["default"]("<div class=\"w-e-content-mantle\" style=\"z-index:" + textContainerZindexValue + "\">\n                <div class=\"w-e-content-preview w-e-text\">" + content + "</div>\n            </div>");
    cov_55lbdzr5().s[15]++;
    editor.$textContainerElem.append($contentDom); // 生成div 菜单膜布

    var menuZindexValue = (cov_55lbdzr5().s[16]++, editor.zIndex.get('menu'));
    cov_55lbdzr5().s[17]++;
    $menuDom = dom_core_1["default"]("<div class=\"w-e-menue-mantle\" style=\"z-index:" + menuZindexValue + "\"></div>");
    cov_55lbdzr5().s[18]++;
    editor.$toolbarElem.append($menuDom);
    cov_55lbdzr5().s[19]++;
    isCurtain = true;
  } // 销毁幕布并显示可编辑区域


  function enable() {
    cov_55lbdzr5().f[4]++;
    cov_55lbdzr5().s[20]++;

    if (!isCurtain) {
      cov_55lbdzr5().b[5][0]++;
      cov_55lbdzr5().s[21]++;
      return;
    } else {
      cov_55lbdzr5().b[5][1]++;
    }

    cov_55lbdzr5().s[22]++;
    $contentDom.remove();
    cov_55lbdzr5().s[23]++;
    $menuDom.remove();
    cov_55lbdzr5().s[24]++;
    editor.$textElem.show();
    cov_55lbdzr5().s[25]++;
    isCurtain = false;
  }

  cov_55lbdzr5().s[26]++;
  return {
    disable: disable,
    enable: enable
  };
}

cov_55lbdzr5().s[27]++;
exports["default"] = disableInit;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(19);
            var content = __webpack_require__(404);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(20);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".w-e-content-mantle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n.w-e-content-mantle .w-e-content-preview {\n  width: 100%;\n  min-height: 100%;\n  padding: 0 10px;\n  line-height: 1.5;\n}\n.w-e-content-mantle .w-e-content-preview img {\n  cursor: default;\n}\n.w-e-content-mantle .w-e-content-preview img:hover {\n  box-shadow: none;\n}\n.w-e-menue-mantle {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _defineProperty = _interopRequireDefault(__webpack_require__(1));

function cov_266ac6729a() {
  var path = "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/index.ts";
  var hash = "455bee7f4909cbf0e3b4a4cba1b9e59bc2fe851e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 0
        },
        end: {
          line: 2,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/index.ts",
      sourceRoot: "",
      sources: ["/home/runner/work/wangEditor/wangEditor/src/menus/menu-constructors/index.ts"],
      names: [],
      mappings: "",
      sourcesContent: ["export { DropListConf, DropListItem } from './DropList'\nexport { PanelTabConf, PanelConf } from './Panel'\nexport { TooltipConfItemType } from './Tooltip'\n"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "455bee7f4909cbf0e3b4a4cba1b9e59bc2fe851e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_266ac6729a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_266ac6729a();
cov_266ac6729a().s[0]++;
(0, _defineProperty["default"])(exports, "__esModule", {
  value: true
});

/***/ })
/******/ ])["default"];
});
//# sourceMappingURL=wangEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/wangeditor/dist/wangEditor.js
// module id = alfv
// module chunks = 0